
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire5889"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire5889"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
'use strict';

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
'use strict';
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Mg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Ng = null, $0b2e6adb871a3b94$var$Og = null, $0b2e6adb871a3b94$var$Pg = null;
function $0b2e6adb871a3b94$var$Qg() {
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Ng = null;
}
function $0b2e6adb871a3b94$var$Rg(a) {
    var b = $0b2e6adb871a3b94$var$Mg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Mg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$Tg(a, b) {
    $0b2e6adb871a3b94$var$Ng = a;
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$Ug = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$Vg(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Og) {
            if (null === $0b2e6adb871a3b94$var$Ng) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Og = a;
            $0b2e6adb871a3b94$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Og.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Wg = null;
function $0b2e6adb871a3b94$var$Xg(a) {
    null === $0b2e6adb871a3b94$var$Wg ? $0b2e6adb871a3b94$var$Wg = [
        a
    ] : $0b2e6adb871a3b94$var$Wg.push(a);
}
function $0b2e6adb871a3b94$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$Zg(a, d);
}
function $0b2e6adb871a3b94$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$$g = !1;
function $0b2e6adb871a3b94$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$Zg(a, c);
}
function $0b2e6adb871a3b94$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$jh = (new $acw62.Component).refs;
function $0b2e6adb871a3b94$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$L(), d = $0b2e6adb871a3b94$var$lh(a), e = $0b2e6adb871a3b94$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$dh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, d, c), $0b2e6adb871a3b94$var$eh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$ph(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$Vg(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0b2e6adb871a3b94$var$jh;
    $0b2e6adb871a3b94$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$Vg(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $0b2e6adb871a3b94$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$sh(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$sh(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$zh(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Ah(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Bh = $0b2e6adb871a3b94$var$vh(!0), $0b2e6adb871a3b94$var$Ch = $0b2e6adb871a3b94$var$vh(!1), $0b2e6adb871a3b94$var$Dh = {}, $0b2e6adb871a3b94$var$Eh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh);
function $0b2e6adb871a3b94$var$Hh(a) {
    if (a === $0b2e6adb871a3b94$var$Dh) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$Ih(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Gh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, $0b2e6adb871a3b94$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, b);
}
function $0b2e6adb871a3b94$var$Jh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Gh);
}
function $0b2e6adb871a3b94$var$Kh(a) {
    $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
    var b = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, c));
}
function $0b2e6adb871a3b94$var$Lh(a) {
    $0b2e6adb871a3b94$var$Fh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh));
}
var $0b2e6adb871a3b94$var$M = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nh = [];
function $0b2e6adb871a3b94$var$Oh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Nh.length; a++)$0b2e6adb871a3b94$var$Nh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Nh.length = 0;
}
var $0b2e6adb871a3b94$var$Ph = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Qh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Rh = 0, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$P = null, $0b2e6adb871a3b94$var$Sh = !1, $0b2e6adb871a3b94$var$Th = !1, $0b2e6adb871a3b94$var$Uh = 0, $0b2e6adb871a3b94$var$Vh = 0;
function $0b2e6adb871a3b94$var$Q() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Xh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Rh = f;
    $0b2e6adb871a3b94$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Ph.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Yh : $0b2e6adb871a3b94$var$Zh;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Th) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$$h;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Th);
    }
    $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
    b = null !== $0b2e6adb871a3b94$var$O && null !== $0b2e6adb871a3b94$var$O.next;
    $0b2e6adb871a3b94$var$Rh = 0;
    $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
    $0b2e6adb871a3b94$var$Sh = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$bi() {
    var a = 0 !== $0b2e6adb871a3b94$var$Uh;
    $0b2e6adb871a3b94$var$Uh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$di() {
    if (null === $0b2e6adb871a3b94$var$O) {
        var a = $0b2e6adb871a3b94$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$O.next;
    var b = null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState : $0b2e6adb871a3b94$var$P.next;
    if (null !== b) $0b2e6adb871a3b94$var$P = b, $0b2e6adb871a3b94$var$O = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$O = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$O.memoizedState,
            baseState: $0b2e6adb871a3b94$var$O.baseState,
            baseQueue: $0b2e6adb871a3b94$var$O.baseQueue,
            queue: $0b2e6adb871a3b94$var$O.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    }
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$N.lanes |= m;
                $0b2e6adb871a3b94$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$N.lanes |= f, $0b2e6adb871a3b94$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$gi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$hi() {}
function $0b2e6adb871a3b94$var$ii(a, b) {
    var c = $0b2e6adb871a3b94$var$N, d = $0b2e6adb871a3b94$var$di(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$Ug = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$ji($0b2e6adb871a3b94$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$P && $0b2e6adb871a3b94$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
}
function $0b2e6adb871a3b94$var$ki(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
    });
}
function $0b2e6adb871a3b94$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$pi(a) {
    var b = $0b2e6adb871a3b94$var$Zg(a, 1);
    null !== b && $0b2e6adb871a3b94$var$mh(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$qi(a) {
    var b = $0b2e6adb871a3b94$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ri.bind(null, $0b2e6adb871a3b94$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$si() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$ti(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$ci();
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$ui(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$O) {
        var g = $0b2e6adb871a3b94$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Wh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$li(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    return $0b2e6adb871a3b94$var$ti(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$ji(a, b) {
    return $0b2e6adb871a3b94$var$ui(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$wi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$xi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$ui(4, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$Ai() {}
function $0b2e6adb871a3b94$var$Bi(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Ci(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Di(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Rh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$Ug = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$N.lanes |= c, $0b2e6adb871a3b94$var$hh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$Ei(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Qh.transition;
    $0b2e6adb871a3b94$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Qh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$Fi() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, c);
    else if (c = $0b2e6adb871a3b94$var$Yg(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$L();
        $0b2e6adb871a3b94$var$mh(c, a, d, e);
        $0b2e6adb871a3b94$var$Ji(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ri(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$Yg(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$L(), $0b2e6adb871a3b94$var$mh(c, a, d, e), $0b2e6adb871a3b94$var$Ji(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$Hi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$N || null !== b && b === $0b2e6adb871a3b94$var$N;
}
function $0b2e6adb871a3b94$var$Ii(a, b) {
    $0b2e6adb871a3b94$var$Th = $0b2e6adb871a3b94$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$ai = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Q,
    useContext: $0b2e6adb871a3b94$var$Q,
    useEffect: $0b2e6adb871a3b94$var$Q,
    useImperativeHandle: $0b2e6adb871a3b94$var$Q,
    useInsertionEffect: $0b2e6adb871a3b94$var$Q,
    useLayoutEffect: $0b2e6adb871a3b94$var$Q,
    useMemo: $0b2e6adb871a3b94$var$Q,
    useReducer: $0b2e6adb871a3b94$var$Q,
    useRef: $0b2e6adb871a3b94$var$Q,
    useState: $0b2e6adb871a3b94$var$Q,
    useDebugValue: $0b2e6adb871a3b94$var$Q,
    useDeferredValue: $0b2e6adb871a3b94$var$Q,
    useTransition: $0b2e6adb871a3b94$var$Q,
    useMutableSource: $0b2e6adb871a3b94$var$Q,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Q,
    useId: $0b2e6adb871a3b94$var$Q,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Yh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ti(4194308, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$Gi.bind(null, $0b2e6adb871a3b94$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$qi,
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$qi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$Ei.bind(null, a[1]);
        $0b2e6adb871a3b94$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$N, e = $0b2e6adb871a3b94$var$ci();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$vi($0b2e6adb871a3b94$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$ci(), b = $0b2e6adb871a3b94$var$R.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Zh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$fi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$$h = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$gi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return null === $0b2e6adb871a3b94$var$O ? b.memoizedState = a : $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Oi(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Pi || ($0b2e6adb871a3b94$var$Pi = !0, $0b2e6adb871a3b94$var$Qi = d);
        $0b2e6adb871a3b94$var$Mi(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Ri(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Mi(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Si ? $0b2e6adb871a3b94$var$Si = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$ch(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Xi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$Ug = !1;
function $0b2e6adb871a3b94$var$Yi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Ch(b, null, c, d) : $0b2e6adb871a3b94$var$Bh(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$Tg(b, e);
    d = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$cj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$Ug = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$$i(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$dj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj);
            $0b2e6adb871a3b94$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= d;
    $0b2e6adb871a3b94$var$Yi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$dj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$Tg(b, e);
    c = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$Tg(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$jj(a, b), $0b2e6adb871a3b94$var$ph(b, c, d), $0b2e6adb871a3b94$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$Vg(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$qh(b, g, d, l);
        $0b2e6adb871a3b94$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof m && ($0b2e6adb871a3b94$var$kh(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$Vg(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$qh(b, g, d, k);
        $0b2e6adb871a3b94$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof y && ($0b2e6adb871a3b94$var$kh(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$kj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$kj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$$i(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Bh(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Bh(b, null, h, f)) : $0b2e6adb871a3b94$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$Ih(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$mj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Yi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$pj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$qj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$oj(c), b.memoizedState = $0b2e6adb871a3b94$var$nj, a) : $0b2e6adb871a3b94$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$wh(h, f) : (f = $0b2e6adb871a3b94$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$rj(a, b) {
    b = $0b2e6adb871a3b94$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$tj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Bh(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$oj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Li(f, d, void 0);
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$Ug || h) {
        d = $0b2e6adb871a3b94$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$Zg(a, e), $0b2e6adb871a3b94$var$mh(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$uj();
        d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$Sg(a.return, b, c);
}
function $0b2e6adb871a3b94$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Yi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$lj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Kh(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$pj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
                a = $0b2e6adb871a3b94$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    return $0b2e6adb871a3b94$var$$i(a, b, c);
}
var $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj, $0b2e6adb871a3b94$var$Dj;
$0b2e6adb871a3b94$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Bj = function() {};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Ej(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$Jh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Bj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Lh(b);
            var e = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
                $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$M.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$Bj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Ej(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Hj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$M.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$gj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Jj(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Lh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M), null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Kj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Oj = !1;
function $0b2e6adb871a3b94$var$Pj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Oj;
    $0b2e6adb871a3b94$var$Oj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Yj = !1;
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$ak(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$ak(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Mj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Yj = !0;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Nj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Zj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Lj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Yj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$ak(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$ek(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Qj(3, a, a.return), $0b2e6adb871a3b94$var$Rj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Qj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$gk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$fk(a);
    }
}
function $0b2e6adb871a3b94$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$jk(a, b, c);
}
function $0b2e6adb871a3b94$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Kj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Kj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$kk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$kk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$jk(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Kj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$lk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$lk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Sj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$hk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$mk = Math.ceil, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$pk = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$gj = 0, $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$qk = null, $0b2e6adb871a3b94$var$hh = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = 0, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$gk = 0, $0b2e6adb871a3b94$var$Hj = Infinity, $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Pi = !1, $0b2e6adb871a3b94$var$Qi = null, $0b2e6adb871a3b94$var$Si = null, $0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = null, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, $0b2e6adb871a3b94$var$Bk = -1, $0b2e6adb871a3b94$var$Ck = 0;
function $0b2e6adb871a3b94$var$L() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Bk ? $0b2e6adb871a3b94$var$Bk : $0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Ck && ($0b2e6adb871a3b94$var$Ck = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Ck;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$mh(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$zk) throw $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$R) a === $0b2e6adb871a3b94$var$R && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$rk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Ek(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Ek(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Fk.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Fk.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Gk(c, $0b2e6adb871a3b94$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Hk(a, b) {
    $0b2e6adb871a3b94$var$Bk = -1;
    $0b2e6adb871a3b94$var$Ck = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Ik() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Jk(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Kk();
        if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Lk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Mk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Nk(a, h);
        }
        $0b2e6adb871a3b94$var$Qg();
        $0b2e6adb871a3b94$var$nk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Ok(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Pk(e) && (b = $0b2e6adb871a3b94$var$Jk(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Ok(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$gk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Hk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Ok(a, b) {
    var c = $0b2e6adb871a3b94$var$tk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Lk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Jk(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$uk = c, null !== b && $0b2e6adb871a3b94$var$Gj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Gj(a) {
    null === $0b2e6adb871a3b94$var$uk ? $0b2e6adb871a3b94$var$uk = a : $0b2e6adb871a3b94$var$uk.push.apply($0b2e6adb871a3b94$var$uk, a);
}
function $0b2e6adb871a3b94$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    b &= ~$0b2e6adb871a3b94$var$sk;
    b &= ~$0b2e6adb871a3b94$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Fk(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Ok(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, b), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Rk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Sk(a) {
    null !== $0b2e6adb871a3b94$var$xk && 0 === $0b2e6adb871a3b94$var$xk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$pk.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$pk.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Ij() {
    $0b2e6adb871a3b94$var$gj = $0b2e6adb871a3b94$var$fj.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$fj);
}
function $0b2e6adb871a3b94$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$Jh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Oh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Lh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$Jh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 10:
                $0b2e6adb871a3b94$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Ij();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$R = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$wh(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$gj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$qk = null;
    $0b2e6adb871a3b94$var$sk = $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$hh = 0;
    $0b2e6adb871a3b94$var$uk = $0b2e6adb871a3b94$var$tk = null;
    if (null !== $0b2e6adb871a3b94$var$Wg) {
        for(b = 0; b < $0b2e6adb871a3b94$var$Wg.length; b++)if (c = $0b2e6adb871a3b94$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$Wg = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$Qg();
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
            if ($0b2e6adb871a3b94$var$Sh) {
                for(var d = $0b2e6adb871a3b94$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Sh = !1;
            }
            $0b2e6adb871a3b94$var$Rh = 0;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            $0b2e6adb871a3b94$var$ok.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$qk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Ti(f, l, b);
                            $0b2e6adb871a3b94$var$uj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Wi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ki(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = [
                    f
                ] : $0b2e6adb871a3b94$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Oi(f, k, b);
                            $0b2e6adb871a3b94$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Ri(f, h, b);
                                $0b2e6adb871a3b94$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Tk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Kk() {
    var a = $0b2e6adb871a3b94$var$nk.current;
    $0b2e6adb871a3b94$var$nk.current = $0b2e6adb871a3b94$var$ai;
    return null === a ? $0b2e6adb871a3b94$var$ai : a;
}
function $0b2e6adb871a3b94$var$uj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$R || 0 === ($0b2e6adb871a3b94$var$hh & 268435455) && 0 === ($0b2e6adb871a3b94$var$rk & 268435455) || $0b2e6adb871a3b94$var$Dk($0b2e6adb871a3b94$var$R, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Jk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Kk();
    if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Lk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Uk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Nk(a, e);
    }
    $0b2e6adb871a3b94$var$Qg();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$nk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$R = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Uk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Mk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Vk(a) {
    var b = $0b2e6adb871a3b94$var$Wk(a.alternate, a, $0b2e6adb871a3b94$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Tk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$ok.current = null;
}
function $0b2e6adb871a3b94$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Fj(c, b, $0b2e6adb871a3b94$var$gj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Qk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$pk.transition;
    try {
        $0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Xk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$pk.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Ik();
    while (null !== $0b2e6adb871a3b94$var$xk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$R && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$wk || ($0b2e6adb871a3b94$var$wk = !0, $0b2e6adb871a3b94$var$Gk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$pk.transition;
        $0b2e6adb871a3b94$var$pk.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$ok.current = null;
        $0b2e6adb871a3b94$var$Pj(a, c);
        $0b2e6adb871a3b94$var$ek(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$ik(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$pk.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$wk && ($0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = a, $0b2e6adb871a3b94$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Si = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Pi) throw $0b2e6adb871a3b94$var$Pi = !1, a = $0b2e6adb871a3b94$var$Qi, $0b2e6adb871a3b94$var$Qi = null, a;
    0 !== ($0b2e6adb871a3b94$var$yk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$zk++ : ($0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = a) : $0b2e6adb871a3b94$var$zk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Ik() {
    if (null !== $0b2e6adb871a3b94$var$xk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$yk), b = $0b2e6adb871a3b94$var$pk.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$pk.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$xk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$xk;
                $0b2e6adb871a3b94$var$xk = null;
                $0b2e6adb871a3b94$var$yk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Tj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Rj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$pk.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Yk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ki(c, b);
    b = $0b2e6adb871a3b94$var$Oi(a, b, 1);
    a = $0b2e6adb871a3b94$var$dh(a, b, 1);
    b = $0b2e6adb871a3b94$var$L();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Ek(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(d))) {
                a = $0b2e6adb871a3b94$var$Ki(c, a);
                a = $0b2e6adb871a3b94$var$Ri(b, a, 1);
                b = $0b2e6adb871a3b94$var$dh(b, a, 1);
                a = $0b2e6adb871a3b94$var$L();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$R === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$gk ? $0b2e6adb871a3b94$var$Lk(a, 0) : $0b2e6adb871a3b94$var$sk |= c);
    $0b2e6adb871a3b94$var$Ek(a, b);
}
function $0b2e6adb871a3b94$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$L();
    a = $0b2e6adb871a3b94$var$Zg(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Ek(a, c));
}
function $0b2e6adb871a3b94$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
var $0b2e6adb871a3b94$var$Wk;
$0b2e6adb871a3b94$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$zj(a, b, c);
            $0b2e6adb871a3b94$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$jj(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$Tg(b, c);
            e = $0b2e6adb871a3b94$var$Xh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$ah(b), e.updater = $0b2e6adb871a3b94$var$nh, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$rh(b, d, a, c), b = $0b2e6adb871a3b94$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$$k(d);
                a = $0b2e6adb871a3b94$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$aj(null, b, d, $0b2e6adb871a3b94$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$lj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$bh(a, b);
                $0b2e6adb871a3b94$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$$i(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Kh(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$hj(a, b), $0b2e6adb871a3b94$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$pj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Bh(b, null, d, c) : $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$Zi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$Tg(b, c), e = $0b2e6adb871a3b94$var$Vg(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Lg(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Lg(d.type, e), $0b2e6adb871a3b94$var$aj(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$jj(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$Tg(b, c), $0b2e6adb871a3b94$var$ph(b, d, e), $0b2e6adb871a3b94$var$rh(b, d, e, c), $0b2e6adb871a3b94$var$kj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$yj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Gk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$al(a, b, c, d);
}
function $0b2e6adb871a3b94$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$$k(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Ah(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Ah(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$qj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$xh(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$zh(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$ah(f);
    return a;
}
function $0b2e6adb871a3b94$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$el(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$el(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$L();
    e = $0b2e6adb871a3b94$var$lh(c);
    f = $0b2e6adb871a3b94$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$dh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Ek(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$gl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$L(), g = $0b2e6adb871a3b94$var$lh(e);
    c = $0b2e6adb871a3b94$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$dh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$mh(a, e, g, f), $0b2e6adb871a3b94$var$eh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$jl(a, b) {
    $0b2e6adb871a3b94$var$il(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$il(a, b);
}
function $0b2e6adb871a3b94$var$kl() {
    return null;
}
var $0b2e6adb871a3b94$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.render = $0b2e6adb871a3b94$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$gl(a, b, null, null);
};
$0b2e6adb871a3b94$var$nl.prototype.unmount = $0b2e6adb871a3b94$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Sk(function() {
            $0b2e6adb871a3b94$var$gl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$ql() {}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$fl(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$hl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$cl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$gl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$gl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$rl(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$hl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Ek(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Sk(function() {
                var b = $0b2e6adb871a3b94$var$Zg(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$L();
                    $0b2e6adb871a3b94$var$mh(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$jl(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$jl(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$lh(a), c = $0b2e6adb871a3b94$var$Zg(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$jl(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Sk;
var $0b2e6adb871a3b94$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Rk
    ]
}, $0b2e6adb871a3b94$var$ul = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$vl = {
    bundleType: $0b2e6adb871a3b94$var$ul.bundleType,
    version: $0b2e6adb871a3b94$var$ul.version,
    rendererPackageName: $0b2e6adb871a3b94$var$ul.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$ul.findFiberByHostInstance || $0b2e6adb871a3b94$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$wl.isDisabled && $0b2e6adb871a3b94$var$wl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$wl.inject($0b2e6adb871a3b94$var$vl), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$wl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$tl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$dl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Sk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$nl(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$pl(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$pl(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$sl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
'use strict';
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});



parcelRegister("ilwRK", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MissingRefError = exports.ValidationError = exports.CodeGen = exports.Name = exports.nil = exports.stringify = exports.str = exports._ = exports.KeywordCxt = exports.Ajv = void 0;

var $5hxSG = parcelRequire("5hxSG");

var $hHp9H = parcelRequire("hHp9H");

var $81ULr = parcelRequire("81ULr");

var $BbyF4 = parcelRequire("BbyF4");
const META_SUPPORT_DATA = [
    "/properties"
];
const META_SCHEMA_ID = "http://json-schema.org/draft-07/schema";
class Ajv extends $5hxSG.default {
    _addVocabularies() {
        super._addVocabularies();
        $hHp9H.default.forEach((v)=>this.addVocabulary(v));
        if (this.opts.discriminator) this.addKeyword($81ULr.default);
    }
    _addDefaultMetaSchema() {
        super._addDefaultMetaSchema();
        if (!this.opts.meta) return;
        const metaSchema = this.opts.$data ? this.$dataMetaSchema($BbyF4, META_SUPPORT_DATA) : $BbyF4;
        this.addMetaSchema(metaSchema, META_SCHEMA_ID, false);
        this.refs["http://json-schema.org/schema"] = META_SCHEMA_ID;
    }
    defaultMeta() {
        return this.opts.defaultMeta = super.defaultMeta() || (this.getSchema(META_SCHEMA_ID) ? META_SCHEMA_ID : undefined);
    }
}
exports.Ajv = Ajv;
module.exports = exports = Ajv;
module.exports.Ajv = Ajv;
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Ajv;

var $9hgV1 = parcelRequire("9hgV1");
Object.defineProperty(exports, "KeywordCxt", {
    enumerable: true,
    get: function() {
        return $9hgV1.KeywordCxt;
    }
});

var $l2ufW = parcelRequire("l2ufW");
Object.defineProperty(exports, "_", {
    enumerable: true,
    get: function() {
        return $l2ufW._;
    }
});
Object.defineProperty(exports, "str", {
    enumerable: true,
    get: function() {
        return $l2ufW.str;
    }
});
Object.defineProperty(exports, "stringify", {
    enumerable: true,
    get: function() {
        return $l2ufW.stringify;
    }
});
Object.defineProperty(exports, "nil", {
    enumerable: true,
    get: function() {
        return $l2ufW.nil;
    }
});
Object.defineProperty(exports, "Name", {
    enumerable: true,
    get: function() {
        return $l2ufW.Name;
    }
});
Object.defineProperty(exports, "CodeGen", {
    enumerable: true,
    get: function() {
        return $l2ufW.CodeGen;
    }
});

var $2gvZO = parcelRequire("2gvZO");
Object.defineProperty(exports, "ValidationError", {
    enumerable: true,
    get: function() {
        return $2gvZO.default;
    }
});

var $euTEo = parcelRequire("euTEo");
Object.defineProperty(exports, "MissingRefError", {
    enumerable: true,
    get: function() {
        return $euTEo.default;
    }
});

});
parcelRegister("5hxSG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.CodeGen = module.exports.Name = module.exports.nil = module.exports.stringify = module.exports.str = module.exports._ = module.exports.KeywordCxt = void 0;

var $9hgV1 = parcelRequire("9hgV1");
Object.defineProperty(module.exports, "KeywordCxt", {
    enumerable: true,
    get: function() {
        return $9hgV1.KeywordCxt;
    }
});

var $l2ufW = parcelRequire("l2ufW");
Object.defineProperty(module.exports, "_", {
    enumerable: true,
    get: function() {
        return $l2ufW._;
    }
});
Object.defineProperty(module.exports, "str", {
    enumerable: true,
    get: function() {
        return $l2ufW.str;
    }
});
Object.defineProperty(module.exports, "stringify", {
    enumerable: true,
    get: function() {
        return $l2ufW.stringify;
    }
});
Object.defineProperty(module.exports, "nil", {
    enumerable: true,
    get: function() {
        return $l2ufW.nil;
    }
});
Object.defineProperty(module.exports, "Name", {
    enumerable: true,
    get: function() {
        return $l2ufW.Name;
    }
});
Object.defineProperty(module.exports, "CodeGen", {
    enumerable: true,
    get: function() {
        return $l2ufW.CodeGen;
    }
});

var $2gvZO = parcelRequire("2gvZO");

var $euTEo = parcelRequire("euTEo");

var $1sl6b = parcelRequire("1sl6b");

var $jstQR = parcelRequire("jstQR");

var $l2ufW = parcelRequire("l2ufW");

var $9ZpNV = parcelRequire("9ZpNV");

var $46MS3 = parcelRequire("46MS3");

var $7eX5i = parcelRequire("7eX5i");

var $83wzf = parcelRequire("83wzf");

var $FaKkF = parcelRequire("FaKkF");
const $3d88d258a9865bba$var$defaultRegExp = (str, flags)=>new RegExp(str, flags);
$3d88d258a9865bba$var$defaultRegExp.code = "new RegExp";
const $3d88d258a9865bba$var$META_IGNORE_OPTIONS = [
    "removeAdditional",
    "useDefaults",
    "coerceTypes"
];
const $3d88d258a9865bba$var$EXT_SCOPE_NAMES = new Set([
    "validate",
    "serialize",
    "parse",
    "wrapper",
    "root",
    "schema",
    "keyword",
    "pattern",
    "formats",
    "validate$data",
    "func",
    "obj",
    "Error"
]);
const $3d88d258a9865bba$var$removedOptions = {
    errorDataPath: "",
    format: "`validateFormats: false` can be used instead.",
    nullable: '"nullable" keyword is supported by default.',
    jsonPointers: "Deprecated jsPropertySyntax can be used instead.",
    extendRefs: "Deprecated ignoreKeywordsWithRef can be used instead.",
    missingRefs: "Pass empty schema with $id that should be ignored to ajv.addSchema.",
    processCode: "Use option `code: {process: (code, schemaEnv: object) => string}`",
    sourceCode: "Use option `code: {source: true}`",
    strictDefaults: "It is default now, see option `strict`.",
    strictKeywords: "It is default now, see option `strict`.",
    uniqueItems: '"uniqueItems" keyword is always validated.',
    unknownFormats: "Disable strict mode or pass `true` to `ajv.addFormat` (or `formats` option).",
    cache: "Map is used as cache, schema object as key.",
    serialize: "Map is used as cache, schema object as key.",
    ajvErrors: "It is default now."
};
const $3d88d258a9865bba$var$deprecatedOptions = {
    ignoreKeywordsWithRef: "",
    jsPropertySyntax: "",
    unicode: '"minLength"/"maxLength" account for unicode characters by default.'
};
const $3d88d258a9865bba$var$MAX_EXPRESSION = 200;
// eslint-disable-next-line complexity
function $3d88d258a9865bba$var$requiredOptions(o) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
    const s = o.strict;
    const _optz = (_a = o.code) === null || _a === void 0 ? void 0 : _a.optimize;
    const optimize = _optz === true || _optz === undefined ? 1 : _optz || 0;
    const regExp = (_c = (_b = o.code) === null || _b === void 0 ? void 0 : _b.regExp) !== null && _c !== void 0 ? _c : $3d88d258a9865bba$var$defaultRegExp;
    const uriResolver = (_d = o.uriResolver) !== null && _d !== void 0 ? _d : $FaKkF.default;
    return {
        strictSchema: (_f = (_e = o.strictSchema) !== null && _e !== void 0 ? _e : s) !== null && _f !== void 0 ? _f : true,
        strictNumbers: (_h = (_g = o.strictNumbers) !== null && _g !== void 0 ? _g : s) !== null && _h !== void 0 ? _h : true,
        strictTypes: (_k = (_j = o.strictTypes) !== null && _j !== void 0 ? _j : s) !== null && _k !== void 0 ? _k : "log",
        strictTuples: (_m = (_l = o.strictTuples) !== null && _l !== void 0 ? _l : s) !== null && _m !== void 0 ? _m : "log",
        strictRequired: (_p = (_o = o.strictRequired) !== null && _o !== void 0 ? _o : s) !== null && _p !== void 0 ? _p : false,
        code: o.code ? {
            ...o.code,
            optimize: optimize,
            regExp: regExp
        } : {
            optimize: optimize,
            regExp: regExp
        },
        loopRequired: (_q = o.loopRequired) !== null && _q !== void 0 ? _q : $3d88d258a9865bba$var$MAX_EXPRESSION,
        loopEnum: (_r = o.loopEnum) !== null && _r !== void 0 ? _r : $3d88d258a9865bba$var$MAX_EXPRESSION,
        meta: (_s = o.meta) !== null && _s !== void 0 ? _s : true,
        messages: (_t = o.messages) !== null && _t !== void 0 ? _t : true,
        inlineRefs: (_u = o.inlineRefs) !== null && _u !== void 0 ? _u : true,
        schemaId: (_v = o.schemaId) !== null && _v !== void 0 ? _v : "$id",
        addUsedSchema: (_w = o.addUsedSchema) !== null && _w !== void 0 ? _w : true,
        validateSchema: (_x = o.validateSchema) !== null && _x !== void 0 ? _x : true,
        validateFormats: (_y = o.validateFormats) !== null && _y !== void 0 ? _y : true,
        unicodeRegExp: (_z = o.unicodeRegExp) !== null && _z !== void 0 ? _z : true,
        int32range: (_0 = o.int32range) !== null && _0 !== void 0 ? _0 : true,
        uriResolver: uriResolver
    };
}
class $3d88d258a9865bba$var$Ajv {
    constructor(opts = {}){
        this.schemas = {};
        this.refs = {};
        this.formats = Object.create(null);
        this._compilations = new Set();
        this._loading = {};
        this._cache = new Map();
        opts = this.opts = {
            ...opts,
            ...$3d88d258a9865bba$var$requiredOptions(opts)
        };
        const { es5: es5, lines: lines } = this.opts.code;
        this.scope = new $l2ufW.ValueScope({
            scope: {},
            prefixes: $3d88d258a9865bba$var$EXT_SCOPE_NAMES,
            es5: es5,
            lines: lines
        });
        this.logger = $3d88d258a9865bba$var$getLogger(opts.logger);
        const formatOpt = opts.validateFormats;
        opts.validateFormats = false;
        this.RULES = (0, $1sl6b.getRules)();
        $3d88d258a9865bba$var$checkOptions.call(this, $3d88d258a9865bba$var$removedOptions, opts, "NOT SUPPORTED");
        $3d88d258a9865bba$var$checkOptions.call(this, $3d88d258a9865bba$var$deprecatedOptions, opts, "DEPRECATED", "warn");
        this._metaOpts = $3d88d258a9865bba$var$getMetaSchemaOptions.call(this);
        if (opts.formats) $3d88d258a9865bba$var$addInitialFormats.call(this);
        this._addVocabularies();
        this._addDefaultMetaSchema();
        if (opts.keywords) $3d88d258a9865bba$var$addInitialKeywords.call(this, opts.keywords);
        if (typeof opts.meta == "object") this.addMetaSchema(opts.meta);
        $3d88d258a9865bba$var$addInitialSchemas.call(this);
        opts.validateFormats = formatOpt;
    }
    _addVocabularies() {
        this.addKeyword("$async");
    }
    _addDefaultMetaSchema() {
        const { $data: $data, meta: meta, schemaId: schemaId } = this.opts;
        let _dataRefSchema = $83wzf;
        if (schemaId === "id") {
            _dataRefSchema = {
                ...$83wzf
            };
            _dataRefSchema.id = _dataRefSchema.$id;
            delete _dataRefSchema.$id;
        }
        if (meta && $data) this.addMetaSchema(_dataRefSchema, _dataRefSchema[schemaId], false);
    }
    defaultMeta() {
        const { meta: meta, schemaId: schemaId } = this.opts;
        return this.opts.defaultMeta = typeof meta == "object" ? meta[schemaId] || meta : undefined;
    }
    validate(schemaKeyRef, // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
    data // to be validated
    ) {
        let v;
        if (typeof schemaKeyRef == "string") {
            v = this.getSchema(schemaKeyRef);
            if (!v) throw new Error(`no schema with key or ref "${schemaKeyRef}"`);
        } else v = this.compile(schemaKeyRef);
        const valid = v(data);
        if (!("$async" in v)) this.errors = v.errors;
        return valid;
    }
    compile(schema, _meta) {
        const sch = this._addSchema(schema, _meta);
        return sch.validate || this._compileSchemaEnv(sch);
    }
    compileAsync(schema, meta) {
        if (typeof this.opts.loadSchema != "function") throw new Error("options.loadSchema should be a function");
        const { loadSchema: loadSchema } = this.opts;
        return runCompileAsync.call(this, schema, meta);
        async function runCompileAsync(_schema, _meta) {
            await loadMetaSchema.call(this, _schema.$schema);
            const sch = this._addSchema(_schema, _meta);
            return sch.validate || _compileAsync.call(this, sch);
        }
        async function loadMetaSchema($ref) {
            if ($ref && !this.getSchema($ref)) await runCompileAsync.call(this, {
                $ref: $ref
            }, true);
        }
        async function _compileAsync(sch) {
            try {
                return this._compileSchemaEnv(sch);
            } catch (e) {
                if (!(e instanceof $euTEo.default)) throw e;
                checkLoaded.call(this, e);
                await loadMissingSchema.call(this, e.missingSchema);
                return _compileAsync.call(this, sch);
            }
        }
        function checkLoaded({ missingSchema: ref, missingRef: missingRef }) {
            if (this.refs[ref]) throw new Error(`AnySchema ${ref} is loaded but ${missingRef} cannot be resolved`);
        }
        async function loadMissingSchema(ref) {
            const _schema = await _loadSchema.call(this, ref);
            if (!this.refs[ref]) await loadMetaSchema.call(this, _schema.$schema);
            if (!this.refs[ref]) this.addSchema(_schema, ref, meta);
        }
        async function _loadSchema(ref) {
            const p = this._loading[ref];
            if (p) return p;
            try {
                return await (this._loading[ref] = loadSchema(ref));
            } finally{
                delete this._loading[ref];
            }
        }
    }
    // Adds schema to the instance
    addSchema(schema, key, _meta, _validateSchema = this.opts.validateSchema // false to skip schema validation. Used internally, option validateSchema should be used instead.
    ) {
        if (Array.isArray(schema)) {
            for (const sch of schema)this.addSchema(sch, undefined, _meta, _validateSchema);
            return this;
        }
        let id;
        if (typeof schema === "object") {
            const { schemaId: schemaId } = this.opts;
            id = schema[schemaId];
            if (id !== undefined && typeof id != "string") throw new Error(`schema ${schemaId} must be string`);
        }
        key = (0, $9ZpNV.normalizeId)(key || id);
        this._checkUnique(key);
        this.schemas[key] = this._addSchema(schema, _meta, key, _validateSchema, true);
        return this;
    }
    // Add schema that will be used to validate other schemas
    // options in META_IGNORE_OPTIONS are alway set to false
    addMetaSchema(schema, key, _validateSchema = this.opts.validateSchema // false to skip schema validation, can be used to override validateSchema option for meta-schema
    ) {
        this.addSchema(schema, key, true, _validateSchema);
        return this;
    }
    //  Validate schema against its meta-schema
    validateSchema(schema, throwOrLogError) {
        if (typeof schema == "boolean") return true;
        let $schema;
        $schema = schema.$schema;
        if ($schema !== undefined && typeof $schema != "string") throw new Error("$schema must be a string");
        $schema = $schema || this.opts.defaultMeta || this.defaultMeta();
        if (!$schema) {
            this.logger.warn("meta-schema not available");
            this.errors = null;
            return true;
        }
        const valid = this.validate($schema, schema);
        if (!valid && throwOrLogError) {
            const message = "schema is invalid: " + this.errorsText();
            if (this.opts.validateSchema === "log") this.logger.error(message);
            else throw new Error(message);
        }
        return valid;
    }
    // Get compiled schema by `key` or `ref`.
    // (`key` that was passed to `addSchema` or full schema reference - `schema.$id` or resolved id)
    getSchema(keyRef) {
        let sch;
        while(typeof (sch = $3d88d258a9865bba$var$getSchEnv.call(this, keyRef)) == "string")keyRef = sch;
        if (sch === undefined) {
            const { schemaId: schemaId } = this.opts;
            const root = new $jstQR.SchemaEnv({
                schema: {},
                schemaId: schemaId
            });
            sch = $jstQR.resolveSchema.call(this, root, keyRef);
            if (!sch) return;
            this.refs[keyRef] = sch;
        }
        return sch.validate || this._compileSchemaEnv(sch);
    }
    // Remove cached schema(s).
    // If no parameter is passed all schemas but meta-schemas are removed.
    // If RegExp is passed all schemas with key/id matching pattern but meta-schemas are removed.
    // Even if schema is referenced by other schemas it still can be removed as other schemas have local references.
    removeSchema(schemaKeyRef) {
        if (schemaKeyRef instanceof RegExp) {
            this._removeAllSchemas(this.schemas, schemaKeyRef);
            this._removeAllSchemas(this.refs, schemaKeyRef);
            return this;
        }
        switch(typeof schemaKeyRef){
            case "undefined":
                this._removeAllSchemas(this.schemas);
                this._removeAllSchemas(this.refs);
                this._cache.clear();
                return this;
            case "string":
                {
                    const sch = $3d88d258a9865bba$var$getSchEnv.call(this, schemaKeyRef);
                    if (typeof sch == "object") this._cache.delete(sch.schema);
                    delete this.schemas[schemaKeyRef];
                    delete this.refs[schemaKeyRef];
                    return this;
                }
            case "object":
                {
                    const cacheKey = schemaKeyRef;
                    this._cache.delete(cacheKey);
                    let id = schemaKeyRef[this.opts.schemaId];
                    if (id) {
                        id = (0, $9ZpNV.normalizeId)(id);
                        delete this.schemas[id];
                        delete this.refs[id];
                    }
                    return this;
                }
            default:
                throw new Error("ajv.removeSchema: invalid parameter");
        }
    }
    // add "vocabulary" - a collection of keywords
    addVocabulary(definitions) {
        for (const def of definitions)this.addKeyword(def);
        return this;
    }
    addKeyword(kwdOrDef, def // deprecated
    ) {
        let keyword;
        if (typeof kwdOrDef == "string") {
            keyword = kwdOrDef;
            if (typeof def == "object") {
                this.logger.warn("these parameters are deprecated, see docs for addKeyword");
                def.keyword = keyword;
            }
        } else if (typeof kwdOrDef == "object" && def === undefined) {
            def = kwdOrDef;
            keyword = def.keyword;
            if (Array.isArray(keyword) && !keyword.length) throw new Error("addKeywords: keyword must be string or non-empty array");
        } else throw new Error("invalid addKeywords parameters");
        $3d88d258a9865bba$var$checkKeyword.call(this, keyword, def);
        if (!def) {
            (0, $7eX5i.eachItem)(keyword, (kwd)=>$3d88d258a9865bba$var$addRule.call(this, kwd));
            return this;
        }
        $3d88d258a9865bba$var$keywordMetaschema.call(this, def);
        const definition = {
            ...def,
            type: (0, $46MS3.getJSONTypes)(def.type),
            schemaType: (0, $46MS3.getJSONTypes)(def.schemaType)
        };
        (0, $7eX5i.eachItem)(keyword, definition.type.length === 0 ? (k)=>$3d88d258a9865bba$var$addRule.call(this, k, definition) : (k)=>definition.type.forEach((t)=>$3d88d258a9865bba$var$addRule.call(this, k, definition, t)));
        return this;
    }
    getKeyword(keyword) {
        const rule = this.RULES.all[keyword];
        return typeof rule == "object" ? rule.definition : !!rule;
    }
    // Remove keyword
    removeKeyword(keyword) {
        // TODO return type should be Ajv
        const { RULES: RULES } = this;
        delete RULES.keywords[keyword];
        delete RULES.all[keyword];
        for (const group of RULES.rules){
            const i = group.rules.findIndex((rule)=>rule.keyword === keyword);
            if (i >= 0) group.rules.splice(i, 1);
        }
        return this;
    }
    // Add format
    addFormat(name, format) {
        if (typeof format == "string") format = new RegExp(format);
        this.formats[name] = format;
        return this;
    }
    errorsText(errors = this.errors, { separator: separator = ", ", dataVar: dataVar = "data" } = {} // optional options with properties `separator` and `dataVar`
    ) {
        if (!errors || errors.length === 0) return "No errors";
        return errors.map((e)=>`${dataVar}${e.instancePath} ${e.message}`).reduce((text, msg)=>text + separator + msg);
    }
    $dataMetaSchema(metaSchema, keywordsJsonPointers) {
        const rules = this.RULES.all;
        metaSchema = JSON.parse(JSON.stringify(metaSchema));
        for (const jsonPointer of keywordsJsonPointers){
            const segments = jsonPointer.split("/").slice(1); // first segment is an empty string
            let keywords = metaSchema;
            for (const seg of segments)keywords = keywords[seg];
            for(const key in rules){
                const rule = rules[key];
                if (typeof rule != "object") continue;
                const { $data: $data } = rule.definition;
                const schema = keywords[key];
                if ($data && schema) keywords[key] = $3d88d258a9865bba$var$schemaOrData(schema);
            }
        }
        return metaSchema;
    }
    _removeAllSchemas(schemas, regex) {
        for(const keyRef in schemas){
            const sch = schemas[keyRef];
            if (!regex || regex.test(keyRef)) {
                if (typeof sch == "string") delete schemas[keyRef];
                else if (sch && !sch.meta) {
                    this._cache.delete(sch.schema);
                    delete schemas[keyRef];
                }
            }
        }
    }
    _addSchema(schema, meta, baseId, validateSchema = this.opts.validateSchema, addSchema = this.opts.addUsedSchema) {
        let id;
        const { schemaId: schemaId } = this.opts;
        if (typeof schema == "object") id = schema[schemaId];
        else {
            if (this.opts.jtd) throw new Error("schema must be object");
            else if (typeof schema != "boolean") throw new Error("schema must be object or boolean");
        }
        let sch = this._cache.get(schema);
        if (sch !== undefined) return sch;
        baseId = (0, $9ZpNV.normalizeId)(id || baseId);
        const localRefs = $9ZpNV.getSchemaRefs.call(this, schema, baseId);
        sch = new $jstQR.SchemaEnv({
            schema: schema,
            schemaId: schemaId,
            meta: meta,
            baseId: baseId,
            localRefs: localRefs
        });
        this._cache.set(sch.schema, sch);
        if (addSchema && !baseId.startsWith("#")) {
            // TODO atm it is allowed to overwrite schemas without id (instead of not adding them)
            if (baseId) this._checkUnique(baseId);
            this.refs[baseId] = sch;
        }
        if (validateSchema) this.validateSchema(schema, true);
        return sch;
    }
    _checkUnique(id) {
        if (this.schemas[id] || this.refs[id]) throw new Error(`schema with key or id "${id}" already exists`);
    }
    _compileSchemaEnv(sch) {
        if (sch.meta) this._compileMetaSchema(sch);
        else $jstQR.compileSchema.call(this, sch);
        /* istanbul ignore if */ if (!sch.validate) throw new Error("ajv implementation error");
        return sch.validate;
    }
    _compileMetaSchema(sch) {
        const currentOpts = this.opts;
        this.opts = this._metaOpts;
        try {
            $jstQR.compileSchema.call(this, sch);
        } finally{
            this.opts = currentOpts;
        }
    }
}
$3d88d258a9865bba$var$Ajv.ValidationError = $2gvZO.default;
$3d88d258a9865bba$var$Ajv.MissingRefError = $euTEo.default;
module.exports.default = $3d88d258a9865bba$var$Ajv;
function $3d88d258a9865bba$var$checkOptions(checkOpts, options, msg, log = "error") {
    for(const key in checkOpts){
        const opt = key;
        if (opt in options) this.logger[log](`${msg}: option ${key}. ${checkOpts[opt]}`);
    }
}
function $3d88d258a9865bba$var$getSchEnv(keyRef) {
    keyRef = (0, $9ZpNV.normalizeId)(keyRef); // TODO tests fail without this line
    return this.schemas[keyRef] || this.refs[keyRef];
}
function $3d88d258a9865bba$var$addInitialSchemas() {
    const optsSchemas = this.opts.schemas;
    if (!optsSchemas) return;
    if (Array.isArray(optsSchemas)) this.addSchema(optsSchemas);
    else for(const key in optsSchemas)this.addSchema(optsSchemas[key], key);
}
function $3d88d258a9865bba$var$addInitialFormats() {
    for(const name in this.opts.formats){
        const format = this.opts.formats[name];
        if (format) this.addFormat(name, format);
    }
}
function $3d88d258a9865bba$var$addInitialKeywords(defs) {
    if (Array.isArray(defs)) {
        this.addVocabulary(defs);
        return;
    }
    this.logger.warn("keywords option as map is deprecated, pass array");
    for(const keyword in defs){
        const def = defs[keyword];
        if (!def.keyword) def.keyword = keyword;
        this.addKeyword(def);
    }
}
function $3d88d258a9865bba$var$getMetaSchemaOptions() {
    const metaOpts = {
        ...this.opts
    };
    for (const opt of $3d88d258a9865bba$var$META_IGNORE_OPTIONS)delete metaOpts[opt];
    return metaOpts;
}
const $3d88d258a9865bba$var$noLogs = {
    log () {},
    warn () {},
    error () {}
};
function $3d88d258a9865bba$var$getLogger(logger) {
    if (logger === false) return $3d88d258a9865bba$var$noLogs;
    if (logger === undefined) return console;
    if (logger.log && logger.warn && logger.error) return logger;
    throw new Error("logger must implement log, warn and error methods");
}
const $3d88d258a9865bba$var$KEYWORD_NAME = /^[a-z_$][a-z0-9_$:-]*$/i;
function $3d88d258a9865bba$var$checkKeyword(keyword, def) {
    const { RULES: RULES } = this;
    (0, $7eX5i.eachItem)(keyword, (kwd)=>{
        if (RULES.keywords[kwd]) throw new Error(`Keyword ${kwd} is already defined`);
        if (!$3d88d258a9865bba$var$KEYWORD_NAME.test(kwd)) throw new Error(`Keyword ${kwd} has invalid name`);
    });
    if (!def) return;
    if (def.$data && !("code" in def || "validate" in def)) throw new Error('$data keyword must have "code" or "validate" function');
}
function $3d88d258a9865bba$var$addRule(keyword, definition, dataType) {
    var _a;
    const post = definition === null || definition === void 0 ? void 0 : definition.post;
    if (dataType && post) throw new Error('keyword with "post" flag cannot have "type"');
    const { RULES: RULES } = this;
    let ruleGroup = post ? RULES.post : RULES.rules.find(({ type: t })=>t === dataType);
    if (!ruleGroup) {
        ruleGroup = {
            type: dataType,
            rules: []
        };
        RULES.rules.push(ruleGroup);
    }
    RULES.keywords[keyword] = true;
    if (!definition) return;
    const rule = {
        keyword: keyword,
        definition: {
            ...definition,
            type: (0, $46MS3.getJSONTypes)(definition.type),
            schemaType: (0, $46MS3.getJSONTypes)(definition.schemaType)
        }
    };
    if (definition.before) $3d88d258a9865bba$var$addBeforeRule.call(this, ruleGroup, rule, definition.before);
    else ruleGroup.rules.push(rule);
    RULES.all[keyword] = rule;
    (_a = definition.implements) === null || _a === void 0 || _a.forEach((kwd)=>this.addKeyword(kwd));
}
function $3d88d258a9865bba$var$addBeforeRule(ruleGroup, rule, before) {
    const i = ruleGroup.rules.findIndex((_rule)=>_rule.keyword === before);
    if (i >= 0) ruleGroup.rules.splice(i, 0, rule);
    else {
        ruleGroup.rules.push(rule);
        this.logger.warn(`rule ${before} is not defined`);
    }
}
function $3d88d258a9865bba$var$keywordMetaschema(def) {
    let { metaSchema: metaSchema } = def;
    if (metaSchema === undefined) return;
    if (def.$data && this.opts.$data) metaSchema = $3d88d258a9865bba$var$schemaOrData(metaSchema);
    def.validateSchema = this.compile(metaSchema, true);
}
const $3d88d258a9865bba$var$$dataRef = {
    $ref: "https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#"
};
function $3d88d258a9865bba$var$schemaOrData(schema) {
    return {
        anyOf: [
            schema,
            $3d88d258a9865bba$var$$dataRef
        ]
    };
}

});
parcelRegister("9hgV1", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getData = module.exports.KeywordCxt = module.exports.validateFunctionCode = void 0;

var $75Cyv = parcelRequire("75Cyv");

var $46MS3 = parcelRequire("46MS3");

var $9KPK3 = parcelRequire("9KPK3");

var $46MS3 = parcelRequire("46MS3");

var $9OJAU = parcelRequire("9OJAU");

var $dTewx = parcelRequire("dTewx");

var $5eunN = parcelRequire("5eunN");

var $l2ufW = parcelRequire("l2ufW");

var $dOpvc = parcelRequire("dOpvc");

var $9ZpNV = parcelRequire("9ZpNV");

var $7eX5i = parcelRequire("7eX5i");

var $hYgW9 = parcelRequire("hYgW9");
// schema compilation - generates validation function, subschemaCode (below) is used for subschemas
function $6c12d34a75202c62$var$validateFunctionCode(it) {
    if ($6c12d34a75202c62$var$isSchemaObj(it)) {
        $6c12d34a75202c62$var$checkKeywords(it);
        if ($6c12d34a75202c62$var$schemaCxtHasRules(it)) {
            $6c12d34a75202c62$var$topSchemaObjCode(it);
            return;
        }
    }
    $6c12d34a75202c62$var$validateFunction(it, ()=>(0, $75Cyv.topBoolOrEmptySchema)(it));
}
module.exports.validateFunctionCode = $6c12d34a75202c62$var$validateFunctionCode;
function $6c12d34a75202c62$var$validateFunction({ gen: gen, validateName: validateName, schema: schema, schemaEnv: schemaEnv, opts: opts }, body) {
    if (opts.code.es5) gen.func(validateName, (0, $l2ufW._)`${$dOpvc.default.data}, ${$dOpvc.default.valCxt}`, schemaEnv.$async, ()=>{
        gen.code((0, $l2ufW._)`"use strict"; ${$6c12d34a75202c62$var$funcSourceUrl(schema, opts)}`);
        $6c12d34a75202c62$var$destructureValCxtES5(gen, opts);
        gen.code(body);
    });
    else gen.func(validateName, (0, $l2ufW._)`${$dOpvc.default.data}, ${$6c12d34a75202c62$var$destructureValCxt(opts)}`, schemaEnv.$async, ()=>gen.code($6c12d34a75202c62$var$funcSourceUrl(schema, opts)).code(body));
}
function $6c12d34a75202c62$var$destructureValCxt(opts) {
    return (0, $l2ufW._)`{${$dOpvc.default.instancePath}="", ${$dOpvc.default.parentData}, ${$dOpvc.default.parentDataProperty}, ${$dOpvc.default.rootData}=${$dOpvc.default.data}${opts.dynamicRef ? (0, $l2ufW._)`, ${$dOpvc.default.dynamicAnchors}={}` : $l2ufW.nil}}={}`;
}
function $6c12d34a75202c62$var$destructureValCxtES5(gen, opts) {
    gen.if($dOpvc.default.valCxt, ()=>{
        gen.var($dOpvc.default.instancePath, (0, $l2ufW._)`${$dOpvc.default.valCxt}.${$dOpvc.default.instancePath}`);
        gen.var($dOpvc.default.parentData, (0, $l2ufW._)`${$dOpvc.default.valCxt}.${$dOpvc.default.parentData}`);
        gen.var($dOpvc.default.parentDataProperty, (0, $l2ufW._)`${$dOpvc.default.valCxt}.${$dOpvc.default.parentDataProperty}`);
        gen.var($dOpvc.default.rootData, (0, $l2ufW._)`${$dOpvc.default.valCxt}.${$dOpvc.default.rootData}`);
        if (opts.dynamicRef) gen.var($dOpvc.default.dynamicAnchors, (0, $l2ufW._)`${$dOpvc.default.valCxt}.${$dOpvc.default.dynamicAnchors}`);
    }, ()=>{
        gen.var($dOpvc.default.instancePath, (0, $l2ufW._)`""`);
        gen.var($dOpvc.default.parentData, (0, $l2ufW._)`undefined`);
        gen.var($dOpvc.default.parentDataProperty, (0, $l2ufW._)`undefined`);
        gen.var($dOpvc.default.rootData, $dOpvc.default.data);
        if (opts.dynamicRef) gen.var($dOpvc.default.dynamicAnchors, (0, $l2ufW._)`{}`);
    });
}
function $6c12d34a75202c62$var$topSchemaObjCode(it) {
    const { schema: schema, opts: opts, gen: gen } = it;
    $6c12d34a75202c62$var$validateFunction(it, ()=>{
        if (opts.$comment && schema.$comment) $6c12d34a75202c62$var$commentKeyword(it);
        $6c12d34a75202c62$var$checkNoDefault(it);
        gen.let($dOpvc.default.vErrors, null);
        gen.let($dOpvc.default.errors, 0);
        if (opts.unevaluated) $6c12d34a75202c62$var$resetEvaluated(it);
        $6c12d34a75202c62$var$typeAndKeywords(it);
        $6c12d34a75202c62$var$returnResults(it);
    });
    return;
}
function $6c12d34a75202c62$var$resetEvaluated(it) {
    // TODO maybe some hook to execute it in the end to check whether props/items are Name, as in assignEvaluated
    const { gen: gen, validateName: validateName } = it;
    it.evaluated = gen.const("evaluated", (0, $l2ufW._)`${validateName}.evaluated`);
    gen.if((0, $l2ufW._)`${it.evaluated}.dynamicProps`, ()=>gen.assign((0, $l2ufW._)`${it.evaluated}.props`, (0, $l2ufW._)`undefined`));
    gen.if((0, $l2ufW._)`${it.evaluated}.dynamicItems`, ()=>gen.assign((0, $l2ufW._)`${it.evaluated}.items`, (0, $l2ufW._)`undefined`));
}
function $6c12d34a75202c62$var$funcSourceUrl(schema, opts) {
    const schId = typeof schema == "object" && schema[opts.schemaId];
    return schId && (opts.code.source || opts.code.process) ? (0, $l2ufW._)`/*# sourceURL=${schId} */` : $l2ufW.nil;
}
// schema compilation - this function is used recursively to generate code for sub-schemas
function $6c12d34a75202c62$var$subschemaCode(it, valid) {
    if ($6c12d34a75202c62$var$isSchemaObj(it)) {
        $6c12d34a75202c62$var$checkKeywords(it);
        if ($6c12d34a75202c62$var$schemaCxtHasRules(it)) {
            $6c12d34a75202c62$var$subSchemaObjCode(it, valid);
            return;
        }
    }
    (0, $75Cyv.boolOrEmptySchema)(it, valid);
}
function $6c12d34a75202c62$var$schemaCxtHasRules({ schema: schema, self: self }) {
    if (typeof schema == "boolean") return !schema;
    for(const key in schema)if (self.RULES.all[key]) return true;
    return false;
}
function $6c12d34a75202c62$var$isSchemaObj(it) {
    return typeof it.schema != "boolean";
}
function $6c12d34a75202c62$var$subSchemaObjCode(it, valid) {
    const { schema: schema, gen: gen, opts: opts } = it;
    if (opts.$comment && schema.$comment) $6c12d34a75202c62$var$commentKeyword(it);
    $6c12d34a75202c62$var$updateContext(it);
    $6c12d34a75202c62$var$checkAsyncSchema(it);
    const errsCount = gen.const("_errs", $dOpvc.default.errors);
    $6c12d34a75202c62$var$typeAndKeywords(it, errsCount);
    // TODO var
    gen.var(valid, (0, $l2ufW._)`${errsCount} === ${$dOpvc.default.errors}`);
}
function $6c12d34a75202c62$var$checkKeywords(it) {
    (0, $7eX5i.checkUnknownRules)(it);
    $6c12d34a75202c62$var$checkRefsAndKeywords(it);
}
function $6c12d34a75202c62$var$typeAndKeywords(it, errsCount) {
    if (it.opts.jtd) return $6c12d34a75202c62$var$schemaKeywords(it, [], false, errsCount);
    const types = (0, $46MS3.getSchemaTypes)(it.schema);
    const checkedTypes = (0, $46MS3.coerceAndCheckDataType)(it, types);
    $6c12d34a75202c62$var$schemaKeywords(it, types, !checkedTypes, errsCount);
}
function $6c12d34a75202c62$var$checkRefsAndKeywords(it) {
    const { schema: schema, errSchemaPath: errSchemaPath, opts: opts, self: self } = it;
    if (schema.$ref && opts.ignoreKeywordsWithRef && (0, $7eX5i.schemaHasRulesButRef)(schema, self.RULES)) self.logger.warn(`$ref: keywords ignored in schema at path "${errSchemaPath}"`);
}
function $6c12d34a75202c62$var$checkNoDefault(it) {
    const { schema: schema, opts: opts } = it;
    if (schema.default !== undefined && opts.useDefaults && opts.strictSchema) (0, $7eX5i.checkStrictMode)(it, "default is ignored in the schema root");
}
function $6c12d34a75202c62$var$updateContext(it) {
    const schId = it.schema[it.opts.schemaId];
    if (schId) it.baseId = (0, $9ZpNV.resolveUrl)(it.opts.uriResolver, it.baseId, schId);
}
function $6c12d34a75202c62$var$checkAsyncSchema(it) {
    if (it.schema.$async && !it.schemaEnv.$async) throw new Error("async schema in sync schema");
}
function $6c12d34a75202c62$var$commentKeyword({ gen: gen, schemaEnv: schemaEnv, schema: schema, errSchemaPath: errSchemaPath, opts: opts }) {
    const msg = schema.$comment;
    if (opts.$comment === true) gen.code((0, $l2ufW._)`${$dOpvc.default.self}.logger.log(${msg})`);
    else if (typeof opts.$comment == "function") {
        const schemaPath = (0, $l2ufW.str)`${errSchemaPath}/$comment`;
        const rootName = gen.scopeValue("root", {
            ref: schemaEnv.root
        });
        gen.code((0, $l2ufW._)`${$dOpvc.default.self}.opts.$comment(${msg}, ${schemaPath}, ${rootName}.schema)`);
    }
}
function $6c12d34a75202c62$var$returnResults(it) {
    const { gen: gen, schemaEnv: schemaEnv, validateName: validateName, ValidationError: ValidationError, opts: opts } = it;
    if (schemaEnv.$async) // TODO assign unevaluated
    gen.if((0, $l2ufW._)`${$dOpvc.default.errors} === 0`, ()=>gen.return($dOpvc.default.data), ()=>gen.throw((0, $l2ufW._)`new ${ValidationError}(${$dOpvc.default.vErrors})`));
    else {
        gen.assign((0, $l2ufW._)`${validateName}.errors`, $dOpvc.default.vErrors);
        if (opts.unevaluated) $6c12d34a75202c62$var$assignEvaluated(it);
        gen.return((0, $l2ufW._)`${$dOpvc.default.errors} === 0`);
    }
}
function $6c12d34a75202c62$var$assignEvaluated({ gen: gen, evaluated: evaluated, props: props, items: items }) {
    if (props instanceof $l2ufW.Name) gen.assign((0, $l2ufW._)`${evaluated}.props`, props);
    if (items instanceof $l2ufW.Name) gen.assign((0, $l2ufW._)`${evaluated}.items`, items);
}
function $6c12d34a75202c62$var$schemaKeywords(it, types, typeErrors, errsCount) {
    const { gen: gen, schema: schema, data: data, allErrors: allErrors, opts: opts, self: self } = it;
    const { RULES: RULES } = self;
    if (schema.$ref && (opts.ignoreKeywordsWithRef || !(0, $7eX5i.schemaHasRulesButRef)(schema, RULES))) {
        gen.block(()=>$6c12d34a75202c62$var$keywordCode(it, "$ref", RULES.all.$ref.definition)); // TODO typecast
        return;
    }
    if (!opts.jtd) $6c12d34a75202c62$var$checkStrictTypes(it, types);
    gen.block(()=>{
        for (const group of RULES.rules)groupKeywords(group);
        groupKeywords(RULES.post);
    });
    function groupKeywords(group) {
        if (!(0, $9KPK3.shouldUseGroup)(schema, group)) return;
        if (group.type) {
            gen.if((0, $46MS3.checkDataType)(group.type, data, opts.strictNumbers));
            $6c12d34a75202c62$var$iterateKeywords(it, group);
            if (types.length === 1 && types[0] === group.type && typeErrors) {
                gen.else();
                (0, $46MS3.reportTypeError)(it);
            }
            gen.endIf();
        } else $6c12d34a75202c62$var$iterateKeywords(it, group);
        // TODO make it "ok" call?
        if (!allErrors) gen.if((0, $l2ufW._)`${$dOpvc.default.errors} === ${errsCount || 0}`);
    }
}
function $6c12d34a75202c62$var$iterateKeywords(it, group) {
    const { gen: gen, schema: schema, opts: { useDefaults: useDefaults } } = it;
    if (useDefaults) (0, $9OJAU.assignDefaults)(it, group.type);
    gen.block(()=>{
        for (const rule of group.rules)if ((0, $9KPK3.shouldUseRule)(schema, rule)) $6c12d34a75202c62$var$keywordCode(it, rule.keyword, rule.definition, group.type);
    });
}
function $6c12d34a75202c62$var$checkStrictTypes(it, types) {
    if (it.schemaEnv.meta || !it.opts.strictTypes) return;
    $6c12d34a75202c62$var$checkContextTypes(it, types);
    if (!it.opts.allowUnionTypes) $6c12d34a75202c62$var$checkMultipleTypes(it, types);
    $6c12d34a75202c62$var$checkKeywordTypes(it, it.dataTypes);
}
function $6c12d34a75202c62$var$checkContextTypes(it, types) {
    if (!types.length) return;
    if (!it.dataTypes.length) {
        it.dataTypes = types;
        return;
    }
    types.forEach((t)=>{
        if (!$6c12d34a75202c62$var$includesType(it.dataTypes, t)) $6c12d34a75202c62$var$strictTypesError(it, `type "${t}" not allowed by context "${it.dataTypes.join(",")}"`);
    });
    $6c12d34a75202c62$var$narrowSchemaTypes(it, types);
}
function $6c12d34a75202c62$var$checkMultipleTypes(it, ts) {
    if (ts.length > 1 && !(ts.length === 2 && ts.includes("null"))) $6c12d34a75202c62$var$strictTypesError(it, "use allowUnionTypes to allow union type keyword");
}
function $6c12d34a75202c62$var$checkKeywordTypes(it, ts) {
    const rules = it.self.RULES.all;
    for(const keyword in rules){
        const rule = rules[keyword];
        if (typeof rule == "object" && (0, $9KPK3.shouldUseRule)(it.schema, rule)) {
            const { type: type } = rule.definition;
            if (type.length && !type.some((t)=>$6c12d34a75202c62$var$hasApplicableType(ts, t))) $6c12d34a75202c62$var$strictTypesError(it, `missing type "${type.join(",")}" for keyword "${keyword}"`);
        }
    }
}
function $6c12d34a75202c62$var$hasApplicableType(schTs, kwdT) {
    return schTs.includes(kwdT) || kwdT === "number" && schTs.includes("integer");
}
function $6c12d34a75202c62$var$includesType(ts, t) {
    return ts.includes(t) || t === "integer" && ts.includes("number");
}
function $6c12d34a75202c62$var$narrowSchemaTypes(it, withTypes) {
    const ts = [];
    for (const t of it.dataTypes){
        if ($6c12d34a75202c62$var$includesType(withTypes, t)) ts.push(t);
        else if (withTypes.includes("integer") && t === "number") ts.push("integer");
    }
    it.dataTypes = ts;
}
function $6c12d34a75202c62$var$strictTypesError(it, msg) {
    const schemaPath = it.schemaEnv.baseId + it.errSchemaPath;
    msg += ` at "${schemaPath}" (strictTypes)`;
    (0, $7eX5i.checkStrictMode)(it, msg, it.opts.strictTypes);
}
class $6c12d34a75202c62$var$KeywordCxt {
    constructor(it, def, keyword){
        (0, $dTewx.validateKeywordUsage)(it, def, keyword);
        this.gen = it.gen;
        this.allErrors = it.allErrors;
        this.keyword = keyword;
        this.data = it.data;
        this.schema = it.schema[keyword];
        this.$data = def.$data && it.opts.$data && this.schema && this.schema.$data;
        this.schemaValue = (0, $7eX5i.schemaRefOrVal)(it, this.schema, keyword, this.$data);
        this.schemaType = def.schemaType;
        this.parentSchema = it.schema;
        this.params = {};
        this.it = it;
        this.def = def;
        if (this.$data) this.schemaCode = it.gen.const("vSchema", $6c12d34a75202c62$var$getData(this.$data, it));
        else {
            this.schemaCode = this.schemaValue;
            if (!(0, $dTewx.validSchemaType)(this.schema, def.schemaType, def.allowUndefined)) throw new Error(`${keyword} value must be ${JSON.stringify(def.schemaType)}`);
        }
        if ("code" in def ? def.trackErrors : def.errors !== false) this.errsCount = it.gen.const("_errs", $dOpvc.default.errors);
    }
    result(condition, successAction, failAction) {
        this.failResult((0, $l2ufW.not)(condition), successAction, failAction);
    }
    failResult(condition, successAction, failAction) {
        this.gen.if(condition);
        if (failAction) failAction();
        else this.error();
        if (successAction) {
            this.gen.else();
            successAction();
            if (this.allErrors) this.gen.endIf();
        } else if (this.allErrors) this.gen.endIf();
        else this.gen.else();
    }
    pass(condition, failAction) {
        this.failResult((0, $l2ufW.not)(condition), undefined, failAction);
    }
    fail(condition) {
        if (condition === undefined) {
            this.error();
            if (!this.allErrors) this.gen.if(false); // this branch will be removed by gen.optimize
            return;
        }
        this.gen.if(condition);
        this.error();
        if (this.allErrors) this.gen.endIf();
        else this.gen.else();
    }
    fail$data(condition) {
        if (!this.$data) return this.fail(condition);
        const { schemaCode: schemaCode } = this;
        this.fail((0, $l2ufW._)`${schemaCode} !== undefined && (${(0, $l2ufW.or)(this.invalid$data(), condition)})`);
    }
    error(append, errorParams, errorPaths) {
        if (errorParams) {
            this.setParams(errorParams);
            this._error(append, errorPaths);
            this.setParams({});
            return;
        }
        this._error(append, errorPaths);
    }
    _error(append, errorPaths) {
        (append ? $hYgW9.reportExtraError : $hYgW9.reportError)(this, this.def.error, errorPaths);
    }
    $dataError() {
        (0, $hYgW9.reportError)(this, this.def.$dataError || $hYgW9.keyword$DataError);
    }
    reset() {
        if (this.errsCount === undefined) throw new Error('add "trackErrors" to keyword definition');
        (0, $hYgW9.resetErrorsCount)(this.gen, this.errsCount);
    }
    ok(cond) {
        if (!this.allErrors) this.gen.if(cond);
    }
    setParams(obj, assign) {
        if (assign) Object.assign(this.params, obj);
        else this.params = obj;
    }
    block$data(valid, codeBlock, $dataValid = $l2ufW.nil) {
        this.gen.block(()=>{
            this.check$data(valid, $dataValid);
            codeBlock();
        });
    }
    check$data(valid = $l2ufW.nil, $dataValid = $l2ufW.nil) {
        if (!this.$data) return;
        const { gen: gen, schemaCode: schemaCode, schemaType: schemaType, def: def } = this;
        gen.if((0, $l2ufW.or)((0, $l2ufW._)`${schemaCode} === undefined`, $dataValid));
        if (valid !== $l2ufW.nil) gen.assign(valid, true);
        if (schemaType.length || def.validateSchema) {
            gen.elseIf(this.invalid$data());
            this.$dataError();
            if (valid !== $l2ufW.nil) gen.assign(valid, false);
        }
        gen.else();
    }
    invalid$data() {
        const { gen: gen, schemaCode: schemaCode, schemaType: schemaType, def: def, it: it } = this;
        return (0, $l2ufW.or)(wrong$DataType(), invalid$DataSchema());
        function wrong$DataType() {
            if (schemaType.length) {
                /* istanbul ignore if */ if (!(schemaCode instanceof $l2ufW.Name)) throw new Error("ajv implementation error");
                const st = Array.isArray(schemaType) ? schemaType : [
                    schemaType
                ];
                return (0, $l2ufW._)`${(0, $46MS3.checkDataTypes)(st, schemaCode, it.opts.strictNumbers, $46MS3.DataType.Wrong)}`;
            }
            return $l2ufW.nil;
        }
        function invalid$DataSchema() {
            if (def.validateSchema) {
                const validateSchemaRef = gen.scopeValue("validate$data", {
                    ref: def.validateSchema
                }); // TODO value.code for standalone
                return (0, $l2ufW._)`!${validateSchemaRef}(${schemaCode})`;
            }
            return $l2ufW.nil;
        }
    }
    subschema(appl, valid) {
        const subschema = (0, $5eunN.getSubschema)(this.it, appl);
        (0, $5eunN.extendSubschemaData)(subschema, this.it, appl);
        (0, $5eunN.extendSubschemaMode)(subschema, appl);
        const nextContext = {
            ...this.it,
            ...subschema,
            items: undefined,
            props: undefined
        };
        $6c12d34a75202c62$var$subschemaCode(nextContext, valid);
        return nextContext;
    }
    mergeEvaluated(schemaCxt, toName) {
        const { it: it, gen: gen } = this;
        if (!it.opts.unevaluated) return;
        if (it.props !== true && schemaCxt.props !== undefined) it.props = $7eX5i.mergeEvaluated.props(gen, schemaCxt.props, it.props, toName);
        if (it.items !== true && schemaCxt.items !== undefined) it.items = $7eX5i.mergeEvaluated.items(gen, schemaCxt.items, it.items, toName);
    }
    mergeValidEvaluated(schemaCxt, valid) {
        const { it: it, gen: gen } = this;
        if (it.opts.unevaluated && (it.props !== true || it.items !== true)) {
            gen.if(valid, ()=>this.mergeEvaluated(schemaCxt, $l2ufW.Name));
            return true;
        }
    }
}
module.exports.KeywordCxt = $6c12d34a75202c62$var$KeywordCxt;
function $6c12d34a75202c62$var$keywordCode(it, keyword, def, ruleType) {
    const cxt = new $6c12d34a75202c62$var$KeywordCxt(it, def, keyword);
    if ("code" in def) def.code(cxt, ruleType);
    else if (cxt.$data && def.validate) (0, $dTewx.funcKeywordCode)(cxt, def);
    else if ("macro" in def) (0, $dTewx.macroKeywordCode)(cxt, def);
    else if (def.compile || def.validate) (0, $dTewx.funcKeywordCode)(cxt, def);
}
const $6c12d34a75202c62$var$JSON_POINTER = /^\/(?:[^~]|~0|~1)*$/;
const $6c12d34a75202c62$var$RELATIVE_JSON_POINTER = /^([0-9]+)(#|\/(?:[^~]|~0|~1)*)?$/;
function $6c12d34a75202c62$var$getData($data, { dataLevel: dataLevel, dataNames: dataNames, dataPathArr: dataPathArr }) {
    let jsonPointer;
    let data;
    if ($data === "") return $dOpvc.default.rootData;
    if ($data[0] === "/") {
        if (!$6c12d34a75202c62$var$JSON_POINTER.test($data)) throw new Error(`Invalid JSON-pointer: ${$data}`);
        jsonPointer = $data;
        data = $dOpvc.default.rootData;
    } else {
        const matches = $6c12d34a75202c62$var$RELATIVE_JSON_POINTER.exec($data);
        if (!matches) throw new Error(`Invalid JSON-pointer: ${$data}`);
        const up = +matches[1];
        jsonPointer = matches[2];
        if (jsonPointer === "#") {
            if (up >= dataLevel) throw new Error(errorMsg("property/index", up));
            return dataPathArr[dataLevel - up];
        }
        if (up > dataLevel) throw new Error(errorMsg("data", up));
        data = dataNames[dataLevel - up];
        if (!jsonPointer) return data;
    }
    let expr = data;
    const segments = jsonPointer.split("/");
    for (const segment of segments)if (segment) {
        data = (0, $l2ufW._)`${data}${(0, $l2ufW.getProperty)((0, $7eX5i.unescapeJsonPointer)(segment))}`;
        expr = (0, $l2ufW._)`${expr} && ${data}`;
    }
    return expr;
    function errorMsg(pointerType, up) {
        return `Cannot access ${pointerType} ${up} levels up, current level is ${dataLevel}`;
    }
}
module.exports.getData = $6c12d34a75202c62$var$getData;

});
parcelRegister("75Cyv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.boolOrEmptySchema = module.exports.topBoolOrEmptySchema = void 0;

var $hYgW9 = parcelRequire("hYgW9");

var $l2ufW = parcelRequire("l2ufW");

var $dOpvc = parcelRequire("dOpvc");
const $5296e860644b4914$var$boolError = {
    message: "boolean schema is false"
};
function $5296e860644b4914$var$topBoolOrEmptySchema(it) {
    const { gen: gen, schema: schema, validateName: validateName } = it;
    if (schema === false) $5296e860644b4914$var$falseSchemaError(it, false);
    else if (typeof schema == "object" && schema.$async === true) gen.return($dOpvc.default.data);
    else {
        gen.assign((0, $l2ufW._)`${validateName}.errors`, null);
        gen.return(true);
    }
}
module.exports.topBoolOrEmptySchema = $5296e860644b4914$var$topBoolOrEmptySchema;
function $5296e860644b4914$var$boolOrEmptySchema(it, valid) {
    const { gen: gen, schema: schema } = it;
    if (schema === false) {
        gen.var(valid, false); // TODO var
        $5296e860644b4914$var$falseSchemaError(it);
    } else gen.var(valid, true); // TODO var
}
module.exports.boolOrEmptySchema = $5296e860644b4914$var$boolOrEmptySchema;
function $5296e860644b4914$var$falseSchemaError(it, overrideAllErrors) {
    const { gen: gen, data: data } = it;
    // TODO maybe some other interface should be used for non-keyword validation errors...
    const cxt = {
        gen: gen,
        keyword: "false schema",
        data: data,
        schema: false,
        schemaCode: false,
        schemaValue: false,
        params: {},
        it: it
    };
    (0, $hYgW9.reportError)(cxt, $5296e860644b4914$var$boolError, undefined, overrideAllErrors);
}

});
parcelRegister("hYgW9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.extendErrors = module.exports.resetErrorsCount = module.exports.reportExtraError = module.exports.reportError = module.exports.keyword$DataError = module.exports.keywordError = void 0;

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");

var $dOpvc = parcelRequire("dOpvc");
module.exports.keywordError = {
    message: ({ keyword: keyword })=>(0, $l2ufW.str)`must pass "${keyword}" keyword validation`
};
module.exports.keyword$DataError = {
    message: ({ keyword: keyword, schemaType: schemaType })=>schemaType ? (0, $l2ufW.str)`"${keyword}" keyword must be ${schemaType} ($data)` : (0, $l2ufW.str)`"${keyword}" keyword is invalid ($data)`
};
function $d1552d9220cfb4a2$var$reportError(cxt, error = module.exports.keywordError, errorPaths, overrideAllErrors) {
    const { it: it } = cxt;
    const { gen: gen, compositeRule: compositeRule, allErrors: allErrors } = it;
    const errObj = $d1552d9220cfb4a2$var$errorObjectCode(cxt, error, errorPaths);
    if (overrideAllErrors !== null && overrideAllErrors !== void 0 ? overrideAllErrors : compositeRule || allErrors) $d1552d9220cfb4a2$var$addError(gen, errObj);
    else $d1552d9220cfb4a2$var$returnErrors(it, (0, $l2ufW._)`[${errObj}]`);
}
module.exports.reportError = $d1552d9220cfb4a2$var$reportError;
function $d1552d9220cfb4a2$var$reportExtraError(cxt, error = module.exports.keywordError, errorPaths) {
    const { it: it } = cxt;
    const { gen: gen, compositeRule: compositeRule, allErrors: allErrors } = it;
    const errObj = $d1552d9220cfb4a2$var$errorObjectCode(cxt, error, errorPaths);
    $d1552d9220cfb4a2$var$addError(gen, errObj);
    if (!(compositeRule || allErrors)) $d1552d9220cfb4a2$var$returnErrors(it, $dOpvc.default.vErrors);
}
module.exports.reportExtraError = $d1552d9220cfb4a2$var$reportExtraError;
function $d1552d9220cfb4a2$var$resetErrorsCount(gen, errsCount) {
    gen.assign($dOpvc.default.errors, errsCount);
    gen.if((0, $l2ufW._)`${$dOpvc.default.vErrors} !== null`, ()=>gen.if(errsCount, ()=>gen.assign((0, $l2ufW._)`${$dOpvc.default.vErrors}.length`, errsCount), ()=>gen.assign($dOpvc.default.vErrors, null)));
}
module.exports.resetErrorsCount = $d1552d9220cfb4a2$var$resetErrorsCount;
function $d1552d9220cfb4a2$var$extendErrors({ gen: gen, keyword: keyword, schemaValue: schemaValue, data: data, errsCount: errsCount, it: it }) {
    /* istanbul ignore if */ if (errsCount === undefined) throw new Error("ajv implementation error");
    const err = gen.name("err");
    gen.forRange("i", errsCount, $dOpvc.default.errors, (i)=>{
        gen.const(err, (0, $l2ufW._)`${$dOpvc.default.vErrors}[${i}]`);
        gen.if((0, $l2ufW._)`${err}.instancePath === undefined`, ()=>gen.assign((0, $l2ufW._)`${err}.instancePath`, (0, $l2ufW.strConcat)($dOpvc.default.instancePath, it.errorPath)));
        gen.assign((0, $l2ufW._)`${err}.schemaPath`, (0, $l2ufW.str)`${it.errSchemaPath}/${keyword}`);
        if (it.opts.verbose) {
            gen.assign((0, $l2ufW._)`${err}.schema`, schemaValue);
            gen.assign((0, $l2ufW._)`${err}.data`, data);
        }
    });
}
module.exports.extendErrors = $d1552d9220cfb4a2$var$extendErrors;
function $d1552d9220cfb4a2$var$addError(gen, errObj) {
    const err = gen.const("err", errObj);
    gen.if((0, $l2ufW._)`${$dOpvc.default.vErrors} === null`, ()=>gen.assign($dOpvc.default.vErrors, (0, $l2ufW._)`[${err}]`), (0, $l2ufW._)`${$dOpvc.default.vErrors}.push(${err})`);
    gen.code((0, $l2ufW._)`${$dOpvc.default.errors}++`);
}
function $d1552d9220cfb4a2$var$returnErrors(it, errs) {
    const { gen: gen, validateName: validateName, schemaEnv: schemaEnv } = it;
    if (schemaEnv.$async) gen.throw((0, $l2ufW._)`new ${it.ValidationError}(${errs})`);
    else {
        gen.assign((0, $l2ufW._)`${validateName}.errors`, errs);
        gen.return(false);
    }
}
const $d1552d9220cfb4a2$var$E = {
    keyword: new $l2ufW.Name("keyword"),
    schemaPath: new $l2ufW.Name("schemaPath"),
    params: new $l2ufW.Name("params"),
    propertyName: new $l2ufW.Name("propertyName"),
    message: new $l2ufW.Name("message"),
    schema: new $l2ufW.Name("schema"),
    parentSchema: new $l2ufW.Name("parentSchema")
};
function $d1552d9220cfb4a2$var$errorObjectCode(cxt, error, errorPaths) {
    const { createErrors: createErrors } = cxt.it;
    if (createErrors === false) return (0, $l2ufW._)`{}`;
    return $d1552d9220cfb4a2$var$errorObject(cxt, error, errorPaths);
}
function $d1552d9220cfb4a2$var$errorObject(cxt, error, errorPaths = {}) {
    const { gen: gen, it: it } = cxt;
    const keyValues = [
        $d1552d9220cfb4a2$var$errorInstancePath(it, errorPaths),
        $d1552d9220cfb4a2$var$errorSchemaPath(cxt, errorPaths)
    ];
    $d1552d9220cfb4a2$var$extraErrorProps(cxt, error, keyValues);
    return gen.object(...keyValues);
}
function $d1552d9220cfb4a2$var$errorInstancePath({ errorPath: errorPath }, { instancePath: instancePath }) {
    const instPath = instancePath ? (0, $l2ufW.str)`${errorPath}${(0, $7eX5i.getErrorPath)(instancePath, $7eX5i.Type.Str)}` : errorPath;
    return [
        $dOpvc.default.instancePath,
        (0, $l2ufW.strConcat)($dOpvc.default.instancePath, instPath)
    ];
}
function $d1552d9220cfb4a2$var$errorSchemaPath({ keyword: keyword, it: { errSchemaPath: errSchemaPath } }, { schemaPath: schemaPath, parentSchema: parentSchema }) {
    let schPath = parentSchema ? errSchemaPath : (0, $l2ufW.str)`${errSchemaPath}/${keyword}`;
    if (schemaPath) schPath = (0, $l2ufW.str)`${schPath}${(0, $7eX5i.getErrorPath)(schemaPath, $7eX5i.Type.Str)}`;
    return [
        $d1552d9220cfb4a2$var$E.schemaPath,
        schPath
    ];
}
function $d1552d9220cfb4a2$var$extraErrorProps(cxt, { params: params, message: message }, keyValues) {
    const { keyword: keyword, data: data, schemaValue: schemaValue, it: it } = cxt;
    const { opts: opts, propertyName: propertyName, topSchemaRef: topSchemaRef, schemaPath: schemaPath } = it;
    keyValues.push([
        $d1552d9220cfb4a2$var$E.keyword,
        keyword
    ], [
        $d1552d9220cfb4a2$var$E.params,
        typeof params == "function" ? params(cxt) : params || (0, $l2ufW._)`{}`
    ]);
    if (opts.messages) keyValues.push([
        $d1552d9220cfb4a2$var$E.message,
        typeof message == "function" ? message(cxt) : message
    ]);
    if (opts.verbose) keyValues.push([
        $d1552d9220cfb4a2$var$E.schema,
        schemaValue
    ], [
        $d1552d9220cfb4a2$var$E.parentSchema,
        (0, $l2ufW._)`${topSchemaRef}${schemaPath}`
    ], [
        $dOpvc.default.data,
        data
    ]);
    if (propertyName) keyValues.push([
        $d1552d9220cfb4a2$var$E.propertyName,
        propertyName
    ]);
}

});
parcelRegister("l2ufW", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.or = module.exports.and = module.exports.not = module.exports.CodeGen = module.exports.operators = module.exports.varKinds = module.exports.ValueScopeName = module.exports.ValueScope = module.exports.Scope = module.exports.Name = module.exports.regexpCode = module.exports.stringify = module.exports.getProperty = module.exports.nil = module.exports.strConcat = module.exports.str = module.exports._ = void 0;

var $4GpWJ = parcelRequire("4GpWJ");

var $eNw2I = parcelRequire("eNw2I");

var $4GpWJ = parcelRequire("4GpWJ");
Object.defineProperty(module.exports, "_", {
    enumerable: true,
    get: function() {
        return $4GpWJ._;
    }
});
Object.defineProperty(module.exports, "str", {
    enumerable: true,
    get: function() {
        return $4GpWJ.str;
    }
});
Object.defineProperty(module.exports, "strConcat", {
    enumerable: true,
    get: function() {
        return $4GpWJ.strConcat;
    }
});
Object.defineProperty(module.exports, "nil", {
    enumerable: true,
    get: function() {
        return $4GpWJ.nil;
    }
});
Object.defineProperty(module.exports, "getProperty", {
    enumerable: true,
    get: function() {
        return $4GpWJ.getProperty;
    }
});
Object.defineProperty(module.exports, "stringify", {
    enumerable: true,
    get: function() {
        return $4GpWJ.stringify;
    }
});
Object.defineProperty(module.exports, "regexpCode", {
    enumerable: true,
    get: function() {
        return $4GpWJ.regexpCode;
    }
});
Object.defineProperty(module.exports, "Name", {
    enumerable: true,
    get: function() {
        return $4GpWJ.Name;
    }
});

var $eNw2I = parcelRequire("eNw2I");
Object.defineProperty(module.exports, "Scope", {
    enumerable: true,
    get: function() {
        return $eNw2I.Scope;
    }
});
Object.defineProperty(module.exports, "ValueScope", {
    enumerable: true,
    get: function() {
        return $eNw2I.ValueScope;
    }
});
Object.defineProperty(module.exports, "ValueScopeName", {
    enumerable: true,
    get: function() {
        return $eNw2I.ValueScopeName;
    }
});
Object.defineProperty(module.exports, "varKinds", {
    enumerable: true,
    get: function() {
        return $eNw2I.varKinds;
    }
});
module.exports.operators = {
    GT: new $4GpWJ._Code(">"),
    GTE: new $4GpWJ._Code(">="),
    LT: new $4GpWJ._Code("<"),
    LTE: new $4GpWJ._Code("<="),
    EQ: new $4GpWJ._Code("==="),
    NEQ: new $4GpWJ._Code("!=="),
    NOT: new $4GpWJ._Code("!"),
    OR: new $4GpWJ._Code("||"),
    AND: new $4GpWJ._Code("&&"),
    ADD: new $4GpWJ._Code("+")
};
class $f511411e7bf8f284$var$Node {
    optimizeNodes() {
        return this;
    }
    optimizeNames(_names, _constants) {
        return this;
    }
}
class $f511411e7bf8f284$var$Def extends $f511411e7bf8f284$var$Node {
    constructor(varKind, name, rhs){
        super();
        this.varKind = varKind;
        this.name = name;
        this.rhs = rhs;
    }
    render({ es5: es5, _n: _n }) {
        const varKind = es5 ? $eNw2I.varKinds.var : this.varKind;
        const rhs = this.rhs === undefined ? "" : ` = ${this.rhs}`;
        return `${varKind} ${this.name}${rhs};` + _n;
    }
    optimizeNames(names, constants) {
        if (!names[this.name.str]) return;
        if (this.rhs) this.rhs = $f511411e7bf8f284$var$optimizeExpr(this.rhs, names, constants);
        return this;
    }
    get names() {
        return this.rhs instanceof $4GpWJ._CodeOrName ? this.rhs.names : {};
    }
}
class $f511411e7bf8f284$var$Assign extends $f511411e7bf8f284$var$Node {
    constructor(lhs, rhs, sideEffects){
        super();
        this.lhs = lhs;
        this.rhs = rhs;
        this.sideEffects = sideEffects;
    }
    render({ _n: _n }) {
        return `${this.lhs} = ${this.rhs};` + _n;
    }
    optimizeNames(names, constants) {
        if (this.lhs instanceof $4GpWJ.Name && !names[this.lhs.str] && !this.sideEffects) return;
        this.rhs = $f511411e7bf8f284$var$optimizeExpr(this.rhs, names, constants);
        return this;
    }
    get names() {
        const names = this.lhs instanceof $4GpWJ.Name ? {} : {
            ...this.lhs.names
        };
        return $f511411e7bf8f284$var$addExprNames(names, this.rhs);
    }
}
class $f511411e7bf8f284$var$AssignOp extends $f511411e7bf8f284$var$Assign {
    constructor(lhs, op, rhs, sideEffects){
        super(lhs, rhs, sideEffects);
        this.op = op;
    }
    render({ _n: _n }) {
        return `${this.lhs} ${this.op}= ${this.rhs};` + _n;
    }
}
class $f511411e7bf8f284$var$Label extends $f511411e7bf8f284$var$Node {
    constructor(label){
        super();
        this.label = label;
        this.names = {};
    }
    render({ _n: _n }) {
        return `${this.label}:` + _n;
    }
}
class $f511411e7bf8f284$var$Break extends $f511411e7bf8f284$var$Node {
    constructor(label){
        super();
        this.label = label;
        this.names = {};
    }
    render({ _n: _n }) {
        const label = this.label ? ` ${this.label}` : "";
        return `break${label};` + _n;
    }
}
class $f511411e7bf8f284$var$Throw extends $f511411e7bf8f284$var$Node {
    constructor(error){
        super();
        this.error = error;
    }
    render({ _n: _n }) {
        return `throw ${this.error};` + _n;
    }
    get names() {
        return this.error.names;
    }
}
class $f511411e7bf8f284$var$AnyCode extends $f511411e7bf8f284$var$Node {
    constructor(code){
        super();
        this.code = code;
    }
    render({ _n: _n }) {
        return `${this.code};` + _n;
    }
    optimizeNodes() {
        return `${this.code}` ? this : undefined;
    }
    optimizeNames(names, constants) {
        this.code = $f511411e7bf8f284$var$optimizeExpr(this.code, names, constants);
        return this;
    }
    get names() {
        return this.code instanceof $4GpWJ._CodeOrName ? this.code.names : {};
    }
}
class $f511411e7bf8f284$var$ParentNode extends $f511411e7bf8f284$var$Node {
    constructor(nodes = []){
        super();
        this.nodes = nodes;
    }
    render(opts) {
        return this.nodes.reduce((code, n)=>code + n.render(opts), "");
    }
    optimizeNodes() {
        const { nodes: nodes } = this;
        let i = nodes.length;
        while(i--){
            const n = nodes[i].optimizeNodes();
            if (Array.isArray(n)) nodes.splice(i, 1, ...n);
            else if (n) nodes[i] = n;
            else nodes.splice(i, 1);
        }
        return nodes.length > 0 ? this : undefined;
    }
    optimizeNames(names, constants) {
        const { nodes: nodes } = this;
        let i = nodes.length;
        while(i--){
            // iterating backwards improves 1-pass optimization
            const n = nodes[i];
            if (n.optimizeNames(names, constants)) continue;
            $f511411e7bf8f284$var$subtractNames(names, n.names);
            nodes.splice(i, 1);
        }
        return nodes.length > 0 ? this : undefined;
    }
    get names() {
        return this.nodes.reduce((names, n)=>$f511411e7bf8f284$var$addNames(names, n.names), {});
    }
}
class $f511411e7bf8f284$var$BlockNode extends $f511411e7bf8f284$var$ParentNode {
    render(opts) {
        return "{" + opts._n + super.render(opts) + "}" + opts._n;
    }
}
class $f511411e7bf8f284$var$Root extends $f511411e7bf8f284$var$ParentNode {
}
class $f511411e7bf8f284$var$Else extends $f511411e7bf8f284$var$BlockNode {
}
$f511411e7bf8f284$var$Else.kind = "else";
class $f511411e7bf8f284$var$If extends $f511411e7bf8f284$var$BlockNode {
    constructor(condition, nodes){
        super(nodes);
        this.condition = condition;
    }
    render(opts) {
        let code = `if(${this.condition})` + super.render(opts);
        if (this.else) code += "else " + this.else.render(opts);
        return code;
    }
    optimizeNodes() {
        super.optimizeNodes();
        const cond = this.condition;
        if (cond === true) return this.nodes; // else is ignored here
        let e = this.else;
        if (e) {
            const ns = e.optimizeNodes();
            e = this.else = Array.isArray(ns) ? new $f511411e7bf8f284$var$Else(ns) : ns;
        }
        if (e) {
            if (cond === false) return e instanceof $f511411e7bf8f284$var$If ? e : e.nodes;
            if (this.nodes.length) return this;
            return new $f511411e7bf8f284$var$If($f511411e7bf8f284$var$not(cond), e instanceof $f511411e7bf8f284$var$If ? [
                e
            ] : e.nodes);
        }
        if (cond === false || !this.nodes.length) return undefined;
        return this;
    }
    optimizeNames(names, constants) {
        var _a;
        this.else = (_a = this.else) === null || _a === void 0 ? void 0 : _a.optimizeNames(names, constants);
        if (!(super.optimizeNames(names, constants) || this.else)) return;
        this.condition = $f511411e7bf8f284$var$optimizeExpr(this.condition, names, constants);
        return this;
    }
    get names() {
        const names = super.names;
        $f511411e7bf8f284$var$addExprNames(names, this.condition);
        if (this.else) $f511411e7bf8f284$var$addNames(names, this.else.names);
        return names;
    }
}
$f511411e7bf8f284$var$If.kind = "if";
class $f511411e7bf8f284$var$For extends $f511411e7bf8f284$var$BlockNode {
}
$f511411e7bf8f284$var$For.kind = "for";
class $f511411e7bf8f284$var$ForLoop extends $f511411e7bf8f284$var$For {
    constructor(iteration){
        super();
        this.iteration = iteration;
    }
    render(opts) {
        return `for(${this.iteration})` + super.render(opts);
    }
    optimizeNames(names, constants) {
        if (!super.optimizeNames(names, constants)) return;
        this.iteration = $f511411e7bf8f284$var$optimizeExpr(this.iteration, names, constants);
        return this;
    }
    get names() {
        return $f511411e7bf8f284$var$addNames(super.names, this.iteration.names);
    }
}
class $f511411e7bf8f284$var$ForRange extends $f511411e7bf8f284$var$For {
    constructor(varKind, name, from, to){
        super();
        this.varKind = varKind;
        this.name = name;
        this.from = from;
        this.to = to;
    }
    render(opts) {
        const varKind = opts.es5 ? $eNw2I.varKinds.var : this.varKind;
        const { name: name, from: from, to: to } = this;
        return `for(${varKind} ${name}=${from}; ${name}<${to}; ${name}++)` + super.render(opts);
    }
    get names() {
        const names = $f511411e7bf8f284$var$addExprNames(super.names, this.from);
        return $f511411e7bf8f284$var$addExprNames(names, this.to);
    }
}
class $f511411e7bf8f284$var$ForIter extends $f511411e7bf8f284$var$For {
    constructor(loop, varKind, name, iterable){
        super();
        this.loop = loop;
        this.varKind = varKind;
        this.name = name;
        this.iterable = iterable;
    }
    render(opts) {
        return `for(${this.varKind} ${this.name} ${this.loop} ${this.iterable})` + super.render(opts);
    }
    optimizeNames(names, constants) {
        if (!super.optimizeNames(names, constants)) return;
        this.iterable = $f511411e7bf8f284$var$optimizeExpr(this.iterable, names, constants);
        return this;
    }
    get names() {
        return $f511411e7bf8f284$var$addNames(super.names, this.iterable.names);
    }
}
class $f511411e7bf8f284$var$Func extends $f511411e7bf8f284$var$BlockNode {
    constructor(name, args, async){
        super();
        this.name = name;
        this.args = args;
        this.async = async;
    }
    render(opts) {
        const _async = this.async ? "async " : "";
        return `${_async}function ${this.name}(${this.args})` + super.render(opts);
    }
}
$f511411e7bf8f284$var$Func.kind = "func";
class $f511411e7bf8f284$var$Return extends $f511411e7bf8f284$var$ParentNode {
    render(opts) {
        return "return " + super.render(opts);
    }
}
$f511411e7bf8f284$var$Return.kind = "return";
class $f511411e7bf8f284$var$Try extends $f511411e7bf8f284$var$BlockNode {
    render(opts) {
        let code = "try" + super.render(opts);
        if (this.catch) code += this.catch.render(opts);
        if (this.finally) code += this.finally.render(opts);
        return code;
    }
    optimizeNodes() {
        var _a, _b;
        super.optimizeNodes();
        (_a = this.catch) === null || _a === void 0 || _a.optimizeNodes();
        (_b = this.finally) === null || _b === void 0 || _b.optimizeNodes();
        return this;
    }
    optimizeNames(names, constants) {
        var _a, _b;
        super.optimizeNames(names, constants);
        (_a = this.catch) === null || _a === void 0 || _a.optimizeNames(names, constants);
        (_b = this.finally) === null || _b === void 0 || _b.optimizeNames(names, constants);
        return this;
    }
    get names() {
        const names = super.names;
        if (this.catch) $f511411e7bf8f284$var$addNames(names, this.catch.names);
        if (this.finally) $f511411e7bf8f284$var$addNames(names, this.finally.names);
        return names;
    }
}
class $f511411e7bf8f284$var$Catch extends $f511411e7bf8f284$var$BlockNode {
    constructor(error){
        super();
        this.error = error;
    }
    render(opts) {
        return `catch(${this.error})` + super.render(opts);
    }
}
$f511411e7bf8f284$var$Catch.kind = "catch";
class $f511411e7bf8f284$var$Finally extends $f511411e7bf8f284$var$BlockNode {
    render(opts) {
        return "finally" + super.render(opts);
    }
}
$f511411e7bf8f284$var$Finally.kind = "finally";
class $f511411e7bf8f284$var$CodeGen {
    constructor(extScope, opts = {}){
        this._values = {};
        this._blockStarts = [];
        this._constants = {};
        this.opts = {
            ...opts,
            _n: opts.lines ? "\n" : ""
        };
        this._extScope = extScope;
        this._scope = new $eNw2I.Scope({
            parent: extScope
        });
        this._nodes = [
            new $f511411e7bf8f284$var$Root()
        ];
    }
    toString() {
        return this._root.render(this.opts);
    }
    // returns unique name in the internal scope
    name(prefix) {
        return this._scope.name(prefix);
    }
    // reserves unique name in the external scope
    scopeName(prefix) {
        return this._extScope.name(prefix);
    }
    // reserves unique name in the external scope and assigns value to it
    scopeValue(prefixOrName, value) {
        const name = this._extScope.value(prefixOrName, value);
        const vs = this._values[name.prefix] || (this._values[name.prefix] = new Set());
        vs.add(name);
        return name;
    }
    getScopeValue(prefix, keyOrRef) {
        return this._extScope.getValue(prefix, keyOrRef);
    }
    // return code that assigns values in the external scope to the names that are used internally
    // (same names that were returned by gen.scopeName or gen.scopeValue)
    scopeRefs(scopeName) {
        return this._extScope.scopeRefs(scopeName, this._values);
    }
    scopeCode() {
        return this._extScope.scopeCode(this._values);
    }
    _def(varKind, nameOrPrefix, rhs, constant) {
        const name = this._scope.toName(nameOrPrefix);
        if (rhs !== undefined && constant) this._constants[name.str] = rhs;
        this._leafNode(new $f511411e7bf8f284$var$Def(varKind, name, rhs));
        return name;
    }
    // `const` declaration (`var` in es5 mode)
    const(nameOrPrefix, rhs, _constant) {
        return this._def($eNw2I.varKinds.const, nameOrPrefix, rhs, _constant);
    }
    // `let` declaration with optional assignment (`var` in es5 mode)
    let(nameOrPrefix, rhs, _constant) {
        return this._def($eNw2I.varKinds.let, nameOrPrefix, rhs, _constant);
    }
    // `var` declaration with optional assignment
    var(nameOrPrefix, rhs, _constant) {
        return this._def($eNw2I.varKinds.var, nameOrPrefix, rhs, _constant);
    }
    // assignment code
    assign(lhs, rhs, sideEffects) {
        return this._leafNode(new $f511411e7bf8f284$var$Assign(lhs, rhs, sideEffects));
    }
    // `+=` code
    add(lhs, rhs) {
        return this._leafNode(new $f511411e7bf8f284$var$AssignOp(lhs, module.exports.operators.ADD, rhs));
    }
    // appends passed SafeExpr to code or executes Block
    code(c) {
        if (typeof c == "function") c();
        else if (c !== $4GpWJ.nil) this._leafNode(new $f511411e7bf8f284$var$AnyCode(c));
        return this;
    }
    // returns code for object literal for the passed argument list of key-value pairs
    object(...keyValues) {
        const code = [
            "{"
        ];
        for (const [key, value] of keyValues){
            if (code.length > 1) code.push(",");
            code.push(key);
            if (key !== value || this.opts.es5) {
                code.push(":");
                (0, $4GpWJ.addCodeArg)(code, value);
            }
        }
        code.push("}");
        return new $4GpWJ._Code(code);
    }
    // `if` clause (or statement if `thenBody` and, optionally, `elseBody` are passed)
    if(condition, thenBody, elseBody) {
        this._blockNode(new $f511411e7bf8f284$var$If(condition));
        if (thenBody && elseBody) this.code(thenBody).else().code(elseBody).endIf();
        else if (thenBody) this.code(thenBody).endIf();
        else if (elseBody) throw new Error('CodeGen: "else" body without "then" body');
        return this;
    }
    // `else if` clause - invalid without `if` or after `else` clauses
    elseIf(condition) {
        return this._elseNode(new $f511411e7bf8f284$var$If(condition));
    }
    // `else` clause - only valid after `if` or `else if` clauses
    else() {
        return this._elseNode(new $f511411e7bf8f284$var$Else());
    }
    // end `if` statement (needed if gen.if was used only with condition)
    endIf() {
        return this._endBlockNode($f511411e7bf8f284$var$If, $f511411e7bf8f284$var$Else);
    }
    _for(node, forBody) {
        this._blockNode(node);
        if (forBody) this.code(forBody).endFor();
        return this;
    }
    // a generic `for` clause (or statement if `forBody` is passed)
    for(iteration, forBody) {
        return this._for(new $f511411e7bf8f284$var$ForLoop(iteration), forBody);
    }
    // `for` statement for a range of values
    forRange(nameOrPrefix, from, to, forBody, varKind = this.opts.es5 ? $eNw2I.varKinds.var : $eNw2I.varKinds.let) {
        const name = this._scope.toName(nameOrPrefix);
        return this._for(new $f511411e7bf8f284$var$ForRange(varKind, name, from, to), ()=>forBody(name));
    }
    // `for-of` statement (in es5 mode replace with a normal for loop)
    forOf(nameOrPrefix, iterable, forBody, varKind = $eNw2I.varKinds.const) {
        const name = this._scope.toName(nameOrPrefix);
        if (this.opts.es5) {
            const arr = iterable instanceof $4GpWJ.Name ? iterable : this.var("_arr", iterable);
            return this.forRange("_i", 0, (0, $4GpWJ._)`${arr}.length`, (i)=>{
                this.var(name, (0, $4GpWJ._)`${arr}[${i}]`);
                forBody(name);
            });
        }
        return this._for(new $f511411e7bf8f284$var$ForIter("of", varKind, name, iterable), ()=>forBody(name));
    }
    // `for-in` statement.
    // With option `ownProperties` replaced with a `for-of` loop for object keys
    forIn(nameOrPrefix, obj, forBody, varKind = this.opts.es5 ? $eNw2I.varKinds.var : $eNw2I.varKinds.const) {
        if (this.opts.ownProperties) return this.forOf(nameOrPrefix, (0, $4GpWJ._)`Object.keys(${obj})`, forBody);
        const name = this._scope.toName(nameOrPrefix);
        return this._for(new $f511411e7bf8f284$var$ForIter("in", varKind, name, obj), ()=>forBody(name));
    }
    // end `for` loop
    endFor() {
        return this._endBlockNode($f511411e7bf8f284$var$For);
    }
    // `label` statement
    label(label) {
        return this._leafNode(new $f511411e7bf8f284$var$Label(label));
    }
    // `break` statement
    break(label) {
        return this._leafNode(new $f511411e7bf8f284$var$Break(label));
    }
    // `return` statement
    return(value) {
        const node = new $f511411e7bf8f284$var$Return();
        this._blockNode(node);
        this.code(value);
        if (node.nodes.length !== 1) throw new Error('CodeGen: "return" should have one node');
        return this._endBlockNode($f511411e7bf8f284$var$Return);
    }
    // `try` statement
    try(tryBody, catchCode, finallyCode) {
        if (!catchCode && !finallyCode) throw new Error('CodeGen: "try" without "catch" and "finally"');
        const node = new $f511411e7bf8f284$var$Try();
        this._blockNode(node);
        this.code(tryBody);
        if (catchCode) {
            const error = this.name("e");
            this._currNode = node.catch = new $f511411e7bf8f284$var$Catch(error);
            catchCode(error);
        }
        if (finallyCode) {
            this._currNode = node.finally = new $f511411e7bf8f284$var$Finally();
            this.code(finallyCode);
        }
        return this._endBlockNode($f511411e7bf8f284$var$Catch, $f511411e7bf8f284$var$Finally);
    }
    // `throw` statement
    throw(error) {
        return this._leafNode(new $f511411e7bf8f284$var$Throw(error));
    }
    // start self-balancing block
    block(body, nodeCount) {
        this._blockStarts.push(this._nodes.length);
        if (body) this.code(body).endBlock(nodeCount);
        return this;
    }
    // end the current self-balancing block
    endBlock(nodeCount) {
        const len = this._blockStarts.pop();
        if (len === undefined) throw new Error("CodeGen: not in self-balancing block");
        const toClose = this._nodes.length - len;
        if (toClose < 0 || nodeCount !== undefined && toClose !== nodeCount) throw new Error(`CodeGen: wrong number of nodes: ${toClose} vs ${nodeCount} expected`);
        this._nodes.length = len;
        return this;
    }
    // `function` heading (or definition if funcBody is passed)
    func(name, args = $4GpWJ.nil, async, funcBody) {
        this._blockNode(new $f511411e7bf8f284$var$Func(name, args, async));
        if (funcBody) this.code(funcBody).endFunc();
        return this;
    }
    // end function definition
    endFunc() {
        return this._endBlockNode($f511411e7bf8f284$var$Func);
    }
    optimize(n = 1) {
        while(n-- > 0){
            this._root.optimizeNodes();
            this._root.optimizeNames(this._root.names, this._constants);
        }
    }
    _leafNode(node) {
        this._currNode.nodes.push(node);
        return this;
    }
    _blockNode(node) {
        this._currNode.nodes.push(node);
        this._nodes.push(node);
    }
    _endBlockNode(N1, N2) {
        const n = this._currNode;
        if (n instanceof N1 || N2 && n instanceof N2) {
            this._nodes.pop();
            return this;
        }
        throw new Error(`CodeGen: not in block "${N2 ? `${N1.kind}/${N2.kind}` : N1.kind}"`);
    }
    _elseNode(node) {
        const n = this._currNode;
        if (!(n instanceof $f511411e7bf8f284$var$If)) throw new Error('CodeGen: "else" without "if"');
        this._currNode = n.else = node;
        return this;
    }
    get _root() {
        return this._nodes[0];
    }
    get _currNode() {
        const ns = this._nodes;
        return ns[ns.length - 1];
    }
    set _currNode(node) {
        const ns = this._nodes;
        ns[ns.length - 1] = node;
    }
}
module.exports.CodeGen = $f511411e7bf8f284$var$CodeGen;
function $f511411e7bf8f284$var$addNames(names, from) {
    for(const n in from)names[n] = (names[n] || 0) + (from[n] || 0);
    return names;
}
function $f511411e7bf8f284$var$addExprNames(names, from) {
    return from instanceof $4GpWJ._CodeOrName ? $f511411e7bf8f284$var$addNames(names, from.names) : names;
}
function $f511411e7bf8f284$var$optimizeExpr(expr, names, constants) {
    if (expr instanceof $4GpWJ.Name) return replaceName(expr);
    if (!canOptimize(expr)) return expr;
    return new $4GpWJ._Code(expr._items.reduce((items, c)=>{
        if (c instanceof $4GpWJ.Name) c = replaceName(c);
        if (c instanceof $4GpWJ._Code) items.push(...c._items);
        else items.push(c);
        return items;
    }, []));
    function replaceName(n) {
        const c = constants[n.str];
        if (c === undefined || names[n.str] !== 1) return n;
        delete names[n.str];
        return c;
    }
    function canOptimize(e) {
        return e instanceof $4GpWJ._Code && e._items.some((c)=>c instanceof $4GpWJ.Name && names[c.str] === 1 && constants[c.str] !== undefined);
    }
}
function $f511411e7bf8f284$var$subtractNames(names, from) {
    for(const n in from)names[n] = (names[n] || 0) - (from[n] || 0);
}
function $f511411e7bf8f284$var$not(x) {
    return typeof x == "boolean" || typeof x == "number" || x === null ? !x : (0, $4GpWJ._)`!${$f511411e7bf8f284$var$par(x)}`;
}
module.exports.not = $f511411e7bf8f284$var$not;
const $f511411e7bf8f284$var$andCode = $f511411e7bf8f284$var$mappend(module.exports.operators.AND);
// boolean AND (&&) expression with the passed arguments
function $f511411e7bf8f284$var$and(...args) {
    return args.reduce($f511411e7bf8f284$var$andCode);
}
module.exports.and = $f511411e7bf8f284$var$and;
const $f511411e7bf8f284$var$orCode = $f511411e7bf8f284$var$mappend(module.exports.operators.OR);
// boolean OR (||) expression with the passed arguments
function $f511411e7bf8f284$var$or(...args) {
    return args.reduce($f511411e7bf8f284$var$orCode);
}
module.exports.or = $f511411e7bf8f284$var$or;
function $f511411e7bf8f284$var$mappend(op) {
    return (x, y)=>x === $4GpWJ.nil ? y : y === $4GpWJ.nil ? x : (0, $4GpWJ._)`${$f511411e7bf8f284$var$par(x)} ${op} ${$f511411e7bf8f284$var$par(y)}`;
}
function $f511411e7bf8f284$var$par(x) {
    return x instanceof $4GpWJ.Name ? x : (0, $4GpWJ._)`(${x})`;
}

});
parcelRegister("4GpWJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.regexpCode = module.exports.getEsmExportName = module.exports.getProperty = module.exports.safeStringify = module.exports.stringify = module.exports.strConcat = module.exports.addCodeArg = module.exports.str = module.exports._ = module.exports.nil = module.exports._Code = module.exports.Name = module.exports.IDENTIFIER = module.exports._CodeOrName = void 0;
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
class $368f361121c33a9b$var$_CodeOrName {
}
module.exports._CodeOrName = $368f361121c33a9b$var$_CodeOrName;
module.exports.IDENTIFIER = /^[a-z$_][a-z$_0-9]*$/i;
class $368f361121c33a9b$var$Name extends $368f361121c33a9b$var$_CodeOrName {
    constructor(s){
        super();
        if (!module.exports.IDENTIFIER.test(s)) throw new Error("CodeGen: name must be a valid identifier");
        this.str = s;
    }
    toString() {
        return this.str;
    }
    emptyStr() {
        return false;
    }
    get names() {
        return {
            [this.str]: 1
        };
    }
}
module.exports.Name = $368f361121c33a9b$var$Name;
class $368f361121c33a9b$var$_Code extends $368f361121c33a9b$var$_CodeOrName {
    constructor(code){
        super();
        this._items = typeof code === "string" ? [
            code
        ] : code;
    }
    toString() {
        return this.str;
    }
    emptyStr() {
        if (this._items.length > 1) return false;
        const item = this._items[0];
        return item === "" || item === '""';
    }
    get str() {
        var _a;
        return (_a = this._str) !== null && _a !== void 0 ? _a : this._str = this._items.reduce((s, c)=>`${s}${c}`, "");
    }
    get names() {
        var _a;
        return (_a = this._names) !== null && _a !== void 0 ? _a : this._names = this._items.reduce((names, c)=>{
            if (c instanceof $368f361121c33a9b$var$Name) names[c.str] = (names[c.str] || 0) + 1;
            return names;
        }, {});
    }
}
module.exports._Code = $368f361121c33a9b$var$_Code;
module.exports.nil = new $368f361121c33a9b$var$_Code("");
function $368f361121c33a9b$var$_(strs, ...args) {
    const code = [
        strs[0]
    ];
    let i = 0;
    while(i < args.length){
        $368f361121c33a9b$var$addCodeArg(code, args[i]);
        code.push(strs[++i]);
    }
    return new $368f361121c33a9b$var$_Code(code);
}
module.exports._ = $368f361121c33a9b$var$_;
const $368f361121c33a9b$var$plus = new $368f361121c33a9b$var$_Code("+");
function $368f361121c33a9b$var$str(strs, ...args) {
    const expr = [
        $368f361121c33a9b$var$safeStringify(strs[0])
    ];
    let i = 0;
    while(i < args.length){
        expr.push($368f361121c33a9b$var$plus);
        $368f361121c33a9b$var$addCodeArg(expr, args[i]);
        expr.push($368f361121c33a9b$var$plus, $368f361121c33a9b$var$safeStringify(strs[++i]));
    }
    $368f361121c33a9b$var$optimize(expr);
    return new $368f361121c33a9b$var$_Code(expr);
}
module.exports.str = $368f361121c33a9b$var$str;
function $368f361121c33a9b$var$addCodeArg(code, arg) {
    if (arg instanceof $368f361121c33a9b$var$_Code) code.push(...arg._items);
    else if (arg instanceof $368f361121c33a9b$var$Name) code.push(arg);
    else code.push($368f361121c33a9b$var$interpolate(arg));
}
module.exports.addCodeArg = $368f361121c33a9b$var$addCodeArg;
function $368f361121c33a9b$var$optimize(expr) {
    let i = 1;
    while(i < expr.length - 1){
        if (expr[i] === $368f361121c33a9b$var$plus) {
            const res = $368f361121c33a9b$var$mergeExprItems(expr[i - 1], expr[i + 1]);
            if (res !== undefined) {
                expr.splice(i - 1, 3, res);
                continue;
            }
            expr[i++] = "+";
        }
        i++;
    }
}
function $368f361121c33a9b$var$mergeExprItems(a, b) {
    if (b === '""') return a;
    if (a === '""') return b;
    if (typeof a == "string") {
        if (b instanceof $368f361121c33a9b$var$Name || a[a.length - 1] !== '"') return;
        if (typeof b != "string") return `${a.slice(0, -1)}${b}"`;
        if (b[0] === '"') return a.slice(0, -1) + b.slice(1);
        return;
    }
    if (typeof b == "string" && b[0] === '"' && !(a instanceof $368f361121c33a9b$var$Name)) return `"${a}${b.slice(1)}`;
    return;
}
function $368f361121c33a9b$var$strConcat(c1, c2) {
    return c2.emptyStr() ? c1 : c1.emptyStr() ? c2 : $368f361121c33a9b$var$str`${c1}${c2}`;
}
module.exports.strConcat = $368f361121c33a9b$var$strConcat;
// TODO do not allow arrays here
function $368f361121c33a9b$var$interpolate(x) {
    return typeof x == "number" || typeof x == "boolean" || x === null ? x : $368f361121c33a9b$var$safeStringify(Array.isArray(x) ? x.join(",") : x);
}
function $368f361121c33a9b$var$stringify(x) {
    return new $368f361121c33a9b$var$_Code($368f361121c33a9b$var$safeStringify(x));
}
module.exports.stringify = $368f361121c33a9b$var$stringify;
function $368f361121c33a9b$var$safeStringify(x) {
    return JSON.stringify(x).replace(/\u2028/g, "\\u2028").replace(/\u2029/g, "\\u2029");
}
module.exports.safeStringify = $368f361121c33a9b$var$safeStringify;
function $368f361121c33a9b$var$getProperty(key) {
    return typeof key == "string" && module.exports.IDENTIFIER.test(key) ? new $368f361121c33a9b$var$_Code(`.${key}`) : $368f361121c33a9b$var$_`[${key}]`;
}
module.exports.getProperty = $368f361121c33a9b$var$getProperty;
//Does best effort to format the name properly
function $368f361121c33a9b$var$getEsmExportName(key) {
    if (typeof key == "string" && module.exports.IDENTIFIER.test(key)) return new $368f361121c33a9b$var$_Code(`${key}`);
    throw new Error(`CodeGen: invalid export name: ${key}, use explicit $id name mapping`);
}
module.exports.getEsmExportName = $368f361121c33a9b$var$getEsmExportName;
function $368f361121c33a9b$var$regexpCode(rx) {
    return new $368f361121c33a9b$var$_Code(rx.toString());
}
module.exports.regexpCode = $368f361121c33a9b$var$regexpCode;

});

parcelRegister("eNw2I", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ValueScope = module.exports.ValueScopeName = module.exports.Scope = module.exports.varKinds = module.exports.UsedValueState = void 0;

var $4GpWJ = parcelRequire("4GpWJ");
class $ac5e7f513a485aeb$var$ValueError extends Error {
    constructor(name){
        super(`CodeGen: "code" for ${name} not defined`);
        this.value = name.value;
    }
}
var $ac5e7f513a485aeb$var$UsedValueState;
(function(UsedValueState) {
    UsedValueState[UsedValueState["Started"] = 0] = "Started";
    UsedValueState[UsedValueState["Completed"] = 1] = "Completed";
})($ac5e7f513a485aeb$var$UsedValueState || (module.exports.UsedValueState = $ac5e7f513a485aeb$var$UsedValueState = {}));
module.exports.varKinds = {
    const: new $4GpWJ.Name("const"),
    let: new $4GpWJ.Name("let"),
    var: new $4GpWJ.Name("var")
};
class $ac5e7f513a485aeb$var$Scope {
    constructor({ prefixes: prefixes, parent: parent } = {}){
        this._names = {};
        this._prefixes = prefixes;
        this._parent = parent;
    }
    toName(nameOrPrefix) {
        return nameOrPrefix instanceof $4GpWJ.Name ? nameOrPrefix : this.name(nameOrPrefix);
    }
    name(prefix) {
        return new $4GpWJ.Name(this._newName(prefix));
    }
    _newName(prefix) {
        const ng = this._names[prefix] || this._nameGroup(prefix);
        return `${prefix}${ng.index++}`;
    }
    _nameGroup(prefix) {
        var _a, _b;
        if (((_b = (_a = this._parent) === null || _a === void 0 ? void 0 : _a._prefixes) === null || _b === void 0 ? void 0 : _b.has(prefix)) || this._prefixes && !this._prefixes.has(prefix)) throw new Error(`CodeGen: prefix "${prefix}" is not allowed in this scope`);
        return this._names[prefix] = {
            prefix: prefix,
            index: 0
        };
    }
}
module.exports.Scope = $ac5e7f513a485aeb$var$Scope;
class $ac5e7f513a485aeb$var$ValueScopeName extends $4GpWJ.Name {
    constructor(prefix, nameStr){
        super(nameStr);
        this.prefix = prefix;
    }
    setValue(value, { property: property, itemIndex: itemIndex }) {
        this.value = value;
        this.scopePath = (0, $4GpWJ._)`.${new $4GpWJ.Name(property)}[${itemIndex}]`;
    }
}
module.exports.ValueScopeName = $ac5e7f513a485aeb$var$ValueScopeName;
const $ac5e7f513a485aeb$var$line = (0, $4GpWJ._)`\n`;
class $ac5e7f513a485aeb$var$ValueScope extends $ac5e7f513a485aeb$var$Scope {
    constructor(opts){
        super(opts);
        this._values = {};
        this._scope = opts.scope;
        this.opts = {
            ...opts,
            _n: opts.lines ? $ac5e7f513a485aeb$var$line : $4GpWJ.nil
        };
    }
    get() {
        return this._scope;
    }
    name(prefix) {
        return new $ac5e7f513a485aeb$var$ValueScopeName(prefix, this._newName(prefix));
    }
    value(nameOrPrefix, value) {
        var _a;
        if (value.ref === undefined) throw new Error("CodeGen: ref must be passed in value");
        const name = this.toName(nameOrPrefix);
        const { prefix: prefix } = name;
        const valueKey = (_a = value.key) !== null && _a !== void 0 ? _a : value.ref;
        let vs = this._values[prefix];
        if (vs) {
            const _name = vs.get(valueKey);
            if (_name) return _name;
        } else vs = this._values[prefix] = new Map();
        vs.set(valueKey, name);
        const s = this._scope[prefix] || (this._scope[prefix] = []);
        const itemIndex = s.length;
        s[itemIndex] = value.ref;
        name.setValue(value, {
            property: prefix,
            itemIndex: itemIndex
        });
        return name;
    }
    getValue(prefix, keyOrRef) {
        const vs = this._values[prefix];
        if (!vs) return;
        return vs.get(keyOrRef);
    }
    scopeRefs(scopeName, values = this._values) {
        return this._reduceValues(values, (name)=>{
            if (name.scopePath === undefined) throw new Error(`CodeGen: name "${name}" has no value`);
            return (0, $4GpWJ._)`${scopeName}${name.scopePath}`;
        });
    }
    scopeCode(values = this._values, usedValues, getCode) {
        return this._reduceValues(values, (name)=>{
            if (name.value === undefined) throw new Error(`CodeGen: name "${name}" has no value`);
            return name.value.code;
        }, usedValues, getCode);
    }
    _reduceValues(values, valueCode, usedValues = {}, getCode) {
        let code = $4GpWJ.nil;
        for(const prefix in values){
            const vs = values[prefix];
            if (!vs) continue;
            const nameSet = usedValues[prefix] = usedValues[prefix] || new Map();
            vs.forEach((name)=>{
                if (nameSet.has(name)) return;
                nameSet.set(name, $ac5e7f513a485aeb$var$UsedValueState.Started);
                let c = valueCode(name);
                if (c) {
                    const def = this.opts.es5 ? module.exports.varKinds.var : module.exports.varKinds.const;
                    code = (0, $4GpWJ._)`${code}${def} ${name} = ${c};${this.opts._n}`;
                } else if (c = getCode === null || getCode === void 0 ? void 0 : getCode(name)) code = (0, $4GpWJ._)`${code}${c}${this.opts._n}`;
                else throw new $ac5e7f513a485aeb$var$ValueError(name);
                nameSet.set(name, $ac5e7f513a485aeb$var$UsedValueState.Completed);
            });
        }
        return code;
    }
}
module.exports.ValueScope = $ac5e7f513a485aeb$var$ValueScope;

});


parcelRegister("7eX5i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkStrictMode = module.exports.getErrorPath = module.exports.Type = module.exports.useFunc = module.exports.setEvaluated = module.exports.evaluatedPropsToName = module.exports.mergeEvaluated = module.exports.eachItem = module.exports.unescapeJsonPointer = module.exports.escapeJsonPointer = module.exports.escapeFragment = module.exports.unescapeFragment = module.exports.schemaRefOrVal = module.exports.schemaHasRulesButRef = module.exports.schemaHasRules = module.exports.checkUnknownRules = module.exports.alwaysValidSchema = module.exports.toHash = void 0;

var $l2ufW = parcelRequire("l2ufW");

var $4GpWJ = parcelRequire("4GpWJ");
// TODO refactor to use Set
function $5457ac2764e63104$var$toHash(arr) {
    const hash = {};
    for (const item of arr)hash[item] = true;
    return hash;
}
module.exports.toHash = $5457ac2764e63104$var$toHash;
function $5457ac2764e63104$var$alwaysValidSchema(it, schema) {
    if (typeof schema == "boolean") return schema;
    if (Object.keys(schema).length === 0) return true;
    $5457ac2764e63104$var$checkUnknownRules(it, schema);
    return !$5457ac2764e63104$var$schemaHasRules(schema, it.self.RULES.all);
}
module.exports.alwaysValidSchema = $5457ac2764e63104$var$alwaysValidSchema;
function $5457ac2764e63104$var$checkUnknownRules(it, schema = it.schema) {
    const { opts: opts, self: self } = it;
    if (!opts.strictSchema) return;
    if (typeof schema === "boolean") return;
    const rules = self.RULES.keywords;
    for(const key in schema)if (!rules[key]) $5457ac2764e63104$var$checkStrictMode(it, `unknown keyword: "${key}"`);
}
module.exports.checkUnknownRules = $5457ac2764e63104$var$checkUnknownRules;
function $5457ac2764e63104$var$schemaHasRules(schema, rules) {
    if (typeof schema == "boolean") return !schema;
    for(const key in schema)if (rules[key]) return true;
    return false;
}
module.exports.schemaHasRules = $5457ac2764e63104$var$schemaHasRules;
function $5457ac2764e63104$var$schemaHasRulesButRef(schema, RULES) {
    if (typeof schema == "boolean") return !schema;
    for(const key in schema)if (key !== "$ref" && RULES.all[key]) return true;
    return false;
}
module.exports.schemaHasRulesButRef = $5457ac2764e63104$var$schemaHasRulesButRef;
function $5457ac2764e63104$var$schemaRefOrVal({ topSchemaRef: topSchemaRef, schemaPath: schemaPath }, schema, keyword, $data) {
    if (!$data) {
        if (typeof schema == "number" || typeof schema == "boolean") return schema;
        if (typeof schema == "string") return (0, $l2ufW._)`${schema}`;
    }
    return (0, $l2ufW._)`${topSchemaRef}${schemaPath}${(0, $l2ufW.getProperty)(keyword)}`;
}
module.exports.schemaRefOrVal = $5457ac2764e63104$var$schemaRefOrVal;
function $5457ac2764e63104$var$unescapeFragment(str) {
    return $5457ac2764e63104$var$unescapeJsonPointer(decodeURIComponent(str));
}
module.exports.unescapeFragment = $5457ac2764e63104$var$unescapeFragment;
function $5457ac2764e63104$var$escapeFragment(str) {
    return encodeURIComponent($5457ac2764e63104$var$escapeJsonPointer(str));
}
module.exports.escapeFragment = $5457ac2764e63104$var$escapeFragment;
function $5457ac2764e63104$var$escapeJsonPointer(str) {
    if (typeof str == "number") return `${str}`;
    return str.replace(/~/g, "~0").replace(/\//g, "~1");
}
module.exports.escapeJsonPointer = $5457ac2764e63104$var$escapeJsonPointer;
function $5457ac2764e63104$var$unescapeJsonPointer(str) {
    return str.replace(/~1/g, "/").replace(/~0/g, "~");
}
module.exports.unescapeJsonPointer = $5457ac2764e63104$var$unescapeJsonPointer;
function $5457ac2764e63104$var$eachItem(xs, f) {
    if (Array.isArray(xs)) for (const x of xs)f(x);
    else f(xs);
}
module.exports.eachItem = $5457ac2764e63104$var$eachItem;
function $5457ac2764e63104$var$makeMergeEvaluated({ mergeNames: mergeNames, mergeToName: mergeToName, mergeValues: mergeValues, resultToName: resultToName }) {
    return (gen, from, to, toName)=>{
        const res = to === undefined ? from : to instanceof $l2ufW.Name ? (from instanceof $l2ufW.Name ? mergeNames(gen, from, to) : mergeToName(gen, from, to), to) : from instanceof $l2ufW.Name ? (mergeToName(gen, to, from), from) : mergeValues(from, to);
        return toName === $l2ufW.Name && !(res instanceof $l2ufW.Name) ? resultToName(gen, res) : res;
    };
}
module.exports.mergeEvaluated = {
    props: $5457ac2764e63104$var$makeMergeEvaluated({
        mergeNames: (gen, from, to)=>gen.if((0, $l2ufW._)`${to} !== true && ${from} !== undefined`, ()=>{
                gen.if((0, $l2ufW._)`${from} === true`, ()=>gen.assign(to, true), ()=>gen.assign(to, (0, $l2ufW._)`${to} || {}`).code((0, $l2ufW._)`Object.assign(${to}, ${from})`));
            }),
        mergeToName: (gen, from, to)=>gen.if((0, $l2ufW._)`${to} !== true`, ()=>{
                if (from === true) gen.assign(to, true);
                else {
                    gen.assign(to, (0, $l2ufW._)`${to} || {}`);
                    $5457ac2764e63104$var$setEvaluated(gen, to, from);
                }
            }),
        mergeValues: (from, to)=>from === true ? true : {
                ...from,
                ...to
            },
        resultToName: $5457ac2764e63104$var$evaluatedPropsToName
    }),
    items: $5457ac2764e63104$var$makeMergeEvaluated({
        mergeNames: (gen, from, to)=>gen.if((0, $l2ufW._)`${to} !== true && ${from} !== undefined`, ()=>gen.assign(to, (0, $l2ufW._)`${from} === true ? true : ${to} > ${from} ? ${to} : ${from}`)),
        mergeToName: (gen, from, to)=>gen.if((0, $l2ufW._)`${to} !== true`, ()=>gen.assign(to, from === true ? true : (0, $l2ufW._)`${to} > ${from} ? ${to} : ${from}`)),
        mergeValues: (from, to)=>from === true ? true : Math.max(from, to),
        resultToName: (gen, items)=>gen.var("items", items)
    })
};
function $5457ac2764e63104$var$evaluatedPropsToName(gen, ps) {
    if (ps === true) return gen.var("props", true);
    const props = gen.var("props", (0, $l2ufW._)`{}`);
    if (ps !== undefined) $5457ac2764e63104$var$setEvaluated(gen, props, ps);
    return props;
}
module.exports.evaluatedPropsToName = $5457ac2764e63104$var$evaluatedPropsToName;
function $5457ac2764e63104$var$setEvaluated(gen, props, ps) {
    Object.keys(ps).forEach((p)=>gen.assign((0, $l2ufW._)`${props}${(0, $l2ufW.getProperty)(p)}`, true));
}
module.exports.setEvaluated = $5457ac2764e63104$var$setEvaluated;
const $5457ac2764e63104$var$snippets = {};
function $5457ac2764e63104$var$useFunc(gen, f) {
    return gen.scopeValue("func", {
        ref: f,
        code: $5457ac2764e63104$var$snippets[f.code] || ($5457ac2764e63104$var$snippets[f.code] = new $4GpWJ._Code(f.code))
    });
}
module.exports.useFunc = $5457ac2764e63104$var$useFunc;
var $5457ac2764e63104$var$Type;
(function(Type) {
    Type[Type["Num"] = 0] = "Num";
    Type[Type["Str"] = 1] = "Str";
})($5457ac2764e63104$var$Type || (module.exports.Type = $5457ac2764e63104$var$Type = {}));
function $5457ac2764e63104$var$getErrorPath(dataProp, dataPropType, jsPropertySyntax) {
    // let path
    if (dataProp instanceof $l2ufW.Name) {
        const isNumber = dataPropType === $5457ac2764e63104$var$Type.Num;
        return jsPropertySyntax ? isNumber ? (0, $l2ufW._)`"[" + ${dataProp} + "]"` : (0, $l2ufW._)`"['" + ${dataProp} + "']"` : isNumber ? (0, $l2ufW._)`"/" + ${dataProp}` : (0, $l2ufW._)`"/" + ${dataProp}.replace(/~/g, "~0").replace(/\\//g, "~1")`; // TODO maybe use global escapePointer
    }
    return jsPropertySyntax ? (0, $l2ufW.getProperty)(dataProp).toString() : "/" + $5457ac2764e63104$var$escapeJsonPointer(dataProp);
}
module.exports.getErrorPath = $5457ac2764e63104$var$getErrorPath;
function $5457ac2764e63104$var$checkStrictMode(it, msg, mode = it.opts.strictSchema) {
    if (!mode) return;
    msg = `strict mode: ${msg}`;
    if (mode === true) throw new Error(msg);
    it.self.logger.warn(msg);
}
module.exports.checkStrictMode = $5457ac2764e63104$var$checkStrictMode;

});

parcelRegister("dOpvc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l2ufW = parcelRequire("l2ufW");
const $a0e3ba1039b4828f$var$names = {
    // validation function arguments
    data: new $l2ufW.Name("data"),
    // args passed from referencing schema
    valCxt: new $l2ufW.Name("valCxt"),
    instancePath: new $l2ufW.Name("instancePath"),
    parentData: new $l2ufW.Name("parentData"),
    parentDataProperty: new $l2ufW.Name("parentDataProperty"),
    rootData: new $l2ufW.Name("rootData"),
    dynamicAnchors: new $l2ufW.Name("dynamicAnchors"),
    // function scoped variables
    vErrors: new $l2ufW.Name("vErrors"),
    errors: new $l2ufW.Name("errors"),
    this: new $l2ufW.Name("this"),
    // "globals"
    self: new $l2ufW.Name("self"),
    scope: new $l2ufW.Name("scope"),
    // JTD serialize/parse name for JSON string and position
    json: new $l2ufW.Name("json"),
    jsonPos: new $l2ufW.Name("jsonPos"),
    jsonLen: new $l2ufW.Name("jsonLen"),
    jsonPart: new $l2ufW.Name("jsonPart")
};
module.exports.default = $a0e3ba1039b4828f$var$names;

});



parcelRegister("46MS3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.reportTypeError = module.exports.checkDataTypes = module.exports.checkDataType = module.exports.coerceAndCheckDataType = module.exports.getJSONTypes = module.exports.getSchemaTypes = module.exports.DataType = void 0;

var $1sl6b = parcelRequire("1sl6b");

var $9KPK3 = parcelRequire("9KPK3");

var $hYgW9 = parcelRequire("hYgW9");

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");
var $2fdda1abbf4dbf9f$var$DataType;
(function(DataType) {
    DataType[DataType["Correct"] = 0] = "Correct";
    DataType[DataType["Wrong"] = 1] = "Wrong";
})($2fdda1abbf4dbf9f$var$DataType || (module.exports.DataType = $2fdda1abbf4dbf9f$var$DataType = {}));
function $2fdda1abbf4dbf9f$var$getSchemaTypes(schema) {
    const types = $2fdda1abbf4dbf9f$var$getJSONTypes(schema.type);
    const hasNull = types.includes("null");
    if (hasNull) {
        if (schema.nullable === false) throw new Error("type: null contradicts nullable: false");
    } else {
        if (!types.length && schema.nullable !== undefined) throw new Error('"nullable" cannot be used without "type"');
        if (schema.nullable === true) types.push("null");
    }
    return types;
}
module.exports.getSchemaTypes = $2fdda1abbf4dbf9f$var$getSchemaTypes;
// eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
function $2fdda1abbf4dbf9f$var$getJSONTypes(ts) {
    const types = Array.isArray(ts) ? ts : ts ? [
        ts
    ] : [];
    if (types.every($1sl6b.isJSONType)) return types;
    throw new Error("type must be JSONType or JSONType[]: " + types.join(","));
}
module.exports.getJSONTypes = $2fdda1abbf4dbf9f$var$getJSONTypes;
function $2fdda1abbf4dbf9f$var$coerceAndCheckDataType(it, types) {
    const { gen: gen, data: data, opts: opts } = it;
    const coerceTo = $2fdda1abbf4dbf9f$var$coerceToTypes(types, opts.coerceTypes);
    const checkTypes = types.length > 0 && !(coerceTo.length === 0 && types.length === 1 && (0, $9KPK3.schemaHasRulesForType)(it, types[0]));
    if (checkTypes) {
        const wrongType = $2fdda1abbf4dbf9f$var$checkDataTypes(types, data, opts.strictNumbers, $2fdda1abbf4dbf9f$var$DataType.Wrong);
        gen.if(wrongType, ()=>{
            if (coerceTo.length) $2fdda1abbf4dbf9f$var$coerceData(it, types, coerceTo);
            else $2fdda1abbf4dbf9f$var$reportTypeError(it);
        });
    }
    return checkTypes;
}
module.exports.coerceAndCheckDataType = $2fdda1abbf4dbf9f$var$coerceAndCheckDataType;
const $2fdda1abbf4dbf9f$var$COERCIBLE = new Set([
    "string",
    "number",
    "integer",
    "boolean",
    "null"
]);
function $2fdda1abbf4dbf9f$var$coerceToTypes(types, coerceTypes) {
    return coerceTypes ? types.filter((t)=>$2fdda1abbf4dbf9f$var$COERCIBLE.has(t) || coerceTypes === "array" && t === "array") : [];
}
function $2fdda1abbf4dbf9f$var$coerceData(it, types, coerceTo) {
    const { gen: gen, data: data, opts: opts } = it;
    const dataType = gen.let("dataType", (0, $l2ufW._)`typeof ${data}`);
    const coerced = gen.let("coerced", (0, $l2ufW._)`undefined`);
    if (opts.coerceTypes === "array") gen.if((0, $l2ufW._)`${dataType} == 'object' && Array.isArray(${data}) && ${data}.length == 1`, ()=>gen.assign(data, (0, $l2ufW._)`${data}[0]`).assign(dataType, (0, $l2ufW._)`typeof ${data}`).if($2fdda1abbf4dbf9f$var$checkDataTypes(types, data, opts.strictNumbers), ()=>gen.assign(coerced, data)));
    gen.if((0, $l2ufW._)`${coerced} !== undefined`);
    for (const t of coerceTo)if ($2fdda1abbf4dbf9f$var$COERCIBLE.has(t) || t === "array" && opts.coerceTypes === "array") coerceSpecificType(t);
    gen.else();
    $2fdda1abbf4dbf9f$var$reportTypeError(it);
    gen.endIf();
    gen.if((0, $l2ufW._)`${coerced} !== undefined`, ()=>{
        gen.assign(data, coerced);
        $2fdda1abbf4dbf9f$var$assignParentData(it, coerced);
    });
    function coerceSpecificType(t) {
        switch(t){
            case "string":
                gen.elseIf((0, $l2ufW._)`${dataType} == "number" || ${dataType} == "boolean"`).assign(coerced, (0, $l2ufW._)`"" + ${data}`).elseIf((0, $l2ufW._)`${data} === null`).assign(coerced, (0, $l2ufW._)`""`);
                return;
            case "number":
                gen.elseIf((0, $l2ufW._)`${dataType} == "boolean" || ${data} === null
              || (${dataType} == "string" && ${data} && ${data} == +${data})`).assign(coerced, (0, $l2ufW._)`+${data}`);
                return;
            case "integer":
                gen.elseIf((0, $l2ufW._)`${dataType} === "boolean" || ${data} === null
              || (${dataType} === "string" && ${data} && ${data} == +${data} && !(${data} % 1))`).assign(coerced, (0, $l2ufW._)`+${data}`);
                return;
            case "boolean":
                gen.elseIf((0, $l2ufW._)`${data} === "false" || ${data} === 0 || ${data} === null`).assign(coerced, false).elseIf((0, $l2ufW._)`${data} === "true" || ${data} === 1`).assign(coerced, true);
                return;
            case "null":
                gen.elseIf((0, $l2ufW._)`${data} === "" || ${data} === 0 || ${data} === false`);
                gen.assign(coerced, null);
                return;
            case "array":
                gen.elseIf((0, $l2ufW._)`${dataType} === "string" || ${dataType} === "number"
              || ${dataType} === "boolean" || ${data} === null`).assign(coerced, (0, $l2ufW._)`[${data}]`);
        }
    }
}
function $2fdda1abbf4dbf9f$var$assignParentData({ gen: gen, parentData: parentData, parentDataProperty: parentDataProperty }, expr) {
    // TODO use gen.property
    gen.if((0, $l2ufW._)`${parentData} !== undefined`, ()=>gen.assign((0, $l2ufW._)`${parentData}[${parentDataProperty}]`, expr));
}
function $2fdda1abbf4dbf9f$var$checkDataType(dataType, data, strictNums, correct = $2fdda1abbf4dbf9f$var$DataType.Correct) {
    const EQ = correct === $2fdda1abbf4dbf9f$var$DataType.Correct ? $l2ufW.operators.EQ : $l2ufW.operators.NEQ;
    let cond;
    switch(dataType){
        case "null":
            return (0, $l2ufW._)`${data} ${EQ} null`;
        case "array":
            cond = (0, $l2ufW._)`Array.isArray(${data})`;
            break;
        case "object":
            cond = (0, $l2ufW._)`${data} && typeof ${data} == "object" && !Array.isArray(${data})`;
            break;
        case "integer":
            cond = numCond((0, $l2ufW._)`!(${data} % 1) && !isNaN(${data})`);
            break;
        case "number":
            cond = numCond();
            break;
        default:
            return (0, $l2ufW._)`typeof ${data} ${EQ} ${dataType}`;
    }
    return correct === $2fdda1abbf4dbf9f$var$DataType.Correct ? cond : (0, $l2ufW.not)(cond);
    function numCond(_cond = $l2ufW.nil) {
        return (0, $l2ufW.and)((0, $l2ufW._)`typeof ${data} == "number"`, _cond, strictNums ? (0, $l2ufW._)`isFinite(${data})` : $l2ufW.nil);
    }
}
module.exports.checkDataType = $2fdda1abbf4dbf9f$var$checkDataType;
function $2fdda1abbf4dbf9f$var$checkDataTypes(dataTypes, data, strictNums, correct) {
    if (dataTypes.length === 1) return $2fdda1abbf4dbf9f$var$checkDataType(dataTypes[0], data, strictNums, correct);
    let cond;
    const types = (0, $7eX5i.toHash)(dataTypes);
    if (types.array && types.object) {
        const notObj = (0, $l2ufW._)`typeof ${data} != "object"`;
        cond = types.null ? notObj : (0, $l2ufW._)`!${data} || ${notObj}`;
        delete types.null;
        delete types.array;
        delete types.object;
    } else cond = $l2ufW.nil;
    if (types.number) delete types.integer;
    for(const t in types)cond = (0, $l2ufW.and)(cond, $2fdda1abbf4dbf9f$var$checkDataType(t, data, strictNums, correct));
    return cond;
}
module.exports.checkDataTypes = $2fdda1abbf4dbf9f$var$checkDataTypes;
const $2fdda1abbf4dbf9f$var$typeError = {
    message: ({ schema: schema })=>`must be ${schema}`,
    params: ({ schema: schema, schemaValue: schemaValue })=>typeof schema == "string" ? (0, $l2ufW._)`{type: ${schema}}` : (0, $l2ufW._)`{type: ${schemaValue}}`
};
function $2fdda1abbf4dbf9f$var$reportTypeError(it) {
    const cxt = $2fdda1abbf4dbf9f$var$getTypeErrorContext(it);
    (0, $hYgW9.reportError)(cxt, $2fdda1abbf4dbf9f$var$typeError);
}
module.exports.reportTypeError = $2fdda1abbf4dbf9f$var$reportTypeError;
function $2fdda1abbf4dbf9f$var$getTypeErrorContext(it) {
    const { gen: gen, data: data, schema: schema } = it;
    const schemaCode = (0, $7eX5i.schemaRefOrVal)(it, schema, "type");
    return {
        gen: gen,
        keyword: "type",
        data: data,
        schema: schema.type,
        schemaCode: schemaCode,
        schemaValue: schemaCode,
        parentSchema: schema,
        params: {},
        it: it
    };
}

});
parcelRegister("1sl6b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getRules = module.exports.isJSONType = void 0;
const $10f8c5b811d8a69e$var$_jsonTypes = [
    "string",
    "number",
    "integer",
    "boolean",
    "null",
    "object",
    "array"
];
const $10f8c5b811d8a69e$var$jsonTypes = new Set($10f8c5b811d8a69e$var$_jsonTypes);
function $10f8c5b811d8a69e$var$isJSONType(x) {
    return typeof x == "string" && $10f8c5b811d8a69e$var$jsonTypes.has(x);
}
module.exports.isJSONType = $10f8c5b811d8a69e$var$isJSONType;
function $10f8c5b811d8a69e$var$getRules() {
    const groups = {
        number: {
            type: "number",
            rules: []
        },
        string: {
            type: "string",
            rules: []
        },
        array: {
            type: "array",
            rules: []
        },
        object: {
            type: "object",
            rules: []
        }
    };
    return {
        types: {
            ...groups,
            integer: true,
            boolean: true,
            null: true
        },
        rules: [
            {
                rules: []
            },
            groups.number,
            groups.string,
            groups.array,
            groups.object
        ],
        post: {
            rules: []
        },
        all: {},
        keywords: {}
    };
}
module.exports.getRules = $10f8c5b811d8a69e$var$getRules;

});

parcelRegister("9KPK3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.shouldUseRule = module.exports.shouldUseGroup = module.exports.schemaHasRulesForType = void 0;
function $71a08bc6f5a5bab9$var$schemaHasRulesForType({ schema: schema, self: self }, type) {
    const group = self.RULES.types[type];
    return group && group !== true && $71a08bc6f5a5bab9$var$shouldUseGroup(schema, group);
}
module.exports.schemaHasRulesForType = $71a08bc6f5a5bab9$var$schemaHasRulesForType;
function $71a08bc6f5a5bab9$var$shouldUseGroup(schema, group) {
    return group.rules.some((rule)=>$71a08bc6f5a5bab9$var$shouldUseRule(schema, rule));
}
module.exports.shouldUseGroup = $71a08bc6f5a5bab9$var$shouldUseGroup;
function $71a08bc6f5a5bab9$var$shouldUseRule(schema, rule) {
    var _a;
    return schema[rule.keyword] !== undefined || ((_a = rule.definition.implements) === null || _a === void 0 ? void 0 : _a.some((kwd)=>schema[kwd] !== undefined));
}
module.exports.shouldUseRule = $71a08bc6f5a5bab9$var$shouldUseRule;

});


parcelRegister("9OJAU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.assignDefaults = void 0;

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");
function $725c26a0727ed10f$var$assignDefaults(it, ty) {
    const { properties: properties, items: items } = it.schema;
    if (ty === "object" && properties) for(const key in properties)$725c26a0727ed10f$var$assignDefault(it, key, properties[key].default);
    else if (ty === "array" && Array.isArray(items)) items.forEach((sch, i)=>$725c26a0727ed10f$var$assignDefault(it, i, sch.default));
}
module.exports.assignDefaults = $725c26a0727ed10f$var$assignDefaults;
function $725c26a0727ed10f$var$assignDefault(it, prop, defaultValue) {
    const { gen: gen, compositeRule: compositeRule, data: data, opts: opts } = it;
    if (defaultValue === undefined) return;
    const childData = (0, $l2ufW._)`${data}${(0, $l2ufW.getProperty)(prop)}`;
    if (compositeRule) {
        (0, $7eX5i.checkStrictMode)(it, `default is ignored for: ${childData}`);
        return;
    }
    let condition = (0, $l2ufW._)`${childData} === undefined`;
    if (opts.useDefaults === "empty") condition = (0, $l2ufW._)`${condition} || ${childData} === null || ${childData} === ""`;
    // `${childData} === undefined` +
    // (opts.useDefaults === "empty" ? ` || ${childData} === null || ${childData} === ""` : "")
    gen.if(condition, (0, $l2ufW._)`${childData} = ${(0, $l2ufW.stringify)(defaultValue)}`);
}

});

parcelRegister("dTewx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateKeywordUsage = module.exports.validSchemaType = module.exports.funcKeywordCode = module.exports.macroKeywordCode = void 0;

var $l2ufW = parcelRequire("l2ufW");

var $dOpvc = parcelRequire("dOpvc");

var $7unnO = parcelRequire("7unnO");

var $hYgW9 = parcelRequire("hYgW9");
function $a1cbad90d3b10795$var$macroKeywordCode(cxt, def) {
    const { gen: gen, keyword: keyword, schema: schema, parentSchema: parentSchema, it: it } = cxt;
    const macroSchema = def.macro.call(it.self, schema, parentSchema, it);
    const schemaRef = $a1cbad90d3b10795$var$useKeyword(gen, keyword, macroSchema);
    if (it.opts.validateSchema !== false) it.self.validateSchema(macroSchema, true);
    const valid = gen.name("valid");
    cxt.subschema({
        schema: macroSchema,
        schemaPath: $l2ufW.nil,
        errSchemaPath: `${it.errSchemaPath}/${keyword}`,
        topSchemaRef: schemaRef,
        compositeRule: true
    }, valid);
    cxt.pass(valid, ()=>cxt.error(true));
}
module.exports.macroKeywordCode = $a1cbad90d3b10795$var$macroKeywordCode;
function $a1cbad90d3b10795$var$funcKeywordCode(cxt, def) {
    var _a;
    const { gen: gen, keyword: keyword, schema: schema, parentSchema: parentSchema, $data: $data, it: it } = cxt;
    $a1cbad90d3b10795$var$checkAsyncKeyword(it, def);
    const validate = !$data && def.compile ? def.compile.call(it.self, schema, parentSchema, it) : def.validate;
    const validateRef = $a1cbad90d3b10795$var$useKeyword(gen, keyword, validate);
    const valid = gen.let("valid");
    cxt.block$data(valid, validateKeyword);
    cxt.ok((_a = def.valid) !== null && _a !== void 0 ? _a : valid);
    function validateKeyword() {
        if (def.errors === false) {
            assignValid();
            if (def.modifying) $a1cbad90d3b10795$var$modifyData(cxt);
            reportErrs(()=>cxt.error());
        } else {
            const ruleErrs = def.async ? validateAsync() : validateSync();
            if (def.modifying) $a1cbad90d3b10795$var$modifyData(cxt);
            reportErrs(()=>$a1cbad90d3b10795$var$addErrs(cxt, ruleErrs));
        }
    }
    function validateAsync() {
        const ruleErrs = gen.let("ruleErrs", null);
        gen.try(()=>assignValid((0, $l2ufW._)`await `), (e)=>gen.assign(valid, false).if((0, $l2ufW._)`${e} instanceof ${it.ValidationError}`, ()=>gen.assign(ruleErrs, (0, $l2ufW._)`${e}.errors`), ()=>gen.throw(e)));
        return ruleErrs;
    }
    function validateSync() {
        const validateErrs = (0, $l2ufW._)`${validateRef}.errors`;
        gen.assign(validateErrs, null);
        assignValid($l2ufW.nil);
        return validateErrs;
    }
    function assignValid(_await = def.async ? (0, $l2ufW._)`await ` : $l2ufW.nil) {
        const passCxt = it.opts.passContext ? $dOpvc.default.this : $dOpvc.default.self;
        const passSchema = !("compile" in def && !$data || def.schema === false);
        gen.assign(valid, (0, $l2ufW._)`${_await}${(0, $7unnO.callValidateCode)(cxt, validateRef, passCxt, passSchema)}`, def.modifying);
    }
    function reportErrs(errors) {
        var _a;
        gen.if((0, $l2ufW.not)((_a = def.valid) !== null && _a !== void 0 ? _a : valid), errors);
    }
}
module.exports.funcKeywordCode = $a1cbad90d3b10795$var$funcKeywordCode;
function $a1cbad90d3b10795$var$modifyData(cxt) {
    const { gen: gen, data: data, it: it } = cxt;
    gen.if(it.parentData, ()=>gen.assign(data, (0, $l2ufW._)`${it.parentData}[${it.parentDataProperty}]`));
}
function $a1cbad90d3b10795$var$addErrs(cxt, errs) {
    const { gen: gen } = cxt;
    gen.if((0, $l2ufW._)`Array.isArray(${errs})`, ()=>{
        gen.assign($dOpvc.default.vErrors, (0, $l2ufW._)`${$dOpvc.default.vErrors} === null ? ${errs} : ${$dOpvc.default.vErrors}.concat(${errs})`).assign($dOpvc.default.errors, (0, $l2ufW._)`${$dOpvc.default.vErrors}.length`);
        (0, $hYgW9.extendErrors)(cxt);
    }, ()=>cxt.error());
}
function $a1cbad90d3b10795$var$checkAsyncKeyword({ schemaEnv: schemaEnv }, def) {
    if (def.async && !schemaEnv.$async) throw new Error("async keyword in sync schema");
}
function $a1cbad90d3b10795$var$useKeyword(gen, keyword, result) {
    if (result === undefined) throw new Error(`keyword "${keyword}" failed to compile`);
    return gen.scopeValue("keyword", typeof result == "function" ? {
        ref: result
    } : {
        ref: result,
        code: (0, $l2ufW.stringify)(result)
    });
}
function $a1cbad90d3b10795$var$validSchemaType(schema, schemaType, allowUndefined = false) {
    // TODO add tests
    return !schemaType.length || schemaType.some((st)=>st === "array" ? Array.isArray(schema) : st === "object" ? schema && typeof schema == "object" && !Array.isArray(schema) : typeof schema == st || allowUndefined && typeof schema == "undefined");
}
module.exports.validSchemaType = $a1cbad90d3b10795$var$validSchemaType;
function $a1cbad90d3b10795$var$validateKeywordUsage({ schema: schema, opts: opts, self: self, errSchemaPath: errSchemaPath }, def, keyword) {
    /* istanbul ignore if */ if (Array.isArray(def.keyword) ? !def.keyword.includes(keyword) : def.keyword !== keyword) throw new Error("ajv implementation error");
    const deps = def.dependencies;
    if (deps === null || deps === void 0 ? void 0 : deps.some((kwd)=>!Object.prototype.hasOwnProperty.call(schema, kwd))) throw new Error(`parent schema must have dependencies of ${keyword}: ${deps.join(",")}`);
    if (def.validateSchema) {
        const valid = def.validateSchema(schema[keyword]);
        if (!valid) {
            const msg = `keyword "${keyword}" value is invalid at path "${errSchemaPath}": ` + self.errorsText(def.validateSchema.errors);
            if (opts.validateSchema === "log") self.logger.error(msg);
            else throw new Error(msg);
        }
    }
}
module.exports.validateKeywordUsage = $a1cbad90d3b10795$var$validateKeywordUsage;

});
parcelRegister("7unnO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateUnion = module.exports.validateArray = module.exports.usePattern = module.exports.callValidateCode = module.exports.schemaProperties = module.exports.allSchemaProperties = module.exports.noPropertyInData = module.exports.propertyInData = module.exports.isOwnProperty = module.exports.hasPropFunc = module.exports.reportMissingProp = module.exports.checkMissingProp = module.exports.checkReportMissingProp = void 0;

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");

var $dOpvc = parcelRequire("dOpvc");

var $7eX5i = parcelRequire("7eX5i");
function $573d792233d8638b$var$checkReportMissingProp(cxt, prop) {
    const { gen: gen, data: data, it: it } = cxt;
    gen.if($573d792233d8638b$var$noPropertyInData(gen, data, prop, it.opts.ownProperties), ()=>{
        cxt.setParams({
            missingProperty: (0, $l2ufW._)`${prop}`
        }, true);
        cxt.error();
    });
}
module.exports.checkReportMissingProp = $573d792233d8638b$var$checkReportMissingProp;
function $573d792233d8638b$var$checkMissingProp({ gen: gen, data: data, it: { opts: opts } }, properties, missing) {
    return (0, $l2ufW.or)(...properties.map((prop)=>(0, $l2ufW.and)($573d792233d8638b$var$noPropertyInData(gen, data, prop, opts.ownProperties), (0, $l2ufW._)`${missing} = ${prop}`)));
}
module.exports.checkMissingProp = $573d792233d8638b$var$checkMissingProp;
function $573d792233d8638b$var$reportMissingProp(cxt, missing) {
    cxt.setParams({
        missingProperty: missing
    }, true);
    cxt.error();
}
module.exports.reportMissingProp = $573d792233d8638b$var$reportMissingProp;
function $573d792233d8638b$var$hasPropFunc(gen) {
    return gen.scopeValue("func", {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        ref: Object.prototype.hasOwnProperty,
        code: (0, $l2ufW._)`Object.prototype.hasOwnProperty`
    });
}
module.exports.hasPropFunc = $573d792233d8638b$var$hasPropFunc;
function $573d792233d8638b$var$isOwnProperty(gen, data, property) {
    return (0, $l2ufW._)`${$573d792233d8638b$var$hasPropFunc(gen)}.call(${data}, ${property})`;
}
module.exports.isOwnProperty = $573d792233d8638b$var$isOwnProperty;
function $573d792233d8638b$var$propertyInData(gen, data, property, ownProperties) {
    const cond = (0, $l2ufW._)`${data}${(0, $l2ufW.getProperty)(property)} !== undefined`;
    return ownProperties ? (0, $l2ufW._)`${cond} && ${$573d792233d8638b$var$isOwnProperty(gen, data, property)}` : cond;
}
module.exports.propertyInData = $573d792233d8638b$var$propertyInData;
function $573d792233d8638b$var$noPropertyInData(gen, data, property, ownProperties) {
    const cond = (0, $l2ufW._)`${data}${(0, $l2ufW.getProperty)(property)} === undefined`;
    return ownProperties ? (0, $l2ufW.or)(cond, (0, $l2ufW.not)($573d792233d8638b$var$isOwnProperty(gen, data, property))) : cond;
}
module.exports.noPropertyInData = $573d792233d8638b$var$noPropertyInData;
function $573d792233d8638b$var$allSchemaProperties(schemaMap) {
    return schemaMap ? Object.keys(schemaMap).filter((p)=>p !== "__proto__") : [];
}
module.exports.allSchemaProperties = $573d792233d8638b$var$allSchemaProperties;
function $573d792233d8638b$var$schemaProperties(it, schemaMap) {
    return $573d792233d8638b$var$allSchemaProperties(schemaMap).filter((p)=>!(0, $7eX5i.alwaysValidSchema)(it, schemaMap[p]));
}
module.exports.schemaProperties = $573d792233d8638b$var$schemaProperties;
function $573d792233d8638b$var$callValidateCode({ schemaCode: schemaCode, data: data, it: { gen: gen, topSchemaRef: topSchemaRef, schemaPath: schemaPath, errorPath: errorPath }, it: it }, func, context, passSchema) {
    const dataAndSchema = passSchema ? (0, $l2ufW._)`${schemaCode}, ${data}, ${topSchemaRef}${schemaPath}` : data;
    const valCxt = [
        [
            $dOpvc.default.instancePath,
            (0, $l2ufW.strConcat)($dOpvc.default.instancePath, errorPath)
        ],
        [
            $dOpvc.default.parentData,
            it.parentData
        ],
        [
            $dOpvc.default.parentDataProperty,
            it.parentDataProperty
        ],
        [
            $dOpvc.default.rootData,
            $dOpvc.default.rootData
        ]
    ];
    if (it.opts.dynamicRef) valCxt.push([
        $dOpvc.default.dynamicAnchors,
        $dOpvc.default.dynamicAnchors
    ]);
    const args = (0, $l2ufW._)`${dataAndSchema}, ${gen.object(...valCxt)}`;
    return context !== $l2ufW.nil ? (0, $l2ufW._)`${func}.call(${context}, ${args})` : (0, $l2ufW._)`${func}(${args})`;
}
module.exports.callValidateCode = $573d792233d8638b$var$callValidateCode;
const $573d792233d8638b$var$newRegExp = (0, $l2ufW._)`new RegExp`;
function $573d792233d8638b$var$usePattern({ gen: gen, it: { opts: opts } }, pattern) {
    const u = opts.unicodeRegExp ? "u" : "";
    const { regExp: regExp } = opts.code;
    const rx = regExp(pattern, u);
    return gen.scopeValue("pattern", {
        key: rx.toString(),
        ref: rx,
        code: (0, $l2ufW._)`${regExp.code === "new RegExp" ? $573d792233d8638b$var$newRegExp : (0, $7eX5i.useFunc)(gen, regExp)}(${pattern}, ${u})`
    });
}
module.exports.usePattern = $573d792233d8638b$var$usePattern;
function $573d792233d8638b$var$validateArray(cxt) {
    const { gen: gen, data: data, keyword: keyword, it: it } = cxt;
    const valid = gen.name("valid");
    if (it.allErrors) {
        const validArr = gen.let("valid", true);
        validateItems(()=>gen.assign(validArr, false));
        return validArr;
    }
    gen.var(valid, true);
    validateItems(()=>gen.break());
    return valid;
    function validateItems(notValid) {
        const len = gen.const("len", (0, $l2ufW._)`${data}.length`);
        gen.forRange("i", 0, len, (i)=>{
            cxt.subschema({
                keyword: keyword,
                dataProp: i,
                dataPropType: $7eX5i.Type.Num
            }, valid);
            gen.if((0, $l2ufW.not)(valid), notValid);
        });
    }
}
module.exports.validateArray = $573d792233d8638b$var$validateArray;
function $573d792233d8638b$var$validateUnion(cxt) {
    const { gen: gen, schema: schema, keyword: keyword, it: it } = cxt;
    /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
    const alwaysValid = schema.some((sch)=>(0, $7eX5i.alwaysValidSchema)(it, sch));
    if (alwaysValid && !it.opts.unevaluated) return;
    const valid = gen.let("valid", false);
    const schValid = gen.name("_valid");
    gen.block(()=>schema.forEach((_sch, i)=>{
            const schCxt = cxt.subschema({
                keyword: keyword,
                schemaProp: i,
                compositeRule: true
            }, schValid);
            gen.assign(valid, (0, $l2ufW._)`${valid} || ${schValid}`);
            const merged = cxt.mergeValidEvaluated(schCxt, schValid);
            // can short-circuit if `unevaluatedProperties/Items` not supported (opts.unevaluated !== true)
            // or if all properties and items were evaluated (it.props === true && it.items === true)
            if (!merged) gen.if((0, $l2ufW.not)(valid));
        }));
    cxt.result(valid, ()=>cxt.reset(), ()=>cxt.error(true));
}
module.exports.validateUnion = $573d792233d8638b$var$validateUnion;

});


parcelRegister("5eunN", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.extendSubschemaMode = module.exports.extendSubschemaData = module.exports.getSubschema = void 0;

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");
function $3cf5d3ecc8063845$var$getSubschema(it, { keyword: keyword, schemaProp: schemaProp, schema: schema, schemaPath: schemaPath, errSchemaPath: errSchemaPath, topSchemaRef: topSchemaRef }) {
    if (keyword !== undefined && schema !== undefined) throw new Error('both "keyword" and "schema" passed, only one allowed');
    if (keyword !== undefined) {
        const sch = it.schema[keyword];
        return schemaProp === undefined ? {
            schema: sch,
            schemaPath: (0, $l2ufW._)`${it.schemaPath}${(0, $l2ufW.getProperty)(keyword)}`,
            errSchemaPath: `${it.errSchemaPath}/${keyword}`
        } : {
            schema: sch[schemaProp],
            schemaPath: (0, $l2ufW._)`${it.schemaPath}${(0, $l2ufW.getProperty)(keyword)}${(0, $l2ufW.getProperty)(schemaProp)}`,
            errSchemaPath: `${it.errSchemaPath}/${keyword}/${(0, $7eX5i.escapeFragment)(schemaProp)}`
        };
    }
    if (schema !== undefined) {
        if (schemaPath === undefined || errSchemaPath === undefined || topSchemaRef === undefined) throw new Error('"schemaPath", "errSchemaPath" and "topSchemaRef" are required with "schema"');
        return {
            schema: schema,
            schemaPath: schemaPath,
            topSchemaRef: topSchemaRef,
            errSchemaPath: errSchemaPath
        };
    }
    throw new Error('either "keyword" or "schema" must be passed');
}
module.exports.getSubschema = $3cf5d3ecc8063845$var$getSubschema;
function $3cf5d3ecc8063845$var$extendSubschemaData(subschema, it, { dataProp: dataProp, dataPropType: dpType, data: data, dataTypes: dataTypes, propertyName: propertyName }) {
    if (data !== undefined && dataProp !== undefined) throw new Error('both "data" and "dataProp" passed, only one allowed');
    const { gen: gen } = it;
    if (dataProp !== undefined) {
        const { errorPath: errorPath, dataPathArr: dataPathArr, opts: opts } = it;
        const nextData = gen.let("data", (0, $l2ufW._)`${it.data}${(0, $l2ufW.getProperty)(dataProp)}`, true);
        dataContextProps(nextData);
        subschema.errorPath = (0, $l2ufW.str)`${errorPath}${(0, $7eX5i.getErrorPath)(dataProp, dpType, opts.jsPropertySyntax)}`;
        subschema.parentDataProperty = (0, $l2ufW._)`${dataProp}`;
        subschema.dataPathArr = [
            ...dataPathArr,
            subschema.parentDataProperty
        ];
    }
    if (data !== undefined) {
        const nextData = data instanceof $l2ufW.Name ? data : gen.let("data", data, true); // replaceable if used once?
        dataContextProps(nextData);
        if (propertyName !== undefined) subschema.propertyName = propertyName;
    // TODO something is possibly wrong here with not changing parentDataProperty and not appending dataPathArr
    }
    if (dataTypes) subschema.dataTypes = dataTypes;
    function dataContextProps(_nextData) {
        subschema.data = _nextData;
        subschema.dataLevel = it.dataLevel + 1;
        subschema.dataTypes = [];
        it.definedProperties = new Set();
        subschema.parentData = it.data;
        subschema.dataNames = [
            ...it.dataNames,
            _nextData
        ];
    }
}
module.exports.extendSubschemaData = $3cf5d3ecc8063845$var$extendSubschemaData;
function $3cf5d3ecc8063845$var$extendSubschemaMode(subschema, { jtdDiscriminator: jtdDiscriminator, jtdMetadata: jtdMetadata, compositeRule: compositeRule, createErrors: createErrors, allErrors: allErrors }) {
    if (compositeRule !== undefined) subschema.compositeRule = compositeRule;
    if (createErrors !== undefined) subschema.createErrors = createErrors;
    if (allErrors !== undefined) subschema.allErrors = allErrors;
    subschema.jtdDiscriminator = jtdDiscriminator; // not inherited
    subschema.jtdMetadata = jtdMetadata; // not inherited
}
module.exports.extendSubschemaMode = $3cf5d3ecc8063845$var$extendSubschemaMode;

});

parcelRegister("9ZpNV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getSchemaRefs = module.exports.resolveUrl = module.exports.normalizeId = module.exports._getFullPath = module.exports.getFullPath = module.exports.inlineRef = void 0;

var $7eX5i = parcelRequire("7eX5i");

var $7hFx0 = parcelRequire("7hFx0");

var $7dBhG = parcelRequire("7dBhG");
// TODO refactor to use keyword definitions
const $745dd3bb66238608$var$SIMPLE_INLINED = new Set([
    "type",
    "format",
    "pattern",
    "maxLength",
    "minLength",
    "maxProperties",
    "minProperties",
    "maxItems",
    "minItems",
    "maximum",
    "minimum",
    "uniqueItems",
    "multipleOf",
    "required",
    "enum",
    "const"
]);
function $745dd3bb66238608$var$inlineRef(schema, limit = true) {
    if (typeof schema == "boolean") return true;
    if (limit === true) return !$745dd3bb66238608$var$hasRef(schema);
    if (!limit) return false;
    return $745dd3bb66238608$var$countKeys(schema) <= limit;
}
module.exports.inlineRef = $745dd3bb66238608$var$inlineRef;
const $745dd3bb66238608$var$REF_KEYWORDS = new Set([
    "$ref",
    "$recursiveRef",
    "$recursiveAnchor",
    "$dynamicRef",
    "$dynamicAnchor"
]);
function $745dd3bb66238608$var$hasRef(schema) {
    for(const key in schema){
        if ($745dd3bb66238608$var$REF_KEYWORDS.has(key)) return true;
        const sch = schema[key];
        if (Array.isArray(sch) && sch.some($745dd3bb66238608$var$hasRef)) return true;
        if (typeof sch == "object" && $745dd3bb66238608$var$hasRef(sch)) return true;
    }
    return false;
}
function $745dd3bb66238608$var$countKeys(schema) {
    let count = 0;
    for(const key in schema){
        if (key === "$ref") return Infinity;
        count++;
        if ($745dd3bb66238608$var$SIMPLE_INLINED.has(key)) continue;
        if (typeof schema[key] == "object") (0, $7eX5i.eachItem)(schema[key], (sch)=>count += $745dd3bb66238608$var$countKeys(sch));
        if (count === Infinity) return Infinity;
    }
    return count;
}
function $745dd3bb66238608$var$getFullPath(resolver, id = "", normalize) {
    if (normalize !== false) id = $745dd3bb66238608$var$normalizeId(id);
    const p = resolver.parse(id);
    return $745dd3bb66238608$var$_getFullPath(resolver, p);
}
module.exports.getFullPath = $745dd3bb66238608$var$getFullPath;
function $745dd3bb66238608$var$_getFullPath(resolver, p) {
    const serialized = resolver.serialize(p);
    return serialized.split("#")[0] + "#";
}
module.exports._getFullPath = $745dd3bb66238608$var$_getFullPath;
const $745dd3bb66238608$var$TRAILING_SLASH_HASH = /#\/?$/;
function $745dd3bb66238608$var$normalizeId(id) {
    return id ? id.replace($745dd3bb66238608$var$TRAILING_SLASH_HASH, "") : "";
}
module.exports.normalizeId = $745dd3bb66238608$var$normalizeId;
function $745dd3bb66238608$var$resolveUrl(resolver, baseId, id) {
    id = $745dd3bb66238608$var$normalizeId(id);
    return resolver.resolve(baseId, id);
}
module.exports.resolveUrl = $745dd3bb66238608$var$resolveUrl;
const $745dd3bb66238608$var$ANCHOR = /^[a-z_][-a-z0-9._]*$/i;
function $745dd3bb66238608$var$getSchemaRefs(schema, baseId) {
    if (typeof schema == "boolean") return {};
    const { schemaId: schemaId, uriResolver: uriResolver } = this.opts;
    const schId = $745dd3bb66238608$var$normalizeId(schema[schemaId] || baseId);
    const baseIds = {
        "": schId
    };
    const pathPrefix = $745dd3bb66238608$var$getFullPath(uriResolver, schId, false);
    const localRefs = {};
    const schemaRefs = new Set();
    $7dBhG(schema, {
        allKeys: true
    }, (sch, jsonPtr, _, parentJsonPtr)=>{
        if (parentJsonPtr === undefined) return;
        const fullPath = pathPrefix + jsonPtr;
        let innerBaseId = baseIds[parentJsonPtr];
        if (typeof sch[schemaId] == "string") innerBaseId = addRef.call(this, sch[schemaId]);
        addAnchor.call(this, sch.$anchor);
        addAnchor.call(this, sch.$dynamicAnchor);
        baseIds[jsonPtr] = innerBaseId;
        function addRef(ref) {
            // eslint-disable-next-line @typescript-eslint/unbound-method
            const _resolve = this.opts.uriResolver.resolve;
            ref = $745dd3bb66238608$var$normalizeId(innerBaseId ? _resolve(innerBaseId, ref) : ref);
            if (schemaRefs.has(ref)) throw ambiguos(ref);
            schemaRefs.add(ref);
            let schOrRef = this.refs[ref];
            if (typeof schOrRef == "string") schOrRef = this.refs[schOrRef];
            if (typeof schOrRef == "object") checkAmbiguosRef(sch, schOrRef.schema, ref);
            else if (ref !== $745dd3bb66238608$var$normalizeId(fullPath)) {
                if (ref[0] === "#") {
                    checkAmbiguosRef(sch, localRefs[ref], ref);
                    localRefs[ref] = sch;
                } else this.refs[ref] = fullPath;
            }
            return ref;
        }
        function addAnchor(anchor) {
            if (typeof anchor == "string") {
                if (!$745dd3bb66238608$var$ANCHOR.test(anchor)) throw new Error(`invalid anchor "${anchor}"`);
                addRef.call(this, `#${anchor}`);
            }
        }
    });
    return localRefs;
    function checkAmbiguosRef(sch1, sch2, ref) {
        if (sch2 !== undefined && !$7hFx0(sch1, sch2)) throw ambiguos(ref);
    }
    function ambiguos(ref) {
        return new Error(`reference "${ref}" resolves to more than one schema`);
    }
}
module.exports.getSchemaRefs = $745dd3bb66238608$var$getSchemaRefs;

});
parcelRegister("7hFx0", function(module, exports) {
'use strict';
// do not edit .js files directly - edit src/index.jst
module.exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && typeof a == 'object' && typeof b == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};

});

parcelRegister("7dBhG", function(module, exports) {
'use strict';
var $5416ab2f1394f8d9$var$traverse = module.exports = function(schema, opts, cb) {
    // Legacy support for v0.3.1 and earlier.
    if (typeof opts == 'function') {
        cb = opts;
        opts = {};
    }
    cb = opts.cb || cb;
    var pre = typeof cb == 'function' ? cb : cb.pre || function() {};
    var post = cb.post || function() {};
    $5416ab2f1394f8d9$var$_traverse(opts, pre, post, schema, '', schema);
};
$5416ab2f1394f8d9$var$traverse.keywords = {
    additionalItems: true,
    items: true,
    contains: true,
    additionalProperties: true,
    propertyNames: true,
    not: true,
    if: true,
    then: true,
    else: true
};
$5416ab2f1394f8d9$var$traverse.arrayKeywords = {
    items: true,
    allOf: true,
    anyOf: true,
    oneOf: true
};
$5416ab2f1394f8d9$var$traverse.propsKeywords = {
    $defs: true,
    definitions: true,
    properties: true,
    patternProperties: true,
    dependencies: true
};
$5416ab2f1394f8d9$var$traverse.skipKeywords = {
    default: true,
    enum: true,
    const: true,
    required: true,
    maximum: true,
    minimum: true,
    exclusiveMaximum: true,
    exclusiveMinimum: true,
    multipleOf: true,
    maxLength: true,
    minLength: true,
    pattern: true,
    format: true,
    maxItems: true,
    minItems: true,
    uniqueItems: true,
    maxProperties: true,
    minProperties: true
};
function $5416ab2f1394f8d9$var$_traverse(opts, pre, post, schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex) {
    if (schema && typeof schema == 'object' && !Array.isArray(schema)) {
        pre(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
        for(var key in schema){
            var sch = schema[key];
            if (Array.isArray(sch)) {
                if (key in $5416ab2f1394f8d9$var$traverse.arrayKeywords) for(var i = 0; i < sch.length; i++)$5416ab2f1394f8d9$var$_traverse(opts, pre, post, sch[i], jsonPtr + '/' + key + '/' + i, rootSchema, jsonPtr, key, schema, i);
            } else if (key in $5416ab2f1394f8d9$var$traverse.propsKeywords) {
                if (sch && typeof sch == 'object') for(var prop in sch)$5416ab2f1394f8d9$var$_traverse(opts, pre, post, sch[prop], jsonPtr + '/' + key + '/' + $5416ab2f1394f8d9$var$escapeJsonPtr(prop), rootSchema, jsonPtr, key, schema, prop);
            } else if (key in $5416ab2f1394f8d9$var$traverse.keywords || opts.allKeys && !(key in $5416ab2f1394f8d9$var$traverse.skipKeywords)) $5416ab2f1394f8d9$var$_traverse(opts, pre, post, sch, jsonPtr + '/' + key, rootSchema, jsonPtr, key, schema);
        }
        post(schema, jsonPtr, rootSchema, parentJsonPtr, parentKeyword, parentSchema, keyIndex);
    }
}
function $5416ab2f1394f8d9$var$escapeJsonPtr(str) {
    return str.replace(/~/g, '~0').replace(/\//g, '~1');
}

});



parcelRegister("2gvZO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
class $1a65e520856caceb$var$ValidationError extends Error {
    constructor(errors){
        super("validation failed");
        this.errors = errors;
        this.ajv = this.validation = true;
    }
}
module.exports.default = $1a65e520856caceb$var$ValidationError;

});

parcelRegister("euTEo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9ZpNV = parcelRequire("9ZpNV");
class $a8df090d24729250$var$MissingRefError extends Error {
    constructor(resolver, baseId, ref, msg){
        super(msg || `can't resolve reference ${ref} from id ${baseId}`);
        this.missingRef = (0, $9ZpNV.resolveUrl)(resolver, baseId, ref);
        this.missingSchema = (0, $9ZpNV.normalizeId)((0, $9ZpNV.getFullPath)(resolver, this.missingRef));
    }
}
module.exports.default = $a8df090d24729250$var$MissingRefError;

});

parcelRegister("jstQR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.resolveSchema = module.exports.getCompilingSchema = module.exports.resolveRef = module.exports.compileSchema = module.exports.SchemaEnv = void 0;

var $l2ufW = parcelRequire("l2ufW");

var $2gvZO = parcelRequire("2gvZO");

var $dOpvc = parcelRequire("dOpvc");

var $9ZpNV = parcelRequire("9ZpNV");

var $7eX5i = parcelRequire("7eX5i");

var $9hgV1 = parcelRequire("9hgV1");
class $e2a7c9c4276e8f03$var$SchemaEnv {
    constructor(env){
        var _a;
        this.refs = {};
        this.dynamicAnchors = {};
        let schema;
        if (typeof env.schema == "object") schema = env.schema;
        this.schema = env.schema;
        this.schemaId = env.schemaId;
        this.root = env.root || this;
        this.baseId = (_a = env.baseId) !== null && _a !== void 0 ? _a : (0, $9ZpNV.normalizeId)(schema === null || schema === void 0 ? void 0 : schema[env.schemaId || "$id"]);
        this.schemaPath = env.schemaPath;
        this.localRefs = env.localRefs;
        this.meta = env.meta;
        this.$async = schema === null || schema === void 0 ? void 0 : schema.$async;
        this.refs = {};
    }
}
module.exports.SchemaEnv = $e2a7c9c4276e8f03$var$SchemaEnv;
// let codeSize = 0
// let nodeCount = 0
// Compiles schema in SchemaEnv
function $e2a7c9c4276e8f03$var$compileSchema(sch) {
    // TODO refactor - remove compilations
    const _sch = $e2a7c9c4276e8f03$var$getCompilingSchema.call(this, sch);
    if (_sch) return _sch;
    const rootId = (0, $9ZpNV.getFullPath)(this.opts.uriResolver, sch.root.baseId); // TODO if getFullPath removed 1 tests fails
    const { es5: es5, lines: lines } = this.opts.code;
    const { ownProperties: ownProperties } = this.opts;
    const gen = new $l2ufW.CodeGen(this.scope, {
        es5: es5,
        lines: lines,
        ownProperties: ownProperties
    });
    let _ValidationError;
    if (sch.$async) _ValidationError = gen.scopeValue("Error", {
        ref: $2gvZO.default,
        code: (0, $l2ufW._)`require("ajv/dist/runtime/validation_error").default`
    });
    const validateName = gen.scopeName("validate");
    sch.validateName = validateName;
    const schemaCxt = {
        gen: gen,
        allErrors: this.opts.allErrors,
        data: $dOpvc.default.data,
        parentData: $dOpvc.default.parentData,
        parentDataProperty: $dOpvc.default.parentDataProperty,
        dataNames: [
            $dOpvc.default.data
        ],
        dataPathArr: [
            $l2ufW.nil
        ],
        dataLevel: 0,
        dataTypes: [],
        definedProperties: new Set(),
        topSchemaRef: gen.scopeValue("schema", this.opts.code.source === true ? {
            ref: sch.schema,
            code: (0, $l2ufW.stringify)(sch.schema)
        } : {
            ref: sch.schema
        }),
        validateName: validateName,
        ValidationError: _ValidationError,
        schema: sch.schema,
        schemaEnv: sch,
        rootId: rootId,
        baseId: sch.baseId || rootId,
        schemaPath: $l2ufW.nil,
        errSchemaPath: sch.schemaPath || (this.opts.jtd ? "" : "#"),
        errorPath: (0, $l2ufW._)`""`,
        opts: this.opts,
        self: this
    };
    let sourceCode;
    try {
        this._compilations.add(sch);
        (0, $9hgV1.validateFunctionCode)(schemaCxt);
        gen.optimize(this.opts.code.optimize);
        // gen.optimize(1)
        const validateCode = gen.toString();
        sourceCode = `${gen.scopeRefs($dOpvc.default.scope)}return ${validateCode}`;
        // console.log((codeSize += sourceCode.length), (nodeCount += gen.nodeCount))
        if (this.opts.code.process) sourceCode = this.opts.code.process(sourceCode, sch);
        // console.log("\n\n\n *** \n", sourceCode)
        const makeValidate = new Function(`${$dOpvc.default.self}`, `${$dOpvc.default.scope}`, sourceCode);
        const validate = makeValidate(this, this.scope.get());
        this.scope.value(validateName, {
            ref: validate
        });
        validate.errors = null;
        validate.schema = sch.schema;
        validate.schemaEnv = sch;
        if (sch.$async) validate.$async = true;
        if (this.opts.code.source === true) validate.source = {
            validateName: validateName,
            validateCode: validateCode,
            scopeValues: gen._values
        };
        if (this.opts.unevaluated) {
            const { props: props, items: items } = schemaCxt;
            validate.evaluated = {
                props: props instanceof $l2ufW.Name ? undefined : props,
                items: items instanceof $l2ufW.Name ? undefined : items,
                dynamicProps: props instanceof $l2ufW.Name,
                dynamicItems: items instanceof $l2ufW.Name
            };
            if (validate.source) validate.source.evaluated = (0, $l2ufW.stringify)(validate.evaluated);
        }
        sch.validate = validate;
        return sch;
    } catch (e) {
        delete sch.validate;
        delete sch.validateName;
        if (sourceCode) this.logger.error("Error compiling schema, function code:", sourceCode);
        // console.log("\n\n\n *** \n", sourceCode, this.opts)
        throw e;
    } finally{
        this._compilations.delete(sch);
    }
}
module.exports.compileSchema = $e2a7c9c4276e8f03$var$compileSchema;
function $e2a7c9c4276e8f03$var$resolveRef(root, baseId, ref) {
    var _a;
    ref = (0, $9ZpNV.resolveUrl)(this.opts.uriResolver, baseId, ref);
    const schOrFunc = root.refs[ref];
    if (schOrFunc) return schOrFunc;
    let _sch = $e2a7c9c4276e8f03$var$resolve.call(this, root, ref);
    if (_sch === undefined) {
        const schema = (_a = root.localRefs) === null || _a === void 0 ? void 0 : _a[ref]; // TODO maybe localRefs should hold SchemaEnv
        const { schemaId: schemaId } = this.opts;
        if (schema) _sch = new $e2a7c9c4276e8f03$var$SchemaEnv({
            schema: schema,
            schemaId: schemaId,
            root: root,
            baseId: baseId
        });
    }
    if (_sch === undefined) return;
    return root.refs[ref] = $e2a7c9c4276e8f03$var$inlineOrCompile.call(this, _sch);
}
module.exports.resolveRef = $e2a7c9c4276e8f03$var$resolveRef;
function $e2a7c9c4276e8f03$var$inlineOrCompile(sch) {
    if ((0, $9ZpNV.inlineRef)(sch.schema, this.opts.inlineRefs)) return sch.schema;
    return sch.validate ? sch : $e2a7c9c4276e8f03$var$compileSchema.call(this, sch);
}
// Index of schema compilation in the currently compiled list
function $e2a7c9c4276e8f03$var$getCompilingSchema(schEnv) {
    for (const sch of this._compilations){
        if ($e2a7c9c4276e8f03$var$sameSchemaEnv(sch, schEnv)) return sch;
    }
}
module.exports.getCompilingSchema = $e2a7c9c4276e8f03$var$getCompilingSchema;
function $e2a7c9c4276e8f03$var$sameSchemaEnv(s1, s2) {
    return s1.schema === s2.schema && s1.root === s2.root && s1.baseId === s2.baseId;
}
// resolve and compile the references ($ref)
// TODO returns AnySchemaObject (if the schema can be inlined) or validation function
function $e2a7c9c4276e8f03$var$resolve(root, ref // reference to resolve
) {
    let sch;
    while(typeof (sch = this.refs[ref]) == "string")ref = sch;
    return sch || this.schemas[ref] || $e2a7c9c4276e8f03$var$resolveSchema.call(this, root, ref);
}
// Resolve schema, its root and baseId
function $e2a7c9c4276e8f03$var$resolveSchema(root, ref // reference to resolve
) {
    const p = this.opts.uriResolver.parse(ref);
    const refPath = (0, $9ZpNV._getFullPath)(this.opts.uriResolver, p);
    let baseId = (0, $9ZpNV.getFullPath)(this.opts.uriResolver, root.baseId, undefined);
    // TODO `Object.keys(root.schema).length > 0` should not be needed - but removing breaks 2 tests
    if (Object.keys(root.schema).length > 0 && refPath === baseId) return $e2a7c9c4276e8f03$var$getJsonPointer.call(this, p, root);
    const id = (0, $9ZpNV.normalizeId)(refPath);
    const schOrRef = this.refs[id] || this.schemas[id];
    if (typeof schOrRef == "string") {
        const sch = $e2a7c9c4276e8f03$var$resolveSchema.call(this, root, schOrRef);
        if (typeof (sch === null || sch === void 0 ? void 0 : sch.schema) !== "object") return;
        return $e2a7c9c4276e8f03$var$getJsonPointer.call(this, p, sch);
    }
    if (typeof (schOrRef === null || schOrRef === void 0 ? void 0 : schOrRef.schema) !== "object") return;
    if (!schOrRef.validate) $e2a7c9c4276e8f03$var$compileSchema.call(this, schOrRef);
    if (id === (0, $9ZpNV.normalizeId)(ref)) {
        const { schema: schema } = schOrRef;
        const { schemaId: schemaId } = this.opts;
        const schId = schema[schemaId];
        if (schId) baseId = (0, $9ZpNV.resolveUrl)(this.opts.uriResolver, baseId, schId);
        return new $e2a7c9c4276e8f03$var$SchemaEnv({
            schema: schema,
            schemaId: schemaId,
            root: root,
            baseId: baseId
        });
    }
    return $e2a7c9c4276e8f03$var$getJsonPointer.call(this, p, schOrRef);
}
module.exports.resolveSchema = $e2a7c9c4276e8f03$var$resolveSchema;
const $e2a7c9c4276e8f03$var$PREVENT_SCOPE_CHANGE = new Set([
    "properties",
    "patternProperties",
    "enum",
    "dependencies",
    "definitions"
]);
function $e2a7c9c4276e8f03$var$getJsonPointer(parsedRef, { baseId: baseId, schema: schema, root: root }) {
    var _a;
    if (((_a = parsedRef.fragment) === null || _a === void 0 ? void 0 : _a[0]) !== "/") return;
    for (const part of parsedRef.fragment.slice(1).split("/")){
        if (typeof schema === "boolean") return;
        const partSchema = schema[(0, $7eX5i.unescapeFragment)(part)];
        if (partSchema === undefined) return;
        schema = partSchema;
        // TODO PREVENT_SCOPE_CHANGE could be defined in keyword def?
        const schId = typeof schema === "object" && schema[this.opts.schemaId];
        if (!$e2a7c9c4276e8f03$var$PREVENT_SCOPE_CHANGE.has(part) && schId) baseId = (0, $9ZpNV.resolveUrl)(this.opts.uriResolver, baseId, schId);
    }
    let env;
    if (typeof schema != "boolean" && schema.$ref && !(0, $7eX5i.schemaHasRulesButRef)(schema, this.RULES)) {
        const $ref = (0, $9ZpNV.resolveUrl)(this.opts.uriResolver, baseId, schema.$ref);
        env = $e2a7c9c4276e8f03$var$resolveSchema.call(this, root, $ref);
    }
    // even though resolution failed we need to return SchemaEnv to throw exception
    // so that compileAsync loads missing schema.
    const { schemaId: schemaId } = this.opts;
    env = env || new $e2a7c9c4276e8f03$var$SchemaEnv({
        schema: schema,
        schemaId: schemaId,
        root: root,
        baseId: baseId
    });
    if (env.schema !== env.root.schema) return env;
    return undefined;
}

});

parcelRegister("83wzf", function(module, exports) {
module.exports = JSON.parse("{\"$id\":\"https://raw.githubusercontent.com/ajv-validator/ajv/master/lib/refs/data.json#\",\"description\":\"Meta-schema for $data reference (JSON AnySchema extension proposal)\",\"type\":\"object\",\"required\":[\"$data\"],\"properties\":{\"$data\":{\"type\":\"string\",\"anyOf\":[{\"format\":\"relative-json-pointer\"},{\"format\":\"json-pointer\"}]}},\"additionalProperties\":false}");

});

parcelRegister("FaKkF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $90J3F = parcelRequire("90J3F");
$90J3F.code = 'require("ajv/dist/runtime/uri").default';
module.exports.default = $90J3F;

});
parcelRegister("90J3F", function(module, exports) {
'use strict';

var $8wZbZ = parcelRequire("8wZbZ");
var $68f710c71c5708fe$require$normalizeIPv6 = $8wZbZ.normalizeIPv6;
var $68f710c71c5708fe$require$removeDotSegments = $8wZbZ.removeDotSegments;
var $68f710c71c5708fe$require$recomposeAuthority = $8wZbZ.recomposeAuthority;
var $68f710c71c5708fe$require$normalizePercentEncoding = $8wZbZ.normalizePercentEncoding;
var $68f710c71c5708fe$require$normalizePathEncoding = $8wZbZ.normalizePathEncoding;
var $68f710c71c5708fe$require$escapePreservingEscapes = $8wZbZ.escapePreservingEscapes;
var $68f710c71c5708fe$require$reescapeHostDelimiters = $8wZbZ.reescapeHostDelimiters;
var $68f710c71c5708fe$require$isIPv4 = $8wZbZ.isIPv4;
var $68f710c71c5708fe$require$nonSimpleDomain = $8wZbZ.nonSimpleDomain;

var $3u62w = parcelRequire("3u62w");
var $68f710c71c5708fe$require$SCHEMES = $3u62w.SCHEMES;
var $68f710c71c5708fe$require$getSchemeHandler = $3u62w.getSchemeHandler;
/**
 * @template {import('./types/index').URIComponent|string} T
 * @param {T} uri
 * @param {import('./types/index').Options} [options]
 * @returns {T}
 */ function $68f710c71c5708fe$var$normalize(uri, options) {
    if (typeof uri === 'string') uri = /** @type {T} */ $68f710c71c5708fe$var$normalizeString(uri, options);
    else if (typeof uri === 'object') uri = /** @type {T} */ $68f710c71c5708fe$var$parse($68f710c71c5708fe$var$serialize(uri, options), options);
    return uri;
}
/**
 * @param {string} baseURI
 * @param {string} relativeURI
 * @param {import('./types/index').Options} [options]
 * @returns {string}
 */ function $68f710c71c5708fe$var$resolve(baseURI, relativeURI, options) {
    const schemelessOptions = options ? Object.assign({
        scheme: 'null'
    }, options) : {
        scheme: 'null'
    };
    const resolved = $68f710c71c5708fe$var$resolveComponent($68f710c71c5708fe$var$parse(baseURI, schemelessOptions), $68f710c71c5708fe$var$parse(relativeURI, schemelessOptions), schemelessOptions, true);
    schemelessOptions.skipEscape = true;
    return $68f710c71c5708fe$var$serialize(resolved, schemelessOptions);
}
/**
 * @param {import ('./types/index').URIComponent} base
 * @param {import ('./types/index').URIComponent} relative
 * @param {import('./types/index').Options} [options]
 * @param {boolean} [skipNormalization=false]
 * @returns {import ('./types/index').URIComponent}
 */ function $68f710c71c5708fe$var$resolveComponent(base, relative, options, skipNormalization) {
    /** @type {import('./types/index').URIComponent} */ const target = {};
    if (!skipNormalization) {
        base = $68f710c71c5708fe$var$parse($68f710c71c5708fe$var$serialize(base, options), options) // normalize base component
        ;
        relative = $68f710c71c5708fe$var$parse($68f710c71c5708fe$var$serialize(relative, options), options) // normalize relative component
        ;
    }
    options = options || {};
    if (!options.tolerant && relative.scheme) {
        target.scheme = relative.scheme;
        // target.authority = relative.authority;
        target.userinfo = relative.userinfo;
        target.host = relative.host;
        target.port = relative.port;
        target.path = $68f710c71c5708fe$require$removeDotSegments(relative.path || '');
        target.query = relative.query;
    } else {
        if (relative.userinfo !== undefined || relative.host !== undefined || relative.port !== undefined) {
            // target.authority = relative.authority;
            target.userinfo = relative.userinfo;
            target.host = relative.host;
            target.port = relative.port;
            target.path = $68f710c71c5708fe$require$removeDotSegments(relative.path || '');
            target.query = relative.query;
        } else {
            if (!relative.path) {
                target.path = base.path;
                if (relative.query !== undefined) target.query = relative.query;
                else target.query = base.query;
            } else {
                if (relative.path[0] === '/') target.path = $68f710c71c5708fe$require$removeDotSegments(relative.path);
                else {
                    if ((base.userinfo !== undefined || base.host !== undefined || base.port !== undefined) && !base.path) target.path = '/' + relative.path;
                    else if (!base.path) target.path = relative.path;
                    else target.path = base.path.slice(0, base.path.lastIndexOf('/') + 1) + relative.path;
                    target.path = $68f710c71c5708fe$require$removeDotSegments(target.path);
                }
                target.query = relative.query;
            }
            // target.authority = base.authority;
            target.userinfo = base.userinfo;
            target.host = base.host;
            target.port = base.port;
        }
        target.scheme = base.scheme;
    }
    target.fragment = relative.fragment;
    return target;
}
/**
 * @param {import ('./types/index').URIComponent|string} uriA
 * @param {import ('./types/index').URIComponent|string} uriB
 * @param {import ('./types/index').Options} options
 * @returns {boolean}
 */ function $68f710c71c5708fe$var$equal(uriA, uriB, options) {
    const normalizedA = $68f710c71c5708fe$var$normalizeComparableURI(uriA, options);
    const normalizedB = $68f710c71c5708fe$var$normalizeComparableURI(uriB, options);
    return normalizedA !== undefined && normalizedB !== undefined && normalizedA.toLowerCase() === normalizedB.toLowerCase();
}
/**
 * @param {Readonly<import('./types/index').URIComponent>} cmpts
 * @param {import('./types/index').Options} [opts]
 * @returns {string}
 */ function $68f710c71c5708fe$var$serialize(cmpts, opts) {
    const component = {
        host: cmpts.host,
        scheme: cmpts.scheme,
        userinfo: cmpts.userinfo,
        port: cmpts.port,
        path: cmpts.path,
        query: cmpts.query,
        nid: cmpts.nid,
        nss: cmpts.nss,
        uuid: cmpts.uuid,
        fragment: cmpts.fragment,
        reference: cmpts.reference,
        resourceName: cmpts.resourceName,
        secure: cmpts.secure,
        error: ''
    };
    const options = Object.assign({}, opts);
    const uriTokens = [];
    // find scheme handler
    const schemeHandler = $68f710c71c5708fe$require$getSchemeHandler(options.scheme || component.scheme);
    // perform scheme specific serialization
    if (schemeHandler && schemeHandler.serialize) schemeHandler.serialize(component, options);
    if (component.path !== undefined) {
        if (!options.skipEscape) {
            component.path = $68f710c71c5708fe$require$escapePreservingEscapes(component.path);
            if (component.scheme !== undefined) component.path = component.path.split('%3A').join(':');
        } else component.path = $68f710c71c5708fe$require$normalizePercentEncoding(component.path);
    }
    if (options.reference !== 'suffix' && component.scheme) uriTokens.push(component.scheme, ':');
    const authority = $68f710c71c5708fe$require$recomposeAuthority(component);
    if (authority !== undefined) {
        if (options.reference !== 'suffix') uriTokens.push('//');
        uriTokens.push(authority);
        if (component.path && component.path[0] !== '/') uriTokens.push('/');
    }
    if (component.path !== undefined) {
        let s = component.path;
        if (!options.absolutePath && (!schemeHandler || !schemeHandler.absolutePath)) s = $68f710c71c5708fe$require$removeDotSegments(s);
        if (authority === undefined && s[0] === '/' && s[1] === '/') // don't allow the path to start with "//"
        s = '/%2F' + s.slice(2);
        uriTokens.push(s);
    }
    if (component.query !== undefined) uriTokens.push('?', component.query);
    if (component.fragment !== undefined) uriTokens.push('#', component.fragment);
    return uriTokens.join('');
}
const $68f710c71c5708fe$var$URI_PARSE = /^(?:([^#/:?]+):)?(?:\/\/((?:([^#/?@]*)@)?(\[[^#/?\]]+\]|[^#/:?]*)(?::(\d*))?))?([^#?]*)(?:\?([^#]*))?(?:#((?:.|[\n\r])*))?/u;
// Captures the authority component (between "//" and the next "/", "?" or "#"),
// with or without a scheme prefix, for the literal-backslash rejection below.
const $68f710c71c5708fe$var$AUTHORITY_PREFIX = /^(?:[^#/:?]+:)?\/\/([^/?#]*)/;
/**
 * @param {import('./types/index').URIComponent} parsed
 * @param {RegExpMatchArray} matches
 * @returns {string|undefined}
 */ function $68f710c71c5708fe$var$getParseError(parsed, matches) {
    if (matches[2] !== undefined && parsed.path && parsed.path[0] !== '/') return 'URI path must start with "/" when authority is present.';
    if (typeof parsed.port === 'number' && (parsed.port < 0 || parsed.port > 65535)) return 'URI port is malformed.';
    return undefined;
}
/**
 * @param {string} uri
 * @param {import('./types/index').Options} [opts]
 * @returns {{ parsed: import('./types/index').URIComponent, malformedAuthorityOrPort: boolean }}
 */ function $68f710c71c5708fe$var$parseWithStatus(uri, opts) {
    const options = Object.assign({}, opts);
    /** @type {import('./types/index').URIComponent} */ const parsed = {
        scheme: undefined,
        userinfo: undefined,
        host: '',
        port: undefined,
        path: '',
        query: undefined,
        fragment: undefined
    };
    let malformedAuthorityOrPort = false;
    let isIP = false;
    if (options.reference === 'suffix') {
        if (options.scheme) uri = options.scheme + ':' + uri;
        else uri = '//' + uri;
    }
    // A literal backslash (U+005C) is not a valid RFC 3986 URI character and is
    // not an authority delimiter. Reject it in the authority rather than
    // rewriting it: normalizing "\" -> "/" (WHATWG error recovery) could silently
    // change the resource identified by an otherwise-invalid input, and lets "\"
    // act as a host delimiter here while Node's native URL parses a different
    // host (SSRF / redirect / origin-allowlist bypass). Percent-encoded %5C is
    // untouched and remains valid encoded data.
    const authorityMatch = uri.match($68f710c71c5708fe$var$AUTHORITY_PREFIX);
    if (authorityMatch !== null && authorityMatch[1].indexOf('\\') !== -1) {
        parsed.error = 'URI authority must not contain a literal backslash.';
        malformedAuthorityOrPort = true;
    }
    const matches = uri.match($68f710c71c5708fe$var$URI_PARSE);
    if (matches) {
        // store each component
        parsed.scheme = matches[1];
        parsed.userinfo = matches[3];
        parsed.host = matches[4];
        parsed.port = parseInt(matches[5], 10);
        parsed.path = matches[6] || '';
        parsed.query = matches[7];
        parsed.fragment = matches[8];
        // fix port number
        if (isNaN(parsed.port)) parsed.port = matches[5];
        const parseError = $68f710c71c5708fe$var$getParseError(parsed, matches);
        if (parseError !== undefined) {
            parsed.error = parsed.error || parseError;
            malformedAuthorityOrPort = true;
        }
        if (parsed.host) {
            const ipv4result = $68f710c71c5708fe$require$isIPv4(parsed.host);
            if (ipv4result === false) {
                const ipv6result = $68f710c71c5708fe$require$normalizeIPv6(parsed.host);
                parsed.host = ipv6result.host.toLowerCase();
                isIP = ipv6result.isIPV6;
            } else isIP = true;
        }
        if (parsed.scheme === undefined && parsed.userinfo === undefined && parsed.host === undefined && parsed.port === undefined && parsed.query === undefined && !parsed.path) parsed.reference = 'same-document';
        else if (parsed.scheme === undefined) parsed.reference = 'relative';
        else if (parsed.fragment === undefined) parsed.reference = 'absolute';
        else parsed.reference = 'uri';
        // check for reference errors
        if (options.reference && options.reference !== 'suffix' && options.reference !== parsed.reference) parsed.error = parsed.error || 'URI is not a ' + options.reference + ' reference.';
        // find scheme handler
        const schemeHandler = $68f710c71c5708fe$require$getSchemeHandler(options.scheme || parsed.scheme);
        // check if scheme can't handle IRIs
        if (!options.unicodeSupport && (!schemeHandler || !schemeHandler.unicodeSupport)) {
            // if host component is a domain name
            if (parsed.host && (options.domainHost || schemeHandler && schemeHandler.domainHost) && isIP === false && $68f710c71c5708fe$require$nonSimpleDomain(parsed.host)) // convert Unicode IDN -> ASCII IDN
            try {
                parsed.host = new URL('http://' + parsed.host).hostname;
            } catch (e) {
                parsed.error = parsed.error || "Host's domain name can not be converted to ASCII: " + e;
            }
        // convert IRI -> URI
        }
        if (!schemeHandler || schemeHandler && !schemeHandler.skipNormalize) {
            if (uri.indexOf('%') !== -1) {
                if (parsed.scheme !== undefined) parsed.scheme = unescape(parsed.scheme);
                if (parsed.host !== undefined) parsed.host = $68f710c71c5708fe$require$reescapeHostDelimiters(unescape(parsed.host), isIP);
            }
            if (parsed.path) parsed.path = $68f710c71c5708fe$require$normalizePathEncoding(parsed.path);
            if (parsed.fragment) try {
                parsed.fragment = encodeURI(decodeURIComponent(parsed.fragment));
            } catch  {
                parsed.error = parsed.error || 'URI malformed';
            }
        }
        // perform scheme specific parsing
        if (schemeHandler && schemeHandler.parse) schemeHandler.parse(parsed, options);
    } else parsed.error = parsed.error || 'URI can not be parsed.';
    return {
        parsed: parsed,
        malformedAuthorityOrPort: malformedAuthorityOrPort
    };
}
/**
 * @param {string} uri
 * @param {import('./types/index').Options} [opts]
 * @returns
 */ function $68f710c71c5708fe$var$parse(uri, opts) {
    return $68f710c71c5708fe$var$parseWithStatus(uri, opts).parsed;
}
/**
 * @param {string} uri
 * @param {import('./types/index').Options} [opts]
 * @returns {string}
 */ function $68f710c71c5708fe$var$normalizeString(uri, opts) {
    return $68f710c71c5708fe$var$normalizeStringWithStatus(uri, opts).normalized;
}
/**
 * @param {string} uri
 * @param {import('./types/index').Options} [opts]
 * @returns {{ normalized: string, malformedAuthorityOrPort: boolean }}
 */ function $68f710c71c5708fe$var$normalizeStringWithStatus(uri, opts) {
    const { parsed: parsed, malformedAuthorityOrPort: malformedAuthorityOrPort } = $68f710c71c5708fe$var$parseWithStatus(uri, opts);
    return {
        normalized: malformedAuthorityOrPort ? uri : $68f710c71c5708fe$var$serialize(parsed, opts),
        malformedAuthorityOrPort: malformedAuthorityOrPort
    };
}
/**
 * @param {import ('./types/index').URIComponent|string} uri
 * @param {import('./types/index').Options} [opts]
 * @returns {string|undefined}
 */ function $68f710c71c5708fe$var$normalizeComparableURI(uri, opts) {
    if (typeof uri === 'string') {
        const { normalized: normalized, malformedAuthorityOrPort: malformedAuthorityOrPort } = $68f710c71c5708fe$var$normalizeStringWithStatus(uri, opts);
        return malformedAuthorityOrPort ? undefined : normalized;
    }
    if (typeof uri === 'object') return $68f710c71c5708fe$var$serialize(uri, opts);
}
const $68f710c71c5708fe$var$fastUri = {
    SCHEMES: $68f710c71c5708fe$require$SCHEMES,
    normalize: $68f710c71c5708fe$var$normalize,
    resolve: $68f710c71c5708fe$var$resolve,
    resolveComponent: $68f710c71c5708fe$var$resolveComponent,
    equal: $68f710c71c5708fe$var$equal,
    serialize: $68f710c71c5708fe$var$serialize,
    parse: $68f710c71c5708fe$var$parse
};
module.exports = $68f710c71c5708fe$var$fastUri;
module.exports.default = $68f710c71c5708fe$var$fastUri;
module.exports.fastUri = $68f710c71c5708fe$var$fastUri;

});
parcelRegister("8wZbZ", function(module, exports) {
'use strict';
/** @type {(value: string) => boolean} */ const $6360c76d2133c2eb$var$isUUID = RegExp.prototype.test.bind(/^[\da-f]{8}-[\da-f]{4}-[\da-f]{4}-[\da-f]{4}-[\da-f]{12}$/iu);
/** @type {(value: string) => boolean} */ const $6360c76d2133c2eb$var$isIPv4 = RegExp.prototype.test.bind(/^(?:(?:25[0-5]|2[0-4]\d|1\d{2}|[1-9]\d|\d)\.){3}(?:25[0-5]|2[0-4]\d|1\d{2}|[1-9]\d|\d)$/u);
/** @type {(value: string) => boolean} */ const $6360c76d2133c2eb$var$isHexPair = RegExp.prototype.test.bind(/^[\da-f]{2}$/iu);
/** @type {(value: string) => boolean} */ const $6360c76d2133c2eb$var$isUnreserved = RegExp.prototype.test.bind(/^[\da-z\-._~]$/iu);
/** @type {(value: string) => boolean} */ const $6360c76d2133c2eb$var$isPathCharacter = RegExp.prototype.test.bind(/^[\da-z\-._~!$&'()*+,;=:@/]$/iu);
/**
 * @param {Array<string>} input
 * @returns {string}
 */ function $6360c76d2133c2eb$var$stringArrayToHexStripped(input) {
    let acc = '';
    let code = 0;
    let i = 0;
    for(i = 0; i < input.length; i++){
        code = input[i].charCodeAt(0);
        if (code === 48) continue;
        if (!(code >= 48 && code <= 57 || code >= 65 && code <= 70 || code >= 97 && code <= 102)) return '';
        acc += input[i];
        break;
    }
    for(i += 1; i < input.length; i++){
        code = input[i].charCodeAt(0);
        if (!(code >= 48 && code <= 57 || code >= 65 && code <= 70 || code >= 97 && code <= 102)) return '';
        acc += input[i];
    }
    return acc;
}
/**
 * @typedef {Object} GetIPV6Result
 * @property {boolean} error - Indicates if there was an error parsing the IPv6 address.
 * @property {string} address - The parsed IPv6 address.
 * @property {string} [zone] - The zone identifier, if present.
 */ /**
 * @param {string} value
 * @returns {boolean}
 */ const $6360c76d2133c2eb$var$nonSimpleDomain = RegExp.prototype.test.bind(/[^!"$&'()*+,\-.;=_`a-z{}~]/u);
/**
 * @param {Array<string>} buffer
 * @returns {boolean}
 */ function $6360c76d2133c2eb$var$consumeIsZone(buffer) {
    buffer.length = 0;
    return true;
}
/**
 * @param {Array<string>} buffer
 * @param {Array<string>} address
 * @param {GetIPV6Result} output
 * @returns {boolean}
 */ function $6360c76d2133c2eb$var$consumeHextets(buffer, address, output) {
    if (buffer.length) {
        const hex = $6360c76d2133c2eb$var$stringArrayToHexStripped(buffer);
        if (hex !== '') address.push(hex);
        else {
            output.error = true;
            return false;
        }
        buffer.length = 0;
    }
    return true;
}
/**
 * @param {string} input
 * @returns {GetIPV6Result}
 */ function $6360c76d2133c2eb$var$getIPV6(input) {
    let tokenCount = 0;
    const output = {
        error: false,
        address: '',
        zone: ''
    };
    /** @type {Array<string>} */ const address = [];
    /** @type {Array<string>} */ const buffer = [];
    let endipv6Encountered = false;
    let endIpv6 = false;
    let consume = $6360c76d2133c2eb$var$consumeHextets;
    for(let i = 0; i < input.length; i++){
        const cursor = input[i];
        if (cursor === '[' || cursor === ']') continue;
        if (cursor === ':') {
            if (endipv6Encountered === true) endIpv6 = true;
            if (!consume(buffer, address, output)) break;
            if (++tokenCount > 7) {
                // not valid
                output.error = true;
                break;
            }
            if (i > 0 && input[i - 1] === ':') endipv6Encountered = true;
            address.push(':');
            continue;
        } else if (cursor === '%') {
            if (!consume(buffer, address, output)) break;
            // switch to zone detection
            consume = $6360c76d2133c2eb$var$consumeIsZone;
        } else {
            buffer.push(cursor);
            continue;
        }
    }
    if (buffer.length) {
        if (consume === $6360c76d2133c2eb$var$consumeIsZone) output.zone = buffer.join('');
        else if (endIpv6) address.push(buffer.join(''));
        else address.push($6360c76d2133c2eb$var$stringArrayToHexStripped(buffer));
    }
    output.address = address.join('');
    return output;
}
/**
 * @typedef {Object} NormalizeIPv6Result
 * @property {string} host - The normalized host.
 * @property {string} [escapedHost] - The escaped host.
 * @property {boolean} isIPV6 - Indicates if the host is an IPv6 address.
 */ /**
 * @param {string} host
 * @returns {NormalizeIPv6Result}
 */ function $6360c76d2133c2eb$var$normalizeIPv6(host) {
    if ($6360c76d2133c2eb$var$findToken(host, ':') < 2) return {
        host: host,
        isIPV6: false
    };
    const ipv6 = $6360c76d2133c2eb$var$getIPV6(host);
    if (!ipv6.error) {
        let newHost = ipv6.address;
        let escapedHost = ipv6.address;
        if (ipv6.zone) {
            newHost += '%' + ipv6.zone;
            escapedHost += '%25' + ipv6.zone;
        }
        return {
            host: newHost,
            isIPV6: true,
            escapedHost: escapedHost
        };
    } else return {
        host: host,
        isIPV6: false
    };
}
/**
 * @param {string} str
 * @param {string} token
 * @returns {number}
 */ function $6360c76d2133c2eb$var$findToken(str, token) {
    let ind = 0;
    for(let i = 0; i < str.length; i++)if (str[i] === token) ind++;
    return ind;
}
/**
 * @param {string} path
 * @returns {string}
 *
 * @see https://datatracker.ietf.org/doc/html/rfc3986#section-5.2.4
 */ function $6360c76d2133c2eb$var$removeDotSegments(path) {
    let input = path;
    const output = [];
    let nextSlash = -1;
    let len = 0;
    // eslint-disable-next-line no-cond-assign
    while(len = input.length){
        if (len === 1) {
            if (input === '.') break;
            else if (input === '/') {
                output.push('/');
                break;
            } else {
                output.push(input);
                break;
            }
        } else if (len === 2) {
            if (input[0] === '.') {
                if (input[1] === '.') break;
                else if (input[1] === '/') {
                    input = input.slice(2);
                    continue;
                }
            } else if (input[0] === '/') {
                if (input[1] === '.' || input[1] === '/') {
                    output.push('/');
                    break;
                }
            }
        } else if (len === 3) {
            if (input === '/..') {
                if (output.length !== 0) output.pop();
                output.push('/');
                break;
            }
        }
        if (input[0] === '.') {
            if (input[1] === '.') {
                if (input[2] === '/') {
                    input = input.slice(3);
                    continue;
                }
            } else if (input[1] === '/') {
                input = input.slice(2);
                continue;
            }
        } else if (input[0] === '/') {
            if (input[1] === '.') {
                if (input[2] === '/') {
                    input = input.slice(2);
                    continue;
                } else if (input[2] === '.') {
                    if (input[3] === '/') {
                        input = input.slice(3);
                        if (output.length !== 0) output.pop();
                        continue;
                    }
                }
            }
        }
        // Rule 2E: Move normal path segment to output
        if ((nextSlash = input.indexOf('/', 1)) === -1) {
            output.push(input);
            break;
        } else {
            output.push(input.slice(0, nextSlash));
            input = input.slice(nextSlash);
        }
    }
    return output.join('');
}
/**
 * Re-escape RFC 3986 gen-delims that must not appear literally in the host.
 * After the URI regex parses, these characters cannot be literal in the host
 * field, so any that appear after decoding came from percent-encoding and
 * must be restored to prevent authority structure changes.
 *
 * @param {string} host
 * @param {boolean} isIP - true for IPv4/IPv6 hosts (skip colon re-escaping)
 * @returns {string}
 */ const $6360c76d2133c2eb$var$HOST_DELIMS = {
    '@': '%40',
    '/': '%2F',
    '?': '%3F',
    '#': '%23',
    ':': '%3A'
};
const $6360c76d2133c2eb$var$HOST_DELIM_RE = /[@/?#:]/g;
const $6360c76d2133c2eb$var$HOST_DELIM_NO_COLON_RE = /[@/?#]/g;
function $6360c76d2133c2eb$var$reescapeHostDelimiters(host, isIP) {
    const re = isIP ? $6360c76d2133c2eb$var$HOST_DELIM_NO_COLON_RE : $6360c76d2133c2eb$var$HOST_DELIM_RE;
    re.lastIndex = 0;
    return host.replace(re, (ch)=>$6360c76d2133c2eb$var$HOST_DELIMS[ch]);
}
/**
 * Normalizes percent escapes and optionally decodes only unreserved ASCII bytes.
 * Reserved delimiters such as `%2F` and `%2E` stay escaped.
 *
 * @param {string} input
 * @param {boolean} [decodeUnreserved=false]
 * @returns {string}
 */ function $6360c76d2133c2eb$var$normalizePercentEncoding(input, decodeUnreserved = false) {
    if (input.indexOf('%') === -1) return input;
    let output = '';
    for(let i = 0; i < input.length; i++){
        if (input[i] === '%' && i + 2 < input.length) {
            const hex = input.slice(i + 1, i + 3);
            if ($6360c76d2133c2eb$var$isHexPair(hex)) {
                const normalizedHex = hex.toUpperCase();
                const decoded = String.fromCharCode(parseInt(normalizedHex, 16));
                if (decodeUnreserved && $6360c76d2133c2eb$var$isUnreserved(decoded)) output += decoded;
                else output += '%' + normalizedHex;
                i += 2;
                continue;
            }
        }
        output += input[i];
    }
    return output;
}
/**
 * Normalizes path data without turning reserved escapes into live path syntax.
 * Valid escapes are uppercased, raw unsafe characters are escaped, and only
 * unreserved bytes that are not `.` are decoded.
 *
 * @param {string} input
 * @returns {string}
 */ function $6360c76d2133c2eb$var$normalizePathEncoding(input) {
    let output = '';
    for(let i = 0; i < input.length; i++){
        if (input[i] === '%' && i + 2 < input.length) {
            const hex = input.slice(i + 1, i + 3);
            if ($6360c76d2133c2eb$var$isHexPair(hex)) {
                const normalizedHex = hex.toUpperCase();
                const decoded = String.fromCharCode(parseInt(normalizedHex, 16));
                if (decoded !== '.' && $6360c76d2133c2eb$var$isUnreserved(decoded)) output += decoded;
                else output += '%' + normalizedHex;
                i += 2;
                continue;
            }
        }
        if ($6360c76d2133c2eb$var$isPathCharacter(input[i])) output += input[i];
        else output += escape(input[i]);
    }
    return output;
}
/**
 * Escapes a component while preserving existing valid percent escapes.
 *
 * @param {string} input
 * @returns {string}
 */ function $6360c76d2133c2eb$var$escapePreservingEscapes(input) {
    let output = '';
    for(let i = 0; i < input.length; i++){
        if (input[i] === '%' && i + 2 < input.length) {
            const hex = input.slice(i + 1, i + 3);
            if ($6360c76d2133c2eb$var$isHexPair(hex)) {
                output += '%' + hex.toUpperCase();
                i += 2;
                continue;
            }
        }
        output += escape(input[i]);
    }
    return output;
}
/**
 * @param {import('../types/index').URIComponent} component
 * @returns {string|undefined}
 */ function $6360c76d2133c2eb$var$recomposeAuthority(component) {
    const uriTokens = [];
    if (component.userinfo !== undefined) {
        uriTokens.push(component.userinfo);
        uriTokens.push('@');
    }
    if (component.host !== undefined) {
        let host = unescape(component.host);
        if (!$6360c76d2133c2eb$var$isIPv4(host)) {
            const ipV6res = $6360c76d2133c2eb$var$normalizeIPv6(host);
            if (ipV6res.isIPV6 === true) host = `[${ipV6res.escapedHost}]`;
            else host = $6360c76d2133c2eb$var$reescapeHostDelimiters(host, false);
        }
        uriTokens.push(host);
    }
    if (typeof component.port === 'number' || typeof component.port === 'string') {
        uriTokens.push(':');
        uriTokens.push(String(component.port));
    }
    return uriTokens.length ? uriTokens.join('') : undefined;
}
module.exports = {
    nonSimpleDomain: $6360c76d2133c2eb$var$nonSimpleDomain,
    recomposeAuthority: $6360c76d2133c2eb$var$recomposeAuthority,
    reescapeHostDelimiters: $6360c76d2133c2eb$var$reescapeHostDelimiters,
    normalizePercentEncoding: $6360c76d2133c2eb$var$normalizePercentEncoding,
    normalizePathEncoding: $6360c76d2133c2eb$var$normalizePathEncoding,
    escapePreservingEscapes: $6360c76d2133c2eb$var$escapePreservingEscapes,
    removeDotSegments: $6360c76d2133c2eb$var$removeDotSegments,
    isIPv4: $6360c76d2133c2eb$var$isIPv4,
    isUUID: $6360c76d2133c2eb$var$isUUID,
    normalizeIPv6: $6360c76d2133c2eb$var$normalizeIPv6,
    stringArrayToHexStripped: $6360c76d2133c2eb$var$stringArrayToHexStripped
};

});

parcelRegister("3u62w", function(module, exports) {
'use strict';

var $8wZbZ = parcelRequire("8wZbZ");
var $2898dbcd08567ca8$require$isUUID = $8wZbZ.isUUID;
const $2898dbcd08567ca8$var$URN_REG = /([\da-z][\d\-a-z]{0,31}):((?:[\w!$'()*+,\-.:;=@]|%[\da-f]{2})+)/iu;
const $2898dbcd08567ca8$var$supportedSchemeNames = /** @type {const} */ [
    'http',
    'https',
    'ws',
    'wss',
    'urn',
    'urn:uuid'
];
/** @typedef {supportedSchemeNames[number]} SchemeName */ /**
 * @param {string} name
 * @returns {name is SchemeName}
 */ function $2898dbcd08567ca8$var$isValidSchemeName(name) {
    return $2898dbcd08567ca8$var$supportedSchemeNames.indexOf(/** @type {*} */ name) !== -1;
}
/**
 * @callback SchemeFn
 * @param {import('../types/index').URIComponent} component
 * @param {import('../types/index').Options} options
 * @returns {import('../types/index').URIComponent}
 */ /**
 * @typedef {Object} SchemeHandler
 * @property {SchemeName} scheme - The scheme name.
 * @property {boolean} [domainHost] - Indicates if the scheme supports domain hosts.
 * @property {SchemeFn} parse - Function to parse the URI component for this scheme.
 * @property {SchemeFn} serialize - Function to serialize the URI component for this scheme.
 * @property {boolean} [skipNormalize] - Indicates if normalization should be skipped for this scheme.
 * @property {boolean} [absolutePath] - Indicates if the scheme uses absolute paths.
 * @property {boolean} [unicodeSupport] - Indicates if the scheme supports Unicode.
 */ /**
 * @param {import('../types/index').URIComponent} wsComponent
 * @returns {boolean}
 */ function $2898dbcd08567ca8$var$wsIsSecure(wsComponent) {
    if (wsComponent.secure === true) return true;
    else if (wsComponent.secure === false) return false;
    else if (wsComponent.scheme) return wsComponent.scheme.length === 3 && (wsComponent.scheme[0] === 'w' || wsComponent.scheme[0] === 'W') && (wsComponent.scheme[1] === 's' || wsComponent.scheme[1] === 'S') && (wsComponent.scheme[2] === 's' || wsComponent.scheme[2] === 'S');
    else return false;
}
/** @type {SchemeFn} */ function $2898dbcd08567ca8$var$httpParse(component) {
    if (!component.host) component.error = component.error || 'HTTP URIs must have a host.';
    return component;
}
/** @type {SchemeFn} */ function $2898dbcd08567ca8$var$httpSerialize(component) {
    const secure = String(component.scheme).toLowerCase() === 'https';
    // normalize the default port
    if (component.port === (secure ? 443 : 80) || component.port === '') component.port = undefined;
    // normalize the empty path
    if (!component.path) component.path = '/';
    // NOTE: We do not parse query strings for HTTP URIs
    // as WWW Form Url Encoded query strings are part of the HTML4+ spec,
    // and not the HTTP spec.
    return component;
}
/** @type {SchemeFn} */ function $2898dbcd08567ca8$var$wsParse(wsComponent) {
    // indicate if the secure flag is set
    wsComponent.secure = $2898dbcd08567ca8$var$wsIsSecure(wsComponent);
    // construct resouce name
    wsComponent.resourceName = (wsComponent.path || '/') + (wsComponent.query ? '?' + wsComponent.query : '');
    wsComponent.path = undefined;
    wsComponent.query = undefined;
    return wsComponent;
}
/** @type {SchemeFn} */ function $2898dbcd08567ca8$var$wsSerialize(wsComponent) {
    // normalize the default port
    if (wsComponent.port === ($2898dbcd08567ca8$var$wsIsSecure(wsComponent) ? 443 : 80) || wsComponent.port === '') wsComponent.port = undefined;
    // ensure scheme matches secure flag
    if (typeof wsComponent.secure === 'boolean') {
        wsComponent.scheme = wsComponent.secure ? 'wss' : 'ws';
        wsComponent.secure = undefined;
    }
    // reconstruct path from resource name
    if (wsComponent.resourceName) {
        const [path, query] = wsComponent.resourceName.split('?');
        wsComponent.path = path && path !== '/' ? path : undefined;
        wsComponent.query = query;
        wsComponent.resourceName = undefined;
    }
    // forbid fragment component
    wsComponent.fragment = undefined;
    return wsComponent;
}
/** @type {SchemeFn} */ function $2898dbcd08567ca8$var$urnParse(urnComponent, options) {
    if (!urnComponent.path) {
        urnComponent.error = 'URN can not be parsed';
        return urnComponent;
    }
    const matches = urnComponent.path.match($2898dbcd08567ca8$var$URN_REG);
    if (matches) {
        const scheme = options.scheme || urnComponent.scheme || 'urn';
        urnComponent.nid = matches[1].toLowerCase();
        urnComponent.nss = matches[2];
        const urnScheme = `${scheme}:${options.nid || urnComponent.nid}`;
        const schemeHandler = $2898dbcd08567ca8$var$getSchemeHandler(urnScheme);
        urnComponent.path = undefined;
        if (schemeHandler) urnComponent = schemeHandler.parse(urnComponent, options);
    } else urnComponent.error = urnComponent.error || 'URN can not be parsed.';
    return urnComponent;
}
/** @type {SchemeFn} */ function $2898dbcd08567ca8$var$urnSerialize(urnComponent, options) {
    if (urnComponent.nid === undefined) throw new Error('URN without nid cannot be serialized');
    const scheme = options.scheme || urnComponent.scheme || 'urn';
    const nid = urnComponent.nid.toLowerCase();
    const urnScheme = `${scheme}:${options.nid || nid}`;
    const schemeHandler = $2898dbcd08567ca8$var$getSchemeHandler(urnScheme);
    if (schemeHandler) urnComponent = schemeHandler.serialize(urnComponent, options);
    const uriComponent = urnComponent;
    const nss = urnComponent.nss;
    uriComponent.path = `${nid || options.nid}:${nss}`;
    options.skipEscape = true;
    return uriComponent;
}
/** @type {SchemeFn} */ function $2898dbcd08567ca8$var$urnuuidParse(urnComponent, options) {
    const uuidComponent = urnComponent;
    uuidComponent.uuid = uuidComponent.nss;
    uuidComponent.nss = undefined;
    if (!options.tolerant && (!uuidComponent.uuid || !$2898dbcd08567ca8$require$isUUID(uuidComponent.uuid))) uuidComponent.error = uuidComponent.error || 'UUID is not valid.';
    return uuidComponent;
}
/** @type {SchemeFn} */ function $2898dbcd08567ca8$var$urnuuidSerialize(uuidComponent) {
    const urnComponent = uuidComponent;
    // normalize UUID
    urnComponent.nss = (uuidComponent.uuid || '').toLowerCase();
    return urnComponent;
}
const $2898dbcd08567ca8$var$http = /** @type {SchemeHandler} */ {
    scheme: 'http',
    domainHost: true,
    parse: $2898dbcd08567ca8$var$httpParse,
    serialize: $2898dbcd08567ca8$var$httpSerialize
};
const $2898dbcd08567ca8$var$https = /** @type {SchemeHandler} */ {
    scheme: 'https',
    domainHost: $2898dbcd08567ca8$var$http.domainHost,
    parse: $2898dbcd08567ca8$var$httpParse,
    serialize: $2898dbcd08567ca8$var$httpSerialize
};
const $2898dbcd08567ca8$var$ws = /** @type {SchemeHandler} */ {
    scheme: 'ws',
    domainHost: true,
    parse: $2898dbcd08567ca8$var$wsParse,
    serialize: $2898dbcd08567ca8$var$wsSerialize
};
const $2898dbcd08567ca8$var$wss = /** @type {SchemeHandler} */ {
    scheme: 'wss',
    domainHost: $2898dbcd08567ca8$var$ws.domainHost,
    parse: $2898dbcd08567ca8$var$ws.parse,
    serialize: $2898dbcd08567ca8$var$ws.serialize
};
const $2898dbcd08567ca8$var$urn = /** @type {SchemeHandler} */ {
    scheme: 'urn',
    parse: $2898dbcd08567ca8$var$urnParse,
    serialize: $2898dbcd08567ca8$var$urnSerialize,
    skipNormalize: true
};
const $2898dbcd08567ca8$var$urnuuid = /** @type {SchemeHandler} */ {
    scheme: 'urn:uuid',
    parse: $2898dbcd08567ca8$var$urnuuidParse,
    serialize: $2898dbcd08567ca8$var$urnuuidSerialize,
    skipNormalize: true
};
const $2898dbcd08567ca8$var$SCHEMES = /** @type {Record<SchemeName, SchemeHandler>} */ {
    http: $2898dbcd08567ca8$var$http,
    https: $2898dbcd08567ca8$var$https,
    ws: $2898dbcd08567ca8$var$ws,
    wss: $2898dbcd08567ca8$var$wss,
    urn: $2898dbcd08567ca8$var$urn,
    'urn:uuid': $2898dbcd08567ca8$var$urnuuid
};
Object.setPrototypeOf($2898dbcd08567ca8$var$SCHEMES, null);
/**
 * @param {string|undefined} scheme
 * @returns {SchemeHandler|undefined}
 */ function $2898dbcd08567ca8$var$getSchemeHandler(scheme) {
    return scheme && ($2898dbcd08567ca8$var$SCHEMES[/** @type {SchemeName} */ scheme] || $2898dbcd08567ca8$var$SCHEMES[/** @type {SchemeName} */ scheme.toLowerCase()]) || undefined;
}
module.exports = {
    wsIsSecure: $2898dbcd08567ca8$var$wsIsSecure,
    SCHEMES: $2898dbcd08567ca8$var$SCHEMES,
    isValidSchemeName: $2898dbcd08567ca8$var$isValidSchemeName,
    getSchemeHandler: $2898dbcd08567ca8$var$getSchemeHandler
};

});




parcelRegister("hHp9H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kt8nB = parcelRequire("kt8nB");

var $9hSw4 = parcelRequire("9hSw4");

var $8U9k8 = parcelRequire("8U9k8");

var $kLdb8 = parcelRequire("kLdb8");

var $koD8T = parcelRequire("koD8T");
const $ce29f730388cb405$var$draft7Vocabularies = [
    $kt8nB.default,
    $9hSw4.default,
    (0, $8U9k8.default)(),
    $kLdb8.default,
    $koD8T.metadataVocabulary,
    $koD8T.contentVocabulary
];
module.exports.default = $ce29f730388cb405$var$draft7Vocabularies;

});
parcelRegister("kt8nB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $6qsig = parcelRequire("6qsig");

var $kw3FV = parcelRequire("kw3FV");
const $ee6d041c7fe7d577$var$core = [
    "$schema",
    "$id",
    "$defs",
    "$vocabulary",
    {
        keyword: "$comment"
    },
    "definitions",
    $6qsig.default,
    $kw3FV.default
];
module.exports.default = $ee6d041c7fe7d577$var$core;

});
parcelRegister("6qsig", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $4adb1e4936824bf9$var$def = {
    keyword: "id",
    code () {
        throw new Error('NOT SUPPORTED: keyword "id", use "$id" for schema ID');
    }
};
module.exports.default = $4adb1e4936824bf9$var$def;

});

parcelRegister("kw3FV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.callRef = module.exports.getValidate = void 0;

var $euTEo = parcelRequire("euTEo");

var $7unnO = parcelRequire("7unnO");

var $l2ufW = parcelRequire("l2ufW");

var $dOpvc = parcelRequire("dOpvc");

var $jstQR = parcelRequire("jstQR");

var $7eX5i = parcelRequire("7eX5i");
const $eef9a5a25da20ed8$var$def = {
    keyword: "$ref",
    schemaType: "string",
    code (cxt) {
        const { gen: gen, schema: $ref, it: it } = cxt;
        const { baseId: baseId, schemaEnv: env, validateName: validateName, opts: opts, self: self } = it;
        const { root: root } = env;
        if (($ref === "#" || $ref === "#/") && baseId === root.baseId) return callRootRef();
        const schOrEnv = $jstQR.resolveRef.call(self, root, baseId, $ref);
        if (schOrEnv === undefined) throw new $euTEo.default(it.opts.uriResolver, baseId, $ref);
        if (schOrEnv instanceof $jstQR.SchemaEnv) return callValidate(schOrEnv);
        return inlineRefSchema(schOrEnv);
        function callRootRef() {
            if (env === root) return $eef9a5a25da20ed8$var$callRef(cxt, validateName, env, env.$async);
            const rootName = gen.scopeValue("root", {
                ref: root
            });
            return $eef9a5a25da20ed8$var$callRef(cxt, (0, $l2ufW._)`${rootName}.validate`, root, root.$async);
        }
        function callValidate(sch) {
            const v = $eef9a5a25da20ed8$var$getValidate(cxt, sch);
            $eef9a5a25da20ed8$var$callRef(cxt, v, sch, sch.$async);
        }
        function inlineRefSchema(sch) {
            const schName = gen.scopeValue("schema", opts.code.source === true ? {
                ref: sch,
                code: (0, $l2ufW.stringify)(sch)
            } : {
                ref: sch
            });
            const valid = gen.name("valid");
            const schCxt = cxt.subschema({
                schema: sch,
                dataTypes: [],
                schemaPath: $l2ufW.nil,
                topSchemaRef: schName,
                errSchemaPath: $ref
            }, valid);
            cxt.mergeEvaluated(schCxt);
            cxt.ok(valid);
        }
    }
};
function $eef9a5a25da20ed8$var$getValidate(cxt, sch) {
    const { gen: gen } = cxt;
    return sch.validate ? gen.scopeValue("validate", {
        ref: sch.validate
    }) : (0, $l2ufW._)`${gen.scopeValue("wrapper", {
        ref: sch
    })}.validate`;
}
module.exports.getValidate = $eef9a5a25da20ed8$var$getValidate;
function $eef9a5a25da20ed8$var$callRef(cxt, v, sch, $async) {
    const { gen: gen, it: it } = cxt;
    const { allErrors: allErrors, schemaEnv: env, opts: opts } = it;
    const passCxt = opts.passContext ? $dOpvc.default.this : $l2ufW.nil;
    if ($async) callAsyncRef();
    else callSyncRef();
    function callAsyncRef() {
        if (!env.$async) throw new Error("async schema referenced by sync schema");
        const valid = gen.let("valid");
        gen.try(()=>{
            gen.code((0, $l2ufW._)`await ${(0, $7unnO.callValidateCode)(cxt, v, passCxt)}`);
            addEvaluatedFrom(v); // TODO will not work with async, it has to be returned with the result
            if (!allErrors) gen.assign(valid, true);
        }, (e)=>{
            gen.if((0, $l2ufW._)`!(${e} instanceof ${it.ValidationError})`, ()=>gen.throw(e));
            addErrorsFrom(e);
            if (!allErrors) gen.assign(valid, false);
        });
        cxt.ok(valid);
    }
    function callSyncRef() {
        cxt.result((0, $7unnO.callValidateCode)(cxt, v, passCxt), ()=>addEvaluatedFrom(v), ()=>addErrorsFrom(v));
    }
    function addErrorsFrom(source) {
        const errs = (0, $l2ufW._)`${source}.errors`;
        gen.assign($dOpvc.default.vErrors, (0, $l2ufW._)`${$dOpvc.default.vErrors} === null ? ${errs} : ${$dOpvc.default.vErrors}.concat(${errs})`); // TODO tagged
        gen.assign($dOpvc.default.errors, (0, $l2ufW._)`${$dOpvc.default.vErrors}.length`);
    }
    function addEvaluatedFrom(source) {
        var _a;
        if (!it.opts.unevaluated) return;
        const schEvaluated = (_a = sch === null || sch === void 0 ? void 0 : sch.validate) === null || _a === void 0 ? void 0 : _a.evaluated;
        // TODO refactor
        if (it.props !== true) {
            if (schEvaluated && !schEvaluated.dynamicProps) {
                if (schEvaluated.props !== undefined) it.props = $7eX5i.mergeEvaluated.props(gen, schEvaluated.props, it.props);
            } else {
                const props = gen.var("props", (0, $l2ufW._)`${source}.evaluated.props`);
                it.props = $7eX5i.mergeEvaluated.props(gen, props, it.props, $l2ufW.Name);
            }
        }
        if (it.items !== true) {
            if (schEvaluated && !schEvaluated.dynamicItems) {
                if (schEvaluated.items !== undefined) it.items = $7eX5i.mergeEvaluated.items(gen, schEvaluated.items, it.items);
            } else {
                const items = gen.var("items", (0, $l2ufW._)`${source}.evaluated.items`);
                it.items = $7eX5i.mergeEvaluated.items(gen, items, it.items, $l2ufW.Name);
            }
        }
    }
}
module.exports.callRef = $eef9a5a25da20ed8$var$callRef;
module.exports.default = $eef9a5a25da20ed8$var$def;

});


parcelRegister("9hSw4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3WoId = parcelRequire("3WoId");

var $bUCRi = parcelRequire("bUCRi");

var $Nqi0g = parcelRequire("Nqi0g");

var $9V0CC = parcelRequire("9V0CC");

var $3HmRG = parcelRequire("3HmRG");

var $aQ9E5 = parcelRequire("aQ9E5");

var $37rVP = parcelRequire("37rVP");

var $1ObWf = parcelRequire("1ObWf");

var $1jiSd = parcelRequire("1jiSd");

var $6bLKD = parcelRequire("6bLKD");
const $6c2ffd64a2866684$var$validation = [
    // number
    $3WoId.default,
    $bUCRi.default,
    // string
    $Nqi0g.default,
    $9V0CC.default,
    // object
    $3HmRG.default,
    $aQ9E5.default,
    // array
    $37rVP.default,
    $1ObWf.default,
    // any
    {
        keyword: "type",
        schemaType: [
            "string",
            "array"
        ]
    },
    {
        keyword: "nullable",
        schemaType: "boolean"
    },
    $1jiSd.default,
    $6bLKD.default
];
module.exports.default = $6c2ffd64a2866684$var$validation;

});
parcelRegister("3WoId", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l2ufW = parcelRequire("l2ufW");
const $2de9f5322632f65d$var$ops = $l2ufW.operators;
const $2de9f5322632f65d$var$KWDs = {
    maximum: {
        okStr: "<=",
        ok: $2de9f5322632f65d$var$ops.LTE,
        fail: $2de9f5322632f65d$var$ops.GT
    },
    minimum: {
        okStr: ">=",
        ok: $2de9f5322632f65d$var$ops.GTE,
        fail: $2de9f5322632f65d$var$ops.LT
    },
    exclusiveMaximum: {
        okStr: "<",
        ok: $2de9f5322632f65d$var$ops.LT,
        fail: $2de9f5322632f65d$var$ops.GTE
    },
    exclusiveMinimum: {
        okStr: ">",
        ok: $2de9f5322632f65d$var$ops.GT,
        fail: $2de9f5322632f65d$var$ops.LTE
    }
};
const $2de9f5322632f65d$var$error = {
    message: ({ keyword: keyword, schemaCode: schemaCode })=>(0, $l2ufW.str)`must be ${$2de9f5322632f65d$var$KWDs[keyword].okStr} ${schemaCode}`,
    params: ({ keyword: keyword, schemaCode: schemaCode })=>(0, $l2ufW._)`{comparison: ${$2de9f5322632f65d$var$KWDs[keyword].okStr}, limit: ${schemaCode}}`
};
const $2de9f5322632f65d$var$def = {
    keyword: Object.keys($2de9f5322632f65d$var$KWDs),
    type: "number",
    schemaType: "number",
    $data: true,
    error: $2de9f5322632f65d$var$error,
    code (cxt) {
        const { keyword: keyword, data: data, schemaCode: schemaCode } = cxt;
        cxt.fail$data((0, $l2ufW._)`${data} ${$2de9f5322632f65d$var$KWDs[keyword].fail} ${schemaCode} || isNaN(${data})`);
    }
};
module.exports.default = $2de9f5322632f65d$var$def;

});

parcelRegister("bUCRi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l2ufW = parcelRequire("l2ufW");
const $8ac31129cbdb6091$var$error = {
    message: ({ schemaCode: schemaCode })=>(0, $l2ufW.str)`must be multiple of ${schemaCode}`,
    params: ({ schemaCode: schemaCode })=>(0, $l2ufW._)`{multipleOf: ${schemaCode}}`
};
const $8ac31129cbdb6091$var$def = {
    keyword: "multipleOf",
    type: "number",
    schemaType: "number",
    $data: true,
    error: $8ac31129cbdb6091$var$error,
    code (cxt) {
        const { gen: gen, data: data, schemaCode: schemaCode, it: it } = cxt;
        // const bdt = bad$DataType(schemaCode, <string>def.schemaType, $data)
        const prec = it.opts.multipleOfPrecision;
        const res = gen.let("res");
        const invalid = prec ? (0, $l2ufW._)`Math.abs(Math.round(${res}) - ${res}) > 1e-${prec}` : (0, $l2ufW._)`${res} !== parseInt(${res})`;
        cxt.fail$data((0, $l2ufW._)`(${schemaCode} === 0 || (${res} = ${data}/${schemaCode}, ${invalid}))`);
    }
};
module.exports.default = $8ac31129cbdb6091$var$def;

});

parcelRegister("Nqi0g", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");

var $6BTyZ = parcelRequire("6BTyZ");
const $0948f83d70ebc31d$var$error = {
    message ({ keyword: keyword, schemaCode: schemaCode }) {
        const comp = keyword === "maxLength" ? "more" : "fewer";
        return (0, $l2ufW.str)`must NOT have ${comp} than ${schemaCode} characters`;
    },
    params: ({ schemaCode: schemaCode })=>(0, $l2ufW._)`{limit: ${schemaCode}}`
};
const $0948f83d70ebc31d$var$def = {
    keyword: [
        "maxLength",
        "minLength"
    ],
    type: "string",
    schemaType: "number",
    $data: true,
    error: $0948f83d70ebc31d$var$error,
    code (cxt) {
        const { keyword: keyword, data: data, schemaCode: schemaCode, it: it } = cxt;
        const op = keyword === "maxLength" ? $l2ufW.operators.GT : $l2ufW.operators.LT;
        const len = it.opts.unicode === false ? (0, $l2ufW._)`${data}.length` : (0, $l2ufW._)`${(0, $7eX5i.useFunc)(cxt.gen, $6BTyZ.default)}(${data})`;
        cxt.fail$data((0, $l2ufW._)`${len} ${op} ${schemaCode}`);
    }
};
module.exports.default = $0948f83d70ebc31d$var$def;

});
parcelRegister("6BTyZ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// https://mathiasbynens.be/notes/javascript-encoding
// https://github.com/bestiejs/punycode.js - punycode.ucs2.decode
function $4d014c7f52d4c6e1$var$ucs2length(str) {
    const len = str.length;
    let length = 0;
    let pos = 0;
    let value;
    while(pos < len){
        length++;
        value = str.charCodeAt(pos++);
        if (value >= 0xd800 && value <= 0xdbff && pos < len) {
            // high surrogate, and there is a next character
            value = str.charCodeAt(pos);
            if ((value & 0xfc00) === 0xdc00) pos++; // low surrogate
        }
    }
    return length;
}
module.exports.default = $4d014c7f52d4c6e1$var$ucs2length;
$4d014c7f52d4c6e1$var$ucs2length.code = 'require("ajv/dist/runtime/ucs2length").default';

});


parcelRegister("9V0CC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7unnO = parcelRequire("7unnO");

var $7eX5i = parcelRequire("7eX5i");

var $l2ufW = parcelRequire("l2ufW");
const $7389eb6c89297209$var$error = {
    message: ({ schemaCode: schemaCode })=>(0, $l2ufW.str)`must match pattern "${schemaCode}"`,
    params: ({ schemaCode: schemaCode })=>(0, $l2ufW._)`{pattern: ${schemaCode}}`
};
const $7389eb6c89297209$var$def = {
    keyword: "pattern",
    type: "string",
    schemaType: "string",
    $data: true,
    error: $7389eb6c89297209$var$error,
    code (cxt) {
        const { gen: gen, data: data, $data: $data, schema: schema, schemaCode: schemaCode, it: it } = cxt;
        const u = it.opts.unicodeRegExp ? "u" : "";
        if ($data) {
            const { regExp: regExp } = it.opts.code;
            const regExpCode = regExp.code === "new RegExp" ? (0, $l2ufW._)`new RegExp` : (0, $7eX5i.useFunc)(gen, regExp);
            const valid = gen.let("valid");
            gen.try(()=>gen.assign(valid, (0, $l2ufW._)`${regExpCode}(${schemaCode}, ${u}).test(${data})`), ()=>gen.assign(valid, false));
            cxt.fail$data((0, $l2ufW._)`!${valid}`);
        } else {
            const regExp = (0, $7unnO.usePattern)(cxt, schema);
            cxt.fail$data((0, $l2ufW._)`!${regExp}.test(${data})`);
        }
    }
};
module.exports.default = $7389eb6c89297209$var$def;

});

parcelRegister("3HmRG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l2ufW = parcelRequire("l2ufW");
const $2b171fbd18b88a3a$var$error = {
    message ({ keyword: keyword, schemaCode: schemaCode }) {
        const comp = keyword === "maxProperties" ? "more" : "fewer";
        return (0, $l2ufW.str)`must NOT have ${comp} than ${schemaCode} properties`;
    },
    params: ({ schemaCode: schemaCode })=>(0, $l2ufW._)`{limit: ${schemaCode}}`
};
const $2b171fbd18b88a3a$var$def = {
    keyword: [
        "maxProperties",
        "minProperties"
    ],
    type: "object",
    schemaType: "number",
    $data: true,
    error: $2b171fbd18b88a3a$var$error,
    code (cxt) {
        const { keyword: keyword, data: data, schemaCode: schemaCode } = cxt;
        const op = keyword === "maxProperties" ? $l2ufW.operators.GT : $l2ufW.operators.LT;
        cxt.fail$data((0, $l2ufW._)`Object.keys(${data}).length ${op} ${schemaCode}`);
    }
};
module.exports.default = $2b171fbd18b88a3a$var$def;

});

parcelRegister("aQ9E5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7unnO = parcelRequire("7unnO");

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");
const $7e463e1d6144c89a$var$error = {
    message: ({ params: { missingProperty: missingProperty } })=>(0, $l2ufW.str)`must have required property '${missingProperty}'`,
    params: ({ params: { missingProperty: missingProperty } })=>(0, $l2ufW._)`{missingProperty: ${missingProperty}}`
};
const $7e463e1d6144c89a$var$def = {
    keyword: "required",
    type: "object",
    schemaType: "array",
    $data: true,
    error: $7e463e1d6144c89a$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, schemaCode: schemaCode, data: data, $data: $data, it: it } = cxt;
        const { opts: opts } = it;
        if (!$data && schema.length === 0) return;
        const useLoop = schema.length >= opts.loopRequired;
        if (it.allErrors) allErrorsMode();
        else exitOnErrorMode();
        if (opts.strictRequired) {
            const props = cxt.parentSchema.properties;
            const { definedProperties: definedProperties } = cxt.it;
            for (const requiredKey of schema)if ((props === null || props === void 0 ? void 0 : props[requiredKey]) === undefined && !definedProperties.has(requiredKey)) {
                const schemaPath = it.schemaEnv.baseId + it.errSchemaPath;
                const msg = `required property "${requiredKey}" is not defined at "${schemaPath}" (strictRequired)`;
                (0, $7eX5i.checkStrictMode)(it, msg, it.opts.strictRequired);
            }
        }
        function allErrorsMode() {
            if (useLoop || $data) cxt.block$data($l2ufW.nil, loopAllRequired);
            else for (const prop of schema)(0, $7unnO.checkReportMissingProp)(cxt, prop);
        }
        function exitOnErrorMode() {
            const missing = gen.let("missing");
            if (useLoop || $data) {
                const valid = gen.let("valid", true);
                cxt.block$data(valid, ()=>loopUntilMissing(missing, valid));
                cxt.ok(valid);
            } else {
                gen.if((0, $7unnO.checkMissingProp)(cxt, schema, missing));
                (0, $7unnO.reportMissingProp)(cxt, missing);
                gen.else();
            }
        }
        function loopAllRequired() {
            gen.forOf("prop", schemaCode, (prop)=>{
                cxt.setParams({
                    missingProperty: prop
                });
                gen.if((0, $7unnO.noPropertyInData)(gen, data, prop, opts.ownProperties), ()=>cxt.error());
            });
        }
        function loopUntilMissing(missing, valid) {
            cxt.setParams({
                missingProperty: missing
            });
            gen.forOf(missing, schemaCode, ()=>{
                gen.assign(valid, (0, $7unnO.propertyInData)(gen, data, missing, opts.ownProperties));
                gen.if((0, $l2ufW.not)(valid), ()=>{
                    cxt.error();
                    gen.break();
                });
            }, $l2ufW.nil);
        }
    }
};
module.exports.default = $7e463e1d6144c89a$var$def;

});

parcelRegister("37rVP", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l2ufW = parcelRequire("l2ufW");
const $2457b12e61a8fb9a$var$error = {
    message ({ keyword: keyword, schemaCode: schemaCode }) {
        const comp = keyword === "maxItems" ? "more" : "fewer";
        return (0, $l2ufW.str)`must NOT have ${comp} than ${schemaCode} items`;
    },
    params: ({ schemaCode: schemaCode })=>(0, $l2ufW._)`{limit: ${schemaCode}}`
};
const $2457b12e61a8fb9a$var$def = {
    keyword: [
        "maxItems",
        "minItems"
    ],
    type: "array",
    schemaType: "number",
    $data: true,
    error: $2457b12e61a8fb9a$var$error,
    code (cxt) {
        const { keyword: keyword, data: data, schemaCode: schemaCode } = cxt;
        const op = keyword === "maxItems" ? $l2ufW.operators.GT : $l2ufW.operators.LT;
        cxt.fail$data((0, $l2ufW._)`${data}.length ${op} ${schemaCode}`);
    }
};
module.exports.default = $2457b12e61a8fb9a$var$def;

});

parcelRegister("1ObWf", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $46MS3 = parcelRequire("46MS3");

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");

var $cMsoH = parcelRequire("cMsoH");
const $1513b8ab19deb343$var$error = {
    message: ({ params: { i: i, j: j } })=>(0, $l2ufW.str)`must NOT have duplicate items (items ## ${j} and ${i} are identical)`,
    params: ({ params: { i: i, j: j } })=>(0, $l2ufW._)`{i: ${i}, j: ${j}}`
};
const $1513b8ab19deb343$var$def = {
    keyword: "uniqueItems",
    type: "array",
    schemaType: "boolean",
    $data: true,
    error: $1513b8ab19deb343$var$error,
    code (cxt) {
        const { gen: gen, data: data, $data: $data, schema: schema, parentSchema: parentSchema, schemaCode: schemaCode, it: it } = cxt;
        if (!$data && !schema) return;
        const valid = gen.let("valid");
        const itemTypes = parentSchema.items ? (0, $46MS3.getSchemaTypes)(parentSchema.items) : [];
        cxt.block$data(valid, validateUniqueItems, (0, $l2ufW._)`${schemaCode} === false`);
        cxt.ok(valid);
        function validateUniqueItems() {
            const i = gen.let("i", (0, $l2ufW._)`${data}.length`);
            const j = gen.let("j");
            cxt.setParams({
                i: i,
                j: j
            });
            gen.assign(valid, true);
            gen.if((0, $l2ufW._)`${i} > 1`, ()=>(canOptimize() ? loopN : loopN2)(i, j));
        }
        function canOptimize() {
            return itemTypes.length > 0 && !itemTypes.some((t)=>t === "object" || t === "array");
        }
        function loopN(i, j) {
            const item = gen.name("item");
            const wrongType = (0, $46MS3.checkDataTypes)(itemTypes, item, it.opts.strictNumbers, $46MS3.DataType.Wrong);
            const indices = gen.const("indices", (0, $l2ufW._)`{}`);
            gen.for((0, $l2ufW._)`;${i}--;`, ()=>{
                gen.let(item, (0, $l2ufW._)`${data}[${i}]`);
                gen.if(wrongType, (0, $l2ufW._)`continue`);
                if (itemTypes.length > 1) gen.if((0, $l2ufW._)`typeof ${item} == "string"`, (0, $l2ufW._)`${item} += "_"`);
                gen.if((0, $l2ufW._)`typeof ${indices}[${item}] == "number"`, ()=>{
                    gen.assign(j, (0, $l2ufW._)`${indices}[${item}]`);
                    cxt.error();
                    gen.assign(valid, false).break();
                }).code((0, $l2ufW._)`${indices}[${item}] = ${i}`);
            });
        }
        function loopN2(i, j) {
            const eql = (0, $7eX5i.useFunc)(gen, $cMsoH.default);
            const outer = gen.name("outer");
            gen.label(outer).for((0, $l2ufW._)`;${i}--;`, ()=>gen.for((0, $l2ufW._)`${j} = ${i}; ${j}--;`, ()=>gen.if((0, $l2ufW._)`${eql}(${data}[${i}], ${data}[${j}])`, ()=>{
                        cxt.error();
                        gen.assign(valid, false).break(outer);
                    })));
        }
    }
};
module.exports.default = $1513b8ab19deb343$var$def;

});
parcelRegister("cMsoH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7hFx0 = parcelRequire("7hFx0");
$7hFx0.code = 'require("ajv/dist/runtime/equal").default';
module.exports.default = $7hFx0;

});


parcelRegister("1jiSd", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");

var $cMsoH = parcelRequire("cMsoH");
const $0f4634aee52087bc$var$error = {
    message: "must be equal to constant",
    params: ({ schemaCode: schemaCode })=>(0, $l2ufW._)`{allowedValue: ${schemaCode}}`
};
const $0f4634aee52087bc$var$def = {
    keyword: "const",
    $data: true,
    error: $0f4634aee52087bc$var$error,
    code (cxt) {
        const { gen: gen, data: data, $data: $data, schemaCode: schemaCode, schema: schema } = cxt;
        if ($data || schema && typeof schema == "object") cxt.fail$data((0, $l2ufW._)`!${(0, $7eX5i.useFunc)(gen, $cMsoH.default)}(${data}, ${schemaCode})`);
        else cxt.fail((0, $l2ufW._)`${schema} !== ${data}`);
    }
};
module.exports.default = $0f4634aee52087bc$var$def;

});

parcelRegister("6bLKD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");

var $cMsoH = parcelRequire("cMsoH");
const $4818cf8a0c8b5641$var$error = {
    message: "must be equal to one of the allowed values",
    params: ({ schemaCode: schemaCode })=>(0, $l2ufW._)`{allowedValues: ${schemaCode}}`
};
const $4818cf8a0c8b5641$var$def = {
    keyword: "enum",
    schemaType: "array",
    $data: true,
    error: $4818cf8a0c8b5641$var$error,
    code (cxt) {
        const { gen: gen, data: data, $data: $data, schema: schema, schemaCode: schemaCode, it: it } = cxt;
        if (!$data && schema.length === 0) throw new Error("enum must have non-empty array");
        const useLoop = schema.length >= it.opts.loopEnum;
        let eql;
        const getEql = ()=>eql !== null && eql !== void 0 ? eql : eql = (0, $7eX5i.useFunc)(gen, $cMsoH.default);
        let valid;
        if (useLoop || $data) {
            valid = gen.let("valid");
            cxt.block$data(valid, loopEnum);
        } else {
            /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
            const vSchema = gen.const("vSchema", schemaCode);
            valid = (0, $l2ufW.or)(...schema.map((_x, i)=>equalCode(vSchema, i)));
        }
        cxt.pass(valid);
        function loopEnum() {
            gen.assign(valid, false);
            gen.forOf("v", schemaCode, (v)=>gen.if((0, $l2ufW._)`${getEql()}(${data}, ${v})`, ()=>gen.assign(valid, true).break()));
        }
        function equalCode(vSchema, i) {
            const sch = schema[i];
            return typeof sch === "object" && sch !== null ? (0, $l2ufW._)`${getEql()}(${data}, ${vSchema}[${i}])` : (0, $l2ufW._)`${data} === ${sch}`;
        }
    }
};
module.exports.default = $4818cf8a0c8b5641$var$def;

});


parcelRegister("8U9k8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7FQbu = parcelRequire("7FQbu");

var $9llPm = parcelRequire("9llPm");

var $cNKK7 = parcelRequire("cNKK7");

var $a2HBF = parcelRequire("a2HBF");

var $2dY63 = parcelRequire("2dY63");

var $ksuYJ = parcelRequire("ksuYJ");

var $bXp0l = parcelRequire("bXp0l");

var $8Wg07 = parcelRequire("8Wg07");

var $iBNsK = parcelRequire("iBNsK");

var $eSOrH = parcelRequire("eSOrH");

var $62Mii = parcelRequire("62Mii");

var $d3kOu = parcelRequire("d3kOu");

var $gC5PA = parcelRequire("gC5PA");

var $fhXQa = parcelRequire("fhXQa");

var $jfpXQ = parcelRequire("jfpXQ");

var $5HS6k = parcelRequire("5HS6k");
function $67bac937e8bbc1f1$var$getApplicator(draft2020 = false) {
    const applicator = [
        // any
        $62Mii.default,
        $d3kOu.default,
        $gC5PA.default,
        $fhXQa.default,
        $jfpXQ.default,
        $5HS6k.default,
        // object
        $bXp0l.default,
        $8Wg07.default,
        $ksuYJ.default,
        $iBNsK.default,
        $eSOrH.default
    ];
    // array
    if (draft2020) applicator.push($9llPm.default, $a2HBF.default);
    else applicator.push($7FQbu.default, $cNKK7.default);
    applicator.push($2dY63.default);
    return applicator;
}
module.exports.default = $67bac937e8bbc1f1$var$getApplicator;

});
parcelRegister("7FQbu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateAdditionalItems = void 0;

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");
const $5964d7729d257dac$var$error = {
    message: ({ params: { len: len } })=>(0, $l2ufW.str)`must NOT have more than ${len} items`,
    params: ({ params: { len: len } })=>(0, $l2ufW._)`{limit: ${len}}`
};
const $5964d7729d257dac$var$def = {
    keyword: "additionalItems",
    type: "array",
    schemaType: [
        "boolean",
        "object"
    ],
    before: "uniqueItems",
    error: $5964d7729d257dac$var$error,
    code (cxt) {
        const { parentSchema: parentSchema, it: it } = cxt;
        const { items: items } = parentSchema;
        if (!Array.isArray(items)) {
            (0, $7eX5i.checkStrictMode)(it, '"additionalItems" is ignored when "items" is not an array of schemas');
            return;
        }
        $5964d7729d257dac$var$validateAdditionalItems(cxt, items);
    }
};
function $5964d7729d257dac$var$validateAdditionalItems(cxt, items) {
    const { gen: gen, schema: schema, data: data, keyword: keyword, it: it } = cxt;
    it.items = true;
    const len = gen.const("len", (0, $l2ufW._)`${data}.length`);
    if (schema === false) {
        cxt.setParams({
            len: items.length
        });
        cxt.pass((0, $l2ufW._)`${len} <= ${items.length}`);
    } else if (typeof schema == "object" && !(0, $7eX5i.alwaysValidSchema)(it, schema)) {
        const valid = gen.var("valid", (0, $l2ufW._)`${len} <= ${items.length}`); // TODO var
        gen.if((0, $l2ufW.not)(valid), ()=>validateItems(valid));
        cxt.ok(valid);
    }
    function validateItems(valid) {
        gen.forRange("i", items.length, len, (i)=>{
            cxt.subschema({
                keyword: keyword,
                dataProp: i,
                dataPropType: $7eX5i.Type.Num
            }, valid);
            if (!it.allErrors) gen.if((0, $l2ufW.not)(valid), ()=>gen.break());
        });
    }
}
module.exports.validateAdditionalItems = $5964d7729d257dac$var$validateAdditionalItems;
module.exports.default = $5964d7729d257dac$var$def;

});

parcelRegister("9llPm", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $cNKK7 = parcelRequire("cNKK7");
const $6cd701aaf66b3db3$var$def = {
    keyword: "prefixItems",
    type: "array",
    schemaType: [
        "array"
    ],
    before: "uniqueItems",
    code: (cxt)=>(0, $cNKK7.validateTuple)(cxt, "items")
};
module.exports.default = $6cd701aaf66b3db3$var$def;

});
parcelRegister("cNKK7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateTuple = void 0;

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");

var $7unnO = parcelRequire("7unnO");
const $951e51c9b8ab42ca$var$def = {
    keyword: "items",
    type: "array",
    schemaType: [
        "object",
        "array",
        "boolean"
    ],
    before: "uniqueItems",
    code (cxt) {
        const { schema: schema, it: it } = cxt;
        if (Array.isArray(schema)) return $951e51c9b8ab42ca$var$validateTuple(cxt, "additionalItems", schema);
        it.items = true;
        if ((0, $7eX5i.alwaysValidSchema)(it, schema)) return;
        cxt.ok((0, $7unnO.validateArray)(cxt));
    }
};
function $951e51c9b8ab42ca$var$validateTuple(cxt, extraItems, schArr = cxt.schema) {
    const { gen: gen, parentSchema: parentSchema, data: data, keyword: keyword, it: it } = cxt;
    checkStrictTuple(parentSchema);
    if (it.opts.unevaluated && schArr.length && it.items !== true) it.items = $7eX5i.mergeEvaluated.items(gen, schArr.length, it.items);
    const valid = gen.name("valid");
    const len = gen.const("len", (0, $l2ufW._)`${data}.length`);
    schArr.forEach((sch, i)=>{
        if ((0, $7eX5i.alwaysValidSchema)(it, sch)) return;
        gen.if((0, $l2ufW._)`${len} > ${i}`, ()=>cxt.subschema({
                keyword: keyword,
                schemaProp: i,
                dataProp: i
            }, valid));
        cxt.ok(valid);
    });
    function checkStrictTuple(sch) {
        const { opts: opts, errSchemaPath: errSchemaPath } = it;
        const l = schArr.length;
        const fullTuple = l === sch.minItems && (l === sch.maxItems || sch[extraItems] === false);
        if (opts.strictTuples && !fullTuple) {
            const msg = `"${keyword}" is ${l}-tuple, but minItems or maxItems/${extraItems} are not specified or different at path "${errSchemaPath}"`;
            (0, $7eX5i.checkStrictMode)(it, msg, opts.strictTuples);
        }
    }
}
module.exports.validateTuple = $951e51c9b8ab42ca$var$validateTuple;
module.exports.default = $951e51c9b8ab42ca$var$def;

});


parcelRegister("a2HBF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");

var $7unnO = parcelRequire("7unnO");

var $7FQbu = parcelRequire("7FQbu");
const $74fbeaa6b7e34267$var$error = {
    message: ({ params: { len: len } })=>(0, $l2ufW.str)`must NOT have more than ${len} items`,
    params: ({ params: { len: len } })=>(0, $l2ufW._)`{limit: ${len}}`
};
const $74fbeaa6b7e34267$var$def = {
    keyword: "items",
    type: "array",
    schemaType: [
        "object",
        "boolean"
    ],
    before: "uniqueItems",
    error: $74fbeaa6b7e34267$var$error,
    code (cxt) {
        const { schema: schema, parentSchema: parentSchema, it: it } = cxt;
        const { prefixItems: prefixItems } = parentSchema;
        it.items = true;
        if ((0, $7eX5i.alwaysValidSchema)(it, schema)) return;
        if (prefixItems) (0, $7FQbu.validateAdditionalItems)(cxt, prefixItems);
        else cxt.ok((0, $7unnO.validateArray)(cxt));
    }
};
module.exports.default = $74fbeaa6b7e34267$var$def;

});

parcelRegister("2dY63", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");
const $19eb69a255f3d502$var$error = {
    message: ({ params: { min: min, max: max } })=>max === undefined ? (0, $l2ufW.str)`must contain at least ${min} valid item(s)` : (0, $l2ufW.str)`must contain at least ${min} and no more than ${max} valid item(s)`,
    params: ({ params: { min: min, max: max } })=>max === undefined ? (0, $l2ufW._)`{minContains: ${min}}` : (0, $l2ufW._)`{minContains: ${min}, maxContains: ${max}}`
};
const $19eb69a255f3d502$var$def = {
    keyword: "contains",
    type: "array",
    schemaType: [
        "object",
        "boolean"
    ],
    before: "uniqueItems",
    trackErrors: true,
    error: $19eb69a255f3d502$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, parentSchema: parentSchema, data: data, it: it } = cxt;
        let min;
        let max;
        const { minContains: minContains, maxContains: maxContains } = parentSchema;
        if (it.opts.next) {
            min = minContains === undefined ? 1 : minContains;
            max = maxContains;
        } else min = 1;
        const len = gen.const("len", (0, $l2ufW._)`${data}.length`);
        cxt.setParams({
            min: min,
            max: max
        });
        if (max === undefined && min === 0) {
            (0, $7eX5i.checkStrictMode)(it, `"minContains" == 0 without "maxContains": "contains" keyword ignored`);
            return;
        }
        if (max !== undefined && min > max) {
            (0, $7eX5i.checkStrictMode)(it, `"minContains" > "maxContains" is always invalid`);
            cxt.fail();
            return;
        }
        if ((0, $7eX5i.alwaysValidSchema)(it, schema)) {
            let cond = (0, $l2ufW._)`${len} >= ${min}`;
            if (max !== undefined) cond = (0, $l2ufW._)`${cond} && ${len} <= ${max}`;
            cxt.pass(cond);
            return;
        }
        it.items = true;
        const valid = gen.name("valid");
        if (max === undefined && min === 1) validateItems(valid, ()=>gen.if(valid, ()=>gen.break()));
        else if (min === 0) {
            gen.let(valid, true);
            if (max !== undefined) gen.if((0, $l2ufW._)`${data}.length > 0`, validateItemsWithCount);
        } else {
            gen.let(valid, false);
            validateItemsWithCount();
        }
        cxt.result(valid, ()=>cxt.reset());
        function validateItemsWithCount() {
            const schValid = gen.name("_valid");
            const count = gen.let("count", 0);
            validateItems(schValid, ()=>gen.if(schValid, ()=>checkLimits(count)));
        }
        function validateItems(_valid, block) {
            gen.forRange("i", 0, len, (i)=>{
                cxt.subschema({
                    keyword: "contains",
                    dataProp: i,
                    dataPropType: $7eX5i.Type.Num,
                    compositeRule: true
                }, _valid);
                block();
            });
        }
        function checkLimits(count) {
            gen.code((0, $l2ufW._)`${count}++`);
            if (max === undefined) gen.if((0, $l2ufW._)`${count} >= ${min}`, ()=>gen.assign(valid, true).break());
            else {
                gen.if((0, $l2ufW._)`${count} > ${max}`, ()=>gen.assign(valid, false).break());
                if (min === 1) gen.assign(valid, true);
                else gen.if((0, $l2ufW._)`${count} >= ${min}`, ()=>gen.assign(valid, true));
            }
        }
    }
};
module.exports.default = $19eb69a255f3d502$var$def;

});

parcelRegister("ksuYJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateSchemaDeps = module.exports.validatePropertyDeps = module.exports.error = void 0;

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");

var $7unnO = parcelRequire("7unnO");
module.exports.error = {
    message: ({ params: { property: property, depsCount: depsCount, deps: deps } })=>{
        const property_ies = depsCount === 1 ? "property" : "properties";
        return (0, $l2ufW.str)`must have ${property_ies} ${deps} when property ${property} is present`;
    },
    params: ({ params: { property: property, depsCount: depsCount, deps: deps, missingProperty: missingProperty } })=>(0, $l2ufW._)`{property: ${property},
    missingProperty: ${missingProperty},
    depsCount: ${depsCount},
    deps: ${deps}}`
};
const $ee4e73e135a0dc71$var$def = {
    keyword: "dependencies",
    type: "object",
    schemaType: "object",
    error: module.exports.error,
    code (cxt) {
        const [propDeps, schDeps] = $ee4e73e135a0dc71$var$splitDependencies(cxt);
        $ee4e73e135a0dc71$var$validatePropertyDeps(cxt, propDeps);
        $ee4e73e135a0dc71$var$validateSchemaDeps(cxt, schDeps);
    }
};
function $ee4e73e135a0dc71$var$splitDependencies({ schema: schema }) {
    const propertyDeps = {};
    const schemaDeps = {};
    for(const key in schema){
        if (key === "__proto__") continue;
        const deps = Array.isArray(schema[key]) ? propertyDeps : schemaDeps;
        deps[key] = schema[key];
    }
    return [
        propertyDeps,
        schemaDeps
    ];
}
function $ee4e73e135a0dc71$var$validatePropertyDeps(cxt, propertyDeps = cxt.schema) {
    const { gen: gen, data: data, it: it } = cxt;
    if (Object.keys(propertyDeps).length === 0) return;
    const missing = gen.let("missing");
    for(const prop in propertyDeps){
        const deps = propertyDeps[prop];
        if (deps.length === 0) continue;
        const hasProperty = (0, $7unnO.propertyInData)(gen, data, prop, it.opts.ownProperties);
        cxt.setParams({
            property: prop,
            depsCount: deps.length,
            deps: deps.join(", ")
        });
        if (it.allErrors) gen.if(hasProperty, ()=>{
            for (const depProp of deps)(0, $7unnO.checkReportMissingProp)(cxt, depProp);
        });
        else {
            gen.if((0, $l2ufW._)`${hasProperty} && (${(0, $7unnO.checkMissingProp)(cxt, deps, missing)})`);
            (0, $7unnO.reportMissingProp)(cxt, missing);
            gen.else();
        }
    }
}
module.exports.validatePropertyDeps = $ee4e73e135a0dc71$var$validatePropertyDeps;
function $ee4e73e135a0dc71$var$validateSchemaDeps(cxt, schemaDeps = cxt.schema) {
    const { gen: gen, data: data, keyword: keyword, it: it } = cxt;
    const valid = gen.name("valid");
    for(const prop in schemaDeps){
        if ((0, $7eX5i.alwaysValidSchema)(it, schemaDeps[prop])) continue;
        gen.if((0, $7unnO.propertyInData)(gen, data, prop, it.opts.ownProperties), ()=>{
            const schCxt = cxt.subschema({
                keyword: keyword,
                schemaProp: prop
            }, valid);
            cxt.mergeValidEvaluated(schCxt, valid);
        }, ()=>gen.var(valid, true) // TODO var
        );
        cxt.ok(valid);
    }
}
module.exports.validateSchemaDeps = $ee4e73e135a0dc71$var$validateSchemaDeps;
module.exports.default = $ee4e73e135a0dc71$var$def;

});

parcelRegister("bXp0l", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");
const $8b4899c22aaf5c4d$var$error = {
    message: "property name must be valid",
    params: ({ params: params })=>(0, $l2ufW._)`{propertyName: ${params.propertyName}}`
};
const $8b4899c22aaf5c4d$var$def = {
    keyword: "propertyNames",
    type: "object",
    schemaType: [
        "object",
        "boolean"
    ],
    error: $8b4899c22aaf5c4d$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, data: data, it: it } = cxt;
        if ((0, $7eX5i.alwaysValidSchema)(it, schema)) return;
        const valid = gen.name("valid");
        gen.forIn("key", data, (key)=>{
            cxt.setParams({
                propertyName: key
            });
            cxt.subschema({
                keyword: "propertyNames",
                data: key,
                dataTypes: [
                    "string"
                ],
                propertyName: key,
                compositeRule: true
            }, valid);
            gen.if((0, $l2ufW.not)(valid), ()=>{
                cxt.error(true);
                if (!it.allErrors) gen.break();
            });
        });
        cxt.ok(valid);
    }
};
module.exports.default = $8b4899c22aaf5c4d$var$def;

});

parcelRegister("8Wg07", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7unnO = parcelRequire("7unnO");

var $l2ufW = parcelRequire("l2ufW");

var $dOpvc = parcelRequire("dOpvc");

var $7eX5i = parcelRequire("7eX5i");
const $682026f44715605d$var$error = {
    message: "must NOT have additional properties",
    params: ({ params: params })=>(0, $l2ufW._)`{additionalProperty: ${params.additionalProperty}}`
};
const $682026f44715605d$var$def = {
    keyword: "additionalProperties",
    type: [
        "object"
    ],
    schemaType: [
        "boolean",
        "object"
    ],
    allowUndefined: true,
    trackErrors: true,
    error: $682026f44715605d$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, parentSchema: parentSchema, data: data, errsCount: errsCount, it: it } = cxt;
        /* istanbul ignore if */ if (!errsCount) throw new Error("ajv implementation error");
        const { allErrors: allErrors, opts: opts } = it;
        it.props = true;
        if (opts.removeAdditional !== "all" && (0, $7eX5i.alwaysValidSchema)(it, schema)) return;
        const props = (0, $7unnO.allSchemaProperties)(parentSchema.properties);
        const patProps = (0, $7unnO.allSchemaProperties)(parentSchema.patternProperties);
        checkAdditionalProperties();
        cxt.ok((0, $l2ufW._)`${errsCount} === ${$dOpvc.default.errors}`);
        function checkAdditionalProperties() {
            gen.forIn("key", data, (key)=>{
                if (!props.length && !patProps.length) additionalPropertyCode(key);
                else gen.if(isAdditional(key), ()=>additionalPropertyCode(key));
            });
        }
        function isAdditional(key) {
            let definedProp;
            if (props.length > 8) {
                // TODO maybe an option instead of hard-coded 8?
                const propsSchema = (0, $7eX5i.schemaRefOrVal)(it, parentSchema.properties, "properties");
                definedProp = (0, $7unnO.isOwnProperty)(gen, propsSchema, key);
            } else if (props.length) definedProp = (0, $l2ufW.or)(...props.map((p)=>(0, $l2ufW._)`${key} === ${p}`));
            else definedProp = $l2ufW.nil;
            if (patProps.length) definedProp = (0, $l2ufW.or)(definedProp, ...patProps.map((p)=>(0, $l2ufW._)`${(0, $7unnO.usePattern)(cxt, p)}.test(${key})`));
            return (0, $l2ufW.not)(definedProp);
        }
        function deleteAdditional(key) {
            gen.code((0, $l2ufW._)`delete ${data}[${key}]`);
        }
        function additionalPropertyCode(key) {
            if (opts.removeAdditional === "all" || opts.removeAdditional && schema === false) {
                deleteAdditional(key);
                return;
            }
            if (schema === false) {
                cxt.setParams({
                    additionalProperty: key
                });
                cxt.error();
                if (!allErrors) gen.break();
                return;
            }
            if (typeof schema == "object" && !(0, $7eX5i.alwaysValidSchema)(it, schema)) {
                const valid = gen.name("valid");
                if (opts.removeAdditional === "failing") {
                    applyAdditionalSchema(key, valid, false);
                    gen.if((0, $l2ufW.not)(valid), ()=>{
                        cxt.reset();
                        deleteAdditional(key);
                    });
                } else {
                    applyAdditionalSchema(key, valid);
                    if (!allErrors) gen.if((0, $l2ufW.not)(valid), ()=>gen.break());
                }
            }
        }
        function applyAdditionalSchema(key, valid, errors) {
            const subschema = {
                keyword: "additionalProperties",
                dataProp: key,
                dataPropType: $7eX5i.Type.Str
            };
            if (errors === false) Object.assign(subschema, {
                compositeRule: true,
                createErrors: false,
                allErrors: false
            });
            cxt.subschema(subschema, valid);
        }
    }
};
module.exports.default = $682026f44715605d$var$def;

});

parcelRegister("iBNsK", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $9hgV1 = parcelRequire("9hgV1");

var $7unnO = parcelRequire("7unnO");

var $7eX5i = parcelRequire("7eX5i");

var $8Wg07 = parcelRequire("8Wg07");
const $d8c20cf8939dcc93$var$def = {
    keyword: "properties",
    type: "object",
    schemaType: "object",
    code (cxt) {
        const { gen: gen, schema: schema, parentSchema: parentSchema, data: data, it: it } = cxt;
        if (it.opts.removeAdditional === "all" && parentSchema.additionalProperties === undefined) $8Wg07.default.code(new $9hgV1.KeywordCxt(it, $8Wg07.default, "additionalProperties"));
        const allProps = (0, $7unnO.allSchemaProperties)(schema);
        for (const prop of allProps)it.definedProperties.add(prop);
        if (it.opts.unevaluated && allProps.length && it.props !== true) it.props = $7eX5i.mergeEvaluated.props(gen, (0, $7eX5i.toHash)(allProps), it.props);
        const properties = allProps.filter((p)=>!(0, $7eX5i.alwaysValidSchema)(it, schema[p]));
        if (properties.length === 0) return;
        const valid = gen.name("valid");
        for (const prop of properties){
            if (hasDefault(prop)) applyPropertySchema(prop);
            else {
                gen.if((0, $7unnO.propertyInData)(gen, data, prop, it.opts.ownProperties));
                applyPropertySchema(prop);
                if (!it.allErrors) gen.else().var(valid, true);
                gen.endIf();
            }
            cxt.it.definedProperties.add(prop);
            cxt.ok(valid);
        }
        function hasDefault(prop) {
            return it.opts.useDefaults && !it.compositeRule && schema[prop].default !== undefined;
        }
        function applyPropertySchema(prop) {
            cxt.subschema({
                keyword: "properties",
                schemaProp: prop,
                dataProp: prop
            }, valid);
        }
    }
};
module.exports.default = $d8c20cf8939dcc93$var$def;

});

parcelRegister("eSOrH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7unnO = parcelRequire("7unnO");

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");

var $7eX5i = parcelRequire("7eX5i");
const $ad5d3d4f26070f68$var$def = {
    keyword: "patternProperties",
    type: "object",
    schemaType: "object",
    code (cxt) {
        const { gen: gen, schema: schema, data: data, parentSchema: parentSchema, it: it } = cxt;
        const { opts: opts } = it;
        const patterns = (0, $7unnO.allSchemaProperties)(schema);
        const alwaysValidPatterns = patterns.filter((p)=>(0, $7eX5i.alwaysValidSchema)(it, schema[p]));
        if (patterns.length === 0 || alwaysValidPatterns.length === patterns.length && (!it.opts.unevaluated || it.props === true)) return;
        const checkProperties = opts.strictSchema && !opts.allowMatchingProperties && parentSchema.properties;
        const valid = gen.name("valid");
        if (it.props !== true && !(it.props instanceof $l2ufW.Name)) it.props = (0, $7eX5i.evaluatedPropsToName)(gen, it.props);
        const { props: props } = it;
        validatePatternProperties();
        function validatePatternProperties() {
            for (const pat of patterns){
                if (checkProperties) checkMatchingProperties(pat);
                if (it.allErrors) validateProperties(pat);
                else {
                    gen.var(valid, true); // TODO var
                    validateProperties(pat);
                    gen.if(valid);
                }
            }
        }
        function checkMatchingProperties(pat) {
            for(const prop in checkProperties)if (new RegExp(pat).test(prop)) (0, $7eX5i.checkStrictMode)(it, `property ${prop} matches pattern ${pat} (use allowMatchingProperties)`);
        }
        function validateProperties(pat) {
            gen.forIn("key", data, (key)=>{
                gen.if((0, $l2ufW._)`${(0, $7unnO.usePattern)(cxt, pat)}.test(${key})`, ()=>{
                    const alwaysValid = alwaysValidPatterns.includes(pat);
                    if (!alwaysValid) cxt.subschema({
                        keyword: "patternProperties",
                        schemaProp: pat,
                        dataProp: key,
                        dataPropType: $7eX5i.Type.Str
                    }, valid);
                    if (it.opts.unevaluated && props !== true) gen.assign((0, $l2ufW._)`${props}[${key}]`, true);
                    else if (!alwaysValid && !it.allErrors) // can short-circuit if `unevaluatedProperties` is not supported (opts.next === false)
                    // or if all properties were evaluated (props === true)
                    gen.if((0, $l2ufW.not)(valid), ()=>gen.break());
                });
            });
        }
    }
};
module.exports.default = $ad5d3d4f26070f68$var$def;

});

parcelRegister("62Mii", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7eX5i = parcelRequire("7eX5i");
const $46686429bf9656cd$var$def = {
    keyword: "not",
    schemaType: [
        "object",
        "boolean"
    ],
    trackErrors: true,
    code (cxt) {
        const { gen: gen, schema: schema, it: it } = cxt;
        if ((0, $7eX5i.alwaysValidSchema)(it, schema)) {
            cxt.fail();
            return;
        }
        const valid = gen.name("valid");
        cxt.subschema({
            keyword: "not",
            compositeRule: true,
            createErrors: false,
            allErrors: false
        }, valid);
        cxt.failResult(valid, ()=>cxt.reset(), ()=>cxt.error());
    },
    error: {
        message: "must NOT be valid"
    }
};
module.exports.default = $46686429bf9656cd$var$def;

});

parcelRegister("d3kOu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7unnO = parcelRequire("7unnO");
const $980bb340f96346f4$var$def = {
    keyword: "anyOf",
    schemaType: "array",
    trackErrors: true,
    code: $7unnO.validateUnion,
    error: {
        message: "must match a schema in anyOf"
    }
};
module.exports.default = $980bb340f96346f4$var$def;

});

parcelRegister("gC5PA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");
const $c184b7de888f90fb$var$error = {
    message: "must match exactly one schema in oneOf",
    params: ({ params: params })=>(0, $l2ufW._)`{passingSchemas: ${params.passing}}`
};
const $c184b7de888f90fb$var$def = {
    keyword: "oneOf",
    schemaType: "array",
    trackErrors: true,
    error: $c184b7de888f90fb$var$error,
    code (cxt) {
        const { gen: gen, schema: schema, parentSchema: parentSchema, it: it } = cxt;
        /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
        if (it.opts.discriminator && parentSchema.discriminator) return;
        const schArr = schema;
        const valid = gen.let("valid", false);
        const passing = gen.let("passing", null);
        const schValid = gen.name("_valid");
        cxt.setParams({
            passing: passing
        });
        // TODO possibly fail straight away (with warning or exception) if there are two empty always valid schemas
        gen.block(validateOneOf);
        cxt.result(valid, ()=>cxt.reset(), ()=>cxt.error(true));
        function validateOneOf() {
            schArr.forEach((sch, i)=>{
                let schCxt;
                if ((0, $7eX5i.alwaysValidSchema)(it, sch)) gen.var(schValid, true);
                else schCxt = cxt.subschema({
                    keyword: "oneOf",
                    schemaProp: i,
                    compositeRule: true
                }, schValid);
                if (i > 0) gen.if((0, $l2ufW._)`${schValid} && ${valid}`).assign(valid, false).assign(passing, (0, $l2ufW._)`[${passing}, ${i}]`).else();
                gen.if(schValid, ()=>{
                    gen.assign(valid, true);
                    gen.assign(passing, i);
                    if (schCxt) cxt.mergeEvaluated(schCxt, $l2ufW.Name);
                });
            });
        }
    }
};
module.exports.default = $c184b7de888f90fb$var$def;

});

parcelRegister("fhXQa", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7eX5i = parcelRequire("7eX5i");
const $b216dc95106535e4$var$def = {
    keyword: "allOf",
    schemaType: "array",
    code (cxt) {
        const { gen: gen, schema: schema, it: it } = cxt;
        /* istanbul ignore if */ if (!Array.isArray(schema)) throw new Error("ajv implementation error");
        const valid = gen.name("valid");
        schema.forEach((sch, i)=>{
            if ((0, $7eX5i.alwaysValidSchema)(it, sch)) return;
            const schCxt = cxt.subschema({
                keyword: "allOf",
                schemaProp: i
            }, valid);
            cxt.ok(valid);
            cxt.mergeEvaluated(schCxt);
        });
    }
};
module.exports.default = $b216dc95106535e4$var$def;

});

parcelRegister("jfpXQ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l2ufW = parcelRequire("l2ufW");

var $7eX5i = parcelRequire("7eX5i");
const $e0338efb54c30e45$var$error = {
    message: ({ params: params })=>(0, $l2ufW.str)`must match "${params.ifClause}" schema`,
    params: ({ params: params })=>(0, $l2ufW._)`{failingKeyword: ${params.ifClause}}`
};
const $e0338efb54c30e45$var$def = {
    keyword: "if",
    schemaType: [
        "object",
        "boolean"
    ],
    trackErrors: true,
    error: $e0338efb54c30e45$var$error,
    code (cxt) {
        const { gen: gen, parentSchema: parentSchema, it: it } = cxt;
        if (parentSchema.then === undefined && parentSchema.else === undefined) (0, $7eX5i.checkStrictMode)(it, '"if" without "then" and "else" is ignored');
        const hasThen = $e0338efb54c30e45$var$hasSchema(it, "then");
        const hasElse = $e0338efb54c30e45$var$hasSchema(it, "else");
        if (!hasThen && !hasElse) return;
        const valid = gen.let("valid", true);
        const schValid = gen.name("_valid");
        validateIf();
        cxt.reset();
        if (hasThen && hasElse) {
            const ifClause = gen.let("ifClause");
            cxt.setParams({
                ifClause: ifClause
            });
            gen.if(schValid, validateClause("then", ifClause), validateClause("else", ifClause));
        } else if (hasThen) gen.if(schValid, validateClause("then"));
        else gen.if((0, $l2ufW.not)(schValid), validateClause("else"));
        cxt.pass(valid, ()=>cxt.error(true));
        function validateIf() {
            const schCxt = cxt.subschema({
                keyword: "if",
                compositeRule: true,
                createErrors: false,
                allErrors: false
            }, schValid);
            cxt.mergeEvaluated(schCxt);
        }
        function validateClause(keyword, ifClause) {
            return ()=>{
                const schCxt = cxt.subschema({
                    keyword: keyword
                }, schValid);
                gen.assign(valid, schValid);
                cxt.mergeValidEvaluated(schCxt, valid);
                if (ifClause) gen.assign(ifClause, (0, $l2ufW._)`${keyword}`);
                else cxt.setParams({
                    ifClause: keyword
                });
            };
        }
    }
};
function $e0338efb54c30e45$var$hasSchema(it, keyword) {
    const schema = it.schema[keyword];
    return schema !== undefined && !(0, $7eX5i.alwaysValidSchema)(it, schema);
}
module.exports.default = $e0338efb54c30e45$var$def;

});

parcelRegister("5HS6k", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7eX5i = parcelRequire("7eX5i");
const $427aef3e960393f3$var$def = {
    keyword: [
        "then",
        "else"
    ],
    schemaType: [
        "object",
        "boolean"
    ],
    code ({ keyword: keyword, parentSchema: parentSchema, it: it }) {
        if (parentSchema.if === undefined) (0, $7eX5i.checkStrictMode)(it, `"${keyword}" without "if" is ignored`);
    }
};
module.exports.default = $427aef3e960393f3$var$def;

});


parcelRegister("kLdb8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $k9lk2 = parcelRequire("k9lk2");
const $f1d26b70ddc76007$var$format = [
    $k9lk2.default
];
module.exports.default = $f1d26b70ddc76007$var$format;

});
parcelRegister("k9lk2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l2ufW = parcelRequire("l2ufW");
const $eab5300bdea14c03$var$error = {
    message: ({ schemaCode: schemaCode })=>(0, $l2ufW.str)`must match format "${schemaCode}"`,
    params: ({ schemaCode: schemaCode })=>(0, $l2ufW._)`{format: ${schemaCode}}`
};
const $eab5300bdea14c03$var$def = {
    keyword: "format",
    type: [
        "number",
        "string"
    ],
    schemaType: "string",
    $data: true,
    error: $eab5300bdea14c03$var$error,
    code (cxt, ruleType) {
        const { gen: gen, data: data, $data: $data, schema: schema, schemaCode: schemaCode, it: it } = cxt;
        const { opts: opts, errSchemaPath: errSchemaPath, schemaEnv: schemaEnv, self: self } = it;
        if (!opts.validateFormats) return;
        if ($data) validate$DataFormat();
        else validateFormat();
        function validate$DataFormat() {
            const fmts = gen.scopeValue("formats", {
                ref: self.formats,
                code: opts.code.formats
            });
            const fDef = gen.const("fDef", (0, $l2ufW._)`${fmts}[${schemaCode}]`);
            const fType = gen.let("fType");
            const format = gen.let("format");
            // TODO simplify
            gen.if((0, $l2ufW._)`typeof ${fDef} == "object" && !(${fDef} instanceof RegExp)`, ()=>gen.assign(fType, (0, $l2ufW._)`${fDef}.type || "string"`).assign(format, (0, $l2ufW._)`${fDef}.validate`), ()=>gen.assign(fType, (0, $l2ufW._)`"string"`).assign(format, fDef));
            cxt.fail$data((0, $l2ufW.or)(unknownFmt(), invalidFmt()));
            function unknownFmt() {
                if (opts.strictSchema === false) return $l2ufW.nil;
                return (0, $l2ufW._)`${schemaCode} && !${format}`;
            }
            function invalidFmt() {
                const callFormat = schemaEnv.$async ? (0, $l2ufW._)`(${fDef}.async ? await ${format}(${data}) : ${format}(${data}))` : (0, $l2ufW._)`${format}(${data})`;
                const validData = (0, $l2ufW._)`(typeof ${format} == "function" ? ${callFormat} : ${format}.test(${data}))`;
                return (0, $l2ufW._)`${format} && ${format} !== true && ${fType} === ${ruleType} && !${validData}`;
            }
        }
        function validateFormat() {
            const formatDef = self.formats[schema];
            if (!formatDef) {
                unknownFormat();
                return;
            }
            if (formatDef === true) return;
            const [fmtType, format, fmtRef] = getFormat(formatDef);
            if (fmtType === ruleType) cxt.pass(validCondition());
            function unknownFormat() {
                if (opts.strictSchema === false) {
                    self.logger.warn(unknownMsg());
                    return;
                }
                throw new Error(unknownMsg());
                function unknownMsg() {
                    return `unknown format "${schema}" ignored in schema at path "${errSchemaPath}"`;
                }
            }
            function getFormat(fmtDef) {
                const code = fmtDef instanceof RegExp ? (0, $l2ufW.regexpCode)(fmtDef) : opts.code.formats ? (0, $l2ufW._)`${opts.code.formats}${(0, $l2ufW.getProperty)(schema)}` : undefined;
                const fmt = gen.scopeValue("formats", {
                    key: schema,
                    ref: fmtDef,
                    code: code
                });
                if (typeof fmtDef == "object" && !(fmtDef instanceof RegExp)) return [
                    fmtDef.type || "string",
                    fmtDef.validate,
                    (0, $l2ufW._)`${fmt}.validate`
                ];
                return [
                    "string",
                    fmtDef,
                    fmt
                ];
            }
            function validCondition() {
                if (typeof formatDef == "object" && !(formatDef instanceof RegExp) && formatDef.async) {
                    if (!schemaEnv.$async) throw new Error("async format in sync schema");
                    return (0, $l2ufW._)`await ${fmtRef}(${data})`;
                }
                return typeof format == "function" ? (0, $l2ufW._)`${fmtRef}(${data})` : (0, $l2ufW._)`${fmtRef}.test(${data})`;
            }
        }
    }
};
module.exports.default = $eab5300bdea14c03$var$def;

});


parcelRegister("koD8T", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.contentVocabulary = module.exports.metadataVocabulary = void 0;
module.exports.metadataVocabulary = [
    "title",
    "description",
    "default",
    "deprecated",
    "readOnly",
    "writeOnly",
    "examples"
];
module.exports.contentVocabulary = [
    "contentMediaType",
    "contentEncoding",
    "contentSchema"
];

});


parcelRegister("81ULr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $l2ufW = parcelRequire("l2ufW");

var $6x7md = parcelRequire("6x7md");

var $jstQR = parcelRequire("jstQR");

var $euTEo = parcelRequire("euTEo");

var $7eX5i = parcelRequire("7eX5i");
const $5d8a72e3f593aa35$var$error = {
    message: ({ params: { discrError: discrError, tagName: tagName } })=>discrError === $6x7md.DiscrError.Tag ? `tag "${tagName}" must be string` : `value of tag "${tagName}" must be in oneOf`,
    params: ({ params: { discrError: discrError, tag: tag, tagName: tagName } })=>(0, $l2ufW._)`{error: ${discrError}, tag: ${tagName}, tagValue: ${tag}}`
};
const $5d8a72e3f593aa35$var$def = {
    keyword: "discriminator",
    type: "object",
    schemaType: "object",
    error: $5d8a72e3f593aa35$var$error,
    code (cxt) {
        const { gen: gen, data: data, schema: schema, parentSchema: parentSchema, it: it } = cxt;
        const { oneOf: oneOf } = parentSchema;
        if (!it.opts.discriminator) throw new Error("discriminator: requires discriminator option");
        const tagName = schema.propertyName;
        if (typeof tagName != "string") throw new Error("discriminator: requires propertyName");
        if (schema.mapping) throw new Error("discriminator: mapping is not supported");
        if (!oneOf) throw new Error("discriminator: requires oneOf keyword");
        const valid = gen.let("valid", false);
        const tag = gen.const("tag", (0, $l2ufW._)`${data}${(0, $l2ufW.getProperty)(tagName)}`);
        gen.if((0, $l2ufW._)`typeof ${tag} == "string"`, ()=>validateMapping(), ()=>cxt.error(false, {
                discrError: $6x7md.DiscrError.Tag,
                tag: tag,
                tagName: tagName
            }));
        cxt.ok(valid);
        function validateMapping() {
            const mapping = getMapping();
            gen.if(false);
            for(const tagValue in mapping){
                gen.elseIf((0, $l2ufW._)`${tag} === ${tagValue}`);
                gen.assign(valid, applyTagSchema(mapping[tagValue]));
            }
            gen.else();
            cxt.error(false, {
                discrError: $6x7md.DiscrError.Mapping,
                tag: tag,
                tagName: tagName
            });
            gen.endIf();
        }
        function applyTagSchema(schemaProp) {
            const _valid = gen.name("valid");
            const schCxt = cxt.subschema({
                keyword: "oneOf",
                schemaProp: schemaProp
            }, _valid);
            cxt.mergeEvaluated(schCxt, $l2ufW.Name);
            return _valid;
        }
        function getMapping() {
            var _a;
            const oneOfMapping = {};
            const topRequired = hasRequired(parentSchema);
            let tagRequired = true;
            for(let i = 0; i < oneOf.length; i++){
                let sch = oneOf[i];
                if ((sch === null || sch === void 0 ? void 0 : sch.$ref) && !(0, $7eX5i.schemaHasRulesButRef)(sch, it.self.RULES)) {
                    const ref = sch.$ref;
                    sch = $jstQR.resolveRef.call(it.self, it.schemaEnv.root, it.baseId, ref);
                    if (sch instanceof $jstQR.SchemaEnv) sch = sch.schema;
                    if (sch === undefined) throw new $euTEo.default(it.opts.uriResolver, it.baseId, ref);
                }
                const propSch = (_a = sch === null || sch === void 0 ? void 0 : sch.properties) === null || _a === void 0 ? void 0 : _a[tagName];
                if (typeof propSch != "object") throw new Error(`discriminator: oneOf subschemas (or referenced schemas) must have "properties/${tagName}"`);
                tagRequired = tagRequired && (topRequired || hasRequired(sch));
                addMappings(propSch, i);
            }
            if (!tagRequired) throw new Error(`discriminator: "${tagName}" must be required`);
            return oneOfMapping;
            function hasRequired({ required: required }) {
                return Array.isArray(required) && required.includes(tagName);
            }
            function addMappings(sch, i) {
                if (sch.const) addMapping(sch.const, i);
                else if (sch.enum) for (const tagValue of sch.enum)addMapping(tagValue, i);
                else throw new Error(`discriminator: "properties/${tagName}" must have "const" or "enum"`);
            }
            function addMapping(tagValue, i) {
                if (typeof tagValue != "string" || tagValue in oneOfMapping) throw new Error(`discriminator: "${tagName}" values must be unique strings`);
                oneOfMapping[tagValue] = i;
            }
        }
    }
};
module.exports.default = $5d8a72e3f593aa35$var$def;

});
parcelRegister("6x7md", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DiscrError = void 0;
var $4c1b8829d2a29cc7$var$DiscrError;
(function(DiscrError) {
    DiscrError["Tag"] = "tag";
    DiscrError["Mapping"] = "mapping";
})($4c1b8829d2a29cc7$var$DiscrError || (module.exports.DiscrError = $4c1b8829d2a29cc7$var$DiscrError = {}));

});


parcelRegister("BbyF4", function(module, exports) {
module.exports = JSON.parse("{\"$schema\":\"http://json-schema.org/draft-07/schema#\",\"$id\":\"http://json-schema.org/draft-07/schema#\",\"title\":\"Core schema meta-schema\",\"definitions\":{\"schemaArray\":{\"type\":\"array\",\"minItems\":1,\"items\":{\"$ref\":\"#\"}},\"nonNegativeInteger\":{\"type\":\"integer\",\"minimum\":0},\"nonNegativeIntegerDefault0\":{\"allOf\":[{\"$ref\":\"#/definitions/nonNegativeInteger\"},{\"default\":0}]},\"simpleTypes\":{\"enum\":[\"array\",\"boolean\",\"integer\",\"null\",\"number\",\"object\",\"string\"]},\"stringArray\":{\"type\":\"array\",\"items\":{\"type\":\"string\"},\"uniqueItems\":true,\"default\":[]}},\"type\":[\"object\",\"boolean\"],\"properties\":{\"$id\":{\"type\":\"string\",\"format\":\"uri-reference\"},\"$schema\":{\"type\":\"string\",\"format\":\"uri\"},\"$ref\":{\"type\":\"string\",\"format\":\"uri-reference\"},\"$comment\":{\"type\":\"string\"},\"title\":{\"type\":\"string\"},\"description\":{\"type\":\"string\"},\"default\":true,\"readOnly\":{\"type\":\"boolean\",\"default\":false},\"examples\":{\"type\":\"array\",\"items\":true},\"multipleOf\":{\"type\":\"number\",\"exclusiveMinimum\":0},\"maximum\":{\"type\":\"number\"},\"exclusiveMaximum\":{\"type\":\"number\"},\"minimum\":{\"type\":\"number\"},\"exclusiveMinimum\":{\"type\":\"number\"},\"maxLength\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minLength\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"pattern\":{\"type\":\"string\",\"format\":\"regex\"},\"additionalItems\":{\"$ref\":\"#\"},\"items\":{\"anyOf\":[{\"$ref\":\"#\"},{\"$ref\":\"#/definitions/schemaArray\"}],\"default\":true},\"maxItems\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minItems\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"uniqueItems\":{\"type\":\"boolean\",\"default\":false},\"contains\":{\"$ref\":\"#\"},\"maxProperties\":{\"$ref\":\"#/definitions/nonNegativeInteger\"},\"minProperties\":{\"$ref\":\"#/definitions/nonNegativeIntegerDefault0\"},\"required\":{\"$ref\":\"#/definitions/stringArray\"},\"additionalProperties\":{\"$ref\":\"#\"},\"definitions\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"properties\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"default\":{}},\"patternProperties\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#\"},\"propertyNames\":{\"format\":\"regex\"},\"default\":{}},\"dependencies\":{\"type\":\"object\",\"additionalProperties\":{\"anyOf\":[{\"$ref\":\"#\"},{\"$ref\":\"#/definitions/stringArray\"}]}},\"propertyNames\":{\"$ref\":\"#\"},\"const\":true,\"enum\":{\"type\":\"array\",\"items\":true,\"minItems\":1,\"uniqueItems\":true},\"type\":{\"anyOf\":[{\"$ref\":\"#/definitions/simpleTypes\"},{\"type\":\"array\",\"items\":{\"$ref\":\"#/definitions/simpleTypes\"},\"minItems\":1,\"uniqueItems\":true}]},\"format\":{\"type\":\"string\"},\"contentMediaType\":{\"type\":\"string\"},\"contentEncoding\":{\"type\":\"string\"},\"if\":{\"$ref\":\"#\"},\"then\":{\"$ref\":\"#\"},\"else\":{\"$ref\":\"#\"},\"allOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"anyOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"oneOf\":{\"$ref\":\"#/definitions/schemaArray\"},\"not\":{\"$ref\":\"#\"}},\"default\":true}");

});


parcelRegister("sBxfj", function(module, exports) {

$parcel$export(module.exports, "renderToNodeStream", () => $055fbb5a82eb5281$export$307591e98609eddd, (v) => $055fbb5a82eb5281$export$307591e98609eddd = v);
$parcel$export(module.exports, "renderToStaticMarkup", () => $055fbb5a82eb5281$export$eb3a06aef9e6ee51, (v) => $055fbb5a82eb5281$export$eb3a06aef9e6ee51 = v);
$parcel$export(module.exports, "renderToStaticNodeStream", () => $055fbb5a82eb5281$export$b23711c915539651, (v) => $055fbb5a82eb5281$export$b23711c915539651 = v);
$parcel$export(module.exports, "renderToString", () => $055fbb5a82eb5281$export$80e7718417253a51, (v) => $055fbb5a82eb5281$export$80e7718417253a51 = v);
$parcel$export(module.exports, "version", () => $055fbb5a82eb5281$export$83d89fbfd8236492, (v) => $055fbb5a82eb5281$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-server-legacy.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $055fbb5a82eb5281$export$307591e98609eddd;
var $055fbb5a82eb5281$export$eb3a06aef9e6ee51;
var $055fbb5a82eb5281$export$b23711c915539651;
var $055fbb5a82eb5281$export$80e7718417253a51;
var $055fbb5a82eb5281$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");
function $055fbb5a82eb5281$var$l(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $055fbb5a82eb5281$var$p = Object.prototype.hasOwnProperty, $055fbb5a82eb5281$var$fa = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $055fbb5a82eb5281$var$ha = {}, $055fbb5a82eb5281$var$ia = {};
function $055fbb5a82eb5281$var$ja(a) {
    if ($055fbb5a82eb5281$var$p.call($055fbb5a82eb5281$var$ia, a)) return !0;
    if ($055fbb5a82eb5281$var$p.call($055fbb5a82eb5281$var$ha, a)) return !1;
    if ($055fbb5a82eb5281$var$fa.test(a)) return $055fbb5a82eb5281$var$ia[a] = !0;
    $055fbb5a82eb5281$var$ha[a] = !0;
    return !1;
}
function $055fbb5a82eb5281$var$r(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $055fbb5a82eb5281$var$t = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $055fbb5a82eb5281$var$t[b] = new $055fbb5a82eb5281$var$r(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $055fbb5a82eb5281$var$ka = /[\-:]([a-z])/g;
function $055fbb5a82eb5281$var$la(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($055fbb5a82eb5281$var$ka, $055fbb5a82eb5281$var$la);
    $055fbb5a82eb5281$var$t[b] = new $055fbb5a82eb5281$var$r(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($055fbb5a82eb5281$var$ka, $055fbb5a82eb5281$var$la);
    $055fbb5a82eb5281$var$t[b] = new $055fbb5a82eb5281$var$r(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($055fbb5a82eb5281$var$ka, $055fbb5a82eb5281$var$la);
    $055fbb5a82eb5281$var$t[b] = new $055fbb5a82eb5281$var$r(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$055fbb5a82eb5281$var$t.xlinkHref = new $055fbb5a82eb5281$var$r("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $055fbb5a82eb5281$var$t[a] = new $055fbb5a82eb5281$var$r(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $055fbb5a82eb5281$var$u = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $055fbb5a82eb5281$var$ma = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($055fbb5a82eb5281$var$u).forEach(function(a) {
    $055fbb5a82eb5281$var$ma.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $055fbb5a82eb5281$var$u[b] = $055fbb5a82eb5281$var$u[a];
    });
});
var $055fbb5a82eb5281$var$na = /["'&<>]/;
function $055fbb5a82eb5281$var$v(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $055fbb5a82eb5281$var$na.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $055fbb5a82eb5281$var$oa = /([A-Z])/g, $055fbb5a82eb5281$var$pa = /^ms-/, $055fbb5a82eb5281$var$qa = Array.isArray;
function $055fbb5a82eb5281$var$w(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $055fbb5a82eb5281$var$ra(a, b, c) {
    switch(b){
        case "select":
            return $055fbb5a82eb5281$var$w(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $055fbb5a82eb5281$var$w(2, null);
        case "math":
            return $055fbb5a82eb5281$var$w(3, null);
        case "foreignObject":
            return $055fbb5a82eb5281$var$w(1, null);
        case "table":
            return $055fbb5a82eb5281$var$w(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $055fbb5a82eb5281$var$w(5, null);
        case "colgroup":
            return $055fbb5a82eb5281$var$w(7, null);
        case "tr":
            return $055fbb5a82eb5281$var$w(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $055fbb5a82eb5281$var$w(1, null) : a;
}
var $055fbb5a82eb5281$var$sa = new Map;
function $055fbb5a82eb5281$var$ta(a, b, c) {
    if ("object" !== typeof c) throw Error($055fbb5a82eb5281$var$l(62));
    b = !0;
    for(var d in c)if ($055fbb5a82eb5281$var$p.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $055fbb5a82eb5281$var$v(d);
                f = $055fbb5a82eb5281$var$v(("" + f).trim());
            } else {
                e = d;
                var g = $055fbb5a82eb5281$var$sa.get(e);
                void 0 !== g ? e = g : (g = $055fbb5a82eb5281$var$v(e.replace($055fbb5a82eb5281$var$oa, "-$1").toLowerCase().replace($055fbb5a82eb5281$var$pa, "-ms-")), $055fbb5a82eb5281$var$sa.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $055fbb5a82eb5281$var$p.call($055fbb5a82eb5281$var$u, d) ? "" + f : f + "px" : $055fbb5a82eb5281$var$v(("" + f).trim());
            }
            b ? (b = !1, a.push(' style="', e, ":", f)) : a.push(";", e, ":", f);
        }
    }
    b || a.push('"');
}
function $055fbb5a82eb5281$var$x(a, b, c, d) {
    switch(c){
        case "style":
            $055fbb5a82eb5281$var$ta(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $055fbb5a82eb5281$var$t.hasOwnProperty(c) ? $055fbb5a82eb5281$var$t[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = b.attributeName;
            switch(b.type){
                case 3:
                    d && a.push(" ", c, '=""');
                    break;
                case 4:
                    !0 === d ? a.push(" ", c, '=""') : !1 !== d && a.push(" ", c, '="', $055fbb5a82eb5281$var$v(d), '"');
                    break;
                case 5:
                    isNaN(d) || a.push(" ", c, '="', $055fbb5a82eb5281$var$v(d), '"');
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push(" ", c, '="', $055fbb5a82eb5281$var$v(d), '"');
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push(" ", c, '="', $055fbb5a82eb5281$var$v(d), '"');
            }
        } else if ($055fbb5a82eb5281$var$ja(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push(" ", c, '="', $055fbb5a82eb5281$var$v(d), '"');
        }
    }
}
function $055fbb5a82eb5281$var$y(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($055fbb5a82eb5281$var$l(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($055fbb5a82eb5281$var$l(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push("" + b);
    }
}
function $055fbb5a82eb5281$var$ua(a) {
    var b = "";
    $acw62.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
function $055fbb5a82eb5281$var$va(a, b, c, d) {
    a.push($055fbb5a82eb5281$var$A(c));
    var f = c = null, e;
    for(e in b)if ($055fbb5a82eb5281$var$p.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $055fbb5a82eb5281$var$x(a, d, e, g);
        }
    }
    a.push(">");
    $055fbb5a82eb5281$var$y(a, f, c);
    return "string" === typeof c ? (a.push($055fbb5a82eb5281$var$v(c)), null) : c;
}
var $055fbb5a82eb5281$var$wa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $055fbb5a82eb5281$var$xa = new Map;
function $055fbb5a82eb5281$var$A(a) {
    var b = $055fbb5a82eb5281$var$xa.get(a);
    if (void 0 === b) {
        if (!$055fbb5a82eb5281$var$wa.test(a)) throw Error($055fbb5a82eb5281$var$l(65, a));
        b = "<" + a;
        $055fbb5a82eb5281$var$xa.set(a, b);
    }
    return b;
}
function $055fbb5a82eb5281$var$ya(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($055fbb5a82eb5281$var$A("select"));
            var e = null, g = null;
            for(n in c)if ($055fbb5a82eb5281$var$p.call(c, n)) {
                var h = c[n];
                if (null != h) switch(n){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $055fbb5a82eb5281$var$x(a, d, n, h);
                }
            }
            a.push(">");
            $055fbb5a82eb5281$var$y(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($055fbb5a82eb5281$var$A("option"));
            var k = h = null, m = null;
            var n = null;
            for(e in c)if ($055fbb5a82eb5281$var$p.call(c, e)) {
                var q = c[e];
                if (null != q) switch(e){
                    case "children":
                        h = q;
                        break;
                    case "selected":
                        m = q;
                        break;
                    case "dangerouslySetInnerHTML":
                        n = q;
                        break;
                    case "value":
                        k = q;
                    default:
                        $055fbb5a82eb5281$var$x(a, d, e, q);
                }
            }
            if (null != g) {
                if (c = null !== k ? "" + k : $055fbb5a82eb5281$var$ua(h), $055fbb5a82eb5281$var$qa(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push(' selected=""');
                        break;
                    }
                } else "" + g === c && a.push(' selected=""');
            } else m && a.push(' selected=""');
            a.push(">");
            $055fbb5a82eb5281$var$y(a, n, h);
            return h;
        case "textarea":
            a.push($055fbb5a82eb5281$var$A("textarea"));
            n = g = e = null;
            for(h in c)if ($055fbb5a82eb5281$var$p.call(c, h) && (k = c[h], null != k)) switch(h){
                case "children":
                    n = k;
                    break;
                case "value":
                    e = k;
                    break;
                case "defaultValue":
                    g = k;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($055fbb5a82eb5281$var$l(91));
                default:
                    $055fbb5a82eb5281$var$x(a, d, h, k);
            }
            null === e && null !== g && (e = g);
            a.push(">");
            if (null != n) {
                if (null != e) throw Error($055fbb5a82eb5281$var$l(92));
                if ($055fbb5a82eb5281$var$qa(n) && 1 < n.length) throw Error($055fbb5a82eb5281$var$l(93));
                e = "" + n;
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            null !== e && a.push($055fbb5a82eb5281$var$v("" + e));
            return null;
        case "input":
            a.push($055fbb5a82eb5281$var$A("input"));
            k = n = h = e = null;
            for(g in c)if ($055fbb5a82eb5281$var$p.call(c, g) && (m = c[g], null != m)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($055fbb5a82eb5281$var$l(399, "input"));
                case "defaultChecked":
                    k = m;
                    break;
                case "defaultValue":
                    h = m;
                    break;
                case "checked":
                    n = m;
                    break;
                case "value":
                    e = m;
                    break;
                default:
                    $055fbb5a82eb5281$var$x(a, d, g, m);
            }
            null !== n ? $055fbb5a82eb5281$var$x(a, d, "checked", n) : null !== k && $055fbb5a82eb5281$var$x(a, d, "checked", k);
            null !== e ? $055fbb5a82eb5281$var$x(a, d, "value", e) : null !== h && $055fbb5a82eb5281$var$x(a, d, "value", h);
            a.push("/>");
            return null;
        case "menuitem":
            a.push($055fbb5a82eb5281$var$A("menuitem"));
            for(var C in c)if ($055fbb5a82eb5281$var$p.call(c, C) && (e = c[C], null != e)) switch(C){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($055fbb5a82eb5281$var$l(400));
                default:
                    $055fbb5a82eb5281$var$x(a, d, C, e);
            }
            a.push(">");
            return null;
        case "title":
            a.push($055fbb5a82eb5281$var$A("title"));
            e = null;
            for(q in c)if ($055fbb5a82eb5281$var$p.call(c, q) && (g = c[q], null != g)) switch(q){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($055fbb5a82eb5281$var$l(434));
                default:
                    $055fbb5a82eb5281$var$x(a, d, q, g);
            }
            a.push(">");
            return e;
        case "listing":
        case "pre":
            a.push($055fbb5a82eb5281$var$A(b));
            g = e = null;
            for(k in c)if ($055fbb5a82eb5281$var$p.call(c, k) && (h = c[k], null != h)) switch(k){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $055fbb5a82eb5281$var$x(a, d, k, h);
            }
            a.push(">");
            if (null != g) {
                if (null != e) throw Error($055fbb5a82eb5281$var$l(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($055fbb5a82eb5281$var$l(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push("\n", c) : a.push("" + c));
            }
            "string" === typeof e && "\n" === e[0] && a.push("\n");
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($055fbb5a82eb5281$var$A(b));
            for(var D in c)if ($055fbb5a82eb5281$var$p.call(c, D) && (e = c[D], null != e)) switch(D){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($055fbb5a82eb5281$var$l(399, b));
                default:
                    $055fbb5a82eb5281$var$x(a, d, D, e);
            }
            a.push("/>");
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $055fbb5a82eb5281$var$va(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push("<!DOCTYPE html>"), $055fbb5a82eb5281$var$va(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $055fbb5a82eb5281$var$va(a, c, b, d);
            a.push($055fbb5a82eb5281$var$A(b));
            g = e = null;
            for(m in c)if ($055fbb5a82eb5281$var$p.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $055fbb5a82eb5281$var$ta(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $055fbb5a82eb5281$var$ja(m) && "function" !== typeof h && "symbol" !== typeof h && a.push(" ", m, '="', $055fbb5a82eb5281$var$v(h), '"');
            }
            a.push(">");
            $055fbb5a82eb5281$var$y(a, g, e);
            return e;
    }
}
function $055fbb5a82eb5281$var$za(a, b, c) {
    a.push('\x3c!--$?--\x3e<template id="');
    if (null === c) throw Error($055fbb5a82eb5281$var$l(395));
    a.push(c);
    return a.push('"></template>');
}
function $055fbb5a82eb5281$var$Aa(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return a.push('<div hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 2:
            return a.push('<svg aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 3:
            return a.push('<math aria-hidden="true" style="display:none" id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 4:
            return a.push('<table hidden id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 5:
            return a.push('<table hidden><tbody id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 6:
            return a.push('<table hidden><tr id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        case 7:
            return a.push('<table hidden><colgroup id="'), a.push(b.segmentPrefix), b = d.toString(16), a.push(b), a.push('">');
        default:
            throw Error($055fbb5a82eb5281$var$l(397));
    }
}
function $055fbb5a82eb5281$var$Ba(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return a.push("</div>");
        case 2:
            return a.push("</svg>");
        case 3:
            return a.push("</math>");
        case 4:
            return a.push("</table>");
        case 5:
            return a.push("</tbody></table>");
        case 6:
            return a.push("</tr></table>");
        case 7:
            return a.push("</colgroup></table>");
        default:
            throw Error($055fbb5a82eb5281$var$l(397));
    }
}
var $055fbb5a82eb5281$var$Ca = /[<\u2028\u2029]/g;
function $055fbb5a82eb5281$var$Da(a) {
    return JSON.stringify(a).replace($055fbb5a82eb5281$var$Ca, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
function $055fbb5a82eb5281$var$Ea(a, b) {
    b = void 0 === b ? "" : b;
    return {
        bootstrapChunks: [],
        startInlineScript: "<script>",
        placeholderPrefix: b + "P:",
        segmentPrefix: b + "S:",
        boundaryPrefix: b + "B:",
        idPrefix: b,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1,
        generateStaticMarkup: a
    };
}
function $055fbb5a82eb5281$var$Fa(a, b, c, d) {
    if (c.generateStaticMarkup) return a.push($055fbb5a82eb5281$var$v(b)), !1;
    "" === b ? a = d : (d && a.push("\x3c!-- --\x3e"), a.push($055fbb5a82eb5281$var$v(b)), a = !0);
    return a;
}
var $055fbb5a82eb5281$var$B = Object.assign, $055fbb5a82eb5281$var$Ga = Symbol.for("react.element"), $055fbb5a82eb5281$var$Ha = Symbol.for("react.portal"), $055fbb5a82eb5281$var$Ia = Symbol.for("react.fragment"), $055fbb5a82eb5281$var$Ja = Symbol.for("react.strict_mode"), $055fbb5a82eb5281$var$Ka = Symbol.for("react.profiler"), $055fbb5a82eb5281$var$La = Symbol.for("react.provider"), $055fbb5a82eb5281$var$Ma = Symbol.for("react.context"), $055fbb5a82eb5281$var$Na = Symbol.for("react.forward_ref"), $055fbb5a82eb5281$var$Oa = Symbol.for("react.suspense"), $055fbb5a82eb5281$var$Pa = Symbol.for("react.suspense_list"), $055fbb5a82eb5281$var$Qa = Symbol.for("react.memo"), $055fbb5a82eb5281$var$Ra = Symbol.for("react.lazy"), $055fbb5a82eb5281$var$Sa = Symbol.for("react.scope"), $055fbb5a82eb5281$var$Ta = Symbol.for("react.debug_trace_mode"), $055fbb5a82eb5281$var$Ua = Symbol.for("react.legacy_hidden"), $055fbb5a82eb5281$var$Va = Symbol.for("react.default_value"), $055fbb5a82eb5281$var$Wa = Symbol.iterator;
function $055fbb5a82eb5281$var$Xa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $055fbb5a82eb5281$var$Ia:
            return "Fragment";
        case $055fbb5a82eb5281$var$Ha:
            return "Portal";
        case $055fbb5a82eb5281$var$Ka:
            return "Profiler";
        case $055fbb5a82eb5281$var$Ja:
            return "StrictMode";
        case $055fbb5a82eb5281$var$Oa:
            return "Suspense";
        case $055fbb5a82eb5281$var$Pa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $055fbb5a82eb5281$var$Ma:
            return (a.displayName || "Context") + ".Consumer";
        case $055fbb5a82eb5281$var$La:
            return (a._context.displayName || "Context") + ".Provider";
        case $055fbb5a82eb5281$var$Na:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $055fbb5a82eb5281$var$Qa:
            return b = a.displayName || null, null !== b ? b : $055fbb5a82eb5281$var$Xa(a.type) || "Memo";
        case $055fbb5a82eb5281$var$Ra:
            b = a._payload;
            a = a._init;
            try {
                return $055fbb5a82eb5281$var$Xa(a(b));
            } catch (c) {}
    }
    return null;
}
var $055fbb5a82eb5281$var$Ya = {};
function $055fbb5a82eb5281$var$Za(a, b) {
    a = a.contextTypes;
    if (!a) return $055fbb5a82eb5281$var$Ya;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $055fbb5a82eb5281$var$E = null;
function $055fbb5a82eb5281$var$F(a, b) {
    if (a !== b) {
        a.context._currentValue2 = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($055fbb5a82eb5281$var$l(401));
        } else {
            if (null === c) throw Error($055fbb5a82eb5281$var$l(401));
            $055fbb5a82eb5281$var$F(a, c);
        }
        b.context._currentValue2 = b.value;
    }
}
function $055fbb5a82eb5281$var$$a(a) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    null !== a && $055fbb5a82eb5281$var$$a(a);
}
function $055fbb5a82eb5281$var$ab(a) {
    var b = a.parent;
    null !== b && $055fbb5a82eb5281$var$ab(b);
    a.context._currentValue2 = a.value;
}
function $055fbb5a82eb5281$var$bb(a, b) {
    a.context._currentValue2 = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($055fbb5a82eb5281$var$l(402));
    a.depth === b.depth ? $055fbb5a82eb5281$var$F(a, b) : $055fbb5a82eb5281$var$bb(a, b);
}
function $055fbb5a82eb5281$var$cb(a, b) {
    var c = b.parent;
    if (null === c) throw Error($055fbb5a82eb5281$var$l(402));
    a.depth === c.depth ? $055fbb5a82eb5281$var$F(a, c) : $055fbb5a82eb5281$var$cb(a, c);
    b.context._currentValue2 = b.value;
}
function $055fbb5a82eb5281$var$G(a) {
    var b = $055fbb5a82eb5281$var$E;
    b !== a && (null === b ? $055fbb5a82eb5281$var$ab(a) : null === a ? $055fbb5a82eb5281$var$$a(b) : b.depth === a.depth ? $055fbb5a82eb5281$var$F(b, a) : b.depth > a.depth ? $055fbb5a82eb5281$var$bb(b, a) : $055fbb5a82eb5281$var$cb(b, a), $055fbb5a82eb5281$var$E = a);
}
var $055fbb5a82eb5281$var$db = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $055fbb5a82eb5281$var$eb(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $055fbb5a82eb5281$var$db;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue2 : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $055fbb5a82eb5281$var$B({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $055fbb5a82eb5281$var$db.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $055fbb5a82eb5281$var$B({}, e, h)) : $055fbb5a82eb5281$var$B(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $055fbb5a82eb5281$var$fb = {
    id: 1,
    overflow: ""
};
function $055fbb5a82eb5281$var$gb(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $055fbb5a82eb5281$var$H(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $055fbb5a82eb5281$var$H(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $055fbb5a82eb5281$var$H(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $055fbb5a82eb5281$var$H = Math.clz32 ? Math.clz32 : $055fbb5a82eb5281$var$hb, $055fbb5a82eb5281$var$ib = Math.log, $055fbb5a82eb5281$var$jb = Math.LN2;
function $055fbb5a82eb5281$var$hb(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($055fbb5a82eb5281$var$ib(a) / $055fbb5a82eb5281$var$jb | 0) | 0;
}
function $055fbb5a82eb5281$var$kb(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $055fbb5a82eb5281$var$lb = "function" === typeof Object.is ? Object.is : $055fbb5a82eb5281$var$kb, $055fbb5a82eb5281$var$I = null, $055fbb5a82eb5281$var$ob = null, $055fbb5a82eb5281$var$J = null, $055fbb5a82eb5281$var$K = null, $055fbb5a82eb5281$var$L = !1, $055fbb5a82eb5281$var$M = !1, $055fbb5a82eb5281$var$N = 0, $055fbb5a82eb5281$var$O = null, $055fbb5a82eb5281$var$P = 0;
function $055fbb5a82eb5281$var$Q() {
    if (null === $055fbb5a82eb5281$var$I) throw Error($055fbb5a82eb5281$var$l(321));
    return $055fbb5a82eb5281$var$I;
}
function $055fbb5a82eb5281$var$pb() {
    if (0 < $055fbb5a82eb5281$var$P) throw Error($055fbb5a82eb5281$var$l(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $055fbb5a82eb5281$var$qb() {
    null === $055fbb5a82eb5281$var$K ? null === $055fbb5a82eb5281$var$J ? ($055fbb5a82eb5281$var$L = !1, $055fbb5a82eb5281$var$J = $055fbb5a82eb5281$var$K = $055fbb5a82eb5281$var$pb()) : ($055fbb5a82eb5281$var$L = !0, $055fbb5a82eb5281$var$K = $055fbb5a82eb5281$var$J) : null === $055fbb5a82eb5281$var$K.next ? ($055fbb5a82eb5281$var$L = !1, $055fbb5a82eb5281$var$K = $055fbb5a82eb5281$var$K.next = $055fbb5a82eb5281$var$pb()) : ($055fbb5a82eb5281$var$L = !0, $055fbb5a82eb5281$var$K = $055fbb5a82eb5281$var$K.next);
    return $055fbb5a82eb5281$var$K;
}
function $055fbb5a82eb5281$var$rb() {
    $055fbb5a82eb5281$var$ob = $055fbb5a82eb5281$var$I = null;
    $055fbb5a82eb5281$var$M = !1;
    $055fbb5a82eb5281$var$J = null;
    $055fbb5a82eb5281$var$P = 0;
    $055fbb5a82eb5281$var$K = $055fbb5a82eb5281$var$O = null;
}
function $055fbb5a82eb5281$var$sb(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $055fbb5a82eb5281$var$tb(a, b, c) {
    $055fbb5a82eb5281$var$I = $055fbb5a82eb5281$var$Q();
    $055fbb5a82eb5281$var$K = $055fbb5a82eb5281$var$qb();
    if ($055fbb5a82eb5281$var$L) {
        var d = $055fbb5a82eb5281$var$K.queue;
        b = d.dispatch;
        if (null !== $055fbb5a82eb5281$var$O && (c = $055fbb5a82eb5281$var$O.get(d), void 0 !== c)) {
            $055fbb5a82eb5281$var$O.delete(d);
            d = $055fbb5a82eb5281$var$K.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $055fbb5a82eb5281$var$K.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $055fbb5a82eb5281$var$K.memoizedState,
            b
        ];
    }
    a = a === $055fbb5a82eb5281$var$sb ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $055fbb5a82eb5281$var$K.memoizedState = a;
    a = $055fbb5a82eb5281$var$K.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $055fbb5a82eb5281$var$ub.bind(null, $055fbb5a82eb5281$var$I, a);
    return [
        $055fbb5a82eb5281$var$K.memoizedState,
        a
    ];
}
function $055fbb5a82eb5281$var$vb(a, b) {
    $055fbb5a82eb5281$var$I = $055fbb5a82eb5281$var$Q();
    $055fbb5a82eb5281$var$K = $055fbb5a82eb5281$var$qb();
    b = void 0 === b ? null : b;
    if (null !== $055fbb5a82eb5281$var$K) {
        var c = $055fbb5a82eb5281$var$K.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$055fbb5a82eb5281$var$lb(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $055fbb5a82eb5281$var$K.memoizedState = [
        a,
        b
    ];
    return a;
}
function $055fbb5a82eb5281$var$ub(a, b, c) {
    if (25 <= $055fbb5a82eb5281$var$P) throw Error($055fbb5a82eb5281$var$l(301));
    if (a === $055fbb5a82eb5281$var$I) {
        if ($055fbb5a82eb5281$var$M = !0, a = {
            action: c,
            next: null
        }, null === $055fbb5a82eb5281$var$O && ($055fbb5a82eb5281$var$O = new Map), c = $055fbb5a82eb5281$var$O.get(b), void 0 === c) $055fbb5a82eb5281$var$O.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $055fbb5a82eb5281$var$wb() {
    throw Error($055fbb5a82eb5281$var$l(394));
}
function $055fbb5a82eb5281$var$R() {}
var $055fbb5a82eb5281$var$xb = {
    readContext: function(a) {
        return a._currentValue2;
    },
    useContext: function(a) {
        $055fbb5a82eb5281$var$Q();
        return a._currentValue2;
    },
    useMemo: $055fbb5a82eb5281$var$vb,
    useReducer: $055fbb5a82eb5281$var$tb,
    useRef: function(a) {
        $055fbb5a82eb5281$var$I = $055fbb5a82eb5281$var$Q();
        $055fbb5a82eb5281$var$K = $055fbb5a82eb5281$var$qb();
        var b = $055fbb5a82eb5281$var$K.memoizedState;
        return null === b ? (a = {
            current: a
        }, $055fbb5a82eb5281$var$K.memoizedState = a) : b;
    },
    useState: function(a) {
        return $055fbb5a82eb5281$var$tb($055fbb5a82eb5281$var$sb, a);
    },
    useInsertionEffect: $055fbb5a82eb5281$var$R,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $055fbb5a82eb5281$var$vb(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $055fbb5a82eb5281$var$R,
    useEffect: $055fbb5a82eb5281$var$R,
    useDebugValue: $055fbb5a82eb5281$var$R,
    useDeferredValue: function(a) {
        $055fbb5a82eb5281$var$Q();
        return a;
    },
    useTransition: function() {
        $055fbb5a82eb5281$var$Q();
        return [
            !1,
            $055fbb5a82eb5281$var$wb
        ];
    },
    useId: function() {
        var a = $055fbb5a82eb5281$var$ob.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $055fbb5a82eb5281$var$H(a) - 1)).toString(32) + b;
        var c = $055fbb5a82eb5281$var$S;
        if (null === c) throw Error($055fbb5a82eb5281$var$l(404));
        b = $055fbb5a82eb5281$var$N++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $055fbb5a82eb5281$var$Q();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($055fbb5a82eb5281$var$l(407));
        return c();
    }
}, $055fbb5a82eb5281$var$S = null, $055fbb5a82eb5281$var$yb = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $055fbb5a82eb5281$var$zb(a) {
    console.error(a);
    return null;
}
function $055fbb5a82eb5281$var$T() {}
function $055fbb5a82eb5281$var$Ab(a, b, c, d, f, e, g, h, k) {
    var m = [], n = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: n,
        pingedTasks: m,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $055fbb5a82eb5281$var$zb : f,
        onAllReady: void 0 === e ? $055fbb5a82eb5281$var$T : e,
        onShellReady: void 0 === g ? $055fbb5a82eb5281$var$T : g,
        onShellError: void 0 === h ? $055fbb5a82eb5281$var$T : h,
        onFatalError: void 0 === k ? $055fbb5a82eb5281$var$T : k
    };
    c = $055fbb5a82eb5281$var$U(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $055fbb5a82eb5281$var$Bb(b, a, null, c, n, $055fbb5a82eb5281$var$Ya, null, $055fbb5a82eb5281$var$fb);
    m.push(a);
    return b;
}
function $055fbb5a82eb5281$var$Bb(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var k = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(k);
            1 === b.length && $055fbb5a82eb5281$var$Cb(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(k);
    return k;
}
function $055fbb5a82eb5281$var$U(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $055fbb5a82eb5281$var$V(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $055fbb5a82eb5281$var$W(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, a.destination.destroy(b)) : (a.status = 1, a.fatalError = b);
}
function $055fbb5a82eb5281$var$Db(a, b, c, d, f) {
    $055fbb5a82eb5281$var$I = {};
    $055fbb5a82eb5281$var$ob = b;
    $055fbb5a82eb5281$var$N = 0;
    for(a = c(d, f); $055fbb5a82eb5281$var$M;)$055fbb5a82eb5281$var$M = !1, $055fbb5a82eb5281$var$N = 0, $055fbb5a82eb5281$var$P += 1, $055fbb5a82eb5281$var$K = null, a = c(d, f);
    $055fbb5a82eb5281$var$rb();
    return a;
}
function $055fbb5a82eb5281$var$Eb(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($055fbb5a82eb5281$var$l(108, $055fbb5a82eb5281$var$Xa(d) || "Unknown", h));
            d = $055fbb5a82eb5281$var$B({}, g, c);
        }
        b.legacyContext = d;
        $055fbb5a82eb5281$var$X(a, b, f);
        b.legacyContext = g;
    } else $055fbb5a82eb5281$var$X(a, b, f);
}
function $055fbb5a82eb5281$var$Fb(a, b) {
    if (a && a.defaultProps) {
        b = $055fbb5a82eb5281$var$B({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $055fbb5a82eb5281$var$Gb(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $055fbb5a82eb5281$var$Za(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue2 : f);
            $055fbb5a82eb5281$var$eb(e, c, d, f);
            $055fbb5a82eb5281$var$Eb(a, b, e, c);
        } else {
            e = $055fbb5a82eb5281$var$Za(c, b.legacyContext);
            f = $055fbb5a82eb5281$var$Db(a, b, c, d, e);
            var g = 0 !== $055fbb5a82eb5281$var$N;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $055fbb5a82eb5281$var$eb(f, c, d, e), $055fbb5a82eb5281$var$Eb(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $055fbb5a82eb5281$var$gb(d, 1, 0);
                try {
                    $055fbb5a82eb5281$var$X(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $055fbb5a82eb5281$var$X(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $055fbb5a82eb5281$var$ya(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $055fbb5a82eb5281$var$ra(g, c, d);
        $055fbb5a82eb5281$var$Hb(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push("</", c, ">");
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $055fbb5a82eb5281$var$Ua:
            case $055fbb5a82eb5281$var$Ta:
            case $055fbb5a82eb5281$var$Ja:
            case $055fbb5a82eb5281$var$Ka:
            case $055fbb5a82eb5281$var$Ia:
                $055fbb5a82eb5281$var$X(a, b, d.children);
                return;
            case $055fbb5a82eb5281$var$Pa:
                $055fbb5a82eb5281$var$X(a, b, d.children);
                return;
            case $055fbb5a82eb5281$var$Sa:
                throw Error($055fbb5a82eb5281$var$l(343));
            case $055fbb5a82eb5281$var$Oa:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, k = $055fbb5a82eb5281$var$U(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(k);
                    f.lastPushedText = !1;
                    var m = $055fbb5a82eb5281$var$U(a, 0, null, f.formatContext, !1, !1);
                    m.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = m;
                    try {
                        if ($055fbb5a82eb5281$var$Hb(a, b, d), a.responseState.generateStaticMarkup || m.lastPushedText && m.textEmbedded && m.chunks.push("\x3c!-- --\x3e"), m.status = 1, $055fbb5a82eb5281$var$Y(h, m), 0 === h.pendingTasks) break a;
                    } catch (n) {
                        m.status = 4, h.forceClientRender = !0, h.errorDigest = $055fbb5a82eb5281$var$V(a, n);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $055fbb5a82eb5281$var$Bb(a, e, c, k, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $055fbb5a82eb5281$var$Na:
                d = $055fbb5a82eb5281$var$Db(a, b, c.render, d, f);
                if (0 !== $055fbb5a82eb5281$var$N) {
                    c = b.treeContext;
                    b.treeContext = $055fbb5a82eb5281$var$gb(c, 1, 0);
                    try {
                        $055fbb5a82eb5281$var$X(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $055fbb5a82eb5281$var$X(a, b, d);
                return;
            case $055fbb5a82eb5281$var$Qa:
                c = c.type;
                d = $055fbb5a82eb5281$var$Fb(c, d);
                $055fbb5a82eb5281$var$Gb(a, b, c, d, f);
                return;
            case $055fbb5a82eb5281$var$La:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue2;
                c._currentValue2 = d;
                g = $055fbb5a82eb5281$var$E;
                $055fbb5a82eb5281$var$E = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $055fbb5a82eb5281$var$X(a, b, f);
                a = $055fbb5a82eb5281$var$E;
                if (null === a) throw Error($055fbb5a82eb5281$var$l(403));
                d = a.parentValue;
                a.context._currentValue2 = d === $055fbb5a82eb5281$var$Va ? a.context._defaultValue : d;
                a = $055fbb5a82eb5281$var$E = a.parent;
                b.context = a;
                return;
            case $055fbb5a82eb5281$var$Ma:
                d = d.children;
                d = d(c._currentValue2);
                $055fbb5a82eb5281$var$X(a, b, d);
                return;
            case $055fbb5a82eb5281$var$Ra:
                f = c._init;
                c = f(c._payload);
                d = $055fbb5a82eb5281$var$Fb(c, d);
                $055fbb5a82eb5281$var$Gb(a, b, c, d, void 0);
                return;
        }
        throw Error($055fbb5a82eb5281$var$l(130, null == c ? c : typeof c, ""));
    }
}
function $055fbb5a82eb5281$var$X(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $055fbb5a82eb5281$var$Ga:
                $055fbb5a82eb5281$var$Gb(a, b, c.type, c.props, c.ref);
                return;
            case $055fbb5a82eb5281$var$Ha:
                throw Error($055fbb5a82eb5281$var$l(257));
            case $055fbb5a82eb5281$var$Ra:
                var d = c._init;
                c = d(c._payload);
                $055fbb5a82eb5281$var$X(a, b, c);
                return;
        }
        if ($055fbb5a82eb5281$var$qa(c)) {
            $055fbb5a82eb5281$var$Ib(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $055fbb5a82eb5281$var$Wa && c[$055fbb5a82eb5281$var$Wa] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $055fbb5a82eb5281$var$Ib(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($055fbb5a82eb5281$var$l(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $055fbb5a82eb5281$var$Fa(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $055fbb5a82eb5281$var$Fa(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $055fbb5a82eb5281$var$Ib(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $055fbb5a82eb5281$var$gb(e, d, f);
        try {
            $055fbb5a82eb5281$var$Hb(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $055fbb5a82eb5281$var$Hb(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $055fbb5a82eb5281$var$X(a, b, c);
    } catch (k) {
        if ($055fbb5a82eb5281$var$rb(), "object" === typeof k && null !== k && "function" === typeof k.then) {
            c = k;
            var g = b.blockedSegment, h = $055fbb5a82eb5281$var$U(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $055fbb5a82eb5281$var$Bb(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $055fbb5a82eb5281$var$G(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $055fbb5a82eb5281$var$G(e), k;
    }
}
function $055fbb5a82eb5281$var$Jb(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $055fbb5a82eb5281$var$Kb(this, b, a);
}
function $055fbb5a82eb5281$var$Lb(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.push(null))) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($055fbb5a82eb5281$var$l(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $055fbb5a82eb5281$var$Lb(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $055fbb5a82eb5281$var$Y(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $055fbb5a82eb5281$var$Y(a, c);
    } else a.completedSegments.push(b);
}
function $055fbb5a82eb5281$var$Kb(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($055fbb5a82eb5281$var$l(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $055fbb5a82eb5281$var$T, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $055fbb5a82eb5281$var$Y(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($055fbb5a82eb5281$var$Jb, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($055fbb5a82eb5281$var$Y(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $055fbb5a82eb5281$var$Cb(a) {
    if (2 !== a.status) {
        var b = $055fbb5a82eb5281$var$E, c = $055fbb5a82eb5281$var$yb.current;
        $055fbb5a82eb5281$var$yb.current = $055fbb5a82eb5281$var$xb;
        var d = $055fbb5a82eb5281$var$S;
        $055fbb5a82eb5281$var$S = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, k = g.blockedSegment;
                if (0 === k.status) {
                    $055fbb5a82eb5281$var$G(g.context);
                    try {
                        $055fbb5a82eb5281$var$X(h, g, g.node), h.responseState.generateStaticMarkup || k.lastPushedText && k.textEmbedded && k.chunks.push("\x3c!-- --\x3e"), g.abortSet.delete(g), k.status = 1, $055fbb5a82eb5281$var$Kb(h, g.blockedBoundary, k);
                    } catch (z) {
                        if ($055fbb5a82eb5281$var$rb(), "object" === typeof z && null !== z && "function" === typeof z.then) {
                            var m = g.ping;
                            z.then(m, m);
                        } else {
                            g.abortSet.delete(g);
                            k.status = 4;
                            var n = g.blockedBoundary, q = z, C = $055fbb5a82eb5281$var$V(h, q);
                            null === n ? $055fbb5a82eb5281$var$W(h, q) : (n.pendingTasks--, n.forceClientRender || (n.forceClientRender = !0, n.errorDigest = C, n.parentFlushed && h.clientRenderedBoundaries.push(n)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var D = h.onAllReady;
                                D();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $055fbb5a82eb5281$var$Mb(a, a.destination);
        } catch (z) {
            $055fbb5a82eb5281$var$V(a, z), $055fbb5a82eb5281$var$W(a, z);
        } finally{
            $055fbb5a82eb5281$var$S = d, $055fbb5a82eb5281$var$yb.current = c, c === $055fbb5a82eb5281$var$xb && $055fbb5a82eb5281$var$G(b);
        }
    }
}
function $055fbb5a82eb5281$var$Z(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            b.push('<template id="');
            b.push(a.placeholderPrefix);
            a = d.toString(16);
            b.push(a);
            return b.push('"></template>');
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)b.push(d[e]);
                f = $055fbb5a82eb5281$var$Nb(a, b, f);
            }
            for(; e < d.length - 1; e++)b.push(d[e]);
            e < d.length && (f = b.push(d[e]));
            return f;
        default:
            throw Error($055fbb5a82eb5281$var$l(390));
    }
}
function $055fbb5a82eb5281$var$Nb(a, b, c) {
    var d = c.boundary;
    if (null === d) return $055fbb5a82eb5281$var$Z(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) return a.responseState.generateStaticMarkup || (d = d.errorDigest, b.push("\x3c!--$!--\x3e"), b.push("<template"), d && (b.push(' data-dgst="'), d = $055fbb5a82eb5281$var$v(d), b.push(d), b.push('"')), b.push("></template>")), $055fbb5a82eb5281$var$Z(a, b, c), a = a.responseState.generateStaticMarkup ? !0 : b.push("\x3c!--/$--\x3e"), a;
    if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = f.boundaryPrefix + e.toString(16);
        d = d.id = f;
        $055fbb5a82eb5281$var$za(b, a.responseState, d);
        $055fbb5a82eb5281$var$Z(a, b, c);
        return b.push("\x3c!--/$--\x3e");
    }
    if (d.byteSize > a.progressiveChunkSize) return d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $055fbb5a82eb5281$var$za(b, a.responseState, d.id), $055fbb5a82eb5281$var$Z(a, b, c), b.push("\x3c!--/$--\x3e");
    a.responseState.generateStaticMarkup || b.push("\x3c!--$--\x3e");
    c = d.completedSegments;
    if (1 !== c.length) throw Error($055fbb5a82eb5281$var$l(391));
    $055fbb5a82eb5281$var$Nb(a, b, c[0]);
    a = a.responseState.generateStaticMarkup ? !0 : b.push("\x3c!--/$--\x3e");
    return a;
}
function $055fbb5a82eb5281$var$Ob(a, b, c) {
    $055fbb5a82eb5281$var$Aa(b, a.responseState, c.formatContext, c.id);
    $055fbb5a82eb5281$var$Nb(a, b, c);
    return $055fbb5a82eb5281$var$Ba(b, c.formatContext);
}
function $055fbb5a82eb5281$var$Pb(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$055fbb5a82eb5281$var$Qb(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    b.push(a.startInlineScript);
    a.sentCompleteBoundaryFunction ? b.push('$RC("') : (a.sentCompleteBoundaryFunction = !0, b.push('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'));
    if (null === d) throw Error($055fbb5a82eb5281$var$l(395));
    c = c.toString(16);
    b.push(d);
    b.push('","');
    b.push(a.segmentPrefix);
    b.push(c);
    return b.push('")\x3c/script>');
}
function $055fbb5a82eb5281$var$Qb(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($055fbb5a82eb5281$var$l(392));
        return $055fbb5a82eb5281$var$Ob(a, b, d);
    }
    $055fbb5a82eb5281$var$Ob(a, b, d);
    a = a.responseState;
    b.push(a.startInlineScript);
    a.sentCompleteSegmentFunction ? b.push('$RS("') : (a.sentCompleteSegmentFunction = !0, b.push('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'));
    b.push(a.segmentPrefix);
    f = f.toString(16);
    b.push(f);
    b.push('","');
    b.push(a.placeholderPrefix);
    b.push(f);
    return b.push('")\x3c/script>');
}
function $055fbb5a82eb5281$var$Mb(a, b) {
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $055fbb5a82eb5281$var$Nb(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)b.push(d[c]);
            c < d.length && b.push(d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, k = g.id, m = g.errorDigest, n = g.errorMessage, q = g.errorComponentStack;
            d.push(h.startInlineScript);
            h.sentClientRenderFunction ? d.push('$RX("') : (h.sentClientRenderFunction = !0, d.push('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'));
            if (null === k) throw Error($055fbb5a82eb5281$var$l(395));
            d.push(k);
            d.push('"');
            if (m || n || q) {
                d.push(",");
                var C = $055fbb5a82eb5281$var$Da(m || "");
                d.push(C);
            }
            if (n || q) {
                d.push(",");
                var D = $055fbb5a82eb5281$var$Da(n || "");
                d.push(D);
            }
            if (q) {
                d.push(",");
                var z = $055fbb5a82eb5281$var$Da(q);
                d.push(z);
            }
            if (!d.push(")\x3c/script>")) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var ba = a.completedBoundaries;
        for(e = 0; e < ba.length; e++)if (!$055fbb5a82eb5281$var$Pb(a, b, ba[e])) {
            a.destination = null;
            e++;
            ba.splice(0, e);
            return;
        }
        ba.splice(0, e);
        var ca = a.partialBoundaries;
        for(e = 0; e < ca.length; e++){
            var mb = ca[e];
            a: {
                f = a;
                g = b;
                var da = mb.completedSegments;
                for(h = 0; h < da.length; h++)if (!$055fbb5a82eb5281$var$Qb(f, g, mb, da[h])) {
                    h++;
                    da.splice(0, h);
                    var nb = !1;
                    break a;
                }
                da.splice(0, h);
                nb = !0;
            }
            if (!nb) {
                a.destination = null;
                e++;
                ca.splice(0, e);
                return;
            }
        }
        ca.splice(0, e);
        var ea = a.completedBoundaries;
        for(e = 0; e < ea.length; e++)if (!$055fbb5a82eb5281$var$Pb(a, b, ea[e])) {
            a.destination = null;
            e++;
            ea.splice(0, e);
            return;
        }
        ea.splice(0, e);
    } finally{
        0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.push(null);
    }
}
function $055fbb5a82eb5281$var$Rb(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $055fbb5a82eb5281$var$Lb(c, a, b);
        });
        c.clear();
        null !== a.destination && $055fbb5a82eb5281$var$Mb(a, a.destination);
    } catch (d) {
        $055fbb5a82eb5281$var$V(a, d), $055fbb5a82eb5281$var$W(a, d);
    }
}
function $055fbb5a82eb5281$var$Sb() {}
function $055fbb5a82eb5281$var$Tb(a, b, c, d) {
    var f = !1, e = null, g = "", h = {
        push: function(a) {
            null !== a && (g += a);
            return !0;
        },
        destroy: function(a) {
            f = !0;
            e = a;
        }
    }, k = !1;
    a = $055fbb5a82eb5281$var$Ab(a, $055fbb5a82eb5281$var$Ea(c, b ? b.identifierPrefix : void 0), {
        insertionMode: 1,
        selectedValue: null
    }, Infinity, $055fbb5a82eb5281$var$Sb, void 0, function() {
        k = !0;
    }, void 0, void 0);
    $055fbb5a82eb5281$var$Cb(a);
    $055fbb5a82eb5281$var$Rb(a, d);
    if (1 === a.status) a.status = 2, h.destroy(a.fatalError);
    else if (2 !== a.status && null === a.destination) {
        a.destination = h;
        try {
            $055fbb5a82eb5281$var$Mb(a, h);
        } catch (m) {
            $055fbb5a82eb5281$var$V(a, m), $055fbb5a82eb5281$var$W(a, m);
        }
    }
    if (f) throw e;
    if (!k) throw Error($055fbb5a82eb5281$var$l(426));
    return g;
}
$055fbb5a82eb5281$export$307591e98609eddd = function() {
    throw Error($055fbb5a82eb5281$var$l(207));
};
$055fbb5a82eb5281$export$eb3a06aef9e6ee51 = function(a, b) {
    return $055fbb5a82eb5281$var$Tb(a, b, !0, 'The server used "renderToStaticMarkup" which does not support Suspense. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$055fbb5a82eb5281$export$b23711c915539651 = function() {
    throw Error($055fbb5a82eb5281$var$l(208));
};
$055fbb5a82eb5281$export$80e7718417253a51 = function(a, b) {
    return $055fbb5a82eb5281$var$Tb(a, b, !1, 'The server used "renderToString" which does not support Suspense. If you intended for this Suspense boundary to render the fallback content on the server consider throwing an Error somewhere within the Suspense boundary. If you intended to have the server wait for the suspended component please switch to "renderToReadableStream" which supports Suspense on the server');
};
$055fbb5a82eb5281$export$83d89fbfd8236492 = "18.2.0";

});

parcelRegister("3odmW", function(module, exports) {

$parcel$export(module.exports, "renderToReadableStream", () => $277dfbc9b64034b1$export$7020a3240b287705, (v) => $277dfbc9b64034b1$export$7020a3240b287705 = v);
$parcel$export(module.exports, "version", () => $277dfbc9b64034b1$export$83d89fbfd8236492, (v) => $277dfbc9b64034b1$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-server.browser.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $277dfbc9b64034b1$export$7020a3240b287705;
var $277dfbc9b64034b1$export$83d89fbfd8236492;
'use strict';

var $acw62 = parcelRequire("acw62");
function $277dfbc9b64034b1$var$k(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $277dfbc9b64034b1$var$l = null, $277dfbc9b64034b1$var$n = 0;
function $277dfbc9b64034b1$var$p(a, b) {
    if (0 !== b.length) {
        if (512 < b.length) 0 < $277dfbc9b64034b1$var$n && (a.enqueue(new Uint8Array($277dfbc9b64034b1$var$l.buffer, 0, $277dfbc9b64034b1$var$n)), $277dfbc9b64034b1$var$l = new Uint8Array(512), $277dfbc9b64034b1$var$n = 0), a.enqueue(b);
        else {
            var c = $277dfbc9b64034b1$var$l.length - $277dfbc9b64034b1$var$n;
            c < b.length && (0 === c ? a.enqueue($277dfbc9b64034b1$var$l) : ($277dfbc9b64034b1$var$l.set(b.subarray(0, c), $277dfbc9b64034b1$var$n), a.enqueue($277dfbc9b64034b1$var$l), b = b.subarray(c)), $277dfbc9b64034b1$var$l = new Uint8Array(512), $277dfbc9b64034b1$var$n = 0);
            $277dfbc9b64034b1$var$l.set(b, $277dfbc9b64034b1$var$n);
            $277dfbc9b64034b1$var$n += b.length;
        }
    }
}
function $277dfbc9b64034b1$var$t(a, b) {
    $277dfbc9b64034b1$var$p(a, b);
    return !0;
}
function $277dfbc9b64034b1$var$ba(a) {
    $277dfbc9b64034b1$var$l && 0 < $277dfbc9b64034b1$var$n && (a.enqueue(new Uint8Array($277dfbc9b64034b1$var$l.buffer, 0, $277dfbc9b64034b1$var$n)), $277dfbc9b64034b1$var$l = null, $277dfbc9b64034b1$var$n = 0);
}
var $277dfbc9b64034b1$var$ca = new TextEncoder;
function $277dfbc9b64034b1$var$u(a) {
    return $277dfbc9b64034b1$var$ca.encode(a);
}
function $277dfbc9b64034b1$var$w(a) {
    return $277dfbc9b64034b1$var$ca.encode(a);
}
function $277dfbc9b64034b1$var$da(a, b) {
    "function" === typeof a.error ? a.error(b) : a.close();
}
var $277dfbc9b64034b1$var$x = Object.prototype.hasOwnProperty, $277dfbc9b64034b1$var$ea = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $277dfbc9b64034b1$var$fa = {}, $277dfbc9b64034b1$var$ha = {};
function $277dfbc9b64034b1$var$ia(a) {
    if ($277dfbc9b64034b1$var$x.call($277dfbc9b64034b1$var$ha, a)) return !0;
    if ($277dfbc9b64034b1$var$x.call($277dfbc9b64034b1$var$fa, a)) return !1;
    if ($277dfbc9b64034b1$var$ea.test(a)) return $277dfbc9b64034b1$var$ha[a] = !0;
    $277dfbc9b64034b1$var$fa[a] = !0;
    return !1;
}
function $277dfbc9b64034b1$var$y(a, b, c, d, f, e, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = f;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = e;
    this.removeEmptyString = g;
}
var $277dfbc9b64034b1$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $277dfbc9b64034b1$var$z[a] = new $277dfbc9b64034b1$var$y(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $277dfbc9b64034b1$var$z[b] = new $277dfbc9b64034b1$var$y(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $277dfbc9b64034b1$var$z[a] = new $277dfbc9b64034b1$var$y(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $277dfbc9b64034b1$var$z[a] = new $277dfbc9b64034b1$var$y(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $277dfbc9b64034b1$var$z[a] = new $277dfbc9b64034b1$var$y(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $277dfbc9b64034b1$var$z[a] = new $277dfbc9b64034b1$var$y(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $277dfbc9b64034b1$var$z[a] = new $277dfbc9b64034b1$var$y(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $277dfbc9b64034b1$var$z[a] = new $277dfbc9b64034b1$var$y(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $277dfbc9b64034b1$var$z[a] = new $277dfbc9b64034b1$var$y(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $277dfbc9b64034b1$var$ja = /[\-:]([a-z])/g;
function $277dfbc9b64034b1$var$ka(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($277dfbc9b64034b1$var$ja, $277dfbc9b64034b1$var$ka);
    $277dfbc9b64034b1$var$z[b] = new $277dfbc9b64034b1$var$y(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($277dfbc9b64034b1$var$ja, $277dfbc9b64034b1$var$ka);
    $277dfbc9b64034b1$var$z[b] = new $277dfbc9b64034b1$var$y(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($277dfbc9b64034b1$var$ja, $277dfbc9b64034b1$var$ka);
    $277dfbc9b64034b1$var$z[b] = new $277dfbc9b64034b1$var$y(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $277dfbc9b64034b1$var$z[a] = new $277dfbc9b64034b1$var$y(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$277dfbc9b64034b1$var$z.xlinkHref = new $277dfbc9b64034b1$var$y("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $277dfbc9b64034b1$var$z[a] = new $277dfbc9b64034b1$var$y(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
var $277dfbc9b64034b1$var$B = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $277dfbc9b64034b1$var$la = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($277dfbc9b64034b1$var$B).forEach(function(a) {
    $277dfbc9b64034b1$var$la.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $277dfbc9b64034b1$var$B[b] = $277dfbc9b64034b1$var$B[a];
    });
});
var $277dfbc9b64034b1$var$oa = /["'&<>]/;
function $277dfbc9b64034b1$var$C(a) {
    if ("boolean" === typeof a || "number" === typeof a) return "" + a;
    a = "" + a;
    var b = $277dfbc9b64034b1$var$oa.exec(a);
    if (b) {
        var c = "", d, f = 0;
        for(d = b.index; d < a.length; d++){
            switch(a.charCodeAt(d)){
                case 34:
                    b = "&quot;";
                    break;
                case 38:
                    b = "&amp;";
                    break;
                case 39:
                    b = "&#x27;";
                    break;
                case 60:
                    b = "&lt;";
                    break;
                case 62:
                    b = "&gt;";
                    break;
                default:
                    continue;
            }
            f !== d && (c += a.substring(f, d));
            f = d + 1;
            c += b;
        }
        a = f !== d ? c + a.substring(f, d) : c;
    }
    return a;
}
var $277dfbc9b64034b1$var$pa = /([A-Z])/g, $277dfbc9b64034b1$var$qa = /^ms-/, $277dfbc9b64034b1$var$ra = Array.isArray, $277dfbc9b64034b1$var$sa = $277dfbc9b64034b1$var$w("<script>"), $277dfbc9b64034b1$var$ta = $277dfbc9b64034b1$var$w("\x3c/script>"), $277dfbc9b64034b1$var$ua = $277dfbc9b64034b1$var$w('<script src="'), $277dfbc9b64034b1$var$va = $277dfbc9b64034b1$var$w('<script type="module" src="'), $277dfbc9b64034b1$var$wa = $277dfbc9b64034b1$var$w('" async="">\x3c/script>'), $277dfbc9b64034b1$var$xa = /(<\/|<)(s)(cript)/gi;
function $277dfbc9b64034b1$var$ya(a, b, c, d) {
    return "" + b + ("s" === c ? "\\u0073" : "\\u0053") + d;
}
function $277dfbc9b64034b1$var$za(a, b, c, d, f) {
    a = void 0 === a ? "" : a;
    b = void 0 === b ? $277dfbc9b64034b1$var$sa : $277dfbc9b64034b1$var$w('<script nonce="' + $277dfbc9b64034b1$var$C(b) + '">');
    var e = [];
    void 0 !== c && e.push(b, $277dfbc9b64034b1$var$u(("" + c).replace($277dfbc9b64034b1$var$xa, $277dfbc9b64034b1$var$ya)), $277dfbc9b64034b1$var$ta);
    if (void 0 !== d) for(c = 0; c < d.length; c++)e.push($277dfbc9b64034b1$var$ua, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(d[c])), $277dfbc9b64034b1$var$wa);
    if (void 0 !== f) for(d = 0; d < f.length; d++)e.push($277dfbc9b64034b1$var$va, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(f[d])), $277dfbc9b64034b1$var$wa);
    return {
        bootstrapChunks: e,
        startInlineScript: b,
        placeholderPrefix: $277dfbc9b64034b1$var$w(a + "P:"),
        segmentPrefix: $277dfbc9b64034b1$var$w(a + "S:"),
        boundaryPrefix: a + "B:",
        idPrefix: a,
        nextSuspenseID: 0,
        sentCompleteSegmentFunction: !1,
        sentCompleteBoundaryFunction: !1,
        sentClientRenderFunction: !1
    };
}
function $277dfbc9b64034b1$var$D(a, b) {
    return {
        insertionMode: a,
        selectedValue: b
    };
}
function $277dfbc9b64034b1$var$Aa(a) {
    return $277dfbc9b64034b1$var$D("http://www.w3.org/2000/svg" === a ? 2 : "http://www.w3.org/1998/Math/MathML" === a ? 3 : 0, null);
}
function $277dfbc9b64034b1$var$Ba(a, b, c) {
    switch(b){
        case "select":
            return $277dfbc9b64034b1$var$D(1, null != c.value ? c.value : c.defaultValue);
        case "svg":
            return $277dfbc9b64034b1$var$D(2, null);
        case "math":
            return $277dfbc9b64034b1$var$D(3, null);
        case "foreignObject":
            return $277dfbc9b64034b1$var$D(1, null);
        case "table":
            return $277dfbc9b64034b1$var$D(4, null);
        case "thead":
        case "tbody":
        case "tfoot":
            return $277dfbc9b64034b1$var$D(5, null);
        case "colgroup":
            return $277dfbc9b64034b1$var$D(7, null);
        case "tr":
            return $277dfbc9b64034b1$var$D(6, null);
    }
    return 4 <= a.insertionMode || 0 === a.insertionMode ? $277dfbc9b64034b1$var$D(1, null) : a;
}
var $277dfbc9b64034b1$var$Ca = $277dfbc9b64034b1$var$w("\x3c!-- --\x3e");
function $277dfbc9b64034b1$var$Da(a, b, c, d) {
    if ("" === b) return d;
    d && a.push($277dfbc9b64034b1$var$Ca);
    a.push($277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(b)));
    return !0;
}
var $277dfbc9b64034b1$var$Ea = new Map, $277dfbc9b64034b1$var$Fa = $277dfbc9b64034b1$var$w(' style="'), $277dfbc9b64034b1$var$Ga = $277dfbc9b64034b1$var$w(":"), $277dfbc9b64034b1$var$Ha = $277dfbc9b64034b1$var$w(";");
function $277dfbc9b64034b1$var$Ia(a, b, c) {
    if ("object" !== typeof c) throw Error($277dfbc9b64034b1$var$k(62));
    b = !0;
    for(var d in c)if ($277dfbc9b64034b1$var$x.call(c, d)) {
        var f = c[d];
        if (null != f && "boolean" !== typeof f && "" !== f) {
            if (0 === d.indexOf("--")) {
                var e = $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(d));
                f = $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(("" + f).trim()));
            } else {
                e = d;
                var g = $277dfbc9b64034b1$var$Ea.get(e);
                void 0 !== g ? e = g : (g = $277dfbc9b64034b1$var$w($277dfbc9b64034b1$var$C(e.replace($277dfbc9b64034b1$var$pa, "-$1").toLowerCase().replace($277dfbc9b64034b1$var$qa, "-ms-"))), $277dfbc9b64034b1$var$Ea.set(e, g), e = g);
                f = "number" === typeof f ? 0 === f || $277dfbc9b64034b1$var$x.call($277dfbc9b64034b1$var$B, d) ? $277dfbc9b64034b1$var$u("" + f) : $277dfbc9b64034b1$var$u(f + "px") : $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(("" + f).trim()));
            }
            b ? (b = !1, a.push($277dfbc9b64034b1$var$Fa, e, $277dfbc9b64034b1$var$Ga, f)) : a.push($277dfbc9b64034b1$var$Ha, e, $277dfbc9b64034b1$var$Ga, f);
        }
    }
    b || a.push($277dfbc9b64034b1$var$E);
}
var $277dfbc9b64034b1$var$H = $277dfbc9b64034b1$var$w(" "), $277dfbc9b64034b1$var$I = $277dfbc9b64034b1$var$w('="'), $277dfbc9b64034b1$var$E = $277dfbc9b64034b1$var$w('"'), $277dfbc9b64034b1$var$Ja = $277dfbc9b64034b1$var$w('=""');
function $277dfbc9b64034b1$var$J(a, b, c, d) {
    switch(c){
        case "style":
            $277dfbc9b64034b1$var$Ia(a, b, d);
            return;
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
            return;
    }
    if (!(2 < c.length) || "o" !== c[0] && "O" !== c[0] || "n" !== c[1] && "N" !== c[1]) {
        if (b = $277dfbc9b64034b1$var$z.hasOwnProperty(c) ? $277dfbc9b64034b1$var$z[c] : null, null !== b) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (!b.acceptsBooleans) return;
            }
            c = $277dfbc9b64034b1$var$u(b.attributeName);
            switch(b.type){
                case 3:
                    d && a.push($277dfbc9b64034b1$var$H, c, $277dfbc9b64034b1$var$Ja);
                    break;
                case 4:
                    !0 === d ? a.push($277dfbc9b64034b1$var$H, c, $277dfbc9b64034b1$var$Ja) : !1 !== d && a.push($277dfbc9b64034b1$var$H, c, $277dfbc9b64034b1$var$I, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(d)), $277dfbc9b64034b1$var$E);
                    break;
                case 5:
                    isNaN(d) || a.push($277dfbc9b64034b1$var$H, c, $277dfbc9b64034b1$var$I, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(d)), $277dfbc9b64034b1$var$E);
                    break;
                case 6:
                    !isNaN(d) && 1 <= d && a.push($277dfbc9b64034b1$var$H, c, $277dfbc9b64034b1$var$I, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(d)), $277dfbc9b64034b1$var$E);
                    break;
                default:
                    b.sanitizeURL && (d = "" + d), a.push($277dfbc9b64034b1$var$H, c, $277dfbc9b64034b1$var$I, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(d)), $277dfbc9b64034b1$var$E);
            }
        } else if ($277dfbc9b64034b1$var$ia(c)) {
            switch(typeof d){
                case "function":
                case "symbol":
                    return;
                case "boolean":
                    if (b = c.toLowerCase().slice(0, 5), "data-" !== b && "aria-" !== b) return;
            }
            a.push($277dfbc9b64034b1$var$H, $277dfbc9b64034b1$var$u(c), $277dfbc9b64034b1$var$I, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(d)), $277dfbc9b64034b1$var$E);
        }
    }
}
var $277dfbc9b64034b1$var$K = $277dfbc9b64034b1$var$w(">"), $277dfbc9b64034b1$var$Ka = $277dfbc9b64034b1$var$w("/>");
function $277dfbc9b64034b1$var$L(a, b, c) {
    if (null != b) {
        if (null != c) throw Error($277dfbc9b64034b1$var$k(60));
        if ("object" !== typeof b || !("__html" in b)) throw Error($277dfbc9b64034b1$var$k(61));
        b = b.__html;
        null !== b && void 0 !== b && a.push($277dfbc9b64034b1$var$u("" + b));
    }
}
function $277dfbc9b64034b1$var$La(a) {
    var b = "";
    $acw62.Children.forEach(a, function(a) {
        null != a && (b += a);
    });
    return b;
}
var $277dfbc9b64034b1$var$Ma = $277dfbc9b64034b1$var$w(' selected=""');
function $277dfbc9b64034b1$var$Na(a, b, c, d) {
    a.push($277dfbc9b64034b1$var$M(c));
    var f = c = null, e;
    for(e in b)if ($277dfbc9b64034b1$var$x.call(b, e)) {
        var g = b[e];
        if (null != g) switch(e){
            case "children":
                c = g;
                break;
            case "dangerouslySetInnerHTML":
                f = g;
                break;
            default:
                $277dfbc9b64034b1$var$J(a, d, e, g);
        }
    }
    a.push($277dfbc9b64034b1$var$K);
    $277dfbc9b64034b1$var$L(a, f, c);
    return "string" === typeof c ? (a.push($277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(c))), null) : c;
}
var $277dfbc9b64034b1$var$Oa = $277dfbc9b64034b1$var$w("\n"), $277dfbc9b64034b1$var$Pa = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/, $277dfbc9b64034b1$var$Qa = new Map;
function $277dfbc9b64034b1$var$M(a) {
    var b = $277dfbc9b64034b1$var$Qa.get(a);
    if (void 0 === b) {
        if (!$277dfbc9b64034b1$var$Pa.test(a)) throw Error($277dfbc9b64034b1$var$k(65, a));
        b = $277dfbc9b64034b1$var$w("<" + a);
        $277dfbc9b64034b1$var$Qa.set(a, b);
    }
    return b;
}
var $277dfbc9b64034b1$var$Ra = $277dfbc9b64034b1$var$w("<!DOCTYPE html>");
function $277dfbc9b64034b1$var$Sa(a, b, c, d, f) {
    switch(b){
        case "select":
            a.push($277dfbc9b64034b1$var$M("select"));
            var e = null, g = null;
            for(r in c)if ($277dfbc9b64034b1$var$x.call(c, r)) {
                var h = c[r];
                if (null != h) switch(r){
                    case "children":
                        e = h;
                        break;
                    case "dangerouslySetInnerHTML":
                        g = h;
                        break;
                    case "defaultValue":
                    case "value":
                        break;
                    default:
                        $277dfbc9b64034b1$var$J(a, d, r, h);
                }
            }
            a.push($277dfbc9b64034b1$var$K);
            $277dfbc9b64034b1$var$L(a, g, e);
            return e;
        case "option":
            g = f.selectedValue;
            a.push($277dfbc9b64034b1$var$M("option"));
            var m = h = null, q = null;
            var r = null;
            for(e in c)if ($277dfbc9b64034b1$var$x.call(c, e)) {
                var v = c[e];
                if (null != v) switch(e){
                    case "children":
                        h = v;
                        break;
                    case "selected":
                        q = v;
                        break;
                    case "dangerouslySetInnerHTML":
                        r = v;
                        break;
                    case "value":
                        m = v;
                    default:
                        $277dfbc9b64034b1$var$J(a, d, e, v);
                }
            }
            if (null != g) {
                if (c = null !== m ? "" + m : $277dfbc9b64034b1$var$La(h), $277dfbc9b64034b1$var$ra(g)) {
                    for(d = 0; d < g.length; d++)if ("" + g[d] === c) {
                        a.push($277dfbc9b64034b1$var$Ma);
                        break;
                    }
                } else "" + g === c && a.push($277dfbc9b64034b1$var$Ma);
            } else q && a.push($277dfbc9b64034b1$var$Ma);
            a.push($277dfbc9b64034b1$var$K);
            $277dfbc9b64034b1$var$L(a, r, h);
            return h;
        case "textarea":
            a.push($277dfbc9b64034b1$var$M("textarea"));
            r = g = e = null;
            for(h in c)if ($277dfbc9b64034b1$var$x.call(c, h) && (m = c[h], null != m)) switch(h){
                case "children":
                    r = m;
                    break;
                case "value":
                    e = m;
                    break;
                case "defaultValue":
                    g = m;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($277dfbc9b64034b1$var$k(91));
                default:
                    $277dfbc9b64034b1$var$J(a, d, h, m);
            }
            null === e && null !== g && (e = g);
            a.push($277dfbc9b64034b1$var$K);
            if (null != r) {
                if (null != e) throw Error($277dfbc9b64034b1$var$k(92));
                if ($277dfbc9b64034b1$var$ra(r) && 1 < r.length) throw Error($277dfbc9b64034b1$var$k(93));
                e = "" + r;
            }
            "string" === typeof e && "\n" === e[0] && a.push($277dfbc9b64034b1$var$Oa);
            null !== e && a.push($277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C("" + e)));
            return null;
        case "input":
            a.push($277dfbc9b64034b1$var$M("input"));
            m = r = h = e = null;
            for(g in c)if ($277dfbc9b64034b1$var$x.call(c, g) && (q = c[g], null != q)) switch(g){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($277dfbc9b64034b1$var$k(399, "input"));
                case "defaultChecked":
                    m = q;
                    break;
                case "defaultValue":
                    h = q;
                    break;
                case "checked":
                    r = q;
                    break;
                case "value":
                    e = q;
                    break;
                default:
                    $277dfbc9b64034b1$var$J(a, d, g, q);
            }
            null !== r ? $277dfbc9b64034b1$var$J(a, d, "checked", r) : null !== m && $277dfbc9b64034b1$var$J(a, d, "checked", m);
            null !== e ? $277dfbc9b64034b1$var$J(a, d, "value", e) : null !== h && $277dfbc9b64034b1$var$J(a, d, "value", h);
            a.push($277dfbc9b64034b1$var$Ka);
            return null;
        case "menuitem":
            a.push($277dfbc9b64034b1$var$M("menuitem"));
            for(var A in c)if ($277dfbc9b64034b1$var$x.call(c, A) && (e = c[A], null != e)) switch(A){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($277dfbc9b64034b1$var$k(400));
                default:
                    $277dfbc9b64034b1$var$J(a, d, A, e);
            }
            a.push($277dfbc9b64034b1$var$K);
            return null;
        case "title":
            a.push($277dfbc9b64034b1$var$M("title"));
            e = null;
            for(v in c)if ($277dfbc9b64034b1$var$x.call(c, v) && (g = c[v], null != g)) switch(v){
                case "children":
                    e = g;
                    break;
                case "dangerouslySetInnerHTML":
                    throw Error($277dfbc9b64034b1$var$k(434));
                default:
                    $277dfbc9b64034b1$var$J(a, d, v, g);
            }
            a.push($277dfbc9b64034b1$var$K);
            return e;
        case "listing":
        case "pre":
            a.push($277dfbc9b64034b1$var$M(b));
            g = e = null;
            for(m in c)if ($277dfbc9b64034b1$var$x.call(c, m) && (h = c[m], null != h)) switch(m){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                default:
                    $277dfbc9b64034b1$var$J(a, d, m, h);
            }
            a.push($277dfbc9b64034b1$var$K);
            if (null != g) {
                if (null != e) throw Error($277dfbc9b64034b1$var$k(60));
                if ("object" !== typeof g || !("__html" in g)) throw Error($277dfbc9b64034b1$var$k(61));
                c = g.__html;
                null !== c && void 0 !== c && ("string" === typeof c && 0 < c.length && "\n" === c[0] ? a.push($277dfbc9b64034b1$var$Oa, $277dfbc9b64034b1$var$u(c)) : a.push($277dfbc9b64034b1$var$u("" + c)));
            }
            "string" === typeof e && "\n" === e[0] && a.push($277dfbc9b64034b1$var$Oa);
            return e;
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "img":
        case "keygen":
        case "link":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
            a.push($277dfbc9b64034b1$var$M(b));
            for(var F in c)if ($277dfbc9b64034b1$var$x.call(c, F) && (e = c[F], null != e)) switch(F){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($277dfbc9b64034b1$var$k(399, b));
                default:
                    $277dfbc9b64034b1$var$J(a, d, F, e);
            }
            a.push($277dfbc9b64034b1$var$Ka);
            return null;
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return $277dfbc9b64034b1$var$Na(a, c, b, d);
        case "html":
            return 0 === f.insertionMode && a.push($277dfbc9b64034b1$var$Ra), $277dfbc9b64034b1$var$Na(a, c, b, d);
        default:
            if (-1 === b.indexOf("-") && "string" !== typeof c.is) return $277dfbc9b64034b1$var$Na(a, c, b, d);
            a.push($277dfbc9b64034b1$var$M(b));
            g = e = null;
            for(q in c)if ($277dfbc9b64034b1$var$x.call(c, q) && (h = c[q], null != h)) switch(q){
                case "children":
                    e = h;
                    break;
                case "dangerouslySetInnerHTML":
                    g = h;
                    break;
                case "style":
                    $277dfbc9b64034b1$var$Ia(a, d, h);
                    break;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                    break;
                default:
                    $277dfbc9b64034b1$var$ia(q) && "function" !== typeof h && "symbol" !== typeof h && a.push($277dfbc9b64034b1$var$H, $277dfbc9b64034b1$var$u(q), $277dfbc9b64034b1$var$I, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(h)), $277dfbc9b64034b1$var$E);
            }
            a.push($277dfbc9b64034b1$var$K);
            $277dfbc9b64034b1$var$L(a, g, e);
            return e;
    }
}
var $277dfbc9b64034b1$var$Ta = $277dfbc9b64034b1$var$w("</"), $277dfbc9b64034b1$var$Ua = $277dfbc9b64034b1$var$w(">"), $277dfbc9b64034b1$var$Va = $277dfbc9b64034b1$var$w('<template id="'), $277dfbc9b64034b1$var$Wa = $277dfbc9b64034b1$var$w('"></template>'), $277dfbc9b64034b1$var$Xa = $277dfbc9b64034b1$var$w("\x3c!--$--\x3e"), $277dfbc9b64034b1$var$Ya = $277dfbc9b64034b1$var$w('\x3c!--$?--\x3e<template id="'), $277dfbc9b64034b1$var$Za = $277dfbc9b64034b1$var$w('"></template>'), $277dfbc9b64034b1$var$$a = $277dfbc9b64034b1$var$w("\x3c!--$!--\x3e"), $277dfbc9b64034b1$var$ab = $277dfbc9b64034b1$var$w("\x3c!--/$--\x3e"), $277dfbc9b64034b1$var$bb = $277dfbc9b64034b1$var$w("<template"), $277dfbc9b64034b1$var$cb = $277dfbc9b64034b1$var$w('"'), $277dfbc9b64034b1$var$db = $277dfbc9b64034b1$var$w(' data-dgst="');
$277dfbc9b64034b1$var$w(' data-msg="');
$277dfbc9b64034b1$var$w(' data-stck="');
var $277dfbc9b64034b1$var$eb = $277dfbc9b64034b1$var$w("></template>");
function $277dfbc9b64034b1$var$fb(a, b, c) {
    $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$Ya);
    if (null === c) throw Error($277dfbc9b64034b1$var$k(395));
    $277dfbc9b64034b1$var$p(a, c);
    return $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$Za);
}
var $277dfbc9b64034b1$var$gb = $277dfbc9b64034b1$var$w('<div hidden id="'), $277dfbc9b64034b1$var$hb = $277dfbc9b64034b1$var$w('">'), $277dfbc9b64034b1$var$ib = $277dfbc9b64034b1$var$w("</div>"), $277dfbc9b64034b1$var$jb = $277dfbc9b64034b1$var$w('<svg aria-hidden="true" style="display:none" id="'), $277dfbc9b64034b1$var$kb = $277dfbc9b64034b1$var$w('">'), $277dfbc9b64034b1$var$lb = $277dfbc9b64034b1$var$w("</svg>"), $277dfbc9b64034b1$var$mb = $277dfbc9b64034b1$var$w('<math aria-hidden="true" style="display:none" id="'), $277dfbc9b64034b1$var$nb = $277dfbc9b64034b1$var$w('">'), $277dfbc9b64034b1$var$ob = $277dfbc9b64034b1$var$w("</math>"), $277dfbc9b64034b1$var$pb = $277dfbc9b64034b1$var$w('<table hidden id="'), $277dfbc9b64034b1$var$qb = $277dfbc9b64034b1$var$w('">'), $277dfbc9b64034b1$var$rb = $277dfbc9b64034b1$var$w("</table>"), $277dfbc9b64034b1$var$sb = $277dfbc9b64034b1$var$w('<table hidden><tbody id="'), $277dfbc9b64034b1$var$tb = $277dfbc9b64034b1$var$w('">'), $277dfbc9b64034b1$var$ub = $277dfbc9b64034b1$var$w("</tbody></table>"), $277dfbc9b64034b1$var$vb = $277dfbc9b64034b1$var$w('<table hidden><tr id="'), $277dfbc9b64034b1$var$wb = $277dfbc9b64034b1$var$w('">'), $277dfbc9b64034b1$var$xb = $277dfbc9b64034b1$var$w("</tr></table>"), $277dfbc9b64034b1$var$yb = $277dfbc9b64034b1$var$w('<table hidden><colgroup id="'), $277dfbc9b64034b1$var$zb = $277dfbc9b64034b1$var$w('">'), $277dfbc9b64034b1$var$Ab = $277dfbc9b64034b1$var$w("</colgroup></table>");
function $277dfbc9b64034b1$var$Bb(a, b, c, d) {
    switch(c.insertionMode){
        case 0:
        case 1:
            return $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$gb), $277dfbc9b64034b1$var$p(a, b.segmentPrefix), $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$u(d.toString(16))), $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$hb);
        case 2:
            return $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$jb), $277dfbc9b64034b1$var$p(a, b.segmentPrefix), $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$u(d.toString(16))), $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$kb);
        case 3:
            return $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$mb), $277dfbc9b64034b1$var$p(a, b.segmentPrefix), $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$u(d.toString(16))), $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$nb);
        case 4:
            return $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$pb), $277dfbc9b64034b1$var$p(a, b.segmentPrefix), $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$u(d.toString(16))), $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$qb);
        case 5:
            return $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$sb), $277dfbc9b64034b1$var$p(a, b.segmentPrefix), $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$u(d.toString(16))), $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$tb);
        case 6:
            return $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$vb), $277dfbc9b64034b1$var$p(a, b.segmentPrefix), $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$u(d.toString(16))), $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$wb);
        case 7:
            return $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$yb), $277dfbc9b64034b1$var$p(a, b.segmentPrefix), $277dfbc9b64034b1$var$p(a, $277dfbc9b64034b1$var$u(d.toString(16))), $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$zb);
        default:
            throw Error($277dfbc9b64034b1$var$k(397));
    }
}
function $277dfbc9b64034b1$var$Cb(a, b) {
    switch(b.insertionMode){
        case 0:
        case 1:
            return $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$ib);
        case 2:
            return $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$lb);
        case 3:
            return $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$ob);
        case 4:
            return $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$rb);
        case 5:
            return $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$ub);
        case 6:
            return $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$xb);
        case 7:
            return $277dfbc9b64034b1$var$t(a, $277dfbc9b64034b1$var$Ab);
        default:
            throw Error($277dfbc9b64034b1$var$k(397));
    }
}
var $277dfbc9b64034b1$var$Db = $277dfbc9b64034b1$var$w('function $RS(a,b){a=document.getElementById(a);b=document.getElementById(b);for(a.parentNode.removeChild(a);a.firstChild;)b.parentNode.insertBefore(a.firstChild,b);b.parentNode.removeChild(b)};$RS("'), $277dfbc9b64034b1$var$Eb = $277dfbc9b64034b1$var$w('$RS("'), $277dfbc9b64034b1$var$Gb = $277dfbc9b64034b1$var$w('","'), $277dfbc9b64034b1$var$Hb = $277dfbc9b64034b1$var$w('")\x3c/script>'), $277dfbc9b64034b1$var$Ib = $277dfbc9b64034b1$var$w('function $RC(a,b){a=document.getElementById(a);b=document.getElementById(b);b.parentNode.removeChild(b);if(a){a=a.previousSibling;var f=a.parentNode,c=a.nextSibling,e=0;do{if(c&&8===c.nodeType){var d=c.data;if("/$"===d)if(0===e)break;else e--;else"$"!==d&&"$?"!==d&&"$!"!==d||e++}d=c.nextSibling;f.removeChild(c);c=d}while(c);for(;b.firstChild;)f.insertBefore(b.firstChild,c);a.data="$";a._reactRetry&&a._reactRetry()}};$RC("'), $277dfbc9b64034b1$var$Jb = $277dfbc9b64034b1$var$w('$RC("'), $277dfbc9b64034b1$var$Kb = $277dfbc9b64034b1$var$w('","'), $277dfbc9b64034b1$var$Lb = $277dfbc9b64034b1$var$w('")\x3c/script>'), $277dfbc9b64034b1$var$Mb = $277dfbc9b64034b1$var$w('function $RX(b,c,d,e){var a=document.getElementById(b);a&&(b=a.previousSibling,b.data="$!",a=a.dataset,c&&(a.dgst=c),d&&(a.msg=d),e&&(a.stck=e),b._reactRetry&&b._reactRetry())};$RX("'), $277dfbc9b64034b1$var$Nb = $277dfbc9b64034b1$var$w('$RX("'), $277dfbc9b64034b1$var$Ob = $277dfbc9b64034b1$var$w('"'), $277dfbc9b64034b1$var$Pb = $277dfbc9b64034b1$var$w(")\x3c/script>"), $277dfbc9b64034b1$var$Qb = $277dfbc9b64034b1$var$w(","), $277dfbc9b64034b1$var$Rb = /[<\u2028\u2029]/g;
function $277dfbc9b64034b1$var$Sb(a) {
    return JSON.stringify(a).replace($277dfbc9b64034b1$var$Rb, function(a) {
        switch(a){
            case "<":
                return "\\u003c";
            case "\u2028":
                return "\\u2028";
            case "\u2029":
                return "\\u2029";
            default:
                throw Error("escapeJSStringsForInstructionScripts encountered a match it does not know how to replace. this means the match regex and the replacement characters are no longer in sync. This is a bug in React");
        }
    });
}
var $277dfbc9b64034b1$var$N = Object.assign, $277dfbc9b64034b1$var$Tb = Symbol.for("react.element"), $277dfbc9b64034b1$var$Ub = Symbol.for("react.portal"), $277dfbc9b64034b1$var$Vb = Symbol.for("react.fragment"), $277dfbc9b64034b1$var$Wb = Symbol.for("react.strict_mode"), $277dfbc9b64034b1$var$Xb = Symbol.for("react.profiler"), $277dfbc9b64034b1$var$Yb = Symbol.for("react.provider"), $277dfbc9b64034b1$var$Zb = Symbol.for("react.context"), $277dfbc9b64034b1$var$$b = Symbol.for("react.forward_ref"), $277dfbc9b64034b1$var$ac = Symbol.for("react.suspense"), $277dfbc9b64034b1$var$bc = Symbol.for("react.suspense_list"), $277dfbc9b64034b1$var$cc = Symbol.for("react.memo"), $277dfbc9b64034b1$var$dc = Symbol.for("react.lazy"), $277dfbc9b64034b1$var$ec = Symbol.for("react.scope"), $277dfbc9b64034b1$var$fc = Symbol.for("react.debug_trace_mode"), $277dfbc9b64034b1$var$gc = Symbol.for("react.legacy_hidden"), $277dfbc9b64034b1$var$hc = Symbol.for("react.default_value"), $277dfbc9b64034b1$var$ic = Symbol.iterator;
function $277dfbc9b64034b1$var$jc(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $277dfbc9b64034b1$var$Vb:
            return "Fragment";
        case $277dfbc9b64034b1$var$Ub:
            return "Portal";
        case $277dfbc9b64034b1$var$Xb:
            return "Profiler";
        case $277dfbc9b64034b1$var$Wb:
            return "StrictMode";
        case $277dfbc9b64034b1$var$ac:
            return "Suspense";
        case $277dfbc9b64034b1$var$bc:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $277dfbc9b64034b1$var$Zb:
            return (a.displayName || "Context") + ".Consumer";
        case $277dfbc9b64034b1$var$Yb:
            return (a._context.displayName || "Context") + ".Provider";
        case $277dfbc9b64034b1$var$$b:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $277dfbc9b64034b1$var$cc:
            return b = a.displayName || null, null !== b ? b : $277dfbc9b64034b1$var$jc(a.type) || "Memo";
        case $277dfbc9b64034b1$var$dc:
            b = a._payload;
            a = a._init;
            try {
                return $277dfbc9b64034b1$var$jc(a(b));
            } catch (c) {}
    }
    return null;
}
var $277dfbc9b64034b1$var$kc = {};
function $277dfbc9b64034b1$var$lc(a, b) {
    a = a.contextTypes;
    if (!a) return $277dfbc9b64034b1$var$kc;
    var c = {}, d;
    for(d in a)c[d] = b[d];
    return c;
}
var $277dfbc9b64034b1$var$O = null;
function $277dfbc9b64034b1$var$P(a, b) {
    if (a !== b) {
        a.context._currentValue = a.parentValue;
        a = a.parent;
        var c = b.parent;
        if (null === a) {
            if (null !== c) throw Error($277dfbc9b64034b1$var$k(401));
        } else {
            if (null === c) throw Error($277dfbc9b64034b1$var$k(401));
            $277dfbc9b64034b1$var$P(a, c);
        }
        b.context._currentValue = b.value;
    }
}
function $277dfbc9b64034b1$var$mc(a) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    null !== a && $277dfbc9b64034b1$var$mc(a);
}
function $277dfbc9b64034b1$var$nc(a) {
    var b = a.parent;
    null !== b && $277dfbc9b64034b1$var$nc(b);
    a.context._currentValue = a.value;
}
function $277dfbc9b64034b1$var$oc(a, b) {
    a.context._currentValue = a.parentValue;
    a = a.parent;
    if (null === a) throw Error($277dfbc9b64034b1$var$k(402));
    a.depth === b.depth ? $277dfbc9b64034b1$var$P(a, b) : $277dfbc9b64034b1$var$oc(a, b);
}
function $277dfbc9b64034b1$var$pc(a, b) {
    var c = b.parent;
    if (null === c) throw Error($277dfbc9b64034b1$var$k(402));
    a.depth === c.depth ? $277dfbc9b64034b1$var$P(a, c) : $277dfbc9b64034b1$var$pc(a, c);
    b.context._currentValue = b.value;
}
function $277dfbc9b64034b1$var$Q(a) {
    var b = $277dfbc9b64034b1$var$O;
    b !== a && (null === b ? $277dfbc9b64034b1$var$nc(a) : null === a ? $277dfbc9b64034b1$var$mc(b) : b.depth === a.depth ? $277dfbc9b64034b1$var$P(b, a) : b.depth > a.depth ? $277dfbc9b64034b1$var$oc(b, a) : $277dfbc9b64034b1$var$pc(b, a), $277dfbc9b64034b1$var$O = a);
}
var $277dfbc9b64034b1$var$qc = {
    isMounted: function() {
        return !1;
    },
    enqueueSetState: function(a, b) {
        a = a._reactInternals;
        null !== a.queue && a.queue.push(b);
    },
    enqueueReplaceState: function(a, b) {
        a = a._reactInternals;
        a.replace = !0;
        a.queue = [
            b
        ];
    },
    enqueueForceUpdate: function() {}
};
function $277dfbc9b64034b1$var$rc(a, b, c, d) {
    var f = void 0 !== a.state ? a.state : null;
    a.updater = $277dfbc9b64034b1$var$qc;
    a.props = c;
    a.state = f;
    var e = {
        queue: [],
        replace: !1
    };
    a._reactInternals = e;
    var g = b.contextType;
    a.context = "object" === typeof g && null !== g ? g._currentValue : d;
    g = b.getDerivedStateFromProps;
    "function" === typeof g && (g = g(c, f), f = null === g || void 0 === g ? f : $277dfbc9b64034b1$var$N({}, f, g), a.state = f);
    if ("function" !== typeof b.getDerivedStateFromProps && "function" !== typeof a.getSnapshotBeforeUpdate && ("function" === typeof a.UNSAFE_componentWillMount || "function" === typeof a.componentWillMount)) {
        if (b = a.state, "function" === typeof a.componentWillMount && a.componentWillMount(), "function" === typeof a.UNSAFE_componentWillMount && a.UNSAFE_componentWillMount(), b !== a.state && $277dfbc9b64034b1$var$qc.enqueueReplaceState(a, a.state, null), null !== e.queue && 0 < e.queue.length) {
            if (b = e.queue, g = e.replace, e.queue = null, e.replace = !1, g && 1 === b.length) a.state = b[0];
            else {
                e = g ? b[0] : a.state;
                f = !0;
                for(g = g ? 1 : 0; g < b.length; g++){
                    var h = b[g];
                    h = "function" === typeof h ? h.call(a, e, c, d) : h;
                    null != h && (f ? (f = !1, e = $277dfbc9b64034b1$var$N({}, e, h)) : $277dfbc9b64034b1$var$N(e, h));
                }
                a.state = e;
            }
        } else e.queue = null;
    }
}
var $277dfbc9b64034b1$var$sc = {
    id: 1,
    overflow: ""
};
function $277dfbc9b64034b1$var$tc(a, b, c) {
    var d = a.id;
    a = a.overflow;
    var f = 32 - $277dfbc9b64034b1$var$uc(d) - 1;
    d &= ~(1 << f);
    c += 1;
    var e = 32 - $277dfbc9b64034b1$var$uc(b) + f;
    if (30 < e) {
        var g = f - f % 5;
        e = (d & (1 << g) - 1).toString(32);
        d >>= g;
        f -= g;
        return {
            id: 1 << 32 - $277dfbc9b64034b1$var$uc(b) + f | c << f | d,
            overflow: e + a
        };
    }
    return {
        id: 1 << e | c << f | d,
        overflow: a
    };
}
var $277dfbc9b64034b1$var$uc = Math.clz32 ? Math.clz32 : $277dfbc9b64034b1$var$vc, $277dfbc9b64034b1$var$wc = Math.log, $277dfbc9b64034b1$var$xc = Math.LN2;
function $277dfbc9b64034b1$var$vc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($277dfbc9b64034b1$var$wc(a) / $277dfbc9b64034b1$var$xc | 0) | 0;
}
function $277dfbc9b64034b1$var$yc(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $277dfbc9b64034b1$var$zc = "function" === typeof Object.is ? Object.is : $277dfbc9b64034b1$var$yc, $277dfbc9b64034b1$var$R = null, $277dfbc9b64034b1$var$Ac = null, $277dfbc9b64034b1$var$Bc = null, $277dfbc9b64034b1$var$S = null, $277dfbc9b64034b1$var$T = !1, $277dfbc9b64034b1$var$Cc = !1, $277dfbc9b64034b1$var$U = 0, $277dfbc9b64034b1$var$V = null, $277dfbc9b64034b1$var$Dc = 0;
function $277dfbc9b64034b1$var$W() {
    if (null === $277dfbc9b64034b1$var$R) throw Error($277dfbc9b64034b1$var$k(321));
    return $277dfbc9b64034b1$var$R;
}
function $277dfbc9b64034b1$var$Ec() {
    if (0 < $277dfbc9b64034b1$var$Dc) throw Error($277dfbc9b64034b1$var$k(312));
    return {
        memoizedState: null,
        queue: null,
        next: null
    };
}
function $277dfbc9b64034b1$var$Fc() {
    null === $277dfbc9b64034b1$var$S ? null === $277dfbc9b64034b1$var$Bc ? ($277dfbc9b64034b1$var$T = !1, $277dfbc9b64034b1$var$Bc = $277dfbc9b64034b1$var$S = $277dfbc9b64034b1$var$Ec()) : ($277dfbc9b64034b1$var$T = !0, $277dfbc9b64034b1$var$S = $277dfbc9b64034b1$var$Bc) : null === $277dfbc9b64034b1$var$S.next ? ($277dfbc9b64034b1$var$T = !1, $277dfbc9b64034b1$var$S = $277dfbc9b64034b1$var$S.next = $277dfbc9b64034b1$var$Ec()) : ($277dfbc9b64034b1$var$T = !0, $277dfbc9b64034b1$var$S = $277dfbc9b64034b1$var$S.next);
    return $277dfbc9b64034b1$var$S;
}
function $277dfbc9b64034b1$var$Gc() {
    $277dfbc9b64034b1$var$Ac = $277dfbc9b64034b1$var$R = null;
    $277dfbc9b64034b1$var$Cc = !1;
    $277dfbc9b64034b1$var$Bc = null;
    $277dfbc9b64034b1$var$Dc = 0;
    $277dfbc9b64034b1$var$S = $277dfbc9b64034b1$var$V = null;
}
function $277dfbc9b64034b1$var$Hc(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $277dfbc9b64034b1$var$Ic(a, b, c) {
    $277dfbc9b64034b1$var$R = $277dfbc9b64034b1$var$W();
    $277dfbc9b64034b1$var$S = $277dfbc9b64034b1$var$Fc();
    if ($277dfbc9b64034b1$var$T) {
        var d = $277dfbc9b64034b1$var$S.queue;
        b = d.dispatch;
        if (null !== $277dfbc9b64034b1$var$V && (c = $277dfbc9b64034b1$var$V.get(d), void 0 !== c)) {
            $277dfbc9b64034b1$var$V.delete(d);
            d = $277dfbc9b64034b1$var$S.memoizedState;
            do d = a(d, c.action), c = c.next;
            while (null !== c);
            $277dfbc9b64034b1$var$S.memoizedState = d;
            return [
                d,
                b
            ];
        }
        return [
            $277dfbc9b64034b1$var$S.memoizedState,
            b
        ];
    }
    a = a === $277dfbc9b64034b1$var$Hc ? "function" === typeof b ? b() : b : void 0 !== c ? c(b) : b;
    $277dfbc9b64034b1$var$S.memoizedState = a;
    a = $277dfbc9b64034b1$var$S.queue = {
        last: null,
        dispatch: null
    };
    a = a.dispatch = $277dfbc9b64034b1$var$Jc.bind(null, $277dfbc9b64034b1$var$R, a);
    return [
        $277dfbc9b64034b1$var$S.memoizedState,
        a
    ];
}
function $277dfbc9b64034b1$var$Kc(a, b) {
    $277dfbc9b64034b1$var$R = $277dfbc9b64034b1$var$W();
    $277dfbc9b64034b1$var$S = $277dfbc9b64034b1$var$Fc();
    b = void 0 === b ? null : b;
    if (null !== $277dfbc9b64034b1$var$S) {
        var c = $277dfbc9b64034b1$var$S.memoizedState;
        if (null !== c && null !== b) {
            var d = c[1];
            a: if (null === d) d = !1;
            else {
                for(var f = 0; f < d.length && f < b.length; f++)if (!$277dfbc9b64034b1$var$zc(b[f], d[f])) {
                    d = !1;
                    break a;
                }
                d = !0;
            }
            if (d) return c[0];
        }
    }
    a = a();
    $277dfbc9b64034b1$var$S.memoizedState = [
        a,
        b
    ];
    return a;
}
function $277dfbc9b64034b1$var$Jc(a, b, c) {
    if (25 <= $277dfbc9b64034b1$var$Dc) throw Error($277dfbc9b64034b1$var$k(301));
    if (a === $277dfbc9b64034b1$var$R) {
        if ($277dfbc9b64034b1$var$Cc = !0, a = {
            action: c,
            next: null
        }, null === $277dfbc9b64034b1$var$V && ($277dfbc9b64034b1$var$V = new Map), c = $277dfbc9b64034b1$var$V.get(b), void 0 === c) $277dfbc9b64034b1$var$V.set(b, a);
        else {
            for(b = c; null !== b.next;)b = b.next;
            b.next = a;
        }
    }
}
function $277dfbc9b64034b1$var$Lc() {
    throw Error($277dfbc9b64034b1$var$k(394));
}
function $277dfbc9b64034b1$var$Mc() {}
var $277dfbc9b64034b1$var$Oc = {
    readContext: function(a) {
        return a._currentValue;
    },
    useContext: function(a) {
        $277dfbc9b64034b1$var$W();
        return a._currentValue;
    },
    useMemo: $277dfbc9b64034b1$var$Kc,
    useReducer: $277dfbc9b64034b1$var$Ic,
    useRef: function(a) {
        $277dfbc9b64034b1$var$R = $277dfbc9b64034b1$var$W();
        $277dfbc9b64034b1$var$S = $277dfbc9b64034b1$var$Fc();
        var b = $277dfbc9b64034b1$var$S.memoizedState;
        return null === b ? (a = {
            current: a
        }, $277dfbc9b64034b1$var$S.memoizedState = a) : b;
    },
    useState: function(a) {
        return $277dfbc9b64034b1$var$Ic($277dfbc9b64034b1$var$Hc, a);
    },
    useInsertionEffect: $277dfbc9b64034b1$var$Mc,
    useLayoutEffect: function() {},
    useCallback: function(a, b) {
        return $277dfbc9b64034b1$var$Kc(function() {
            return a;
        }, b);
    },
    useImperativeHandle: $277dfbc9b64034b1$var$Mc,
    useEffect: $277dfbc9b64034b1$var$Mc,
    useDebugValue: $277dfbc9b64034b1$var$Mc,
    useDeferredValue: function(a) {
        $277dfbc9b64034b1$var$W();
        return a;
    },
    useTransition: function() {
        $277dfbc9b64034b1$var$W();
        return [
            !1,
            $277dfbc9b64034b1$var$Lc
        ];
    },
    useId: function() {
        var a = $277dfbc9b64034b1$var$Ac.treeContext;
        var b = a.overflow;
        a = a.id;
        a = (a & ~(1 << 32 - $277dfbc9b64034b1$var$uc(a) - 1)).toString(32) + b;
        var c = $277dfbc9b64034b1$var$Nc;
        if (null === c) throw Error($277dfbc9b64034b1$var$k(404));
        b = $277dfbc9b64034b1$var$U++;
        a = ":" + c.idPrefix + "R" + a;
        0 < b && (a += "H" + b.toString(32));
        return a + ":";
    },
    useMutableSource: function(a, b) {
        $277dfbc9b64034b1$var$W();
        return b(a._source);
    },
    useSyncExternalStore: function(a, b, c) {
        if (void 0 === c) throw Error($277dfbc9b64034b1$var$k(407));
        return c();
    }
}, $277dfbc9b64034b1$var$Nc = null, $277dfbc9b64034b1$var$Pc = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentDispatcher;
function $277dfbc9b64034b1$var$Qc(a) {
    console.error(a);
    return null;
}
function $277dfbc9b64034b1$var$X() {}
function $277dfbc9b64034b1$var$Rc(a, b, c, d, f, e, g, h, m) {
    var q = [], r = new Set;
    b = {
        destination: null,
        responseState: b,
        progressiveChunkSize: void 0 === d ? 12800 : d,
        status: 0,
        fatalError: null,
        nextSegmentId: 0,
        allPendingTasks: 0,
        pendingRootTasks: 0,
        completedRootSegment: null,
        abortableTasks: r,
        pingedTasks: q,
        clientRenderedBoundaries: [],
        completedBoundaries: [],
        partialBoundaries: [],
        onError: void 0 === f ? $277dfbc9b64034b1$var$Qc : f,
        onAllReady: void 0 === e ? $277dfbc9b64034b1$var$X : e,
        onShellReady: void 0 === g ? $277dfbc9b64034b1$var$X : g,
        onShellError: void 0 === h ? $277dfbc9b64034b1$var$X : h,
        onFatalError: void 0 === m ? $277dfbc9b64034b1$var$X : m
    };
    c = $277dfbc9b64034b1$var$Sc(b, 0, null, c, !1, !1);
    c.parentFlushed = !0;
    a = $277dfbc9b64034b1$var$Tc(b, a, null, c, r, $277dfbc9b64034b1$var$kc, null, $277dfbc9b64034b1$var$sc);
    q.push(a);
    return b;
}
function $277dfbc9b64034b1$var$Tc(a, b, c, d, f, e, g, h) {
    a.allPendingTasks++;
    null === c ? a.pendingRootTasks++ : c.pendingTasks++;
    var m = {
        node: b,
        ping: function() {
            var b = a.pingedTasks;
            b.push(m);
            1 === b.length && $277dfbc9b64034b1$var$Uc(a);
        },
        blockedBoundary: c,
        blockedSegment: d,
        abortSet: f,
        legacyContext: e,
        context: g,
        treeContext: h
    };
    f.add(m);
    return m;
}
function $277dfbc9b64034b1$var$Sc(a, b, c, d, f, e) {
    return {
        status: 0,
        id: -1,
        index: b,
        parentFlushed: !1,
        chunks: [],
        children: [],
        formatContext: d,
        boundary: c,
        lastPushedText: f,
        textEmbedded: e
    };
}
function $277dfbc9b64034b1$var$Y(a, b) {
    a = a.onError(b);
    if (null != a && "string" !== typeof a) throw Error('onError returned something with a type other than "string". onError should return a string and may return null or undefined but must not return anything else. It received something of type "' + typeof a + '" instead');
    return a;
}
function $277dfbc9b64034b1$var$Vc(a, b) {
    var c = a.onShellError;
    c(b);
    c = a.onFatalError;
    c(b);
    null !== a.destination ? (a.status = 2, $277dfbc9b64034b1$var$da(a.destination, b)) : (a.status = 1, a.fatalError = b);
}
function $277dfbc9b64034b1$var$Wc(a, b, c, d, f) {
    $277dfbc9b64034b1$var$R = {};
    $277dfbc9b64034b1$var$Ac = b;
    $277dfbc9b64034b1$var$U = 0;
    for(a = c(d, f); $277dfbc9b64034b1$var$Cc;)$277dfbc9b64034b1$var$Cc = !1, $277dfbc9b64034b1$var$U = 0, $277dfbc9b64034b1$var$Dc += 1, $277dfbc9b64034b1$var$S = null, a = c(d, f);
    $277dfbc9b64034b1$var$Gc();
    return a;
}
function $277dfbc9b64034b1$var$Xc(a, b, c, d) {
    var f = c.render(), e = d.childContextTypes;
    if (null !== e && void 0 !== e) {
        var g = b.legacyContext;
        if ("function" !== typeof c.getChildContext) d = g;
        else {
            c = c.getChildContext();
            for(var h in c)if (!(h in e)) throw Error($277dfbc9b64034b1$var$k(108, $277dfbc9b64034b1$var$jc(d) || "Unknown", h));
            d = $277dfbc9b64034b1$var$N({}, g, c);
        }
        b.legacyContext = d;
        $277dfbc9b64034b1$var$Z(a, b, f);
        b.legacyContext = g;
    } else $277dfbc9b64034b1$var$Z(a, b, f);
}
function $277dfbc9b64034b1$var$Yc(a, b) {
    if (a && a.defaultProps) {
        b = $277dfbc9b64034b1$var$N({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $277dfbc9b64034b1$var$Zc(a, b, c, d, f) {
    if ("function" === typeof c) {
        if (c.prototype && c.prototype.isReactComponent) {
            f = $277dfbc9b64034b1$var$lc(c, b.legacyContext);
            var e = c.contextType;
            e = new c(d, "object" === typeof e && null !== e ? e._currentValue : f);
            $277dfbc9b64034b1$var$rc(e, c, d, f);
            $277dfbc9b64034b1$var$Xc(a, b, e, c);
        } else {
            e = $277dfbc9b64034b1$var$lc(c, b.legacyContext);
            f = $277dfbc9b64034b1$var$Wc(a, b, c, d, e);
            var g = 0 !== $277dfbc9b64034b1$var$U;
            if ("object" === typeof f && null !== f && "function" === typeof f.render && void 0 === f.$$typeof) $277dfbc9b64034b1$var$rc(f, c, d, e), $277dfbc9b64034b1$var$Xc(a, b, f, c);
            else if (g) {
                d = b.treeContext;
                b.treeContext = $277dfbc9b64034b1$var$tc(d, 1, 0);
                try {
                    $277dfbc9b64034b1$var$Z(a, b, f);
                } finally{
                    b.treeContext = d;
                }
            } else $277dfbc9b64034b1$var$Z(a, b, f);
        }
    } else if ("string" === typeof c) {
        f = b.blockedSegment;
        e = $277dfbc9b64034b1$var$Sa(f.chunks, c, d, a.responseState, f.formatContext);
        f.lastPushedText = !1;
        g = f.formatContext;
        f.formatContext = $277dfbc9b64034b1$var$Ba(g, c, d);
        $277dfbc9b64034b1$var$$c(a, b, e);
        f.formatContext = g;
        switch(c){
            case "area":
            case "base":
            case "br":
            case "col":
            case "embed":
            case "hr":
            case "img":
            case "input":
            case "keygen":
            case "link":
            case "meta":
            case "param":
            case "source":
            case "track":
            case "wbr":
                break;
            default:
                f.chunks.push($277dfbc9b64034b1$var$Ta, $277dfbc9b64034b1$var$u(c), $277dfbc9b64034b1$var$Ua);
        }
        f.lastPushedText = !1;
    } else {
        switch(c){
            case $277dfbc9b64034b1$var$gc:
            case $277dfbc9b64034b1$var$fc:
            case $277dfbc9b64034b1$var$Wb:
            case $277dfbc9b64034b1$var$Xb:
            case $277dfbc9b64034b1$var$Vb:
                $277dfbc9b64034b1$var$Z(a, b, d.children);
                return;
            case $277dfbc9b64034b1$var$bc:
                $277dfbc9b64034b1$var$Z(a, b, d.children);
                return;
            case $277dfbc9b64034b1$var$ec:
                throw Error($277dfbc9b64034b1$var$k(343));
            case $277dfbc9b64034b1$var$ac:
                a: {
                    c = b.blockedBoundary;
                    f = b.blockedSegment;
                    e = d.fallback;
                    d = d.children;
                    g = new Set;
                    var h = {
                        id: null,
                        rootSegmentID: -1,
                        parentFlushed: !1,
                        pendingTasks: 0,
                        forceClientRender: !1,
                        completedSegments: [],
                        byteSize: 0,
                        fallbackAbortableTasks: g,
                        errorDigest: null
                    }, m = $277dfbc9b64034b1$var$Sc(a, f.chunks.length, h, f.formatContext, !1, !1);
                    f.children.push(m);
                    f.lastPushedText = !1;
                    var q = $277dfbc9b64034b1$var$Sc(a, 0, null, f.formatContext, !1, !1);
                    q.parentFlushed = !0;
                    b.blockedBoundary = h;
                    b.blockedSegment = q;
                    try {
                        if ($277dfbc9b64034b1$var$$c(a, b, d), q.lastPushedText && q.textEmbedded && q.chunks.push($277dfbc9b64034b1$var$Ca), q.status = 1, $277dfbc9b64034b1$var$ad(h, q), 0 === h.pendingTasks) break a;
                    } catch (r) {
                        q.status = 4, h.forceClientRender = !0, h.errorDigest = $277dfbc9b64034b1$var$Y(a, r);
                    } finally{
                        b.blockedBoundary = c, b.blockedSegment = f;
                    }
                    b = $277dfbc9b64034b1$var$Tc(a, e, c, m, g, b.legacyContext, b.context, b.treeContext);
                    a.pingedTasks.push(b);
                }
                return;
        }
        if ("object" === typeof c && null !== c) switch(c.$$typeof){
            case $277dfbc9b64034b1$var$$b:
                d = $277dfbc9b64034b1$var$Wc(a, b, c.render, d, f);
                if (0 !== $277dfbc9b64034b1$var$U) {
                    c = b.treeContext;
                    b.treeContext = $277dfbc9b64034b1$var$tc(c, 1, 0);
                    try {
                        $277dfbc9b64034b1$var$Z(a, b, d);
                    } finally{
                        b.treeContext = c;
                    }
                } else $277dfbc9b64034b1$var$Z(a, b, d);
                return;
            case $277dfbc9b64034b1$var$cc:
                c = c.type;
                d = $277dfbc9b64034b1$var$Yc(c, d);
                $277dfbc9b64034b1$var$Zc(a, b, c, d, f);
                return;
            case $277dfbc9b64034b1$var$Yb:
                f = d.children;
                c = c._context;
                d = d.value;
                e = c._currentValue;
                c._currentValue = d;
                g = $277dfbc9b64034b1$var$O;
                $277dfbc9b64034b1$var$O = d = {
                    parent: g,
                    depth: null === g ? 0 : g.depth + 1,
                    context: c,
                    parentValue: e,
                    value: d
                };
                b.context = d;
                $277dfbc9b64034b1$var$Z(a, b, f);
                a = $277dfbc9b64034b1$var$O;
                if (null === a) throw Error($277dfbc9b64034b1$var$k(403));
                d = a.parentValue;
                a.context._currentValue = d === $277dfbc9b64034b1$var$hc ? a.context._defaultValue : d;
                a = $277dfbc9b64034b1$var$O = a.parent;
                b.context = a;
                return;
            case $277dfbc9b64034b1$var$Zb:
                d = d.children;
                d = d(c._currentValue);
                $277dfbc9b64034b1$var$Z(a, b, d);
                return;
            case $277dfbc9b64034b1$var$dc:
                f = c._init;
                c = f(c._payload);
                d = $277dfbc9b64034b1$var$Yc(c, d);
                $277dfbc9b64034b1$var$Zc(a, b, c, d, void 0);
                return;
        }
        throw Error($277dfbc9b64034b1$var$k(130, null == c ? c : typeof c, ""));
    }
}
function $277dfbc9b64034b1$var$Z(a, b, c) {
    b.node = c;
    if ("object" === typeof c && null !== c) {
        switch(c.$$typeof){
            case $277dfbc9b64034b1$var$Tb:
                $277dfbc9b64034b1$var$Zc(a, b, c.type, c.props, c.ref);
                return;
            case $277dfbc9b64034b1$var$Ub:
                throw Error($277dfbc9b64034b1$var$k(257));
            case $277dfbc9b64034b1$var$dc:
                var d = c._init;
                c = d(c._payload);
                $277dfbc9b64034b1$var$Z(a, b, c);
                return;
        }
        if ($277dfbc9b64034b1$var$ra(c)) {
            $277dfbc9b64034b1$var$bd(a, b, c);
            return;
        }
        null === c || "object" !== typeof c ? d = null : (d = $277dfbc9b64034b1$var$ic && c[$277dfbc9b64034b1$var$ic] || c["@@iterator"], d = "function" === typeof d ? d : null);
        if (d && (d = d.call(c))) {
            c = d.next();
            if (!c.done) {
                var f = [];
                do f.push(c.value), c = d.next();
                while (!c.done);
                $277dfbc9b64034b1$var$bd(a, b, f);
            }
            return;
        }
        a = Object.prototype.toString.call(c);
        throw Error($277dfbc9b64034b1$var$k(31, "[object Object]" === a ? "object with keys {" + Object.keys(c).join(", ") + "}" : a));
    }
    "string" === typeof c ? (d = b.blockedSegment, d.lastPushedText = $277dfbc9b64034b1$var$Da(b.blockedSegment.chunks, c, a.responseState, d.lastPushedText)) : "number" === typeof c && (d = b.blockedSegment, d.lastPushedText = $277dfbc9b64034b1$var$Da(b.blockedSegment.chunks, "" + c, a.responseState, d.lastPushedText));
}
function $277dfbc9b64034b1$var$bd(a, b, c) {
    for(var d = c.length, f = 0; f < d; f++){
        var e = b.treeContext;
        b.treeContext = $277dfbc9b64034b1$var$tc(e, d, f);
        try {
            $277dfbc9b64034b1$var$$c(a, b, c[f]);
        } finally{
            b.treeContext = e;
        }
    }
}
function $277dfbc9b64034b1$var$$c(a, b, c) {
    var d = b.blockedSegment.formatContext, f = b.legacyContext, e = b.context;
    try {
        return $277dfbc9b64034b1$var$Z(a, b, c);
    } catch (m) {
        if ($277dfbc9b64034b1$var$Gc(), "object" === typeof m && null !== m && "function" === typeof m.then) {
            c = m;
            var g = b.blockedSegment, h = $277dfbc9b64034b1$var$Sc(a, g.chunks.length, null, g.formatContext, g.lastPushedText, !0);
            g.children.push(h);
            g.lastPushedText = !1;
            a = $277dfbc9b64034b1$var$Tc(a, b.node, b.blockedBoundary, h, b.abortSet, b.legacyContext, b.context, b.treeContext).ping;
            c.then(a, a);
            b.blockedSegment.formatContext = d;
            b.legacyContext = f;
            b.context = e;
            $277dfbc9b64034b1$var$Q(e);
        } else throw b.blockedSegment.formatContext = d, b.legacyContext = f, b.context = e, $277dfbc9b64034b1$var$Q(e), m;
    }
}
function $277dfbc9b64034b1$var$cd(a) {
    var b = a.blockedBoundary;
    a = a.blockedSegment;
    a.status = 3;
    $277dfbc9b64034b1$var$dd(this, b, a);
}
function $277dfbc9b64034b1$var$ed(a, b, c) {
    var d = a.blockedBoundary;
    a.blockedSegment.status = 3;
    null === d ? (b.allPendingTasks--, 2 !== b.status && (b.status = 2, null !== b.destination && b.destination.close())) : (d.pendingTasks--, d.forceClientRender || (d.forceClientRender = !0, a = void 0 === c ? Error($277dfbc9b64034b1$var$k(432)) : c, d.errorDigest = b.onError(a), d.parentFlushed && b.clientRenderedBoundaries.push(d)), d.fallbackAbortableTasks.forEach(function(a) {
        return $277dfbc9b64034b1$var$ed(a, b, c);
    }), d.fallbackAbortableTasks.clear(), b.allPendingTasks--, 0 === b.allPendingTasks && (d = b.onAllReady, d()));
}
function $277dfbc9b64034b1$var$ad(a, b) {
    if (0 === b.chunks.length && 1 === b.children.length && null === b.children[0].boundary) {
        var c = b.children[0];
        c.id = b.id;
        c.parentFlushed = !0;
        1 === c.status && $277dfbc9b64034b1$var$ad(a, c);
    } else a.completedSegments.push(b);
}
function $277dfbc9b64034b1$var$dd(a, b, c) {
    if (null === b) {
        if (c.parentFlushed) {
            if (null !== a.completedRootSegment) throw Error($277dfbc9b64034b1$var$k(389));
            a.completedRootSegment = c;
        }
        a.pendingRootTasks--;
        0 === a.pendingRootTasks && (a.onShellError = $277dfbc9b64034b1$var$X, b = a.onShellReady, b());
    } else b.pendingTasks--, b.forceClientRender || (0 === b.pendingTasks ? (c.parentFlushed && 1 === c.status && $277dfbc9b64034b1$var$ad(b, c), b.parentFlushed && a.completedBoundaries.push(b), b.fallbackAbortableTasks.forEach($277dfbc9b64034b1$var$cd, a), b.fallbackAbortableTasks.clear()) : c.parentFlushed && 1 === c.status && ($277dfbc9b64034b1$var$ad(b, c), 1 === b.completedSegments.length && b.parentFlushed && a.partialBoundaries.push(b)));
    a.allPendingTasks--;
    0 === a.allPendingTasks && (a = a.onAllReady, a());
}
function $277dfbc9b64034b1$var$Uc(a) {
    if (2 !== a.status) {
        var b = $277dfbc9b64034b1$var$O, c = $277dfbc9b64034b1$var$Pc.current;
        $277dfbc9b64034b1$var$Pc.current = $277dfbc9b64034b1$var$Oc;
        var d = $277dfbc9b64034b1$var$Nc;
        $277dfbc9b64034b1$var$Nc = a.responseState;
        try {
            var f = a.pingedTasks, e;
            for(e = 0; e < f.length; e++){
                var g = f[e];
                var h = a, m = g.blockedSegment;
                if (0 === m.status) {
                    $277dfbc9b64034b1$var$Q(g.context);
                    try {
                        $277dfbc9b64034b1$var$Z(h, g, g.node), m.lastPushedText && m.textEmbedded && m.chunks.push($277dfbc9b64034b1$var$Ca), g.abortSet.delete(g), m.status = 1, $277dfbc9b64034b1$var$dd(h, g.blockedBoundary, m);
                    } catch (G) {
                        if ($277dfbc9b64034b1$var$Gc(), "object" === typeof G && null !== G && "function" === typeof G.then) {
                            var q = g.ping;
                            G.then(q, q);
                        } else {
                            g.abortSet.delete(g);
                            m.status = 4;
                            var r = g.blockedBoundary, v = G, A = $277dfbc9b64034b1$var$Y(h, v);
                            null === r ? $277dfbc9b64034b1$var$Vc(h, v) : (r.pendingTasks--, r.forceClientRender || (r.forceClientRender = !0, r.errorDigest = A, r.parentFlushed && h.clientRenderedBoundaries.push(r)));
                            h.allPendingTasks--;
                            if (0 === h.allPendingTasks) {
                                var F = h.onAllReady;
                                F();
                            }
                        }
                    } finally{}
                }
            }
            f.splice(0, e);
            null !== a.destination && $277dfbc9b64034b1$var$fd(a, a.destination);
        } catch (G) {
            $277dfbc9b64034b1$var$Y(a, G), $277dfbc9b64034b1$var$Vc(a, G);
        } finally{
            $277dfbc9b64034b1$var$Nc = d, $277dfbc9b64034b1$var$Pc.current = c, c === $277dfbc9b64034b1$var$Oc && $277dfbc9b64034b1$var$Q(b);
        }
    }
}
function $277dfbc9b64034b1$var$gd(a, b, c) {
    c.parentFlushed = !0;
    switch(c.status){
        case 0:
            var d = c.id = a.nextSegmentId++;
            c.lastPushedText = !1;
            c.textEmbedded = !1;
            a = a.responseState;
            $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$Va);
            $277dfbc9b64034b1$var$p(b, a.placeholderPrefix);
            a = $277dfbc9b64034b1$var$u(d.toString(16));
            $277dfbc9b64034b1$var$p(b, a);
            return $277dfbc9b64034b1$var$t(b, $277dfbc9b64034b1$var$Wa);
        case 1:
            c.status = 2;
            var f = !0;
            d = c.chunks;
            var e = 0;
            c = c.children;
            for(var g = 0; g < c.length; g++){
                for(f = c[g]; e < f.index; e++)$277dfbc9b64034b1$var$p(b, d[e]);
                f = $277dfbc9b64034b1$var$hd(a, b, f);
            }
            for(; e < d.length - 1; e++)$277dfbc9b64034b1$var$p(b, d[e]);
            e < d.length && (f = $277dfbc9b64034b1$var$t(b, d[e]));
            return f;
        default:
            throw Error($277dfbc9b64034b1$var$k(390));
    }
}
function $277dfbc9b64034b1$var$hd(a, b, c) {
    var d = c.boundary;
    if (null === d) return $277dfbc9b64034b1$var$gd(a, b, c);
    d.parentFlushed = !0;
    if (d.forceClientRender) d = d.errorDigest, $277dfbc9b64034b1$var$t(b, $277dfbc9b64034b1$var$$a), $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$bb), d && ($277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$db), $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$C(d))), $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$cb)), $277dfbc9b64034b1$var$t(b, $277dfbc9b64034b1$var$eb), $277dfbc9b64034b1$var$gd(a, b, c);
    else if (0 < d.pendingTasks) {
        d.rootSegmentID = a.nextSegmentId++;
        0 < d.completedSegments.length && a.partialBoundaries.push(d);
        var f = a.responseState;
        var e = f.nextSuspenseID++;
        f = $277dfbc9b64034b1$var$w(f.boundaryPrefix + e.toString(16));
        d = d.id = f;
        $277dfbc9b64034b1$var$fb(b, a.responseState, d);
        $277dfbc9b64034b1$var$gd(a, b, c);
    } else if (d.byteSize > a.progressiveChunkSize) d.rootSegmentID = a.nextSegmentId++, a.completedBoundaries.push(d), $277dfbc9b64034b1$var$fb(b, a.responseState, d.id), $277dfbc9b64034b1$var$gd(a, b, c);
    else {
        $277dfbc9b64034b1$var$t(b, $277dfbc9b64034b1$var$Xa);
        c = d.completedSegments;
        if (1 !== c.length) throw Error($277dfbc9b64034b1$var$k(391));
        $277dfbc9b64034b1$var$hd(a, b, c[0]);
    }
    return $277dfbc9b64034b1$var$t(b, $277dfbc9b64034b1$var$ab);
}
function $277dfbc9b64034b1$var$id(a, b, c) {
    $277dfbc9b64034b1$var$Bb(b, a.responseState, c.formatContext, c.id);
    $277dfbc9b64034b1$var$hd(a, b, c);
    return $277dfbc9b64034b1$var$Cb(b, c.formatContext);
}
function $277dfbc9b64034b1$var$jd(a, b, c) {
    for(var d = c.completedSegments, f = 0; f < d.length; f++)$277dfbc9b64034b1$var$kd(a, b, c, d[f]);
    d.length = 0;
    a = a.responseState;
    d = c.id;
    c = c.rootSegmentID;
    $277dfbc9b64034b1$var$p(b, a.startInlineScript);
    a.sentCompleteBoundaryFunction ? $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$Jb) : (a.sentCompleteBoundaryFunction = !0, $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$Ib));
    if (null === d) throw Error($277dfbc9b64034b1$var$k(395));
    c = $277dfbc9b64034b1$var$u(c.toString(16));
    $277dfbc9b64034b1$var$p(b, d);
    $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$Kb);
    $277dfbc9b64034b1$var$p(b, a.segmentPrefix);
    $277dfbc9b64034b1$var$p(b, c);
    return $277dfbc9b64034b1$var$t(b, $277dfbc9b64034b1$var$Lb);
}
function $277dfbc9b64034b1$var$kd(a, b, c, d) {
    if (2 === d.status) return !0;
    var f = d.id;
    if (-1 === f) {
        if (-1 === (d.id = c.rootSegmentID)) throw Error($277dfbc9b64034b1$var$k(392));
        return $277dfbc9b64034b1$var$id(a, b, d);
    }
    $277dfbc9b64034b1$var$id(a, b, d);
    a = a.responseState;
    $277dfbc9b64034b1$var$p(b, a.startInlineScript);
    a.sentCompleteSegmentFunction ? $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$Eb) : (a.sentCompleteSegmentFunction = !0, $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$Db));
    $277dfbc9b64034b1$var$p(b, a.segmentPrefix);
    f = $277dfbc9b64034b1$var$u(f.toString(16));
    $277dfbc9b64034b1$var$p(b, f);
    $277dfbc9b64034b1$var$p(b, $277dfbc9b64034b1$var$Gb);
    $277dfbc9b64034b1$var$p(b, a.placeholderPrefix);
    $277dfbc9b64034b1$var$p(b, f);
    return $277dfbc9b64034b1$var$t(b, $277dfbc9b64034b1$var$Hb);
}
function $277dfbc9b64034b1$var$fd(a, b) {
    $277dfbc9b64034b1$var$l = new Uint8Array(512);
    $277dfbc9b64034b1$var$n = 0;
    try {
        var c = a.completedRootSegment;
        if (null !== c && 0 === a.pendingRootTasks) {
            $277dfbc9b64034b1$var$hd(a, b, c);
            a.completedRootSegment = null;
            var d = a.responseState.bootstrapChunks;
            for(c = 0; c < d.length - 1; c++)$277dfbc9b64034b1$var$p(b, d[c]);
            c < d.length && $277dfbc9b64034b1$var$t(b, d[c]);
        }
        var f = a.clientRenderedBoundaries, e;
        for(e = 0; e < f.length; e++){
            var g = f[e];
            d = b;
            var h = a.responseState, m = g.id, q = g.errorDigest, r = g.errorMessage, v = g.errorComponentStack;
            $277dfbc9b64034b1$var$p(d, h.startInlineScript);
            h.sentClientRenderFunction ? $277dfbc9b64034b1$var$p(d, $277dfbc9b64034b1$var$Nb) : (h.sentClientRenderFunction = !0, $277dfbc9b64034b1$var$p(d, $277dfbc9b64034b1$var$Mb));
            if (null === m) throw Error($277dfbc9b64034b1$var$k(395));
            $277dfbc9b64034b1$var$p(d, m);
            $277dfbc9b64034b1$var$p(d, $277dfbc9b64034b1$var$Ob);
            if (q || r || v) $277dfbc9b64034b1$var$p(d, $277dfbc9b64034b1$var$Qb), $277dfbc9b64034b1$var$p(d, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$Sb(q || "")));
            if (r || v) $277dfbc9b64034b1$var$p(d, $277dfbc9b64034b1$var$Qb), $277dfbc9b64034b1$var$p(d, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$Sb(r || "")));
            v && ($277dfbc9b64034b1$var$p(d, $277dfbc9b64034b1$var$Qb), $277dfbc9b64034b1$var$p(d, $277dfbc9b64034b1$var$u($277dfbc9b64034b1$var$Sb(v))));
            if (!$277dfbc9b64034b1$var$t(d, $277dfbc9b64034b1$var$Pb)) {
                a.destination = null;
                e++;
                f.splice(0, e);
                return;
            }
        }
        f.splice(0, e);
        var A = a.completedBoundaries;
        for(e = 0; e < A.length; e++)if (!$277dfbc9b64034b1$var$jd(a, b, A[e])) {
            a.destination = null;
            e++;
            A.splice(0, e);
            return;
        }
        A.splice(0, e);
        $277dfbc9b64034b1$var$ba(b);
        $277dfbc9b64034b1$var$l = new Uint8Array(512);
        $277dfbc9b64034b1$var$n = 0;
        var F = a.partialBoundaries;
        for(e = 0; e < F.length; e++){
            var G = F[e];
            a: {
                f = a;
                g = b;
                var ma = G.completedSegments;
                for(h = 0; h < ma.length; h++)if (!$277dfbc9b64034b1$var$kd(f, g, G, ma[h])) {
                    h++;
                    ma.splice(0, h);
                    var Fb = !1;
                    break a;
                }
                ma.splice(0, h);
                Fb = !0;
            }
            if (!Fb) {
                a.destination = null;
                e++;
                F.splice(0, e);
                return;
            }
        }
        F.splice(0, e);
        var na = a.completedBoundaries;
        for(e = 0; e < na.length; e++)if (!$277dfbc9b64034b1$var$jd(a, b, na[e])) {
            a.destination = null;
            e++;
            na.splice(0, e);
            return;
        }
        na.splice(0, e);
    } finally{
        $277dfbc9b64034b1$var$ba(b), 0 === a.allPendingTasks && 0 === a.pingedTasks.length && 0 === a.clientRenderedBoundaries.length && 0 === a.completedBoundaries.length && b.close();
    }
}
function $277dfbc9b64034b1$var$ld(a, b) {
    try {
        var c = a.abortableTasks;
        c.forEach(function(c) {
            return $277dfbc9b64034b1$var$ed(c, a, b);
        });
        c.clear();
        null !== a.destination && $277dfbc9b64034b1$var$fd(a, a.destination);
    } catch (d) {
        $277dfbc9b64034b1$var$Y(a, d), $277dfbc9b64034b1$var$Vc(a, d);
    }
}
$277dfbc9b64034b1$export$7020a3240b287705 = function(a, b) {
    return new Promise(function(c, d) {
        var f, e, g = new Promise(function(a, b) {
            e = a;
            f = b;
        }), h = $277dfbc9b64034b1$var$Rc(a, $277dfbc9b64034b1$var$za(b ? b.identifierPrefix : void 0, b ? b.nonce : void 0, b ? b.bootstrapScriptContent : void 0, b ? b.bootstrapScripts : void 0, b ? b.bootstrapModules : void 0), $277dfbc9b64034b1$var$Aa(b ? b.namespaceURI : void 0), b ? b.progressiveChunkSize : void 0, b ? b.onError : void 0, e, function() {
            var a = new ReadableStream({
                type: "bytes",
                pull: function(a) {
                    if (1 === h.status) h.status = 2, $277dfbc9b64034b1$var$da(a, h.fatalError);
                    else if (2 !== h.status && null === h.destination) {
                        h.destination = a;
                        try {
                            $277dfbc9b64034b1$var$fd(h, a);
                        } catch (A) {
                            $277dfbc9b64034b1$var$Y(h, A), $277dfbc9b64034b1$var$Vc(h, A);
                        }
                    }
                },
                cancel: function() {
                    $277dfbc9b64034b1$var$ld(h);
                }
            }, {
                highWaterMark: 0
            });
            a.allReady = g;
            c(a);
        }, function(a) {
            g.catch(function() {});
            d(a);
        }, f);
        if (b && b.signal) {
            var m = b.signal, q = function() {
                $277dfbc9b64034b1$var$ld(h, m.reason);
                m.removeEventListener("abort", q);
            };
            m.addEventListener("abort", q);
        }
        $277dfbc9b64034b1$var$Uc(h);
    });
};
$277dfbc9b64034b1$export$83d89fbfd8236492 = "18.2.0";

});

var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
'use strict';
var $11492dca620dcaa5$exports = {};
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

$11492dca620dcaa5$exports = (parcelRequire("Xw6Mv"));


var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $11492dca620dcaa5$exports.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $11492dca620dcaa5$exports.hydrateRoot;



parcelRequire("acw62");

parcelRequire("acw62");
var $3d2cc403ee648109$exports = {};
$3d2cc403ee648109$exports = JSON.parse('{"boot.subtitle":"War of Independence \xb7 1919","brand.title":"Independence","intro.date":"19 May 1919 \xb7 Samsun","intro.subtitle":"A nation under occupation. Independence to be won.","intro.begin":"Begin the struggle","intro.loading":"Loading map\u2026","intro.caption":"A strategy game of the Turkish War of Independence","hud.dateRound":"{date} \xb7 Round {round}","tooltip.territory":"{name} \u2014 {faction}, {troops} units","phase.reinforce":"Reinforce","phase.attack":"Attack","phase.fortify":"Fortify","phase.gameover":"War Over","phase.help.reinforce":"Click your territories to deploy units.","phase.help.attack":"Begin up to {attacks} battles. An advancing army may conquer 2 territories in succession. Conquer land to earn a card.","phase.help.fortify":"Move units between adjacent friendly lands, or end your turn.","hud.advanceHelp":"Choose how many units march in. The rest hold the province they attacked from.","hud.landingHelp":"The port fell while your troops were at sea. Storm the beach, or turn back home?","hud.landingStorm":"Storm {territory}","hud.landingFallBack":"Turn back to {territory}","hud.left":"left","hud.moves":"moves","hud.attacks":"attacks","hud.advanceDepth":"advance depth {current}","hud.pact":"Misak-\u0131 Mill\xee","hud.requisition":"Tek\xe2lif-i Milliye \xb7 {n} rounds","hud.requisitionTitle":"The first two exchanges of each homeland battle are rolled with 3 dice instead of 2 \u2014 at the cost of 3 reinforcements a turn and no militia growth.","hud.trade":"Trade +{n}","hud.autoDeploy":"Auto-deploy {n}","hud.endAttacks":"End attacks","hud.endTurn":"End turn","hud.skipEndTurn":"Skip & end turn","hud.halfMax":"(half max)","hud.mubadeleTransferLimit":"(M\xfcbadale: half capacity)","hud.half":"Half","hud.all":"All {n}","hud.aiThinking":"{faction} is on the move\u2026","hud.cardHandTitle":"Conquer a territory to earn a card. 3 alike or one of each trades for units.","hud.falls":"{territory} falls! \u2212{atkLoss} / \u2212{defLoss}","hud.battleTally":"{from} {fromN} vs {to} {toN} \xb7 \u2212{atkLoss} / \u2212{defLoss}","hud.press":"Press attack","hud.blitz":"Blitz","hud.pullBack":"Pull back","hud.repelled":"Repelled at {territory} \u2212{atkLoss} / \u2212{defLoss}","log.gameStart":"The War of Independence begins. Reclaim the homeland, Pasha!","log.tradeCards":"{faction} trades a card set for {bonus} extra units","log.peaceBroken":"\u2694\uFE0F {attacker} broke the peace \u2014 {defender} mobilizes for war again!","log.armeniaRemobilizes":"\uD83E\uDE96 Armenia raises an emergency pool of {n} units to distribute next turn.","log.karsConcessions":"\uD83D\uDCDC Under the Treaty of Kars Armenia withdraws from {territories}; each returns to its homeland owner.","log.knockedOut":"{faction} has been knocked out of the war!","log.captured":"{attacker} captured {territory} from {defender} (lost {atkLoss}, killed {defLoss})","log.repelled":"{attacker} attacked {territory} of {defender} and was repelled (lost {atkLoss}, killed {defLoss})","log.italyConcedes":"\uD83D\uDD4A\uFE0F Italy evacuates the southwest without a fight \u2014 {territories} pass to Ankara.","log.franceConcedes":"\uD83D\uDD4A\uFE0F Under the Ankara Agreement France withdraws from Cilicia \u2014 {territories} pass to Ankara.","log.turkeyFallen":"Turkey has fallen. The occupation is complete.","log.victory":"The borders of Misak-\u0131 Mill\xee are reached in {date} \u2014 the homeland is free. Victory!","event.erzurumCongress":"\uD83D\uDCDC The Erzurum Congress (23 July 1919) \u2014 delegates of the eastern provinces declare that the nation will resist partition and accept no mandate. A regional resistance becomes an organized eastern front.","event.sivasCongress":"\uD83D\uDCDC The Sivas Congress (4 September 1919) \u2014 the regional defence-of-rights societies merge under one representative committee. Resistance becomes a national movement with deeper reach.","event.sanRemo":"\uD83D\uDCDC The Conference of San Remo (19 April 1920) \u2014 the Allies end their administration of Western Thrace and clear the way for the Greek claim. A new Greek\u2013Bulgarian rivalry opens in Thrace and Macedonia.","event.tekalif":"\u2696\uFE0F The National Tax Orders (August 1921) \u2014 the Greek army stands two marches from Ankara. The Assembly may requisition 40% of the nation\u2019s food, cloth, boots and transport to equip the army for a decisive stand. It conscripts no one: the army will strike harder on home soil, but reinforcement and local organization will suffer while the orders remain.","event.tekalif.requisition.log":"\u2696\uFE0F Tek\xe2lif-i Milliye proclaimed \u2014 the nation is stripped to equip the army.","event.tekalif.decline.log":"\u2696\uFE0F The requisition is declined \u2014 the people are spared, and the army fights as it is.","event.conference":"\uD83D\uDCDC The Conference of Lausanne convenes \u2014 the powers offer terms on the borders as they stand. You hold {held} of {total} National Pact provinces. Sign, and the war ends there. Refuse, and they will come back for the rest.","event.conference.accept.log":"\uD83D\uDCDC Terms accepted at Lausanne \u2014 the war is over.","event.conference.reject.log":"\u2694\uFE0F Terms refused \u2014 the delegation walks out and the war goes on.","log.termsRefused":"\u2694\uFE0F Ankara refuses the terms. The powers will return in force.","log.landing":"\u2693 {faction} lands {n} units at {territory} and takes it.","log.landingRepelled":"\u2693 {faction} attempts a landing at {territory} with {n} units and is thrown back into the sea.","log.landingUnopposed":"\u2693 {faction} puts another {n} units ashore at {territory}, unopposed.","log.embark":"\u26F5 {faction} embarks {n} units at {from} for {to}.","tooltip.convoy":"{faction} \u2014 {troops} units at sea, bound for {to} ({rounds} rounds out)","tooltip.convoyLast":"{faction} \u2014 {troops} units at sea, bound for {to} (ashore next round)","log.convoyLanded":"\u2693 {faction} lands {n} units at {territory}.","log.convoyTurnedBack":"\u21A9\uFE0E The port was lost mid-crossing \u2014 {faction} turns {n} units back toward {territory}.","log.convoyReturned":"\u2693 {faction} brings {n} units back to {territory}.","event.lausanne":"\uD83D\uDCDC The Conference of Lausanne settles the peace \u2014 the borders as they now stand become the borders of the Republic. The war is over.","log.assemblySuspended":"\u26A0\uFE0F The Assembly is driven from its seat \u2014 the government cannot sit, and everything that depends on it halts.","log.assemblyReconvened":"\uD83D\uDCDC The Assembly reconvenes in {city} \u2014 the government sits again.","log.tekalifWindow":"The army is equipped and moving \u2014 3 attack dice in the homeland until {until}","log.lausanneShort":"Lausanne settles with {held} of {total} National Pact provinces in Turkish hands. The rest stay lost.","event.istanbulOccupied":"\uD83D\uDCDC The Allies occupy \u0130stanbul (16 March 1920) \u2014 the capital is taken by force and the Ottoman parliament dissolved. The city passes to Britain, and the movement\u2019s centre of gravity shifts to Ankara for good.","event.sevres":"\uD83D\uDCDC The Treaty of S\xe8vres (10 August 1920) \u2014 the Porte signs away the partition of the country. Recruitment reels under the dictated peace, but outrage gradually hardens resistance into a nation in arms.","event.ethem":"\u2694\uFE0F \xc7erkes Ethem\u2019s revolt (December 1920) \u2014 the Kuv\xe2-yi Seyyare irregulars turn on the regular army, throwing western garrisons into disorder and tearing up their defences.","event.inonu":"\u2694\uFE0F \u0130n\xf6n\xfc (March 1921) \u2014 the line in front of Eski\u015Fehir holds and the Greek advance is thrown back. The force before the city is broken, and Ankara wins its first recognition abroad.","event.sakarya":"\u2694\uFE0F Sakarya (23 August \u2013 13 September 1921) \u2014 after twenty-two days and nights on the river, the Greek advance ends for good. Its army is stunned and never fully recovers the offensive initiative.","event.greekOffensive":"\u2694\uFE0F The Greek summer offensive (July 1921) \u2014 under the royalist government, months after Venizelos fell, the army drives east through K\xfctahya and Eski\u015Fehir toward the Sakarya, the deepest it ever reaches. The Greek front in Anatolia is reinforced and dug in.","event.karsTreaty":"\uD83D\uDCDC The Treaty of Kars (13 October 1921) \u2014 Armenia restores its conquests to their homeland owners, the northeastern frontier is settled, and the war between Ankara and Yerevan closes.","event.mudanya":"\uD83D\uDCDC The Armistice of Mudanya (11 October 1922) \u2014 with the city encircled, Britain gives up \u0130stanbul rather than fight for it. The capital returns without a shot, and the British garrison redeploys to what London still holds.","log.ethemRevolt":"The revolt costs {n} units and their entrenchments across {territories}","log.greekOffensive":"\u2694\uFE0F The summer offensive puts {n} units onto the Greek front and digs it in","log.mudanyaRedeploy":"The British garrison of {n} withdraws from \u0130stanbul, redeployed across {territories} provinces","event.lloydGeorge":"\uD83D\uDCDC Lloyd George falls (19 October 1922) \u2014 the Chanak crisis brings down the government that backed the Greek campaign, because Britain will not fight Turkey a second time. British forces will hold what they have and start nothing.","event.sultanate":"\uD83D\uDCDC The Sultanate is abolished (1 November 1922) \u2014 there is no longer a rival government in occupied \u0130stanbul. One authority and one command now direct the Turkish armies.","event.greekCollapse":"\u2694\uFE0F The Greek army collapses \u2014 the officers revolt, the king abdicates, and the ministers who lost Anatolia are shot. The Greek war effort loses its ability to recover.","event.mubadele":"\uD83D\uDCDC The Convention on the Exchange of Populations (30 January 1923) \u2014 uprooted communities are resettled across the Aegean, straining transport and administration on both shores.","event.caliphate":"\uD83D\uDCDC The Caliphate is abolished (3 March 1924) \u2014 the last institution of the old order is gone, and the Assembly answers to nobody above it.","event.mosulQuestion":"\uD83D\uDCDC The Mosul question (October 1924) \u2014 the League draws the Brussels line in Britain\u2019s favour and folds its Mesopotamian possessions into the new Kingdom of Iraq, placing Ankara\u2019s claim in peril.","event.sheikhSaid":"\u2694\uFE0F The Sheikh Said rebellion (13 February 1925) \u2014 a year after the Caliphate is abolished, the east rises, draining garrisons and undoing hard-won defences.","log.sheikhSaid":"The rising costs {n} units and their entrenchments across {territories}","log.mosulCeded":"The League awards {territories} to the Kingdom of Iraq","event.venizelos":"\uD83D\uDCDC Venizelos falls in the Greek elections \u2014 Allied support wanes. Greek reinforcements drop.","event.alexandropol":"\uD83D\uDCDC Treaty of Alexandropol \u2014 Armenia sues for peace and lays down its arms. If Ankara breaks the peace, Armenia will remobilize.","event.italyWithdraws":"\uD83D\uDCDC Italy begins withdrawing from Anatolia \u2014 Italian deployments and offensives cease.","event.ankaraAgreement":"\uD83D\uDCDC Ankara Agreement \u2014 France makes peace with Ankara and goes on the defensive.","event.exhaustion":"\uD83D\uDCDC The occupation has become politically untenable \u2014 the foreign powers\u2019 will and ability to sustain the Anatolian campaign wither.","event.tbmm":"\uD83D\uDCDC The Grand National Assembly opens in {city}, {date} \u2014 a government, a unified command and a national mandate: the movement can raise far more units from the land it holds.","event.sovietAid1":"\uD83D\uDCDC The first Soviet gold and rifles land \u2014 Ankara can raise better-armed units.","event.sovietAid2":"\uD83D\uDCDC Treaty of Moscow \u2014 a major shipment of rifles, machine guns and artillery reaches the front, strengthening the national army.","event.greatOffensive":"\u2694\uFE0F The Great Offensive \u2014 the army massed at Afyon breaks the Greek line. The regular army seizes the initiative, fights at full strength and can drive deeper through the homeland.","overlay.victory.title":"Zafer!","overlay.victory.body":"The borders of Misak-\u0131 Mill\xee were reached in {date}. The occupying powers have been driven out and the Republic will be proclaimed. Long live the Republic!","overlay.beyond.title":"Victory, and More","overlay.beyond.body":"You reached the aims of Misak-\u0131 Mill\xee in {date}, and annexed {named} on top of them. Ankara goes to Lausanne with the stronger hand. Long live the Republic!","overlay.total.title":"Absolute Victory!","overlay.total.body":"You did not just free the homeland in {date}, you widened its borders. The Turkish flag flies everywhere on the map. There is nothing left to bargain over at Lausanne: only one side sits at the table. Long live the Republic!","overlay.defeat.title":"Defeat","overlay.defeat.body":"Turkey was eliminated in {date}. The homeland remains under occupation, and there is no army left to contest it.","overlay.lausanne.near.title":"Peace, Just Short","overlay.lausanne.near.body":"The conference settled in {date} with {held} of {total} provinces in Turkish hands. The Republic is founded and the occupation is over \u2014 but {named} stayed on the other side of the line, and the borders drawn here will not be redrawn.","overlay.lausanne.partial.title":"A Truncated Peace","overlay.lausanne.partial.body":"The conference settled in {date} with {held} of {total} provinces recovered. A Turkish state survives and will be a republic, but {missing} of the provinces the National Pact claimed are signed away. The war is over; the map is not what was sworn.","overlay.lausanne.poor.title":"Peace on Their Terms","overlay.lausanne.poor.body":"The conference settled in {date} with only {held} of {total} provinces held. The powers wrote the terms and Ankara signed them. A rump state remains \u2014 the homeland the National Pact described is gone.","overlay.playAgain":"Play again","dialog.ok":"OK","dialog.cancel":"Cancel","card.dismiss":"Continue","card.choice.accept":"Sign the treaty","card.choice.reject":"Fight on","card.choice.requisition":"Proclaim the orders","card.choice.decline":"Spare the people","menu.title":"Settings","menu.language":"Language","menu.display":"Display","menu.fullscreen":"Full screen","menu.exitFullscreen":"Leave full screen","menu.installHint":"Add this to your home screen and it opens without the browser bars.","menu.sound":"Sound","menu.musicOn":"Turn music on","menu.musicOff":"Turn music off","menu.musicVolume":"Music volume","menu.volumeValue":"{volume}%","menu.sfxOn":"Turn sound effects on","menu.sfxOff":"Turn sound effects off","menu.sfxVolume":"Sound effects volume","menu.saves":"Saved games","menu.saveCurrent":"Save current game","menu.noSaves":"No saved games yet.","menu.load":"Load","menu.delete":"Delete","menu.saveNamePrompt":"Name this save","menu.defaultSaveName":"{date} \xb7 {pact}/30","menu.confirmLoad":"Load this save? The current game will be lost.","menu.confirmDelete":"Delete this save?","menu.saveFailed":"Could not save \u2014 browser storage is full or unavailable.","menu.loadFailed":"Could not load that save.","menu.savedRound":"Round {round} \xb7 {date}","lang.switcher.title":"Language","lang.en":"English","lang.tr":"T\xfcrk\xe7e","trait.Turkey":"Mobilization deepens in stages \u2014 territory \xf72 and a 25% exhaustion loss in 1919, \xf71.5 and 10% from the Assembly (Apr 1920), no loss from the Great Offensive (Aug 1922). Kuv\xe2-yi Milliye: +2 reinforcements, +3 once Soviet arms land (Sept 1920). Interior lines: 2 fortify moves. Every faction may begin 3 battles per turn and an advancing army may cross 2 provinces; the Great Offensive raises Turkey\'s advance to 3 inside Misak-\u0131 Mill\xee. Invaders in the homeland roll at most 2 dice until the Great Offensive (Aug 1922). Until the Great Offensive (Aug 1922) Turkey attacks with 2 dice and defends the homeland with 2; from then it attacks and defends with 3. Invaders roll at most 2 against the homeland until then. Proclaiming Tek\xe2lif-i Milliye (Aug 1921) opens a 3-round window in which the first two exchanges of each homeland battle use 3 dice, at \u22123 reinforcements a turn and no militia growth. Liberating a homeland province rallies local militia to it: before the offensive, +2 if it is retaken within a turn of falling and +1 once the occupiers have settled in, on every province freed. From the offensive onward only the first province freed each turn draws a garrison, and it draws +1.","trait.Greece":"Overseas supply: fortify moves at most half a garrison. Salonica stops levying when Venizelos falls; the field levy thins after Sakarya.","trait.Britain":"Demobilization: \u22122 reinforcements. Entente member.","trait.France":"Entente member. The Ankara Agreement makes peace and concedes French conquests to their homeland owners (passive, half reinforcements).","trait.Italy":"Entente member. Its withdrawal card concedes Italian conquests to their homeland owners (passive, no reinforcements).","trait.Armenia":"Entente-aligned. Once the Assembly is active, Alexandropol ends Armenian attacks and reinforcements when signed. If Turkey breaks that peace, Armenia remobilizes with 20 emergency units and can attack freely until Kars. Once Armenia holds its four-province homeland and nothing in the National Pact, Kars confines every Armenian attack to that homeland, returns all other conquests to their homeland owners, and prevents Turkey from attacking Armenia.","trait.Bulgaria":"Neuilly arms cap: max 3 reinforcements. Neutral, but Greece is a rival."}');


var $efbe095757b33555$exports = {};
$efbe095757b33555$exports = JSON.parse('{"boot.subtitle":"Kurtulu\u015F Sava\u015F\u0131 \xb7 1919","brand.title":"Kurtulu\u015F","intro.date":"19 May\u0131s 1919 \xb7 Samsun","intro.subtitle":"\u0130\u015Fgal edilen bir vatan. Kazan\u0131lacak bir istiklal.","intro.begin":"M\xfccadeleyi ba\u015Flat","intro.loading":"Harita y\xfckleniyor\u2026","intro.caption":"Kurtulu\u015F Sava\u015F\u0131 \xfczerine bir strateji oyunu","hud.dateRound":"{date} \xb7 {round}. Tur","tooltip.territory":"{name} \u2014 {faction}, {troops} birlik","phase.reinforce":"Takviye","phase.attack":"Sald\u0131r\u0131","phase.fortify":"Tahkim","phase.gameover":"Sava\u015F Bitti","phase.help.reinforce":"Birlik konu\u015Fland\u0131rmak i\xe7in topraklar\u0131n\u0131za t\u0131klay\u0131n.","phase.help.attack":"En fazla {attacks} muharebe ba\u015Flat\u0131n. \u0130lerleyen bir ordu art arda 2 b\xf6lge fethedebilir. Toprak fethederek kart kazan\u0131n.","phase.help.fortify":"Kom\u015Fu dost topraklar aras\u0131nda birlik ta\u015F\u0131y\u0131n veya turunuzu bitirin.","hud.advanceHelp":"Ka\xe7 birlik ilerlesin? Kalanlar sald\u0131r\u0131n\u0131n ba\u015Flad\u0131\u011F\u0131 b\xf6lgeyi tutar.","hud.landingHelp":"Liman, birlikleriniz denizdeyken d\xfc\u015Ft\xfc. Karaya \xe7\u0131k\u0131p sald\u0131rs\u0131nlar m\u0131, yoksa geri mi d\xf6ns\xfcnler?","hud.landingStorm":"{territory} \xe7\u0131karmas\u0131","hud.landingFallBack":"{territory} liman\u0131na d\xf6n","hud.left":"kald\u0131","hud.moves":"hamle","hud.attacks":"sald\u0131r\u0131","hud.advanceDepth":"ilerleme derinli\u011Fi {current}","hud.pact":"Misak-\u0131 Mill\xee","hud.requisition":"Tek\xe2lif-i Milliye \xb7 {n} tur","hud.requisitionTitle":"Vatan topraklar\u0131ndaki her muharebenin ilk iki hamlesi 2 yerine 3 zarla at\u0131l\u0131r \u2014 turda 3 takviye eksi\u011Fi ve milis toplanamamas\u0131 pahas\u0131na.","hud.trade":"+{n} Takas","hud.autoDeploy":"Otomatik konu\u015Fland\u0131r {n}","hud.endAttacks":"Sald\u0131r\u0131lar\u0131 bitir","hud.endTurn":"Turu bitir","hud.skipEndTurn":"Ge\xe7 & turu bitir","hud.halfMax":"(yar\u0131s\u0131)","hud.mubadeleTransferLimit":"(M\xfcbadele: yar\u0131 kapasite)","hud.half":"Yar\u0131s\u0131","hud.all":"T\xfcm\xfc {n}","hud.aiThinking":"{faction} harekette\u2026","hud.cardHandTitle":"Kart kazanmak i\xe7in bir toprak fethedin. 3 ayn\u0131 ya da her t\xfcrden biri birlik ile takas edilir.","hud.falls":"{territory} d\xfc\u015Ft\xfc! \u2212{atkLoss} / \u2212{defLoss}","hud.battleTally":"{from} {fromN} \u2014 {to} {toN} \xb7 \u2212{atkLoss} / \u2212{defLoss}","hud.press":"Sald\u0131r","hud.blitz":"Sonuna kadar","hud.pullBack":"Geri \xe7ekil","hud.repelled":"{territoryLoc} p\xfcsk\xfcrt\xfcld\xfc \u2212{atkLoss} / \u2212{defLoss}","log.gameStart":"Kurtulu\u015F Sava\u015F\u0131 ba\u015Fl\u0131yor. Vatan\u0131 kurtar, Pa\u015Fam!","log.tradeCards":"{faction} bir kart tak\u0131m\u0131n\u0131 {bonus} ek birlikle takas etti","log.peaceBroken":"\u2694\uFE0F {attacker} bar\u0131\u015F\u0131 bozdu \u2014 {defender} yeniden sava\u015Fa haz\u0131rlan\u0131yor!","log.armeniaRemobilizes":"\uD83E\uDE96 Ermenistan, sonraki turda da\u011F\u0131tmak \xfczere {n} birliklik acil kuvvet topluyor.","log.karsConcessions":"\uD83D\uDCDC Kars Antla\u015Fmas\u0131 uyar\u0131nca Ermenistan {territories} b\xf6lgelerinden \xe7ekiliyor; her b\xf6lge kendi anayurt sahibine d\xf6n\xfcyor.","log.knockedOut":"{faction} sava\u015F d\u0131\u015F\u0131 kald\u0131!","log.captured":"{attacker}, {defender} kontrol\xfcndeki {territoryAcc} fethetti (kay\u0131p {atkLoss}, d\xfc\u015Fman kayb\u0131 {defLoss})","log.repelled":"{attacker}, {defender} kontrol\xfcndeki {territoryDat} sald\u0131rd\u0131 ve p\xfcsk\xfcrt\xfcld\xfc (kay\u0131p {atkLoss}, d\xfc\u015Fman kayb\u0131 {defLoss})","log.italyConcedes":"\uD83D\uDD4A\uFE0F \u0130talya g\xfcneybat\u0131y\u0131 \xe7at\u0131\u015Fmas\u0131z bo\u015Falt\u0131yor \u2014 {territories} Ankara\'ya ge\xe7ti.","log.franceConcedes":"\uD83D\uDD4A\uFE0F Ankara Antla\u015Fmas\u0131 uyar\u0131nca Fransa \xc7ukurova\'dan \xe7ekiliyor \u2014 {territories} Ankara\'ya ge\xe7ti.","log.turkeyFallen":"T\xfcrkiye d\xfc\u015Ft\xfc. \u0130\u015Fgal tamamland\u0131.","log.victory":"Misak-\u0131 Mill\xee s\u0131n\u0131rlar\u0131na {date} ula\u015F\u0131ld\u0131 \u2014 vatan \xf6zg\xfcr. Zafer!","event.erzurumCongress":"\uD83D\uDCDC Erzurum Kongresi (23 Temmuz 1919) \u2014 do\u011Fu illerinin delegeleri milletin par\xe7alanmaya direnece\u011Fini ve hi\xe7bir manday\u0131 kabul etmeyece\u011Fini ilan etti. B\xf6lgesel direni\u015F, \xf6rg\xfctl\xfc bir do\u011Fu cephesine d\xf6n\xfc\u015F\xfcyor.","event.sivasCongress":"\uD83D\uDCDC Sivas Kongresi (4 Eyl\xfcl 1919) \u2014 b\xf6lgesel M\xfcdafaa-i Hukuk cemiyetleri tek bir temsil heyeti alt\u0131nda birle\u015Fiyor. Direni\u015F, yurt \xe7ap\u0131nda k\xf6k salan mill\xee bir harekete d\xf6n\xfc\u015F\xfcyor.","event.sanRemo":"\uD83D\uDCDC San Remo Konferans\u0131 (19 Nisan 1920) \u2014 \u0130tilaf Devletleri Bat\u0131 Trakya\u2019daki idarelerini sona erdirip Yunan iddias\u0131n\u0131n \xf6n\xfcn\xfc a\xe7\u0131yor. Trakya ve Makedonya\u2019da yeni bir Yunan\u2013Bulgar rekabeti ba\u015Fl\u0131yor.","event.tekalif":"\u2696\uFE0F Tek\xe2lif-i Milliye Emirleri (A\u011Fustos 1921) \u2014 Yunan ordusu Ankara\u2019ya iki konak uzakta. Meclis, orduyu son bir direni\u015Fe donatmak i\xe7in milletin yiyece\u011Finin, kuma\u015F\u0131n\u0131n, \xe7ar\u0131\u011F\u0131n\u0131n ve nakil vas\u0131talar\u0131n\u0131n %40\u2019\u0131na el koyabilir. Kimseyi askere almaz: ordu vatan topra\u011F\u0131nda daha sert vuracak, fakat emirler y\xfcr\xfcrl\xfckteyken takviye ve yerel \xf6rg\xfctlenme zay\u0131flayacak.","event.tekalif.requisition.log":"\u2696\uFE0F Tek\xe2lif-i Milliye ilan edildi \u2014 ordu donat\u0131ls\u0131n diye millet son verdi\u011Fini veriyor.","event.tekalif.decline.log":"\u2696\uFE0F Emirler \xe7\u0131kar\u0131lmad\u0131 \u2014 millet esirgendi, ordu elindekiyle sava\u015Facak.","event.conference":"\uD83D\uDCDC Lozan Konferans\u0131 topland\u0131 \u2014 d\xfcvel-i muazzama bug\xfcnk\xfc s\u0131n\u0131rlar \xfczerinden \u015Fartlar\u0131n\u0131 sunuyor. Misak-\u0131 Mill\xee illerinin {total} tanesinden {held} tanesi elinde. \u0130mzalarsan sava\u015F burada biter. Reddedersen gerisi i\xe7in geri gelirler.","event.conference.accept.log":"\uD83D\uDCDC Lozan\u2019da \u015Fartlar kabul edildi \u2014 sava\u015F bitti.","event.conference.reject.log":"\u2694\uFE0F \u015Eartlar reddedildi \u2014 heyet masadan kalkt\u0131, sava\u015F s\xfcr\xfcyor.","log.termsRefused":"\u2694\uFE0F Ankara \u015Fartlar\u0131 reddetti. D\xfcvel-i muazzama kuvvetle geri d\xf6necek.","log.landing":"\u2693 {faction} {territory} k\u0131y\u0131s\u0131na {n} birlik \xe7\u0131kard\u0131 ve oray\u0131 ald\u0131.","log.landingRepelled":"\u2693 {faction} {territory} k\u0131y\u0131s\u0131na {n} birlikle \xe7\u0131karma denedi ve denize d\xf6k\xfcld\xfc.","log.landingUnopposed":"\u2693 {faction} {territory} k\u0131y\u0131s\u0131na {n} birlik daha \xe7\u0131kard\u0131; kar\u015F\u0131lar\u0131nda kimse yoktu.","log.embark":"\u26F5 {faction} {from} liman\u0131nda {n} birli\u011Fi gemiye bindirdi; rotalar\u0131 {to}.","tooltip.convoy":"{faction} \u2014 denizde {troops} birlik, {to} yolunda ({rounds} tur kald\u0131)","tooltip.convoyLast":"{faction} \u2014 denizde {troops} birlik, {to} yolunda (gelecek tur karaya \xe7\u0131k\u0131yor)","log.convoyLanded":"\u2693 {faction} {territory} k\u0131y\u0131s\u0131na {n} birlik \xe7\u0131kard\u0131.","log.convoyTurnedBack":"\u21A9\uFE0E Liman onlar denizdeyken elden \xe7\u0131kt\u0131; {faction} {n} birli\u011Fi {territory} y\xf6n\xfcne geri \xe7evirdi.","log.convoyReturned":"\u2693 {faction} {n} birli\u011Fi {territory} liman\u0131na geri getirdi.","event.lausanne":"\uD83D\uDCDC Lozan Konferans\u0131 bar\u0131\u015F\u0131 ba\u011Flad\u0131 \u2014 bug\xfcnk\xfc s\u0131n\u0131rlar Cumhuriyet\'in s\u0131n\u0131rlar\u0131 oldu. Sava\u015F bitti.","log.assemblySuspended":"\u26A0\uFE0F Meclis makam\u0131ndan s\xfcr\xfcld\xfc \u2014 h\xfck\xfcmet toplanam\u0131yor, ona ba\u011Fl\u0131 olan her \u015Fey duruyor.","log.assemblyReconvened":"\uD83D\uDCDC Meclis {city} yeniden topland\u0131 \u2014 h\xfck\xfcmet yine i\u015F ba\u015F\u0131nda.","log.tekalifWindow":"Ordu donat\u0131ld\u0131 ve hareket halinde \u2014 {until} tarihine kadar vatan topraklar\u0131nda 3 sald\u0131r\u0131 zar\u0131","log.lausanneShort":"Lozan, {total} Misak-\u0131 Mill\xee ilinin {held} tanesi T\xfcrk elindeyken ba\u011Fland\u0131. Gerisi kay\u0131p.","event.istanbulOccupied":"\uD83D\uDCDC \u0130stanbul\u2019un i\u015Fgali (16 Mart 1920) \u2014 ba\u015Fkent zorla al\u0131nd\u0131, Meclis-i Mebusan da\u011F\u0131t\u0131ld\u0131. \u015Eehir \u0130ngiltere\u2019ye ge\xe7iyor ve hareketin a\u011F\u0131rl\u0131k merkezi temelli Ankara\u2019ya kay\u0131yor.","event.sevres":"\uD83D\uDCDC Sevr Antla\u015Fmas\u0131 (10 A\u011Fustos 1920) \u2014 B\xe2b\u0131\xe2li \xfclkenin payla\u015F\u0131lmas\u0131na imza at\u0131yor. Dayat\u0131lan bar\u0131\u015F \xf6nce askere yaz\u0131lmay\u0131 sars\u0131yor, fakat yaratt\u0131\u011F\u0131 \xf6fke zamanla direni\u015Fi silahl\u0131 bir millete d\xf6n\xfc\u015Ft\xfcr\xfcyor.","event.ethem":"\u2694\uFE0F \xc7erkes Ethem \u0130syan\u0131 (Aral\u0131k 1920) \u2014 Kuv\xe2-yi Seyyare d\xfczenli orduya kar\u015F\u0131 ayaklan\u0131yor; bat\u0131daki garnizonlar\u0131 karga\u015Faya s\xfcr\xfckl\xfcyor ve savunmalar\u0131n\u0131 da\u011F\u0131t\u0131yor.","event.inonu":"\u2694\uFE0F \u0130n\xf6n\xfc (Mart 1921) \u2014 Eski\u015Fehir \xf6n\xfcndeki hat tutuyor ve Yunan ilerleyi\u015Fi geri p\xfcsk\xfcrt\xfcl\xfcyor. \u015Eehrin \xf6n\xfcndeki kuvvet k\u0131r\u0131l\u0131yor, Ankara d\u0131\u015Far\u0131da ilk tan\u0131nmas\u0131n\u0131 kazan\u0131yor.","event.sakarya":"\u2694\uFE0F Sakarya (23 A\u011Fustos \u2013 13 Eyl\xfcl 1921) \u2014 nehir boyunda yirmi iki g\xfcn yirmi iki gecenin ard\u0131ndan Yunan ilerleyi\u015Fi temelli bitiyor. Ordu sars\u0131l\u0131yor ve taarruz inisiyatifini bir daha tam olarak kazanam\u0131yor.","event.greekOffensive":"\u2694\uFE0F Yunan Yaz Taarruzu (Temmuz 1921) \u2014 Venizelos d\xfc\u015Ft\xfckten aylar sonra, kralc\u0131 h\xfck\xfcmet alt\u0131nda ordu K\xfctahya ve Eski\u015Fehir \xfczerinden Sakarya\u2019ya do\u011Fru en derin noktas\u0131na ilerliyor. Yunan\u2019\u0131n Anadolu cephesi takviye ediliyor ve siperleniyor.","event.karsTreaty":"\uD83D\uDCDC Kars Antla\u015Fmas\u0131 (13 Ekim 1921) \u2014 Ermenistan fetihlerini anayurt sahiplerine geri veriyor, kuzeydo\u011Fu s\u0131n\u0131r\u0131 \xe7iziliyor ve Ankara ile Erivan aras\u0131ndaki sava\u015F kapan\u0131yor.","event.mudanya":"\uD83D\uDCDC Mudanya M\xfctarekesi (11 Ekim 1922) \u2014 \u015Fehir ku\u015Fat\u0131lm\u0131\u015Fken \u0130ngiltere \u0130stanbul i\xe7in sava\u015Fmak yerine onu b\u0131rak\u0131yor. Ba\u015Fkent tek kur\u015Fun at\u0131lmadan geri d\xf6n\xfcyor, \u0130ngiliz garnizonu Londra\u2019n\u0131n elinde kalan yerlere da\u011F\u0131l\u0131yor.","log.ethemRevolt":"\u0130syan {territories} illerinde {n} birli\u011Fe ve siperlerine mal oldu","log.greekOffensive":"\u2694\uFE0F Yaz taarruzu Yunan cephesine {n} birlik y\u0131\u011F\u0131yor ve siperlendiriyor","log.mudanyaRedeploy":"{n} ki\u015Filik \u0130ngiliz garnizonu \u0130stanbul\u2019dan \xe7ekildi, {territories} ile da\u011F\u0131t\u0131ld\u0131","event.lloydGeorge":"\uD83D\uDCDC Lloyd George d\xfc\u015Ft\xfc (19 Ekim 1922) \u2014 \xc7anak buhran\u0131, Yunan seferini destekleyen h\xfck\xfcmeti devirdi; \xe7\xfcnk\xfc \u0130ngiltere T\xfcrkiye ile ikinci kez sava\u015Fmayacak. \u0130ngiliz kuvvetleri ellerindekini tutacak, hi\xe7bir \u015Fey ba\u015Flatmayacak.","event.sultanate":"\uD83D\uDCDC Saltanat kald\u0131r\u0131ld\u0131 (1 Kas\u0131m 1922) \u2014 i\u015Fgal alt\u0131ndaki \u0130stanbul\u2019da art\u0131k rakip bir h\xfck\xfcmet yok. T\xfcrk ordular\u0131n\u0131 art\u0131k tek otorite ve tek komuta y\xf6netiyor.","event.greekCollapse":"\u2694\uFE0F Yunan ordusu \xe7\xf6kt\xfc \u2014 subaylar ayakland\u0131, kral taht\u0131 b\u0131rakt\u0131, Anadolu\u2019yu kaybeden naz\u0131rlar kur\u015Funa dizildi. Yunan sava\u015F gayreti toparlanma g\xfcc\xfcn\xfc kaybediyor.","event.mubadele":"\uD83D\uDCDC M\xfcbadele S\xf6zle\u015Fmesi (30 Ocak 1923) \u2014 yerinden edilen topluluklar Ege\u2019nin iki yakas\u0131na isk\xe2n ediliyor; ula\u015F\u0131m ve idare a\u011F\u0131r bir y\xfck alt\u0131nda kal\u0131yor.","event.caliphate":"\uD83D\uDCDC Halifelik kald\u0131r\u0131ld\u0131 (3 Mart 1924) \u2014 eski d\xfczenin son kurumu da gitti; Meclis\u2019in \xfcst\xfcnde kimse kalmad\u0131.","event.mosulQuestion":"\uD83D\uDCDC Musul meselesi (Ekim 1924) \u2014 Cemiyet-i Akvam Br\xfcksel hatt\u0131n\u0131 \u0130ngiltere lehine \xe7iziyor ve Mezopotamya\u2019daki \u0130ngiliz topraklar\u0131n\u0131 yeni Irak Krall\u0131\u011F\u0131\u2019na ba\u011Fl\u0131yor; Ankara\u2019n\u0131n iddias\u0131 tehlikeye giriyor.","event.sheikhSaid":"\u2694\uFE0F \u015Eeyh Said \u0130syan\u0131 (13 \u015Eubat 1925) \u2014 halifeli\u011Fin kald\u0131r\u0131lmas\u0131ndan bir y\u0131l sonra do\u011Fu ayaklan\u0131yor; garnizonlar eriyor, g\xfc\xe7l\xfckle kurulan savunmalar da\u011F\u0131l\u0131yor.","log.sheikhSaid":"\u0130syan {territories} illerinde {n} birli\u011Fe ve siperlerine mal oldu","log.mosulCeded":"Cemiyet-i Akvam {territories} vilayetini Irak Krall\u0131\u011F\u0131\u2019na verdi","event.venizelos":"\uD83D\uDCDC Venizelos, Yunan se\xe7imlerinde d\xfc\u015F\xfcyor \u2014 M\xfcttefik deste\u011Fi azal\u0131yor. Yunan takviyeleri d\xfc\u015F\xfcyor.","event.alexandropol":"\uD83D\uDCDC Aleksandropol Antla\u015Fmas\u0131 \u2014 Ermenistan bar\u0131\u015F istiyor ve silah b\u0131rak\u0131yor. Ankara bar\u0131\u015F\u0131 bozarsa yeniden seferber olacak.","event.italyWithdraws":"\uD83D\uDCDC \u0130talya, Anadolu\'dan \xe7ekilmeye ba\u015Fl\u0131yor \u2014 \u0130talyan konu\u015Flanmalar\u0131 ve sald\u0131r\u0131lar\u0131 duruyor.","event.ankaraAgreement":"\uD83D\uDCDC Ankara Antla\u015Fmas\u0131 \u2014 Fransa, Ankara ile bar\u0131\u015F yap\u0131yor ve savunmaya ge\xe7iyor.","event.exhaustion":"\uD83D\uDCDC \u0130\u015Fgal siyasi olarak s\xfcrd\xfcr\xfclemez hale geliyor \u2014 yabanc\u0131 g\xfc\xe7lerin Anadolu seferini s\xfcrd\xfcrme iradesi ve imk\xe2n\u0131 t\xfckeniyor.","event.tbmm":"\uD83D\uDCDC B\xfcy\xfck Millet Meclisi {date} {city} a\xe7\u0131ld\u0131 \u2014 h\xfck\xfcmet, tek elden komuta ve mill\xee yetki: hareket elindeki topraklardan \xe7ok daha fazla birlik toplayabiliyor.","event.sovietAid1":"\uD83D\uDCDC \u0130lk Sovyet alt\u0131n\u0131 ve t\xfcfekleri ula\u015Ft\u0131 \u2014 Ankara daha iyi te\xe7hiz edilmi\u015F birlik toplayabiliyor.","event.sovietAid2":"\uD83D\uDCDC Moskova Antla\u015Fmas\u0131 \u2014 cepheye b\xfcy\xfck bir t\xfcfek, makineli t\xfcfek ve top sevkiyat\u0131 ula\u015F\u0131yor; mill\xee ordu g\xfc\xe7leniyor.","event.greatOffensive":"\u2694\uFE0F B\xfcy\xfck Taarruz \u2014 Afyon\u2019da toplanan ordu Yunan hatt\u0131n\u0131 yar\u0131yor. D\xfczenli ordu inisiyatifi ele ge\xe7iriyor, tam g\xfcc\xfcyle sava\u015F\u0131yor ve vatan i\xe7inde daha derine ilerleyebiliyor.","overlay.victory.title":"Zafer!","overlay.victory.body":"Misak-\u0131 Mill\xee s\u0131n\u0131rlar\u0131na {date} ula\u015F\u0131ld\u0131. \u0130\u015Fgal g\xfc\xe7leri vatandan s\xfcr\xfcld\xfc ve Cumhuriyet ilan edilecek. Ya\u015Fas\u0131n Cumhuriyet!","overlay.beyond.title":"Zafer ve Fazlas\u0131!","overlay.beyond.body":"Misak-\u0131 Mill\xee hedeflerine {date} ula\u015Ft\u0131n. Vatana ayr\u0131ca {named} b\xf6lgelerini de katt\u0131n. Lozan\u2019da elin art\u0131k daha g\xfc\xe7l\xfc. Ya\u015Fas\u0131n Cumhuriyet!","overlay.total.title":"Mutlak Zafer!","overlay.total.body":"Vatan\u0131 {date} kurtarmakla kalmad\u0131n, s\u0131n\u0131rlar\u0131n\u0131 geni\u015Flettin. Haritada her yerde T\xfcrk bayra\u011F\u0131 dalgalan\u0131yor. Lozan\u2019da pazarl\u0131k edecek bir \u015Fey kalmad\u0131: masada tek taraf var. Ya\u015Fas\u0131n Cumhuriyet!","overlay.defeat.title":"Yenilgi","overlay.defeat.body":"T\xfcrkiye {date} yenildi. Vatan i\u015Fgal alt\u0131nda kal\u0131yor ve onu geri alacak ordu kalmad\u0131.","overlay.lausanne.near.title":"Ucundan Ka\xe7an Bar\u0131\u015F","overlay.lausanne.near.body":"Konferans {date} ba\u011Fland\u0131; {total} ilin {held} tanesi T\xfcrk elinde. Cumhuriyet kuruluyor ve i\u015Fgal bitiyor \u2014 ama {named} s\u0131n\u0131r\u0131n \xf6te yan\u0131nda kald\u0131 ve burada \xe7izilen hat bir daha \xe7izilmeyecek.","overlay.lausanne.partial.title":"Yar\u0131m Kalan Bar\u0131\u015F","overlay.lausanne.partial.body":"Konferans {date} ba\u011Fland\u0131; {total} ilin {held} tanesi kurtar\u0131ld\u0131. Bir T\xfcrk devleti ayakta ve cumhuriyet olacak, ama Misak-\u0131 Mill\xee\u2019nin \xf6ng\xf6rd\xfc\u011F\xfc illerin {missing} tanesi masada verildi. Sava\u015F bitti; Misak-\u0131 Mill\xee k\xe2\u011F\u0131t \xfcst\xfcnde kald\u0131.","overlay.lausanne.poor.title":"Onlar\u0131n \u015Eartlar\u0131yla Bar\u0131\u015F","overlay.lausanne.poor.body":"Konferans {date} ba\u011Fland\u0131; {total} ilin yaln\u0131zca {held} tanesi elde kald\u0131. \u015Eartlar\u0131 d\xfcvel-i muazzama yazd\u0131, Ankara imzalad\u0131. Geriye g\xfc\xe7s\xfcz bir \xfclke kald\u0131 \u2014 Misak-\u0131 Mill\xee\u2019nin tarif etti\u011Fi vatan yok.","overlay.playAgain":"Tekrar oyna","dialog.ok":"Tamam","dialog.cancel":"Vazge\xe7","card.dismiss":"Devam","card.choice.accept":"Antla\u015Fmay\u0131 imzala","card.choice.reject":"Sava\u015Fa devam et","card.choice.requisition":"Emirleri ilan et","card.choice.decline":"Milleti esirge","menu.title":"Ayarlar","menu.language":"Dil","menu.display":"G\xf6r\xfcn\xfcm","menu.fullscreen":"Tam ekran","menu.exitFullscreen":"Tam ekrandan \xe7\u0131k","menu.installHint":"Ana ekrana ekle; taray\u0131c\u0131 \xe7ubuklar\u0131 olmadan a\xe7\u0131l\u0131r.","menu.sound":"Ses","menu.musicOn":"M\xfczi\u011Fi a\xe7","menu.musicOff":"M\xfczi\u011Fi kapat","menu.musicVolume":"M\xfczik d\xfczeyi","menu.volumeValue":"%{volume}","menu.sfxOn":"Ses efektlerini a\xe7","menu.sfxOff":"Ses efektlerini kapat","menu.sfxVolume":"Ses efekti d\xfczeyi","menu.saves":"Kay\u0131tl\u0131 oyunlar","menu.saveCurrent":"Oyunu kaydet","menu.noSaves":"Hen\xfcz kay\u0131tl\u0131 oyun yok.","menu.load":"Y\xfckle","menu.delete":"Sil","menu.saveNamePrompt":"Kayda bir ad verin","menu.defaultSaveName":"{date} \xb7 {pact}/30","menu.confirmLoad":"Bu kay\u0131t y\xfcklensin mi? Mevcut oyun kaybolacak.","menu.confirmDelete":"Bu kay\u0131t silinsin mi?","menu.saveFailed":"Kaydedilemedi \u2014 taray\u0131c\u0131 depolamas\u0131 dolu veya kullan\u0131lam\u0131yor.","menu.loadFailed":"Bu kay\u0131t y\xfcklenemedi.","menu.savedRound":"{round}. tur \xb7 {date}","lang.switcher.title":"Dil","lang.en":"English","lang.tr":"T\xfcrk\xe7e","trait.Turkey":"Seferberlik a\u015Famal\u0131 derinle\u015Fir \u2014 1919\'da toprak \xf72 ve %25 y\u0131pranma kayb\u0131, Meclis\'ten sonra (Nisan 1920) \xf71.5 ve %10, B\xfcy\xfck Taarruz\'dan sonra (A\u011Fustos 1922) kay\u0131p yok. Kuv\xe2-yi Milliye: +2 takviye, Sovyet silahlar\u0131ndan sonra +3 (Eyl\xfcl 1920). \u0130\xe7 hatlar: 2 tahkim hamlesi. Her devlet turda en fazla 3 muharebe ba\u015Flatabilir ve ilerleyen bir ordu 2 b\xf6lge ge\xe7ebilir; B\xfcy\xfck Taarruz T\xfcrkiye\'nin ilerlemesini Misak-\u0131 Mill\xee i\xe7inde 3\'e \xe7\u0131kar\u0131r. Vatan topraklar\u0131ndaki i\u015Fgalciler B\xfcy\xfck Taarruz\'a kadar (A\u011Fustos 1922) en fazla 2 zar atar. B\xfcy\xfck Taarruz\'a kadar (A\u011Fustos 1922) T\xfcrkiye 2 zarla sald\u0131r\u0131r ve vatan\u0131 2 zarla savunur; sonras\u0131nda hem sald\u0131r\u0131 hem savunma 3 zar. \u0130\u015Fgalciler o tarihe dek vatan topraklar\u0131na en fazla 2 zarla sald\u0131r\u0131r. Tek\xe2lif-i Milliye ilan edilirse (A\u011Fustos 1921) 3 tur boyunca vatan topraklar\u0131ndaki her muharebenin ilk iki hamlesi 3 zarla at\u0131l\u0131r; bu s\xfcre boyunca turda 3 takviye eksilir ve milis toplanmaz. Kurtar\u0131lan vatan topra\u011F\u0131na yerel milis kat\u0131l\u0131r: Taarruz\'dan \xf6nce, kurtar\u0131lan her ile, d\xfc\u015Ft\xfckten sonraki bir tur i\xe7inde geri al\u0131n\u0131rsa +2, i\u015Fgalci yerle\u015Ftikten sonra +1. Taarruz\'dan itibaren yaln\u0131zca turda kurtar\u0131lan ilk il garnizon al\u0131r, o da +1.","trait.Greece":"Deniz a\u015F\u0131r\u0131 ikmal: tahkim hamlesi en fazla yar\u0131m garnizon. Venizelos d\xfc\u015F\xfcnce Selanik askere almay\u0131 b\u0131rak\u0131r; Sakarya\u2019dan sonra cephe takviyesi azal\u0131r.","trait.Britain":"Terhis: \u22122 takviye. \u0130tilaf \xfcyesi.","trait.France":"\u0130tilaf \xfcyesi. Ankara Antla\u015Fmas\u0131 bar\u0131\u015F getirir ve Frans\u0131z fetihlerini anayurt sahiplerine b\u0131rak\u0131r (pasif, yar\u0131m takviye).","trait.Italy":"\u0130tilaf \xfcyesi. \xc7ekilme kart\u0131 \u0130talyan fetihlerini anayurt sahiplerine b\u0131rak\u0131r (pasif, takviye yok).","trait.Armenia":"\u0130tilaf yanl\u0131s\u0131. Meclis faalken imzalanan Aleksandropol, Ermeni sald\u0131r\u0131lar\u0131n\u0131 ve takviyelerini sona erdirir. T\xfcrkiye bar\u0131\u015F\u0131 bozarsa Ermenistan 20 acil birlikle yeniden seferber olur ve Kars\u2019a kadar serbest\xe7e sald\u0131rabilir. Ermenistan d\xf6rt vilayetlik anayurdunun tamam\u0131n\u0131 elinde tutup Misak-\u0131 Mill\xee\u2019de hi\xe7bir yer tutmad\u0131\u011F\u0131nda Kars, t\xfcm Ermeni sald\u0131r\u0131lar\u0131n\u0131 bu anayurtla s\u0131n\u0131rlar, di\u011Fer b\xfct\xfcn fetihleri anayurt sahiplerine geri verir ve T\xfcrkiye\u2019nin Ermenistan\u2019a sald\u0131rmas\u0131n\u0131 engeller.","trait.Bulgaria":"Neuilly silah s\u0131n\u0131r\u0131: en fazla 3 takviye. Tarafs\u0131z, ama Yunanistan rakip."}');


const $6c154842fccf6556$var$STORAGE_KEY = 'independence.lang';
const $6c154842fccf6556$var$detectInitial = ()=>{
    try {
        const saved = typeof localStorage !== 'undefined' ? localStorage.getItem($6c154842fccf6556$var$STORAGE_KEY) : null;
        if (saved === 'en' || saved === 'tr') return saved;
    } catch  {
    // localStorage unavailable (private mode etc.) — fall through to detection
    // localStorage unavailable (private mode etc.) — fall through to detection
    }
    if (typeof navigator !== 'undefined' && /^tr\b/i.test(navigator.language || '')) return 'tr';
    return 'en';
};
let $6c154842fccf6556$var$lang = $6c154842fccf6556$var$detectInitial();
const $6c154842fccf6556$var$listeners = new Set();
const $6c154842fccf6556$export$dec8f99c0c14e178 = ()=>$6c154842fccf6556$var$lang;
const $6c154842fccf6556$export$a3665b844fbc095d = (l)=>{
    if (l === $6c154842fccf6556$var$lang) return;
    $6c154842fccf6556$var$lang = l;
    try {
        localStorage.setItem($6c154842fccf6556$var$STORAGE_KEY, l);
    } catch  {
    // ignore — language just won't persist across reloads
    // ignore — language just won't persist across reloads
    }
    // keeps CSS text-transform locale-correct: uppercasing "Takviye" only yields
    // "TAKVİYE" (dotted İ) when the document language is Turkish
    // keeps CSS text-transform locale-correct: uppercasing "Takviye" only yields
    // "TAKVİYE" (dotted İ) when the document language is Turkish
    if (typeof document !== 'undefined') document.documentElement.lang = l;
    $6c154842fccf6556$var$listeners.forEach((fn)=>fn());
};
const $6c154842fccf6556$export$b6eb773519eded85 = (items)=>{
    if (items.length < 2) return items[0] ?? '';
    const conjunction = $6c154842fccf6556$var$lang === 'tr' ? 've' : 'and';
    return `${items.slice(0, -1).join(', ')} ${conjunction} ${items[items.length - 1]}`;
};
const $6c154842fccf6556$export$18c6e7c9e91e1c0f = (fn)=>{
    $6c154842fccf6556$var$listeners.add(fn);
    return ()=>$6c154842fccf6556$var$listeners.delete(fn);
};
const $6c154842fccf6556$export$553ffa39138e14d5 = {
    en: (/*@__PURE__*/$parcel$interopDefault($3d2cc403ee648109$exports)),
    tr: (/*@__PURE__*/$parcel$interopDefault($efbe095757b33555$exports))
};
const $6c154842fccf6556$export$625550452a3fa3ec = (key, vars)=>{
    let s = $6c154842fccf6556$export$553ffa39138e14d5[$6c154842fccf6556$var$lang][key] ?? $6c154842fccf6556$export$553ffa39138e14d5.en[key] ?? key;
    if (vars) for (const [k, v] of Object.entries(vars))s = s.split(`{${k}}`).join(String(v));
    return s;
};
// ---- Turkish case suffixes ----
// Turkish agglutinates case endings onto proper nouns after an apostrophe, and
// the ending must obey vowel harmony (and take a buffer -y- after a vowel, or
// harden to -t- after a voiceless consonant). Hard-coding "'e"/"'ye" produced
// "Ermenistan'e", "Kars'ye" — wrong for every back-vowel name on the map.
// ---- Turkish case suffixes ----
// Turkish agglutinates case endings onto proper nouns after an apostrophe, and
// the ending must obey vowel harmony (and take a buffer -y- after a vowel, or
// harden to -t- after a voiceless consonant). Hard-coding "'e"/"'ye" produced
// "Ermenistan'e", "Kars'ye" — wrong for every back-vowel name on the map.
const $6c154842fccf6556$var$BACK = "a\u0131ou";
const $6c154842fccf6556$var$ROUNDED = "ou\xf6\xfc";
const $6c154842fccf6556$var$VOWELS = "ae\u0131io\xf6u\xfc";
const $6c154842fccf6556$var$VOICELESS = "fstk\xe7\u015Fhp";
const $6c154842fccf6556$var$lastVowel = (w)=>{
    for(let i = w.length - 1; i >= 0; i--)if ($6c154842fccf6556$var$VOWELS.includes(w[i].toLocaleLowerCase('tr'))) return w[i].toLocaleLowerCase('tr');
    return 'e';
};
const $6c154842fccf6556$export$120c965bd7d49660 = (word, kase)=>{
    const v = $6c154842fccf6556$var$lastVowel(word);
    const back = $6c154842fccf6556$var$BACK.includes(v);
    const endsVowel = $6c154842fccf6556$var$VOWELS.includes(word[word.length - 1].toLocaleLowerCase('tr'));
    const hard = $6c154842fccf6556$var$VOICELESS.includes(word[word.length - 1].toLocaleLowerCase('tr'));
    if (kase === 'dat') return `${word}'${endsVowel ? 'y' : ''}${back ? 'a' : 'e'}`;
    if (kase === 'acc') {
        const vowel = back ? $6c154842fccf6556$var$ROUNDED.includes(v) ? 'u' : "\u0131" : $6c154842fccf6556$var$ROUNDED.includes(v) ? "\xfc" : 'i';
        return `${word}'${endsVowel ? 'y' : ''}${vowel}`;
    }
    const d = hard ? 't' : 'd';
    const a = back ? 'a' : 'e';
    return kase === 'loc' ? `${word}'${d}${a}` : `${word}'${d}${a}n`;
};
const $6c154842fccf6556$export$9c131fee79280443 = (name, kase)=>$6c154842fccf6556$var$lang === 'tr' ? $6c154842fccf6556$export$120c965bd7d49660(name, kase) : name;
// A year takes its suffix from how it is SPOKEN, not from its final digit:
// 1921 is "…bir" so it takes 'de, but 1923 is "…üç" so it takes 'te.
// A year takes its suffix from how it is SPOKEN, not from its final digit:
// 1921 is "…bir" so it takes 'de, but 1923 is "…üç" so it takes 'te.
const $6c154842fccf6556$var$UNITS = [
    "s\u0131f\u0131r",
    'bir',
    'iki',
    "\xfc\xe7",
    "d\xf6rt",
    "be\u015F",
    "alt\u0131",
    'yedi',
    'sekiz',
    'dokuz'
];
const $6c154842fccf6556$var$TENS = [
    '',
    'on',
    'yirmi',
    'otuz',
    "k\u0131rk",
    'elli',
    "altm\u0131\u015F",
    "yetmi\u015F",
    'seksen',
    'doksan'
];
const $6c154842fccf6556$var$yearWord = (year)=>{
    const unit = year % 10;
    if (unit) return $6c154842fccf6556$var$UNITS[unit];
    const ten = Math.floor(year / 10) % 10;
    return ten ? $6c154842fccf6556$var$TENS[ten] : "y\xfcz";
};
const $6c154842fccf6556$export$950651e963a037d3 = (date)=>{
    if ($6c154842fccf6556$var$lang !== 'tr') return date;
    const year = parseInt(date.split(' ').pop() ?? '', 10);
    if (!year) return date;
    const spoken = $6c154842fccf6556$export$120c965bd7d49660($6c154842fccf6556$var$yearWord(year), 'loc');
    return date + spoken.slice(spoken.indexOf("'"));
};
// ---- faction display names (keyed by the STABLE English faction.name used
// throughout game logic — never translate the key itself) ----
// ---- faction display names (keyed by the STABLE English faction.name used
// throughout game logic — never translate the key itself) ----
const $6c154842fccf6556$var$FACTION_TR = {
    Turkey: "T\xfcrkiye",
    Greece: 'Yunanistan',
    Bulgaria: 'Bulgaristan',
    Armenia: 'Ermenistan',
    Italy: "\u0130talya",
    Britain: "\u0130ngiltere",
    France: 'Fransa',
    Iraq: 'Irak'
};
const $6c154842fccf6556$export$e75392c849ab10e7 = (name)=>$6c154842fccf6556$var$lang === 'tr' ? $6c154842fccf6556$var$FACTION_TR[name] ?? name : name;
// ---- territory display names (keyed by slug — the stable identifier used
// everywhere in game-data/geometry; Territory.name itself is untouched) ----
// ---- territory display names (keyed by slug — the stable identifier used
// everywhere in game-data/geometry; Territory.name itself is untouched) ----
const $6c154842fccf6556$var$TERRITORY_TR = {
    salonica: 'Selanik',
    kozani: 'Kozani',
    'western-thrace': "Bat\u0131 Trakya",
    lesbos: 'Midilli',
    rhodes: 'Rodos',
    sofia: 'Sofya',
    plovdiv: 'Filibe',
    burgas: 'Burgaz',
    gyumri: "G\xfcmr\xfc",
    yerevan: 'Erivan',
    aleppo: 'Halep',
    mosul: 'Musul',
    baghdad: "Ba\u011Fdat"
};
const $6c154842fccf6556$export$983732bc59a669db = (slug, fallback)=>$6c154842fccf6556$var$lang === 'tr' ? $6c154842fccf6556$var$TERRITORY_TR[slug] ?? fallback : fallback;
// ---- decorative sea/country labels (keyed by DECOR_DEFS slug) ----
// ---- decorative sea/country labels (keyed by DECOR_DEFS slug) ----
const $6c154842fccf6556$var$DECOR_TR = {
    'black-sea': 'Karadeniz',
    'mediterranean-sea': 'Akdeniz',
    'aegean-sea': 'Ege Denizi',
    russia: 'Rusya',
    georgia: "G\xfcrcistan",
    iran: "\u0130ran",
    serbia: "S\u0131rbistan",
    romania: 'Romanya',
    cyprus: "K\u0131br\u0131s",
    crete: 'Girit',
    greece: 'Yunanistan',
    macedonia: 'Makedonya',
    azerbaijan: 'Azerbaycan'
};
const $6c154842fccf6556$export$367ec920d3208c60 = (slug, fallback)=>$6c154842fccf6556$var$lang === 'tr' ? $6c154842fccf6556$var$DECOR_TR[slug] ?? fallback : fallback;



parcelRequire("acw62");
const $45f8179f43663cce$export$543153e4c8586a40 = {
    Turkey: {
        fill: '#d8353c',
        stroke: '#8f1d1d',
        border: '#701212',
        swatch: '#d8353c'
    },
    Greece: {
        fill: '#2f74c0',
        stroke: '#0D5EAF',
        swatch: 'repeating-linear-gradient(180deg, #2f74c0 0 4px, #f4f6f8 4px 8px)'
    },
    Bulgaria: {
        fill: '#00966E',
        stroke: '#00966E',
        swatch: 'linear-gradient(180deg, #f4f6f8 0 33%, #00966E 33% 66%, #D62612 66% 100%)'
    },
    Armenia: {
        fill: '#0033A0',
        stroke: '#0033A0',
        swatch: 'linear-gradient(180deg, #D90012 0 33%, #0033A0 33% 66%, #F2A800 66% 100%)'
    },
    Italy: {
        fill: '#ece8dc',
        stroke: '#009246',
        swatch: 'linear-gradient(90deg, #009246 0 33%, #f4f6f8 33% 66%, #CE2B37 66% 100%)'
    },
    Britain: {
        fill: '#1d3f94',
        stroke: '#012169',
        swatch: 'linear-gradient(135deg, #1d3f94 0 55%, #f4f6f8 55% 70%, #C8102E 70% 100%)'
    },
    France: {
        fill: '#ece8dc',
        stroke: '#0055A4',
        swatch: 'linear-gradient(90deg, #0055A4 0 33%, #f4f6f8 33% 66%, #EF4135 66% 100%)'
    },
    // Iraq is out of the war, not in it: no flag art, so it paints as plain
    // unclaimed land like the neutral countries around the edge of the map.
    // The entry itself has to exist — FLAG_STYLES is indexed without a fallback.
    Iraq: {
        fill: '#ded3b6',
        stroke: '#a99a78',
        swatch: 'linear-gradient(135deg, #ded3b6 0 100%)'
    }
};
const $45f8179f43663cce$export$ddd9ff6d6835a025 = (troops)=>({
        cannonballs: Math.floor(troops / 10),
        cavalry: Math.floor(troops % 10 / 5),
        infantry: troops % 5
    });
const $45f8179f43663cce$export$789179201c389be1 = (troops)=>{
    const { cannonballs: cannonballs, cavalry: cavalry, infantry: infantry } = $45f8179f43663cce$export$ddd9ff6d6835a025(troops);
    const balls = cannonballs > 4 ? `\u{25CF}\xd7${cannonballs}` : "\u25CF".repeat(cannonballs);
    return `${balls}${"\u265E".repeat(cavalry)}${"\u265F".repeat(infantry)}`;
};
const $45f8179f43663cce$export$9a623eb1424c0726 = "M -9 2 Q 0 10.5 9 2 Z M -0.7 -10.5 L 0.7 -10.5 L 0.7 2 L -0.7 2 Z M 1.6 -9.5 Q 8.5 -3.5 1.6 1 Z M -1.6 -6.5 Q -6.5 -2.5 -1.6 1 Z";
const $45f8179f43663cce$export$4e4d42634ffd3747 = {
    Turkey: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: "36",
                height: "24",
                fill: "#E30A17"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "13.5",
                cy: "12",
                r: "6",
                fill: "#f4f6f8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: "15",
                cy: "12",
                r: "4.8",
                fill: "#E30A17"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                fill: "#f4f6f8",
                points: "24,12 22.31,12.59 22.27,14.38 21.19,12.95 19.48,13.47 20.5,12 19.48,10.53 21.19,11.05 22.27,9.62 22.31,11.41"
            })
        ]
    }),
    Greece: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: "36",
                height: "24",
                fill: "#f4f6f8"
            }),
            [
                0,
                2,
                4,
                6,
                8
            ].map((i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    y: i * 24 / 9,
                    width: "36",
                    height: 24 / 9,
                    fill: "#2f74c0"
                }, i)),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: "13.33",
                height: "13.33",
                fill: "#2f74c0"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "5.33",
                width: "2.67",
                height: "13.33",
                fill: "#f4f6f8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                y: "5.33",
                width: "13.33",
                height: "2.67",
                fill: "#f4f6f8"
            })
        ]
    }),
    Bulgaria: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: "36",
                height: "8",
                fill: "#f4f6f8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                y: "8",
                width: "36",
                height: "8",
                fill: "#00966E"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                y: "16",
                width: "36",
                height: "8",
                fill: "#D62612"
            })
        ]
    }),
    Armenia: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: "36",
                height: "8",
                fill: "#D90012"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                y: "8",
                width: "36",
                height: "8",
                fill: "#0033A0"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                y: "16",
                width: "36",
                height: "8",
                fill: "#F2A800"
            })
        ]
    }),
    Italy: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: "12",
                height: "24",
                fill: "#009246"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "12",
                width: "12",
                height: "24",
                fill: "#f4f6f8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "24",
                width: "12",
                height: "24",
                fill: "#CE2B37"
            })
        ]
    }),
    France: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: "12",
                height: "24",
                fill: "#0055A4"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "12",
                width: "12",
                height: "24",
                fill: "#f4f6f8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "24",
                width: "12",
                height: "24",
                fill: "#EF4135"
            })
        ]
    }),
    Britain: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                width: "36",
                height: "24",
                fill: "#012169"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M0,0 L36,24 M36,0 L0,24",
                stroke: "#f4f6f8",
                strokeWidth: "4.8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M0,0 L36,24 M36,0 L0,24",
                stroke: "#C8102E",
                strokeWidth: "1.9"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "14",
                width: "8",
                height: "24",
                fill: "#f4f6f8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                y: "8",
                width: "36",
                height: "8",
                fill: "#f4f6f8"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: "15.6",
                width: "4.8",
                height: "24",
                fill: "#C8102E"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                y: "9.6",
                width: "36",
                height: "4.8",
                fill: "#C8102E"
            })
        ]
    })
};
const $45f8179f43663cce$export$4fd8d63cb0915eb0 = ({ faction: faction, className: className = 'swatch' })=>$45f8179f43663cce$export$4e4d42634ffd3747[faction] ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        className: className,
        viewBox: "0 0 36 24",
        preserveAspectRatio: "none",
        children: $45f8179f43663cce$export$4e4d42634ffd3747[faction]
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
        className: `${className} swatch-neutral`
    });
const $45f8179f43663cce$export$a2c0099db84fd7d8 = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("defs", {
        children: Object.entries($45f8179f43663cce$export$4e4d42634ffd3747).map(([name, art])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("symbol", {
                id: `flag-def-${name}`,
                viewBox: "0 0 36 24",
                preserveAspectRatio: "none",
                children: art
            }, name))
    });


// Historical turning points arrive as a card over the map rather than a line in
// the log, so the player actually reads them. Decisions carry their options
// instead of a dismiss button.
const $36da971f4939abf4$var$EventCard = ({ entries: entries, choices: choices, onDismiss: onDismiss, onChoose: onChoose })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "overlay event-overlay",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "overlay-card event-card",
            children: [
                entries.map((e, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "event-entry",
                        children: [
                            e.faction && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45f8179f43663cce$export$4fd8d63cb0915eb0), {
                                faction: e.faction,
                                className: "event-flag"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "event-text",
                                children: (0, $6c154842fccf6556$export$625550452a3fa3ec)(e.textKey, e.vars)
                            })
                        ]
                    }, e.textKey + i)),
                choices ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: "event-choices",
                    children: choices.map((c, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: i === 0 ? 'primary' : '',
                            onClick: ()=>onChoose(c.key),
                            children: (0, $6c154842fccf6556$export$625550452a3fa3ec)(`card.choice.${c.key}`)
                        }, c.key))
                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                    className: "primary",
                    onClick: onDismiss,
                    children: (0, $6c154842fccf6556$export$625550452a3fa3ec)('card.dismiss')
                })
            ]
        })
    });
var $36da971f4939abf4$export$2e2bcd8739ae039 = $36da971f4939abf4$var$EventCard;



parcelRequire("acw62");


var $acw62 = parcelRequire("acw62");


parcelRequire("acw62");


parcelRequire("acw62");

const $5181a4732ad985ba$export$38ec310266e974b7 = [
    "\u2680",
    "\u2681",
    "\u2682",
    "\u2683",
    "\u2684",
    "\u2685"
];
const $5181a4732ad985ba$export$5c520e6b3ff78ac = {
    infantry: "\u265F",
    cavalry: "\u265E",
    cannon: "\u25CF"
};
const $5181a4732ad985ba$export$cc499a901ec5a0d9 = {
    reinforce: 'phase.reinforce',
    attack: 'phase.attack',
    fortify: 'phase.fortify',
    gameover: 'phase.gameover'
};
const $5181a4732ad985ba$export$ca28a185acb4e2f2 = {
    reinforce: 'phase.help.reinforce',
    attack: 'phase.help.attack',
    fortify: 'phase.help.fortify'
};
const $5181a4732ad985ba$export$c463048d6131b309 = ({ faction: faction })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45f8179f43663cce$export$4fd8d63cb0915eb0), {
        faction: faction,
        className: "swatch"
    });
const $5181a4732ad985ba$export$759f0e01a7cdb97c = ({ troops: troops })=>{
    const { cannonballs: cannonballs, cavalry: cavalry, infantry: infantry } = (0, $45f8179f43663cce$export$ddd9ff6d6835a025)(troops);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
        className: "unit-row",
        title: `${cannonballs} cannonballs (10) \xb7 ${cavalry} cavalry (5) \xb7 ${infantry} infantry (1)`,
        children: [
            cannonballs > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "unit",
                children: [
                    "\u25CF ",
                    cannonballs
                ]
            }),
            cavalry > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "unit",
                children: [
                    "\u265E ",
                    cavalry
                ]
            }),
            infantry > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "unit",
                children: [
                    "\u265F ",
                    infantry
                ]
            })
        ]
    });
};


const $9ed43f648a9985e4$export$3f200ecf7ea81959 = ({ game: game, battle: battle, onAttackPress: onAttackPress, onAttackBlitz: onAttackBlitz, onPullBack: onPullBack })=>{
    const lastRound = battle.rounds[battle.rounds.length - 1];
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `battle-report${battle.pending ? ' pending' : battle.conquered ? ' won' : ' lost'}`,
        children: [
            lastRound && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "dice attacker",
                        children: lastRound.attackerDice.map((value)=>(0, $5181a4732ad985ba$export$38ec310266e974b7)[value - 1]).join(' ')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "vs",
                        children: "vs"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "dice defender",
                        children: lastRound.defenderDice.map((value)=>(0, $5181a4732ad985ba$export$38ec310266e974b7)[value - 1]).join(' ')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "battle-outcome",
                children: battle.pending ? (0, $6c154842fccf6556$export$625550452a3fa3ec)('hud.battleTally', {
                    from: (0, $6c154842fccf6556$export$983732bc59a669db)(battle.from.slug, battle.from.name),
                    fromN: battle.from.troops,
                    to: (0, $6c154842fccf6556$export$983732bc59a669db)(battle.to.slug, battle.to.name),
                    toN: battle.to.troops,
                    atkLoss: battle.attackerLosses,
                    defLoss: battle.defenderLosses
                }) : battle.conquered ? (0, $6c154842fccf6556$export$625550452a3fa3ec)('hud.falls', {
                    territory: (0, $6c154842fccf6556$export$983732bc59a669db)(battle.to.slug, battle.to.name),
                    atkLoss: battle.attackerLosses,
                    defLoss: battle.defenderLosses
                }) : (0, $6c154842fccf6556$export$625550452a3fa3ec)('hud.repelled', {
                    territory: (0, $6c154842fccf6556$export$983732bc59a669db)(battle.to.slug, battle.to.name),
                    territoryLoc: (0, $6c154842fccf6556$export$9c131fee79280443)((0, $6c154842fccf6556$export$983732bc59a669db)(battle.to.slug, battle.to.name), 'loc'),
                    atkLoss: battle.attackerLosses,
                    defLoss: battle.defenderLosses
                })
            }),
            battle.pending && game.turn.currentPlayer.isHuman && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                className: "battle-controls",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "primary",
                        onClick: onAttackPress,
                        children: (0, $6c154842fccf6556$export$625550452a3fa3ec)('hud.press')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: onAttackBlitz,
                        children: (0, $6c154842fccf6556$export$625550452a3fa3ec)('hud.blitz')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        onClick: onPullBack,
                        children: (0, $6c154842fccf6556$export$625550452a3fa3ec)('hud.pullBack')
                    })
                ]
            })
        ]
    });
};



const $25fe57349a38cc60$export$4d9c9e1c1a52b59b = ({ game: game, selected: selected, fortifyTarget: fortifyTarget, lastBattle: lastBattle, onFortifyAmount: onFortifyAmount, onAdvance: onAdvance, onLandingResolve: onLandingResolve, onCancelSelection: onCancelSelection, onEndPhase: onEndPhase, onAutoPlace: onAutoPlace, onTrade: onTrade, onAttackPress: onAttackPress, onAttackBlitz: onAttackBlitz, onPullBack: onPullBack })=>{
    const actionsRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const element = actionsRef.current;
        const apply = ()=>document.documentElement.style.setProperty('--actions-h', `${element ? element.getBoundingClientRect().height : 0}px`);
        apply();
        if (!element) return;
        const observer = new ResizeObserver(apply);
        observer.observe(element);
        return ()=>observer.disconnect();
    }, [
        game.turn.phase
    ]);
    if (game.turn.phase === 'gameover') return null;
    const human = game.turn.currentPlayer.isHuman;
    const humanFaction = game.humanPlayer.faction;
    const fortifying = game.turn.phase === 'fortify' && selected && fortifyTarget;
    const maxMove = fortifying ? game.movement.transferCapacity(game.bySlug[selected], game.bySlug[fortifyTarget]) : 0;
    const transferDisrupted = fortifying ? game.movement.transferDisrupted(game.bySlug[selected], game.bySlug[fortifyTarget]) : false;
    const selectedTerritory = selected ? game.bySlug[selected] : null;
    const selectedAdvanceDepth = selected ? game.turn.advanceDepth(selected) : 0;
    const advance = human ? game.combat.pendingAdvance : null;
    const landing = human ? game.movement.pendingLandings[0] ?? null : null;
    const canTrade = !landing && game.turn.phase === 'reinforce' && human && game.findTradeSet(humanFaction.hand) !== null;
    const phaseHelp = game.turn.phase === 'attack' ? (0, $6c154842fccf6556$export$625550452a3fa3ec)((0, $5181a4732ad985ba$export$ca28a185acb4e2f2).attack, {
        attacks: game.turn.attackLimit
    }) : (0, $6c154842fccf6556$export$625550452a3fa3ec)((0, $5181a4732ad985ba$export$ca28a185acb4e2f2)[game.turn.phase]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "hud hud-actions",
        ref: actionsRef,
        children: [
            lastBattle && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9ed43f648a9985e4$export$3f200ecf7ea81959), {
                game: game,
                battle: lastBattle,
                onAttackPress: onAttackPress,
                onAttackBlitz: onAttackBlitz,
                onPullBack: onPullBack
            }),
            human && advance && !landing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "advance-order",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "advance-copy",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                className: "advance-route",
                                children: [
                                    (0, $6c154842fccf6556$export$983732bc59a669db)(game.bySlug[advance.from].slug, game.bySlug[advance.from].name),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        "aria-hidden": "true",
                                        children: "\u2192"
                                    }),
                                    (0, $6c154842fccf6556$export$983732bc59a669db)(game.bySlug[advance.to].slug, game.bySlug[advance.to].name)
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "advance-help",
                                children: (0, $6c154842fccf6556$export$625550452a3fa3ec)('hud.advanceHelp')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "advance-options",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>onAdvance(advance.min),
                                children: advance.min
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>onAdvance(Math.max(advance.min, Math.round(advance.max / 2))),
                                children: (0, $6c154842fccf6556$export$625550452a3fa3ec)('hud.half')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "primary",
                                onClick: ()=>onAdvance(advance.max),
                                children: (0, $6c154842fccf6556$export$625550452a3fa3ec)('hud.all', {
                                    n: advance.max
                                })
                            })
                        ]
                    })
                ]
            }) : human ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "action-row",
                children: [
                    humanFaction.hand.length > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "card-hand",
                        title: (0, $6c154842fccf6556$export$625550452a3fa3ec)('hud.cardHandTitle'),
                        children: [
                            humanFaction.hand.map((card, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    className: `game-card card-${card}`,
                                    children: (0, $5181a4732ad985ba$export$5c520e6b3ff78ac)[card]
                                }, index)),
                            canTrade && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "primary",
                                onClick: onTrade,
                                children: (0, $6c154842fccf6556$export$625550452a3fa3ec)('hud.trade', {
                                    n: game.pendingTradeBonus
                                })
                            })
                        ]
                    }),
                    selectedTerritory && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "selection",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: (0, $6c154842fccf6556$export$983732bc59a669db)(selectedTerritory.slug, selectedTerritory.name)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5181a4732ad985ba$export$759f0e01a7cdb97c), {
                                troops: selectedTerritory.troops
                            }),
                            game.turn.phase === 'attack' && selectedAdvanceDepth > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "hud-count",
                                children: (0, $6c154842fccf6556$export$625550452a3fa3ec)('hud.advanceDepth', {
                                    current: selectedAdvanceDepth
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "hud-help",
                        children: landing ? (0, $6c154842fccf6556$export$625550452a3fa3ec)('hud.landingHelp') : phaseHelp
                    }),
                    landing && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "fortify-row",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: (0, $6c154842fccf6556$export$983732bc59a669db)(game.bySlug[landing.to].slug, game.bySlug[landing.to].name)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "primary",
                                onClick: ()=>onLandingResolve(true),
                                children: (0, $6c154842fccf6556$export$625550452a3fa3ec)('hud.landingStorm', {
                                    territory: (0, $6c154842fccf6556$export$983732bc59a669db)(game.bySlug[landing.to].slug, game.bySlug[landing.to].name)
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>onLandingResolve(false),
                                children: (0, $6c154842fccf6556$export$625550452a3fa3ec)('hud.landingFallBack', {
                                    territory: (0, $6c154842fccf6556$export$983732bc59a669db)(game.bySlug[landing.from].slug, game.bySlug[landing.from].name)
                                })
                            })
                        ]
                    }),
                    !landing && !advance && game.turn.phase === 'reinforce' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "primary",
                        onClick: onAutoPlace,
                        children: (0, $6c154842fccf6556$export$625550452a3fa3ec)('hud.autoDeploy', {
                            n: game.turn.reinforcementsLeft
                        })
                    }),
                    !landing && !advance && game.turn.phase === 'attack' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "primary",
                        onClick: onEndPhase,
                        children: (0, $6c154842fccf6556$export$625550452a3fa3ec)('hud.endAttacks')
                    }),
                    !landing && !advance && game.turn.phase === 'fortify' && !fortifying && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "primary",
                        onClick: onEndPhase,
                        children: game.turn.fortifiesUsed > 0 ? (0, $6c154842fccf6556$export$625550452a3fa3ec)('hud.endTurn') : (0, $6c154842fccf6556$export$625550452a3fa3ec)('hud.skipEndTurn')
                    }),
                    !landing && !advance && fortifying && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "fortify-row",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                children: [
                                    (0, $6c154842fccf6556$export$983732bc59a669db)(game.bySlug[selected].slug, game.bySlug[selected].name),
                                    " \u2192",
                                    ' ',
                                    (0, $6c154842fccf6556$export$983732bc59a669db)(game.bySlug[fortifyTarget].slug, game.bySlug[fortifyTarget].name),
                                    transferDisrupted && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("em", {
                                        children: [
                                            " ",
                                            (0, $6c154842fccf6556$export$625550452a3fa3ec)('hud.mubadeleTransferLimit')
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>onFortifyAmount(1),
                                children: "1"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: ()=>onFortifyAmount(Math.max(1, Math.floor(maxMove / 2))),
                                children: (0, $6c154842fccf6556$export$625550452a3fa3ec)('hud.half')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "primary",
                                onClick: ()=>onFortifyAmount(maxMove),
                                children: (0, $6c154842fccf6556$export$625550452a3fa3ec)('hud.all', {
                                    n: maxMove
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                onClick: onCancelSelection,
                                children: "\u2715"
                            })
                        ]
                    })
                ]
            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "action-row ai-thinking",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5181a4732ad985ba$export$c463048d6131b309), {
                        faction: game.turn.currentPlayer.faction.name
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: (0, $6c154842fccf6556$export$625550452a3fa3ec)('hud.aiThinking', {
                            faction: (0, $6c154842fccf6556$export$e75392c849ab10e7)(game.turn.currentPlayer.faction.name)
                        })
                    })
                ]
            })
        ]
    });
};



parcelRequire("acw62");
var $2624524d1190a2c3$exports = {};
$2624524d1190a2c3$exports = JSON.parse('{"$schema":"campaign-map.v1","id":"turkish-war-of-independence","version":1,"title":"Turkish War of Independence","description":"Political, military and treaty events from May 1919 through the final Lausanne deadline.","calendar":{"starts":{"year":1919,"month":5},"monthsPerRound":3},"groups":{"nationalPact":["edirne","istanbul","izmit","gelibolu","canakkale","sakarya","balikesir","usak","eskisehir","kutahya","ankara","konya","sivas","kastamonu","samsun","trabzon","erzurum","van","elazig","diyarbakir","izmir","aydin","antalya","isparta","adana","maras","hatay","kars","igdir","mosul"],"westernProvinces":["balikesir","usak","eskisehir","kutahya","sakarya","izmir","aydin"],"occupiers":["Greece","Britain","France","Italy","Armenia"],"assemblySeats":["ankara","sivas"],"armenianHomeland":["gyumri","yerevan","vanadzor","sevan"],"easternCongress":["erzurum","van","elazig","diyarbakir","sivas","trabzon","kars","igdir"],"mudanyaApproaches":["izmit","gelibolu","canakkale"],"mubadeleTurkish":["izmir","aydin","balikesir","canakkale"],"mubadeleGreek":["salonica","kozani"],"mubadeleAffected":["izmir","aydin","balikesir","canakkale","salonica","kozani"],"mosulQuestion":["baghdad","mosul"],"sheikhSaidProvinces":["diyarbakir","elazig","erzurum","van"],"landingPowers":["Britain","France","Greece"],"landingSites":["lesbos","rhodes","izmir","aydin","balikesir","canakkale","gelibolu","edirne","antalya","adana","maras","hatay","aleppo"],"straits":["gelibolu","canakkale"]},"variables":{"assembly":{"active":false,"everConvened":false,"reconveneTurns":0},"britain":{"stoodDown":false},"caliphate":{"abolished":false},"conference":{"pactHeldTurns":0,"rejectedAt":0},"exhaustion":{"round":0},"government":{"fortifyBonus":0},"greatOffensive":{"round":0},"mubadele":{"disruptionRound":0},"greece":{"collapsed":false},"grants":{"sovietAid2":false},"reinforcementPools":{"Armenia":0},"sakarya":{"round":0},"sanRemo":{"completed":false},"sevres":{"shockUntil":0},"sovietAid":{"first":{"received":false},"moscow":{"received":false}},"tekalif":{"until":0},"treaties":{"alexandropol":{"signed":false},"kars":{"signed":false},"ankara":{"signed":false}},"venizelos":{"fell":false},"withdrawals":{"Italy":false,"France":false}},"events":[{"id":"event.erzurumCongress","title":"Erzurum Congress","at":{"year":1919,"month":7,"day":23},"actor":"Turkey","category":"political","data":{"provinces":["sivas","trabzon","erzurum","van","elazig","diyarbakir","kars","igdir"]},"when":[{"territories.erzurum.heldBy":"Turkey"}],"gate":{"id":"erzurum.held","label":"Turkey holds Erzurum"},"then":{"territories":[{"where":{"slug":{"$in":{"$group":"easternCongress"}},"heldBy":"Turkey","entrenched":{"$lt":4}},"set":{"troops":{"$add":["$troops",1]},"entrenched":{"$add":["$entrenched",1]},"quietTurns":0}}]},"outcome":{"id":"erzurum.pulse","label":"Eastern provinces gain militia"}},{"id":"event.sivasCongress","title":"Sivas Congress","at":{"year":1919,"month":9,"day":4},"actor":"Turkey","category":"political","when":[{"territories.sivas.heldBy":"Turkey"}],"gate":{"id":"sivas.held","label":"Turkey holds Sivas"},"then":{"territories":[{"where":{"heldBy":"Turkey","entrenched":{"$lt":4}},"set":{"troops":{"$add":["$troops",1]},"entrenched":{"$add":["$entrenched",1]},"quietTurns":0}}]},"outcome":{"id":"sivas.pulse","label":"Every Turkish province gains militia"}},{"id":"event.istanbulOccupied","title":"Occupation of \u0130stanbul","at":{"year":1920,"month":3,"day":16},"actor":"Britain","category":"political","when":[{"territories.istanbul.heldBy":"Turkey"}],"gate":{"id":"istanbul.occupation-window","label":"Within its three-round window and Turkey holds \u0130stanbul"},"retry":{"mode":"window","rounds":3},"then":{"territories":[{"where":{"slug":"istanbul","heldBy":"Turkey"},"set":{"heldBy":"Britain","troops":{"$max":[1,{"$round":[{"$multiply":["$troops",0.5]},"down"]}]}}}],"cards":[{"faction":"Turkey","count":1}]},"outcome":{"id":"istanbul.occupied","label":"Britain occupies \u0130stanbul","writes":["territory.istanbul"]}},{"id":"event.sanRemo","title":"Conference of San Remo","at":{"year":1920,"month":4,"day":19},"actor":"System","category":"political","then":{"variables":{"sanRemo.completed":true}},"outcome":{"id":"san-remo.thrace","label":"The Entente administration of Western Thrace ends"}},{"id":"event.tbmm","title":"Grand National Assembly","at":{"year":1920,"month":4,"day":23},"actor":"Turkey","category":"political","data":{"fallbackAfterAttempts":3},"when":[{"$or":[{"territories.ankara.heldBy":"Turkey"},{"$and":[{"event.attempts":{"$gte":3}},{"territories.sivas.heldBy":"Turkey"}]}]}],"gate":{"id":"tbmm.seat","label":"Turkey holds Ankara, or Sivas after three delays"},"retry":{"mode":"forever"},"vars":{"date":"$presentation.currentDate","city":"$presentation.assemblySeat"},"then":{"variables":{"assembly.active":true,"assembly.everConvened":true}},"outcome":{"id":"tbmm.convenes","label":"Assembly becomes active","writes":["variables.assembly.active","variables.assembly.everConvened"]}},{"id":"event.sevres","title":"Treaty of S\xe8vres","at":{"year":1920,"month":8,"day":10},"category":"treaty","data":{"shockRounds":2},"vars":{"n":"$event.data.shockRounds"},"then":{"variables":{"sevres.shockUntil":{"$add":["$game.round","$event.data.shockRounds"]}}},"outcome":{"id":"sevres.shock","label":"Recruitment shock begins","writes":["variables.sevres.shockUntil"]}},{"id":"event.ethem","title":"\xc7erkes Ethem revolt","at":{"year":1920,"month":12},"actor":"Turkey","category":"battle","when":[{"variables.assembly.active":true},{"territories":{"$some":{"slug":{"$in":{"$group":"westernProvinces"}},"heldBy":"Turkey","troops":{"$gt":1}}}}],"gate":{"id":"ethem.ready","label":"Assembly is active and Turkey holds an eligible western province","requires":["event.tbmm"]},"then":{"territories":[{"where":{"slug":{"$in":{"$group":"westernProvinces"}},"heldBy":"Turkey","troops":{"$gt":1}},"select":{"$sample":{"fraction":0.5,"round":"up"}},"set":{"troops":{"$round":[{"$multiply":["$troops",0.5]},"down"]},"entrenched":0,"quietTurns":0}}]},"outcome":{"id":"ethem.revolt","label":"Western garrisons revolt"}},{"id":"event.inonu","title":"Second Battle of \u0130n\xf6n\xfc","at":{"year":1921,"month":4},"actor":"Turkey","category":"battle","data":{"greekLosses":3},"when":[{"variables.assembly.active":true},{"territories.eskisehir.heldBy":"Turkey"},{"territories":{"$some":{"heldBy":"Greece","slug":{"$in":{"$group":"nationalPact"}}}}},{"variables.greece.collapsed":{"$ne":true}}],"gate":{"id":"inonu.front","label":"Assembly active, Greece fighting, Turkey holds Eski\u015Fehir","requires":["event.tbmm"]},"retry":{"mode":"window","rounds":3},"then":{"territories":[{"where":{"heldBy":"Greece","adjacent":{"$some":{"slug":"eskisehir"}}},"select":{"$sort":{"troops":"desc"},"$limit":1},"set":{"troops":{"$max":[1,{"$subtract":["$troops",3]}]}}}],"cards":[{"faction":"Turkey"}]},"outcome":{"id":"inonu.stand","label":"Greek army loses units at Eski\u015Fehir"}},{"id":"event.greekOffensive","title":"Greek summer offensive","at":{"year":1921,"month":7},"actor":"Greece","category":"battle","data":{"troopsPerFront":2},"when":[{"variables.greece.collapsed":{"$ne":true}},{"territories":{"$some":{"heldBy":"Greece","slug":{"$in":{"$group":"nationalPact"}}}}}],"gate":{"id":"greek-offensive.ready","label":"Greece still fights in Anatolia and has not collapsed"},"retry":{"mode":"window","rounds":3},"then":{"territories":[{"where":{"heldBy":"Greece","slug":{"$in":{"$group":"nationalPact"}},"adjacent":{"$some":{"heldByAlliance":"turkey"}}},"set":{"troops":{"$add":["$troops",2]},"entrenched":{"$min":[6,{"$add":["$entrenched",1]}]},"quietTurns":0}}]},"outcome":{"id":"greek-offensive.surge","label":"Greek Anatolian front is reinforced and entrenched"}},{"id":"event.sakarya","title":"Battle of Sakarya","at":{"year":1921,"month":9,"day":13},"actor":"Turkey","category":"battle","data":{"freezeRounds":2,"greekAttackDice":2},"vars":{"n":2},"when":[{"variables.assembly.active":true},{"territories.ankara.heldBy":"Turkey"},{"variables.greece.collapsed":{"$ne":true}},{"territories":{"$some":{"heldBy":"Greece","slug":{"$in":{"$group":"nationalPact"}}}}}],"gate":{"id":"sakarya.front","label":"Assembly active, Greece fighting, Turkey holds Ankara","requires":["event.tbmm"]},"retry":{"mode":"window","rounds":3},"then":{"variables":{"sakarya.round":"$game.round"}},"outcome":{"id":"sakarya.stand","label":"Greek offensive freezes and permanently weakens","writes":["variables.sakarya.round"]}},{"id":"event.karsTreaty","title":"Treaty of Kars","at":{"year":1921,"month":10,"day":13},"actor":"Turkey","category":"treaty","when":[{"variables.assembly.active":true},{"variables.treaties.alexandropol.signed":true},{"territories":{"$none":{"slug":{"$in":{"$group":"armenianHomeland"}},"heldBy":{"$ne":"Armenia"}}}},{"territories":{"$none":{"slug":{"$in":{"$group":"nationalPact"}},"heldBy":"Armenia"}}}],"gate":{"id":"kars.ready","label":"Assembly active, Alexandropol signed, Armenian homeland restored and National Pact clear","requires":["event.tbmm","event.alexandropol"]},"retry":{"mode":"forever"},"then":{"variables":{"treaties.kars.signed":true},"territories":[{"where":{"heldBy":"Armenia","slug":{"$nin":{"$group":"armenianHomeland"}}},"set":{"heldBy":"$homelandOwner","troops":1}}]},"outcome":{"id":"kars.signed","label":"Borders settle and both sides are confined by the peace","writes":["variables.treaties.kars.signed"]}},{"id":"event.mudanya","title":"Armistice of Mudanya","at":{"year":1922,"month":10,"day":11},"actor":"Britain","category":"treaty","data":{"approaches":["izmit","gelibolu","canakkale"]},"when":[{"variables.assembly.active":true},{"territories.istanbul.heldBy":"Britain"},{"territories":{"$none":{"slug":{"$in":{"$group":"mudanyaApproaches"}},"heldBy":{"$ne":"Turkey"}}}}],"gate":{"id":"mudanya.ready","label":"Assembly active, Turkey holds the approaches, Britain holds \u0130stanbul","requires":["event.tbmm"]},"retry":{"mode":"forever"},"then":{"territories":[{"where":{"heldBy":"Britain","slug":{"$ne":"istanbul"}},"set":{"troops":{"$add":["$troops",{"$round":[{"$divide":["$territories.istanbul.troops","$selection.count"]},"down"]},{"$if":[{"$lt":["$selection.index",{"$mod":["$territories.istanbul.troops","$selection.count"]}]},1,0]}]}}},{"where":{"slug":"istanbul","heldBy":"Britain"},"set":{"heldBy":"Turkey","troops":1}}]},"outcome":{"id":"mudanya.armistice","label":"\u0130stanbul returns to Turkey and Britain redeploys","writes":["territory.istanbul"]}},{"id":"event.lloydGeorge","title":"Lloyd George falls","at":{"year":1922,"month":10,"day":19},"actor":"Britain","category":"political","when":[{"factions.Britain.territoryCount":{"$lt":{"$multiply":["$factions.Britain.setupTerritoryCount",2]}}}],"gate":{"id":"lloyd-george.not-ascendant","label":"Britain is not ascendant"},"retry":{"mode":"forever"},"then":{"variables":{"britain.stoodDown":true}},"outcome":{"id":"lloyd-george.stand-down","label":"Britain becomes passive","writes":["variables.britain.stoodDown"]}},{"id":"event.sultanate","title":"Sultanate abolished","at":{"year":1922,"month":11,"day":1},"actor":"Turkey","category":"political","data":{"fortifyBonus":1},"when":[{"variables.assembly.active":true}],"gate":{"id":"sultanate.assembly","label":"Assembly is active","requires":["event.tbmm"]},"retry":{"mode":"forever"},"then":{"variables":{"government.fortifyBonus":{"$add":["$variables.government.fortifyBonus",1]}}},"outcome":{"id":"sultanate.abolished","label":"Turkey gains a fortify move","writes":["variables.government.fortifyBonus"]}},{"id":"event.greekCollapse","title":"Greek army collapses","at":{"year":1923,"month":1},"actor":"Greece","category":"battle","when":[{"factions.Greece.territoryCount":{"$lt":{"$multiply":["$factions.Greece.setupTerritoryCount",2]}}}],"gate":{"id":"greek-collapse.not-ascendant","label":"Greece is not ascendant"},"retry":{"mode":"forever"},"then":{"variables":{"greece.collapsed":true}},"outcome":{"id":"greek-collapse.army","label":"Greece fields no new units","writes":["variables.greece.collapsed"]}},{"id":"event.mubadele","title":"Population exchange","at":{"year":1923,"month":1,"day":30},"category":"treaty","data":{"turkish":["izmir","aydin","balikesir","canakkale"],"greek":["salonica","kozani"]},"when":[{"variables.assembly.active":true},{"factions.Greece.territoryCount":{"$gt":0}}],"gate":{"id":"mubadele.assembly","label":"Assembly is active and Greece remains on the map","requires":["event.tbmm"]},"retry":{"mode":"forever"},"then":{"variables":{"mubadele.disruptionRound":"$game.round"}},"outcome":{"id":"mubadele.exchange","label":"Aegean resettlement disrupts regional transport for the round","writes":["variables.mubadele.disruptionRound"]}},{"id":"event.caliphate","title":"Caliphate abolished","at":{"year":1924,"month":3,"day":3},"actor":"Turkey","category":"political","when":[{"variables.assembly.active":true}],"gate":{"id":"caliphate.assembly","label":"Assembly is active","requires":["event.tbmm"]},"retry":{"mode":"forever"},"then":{"variables":{"caliphate.abolished":true},"cards":[{"faction":"Turkey"}]},"outcome":{"id":"caliphate.abolished","label":"Caliphate state is abolished and Turkey draws a card","writes":["variables.caliphate.abolished"]}},{"id":"event.mosulQuestion","title":"Mosul question","at":{"year":1924,"month":10},"category":"treaty","data":{"territories":["baghdad","mosul"]},"when":[{"territories":{"$some":{"slug":{"$in":{"$group":"mosulQuestion"}},"heldBy":"Britain"}}}],"gate":{"id":"mosul.british-award","label":"Britain holds Baghdad or Mosul"},"then":{"territories":[{"where":{"slug":{"$in":{"$group":"mosulQuestion"}},"heldBy":"Britain"},"set":{"heldBy":"Iraq"}}]},"outcome":{"id":"mosul.settled","label":"British Mesopotamian territory passes to Iraq"}},{"id":"event.sheikhSaid","title":"Sheikh Said rebellion","at":{"year":1925,"month":2,"day":13},"actor":"Turkey","category":"battle","data":{"provinces":["diyarbakir","elazig","erzurum","van"]},"when":[{"variables.caliphate.abolished":true},{"territories":{"$some":{"slug":{"$in":{"$group":"sheikhSaidProvinces"}},"heldBy":"Turkey","troops":{"$gt":1}}}}],"gate":{"id":"sheikh-said.ready","label":"Caliphate abolished and Turkey holds an affected eastern province","requires":["event.caliphate"]},"retry":{"mode":"forever"},"then":{"territories":[{"where":{"slug":{"$in":{"$group":"sheikhSaidProvinces"}},"heldBy":"Turkey","troops":{"$gt":1}},"set":{"troops":{"$subtract":["$troops",{"$round":[{"$multiply":["$troops",0.5]},"down"]}]},"entrenched":0,"quietTurns":0}}]},"outcome":{"id":"sheikh-said.revolt","label":"Eastern garrisons and entrenchments are halved"}},{"id":"event.venizelos","title":"Venizelos falls","at":{"year":1920,"month":11},"actor":"Greece","category":"political","when":[{"variables.assembly.active":true},{"territories.ankara.heldBy":{"$ne":"Greece"}}],"gate":{"id":"venizelos.ready","label":"Assembly is active and Greece does not hold Ankara","requires":["event.tbmm"]},"retry":{"mode":"forever"},"then":{"variables":{"venizelos.fell":true}},"outcome":{"id":"venizelos.falls","label":"Salonica levy stops","writes":["variables.venizelos.fell"]}},{"id":"event.alexandropol","title":"Treaty of Alexandropol","at":{"year":1920,"month":12},"actor":"Armenia","category":"treaty","data":{"remobilizationTroops":20},"vars":{"n":20},"when":[{"variables.assembly.active":true},{"factions.Armenia.territoryCount":{"$lt":{"$multiply":["$factions.Armenia.setupTerritoryCount",2]}}}],"gate":{"id":"alexandropol.ready","label":"Assembly is active and Armenia is not ascendant","requires":["event.tbmm"]},"retry":{"mode":"forever"},"then":{"variables":{"treaties.alexandropol.signed":true},"turn":{"reinforcementsLeft":{"$if":[{"$eq":["$turn.currentFaction","Armenia"]},0,"$turn.reinforcementsLeft"]}}},"outcome":{"id":"alexandropol.signed","label":"Armenia makes peace and demobilizes","writes":["variables.treaties.alexandropol.signed"]}},{"id":"event.italyWithdraws","title":"Italy withdraws","at":{"year":1921,"month":6},"actor":"Italy","category":"treaty","then":{"variables":{"withdrawals.Italy":true},"territories":[{"where":{"heldBy":"Italy","homelandOwner":{"$ne":"Italy"},"factions.Italy.peaceBroken":false},"set":{"heldBy":"$homelandOwner","troops":1}}]},"outcome":{"id":"italy.withdraws","label":"Italian conquests return to homeland owners","writes":["variables.withdrawals.Italy"]}},{"id":"event.ankaraAgreement","title":"Ankara Agreement","at":{"year":1921,"month":10},"actor":"France","category":"treaty","when":[{"variables.assembly.active":true}],"gate":{"id":"ankara-agreement.assembly","label":"Assembly is active","requires":["event.tbmm"]},"retry":{"mode":"forever"},"then":{"variables":{"treaties.ankara.signed":true,"withdrawals.France":true},"territories":[{"where":{"heldBy":"France","homelandOwner":{"$ne":"France"},"factions.France.peaceBroken":false},"set":{"heldBy":"$homelandOwner","troops":1}}]},"outcome":{"id":"ankara-agreement.signed","label":"France makes peace and returns its conquests","writes":["variables.treaties.ankara.signed"]}},{"id":"event.exhaustion","title":"Occupation exhaustion","at":{"year":1922,"month":8},"category":"political","when":[{"factions":{"$none":{"name":{"$in":{"$group":"occupiers"}},"territoryCount":{"$gte":{"$multiply":["$setupTerritoryCount",2]}}}}}],"gate":{"id":"exhaustion.no-ascendant","label":"No occupying power is ascendant"},"retry":{"mode":"forever"},"then":{"variables":{"exhaustion.round":"$game.round"}},"outcome":{"id":"exhaustion.begins","label":"Occupation reinforcement and entrenchment end","writes":["variables.exhaustion.round"]}},{"id":"event.sovietAid1","title":"First Soviet shipment","at":{"year":1920,"month":9},"actor":"Turkey","category":"supply","then":{"variables":{"sovietAid.first.received":true},"turn":{"reinforcementsLeft":{"$if":[{"$and":[{"turn.currentFaction":"Turkey"},{"turn.phase":"reinforce"}]},{"$add":["$turn.reinforcementsLeft",1]},"$turn.reinforcementsLeft"]}}},"outcome":{"id":"soviet-aid-1.received","label":"Turkish standing levy improves","writes":["variables.sovietAid.first.received"]}},{"id":"event.sovietAid2","title":"Treaty of Moscow","at":{"year":1921,"month":3,"day":16},"actor":"Turkey","category":"supply","data":{"troops":5},"when":[{"variables.assembly.active":true}],"gate":{"id":"soviet-aid-2.assembly","label":"Assembly is active","requires":["event.tbmm"]},"retry":{"mode":"forever"},"then":{"variables":{"sovietAid.moscow.received":true,"grants.sovietAid2":{"$and":[{"turn.currentFaction":"Turkey"},{"turn.phase":"reinforce"}]}},"turn":{"reinforcementsLeft":{"$if":[{"$and":[{"turn.currentFaction":"Turkey"},{"turn.phase":"reinforce"}]},{"$add":["$turn.reinforcementsLeft",5]},"$turn.reinforcementsLeft"]}}},"outcome":{"id":"soviet-aid-2.received","label":"Turkey receives five units","writes":["variables.sovietAid.moscow.received"]}},{"id":"event.tekalif","title":"Tek\xe2lif-i Milliye","at":{"year":1921,"month":8},"actor":"Turkey","category":"political","data":{"durationRounds":3,"levyPenalty":3,"pressedExchanges":2},"vars":{"n":3,"cost":3},"when":[{"variables.assembly.active":true},{"territories.ankara.heldBy":"Turkey"}],"gate":{"id":"tekalif.ready","label":"Assembly is active and Turkey holds Ankara","requires":["event.tbmm"]},"retry":{"mode":"forever"},"choices":[{"key":"requisition","label":"Proclaim the orders","then":{"variables":{"tekalif.until":{"$add":["$game.round",2]}}}},{"key":"decline","label":"Decline the orders"}]},{"id":"event.greatOffensive","title":"Great Offensive","at":{"year":1922,"month":8,"day":26},"actor":"Turkey","category":"battle","when":[{"variables.assembly.active":true},{"territories":{"$some":{"slug":{"$in":{"$group":"nationalPact"}},"heldBy":{"$in":{"$group":"occupiers"}}}}}],"gate":{"id":"great-offensive.ready","label":"Assembly is active and an occupier remains in the National Pact","requires":["event.tbmm"]},"retry":{"mode":"forever"},"then":{"variables":{"greatOffensive.round":"$game.round"}},"outcome":{"id":"great-offensive.launched","label":"Full mobilization and three-die combat begin","writes":["variables.greatOffensive.round"]}},{"id":"event.conference","title":"Lausanne Conference","at":{"year":1923,"month":7,"day":24},"category":"treaty","data":{"pactHoldRounds":3,"landingPowers":["Britain","France","Greece"],"landingsPerRound":2,"firstWaveTroops":30,"laterWaveTroops":10,"landingSites":["lesbos","rhodes","izmir","aydin","balikesir","canakkale","gelibolu","edirne","antalya","adana","maras","hatay","aleppo"],"straits":["gelibolu","canakkale"]},"when":[{"variables.assembly.active":true},{"game.phase":{"$ne":"gameover"}},{"$or":[{"variables.conference.rejectedAt":{"$exists":false}},{"variables.conference.rejectedAt":0}]},{"game.pactProgress":{"$lt":{"$count":{"$group":"nationalPact"}}}},{"factions":{"$some":{"name":{"$in":{"$group":"landingPowers"}},"eliminated":false}}}],"gate":{"id":"conference.open","label":"Assembly is active and negotiated terms are available","requires":["event.tbmm"]},"retry":{"mode":"forever"},"vars":{"held":"$game.pactProgress","total":{"$count":{"$group":"nationalPact"}}},"choices":[{"key":"accept","label":"Sign the treaty","then":{"game":{"phase":"gameover","endedRound":"$game.round","winner":{"$if":[{"$eq":["$game.pactProgress",{"$count":{"$group":"nationalPact"}}]},"Turkey",null]},"humanDefeated":{"$ne":["$game.pactProgress",{"$count":{"$group":"nationalPact"}}]}}}},{"key":"reject","label":"Fight on","then":{"variables":{"conference.rejectedAt":"$game.round","conference.pactHeldTurns":0}}}]},{"id":"event.lausanne","title":"Final Lausanne settlement","at":{"year":1925,"month":10},"category":"deadline","then":{"game":{"phase":"gameover","endedRound":"$game.round","winner":{"$if":[{"$eq":["$game.pactProgress",{"$count":{"$group":"nationalPact"}}]},"Turkey",null]},"humanDefeated":{"$ne":["$game.pactProgress",{"$count":{"$group":"nationalPact"}}]}}},"outcome":{"id":"lausanne.settled","label":"End the campaign at the outer deadline","writes":["phase","endedRound"]}}],"rules":[{"id":"rule.reinforcements.turkey-foundation","on":"reinforcements.calculate","priority":10,"when":[{"action.faction":"Turkey"}],"then":{"result":{"value":{"$max":[2,{"$round":[{"$divide":["$factions.Turkey.territoryCount",{"$if":[{"variables.assembly.active":true},1.5,2]}]},"down"]}]}}}},{"id":"rule.reinforcements.turkey-soviet-equipment","on":"reinforcements.calculate","priority":20,"when":[{"action.faction":"Turkey"}],"then":{"result":{"value":{"$add":["$result.value",{"$if":[{"variables.sovietAid.first.received":true},3,2]}]}}}},{"id":"rule.reinforcements.sevres","on":"reinforcements.calculate","priority":30,"when":[{"action.faction":"Turkey"},{"variables.sevres.shockUntil":{"$gt":0}}],"then":{"result":{"value":{"$if":[{"game.round":{"$lt":"$variables.sevres.shockUntil"}},{"$max":[2,{"$round":[{"$divide":["$result.value",2]},"down"]}]},{"$add":["$result.value",1]}]}}}},{"id":"rule.reinforcements.turkey-exhaustion","on":"reinforcements.calculate","priority":40,"when":[{"action.faction":"Turkey"}],"then":{"result":{"value":{"$max":[2,{"$round":[{"$multiply":["$result.value",{"$if":[{"variables.greatOffensive.round":{"$gt":0}},1,{"$if":[{"variables.assembly.active":true},0.9,0.75]}]}]},"down"]}]}}}},{"id":"rule.reinforcements.tekalif-cost","on":"reinforcements.calculate","priority":50,"when":[{"action.faction":"Turkey"},{"variables.tekalif.until":{"$gte":"$game.round"}}],"then":{"result":{"value":{"$max":[2,{"$subtract":["$result.value",3]}]}}}},{"id":"rule.reinforcements.britain-demobilization","on":"reinforcements.calculate","priority":10,"when":[{"action.faction":"Britain"}],"then":{"result":{"value":{"$max":[2,{"$subtract":["$result.value",2]}]}}}},{"id":"rule.reinforcements.bulgaria-cap","on":"reinforcements.calculate","priority":10,"when":[{"action.faction":"Bulgaria"}],"then":{"result":{"value":{"$min":["$result.value",2]}}}},{"id":"rule.reinforcements.greek-collapse","on":"reinforcements.calculate","priority":20,"when":[{"action.faction":"Greece"},{"variables.greece.collapsed":true}],"then":{"result":{"value":{"$max":[1,{"$round":[{"$divide":["$factions.Greece.homeTerritoryCount",3]},"down"]}]}}}},{"id":"rule.reinforcements.sakarya","on":"reinforcements.calculate","priority":21,"when":[{"action.faction":"Greece"},{"variables.greece.collapsed":{"$ne":true}},{"variables.sakarya.round":{"$gt":0}}],"then":{"result":{"value":{"$max":[1,{"$subtract":["$result.value",1]}]}}}},{"id":"rule.reinforcements.alexandropol","on":"reinforcements.calculate","priority":20,"when":[{"action.faction":"Armenia"},{"variables.treaties.alexandropol.signed":true},{"factions.Armenia.peaceBroken":false}],"then":{"result":{"value":0}}},{"id":"rule.reinforcements.italian-withdrawal","on":"reinforcements.calculate","priority":20,"when":[{"action.faction":"Italy"},{"variables.withdrawals.Italy":true},{"factions.Italy.peaceBroken":false}],"then":{"result":{"value":0}}},{"id":"rule.reinforcements.ankara-agreement","on":"reinforcements.calculate","priority":20,"when":[{"action.faction":"France"},{"variables.treaties.ankara.signed":true},{"factions.France.peaceBroken":false}],"then":{"result":{"value":{"$round":[{"$divide":["$result.value",2]},"down"]}}}},{"id":"rule.reinforcements.occupation-exhaustion","on":"reinforcements.calculate","priority":100,"when":[{"action.alliance":{"$ne":"turkey"}},{"variables.exhaustion.round":{"$gt":0}},{"action.peaceBroken":false}],"then":{"result":{"value":{"$min":["$result.value",{"$round":[{"$divide":["$action.homeTerritoryCount",3]},"down"]}]}}}},{"id":"rule.turn.apply-armenian-remobilization","on":"turn.started","priority":10,"when":[{"action.faction":"Armenia"},{"variables.reinforcementPools.Armenia":{"$gt":0}}],"then":{"turn":{"reinforcementsLeft":{"$add":["$turn.reinforcementsLeft","$variables.reinforcementPools.Armenia"]}}}},{"id":"rule.turn.clear-armenian-remobilization","on":"turn.started","priority":11,"when":[{"action.faction":"Armenia"},{"variables.reinforcementPools.Armenia":{"$gt":0}}],"then":{"variables":{"reinforcementPools.Armenia":0}}},{"id":"rule.turn.deliver-moscow-grant","on":"turn.started","priority":20,"when":[{"action.faction":"Turkey"},{"variables.sovietAid.moscow.received":true},{"variables.grants.sovietAid2":{"$ne":true}}],"then":{"turn":{"reinforcementsLeft":{"$add":["$turn.reinforcementsLeft",5]}},"variables":{"grants.sovietAid2":true}}},{"id":"rule.peace.britain","on":"faction.peaceStatus","when":[{"action.faction":"Britain"},{"action.peaceBroken":false},{"variables.britain.stoodDown":true}],"then":{"result":{"passive":true,"atPeace":true}}},{"id":"rule.peace.greece","on":"faction.peaceStatus","when":[{"action.faction":"Greece"},{"action.peaceBroken":false},{"variables.greece.collapsed":true}],"then":{"result":{"passive":true,"atPeace":true}}},{"id":"rule.peace.armenia","on":"faction.peaceStatus","when":[{"action.faction":"Armenia"},{"action.peaceBroken":false},{"variables.treaties.alexandropol.signed":true}],"then":{"result":{"passive":true,"atPeace":true}}},{"id":"rule.peace.italy","on":"faction.peaceStatus","when":[{"action.faction":"Italy"},{"action.peaceBroken":false},{"variables.withdrawals.Italy":true}],"then":{"result":{"passive":true,"atPeace":true}}},{"id":"rule.peace.france","on":"faction.peaceStatus","when":[{"action.faction":"France"},{"action.peaceBroken":false},{"variables.treaties.ankara.signed":true}],"then":{"result":{"passive":true,"atPeace":true}}},{"id":"rule.assembly.suspend","on":"round.upkeep","priority":110,"when":[{"variables.assembly.everConvened":true},{"variables.assembly.active":true},{"territories":{"$none":{"slug":{"$in":{"$group":"assemblySeats"}},"heldBy":"Turkey"}}}],"then":{"variables":{"assembly.active":false,"assembly.reconveneTurns":0},"logs":[{"key":"log.assemblySuspended","faction":"Turkey","event":true}]}},{"id":"rule.assembly.count-reconvening","on":"round.upkeep","priority":120,"when":[{"variables.assembly.everConvened":true},{"variables.assembly.active":false},{"territories":{"$some":{"slug":{"$in":{"$group":"assemblySeats"}},"heldBy":"Turkey"}}}],"then":{"variables":{"assembly.reconveneTurns":{"$add":["$variables.assembly.reconveneTurns",1]}}}},{"id":"rule.assembly.reset-reconvening","on":"round.upkeep","priority":125,"when":[{"variables.assembly.everConvened":true},{"variables.assembly.active":false},{"variables.assembly.reconveneTurns":{"$gt":0}},{"territories":{"$none":{"slug":{"$in":{"$group":"assemblySeats"}},"heldBy":"Turkey"}}}],"then":{"variables":{"assembly.reconveneTurns":0}}},{"id":"rule.assembly.reconvene","on":"round.upkeep","priority":130,"when":[{"variables.assembly.active":false},{"variables.assembly.reconveneTurns":{"$gte":3}}],"then":{"variables":{"assembly.active":true,"assembly.reconveneTurns":0},"logs":[{"key":"log.assemblyReconvened","faction":"Turkey","vars":{"city":"$presentation.assemblySeat"},"event":true}]}},{"id":"rule.combat.invader-cap","on":"combatDice.calculate","priority":10,"when":[{"action.kind":{"$ne":"landing"}},{"action.attackerAlliance":{"$ne":"turkey"}},{"action.defenderAlliance":"turkey"},{"action.target.slug":{"$in":{"$group":"nationalPact"}}},{"$or":[{"variables.greatOffensive.round":{"$exists":false}},{"variables.greatOffensive.round":0}]}],"then":{"result":{"attacker":{"$min":["$result.attacker",2]}}}},{"id":"rule.combat.turkish-irregular-cap","on":"combatDice.calculate","priority":10,"when":[{"action.attackerAlliance":"turkey"},{"$or":[{"variables.greatOffensive.round":{"$exists":false}},{"variables.greatOffensive.round":0}]}],"then":{"result":{"attacker":{"$min":["$result.attacker",2]}}}},{"id":"rule.combat.tekalif-equipment","on":"combatDice.calculate","priority":20,"when":[{"action.attackerAlliance":"turkey"},{"variables.tekalif.until":{"$gte":"$game.round"}},{"action.target.slug":{"$in":{"$group":"nationalPact"}}},{"action.exchangesSpent":{"$lt":2}}],"then":{"result":{"attacker":3,"equipped":true}}},{"id":"rule.combat.sakarya-greek-cap","on":"combatDice.calculate","priority":30,"when":[{"action.attacker":"Greece"},{"variables.sakarya.round":{"$gt":0}},{"action.target.slug":{"$in":{"$group":"nationalPact"}}}],"then":{"result":{"attacker":{"$min":["$result.attacker",2]}}}},{"id":"rule.combat.great-offensive-defence","on":"combatDice.calculate","priority":30,"when":[{"action.attackerAlliance":{"$ne":"turkey"}},{"action.defenderAlliance":"turkey"},{"action.target.slug":{"$in":{"$group":"nationalPact"}}},{"variables.greatOffensive.round":{"$gt":0}}],"then":{"result":{"defender":3}}},{"id":"rule.turn.sakarya-freeze","on":"faction.turnStatus","when":[{"action.faction":"Greece"},{"variables.sakarya.round":{"$gt":0}},{"game.round":{"$lt":{"$add":["$variables.sakarya.round",2]}}}],"then":{"result":{"frozen":true}}},{"id":"rule.combat.great-offensive-advance-depth","on":"maximumAdvanceDepth.calculate","when":[{"action.faction":"Turkey"},{"action.target.slug":{"$in":{"$group":"nationalPact"}}},{"variables.greatOffensive.round":{"$gt":0}}],"then":{"result":{"value":3}}},{"id":"rule.movement.mubadele-disruption","on":"transferCapacity.calculate","priority":10,"when":[{"variables.mubadele.disruptionRound":{"$eq":"$game.round"}},{"variables.mubadele.disruptionRound":{"$gt":0}},{"$or":[{"action.from.slug":{"$in":{"$group":"mubadeleAffected"}}},{"action.to.slug":{"$in":{"$group":"mubadeleAffected"}}}]}],"then":{"result":{"value":{"$round":[{"$divide":["$result.value",2]},"down"]}}}},{"id":"rule.fortify.sultanate","on":"fortifyLimit.calculate","when":[{"action.faction":"Turkey"}],"then":{"result":{"value":{"$add":["$result.value","$variables.government.fortifyBonus"]}}}},{"id":"rule.levy.ankara","on":"round.upkeep","priority":50,"then":{"territories":[{"where":{"slug":"ankara","heldBy":"Turkey"},"set":{"troops":{"$add":["$troops",1]}}}]}},{"id":"rule.levy.salonica","on":"round.upkeep","priority":50,"when":[{"variables.venizelos.fell":{"$ne":true}},{"variables.greece.collapsed":{"$ne":true}}],"then":{"territories":[{"where":{"slug":"salonica","heldBy":"Greece"},"set":{"troops":{"$add":["$troops",1]}}}]}},{"id":"rule.entrench.turkish-clock","on":"round.upkeep","priority":10,"when":[{"$or":[{"variables.greatOffensive.round":{"$exists":false}},{"variables.greatOffensive.round":0}]},{"$or":[{"variables.tekalif.until":{"$exists":false}},{"variables.tekalif.until":{"$lt":"$game.round"}}]}],"then":{"territories":[{"where":{"heldByAlliance":"turkey"},"set":{"quietTurns":{"$add":["$quietTurns",1]}}}]}},{"id":"rule.entrench.turkish-pulse","on":"round.upkeep","priority":11,"when":[{"$or":[{"variables.greatOffensive.round":{"$exists":false}},{"variables.greatOffensive.round":0}]},{"$or":[{"variables.tekalif.until":{"$exists":false}},{"variables.tekalif.until":{"$lt":"$game.round"}}]}],"then":{"territories":[{"where":{"heldByAlliance":"turkey","quietTurns":{"$gte":4},"entrenched":{"$lt":4}},"set":{"quietTurns":0,"entrenched":{"$add":["$entrenched",1]},"troops":{"$add":["$troops",1]}}}]}},{"id":"rule.entrench.occupier-clock","on":"round.upkeep","priority":20,"when":[{"$or":[{"variables.exhaustion.round":{"$exists":false}},{"variables.exhaustion.round":0}]}],"then":{"territories":[{"where":{"heldByAlliance":{"$ne":"turkey"},"slug":{"$in":{"$group":"nationalPact"}}},"set":{"quietTurns":{"$add":["$quietTurns",1]}}}]}},{"id":"rule.entrench.occupier-pulse","on":"round.upkeep","priority":21,"when":[{"$or":[{"variables.exhaustion.round":{"$exists":false}},{"variables.exhaustion.round":0}]}],"then":{"territories":[{"where":{"heldByAlliance":{"$ne":"turkey"},"slug":{"$in":{"$group":"nationalPact"}},"quietTurns":{"$gte":2},"entrenched":{"$lt":6}},"set":{"quietTurns":0,"entrenched":{"$add":["$entrenched",1]},"troops":{"$add":["$troops",1]}}}]}},{"id":"rule.conference.reset-pact-clock","on":"round.upkeep","priority":210,"when":[{"game.phase":{"$ne":"gameover"}},{"game.pactProgress":{"$lt":{"$count":{"$group":"nationalPact"}}}}],"then":{"variables":{"conference.pactHeldTurns":0}}},{"id":"rule.conference.advance-pact-clock","on":"round.upkeep","priority":210,"when":[{"game.phase":{"$ne":"gameover"}},{"game.pactProgress":{"$eq":{"$count":{"$group":"nationalPact"}}}}],"then":{"variables":{"conference.pactHeldTurns":{"$add":["$variables.conference.pactHeldTurns",1]}}}},{"id":"rule.conference.pact-victory","on":"round.upkeep","priority":220,"when":[{"variables.conference.pactHeldTurns":{"$gte":3}}],"then":{"game":{"phase":"gameover","endedRound":"$game.round","winner":"Turkey","humanDefeated":false},"logs":[{"key":"log.victory","faction":"Turkey","vars":{"date":"$presentation.currentDateLoc"}}]}},{"id":"rule.conference.unopposed-settlement","on":"round.upkeep","priority":230,"when":[{"game.phase":{"$ne":"gameover"}},{"game.round":{"$gte":18}},{"$or":[{"variables.conference.rejectedAt":{"$exists":false}},{"variables.conference.rejectedAt":0}]},{"factions":{"$none":{"name":{"$in":{"$group":"landingPowers"}},"eliminated":false}}}],"then":{"game":{"phase":"gameover","endedRound":"$game.round","winner":{"$if":[{"$eq":["$game.pactProgress",{"$count":{"$group":"nationalPact"}}]},"Turkey",null]},"humanDefeated":{"$ne":["$game.pactProgress",{"$count":{"$group":"nationalPact"}}]}},"logs":[{"key":{"$if":[{"$eq":["$game.pactProgress",{"$count":{"$group":"nationalPact"}}]},"log.victory","log.lausanneShort"]},"faction":{"$if":[{"$eq":["$game.pactProgress",{"$count":{"$group":"nationalPact"}}]},"Turkey",null]},"vars":{"date":"$presentation.currentDateLoc","held":"$game.pactProgress","total":{"$count":{"$group":"nationalPact"}}}}]}},{"id":"rule.conference.landings","on":"round.upkeep","priority":240,"when":[{"game.phase":{"$ne":"gameover"}},{"variables.conference.rejectedAt":{"$gt":0}},{"game.round":{"$gt":"$variables.conference.rejectedAt"}}],"then":{"battles":[{"repeat":2,"attacker":{"from":"factions","where":{"name":{"$in":{"$group":"landingPowers"}},"eliminated":false},"select":"$sample"},"target":{"from":"territories","where":{"$or":[{"slug":{"$in":{"$group":"landingSites"}}},{"$and":[{"slug":"istanbul"},{"territories.gelibolu.heldByAlliance":{"$ne":"turkey"}},{"territories.canakkale.heldByAlliance":{"$ne":"turkey"}}]},{"$and":[{"slug":"izmit"},{"territories.istanbul.heldByAlliance":{"$ne":"turkey"}}]}]},"select":"$sample"},"troops":{"$if":[{"$eq":["$game.round",{"$add":["$variables.conference.rejectedAt",1]}]},30,10]}}]}},{"id":"rule.alexandropol-breach","on":"attack.started","priority":10,"when":[{"action.attacker":"Turkey"},{"action.defender":"Armenia"},{"variables.treaties.alexandropol.signed":true},{"factions.Armenia.peaceBroken":false}],"then":{"variables":{"reinforcementPools.Armenia":{"$add":["$variables.reinforcementPools.Armenia",20]}},"result":{"remobilized":20}}},{"id":"rule.peace.break","on":"attack.started","priority":20,"when":[{"action.defenderAtPeace":true}],"then":{"factions":[{"where":{"name":"$action.defender"},"set":{"peaceBroken":true}}],"result":{"peaceBroken":true}}},{"id":"rule.liberation.irregulars","on":"territory.captured","priority":10,"when":[{"action.attackerAlliance":"turkey"},{"action.target.slug":{"$in":{"$group":"nationalPact"}}},{"variables.greatOffensive.round":0}],"then":{"territories":[{"where":{"slug":"$action.target.slug"},"set":{"troops":{"$add":["$troops",{"$if":[{"$lte":["$action.occupiedFor",1]},2,1]}]}}}]}},{"id":"rule.liberation.regular-army","on":"territory.captured","priority":20,"when":[{"action.attackerAlliance":"turkey"},{"action.target.slug":{"$in":{"$group":"nationalPact"}}},{"variables.greatOffensive.round":{"$gt":0}},{"game.liberatedThisTurn":false}],"then":{"territories":[{"where":{"slug":"$action.target.slug"},"set":{"troops":{"$add":["$troops",1]}}}],"game":{"liberatedThisTurn":true}}},{"id":"rule.attack.iraq-bystander","on":"attack.validate","priority":1,"when":[{"$or":[{"action.attacker":"Iraq"},{"action.defender":"Iraq"}]}],"then":{"result":{"allowed":false}}},{"id":"rule.attack.national-pact-restraint","on":"attack.target.validate","priority":5,"when":[{"action.attackerAlliance":"turkey"},{"action.target.slug":{"$nin":{"$group":"nationalPact"}}},{"game.pactProgress":{"$lt":{"$count":{"$group":"nationalPact"}}}},{"action.targetLandedOn":false},{"action.retaliationActive":false}],"then":{"result":{"allowed":false}}},{"id":"rule.attack.san-remo-thrace","on":"attack.target.validate","priority":5,"when":[{"action.attacker":"Bulgaria"},{"action.defender":"Greece"},{"variables.sanRemo.completed":false}],"then":{"result":{"allowed":false}}},{"id":"rule.kars-protects-armenia","on":"attack.validate","when":[{"variables.treaties.kars.signed":true},{"action.attacker":"Turkey"},{"action.defender":"Armenia"}],"then":{"result":{"allowed":false}}},{"id":"rule.alexandropol-pacifies-armenia","on":"attack.validate","when":[{"action.attacker":"Armenia"},{"variables.treaties.alexandropol.signed":true},{"factions.Armenia.peaceBroken":false}],"then":{"result":{"allowed":false}}},{"id":"rule.kars-confines-armenia","on":"attack.target.validate","when":[{"variables.treaties.kars.signed":true},{"action.attacker":"Armenia"},{"action.target.slug":{"$nin":{"$group":"armenianHomeland"}}}],"then":{"result":{"allowed":false}}}]}');



const $6fa8a5163afda41a$export$61ba01f667ecbf29 = (year, month, day)=>({
        year: year,
        month: month,
        day: day
    });
const $6fa8a5163afda41a$export$a90da3d0131ffe9 = (calendar, at)=>{
    const start = calendar.starts.year * 12 + calendar.starts.month - 1;
    const target = at.year * 12 + at.month - 1;
    return Math.ceil((target - start) / calendar.monthsPerRound) + 1;
};
const $6fa8a5163afda41a$export$65079553212d26d6 = (calendar, round)=>{
    const monthIndex = calendar.starts.year * 12 + calendar.starts.month - 1 + (round - 1) * calendar.monthsPerRound;
    return {
        year: Math.floor(monthIndex / 12),
        month: monthIndex % 12 + 1
    };
};
const $6fa8a5163afda41a$export$355ef19165780f94 = (id, label, test, requires)=>({
        id: id,
        label: label,
        test: test,
        requires: requires
    });
const $6fa8a5163afda41a$export$ba6444de194e78c5 = (id, label, apply, writes)=>({
        id: id,
        label: label,
        apply: apply,
        writes: writes
    });
const $6fa8a5163afda41a$export$7a5825874deea16a = (key, label, outcomes = [])=>({
        key: key,
        label: label,
        outcomes: outcomes
    });
const $6fa8a5163afda41a$export$9369b12211e1fce4 = {
    once: {
        mode: 'once'
    },
    forever: {
        mode: 'forever'
    },
    attempts: (attempts)=>({
            mode: 'attempts',
            attempts: attempts
        }),
    window: (rounds)=>({
            mode: 'window',
            rounds: rounds
        })
};
const $6fa8a5163afda41a$var$applyOutcomes = (outcomes, context, scope)=>{
    for (const eventOutcome of outcomes ?? [])eventOutcome.apply(context, scope);
};
const $6fa8a5163afda41a$var$attemptsFor = (retryPolicy)=>{
    if (!retryPolicy || retryPolicy.mode === 'once') return undefined;
    if (retryPolicy.mode === 'forever') return Number.POSITIVE_INFINITY;
    return retryPolicy.mode === 'attempts' ? retryPolicy.attempts : retryPolicy.rounds;
};
const $6fa8a5163afda41a$var$valueFrom = (event, key)=>{
    if (!event.data || !(key in event.data)) throw new Error(`${event.id} has no data value named ${key}`);
    return event.data[key];
};
const $6fa8a5163afda41a$export$bb878fb33a12512d = (map, event, currentRound, attempts = 0, hasFired = ()=>false)=>({
        event: event,
        map: map,
        currentRound: currentRound,
        scheduledRound: event.round,
        attempts: attempts,
        elapsedRounds: currentRound - event.round,
        onSchedule: currentRound === event.round,
        hasFired: hasFired,
        value: (key)=>$6fa8a5163afda41a$var$valueFrom(event, key)
    });
const $6fa8a5163afda41a$export$56b57e257ad70daf = (meta, specs)=>{
    const ids = new Set();
    const conditionIds = new Set();
    const outcomeIds = new Set();
    const events = specs.map((spec)=>{
        if (ids.has(spec.id)) throw new Error(`Duplicate event id: ${spec.id}`);
        ids.add(spec.id);
        if (spec.round == null === (spec.at == null)) throw new Error(`${spec.id} must declare exactly one of round or at`);
        const round = spec.round ?? (meta.calendar && spec.at ? $6fa8a5163afda41a$export$a90da3d0131ffe9(meta.calendar, spec.at) : NaN);
        if (!Number.isFinite(round) || round < 1) throw new Error(`Invalid schedule for ${spec.id}`);
        if (spec.retry && !spec.conditions?.length) throw new Error(`${spec.id} retries without a condition`);
        for (const gate of spec.conditions ?? []){
            if (conditionIds.has(gate.id)) throw new Error(`Duplicate condition id: ${gate.id}`);
            conditionIds.add(gate.id);
        }
        for (const eventOutcome of [
            ...spec.outcomes ?? [],
            ...(spec.choices ?? []).flatMap((eventChoice)=>eventChoice.outcomes ?? [])
        ]){
            if (outcomeIds.has(eventOutcome.id)) throw new Error(`Duplicate outcome id: ${eventOutcome.id}`);
            outcomeIds.add(eventOutcome.id);
        }
        const runtime = {
            ...spec,
            round: round
        };
        return runtime;
    });
    for (const event of events)for (const gate of event.conditions ?? [])for (const required of gate.requires ?? [])if (!ids.has(required)) throw new Error(`${event.id} depends on unknown event ${required}`);
    const map = {
        ...meta,
        events: events
    };
    return map;
};
const $6fa8a5163afda41a$export$e9c699717fea721a = (map, eventId)=>{
    const event = map.events.find((candidate)=>candidate.id === eventId);
    if (!event) throw new Error(`Unknown event: ${eventId}`);
    return event;
};
class $6fa8a5163afda41a$export$8f6a565166f76095 {
    map;
    constructor(map){
        this.map = map;
    }
    get events() {
        return this.map.events;
    }
    event(eventId) {
        return $6fa8a5163afda41a$export$e9c699717fea721a(this.map, eventId);
    }
    round(eventId) {
        return this.event(eventId).round;
    }
    value(eventId, key) {
        return $6fa8a5163afda41a$var$valueFrom(this.event(eventId), key);
    }
    conditionsPass(eventId, context, currentRound = this.map.currentRound?.(context) ?? this.round(eventId), attempts = 0, hasFired = ()=>false) {
        const event = this.event(eventId);
        if (event.retry?.mode === 'window' && currentRound > event.round + event.retry.rounds - 1) return false;
        const scope = $6fa8a5163afda41a$export$bb878fb33a12512d(this.map, event, currentRound, attempts, hasFired);
        return (event.conditions ?? []).every((eventCondition)=>eventCondition.test(context, scope));
    }
    variables(event, context, currentRound = this.map.currentRound?.(context) ?? event.round, attempts = 0) {
        return event.vars?.(context, $6fa8a5163afda41a$export$bb878fb33a12512d(this.map, event, currentRound, attempts));
    }
    dispatch(runtime) {
        return $6fa8a5163afda41a$export$20d969d418c25cc7(this.map, runtime);
    }
    resolveChoice(event, choiceKey, context, currentRound = this.map.currentRound?.(context) ?? event.round) {
        return $6fa8a5163afda41a$export$8f5bb1be52565893(this.map, event, choiceKey, context, currentRound);
    }
}
const $6fa8a5163afda41a$export$ebedbb3d51beda4b = (meta, specs)=>new $6fa8a5163afda41a$export$8f6a565166f76095($6fa8a5163afda41a$export$56b57e257ad70daf(meta, specs));
const $6fa8a5163afda41a$export$20d969d418c25cc7 = (map, runtime)=>{
    for (const event of map.events){
        if (runtime.hasPendingDecision()) return;
        if (runtime.round < event.round || runtime.hasFired(event.id)) continue;
        const attempts = runtime.gateAttempts(event.id);
        const scope = $6fa8a5163afda41a$export$bb878fb33a12512d(map, event, runtime.round, attempts, runtime.hasFired);
        if (event.retry?.mode === 'window' && runtime.round > event.round + event.retry.rounds - 1) {
            runtime.markFired(event.id);
            continue;
        }
        if (event.conditions?.length && !event.conditions.every((gate)=>gate.test(runtime.context, scope))) {
            if (runtime.gateLastChecked(event.id) !== runtime.round) {
                runtime.setGateLastChecked(event.id, runtime.round);
                const tried = runtime.gateAttempts(event.id) + 1;
                runtime.setGateAttempts(event.id, tried);
                const limit = $6fa8a5163afda41a$var$attemptsFor(event.retry) ?? 1;
                const windowEnded = event.retry?.mode === 'window' && runtime.round >= event.round + event.retry.rounds - 1;
                if (tried >= limit || windowEnded) runtime.markFired(event.id);
            }
            continue;
        }
        if (event.actor && runtime.actorEliminated(event.actor)) {
            runtime.markFired(event.id);
            continue;
        }
        if (event.choices?.length && !runtime.isHumanTurn) continue;
        runtime.markFired(event.id);
        runtime.announce(event, scope);
        if (event.choices?.length) {
            runtime.setPendingDecision(event);
            return;
        }
        $6fa8a5163afda41a$var$applyOutcomes(event.outcomes, runtime.context, scope);
        if ((event.presentation ?? 'card') === 'card') runtime.queueCard(event.id);
    }
};
const $6fa8a5163afda41a$export$8f5bb1be52565893 = (map, event, choiceKey, context, currentRound = event.round)=>{
    const selected = event.choices?.find((eventChoice)=>eventChoice.key === choiceKey);
    if (!selected) return false;
    $6fa8a5163afda41a$var$applyOutcomes(selected.outcomes, context, $6fa8a5163afda41a$export$bb878fb33a12512d(map, event, currentRound));
    return true;
};
const $6fa8a5163afda41a$var$mermaidId = (prefix, value)=>`${prefix}_${value.replace(/[^a-zA-Z0-9_]/g, '_').replace(/^([0-9])/, '_$1')}`;
const $6fa8a5163afda41a$export$3f9b5e36512a0ea5 = (eventId)=>$6fa8a5163afda41a$var$mermaidId('event', eventId);
const $6fa8a5163afda41a$var$mermaidLabel = (value)=>value.replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/\n/g, ' ');
const $6fa8a5163afda41a$var$MERMAID_MONTHS = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
const $6fa8a5163afda41a$var$mermaidDate = (at)=>`${at.day ? `${at.day} ` : ''}${$6fa8a5163afda41a$var$MERMAID_MONTHS[at.month - 1]} ${at.year}`;
const $6fa8a5163afda41a$export$9b8cb7eeb2dc24b7 = (map, options = {})=>{
    const included = options.eventIds ? new Set(options.eventIds) : null;
    const events = map.events.filter((event)=>!included || included.has(event.id));
    const lines = [
        `flowchart ${options.direction ?? 'LR'}`
    ];
    const known = new Set(events.map((event)=>event.id));
    const retryNodes = [];
    const missNodes = [];
    for (const event of events){
        const eventNode = $6fa8a5163afda41a$export$3f9b5e36512a0ea5(event.id);
        const schedule = `Round ${event.round}${event.at ? ` \xb7 ${$6fa8a5163afda41a$var$mermaidDate(event.at)}` : ''}`;
        lines.push(`  ${eventNode}["${$6fa8a5163afda41a$var$mermaidLabel(`${event.title}<br/>${schedule}`)}"]`);
        const gates = event.conditions ?? [];
        const gateNodesForEvent = gates.map((gate)=>$6fa8a5163afda41a$var$mermaidId('gate', `${event.id}_${gate.id}`));
        gates.forEach((gate, index)=>{
            const gateNode = gateNodesForEvent[index];
            lines.push(`  ${gateNode}{"${$6fa8a5163afda41a$var$mermaidLabel(gate.label)}"}`);
            lines.push(`  ${gateNode} -->|yes| ${gateNodesForEvent[index + 1] ?? eventNode}`);
            for (const dependency of gate.requires ?? [])if (known.has(dependency)) lines.push(`  ${$6fa8a5163afda41a$export$3f9b5e36512a0ea5(dependency)} -. enables .-> ${gateNode}`);
        });
        if (gateNodesForEvent.length) {
            const firstGate = gateNodesForEvent[0];
            if (event.retry?.mode === 'forever') gateNodesForEvent.forEach((gateNode)=>lines.push(`  ${gateNode} -->|no \xb7 next round| ${firstGate}`));
            else if (event.retry?.mode === 'attempts' || event.retry?.mode === 'window') {
                const retryNode = $6fa8a5163afda41a$var$mermaidId('retry', event.id);
                const missNode = $6fa8a5163afda41a$var$mermaidId('miss', event.id);
                const retryLabel = event.retry.mode === 'attempts' ? `Fewer than ${event.retry.attempts} checks used?` : `Still inside ${event.retry.rounds}-round window?`;
                lines.push(`  ${retryNode}{"${$6fa8a5163afda41a$var$mermaidLabel(retryLabel)}"}`);
                lines.push(`  ${missNode}(["Event expires"])`);
                gateNodesForEvent.forEach((gateNode)=>lines.push(`  ${gateNode} -->|no| ${retryNode}`));
                lines.push(`  ${retryNode} -->|yes \xb7 next round| ${firstGate}`);
                lines.push(`  ${retryNode} -->|no| ${missNode}`);
                retryNodes.push(retryNode);
                missNodes.push(missNode);
            } else {
                const missNode = $6fa8a5163afda41a$var$mermaidId('miss', event.id);
                lines.push(`  ${missNode}(["Event does not fire"])`);
                gateNodesForEvent.forEach((gateNode)=>lines.push(`  ${gateNode} -->|no| ${missNode}`));
                missNodes.push(missNode);
            }
        }
        for (const eventOutcome of event.outcomes ?? []){
            const outcomeNode = $6fa8a5163afda41a$var$mermaidId('outcome', `${event.id}_${eventOutcome.id}`);
            lines.push(`  ${outcomeNode}(["${$6fa8a5163afda41a$var$mermaidLabel(eventOutcome.label)}"])`);
            lines.push(`  ${eventNode} --> ${outcomeNode}`);
        }
        for (const eventChoice of event.choices ?? []){
            const choiceNode = $6fa8a5163afda41a$var$mermaidId('choice', `${event.id}_${eventChoice.key}`);
            lines.push(`  ${choiceNode}(["${$6fa8a5163afda41a$var$mermaidLabel(eventChoice.label)}"])`);
            lines.push(`  ${eventNode} -->|choice| ${choiceNode}`);
            for (const eventOutcome of eventChoice.outcomes ?? []){
                const outcomeNode = $6fa8a5163afda41a$var$mermaidId('outcome', `${event.id}_${eventChoice.key}_${eventOutcome.id}`);
                lines.push(`  ${outcomeNode}(["${$6fa8a5163afda41a$var$mermaidLabel(eventOutcome.label)}"])`);
                lines.push(`  ${choiceNode} --> ${outcomeNode}`);
            }
        }
    }
    if (options.includeChronology) {
        const ordered = [
            ...events
        ].sort((a, b)=>a.round - b.round || map.events.indexOf(a) - map.events.indexOf(b));
        for(let i = 1; i < ordered.length; i++)lines.push(`  ${$6fa8a5163afda41a$export$3f9b5e36512a0ea5(ordered[i - 1].id)} ~~~ ${$6fa8a5163afda41a$export$3f9b5e36512a0ea5(ordered[i].id)}`);
    }
    lines.push('  classDef event fill:#e8dfc2,stroke:#23384a,color:#152633,stroke-width:1.5px');
    lines.push('  classDef gate fill:#f5f0df,stroke:#b6713b,color:#3b2c20,stroke-dasharray:4 3');
    lines.push('  classDef outcome fill:#dce8df,stroke:#4e765e,color:#173525');
    lines.push('  classDef choice fill:#e5def0,stroke:#70558d,color:#30203e');
    lines.push('  classDef miss fill:#ece9df,stroke:#8b8577,color:#575247,stroke-dasharray:2 2');
    lines.push('  classDef selected fill:#d2a84c,stroke:#152633,color:#152633,stroke-width:4px');
    if (events.length) lines.push(`  class ${events.map((event)=>$6fa8a5163afda41a$export$3f9b5e36512a0ea5(event.id)).join(',')} event`);
    const gateNodes = events.flatMap((event)=>(event.conditions ?? []).map((gate)=>$6fa8a5163afda41a$var$mermaidId('gate', `${event.id}_${gate.id}`)));
    if (gateNodes.length) lines.push(`  class ${gateNodes.join(',')} gate`);
    if (retryNodes.length) lines.push(`  class ${retryNodes.join(',')} gate`);
    if (missNodes.length) lines.push(`  class ${missNodes.join(',')} miss`);
    const outcomeNodes = events.flatMap((event)=>[
            ...(event.outcomes ?? []).map((eventOutcome)=>$6fa8a5163afda41a$var$mermaidId('outcome', `${event.id}_${eventOutcome.id}`)),
            ...(event.choices ?? []).flatMap((eventChoice)=>(eventChoice.outcomes ?? []).map((eventOutcome)=>$6fa8a5163afda41a$var$mermaidId('outcome', `${event.id}_${eventChoice.key}_${eventOutcome.id}`)))
        ]);
    if (outcomeNodes.length) lines.push(`  class ${outcomeNodes.join(',')} outcome`);
    const choiceNodes = events.flatMap((event)=>(event.choices ?? []).map((eventChoice)=>$6fa8a5163afda41a$var$mermaidId('choice', `${event.id}_${eventChoice.key}`)));
    if (choiceNodes.length) lines.push(`  class ${choiceNodes.join(',')} choice`);
    if (options.selectedEvent && known.has(options.selectedEvent)) lines.push(`  class ${$6fa8a5163afda41a$export$3f9b5e36512a0ea5(options.selectedEvent)} selected`);
    return lines.join('\n');
};
const $6fa8a5163afda41a$export$34bac984d488f657 = (map, options = {})=>$6fa8a5163afda41a$export$9b8cb7eeb2dc24b7(map, options);



var $ilwRK = parcelRequire("ilwRK");
var $3b1ac09509bf51df$exports = {};
$3b1ac09509bf51df$exports = JSON.parse("{\"$schema\":\"http://json-schema.org/draft-07/schema#\",\"$defs\":{\"jsonValue\":{\"anyOf\":[{\"type\":[\"string\",\"number\",\"boolean\",\"null\"]},{\"type\":\"array\",\"items\":{\"$ref\":\"#/$defs/jsonValue\"}},{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#/$defs/jsonValue\"}}]},\"queryArray\":{\"type\":\"array\",\"items\":{\"type\":\"object\"}},\"date\":{\"type\":\"object\",\"additionalProperties\":false,\"required\":[\"year\",\"month\"],\"properties\":{\"year\":{\"type\":\"integer\"},\"month\":{\"type\":\"integer\",\"minimum\":1,\"maximum\":12},\"day\":{\"type\":\"integer\",\"minimum\":1,\"maximum\":31}}},\"entityUpdate\":{\"type\":\"object\",\"additionalProperties\":false,\"required\":[\"set\"],\"properties\":{\"id\":{\"type\":\"string\",\"minLength\":1},\"where\":{\"type\":\"object\"},\"select\":{\"type\":\"object\",\"additionalProperties\":false,\"properties\":{\"$sample\":{\"type\":\"object\",\"additionalProperties\":false,\"properties\":{\"fraction\":{\"type\":\"number\",\"minimum\":0,\"maximum\":1},\"count\":{\"type\":\"integer\",\"minimum\":0},\"round\":{\"enum\":[\"up\",\"down\"]}}},\"$sort\":{\"type\":\"object\",\"additionalProperties\":{\"enum\":[\"asc\",\"desc\"]}},\"$limit\":{\"type\":\"integer\",\"minimum\":0}}},\"set\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#/$defs/jsonValue\"}}}},\"then\":{\"type\":\"object\",\"additionalProperties\":false,\"properties\":{\"variables\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#/$defs/jsonValue\"}},\"territories\":{\"type\":\"array\",\"items\":{\"$ref\":\"#/$defs/entityUpdate\"}},\"factions\":{\"type\":\"array\",\"items\":{\"$ref\":\"#/$defs/entityUpdate\"}},\"turn\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#/$defs/jsonValue\"}},\"game\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#/$defs/jsonValue\"}},\"result\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#/$defs/jsonValue\"}},\"cards\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"additionalProperties\":false,\"required\":[\"faction\"],\"properties\":{\"faction\":{\"$ref\":\"#/$defs/jsonValue\"},\"count\":{\"$ref\":\"#/$defs/jsonValue\"}}}},\"logs\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"additionalProperties\":false,\"required\":[\"key\"],\"properties\":{\"key\":{\"$ref\":\"#/$defs/jsonValue\"},\"faction\":{\"$ref\":\"#/$defs/jsonValue\"},\"vars\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#/$defs/jsonValue\"}},\"event\":{\"$ref\":\"#/$defs/jsonValue\"}}}},\"battles\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"additionalProperties\":false,\"required\":[\"attacker\",\"target\",\"troops\"],\"properties\":{\"repeat\":{\"$ref\":\"#/$defs/jsonValue\"},\"attacker\":{\"$ref\":\"#/$defs/selection\"},\"target\":{\"$ref\":\"#/$defs/selection\"},\"troops\":{\"$ref\":\"#/$defs/jsonValue\"}}}}}},\"selection\":{\"type\":\"object\",\"additionalProperties\":false,\"required\":[\"from\"],\"properties\":{\"from\":{\"enum\":[\"factions\",\"territories\"]},\"where\":{\"type\":\"object\"},\"select\":{\"const\":\"$sample\"},\"field\":{\"type\":\"string\"}}},\"choice\":{\"type\":\"object\",\"additionalProperties\":false,\"required\":[\"key\",\"label\"],\"properties\":{\"key\":{\"type\":\"string\",\"minLength\":1},\"label\":{\"type\":\"string\",\"minLength\":1},\"then\":{\"$ref\":\"#/$defs/then\"}}},\"event\":{\"type\":\"object\",\"additionalProperties\":false,\"required\":[\"id\",\"title\",\"at\"],\"properties\":{\"id\":{\"type\":\"string\",\"minLength\":1},\"title\":{\"type\":\"string\",\"minLength\":1},\"at\":{\"$ref\":\"#/$defs/date\"},\"actor\":{\"type\":\"string\"},\"category\":{\"enum\":[\"political\",\"battle\",\"treaty\",\"supply\",\"deadline\"]},\"presentation\":{\"type\":\"object\"},\"data\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#/$defs/jsonValue\"}},\"when\":{\"$ref\":\"#/$defs/queryArray\"},\"gate\":{\"type\":\"object\",\"additionalProperties\":false,\"required\":[\"id\",\"label\"],\"properties\":{\"id\":{\"type\":\"string\"},\"label\":{\"type\":\"string\"},\"requires\":{\"type\":\"array\",\"items\":{\"type\":\"string\"},\"uniqueItems\":true}}},\"retry\":{\"type\":\"object\",\"additionalProperties\":false,\"required\":[\"mode\"],\"properties\":{\"mode\":{\"enum\":[\"forever\",\"window\"]},\"rounds\":{\"type\":\"integer\",\"minimum\":1}}},\"then\":{\"$ref\":\"#/$defs/then\"},\"outcome\":{\"type\":\"object\",\"additionalProperties\":false,\"required\":[\"id\",\"label\"],\"properties\":{\"id\":{\"type\":\"string\"},\"label\":{\"type\":\"string\"},\"writes\":{\"type\":\"array\",\"items\":{\"type\":\"string\"},\"uniqueItems\":true}}},\"choices\":{\"type\":\"array\",\"items\":{\"$ref\":\"#/$defs/choice\"}},\"vars\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#/$defs/jsonValue\"}}}},\"rule\":{\"type\":\"object\",\"additionalProperties\":false,\"required\":[\"id\",\"on\",\"then\"],\"properties\":{\"id\":{\"type\":\"string\",\"minLength\":1},\"on\":{\"type\":\"string\",\"minLength\":1},\"priority\":{\"type\":\"number\"},\"when\":{\"$ref\":\"#/$defs/queryArray\"},\"then\":{\"$ref\":\"#/$defs/then\"}}}},\"type\":\"object\",\"additionalProperties\":false,\"required\":[\"$schema\",\"id\",\"version\",\"title\",\"calendar\",\"events\"],\"properties\":{\"$schema\":{\"const\":\"campaign-map.v1\"},\"id\":{\"type\":\"string\",\"minLength\":1},\"version\":{\"type\":\"integer\",\"minimum\":1},\"title\":{\"type\":\"string\",\"minLength\":1},\"description\":{\"type\":\"string\"},\"calendar\":{\"type\":\"object\",\"additionalProperties\":false,\"required\":[\"starts\",\"monthsPerRound\"],\"properties\":{\"starts\":{\"$ref\":\"#/$defs/date\"},\"monthsPerRound\":{\"type\":\"integer\",\"minimum\":1}}},\"groups\":{\"type\":\"object\",\"additionalProperties\":{\"type\":\"array\",\"items\":{\"$ref\":\"#/$defs/jsonValue\"},\"uniqueItems\":true}},\"variables\":{\"type\":\"object\",\"additionalProperties\":{\"$ref\":\"#/$defs/jsonValue\"}},\"events\":{\"type\":\"array\",\"items\":{\"$ref\":\"#/$defs/event\"}},\"rules\":{\"type\":\"array\",\"items\":{\"$ref\":\"#/$defs/rule\"}}}}");


const $f58ea500d1dcc983$var$validateSchema = new (0, (/*@__PURE__*/$parcel$interopDefault($ilwRK)))({
    allErrors: true,
    strict: true,
    allowUnionTypes: true
}).compile((0, (/*@__PURE__*/$parcel$interopDefault($3b1ac09509bf51df$exports))));
const $f58ea500d1dcc983$var$OPERATORS = new Set([
    '$add',
    '$and',
    '$count',
    '$divide',
    '$eq',
    '$exists',
    '$group',
    '$gt',
    '$gte',
    '$if',
    '$in',
    '$limit',
    '$lt',
    '$lte',
    '$max',
    '$min',
    '$mod',
    '$multiply',
    '$ne',
    '$nin',
    '$none',
    '$not',
    '$or',
    '$round',
    '$sample',
    '$some',
    '$sort',
    '$subtract',
    '$every',
    '$literal'
]);
const $f58ea500d1dcc983$var$object = (value)=>!!value && typeof value === 'object' && !Array.isArray(value);
const $f58ea500d1dcc983$var$semanticValidation = (document)=>{
    const groups = $f58ea500d1dcc983$var$object(document.groups) ? new Set(Object.keys(document.groups)) : new Set();
    const events = document.events;
    const rules = document.rules ?? [];
    const eventIds = new Set();
    const ruleIds = new Set();
    for (const event of events){
        const id = String(event.id);
        if (eventIds.has(id)) throw new Error(`Campaign document contains duplicate event id ${id}`);
        eventIds.add(id);
        const choices = event.choices ?? [];
        const choiceKeys = new Set();
        for (const choice of choices){
            const key = String(choice.key);
            if (choiceKeys.has(key)) throw new Error(`Campaign event ${id} contains duplicate choice key ${key}`);
            choiceKeys.add(key);
        }
    }
    for (const rule of rules){
        const id = String(rule.id);
        if (ruleIds.has(id)) throw new Error(`Campaign document contains duplicate rule id ${id}`);
        ruleIds.add(id);
    }
    for (const event of events){
        const gate = $f58ea500d1dcc983$var$object(event.gate) ? event.gate : null;
        for (const required of gate?.requires ?? [])if (!eventIds.has(required)) throw new Error(`Campaign event ${event.id} requires unknown event ${required}`);
    }
    const visit = (value, path)=>{
        if (Array.isArray(value)) {
            value.forEach((item, index)=>visit(item, `${path}/${index}`));
            return;
        }
        if (!$f58ea500d1dcc983$var$object(value)) return;
        for (const [key, item] of Object.entries(value)){
            if (key === '$group' && (typeof item !== 'string' || !groups.has(item))) throw new Error(`Campaign document references unknown group ${String(item)} at ${path}`);
            if (key.startsWith('$') && key !== '$schema' && !$f58ea500d1dcc983$var$OPERATORS.has(key)) throw new Error(`Campaign document uses unsupported operator ${key} at ${path}`);
            visit(item, `${path}/${key}`);
        }
    };
    visit(document, '');
};
const $f58ea500d1dcc983$export$86195bdf4982ebe1 = (document)=>{
    if (!$f58ea500d1dcc983$var$object(document)) throw new Error('Campaign document must be a JSON object');
    if (document.$schema !== 'campaign-map.v1') throw new Error('Unsupported campaign document schema');
    if (!Array.isArray(document.events)) throw new Error('Campaign document requires an events array');
    if (!$f58ea500d1dcc983$var$validateSchema(document)) {
        const details = $f58ea500d1dcc983$var$validateSchema.errors?.map((error)=>`${error.instancePath || '/'} ${error.message}`).join('; ');
        throw new Error(`Invalid campaign document: ${details}`);
    }
    $f58ea500d1dcc983$var$semanticValidation(document);
};


const $df0d9308ad8f3180$export$a4a48e7a73cf2842 = (document)=>{
    (0, $f58ea500d1dcc983$export$86195bdf4982ebe1)(document);
    return document;
};
const $df0d9308ad8f3180$export$cfd840527205979b = (document)=>document.events.map((event)=>({
            id: event.id,
            title: event.title,
            round: (0, $6fa8a5163afda41a$export$a90da3d0131ffe9)(document.calendar, event.at),
            at: event.at,
            retry: event.retry,
            conditions: event.when?.length ? [
                {
                    id: event.gate?.id ?? `${event.id}.when`,
                    label: event.gate?.label ?? 'Declared conditions are satisfied',
                    requires: event.gate?.requires
                }
            ] : undefined,
            outcomes: event.then ? [
                {
                    id: event.outcome?.id ?? `${event.id}.then`,
                    label: event.outcome?.label ?? 'Apply declared changes'
                }
            ] : undefined,
            choices: event.choices?.map((eventChoice)=>({
                    key: eventChoice.key,
                    label: eventChoice.label,
                    outcomes: eventChoice.then ? [
                        {
                            id: `${event.id}.${eventChoice.key}`,
                            label: eventChoice.label
                        }
                    ] : undefined
                }))
        }));


const $4b381e23cd3413de$var$isObject = (value)=>!!value && typeof value === 'object' && !Array.isArray(value);
const $4b381e23cd3413de$export$2aa3fd96c49a84a8 = (source, path)=>{
    if (!path) return source;
    let value = source;
    for (const part of path.split('.')){
        if (value == null) return undefined;
        if (Array.isArray(value) && /^\d+$/.test(part)) value = value[Number(part)];
        else value = value[part];
    }
    return value;
};
const $4b381e23cd3413de$export$1518ffc4a8ff94f2 = (source, path, value)=>{
    const parts = path.split('.');
    let target = source;
    for (const part of parts.slice(0, -1)){
        if (!$4b381e23cd3413de$var$isObject(target[part])) target[part] = {};
        target = target[part];
    }
    target[parts.at(-1)] = value;
};
const $4b381e23cd3413de$var$reference = (path, context)=>{
    if (path === 'selection.index') return context.selection?.index;
    if (path === 'selection.count') return context.selection?.count;
    if (path === 'event.attempts') return context.scope?.attempts;
    if (path === 'event.elapsedRounds') return context.scope?.elapsedRounds;
    if (path === 'event.scheduledRound') return context.scope?.scheduledRound;
    if (path === 'event.currentRound') return context.scope?.currentRound;
    if (path.startsWith('event.')) {
        const scopedEventValue = $4b381e23cd3413de$export$2aa3fd96c49a84a8(context.scope?.event, path.slice(6));
        if (scopedEventValue !== undefined) return scopedEventValue;
    }
    const relative = context.entity == null ? undefined : $4b381e23cd3413de$export$2aa3fd96c49a84a8(context.entity, path);
    return relative !== undefined ? relative : $4b381e23cd3413de$export$2aa3fd96c49a84a8(context.host.root, path);
};
const $4b381e23cd3413de$export$b7a508fa8dae59fc = (value)=>Number(value ?? 0);
const $4b381e23cd3413de$export$fef61f332f2c0afc = (value, context)=>{
    if (typeof value === 'string' && value.startsWith('$')) return $4b381e23cd3413de$var$reference(value.slice(1), context);
    if (Array.isArray(value)) return value.map((item)=>$4b381e23cd3413de$export$fef61f332f2c0afc(item, context));
    if (!$4b381e23cd3413de$var$isObject(value)) return value;
    if ('$literal' in value) return value.$literal;
    if ('$group' in value) return context.host.groups?.[String(value.$group)] ?? [];
    if ('$and' in value) return value.$and.every((clause)=>$4b381e23cd3413de$export$720c7cf5a5c0e696(context.host.root, clause, context));
    if ('$or' in value) return value.$or.some((clause)=>$4b381e23cd3413de$export$720c7cf5a5c0e696(context.host.root, clause, context));
    if ('$not' in value) return !$4b381e23cd3413de$export$720c7cf5a5c0e696(context.host.root, value.$not, context);
    if ('$add' in value) return $4b381e23cd3413de$export$fef61f332f2c0afc(value.$add, context).reduce((sum, item)=>sum + $4b381e23cd3413de$export$b7a508fa8dae59fc(item), 0);
    if ('$subtract' in value) {
        const [first, ...rest] = $4b381e23cd3413de$export$fef61f332f2c0afc(value.$subtract, context);
        return rest.reduce((sum, item)=>sum - $4b381e23cd3413de$export$b7a508fa8dae59fc(item), $4b381e23cd3413de$export$b7a508fa8dae59fc(first));
    }
    if ('$multiply' in value) return $4b381e23cd3413de$export$fef61f332f2c0afc(value.$multiply, context).reduce((product, item)=>product * $4b381e23cd3413de$export$b7a508fa8dae59fc(item), 1);
    if ('$divide' in value) {
        const [left, right] = $4b381e23cd3413de$export$fef61f332f2c0afc(value.$divide, context);
        return $4b381e23cd3413de$export$b7a508fa8dae59fc(left) / $4b381e23cd3413de$export$b7a508fa8dae59fc(right);
    }
    if ('$mod' in value) {
        const [left, right] = $4b381e23cd3413de$export$fef61f332f2c0afc(value.$mod, context);
        return $4b381e23cd3413de$export$b7a508fa8dae59fc(left) % $4b381e23cd3413de$export$b7a508fa8dae59fc(right);
    }
    if ('$min' in value) return Math.min(...$4b381e23cd3413de$export$fef61f332f2c0afc(value.$min, context).map($4b381e23cd3413de$export$b7a508fa8dae59fc));
    if ('$max' in value) return Math.max(...$4b381e23cd3413de$export$fef61f332f2c0afc(value.$max, context).map($4b381e23cd3413de$export$b7a508fa8dae59fc));
    if ('$round' in value) {
        const [operand, direction] = value.$round;
        const n = $4b381e23cd3413de$export$b7a508fa8dae59fc($4b381e23cd3413de$export$fef61f332f2c0afc(operand, context));
        return direction === 'up' ? Math.ceil(n) : direction === 'down' ? Math.floor(n) : Math.round(n);
    }
    if ('$if' in value) {
        const [conditionValue, yes, no] = value.$if;
        const conditionResult = $4b381e23cd3413de$var$isObject(conditionValue) && !Object.keys(conditionValue).some((key)=>[
                '$eq',
                '$ne',
                '$gt',
                '$gte',
                '$lt',
                '$lte',
                '$and',
                '$or',
                '$not'
            ].includes(key)) ? $4b381e23cd3413de$export$720c7cf5a5c0e696(context.host.root, conditionValue, context) : $4b381e23cd3413de$export$fef61f332f2c0afc(conditionValue, context);
        return conditionResult ? $4b381e23cd3413de$export$fef61f332f2c0afc(yes, context) : $4b381e23cd3413de$export$fef61f332f2c0afc(no, context);
    }
    if ('$count' in value) {
        const evaluated = $4b381e23cd3413de$export$fef61f332f2c0afc(value.$count, context);
        if (Array.isArray(evaluated) || typeof evaluated === 'string') return evaluated.length;
        if ($4b381e23cd3413de$var$isObject(evaluated)) return Object.keys(evaluated).length;
        return 0;
    }
    for (const operator of [
        '$eq',
        '$ne',
        '$gt',
        '$gte',
        '$lt',
        '$lte'
    ]){
        if (!(operator in value)) continue;
        const [left, right] = $4b381e23cd3413de$export$fef61f332f2c0afc(value[operator], context);
        return $4b381e23cd3413de$var$compare(left, operator, right, context);
    }
    return Object.fromEntries(Object.entries(value).map(([key, item])=>[
            key,
            $4b381e23cd3413de$export$fef61f332f2c0afc(item, context)
        ]));
};
const $4b381e23cd3413de$var$equal = (actual, expected)=>{
    if (Array.isArray(actual) && !Array.isArray(expected)) return actual.includes(expected);
    return actual === expected;
};
const $4b381e23cd3413de$var$compare = (actual, operator, operand, context)=>{
    const expected = $4b381e23cd3413de$export$fef61f332f2c0afc(operand, context);
    switch(operator){
        case '$eq':
            return $4b381e23cd3413de$var$equal(actual, expected);
        case '$ne':
            return !$4b381e23cd3413de$var$equal(actual, expected);
        case '$gt':
            return $4b381e23cd3413de$export$b7a508fa8dae59fc(actual) > $4b381e23cd3413de$export$b7a508fa8dae59fc(expected);
        case '$gte':
            return $4b381e23cd3413de$export$b7a508fa8dae59fc(actual) >= $4b381e23cd3413de$export$b7a508fa8dae59fc(expected);
        case '$lt':
            return $4b381e23cd3413de$export$b7a508fa8dae59fc(actual) < $4b381e23cd3413de$export$b7a508fa8dae59fc(expected);
        case '$lte':
            return $4b381e23cd3413de$export$b7a508fa8dae59fc(actual) <= $4b381e23cd3413de$export$b7a508fa8dae59fc(expected);
        case '$in':
            return Array.isArray(expected) && expected.includes(actual);
        case '$nin':
            return Array.isArray(expected) && !expected.includes(actual);
        case '$exists':
            return expected ? actual !== undefined : actual === undefined;
        default:
            return false;
    }
};
const $4b381e23cd3413de$var$collectionValues = (value)=>Array.isArray(value) ? value : $4b381e23cd3413de$var$isObject(value) ? Object.values(value) : [];
const $4b381e23cd3413de$var$matchesField = (actual, expected, context)=>{
    if (!$4b381e23cd3413de$var$isObject(expected) || !Object.keys(expected).some((key)=>key.startsWith('$'))) return $4b381e23cd3413de$var$equal(actual, $4b381e23cd3413de$export$fef61f332f2c0afc(expected, context));
    if ('$some' in expected) return $4b381e23cd3413de$var$collectionValues(actual).some((item)=>$4b381e23cd3413de$export$720c7cf5a5c0e696(item, expected.$some, {
            ...context,
            entity: item
        }));
    if ('$none' in expected) return $4b381e23cd3413de$var$collectionValues(actual).every((item)=>!$4b381e23cd3413de$export$720c7cf5a5c0e696(item, expected.$none, {
            ...context,
            entity: item
        }));
    if ('$every' in expected) return $4b381e23cd3413de$var$collectionValues(actual).every((item)=>$4b381e23cd3413de$export$720c7cf5a5c0e696(item, expected.$every, {
            ...context,
            entity: item
        }));
    return Object.entries(expected).every(([operator, operand])=>$4b381e23cd3413de$var$compare(actual, operator, operand, context));
};
const $4b381e23cd3413de$export$720c7cf5a5c0e696 = (entity, query, context)=>{
    if ('$and' in query) return query.$and.every((clause)=>$4b381e23cd3413de$export$720c7cf5a5c0e696(entity, clause, context));
    if ('$or' in query) return query.$or.some((clause)=>$4b381e23cd3413de$export$720c7cf5a5c0e696(entity, clause, context));
    if ('$not' in query) return !$4b381e23cd3413de$export$720c7cf5a5c0e696(entity, query.$not, context);
    return Object.entries(query).every(([path, expected])=>{
        const actual = $4b381e23cd3413de$var$reference(path, {
            ...context,
            entity: entity
        });
        return $4b381e23cd3413de$var$matchesField(actual, expected, {
            ...context,
            entity: entity
        });
    });
};
const $4b381e23cd3413de$export$f8d845b709d7dead = (when, host, scope)=>(when ?? []).every((clause)=>$4b381e23cd3413de$export$720c7cf5a5c0e696(host.root, clause, {
            host: host,
            scope: scope
        }));


const $ecb1a4ea9ed6bc66$var$selectedEntities = (update, host, collection, scope)=>{
    let selected = host.collections[collection].filter((entity)=>!update.where || (0, $4b381e23cd3413de$export$720c7cf5a5c0e696)(entity, update.where, {
            host: host,
            entity: entity,
            scope: scope
        }));
    if (update.select?.$sort) {
        const fields = Object.entries(update.select.$sort);
        selected = [
            ...selected
        ].sort((left, right)=>{
            for (const [field, direction] of fields){
                const a = (0, $4b381e23cd3413de$export$2aa3fd96c49a84a8)(left, field);
                const b = (0, $4b381e23cd3413de$export$2aa3fd96c49a84a8)(right, field);
                if (a === b) continue;
                const comparison = a < b ? -1 : 1;
                return direction === 'desc' ? -comparison : comparison;
            }
            return 0;
        });
    }
    if (update.select?.$sample) {
        const random = host.random ?? Math.random;
        const shuffled = [
            ...selected
        ];
        for(let i = shuffled.length - 1; i > 0; i--){
            const j = Math.floor(random() * (i + 1));
            [shuffled[i], shuffled[j]] = [
                shuffled[j],
                shuffled[i]
            ];
        }
        const sample = update.select.$sample;
        const raw = sample.count ?? selected.length * (sample.fraction ?? 1);
        const count = sample.round === 'down' ? Math.floor(raw) : Math.ceil(raw);
        selected = shuffled.slice(0, Math.max(0, count));
    }
    if (update.select?.$limit != null) selected = selected.slice(0, update.select.$limit);
    return selected;
};
const $ecb1a4ea9ed6bc66$export$d7257c389cd5bac5 = (then, host, scope)=>{
    if (!then) return;
    const changed = new Set();
    for (const [path, expression] of Object.entries(then.variables ?? {})){
        const value = (0, $4b381e23cd3413de$export$fef61f332f2c0afc)(expression, {
            host: host,
            scope: scope
        });
        host.setVariable?.(path, value);
        if (!host.setVariable) (0, $4b381e23cd3413de$export$1518ffc4a8ff94f2)(host.root.variables, path, value);
        changed.add('variables');
    }
    for (const collection of [
        'territories',
        'factions'
    ])for (const update of then[collection] ?? []){
        const selected = $ecb1a4ea9ed6bc66$var$selectedEntities(update, host, collection, scope);
        const patches = selected.map((entity, index)=>({
                entity: entity,
                values: Object.fromEntries(Object.entries(update.set).map(([field, expression])=>[
                        field,
                        (0, $4b381e23cd3413de$export$fef61f332f2c0afc)(expression, {
                            host: host,
                            entity: entity,
                            selection: {
                                index: index,
                                count: selected.length
                            },
                            scope: scope
                        })
                    ]))
            }));
        for (const patch of patches)for (const [field, value] of Object.entries(patch.values))host.setEntity(collection, patch.entity, field, value);
        if (patches.length) changed.add(collection);
    }
    for (const rootName of [
        'turn',
        'game',
        'result'
    ])for (const [field, expression] of Object.entries(then[rootName] ?? {})){
        const value = (0, $4b381e23cd3413de$export$fef61f332f2c0afc)(expression, {
            host: host,
            scope: scope
        });
        host.setRoot?.(rootName, field, value);
        if (!host.setRoot) (0, $4b381e23cd3413de$export$1518ffc4a8ff94f2)(host.root[rootName], field, value);
        changed.add(rootName);
    }
    for (const card of then.cards ?? []){
        const faction = String((0, $4b381e23cd3413de$export$fef61f332f2c0afc)(card.faction, {
            host: host,
            scope: scope
        }));
        const count = (0, $4b381e23cd3413de$export$b7a508fa8dae59fc)((0, $4b381e23cd3413de$export$fef61f332f2c0afc)(card.count ?? 1, {
            host: host,
            scope: scope
        }));
        host.drawCards?.(faction, count);
        changed.add('cards');
    }
    for (const log of then.logs ?? []){
        const key = String((0, $4b381e23cd3413de$export$fef61f332f2c0afc)(log.key, {
            host: host,
            scope: scope
        }));
        const factionValue = (0, $4b381e23cd3413de$export$fef61f332f2c0afc)(log.faction ?? null, {
            host: host,
            scope: scope
        });
        const vars = Object.fromEntries(Object.entries(log.vars ?? {}).map(([name, expression])=>[
                name,
                (0, $4b381e23cd3413de$export$fef61f332f2c0afc)(expression, {
                    host: host,
                    scope: scope
                })
            ]));
        host.writeLog?.(key, factionValue == null ? null : String(factionValue), vars, (0, $4b381e23cd3413de$export$fef61f332f2c0afc)(log.event ?? false, {
            host: host,
            scope: scope
        }) === true);
    }
    for (const battle of then.battles ?? []){
        const repeat = (0, $4b381e23cd3413de$export$b7a508fa8dae59fc)((0, $4b381e23cd3413de$export$fef61f332f2c0afc)(battle.repeat ?? 1, {
            host: host,
            scope: scope
        }));
        for(let n = 0; n < repeat; n++){
            const choose = (selection)=>{
                const candidates = host.collections[selection.from].filter((entity)=>!selection.where || (0, $4b381e23cd3413de$export$720c7cf5a5c0e696)(entity, selection.where, {
                        host: host,
                        entity: entity,
                        scope: scope
                    }));
                if (!candidates.length) return undefined;
                const index = selection.select === '$sample' ? Math.floor((host.random ?? Math.random)() * candidates.length) : 0;
                return (0, $4b381e23cd3413de$export$2aa3fd96c49a84a8)(candidates[index], selection.field ?? (selection.from === 'factions' ? 'name' : 'slug'));
            };
            const attacker = choose(battle.attacker);
            const target = choose(battle.target);
            if (attacker != null && target != null) host.resolveBattle?.(String(attacker), String(target), (0, $4b381e23cd3413de$export$b7a508fa8dae59fc)((0, $4b381e23cd3413de$export$fef61f332f2c0afc)(battle.troops, {
                host: host,
                scope: scope
            })));
        }
    }
    host.afterApply?.(changed);
};



const $5b57b6d8a1f22309$export$a6cdc56e425d0d0a = (value)=>!!value && typeof value === 'object' && !Array.isArray(value);
const $5b57b6d8a1f22309$export$aff7a2c55c422b83 = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
const $5b57b6d8a1f22309$export$a5a0914cccdde6d5 = (prefix, ...parts)=>`${prefix}_${parts.join('_').replace(/[^a-zA-Z0-9_]/g, '_').replace(/^([0-9])/, '_$1')}`;
const $5b57b6d8a1f22309$var$graphEscape = (value)=>String(value).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
const $5b57b6d8a1f22309$export$6c3e2e0c633386e8 = (lines)=>lines.filter((line)=>line !== undefined && line !== '').map($5b57b6d8a1f22309$var$graphEscape).join('<br/>');
const $5b57b6d8a1f22309$export$66c93ee051ba7e2a = (path)=>path.startsWith('action.') ? `trigger input \xb7 ${path.slice(7)}` : path;
const $5b57b6d8a1f22309$export$c2f35a86bc746465 = (value)=>{
    if (typeof value === 'string') return value.startsWith('$') ? value : JSON.stringify(value);
    if (value === null || typeof value === 'number' || typeof value === 'boolean') return String(value);
    if (Array.isArray(value)) return `[${value.map($5b57b6d8a1f22309$export$c2f35a86bc746465).join(', ')}]`;
    if (!$5b57b6d8a1f22309$export$a6cdc56e425d0d0a(value)) return String(value);
    if ('$group' in value) return `group:${String(value.$group)}`;
    if ('$literal' in value) return $5b57b6d8a1f22309$export$c2f35a86bc746465(value.$literal);
    return Object.entries(value).map(([key, item])=>`${key} ${$5b57b6d8a1f22309$export$c2f35a86bc746465(item)}`).join(', ');
};
const $5b57b6d8a1f22309$export$94ca9a8392da2889 = {
    $eq: '=',
    $ne: "\u2260",
    $gt: '>',
    $gte: "\u2265",
    $lt: '<',
    $lte: "\u2264",
    $in: 'in',
    $nin: 'not in',
    $exists: 'exists',
    $some: 'any',
    $none: 'none',
    $every: 'all'
};
function $5b57b6d8a1f22309$export$614d86e866f80092(query) {
    if (!$5b57b6d8a1f22309$export$a6cdc56e425d0d0a(query)) return $5b57b6d8a1f22309$export$c2f35a86bc746465(query);
    if ('$and' in query || '$or' in query) {
        const operator = '$and' in query ? '$and' : '$or';
        const clauses = Array.isArray(query[operator]) ? query[operator] : [];
        return `(${clauses.map($5b57b6d8a1f22309$export$614d86e866f80092).join(operator === '$and' ? ' AND ' : ' OR ')})`;
    }
    if ('$not' in query) return `NOT (${$5b57b6d8a1f22309$export$614d86e866f80092(query.$not)})`;
    for (const [operator, label] of Object.entries($5b57b6d8a1f22309$export$94ca9a8392da2889)){
        if (!(operator in query) || !Array.isArray(query[operator])) continue;
        const operands = query[operator];
        return operands.length === 2 ? `${$5b57b6d8a1f22309$export$3558f7451ea2e1b(operands[0])} ${label} ${$5b57b6d8a1f22309$export$3558f7451ea2e1b(operands[1])}` : `${label} ${operands.map($5b57b6d8a1f22309$export$3558f7451ea2e1b).join(', ')}`;
    }
    return Object.entries(query).map(([path, expected])=>{
        if (!$5b57b6d8a1f22309$export$a6cdc56e425d0d0a(expected) || !Object.keys(expected).some((key)=>key.startsWith('$'))) return `${path} = ${$5b57b6d8a1f22309$export$3558f7451ea2e1b(expected)}`;
        return Object.entries(expected).map(([operator, operand])=>{
            const label = $5b57b6d8a1f22309$export$94ca9a8392da2889[operator] ?? operator.replace(/^\$/, '');
            const rendered = [
                '$some',
                '$none',
                '$every'
            ].includes(operator) ? $5b57b6d8a1f22309$export$614d86e866f80092(operand) : $5b57b6d8a1f22309$export$3558f7451ea2e1b(operand);
            return `${path} ${label} ${rendered}`;
        }).join(' AND ');
    }).join(' AND ');
}
const $5b57b6d8a1f22309$export$313cceabf063c648 = {
    $add: {
        name: 'ADD',
        symbol: '+'
    },
    $subtract: {
        name: 'SUBTRACT',
        symbol: "\u2212"
    },
    $multiply: {
        name: 'MULTIPLY',
        symbol: "\xd7"
    },
    $divide: {
        name: 'DIVIDE',
        symbol: "\xf7"
    },
    $mod: {
        name: 'REMAINDER',
        symbol: 'mod'
    },
    $min: {
        name: 'MINIMUM OF'
    },
    $max: {
        name: 'MAXIMUM OF'
    }
};
function $5b57b6d8a1f22309$export$3558f7451ea2e1b(value) {
    if (typeof value === 'string') return value.startsWith('$') ? value : JSON.stringify(value);
    if (value === null || typeof value === 'number' || typeof value === 'boolean') return String(value);
    if (Array.isArray(value)) return value.map($5b57b6d8a1f22309$export$3558f7451ea2e1b).join(', ');
    if (!$5b57b6d8a1f22309$export$a6cdc56e425d0d0a(value)) return String(value);
    if ('$group' in value) return `group:${String(value.$group)}`;
    if ('$literal' in value) return $5b57b6d8a1f22309$export$3558f7451ea2e1b(value.$literal);
    if ('$count' in value) return `count(${$5b57b6d8a1f22309$export$3558f7451ea2e1b(value.$count)})`;
    if ('$round' in value && Array.isArray(value.$round)) {
        const [operand, mode] = value.$round;
        const name = mode === 'down' ? 'floor' : mode === 'up' ? 'ceiling' : 'round';
        return `${name}(${$5b57b6d8a1f22309$export$3558f7451ea2e1b(operand)})`;
    }
    if ('$if' in value) return 'conditional value';
    for (const [operator, { name: name, symbol: symbol }] of Object.entries($5b57b6d8a1f22309$export$313cceabf063c648)){
        if (!(operator in value)) continue;
        const operands = Array.isArray(value[operator]) ? value[operator] : [
            value[operator]
        ];
        return symbol ? operands.map($5b57b6d8a1f22309$export$3558f7451ea2e1b).join(` ${symbol} `) : `${name.toLowerCase()}(${operands.map($5b57b6d8a1f22309$export$3558f7451ea2e1b).join(', ')})`;
    }
    if ('$and' in value || '$or' in value || '$not' in value || Object.keys(value).some((key)=>key in $5b57b6d8a1f22309$export$94ca9a8392da2889)) return $5b57b6d8a1f22309$export$614d86e866f80092(value);
    return Object.entries(value).map(([key, item])=>`${key}: ${$5b57b6d8a1f22309$export$3558f7451ea2e1b(item)}`).join(', ');
}
const $5b57b6d8a1f22309$export$eefadfdc6c36b3d4 = (select)=>{
    if (!select) return undefined;
    const parts = [];
    if (select.$sample) parts.push(`sample ${$5b57b6d8a1f22309$export$c2f35a86bc746465(select.$sample)}`);
    if (select.$sort) parts.push(`sort ${$5b57b6d8a1f22309$export$c2f35a86bc746465(select.$sort)}`);
    if (select.$limit != null) parts.push(`limit ${select.$limit}`);
    return `Select: ${parts.join(" \xb7 ")}`;
};
const $5b57b6d8a1f22309$export$c57af210ae57203e = (slug)=>slug.split('-').map((part)=>part ? `${part[0].toUpperCase()}${part.slice(1)}` : part).join(' ');


const $3a23179f5383b5d7$var$literalTerritorySelector = (where)=>{
    if (!where || !('slug' in where)) return null;
    const expected = where.slug;
    const slug = typeof expected === 'string' ? expected : (0, $5b57b6d8a1f22309$export$a6cdc56e425d0d0a)(expected) && Object.keys(expected).length === 1 && typeof expected.$eq === 'string' ? expected.$eq : null;
    if (!slug || slug.startsWith('$')) return null;
    const remaining = Object.fromEntries(Object.entries(where).filter(([path])=>path !== 'slug'));
    return {
        label: (0, $5b57b6d8a1f22309$export$c57af210ae57203e)(slug),
        where: Object.keys(remaining).length ? remaining : undefined
    };
};
const $3a23179f5383b5d7$export$43b8a8d32b5c7a09 = (then)=>{
    if (!then) return [];
    const details = [];
    for (const root of [
        'variables',
        'game',
        'turn',
        'result'
    ]){
        const values = then[root];
        if (values) details.push({
            id: root,
            kind: 'write',
            lines: [
                `Set ${root}`
            ],
            assignments: Object.entries(values).map(([field, value])=>({
                    path: `${root}.${field}`,
                    value: value
                }))
        });
    }
    for (const collection of [
        'territories',
        'factions'
    ])for (const [index, update] of (then[collection] ?? []).entries()){
        const literalTerritory = collection === 'territories' ? $3a23179f5383b5d7$var$literalTerritorySelector(update.where) : null;
        details.push({
            id: `${collection}-${update.id ?? index + 1}`,
            kind: 'effect',
            collection: collection,
            entityLabel: literalTerritory?.label,
            where: literalTerritory ? literalTerritory.where : update.where,
            lines: [
                literalTerritory ? `Update ${literalTerritory.label}` : `Update ${collection}`,
                (0, $5b57b6d8a1f22309$export$eefadfdc6c36b3d4)(update.select)
            ].filter((line)=>!!line),
            assignments: Object.entries(update.set).map(([field, value])=>({
                    path: field,
                    value: value
                }))
        });
    }
    if (then.cards?.length) details.push({
        id: 'cards',
        kind: 'effect',
        lines: [
            'Draw cards',
            ...then.cards.map((draw)=>`${(0, $5b57b6d8a1f22309$export$c2f35a86bc746465)(draw.faction)} draws ${(0, $5b57b6d8a1f22309$export$c2f35a86bc746465)(draw.count ?? 1)}`)
        ]
    });
    if (then.logs?.length) details.push({
        id: 'logs',
        kind: 'effect',
        lines: [
            'Write logs',
            ...then.logs.map((log)=>`${(0, $5b57b6d8a1f22309$export$c2f35a86bc746465)(log.key)}${log.faction === undefined ? '' : ` \xb7 ${(0, $5b57b6d8a1f22309$export$c2f35a86bc746465)(log.faction)}`}`)
        ]
    });
    if (then.battles?.length) details.push({
        id: 'battles',
        kind: 'effect',
        lines: [
            'Resolve battles',
            ...then.battles.map((battle)=>`${(0, $5b57b6d8a1f22309$export$c2f35a86bc746465)(battle.repeat ?? 1)}\xd7 ${(0, $5b57b6d8a1f22309$export$c2f35a86bc746465)(battle.attacker)} \u{2192} ${(0, $5b57b6d8a1f22309$export$c2f35a86bc746465)(battle.target)} \xb7 ${(0, $5b57b6d8a1f22309$export$c2f35a86bc746465)(battle.troops)} troops`)
        ]
    });
    return details;
};
const $3a23179f5383b5d7$var$collectGraphReferences = (value, references = new Set())=>{
    if (typeof value === 'string' && value.startsWith('$')) references.add(value.slice(1));
    else if (Array.isArray(value)) value.forEach((item)=>$3a23179f5383b5d7$var$collectGraphReferences(item, references));
    else if ((0, $5b57b6d8a1f22309$export$a6cdc56e425d0d0a)(value)) Object.entries(value).forEach(([key, item])=>{
        if (!key.startsWith('$')) references.add(key);
        $3a23179f5383b5d7$var$collectGraphReferences(item, references);
    });
    return references;
};
const $3a23179f5383b5d7$var$collectGraphExpressionReferences = (value, references = new Set())=>{
    if (typeof value === 'string' && value.startsWith('$')) references.add(value.slice(1));
    else if (Array.isArray(value)) value.forEach((item)=>$3a23179f5383b5d7$var$collectGraphExpressionReferences(item, references));
    else if ((0, $5b57b6d8a1f22309$export$a6cdc56e425d0d0a)(value) && '$if' in value && Array.isArray(value.$if)) {
        const [condition, whenTrue, whenFalse] = value.$if;
        $3a23179f5383b5d7$var$collectGraphReferences(condition, references);
        $3a23179f5383b5d7$var$collectGraphExpressionReferences(whenTrue, references);
        $3a23179f5383b5d7$var$collectGraphExpressionReferences(whenFalse, references);
    } else if ((0, $5b57b6d8a1f22309$export$a6cdc56e425d0d0a)(value)) Object.values(value).forEach((item)=>$3a23179f5383b5d7$var$collectGraphExpressionReferences(item, references));
    return references;
};
const $3a23179f5383b5d7$var$collectGraphThenReferences = (then, references = new Set())=>{
    for (const root of [
        'variables',
        'game',
        'turn',
        'result'
    ])Object.values(then[root] ?? {}).forEach((value)=>$3a23179f5383b5d7$var$collectGraphExpressionReferences(value, references));
    for (const collection of [
        'territories',
        'factions'
    ])for (const update of then[collection] ?? []){
        if (update.where) $3a23179f5383b5d7$var$collectGraphReferences(update.where, references);
        if (update.select) $3a23179f5383b5d7$var$collectGraphExpressionReferences(update.select, references);
        Object.values(update.set).forEach((value)=>$3a23179f5383b5d7$var$collectGraphExpressionReferences(value, references));
    }
    for (const action of [
        ...then.cards ?? [],
        ...then.logs ?? [],
        ...then.battles ?? []
    ])$3a23179f5383b5d7$var$collectGraphExpressionReferences(action, references);
    return references;
};
const $3a23179f5383b5d7$var$collectGraphWrites = (then, writes = new Set())=>{
    if (!then) return writes;
    for (const root of [
        'variables',
        'game',
        'turn',
        'result'
    ])Object.keys(then[root] ?? {}).forEach((path)=>writes.add(`${root}.${path}`));
    return writes;
};
const $3a23179f5383b5d7$export$dedb529b6eeeb467 = (document, event)=>{
    const writes = $3a23179f5383b5d7$var$collectGraphWrites(event.then);
    event.choices?.forEach((eventChoice)=>$3a23179f5383b5d7$var$collectGraphWrites(eventChoice.then, writes));
    const overlaps = (left, right)=>left === right || left.startsWith(`${right}.`) || right.startsWith(`${left}.`);
    return (document.rules ?? []).filter((rule)=>{
        const reads = $3a23179f5383b5d7$var$collectGraphReferences(rule.when);
        $3a23179f5383b5d7$var$collectGraphThenReferences(rule.then, reads);
        return [
            ...writes
        ].some((write)=>[
                ...reads
            ].some((read)=>overlaps(write, read)));
    });
};



const $9a34f36fb207f611$export$fb1c669d9ff61b02 = (writer, document, event, scope, queries, trail, entityLabel)=>{
    const singular = (path)=>path.endsWith('ies') ? `${path.slice(0, -3)}y` : path.endsWith('s') ? path.slice(0, -1) : path;
    const connect = (exits, targetId)=>exits.forEach((exit)=>writer.line(`  ${exit.id} -->|${exit.label}| ${targetId}`));
    const atom = (label, atomTrail, passLabel = 'yes')=>{
        const id = (0, $5b57b6d8a1f22309$export$a5a0914cccdde6d5)('condition', event.id, scope, atomTrail);
        writer.addNode(id, 'condition', Array.isArray(label) ? label : [
            label
        ]);
        const failLabel = passLabel === 'yes' ? 'no' : 'yes';
        return {
            entryId: id,
            pass: [
                {
                    id: id,
                    label: passLabel
                }
            ],
            fail: [
                {
                    id: id,
                    label: failLabel
                }
            ]
        };
    };
    const all = (flows)=>{
        if (!flows.length) return atom('Always true?', `${trail}-always`);
        for(let index = 0; index < flows.length - 1; index++)connect(flows[index].pass, flows[index + 1].entryId);
        return {
            entryId: flows[0].entryId,
            pass: flows.at(-1).pass,
            fail: flows.flatMap((flow)=>flow.fail)
        };
    };
    const any = (flows)=>{
        if (!flows.length) return atom('Always false?', `${trail}-never`);
        for(let index = 0; index < flows.length - 1; index++)connect(flows[index].fail, flows[index + 1].entryId);
        return {
            entryId: flows[0].entryId,
            pass: flows.flatMap((flow)=>flow.pass),
            fail: flows.at(-1).fail
        };
    };
    const quantifierSubject = (path)=>path === 'territories' ? 'Territory' : path === 'factions' ? 'Faction' : path === 'adjacent' ? 'Adjacent territory' : (0, $5b57b6d8a1f22309$export$c57af210ae57203e)(singular(path));
    const expandedGroupMembers = (groupName)=>groupName === 'nationalPact' ? [] : (document.groups?.[groupName] ?? []).filter((member)=>typeof member === 'string').map((0, $5b57b6d8a1f22309$export$c57af210ae57203e));
    const groupLines = (subject, path, operator, operand)=>{
        if (!(0, $5b57b6d8a1f22309$export$a6cdc56e425d0d0a)(operand) || !('$group' in operand)) return null;
        const groupName = String(operand.$group);
        const members = expandedGroupMembers(groupName);
        const relation = path === 'heldBy' ? `${subject} ${operator === '$nin' ? 'is not held by' : 'is held by'} one of ${groupName}` : `${subject} ${operator === '$nin' ? 'is not' : 'is'} one of ${groupName}`;
        return members.length ? [
            relation,
            `(${members.join(', ')})`
        ] : [
            relation
        ];
    };
    const predicateLines = (query, subject)=>{
        if (!(0, $5b57b6d8a1f22309$export$a6cdc56e425d0d0a)(query)) return [
            `${subject}: ${(0, $5b57b6d8a1f22309$export$3558f7451ea2e1b)(query)}`
        ];
        if ('$and' in query || '$or' in query) {
            const operator = '$and' in query ? '$and' : '$or';
            const clauses = Array.isArray(query[operator]) ? query[operator] : [];
            return clauses.flatMap((clause, index)=>{
                const rendered = predicateLines(clause, subject);
                return operator === '$or' && index > 0 ? [
                    `OR \u{2014} ${rendered[0]}`,
                    ...rendered.slice(1)
                ] : rendered;
            });
        }
        if ('$not' in query) return [
            'Not:',
            ...predicateLines(query.$not, subject)
        ];
        return Object.entries(query).flatMap(([path, expected])=>{
            if ((0, $5b57b6d8a1f22309$export$a6cdc56e425d0d0a)(expected)) {
                for (const operator of [
                    '$some',
                    '$none',
                    '$every'
                ]){
                    if (!(operator in expected)) continue;
                    const nestedSubject = quantifierSubject(path);
                    const quantifier = operator === '$some' ? 'Any' : operator === '$none' ? 'No' : 'Every';
                    return [
                        `${quantifier} ${nestedSubject.toLowerCase()} matches:`,
                        ...predicateLines(expected[operator], nestedSubject).map((line)=>`\u{21B3} ${line}`)
                    ];
                }
                const comparisons = Object.entries(expected).filter(([operator])=>operator.startsWith('$'));
                if (comparisons.length) return comparisons.flatMap(([operator, operand])=>{
                    const grouped = groupLines(subject, path, operator, operand);
                    if (grouped) return grouped;
                    if (path === 'troops' && typeof operand === 'number') {
                        const troop = operand === 1 ? 'troop' : 'troops';
                        const phrase = {
                            $eq: `has exactly ${operand} ${troop}`,
                            $ne: `does not have exactly ${operand} ${troop}`,
                            $gt: `has more than ${operand} ${troop}`,
                            $gte: `has at least ${operand} ${troop}`,
                            $lt: `has fewer than ${operand} ${troop}`,
                            $lte: `has at most ${operand} ${troop}`
                        };
                        if (phrase[operator]) return [
                            `${subject} ${phrase[operator]}`
                        ];
                    }
                    const label = (0, $5b57b6d8a1f22309$export$94ca9a8392da2889)[operator] ?? operator.replace(/^\$/, '').toUpperCase();
                    return [
                        `${subject} \xb7 ${path} ${label} ${(0, $5b57b6d8a1f22309$export$3558f7451ea2e1b)(operand)}`
                    ];
                });
            }
            if (path === 'heldBy' && typeof expected === 'string') return [
                `${subject} held by ${expected}`
            ];
            if (path === 'slug' && typeof expected === 'string') return [
                `${subject} is ${(0, $5b57b6d8a1f22309$export$c57af210ae57203e)(expected)}`
            ];
            if (path === 'name' && typeof expected === 'string') return [
                `${subject} is ${expected}`
            ];
            if (typeof expected === 'boolean') {
                const field = path.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase();
                return [
                    `${subject} ${expected ? 'is' : 'is not'} ${field}`
                ];
            }
            return [
                `${subject} \xb7 ${path} = ${(0, $5b57b6d8a1f22309$export$3558f7451ea2e1b)(expected)}`
            ];
        });
    };
    const addField = (path, expected, fieldTrail)=>{
        const displayPath = (0, $5b57b6d8a1f22309$export$66c93ee051ba7e2a)(path);
        const territoryOwnerPath = displayPath.match(/^territories\.([^.]+)\.heldBy$/);
        const heldSubject = displayPath === 'heldBy' && entityLabel ? entityLabel : territoryOwnerPath ? (0, $5b57b6d8a1f22309$export$c57af210ae57203e)(territoryOwnerPath[1]) : null;
        const heldByLabel = heldSubject && typeof expected === 'string' ? `${heldSubject} held by ${expected}` : null;
        if ((0, $5b57b6d8a1f22309$export$a6cdc56e425d0d0a)(expected)) {
            for (const [operator, quantifier] of [
                [
                    '$some',
                    'ANY'
                ],
                [
                    '$none',
                    'NO'
                ],
                [
                    '$every',
                    'EVERY'
                ]
            ]){
                if (!(operator in expected)) continue;
                if ((0, $5b57b6d8a1f22309$export$a6cdc56e425d0d0a)(expected[operator])) {
                    const subject = quantifierSubject(displayPath);
                    const details = predicateLines(expected[operator], subject);
                    const withoutRepeatedSubject = details.map((line)=>{
                        if (!line.startsWith(`${subject} `)) return line;
                        const fragment = line.slice(subject.length + 1);
                        return fragment ? `${fragment[0].toUpperCase()}${fragment.slice(1)}` : fragment;
                    });
                    if (details.length === 1 && details[0].startsWith(`${subject} `)) {
                        const predicate = details[0].slice(subject.length + 1);
                        const lead = operator === '$some' ? `At least one ${subject.toLowerCase()}` : operator === '$none' ? `No ${subject.toLowerCase()}` : `Every ${subject.toLowerCase()}`;
                        return atom(`${lead} ${predicate}`, `${fieldTrail}-${operator}`);
                    }
                    return atom([
                        `${quantifier === 'ANY' ? 'At least one' : quantifier === 'NO' ? 'No' : 'Every'} ${subject.toLowerCase()} satisfies all:`,
                        ...withoutRepeatedSubject
                    ], `${fieldTrail}-${operator}`);
                }
                return atom(`${quantifier} ${singular(displayPath)} where ${(0, $5b57b6d8a1f22309$export$614d86e866f80092)(expected[operator])}?`, `${fieldTrail}-${operator}`);
            }
            const comparisons = Object.entries(expected).filter(([operator])=>operator.startsWith('$'));
            if (comparisons.length) return all(comparisons.map(([operator, operand], index)=>{
                if (displayPath === 'slug' && entityLabel && (0, $5b57b6d8a1f22309$export$a6cdc56e425d0d0a)(operand) && '$group' in operand && (operator === '$in' || operator === '$nin')) {
                    const groupName = String(operand.$group);
                    const members = expandedGroupMembers(groupName);
                    const memberList = members.length ? ` (${members.join(', ')})` : '';
                    return atom(`${entityLabel} ${operator === '$nin' ? 'is not' : 'is'} one of ${groupName}${memberList}`, `${fieldTrail}-${operator}-${index}`);
                }
                if (heldSubject && typeof operand === 'string' && (operator === '$eq' || operator === '$ne')) return atom(`${heldSubject} ${operator === '$ne' ? 'not ' : ''}held by ${operand}`, `${fieldTrail}-${operator}-${index}`);
                if ((operator === '$eq' || operator === '$ne') && typeof operand === 'boolean') {
                    const passesWhenTrue = operator === '$eq' ? operand : !operand;
                    return atom(displayPath, `${fieldTrail}-${operator}-${index}`, passesWhenTrue ? 'yes' : 'no');
                }
                if (operator === '$exists' && typeof operand === 'boolean') return atom(`${displayPath} exists?`, `${fieldTrail}-${operator}-${index}`, operand ? 'yes' : 'no');
                if (entityLabel && displayPath === 'troops' && typeof operand === 'number') {
                    const troop = operand === 1 ? 'troop' : 'troops';
                    const phrase = {
                        $eq: `has exactly ${operand} ${troop}`,
                        $ne: `does not have exactly ${operand} ${troop}`,
                        $gt: `has more than ${operand} ${troop}`,
                        $gte: `has at least ${operand} ${troop}`,
                        $lt: `has fewer than ${operand} ${troop}`,
                        $lte: `has at most ${operand} ${troop}`
                    };
                    if (phrase[operator]) return atom(`${entityLabel} ${phrase[operator]}`, `${fieldTrail}-${operator}-${index}`);
                }
                const label = (0, $5b57b6d8a1f22309$export$94ca9a8392da2889)[operator] ?? operator.replace(/^\$/, '').toUpperCase();
                return atom(`${displayPath} ${label} ${(0, $5b57b6d8a1f22309$export$3558f7451ea2e1b)(operand)}`, `${fieldTrail}-${operator}-${index}`);
            }));
        }
        if (typeof expected === 'boolean') return atom(displayPath, `${fieldTrail}-equals`, expected ? 'yes' : 'no');
        if (heldByLabel) return atom(heldByLabel, `${fieldTrail}-equals`);
        if (entityLabel && displayPath === 'troops' && typeof expected === 'number') return atom(`${entityLabel} has ${expected} ${expected === 1 ? 'troop' : 'troops'}`, `${fieldTrail}-equals`);
        return atom(`${displayPath} = ${(0, $5b57b6d8a1f22309$export$3558f7451ea2e1b)(expected)}`, `${fieldTrail}-equals`);
    };
    const actionRole = (query)=>{
        if (!(0, $5b57b6d8a1f22309$export$a6cdc56e425d0d0a)(query) || Object.keys(query).length !== 1) return null;
        const [path, expected] = Object.entries(query)[0];
        if (path !== 'action.attacker' && path !== 'action.defender') return null;
        const value = (0, $5b57b6d8a1f22309$export$a6cdc56e425d0d0a)(expected) && Object.keys(expected).length === 1 && '$eq' in expected ? expected.$eq : expected;
        if (typeof value !== 'string' || value.startsWith('$')) return null;
        return {
            role: path === 'action.attacker' ? 'attacker' : 'defender',
            value: value
        };
    };
    const compactActionPair = (first, second)=>{
        const roles = [
            actionRole(first),
            actionRole(second)
        ];
        if (!roles[0] || !roles[1] || roles[0].role === roles[1].role) return null;
        const attacker = roles.find((role)=>role?.role === 'attacker');
        const defender = roles.find((role)=>role?.role === 'defender');
        return `${attacker.value} attacks ${defender.value}`;
    };
    const addSequence = (clauses, sequenceTrail)=>{
        const flows = [];
        for(let index = 0; index < clauses.length; index++){
            const compactLabel = index + 1 < clauses.length ? compactActionPair(clauses[index], clauses[index + 1]) : null;
            if (compactLabel) {
                flows.push(atom(compactLabel, `${sequenceTrail}-${index}-attack-pair`));
                index++;
            } else flows.push(addQuery(clauses[index], `${sequenceTrail}-${index}`));
        }
        return all(flows);
    };
    const addQuery = (query, queryTrail)=>{
        if (!(0, $5b57b6d8a1f22309$export$a6cdc56e425d0d0a)(query)) return atom((0, $5b57b6d8a1f22309$export$3558f7451ea2e1b)(query), `${queryTrail}-value`);
        if ('$and' in query || '$or' in query) {
            const operator = '$and' in query ? '$and' : '$or';
            const clauses = Array.isArray(query[operator]) ? query[operator] : [];
            if (operator === '$and') return addSequence(clauses, `${queryTrail}-${operator}`);
            return any(clauses.map((clause, index)=>addQuery(clause, `${queryTrail}-${operator}-${index}`)));
        }
        if ('$not' in query) {
            const flow = addQuery(query.$not, `${queryTrail}-not`);
            return {
                entryId: flow.entryId,
                pass: flow.fail,
                fail: flow.pass
            };
        }
        return all(Object.entries(query).map(([path, expected], index)=>addField(path, expected, `${queryTrail}-${path}-${index}`)));
    };
    return addSequence(queries, trail);
};





const $f0172c32ded23811$export$fcce4bcdcbb8f2de = (writer, event, scope, parentId, value, trail, edgeLabel)=>{
    const connect = (childId)=>writer.line(`  ${parentId} -->${edgeLabel ? `|${edgeLabel}|` : ''} ${childId}`);
    if (!(0, $5b57b6d8a1f22309$export$a6cdc56e425d0d0a)(value) || Object.keys(value).length !== 1) {
        const valueNode = (0, $5b57b6d8a1f22309$export$a5a0914cccdde6d5)('value', event.id, scope, trail);
        writer.addNode(valueNode, 'value', [
            (0, $5b57b6d8a1f22309$export$3558f7451ea2e1b)(value)
        ]);
        connect(valueNode);
        return {
            entryId: valueNode,
            exits: [
                valueNode
            ]
        };
    }
    if ('$if' in value && Array.isArray(value.$if)) {
        const [condition, whenTrue, whenFalse] = value.$if;
        const conditionNode = (0, $5b57b6d8a1f22309$export$a5a0914cccdde6d5)('condition', event.id, scope, trail, 'condition');
        writer.addNode(conditionNode, 'condition', [
            (0, $5b57b6d8a1f22309$export$614d86e866f80092)(condition)
        ]);
        connect(conditionNode);
        const thenFlow = $f0172c32ded23811$export$fcce4bcdcbb8f2de(writer, event, scope, conditionNode, whenTrue, `${trail}-then`, 'then');
        const elseFlow = $f0172c32ded23811$export$fcce4bcdcbb8f2de(writer, event, scope, conditionNode, whenFalse, `${trail}-else`, 'else');
        return {
            entryId: conditionNode,
            exits: [
                ...thenFlow.exits,
                ...elseFlow.exits
            ]
        };
    }
    if ('$round' in value && Array.isArray(value.$round)) {
        const [operand, mode] = value.$round;
        const formulaNode = (0, $5b57b6d8a1f22309$export$a5a0914cccdde6d5)('formula', event.id, scope, trail, 'round');
        writer.addNode(formulaNode, 'formula', [
            `ROUND ${String(mode).toUpperCase()}`
        ]);
        connect(formulaNode);
        const operandFlow = $f0172c32ded23811$export$fcce4bcdcbb8f2de(writer, event, scope, formulaNode, operand, `${trail}-value`, 'value');
        return {
            entryId: formulaNode,
            exits: operandFlow.exits
        };
    }
    if ('$count' in value) {
        const formulaNode = (0, $5b57b6d8a1f22309$export$a5a0914cccdde6d5)('formula', event.id, scope, trail, 'count');
        writer.addNode(formulaNode, 'formula', [
            'COUNT'
        ]);
        connect(formulaNode);
        const collectionFlow = $f0172c32ded23811$export$fcce4bcdcbb8f2de(writer, event, scope, formulaNode, value.$count, `${trail}-collection`, 'collection');
        return {
            entryId: formulaNode,
            exits: collectionFlow.exits
        };
    }
    for (const [operator, details] of Object.entries((0, $5b57b6d8a1f22309$export$313cceabf063c648))){
        if (!(operator in value)) continue;
        const operands = Array.isArray(value[operator]) ? value[operator] : [
            value[operator]
        ];
        const formulaNode = (0, $5b57b6d8a1f22309$export$a5a0914cccdde6d5)('formula', event.id, scope, trail, operator);
        writer.addNode(formulaNode, 'formula', [
            details.name
        ]);
        connect(formulaNode);
        const connectors = {
            $add: 'plus',
            $subtract: 'minus',
            $multiply: 'with',
            $divide: 'by',
            $mod: 'modulo',
            $min: 'and',
            $max: 'and'
        };
        let exits = [
            formulaNode
        ];
        operands.forEach((operand, index)=>{
            const label = index === 0 ? undefined : connectors[operator] ?? 'with';
            const operandFlow = $f0172c32ded23811$export$fcce4bcdcbb8f2de(writer, event, scope, exits[0], operand, `${trail}-${operator}-${index}`, label);
            for (const additionalExit of exits.slice(1))writer.line(`  ${additionalExit} -->${label ? `|${label}|` : ''} ${operandFlow.entryId}`);
            exits = operandFlow.exits;
        });
        return {
            entryId: formulaNode,
            exits: exits
        };
    }
    if ('$group' in value) {
        const valueNode = (0, $5b57b6d8a1f22309$export$a5a0914cccdde6d5)('value', event.id, scope, trail, 'group');
        writer.addNode(valueNode, 'value', [
            `Group: ${String(value.$group)}`
        ]);
        connect(valueNode);
        return {
            entryId: valueNode,
            exits: [
                valueNode
            ]
        };
    }
    const valueNode = (0, $5b57b6d8a1f22309$export$a5a0914cccdde6d5)('value', event.id, scope, trail);
    writer.addNode(valueNode, 'value', [
        (0, $5b57b6d8a1f22309$export$3558f7451ea2e1b)(value)
    ]);
    connect(valueNode);
    return {
        entryId: valueNode,
        exits: [
            valueNode
        ]
    };
};



const $b4c0d0e6d64f03bd$export$8f4a5aedca2efb54 = (writer, document, event, parentId, scope, then)=>{
    const writeIds = [];
    const finiteNumber = (value)=>typeof value === 'number' && Number.isFinite(value);
    const conciseNumber = (value)=>String(Number(value.toFixed(6)));
    const boundedChange = (assignment)=>{
        if (!(0, $5b57b6d8a1f22309$export$a6cdc56e425d0d0a)(assignment.value) || Object.keys(assignment.value).length !== 1) return null;
        const self = `$${assignment.path}`;
        const matchBound = (operands, direction)=>{
            if (!Array.isArray(operands) || operands.length !== 2) return null;
            const boundIndex = operands.findIndex(finiteNumber);
            if (boundIndex < 0) return null;
            const bound = operands[boundIndex];
            const change = operands[boundIndex === 0 ? 1 : 0];
            if (!(0, $5b57b6d8a1f22309$export$a6cdc56e425d0d0a)(change) || Object.keys(change).length !== 1) return null;
            if (direction === 'increase') {
                if (!Array.isArray(change.$add) || change.$add.length !== 2) return null;
                const amount = change.$add[0] === self ? change.$add[1] : change.$add[1] === self ? change.$add[0] : undefined;
                return finiteNumber(amount) && amount > 0 ? {
                    direction: direction,
                    amount: amount,
                    bound: bound
                } : null;
            }
            if (!Array.isArray(change.$subtract) || change.$subtract.length !== 2 || change.$subtract[0] !== self) return null;
            const amount = change.$subtract[1];
            return finiteNumber(amount) && amount > 0 ? {
                direction: direction,
                amount: amount,
                bound: bound
            } : null;
        };
        if ('$min' in assignment.value) return matchBound(assignment.value.$min, 'increase');
        if ('$max' in assignment.value) return matchBound(assignment.value.$max, 'decrease');
        return null;
    };
    const assignmentNoun = (path, amount)=>{
        const field = path.split('.').at(-1) ?? path;
        if (field === 'entrenched') return 'entrenchment';
        if (field === 'troops') return amount === 1 ? 'troop' : 'troops';
        return field.replace(/([a-z])([A-Z])/g, '$1 $2').toLowerCase();
    };
    const selfScale = (value, self)=>{
        if (!(0, $5b57b6d8a1f22309$export$a6cdc56e425d0d0a)(value) || Object.keys(value).length !== 1) return null;
        if (Array.isArray(value.$round) && value.$round.length === 2) {
            const [operand, mode] = value.$round;
            const scale = selfScale(operand, self);
            if (!scale || mode !== 'up' && mode !== 'down') return null;
            return {
                ...scale,
                rounding: mode
            };
        }
        if (Array.isArray(value.$multiply) && value.$multiply.length === 2) {
            const factors = value.$multiply;
            const factor = factors[0] === self ? factors[1] : factors[1] === self ? factors[0] : undefined;
            return finiteNumber(factor) ? {
                factor: factor
            } : null;
        }
        if (Array.isArray(value.$divide) && value.$divide.length === 2) {
            const [dividend, divisor] = value.$divide;
            return dividend === self && finiteNumber(divisor) && divisor !== 0 ? {
                factor: 1 / divisor,
                divisor: divisor
            } : null;
        }
        return null;
    };
    const scaleLines = (path, scale)=>{
        const operation = scale.factor === 0.5 ? `Halve ${path}` : scale.factor === 2 ? `Double ${path}` : scale.divisor ? `Divide ${path} by ${conciseNumber(scale.divisor)}` : `Multiply ${path} by ${conciseNumber(scale.factor)}`;
        return scale.rounding ? [
            operation,
            scale.rounding === 'down' ? 'Round down' : 'Round up'
        ] : [
            operation
        ];
    };
    const withMinimum = (lines, minimum)=>{
        const qualifier = `minimum ${conciseNumber(minimum)}`;
        if (lines.length > 1) lines[lines.length - 1] = `${lines.at(-1)} \xb7 ${qualifier}`;
        else writer.line(`Minimum ${conciseNumber(minimum)}`);
        return lines;
    };
    const compactAssignment = (assignment)=>{
        if (!(0, $5b57b6d8a1f22309$export$a6cdc56e425d0d0a)(assignment.value) || Object.keys(assignment.value).length !== 1) return null;
        const self = `$${assignment.path}`;
        const addOperands = assignment.value.$add;
        if (Array.isArray(addOperands) && addOperands.length === 2) {
            const value = addOperands[0] === self ? addOperands[1] : addOperands[1] === self ? addOperands[0] : undefined;
            if (typeof value === 'number' && Number.isFinite(value)) return [
                `Add ${value} ${assignment.path}`
            ];
        }
        const subtractOperands = assignment.value.$subtract;
        if (Array.isArray(subtractOperands) && subtractOperands.length === 2 && subtractOperands[0] === self) {
            if (finiteNumber(subtractOperands[1])) return [
                `Subtract ${conciseNumber(subtractOperands[1])} ${assignment.path}`
            ];
            const removed = selfScale(subtractOperands[1], self);
            if (removed) {
                const remaining = {
                    factor: 1 - removed.factor,
                    rounding: removed.rounding === 'down' ? 'up' : removed.rounding === 'up' ? 'down' : undefined
                };
                return scaleLines(assignment.path, remaining);
            }
        }
        const directScale = selfScale(assignment.value, self);
        if (directScale) return scaleLines(assignment.path, directScale);
        const maxOperands = assignment.value.$max;
        if (!Array.isArray(maxOperands) || maxOperands.length !== 2) return null;
        const minimumIndex = maxOperands.findIndex(finiteNumber);
        if (minimumIndex < 0) return null;
        const minimum = maxOperands[minimumIndex];
        const limited = maxOperands[minimumIndex === 0 ? 1 : 0];
        const limitedScale = selfScale(limited, self);
        if (limitedScale) return withMinimum(scaleLines(assignment.path, limitedScale), minimum);
        if ((0, $5b57b6d8a1f22309$export$a6cdc56e425d0d0a)(limited) && Array.isArray(limited.$subtract)) {
            const operands = limited.$subtract;
            if (operands.length === 2 && operands[0] === self && finiteNumber(operands[1])) return withMinimum([
                `Subtract ${conciseNumber(operands[1])} ${assignment.path}`
            ], minimum);
        }
        return null;
    };
    for (const detail of (0, $3a23179f5383b5d7$export$43b8a8d32b5c7a09)(then)){
        const id = (0, $5b57b6d8a1f22309$export$a5a0914cccdde6d5)(detail.kind, event.id, scope, detail.id);
        const collapseSingleAssignment = detail.kind === 'write' && detail.assignments?.length === 1 && detail.lines.length === 1;
        if (!collapseSingleAssignment) {
            writer.addNode(id, detail.kind, detail.lines);
            if (detail.where) {
                const whereScope = `${scope}-${detail.id}-where`;
                const entityLabel = detail.entityLabel ?? (detail.collection === 'factions' ? 'Faction' : 'Territory');
                const conditionFlow = (0, $9a34f36fb207f611$export$fb1c669d9ff61b02)(writer, document, event, whereScope, [
                    detail.where
                ], whereScope, entityLabel);
                writer.line(`  ${parentId} --> ${conditionFlow.entryId}`);
                conditionFlow.pass.forEach((exit)=>writer.line(`  ${exit.id} -->|${exit.label}| ${id}`));
                const missNode = (0, $5b57b6d8a1f22309$export$a5a0914cccdde6d5)('miss', event.id, whereScope, 'not-updated');
                const entity = detail.entityLabel ?? (detail.collection === 'factions' ? 'Faction' : 'Territory');
                writer.addNode(missNode, 'miss', [
                    `${entity} not updated`
                ]);
                conditionFlow.fail.forEach((exit)=>writer.line(`  ${exit.id} -->|${exit.label}| ${missNode}`));
            } else writer.line(`  ${parentId} --> ${id}`);
        }
        const assignmentParent = collapseSingleAssignment ? parentId : id;
        for (const [index, assignment] of (detail.assignments ?? []).entries()){
            const bounded = boundedChange(assignment);
            if (bounded) {
                const self = `$${assignment.path}`;
                const conditionNode = (0, $5b57b6d8a1f22309$export$a5a0914cccdde6d5)('condition', event.id, scope, detail.id, assignment.path, String(index), 'bound');
                const assignmentNode = (0, $5b57b6d8a1f22309$export$a5a0914cccdde6d5)('write', event.id, scope, detail.id, assignment.path, String(index));
                const skipNode = (0, $5b57b6d8a1f22309$export$a5a0914cccdde6d5)('miss', event.id, scope, detail.id, assignment.path, String(index), 'skip');
                const comparison = bounded.direction === 'increase' ? '<' : '>';
                const verb = bounded.direction === 'increase' ? 'Add' : 'Subtract';
                const actionLines = [
                    `${verb} ${conciseNumber(bounded.amount)} ${assignmentNoun(assignment.path, bounded.amount)}`
                ];
                if (bounded.amount !== 1) actionLines.push(`${bounded.direction === 'increase' ? 'Maximum' : 'Minimum'} ${conciseNumber(bounded.bound)}`);
                writer.addNode(conditionNode, 'condition', [
                    `${self} ${comparison} ${conciseNumber(bounded.bound)}?`
                ]);
                writer.addNode(assignmentNode, 'write', actionLines);
                writer.addNode(skipNode, 'miss', [
                    'Skip'
                ]);
                writer.line(`  ${assignmentParent} --> ${conditionNode}`);
                writer.line(`  ${conditionNode} -->|yes| ${assignmentNode}`);
                writer.line(`  ${conditionNode} -->|no| ${skipNode}`);
                if (detail.kind === 'write') writeIds.push(assignmentNode, skipNode);
                continue;
            }
            const assignmentNode = (0, $5b57b6d8a1f22309$export$a5a0914cccdde6d5)('write', event.id, scope, detail.id, assignment.path, String(index));
            const computed = (0, $5b57b6d8a1f22309$export$a6cdc56e425d0d0a)(assignment.value) && Object.keys(assignment.value).some((key)=>key.startsWith('$'));
            const compactLabel = compactAssignment(assignment);
            const ownershipLabel = detail.collection === 'territories' && assignment.path === 'heldBy' && typeof assignment.value === 'string' ? `${detail.entityLabel ?? 'Territory'} moves to ${assignment.value}` : null;
            writer.addNode(assignmentNode, 'write', ownershipLabel ? [
                ownershipLabel
            ] : compactLabel ? compactLabel : computed ? [
                'Set',
                assignment.path
            ] : [
                assignment.path,
                `\u{2190} ${(0, $5b57b6d8a1f22309$export$3558f7451ea2e1b)(assignment.value)}`
            ]);
            writer.line(`  ${assignmentParent} --> ${assignmentNode}`);
            if (computed && !compactLabel) (0, $f0172c32ded23811$export$fcce4bcdcbb8f2de)(writer, event, scope, assignmentNode, assignment.value, `${detail.id}-${index}`);
            if (detail.kind === 'write') writeIds.push(assignmentNode);
        }
        if (detail.kind === 'write' && !detail.assignments?.length) writeIds.push(id);
    }
    return writeIds;
};





const $53afe75f1635cdce$var$DEFINITIONS = {
    event: 'fill:#e8dfc2,stroke:#23384a,color:#152633,stroke-width:1.5px',
    outcome: 'fill:#dce8df,stroke:#4e765e,color:#173525',
    choice: 'fill:#e5def0,stroke:#70558d,color:#30203e',
    input: 'fill:#e7eef1,stroke:#496f82,color:#244a5d,stroke-dasharray:2 2',
    write: 'fill:#e3eee5,stroke:#3f7654,color:#214b30,stroke-width:2px',
    effect: 'fill:#efe8d6,stroke:#8a6e2d,color:#4d3b17',
    rule: 'fill:#f0e0d8,stroke:#a45632,color:#5c2c1c,stroke-width:1.5px',
    formula: 'fill:#e8e1f0,stroke:#70558d,color:#342447,stroke-width:1.5px',
    value: 'fill:#edf2f3,stroke:#6c8793,color:#294855',
    condition: 'fill:#f7eddc,stroke:#b6713b,color:#4a3020,stroke-dasharray:3 2',
    miss: 'fill:#ece9df,stroke:#8b8577,color:#575247,stroke-dasharray:2 2'
};
class $53afe75f1635cdce$export$6a0daef1ba659123 {
    lines;
    nodes = new Map();
    constructor(direction){
        this.lines = [
            `flowchart ${direction}`
        ];
    }
    line(source) {
        this.lines.push(source);
    }
    addNode(id, kind, labelLines) {
        const label = (0, $5b57b6d8a1f22309$export$6c3e2e0c633386e8)(labelLines);
        if (kind === 'condition') this.lines.push(`  ${id}{"${label}"}`);
        else if (kind === 'outcome' || kind === 'choice' || kind === 'formula' || kind === 'miss') this.lines.push(`  ${id}(["${label}"])`);
        else if (kind === 'rule') this.lines.push(`  ${id}{{"${label}"}}`);
        else this.lines.push(`  ${id}["${label}"]`);
        if (!this.nodes.has(kind)) this.nodes.set(kind, new Set());
        this.nodes.get(kind).add(id);
    }
    render(selectedEvent, selectedKnown = false) {
        for (const [kind, definition] of Object.entries($53afe75f1635cdce$var$DEFINITIONS)){
            this.lines.push(`  classDef ${kind} ${definition}`);
            const ids = [
                ...this.nodes.get(kind) ?? []
            ];
            if (ids.length) this.lines.push(`  class ${ids.join(',')} ${kind}`);
        }
        this.lines.push('  classDef selected fill:#d2a84c,stroke:#152633,color:#152633,stroke-width:4px');
        if (selectedEvent && selectedKnown) this.lines.push(`  class ${(0, $6fa8a5163afda41a$export$3f9b5e36512a0ea5)(selectedEvent)} selected`);
        return this.lines.join('\n');
    }
}



const $89cbd68bd6bba307$export$7a77c3750a37177e = (writer, event, flow)=>{
    const retryPolicy = event.retry;
    const waitNode = (0, $5b57b6d8a1f22309$export$a5a0914cccdde6d5)('effect', event.id, 'retry-wait');
    const connectFailureToWait = ()=>{
        writer.addNode(waitNode, 'effect', [
            'Wait until next turn'
        ]);
        flow.fail.forEach((exit)=>writer.line(`  ${exit.id} -->|${exit.label}| ${waitNode}`));
    };
    if (retryPolicy?.mode === 'forever') {
        connectFailureToWait();
        writer.line(`  ${waitNode} -->|retry| ${flow.entryId}`);
        return;
    }
    const missNode = (0, $5b57b6d8a1f22309$export$a5a0914cccdde6d5)('miss', event.id, 'gate-failed');
    if (!retryPolicy || retryPolicy.mode === 'once') {
        writer.addNode(missNode, 'miss', [
            'Event does not fire'
        ]);
        flow.fail.forEach((exit)=>writer.line(`  ${exit.id} -->|${exit.label}| ${missNode}`));
        return;
    }
    const retryNode = (0, $5b57b6d8a1f22309$export$a5a0914cccdde6d5)('condition', event.id, 'retry-available');
    const retryLabel = retryPolicy.mode === 'attempts' ? `Fewer than ${retryPolicy.attempts} checks used?` : `Still inside ${retryPolicy.rounds}-round retry window?`;
    connectFailureToWait();
    writer.addNode(retryNode, 'condition', [
        retryLabel
    ]);
    writer.addNode(missNode, 'miss', [
        'Event expires'
    ]);
    writer.line(`  ${waitNode} --> ${retryNode}`);
    writer.line(`  ${retryNode} -->|yes \xb7 retry| ${flow.entryId}`);
    writer.line(`  ${retryNode} -->|no \xb7 expire| ${missNode}`);
};


const $6114ff7ae3814646$export$54c28aad58888f2d = (document, options = {})=>{
    const included = options.eventIds ? new Set(options.eventIds) : null;
    const events = document.events.filter((event)=>!included || included.has(event.id));
    const known = new Set(events.map((event)=>event.id));
    const expanded = options.expandedEventIds ? new Set(options.expandedEventIds) : null;
    const writer = new (0, $53afe75f1635cdce$export$6a0daef1ba659123)(options.direction ?? 'LR');
    for (const event of events){
        const eventNode = (0, $6fa8a5163afda41a$export$3f9b5e36512a0ea5)(event.id);
        const round = (0, $6fa8a5163afda41a$export$a90da3d0131ffe9)(document.calendar, event.at);
        const date = `${event.at.day ? `${event.at.day} ` : ''}${(0, $5b57b6d8a1f22309$export$aff7a2c55c422b83)[event.at.month - 1]} ${event.at.year}`;
        writer.addNode(eventNode, 'event', [
            event.title,
            `Round ${round} \xb7 ${date}`,
            `${event.actor ?? 'System'} \xb7 ${event.category ?? 'uncategorized'}`
        ]);
        // Focus maps keep prerequisite events as causal landmarks. Expanding their
        // own gates here makes those gates look like requirements of the selected
        // event, even though they belong to a separate earlier event.
        if (expanded && !expanded.has(event.id)) continue;
        if (event.data && Object.keys(event.data).length) {
            const inputNode = (0, $5b57b6d8a1f22309$export$a5a0914cccdde6d5)('input', event.id, 'parameters');
            writer.addNode(inputNode, 'input', [
                'Parameters',
                ...Object.entries(event.data).map(([key, value])=>`${key} \u{2190} ${(0, $5b57b6d8a1f22309$export$c2f35a86bc746465)(value)}`)
            ]);
            writer.line(`  ${inputNode} -. parameters .-> ${eventNode}`);
        }
        if (event.vars && Object.keys(event.vars).length) {
            const inputNode = (0, $5b57b6d8a1f22309$export$a5a0914cccdde6d5)('input', event.id, 'bindings');
            writer.addNode(inputNode, 'input', [
                'Card bindings',
                ...Object.entries(event.vars).map(([key, value])=>`${key} \u{2190} ${(0, $5b57b6d8a1f22309$export$c2f35a86bc746465)(value)}`)
            ]);
            writer.line(`  ${inputNode} -. bindings .-> ${eventNode}`);
        }
        if (event.when?.length) {
            const conditionFlow = (0, $9a34f36fb207f611$export$fb1c669d9ff61b02)(writer, document, event, 'when', event.when, 'when');
            conditionFlow.pass.forEach((exit)=>writer.line(`  ${exit.id} -->|${exit.label}| ${eventNode}`));
            (0, $89cbd68bd6bba307$export$7a77c3750a37177e)(writer, event, conditionFlow);
            for (const dependency of event.gate?.requires ?? [])if (known.has(dependency)) writer.line(`  ${(0, $6fa8a5163afda41a$export$3f9b5e36512a0ea5)(dependency)} -. enables .-> ${conditionFlow.entryId}`);
        }
        const writeIds = [];
        if (event.then) {
            const outcomeNode = (0, $5b57b6d8a1f22309$export$a5a0914cccdde6d5)('outcome', event.id, event.outcome?.id ?? 'then');
            writer.addNode(outcomeNode, 'outcome', [
                event.outcome?.label ?? 'Apply declared changes'
            ]);
            writer.line(`  ${eventNode} --> ${outcomeNode}`);
            writeIds.push(...(0, $b4c0d0e6d64f03bd$export$8f4a5aedca2efb54)(writer, document, event, outcomeNode, 'then', event.then));
        }
        for (const eventChoice of event.choices ?? []){
            const choiceNode = (0, $5b57b6d8a1f22309$export$a5a0914cccdde6d5)('choice', event.id, eventChoice.key);
            writer.addNode(choiceNode, 'choice', [
                eventChoice.label,
                `Choice: ${eventChoice.key}`
            ]);
            writer.line(`  ${eventNode} -->|choice| ${choiceNode}`);
            writeIds.push(...(0, $b4c0d0e6d64f03bd$export$8f4a5aedca2efb54)(writer, document, event, choiceNode, `choice-${eventChoice.key}`, eventChoice.then));
        }
        if (!options.selectedEvent || options.selectedEvent === event.id) for (const rule of (0, $3a23179f5383b5d7$export$dedb529b6eeeb467)(document, event)){
            const ruleNode = (0, $5b57b6d8a1f22309$export$a5a0914cccdde6d5)('rule', event.id, rule.id);
            writer.addNode(ruleNode, 'rule', [
                rule.id,
                `On: ${rule.on}${rule.priority == null ? '' : ` \xb7 priority ${rule.priority}`}`
            ]);
            if (rule.when?.length) {
                const scope = `rule-${rule.id}`;
                const conditionFlow = (0, $9a34f36fb207f611$export$fb1c669d9ff61b02)(writer, document, event, scope, rule.when, `${scope}-when`);
                conditionFlow.pass.forEach((exit)=>writer.line(`  ${exit.id} -->|${exit.label}| ${ruleNode}`));
                const missNode = (0, $5b57b6d8a1f22309$export$a5a0914cccdde6d5)('miss', event.id, scope, 'not-applied');
                writer.addNode(missNode, 'miss', [
                    'Rule does not apply'
                ]);
                conditionFlow.fail.forEach((exit)=>writer.line(`  ${exit.id} -->|${exit.label}| ${missNode}`));
            }
            for (const sourceId of writeIds.length ? writeIds : [
                eventNode
            ])writer.line(`  ${sourceId} -. affects .-> ${ruleNode}`);
            (0, $b4c0d0e6d64f03bd$export$8f4a5aedca2efb54)(writer, document, event, ruleNode, `rule-${rule.id}`, rule.then);
        }
    }
    if (options.includeChronology) {
        const ordered = [
            ...events
        ].sort((left, right)=>(0, $6fa8a5163afda41a$export$a90da3d0131ffe9)(document.calendar, left.at) - (0, $6fa8a5163afda41a$export$a90da3d0131ffe9)(document.calendar, right.at) || document.events.indexOf(left) - document.events.indexOf(right));
        for(let index = 1; index < ordered.length; index++)writer.line(`  ${(0, $6fa8a5163afda41a$export$3f9b5e36512a0ea5)(ordered[index - 1].id)} ~~~ ${(0, $6fa8a5163afda41a$export$3f9b5e36512a0ea5)(ordered[index].id)}`);
    }
    return writer.render(options.selectedEvent, !!options.selectedEvent && known.has(options.selectedEvent));
};






const $22a7e83478aa8a3b$export$6ce4f3c9dae0e018 = (document, hostFactory)=>{
    const rulesByTrigger = new Map();
    for (const rule of document.rules ?? []){
        const rules = rulesByTrigger.get(rule.on) ?? [];
        rules.push(rule);
        rulesByTrigger.set(rule.on, rules);
    }
    for (const rules of rulesByTrigger.values())rules.sort((left, right)=>(left.priority ?? 0) - (right.priority ?? 0));
    const runtime = (0, $6fa8a5163afda41a$export$ebedbb3d51beda4b)({
        id: document.id,
        title: document.title,
        description: document.description,
        calendar: document.calendar,
        currentRound: (context)=>(0, $4b381e23cd3413de$export$b7a508fa8dae59fc)((0, $4b381e23cd3413de$export$2aa3fd96c49a84a8)(hostFactory(context).root, 'game.round'))
    }, document.events.map((spec)=>({
            id: spec.id,
            title: spec.title,
            at: spec.at,
            actor: spec.actor,
            category: spec.category,
            presentation: spec.presentation,
            data: spec.data,
            retry: spec.retry,
            conditions: spec.when?.length ? [
                (0, $6fa8a5163afda41a$export$355ef19165780f94)(spec.gate?.id ?? `${spec.id}.when`, spec.gate?.label ?? 'Declared conditions are satisfied', (context, scope)=>(0, $4b381e23cd3413de$export$f8d845b709d7dead)(spec.when, hostFactory(context), scope), spec.gate?.requires)
            ] : undefined,
            outcomes: spec.then ? [
                (0, $6fa8a5163afda41a$export$ba6444de194e78c5)(spec.outcome?.id ?? `${spec.id}.then`, spec.outcome?.label ?? 'Apply declared changes', (context, scope)=>(0, $ecb1a4ea9ed6bc66$export$d7257c389cd5bac5)(spec.then, hostFactory(context), scope), spec.outcome?.writes)
            ] : undefined,
            choices: spec.choices?.map((item)=>(0, $6fa8a5163afda41a$export$7a5825874deea16a)(item.key, item.label, item.then ? [
                    (0, $6fa8a5163afda41a$export$ba6444de194e78c5)(`${spec.id}.${item.key}`, item.label, (context, scope)=>(0, $ecb1a4ea9ed6bc66$export$d7257c389cd5bac5)(item.then, hostFactory(context), scope))
                ] : [])),
            vars: spec.vars ? (context, scope)=>Object.fromEntries(Object.entries(spec.vars).map(([key, value])=>[
                        key,
                        (0, $4b381e23cd3413de$export$fef61f332f2c0afc)(value, {
                            host: hostFactory(context),
                            scope: scope
                        })
                    ])) : undefined
        })));
    const engine = runtime;
    engine.document = document;
    engine.host = hostFactory;
    engine.initialVariables = ()=>JSON.parse(JSON.stringify(document.variables ?? {}));
    engine.variable = (context, path)=>(0, $4b381e23cd3413de$export$2aa3fd96c49a84a8)(hostFactory(context).root.variables, path);
    engine.setVariable = (context, path, value)=>{
        const host = hostFactory(context);
        host.setVariable?.(path, value);
        if (!host.setVariable) (0, $4b381e23cd3413de$export$1518ffc4a8ff94f2)(host.root.variables, path, value);
    };
    engine.select = (context, collection, where)=>{
        const host = hostFactory(context);
        return host.collections[collection].filter((entity)=>!where || (0, $4b381e23cd3413de$export$720c7cf5a5c0e696)(entity, where, {
                host: host,
                entity: entity
            }));
    };
    engine.group = (name)=>document.groups?.[name] ?? [];
    engine.apply = (eventId, context)=>{
        const spec = document.events.find((candidate)=>candidate.id === eventId);
        if (!spec) throw new Error(`Unknown event: ${eventId}`);
        const event = runtime.event(eventId);
        const currentRound = (0, $4b381e23cd3413de$export$b7a508fa8dae59fc)((0, $4b381e23cd3413de$export$2aa3fd96c49a84a8)(hostFactory(context).root, 'game.round'));
        (0, $ecb1a4ea9ed6bc66$export$d7257c389cd5bac5)(spec.then, hostFactory(context), (0, $6fa8a5163afda41a$export$bb878fb33a12512d)(runtime.map, event, currentRound));
    };
    engine.fireRules = (on, context, extraRoot = {})=>{
        const host = hostFactory(context, extraRoot);
        for (const rule of rulesByTrigger.get(on) ?? [])if ((0, $4b381e23cd3413de$export$f8d845b709d7dead)(rule.when, host)) (0, $ecb1a4ea9ed6bc66$export$d7257c389cd5bac5)(rule.then, host);
        return host;
    };
    return engine;
};




var $1dee7a0df1696628$exports = {};
$1dee7a0df1696628$exports = JSON.parse("{\"factions\":[{\"name\":\"Turkey\",\"color\":\"red\",\"territories\":[{\"slug\":\"edirne\",\"troops\":5},{\"slug\":\"balikesir\",\"troops\":8},{\"slug\":\"usak\",\"troops\":6},{\"slug\":\"eskisehir\",\"troops\":6},{\"slug\":\"kutahya\",\"troops\":8},{\"slug\":\"ankara\",\"troops\":10},{\"slug\":\"konya\",\"troops\":4},{\"slug\":\"sivas\",\"troops\":4},{\"slug\":\"kastamonu\",\"troops\":4},{\"slug\":\"samsun\",\"troops\":4},{\"slug\":\"trabzon\",\"troops\":5},{\"slug\":\"sakarya\",\"troops\":4},{\"slug\":\"erzurum\",\"troops\":5},{\"slug\":\"van\",\"troops\":5},{\"slug\":\"elazig\",\"troops\":4},{\"slug\":\"diyarbakir\",\"troops\":4}]},{\"name\":\"Greece\",\"color\":\"blue\",\"territories\":[{\"slug\":\"salonica\",\"troops\":12},{\"slug\":\"kozani\",\"troops\":9},{\"slug\":\"western-thrace\",\"troops\":7},{\"slug\":\"lesbos\",\"troops\":4},{\"slug\":\"rhodes\",\"troops\":4},{\"slug\":\"izmir\",\"troops\":10},{\"slug\":\"aydin\",\"troops\":8}]},{\"name\":\"Bulgaria\",\"color\":\"green\",\"territories\":[{\"slug\":\"sofia\",\"troops\":7},{\"slug\":\"plovdiv\",\"troops\":4},{\"slug\":\"varna\",\"troops\":6},{\"slug\":\"burgas\",\"troops\":3}]},{\"name\":\"Armenia\",\"color\":\"goldenrod\",\"territories\":[{\"slug\":\"kars\",\"troops\":5},{\"slug\":\"igdir\",\"troops\":3},{\"slug\":\"gyumri\",\"troops\":3},{\"slug\":\"yerevan\",\"troops\":3},{\"slug\":\"vanadzor\",\"troops\":3},{\"slug\":\"sevan\",\"troops\":3}]},{\"name\":\"Italy\",\"color\":\"purple\",\"territories\":[{\"slug\":\"antalya\",\"troops\":7},{\"slug\":\"isparta\",\"troops\":5}]},{\"name\":\"Britain\",\"color\":\"pink\",\"territories\":[{\"slug\":\"istanbul\",\"troops\":10},{\"slug\":\"izmit\",\"troops\":8},{\"slug\":\"gelibolu\",\"troops\":6},{\"slug\":\"canakkale\",\"troops\":6},{\"slug\":\"mosul\",\"troops\":5},{\"slug\":\"baghdad\",\"troops\":5}]},{\"name\":\"France\",\"color\":\"orange\",\"territories\":[{\"slug\":\"adana\",\"troops\":6},{\"slug\":\"maras\",\"troops\":7},{\"slug\":\"hatay\",\"troops\":5},{\"slug\":\"aleppo\",\"troops\":6}]},{\"name\":\"Iraq\",\"color\":\"olive\",\"territories\":[]}]}");



const $a57adc7b3bbfe58c$export$458d7a1c5c3db6e9 = (0, (/*@__PURE__*/$parcel$interopDefault($2624524d1190a2c3$exports))).groups.nationalPact;
const $a57adc7b3bbfe58c$export$afae29cb2a27dbd6 = (0, (/*@__PURE__*/$parcel$interopDefault($2624524d1190a2c3$exports))).groups.assemblySeats;
const $a57adc7b3bbfe58c$export$49c6d8172300da39 = (0, (/*@__PURE__*/$parcel$interopDefault($2624524d1190a2c3$exports))).groups;
const $a57adc7b3bbfe58c$export$59d67d3ae020dbb = (name)=>{
    const group = $a57adc7b3bbfe58c$export$49c6d8172300da39[name];
    if (!group) throw new Error(`Unknown campaign territory group: ${name}`);
    return group;
};
const $a57adc7b3bbfe58c$export$662bb6d1cd2d3f16 = Object.fromEntries((0, (/*@__PURE__*/$parcel$interopDefault($1dee7a0df1696628$exports))).factions.map((faction)=>[
        faction.name,
        faction.territories.length
    ]));
const $a57adc7b3bbfe58c$export$8ca11ae64af8ab3e = Object.fromEntries((0, (/*@__PURE__*/$parcel$interopDefault($1dee7a0df1696628$exports))).factions.flatMap((faction)=>faction.territories.map((territory)=>[
            territory.slug,
            faction.name
        ])));
for (const slug of $a57adc7b3bbfe58c$export$458d7a1c5c3db6e9)$a57adc7b3bbfe58c$export$8ca11ae64af8ab3e[slug] = 'Turkey';



var $ilwRK = parcelRequire("ilwRK");
var $c3c22db1b850038e$exports = {};
$c3c22db1b850038e$exports = JSON.parse("{\"$schema\":\"game-scenario.v1\",\"humanFaction\":\"Turkey\",\"alliances\":{\"Turkey\":\"turkey\",\"Greece\":\"entente\",\"Britain\":\"entente\",\"France\":\"entente\",\"Italy\":\"entente\",\"Armenia\":\"entente\",\"Bulgaria\":\"neutral\",\"Iraq\":\"neutral\"},\"diplomacy\":{\"grudgesOverride\":true,\"permissions\":[{\"attackerAlliance\":\"turkey\"},{\"attackerAlliance\":\"entente\",\"defenderAlliance\":\"turkey\"},{\"attacker\":\"Bulgaria\",\"defender\":\"Greece\"}]},\"movement\":{\"navies\":[\"Greece\",\"Britain\",\"Italy\",\"France\"],\"seaLanes\":[{\"ports\":[\"salonica\",\"izmir\"],\"at\":[285,330]},{\"ports\":[\"salonica\",\"lesbos\"],\"at\":[276,311]},{\"ports\":[\"salonica\",\"rhodes\"],\"at\":[306,389]}],\"crossingRounds\":2,\"crossingCapacity\":6,\"occupiedTerritoryGroup\":\"nationalPact\",\"occupiedMovementFactor\":0.5},\"combat\":{\"attacksPerTurn\":3,\"advanceDepth\":{\"homeland\":2,\"foreign\":2}},\"economy\":{\"minimumReinforcements\":2,\"territoriesPerReinforcement\":3,\"defaultFortifyLimit\":1,\"fortifyLimitByFaction\":{\"Turkey\":2},\"cardTypes\":[\"infantry\",\"cavalry\",\"cannon\"],\"tradeBonuses\":[4,6,8,10,12,15],\"tradeIncrement\":5},\"presentation\":{\"governmentFaction\":\"Turkey\",\"governmentSeats\":[\"ankara\",\"sivas\"]},\"retaliationWindow\":3}");


var $b337a22fd7060284$exports = {};
$b337a22fd7060284$exports = JSON.parse("{\"$schema\":\"http://json-schema.org/draft-07/schema#\",\"type\":\"object\",\"additionalProperties\":false,\"required\":[\"$schema\",\"humanFaction\",\"alliances\",\"diplomacy\",\"movement\",\"combat\",\"economy\",\"presentation\",\"retaliationWindow\"],\"properties\":{\"$schema\":{\"const\":\"game-scenario.v1\"},\"humanFaction\":{\"type\":\"string\",\"minLength\":1},\"alliances\":{\"type\":\"object\",\"minProperties\":1,\"additionalProperties\":{\"enum\":[\"turkey\",\"entente\",\"neutral\"]}},\"diplomacy\":{\"type\":\"object\",\"additionalProperties\":false,\"required\":[\"grudgesOverride\",\"permissions\"],\"properties\":{\"grudgesOverride\":{\"type\":\"boolean\"},\"permissions\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"additionalProperties\":false,\"minProperties\":1,\"properties\":{\"attacker\":{\"type\":\"string\"},\"attackerAlliance\":{\"enum\":[\"turkey\",\"entente\",\"neutral\"]},\"defender\":{\"type\":\"string\"},\"defenderAlliance\":{\"enum\":[\"turkey\",\"entente\",\"neutral\"]}}}}}},\"movement\":{\"type\":\"object\",\"additionalProperties\":false,\"required\":[\"navies\",\"seaLanes\",\"crossingRounds\",\"crossingCapacity\",\"occupiedTerritoryGroup\",\"occupiedMovementFactor\"],\"properties\":{\"navies\":{\"type\":\"array\",\"items\":{\"type\":\"string\"},\"uniqueItems\":true},\"seaLanes\":{\"type\":\"array\",\"items\":{\"type\":\"object\",\"additionalProperties\":false,\"required\":[\"ports\",\"at\"],\"properties\":{\"ports\":{\"type\":\"array\",\"items\":{\"type\":\"string\"},\"minItems\":2,\"maxItems\":2},\"at\":{\"type\":\"array\",\"items\":{\"type\":\"number\"},\"minItems\":2,\"maxItems\":2}}}},\"crossingRounds\":{\"type\":\"integer\",\"minimum\":1},\"crossingCapacity\":{\"type\":\"integer\",\"minimum\":1},\"occupiedTerritoryGroup\":{\"type\":\"string\"},\"occupiedMovementFactor\":{\"type\":\"number\",\"exclusiveMinimum\":0,\"maximum\":1}}},\"combat\":{\"type\":\"object\",\"additionalProperties\":false,\"required\":[\"attacksPerTurn\",\"advanceDepth\"],\"properties\":{\"attacksPerTurn\":{\"type\":\"integer\",\"minimum\":0},\"advanceDepth\":{\"type\":\"object\",\"additionalProperties\":false,\"required\":[\"homeland\",\"foreign\"],\"properties\":{\"homeland\":{\"type\":\"integer\",\"minimum\":0},\"foreign\":{\"type\":\"integer\",\"minimum\":0}}}}},\"economy\":{\"type\":\"object\",\"additionalProperties\":false,\"required\":[\"minimumReinforcements\",\"territoriesPerReinforcement\",\"defaultFortifyLimit\",\"fortifyLimitByFaction\",\"cardTypes\",\"tradeBonuses\",\"tradeIncrement\"],\"properties\":{\"minimumReinforcements\":{\"type\":\"integer\",\"minimum\":0},\"territoriesPerReinforcement\":{\"type\":\"integer\",\"minimum\":1},\"defaultFortifyLimit\":{\"type\":\"integer\",\"minimum\":0},\"fortifyLimitByFaction\":{\"type\":\"object\",\"additionalProperties\":{\"type\":\"integer\",\"minimum\":0}},\"cardTypes\":{\"type\":\"array\",\"items\":{\"enum\":[\"infantry\",\"cavalry\",\"cannon\"]},\"minItems\":1,\"uniqueItems\":true},\"tradeBonuses\":{\"type\":\"array\",\"items\":{\"type\":\"integer\",\"minimum\":0},\"minItems\":1},\"tradeIncrement\":{\"type\":\"integer\",\"minimum\":0}}},\"presentation\":{\"type\":\"object\",\"additionalProperties\":false,\"required\":[\"governmentFaction\",\"governmentSeats\"],\"properties\":{\"governmentFaction\":{\"type\":\"string\"},\"governmentSeats\":{\"type\":\"array\",\"items\":{\"type\":\"string\"},\"minItems\":1}}},\"retaliationWindow\":{\"type\":\"integer\",\"minimum\":0}}}");


const $9ff2839edea1890c$var$validate = new (0, (/*@__PURE__*/$parcel$interopDefault($ilwRK)))({
    allErrors: true,
    strict: true
}).compile((0, (/*@__PURE__*/$parcel$interopDefault($b337a22fd7060284$exports))));
const $9ff2839edea1890c$export$1994841799cda095 = (document)=>{
    if (!$9ff2839edea1890c$var$validate(document)) {
        const detail = $9ff2839edea1890c$var$validate.errors?.map((error)=>`${error.instancePath || '/'} ${error.message}`).join('; ');
        throw new Error(`Invalid scenario document: ${detail}`);
    }
    return document;
};
const $9ff2839edea1890c$export$9b928fc5e710e864 = $9ff2839edea1890c$export$1994841799cda095((0, (/*@__PURE__*/$parcel$interopDefault($c3c22db1b850038e$exports))));


const $5fc948bed93bbc7c$export$6f36fe8735a5e3e9 = (0, $df0d9308ad8f3180$export$a4a48e7a73cf2842)((0, (/*@__PURE__*/$parcel$interopDefault($2624524d1190a2c3$exports))));
const $5fc948bed93bbc7c$var$hostFactories = new WeakMap();
const $5fc948bed93bbc7c$var$dynamicView = (source, fixed, values)=>{
    const view = {
        $source: source,
        ...fixed
    };
    Object.defineProperties(view, Object.fromEntries(Object.entries(values).map(([name, get])=>[
            name,
            {
                enumerable: true,
                configurable: false,
                get: get
            }
        ])));
    return view;
};
const $5fc948bed93bbc7c$var$createHostFactory = (game)=>{
    const territoryViews = game.territories.map((territory)=>$5fc948bed93bbc7c$var$dynamicView(territory, {
            slug: territory.slug,
            homelandOwner: (0, $a57adc7b3bbfe58c$export$8ca11ae64af8ab3e)[territory.slug],
            adjacent: territory.adjacent.map((adjacent)=>$5fc948bed93bbc7c$var$dynamicView(adjacent, {
                    slug: adjacent.slug
                }, {
                    heldBy: ()=>adjacent.faction.name,
                    heldByAlliance: ()=>adjacent.faction.alliance,
                    troops: ()=>adjacent.troops
                }))
        }, {
            heldBy: ()=>territory.faction.name,
            heldByAlliance: ()=>territory.faction.alliance,
            troops: ()=>territory.troops,
            entrenched: ()=>territory.entrenched,
            quietTurns: ()=>territory.quietTurns,
            heldSince: ()=>territory.heldSince,
            raidedOn: ()=>territory.raidedOn
        }));
    const factionViews = game.factions.map((faction)=>$5fc948bed93bbc7c$var$dynamicView(faction, {
            name: faction.name,
            alliance: faction.alliance,
            setupTerritoryCount: (0, $a57adc7b3bbfe58c$export$662bb6d1cd2d3f16)[faction.name] ?? Number.POSITIVE_INFINITY
        }, {
            territoryCount: ()=>faction.territories.length,
            homeTerritoryCount: ()=>faction.territories.filter((territory)=>!(0, $a57adc7b3bbfe58c$export$458d7a1c5c3db6e9).includes(territory.slug)).length,
            eliminated: ()=>faction.eliminated,
            peaceBroken: ()=>faction.peaceBroken
        }));
    const territories = Object.fromEntries(territoryViews.map((view)=>[
            view.slug,
            view
        ]));
    const factions = Object.fromEntries(factionViews.map((view)=>[
            view.name,
            view
        ]));
    const gameView = $5fc948bed93bbc7c$var$dynamicView(game, {}, {
        round: ()=>game.turn.round,
        phase: ()=>game.turn.phase,
        pactProgress: ()=>game.pactProgress,
        liberatedThisTurn: ()=>game.turn.liberatedHomeland
    });
    const turnView = $5fc948bed93bbc7c$var$dynamicView(game.turn, {}, {
        currentFaction: ()=>game.turn.currentPlayer.faction.name,
        phase: ()=>game.turn.phase,
        reinforcementsLeft: ()=>game.turn.reinforcementsLeft
    });
    const presentationView = $5fc948bed93bbc7c$var$dynamicView(game, {}, {
        currentDate: ()=>game.date,
        currentDateLoc: ()=>(0, $6c154842fccf6556$export$950651e963a037d3)(game.date),
        assemblySeat: ()=>{
            const seat = (0, $9ff2839edea1890c$export$9b928fc5e710e864).presentation.governmentSeats.find((slug)=>game.bySlug[slug]?.faction.name === (0, $9ff2839edea1890c$export$9b928fc5e710e864).presentation.governmentFaction) ?? (0, $9ff2839edea1890c$export$9b928fc5e710e864).presentation.governmentSeats[(0, $9ff2839edea1890c$export$9b928fc5e710e864).presentation.governmentSeats.length - 1];
            return (0, $6c154842fccf6556$export$9c131fee79280443)((0, $6c154842fccf6556$export$983732bc59a669db)(seat, game.bySlug[seat].name), 'loc');
        }
    });
    const baseHost = {
        groups: $5fc948bed93bbc7c$export$6f36fe8735a5e3e9.groups,
        collections: {
            territories: territoryViews,
            factions: factionViews
        },
        setVariable (path, value) {
            (0, $4b381e23cd3413de$export$1518ffc4a8ff94f2)(game.campaign.variables, path, value);
        },
        setEntity (collection, entity, field, value) {
            const source = entity.$source;
            if (collection === 'territories' && field === 'heldBy') {
                const territory = source;
                const owner = game.factions.find((faction)=>faction.name === value);
                if (owner && territory.faction !== owner) game.board.changeControl(territory, owner, game.turn.round);
                return;
            }
            source[field] = value;
        },
        drawCards (factionName, count) {
            const faction = game.factions.find((candidate)=>candidate.name === factionName);
            if (faction) for(let n = 0; n < count; n++)game.drawCard(faction);
        },
        writeLog (key, factionName, vars, event) {
            const faction = factionName ? game.factions.find((candidate)=>candidate.name === factionName) ?? null : null;
            const interpolation = Object.fromEntries(Object.entries(vars).map(([name, value])=>[
                    name,
                    typeof value === 'number' ? value : String(value)
                ]));
            game.record(faction, key, interpolation, event);
        },
        resolveBattle (attackerName, targetSlug, troops) {
            const attacker = game.factions.find((candidate)=>candidate.name === attackerName);
            const target = game.bySlug[targetSlug];
            if (attacker && target) game.combat.land(attacker, target, troops);
        },
        random: ()=>game.random.next(),
        afterApply (changed) {
            if (changed.has('territories')) game.checkGameEnd();
        }
    };
    return (extraRoot = {})=>{
        const root = {
            game: gameView,
            turn: turnView,
            variables: game.campaign.variables,
            territories: territories,
            factions: factions,
            presentation: presentationView,
            result: {
                allowed: true
            },
            ...extraRoot
        };
        return {
            ...baseHost,
            root: root,
            setRoot (target, field, value) {
                if (target === 'turn') {
                    if (field === 'reinforcementsLeft') game.turn.setReinforcements(Number(value));
                    else if (field === 'phase') game.turn.setPhase(value);
                    return;
                }
                if (target === 'game') {
                    if (field === 'winner') game.winner = value ? game.factions.find((faction)=>faction.name === value) ?? null : null;
                    else if (field === 'phase') game.turn.setPhase(value);
                    else if (field === 'liberatedThisTurn' && value) game.turn.recordLiberation();
                    else game[field] = value;
                    return;
                }
                (0, $4b381e23cd3413de$export$1518ffc4a8ff94f2)(root.result, field, value);
            }
        };
    };
};
const $5fc948bed93bbc7c$var$campaignHost = (game, extraRoot)=>{
    let factory = $5fc948bed93bbc7c$var$hostFactories.get(game);
    if (!factory) {
        factory = $5fc948bed93bbc7c$var$createHostFactory(game);
        $5fc948bed93bbc7c$var$hostFactories.set(game, factory);
    }
    return factory(extraRoot);
};
const $5fc948bed93bbc7c$export$8d060eafa82de264 = ()=>(0, $22a7e83478aa8a3b$export$6ce4f3c9dae0e018)($5fc948bed93bbc7c$export$6f36fe8735a5e3e9, $5fc948bed93bbc7c$var$campaignHost);
const $5fc948bed93bbc7c$export$b59a2891c59b34d8 = $5fc948bed93bbc7c$export$8d060eafa82de264();
const $5fc948bed93bbc7c$export$239cb250891f2735 = $5fc948bed93bbc7c$export$b59a2891c59b34d8.map;
const $5fc948bed93bbc7c$export$bb2f7671035ac146 = $5fc948bed93bbc7c$export$b59a2891c59b34d8.events;
const $5fc948bed93bbc7c$export$911a7205eac2c27a = (game, extraRoot)=>$5fc948bed93bbc7c$var$campaignHost(game, extraRoot);





const $141f04841e249a01$export$2de664e47e59a58d = ({ game: game })=>{
    const human = game.turn.currentPlayer.isHuman;
    const fortifiesLeft = game.campaign.fortifyLimit - game.turn.fortifiesUsed;
    const requisitionUntil = Number((0, $5fc948bed93bbc7c$export$b59a2891c59b34d8).variable(game, 'tekalif.until'));
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
                className: "hud hud-brand",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        children: (0, $6c154842fccf6556$export$625550452a3fa3ec)('brand.title')
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "hud-date",
                        children: (0, $6c154842fccf6556$export$625550452a3fa3ec)('hud.dateRound', {
                            date: game.date,
                            round: game.turn.round
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "hud hud-phase",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "hud-player",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5181a4732ad985ba$export$c463048d6131b309), {
                                faction: game.turn.currentPlayer.faction.name
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: game.leaderName(game.turn.currentPlayer)
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: `hud-phase-title phase-${game.turn.phase}`,
                        children: [
                            (0, $6c154842fccf6556$export$625550452a3fa3ec)((0, $5181a4732ad985ba$export$cc499a901ec5a0d9)[game.turn.phase]),
                            human && game.turn.phase === 'reinforce' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "hud-count",
                                children: [
                                    ' ',
                                    "\xb7 ",
                                    game.turn.reinforcementsLeft,
                                    " ",
                                    (0, $6c154842fccf6556$export$625550452a3fa3ec)('hud.left')
                                ]
                            }),
                            human && game.turn.phase === 'attack' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "hud-count",
                                children: [
                                    ' ',
                                    "\xb7 ",
                                    game.turn.attacksLeft,
                                    " ",
                                    (0, $6c154842fccf6556$export$625550452a3fa3ec)('hud.attacks')
                                ]
                            }),
                            human && game.turn.phase === 'fortify' && game.campaign.fortifyLimit > 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "hud-count",
                                children: [
                                    ' ',
                                    "\xb7 ",
                                    fortifiesLeft,
                                    " ",
                                    (0, $6c154842fccf6556$export$625550452a3fa3ec)('hud.moves')
                                ]
                            })
                        ]
                    }),
                    game.turn.round <= requisitionUntil && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "hud-requisition",
                        title: (0, $6c154842fccf6556$export$625550452a3fa3ec)('hud.requisitionTitle'),
                        children: [
                            "\u2696\uFE0F ",
                            (0, $6c154842fccf6556$export$625550452a3fa3ec)('hud.requisition', {
                                n: requisitionUntil - game.turn.round + 1
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "hud-pact",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                children: [
                                    (0, $6c154842fccf6556$export$625550452a3fa3ec)('hud.pact'),
                                    " ",
                                    game.pactProgress,
                                    "/",
                                    (0, $a57adc7b3bbfe58c$export$458d7a1c5c3db6e9).length
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                className: "pact-bar",
                                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                    className: "pact-fill",
                                    style: {
                                        width: `${100 * game.pactProgress / (0, $a57adc7b3bbfe58c$export$458d7a1c5c3db6e9).length}%`
                                    }
                                })
                            })
                        ]
                    })
                ]
            })
        ]
    });
};



parcelRequire("acw62");


const $7c537a863ca8b3ea$export$ff5bd22a9d8c53ff = ({ game: game })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("aside", {
        className: "hud hud-factions",
        children: game.players.map((player)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                title: game.traitSummary(player.faction),
                className: `chip${player.faction.eliminated ? ' eliminated' : ''}${player === game.turn.currentPlayer ? ' active' : ''}`,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5181a4732ad985ba$export$c463048d6131b309), {
                        faction: player.faction.name
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "chip-name",
                        children: (0, $6c154842fccf6556$export$e75392c849ab10e7)(player.faction.name)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "chip-stats",
                        children: [
                            player.faction.territories.length,
                            "\u2691 ",
                            player.faction.troopTotal,
                            "\u2694",
                            game.campaign.isPassive(player.faction) && !player.faction.eliminated && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "chip-flag",
                                children: " \u262E"
                            })
                        ]
                    })
                ]
            }, player.faction.name))
    });




var $acw62 = parcelRequire("acw62");

const $99b5c8068df0b6a9$export$b827813b2cbfb4b1 = (name)=>({
        kind: 'faction',
        name: name
    });
const $99b5c8068df0b6a9$export$1a920137df84177e = (slug, fallback, grammaticalCase)=>({
        kind: 'territory',
        slug: slug,
        fallback: fallback,
        grammaticalCase: grammaticalCase
    });
const $99b5c8068df0b6a9$export$9f8baa050125a116 = (value)=>({
        kind: 'date',
        value: value
    });
const $99b5c8068df0b6a9$var$resolveValue = (value)=>{
    if (typeof value === 'string' || typeof value === 'number') return value;
    if (value.kind === 'faction') return (0, $6c154842fccf6556$export$e75392c849ab10e7)(value.name);
    if (value.kind === 'date') return (0, $6c154842fccf6556$export$950651e963a037d3)(value.value);
    const territory = (0, $6c154842fccf6556$export$983732bc59a669db)(value.slug, value.fallback);
    return value.grammaticalCase ? (0, $6c154842fccf6556$export$9c131fee79280443)(territory, value.grammaticalCase) : territory;
};
const $99b5c8068df0b6a9$export$22c57dd65f98f02d = (entry)=>(0, $6c154842fccf6556$export$625550452a3fa3ec)(entry.key, Object.fromEntries(Object.entries(entry.vars).map(([name, value])=>[
            name,
            $99b5c8068df0b6a9$var$resolveValue(value)
        ])));



const $6d4cfe8a4b4b9416$export$6f3564cffef410fa = ({ game: game })=>{
    const logRef = (0, $acw62.useRef)(null);
    const [open, setOpen] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        if (logRef.current) logRef.current.scrollTop = logRef.current.scrollHeight;
    }, [
        game.log.length,
        open
    ]);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: `hud hud-log${open ? ' open' : ''}`,
        ref: logRef,
        onClick: ()=>setOpen((value)=>!value),
        children: game.log.slice(-40).map((entry, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: `log-entry${entry.event ? ' log-event' : ''}`,
                children: [
                    !entry.event && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5181a4732ad985ba$export$c463048d6131b309), {
                        faction: entry.faction
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: (0, $99b5c8068df0b6a9$export$22c57dd65f98f02d)(entry)
                    })
                ]
            }, index))
    });
};


const $6e91e55e9b7ea13b$var$Hud = (props)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $141f04841e249a01$export$2de664e47e59a58d), {
                game: props.game
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7c537a863ca8b3ea$export$ff5bd22a9d8c53ff), {
                game: props.game
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6d4cfe8a4b4b9416$export$6f3564cffef410fa), {
                game: props.game
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $25fe57349a38cc60$export$4d9c9e1c1a52b59b), {
                ...props
            })
        ]
    });
var $6e91e55e9b7ea13b$export$2e2bcd8739ae039 = $6e91e55e9b7ea13b$var$Hud;




var $acw62 = parcelRequire("acw62");

var $818b933824179c94$exports = {};
$818b933824179c94$exports = import.meta.resolve("a7L2E");


var $666b0f3813cfa78c$exports = {};
$666b0f3813cfa78c$exports = import.meta.resolve("a29NL");


var $962f3913a6cc4d4d$exports = {};
$962f3913a6cc4d4d$exports = import.meta.resolve("hnsp2");


var $41f8d21a21392820$exports = {};
$41f8d21a21392820$exports = import.meta.resolve("9pa9O");


var $c27beb98e27e163c$exports = {};
$c27beb98e27e163c$exports = import.meta.resolve("56YVn");


var $824e0ce03078885f$exports = {};
$824e0ce03078885f$exports = import.meta.resolve("bjLC4");


var $e3aa7d7b47c90d21$exports = {};
$e3aa7d7b47c90d21$exports = import.meta.resolve("6eYKb");


var $5da9cec80afe5fad$exports = {};
$5da9cec80afe5fad$exports = import.meta.resolve("jvVBu");


var $19ae5378b6904214$exports = {};
$19ae5378b6904214$exports = import.meta.resolve("ljZbq");


var $ffec9804f1b8ebba$exports = {};
$ffec9804f1b8ebba$exports = import.meta.resolve("6gH0E");


var $6df782523b42657e$exports = {};
$6df782523b42657e$exports = import.meta.resolve("8QthH");


var $836fb0da37c2236f$exports = {};
$836fb0da37c2236f$exports = import.meta.resolve("5fWMC");


var $bfa7d68ec037a10b$exports = {};
$bfa7d68ec037a10b$exports = import.meta.resolve("38W1U");


const $a02a16ce6e0bc642$var$TRACKS = [
    new URL($818b933824179c94$exports),
    new URL($666b0f3813cfa78c$exports),
    new URL($962f3913a6cc4d4d$exports),
    new URL($41f8d21a21392820$exports),
    new URL($c27beb98e27e163c$exports),
    new URL($824e0ce03078885f$exports),
    new URL($e3aa7d7b47c90d21$exports),
    new URL($5da9cec80afe5fad$exports),
    new URL($19ae5378b6904214$exports),
    new URL($ffec9804f1b8ebba$exports),
    new URL($6df782523b42657e$exports),
    new URL($836fb0da37c2236f$exports),
    new URL($bfa7d68ec037a10b$exports)
];
const $a02a16ce6e0bc642$var$DEFAULT_VOLUME = 0.33;
const $a02a16ce6e0bc642$var$STORAGE_KEY = 'independence.music';
const $a02a16ce6e0bc642$var$VOLUME_KEY = 'independence.musicVolume';
const $a02a16ce6e0bc642$var$readPref = ()=>{
    try {
        return localStorage.getItem($a02a16ce6e0bc642$var$STORAGE_KEY) !== 'off';
    } catch  {
        return true;
    }
};
const $a02a16ce6e0bc642$var$readVolume = ()=>{
    try {
        const raw = localStorage.getItem($a02a16ce6e0bc642$var$VOLUME_KEY);
        const parsed = raw === null ? NaN : Number(raw);
        return parsed >= 0 && parsed <= 1 ? parsed : $a02a16ce6e0bc642$var$DEFAULT_VOLUME;
    } catch  {
        return $a02a16ce6e0bc642$var$DEFAULT_VOLUME;
    }
};
let $a02a16ce6e0bc642$var$enabled = $a02a16ce6e0bc642$var$readPref();
let $a02a16ce6e0bc642$var$volume = $a02a16ce6e0bc642$var$readVolume();
let $a02a16ce6e0bc642$var$audio = null;
let $a02a16ce6e0bc642$var$position = 0;
// The stored value is a 0..1 loudness fraction; ears hear loudness roughly
// logarithmically, so a linear slider jumps to "loud" almost at once. A
// perceptual taper (fraction^1.5) makes the low end genuinely quiet, matching
// how a volume control like Spotify's behaves.
const $a02a16ce6e0bc642$var$gainFor = (fraction)=>fraction * Math.sqrt(fraction);
const $a02a16ce6e0bc642$var$retryOnGesture = ()=>{
    const resume = ()=>{
        if ($a02a16ce6e0bc642$var$enabled) $a02a16ce6e0bc642$var$audio?.play().catch(()=>{});
    };
    document.addEventListener('pointerdown', resume, {
        once: true
    });
};
const $a02a16ce6e0bc642$var$playCurrent = ()=>{
    if (!$a02a16ce6e0bc642$var$audio) return;
    $a02a16ce6e0bc642$var$audio.src = $a02a16ce6e0bc642$var$TRACKS[$a02a16ce6e0bc642$var$position].href;
    $a02a16ce6e0bc642$var$audio.play().catch($a02a16ce6e0bc642$var$retryOnGesture);
};
const $a02a16ce6e0bc642$var$playNext = ()=>{
    $a02a16ce6e0bc642$var$position = ($a02a16ce6e0bc642$var$position + 1) % $a02a16ce6e0bc642$var$TRACKS.length;
    $a02a16ce6e0bc642$var$playCurrent();
};
const $a02a16ce6e0bc642$export$2f52891e98fc2f65 = ()=>$a02a16ce6e0bc642$var$enabled;
const $a02a16ce6e0bc642$export$6b637599c0fa455f = ()=>$a02a16ce6e0bc642$var$volume;
const $a02a16ce6e0bc642$export$ad4230c756f5c4e = (level)=>{
    $a02a16ce6e0bc642$var$volume = Math.min(1, Math.max(0, level));
    try {
        localStorage.setItem($a02a16ce6e0bc642$var$VOLUME_KEY, String($a02a16ce6e0bc642$var$volume));
    } catch  {}
    if ($a02a16ce6e0bc642$var$audio) $a02a16ce6e0bc642$var$audio.volume = $a02a16ce6e0bc642$var$gainFor($a02a16ce6e0bc642$var$volume);
};
const $a02a16ce6e0bc642$export$6df7d8ca8e8b46f5 = (on)=>{
    $a02a16ce6e0bc642$var$enabled = on;
    try {
        localStorage.setItem($a02a16ce6e0bc642$var$STORAGE_KEY, on ? 'on' : 'off');
    } catch  {}
    if (!$a02a16ce6e0bc642$var$audio) return;
    if (!on) {
        $a02a16ce6e0bc642$var$audio.pause();
        return;
    }
    // Turning music on: if the element was created while music was off it has no
    // src yet, so play() alone is silent — load the current track first. Once a
    // track is loaded, plain play() resumes it.
    if (!$a02a16ce6e0bc642$var$audio.src) $a02a16ce6e0bc642$var$playCurrent();
    else $a02a16ce6e0bc642$var$audio.play().catch($a02a16ce6e0bc642$var$retryOnGesture);
};
const $a02a16ce6e0bc642$export$275a724b3b452522 = ()=>{
    if ($a02a16ce6e0bc642$var$audio) return;
    $a02a16ce6e0bc642$var$audio = new Audio();
    $a02a16ce6e0bc642$var$audio.volume = $a02a16ce6e0bc642$var$gainFor($a02a16ce6e0bc642$var$volume);
    if (typeof window !== 'undefined') window.__music = $a02a16ce6e0bc642$var$audio;
    $a02a16ce6e0bc642$var$audio.addEventListener('ended', $a02a16ce6e0bc642$var$playNext);
    $a02a16ce6e0bc642$var$position = 0;
    if ($a02a16ce6e0bc642$var$enabled) $a02a16ce6e0bc642$var$playCurrent();
};


// Sound-effect engine — a sibling of music.ts. Where music streams one long
// backing track through an <audio> element, effects need sample-accurate
// timing, zero-latency retriggers, and clean overlap, so this runs on the Web
// Audio API: each file is decoded once into an AudioBuffer and played through a
// fresh source node routed AudioBufferSourceNode → per-voice GainNode → master
// gain → destination. The per-voice gain also does a short tail ramp to true
// silence, which kills the end-of-clip click an <audio> element leaves behind.
//
// It lives in the browser layer only — the game engine runs headless during AI
// training and must never reach for audio.
// CLIPS is a generated module written by the sound admin: each cue id maps to
// its live take URLs. It's a normal source module (not a bundler glob), so it
// rebuilds cleanly whenever the admin promotes new takes — a page reload is
// enough, no dev-server restart.
// AUTO-GENERATED by independence-sound-admin — do not edit by hand.
// Each cue id maps to its live take URLs; the game plays one at random.
var $5fb60cf8ebea31f5$exports = {};
$5fb60cf8ebea31f5$exports = import.meta.resolve("kgkm3");


var $5a9cce4bd58f9ed9$exports = {};
$5a9cce4bd58f9ed9$exports = import.meta.resolve("a6SBw");


var $445388d46b34412a$exports = {};
$445388d46b34412a$exports = import.meta.resolve("ivFN2");


var $ce3b702f01615a0a$exports = {};
$ce3b702f01615a0a$exports = import.meta.resolve("8g0Kj");


var $5d54a27ec7f2722e$exports = {};
$5d54a27ec7f2722e$exports = import.meta.resolve("2rRys");


var $f9d2a5dffbad4f4f$exports = {};
$f9d2a5dffbad4f4f$exports = import.meta.resolve("4inEx");


var $aa926dd0807e5d9c$exports = {};
$aa926dd0807e5d9c$exports = import.meta.resolve("8lHP5");


var $fd2372f297d26d47$exports = {};
$fd2372f297d26d47$exports = import.meta.resolve("4YdBx");


var $4e43fba1b7628755$exports = {};
$4e43fba1b7628755$exports = import.meta.resolve("9crH4");


var $8528355ec5f89ab1$exports = {};
$8528355ec5f89ab1$exports = import.meta.resolve("l7wSX");


var $bc1ab456136cf023$exports = {};
$bc1ab456136cf023$exports = import.meta.resolve("7hlNs");


var $31e9b10790a795db$exports = {};
$31e9b10790a795db$exports = import.meta.resolve("2E4J7");


var $f33437047575c439$exports = {};
$f33437047575c439$exports = import.meta.resolve("fmA9D");


var $c4b2c26d95811bfd$exports = {};
$c4b2c26d95811bfd$exports = import.meta.resolve("1Zmv1");


var $36c0524d02260298$exports = {};
$36c0524d02260298$exports = import.meta.resolve("2Ycsb");


var $0d9d88ca43f84749$exports = {};
$0d9d88ca43f84749$exports = import.meta.resolve("1jsAR");


var $7422c48c5822fcc8$exports = {};
$7422c48c5822fcc8$exports = import.meta.resolve("jZ1ud");


var $cdc8aee02df4cc08$exports = {};
$cdc8aee02df4cc08$exports = import.meta.resolve("WDBaR");


var $c14697fe9fdf0956$exports = {};
$c14697fe9fdf0956$exports = import.meta.resolve("ZnvIH");


const $f027138e99f6a81d$export$e5ec2dcb9331ab23 = {
    "battle-exchange": [
        new URL($5fb60cf8ebea31f5$exports).href,
        new URL($5a9cce4bd58f9ed9$exports).href,
        new URL($445388d46b34412a$exports).href,
        new URL($ce3b702f01615a0a$exports).href
    ],
    "battle-blitz": [
        new URL($5d54a27ec7f2722e$exports).href
    ],
    "conquest": [
        new URL($f9d2a5dffbad4f4f$exports).href
    ],
    "pull-back": [
        new URL($aa926dd0807e5d9c$exports).href
    ],
    "elimination": [
        new URL($fd2372f297d26d47$exports).href
    ],
    "reinforce-place": [
        new URL($4e43fba1b7628755$exports).href
    ],
    "card-draw": [
        new URL($8528355ec5f89ab1$exports).href
    ],
    "card-trade": [
        new URL($bc1ab456136cf023$exports).href
    ],
    "fortify": [
        new URL($31e9b10790a795db$exports).href
    ],
    "embark": [
        new URL($f33437047575c439$exports).href
    ],
    "your-turn": [
        new URL($c4b2c26d95811bfd$exports).href
    ],
    "decision-card": [
        new URL($36c0524d02260298$exports).href
    ],
    "landings": [
        new URL($0d9d88ca43f84749$exports).href
    ],
    "select": [
        new URL($7422c48c5822fcc8$exports).href
    ],
    "ui-click": [
        new URL($cdc8aee02df4cc08$exports).href
    ],
    "game-start": [
        new URL($c14697fe9fdf0956$exports).href
    ]
};


// Each cue maps to a base asset id. A cue can ship several interchangeable takes
// — game-start.mp3, game-start-2.mp3, game-start-3.mp3 — and one is chosen at
// random on every play so repeated triggers don't sound canned.
const $ae4c9b4b24a86223$var$CUES = {
    gameStart: 'game-start',
    yourTurn: 'your-turn',
    reinforcePlace: 'reinforce-place',
    select: 'select',
    uiClick: 'ui-click',
    cardDraw: 'card-draw',
    cardTrade: 'card-trade',
    decisionCard: 'decision-card',
    battleExchange: 'battle-exchange',
    battleBlitz: 'battle-blitz',
    conquest: 'conquest',
    fortify: 'fortify',
    embark: 'embark',
    landings: 'landings',
    pullBack: 'pull-back',
    elimination: 'elimination'
};
// The live takes for one cue, in play order, as promoted by the sound admin.
const $ae4c9b4b24a86223$var$takesFor = (id)=>(0, $f027138e99f6a81d$export$e5ec2dcb9331ab23)[id] ?? [];
const $ae4c9b4b24a86223$var$DEFAULT_VOLUME = 0.6;
const $ae4c9b4b24a86223$var$STORAGE_KEY = 'independence.sfx';
const $ae4c9b4b24a86223$var$VOLUME_KEY = 'independence.sfxVolume';
// The slider value is a 0..1 loudness *fraction*, not raw gain. Ears hear
// loudness roughly logarithmically, so a linear slider feels loud almost
// immediately. Mapping through a perceptual taper (fraction^1.5) makes low
// settings genuinely quiet the way Spotify's slider does — the clips are
// peak-normalized to 0 dBFS, so the 60% default lands near -7 dBFS: present
// without overpowering the music, while low settings stay soft but audible.
const $ae4c9b4b24a86223$var$gainFor = (fraction)=>fraction * Math.sqrt(fraction);
// Length of the ramp-to-silence applied at each clip's tail. Long enough to
// smooth an abrupt final sample into silence, short enough to be inaudible.
const $ae4c9b4b24a86223$var$TAIL_FADE = 0.012;
const $ae4c9b4b24a86223$var$readPref = ()=>{
    try {
        return localStorage.getItem($ae4c9b4b24a86223$var$STORAGE_KEY) !== 'off';
    } catch  {
        return true;
    }
};
const $ae4c9b4b24a86223$var$readVolume = ()=>{
    try {
        const raw = localStorage.getItem($ae4c9b4b24a86223$var$VOLUME_KEY);
        const parsed = raw === null ? NaN : Number(raw);
        return parsed >= 0 && parsed <= 1 ? parsed : $ae4c9b4b24a86223$var$DEFAULT_VOLUME;
    } catch  {
        return $ae4c9b4b24a86223$var$DEFAULT_VOLUME;
    }
};
let $ae4c9b4b24a86223$var$enabled = $ae4c9b4b24a86223$var$readPref();
let $ae4c9b4b24a86223$var$volume = $ae4c9b4b24a86223$var$readVolume();
let $ae4c9b4b24a86223$var$ctx = null;
let $ae4c9b4b24a86223$var$master = null;
const $ae4c9b4b24a86223$var$buffers = new Map();
const $ae4c9b4b24a86223$export$b2e9fbdd9ded6db3 = ()=>$ae4c9b4b24a86223$var$enabled;
const $ae4c9b4b24a86223$export$a5912a2438426e42 = (on)=>{
    $ae4c9b4b24a86223$var$enabled = on;
    try {
        localStorage.setItem($ae4c9b4b24a86223$var$STORAGE_KEY, on ? 'on' : 'off');
    } catch  {}
};
const $ae4c9b4b24a86223$export$53d47d6e5fab65a1 = ()=>$ae4c9b4b24a86223$var$volume;
const $ae4c9b4b24a86223$export$6d762aca21a0d7bf = (level)=>{
    $ae4c9b4b24a86223$var$volume = Math.min(1, Math.max(0, level));
    try {
        localStorage.setItem($ae4c9b4b24a86223$var$VOLUME_KEY, String($ae4c9b4b24a86223$var$volume));
    } catch  {}
    if ($ae4c9b4b24a86223$var$master) $ae4c9b4b24a86223$var$master.gain.value = $ae4c9b4b24a86223$var$gainFor($ae4c9b4b24a86223$var$volume);
};
// Autoplay policy parks a freshly created context in "suspended" until a user
// gesture; resume() is a no-op once it's running, so it's cheap to call often.
const $ae4c9b4b24a86223$var$resume = ()=>{
    if ($ae4c9b4b24a86223$var$ctx && $ae4c9b4b24a86223$var$ctx.state === 'suspended') $ae4c9b4b24a86223$var$ctx.resume().catch(()=>{});
};
const $ae4c9b4b24a86223$export$3d7e390f2650e949 = ()=>{
    if ($ae4c9b4b24a86223$var$ctx) return;
    const Ctor = window.AudioContext ?? window.webkitAudioContext;
    if (!Ctor) return;
    // A locked-down browser (or one out of hardware audio contexts) can throw on
    // construction — degrade to silence rather than take the caller down with us.
    try {
        $ae4c9b4b24a86223$var$ctx = new Ctor();
        $ae4c9b4b24a86223$var$master = $ae4c9b4b24a86223$var$ctx.createGain();
        $ae4c9b4b24a86223$var$master.gain.value = $ae4c9b4b24a86223$var$gainFor($ae4c9b4b24a86223$var$volume);
        $ae4c9b4b24a86223$var$master.connect($ae4c9b4b24a86223$var$ctx.destination);
    } catch (error) {
        console.warn('[sounds] audio engine unavailable', error);
        $ae4c9b4b24a86223$var$ctx = null;
        $ae4c9b4b24a86223$var$master = null;
        return;
    }
    // A pointer gesture is what unlocks the context on most browsers.
    document.addEventListener('pointerdown', $ae4c9b4b24a86223$var$resume, {
        capture: true
    });
    for (const name of Object.keys($ae4c9b4b24a86223$var$CUES)){
        // Push each take in as it decodes, so one bad clip can't sink the whole cue
        // and the first playable take is available as early as possible.
        const decoded = [];
        $ae4c9b4b24a86223$var$buffers.set(name, decoded);
        for (const href of $ae4c9b4b24a86223$var$takesFor($ae4c9b4b24a86223$var$CUES[name]))fetch(href).then((response)=>response.arrayBuffer()).then((data)=>$ae4c9b4b24a86223$var$ctx.decodeAudioData(data)).then((buffer)=>decoded.push(buffer)).catch(()=>{});
    }
};
const $ae4c9b4b24a86223$export$80cb197f7ea4fe13 = (name)=>{
    if (!$ae4c9b4b24a86223$var$enabled || !$ae4c9b4b24a86223$var$ctx || !$ae4c9b4b24a86223$var$master) return;
    const takes = $ae4c9b4b24a86223$var$buffers.get(name);
    if (!takes || takes.length === 0) return;
    // Pick a random take so repeated triggers vary.
    const buffer = takes[Math.random() * takes.length | 0];
    $ae4c9b4b24a86223$var$resume();
    const start = $ae4c9b4b24a86223$var$ctx.currentTime;
    const end = start + buffer.duration;
    const source = $ae4c9b4b24a86223$var$ctx.createBufferSource();
    source.buffer = buffer;
    // A per-voice gain lets clips overlap without touching each other and carries
    // the tail ramp that lands every clip on exact silence.
    const gain = $ae4c9b4b24a86223$var$ctx.createGain();
    const fadeAt = Math.max(start, end - $ae4c9b4b24a86223$var$TAIL_FADE);
    gain.gain.setValueAtTime(1, start);
    gain.gain.setValueAtTime(1, fadeAt);
    gain.gain.linearRampToValueAtTime(0, end);
    source.connect(gain).connect($ae4c9b4b24a86223$var$master);
    source.start(start);
    source.stop(end);
    // Let the node graph be collected once it has finished.
    source.onended = ()=>{
        source.disconnect();
        gain.disconnect();
    };
};


const $0e85057378cd98c0$var$LANGS = [
    'en',
    'tr'
];
/**
 * The campaign opens on the map before it becomes a board: one quiet moment
 * to establish the date, the land and the stakes before the HUD appears.
 */ const $0e85057378cd98c0$var$IntroScreen = ({ onStart: onStart, onBegin: onBegin, mapReady: mapReady })=>{
    const [leaving, setLeaving] = (0, $acw62.useState)(false);
    const [preparing, setPreparing] = (0, $acw62.useState)(false);
    const [music, setMusic] = (0, $acw62.useState)(()=>(0, $a02a16ce6e0bc642$export$2f52891e98fc2f65)());
    const beginButton = (0, $acw62.useRef)(null);
    const transitionStarted = (0, $acw62.useRef)(false);
    // Synchronous re-entry guard: the `disabled` attribute only lands on the next
    // render, so a fast second click would otherwise slip through before then.
    const begun = (0, $acw62.useRef)(false);
    const lang = (0, $6c154842fccf6556$export$dec8f99c0c14e178)();
    (0, $acw62.useEffect)(()=>{
        beginButton.current?.focus({
            preventScroll: true
        });
        // Warm the sound engine now, while the intro is on screen — the game isn't
        // mounted yet, so without this the intro's own controls (Begin, language,
        // music) would have no audio and the opening fanfare would miss its cue.
        (0, $ae4c9b4b24a86223$export$3d7e390f2650e949)();
    }, []);
    (0, $acw62.useEffect)(()=>{
        if (!preparing || !mapReady || transitionStarted.current) return;
        transitionStarted.current = true;
        setLeaving(true);
        // The campaign fanfare, as the intro dissolves into the board.
        (0, $ae4c9b4b24a86223$export$80cb197f7ea4fe13)('gameStart');
        const timer = window.setTimeout(onBegin, 520);
        return ()=>window.clearTimeout(timer);
    }, [
        preparing,
        mapReady,
        onBegin
    ]);
    const begin = ()=>{
        if (begun.current) return;
        begun.current = true;
        (0, $ae4c9b4b24a86223$export$80cb197f7ea4fe13)('uiClick');
        setPreparing(true);
        // Mounting the game is heavy enough to lock the main thread, so defer it
        // until the browser has actually painted the transparent "LOADING" state.
        // A single rAF still runs before paint; the nested rAF fires on the frame
        // after, once the loading style is on screen.
        requestAnimationFrame(()=>requestAnimationFrame(onStart));
    };
    const toggleMusic = ()=>{
        (0, $a02a16ce6e0bc642$export$6df7d8ca8e8b46f5)(!music);
        setMusic(!music);
    };
    const keepFocusInside = (event)=>{
        if (event.key !== 'Tab') return;
        const controls = Array.from(event.currentTarget.querySelectorAll('button:not(:disabled)'));
        if (controls.length === 0) return;
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: `intro-screen intro-baked${leaving ? ' leaving' : ''}`,
        "data-lang": lang,
        role: "dialog",
        "aria-modal": "true",
        "aria-labelledby": "intro-title",
        onKeyDown: keepFocusInside,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "opening-scene-background",
                "data-lang": lang,
                "aria-hidden": "true"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("nav", {
                className: "intro-languages",
                "aria-label": (0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.language'),
                children: $0e85057378cd98c0$var$LANGS.map((code)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: lang === code ? 'active' : '',
                        onClick: ()=>(0, $6c154842fccf6556$export$a3665b844fbc095d)(code),
                        "aria-pressed": lang === code,
                        children: code.toLocaleUpperCase(code)
                    }, code))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "intro-content",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "intro-copy",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "intro-date",
                                children: (0, $6c154842fccf6556$export$625550452a3fa3ec)('intro.date')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                                id: "intro-title",
                                children: (0, $6c154842fccf6556$export$625550452a3fa3ec)('brand.title')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                className: "intro-mark",
                                "aria-hidden": "true",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {}),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                        children: "\u2605"
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {})
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "intro-subtitle",
                                children: (0, $6c154842fccf6556$export$625550452a3fa3ec)('intro.subtitle')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "intro-actions",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                ref: beginButton,
                                className: "intro-begin",
                                onClick: begin,
                                disabled: preparing || leaving,
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: preparing || leaving ? (0, $6c154842fccf6556$export$625550452a3fa3ec)('intro.loading') : (0, $6c154842fccf6556$export$625550452a3fa3ec)('intro.begin')
                                    }),
                                    preparing || leaving ? null : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                        "aria-hidden": "true",
                                        children: "\u2192"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "intro-caption",
                                children: (0, $6c154842fccf6556$export$625550452a3fa3ec)('intro.caption')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: `intro-sound${music ? '' : ' muted'}`,
                onClick: toggleMusic,
                "aria-label": music ? (0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.musicOff') : (0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.musicOn'),
                "aria-pressed": music,
                title: music ? (0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.musicOff') : (0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.musicOn'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                    viewBox: "0 0 24 24",
                    width: "20",
                    height: "20",
                    fill: "none",
                    stroke: "currentColor",
                    strokeWidth: "1.6",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: "M9 18V5l12-2v13"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                            cx: "6",
                            cy: "18",
                            r: "3"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                            cx: "18",
                            cy: "16",
                            r: "3"
                        }),
                        !music && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("line", {
                            x1: "2.5",
                            y1: "2.5",
                            x2: "21.5",
                            y2: "21.5"
                        })
                    ]
                })
            })
        ]
    });
};
var $0e85057378cd98c0$export$2e2bcd8739ae039 = $0e85057378cd98c0$var$IntroScreen;




var $acw62 = parcelRequire("acw62");

var $6e0489fffd2d2588$exports = {};
/*******************************************************************************
 *                                                                              *
 * Author    :  Angus Johnson                                                   *
 * Version   :  6.4.2                                                           *
 * Date      :  27 February 2017                                                *
 * Website   :  http://www.angusj.com                                           *
 * Copyright :  Angus Johnson 2010-2017                                         *
 *                                                                              *
 * License:                                                                     *
 * Use, modification & distribution is subject to Boost Software License Ver 1. *
 * http://www.boost.org/LICENSE_1_0.txt                                         *
 *                                                                              *
 * Attributions:                                                                *
 * The code in this library is an extension of Bala Vatti's clipping algorithm: *
 * "A generic solution to polygon clipping"                                     *
 * Communications of the ACM, Vol 35, Issue 7 (July 1992) pp 56-63.             *
 * http://portal.acm.org/citation.cfm?id=129906                                 *
 *                                                                              *
 * Computer graphics and geometric modeling: implementation and algorithms      *
 * By Max K. Agoston                                                            *
 * Springer; 1 edition (January 4, 2005)                                        *
 * http://books.google.com/books?q=vatti+clipping+agoston                       *
 *                                                                              *
 * See also:                                                                    *
 * "Polygon Offsetting by Computing Winding Numbers"                            *
 * Paper no. DETC2005-85513 pp. 565-575                                         *
 * ASME 2005 International Design Engineering Technical Conferences             *
 * and Computers and Information in Engineering Conference (IDETC/CIE2005)      *
 * September 24-28, 2005 , Long Beach, California, USA                          *
 * http://www.me.berkeley.edu/~mcmains/pubs/DAC05OffsetPolygon.pdf              *
 *                                                                              *
 *******************************************************************************/ /*******************************************************************************
 *                                                                              *
 * Author    :  Timo                                                            *
 * Version   :  6.4.2.2                                                         *
 * Date      :  8 September 2017                                                 *
 *                                                                              *
 * This is a translation of the C# Clipper library to Javascript.               *
 * Int128 struct of C# is implemented using JSBN of Tom Wu.                     *
 * Because Javascript lacks support for 64-bit integers, the space              *
 * is a little more restricted than in C# version.                              *
 *                                                                              *
 * C# version has support for coordinate space:                                 *
 * +-4611686018427387903 ( sqrt(2^127 -1)/2 )                                   *
 * while Javascript version has support for space:                              *
 * +-4503599627370495 ( sqrt(2^106 -1)/2 )                                      *
 *                                                                              *
 * Tom Wu's JSBN proved to be the fastest big integer library:                  *
 * http://jsperf.com/big-integer-library-test                                   *
 *                                                                              *
 * This class can be made simpler when (if ever) 64-bit integer support comes   *
 * or floating point Clipper is released.                                       *
 *                                                                              *
 *******************************************************************************/ /*******************************************************************************
 *                                                                              *
 * Basic JavaScript BN library - subset useful for RSA encryption.              *
 * http://www-cs-students.stanford.edu/~tjw/jsbn/                               *
 * Copyright (c) 2005  Tom Wu                                                   *
 * All Rights Reserved.                                                         *
 * See "LICENSE" for details:                                                   *
 * http://www-cs-students.stanford.edu/~tjw/jsbn/LICENSE                        *
 *                                                                              *
 *******************************************************************************/ (function() {
    "use strict";
    var ClipperLib = {};
    ClipperLib.version = '6.4.2.2';
    //UseLines: Enables open path clipping. Adds a very minor cost to performance.
    ClipperLib.use_lines = true;
    //ClipperLib.use_xyz: adds a Z member to IntPoint. Adds a minor cost to performance.
    ClipperLib.use_xyz = false;
    var isNode = false;
    if ($6e0489fffd2d2588$exports) {
        $6e0489fffd2d2588$exports = ClipperLib;
        isNode = true;
    } else {
        if (typeof define === 'function' && define.amd) define(ClipperLib);
        if (typeof document !== "undefined") window.ClipperLib = ClipperLib;
        else self['ClipperLib'] = ClipperLib;
    }
    var navigator_appName;
    if (!isNode) {
        var nav = navigator.userAgent.toString().toLowerCase();
        navigator_appName = navigator.appName;
    } else {
        var nav = "chrome"; // Node.js uses Chrome's V8 engine
        navigator_appName = "Netscape"; // Firefox, Chrome and Safari returns "Netscape", so Node.js should also
    }
    // Browser test to speedup performance critical functions
    var browser = {};
    if (nav.indexOf("chrome") != -1 && nav.indexOf("chromium") == -1) browser.chrome = 1;
    else browser.chrome = 0;
    if (nav.indexOf("chromium") != -1) browser.chromium = 1;
    else browser.chromium = 0;
    if (nav.indexOf("safari") != -1 && nav.indexOf("chrome") == -1 && nav.indexOf("chromium") == -1) browser.safari = 1;
    else browser.safari = 0;
    if (nav.indexOf("firefox") != -1) browser.firefox = 1;
    else browser.firefox = 0;
    if (nav.indexOf("firefox/17") != -1) browser.firefox17 = 1;
    else browser.firefox17 = 0;
    if (nav.indexOf("firefox/15") != -1) browser.firefox15 = 1;
    else browser.firefox15 = 0;
    if (nav.indexOf("firefox/3") != -1) browser.firefox3 = 1;
    else browser.firefox3 = 0;
    if (nav.indexOf("opera") != -1) browser.opera = 1;
    else browser.opera = 0;
    if (nav.indexOf("msie 10") != -1) browser.msie10 = 1;
    else browser.msie10 = 0;
    if (nav.indexOf("msie 9") != -1) browser.msie9 = 1;
    else browser.msie9 = 0;
    if (nav.indexOf("msie 8") != -1) browser.msie8 = 1;
    else browser.msie8 = 0;
    if (nav.indexOf("msie 7") != -1) browser.msie7 = 1;
    else browser.msie7 = 0;
    if (nav.indexOf("msie ") != -1) browser.msie = 1;
    else browser.msie = 0;
    ClipperLib.biginteger_used = null;
    // Copyright (c) 2005  Tom Wu
    // All Rights Reserved.
    // See "LICENSE" for details.
    // Basic JavaScript BN library - subset useful for RSA encryption.
    // Bits per digit
    var dbits;
    // JavaScript engine analysis
    var canary = 0xdeadbeefcafe;
    var j_lm = (canary & 0xffffff) == 0xefcafe;
    // (public) Constructor
    /**
	* @constructor
	*/ function BigInteger(a, b, c) {
        // This test variable can be removed,
        // but at least for performance tests it is useful piece of knowledge
        // This is the only ClipperLib related variable in BigInteger library
        ClipperLib.biginteger_used = 1;
        if (a != null) {
            if ("number" == typeof a && "undefined" == typeof b) this.fromInt(a); // faster conversion
            else if ("number" == typeof a) this.fromNumber(a, b, c);
            else if (b == null && "string" != typeof a) this.fromString(a, 256);
            else this.fromString(a, b);
        }
    }
    // return new, unset BigInteger
    function nbi() {
        return new BigInteger(null, undefined, undefined);
    }
    // am: Compute w_j += (x*this_i), propagate carries,
    // c is initial carry, returns final carry.
    // c < 3*dvalue, x < 2*dvalue, this_i < dvalue
    // We need to select the fastest one that works in this environment.
    // am1: use a single mult and divide to get the high bits,
    // max digit bits should be 26 because
    // max internal value = 2*dvalue^2-2*dvalue (< 2^53)
    function am1(i, x, w, j, c, n) {
        while(--n >= 0){
            var v = x * this[i++] + w[j] + c;
            c = Math.floor(v / 0x4000000);
            w[j++] = v & 0x3ffffff;
        }
        return c;
    }
    // am2 avoids a big mult-and-extract completely.
    // Max digit bits should be <= 30 because we do bitwise ops
    // on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
    function am2(i, x, w, j, c, n) {
        var xl = x & 0x7fff, xh = x >> 15;
        while(--n >= 0){
            var l = this[i] & 0x7fff;
            var h = this[i++] >> 15;
            var m = xh * l + h * xl;
            l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
            c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
            w[j++] = l & 0x3fffffff;
        }
        return c;
    }
    // Alternately, set max digit bits to 28 since some
    // browsers slow down when dealing with 32-bit numbers.
    function am3(i, x, w, j, c, n) {
        var xl = x & 0x3fff, xh = x >> 14;
        while(--n >= 0){
            var l = this[i] & 0x3fff;
            var h = this[i++] >> 14;
            var m = xh * l + h * xl;
            l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
            c = (l >> 28) + (m >> 14) + xh * h;
            w[j++] = l & 0xfffffff;
        }
        return c;
    }
    if (j_lm && navigator_appName == "Microsoft Internet Explorer") {
        BigInteger.prototype.am = am2;
        dbits = 30;
    } else if (j_lm && navigator_appName != "Netscape") {
        BigInteger.prototype.am = am1;
        dbits = 26;
    } else {
        BigInteger.prototype.am = am3;
        dbits = 28;
    }
    BigInteger.prototype.DB = dbits;
    BigInteger.prototype.DM = (1 << dbits) - 1;
    BigInteger.prototype.DV = 1 << dbits;
    var BI_FP = 52;
    BigInteger.prototype.FV = Math.pow(2, BI_FP);
    BigInteger.prototype.F1 = BI_FP - dbits;
    BigInteger.prototype.F2 = 2 * dbits - BI_FP;
    // Digit conversions
    var BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
    var BI_RC = new Array();
    var rr, vv;
    rr = "0".charCodeAt(0);
    for(vv = 0; vv <= 9; ++vv)BI_RC[rr++] = vv;
    rr = "a".charCodeAt(0);
    for(vv = 10; vv < 36; ++vv)BI_RC[rr++] = vv;
    rr = "A".charCodeAt(0);
    for(vv = 10; vv < 36; ++vv)BI_RC[rr++] = vv;
    function int2char(n) {
        return BI_RM.charAt(n);
    }
    function intAt(s, i) {
        var c = BI_RC[s.charCodeAt(i)];
        return c == null ? -1 : c;
    }
    // (protected) copy this to r
    function bnpCopyTo(r) {
        for(var i = this.t - 1; i >= 0; --i)r[i] = this[i];
        r.t = this.t;
        r.s = this.s;
    }
    // (protected) set from integer value x, -DV <= x < DV
    function bnpFromInt(x) {
        this.t = 1;
        this.s = x < 0 ? -1 : 0;
        if (x > 0) this[0] = x;
        else if (x < -1) this[0] = x + this.DV;
        else this.t = 0;
    }
    // return bigint initialized to value
    function nbv(i) {
        var r = nbi();
        r.fromInt(i);
        return r;
    }
    // (protected) set from string and radix
    function bnpFromString(s, b) {
        var k;
        if (b == 16) k = 4;
        else if (b == 8) k = 3;
        else if (b == 256) k = 8; // byte array
        else if (b == 2) k = 1;
        else if (b == 32) k = 5;
        else if (b == 4) k = 2;
        else {
            this.fromRadix(s, b);
            return;
        }
        this.t = 0;
        this.s = 0;
        var i = s.length, mi = false, sh = 0;
        while(--i >= 0){
            var x = k == 8 ? s[i] & 0xff : intAt(s, i);
            if (x < 0) {
                if (s.charAt(i) == "-") mi = true;
                continue;
            }
            mi = false;
            if (sh == 0) this[this.t++] = x;
            else if (sh + k > this.DB) {
                this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
                this[this.t++] = x >> this.DB - sh;
            } else this[this.t - 1] |= x << sh;
            sh += k;
            if (sh >= this.DB) sh -= this.DB;
        }
        if (k == 8 && (s[0] & 0x80) != 0) {
            this.s = -1;
            if (sh > 0) this[this.t - 1] |= (1 << this.DB - sh) - 1 << sh;
        }
        this.clamp();
        if (mi) BigInteger.ZERO.subTo(this, this);
    }
    // (protected) clamp off excess high words
    function bnpClamp() {
        var c = this.s & this.DM;
        while(this.t > 0 && this[this.t - 1] == c)--this.t;
    }
    // (public) return string representation in given radix
    function bnToString(b) {
        if (this.s < 0) return "-" + this.negate().toString(b);
        var k;
        if (b == 16) k = 4;
        else if (b == 8) k = 3;
        else if (b == 2) k = 1;
        else if (b == 32) k = 5;
        else if (b == 4) k = 2;
        else return this.toRadix(b);
        var km = (1 << k) - 1, d, m = false, r = "", i = this.t;
        var p = this.DB - i * this.DB % k;
        if (i-- > 0) {
            if (p < this.DB && (d = this[i] >> p) > 0) {
                m = true;
                r = int2char(d);
            }
            while(i >= 0){
                if (p < k) {
                    d = (this[i] & (1 << p) - 1) << k - p;
                    d |= this[--i] >> (p += this.DB - k);
                } else {
                    d = this[i] >> (p -= k) & km;
                    if (p <= 0) {
                        p += this.DB;
                        --i;
                    }
                }
                if (d > 0) m = true;
                if (m) r += int2char(d);
            }
        }
        return m ? r : "0";
    }
    // (public) -this
    function bnNegate() {
        var r = nbi();
        BigInteger.ZERO.subTo(this, r);
        return r;
    }
    // (public) |this|
    function bnAbs() {
        return this.s < 0 ? this.negate() : this;
    }
    // (public) return + if this > a, - if this < a, 0 if equal
    function bnCompareTo(a) {
        var r = this.s - a.s;
        if (r != 0) return r;
        var i = this.t;
        r = i - a.t;
        if (r != 0) return this.s < 0 ? -r : r;
        while(--i >= 0)if ((r = this[i] - a[i]) != 0) return r;
        return 0;
    }
    // returns bit length of the integer x
    function nbits(x) {
        var r = 1, t;
        if ((t = x >>> 16) != 0) {
            x = t;
            r += 16;
        }
        if ((t = x >> 8) != 0) {
            x = t;
            r += 8;
        }
        if ((t = x >> 4) != 0) {
            x = t;
            r += 4;
        }
        if ((t = x >> 2) != 0) {
            x = t;
            r += 2;
        }
        if ((t = x >> 1) != 0) {
            x = t;
            r += 1;
        }
        return r;
    }
    // (public) return the number of bits in "this"
    function bnBitLength() {
        if (this.t <= 0) return 0;
        return this.DB * (this.t - 1) + nbits(this[this.t - 1] ^ this.s & this.DM);
    }
    // (protected) r = this << n*DB
    function bnpDLShiftTo(n, r) {
        var i;
        for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
        for(i = n - 1; i >= 0; --i)r[i] = 0;
        r.t = this.t + n;
        r.s = this.s;
    }
    // (protected) r = this >> n*DB
    function bnpDRShiftTo(n, r) {
        for(var i = n; i < this.t; ++i)r[i - n] = this[i];
        r.t = Math.max(this.t - n, 0);
        r.s = this.s;
    }
    // (protected) r = this << n
    function bnpLShiftTo(n, r) {
        var bs = n % this.DB;
        var cbs = this.DB - bs;
        var bm = (1 << cbs) - 1;
        var ds = Math.floor(n / this.DB), c = this.s << bs & this.DM, i;
        for(i = this.t - 1; i >= 0; --i){
            r[i + ds + 1] = this[i] >> cbs | c;
            c = (this[i] & bm) << bs;
        }
        for(i = ds - 1; i >= 0; --i)r[i] = 0;
        r[ds] = c;
        r.t = this.t + ds + 1;
        r.s = this.s;
        r.clamp();
    }
    // (protected) r = this >> n
    function bnpRShiftTo(n, r) {
        r.s = this.s;
        var ds = Math.floor(n / this.DB);
        if (ds >= this.t) {
            r.t = 0;
            return;
        }
        var bs = n % this.DB;
        var cbs = this.DB - bs;
        var bm = (1 << bs) - 1;
        r[0] = this[ds] >> bs;
        for(var i = ds + 1; i < this.t; ++i){
            r[i - ds - 1] |= (this[i] & bm) << cbs;
            r[i - ds] = this[i] >> bs;
        }
        if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
        r.t = this.t - ds;
        r.clamp();
    }
    // (protected) r = this - a
    function bnpSubTo(a, r) {
        var i = 0, c = 0, m = Math.min(a.t, this.t);
        while(i < m){
            c += this[i] - a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        if (a.t < this.t) {
            c -= a.s;
            while(i < this.t){
                c += this[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c += this.s;
        } else {
            c += this.s;
            while(i < a.t){
                c -= a[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c -= a.s;
        }
        r.s = c < 0 ? -1 : 0;
        if (c < -1) r[i++] = this.DV + c;
        else if (c > 0) r[i++] = c;
        r.t = i;
        r.clamp();
    }
    // (protected) r = this * a, r != this,a (HAC 14.12)
    // "this" should be the larger one if appropriate.
    function bnpMultiplyTo(a, r) {
        var x = this.abs(), y = a.abs();
        var i = x.t;
        r.t = i + y.t;
        while(--i >= 0)r[i] = 0;
        for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
        r.s = 0;
        r.clamp();
        if (this.s != a.s) BigInteger.ZERO.subTo(r, r);
    }
    // (protected) r = this^2, r != this (HAC 14.16)
    function bnpSquareTo(r) {
        var x = this.abs();
        var i = r.t = 2 * x.t;
        while(--i >= 0)r[i] = 0;
        for(i = 0; i < x.t - 1; ++i){
            var c = x.am(i, x[i], r, 2 * i, 0, 1);
            if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
                r[i + x.t] -= x.DV;
                r[i + x.t + 1] = 1;
            }
        }
        if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
        r.s = 0;
        r.clamp();
    }
    // (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
    // r != q, this != m.  q or r may be null.
    function bnpDivRemTo(m, q, r) {
        var pm = m.abs();
        if (pm.t <= 0) return;
        var pt = this.abs();
        if (pt.t < pm.t) {
            if (q != null) q.fromInt(0);
            if (r != null) this.copyTo(r);
            return;
        }
        if (r == null) r = nbi();
        var y = nbi(), ts = this.s, ms = m.s;
        var nsh = this.DB - nbits(pm[pm.t - 1]); // normalize modulus
        if (nsh > 0) {
            pm.lShiftTo(nsh, y);
            pt.lShiftTo(nsh, r);
        } else {
            pm.copyTo(y);
            pt.copyTo(r);
        }
        var ys = y.t;
        var y0 = y[ys - 1];
        if (y0 == 0) return;
        var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
        var d1 = this.FV / yt, d2 = (1 << this.F1) / yt, e = 1 << this.F2;
        var i = r.t, j = i - ys, t = q == null ? nbi() : q;
        y.dlShiftTo(j, t);
        if (r.compareTo(t) >= 0) {
            r[r.t++] = 1;
            r.subTo(t, r);
        }
        BigInteger.ONE.dlShiftTo(ys, t);
        t.subTo(y, y); // "negative" y so we can replace sub with am later
        while(y.t < ys)y[y.t++] = 0;
        while(--j >= 0){
            // Estimate quotient digit
            var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
            if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
                y.dlShiftTo(j, t);
                r.subTo(t, r);
                while(r[i] < --qd)r.subTo(t, r);
            }
        }
        if (q != null) {
            r.drShiftTo(ys, q);
            if (ts != ms) BigInteger.ZERO.subTo(q, q);
        }
        r.t = ys;
        r.clamp();
        if (nsh > 0) r.rShiftTo(nsh, r); // Denormalize remainder
        if (ts < 0) BigInteger.ZERO.subTo(r, r);
    }
    // (public) this mod a
    function bnMod(a) {
        var r = nbi();
        this.abs().divRemTo(a, null, r);
        if (this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r, r);
        return r;
    }
    // Modular reduction using "classic" algorithm
    /**
	* @constructor
	*/ function Classic(m) {
        this.m = m;
    }
    function cConvert(x) {
        if (x.s < 0 || x.compareTo(this.m) >= 0) return x.mod(this.m);
        else return x;
    }
    function cRevert(x) {
        return x;
    }
    function cReduce(x) {
        x.divRemTo(this.m, null, x);
    }
    function cMulTo(x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
    }
    function cSqrTo(x, r) {
        x.squareTo(r);
        this.reduce(r);
    }
    Classic.prototype.convert = cConvert;
    Classic.prototype.revert = cRevert;
    Classic.prototype.reduce = cReduce;
    Classic.prototype.mulTo = cMulTo;
    Classic.prototype.sqrTo = cSqrTo;
    // (protected) return "-1/this % 2^DB"; useful for Mont. reduction
    // justification:
    //         xy == 1 (mod m)
    //         xy =  1+km
    //   xy(2-xy) = (1+km)(1-km)
    // x[y(2-xy)] = 1-k^2m^2
    // x[y(2-xy)] == 1 (mod m^2)
    // if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
    // should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
    // JS multiply "overflows" differently from C/C++, so care is needed here.
    function bnpInvDigit() {
        if (this.t < 1) return 0;
        var x = this[0];
        if ((x & 1) == 0) return 0;
        var y = x & 3; // y == 1/x mod 2^2
        y = y * (2 - (x & 0xf) * y) & 0xf; // y == 1/x mod 2^4
        y = y * (2 - (x & 0xff) * y) & 0xff; // y == 1/x mod 2^8
        y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff; // y == 1/x mod 2^16
        // last step - calculate inverse mod DV directly;
        // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
        y = y * (2 - x * y % this.DV) % this.DV; // y == 1/x mod 2^dbits
        // we really want the negative inverse, and -DV < y < DV
        return y > 0 ? this.DV - y : -y;
    }
    // Montgomery reduction
    /**
	* @constructor
	*/ function Montgomery(m) {
        this.m = m;
        this.mp = m.invDigit();
        this.mpl = this.mp & 0x7fff;
        this.mph = this.mp >> 15;
        this.um = (1 << m.DB - 15) - 1;
        this.mt2 = 2 * m.t;
    }
    // xR mod m
    function montConvert(x) {
        var r = nbi();
        x.abs().dlShiftTo(this.m.t, r);
        r.divRemTo(this.m, null, r);
        if (x.s < 0 && r.compareTo(BigInteger.ZERO) > 0) this.m.subTo(r, r);
        return r;
    }
    // x/R mod m
    function montRevert(x) {
        var r = nbi();
        x.copyTo(r);
        this.reduce(r);
        return r;
    }
    // x = x/R mod m (HAC 14.32)
    function montReduce(x) {
        while(x.t <= this.mt2)x[x.t++] = 0;
        for(var i = 0; i < this.m.t; ++i){
            // faster way of calculating u0 = x[i]*mp mod DV
            var j = x[i] & 0x7fff;
            var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
            // use am to combine the multiply-shift-add into one call
            j = i + this.m.t;
            x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
            // propagate carry
            while(x[j] >= x.DV){
                x[j] -= x.DV;
                x[++j]++;
            }
        }
        x.clamp();
        x.drShiftTo(this.m.t, x);
        if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
    }
    // r = "x^2/R mod m"; x != r
    function montSqrTo(x, r) {
        x.squareTo(r);
        this.reduce(r);
    }
    // r = "xy/R mod m"; x,y != r
    function montMulTo(x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
    }
    Montgomery.prototype.convert = montConvert;
    Montgomery.prototype.revert = montRevert;
    Montgomery.prototype.reduce = montReduce;
    Montgomery.prototype.mulTo = montMulTo;
    Montgomery.prototype.sqrTo = montSqrTo;
    // (protected) true iff this is even
    function bnpIsEven() {
        return (this.t > 0 ? this[0] & 1 : this.s) == 0;
    }
    // (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)
    function bnpExp(e, z) {
        if (e > 0xffffffff || e < 1) return BigInteger.ONE;
        var r = nbi(), r2 = nbi(), g = z.convert(this), i = nbits(e) - 1;
        g.copyTo(r);
        while(--i >= 0){
            z.sqrTo(r, r2);
            if ((e & 1 << i) > 0) z.mulTo(r2, g, r);
            else {
                var t = r;
                r = r2;
                r2 = t;
            }
        }
        return z.revert(r);
    }
    // (public) this^e % m, 0 <= e < 2^32
    function bnModPowInt(e, m) {
        var z;
        if (e < 256 || m.isEven()) z = new Classic(m);
        else z = new Montgomery(m);
        return this.exp(e, z);
    }
    // protected
    BigInteger.prototype.copyTo = bnpCopyTo;
    BigInteger.prototype.fromInt = bnpFromInt;
    BigInteger.prototype.fromString = bnpFromString;
    BigInteger.prototype.clamp = bnpClamp;
    BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
    BigInteger.prototype.drShiftTo = bnpDRShiftTo;
    BigInteger.prototype.lShiftTo = bnpLShiftTo;
    BigInteger.prototype.rShiftTo = bnpRShiftTo;
    BigInteger.prototype.subTo = bnpSubTo;
    BigInteger.prototype.multiplyTo = bnpMultiplyTo;
    BigInteger.prototype.squareTo = bnpSquareTo;
    BigInteger.prototype.divRemTo = bnpDivRemTo;
    BigInteger.prototype.invDigit = bnpInvDigit;
    BigInteger.prototype.isEven = bnpIsEven;
    BigInteger.prototype.exp = bnpExp;
    // public
    BigInteger.prototype.toString = bnToString;
    BigInteger.prototype.negate = bnNegate;
    BigInteger.prototype.abs = bnAbs;
    BigInteger.prototype.compareTo = bnCompareTo;
    BigInteger.prototype.bitLength = bnBitLength;
    BigInteger.prototype.mod = bnMod;
    BigInteger.prototype.modPowInt = bnModPowInt;
    // "constants"
    BigInteger.ZERO = nbv(0);
    BigInteger.ONE = nbv(1);
    // Copyright (c) 2005-2009  Tom Wu
    // All Rights Reserved.
    // See "LICENSE" for details.
    // Extended JavaScript BN functions, required for RSA private ops.
    // Version 1.1: new BigInteger("0", 10) returns "proper" zero
    // Version 1.2: square() API, isProbablePrime fix
    // (public)
    function bnClone() {
        var r = nbi();
        this.copyTo(r);
        return r;
    }
    // (public) return value as integer
    function bnIntValue() {
        if (this.s < 0) {
            if (this.t == 1) return this[0] - this.DV;
            else if (this.t == 0) return -1;
        } else if (this.t == 1) return this[0];
        else if (this.t == 0) return 0;
        // assumes 16 < DB < 32
        return (this[1] & (1 << 32 - this.DB) - 1) << this.DB | this[0];
    }
    // (public) return value as byte
    function bnByteValue() {
        return this.t == 0 ? this.s : this[0] << 24 >> 24;
    }
    // (public) return value as short (assumes DB>=16)
    function bnShortValue() {
        return this.t == 0 ? this.s : this[0] << 16 >> 16;
    }
    // (protected) return x s.t. r^x < DV
    function bnpChunkSize(r) {
        return Math.floor(Math.LN2 * this.DB / Math.log(r));
    }
    // (public) 0 if this == 0, 1 if this > 0
    function bnSigNum() {
        if (this.s < 0) return -1;
        else if (this.t <= 0 || this.t == 1 && this[0] <= 0) return 0;
        else return 1;
    }
    // (protected) convert to radix string
    function bnpToRadix(b) {
        if (b == null) b = 10;
        if (this.signum() == 0 || b < 2 || b > 36) return "0";
        var cs = this.chunkSize(b);
        var a = Math.pow(b, cs);
        var d = nbv(a), y = nbi(), z = nbi(), r = "";
        this.divRemTo(d, y, z);
        while(y.signum() > 0){
            r = (a + z.intValue()).toString(b).substr(1) + r;
            y.divRemTo(d, y, z);
        }
        return z.intValue().toString(b) + r;
    }
    // (protected) convert from radix string
    function bnpFromRadix(s, b) {
        this.fromInt(0);
        if (b == null) b = 10;
        var cs = this.chunkSize(b);
        var d = Math.pow(b, cs), mi = false, j = 0, w = 0;
        for(var i = 0; i < s.length; ++i){
            var x = intAt(s, i);
            if (x < 0) {
                if (s.charAt(i) == "-" && this.signum() == 0) mi = true;
                continue;
            }
            w = b * w + x;
            if (++j >= cs) {
                this.dMultiply(d);
                this.dAddOffset(w, 0);
                j = 0;
                w = 0;
            }
        }
        if (j > 0) {
            this.dMultiply(Math.pow(b, j));
            this.dAddOffset(w, 0);
        }
        if (mi) BigInteger.ZERO.subTo(this, this);
    }
    // (protected) alternate constructor
    function bnpFromNumber(a, b, c) {
        if ("number" == typeof b) {
            // new BigInteger(int,int,RNG)
            if (a < 2) this.fromInt(1);
            else {
                this.fromNumber(a, c);
                if (!this.testBit(a - 1)) this.bitwiseTo(BigInteger.ONE.shiftLeft(a - 1), op_or, this);
                if (this.isEven()) this.dAddOffset(1, 0); // force odd
                while(!this.isProbablePrime(b)){
                    this.dAddOffset(2, 0);
                    if (this.bitLength() > a) this.subTo(BigInteger.ONE.shiftLeft(a - 1), this);
                }
            }
        } else {
            // new BigInteger(int,RNG)
            var x = new Array(), t = a & 7;
            x.length = (a >> 3) + 1;
            b.nextBytes(x);
            if (t > 0) x[0] &= (1 << t) - 1;
            else x[0] = 0;
            this.fromString(x, 256);
        }
    }
    // (public) convert to bigendian byte array
    function bnToByteArray() {
        var i = this.t, r = new Array();
        r[0] = this.s;
        var p = this.DB - i * this.DB % 8, d, k = 0;
        if (i-- > 0) {
            if (p < this.DB && (d = this[i] >> p) != (this.s & this.DM) >> p) r[k++] = d | this.s << this.DB - p;
            while(i >= 0){
                if (p < 8) {
                    d = (this[i] & (1 << p) - 1) << 8 - p;
                    d |= this[--i] >> (p += this.DB - 8);
                } else {
                    d = this[i] >> (p -= 8) & 0xff;
                    if (p <= 0) {
                        p += this.DB;
                        --i;
                    }
                }
                if ((d & 0x80) != 0) d |= -256;
                if (k == 0 && (this.s & 0x80) != (d & 0x80)) ++k;
                if (k > 0 || d != this.s) r[k++] = d;
            }
        }
        return r;
    }
    function bnEquals(a) {
        return this.compareTo(a) == 0;
    }
    function bnMin(a) {
        return this.compareTo(a) < 0 ? this : a;
    }
    function bnMax(a) {
        return this.compareTo(a) > 0 ? this : a;
    }
    // (protected) r = this op a (bitwise)
    function bnpBitwiseTo(a, op, r) {
        var i, f, m = Math.min(a.t, this.t);
        for(i = 0; i < m; ++i)r[i] = op(this[i], a[i]);
        if (a.t < this.t) {
            f = a.s & this.DM;
            for(i = m; i < this.t; ++i)r[i] = op(this[i], f);
            r.t = this.t;
        } else {
            f = this.s & this.DM;
            for(i = m; i < a.t; ++i)r[i] = op(f, a[i]);
            r.t = a.t;
        }
        r.s = op(this.s, a.s);
        r.clamp();
    }
    // (public) this & a
    function op_and(x, y) {
        return x & y;
    }
    function bnAnd(a) {
        var r = nbi();
        this.bitwiseTo(a, op_and, r);
        return r;
    }
    // (public) this | a
    function op_or(x, y) {
        return x | y;
    }
    function bnOr(a) {
        var r = nbi();
        this.bitwiseTo(a, op_or, r);
        return r;
    }
    // (public) this ^ a
    function op_xor(x, y) {
        return x ^ y;
    }
    function bnXor(a) {
        var r = nbi();
        this.bitwiseTo(a, op_xor, r);
        return r;
    }
    // (public) this & ~a
    function op_andnot(x, y) {
        return x & ~y;
    }
    function bnAndNot(a) {
        var r = nbi();
        this.bitwiseTo(a, op_andnot, r);
        return r;
    }
    // (public) ~this
    function bnNot() {
        var r = nbi();
        for(var i = 0; i < this.t; ++i)r[i] = this.DM & ~this[i];
        r.t = this.t;
        r.s = ~this.s;
        return r;
    }
    // (public) this << n
    function bnShiftLeft(n) {
        var r = nbi();
        if (n < 0) this.rShiftTo(-n, r);
        else this.lShiftTo(n, r);
        return r;
    }
    // (public) this >> n
    function bnShiftRight(n) {
        var r = nbi();
        if (n < 0) this.lShiftTo(-n, r);
        else this.rShiftTo(n, r);
        return r;
    }
    // return index of lowest 1-bit in x, x < 2^31
    function lbit(x) {
        if (x == 0) return -1;
        var r = 0;
        if ((x & 0xffff) == 0) {
            x >>= 16;
            r += 16;
        }
        if ((x & 0xff) == 0) {
            x >>= 8;
            r += 8;
        }
        if ((x & 0xf) == 0) {
            x >>= 4;
            r += 4;
        }
        if ((x & 3) == 0) {
            x >>= 2;
            r += 2;
        }
        if ((x & 1) == 0) ++r;
        return r;
    }
    // (public) returns index of lowest 1-bit (or -1 if none)
    function bnGetLowestSetBit() {
        for(var i = 0; i < this.t; ++i)if (this[i] != 0) return i * this.DB + lbit(this[i]);
        if (this.s < 0) return this.t * this.DB;
        return -1;
    }
    // return number of 1 bits in x
    function cbit(x) {
        var r = 0;
        while(x != 0){
            x &= x - 1;
            ++r;
        }
        return r;
    }
    // (public) return number of set bits
    function bnBitCount() {
        var r = 0, x = this.s & this.DM;
        for(var i = 0; i < this.t; ++i)r += cbit(this[i] ^ x);
        return r;
    }
    // (public) true iff nth bit is set
    function bnTestBit(n) {
        var j = Math.floor(n / this.DB);
        if (j >= this.t) return this.s != 0;
        return (this[j] & 1 << n % this.DB) != 0;
    }
    // (protected) this op (1<<n)
    function bnpChangeBit(n, op) {
        var r = BigInteger.ONE.shiftLeft(n);
        this.bitwiseTo(r, op, r);
        return r;
    }
    // (public) this | (1<<n)
    function bnSetBit(n) {
        return this.changeBit(n, op_or);
    }
    // (public) this & ~(1<<n)
    function bnClearBit(n) {
        return this.changeBit(n, op_andnot);
    }
    // (public) this ^ (1<<n)
    function bnFlipBit(n) {
        return this.changeBit(n, op_xor);
    }
    // (protected) r = this + a
    function bnpAddTo(a, r) {
        var i = 0, c = 0, m = Math.min(a.t, this.t);
        while(i < m){
            c += this[i] + a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        if (a.t < this.t) {
            c += a.s;
            while(i < this.t){
                c += this[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c += this.s;
        } else {
            c += this.s;
            while(i < a.t){
                c += a[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c += a.s;
        }
        r.s = c < 0 ? -1 : 0;
        if (c > 0) r[i++] = c;
        else if (c < -1) r[i++] = this.DV + c;
        r.t = i;
        r.clamp();
    }
    // (public) this + a
    function bnAdd(a) {
        var r = nbi();
        this.addTo(a, r);
        return r;
    }
    // (public) this - a
    function bnSubtract(a) {
        var r = nbi();
        this.subTo(a, r);
        return r;
    }
    // (public) this * a
    function bnMultiply(a) {
        var r = nbi();
        this.multiplyTo(a, r);
        return r;
    }
    // (public) this^2
    function bnSquare() {
        var r = nbi();
        this.squareTo(r);
        return r;
    }
    // (public) this / a
    function bnDivide(a) {
        var r = nbi();
        this.divRemTo(a, r, null);
        return r;
    }
    // (public) this % a
    function bnRemainder(a) {
        var r = nbi();
        this.divRemTo(a, null, r);
        return r;
    }
    // (public) [this/a,this%a]
    function bnDivideAndRemainder(a) {
        var q = nbi(), r = nbi();
        this.divRemTo(a, q, r);
        return new Array(q, r);
    }
    // (protected) this *= n, this >= 0, 1 < n < DV
    function bnpDMultiply(n) {
        this[this.t] = this.am(0, n - 1, this, 0, 0, this.t);
        ++this.t;
        this.clamp();
    }
    // (protected) this += n << w words, this >= 0
    function bnpDAddOffset(n, w) {
        if (n == 0) return;
        while(this.t <= w)this[this.t++] = 0;
        this[w] += n;
        while(this[w] >= this.DV){
            this[w] -= this.DV;
            if (++w >= this.t) this[this.t++] = 0;
            ++this[w];
        }
    }
    // A "null" reducer
    /**
	* @constructor
	*/ function NullExp() {}
    function nNop(x) {
        return x;
    }
    function nMulTo(x, y, r) {
        x.multiplyTo(y, r);
    }
    function nSqrTo(x, r) {
        x.squareTo(r);
    }
    NullExp.prototype.convert = nNop;
    NullExp.prototype.revert = nNop;
    NullExp.prototype.mulTo = nMulTo;
    NullExp.prototype.sqrTo = nSqrTo;
    // (public) this^e
    function bnPow(e) {
        return this.exp(e, new NullExp());
    }
    // (protected) r = lower n words of "this * a", a.t <= n
    // "this" should be the larger one if appropriate.
    function bnpMultiplyLowerTo(a, n, r) {
        var i = Math.min(this.t + a.t, n);
        r.s = 0; // assumes a,this >= 0
        r.t = i;
        while(i > 0)r[--i] = 0;
        var j;
        for(j = r.t - this.t; i < j; ++i)r[i + this.t] = this.am(0, a[i], r, i, 0, this.t);
        for(j = Math.min(a.t, n); i < j; ++i)this.am(0, a[i], r, i, 0, n - i);
        r.clamp();
    }
    // (protected) r = "this * a" without lower n words, n > 0
    // "this" should be the larger one if appropriate.
    function bnpMultiplyUpperTo(a, n, r) {
        --n;
        var i = r.t = this.t + a.t - n;
        r.s = 0; // assumes a,this >= 0
        while(--i >= 0)r[i] = 0;
        for(i = Math.max(n - this.t, 0); i < a.t; ++i)r[this.t + i - n] = this.am(n - i, a[i], r, 0, 0, this.t + i - n);
        r.clamp();
        r.drShiftTo(1, r);
    }
    // Barrett modular reduction
    /**
	* @constructor
	*/ function Barrett(m) {
        // setup Barrett
        this.r2 = nbi();
        this.q3 = nbi();
        BigInteger.ONE.dlShiftTo(2 * m.t, this.r2);
        this.mu = this.r2.divide(m);
        this.m = m;
    }
    function barrettConvert(x) {
        if (x.s < 0 || x.t > 2 * this.m.t) return x.mod(this.m);
        else if (x.compareTo(this.m) < 0) return x;
        else {
            var r = nbi();
            x.copyTo(r);
            this.reduce(r);
            return r;
        }
    }
    function barrettRevert(x) {
        return x;
    }
    // x = x mod m (HAC 14.42)
    function barrettReduce(x) {
        x.drShiftTo(this.m.t - 1, this.r2);
        if (x.t > this.m.t + 1) {
            x.t = this.m.t + 1;
            x.clamp();
        }
        this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3);
        this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2);
        while(x.compareTo(this.r2) < 0)x.dAddOffset(1, this.m.t + 1);
        x.subTo(this.r2, x);
        while(x.compareTo(this.m) >= 0)x.subTo(this.m, x);
    }
    // r = x^2 mod m; x != r
    function barrettSqrTo(x, r) {
        x.squareTo(r);
        this.reduce(r);
    }
    // r = x*y mod m; x,y != r
    function barrettMulTo(x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
    }
    Barrett.prototype.convert = barrettConvert;
    Barrett.prototype.revert = barrettRevert;
    Barrett.prototype.reduce = barrettReduce;
    Barrett.prototype.mulTo = barrettMulTo;
    Barrett.prototype.sqrTo = barrettSqrTo;
    // (public) this^e % m (HAC 14.85)
    function bnModPow(e, m) {
        var i = e.bitLength(), k, r = nbv(1), z;
        if (i <= 0) return r;
        else if (i < 18) k = 1;
        else if (i < 48) k = 3;
        else if (i < 144) k = 4;
        else if (i < 768) k = 5;
        else k = 6;
        if (i < 8) z = new Classic(m);
        else if (m.isEven()) z = new Barrett(m);
        else z = new Montgomery(m);
        // precomputation
        var g = new Array(), n = 3, k1 = k - 1, km = (1 << k) - 1;
        g[1] = z.convert(this);
        if (k > 1) {
            var g2 = nbi();
            z.sqrTo(g[1], g2);
            while(n <= km){
                g[n] = nbi();
                z.mulTo(g2, g[n - 2], g[n]);
                n += 2;
            }
        }
        var j = e.t - 1, w, is1 = true, r2 = nbi(), t;
        i = nbits(e[j]) - 1;
        while(j >= 0){
            if (i >= k1) w = e[j] >> i - k1 & km;
            else {
                w = (e[j] & (1 << i + 1) - 1) << k1 - i;
                if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
            }
            n = k;
            while((w & 1) == 0){
                w >>= 1;
                --n;
            }
            if ((i -= n) < 0) {
                i += this.DB;
                --j;
            }
            if (is1) {
                g[w].copyTo(r);
                is1 = false;
            } else {
                while(n > 1){
                    z.sqrTo(r, r2);
                    z.sqrTo(r2, r);
                    n -= 2;
                }
                if (n > 0) z.sqrTo(r, r2);
                else {
                    t = r;
                    r = r2;
                    r2 = t;
                }
                z.mulTo(r2, g[w], r);
            }
            while(j >= 0 && (e[j] & 1 << i) == 0){
                z.sqrTo(r, r2);
                t = r;
                r = r2;
                r2 = t;
                if (--i < 0) {
                    i = this.DB - 1;
                    --j;
                }
            }
        }
        return z.revert(r);
    }
    // (public) gcd(this,a) (HAC 14.54)
    function bnGCD(a) {
        var x = this.s < 0 ? this.negate() : this.clone();
        var y = a.s < 0 ? a.negate() : a.clone();
        if (x.compareTo(y) < 0) {
            var t = x;
            x = y;
            y = t;
        }
        var i = x.getLowestSetBit(), g = y.getLowestSetBit();
        if (g < 0) return x;
        if (i < g) g = i;
        if (g > 0) {
            x.rShiftTo(g, x);
            y.rShiftTo(g, y);
        }
        while(x.signum() > 0){
            if ((i = x.getLowestSetBit()) > 0) x.rShiftTo(i, x);
            if ((i = y.getLowestSetBit()) > 0) y.rShiftTo(i, y);
            if (x.compareTo(y) >= 0) {
                x.subTo(y, x);
                x.rShiftTo(1, x);
            } else {
                y.subTo(x, y);
                y.rShiftTo(1, y);
            }
        }
        if (g > 0) y.lShiftTo(g, y);
        return y;
    }
    // (protected) this % n, n < 2^26
    function bnpModInt(n) {
        if (n <= 0) return 0;
        var d = this.DV % n, r = this.s < 0 ? n - 1 : 0;
        if (this.t > 0) {
            if (d == 0) r = this[0] % n;
            else for(var i = this.t - 1; i >= 0; --i)r = (d * r + this[i]) % n;
        }
        return r;
    }
    // (public) 1/this % m (HAC 14.61)
    function bnModInverse(m) {
        var ac = m.isEven();
        if (this.isEven() && ac || m.signum() == 0) return BigInteger.ZERO;
        var u = m.clone(), v = this.clone();
        var a = nbv(1), b = nbv(0), c = nbv(0), d = nbv(1);
        while(u.signum() != 0){
            while(u.isEven()){
                u.rShiftTo(1, u);
                if (ac) {
                    if (!a.isEven() || !b.isEven()) {
                        a.addTo(this, a);
                        b.subTo(m, b);
                    }
                    a.rShiftTo(1, a);
                } else if (!b.isEven()) b.subTo(m, b);
                b.rShiftTo(1, b);
            }
            while(v.isEven()){
                v.rShiftTo(1, v);
                if (ac) {
                    if (!c.isEven() || !d.isEven()) {
                        c.addTo(this, c);
                        d.subTo(m, d);
                    }
                    c.rShiftTo(1, c);
                } else if (!d.isEven()) d.subTo(m, d);
                d.rShiftTo(1, d);
            }
            if (u.compareTo(v) >= 0) {
                u.subTo(v, u);
                if (ac) a.subTo(c, a);
                b.subTo(d, b);
            } else {
                v.subTo(u, v);
                if (ac) c.subTo(a, c);
                d.subTo(b, d);
            }
        }
        if (v.compareTo(BigInteger.ONE) != 0) return BigInteger.ZERO;
        if (d.compareTo(m) >= 0) return d.subtract(m);
        if (d.signum() < 0) d.addTo(m, d);
        else return d;
        if (d.signum() < 0) return d.add(m);
        else return d;
    }
    var lowprimes = [
        2,
        3,
        5,
        7,
        11,
        13,
        17,
        19,
        23,
        29,
        31,
        37,
        41,
        43,
        47,
        53,
        59,
        61,
        67,
        71,
        73,
        79,
        83,
        89,
        97,
        101,
        103,
        107,
        109,
        113,
        127,
        131,
        137,
        139,
        149,
        151,
        157,
        163,
        167,
        173,
        179,
        181,
        191,
        193,
        197,
        199,
        211,
        223,
        227,
        229,
        233,
        239,
        241,
        251,
        257,
        263,
        269,
        271,
        277,
        281,
        283,
        293,
        307,
        311,
        313,
        317,
        331,
        337,
        347,
        349,
        353,
        359,
        367,
        373,
        379,
        383,
        389,
        397,
        401,
        409,
        419,
        421,
        431,
        433,
        439,
        443,
        449,
        457,
        461,
        463,
        467,
        479,
        487,
        491,
        499,
        503,
        509,
        521,
        523,
        541,
        547,
        557,
        563,
        569,
        571,
        577,
        587,
        593,
        599,
        601,
        607,
        613,
        617,
        619,
        631,
        641,
        643,
        647,
        653,
        659,
        661,
        673,
        677,
        683,
        691,
        701,
        709,
        719,
        727,
        733,
        739,
        743,
        751,
        757,
        761,
        769,
        773,
        787,
        797,
        809,
        811,
        821,
        823,
        827,
        829,
        839,
        853,
        857,
        859,
        863,
        877,
        881,
        883,
        887,
        907,
        911,
        919,
        929,
        937,
        941,
        947,
        953,
        967,
        971,
        977,
        983,
        991,
        997
    ];
    var lplim = 67108864 / lowprimes[lowprimes.length - 1];
    // (public) test primality with certainty >= 1-.5^t
    function bnIsProbablePrime(t) {
        var i, x = this.abs();
        if (x.t == 1 && x[0] <= lowprimes[lowprimes.length - 1]) {
            for(i = 0; i < lowprimes.length; ++i)if (x[0] == lowprimes[i]) return true;
            return false;
        }
        if (x.isEven()) return false;
        i = 1;
        while(i < lowprimes.length){
            var m = lowprimes[i], j = i + 1;
            while(j < lowprimes.length && m < lplim)m *= lowprimes[j++];
            m = x.modInt(m);
            while(i < j)if (m % lowprimes[i++] == 0) return false;
        }
        return x.millerRabin(t);
    }
    // (protected) true if probably prime (HAC 4.24, Miller-Rabin)
    function bnpMillerRabin(t) {
        var n1 = this.subtract(BigInteger.ONE);
        var k = n1.getLowestSetBit();
        if (k <= 0) return false;
        var r = n1.shiftRight(k);
        t = t + 1 >> 1;
        if (t > lowprimes.length) t = lowprimes.length;
        var a = nbi();
        for(var i = 0; i < t; ++i){
            //Pick bases at random, instead of starting at 2
            a.fromInt(lowprimes[Math.floor(Math.random() * lowprimes.length)]);
            var y = a.modPow(r, this);
            if (y.compareTo(BigInteger.ONE) != 0 && y.compareTo(n1) != 0) {
                var j = 1;
                while(j++ < k && y.compareTo(n1) != 0){
                    y = y.modPowInt(2, this);
                    if (y.compareTo(BigInteger.ONE) == 0) return false;
                }
                if (y.compareTo(n1) != 0) return false;
            }
        }
        return true;
    }
    // protected
    BigInteger.prototype.chunkSize = bnpChunkSize;
    BigInteger.prototype.toRadix = bnpToRadix;
    BigInteger.prototype.fromRadix = bnpFromRadix;
    BigInteger.prototype.fromNumber = bnpFromNumber;
    BigInteger.prototype.bitwiseTo = bnpBitwiseTo;
    BigInteger.prototype.changeBit = bnpChangeBit;
    BigInteger.prototype.addTo = bnpAddTo;
    BigInteger.prototype.dMultiply = bnpDMultiply;
    BigInteger.prototype.dAddOffset = bnpDAddOffset;
    BigInteger.prototype.multiplyLowerTo = bnpMultiplyLowerTo;
    BigInteger.prototype.multiplyUpperTo = bnpMultiplyUpperTo;
    BigInteger.prototype.modInt = bnpModInt;
    BigInteger.prototype.millerRabin = bnpMillerRabin;
    // public
    BigInteger.prototype.clone = bnClone;
    BigInteger.prototype.intValue = bnIntValue;
    BigInteger.prototype.byteValue = bnByteValue;
    BigInteger.prototype.shortValue = bnShortValue;
    BigInteger.prototype.signum = bnSigNum;
    BigInteger.prototype.toByteArray = bnToByteArray;
    BigInteger.prototype.equals = bnEquals;
    BigInteger.prototype.min = bnMin;
    BigInteger.prototype.max = bnMax;
    BigInteger.prototype.and = bnAnd;
    BigInteger.prototype.or = bnOr;
    BigInteger.prototype.xor = bnXor;
    BigInteger.prototype.andNot = bnAndNot;
    BigInteger.prototype.not = bnNot;
    BigInteger.prototype.shiftLeft = bnShiftLeft;
    BigInteger.prototype.shiftRight = bnShiftRight;
    BigInteger.prototype.getLowestSetBit = bnGetLowestSetBit;
    BigInteger.prototype.bitCount = bnBitCount;
    BigInteger.prototype.testBit = bnTestBit;
    BigInteger.prototype.setBit = bnSetBit;
    BigInteger.prototype.clearBit = bnClearBit;
    BigInteger.prototype.flipBit = bnFlipBit;
    BigInteger.prototype.add = bnAdd;
    BigInteger.prototype.subtract = bnSubtract;
    BigInteger.prototype.multiply = bnMultiply;
    BigInteger.prototype.divide = bnDivide;
    BigInteger.prototype.remainder = bnRemainder;
    BigInteger.prototype.divideAndRemainder = bnDivideAndRemainder;
    BigInteger.prototype.modPow = bnModPow;
    BigInteger.prototype.modInverse = bnModInverse;
    BigInteger.prototype.pow = bnPow;
    BigInteger.prototype.gcd = bnGCD;
    BigInteger.prototype.isProbablePrime = bnIsProbablePrime;
    // JSBN-specific extension
    BigInteger.prototype.square = bnSquare;
    var Int128 = BigInteger;
    // BigInteger interfaces not implemented in jsbn:
    // BigInteger(int signum, byte[] magnitude)
    // double doubleValue()
    // float floatValue()
    // int hashCode()
    // long longValue()
    // static BigInteger valueOf(long val)
    // Helper functions to make BigInteger functions callable with two parameters
    // as in original C# Clipper
    Int128.prototype.IsNegative = function() {
        if (this.compareTo(Int128.ZERO) == -1) return true;
        else return false;
    };
    Int128.op_Equality = function(val1, val2) {
        if (val1.compareTo(val2) == 0) return true;
        else return false;
    };
    Int128.op_Inequality = function(val1, val2) {
        if (val1.compareTo(val2) != 0) return true;
        else return false;
    };
    Int128.op_GreaterThan = function(val1, val2) {
        if (val1.compareTo(val2) > 0) return true;
        else return false;
    };
    Int128.op_LessThan = function(val1, val2) {
        if (val1.compareTo(val2) < 0) return true;
        else return false;
    };
    Int128.op_Addition = function(lhs, rhs) {
        return new Int128(lhs, undefined, undefined).add(new Int128(rhs, undefined, undefined));
    };
    Int128.op_Subtraction = function(lhs, rhs) {
        return new Int128(lhs, undefined, undefined).subtract(new Int128(rhs, undefined, undefined));
    };
    Int128.Int128Mul = function(lhs, rhs) {
        return new Int128(lhs, undefined, undefined).multiply(new Int128(rhs, undefined, undefined));
    };
    Int128.op_Division = function(lhs, rhs) {
        return lhs.divide(rhs);
    };
    Int128.prototype.ToDouble = function() {
        return parseFloat(this.toString()); // This could be something faster
    };
    // end of Int128 section
    /*
	// Uncomment the following two lines if you want to use Int128 outside ClipperLib
	if (typeof(document) !== "undefined") window.Int128 = Int128;
	else self.Int128 = Int128;
	*/ // ---------------------------------------------
    // Here starts the actual Clipper library:
    // Helper function to support Inheritance in Javascript
    var Inherit = function(ce, ce2) {
        var p;
        if (typeof Object.getOwnPropertyNames === 'undefined') {
            for(p in ce2.prototype)if (typeof ce.prototype[p] === 'undefined' || ce.prototype[p] === Object.prototype[p]) ce.prototype[p] = ce2.prototype[p];
            for(p in ce2)if (typeof ce[p] === 'undefined') ce[p] = ce2[p];
            ce.$baseCtor = ce2;
        } else {
            var props = Object.getOwnPropertyNames(ce2.prototype);
            for(var i = 0; i < props.length; i++)if (typeof Object.getOwnPropertyDescriptor(ce.prototype, props[i]) === 'undefined') Object.defineProperty(ce.prototype, props[i], Object.getOwnPropertyDescriptor(ce2.prototype, props[i]));
            for(p in ce2)if (typeof ce[p] === 'undefined') ce[p] = ce2[p];
            ce.$baseCtor = ce2;
        }
    };
    /**
	* @constructor
	*/ ClipperLib.Path = function() {
        return [];
    };
    ClipperLib.Path.prototype.push = Array.prototype.push;
    /**
	* @constructor
	*/ ClipperLib.Paths = function() {
        return []; // Was previously [[]], but caused problems when pushed
    };
    ClipperLib.Paths.prototype.push = Array.prototype.push;
    // Preserves the calling way of original C# Clipper
    // Is essential due to compatibility, because DoublePoint is public class in original C# version
    /**
	* @constructor
	*/ ClipperLib.DoublePoint = function() {
        var a = arguments;
        this.X = 0;
        this.Y = 0;
        // public DoublePoint(DoublePoint dp)
        // public DoublePoint(IntPoint ip)
        if (a.length === 1) {
            this.X = a[0].X;
            this.Y = a[0].Y;
        } else if (a.length === 2) {
            this.X = a[0];
            this.Y = a[1];
        }
    }; // This is internal faster function when called without arguments
    /**
	* @constructor
	*/ ClipperLib.DoublePoint0 = function() {
        this.X = 0;
        this.Y = 0;
    };
    ClipperLib.DoublePoint0.prototype = ClipperLib.DoublePoint.prototype;
    // This is internal faster function when called with 1 argument (dp or ip)
    /**
	* @constructor
	*/ ClipperLib.DoublePoint1 = function(dp) {
        this.X = dp.X;
        this.Y = dp.Y;
    };
    ClipperLib.DoublePoint1.prototype = ClipperLib.DoublePoint.prototype;
    // This is internal faster function when called with 2 arguments (x and y)
    /**
	* @constructor
	*/ ClipperLib.DoublePoint2 = function(x, y) {
        this.X = x;
        this.Y = y;
    };
    ClipperLib.DoublePoint2.prototype = ClipperLib.DoublePoint.prototype;
    // PolyTree & PolyNode start
    /**
	* @suppress {missingProperties}
	*/ ClipperLib.PolyNode = function() {
        this.m_Parent = null;
        this.m_polygon = new ClipperLib.Path();
        this.m_Index = 0;
        this.m_jointype = 0;
        this.m_endtype = 0;
        this.m_Childs = [];
        this.IsOpen = false;
    };
    ClipperLib.PolyNode.prototype.IsHoleNode = function() {
        var result = true;
        var node = this.m_Parent;
        while(node !== null){
            result = !result;
            node = node.m_Parent;
        }
        return result;
    };
    ClipperLib.PolyNode.prototype.ChildCount = function() {
        return this.m_Childs.length;
    };
    ClipperLib.PolyNode.prototype.Contour = function() {
        return this.m_polygon;
    };
    ClipperLib.PolyNode.prototype.AddChild = function(Child) {
        var cnt = this.m_Childs.length;
        this.m_Childs.push(Child);
        Child.m_Parent = this;
        Child.m_Index = cnt;
    };
    ClipperLib.PolyNode.prototype.GetNext = function() {
        if (this.m_Childs.length > 0) return this.m_Childs[0];
        else return this.GetNextSiblingUp();
    };
    ClipperLib.PolyNode.prototype.GetNextSiblingUp = function() {
        if (this.m_Parent === null) return null;
        else if (this.m_Index === this.m_Parent.m_Childs.length - 1) return this.m_Parent.GetNextSiblingUp();
        else return this.m_Parent.m_Childs[this.m_Index + 1];
    };
    ClipperLib.PolyNode.prototype.Childs = function() {
        return this.m_Childs;
    };
    ClipperLib.PolyNode.prototype.Parent = function() {
        return this.m_Parent;
    };
    ClipperLib.PolyNode.prototype.IsHole = function() {
        return this.IsHoleNode();
    };
    // PolyTree : PolyNode
    /**
	 * @suppress {missingProperties}
	 * @constructor
	 */ ClipperLib.PolyTree = function() {
        this.m_AllPolys = [];
        ClipperLib.PolyNode.call(this);
    };
    ClipperLib.PolyTree.prototype.Clear = function() {
        for(var i = 0, ilen = this.m_AllPolys.length; i < ilen; i++)this.m_AllPolys[i] = null;
        this.m_AllPolys.length = 0;
        this.m_Childs.length = 0;
    };
    ClipperLib.PolyTree.prototype.GetFirst = function() {
        if (this.m_Childs.length > 0) return this.m_Childs[0];
        else return null;
    };
    ClipperLib.PolyTree.prototype.Total = function() {
        var result = this.m_AllPolys.length;
        //with negative offsets, ignore the hidden outer polygon ...
        if (result > 0 && this.m_Childs[0] !== this.m_AllPolys[0]) result--;
        return result;
    };
    Inherit(ClipperLib.PolyTree, ClipperLib.PolyNode);
    // PolyTree & PolyNode end
    ClipperLib.Math_Abs_Int64 = ClipperLib.Math_Abs_Int32 = ClipperLib.Math_Abs_Double = function(a) {
        return Math.abs(a);
    };
    ClipperLib.Math_Max_Int32_Int32 = function(a, b) {
        return Math.max(a, b);
    };
    /*
	-----------------------------------
	cast_32 speedtest: http://jsperf.com/truncate-float-to-integer/2
	-----------------------------------
	*/ if (browser.msie || browser.opera || browser.safari) ClipperLib.Cast_Int32 = function(a) {
        return a | 0;
    };
    else ClipperLib.Cast_Int32 = function(a) {
        return ~~a;
    };
    /*
	--------------------------
	cast_64 speedtests: http://jsperf.com/truncate-float-to-integer
	Chrome: bitwise_not_floor
	Firefox17: toInteger (typeof test)
	IE9: bitwise_or_floor
	IE7 and IE8: to_parseint
	Chromium: to_floor_or_ceil
	Firefox3: to_floor_or_ceil
	Firefox15: to_floor_or_ceil
	Opera: to_floor_or_ceil
	Safari: to_floor_or_ceil
	--------------------------
	*/ if (typeof Number.toInteger === "undefined") Number.toInteger = null;
    if (browser.chrome) ClipperLib.Cast_Int64 = function(a) {
        if (a < -2147483648 || a > 2147483647) return a < 0 ? Math.ceil(a) : Math.floor(a);
        else return ~~a;
    };
    else if (browser.firefox && typeof Number.toInteger === "function") ClipperLib.Cast_Int64 = function(a) {
        return Number.toInteger(a);
    };
    else if (browser.msie7 || browser.msie8) ClipperLib.Cast_Int64 = function(a) {
        return parseInt(a, 10);
    };
    else if (browser.msie) ClipperLib.Cast_Int64 = function(a) {
        if (a < -2147483648 || a > 2147483647) return a < 0 ? Math.ceil(a) : Math.floor(a);
        return a | 0;
    };
    else ClipperLib.Cast_Int64 = function(a) {
        return a < 0 ? Math.ceil(a) : Math.floor(a);
    };
    ClipperLib.Clear = function(a) {
        a.length = 0;
    };
    //ClipperLib.MaxSteps = 64; // How many steps at maximum in arc in BuildArc() function
    ClipperLib.PI = 3.141592653589793;
    ClipperLib.PI2 = 6.283185307179586;
    /**
	* @constructor
	*/ ClipperLib.IntPoint = function() {
        var a = arguments, alen = a.length;
        this.X = 0;
        this.Y = 0;
        if (ClipperLib.use_xyz) {
            this.Z = 0;
            if (alen === 3) {
                this.X = a[0];
                this.Y = a[1];
                this.Z = a[2];
            } else if (alen === 2) {
                this.X = a[0];
                this.Y = a[1];
                this.Z = 0;
            } else if (alen === 1) {
                if (a[0] instanceof ClipperLib.DoublePoint) {
                    var dp = a[0];
                    this.X = ClipperLib.Clipper.Round(dp.X);
                    this.Y = ClipperLib.Clipper.Round(dp.Y);
                    this.Z = 0;
                } else {
                    var pt = a[0];
                    if (typeof pt.Z === "undefined") pt.Z = 0;
                    this.X = pt.X;
                    this.Y = pt.Y;
                    this.Z = pt.Z;
                }
            } else {
                this.X = 0;
                this.Y = 0;
                this.Z = 0;
            }
        } else {
            if (alen === 2) {
                this.X = a[0];
                this.Y = a[1];
            } else if (alen === 1) {
                if (a[0] instanceof ClipperLib.DoublePoint) {
                    var dp = a[0];
                    this.X = ClipperLib.Clipper.Round(dp.X);
                    this.Y = ClipperLib.Clipper.Round(dp.Y);
                } else {
                    var pt = a[0];
                    this.X = pt.X;
                    this.Y = pt.Y;
                }
            } else {
                this.X = 0;
                this.Y = 0;
            }
        }
    };
    ClipperLib.IntPoint.op_Equality = function(a, b) {
        //return a == b;
        return a.X === b.X && a.Y === b.Y;
    };
    ClipperLib.IntPoint.op_Inequality = function(a, b) {
        //return a !== b;
        return a.X !== b.X || a.Y !== b.Y;
    };
    /*
  ClipperLib.IntPoint.prototype.Equals = function (obj)
  {
	if (obj === null)
		return false;
	if (obj instanceof ClipperLib.IntPoint)
	{
		var a = Cast(obj, ClipperLib.IntPoint);
		return (this.X == a.X) && (this.Y == a.Y);
	}
	else
		return false;
  };

	*/ /**
	* @constructor
	*/ ClipperLib.IntPoint0 = function() {
        this.X = 0;
        this.Y = 0;
        if (ClipperLib.use_xyz) this.Z = 0;
    };
    ClipperLib.IntPoint0.prototype = ClipperLib.IntPoint.prototype;
    /**
	* @constructor
	*/ ClipperLib.IntPoint1 = function(pt) {
        this.X = pt.X;
        this.Y = pt.Y;
        if (ClipperLib.use_xyz) {
            if (typeof pt.Z === "undefined") this.Z = 0;
            else this.Z = pt.Z;
        }
    };
    ClipperLib.IntPoint1.prototype = ClipperLib.IntPoint.prototype;
    /**
	* @constructor
	*/ ClipperLib.IntPoint1dp = function(dp) {
        this.X = ClipperLib.Clipper.Round(dp.X);
        this.Y = ClipperLib.Clipper.Round(dp.Y);
        if (ClipperLib.use_xyz) this.Z = 0;
    };
    ClipperLib.IntPoint1dp.prototype = ClipperLib.IntPoint.prototype;
    /**
	* @constructor
	*/ ClipperLib.IntPoint2 = function(x, y, z) {
        this.X = x;
        this.Y = y;
        if (ClipperLib.use_xyz) {
            if (typeof z === "undefined") this.Z = 0;
            else this.Z = z;
        }
    };
    ClipperLib.IntPoint2.prototype = ClipperLib.IntPoint.prototype;
    /**
	* @constructor
	*/ ClipperLib.IntRect = function() {
        var a = arguments, alen = a.length;
        if (alen === 4) {
            this.left = a[0];
            this.top = a[1];
            this.right = a[2];
            this.bottom = a[3];
        } else if (alen === 1) {
            var ir = a[0];
            this.left = ir.left;
            this.top = ir.top;
            this.right = ir.right;
            this.bottom = ir.bottom;
        } else {
            this.left = 0;
            this.top = 0;
            this.right = 0;
            this.bottom = 0;
        }
    };
    /**
	* @constructor
	*/ ClipperLib.IntRect0 = function() {
        this.left = 0;
        this.top = 0;
        this.right = 0;
        this.bottom = 0;
    };
    ClipperLib.IntRect0.prototype = ClipperLib.IntRect.prototype;
    /**
	* @constructor
	*/ ClipperLib.IntRect1 = function(ir) {
        this.left = ir.left;
        this.top = ir.top;
        this.right = ir.right;
        this.bottom = ir.bottom;
    };
    ClipperLib.IntRect1.prototype = ClipperLib.IntRect.prototype;
    /**
	* @constructor
	*/ ClipperLib.IntRect4 = function(l, t, r, b) {
        this.left = l;
        this.top = t;
        this.right = r;
        this.bottom = b;
    };
    ClipperLib.IntRect4.prototype = ClipperLib.IntRect.prototype;
    ClipperLib.ClipType = {
        ctIntersection: 0,
        ctUnion: 1,
        ctDifference: 2,
        ctXor: 3
    };
    ClipperLib.PolyType = {
        ptSubject: 0,
        ptClip: 1
    };
    ClipperLib.PolyFillType = {
        pftEvenOdd: 0,
        pftNonZero: 1,
        pftPositive: 2,
        pftNegative: 3
    };
    ClipperLib.JoinType = {
        jtSquare: 0,
        jtRound: 1,
        jtMiter: 2
    };
    ClipperLib.EndType = {
        etOpenSquare: 0,
        etOpenRound: 1,
        etOpenButt: 2,
        etClosedLine: 3,
        etClosedPolygon: 4
    };
    ClipperLib.EdgeSide = {
        esLeft: 0,
        esRight: 1
    };
    ClipperLib.Direction = {
        dRightToLeft: 0,
        dLeftToRight: 1
    };
    /**
	* @constructor
	*/ ClipperLib.TEdge = function() {
        this.Bot = new ClipperLib.IntPoint0();
        this.Curr = new ClipperLib.IntPoint0(); //current (updated for every new scanbeam)
        this.Top = new ClipperLib.IntPoint0();
        this.Delta = new ClipperLib.IntPoint0();
        this.Dx = 0;
        this.PolyTyp = ClipperLib.PolyType.ptSubject;
        this.Side = ClipperLib.EdgeSide.esLeft; //side only refers to current side of solution poly
        this.WindDelta = 0; //1 or -1 depending on winding direction
        this.WindCnt = 0;
        this.WindCnt2 = 0; //winding count of the opposite polytype
        this.OutIdx = 0;
        this.Next = null;
        this.Prev = null;
        this.NextInLML = null;
        this.NextInAEL = null;
        this.PrevInAEL = null;
        this.NextInSEL = null;
        this.PrevInSEL = null;
    };
    /**
	* @constructor
	*/ ClipperLib.IntersectNode = function() {
        this.Edge1 = null;
        this.Edge2 = null;
        this.Pt = new ClipperLib.IntPoint0();
    };
    ClipperLib.MyIntersectNodeSort = function() {};
    ClipperLib.MyIntersectNodeSort.Compare = function(node1, node2) {
        var i = node2.Pt.Y - node1.Pt.Y;
        if (i > 0) return 1;
        else if (i < 0) return -1;
        else return 0;
    };
    /**
	* @constructor
	*/ ClipperLib.LocalMinima = function() {
        this.Y = 0;
        this.LeftBound = null;
        this.RightBound = null;
        this.Next = null;
    };
    /**
	* @constructor
	*/ ClipperLib.Scanbeam = function() {
        this.Y = 0;
        this.Next = null;
    };
    /**
	* @constructor
	*/ ClipperLib.Maxima = function() {
        this.X = 0;
        this.Next = null;
        this.Prev = null;
    };
    //OutRec: contains a path in the clipping solution. Edges in the AEL will
    //carry a pointer to an OutRec when they are part of the clipping solution.
    /**
	* @constructor
	*/ ClipperLib.OutRec = function() {
        this.Idx = 0;
        this.IsHole = false;
        this.IsOpen = false;
        this.FirstLeft = null; //see comments in clipper.pas
        this.Pts = null;
        this.BottomPt = null;
        this.PolyNode = null;
    };
    /**
	* @constructor
	*/ ClipperLib.OutPt = function() {
        this.Idx = 0;
        this.Pt = new ClipperLib.IntPoint0();
        this.Next = null;
        this.Prev = null;
    };
    /**
	* @constructor
	*/ ClipperLib.Join = function() {
        this.OutPt1 = null;
        this.OutPt2 = null;
        this.OffPt = new ClipperLib.IntPoint0();
    };
    ClipperLib.ClipperBase = function() {
        this.m_MinimaList = null;
        this.m_CurrentLM = null;
        this.m_edges = new Array();
        this.m_UseFullRange = false;
        this.m_HasOpenPaths = false;
        this.PreserveCollinear = false;
        this.m_Scanbeam = null;
        this.m_PolyOuts = null;
        this.m_ActiveEdges = null;
    };
    // Ranges are in original C# too high for Javascript (in current state 2013 september):
    // protected const double horizontal = -3.4E+38;
    // internal const cInt loRange = 0x3FFFFFFF; // = 1073741823 = sqrt(2^63 -1)/2
    // internal const cInt hiRange = 0x3FFFFFFFFFFFFFFFL; // = 4611686018427387903 = sqrt(2^127 -1)/2
    // So had to adjust them to more suitable for Javascript.
    // If JS some day supports truly 64-bit integers, then these ranges can be as in C#
    // and biginteger library can be more simpler (as then 128bit can be represented as two 64bit numbers)
    ClipperLib.ClipperBase.horizontal = -9007199254740992; //-2^53
    ClipperLib.ClipperBase.Skip = -2;
    ClipperLib.ClipperBase.Unassigned = -1;
    ClipperLib.ClipperBase.tolerance = 1E-20;
    ClipperLib.ClipperBase.loRange = 47453132; // sqrt(2^53 -1)/2
    ClipperLib.ClipperBase.hiRange = 4503599627370495; // sqrt(2^106 -1)/2
    ClipperLib.ClipperBase.near_zero = function(val) {
        return val > -ClipperLib.ClipperBase.tolerance && val < ClipperLib.ClipperBase.tolerance;
    };
    ClipperLib.ClipperBase.IsHorizontal = function(e) {
        return e.Delta.Y === 0;
    };
    ClipperLib.ClipperBase.prototype.PointIsVertex = function(pt, pp) {
        var pp2 = pp;
        do {
            if (ClipperLib.IntPoint.op_Equality(pp2.Pt, pt)) return true;
            pp2 = pp2.Next;
        }while (pp2 !== pp);
        return false;
    };
    ClipperLib.ClipperBase.prototype.PointOnLineSegment = function(pt, linePt1, linePt2, UseFullRange) {
        if (UseFullRange) return pt.X === linePt1.X && pt.Y === linePt1.Y || pt.X === linePt2.X && pt.Y === linePt2.Y || pt.X > linePt1.X === pt.X < linePt2.X && pt.Y > linePt1.Y === pt.Y < linePt2.Y && Int128.op_Equality(Int128.Int128Mul(pt.X - linePt1.X, linePt2.Y - linePt1.Y), Int128.Int128Mul(linePt2.X - linePt1.X, pt.Y - linePt1.Y));
        else return pt.X === linePt1.X && pt.Y === linePt1.Y || pt.X === linePt2.X && pt.Y === linePt2.Y || pt.X > linePt1.X === pt.X < linePt2.X && pt.Y > linePt1.Y === pt.Y < linePt2.Y && (pt.X - linePt1.X) * (linePt2.Y - linePt1.Y) === (linePt2.X - linePt1.X) * (pt.Y - linePt1.Y);
    };
    ClipperLib.ClipperBase.prototype.PointOnPolygon = function(pt, pp, UseFullRange) {
        var pp2 = pp;
        while(true){
            if (this.PointOnLineSegment(pt, pp2.Pt, pp2.Next.Pt, UseFullRange)) return true;
            pp2 = pp2.Next;
            if (pp2 === pp) break;
        }
        return false;
    };
    ClipperLib.ClipperBase.prototype.SlopesEqual = ClipperLib.ClipperBase.SlopesEqual = function() {
        var a = arguments, alen = a.length;
        var e1, e2, pt1, pt2, pt3, pt4, UseFullRange;
        if (alen === 3) {
            e1 = a[0];
            e2 = a[1];
            UseFullRange = a[2];
            if (UseFullRange) return Int128.op_Equality(Int128.Int128Mul(e1.Delta.Y, e2.Delta.X), Int128.Int128Mul(e1.Delta.X, e2.Delta.Y));
            else return ClipperLib.Cast_Int64(e1.Delta.Y * e2.Delta.X) === ClipperLib.Cast_Int64(e1.Delta.X * e2.Delta.Y);
        } else if (alen === 4) {
            pt1 = a[0];
            pt2 = a[1];
            pt3 = a[2];
            UseFullRange = a[3];
            if (UseFullRange) return Int128.op_Equality(Int128.Int128Mul(pt1.Y - pt2.Y, pt2.X - pt3.X), Int128.Int128Mul(pt1.X - pt2.X, pt2.Y - pt3.Y));
            else return ClipperLib.Cast_Int64((pt1.Y - pt2.Y) * (pt2.X - pt3.X)) - ClipperLib.Cast_Int64((pt1.X - pt2.X) * (pt2.Y - pt3.Y)) === 0;
        } else {
            pt1 = a[0];
            pt2 = a[1];
            pt3 = a[2];
            pt4 = a[3];
            UseFullRange = a[4];
            if (UseFullRange) return Int128.op_Equality(Int128.Int128Mul(pt1.Y - pt2.Y, pt3.X - pt4.X), Int128.Int128Mul(pt1.X - pt2.X, pt3.Y - pt4.Y));
            else return ClipperLib.Cast_Int64((pt1.Y - pt2.Y) * (pt3.X - pt4.X)) - ClipperLib.Cast_Int64((pt1.X - pt2.X) * (pt3.Y - pt4.Y)) === 0;
        }
    };
    ClipperLib.ClipperBase.SlopesEqual3 = function(e1, e2, UseFullRange) {
        if (UseFullRange) return Int128.op_Equality(Int128.Int128Mul(e1.Delta.Y, e2.Delta.X), Int128.Int128Mul(e1.Delta.X, e2.Delta.Y));
        else return ClipperLib.Cast_Int64(e1.Delta.Y * e2.Delta.X) === ClipperLib.Cast_Int64(e1.Delta.X * e2.Delta.Y);
    };
    ClipperLib.ClipperBase.SlopesEqual4 = function(pt1, pt2, pt3, UseFullRange) {
        if (UseFullRange) return Int128.op_Equality(Int128.Int128Mul(pt1.Y - pt2.Y, pt2.X - pt3.X), Int128.Int128Mul(pt1.X - pt2.X, pt2.Y - pt3.Y));
        else return ClipperLib.Cast_Int64((pt1.Y - pt2.Y) * (pt2.X - pt3.X)) - ClipperLib.Cast_Int64((pt1.X - pt2.X) * (pt2.Y - pt3.Y)) === 0;
    };
    ClipperLib.ClipperBase.SlopesEqual5 = function(pt1, pt2, pt3, pt4, UseFullRange) {
        if (UseFullRange) return Int128.op_Equality(Int128.Int128Mul(pt1.Y - pt2.Y, pt3.X - pt4.X), Int128.Int128Mul(pt1.X - pt2.X, pt3.Y - pt4.Y));
        else return ClipperLib.Cast_Int64((pt1.Y - pt2.Y) * (pt3.X - pt4.X)) - ClipperLib.Cast_Int64((pt1.X - pt2.X) * (pt3.Y - pt4.Y)) === 0;
    };
    ClipperLib.ClipperBase.prototype.Clear = function() {
        this.DisposeLocalMinimaList();
        for(var i = 0, ilen = this.m_edges.length; i < ilen; ++i){
            for(var j = 0, jlen = this.m_edges[i].length; j < jlen; ++j)this.m_edges[i][j] = null;
            ClipperLib.Clear(this.m_edges[i]);
        }
        ClipperLib.Clear(this.m_edges);
        this.m_UseFullRange = false;
        this.m_HasOpenPaths = false;
    };
    ClipperLib.ClipperBase.prototype.DisposeLocalMinimaList = function() {
        while(this.m_MinimaList !== null){
            var tmpLm = this.m_MinimaList.Next;
            this.m_MinimaList = null;
            this.m_MinimaList = tmpLm;
        }
        this.m_CurrentLM = null;
    };
    ClipperLib.ClipperBase.prototype.RangeTest = function(Pt, useFullRange) {
        if (useFullRange.Value) {
            if (Pt.X > ClipperLib.ClipperBase.hiRange || Pt.Y > ClipperLib.ClipperBase.hiRange || -Pt.X > ClipperLib.ClipperBase.hiRange || -Pt.Y > ClipperLib.ClipperBase.hiRange) ClipperLib.Error("Coordinate outside allowed range in RangeTest().");
        } else if (Pt.X > ClipperLib.ClipperBase.loRange || Pt.Y > ClipperLib.ClipperBase.loRange || -Pt.X > ClipperLib.ClipperBase.loRange || -Pt.Y > ClipperLib.ClipperBase.loRange) {
            useFullRange.Value = true;
            this.RangeTest(Pt, useFullRange);
        }
    };
    ClipperLib.ClipperBase.prototype.InitEdge = function(e, eNext, ePrev, pt) {
        e.Next = eNext;
        e.Prev = ePrev;
        //e.Curr = pt;
        e.Curr.X = pt.X;
        e.Curr.Y = pt.Y;
        if (ClipperLib.use_xyz) e.Curr.Z = pt.Z;
        e.OutIdx = -1;
    };
    ClipperLib.ClipperBase.prototype.InitEdge2 = function(e, polyType) {
        if (e.Curr.Y >= e.Next.Curr.Y) {
            //e.Bot = e.Curr;
            e.Bot.X = e.Curr.X;
            e.Bot.Y = e.Curr.Y;
            if (ClipperLib.use_xyz) e.Bot.Z = e.Curr.Z;
            //e.Top = e.Next.Curr;
            e.Top.X = e.Next.Curr.X;
            e.Top.Y = e.Next.Curr.Y;
            if (ClipperLib.use_xyz) e.Top.Z = e.Next.Curr.Z;
        } else {
            //e.Top = e.Curr;
            e.Top.X = e.Curr.X;
            e.Top.Y = e.Curr.Y;
            if (ClipperLib.use_xyz) e.Top.Z = e.Curr.Z;
            //e.Bot = e.Next.Curr;
            e.Bot.X = e.Next.Curr.X;
            e.Bot.Y = e.Next.Curr.Y;
            if (ClipperLib.use_xyz) e.Bot.Z = e.Next.Curr.Z;
        }
        this.SetDx(e);
        e.PolyTyp = polyType;
    };
    ClipperLib.ClipperBase.prototype.FindNextLocMin = function(E) {
        var E2;
        for(;;){
            while(ClipperLib.IntPoint.op_Inequality(E.Bot, E.Prev.Bot) || ClipperLib.IntPoint.op_Equality(E.Curr, E.Top))E = E.Next;
            if (E.Dx !== ClipperLib.ClipperBase.horizontal && E.Prev.Dx !== ClipperLib.ClipperBase.horizontal) break;
            while(E.Prev.Dx === ClipperLib.ClipperBase.horizontal)E = E.Prev;
            E2 = E;
            while(E.Dx === ClipperLib.ClipperBase.horizontal)E = E.Next;
            if (E.Top.Y === E.Prev.Bot.Y) continue;
            //ie just an intermediate horz.
            if (E2.Prev.Bot.X < E.Bot.X) E = E2;
            break;
        }
        return E;
    };
    ClipperLib.ClipperBase.prototype.ProcessBound = function(E, LeftBoundIsForward) {
        var EStart;
        var Result = E;
        var Horz;
        if (Result.OutIdx === ClipperLib.ClipperBase.Skip) {
            //check if there are edges beyond the skip edge in the bound and if so
            //create another LocMin and calling ProcessBound once more ...
            E = Result;
            if (LeftBoundIsForward) {
                while(E.Top.Y === E.Next.Bot.Y)E = E.Next;
                while(E !== Result && E.Dx === ClipperLib.ClipperBase.horizontal)E = E.Prev;
            } else {
                while(E.Top.Y === E.Prev.Bot.Y)E = E.Prev;
                while(E !== Result && E.Dx === ClipperLib.ClipperBase.horizontal)E = E.Next;
            }
            if (E === Result) {
                if (LeftBoundIsForward) Result = E.Next;
                else Result = E.Prev;
            } else {
                //there are more edges in the bound beyond result starting with E
                if (LeftBoundIsForward) E = Result.Next;
                else E = Result.Prev;
                var locMin = new ClipperLib.LocalMinima();
                locMin.Next = null;
                locMin.Y = E.Bot.Y;
                locMin.LeftBound = null;
                locMin.RightBound = E;
                E.WindDelta = 0;
                Result = this.ProcessBound(E, LeftBoundIsForward);
                this.InsertLocalMinima(locMin);
            }
            return Result;
        }
        if (E.Dx === ClipperLib.ClipperBase.horizontal) {
            //We need to be careful with open paths because this may not be a
            //true local minima (ie E may be following a skip edge).
            //Also, consecutive horz. edges may start heading left before going right.
            if (LeftBoundIsForward) EStart = E.Prev;
            else EStart = E.Next;
            if (EStart.Dx === ClipperLib.ClipperBase.horizontal) {
                if (EStart.Bot.X !== E.Bot.X && EStart.Top.X !== E.Bot.X) this.ReverseHorizontal(E);
            } else if (EStart.Bot.X !== E.Bot.X) this.ReverseHorizontal(E);
        }
        EStart = E;
        if (LeftBoundIsForward) {
            while(Result.Top.Y === Result.Next.Bot.Y && Result.Next.OutIdx !== ClipperLib.ClipperBase.Skip)Result = Result.Next;
            if (Result.Dx === ClipperLib.ClipperBase.horizontal && Result.Next.OutIdx !== ClipperLib.ClipperBase.Skip) {
                //nb: at the top of a bound, horizontals are added to the bound
                //only when the preceding edge attaches to the horizontal's left vertex
                //unless a Skip edge is encountered when that becomes the top divide
                Horz = Result;
                while(Horz.Prev.Dx === ClipperLib.ClipperBase.horizontal)Horz = Horz.Prev;
                if (Horz.Prev.Top.X > Result.Next.Top.X) Result = Horz.Prev;
            }
            while(E !== Result){
                E.NextInLML = E.Next;
                if (E.Dx === ClipperLib.ClipperBase.horizontal && E !== EStart && E.Bot.X !== E.Prev.Top.X) this.ReverseHorizontal(E);
                E = E.Next;
            }
            if (E.Dx === ClipperLib.ClipperBase.horizontal && E !== EStart && E.Bot.X !== E.Prev.Top.X) this.ReverseHorizontal(E);
            Result = Result.Next;
        //move to the edge just beyond current bound
        } else {
            while(Result.Top.Y === Result.Prev.Bot.Y && Result.Prev.OutIdx !== ClipperLib.ClipperBase.Skip)Result = Result.Prev;
            if (Result.Dx === ClipperLib.ClipperBase.horizontal && Result.Prev.OutIdx !== ClipperLib.ClipperBase.Skip) {
                Horz = Result;
                while(Horz.Next.Dx === ClipperLib.ClipperBase.horizontal)Horz = Horz.Next;
                if (Horz.Next.Top.X === Result.Prev.Top.X || Horz.Next.Top.X > Result.Prev.Top.X) Result = Horz.Next;
            }
            while(E !== Result){
                E.NextInLML = E.Prev;
                if (E.Dx === ClipperLib.ClipperBase.horizontal && E !== EStart && E.Bot.X !== E.Next.Top.X) this.ReverseHorizontal(E);
                E = E.Prev;
            }
            if (E.Dx === ClipperLib.ClipperBase.horizontal && E !== EStart && E.Bot.X !== E.Next.Top.X) this.ReverseHorizontal(E);
            Result = Result.Prev;
        //move to the edge just beyond current bound
        }
        return Result;
    };
    ClipperLib.ClipperBase.prototype.AddPath = function(pg, polyType, Closed) {
        if (ClipperLib.use_lines) {
            if (!Closed && polyType === ClipperLib.PolyType.ptClip) ClipperLib.Error("AddPath: Open paths must be subject.");
        } else if (!Closed) ClipperLib.Error("AddPath: Open paths have been disabled.");
        var highI = pg.length - 1;
        if (Closed) while(highI > 0 && ClipperLib.IntPoint.op_Equality(pg[highI], pg[0]))--highI;
        while(highI > 0 && ClipperLib.IntPoint.op_Equality(pg[highI], pg[highI - 1]))--highI;
        if (Closed && highI < 2 || !Closed && highI < 1) return false;
        //create a new edge array ...
        var edges = new Array();
        for(var i = 0; i <= highI; i++)edges.push(new ClipperLib.TEdge());
        var IsFlat = true;
        //1. Basic (first) edge initialization ...
        //edges[1].Curr = pg[1];
        edges[1].Curr.X = pg[1].X;
        edges[1].Curr.Y = pg[1].Y;
        if (ClipperLib.use_xyz) edges[1].Curr.Z = pg[1].Z;
        var $1 = {
            Value: this.m_UseFullRange
        };
        this.RangeTest(pg[0], $1);
        this.m_UseFullRange = $1.Value;
        $1.Value = this.m_UseFullRange;
        this.RangeTest(pg[highI], $1);
        this.m_UseFullRange = $1.Value;
        this.InitEdge(edges[0], edges[1], edges[highI], pg[0]);
        this.InitEdge(edges[highI], edges[0], edges[highI - 1], pg[highI]);
        for(var i = highI - 1; i >= 1; --i){
            $1.Value = this.m_UseFullRange;
            this.RangeTest(pg[i], $1);
            this.m_UseFullRange = $1.Value;
            this.InitEdge(edges[i], edges[i + 1], edges[i - 1], pg[i]);
        }
        var eStart = edges[0];
        //2. Remove duplicate vertices, and (when closed) collinear edges ...
        var E = eStart, eLoopStop = eStart;
        for(;;){
            //console.log(E.Next, eStart);
            //nb: allows matching start and end points when not Closed ...
            if (E.Curr === E.Next.Curr && (Closed || E.Next !== eStart)) {
                if (E === E.Next) break;
                if (E === eStart) eStart = E.Next;
                E = this.RemoveEdge(E);
                eLoopStop = E;
                continue;
            }
            if (E.Prev === E.Next) break;
            else if (Closed && ClipperLib.ClipperBase.SlopesEqual4(E.Prev.Curr, E.Curr, E.Next.Curr, this.m_UseFullRange) && (!this.PreserveCollinear || !this.Pt2IsBetweenPt1AndPt3(E.Prev.Curr, E.Curr, E.Next.Curr))) {
                //Collinear edges are allowed for open paths but in closed paths
                //the default is to merge adjacent collinear edges into a single edge.
                //However, if the PreserveCollinear property is enabled, only overlapping
                //collinear edges (ie spikes) will be removed from closed paths.
                if (E === eStart) eStart = E.Next;
                E = this.RemoveEdge(E);
                E = E.Prev;
                eLoopStop = E;
                continue;
            }
            E = E.Next;
            if (E === eLoopStop || !Closed && E.Next === eStart) break;
        }
        if (!Closed && E === E.Next || Closed && E.Prev === E.Next) return false;
        if (!Closed) {
            this.m_HasOpenPaths = true;
            eStart.Prev.OutIdx = ClipperLib.ClipperBase.Skip;
        }
        //3. Do second stage of edge initialization ...
        E = eStart;
        do {
            this.InitEdge2(E, polyType);
            E = E.Next;
            if (IsFlat && E.Curr.Y !== eStart.Curr.Y) IsFlat = false;
        }while (E !== eStart);
        //4. Finally, add edge bounds to LocalMinima list ...
        //Totally flat paths must be handled differently when adding them
        //to LocalMinima list to avoid endless loops etc ...
        if (IsFlat) {
            if (Closed) return false;
            E.Prev.OutIdx = ClipperLib.ClipperBase.Skip;
            var locMin = new ClipperLib.LocalMinima();
            locMin.Next = null;
            locMin.Y = E.Bot.Y;
            locMin.LeftBound = null;
            locMin.RightBound = E;
            locMin.RightBound.Side = ClipperLib.EdgeSide.esRight;
            locMin.RightBound.WindDelta = 0;
            for(;;){
                if (E.Bot.X !== E.Prev.Top.X) this.ReverseHorizontal(E);
                if (E.Next.OutIdx === ClipperLib.ClipperBase.Skip) break;
                E.NextInLML = E.Next;
                E = E.Next;
            }
            this.InsertLocalMinima(locMin);
            this.m_edges.push(edges);
            return true;
        }
        this.m_edges.push(edges);
        var leftBoundIsForward;
        var EMin = null;
        //workaround to avoid an endless loop in the while loop below when
        //open paths have matching start and end points ...
        if (ClipperLib.IntPoint.op_Equality(E.Prev.Bot, E.Prev.Top)) E = E.Next;
        for(;;){
            E = this.FindNextLocMin(E);
            if (E === EMin) break;
            else if (EMin === null) EMin = E;
            //E and E.Prev now share a local minima (left aligned if horizontal).
            //Compare their slopes to find which starts which bound ...
            var locMin = new ClipperLib.LocalMinima();
            locMin.Next = null;
            locMin.Y = E.Bot.Y;
            if (E.Dx < E.Prev.Dx) {
                locMin.LeftBound = E.Prev;
                locMin.RightBound = E;
                leftBoundIsForward = false;
            //Q.nextInLML = Q.prev
            } else {
                locMin.LeftBound = E;
                locMin.RightBound = E.Prev;
                leftBoundIsForward = true;
            //Q.nextInLML = Q.next
            }
            locMin.LeftBound.Side = ClipperLib.EdgeSide.esLeft;
            locMin.RightBound.Side = ClipperLib.EdgeSide.esRight;
            if (!Closed) locMin.LeftBound.WindDelta = 0;
            else if (locMin.LeftBound.Next === locMin.RightBound) locMin.LeftBound.WindDelta = -1;
            else locMin.LeftBound.WindDelta = 1;
            locMin.RightBound.WindDelta = -locMin.LeftBound.WindDelta;
            E = this.ProcessBound(locMin.LeftBound, leftBoundIsForward);
            if (E.OutIdx === ClipperLib.ClipperBase.Skip) E = this.ProcessBound(E, leftBoundIsForward);
            var E2 = this.ProcessBound(locMin.RightBound, !leftBoundIsForward);
            if (E2.OutIdx === ClipperLib.ClipperBase.Skip) E2 = this.ProcessBound(E2, !leftBoundIsForward);
            if (locMin.LeftBound.OutIdx === ClipperLib.ClipperBase.Skip) locMin.LeftBound = null;
            else if (locMin.RightBound.OutIdx === ClipperLib.ClipperBase.Skip) locMin.RightBound = null;
            this.InsertLocalMinima(locMin);
            if (!leftBoundIsForward) E = E2;
        }
        return true;
    };
    ClipperLib.ClipperBase.prototype.AddPaths = function(ppg, polyType, closed) {
        //  console.log("-------------------------------------------");
        //  console.log(JSON.stringify(ppg));
        var result = false;
        for(var i = 0, ilen = ppg.length; i < ilen; ++i)if (this.AddPath(ppg[i], polyType, closed)) result = true;
        return result;
    };
    ClipperLib.ClipperBase.prototype.Pt2IsBetweenPt1AndPt3 = function(pt1, pt2, pt3) {
        if (ClipperLib.IntPoint.op_Equality(pt1, pt3) || ClipperLib.IntPoint.op_Equality(pt1, pt2) || ClipperLib.IntPoint.op_Equality(pt3, pt2)) //if ((pt1 == pt3) || (pt1 == pt2) || (pt3 == pt2))
        return false;
        else if (pt1.X !== pt3.X) return pt2.X > pt1.X === pt2.X < pt3.X;
        else return pt2.Y > pt1.Y === pt2.Y < pt3.Y;
    };
    ClipperLib.ClipperBase.prototype.RemoveEdge = function(e) {
        //removes e from double_linked_list (but without removing from memory)
        e.Prev.Next = e.Next;
        e.Next.Prev = e.Prev;
        var result = e.Next;
        e.Prev = null; //flag as removed (see ClipperBase.Clear)
        return result;
    };
    ClipperLib.ClipperBase.prototype.SetDx = function(e) {
        e.Delta.X = e.Top.X - e.Bot.X;
        e.Delta.Y = e.Top.Y - e.Bot.Y;
        if (e.Delta.Y === 0) e.Dx = ClipperLib.ClipperBase.horizontal;
        else e.Dx = e.Delta.X / e.Delta.Y;
    };
    ClipperLib.ClipperBase.prototype.InsertLocalMinima = function(newLm) {
        if (this.m_MinimaList === null) this.m_MinimaList = newLm;
        else if (newLm.Y >= this.m_MinimaList.Y) {
            newLm.Next = this.m_MinimaList;
            this.m_MinimaList = newLm;
        } else {
            var tmpLm = this.m_MinimaList;
            while(tmpLm.Next !== null && newLm.Y < tmpLm.Next.Y)tmpLm = tmpLm.Next;
            newLm.Next = tmpLm.Next;
            tmpLm.Next = newLm;
        }
    };
    ClipperLib.ClipperBase.prototype.PopLocalMinima = function(Y, current) {
        current.v = this.m_CurrentLM;
        if (this.m_CurrentLM !== null && this.m_CurrentLM.Y === Y) {
            this.m_CurrentLM = this.m_CurrentLM.Next;
            return true;
        }
        return false;
    };
    ClipperLib.ClipperBase.prototype.ReverseHorizontal = function(e) {
        //swap horizontal edges' top and bottom x's so they follow the natural
        //progression of the bounds - ie so their xbots will align with the
        //adjoining lower edge. [Helpful in the ProcessHorizontal() method.]
        var tmp = e.Top.X;
        e.Top.X = e.Bot.X;
        e.Bot.X = tmp;
        if (ClipperLib.use_xyz) {
            tmp = e.Top.Z;
            e.Top.Z = e.Bot.Z;
            e.Bot.Z = tmp;
        }
    };
    ClipperLib.ClipperBase.prototype.Reset = function() {
        this.m_CurrentLM = this.m_MinimaList;
        if (this.m_CurrentLM === null) return;
        //reset all edges ...
        this.m_Scanbeam = null;
        var lm = this.m_MinimaList;
        while(lm !== null){
            this.InsertScanbeam(lm.Y);
            var e = lm.LeftBound;
            if (e !== null) {
                //e.Curr = e.Bot;
                e.Curr.X = e.Bot.X;
                e.Curr.Y = e.Bot.Y;
                if (ClipperLib.use_xyz) e.Curr.Z = e.Bot.Z;
                e.OutIdx = ClipperLib.ClipperBase.Unassigned;
            }
            e = lm.RightBound;
            if (e !== null) {
                //e.Curr = e.Bot;
                e.Curr.X = e.Bot.X;
                e.Curr.Y = e.Bot.Y;
                if (ClipperLib.use_xyz) e.Curr.Z = e.Bot.Z;
                e.OutIdx = ClipperLib.ClipperBase.Unassigned;
            }
            lm = lm.Next;
        }
        this.m_ActiveEdges = null;
    };
    ClipperLib.ClipperBase.prototype.InsertScanbeam = function(Y) {
        //single-linked list: sorted descending, ignoring dups.
        if (this.m_Scanbeam === null) {
            this.m_Scanbeam = new ClipperLib.Scanbeam();
            this.m_Scanbeam.Next = null;
            this.m_Scanbeam.Y = Y;
        } else if (Y > this.m_Scanbeam.Y) {
            var newSb = new ClipperLib.Scanbeam();
            newSb.Y = Y;
            newSb.Next = this.m_Scanbeam;
            this.m_Scanbeam = newSb;
        } else {
            var sb2 = this.m_Scanbeam;
            while(sb2.Next !== null && Y <= sb2.Next.Y)sb2 = sb2.Next;
            if (Y === sb2.Y) return;
             //ie ignores duplicates
            var newSb1 = new ClipperLib.Scanbeam();
            newSb1.Y = Y;
            newSb1.Next = sb2.Next;
            sb2.Next = newSb1;
        }
    };
    ClipperLib.ClipperBase.prototype.PopScanbeam = function(Y) {
        if (this.m_Scanbeam === null) {
            Y.v = 0;
            return false;
        }
        Y.v = this.m_Scanbeam.Y;
        this.m_Scanbeam = this.m_Scanbeam.Next;
        return true;
    };
    ClipperLib.ClipperBase.prototype.LocalMinimaPending = function() {
        return this.m_CurrentLM !== null;
    };
    ClipperLib.ClipperBase.prototype.CreateOutRec = function() {
        var result = new ClipperLib.OutRec();
        result.Idx = ClipperLib.ClipperBase.Unassigned;
        result.IsHole = false;
        result.IsOpen = false;
        result.FirstLeft = null;
        result.Pts = null;
        result.BottomPt = null;
        result.PolyNode = null;
        this.m_PolyOuts.push(result);
        result.Idx = this.m_PolyOuts.length - 1;
        return result;
    };
    ClipperLib.ClipperBase.prototype.DisposeOutRec = function(index) {
        var outRec = this.m_PolyOuts[index];
        outRec.Pts = null;
        outRec = null;
        this.m_PolyOuts[index] = null;
    };
    ClipperLib.ClipperBase.prototype.UpdateEdgeIntoAEL = function(e) {
        if (e.NextInLML === null) ClipperLib.Error("UpdateEdgeIntoAEL: invalid call");
        var AelPrev = e.PrevInAEL;
        var AelNext = e.NextInAEL;
        e.NextInLML.OutIdx = e.OutIdx;
        if (AelPrev !== null) AelPrev.NextInAEL = e.NextInLML;
        else this.m_ActiveEdges = e.NextInLML;
        if (AelNext !== null) AelNext.PrevInAEL = e.NextInLML;
        e.NextInLML.Side = e.Side;
        e.NextInLML.WindDelta = e.WindDelta;
        e.NextInLML.WindCnt = e.WindCnt;
        e.NextInLML.WindCnt2 = e.WindCnt2;
        e = e.NextInLML;
        e.Curr.X = e.Bot.X;
        e.Curr.Y = e.Bot.Y;
        e.PrevInAEL = AelPrev;
        e.NextInAEL = AelNext;
        if (!ClipperLib.ClipperBase.IsHorizontal(e)) this.InsertScanbeam(e.Top.Y);
        return e;
    };
    ClipperLib.ClipperBase.prototype.SwapPositionsInAEL = function(edge1, edge2) {
        //check that one or other edge hasn't already been removed from AEL ...
        if (edge1.NextInAEL === edge1.PrevInAEL || edge2.NextInAEL === edge2.PrevInAEL) return;
        if (edge1.NextInAEL === edge2) {
            var next = edge2.NextInAEL;
            if (next !== null) next.PrevInAEL = edge1;
            var prev = edge1.PrevInAEL;
            if (prev !== null) prev.NextInAEL = edge2;
            edge2.PrevInAEL = prev;
            edge2.NextInAEL = edge1;
            edge1.PrevInAEL = edge2;
            edge1.NextInAEL = next;
        } else if (edge2.NextInAEL === edge1) {
            var next1 = edge1.NextInAEL;
            if (next1 !== null) next1.PrevInAEL = edge2;
            var prev1 = edge2.PrevInAEL;
            if (prev1 !== null) prev1.NextInAEL = edge1;
            edge1.PrevInAEL = prev1;
            edge1.NextInAEL = edge2;
            edge2.PrevInAEL = edge1;
            edge2.NextInAEL = next1;
        } else {
            var next2 = edge1.NextInAEL;
            var prev2 = edge1.PrevInAEL;
            edge1.NextInAEL = edge2.NextInAEL;
            if (edge1.NextInAEL !== null) edge1.NextInAEL.PrevInAEL = edge1;
            edge1.PrevInAEL = edge2.PrevInAEL;
            if (edge1.PrevInAEL !== null) edge1.PrevInAEL.NextInAEL = edge1;
            edge2.NextInAEL = next2;
            if (edge2.NextInAEL !== null) edge2.NextInAEL.PrevInAEL = edge2;
            edge2.PrevInAEL = prev2;
            if (edge2.PrevInAEL !== null) edge2.PrevInAEL.NextInAEL = edge2;
        }
        if (edge1.PrevInAEL === null) this.m_ActiveEdges = edge1;
        else if (edge2.PrevInAEL === null) this.m_ActiveEdges = edge2;
    };
    ClipperLib.ClipperBase.prototype.DeleteFromAEL = function(e) {
        var AelPrev = e.PrevInAEL;
        var AelNext = e.NextInAEL;
        if (AelPrev === null && AelNext === null && e !== this.m_ActiveEdges) return;
         //already deleted
        if (AelPrev !== null) AelPrev.NextInAEL = AelNext;
        else this.m_ActiveEdges = AelNext;
        if (AelNext !== null) AelNext.PrevInAEL = AelPrev;
        e.NextInAEL = null;
        e.PrevInAEL = null;
    };
    // public Clipper(int InitOptions = 0)
    /**
	 * @suppress {missingProperties}
	 */ ClipperLib.Clipper = function(InitOptions) {
        if (typeof InitOptions === "undefined") InitOptions = 0;
        this.m_PolyOuts = null;
        this.m_ClipType = ClipperLib.ClipType.ctIntersection;
        this.m_Scanbeam = null;
        this.m_Maxima = null;
        this.m_ActiveEdges = null;
        this.m_SortedEdges = null;
        this.m_IntersectList = null;
        this.m_IntersectNodeComparer = null;
        this.m_ExecuteLocked = false;
        this.m_ClipFillType = ClipperLib.PolyFillType.pftEvenOdd;
        this.m_SubjFillType = ClipperLib.PolyFillType.pftEvenOdd;
        this.m_Joins = null;
        this.m_GhostJoins = null;
        this.m_UsingPolyTree = false;
        this.ReverseSolution = false;
        this.StrictlySimple = false;
        ClipperLib.ClipperBase.call(this);
        this.m_Scanbeam = null;
        this.m_Maxima = null;
        this.m_ActiveEdges = null;
        this.m_SortedEdges = null;
        this.m_IntersectList = new Array();
        this.m_IntersectNodeComparer = ClipperLib.MyIntersectNodeSort.Compare;
        this.m_ExecuteLocked = false;
        this.m_UsingPolyTree = false;
        this.m_PolyOuts = new Array();
        this.m_Joins = new Array();
        this.m_GhostJoins = new Array();
        this.ReverseSolution = (1 & InitOptions) !== 0;
        this.StrictlySimple = (2 & InitOptions) !== 0;
        this.PreserveCollinear = (4 & InitOptions) !== 0;
        if (ClipperLib.use_xyz) this.ZFillFunction = null; // function (IntPoint vert1, IntPoint vert2, ref IntPoint intersectPt);
    };
    ClipperLib.Clipper.ioReverseSolution = 1;
    ClipperLib.Clipper.ioStrictlySimple = 2;
    ClipperLib.Clipper.ioPreserveCollinear = 4;
    ClipperLib.Clipper.prototype.Clear = function() {
        if (this.m_edges.length === 0) return;
        //avoids problems with ClipperBase destructor
        this.DisposeAllPolyPts();
        ClipperLib.ClipperBase.prototype.Clear.call(this);
    };
    ClipperLib.Clipper.prototype.InsertMaxima = function(X) {
        //double-linked list: sorted ascending, ignoring dups.
        var newMax = new ClipperLib.Maxima();
        newMax.X = X;
        if (this.m_Maxima === null) {
            this.m_Maxima = newMax;
            this.m_Maxima.Next = null;
            this.m_Maxima.Prev = null;
        } else if (X < this.m_Maxima.X) {
            newMax.Next = this.m_Maxima;
            newMax.Prev = null;
            this.m_Maxima = newMax;
        } else {
            var m = this.m_Maxima;
            while(m.Next !== null && X >= m.Next.X)m = m.Next;
            if (X === m.X) return;
             //ie ignores duplicates (& CG to clean up newMax)
            //insert newMax between m and m.Next ...
            newMax.Next = m.Next;
            newMax.Prev = m;
            if (m.Next !== null) m.Next.Prev = newMax;
            m.Next = newMax;
        }
    };
    // ************************************
    ClipperLib.Clipper.prototype.Execute = function() {
        var a = arguments, alen = a.length, ispolytree = a[1] instanceof ClipperLib.PolyTree;
        if (alen === 4 && !ispolytree) {
            var clipType = a[0], solution = a[1], subjFillType = a[2], clipFillType = a[3];
            if (this.m_ExecuteLocked) return false;
            if (this.m_HasOpenPaths) ClipperLib.Error("Error: PolyTree struct is needed for open path clipping.");
            this.m_ExecuteLocked = true;
            ClipperLib.Clear(solution);
            this.m_SubjFillType = subjFillType;
            this.m_ClipFillType = clipFillType;
            this.m_ClipType = clipType;
            this.m_UsingPolyTree = false;
            try {
                var succeeded = this.ExecuteInternal();
                //build the return polygons ...
                if (succeeded) this.BuildResult(solution);
            } finally{
                this.DisposeAllPolyPts();
                this.m_ExecuteLocked = false;
            }
            return succeeded;
        } else if (alen === 4 && ispolytree) {
            var clipType = a[0], polytree = a[1], subjFillType = a[2], clipFillType = a[3];
            if (this.m_ExecuteLocked) return false;
            this.m_ExecuteLocked = true;
            this.m_SubjFillType = subjFillType;
            this.m_ClipFillType = clipFillType;
            this.m_ClipType = clipType;
            this.m_UsingPolyTree = true;
            try {
                var succeeded = this.ExecuteInternal();
                //build the return polygons ...
                if (succeeded) this.BuildResult2(polytree);
            } finally{
                this.DisposeAllPolyPts();
                this.m_ExecuteLocked = false;
            }
            return succeeded;
        } else if (alen === 2 && !ispolytree) {
            var clipType = a[0], solution = a[1];
            return this.Execute(clipType, solution, ClipperLib.PolyFillType.pftEvenOdd, ClipperLib.PolyFillType.pftEvenOdd);
        } else if (alen === 2 && ispolytree) {
            var clipType = a[0], polytree = a[1];
            return this.Execute(clipType, polytree, ClipperLib.PolyFillType.pftEvenOdd, ClipperLib.PolyFillType.pftEvenOdd);
        }
    };
    ClipperLib.Clipper.prototype.FixHoleLinkage = function(outRec) {
        //skip if an outermost polygon or
        //already already points to the correct FirstLeft ...
        if (outRec.FirstLeft === null || outRec.IsHole !== outRec.FirstLeft.IsHole && outRec.FirstLeft.Pts !== null) return;
        var orfl = outRec.FirstLeft;
        while(orfl !== null && (orfl.IsHole === outRec.IsHole || orfl.Pts === null))orfl = orfl.FirstLeft;
        outRec.FirstLeft = orfl;
    };
    ClipperLib.Clipper.prototype.ExecuteInternal = function() {
        try {
            this.Reset();
            this.m_SortedEdges = null;
            this.m_Maxima = null;
            var botY = {}, topY = {};
            if (!this.PopScanbeam(botY)) return false;
            this.InsertLocalMinimaIntoAEL(botY.v);
            while(this.PopScanbeam(topY) || this.LocalMinimaPending()){
                this.ProcessHorizontals();
                this.m_GhostJoins.length = 0;
                if (!this.ProcessIntersections(topY.v)) return false;
                this.ProcessEdgesAtTopOfScanbeam(topY.v);
                botY.v = topY.v;
                this.InsertLocalMinimaIntoAEL(botY.v);
            }
            //fix orientations ...
            var outRec, i, ilen;
            //fix orientations ...
            for(i = 0, ilen = this.m_PolyOuts.length; i < ilen; i++){
                outRec = this.m_PolyOuts[i];
                if (outRec.Pts === null || outRec.IsOpen) continue;
                if ((outRec.IsHole ^ this.ReverseSolution) == this.Area$1(outRec) > 0) this.ReversePolyPtLinks(outRec.Pts);
            }
            this.JoinCommonEdges();
            for(i = 0, ilen = this.m_PolyOuts.length; i < ilen; i++){
                outRec = this.m_PolyOuts[i];
                if (outRec.Pts === null) continue;
                else if (outRec.IsOpen) this.FixupOutPolyline(outRec);
                else this.FixupOutPolygon(outRec);
            }
            if (this.StrictlySimple) this.DoSimplePolygons();
            return true;
        } finally{
            this.m_Joins.length = 0;
            this.m_GhostJoins.length = 0;
        }
    };
    ClipperLib.Clipper.prototype.DisposeAllPolyPts = function() {
        for(var i = 0, ilen = this.m_PolyOuts.length; i < ilen; ++i)this.DisposeOutRec(i);
        ClipperLib.Clear(this.m_PolyOuts);
    };
    ClipperLib.Clipper.prototype.AddJoin = function(Op1, Op2, OffPt) {
        var j = new ClipperLib.Join();
        j.OutPt1 = Op1;
        j.OutPt2 = Op2;
        //j.OffPt = OffPt;
        j.OffPt.X = OffPt.X;
        j.OffPt.Y = OffPt.Y;
        if (ClipperLib.use_xyz) j.OffPt.Z = OffPt.Z;
        this.m_Joins.push(j);
    };
    ClipperLib.Clipper.prototype.AddGhostJoin = function(Op, OffPt) {
        var j = new ClipperLib.Join();
        j.OutPt1 = Op;
        //j.OffPt = OffPt;
        j.OffPt.X = OffPt.X;
        j.OffPt.Y = OffPt.Y;
        if (ClipperLib.use_xyz) j.OffPt.Z = OffPt.Z;
        this.m_GhostJoins.push(j);
    };
    //if (ClipperLib.use_xyz)
    //{
    ClipperLib.Clipper.prototype.SetZ = function(pt, e1, e2) {
        if (this.ZFillFunction !== null) {
            if (pt.Z !== 0 || this.ZFillFunction === null) return;
            else if (ClipperLib.IntPoint.op_Equality(pt, e1.Bot)) pt.Z = e1.Bot.Z;
            else if (ClipperLib.IntPoint.op_Equality(pt, e1.Top)) pt.Z = e1.Top.Z;
            else if (ClipperLib.IntPoint.op_Equality(pt, e2.Bot)) pt.Z = e2.Bot.Z;
            else if (ClipperLib.IntPoint.op_Equality(pt, e2.Top)) pt.Z = e2.Top.Z;
            else this.ZFillFunction(e1.Bot, e1.Top, e2.Bot, e2.Top, pt);
        }
    };
    //}
    ClipperLib.Clipper.prototype.InsertLocalMinimaIntoAEL = function(botY) {
        var lm = {};
        var lb;
        var rb;
        while(this.PopLocalMinima(botY, lm)){
            lb = lm.v.LeftBound;
            rb = lm.v.RightBound;
            var Op1 = null;
            if (lb === null) {
                this.InsertEdgeIntoAEL(rb, null);
                this.SetWindingCount(rb);
                if (this.IsContributing(rb)) Op1 = this.AddOutPt(rb, rb.Bot);
            } else if (rb === null) {
                this.InsertEdgeIntoAEL(lb, null);
                this.SetWindingCount(lb);
                if (this.IsContributing(lb)) Op1 = this.AddOutPt(lb, lb.Bot);
                this.InsertScanbeam(lb.Top.Y);
            } else {
                this.InsertEdgeIntoAEL(lb, null);
                this.InsertEdgeIntoAEL(rb, lb);
                this.SetWindingCount(lb);
                rb.WindCnt = lb.WindCnt;
                rb.WindCnt2 = lb.WindCnt2;
                if (this.IsContributing(lb)) Op1 = this.AddLocalMinPoly(lb, rb, lb.Bot);
                this.InsertScanbeam(lb.Top.Y);
            }
            if (rb !== null) {
                if (ClipperLib.ClipperBase.IsHorizontal(rb)) {
                    if (rb.NextInLML !== null) this.InsertScanbeam(rb.NextInLML.Top.Y);
                    this.AddEdgeToSEL(rb);
                } else this.InsertScanbeam(rb.Top.Y);
            }
            if (lb === null || rb === null) continue;
            //if output polygons share an Edge with a horizontal rb, they'll need joining later ...
            if (Op1 !== null && ClipperLib.ClipperBase.IsHorizontal(rb) && this.m_GhostJoins.length > 0 && rb.WindDelta !== 0) for(var i = 0, ilen = this.m_GhostJoins.length; i < ilen; i++){
                //if the horizontal Rb and a 'ghost' horizontal overlap, then convert
                //the 'ghost' join to a real join ready for later ...
                var j = this.m_GhostJoins[i];
                if (this.HorzSegmentsOverlap(j.OutPt1.Pt.X, j.OffPt.X, rb.Bot.X, rb.Top.X)) this.AddJoin(j.OutPt1, Op1, j.OffPt);
            }
            if (lb.OutIdx >= 0 && lb.PrevInAEL !== null && lb.PrevInAEL.Curr.X === lb.Bot.X && lb.PrevInAEL.OutIdx >= 0 && ClipperLib.ClipperBase.SlopesEqual5(lb.PrevInAEL.Curr, lb.PrevInAEL.Top, lb.Curr, lb.Top, this.m_UseFullRange) && lb.WindDelta !== 0 && lb.PrevInAEL.WindDelta !== 0) {
                var Op2 = this.AddOutPt(lb.PrevInAEL, lb.Bot);
                this.AddJoin(Op1, Op2, lb.Top);
            }
            if (lb.NextInAEL !== rb) {
                if (rb.OutIdx >= 0 && rb.PrevInAEL.OutIdx >= 0 && ClipperLib.ClipperBase.SlopesEqual5(rb.PrevInAEL.Curr, rb.PrevInAEL.Top, rb.Curr, rb.Top, this.m_UseFullRange) && rb.WindDelta !== 0 && rb.PrevInAEL.WindDelta !== 0) {
                    var Op2 = this.AddOutPt(rb.PrevInAEL, rb.Bot);
                    this.AddJoin(Op1, Op2, rb.Top);
                }
                var e = lb.NextInAEL;
                if (e !== null) while(e !== rb){
                    //nb: For calculating winding counts etc, IntersectEdges() assumes
                    //that param1 will be to the right of param2 ABOVE the intersection ...
                    this.IntersectEdges(rb, e, lb.Curr);
                    //order important here
                    e = e.NextInAEL;
                }
            }
        }
    };
    ClipperLib.Clipper.prototype.InsertEdgeIntoAEL = function(edge, startEdge) {
        if (this.m_ActiveEdges === null) {
            edge.PrevInAEL = null;
            edge.NextInAEL = null;
            this.m_ActiveEdges = edge;
        } else if (startEdge === null && this.E2InsertsBeforeE1(this.m_ActiveEdges, edge)) {
            edge.PrevInAEL = null;
            edge.NextInAEL = this.m_ActiveEdges;
            this.m_ActiveEdges.PrevInAEL = edge;
            this.m_ActiveEdges = edge;
        } else {
            if (startEdge === null) startEdge = this.m_ActiveEdges;
            while(startEdge.NextInAEL !== null && !this.E2InsertsBeforeE1(startEdge.NextInAEL, edge))startEdge = startEdge.NextInAEL;
            edge.NextInAEL = startEdge.NextInAEL;
            if (startEdge.NextInAEL !== null) startEdge.NextInAEL.PrevInAEL = edge;
            edge.PrevInAEL = startEdge;
            startEdge.NextInAEL = edge;
        }
    };
    ClipperLib.Clipper.prototype.E2InsertsBeforeE1 = function(e1, e2) {
        if (e2.Curr.X === e1.Curr.X) {
            if (e2.Top.Y > e1.Top.Y) return e2.Top.X < ClipperLib.Clipper.TopX(e1, e2.Top.Y);
            else return e1.Top.X > ClipperLib.Clipper.TopX(e2, e1.Top.Y);
        } else return e2.Curr.X < e1.Curr.X;
    };
    ClipperLib.Clipper.prototype.IsEvenOddFillType = function(edge) {
        if (edge.PolyTyp === ClipperLib.PolyType.ptSubject) return this.m_SubjFillType === ClipperLib.PolyFillType.pftEvenOdd;
        else return this.m_ClipFillType === ClipperLib.PolyFillType.pftEvenOdd;
    };
    ClipperLib.Clipper.prototype.IsEvenOddAltFillType = function(edge) {
        if (edge.PolyTyp === ClipperLib.PolyType.ptSubject) return this.m_ClipFillType === ClipperLib.PolyFillType.pftEvenOdd;
        else return this.m_SubjFillType === ClipperLib.PolyFillType.pftEvenOdd;
    };
    ClipperLib.Clipper.prototype.IsContributing = function(edge) {
        var pft, pft2;
        if (edge.PolyTyp === ClipperLib.PolyType.ptSubject) {
            pft = this.m_SubjFillType;
            pft2 = this.m_ClipFillType;
        } else {
            pft = this.m_ClipFillType;
            pft2 = this.m_SubjFillType;
        }
        switch(pft){
            case ClipperLib.PolyFillType.pftEvenOdd:
                if (edge.WindDelta === 0 && edge.WindCnt !== 1) return false;
                break;
            case ClipperLib.PolyFillType.pftNonZero:
                if (Math.abs(edge.WindCnt) !== 1) return false;
                break;
            case ClipperLib.PolyFillType.pftPositive:
                if (edge.WindCnt !== 1) return false;
                break;
            default:
                if (edge.WindCnt !== -1) return false;
                break;
        }
        switch(this.m_ClipType){
            case ClipperLib.ClipType.ctIntersection:
                switch(pft2){
                    case ClipperLib.PolyFillType.pftEvenOdd:
                    case ClipperLib.PolyFillType.pftNonZero:
                        return edge.WindCnt2 !== 0;
                    case ClipperLib.PolyFillType.pftPositive:
                        return edge.WindCnt2 > 0;
                    default:
                        return edge.WindCnt2 < 0;
                }
            case ClipperLib.ClipType.ctUnion:
                switch(pft2){
                    case ClipperLib.PolyFillType.pftEvenOdd:
                    case ClipperLib.PolyFillType.pftNonZero:
                        return edge.WindCnt2 === 0;
                    case ClipperLib.PolyFillType.pftPositive:
                        return edge.WindCnt2 <= 0;
                    default:
                        return edge.WindCnt2 >= 0;
                }
            case ClipperLib.ClipType.ctDifference:
                if (edge.PolyTyp === ClipperLib.PolyType.ptSubject) switch(pft2){
                    case ClipperLib.PolyFillType.pftEvenOdd:
                    case ClipperLib.PolyFillType.pftNonZero:
                        return edge.WindCnt2 === 0;
                    case ClipperLib.PolyFillType.pftPositive:
                        return edge.WindCnt2 <= 0;
                    default:
                        return edge.WindCnt2 >= 0;
                }
                else switch(pft2){
                    case ClipperLib.PolyFillType.pftEvenOdd:
                    case ClipperLib.PolyFillType.pftNonZero:
                        return edge.WindCnt2 !== 0;
                    case ClipperLib.PolyFillType.pftPositive:
                        return edge.WindCnt2 > 0;
                    default:
                        return edge.WindCnt2 < 0;
                }
            case ClipperLib.ClipType.ctXor:
                if (edge.WindDelta === 0) switch(pft2){
                    case ClipperLib.PolyFillType.pftEvenOdd:
                    case ClipperLib.PolyFillType.pftNonZero:
                        return edge.WindCnt2 === 0;
                    case ClipperLib.PolyFillType.pftPositive:
                        return edge.WindCnt2 <= 0;
                    default:
                        return edge.WindCnt2 >= 0;
                }
                else return true;
        }
        return true;
    };
    ClipperLib.Clipper.prototype.SetWindingCount = function(edge) {
        var e = edge.PrevInAEL;
        //find the edge of the same polytype that immediately preceeds 'edge' in AEL
        while(e !== null && (e.PolyTyp !== edge.PolyTyp || e.WindDelta === 0))e = e.PrevInAEL;
        if (e === null) {
            var pft = edge.PolyTyp === ClipperLib.PolyType.ptSubject ? this.m_SubjFillType : this.m_ClipFillType;
            if (edge.WindDelta === 0) edge.WindCnt = pft === ClipperLib.PolyFillType.pftNegative ? -1 : 1;
            else edge.WindCnt = edge.WindDelta;
            edge.WindCnt2 = 0;
            e = this.m_ActiveEdges;
        //ie get ready to calc WindCnt2
        } else if (edge.WindDelta === 0 && this.m_ClipType !== ClipperLib.ClipType.ctUnion) {
            edge.WindCnt = 1;
            edge.WindCnt2 = e.WindCnt2;
            e = e.NextInAEL;
        //ie get ready to calc WindCnt2
        } else if (this.IsEvenOddFillType(edge)) {
            //EvenOdd filling ...
            if (edge.WindDelta === 0) {
                //are we inside a subj polygon ...
                var Inside = true;
                var e2 = e.PrevInAEL;
                while(e2 !== null){
                    if (e2.PolyTyp === e.PolyTyp && e2.WindDelta !== 0) Inside = !Inside;
                    e2 = e2.PrevInAEL;
                }
                edge.WindCnt = Inside ? 0 : 1;
            } else edge.WindCnt = edge.WindDelta;
            edge.WindCnt2 = e.WindCnt2;
            e = e.NextInAEL;
        //ie get ready to calc WindCnt2
        } else {
            //nonZero, Positive or Negative filling ...
            if (e.WindCnt * e.WindDelta < 0) {
                //prev edge is 'decreasing' WindCount (WC) toward zero
                //so we're outside the previous polygon ...
                if (Math.abs(e.WindCnt) > 1) {
                    //outside prev poly but still inside another.
                    //when reversing direction of prev poly use the same WC
                    if (e.WindDelta * edge.WindDelta < 0) edge.WindCnt = e.WindCnt;
                    else edge.WindCnt = e.WindCnt + edge.WindDelta;
                } else edge.WindCnt = edge.WindDelta === 0 ? 1 : edge.WindDelta;
            } else {
                //prev edge is 'increasing' WindCount (WC) away from zero
                //so we're inside the previous polygon ...
                if (edge.WindDelta === 0) edge.WindCnt = e.WindCnt < 0 ? e.WindCnt - 1 : e.WindCnt + 1;
                else if (e.WindDelta * edge.WindDelta < 0) edge.WindCnt = e.WindCnt;
                else edge.WindCnt = e.WindCnt + edge.WindDelta;
            }
            edge.WindCnt2 = e.WindCnt2;
            e = e.NextInAEL;
        //ie get ready to calc WindCnt2
        }
        //update WindCnt2 ...
        if (this.IsEvenOddAltFillType(edge)) //EvenOdd filling ...
        while(e !== edge){
            if (e.WindDelta !== 0) edge.WindCnt2 = edge.WindCnt2 === 0 ? 1 : 0;
            e = e.NextInAEL;
        }
        else //nonZero, Positive or Negative filling ...
        while(e !== edge){
            edge.WindCnt2 += e.WindDelta;
            e = e.NextInAEL;
        }
    };
    ClipperLib.Clipper.prototype.AddEdgeToSEL = function(edge) {
        //SEL pointers in PEdge are use to build transient lists of horizontal edges.
        //However, since we don't need to worry about processing order, all additions
        //are made to the front of the list ...
        if (this.m_SortedEdges === null) {
            this.m_SortedEdges = edge;
            edge.PrevInSEL = null;
            edge.NextInSEL = null;
        } else {
            edge.NextInSEL = this.m_SortedEdges;
            edge.PrevInSEL = null;
            this.m_SortedEdges.PrevInSEL = edge;
            this.m_SortedEdges = edge;
        }
    };
    ClipperLib.Clipper.prototype.PopEdgeFromSEL = function(e) {
        //Pop edge from front of SEL (ie SEL is a FILO list)
        e.v = this.m_SortedEdges;
        if (e.v === null) return false;
        var oldE = e.v;
        this.m_SortedEdges = e.v.NextInSEL;
        if (this.m_SortedEdges !== null) this.m_SortedEdges.PrevInSEL = null;
        oldE.NextInSEL = null;
        oldE.PrevInSEL = null;
        return true;
    };
    ClipperLib.Clipper.prototype.CopyAELToSEL = function() {
        var e = this.m_ActiveEdges;
        this.m_SortedEdges = e;
        while(e !== null){
            e.PrevInSEL = e.PrevInAEL;
            e.NextInSEL = e.NextInAEL;
            e = e.NextInAEL;
        }
    };
    ClipperLib.Clipper.prototype.SwapPositionsInSEL = function(edge1, edge2) {
        if (edge1.NextInSEL === null && edge1.PrevInSEL === null) return;
        if (edge2.NextInSEL === null && edge2.PrevInSEL === null) return;
        if (edge1.NextInSEL === edge2) {
            var next = edge2.NextInSEL;
            if (next !== null) next.PrevInSEL = edge1;
            var prev = edge1.PrevInSEL;
            if (prev !== null) prev.NextInSEL = edge2;
            edge2.PrevInSEL = prev;
            edge2.NextInSEL = edge1;
            edge1.PrevInSEL = edge2;
            edge1.NextInSEL = next;
        } else if (edge2.NextInSEL === edge1) {
            var next = edge1.NextInSEL;
            if (next !== null) next.PrevInSEL = edge2;
            var prev = edge2.PrevInSEL;
            if (prev !== null) prev.NextInSEL = edge1;
            edge1.PrevInSEL = prev;
            edge1.NextInSEL = edge2;
            edge2.PrevInSEL = edge1;
            edge2.NextInSEL = next;
        } else {
            var next = edge1.NextInSEL;
            var prev = edge1.PrevInSEL;
            edge1.NextInSEL = edge2.NextInSEL;
            if (edge1.NextInSEL !== null) edge1.NextInSEL.PrevInSEL = edge1;
            edge1.PrevInSEL = edge2.PrevInSEL;
            if (edge1.PrevInSEL !== null) edge1.PrevInSEL.NextInSEL = edge1;
            edge2.NextInSEL = next;
            if (edge2.NextInSEL !== null) edge2.NextInSEL.PrevInSEL = edge2;
            edge2.PrevInSEL = prev;
            if (edge2.PrevInSEL !== null) edge2.PrevInSEL.NextInSEL = edge2;
        }
        if (edge1.PrevInSEL === null) this.m_SortedEdges = edge1;
        else if (edge2.PrevInSEL === null) this.m_SortedEdges = edge2;
    };
    ClipperLib.Clipper.prototype.AddLocalMaxPoly = function(e1, e2, pt) {
        this.AddOutPt(e1, pt);
        if (e2.WindDelta === 0) this.AddOutPt(e2, pt);
        if (e1.OutIdx === e2.OutIdx) {
            e1.OutIdx = -1;
            e2.OutIdx = -1;
        } else if (e1.OutIdx < e2.OutIdx) this.AppendPolygon(e1, e2);
        else this.AppendPolygon(e2, e1);
    };
    ClipperLib.Clipper.prototype.AddLocalMinPoly = function(e1, e2, pt) {
        var result;
        var e, prevE;
        if (ClipperLib.ClipperBase.IsHorizontal(e2) || e1.Dx > e2.Dx) {
            result = this.AddOutPt(e1, pt);
            e2.OutIdx = e1.OutIdx;
            e1.Side = ClipperLib.EdgeSide.esLeft;
            e2.Side = ClipperLib.EdgeSide.esRight;
            e = e1;
            if (e.PrevInAEL === e2) prevE = e2.PrevInAEL;
            else prevE = e.PrevInAEL;
        } else {
            result = this.AddOutPt(e2, pt);
            e1.OutIdx = e2.OutIdx;
            e1.Side = ClipperLib.EdgeSide.esRight;
            e2.Side = ClipperLib.EdgeSide.esLeft;
            e = e2;
            if (e.PrevInAEL === e1) prevE = e1.PrevInAEL;
            else prevE = e.PrevInAEL;
        }
        if (prevE !== null && prevE.OutIdx >= 0 && prevE.Top.Y < pt.Y && e.Top.Y < pt.Y) {
            var xPrev = ClipperLib.Clipper.TopX(prevE, pt.Y);
            var xE = ClipperLib.Clipper.TopX(e, pt.Y);
            if (xPrev === xE && e.WindDelta !== 0 && prevE.WindDelta !== 0 && ClipperLib.ClipperBase.SlopesEqual5(new ClipperLib.IntPoint2(xPrev, pt.Y), prevE.Top, new ClipperLib.IntPoint2(xE, pt.Y), e.Top, this.m_UseFullRange)) {
                var outPt = this.AddOutPt(prevE, pt);
                this.AddJoin(result, outPt, e.Top);
            }
        }
        return result;
    };
    ClipperLib.Clipper.prototype.AddOutPt = function(e, pt) {
        if (e.OutIdx < 0) {
            var outRec = this.CreateOutRec();
            outRec.IsOpen = e.WindDelta === 0;
            var newOp = new ClipperLib.OutPt();
            outRec.Pts = newOp;
            newOp.Idx = outRec.Idx;
            //newOp.Pt = pt;
            newOp.Pt.X = pt.X;
            newOp.Pt.Y = pt.Y;
            if (ClipperLib.use_xyz) newOp.Pt.Z = pt.Z;
            newOp.Next = newOp;
            newOp.Prev = newOp;
            if (!outRec.IsOpen) this.SetHoleState(e, outRec);
            e.OutIdx = outRec.Idx;
            //nb: do this after SetZ !
            return newOp;
        } else {
            var outRec = this.m_PolyOuts[e.OutIdx];
            //OutRec.Pts is the 'Left-most' point & OutRec.Pts.Prev is the 'Right-most'
            var op = outRec.Pts;
            var ToFront = e.Side === ClipperLib.EdgeSide.esLeft;
            if (ToFront && ClipperLib.IntPoint.op_Equality(pt, op.Pt)) return op;
            else if (!ToFront && ClipperLib.IntPoint.op_Equality(pt, op.Prev.Pt)) return op.Prev;
            var newOp = new ClipperLib.OutPt();
            newOp.Idx = outRec.Idx;
            //newOp.Pt = pt;
            newOp.Pt.X = pt.X;
            newOp.Pt.Y = pt.Y;
            if (ClipperLib.use_xyz) newOp.Pt.Z = pt.Z;
            newOp.Next = op;
            newOp.Prev = op.Prev;
            newOp.Prev.Next = newOp;
            op.Prev = newOp;
            if (ToFront) outRec.Pts = newOp;
            return newOp;
        }
    };
    ClipperLib.Clipper.prototype.GetLastOutPt = function(e) {
        var outRec = this.m_PolyOuts[e.OutIdx];
        if (e.Side === ClipperLib.EdgeSide.esLeft) return outRec.Pts;
        else return outRec.Pts.Prev;
    };
    ClipperLib.Clipper.prototype.SwapPoints = function(pt1, pt2) {
        var tmp = new ClipperLib.IntPoint1(pt1.Value);
        //pt1.Value = pt2.Value;
        pt1.Value.X = pt2.Value.X;
        pt1.Value.Y = pt2.Value.Y;
        if (ClipperLib.use_xyz) pt1.Value.Z = pt2.Value.Z;
        //pt2.Value = tmp;
        pt2.Value.X = tmp.X;
        pt2.Value.Y = tmp.Y;
        if (ClipperLib.use_xyz) pt2.Value.Z = tmp.Z;
    };
    ClipperLib.Clipper.prototype.HorzSegmentsOverlap = function(seg1a, seg1b, seg2a, seg2b) {
        var tmp;
        if (seg1a > seg1b) {
            tmp = seg1a;
            seg1a = seg1b;
            seg1b = tmp;
        }
        if (seg2a > seg2b) {
            tmp = seg2a;
            seg2a = seg2b;
            seg2b = tmp;
        }
        return seg1a < seg2b && seg2a < seg1b;
    };
    ClipperLib.Clipper.prototype.SetHoleState = function(e, outRec) {
        var e2 = e.PrevInAEL;
        var eTmp = null;
        while(e2 !== null){
            if (e2.OutIdx >= 0 && e2.WindDelta !== 0) {
                if (eTmp === null) eTmp = e2;
                else if (eTmp.OutIdx === e2.OutIdx) eTmp = null; //paired
            }
            e2 = e2.PrevInAEL;
        }
        if (eTmp === null) {
            outRec.FirstLeft = null;
            outRec.IsHole = false;
        } else {
            outRec.FirstLeft = this.m_PolyOuts[eTmp.OutIdx];
            outRec.IsHole = !outRec.FirstLeft.IsHole;
        }
    };
    ClipperLib.Clipper.prototype.GetDx = function(pt1, pt2) {
        if (pt1.Y === pt2.Y) return ClipperLib.ClipperBase.horizontal;
        else return (pt2.X - pt1.X) / (pt2.Y - pt1.Y);
    };
    ClipperLib.Clipper.prototype.FirstIsBottomPt = function(btmPt1, btmPt2) {
        var p = btmPt1.Prev;
        while(ClipperLib.IntPoint.op_Equality(p.Pt, btmPt1.Pt) && p !== btmPt1)p = p.Prev;
        var dx1p = Math.abs(this.GetDx(btmPt1.Pt, p.Pt));
        p = btmPt1.Next;
        while(ClipperLib.IntPoint.op_Equality(p.Pt, btmPt1.Pt) && p !== btmPt1)p = p.Next;
        var dx1n = Math.abs(this.GetDx(btmPt1.Pt, p.Pt));
        p = btmPt2.Prev;
        while(ClipperLib.IntPoint.op_Equality(p.Pt, btmPt2.Pt) && p !== btmPt2)p = p.Prev;
        var dx2p = Math.abs(this.GetDx(btmPt2.Pt, p.Pt));
        p = btmPt2.Next;
        while(ClipperLib.IntPoint.op_Equality(p.Pt, btmPt2.Pt) && p !== btmPt2)p = p.Next;
        var dx2n = Math.abs(this.GetDx(btmPt2.Pt, p.Pt));
        if (Math.max(dx1p, dx1n) === Math.max(dx2p, dx2n) && Math.min(dx1p, dx1n) === Math.min(dx2p, dx2n)) return this.Area(btmPt1) > 0; //if otherwise identical use orientation
        else return dx1p >= dx2p && dx1p >= dx2n || dx1n >= dx2p && dx1n >= dx2n;
    };
    ClipperLib.Clipper.prototype.GetBottomPt = function(pp) {
        var dups = null;
        var p = pp.Next;
        while(p !== pp){
            if (p.Pt.Y > pp.Pt.Y) {
                pp = p;
                dups = null;
            } else if (p.Pt.Y === pp.Pt.Y && p.Pt.X <= pp.Pt.X) {
                if (p.Pt.X < pp.Pt.X) {
                    dups = null;
                    pp = p;
                } else if (p.Next !== pp && p.Prev !== pp) dups = p;
            }
            p = p.Next;
        }
        if (dups !== null) //there appears to be at least 2 vertices at bottomPt so ...
        while(dups !== p){
            if (!this.FirstIsBottomPt(p, dups)) pp = dups;
            dups = dups.Next;
            while(ClipperLib.IntPoint.op_Inequality(dups.Pt, pp.Pt))dups = dups.Next;
        }
        return pp;
    };
    ClipperLib.Clipper.prototype.GetLowermostRec = function(outRec1, outRec2) {
        //work out which polygon fragment has the correct hole state ...
        if (outRec1.BottomPt === null) outRec1.BottomPt = this.GetBottomPt(outRec1.Pts);
        if (outRec2.BottomPt === null) outRec2.BottomPt = this.GetBottomPt(outRec2.Pts);
        var bPt1 = outRec1.BottomPt;
        var bPt2 = outRec2.BottomPt;
        if (bPt1.Pt.Y > bPt2.Pt.Y) return outRec1;
        else if (bPt1.Pt.Y < bPt2.Pt.Y) return outRec2;
        else if (bPt1.Pt.X < bPt2.Pt.X) return outRec1;
        else if (bPt1.Pt.X > bPt2.Pt.X) return outRec2;
        else if (bPt1.Next === bPt1) return outRec2;
        else if (bPt2.Next === bPt2) return outRec1;
        else if (this.FirstIsBottomPt(bPt1, bPt2)) return outRec1;
        else return outRec2;
    };
    ClipperLib.Clipper.prototype.OutRec1RightOfOutRec2 = function(outRec1, outRec2) {
        do {
            outRec1 = outRec1.FirstLeft;
            if (outRec1 === outRec2) return true;
        }while (outRec1 !== null);
        return false;
    };
    ClipperLib.Clipper.prototype.GetOutRec = function(idx) {
        var outrec = this.m_PolyOuts[idx];
        while(outrec !== this.m_PolyOuts[outrec.Idx])outrec = this.m_PolyOuts[outrec.Idx];
        return outrec;
    };
    ClipperLib.Clipper.prototype.AppendPolygon = function(e1, e2) {
        //get the start and ends of both output polygons ...
        var outRec1 = this.m_PolyOuts[e1.OutIdx];
        var outRec2 = this.m_PolyOuts[e2.OutIdx];
        var holeStateRec;
        if (this.OutRec1RightOfOutRec2(outRec1, outRec2)) holeStateRec = outRec2;
        else if (this.OutRec1RightOfOutRec2(outRec2, outRec1)) holeStateRec = outRec1;
        else holeStateRec = this.GetLowermostRec(outRec1, outRec2);
        //get the start and ends of both output polygons and
        //join E2 poly onto E1 poly and delete pointers to E2 ...
        var p1_lft = outRec1.Pts;
        var p1_rt = p1_lft.Prev;
        var p2_lft = outRec2.Pts;
        var p2_rt = p2_lft.Prev;
        //join e2 poly onto e1 poly and delete pointers to e2 ...
        if (e1.Side === ClipperLib.EdgeSide.esLeft) {
            if (e2.Side === ClipperLib.EdgeSide.esLeft) {
                //z y x a b c
                this.ReversePolyPtLinks(p2_lft);
                p2_lft.Next = p1_lft;
                p1_lft.Prev = p2_lft;
                p1_rt.Next = p2_rt;
                p2_rt.Prev = p1_rt;
                outRec1.Pts = p2_rt;
            } else {
                //x y z a b c
                p2_rt.Next = p1_lft;
                p1_lft.Prev = p2_rt;
                p2_lft.Prev = p1_rt;
                p1_rt.Next = p2_lft;
                outRec1.Pts = p2_lft;
            }
        } else if (e2.Side === ClipperLib.EdgeSide.esRight) {
            //a b c z y x
            this.ReversePolyPtLinks(p2_lft);
            p1_rt.Next = p2_rt;
            p2_rt.Prev = p1_rt;
            p2_lft.Next = p1_lft;
            p1_lft.Prev = p2_lft;
        } else {
            //a b c x y z
            p1_rt.Next = p2_lft;
            p2_lft.Prev = p1_rt;
            p1_lft.Prev = p2_rt;
            p2_rt.Next = p1_lft;
        }
        outRec1.BottomPt = null;
        if (holeStateRec === outRec2) {
            if (outRec2.FirstLeft !== outRec1) outRec1.FirstLeft = outRec2.FirstLeft;
            outRec1.IsHole = outRec2.IsHole;
        }
        outRec2.Pts = null;
        outRec2.BottomPt = null;
        outRec2.FirstLeft = outRec1;
        var OKIdx = e1.OutIdx;
        var ObsoleteIdx = e2.OutIdx;
        e1.OutIdx = -1;
        //nb: safe because we only get here via AddLocalMaxPoly
        e2.OutIdx = -1;
        var e = this.m_ActiveEdges;
        while(e !== null){
            if (e.OutIdx === ObsoleteIdx) {
                e.OutIdx = OKIdx;
                e.Side = e1.Side;
                break;
            }
            e = e.NextInAEL;
        }
        outRec2.Idx = outRec1.Idx;
    };
    ClipperLib.Clipper.prototype.ReversePolyPtLinks = function(pp) {
        if (pp === null) return;
        var pp1;
        var pp2;
        pp1 = pp;
        do {
            pp2 = pp1.Next;
            pp1.Next = pp1.Prev;
            pp1.Prev = pp2;
            pp1 = pp2;
        }while (pp1 !== pp);
    };
    ClipperLib.Clipper.SwapSides = function(edge1, edge2) {
        var side = edge1.Side;
        edge1.Side = edge2.Side;
        edge2.Side = side;
    };
    ClipperLib.Clipper.SwapPolyIndexes = function(edge1, edge2) {
        var outIdx = edge1.OutIdx;
        edge1.OutIdx = edge2.OutIdx;
        edge2.OutIdx = outIdx;
    };
    ClipperLib.Clipper.prototype.IntersectEdges = function(e1, e2, pt) {
        //e1 will be to the left of e2 BELOW the intersection. Therefore e1 is before
        //e2 in AEL except when e1 is being inserted at the intersection point ...
        var e1Contributing = e1.OutIdx >= 0;
        var e2Contributing = e2.OutIdx >= 0;
        if (ClipperLib.use_xyz) this.SetZ(pt, e1, e2);
        if (ClipperLib.use_lines) //if either edge is on an OPEN path ...
        {
            if (e1.WindDelta === 0 || e2.WindDelta === 0) {
                //ignore subject-subject open path intersections UNLESS they
                //are both open paths, AND they are both 'contributing maximas' ...
                if (e1.WindDelta === 0 && e2.WindDelta === 0) return;
                else if (e1.PolyTyp === e2.PolyTyp && e1.WindDelta !== e2.WindDelta && this.m_ClipType === ClipperLib.ClipType.ctUnion) {
                    if (e1.WindDelta === 0) {
                        if (e2Contributing) {
                            this.AddOutPt(e1, pt);
                            if (e1Contributing) e1.OutIdx = -1;
                        }
                    } else if (e1Contributing) {
                        this.AddOutPt(e2, pt);
                        if (e2Contributing) e2.OutIdx = -1;
                    }
                } else if (e1.PolyTyp !== e2.PolyTyp) {
                    if (e1.WindDelta === 0 && Math.abs(e2.WindCnt) === 1 && (this.m_ClipType !== ClipperLib.ClipType.ctUnion || e2.WindCnt2 === 0)) {
                        this.AddOutPt(e1, pt);
                        if (e1Contributing) e1.OutIdx = -1;
                    } else if (e2.WindDelta === 0 && Math.abs(e1.WindCnt) === 1 && (this.m_ClipType !== ClipperLib.ClipType.ctUnion || e1.WindCnt2 === 0)) {
                        this.AddOutPt(e2, pt);
                        if (e2Contributing) e2.OutIdx = -1;
                    }
                }
                return;
            }
        }
        //update winding counts...
        //assumes that e1 will be to the Right of e2 ABOVE the intersection
        if (e1.PolyTyp === e2.PolyTyp) {
            if (this.IsEvenOddFillType(e1)) {
                var oldE1WindCnt = e1.WindCnt;
                e1.WindCnt = e2.WindCnt;
                e2.WindCnt = oldE1WindCnt;
            } else {
                if (e1.WindCnt + e2.WindDelta === 0) e1.WindCnt = -e1.WindCnt;
                else e1.WindCnt += e2.WindDelta;
                if (e2.WindCnt - e1.WindDelta === 0) e2.WindCnt = -e2.WindCnt;
                else e2.WindCnt -= e1.WindDelta;
            }
        } else {
            if (!this.IsEvenOddFillType(e2)) e1.WindCnt2 += e2.WindDelta;
            else e1.WindCnt2 = e1.WindCnt2 === 0 ? 1 : 0;
            if (!this.IsEvenOddFillType(e1)) e2.WindCnt2 -= e1.WindDelta;
            else e2.WindCnt2 = e2.WindCnt2 === 0 ? 1 : 0;
        }
        var e1FillType, e2FillType, e1FillType2, e2FillType2;
        if (e1.PolyTyp === ClipperLib.PolyType.ptSubject) {
            e1FillType = this.m_SubjFillType;
            e1FillType2 = this.m_ClipFillType;
        } else {
            e1FillType = this.m_ClipFillType;
            e1FillType2 = this.m_SubjFillType;
        }
        if (e2.PolyTyp === ClipperLib.PolyType.ptSubject) {
            e2FillType = this.m_SubjFillType;
            e2FillType2 = this.m_ClipFillType;
        } else {
            e2FillType = this.m_ClipFillType;
            e2FillType2 = this.m_SubjFillType;
        }
        var e1Wc, e2Wc;
        switch(e1FillType){
            case ClipperLib.PolyFillType.pftPositive:
                e1Wc = e1.WindCnt;
                break;
            case ClipperLib.PolyFillType.pftNegative:
                e1Wc = -e1.WindCnt;
                break;
            default:
                e1Wc = Math.abs(e1.WindCnt);
                break;
        }
        switch(e2FillType){
            case ClipperLib.PolyFillType.pftPositive:
                e2Wc = e2.WindCnt;
                break;
            case ClipperLib.PolyFillType.pftNegative:
                e2Wc = -e2.WindCnt;
                break;
            default:
                e2Wc = Math.abs(e2.WindCnt);
                break;
        }
        if (e1Contributing && e2Contributing) {
            if (e1Wc !== 0 && e1Wc !== 1 || e2Wc !== 0 && e2Wc !== 1 || e1.PolyTyp !== e2.PolyTyp && this.m_ClipType !== ClipperLib.ClipType.ctXor) this.AddLocalMaxPoly(e1, e2, pt);
            else {
                this.AddOutPt(e1, pt);
                this.AddOutPt(e2, pt);
                ClipperLib.Clipper.SwapSides(e1, e2);
                ClipperLib.Clipper.SwapPolyIndexes(e1, e2);
            }
        } else if (e1Contributing) {
            if (e2Wc === 0 || e2Wc === 1) {
                this.AddOutPt(e1, pt);
                ClipperLib.Clipper.SwapSides(e1, e2);
                ClipperLib.Clipper.SwapPolyIndexes(e1, e2);
            }
        } else if (e2Contributing) {
            if (e1Wc === 0 || e1Wc === 1) {
                this.AddOutPt(e2, pt);
                ClipperLib.Clipper.SwapSides(e1, e2);
                ClipperLib.Clipper.SwapPolyIndexes(e1, e2);
            }
        } else if ((e1Wc === 0 || e1Wc === 1) && (e2Wc === 0 || e2Wc === 1)) {
            //neither edge is currently contributing ...
            var e1Wc2, e2Wc2;
            switch(e1FillType2){
                case ClipperLib.PolyFillType.pftPositive:
                    e1Wc2 = e1.WindCnt2;
                    break;
                case ClipperLib.PolyFillType.pftNegative:
                    e1Wc2 = -e1.WindCnt2;
                    break;
                default:
                    e1Wc2 = Math.abs(e1.WindCnt2);
                    break;
            }
            switch(e2FillType2){
                case ClipperLib.PolyFillType.pftPositive:
                    e2Wc2 = e2.WindCnt2;
                    break;
                case ClipperLib.PolyFillType.pftNegative:
                    e2Wc2 = -e2.WindCnt2;
                    break;
                default:
                    e2Wc2 = Math.abs(e2.WindCnt2);
                    break;
            }
            if (e1.PolyTyp !== e2.PolyTyp) this.AddLocalMinPoly(e1, e2, pt);
            else if (e1Wc === 1 && e2Wc === 1) switch(this.m_ClipType){
                case ClipperLib.ClipType.ctIntersection:
                    if (e1Wc2 > 0 && e2Wc2 > 0) this.AddLocalMinPoly(e1, e2, pt);
                    break;
                case ClipperLib.ClipType.ctUnion:
                    if (e1Wc2 <= 0 && e2Wc2 <= 0) this.AddLocalMinPoly(e1, e2, pt);
                    break;
                case ClipperLib.ClipType.ctDifference:
                    if (e1.PolyTyp === ClipperLib.PolyType.ptClip && e1Wc2 > 0 && e2Wc2 > 0 || e1.PolyTyp === ClipperLib.PolyType.ptSubject && e1Wc2 <= 0 && e2Wc2 <= 0) this.AddLocalMinPoly(e1, e2, pt);
                    break;
                case ClipperLib.ClipType.ctXor:
                    this.AddLocalMinPoly(e1, e2, pt);
                    break;
            }
            else ClipperLib.Clipper.SwapSides(e1, e2);
        }
    };
    ClipperLib.Clipper.prototype.DeleteFromSEL = function(e) {
        var SelPrev = e.PrevInSEL;
        var SelNext = e.NextInSEL;
        if (SelPrev === null && SelNext === null && e !== this.m_SortedEdges) return;
        //already deleted
        if (SelPrev !== null) SelPrev.NextInSEL = SelNext;
        else this.m_SortedEdges = SelNext;
        if (SelNext !== null) SelNext.PrevInSEL = SelPrev;
        e.NextInSEL = null;
        e.PrevInSEL = null;
    };
    ClipperLib.Clipper.prototype.ProcessHorizontals = function() {
        var horzEdge = {}; //m_SortedEdges;
        while(this.PopEdgeFromSEL(horzEdge))this.ProcessHorizontal(horzEdge.v);
    };
    ClipperLib.Clipper.prototype.GetHorzDirection = function(HorzEdge, $var) {
        if (HorzEdge.Bot.X < HorzEdge.Top.X) {
            $var.Left = HorzEdge.Bot.X;
            $var.Right = HorzEdge.Top.X;
            $var.Dir = ClipperLib.Direction.dLeftToRight;
        } else {
            $var.Left = HorzEdge.Top.X;
            $var.Right = HorzEdge.Bot.X;
            $var.Dir = ClipperLib.Direction.dRightToLeft;
        }
    };
    ClipperLib.Clipper.prototype.ProcessHorizontal = function(horzEdge) {
        var $var = {
            Dir: null,
            Left: null,
            Right: null
        };
        this.GetHorzDirection(horzEdge, $var);
        var dir = $var.Dir;
        var horzLeft = $var.Left;
        var horzRight = $var.Right;
        var IsOpen = horzEdge.WindDelta === 0;
        var eLastHorz = horzEdge, eMaxPair = null;
        while(eLastHorz.NextInLML !== null && ClipperLib.ClipperBase.IsHorizontal(eLastHorz.NextInLML))eLastHorz = eLastHorz.NextInLML;
        if (eLastHorz.NextInLML === null) eMaxPair = this.GetMaximaPair(eLastHorz);
        var currMax = this.m_Maxima;
        if (currMax !== null) {
            //get the first maxima in range (X) ...
            if (dir === ClipperLib.Direction.dLeftToRight) {
                while(currMax !== null && currMax.X <= horzEdge.Bot.X)currMax = currMax.Next;
                if (currMax !== null && currMax.X >= eLastHorz.Top.X) currMax = null;
            } else {
                while(currMax.Next !== null && currMax.Next.X < horzEdge.Bot.X)currMax = currMax.Next;
                if (currMax.X <= eLastHorz.Top.X) currMax = null;
            }
        }
        var op1 = null;
        for(;;){
            var IsLastHorz = horzEdge === eLastHorz;
            var e = this.GetNextInAEL(horzEdge, dir);
            while(e !== null){
                //this code block inserts extra coords into horizontal edges (in output
                //polygons) whereever maxima touch these horizontal edges. This helps
                //'simplifying' polygons (ie if the Simplify property is set).
                if (currMax !== null) {
                    if (dir === ClipperLib.Direction.dLeftToRight) while(currMax !== null && currMax.X < e.Curr.X){
                        if (horzEdge.OutIdx >= 0 && !IsOpen) this.AddOutPt(horzEdge, new ClipperLib.IntPoint2(currMax.X, horzEdge.Bot.Y));
                        currMax = currMax.Next;
                    }
                    else while(currMax !== null && currMax.X > e.Curr.X){
                        if (horzEdge.OutIdx >= 0 && !IsOpen) this.AddOutPt(horzEdge, new ClipperLib.IntPoint2(currMax.X, horzEdge.Bot.Y));
                        currMax = currMax.Prev;
                    }
                }
                if (dir === ClipperLib.Direction.dLeftToRight && e.Curr.X > horzRight || dir === ClipperLib.Direction.dRightToLeft && e.Curr.X < horzLeft) break;
                //Also break if we've got to the end of an intermediate horizontal edge ...
                //nb: Smaller Dx's are to the right of larger Dx's ABOVE the horizontal.
                if (e.Curr.X === horzEdge.Top.X && horzEdge.NextInLML !== null && e.Dx < horzEdge.NextInLML.Dx) break;
                if (horzEdge.OutIdx >= 0 && !IsOpen) {
                    if (ClipperLib.use_xyz) {
                        if (dir === ClipperLib.Direction.dLeftToRight) this.SetZ(e.Curr, horzEdge, e);
                        else this.SetZ(e.Curr, e, horzEdge);
                    }
                    op1 = this.AddOutPt(horzEdge, e.Curr);
                    var eNextHorz = this.m_SortedEdges;
                    while(eNextHorz !== null){
                        if (eNextHorz.OutIdx >= 0 && this.HorzSegmentsOverlap(horzEdge.Bot.X, horzEdge.Top.X, eNextHorz.Bot.X, eNextHorz.Top.X)) {
                            var op2 = this.GetLastOutPt(eNextHorz);
                            this.AddJoin(op2, op1, eNextHorz.Top);
                        }
                        eNextHorz = eNextHorz.NextInSEL;
                    }
                    this.AddGhostJoin(op1, horzEdge.Bot);
                }
                //OK, so far we're still in range of the horizontal Edge  but make sure
                //we're at the last of consec. horizontals when matching with eMaxPair
                if (e === eMaxPair && IsLastHorz) {
                    if (horzEdge.OutIdx >= 0) this.AddLocalMaxPoly(horzEdge, eMaxPair, horzEdge.Top);
                    this.DeleteFromAEL(horzEdge);
                    this.DeleteFromAEL(eMaxPair);
                    return;
                }
                if (dir === ClipperLib.Direction.dLeftToRight) {
                    var Pt = new ClipperLib.IntPoint2(e.Curr.X, horzEdge.Curr.Y);
                    this.IntersectEdges(horzEdge, e, Pt);
                } else {
                    var Pt = new ClipperLib.IntPoint2(e.Curr.X, horzEdge.Curr.Y);
                    this.IntersectEdges(e, horzEdge, Pt);
                }
                var eNext = this.GetNextInAEL(e, dir);
                this.SwapPositionsInAEL(horzEdge, e);
                e = eNext;
            } //end while(e !== null)
            //Break out of loop if HorzEdge.NextInLML is not also horizontal ...
            if (horzEdge.NextInLML === null || !ClipperLib.ClipperBase.IsHorizontal(horzEdge.NextInLML)) break;
            horzEdge = this.UpdateEdgeIntoAEL(horzEdge);
            if (horzEdge.OutIdx >= 0) this.AddOutPt(horzEdge, horzEdge.Bot);
            $var = {
                Dir: dir,
                Left: horzLeft,
                Right: horzRight
            };
            this.GetHorzDirection(horzEdge, $var);
            dir = $var.Dir;
            horzLeft = $var.Left;
            horzRight = $var.Right;
        } //end for (;;)
        if (horzEdge.OutIdx >= 0 && op1 === null) {
            op1 = this.GetLastOutPt(horzEdge);
            var eNextHorz = this.m_SortedEdges;
            while(eNextHorz !== null){
                if (eNextHorz.OutIdx >= 0 && this.HorzSegmentsOverlap(horzEdge.Bot.X, horzEdge.Top.X, eNextHorz.Bot.X, eNextHorz.Top.X)) {
                    var op2 = this.GetLastOutPt(eNextHorz);
                    this.AddJoin(op2, op1, eNextHorz.Top);
                }
                eNextHorz = eNextHorz.NextInSEL;
            }
            this.AddGhostJoin(op1, horzEdge.Top);
        }
        if (horzEdge.NextInLML !== null) {
            if (horzEdge.OutIdx >= 0) {
                op1 = this.AddOutPt(horzEdge, horzEdge.Top);
                horzEdge = this.UpdateEdgeIntoAEL(horzEdge);
                if (horzEdge.WindDelta === 0) return;
                //nb: HorzEdge is no longer horizontal here
                var ePrev = horzEdge.PrevInAEL;
                var eNext = horzEdge.NextInAEL;
                if (ePrev !== null && ePrev.Curr.X === horzEdge.Bot.X && ePrev.Curr.Y === horzEdge.Bot.Y && ePrev.WindDelta === 0 && ePrev.OutIdx >= 0 && ePrev.Curr.Y > ePrev.Top.Y && ClipperLib.ClipperBase.SlopesEqual3(horzEdge, ePrev, this.m_UseFullRange)) {
                    var op2 = this.AddOutPt(ePrev, horzEdge.Bot);
                    this.AddJoin(op1, op2, horzEdge.Top);
                } else if (eNext !== null && eNext.Curr.X === horzEdge.Bot.X && eNext.Curr.Y === horzEdge.Bot.Y && eNext.WindDelta !== 0 && eNext.OutIdx >= 0 && eNext.Curr.Y > eNext.Top.Y && ClipperLib.ClipperBase.SlopesEqual3(horzEdge, eNext, this.m_UseFullRange)) {
                    var op2 = this.AddOutPt(eNext, horzEdge.Bot);
                    this.AddJoin(op1, op2, horzEdge.Top);
                }
            } else horzEdge = this.UpdateEdgeIntoAEL(horzEdge);
        } else {
            if (horzEdge.OutIdx >= 0) this.AddOutPt(horzEdge, horzEdge.Top);
            this.DeleteFromAEL(horzEdge);
        }
    };
    ClipperLib.Clipper.prototype.GetNextInAEL = function(e, Direction) {
        return Direction === ClipperLib.Direction.dLeftToRight ? e.NextInAEL : e.PrevInAEL;
    };
    ClipperLib.Clipper.prototype.IsMinima = function(e) {
        return e !== null && e.Prev.NextInLML !== e && e.Next.NextInLML !== e;
    };
    ClipperLib.Clipper.prototype.IsMaxima = function(e, Y) {
        return e !== null && e.Top.Y === Y && e.NextInLML === null;
    };
    ClipperLib.Clipper.prototype.IsIntermediate = function(e, Y) {
        return e.Top.Y === Y && e.NextInLML !== null;
    };
    ClipperLib.Clipper.prototype.GetMaximaPair = function(e) {
        if (ClipperLib.IntPoint.op_Equality(e.Next.Top, e.Top) && e.Next.NextInLML === null) return e.Next;
        else {
            if (ClipperLib.IntPoint.op_Equality(e.Prev.Top, e.Top) && e.Prev.NextInLML === null) return e.Prev;
            else return null;
        }
    };
    ClipperLib.Clipper.prototype.GetMaximaPairEx = function(e) {
        //as above but returns null if MaxPair isn't in AEL (unless it's horizontal)
        var result = this.GetMaximaPair(e);
        if (result === null || result.OutIdx === ClipperLib.ClipperBase.Skip || result.NextInAEL === result.PrevInAEL && !ClipperLib.ClipperBase.IsHorizontal(result)) return null;
        return result;
    };
    ClipperLib.Clipper.prototype.ProcessIntersections = function(topY) {
        if (this.m_ActiveEdges === null) return true;
        try {
            this.BuildIntersectList(topY);
            if (this.m_IntersectList.length === 0) return true;
            if (this.m_IntersectList.length === 1 || this.FixupIntersectionOrder()) this.ProcessIntersectList();
            else return false;
        } catch ($$e2) {
            this.m_SortedEdges = null;
            this.m_IntersectList.length = 0;
            ClipperLib.Error("ProcessIntersections error");
        }
        this.m_SortedEdges = null;
        return true;
    };
    ClipperLib.Clipper.prototype.BuildIntersectList = function(topY) {
        if (this.m_ActiveEdges === null) return;
        //prepare for sorting ...
        var e = this.m_ActiveEdges;
        //console.log(JSON.stringify(JSON.decycle( e )));
        this.m_SortedEdges = e;
        while(e !== null){
            e.PrevInSEL = e.PrevInAEL;
            e.NextInSEL = e.NextInAEL;
            e.Curr.X = ClipperLib.Clipper.TopX(e, topY);
            e = e.NextInAEL;
        }
        //bubblesort ...
        var isModified = true;
        while(isModified && this.m_SortedEdges !== null){
            isModified = false;
            e = this.m_SortedEdges;
            while(e.NextInSEL !== null){
                var eNext = e.NextInSEL;
                var pt = new ClipperLib.IntPoint0();
                //console.log("e.Curr.X: " + e.Curr.X + " eNext.Curr.X" + eNext.Curr.X);
                if (e.Curr.X > eNext.Curr.X) {
                    this.IntersectPoint(e, eNext, pt);
                    if (pt.Y < topY) pt = new ClipperLib.IntPoint2(ClipperLib.Clipper.TopX(e, topY), topY);
                    var newNode = new ClipperLib.IntersectNode();
                    newNode.Edge1 = e;
                    newNode.Edge2 = eNext;
                    //newNode.Pt = pt;
                    newNode.Pt.X = pt.X;
                    newNode.Pt.Y = pt.Y;
                    if (ClipperLib.use_xyz) newNode.Pt.Z = pt.Z;
                    this.m_IntersectList.push(newNode);
                    this.SwapPositionsInSEL(e, eNext);
                    isModified = true;
                } else e = eNext;
            }
            if (e.PrevInSEL !== null) e.PrevInSEL.NextInSEL = null;
            else break;
        }
        this.m_SortedEdges = null;
    };
    ClipperLib.Clipper.prototype.EdgesAdjacent = function(inode) {
        return inode.Edge1.NextInSEL === inode.Edge2 || inode.Edge1.PrevInSEL === inode.Edge2;
    };
    ClipperLib.Clipper.IntersectNodeSort = function(node1, node2) {
        //the following typecast is safe because the differences in Pt.Y will
        //be limited to the height of the scanbeam.
        return node2.Pt.Y - node1.Pt.Y;
    };
    ClipperLib.Clipper.prototype.FixupIntersectionOrder = function() {
        //pre-condition: intersections are sorted bottom-most first.
        //Now it's crucial that intersections are made only between adjacent edges,
        //so to ensure this the order of intersections may need adjusting ...
        this.m_IntersectList.sort(this.m_IntersectNodeComparer);
        this.CopyAELToSEL();
        var cnt = this.m_IntersectList.length;
        for(var i = 0; i < cnt; i++){
            if (!this.EdgesAdjacent(this.m_IntersectList[i])) {
                var j = i + 1;
                while(j < cnt && !this.EdgesAdjacent(this.m_IntersectList[j]))j++;
                if (j === cnt) return false;
                var tmp = this.m_IntersectList[i];
                this.m_IntersectList[i] = this.m_IntersectList[j];
                this.m_IntersectList[j] = tmp;
            }
            this.SwapPositionsInSEL(this.m_IntersectList[i].Edge1, this.m_IntersectList[i].Edge2);
        }
        return true;
    };
    ClipperLib.Clipper.prototype.ProcessIntersectList = function() {
        for(var i = 0, ilen = this.m_IntersectList.length; i < ilen; i++){
            var iNode = this.m_IntersectList[i];
            this.IntersectEdges(iNode.Edge1, iNode.Edge2, iNode.Pt);
            this.SwapPositionsInAEL(iNode.Edge1, iNode.Edge2);
        }
        this.m_IntersectList.length = 0;
    };
    /*
	--------------------------------
	Round speedtest: http://jsperf.com/fastest-round
	--------------------------------
	*/ var R1 = function(a) {
        return a < 0 ? Math.ceil(a - 0.5) : Math.round(a);
    };
    var R2 = function(a) {
        return a < 0 ? Math.ceil(a - 0.5) : Math.floor(a + 0.5);
    };
    var R3 = function(a) {
        return a < 0 ? -Math.round(Math.abs(a)) : Math.round(a);
    };
    var R4 = function(a) {
        if (a < 0) {
            a -= 0.5;
            return a < -2147483648 ? Math.ceil(a) : a | 0;
        } else {
            a += 0.5;
            return a > 2147483647 ? Math.floor(a) : a | 0;
        }
    };
    if (browser.msie) ClipperLib.Clipper.Round = R1;
    else if (browser.chromium) ClipperLib.Clipper.Round = R3;
    else if (browser.safari) ClipperLib.Clipper.Round = R4;
    else ClipperLib.Clipper.Round = R2; // eg. browser.chrome || browser.firefox || browser.opera
    ClipperLib.Clipper.TopX = function(edge, currentY) {
        //if (edge.Bot == edge.Curr) alert ("edge.Bot = edge.Curr");
        //if (edge.Bot == edge.Top) alert ("edge.Bot = edge.Top");
        if (currentY === edge.Top.Y) return edge.Top.X;
        return edge.Bot.X + ClipperLib.Clipper.Round(edge.Dx * (currentY - edge.Bot.Y));
    };
    ClipperLib.Clipper.prototype.IntersectPoint = function(edge1, edge2, ip) {
        ip.X = 0;
        ip.Y = 0;
        var b1, b2;
        //nb: with very large coordinate values, it's possible for SlopesEqual() to
        //return false but for the edge.Dx value be equal due to double precision rounding.
        if (edge1.Dx === edge2.Dx) {
            ip.Y = edge1.Curr.Y;
            ip.X = ClipperLib.Clipper.TopX(edge1, ip.Y);
            return;
        }
        if (edge1.Delta.X === 0) {
            ip.X = edge1.Bot.X;
            if (ClipperLib.ClipperBase.IsHorizontal(edge2)) ip.Y = edge2.Bot.Y;
            else {
                b2 = edge2.Bot.Y - edge2.Bot.X / edge2.Dx;
                ip.Y = ClipperLib.Clipper.Round(ip.X / edge2.Dx + b2);
            }
        } else if (edge2.Delta.X === 0) {
            ip.X = edge2.Bot.X;
            if (ClipperLib.ClipperBase.IsHorizontal(edge1)) ip.Y = edge1.Bot.Y;
            else {
                b1 = edge1.Bot.Y - edge1.Bot.X / edge1.Dx;
                ip.Y = ClipperLib.Clipper.Round(ip.X / edge1.Dx + b1);
            }
        } else {
            b1 = edge1.Bot.X - edge1.Bot.Y * edge1.Dx;
            b2 = edge2.Bot.X - edge2.Bot.Y * edge2.Dx;
            var q = (b2 - b1) / (edge1.Dx - edge2.Dx);
            ip.Y = ClipperLib.Clipper.Round(q);
            if (Math.abs(edge1.Dx) < Math.abs(edge2.Dx)) ip.X = ClipperLib.Clipper.Round(edge1.Dx * q + b1);
            else ip.X = ClipperLib.Clipper.Round(edge2.Dx * q + b2);
        }
        if (ip.Y < edge1.Top.Y || ip.Y < edge2.Top.Y) {
            if (edge1.Top.Y > edge2.Top.Y) {
                ip.Y = edge1.Top.Y;
                ip.X = ClipperLib.Clipper.TopX(edge2, edge1.Top.Y);
                return ip.X < edge1.Top.X;
            } else ip.Y = edge2.Top.Y;
            if (Math.abs(edge1.Dx) < Math.abs(edge2.Dx)) ip.X = ClipperLib.Clipper.TopX(edge1, ip.Y);
            else ip.X = ClipperLib.Clipper.TopX(edge2, ip.Y);
        }
        //finally, don't allow 'ip' to be BELOW curr.Y (ie bottom of scanbeam) ...
        if (ip.Y > edge1.Curr.Y) {
            ip.Y = edge1.Curr.Y;
            //better to use the more vertical edge to derive X ...
            if (Math.abs(edge1.Dx) > Math.abs(edge2.Dx)) ip.X = ClipperLib.Clipper.TopX(edge2, ip.Y);
            else ip.X = ClipperLib.Clipper.TopX(edge1, ip.Y);
        }
    };
    ClipperLib.Clipper.prototype.ProcessEdgesAtTopOfScanbeam = function(topY) {
        var e = this.m_ActiveEdges;
        while(e !== null){
            //1. process maxima, treating them as if they're 'bent' horizontal edges,
            //   but exclude maxima with horizontal edges. nb: e can't be a horizontal.
            var IsMaximaEdge = this.IsMaxima(e, topY);
            if (IsMaximaEdge) {
                var eMaxPair = this.GetMaximaPairEx(e);
                IsMaximaEdge = eMaxPair === null || !ClipperLib.ClipperBase.IsHorizontal(eMaxPair);
            }
            if (IsMaximaEdge) {
                if (this.StrictlySimple) this.InsertMaxima(e.Top.X);
                var ePrev = e.PrevInAEL;
                this.DoMaxima(e);
                if (ePrev === null) e = this.m_ActiveEdges;
                else e = ePrev.NextInAEL;
            } else {
                //2. promote horizontal edges, otherwise update Curr.X and Curr.Y ...
                if (this.IsIntermediate(e, topY) && ClipperLib.ClipperBase.IsHorizontal(e.NextInLML)) {
                    e = this.UpdateEdgeIntoAEL(e);
                    if (e.OutIdx >= 0) this.AddOutPt(e, e.Bot);
                    this.AddEdgeToSEL(e);
                } else {
                    e.Curr.X = ClipperLib.Clipper.TopX(e, topY);
                    e.Curr.Y = topY;
                }
                if (ClipperLib.use_xyz) {
                    if (e.Top.Y === topY) e.Curr.Z = e.Top.Z;
                    else if (e.Bot.Y === topY) e.Curr.Z = e.Bot.Z;
                    else e.Curr.Z = 0;
                }
                //When StrictlySimple and 'e' is being touched by another edge, then
                //make sure both edges have a vertex here ...
                if (this.StrictlySimple) {
                    var ePrev = e.PrevInAEL;
                    if (e.OutIdx >= 0 && e.WindDelta !== 0 && ePrev !== null && ePrev.OutIdx >= 0 && ePrev.Curr.X === e.Curr.X && ePrev.WindDelta !== 0) {
                        var ip = new ClipperLib.IntPoint1(e.Curr);
                        if (ClipperLib.use_xyz) this.SetZ(ip, ePrev, e);
                        var op = this.AddOutPt(ePrev, ip);
                        var op2 = this.AddOutPt(e, ip);
                        this.AddJoin(op, op2, ip); //StrictlySimple (type-3) join
                    }
                }
                e = e.NextInAEL;
            }
        }
        //3. Process horizontals at the Top of the scanbeam ...
        this.ProcessHorizontals();
        this.m_Maxima = null;
        //4. Promote intermediate vertices ...
        e = this.m_ActiveEdges;
        while(e !== null){
            if (this.IsIntermediate(e, topY)) {
                var op = null;
                if (e.OutIdx >= 0) op = this.AddOutPt(e, e.Top);
                e = this.UpdateEdgeIntoAEL(e);
                //if output polygons share an edge, they'll need joining later ...
                var ePrev = e.PrevInAEL;
                var eNext = e.NextInAEL;
                if (ePrev !== null && ePrev.Curr.X === e.Bot.X && ePrev.Curr.Y === e.Bot.Y && op !== null && ePrev.OutIdx >= 0 && ePrev.Curr.Y === ePrev.Top.Y && ClipperLib.ClipperBase.SlopesEqual5(e.Curr, e.Top, ePrev.Curr, ePrev.Top, this.m_UseFullRange) && e.WindDelta !== 0 && ePrev.WindDelta !== 0) {
                    var op2 = this.AddOutPt(ePrev2, e.Bot);
                    this.AddJoin(op, op2, e.Top);
                } else if (eNext !== null && eNext.Curr.X === e.Bot.X && eNext.Curr.Y === e.Bot.Y && op !== null && eNext.OutIdx >= 0 && eNext.Curr.Y === eNext.Top.Y && ClipperLib.ClipperBase.SlopesEqual5(e.Curr, e.Top, eNext.Curr, eNext.Top, this.m_UseFullRange) && e.WindDelta !== 0 && eNext.WindDelta !== 0) {
                    var op2 = this.AddOutPt(eNext, e.Bot);
                    this.AddJoin(op, op2, e.Top);
                }
            }
            e = e.NextInAEL;
        }
    };
    ClipperLib.Clipper.prototype.DoMaxima = function(e) {
        var eMaxPair = this.GetMaximaPairEx(e);
        if (eMaxPair === null) {
            if (e.OutIdx >= 0) this.AddOutPt(e, e.Top);
            this.DeleteFromAEL(e);
            return;
        }
        var eNext = e.NextInAEL;
        while(eNext !== null && eNext !== eMaxPair){
            this.IntersectEdges(e, eNext, e.Top);
            this.SwapPositionsInAEL(e, eNext);
            eNext = e.NextInAEL;
        }
        if (e.OutIdx === -1 && eMaxPair.OutIdx === -1) {
            this.DeleteFromAEL(e);
            this.DeleteFromAEL(eMaxPair);
        } else if (e.OutIdx >= 0 && eMaxPair.OutIdx >= 0) {
            if (e.OutIdx >= 0) this.AddLocalMaxPoly(e, eMaxPair, e.Top);
            this.DeleteFromAEL(e);
            this.DeleteFromAEL(eMaxPair);
        } else if (ClipperLib.use_lines && e.WindDelta === 0) {
            if (e.OutIdx >= 0) {
                this.AddOutPt(e, e.Top);
                e.OutIdx = ClipperLib.ClipperBase.Unassigned;
            }
            this.DeleteFromAEL(e);
            if (eMaxPair.OutIdx >= 0) {
                this.AddOutPt(eMaxPair, e.Top);
                eMaxPair.OutIdx = ClipperLib.ClipperBase.Unassigned;
            }
            this.DeleteFromAEL(eMaxPair);
        } else ClipperLib.Error("DoMaxima error");
    };
    ClipperLib.Clipper.ReversePaths = function(polys) {
        for(var i = 0, len = polys.length; i < len; i++)polys[i].reverse();
    };
    ClipperLib.Clipper.Orientation = function(poly) {
        return ClipperLib.Clipper.Area(poly) >= 0;
    };
    ClipperLib.Clipper.prototype.PointCount = function(pts) {
        if (pts === null) return 0;
        var result = 0;
        var p = pts;
        do {
            result++;
            p = p.Next;
        }while (p !== pts);
        return result;
    };
    ClipperLib.Clipper.prototype.BuildResult = function(polyg) {
        ClipperLib.Clear(polyg);
        for(var i = 0, ilen = this.m_PolyOuts.length; i < ilen; i++){
            var outRec = this.m_PolyOuts[i];
            if (outRec.Pts === null) continue;
            var p = outRec.Pts.Prev;
            var cnt = this.PointCount(p);
            if (cnt < 2) continue;
            var pg = new Array(cnt);
            for(var j = 0; j < cnt; j++){
                pg[j] = p.Pt;
                p = p.Prev;
            }
            polyg.push(pg);
        }
    };
    ClipperLib.Clipper.prototype.BuildResult2 = function(polytree) {
        polytree.Clear();
        //add each output polygon/contour to polytree ...
        //polytree.m_AllPolys.set_Capacity(this.m_PolyOuts.length);
        for(var i = 0, ilen = this.m_PolyOuts.length; i < ilen; i++){
            var outRec = this.m_PolyOuts[i];
            var cnt = this.PointCount(outRec.Pts);
            if (outRec.IsOpen && cnt < 2 || !outRec.IsOpen && cnt < 3) continue;
            this.FixHoleLinkage(outRec);
            var pn = new ClipperLib.PolyNode();
            polytree.m_AllPolys.push(pn);
            outRec.PolyNode = pn;
            pn.m_polygon.length = cnt;
            var op = outRec.Pts.Prev;
            for(var j = 0; j < cnt; j++){
                pn.m_polygon[j] = op.Pt;
                op = op.Prev;
            }
        }
        //fixup PolyNode links etc ...
        //polytree.m_Childs.set_Capacity(this.m_PolyOuts.length);
        for(var i = 0, ilen = this.m_PolyOuts.length; i < ilen; i++){
            var outRec = this.m_PolyOuts[i];
            if (outRec.PolyNode === null) continue;
            else if (outRec.IsOpen) {
                outRec.PolyNode.IsOpen = true;
                polytree.AddChild(outRec.PolyNode);
            } else if (outRec.FirstLeft !== null && outRec.FirstLeft.PolyNode !== null) outRec.FirstLeft.PolyNode.AddChild(outRec.PolyNode);
            else polytree.AddChild(outRec.PolyNode);
        }
    };
    ClipperLib.Clipper.prototype.FixupOutPolyline = function(outRec) {
        var pp = outRec.Pts;
        var lastPP = pp.Prev;
        while(pp !== lastPP){
            pp = pp.Next;
            if (ClipperLib.IntPoint.op_Equality(pp.Pt, pp.Prev.Pt)) {
                if (pp === lastPP) lastPP = pp.Prev;
                var tmpPP = pp.Prev;
                tmpPP.Next = pp.Next;
                pp.Next.Prev = tmpPP;
                pp = tmpPP;
            }
        }
        if (pp === pp.Prev) outRec.Pts = null;
    };
    ClipperLib.Clipper.prototype.FixupOutPolygon = function(outRec) {
        //FixupOutPolygon() - removes duplicate points and simplifies consecutive
        //parallel edges by removing the middle vertex.
        var lastOK = null;
        outRec.BottomPt = null;
        var pp = outRec.Pts;
        var preserveCol = this.PreserveCollinear || this.StrictlySimple;
        for(;;){
            if (pp.Prev === pp || pp.Prev === pp.Next) {
                outRec.Pts = null;
                return;
            }
            //test for duplicate points and collinear edges ...
            if (ClipperLib.IntPoint.op_Equality(pp.Pt, pp.Next.Pt) || ClipperLib.IntPoint.op_Equality(pp.Pt, pp.Prev.Pt) || ClipperLib.ClipperBase.SlopesEqual4(pp.Prev.Pt, pp.Pt, pp.Next.Pt, this.m_UseFullRange) && (!preserveCol || !this.Pt2IsBetweenPt1AndPt3(pp.Prev.Pt, pp.Pt, pp.Next.Pt))) {
                lastOK = null;
                pp.Prev.Next = pp.Next;
                pp.Next.Prev = pp.Prev;
                pp = pp.Prev;
            } else if (pp === lastOK) break;
            else {
                if (lastOK === null) lastOK = pp;
                pp = pp.Next;
            }
        }
        outRec.Pts = pp;
    };
    ClipperLib.Clipper.prototype.DupOutPt = function(outPt, InsertAfter) {
        var result = new ClipperLib.OutPt();
        //result.Pt = outPt.Pt;
        result.Pt.X = outPt.Pt.X;
        result.Pt.Y = outPt.Pt.Y;
        if (ClipperLib.use_xyz) result.Pt.Z = outPt.Pt.Z;
        result.Idx = outPt.Idx;
        if (InsertAfter) {
            result.Next = outPt.Next;
            result.Prev = outPt;
            outPt.Next.Prev = result;
            outPt.Next = result;
        } else {
            result.Prev = outPt.Prev;
            result.Next = outPt;
            outPt.Prev.Next = result;
            outPt.Prev = result;
        }
        return result;
    };
    ClipperLib.Clipper.prototype.GetOverlap = function(a1, a2, b1, b2, $val) {
        if (a1 < a2) {
            if (b1 < b2) {
                $val.Left = Math.max(a1, b1);
                $val.Right = Math.min(a2, b2);
            } else {
                $val.Left = Math.max(a1, b2);
                $val.Right = Math.min(a2, b1);
            }
        } else if (b1 < b2) {
            $val.Left = Math.max(a2, b1);
            $val.Right = Math.min(a1, b2);
        } else {
            $val.Left = Math.max(a2, b2);
            $val.Right = Math.min(a1, b1);
        }
        return $val.Left < $val.Right;
    };
    ClipperLib.Clipper.prototype.JoinHorz = function(op1, op1b, op2, op2b, Pt, DiscardLeft) {
        var Dir1 = op1.Pt.X > op1b.Pt.X ? ClipperLib.Direction.dRightToLeft : ClipperLib.Direction.dLeftToRight;
        var Dir2 = op2.Pt.X > op2b.Pt.X ? ClipperLib.Direction.dRightToLeft : ClipperLib.Direction.dLeftToRight;
        if (Dir1 === Dir2) return false;
        //When DiscardLeft, we want Op1b to be on the Left of Op1, otherwise we
        //want Op1b to be on the Right. (And likewise with Op2 and Op2b.)
        //So, to facilitate this while inserting Op1b and Op2b ...
        //when DiscardLeft, make sure we're AT or RIGHT of Pt before adding Op1b,
        //otherwise make sure we're AT or LEFT of Pt. (Likewise with Op2b.)
        if (Dir1 === ClipperLib.Direction.dLeftToRight) {
            while(op1.Next.Pt.X <= Pt.X && op1.Next.Pt.X >= op1.Pt.X && op1.Next.Pt.Y === Pt.Y)op1 = op1.Next;
            if (DiscardLeft && op1.Pt.X !== Pt.X) op1 = op1.Next;
            op1b = this.DupOutPt(op1, !DiscardLeft);
            if (ClipperLib.IntPoint.op_Inequality(op1b.Pt, Pt)) {
                op1 = op1b;
                //op1.Pt = Pt;
                op1.Pt.X = Pt.X;
                op1.Pt.Y = Pt.Y;
                if (ClipperLib.use_xyz) op1.Pt.Z = Pt.Z;
                op1b = this.DupOutPt(op1, !DiscardLeft);
            }
        } else {
            while(op1.Next.Pt.X >= Pt.X && op1.Next.Pt.X <= op1.Pt.X && op1.Next.Pt.Y === Pt.Y)op1 = op1.Next;
            if (!DiscardLeft && op1.Pt.X !== Pt.X) op1 = op1.Next;
            op1b = this.DupOutPt(op1, DiscardLeft);
            if (ClipperLib.IntPoint.op_Inequality(op1b.Pt, Pt)) {
                op1 = op1b;
                //op1.Pt = Pt;
                op1.Pt.X = Pt.X;
                op1.Pt.Y = Pt.Y;
                if (ClipperLib.use_xyz) op1.Pt.Z = Pt.Z;
                op1b = this.DupOutPt(op1, DiscardLeft);
            }
        }
        if (Dir2 === ClipperLib.Direction.dLeftToRight) {
            while(op2.Next.Pt.X <= Pt.X && op2.Next.Pt.X >= op2.Pt.X && op2.Next.Pt.Y === Pt.Y)op2 = op2.Next;
            if (DiscardLeft && op2.Pt.X !== Pt.X) op2 = op2.Next;
            op2b = this.DupOutPt(op2, !DiscardLeft);
            if (ClipperLib.IntPoint.op_Inequality(op2b.Pt, Pt)) {
                op2 = op2b;
                //op2.Pt = Pt;
                op2.Pt.X = Pt.X;
                op2.Pt.Y = Pt.Y;
                if (ClipperLib.use_xyz) op2.Pt.Z = Pt.Z;
                op2b = this.DupOutPt(op2, !DiscardLeft);
            }
        } else {
            while(op2.Next.Pt.X >= Pt.X && op2.Next.Pt.X <= op2.Pt.X && op2.Next.Pt.Y === Pt.Y)op2 = op2.Next;
            if (!DiscardLeft && op2.Pt.X !== Pt.X) op2 = op2.Next;
            op2b = this.DupOutPt(op2, DiscardLeft);
            if (ClipperLib.IntPoint.op_Inequality(op2b.Pt, Pt)) {
                op2 = op2b;
                //op2.Pt = Pt;
                op2.Pt.X = Pt.X;
                op2.Pt.Y = Pt.Y;
                if (ClipperLib.use_xyz) op2.Pt.Z = Pt.Z;
                op2b = this.DupOutPt(op2, DiscardLeft);
            }
        }
        if (Dir1 === ClipperLib.Direction.dLeftToRight === DiscardLeft) {
            op1.Prev = op2;
            op2.Next = op1;
            op1b.Next = op2b;
            op2b.Prev = op1b;
        } else {
            op1.Next = op2;
            op2.Prev = op1;
            op1b.Prev = op2b;
            op2b.Next = op1b;
        }
        return true;
    };
    ClipperLib.Clipper.prototype.JoinPoints = function(j, outRec1, outRec2) {
        var op1 = j.OutPt1, op1b = new ClipperLib.OutPt();
        var op2 = j.OutPt2, op2b = new ClipperLib.OutPt();
        //There are 3 kinds of joins for output polygons ...
        //1. Horizontal joins where Join.OutPt1 & Join.OutPt2 are vertices anywhere
        //along (horizontal) collinear edges (& Join.OffPt is on the same horizontal).
        //2. Non-horizontal joins where Join.OutPt1 & Join.OutPt2 are at the same
        //location at the Bottom of the overlapping segment (& Join.OffPt is above).
        //3. StrictlySimple joins where edges touch but are not collinear and where
        //Join.OutPt1, Join.OutPt2 & Join.OffPt all share the same point.
        var isHorizontal = j.OutPt1.Pt.Y === j.OffPt.Y;
        if (isHorizontal && ClipperLib.IntPoint.op_Equality(j.OffPt, j.OutPt1.Pt) && ClipperLib.IntPoint.op_Equality(j.OffPt, j.OutPt2.Pt)) {
            //Strictly Simple join ...
            if (outRec1 !== outRec2) return false;
            op1b = j.OutPt1.Next;
            while(op1b !== op1 && ClipperLib.IntPoint.op_Equality(op1b.Pt, j.OffPt))op1b = op1b.Next;
            var reverse1 = op1b.Pt.Y > j.OffPt.Y;
            op2b = j.OutPt2.Next;
            while(op2b !== op2 && ClipperLib.IntPoint.op_Equality(op2b.Pt, j.OffPt))op2b = op2b.Next;
            var reverse2 = op2b.Pt.Y > j.OffPt.Y;
            if (reverse1 === reverse2) return false;
            if (reverse1) {
                op1b = this.DupOutPt(op1, false);
                op2b = this.DupOutPt(op2, true);
                op1.Prev = op2;
                op2.Next = op1;
                op1b.Next = op2b;
                op2b.Prev = op1b;
                j.OutPt1 = op1;
                j.OutPt2 = op1b;
                return true;
            } else {
                op1b = this.DupOutPt(op1, true);
                op2b = this.DupOutPt(op2, false);
                op1.Next = op2;
                op2.Prev = op1;
                op1b.Prev = op2b;
                op2b.Next = op1b;
                j.OutPt1 = op1;
                j.OutPt2 = op1b;
                return true;
            }
        } else if (isHorizontal) {
            //treat horizontal joins differently to non-horizontal joins since with
            //them we're not yet sure where the overlapping is. OutPt1.Pt & OutPt2.Pt
            //may be anywhere along the horizontal edge.
            op1b = op1;
            while(op1.Prev.Pt.Y === op1.Pt.Y && op1.Prev !== op1b && op1.Prev !== op2)op1 = op1.Prev;
            while(op1b.Next.Pt.Y === op1b.Pt.Y && op1b.Next !== op1 && op1b.Next !== op2)op1b = op1b.Next;
            if (op1b.Next === op1 || op1b.Next === op2) return false;
            //a flat 'polygon'
            op2b = op2;
            while(op2.Prev.Pt.Y === op2.Pt.Y && op2.Prev !== op2b && op2.Prev !== op1b)op2 = op2.Prev;
            while(op2b.Next.Pt.Y === op2b.Pt.Y && op2b.Next !== op2 && op2b.Next !== op1)op2b = op2b.Next;
            if (op2b.Next === op2 || op2b.Next === op1) return false;
            //a flat 'polygon'
            //Op1 -. Op1b & Op2 -. Op2b are the extremites of the horizontal edges
            var $val = {
                Left: null,
                Right: null
            };
            if (!this.GetOverlap(op1.Pt.X, op1b.Pt.X, op2.Pt.X, op2b.Pt.X, $val)) return false;
            var Left = $val.Left;
            var Right = $val.Right;
            //DiscardLeftSide: when overlapping edges are joined, a spike will created
            //which needs to be cleaned up. However, we don't want Op1 or Op2 caught up
            //on the discard Side as either may still be needed for other joins ...
            var Pt = new ClipperLib.IntPoint0();
            var DiscardLeftSide;
            if (op1.Pt.X >= Left && op1.Pt.X <= Right) {
                //Pt = op1.Pt;
                Pt.X = op1.Pt.X;
                Pt.Y = op1.Pt.Y;
                if (ClipperLib.use_xyz) Pt.Z = op1.Pt.Z;
                DiscardLeftSide = op1.Pt.X > op1b.Pt.X;
            } else if (op2.Pt.X >= Left && op2.Pt.X <= Right) {
                //Pt = op2.Pt;
                Pt.X = op2.Pt.X;
                Pt.Y = op2.Pt.Y;
                if (ClipperLib.use_xyz) Pt.Z = op2.Pt.Z;
                DiscardLeftSide = op2.Pt.X > op2b.Pt.X;
            } else if (op1b.Pt.X >= Left && op1b.Pt.X <= Right) {
                //Pt = op1b.Pt;
                Pt.X = op1b.Pt.X;
                Pt.Y = op1b.Pt.Y;
                if (ClipperLib.use_xyz) Pt.Z = op1b.Pt.Z;
                DiscardLeftSide = op1b.Pt.X > op1.Pt.X;
            } else {
                //Pt = op2b.Pt;
                Pt.X = op2b.Pt.X;
                Pt.Y = op2b.Pt.Y;
                if (ClipperLib.use_xyz) Pt.Z = op2b.Pt.Z;
                DiscardLeftSide = op2b.Pt.X > op2.Pt.X;
            }
            j.OutPt1 = op1;
            j.OutPt2 = op2;
            return this.JoinHorz(op1, op1b, op2, op2b, Pt, DiscardLeftSide);
        } else {
            //nb: For non-horizontal joins ...
            //    1. Jr.OutPt1.Pt.Y == Jr.OutPt2.Pt.Y
            //    2. Jr.OutPt1.Pt > Jr.OffPt.Y
            //make sure the polygons are correctly oriented ...
            op1b = op1.Next;
            while(ClipperLib.IntPoint.op_Equality(op1b.Pt, op1.Pt) && op1b !== op1)op1b = op1b.Next;
            var Reverse1 = op1b.Pt.Y > op1.Pt.Y || !ClipperLib.ClipperBase.SlopesEqual4(op1.Pt, op1b.Pt, j.OffPt, this.m_UseFullRange);
            if (Reverse1) {
                op1b = op1.Prev;
                while(ClipperLib.IntPoint.op_Equality(op1b.Pt, op1.Pt) && op1b !== op1)op1b = op1b.Prev;
                if (op1b.Pt.Y > op1.Pt.Y || !ClipperLib.ClipperBase.SlopesEqual4(op1.Pt, op1b.Pt, j.OffPt, this.m_UseFullRange)) return false;
            }
            op2b = op2.Next;
            while(ClipperLib.IntPoint.op_Equality(op2b.Pt, op2.Pt) && op2b !== op2)op2b = op2b.Next;
            var Reverse2 = op2b.Pt.Y > op2.Pt.Y || !ClipperLib.ClipperBase.SlopesEqual4(op2.Pt, op2b.Pt, j.OffPt, this.m_UseFullRange);
            if (Reverse2) {
                op2b = op2.Prev;
                while(ClipperLib.IntPoint.op_Equality(op2b.Pt, op2.Pt) && op2b !== op2)op2b = op2b.Prev;
                if (op2b.Pt.Y > op2.Pt.Y || !ClipperLib.ClipperBase.SlopesEqual4(op2.Pt, op2b.Pt, j.OffPt, this.m_UseFullRange)) return false;
            }
            if (op1b === op1 || op2b === op2 || op1b === op2b || outRec1 === outRec2 && Reverse1 === Reverse2) return false;
            if (Reverse1) {
                op1b = this.DupOutPt(op1, false);
                op2b = this.DupOutPt(op2, true);
                op1.Prev = op2;
                op2.Next = op1;
                op1b.Next = op2b;
                op2b.Prev = op1b;
                j.OutPt1 = op1;
                j.OutPt2 = op1b;
                return true;
            } else {
                op1b = this.DupOutPt(op1, true);
                op2b = this.DupOutPt(op2, false);
                op1.Next = op2;
                op2.Prev = op1;
                op1b.Prev = op2b;
                op2b.Next = op1b;
                j.OutPt1 = op1;
                j.OutPt2 = op1b;
                return true;
            }
        }
    };
    ClipperLib.Clipper.GetBounds = function(paths) {
        var i = 0, cnt = paths.length;
        while(i < cnt && paths[i].length === 0)i++;
        if (i === cnt) return new ClipperLib.IntRect(0, 0, 0, 0);
        var result = new ClipperLib.IntRect();
        result.left = paths[i][0].X;
        result.right = result.left;
        result.top = paths[i][0].Y;
        result.bottom = result.top;
        for(; i < cnt; i++)for(var j = 0, jlen = paths[i].length; j < jlen; j++){
            if (paths[i][j].X < result.left) result.left = paths[i][j].X;
            else if (paths[i][j].X > result.right) result.right = paths[i][j].X;
            if (paths[i][j].Y < result.top) result.top = paths[i][j].Y;
            else if (paths[i][j].Y > result.bottom) result.bottom = paths[i][j].Y;
        }
        return result;
    };
    ClipperLib.Clipper.prototype.GetBounds2 = function(ops) {
        var opStart = ops;
        var result = new ClipperLib.IntRect();
        result.left = ops.Pt.X;
        result.right = ops.Pt.X;
        result.top = ops.Pt.Y;
        result.bottom = ops.Pt.Y;
        ops = ops.Next;
        while(ops !== opStart){
            if (ops.Pt.X < result.left) result.left = ops.Pt.X;
            if (ops.Pt.X > result.right) result.right = ops.Pt.X;
            if (ops.Pt.Y < result.top) result.top = ops.Pt.Y;
            if (ops.Pt.Y > result.bottom) result.bottom = ops.Pt.Y;
            ops = ops.Next;
        }
        return result;
    };
    ClipperLib.Clipper.PointInPolygon = function(pt, path) {
        //returns 0 if false, +1 if true, -1 if pt ON polygon boundary
        //See "The Point in Polygon Problem for Arbitrary Polygons" by Hormann & Agathos
        //http://citeseerx.ist.psu.edu/viewdoc/download?doi=10.1.1.88.5498&rep=rep1&type=pdf
        var result = 0, cnt = path.length;
        if (cnt < 3) return 0;
        var ip = path[0];
        for(var i = 1; i <= cnt; ++i){
            var ipNext = i === cnt ? path[0] : path[i];
            if (ipNext.Y === pt.Y) {
                if (ipNext.X === pt.X || ip.Y === pt.Y && ipNext.X > pt.X === ip.X < pt.X) return -1;
            }
            if (ip.Y < pt.Y !== ipNext.Y < pt.Y) {
                if (ip.X >= pt.X) {
                    if (ipNext.X > pt.X) result = 1 - result;
                    else {
                        var d = (ip.X - pt.X) * (ipNext.Y - pt.Y) - (ipNext.X - pt.X) * (ip.Y - pt.Y);
                        if (d === 0) return -1;
                        else if (d > 0 === ipNext.Y > ip.Y) result = 1 - result;
                    }
                } else if (ipNext.X > pt.X) {
                    var d = (ip.X - pt.X) * (ipNext.Y - pt.Y) - (ipNext.X - pt.X) * (ip.Y - pt.Y);
                    if (d === 0) return -1;
                    else if (d > 0 === ipNext.Y > ip.Y) result = 1 - result;
                }
            }
            ip = ipNext;
        }
        return result;
    };
    ClipperLib.Clipper.prototype.PointInPolygon = function(pt, op) {
        //returns 0 if false, +1 if true, -1 if pt ON polygon boundary
        var result = 0;
        var startOp = op;
        var ptx = pt.X, pty = pt.Y;
        var poly0x = op.Pt.X, poly0y = op.Pt.Y;
        do {
            op = op.Next;
            var poly1x = op.Pt.X, poly1y = op.Pt.Y;
            if (poly1y === pty) {
                if (poly1x === ptx || poly0y === pty && poly1x > ptx === poly0x < ptx) return -1;
            }
            if (poly0y < pty !== poly1y < pty) {
                if (poly0x >= ptx) {
                    if (poly1x > ptx) result = 1 - result;
                    else {
                        var d = (poly0x - ptx) * (poly1y - pty) - (poly1x - ptx) * (poly0y - pty);
                        if (d === 0) return -1;
                        if (d > 0 === poly1y > poly0y) result = 1 - result;
                    }
                } else if (poly1x > ptx) {
                    var d = (poly0x - ptx) * (poly1y - pty) - (poly1x - ptx) * (poly0y - pty);
                    if (d === 0) return -1;
                    if (d > 0 === poly1y > poly0y) result = 1 - result;
                }
            }
            poly0x = poly1x;
            poly0y = poly1y;
        }while (startOp !== op);
        return result;
    };
    ClipperLib.Clipper.prototype.Poly2ContainsPoly1 = function(outPt1, outPt2) {
        var op = outPt1;
        do {
            //nb: PointInPolygon returns 0 if false, +1 if true, -1 if pt on polygon
            var res = this.PointInPolygon(op.Pt, outPt2);
            if (res >= 0) return res > 0;
            op = op.Next;
        }while (op !== outPt1);
        return true;
    };
    ClipperLib.Clipper.prototype.FixupFirstLefts1 = function(OldOutRec, NewOutRec) {
        var outRec, firstLeft;
        for(var i = 0, ilen = this.m_PolyOuts.length; i < ilen; i++){
            outRec = this.m_PolyOuts[i];
            firstLeft = ClipperLib.Clipper.ParseFirstLeft(outRec.FirstLeft);
            if (outRec.Pts !== null && firstLeft === OldOutRec) {
                if (this.Poly2ContainsPoly1(outRec.Pts, NewOutRec.Pts)) outRec.FirstLeft = NewOutRec;
            }
        }
    };
    ClipperLib.Clipper.prototype.FixupFirstLefts2 = function(innerOutRec, outerOutRec) {
        //A polygon has split into two such that one is now the inner of the other.
        //It's possible that these polygons now wrap around other polygons, so check
        //every polygon that's also contained by OuterOutRec's FirstLeft container
        //(including nil) to see if they've become inner to the new inner polygon ...
        var orfl = outerOutRec.FirstLeft;
        var outRec, firstLeft;
        for(var i = 0, ilen = this.m_PolyOuts.length; i < ilen; i++){
            outRec = this.m_PolyOuts[i];
            if (outRec.Pts === null || outRec === outerOutRec || outRec === innerOutRec) continue;
            firstLeft = ClipperLib.Clipper.ParseFirstLeft(outRec.FirstLeft);
            if (firstLeft !== orfl && firstLeft !== innerOutRec && firstLeft !== outerOutRec) continue;
            if (this.Poly2ContainsPoly1(outRec.Pts, innerOutRec.Pts)) outRec.FirstLeft = innerOutRec;
            else if (this.Poly2ContainsPoly1(outRec.Pts, outerOutRec.Pts)) outRec.FirstLeft = outerOutRec;
            else if (outRec.FirstLeft === innerOutRec || outRec.FirstLeft === outerOutRec) outRec.FirstLeft = orfl;
        }
    };
    ClipperLib.Clipper.prototype.FixupFirstLefts3 = function(OldOutRec, NewOutRec) {
        //same as FixupFirstLefts1 but doesn't call Poly2ContainsPoly1()
        var outRec;
        var firstLeft;
        for(var i = 0, ilen = this.m_PolyOuts.length; i < ilen; i++){
            outRec = this.m_PolyOuts[i];
            firstLeft = ClipperLib.Clipper.ParseFirstLeft(outRec.FirstLeft);
            if (outRec.Pts !== null && firstLeft === OldOutRec) outRec.FirstLeft = NewOutRec;
        }
    };
    ClipperLib.Clipper.ParseFirstLeft = function(FirstLeft) {
        while(FirstLeft !== null && FirstLeft.Pts === null)FirstLeft = FirstLeft.FirstLeft;
        return FirstLeft;
    };
    ClipperLib.Clipper.prototype.JoinCommonEdges = function() {
        for(var i = 0, ilen = this.m_Joins.length; i < ilen; i++){
            var join = this.m_Joins[i];
            var outRec1 = this.GetOutRec(join.OutPt1.Idx);
            var outRec2 = this.GetOutRec(join.OutPt2.Idx);
            if (outRec1.Pts === null || outRec2.Pts === null) continue;
            if (outRec1.IsOpen || outRec2.IsOpen) continue;
            //get the polygon fragment with the correct hole state (FirstLeft)
            //before calling JoinPoints() ...
            var holeStateRec;
            if (outRec1 === outRec2) holeStateRec = outRec1;
            else if (this.OutRec1RightOfOutRec2(outRec1, outRec2)) holeStateRec = outRec2;
            else if (this.OutRec1RightOfOutRec2(outRec2, outRec1)) holeStateRec = outRec1;
            else holeStateRec = this.GetLowermostRec(outRec1, outRec2);
            if (!this.JoinPoints(join, outRec1, outRec2)) continue;
            if (outRec1 === outRec2) {
                //instead of joining two polygons, we've just created a new one by
                //splitting one polygon into two.
                outRec1.Pts = join.OutPt1;
                outRec1.BottomPt = null;
                outRec2 = this.CreateOutRec();
                outRec2.Pts = join.OutPt2;
                //update all OutRec2.Pts Idx's ...
                this.UpdateOutPtIdxs(outRec2);
                if (this.Poly2ContainsPoly1(outRec2.Pts, outRec1.Pts)) {
                    //outRec1 contains outRec2 ...
                    outRec2.IsHole = !outRec1.IsHole;
                    outRec2.FirstLeft = outRec1;
                    if (this.m_UsingPolyTree) this.FixupFirstLefts2(outRec2, outRec1);
                    if ((outRec2.IsHole ^ this.ReverseSolution) == this.Area$1(outRec2) > 0) this.ReversePolyPtLinks(outRec2.Pts);
                } else if (this.Poly2ContainsPoly1(outRec1.Pts, outRec2.Pts)) {
                    //outRec2 contains outRec1 ...
                    outRec2.IsHole = outRec1.IsHole;
                    outRec1.IsHole = !outRec2.IsHole;
                    outRec2.FirstLeft = outRec1.FirstLeft;
                    outRec1.FirstLeft = outRec2;
                    if (this.m_UsingPolyTree) this.FixupFirstLefts2(outRec1, outRec2);
                    if ((outRec1.IsHole ^ this.ReverseSolution) == this.Area$1(outRec1) > 0) this.ReversePolyPtLinks(outRec1.Pts);
                } else {
                    //the 2 polygons are completely separate ...
                    outRec2.IsHole = outRec1.IsHole;
                    outRec2.FirstLeft = outRec1.FirstLeft;
                    //fixup FirstLeft pointers that may need reassigning to OutRec2
                    if (this.m_UsingPolyTree) this.FixupFirstLefts1(outRec1, outRec2);
                }
            } else {
                //joined 2 polygons together ...
                outRec2.Pts = null;
                outRec2.BottomPt = null;
                outRec2.Idx = outRec1.Idx;
                outRec1.IsHole = holeStateRec.IsHole;
                if (holeStateRec === outRec2) outRec1.FirstLeft = outRec2.FirstLeft;
                outRec2.FirstLeft = outRec1;
                //fixup FirstLeft pointers that may need reassigning to OutRec1
                if (this.m_UsingPolyTree) this.FixupFirstLefts3(outRec2, outRec1);
            }
        }
    };
    ClipperLib.Clipper.prototype.UpdateOutPtIdxs = function(outrec) {
        var op = outrec.Pts;
        do {
            op.Idx = outrec.Idx;
            op = op.Prev;
        }while (op !== outrec.Pts);
    };
    ClipperLib.Clipper.prototype.DoSimplePolygons = function() {
        var i = 0;
        while(i < this.m_PolyOuts.length){
            var outrec = this.m_PolyOuts[i++];
            var op = outrec.Pts;
            if (op === null || outrec.IsOpen) continue;
            do {
                var op2 = op.Next;
                while(op2 !== outrec.Pts){
                    if (ClipperLib.IntPoint.op_Equality(op.Pt, op2.Pt) && op2.Next !== op && op2.Prev !== op) {
                        //split the polygon into two ...
                        var op3 = op.Prev;
                        var op4 = op2.Prev;
                        op.Prev = op4;
                        op4.Next = op;
                        op2.Prev = op3;
                        op3.Next = op2;
                        outrec.Pts = op;
                        var outrec2 = this.CreateOutRec();
                        outrec2.Pts = op2;
                        this.UpdateOutPtIdxs(outrec2);
                        if (this.Poly2ContainsPoly1(outrec2.Pts, outrec.Pts)) {
                            //OutRec2 is contained by OutRec1 ...
                            outrec2.IsHole = !outrec.IsHole;
                            outrec2.FirstLeft = outrec;
                            if (this.m_UsingPolyTree) this.FixupFirstLefts2(outrec2, outrec);
                        } else if (this.Poly2ContainsPoly1(outrec.Pts, outrec2.Pts)) {
                            //OutRec1 is contained by OutRec2 ...
                            outrec2.IsHole = outrec.IsHole;
                            outrec.IsHole = !outrec2.IsHole;
                            outrec2.FirstLeft = outrec.FirstLeft;
                            outrec.FirstLeft = outrec2;
                            if (this.m_UsingPolyTree) this.FixupFirstLefts2(outrec, outrec2);
                        } else {
                            //the 2 polygons are separate ...
                            outrec2.IsHole = outrec.IsHole;
                            outrec2.FirstLeft = outrec.FirstLeft;
                            if (this.m_UsingPolyTree) this.FixupFirstLefts1(outrec, outrec2);
                        }
                        op2 = op;
                    //ie get ready for the next iteration
                    }
                    op2 = op2.Next;
                }
                op = op.Next;
            }while (op !== outrec.Pts);
        }
    };
    ClipperLib.Clipper.Area = function(poly) {
        if (!Array.isArray(poly)) return 0;
        var cnt = poly.length;
        if (cnt < 3) return 0;
        var a = 0;
        for(var i = 0, j = cnt - 1; i < cnt; ++i){
            a += (poly[j].X + poly[i].X) * (poly[j].Y - poly[i].Y);
            j = i;
        }
        return -a * 0.5;
    };
    ClipperLib.Clipper.prototype.Area = function(op) {
        var opFirst = op;
        if (op === null) return 0;
        var a = 0;
        do {
            a = a + (op.Prev.Pt.X + op.Pt.X) * (op.Prev.Pt.Y - op.Pt.Y);
            op = op.Next;
        }while (op !== opFirst); // && typeof op !== 'undefined');
        return a * 0.5;
    };
    ClipperLib.Clipper.prototype.Area$1 = function(outRec) {
        return this.Area(outRec.Pts);
    };
    ClipperLib.Clipper.SimplifyPolygon = function(poly, fillType) {
        var result = new Array();
        var c = new ClipperLib.Clipper(0);
        c.StrictlySimple = true;
        c.AddPath(poly, ClipperLib.PolyType.ptSubject, true);
        c.Execute(ClipperLib.ClipType.ctUnion, result, fillType, fillType);
        return result;
    };
    ClipperLib.Clipper.SimplifyPolygons = function(polys, fillType) {
        if (typeof fillType === "undefined") fillType = ClipperLib.PolyFillType.pftEvenOdd;
        var result = new Array();
        var c = new ClipperLib.Clipper(0);
        c.StrictlySimple = true;
        c.AddPaths(polys, ClipperLib.PolyType.ptSubject, true);
        c.Execute(ClipperLib.ClipType.ctUnion, result, fillType, fillType);
        return result;
    };
    ClipperLib.Clipper.DistanceSqrd = function(pt1, pt2) {
        var dx = pt1.X - pt2.X;
        var dy = pt1.Y - pt2.Y;
        return dx * dx + dy * dy;
    };
    ClipperLib.Clipper.DistanceFromLineSqrd = function(pt, ln1, ln2) {
        //The equation of a line in general form (Ax + By + C = 0)
        //given 2 points (x¹,y¹) & (x²,y²) is ...
        //(y¹ - y²)x + (x² - x¹)y + (y² - y¹)x¹ - (x² - x¹)y¹ = 0
        //A = (y¹ - y²); B = (x² - x¹); C = (y² - y¹)x¹ - (x² - x¹)y¹
        //perpendicular distance of point (x³,y³) = (Ax³ + By³ + C)/Sqrt(A² + B²)
        //see http://en.wikipedia.org/wiki/Perpendicular_distance
        var A = ln1.Y - ln2.Y;
        var B = ln2.X - ln1.X;
        var C = A * ln1.X + B * ln1.Y;
        C = A * pt.X + B * pt.Y - C;
        return C * C / (A * A + B * B);
    };
    ClipperLib.Clipper.SlopesNearCollinear = function(pt1, pt2, pt3, distSqrd) {
        //this function is more accurate when the point that's GEOMETRICALLY
        //between the other 2 points is the one that's tested for distance.
        //nb: with 'spikes', either pt1 or pt3 is geometrically between the other pts
        if (Math.abs(pt1.X - pt2.X) > Math.abs(pt1.Y - pt2.Y)) {
            if (pt1.X > pt2.X === pt1.X < pt3.X) return ClipperLib.Clipper.DistanceFromLineSqrd(pt1, pt2, pt3) < distSqrd;
            else if (pt2.X > pt1.X === pt2.X < pt3.X) return ClipperLib.Clipper.DistanceFromLineSqrd(pt2, pt1, pt3) < distSqrd;
            else return ClipperLib.Clipper.DistanceFromLineSqrd(pt3, pt1, pt2) < distSqrd;
        } else {
            if (pt1.Y > pt2.Y === pt1.Y < pt3.Y) return ClipperLib.Clipper.DistanceFromLineSqrd(pt1, pt2, pt3) < distSqrd;
            else if (pt2.Y > pt1.Y === pt2.Y < pt3.Y) return ClipperLib.Clipper.DistanceFromLineSqrd(pt2, pt1, pt3) < distSqrd;
            else return ClipperLib.Clipper.DistanceFromLineSqrd(pt3, pt1, pt2) < distSqrd;
        }
    };
    ClipperLib.Clipper.PointsAreClose = function(pt1, pt2, distSqrd) {
        var dx = pt1.X - pt2.X;
        var dy = pt1.Y - pt2.Y;
        return dx * dx + dy * dy <= distSqrd;
    };
    ClipperLib.Clipper.ExcludeOp = function(op) {
        var result = op.Prev;
        result.Next = op.Next;
        op.Next.Prev = result;
        result.Idx = 0;
        return result;
    };
    ClipperLib.Clipper.CleanPolygon = function(path, distance) {
        if (typeof distance === "undefined") distance = 1.415;
        //distance = proximity in units/pixels below which vertices will be stripped.
        //Default ~= sqrt(2) so when adjacent vertices or semi-adjacent vertices have
        //both x & y coords within 1 unit, then the second vertex will be stripped.
        var cnt = path.length;
        if (cnt === 0) return new Array();
        var outPts = new Array(cnt);
        for(var i = 0; i < cnt; ++i)outPts[i] = new ClipperLib.OutPt();
        for(var i = 0; i < cnt; ++i){
            outPts[i].Pt = path[i];
            outPts[i].Next = outPts[(i + 1) % cnt];
            outPts[i].Next.Prev = outPts[i];
            outPts[i].Idx = 0;
        }
        var distSqrd = distance * distance;
        var op = outPts[0];
        while(op.Idx === 0 && op.Next !== op.Prev){
            if (ClipperLib.Clipper.PointsAreClose(op.Pt, op.Prev.Pt, distSqrd)) {
                op = ClipperLib.Clipper.ExcludeOp(op);
                cnt--;
            } else if (ClipperLib.Clipper.PointsAreClose(op.Prev.Pt, op.Next.Pt, distSqrd)) {
                ClipperLib.Clipper.ExcludeOp(op.Next);
                op = ClipperLib.Clipper.ExcludeOp(op);
                cnt -= 2;
            } else if (ClipperLib.Clipper.SlopesNearCollinear(op.Prev.Pt, op.Pt, op.Next.Pt, distSqrd)) {
                op = ClipperLib.Clipper.ExcludeOp(op);
                cnt--;
            } else {
                op.Idx = 1;
                op = op.Next;
            }
        }
        if (cnt < 3) cnt = 0;
        var result = new Array(cnt);
        for(var i = 0; i < cnt; ++i){
            result[i] = new ClipperLib.IntPoint1(op.Pt);
            op = op.Next;
        }
        outPts = null;
        return result;
    };
    ClipperLib.Clipper.CleanPolygons = function(polys, distance) {
        var result = new Array(polys.length);
        for(var i = 0, ilen = polys.length; i < ilen; i++)result[i] = ClipperLib.Clipper.CleanPolygon(polys[i], distance);
        return result;
    };
    ClipperLib.Clipper.Minkowski = function(pattern, path, IsSum, IsClosed) {
        var delta = IsClosed ? 1 : 0;
        var polyCnt = pattern.length;
        var pathCnt = path.length;
        var result = new Array();
        if (IsSum) for(var i = 0; i < pathCnt; i++){
            var p = new Array(polyCnt);
            for(var j = 0, jlen = pattern.length, ip = pattern[j]; j < jlen; j++, ip = pattern[j])p[j] = new ClipperLib.IntPoint2(path[i].X + ip.X, path[i].Y + ip.Y);
            result.push(p);
        }
        else for(var i = 0; i < pathCnt; i++){
            var p = new Array(polyCnt);
            for(var j = 0, jlen = pattern.length, ip = pattern[j]; j < jlen; j++, ip = pattern[j])p[j] = new ClipperLib.IntPoint2(path[i].X - ip.X, path[i].Y - ip.Y);
            result.push(p);
        }
        var quads = new Array();
        for(var i = 0; i < pathCnt - 1 + delta; i++)for(var j = 0; j < polyCnt; j++){
            var quad = new Array();
            quad.push(result[i % pathCnt][j % polyCnt]);
            quad.push(result[(i + 1) % pathCnt][j % polyCnt]);
            quad.push(result[(i + 1) % pathCnt][(j + 1) % polyCnt]);
            quad.push(result[i % pathCnt][(j + 1) % polyCnt]);
            if (!ClipperLib.Clipper.Orientation(quad)) quad.reverse();
            quads.push(quad);
        }
        return quads;
    };
    ClipperLib.Clipper.MinkowskiSum = function(pattern, path_or_paths, pathIsClosed) {
        if (!(path_or_paths[0] instanceof Array)) {
            var path = path_or_paths;
            var paths = ClipperLib.Clipper.Minkowski(pattern, path, true, pathIsClosed);
            var c = new ClipperLib.Clipper();
            c.AddPaths(paths, ClipperLib.PolyType.ptSubject, true);
            c.Execute(ClipperLib.ClipType.ctUnion, paths, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
            return paths;
        } else {
            var paths = path_or_paths;
            var solution = new ClipperLib.Paths();
            var c = new ClipperLib.Clipper();
            for(var i = 0; i < paths.length; ++i){
                var tmp = ClipperLib.Clipper.Minkowski(pattern, paths[i], true, pathIsClosed);
                c.AddPaths(tmp, ClipperLib.PolyType.ptSubject, true);
                if (pathIsClosed) {
                    var path = ClipperLib.Clipper.TranslatePath(paths[i], pattern[0]);
                    c.AddPath(path, ClipperLib.PolyType.ptClip, true);
                }
            }
            c.Execute(ClipperLib.ClipType.ctUnion, solution, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
            return solution;
        }
    };
    ClipperLib.Clipper.TranslatePath = function(path, delta) {
        var outPath = new ClipperLib.Path();
        for(var i = 0; i < path.length; i++)outPath.push(new ClipperLib.IntPoint2(path[i].X + delta.X, path[i].Y + delta.Y));
        return outPath;
    };
    ClipperLib.Clipper.MinkowskiDiff = function(poly1, poly2) {
        var paths = ClipperLib.Clipper.Minkowski(poly1, poly2, false, true);
        var c = new ClipperLib.Clipper();
        c.AddPaths(paths, ClipperLib.PolyType.ptSubject, true);
        c.Execute(ClipperLib.ClipType.ctUnion, paths, ClipperLib.PolyFillType.pftNonZero, ClipperLib.PolyFillType.pftNonZero);
        return paths;
    };
    ClipperLib.Clipper.PolyTreeToPaths = function(polytree) {
        var result = new Array();
        //result.set_Capacity(polytree.get_Total());
        ClipperLib.Clipper.AddPolyNodeToPaths(polytree, ClipperLib.Clipper.NodeType.ntAny, result);
        return result;
    };
    ClipperLib.Clipper.AddPolyNodeToPaths = function(polynode, nt, paths) {
        var match = true;
        switch(nt){
            case ClipperLib.Clipper.NodeType.ntOpen:
                return;
            case ClipperLib.Clipper.NodeType.ntClosed:
                match = !polynode.IsOpen;
                break;
            default:
                break;
        }
        if (polynode.m_polygon.length > 0 && match) paths.push(polynode.m_polygon);
        for(var $i3 = 0, $t3 = polynode.Childs(), $l3 = $t3.length, pn = $t3[$i3]; $i3 < $l3; $i3++, pn = $t3[$i3])ClipperLib.Clipper.AddPolyNodeToPaths(pn, nt, paths);
    };
    ClipperLib.Clipper.OpenPathsFromPolyTree = function(polytree) {
        var result = new ClipperLib.Paths();
        //result.set_Capacity(polytree.ChildCount());
        for(var i = 0, ilen = polytree.ChildCount(); i < ilen; i++)if (polytree.Childs()[i].IsOpen) result.push(polytree.Childs()[i].m_polygon);
        return result;
    };
    ClipperLib.Clipper.ClosedPathsFromPolyTree = function(polytree) {
        var result = new ClipperLib.Paths();
        //result.set_Capacity(polytree.Total());
        ClipperLib.Clipper.AddPolyNodeToPaths(polytree, ClipperLib.Clipper.NodeType.ntClosed, result);
        return result;
    };
    Inherit(ClipperLib.Clipper, ClipperLib.ClipperBase);
    ClipperLib.Clipper.NodeType = {
        ntAny: 0,
        ntOpen: 1,
        ntClosed: 2
    };
    /**
	* @constructor
	*/ ClipperLib.ClipperOffset = function(miterLimit, arcTolerance) {
        if (typeof miterLimit === "undefined") miterLimit = 2;
        if (typeof arcTolerance === "undefined") arcTolerance = ClipperLib.ClipperOffset.def_arc_tolerance;
        this.m_destPolys = new ClipperLib.Paths();
        this.m_srcPoly = new ClipperLib.Path();
        this.m_destPoly = new ClipperLib.Path();
        this.m_normals = new Array();
        this.m_delta = 0;
        this.m_sinA = 0;
        this.m_sin = 0;
        this.m_cos = 0;
        this.m_miterLim = 0;
        this.m_StepsPerRad = 0;
        this.m_lowest = new ClipperLib.IntPoint0();
        this.m_polyNodes = new ClipperLib.PolyNode();
        this.MiterLimit = miterLimit;
        this.ArcTolerance = arcTolerance;
        this.m_lowest.X = -1;
    };
    ClipperLib.ClipperOffset.two_pi = 6.28318530717959;
    ClipperLib.ClipperOffset.def_arc_tolerance = 0.25;
    ClipperLib.ClipperOffset.prototype.Clear = function() {
        ClipperLib.Clear(this.m_polyNodes.Childs());
        this.m_lowest.X = -1;
    };
    ClipperLib.ClipperOffset.Round = ClipperLib.Clipper.Round;
    ClipperLib.ClipperOffset.prototype.AddPath = function(path, joinType, endType) {
        var highI = path.length - 1;
        if (highI < 0) return;
        var newNode = new ClipperLib.PolyNode();
        newNode.m_jointype = joinType;
        newNode.m_endtype = endType;
        //strip duplicate points from path and also get index to the lowest point ...
        if (endType === ClipperLib.EndType.etClosedLine || endType === ClipperLib.EndType.etClosedPolygon) while(highI > 0 && ClipperLib.IntPoint.op_Equality(path[0], path[highI]))highI--;
        //newNode.m_polygon.set_Capacity(highI + 1);
        newNode.m_polygon.push(path[0]);
        var j = 0, k = 0;
        for(var i = 1; i <= highI; i++)if (ClipperLib.IntPoint.op_Inequality(newNode.m_polygon[j], path[i])) {
            j++;
            newNode.m_polygon.push(path[i]);
            if (path[i].Y > newNode.m_polygon[k].Y || path[i].Y === newNode.m_polygon[k].Y && path[i].X < newNode.m_polygon[k].X) k = j;
        }
        if (endType === ClipperLib.EndType.etClosedPolygon && j < 2) return;
        this.m_polyNodes.AddChild(newNode);
        //if this path's lowest pt is lower than all the others then update m_lowest
        if (endType !== ClipperLib.EndType.etClosedPolygon) return;
        if (this.m_lowest.X < 0) this.m_lowest = new ClipperLib.IntPoint2(this.m_polyNodes.ChildCount() - 1, k);
        else {
            var ip = this.m_polyNodes.Childs()[this.m_lowest.X].m_polygon[this.m_lowest.Y];
            if (newNode.m_polygon[k].Y > ip.Y || newNode.m_polygon[k].Y === ip.Y && newNode.m_polygon[k].X < ip.X) this.m_lowest = new ClipperLib.IntPoint2(this.m_polyNodes.ChildCount() - 1, k);
        }
    };
    ClipperLib.ClipperOffset.prototype.AddPaths = function(paths, joinType, endType) {
        for(var i = 0, ilen = paths.length; i < ilen; i++)this.AddPath(paths[i], joinType, endType);
    };
    ClipperLib.ClipperOffset.prototype.FixOrientations = function() {
        //fixup orientations of all closed paths if the orientation of the
        //closed path with the lowermost vertex is wrong ...
        if (this.m_lowest.X >= 0 && !ClipperLib.Clipper.Orientation(this.m_polyNodes.Childs()[this.m_lowest.X].m_polygon)) for(var i = 0; i < this.m_polyNodes.ChildCount(); i++){
            var node = this.m_polyNodes.Childs()[i];
            if (node.m_endtype === ClipperLib.EndType.etClosedPolygon || node.m_endtype === ClipperLib.EndType.etClosedLine && ClipperLib.Clipper.Orientation(node.m_polygon)) node.m_polygon.reverse();
        }
        else for(var i = 0; i < this.m_polyNodes.ChildCount(); i++){
            var node = this.m_polyNodes.Childs()[i];
            if (node.m_endtype === ClipperLib.EndType.etClosedLine && !ClipperLib.Clipper.Orientation(node.m_polygon)) node.m_polygon.reverse();
        }
    };
    ClipperLib.ClipperOffset.GetUnitNormal = function(pt1, pt2) {
        var dx = pt2.X - pt1.X;
        var dy = pt2.Y - pt1.Y;
        if (dx === 0 && dy === 0) return new ClipperLib.DoublePoint2(0, 0);
        var f = 1 / Math.sqrt(dx * dx + dy * dy);
        dx *= f;
        dy *= f;
        return new ClipperLib.DoublePoint2(dy, -dx);
    };
    ClipperLib.ClipperOffset.prototype.DoOffset = function(delta) {
        this.m_destPolys = new Array();
        this.m_delta = delta;
        //if Zero offset, just copy any CLOSED polygons to m_p and return ...
        if (ClipperLib.ClipperBase.near_zero(delta)) {
            //this.m_destPolys.set_Capacity(this.m_polyNodes.ChildCount);
            for(var i = 0; i < this.m_polyNodes.ChildCount(); i++){
                var node = this.m_polyNodes.Childs()[i];
                if (node.m_endtype === ClipperLib.EndType.etClosedPolygon) this.m_destPolys.push(node.m_polygon);
            }
            return;
        }
        //see offset_triginometry3.svg in the documentation folder ...
        if (this.MiterLimit > 2) this.m_miterLim = 2 / (this.MiterLimit * this.MiterLimit);
        else this.m_miterLim = 0.5;
        var y;
        if (this.ArcTolerance <= 0) y = ClipperLib.ClipperOffset.def_arc_tolerance;
        else if (this.ArcTolerance > Math.abs(delta) * ClipperLib.ClipperOffset.def_arc_tolerance) y = Math.abs(delta) * ClipperLib.ClipperOffset.def_arc_tolerance;
        else y = this.ArcTolerance;
        //see offset_triginometry2.svg in the documentation folder ...
        var steps = 3.14159265358979 / Math.acos(1 - y / Math.abs(delta));
        this.m_sin = Math.sin(ClipperLib.ClipperOffset.two_pi / steps);
        this.m_cos = Math.cos(ClipperLib.ClipperOffset.two_pi / steps);
        this.m_StepsPerRad = steps / ClipperLib.ClipperOffset.two_pi;
        if (delta < 0) this.m_sin = -this.m_sin;
        //this.m_destPolys.set_Capacity(this.m_polyNodes.ChildCount * 2);
        for(var i = 0; i < this.m_polyNodes.ChildCount(); i++){
            var node = this.m_polyNodes.Childs()[i];
            this.m_srcPoly = node.m_polygon;
            var len = this.m_srcPoly.length;
            if (len === 0 || delta <= 0 && (len < 3 || node.m_endtype !== ClipperLib.EndType.etClosedPolygon)) continue;
            this.m_destPoly = new Array();
            if (len === 1) {
                if (node.m_jointype === ClipperLib.JoinType.jtRound) {
                    var X = 1, Y = 0;
                    for(var j = 1; j <= steps; j++){
                        this.m_destPoly.push(new ClipperLib.IntPoint2(ClipperLib.ClipperOffset.Round(this.m_srcPoly[0].X + X * delta), ClipperLib.ClipperOffset.Round(this.m_srcPoly[0].Y + Y * delta)));
                        var X2 = X;
                        X = X * this.m_cos - this.m_sin * Y;
                        Y = X2 * this.m_sin + Y * this.m_cos;
                    }
                } else {
                    var X = -1, Y = -1;
                    for(var j = 0; j < 4; ++j){
                        this.m_destPoly.push(new ClipperLib.IntPoint2(ClipperLib.ClipperOffset.Round(this.m_srcPoly[0].X + X * delta), ClipperLib.ClipperOffset.Round(this.m_srcPoly[0].Y + Y * delta)));
                        if (X < 0) X = 1;
                        else if (Y < 0) Y = 1;
                        else X = -1;
                    }
                }
                this.m_destPolys.push(this.m_destPoly);
                continue;
            }
            //build m_normals ...
            this.m_normals.length = 0;
            //this.m_normals.set_Capacity(len);
            for(var j = 0; j < len - 1; j++)this.m_normals.push(ClipperLib.ClipperOffset.GetUnitNormal(this.m_srcPoly[j], this.m_srcPoly[j + 1]));
            if (node.m_endtype === ClipperLib.EndType.etClosedLine || node.m_endtype === ClipperLib.EndType.etClosedPolygon) this.m_normals.push(ClipperLib.ClipperOffset.GetUnitNormal(this.m_srcPoly[len - 1], this.m_srcPoly[0]));
            else this.m_normals.push(new ClipperLib.DoublePoint1(this.m_normals[len - 2]));
            if (node.m_endtype === ClipperLib.EndType.etClosedPolygon) {
                var k = len - 1;
                for(var j = 0; j < len; j++)k = this.OffsetPoint(j, k, node.m_jointype);
                this.m_destPolys.push(this.m_destPoly);
            } else if (node.m_endtype === ClipperLib.EndType.etClosedLine) {
                var k = len - 1;
                for(var j = 0; j < len; j++)k = this.OffsetPoint(j, k, node.m_jointype);
                this.m_destPolys.push(this.m_destPoly);
                this.m_destPoly = new Array();
                //re-build m_normals ...
                var n = this.m_normals[len - 1];
                for(var j = len - 1; j > 0; j--)this.m_normals[j] = new ClipperLib.DoublePoint2(-this.m_normals[j - 1].X, -this.m_normals[j - 1].Y);
                this.m_normals[0] = new ClipperLib.DoublePoint2(-n.X, -n.Y);
                k = 0;
                for(var j = len - 1; j >= 0; j--)k = this.OffsetPoint(j, k, node.m_jointype);
                this.m_destPolys.push(this.m_destPoly);
            } else {
                var k = 0;
                for(var j = 1; j < len - 1; ++j)k = this.OffsetPoint(j, k, node.m_jointype);
                var pt1;
                if (node.m_endtype === ClipperLib.EndType.etOpenButt) {
                    var j = len - 1;
                    pt1 = new ClipperLib.IntPoint2(ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].X + this.m_normals[j].X * delta), ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].Y + this.m_normals[j].Y * delta));
                    this.m_destPoly.push(pt1);
                    pt1 = new ClipperLib.IntPoint2(ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].X - this.m_normals[j].X * delta), ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].Y - this.m_normals[j].Y * delta));
                    this.m_destPoly.push(pt1);
                } else {
                    var j = len - 1;
                    k = len - 2;
                    this.m_sinA = 0;
                    this.m_normals[j] = new ClipperLib.DoublePoint2(-this.m_normals[j].X, -this.m_normals[j].Y);
                    if (node.m_endtype === ClipperLib.EndType.etOpenSquare) this.DoSquare(j, k);
                    else this.DoRound(j, k);
                }
                //re-build m_normals ...
                for(var j = len - 1; j > 0; j--)this.m_normals[j] = new ClipperLib.DoublePoint2(-this.m_normals[j - 1].X, -this.m_normals[j - 1].Y);
                this.m_normals[0] = new ClipperLib.DoublePoint2(-this.m_normals[1].X, -this.m_normals[1].Y);
                k = len - 1;
                for(var j = k - 1; j > 0; --j)k = this.OffsetPoint(j, k, node.m_jointype);
                if (node.m_endtype === ClipperLib.EndType.etOpenButt) {
                    pt1 = new ClipperLib.IntPoint2(ClipperLib.ClipperOffset.Round(this.m_srcPoly[0].X - this.m_normals[0].X * delta), ClipperLib.ClipperOffset.Round(this.m_srcPoly[0].Y - this.m_normals[0].Y * delta));
                    this.m_destPoly.push(pt1);
                    pt1 = new ClipperLib.IntPoint2(ClipperLib.ClipperOffset.Round(this.m_srcPoly[0].X + this.m_normals[0].X * delta), ClipperLib.ClipperOffset.Round(this.m_srcPoly[0].Y + this.m_normals[0].Y * delta));
                    this.m_destPoly.push(pt1);
                } else {
                    k = 1;
                    this.m_sinA = 0;
                    if (node.m_endtype === ClipperLib.EndType.etOpenSquare) this.DoSquare(0, 1);
                    else this.DoRound(0, 1);
                }
                this.m_destPolys.push(this.m_destPoly);
            }
        }
    };
    ClipperLib.ClipperOffset.prototype.Execute = function() {
        var a = arguments, ispolytree = a[0] instanceof ClipperLib.PolyTree;
        if (!ispolytree) {
            var solution = a[0], delta = a[1];
            ClipperLib.Clear(solution);
            this.FixOrientations();
            this.DoOffset(delta);
            //now clean up 'corners' ...
            var clpr = new ClipperLib.Clipper(0);
            clpr.AddPaths(this.m_destPolys, ClipperLib.PolyType.ptSubject, true);
            if (delta > 0) clpr.Execute(ClipperLib.ClipType.ctUnion, solution, ClipperLib.PolyFillType.pftPositive, ClipperLib.PolyFillType.pftPositive);
            else {
                var r = ClipperLib.Clipper.GetBounds(this.m_destPolys);
                var outer = new ClipperLib.Path();
                outer.push(new ClipperLib.IntPoint2(r.left - 10, r.bottom + 10));
                outer.push(new ClipperLib.IntPoint2(r.right + 10, r.bottom + 10));
                outer.push(new ClipperLib.IntPoint2(r.right + 10, r.top - 10));
                outer.push(new ClipperLib.IntPoint2(r.left - 10, r.top - 10));
                clpr.AddPath(outer, ClipperLib.PolyType.ptSubject, true);
                clpr.ReverseSolution = true;
                clpr.Execute(ClipperLib.ClipType.ctUnion, solution, ClipperLib.PolyFillType.pftNegative, ClipperLib.PolyFillType.pftNegative);
                if (solution.length > 0) solution.splice(0, 1);
            }
        //console.log(JSON.stringify(solution));
        } else {
            var solution = a[0], delta = a[1];
            solution.Clear();
            this.FixOrientations();
            this.DoOffset(delta);
            //now clean up 'corners' ...
            var clpr = new ClipperLib.Clipper(0);
            clpr.AddPaths(this.m_destPolys, ClipperLib.PolyType.ptSubject, true);
            if (delta > 0) clpr.Execute(ClipperLib.ClipType.ctUnion, solution, ClipperLib.PolyFillType.pftPositive, ClipperLib.PolyFillType.pftPositive);
            else {
                var r = ClipperLib.Clipper.GetBounds(this.m_destPolys);
                var outer = new ClipperLib.Path();
                outer.push(new ClipperLib.IntPoint2(r.left - 10, r.bottom + 10));
                outer.push(new ClipperLib.IntPoint2(r.right + 10, r.bottom + 10));
                outer.push(new ClipperLib.IntPoint2(r.right + 10, r.top - 10));
                outer.push(new ClipperLib.IntPoint2(r.left - 10, r.top - 10));
                clpr.AddPath(outer, ClipperLib.PolyType.ptSubject, true);
                clpr.ReverseSolution = true;
                clpr.Execute(ClipperLib.ClipType.ctUnion, solution, ClipperLib.PolyFillType.pftNegative, ClipperLib.PolyFillType.pftNegative);
                //remove the outer PolyNode rectangle ...
                if (solution.ChildCount() === 1 && solution.Childs()[0].ChildCount() > 0) {
                    var outerNode = solution.Childs()[0];
                    //solution.Childs.set_Capacity(outerNode.ChildCount);
                    solution.Childs()[0] = outerNode.Childs()[0];
                    solution.Childs()[0].m_Parent = solution;
                    for(var i = 1; i < outerNode.ChildCount(); i++)solution.AddChild(outerNode.Childs()[i]);
                } else solution.Clear();
            }
        }
    };
    ClipperLib.ClipperOffset.prototype.OffsetPoint = function(j, k, jointype) {
        //cross product ...
        this.m_sinA = this.m_normals[k].X * this.m_normals[j].Y - this.m_normals[j].X * this.m_normals[k].Y;
        if (Math.abs(this.m_sinA * this.m_delta) < 1.0) {
            //dot product ...
            var cosA = this.m_normals[k].X * this.m_normals[j].X + this.m_normals[j].Y * this.m_normals[k].Y;
            if (cosA > 0) {
                this.m_destPoly.push(new ClipperLib.IntPoint2(ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].X + this.m_normals[k].X * this.m_delta), ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].Y + this.m_normals[k].Y * this.m_delta)));
                return k;
            }
        //else angle ==> 180 degrees
        } else if (this.m_sinA > 1) this.m_sinA = 1.0;
        else if (this.m_sinA < -1) this.m_sinA = -1;
        if (this.m_sinA * this.m_delta < 0) {
            this.m_destPoly.push(new ClipperLib.IntPoint2(ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].X + this.m_normals[k].X * this.m_delta), ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].Y + this.m_normals[k].Y * this.m_delta)));
            this.m_destPoly.push(new ClipperLib.IntPoint1(this.m_srcPoly[j]));
            this.m_destPoly.push(new ClipperLib.IntPoint2(ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].X + this.m_normals[j].X * this.m_delta), ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].Y + this.m_normals[j].Y * this.m_delta)));
        } else switch(jointype){
            case ClipperLib.JoinType.jtMiter:
                var r = 1 + (this.m_normals[j].X * this.m_normals[k].X + this.m_normals[j].Y * this.m_normals[k].Y);
                if (r >= this.m_miterLim) this.DoMiter(j, k, r);
                else this.DoSquare(j, k);
                break;
            case ClipperLib.JoinType.jtSquare:
                this.DoSquare(j, k);
                break;
            case ClipperLib.JoinType.jtRound:
                this.DoRound(j, k);
                break;
        }
        k = j;
        return k;
    };
    ClipperLib.ClipperOffset.prototype.DoSquare = function(j, k) {
        var dx = Math.tan(Math.atan2(this.m_sinA, this.m_normals[k].X * this.m_normals[j].X + this.m_normals[k].Y * this.m_normals[j].Y) / 4);
        this.m_destPoly.push(new ClipperLib.IntPoint2(ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].X + this.m_delta * (this.m_normals[k].X - this.m_normals[k].Y * dx)), ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].Y + this.m_delta * (this.m_normals[k].Y + this.m_normals[k].X * dx))));
        this.m_destPoly.push(new ClipperLib.IntPoint2(ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].X + this.m_delta * (this.m_normals[j].X + this.m_normals[j].Y * dx)), ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].Y + this.m_delta * (this.m_normals[j].Y - this.m_normals[j].X * dx))));
    };
    ClipperLib.ClipperOffset.prototype.DoMiter = function(j, k, r) {
        var q = this.m_delta / r;
        this.m_destPoly.push(new ClipperLib.IntPoint2(ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].X + (this.m_normals[k].X + this.m_normals[j].X) * q), ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].Y + (this.m_normals[k].Y + this.m_normals[j].Y) * q)));
    };
    ClipperLib.ClipperOffset.prototype.DoRound = function(j, k) {
        var a = Math.atan2(this.m_sinA, this.m_normals[k].X * this.m_normals[j].X + this.m_normals[k].Y * this.m_normals[j].Y);
        var steps = Math.max(ClipperLib.Cast_Int32(ClipperLib.ClipperOffset.Round(this.m_StepsPerRad * Math.abs(a))), 1);
        var X = this.m_normals[k].X, Y = this.m_normals[k].Y, X2;
        for(var i = 0; i < steps; ++i){
            this.m_destPoly.push(new ClipperLib.IntPoint2(ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].X + X * this.m_delta), ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].Y + Y * this.m_delta)));
            X2 = X;
            X = X * this.m_cos - this.m_sin * Y;
            Y = X2 * this.m_sin + Y * this.m_cos;
        }
        this.m_destPoly.push(new ClipperLib.IntPoint2(ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].X + this.m_normals[j].X * this.m_delta), ClipperLib.ClipperOffset.Round(this.m_srcPoly[j].Y + this.m_normals[j].Y * this.m_delta)));
    };
    ClipperLib.Error = function(message) {
        try {
            throw new Error(message);
        } catch (err) {
            alert(err.message);
        }
    };
    // ---------------------------------------------
    // JS extension by Timo 2013
    ClipperLib.JS = {};
    ClipperLib.JS.AreaOfPolygon = function(poly, scale) {
        if (!scale) scale = 1;
        return ClipperLib.Clipper.Area(poly) / (scale * scale);
    };
    ClipperLib.JS.AreaOfPolygons = function(poly, scale) {
        if (!scale) scale = 1;
        var area = 0;
        for(var i = 0; i < poly.length; i++)area += ClipperLib.Clipper.Area(poly[i]);
        return area / (scale * scale);
    };
    ClipperLib.JS.BoundsOfPath = function(path, scale) {
        return ClipperLib.JS.BoundsOfPaths([
            path
        ], scale);
    };
    ClipperLib.JS.BoundsOfPaths = function(paths, scale) {
        if (!scale) scale = 1;
        var bounds = ClipperLib.Clipper.GetBounds(paths);
        bounds.left /= scale;
        bounds.bottom /= scale;
        bounds.right /= scale;
        bounds.top /= scale;
        return bounds;
    };
    // Clean() joins vertices that are too near each other
    // and causes distortion to offsetted polygons without cleaning
    ClipperLib.JS.Clean = function(polygon, delta) {
        if (!(polygon instanceof Array)) return [];
        var isPolygons = polygon[0] instanceof Array;
        var polygon = ClipperLib.JS.Clone(polygon);
        if (typeof delta !== "number" || delta === null) {
            ClipperLib.Error("Delta is not a number in Clean().");
            return polygon;
        }
        if (polygon.length === 0 || polygon.length === 1 && polygon[0].length === 0 || delta < 0) return polygon;
        if (!isPolygons) polygon = [
            polygon
        ];
        var k_length = polygon.length;
        var len, poly, result, d, p, j, i;
        var results = [];
        for(var k = 0; k < k_length; k++){
            poly = polygon[k];
            len = poly.length;
            if (len === 0) continue;
            else if (len < 3) {
                result = poly;
                results.push(result);
                continue;
            }
            result = poly;
            d = delta * delta;
            //d = Math.floor(c_delta * c_delta);
            p = poly[0];
            j = 1;
            for(i = 1; i < len; i++){
                if ((poly[i].X - p.X) * (poly[i].X - p.X) + (poly[i].Y - p.Y) * (poly[i].Y - p.Y) <= d) continue;
                result[j] = poly[i];
                p = poly[i];
                j++;
            }
            p = poly[j - 1];
            if ((poly[0].X - p.X) * (poly[0].X - p.X) + (poly[0].Y - p.Y) * (poly[0].Y - p.Y) <= d) j--;
            if (j < len) result.splice(j, len - j);
            if (result.length) results.push(result);
        }
        if (!isPolygons && results.length) results = results[0];
        else if (!isPolygons && results.length === 0) results = [];
        else if (isPolygons && results.length === 0) results = [
            []
        ];
        return results;
    };
    // Make deep copy of Polygons or Polygon
    // so that also IntPoint objects are cloned and not only referenced
    // This should be the fastest way
    ClipperLib.JS.Clone = function(polygon) {
        if (!(polygon instanceof Array)) return [];
        if (polygon.length === 0) return [];
        else if (polygon.length === 1 && polygon[0].length === 0) return [
            []
        ];
        var isPolygons = polygon[0] instanceof Array;
        if (!isPolygons) polygon = [
            polygon
        ];
        var len = polygon.length, plen, i, j, result;
        var results = new Array(len);
        for(i = 0; i < len; i++){
            plen = polygon[i].length;
            result = new Array(plen);
            for(j = 0; j < plen; j++)result[j] = {
                X: polygon[i][j].X,
                Y: polygon[i][j].Y
            };
            results[i] = result;
        }
        if (!isPolygons) results = results[0];
        return results;
    };
    // Removes points that doesn't affect much to the visual appearance.
    // If middle point is at or under certain distance (tolerance) of the line segment between
    // start and end point, the middle point is removed.
    ClipperLib.JS.Lighten = function(polygon, tolerance) {
        if (!(polygon instanceof Array)) return [];
        if (typeof tolerance !== "number" || tolerance === null) {
            ClipperLib.Error("Tolerance is not a number in Lighten().");
            return ClipperLib.JS.Clone(polygon);
        }
        if (polygon.length === 0 || polygon.length === 1 && polygon[0].length === 0 || tolerance < 0) return ClipperLib.JS.Clone(polygon);
        var isPolygons = polygon[0] instanceof Array;
        if (!isPolygons) polygon = [
            polygon
        ];
        var i, j, poly, k, poly2, plen, A, B, P, d, rem, addlast;
        var bxax, byay, l, ax, ay;
        var len = polygon.length;
        var toleranceSq = tolerance * tolerance;
        var results = [];
        for(i = 0; i < len; i++){
            poly = polygon[i];
            plen = poly.length;
            if (plen === 0) continue;
            for(k = 0; k < 1000000; k++){
                poly2 = [];
                plen = poly.length;
                // the first have to added to the end, if first and last are not the same
                // this way we ensure that also the actual last point can be removed if needed
                if (poly[plen - 1].X !== poly[0].X || poly[plen - 1].Y !== poly[0].Y) {
                    addlast = 1;
                    poly.push({
                        X: poly[0].X,
                        Y: poly[0].Y
                    });
                    plen = poly.length;
                } else addlast = 0;
                rem = []; // Indexes of removed points
                for(j = 0; j < plen - 2; j++){
                    A = poly[j]; // Start point of line segment
                    P = poly[j + 1]; // Middle point. This is the one to be removed.
                    B = poly[j + 2]; // End point of line segment
                    ax = A.X;
                    ay = A.Y;
                    bxax = B.X - ax;
                    byay = B.Y - ay;
                    if (bxax !== 0 || byay !== 0) {
                        l = ((P.X - ax) * bxax + (P.Y - ay) * byay) / (bxax * bxax + byay * byay);
                        if (l > 1) {
                            ax = B.X;
                            ay = B.Y;
                        } else if (l > 0) {
                            ax += bxax * l;
                            ay += byay * l;
                        }
                    }
                    bxax = P.X - ax;
                    byay = P.Y - ay;
                    d = bxax * bxax + byay * byay;
                    if (d <= toleranceSq) {
                        rem[j + 1] = 1;
                        j++; // when removed, transfer the pointer to the next one
                    }
                }
                // add all unremoved points to poly2
                poly2.push({
                    X: poly[0].X,
                    Y: poly[0].Y
                });
                for(j = 1; j < plen - 1; j++)if (!rem[j]) poly2.push({
                    X: poly[j].X,
                    Y: poly[j].Y
                });
                poly2.push({
                    X: poly[plen - 1].X,
                    Y: poly[plen - 1].Y
                });
                // if the first point was added to the end, remove it
                if (addlast) poly.pop();
                // break, if there was not anymore removed points
                if (!rem.length) break;
                else poly = poly2;
            }
            plen = poly2.length;
            // remove duplicate from end, if needed
            if (poly2[plen - 1].X === poly2[0].X && poly2[plen - 1].Y === poly2[0].Y) poly2.pop();
            if (poly2.length > 2) results.push(poly2);
        }
        if (!isPolygons) results = results[0];
        if (typeof results === "undefined") results = [];
        return results;
    };
    ClipperLib.JS.PerimeterOfPath = function(path, closed, scale) {
        if (typeof path === "undefined") return 0;
        var sqrt = Math.sqrt;
        var perimeter = 0.0;
        var p1, p2, p1x = 0.0, p1y = 0.0, p2x = 0.0, p2y = 0.0;
        var j = path.length;
        if (j < 2) return 0;
        if (closed) {
            path[j] = path[0];
            j++;
        }
        while(--j){
            p1 = path[j];
            p1x = p1.X;
            p1y = p1.Y;
            p2 = path[j - 1];
            p2x = p2.X;
            p2y = p2.Y;
            perimeter += sqrt((p1x - p2x) * (p1x - p2x) + (p1y - p2y) * (p1y - p2y));
        }
        if (closed) path.pop();
        return perimeter / scale;
    };
    ClipperLib.JS.PerimeterOfPaths = function(paths, closed, scale) {
        if (!scale) scale = 1;
        var perimeter = 0;
        for(var i = 0; i < paths.length; i++)perimeter += ClipperLib.JS.PerimeterOfPath(paths[i], closed, scale);
        return perimeter;
    };
    ClipperLib.JS.ScaleDownPath = function(path, scale) {
        var i, p;
        if (!scale) scale = 1;
        i = path.length;
        while(i--){
            p = path[i];
            p.X = p.X / scale;
            p.Y = p.Y / scale;
        }
    };
    ClipperLib.JS.ScaleDownPaths = function(paths, scale) {
        var i, j, p;
        if (!scale) scale = 1;
        i = paths.length;
        while(i--){
            j = paths[i].length;
            while(j--){
                p = paths[i][j];
                p.X = p.X / scale;
                p.Y = p.Y / scale;
            }
        }
    };
    ClipperLib.JS.ScaleUpPath = function(path, scale) {
        var i, p, round = Math.round;
        if (!scale) scale = 1;
        i = path.length;
        while(i--){
            p = path[i];
            p.X = round(p.X * scale);
            p.Y = round(p.Y * scale);
        }
    };
    ClipperLib.JS.ScaleUpPaths = function(paths, scale) {
        var i, j, p, round = Math.round;
        if (!scale) scale = 1;
        i = paths.length;
        while(i--){
            j = paths[i].length;
            while(j--){
                p = paths[i][j];
                p.X = round(p.X * scale);
                p.Y = round(p.Y * scale);
            }
        }
    };
    /**
	* @constructor
	*/ ClipperLib.ExPolygons = function() {
        return [];
    };
    /**
	* @constructor
	*/ ClipperLib.ExPolygon = function() {
        this.outer = null;
        this.holes = null;
    };
    ClipperLib.JS.AddOuterPolyNodeToExPolygons = function(polynode, expolygons) {
        var ep = new ClipperLib.ExPolygon();
        ep.outer = polynode.Contour();
        var childs = polynode.Childs();
        var ilen = childs.length;
        ep.holes = new Array(ilen);
        var node, n, i, j, childs2, jlen;
        for(i = 0; i < ilen; i++){
            node = childs[i];
            ep.holes[i] = node.Contour();
            //Add outer polygons contained by (nested within) holes ...
            for(j = 0, childs2 = node.Childs(), jlen = childs2.length; j < jlen; j++){
                n = childs2[j];
                ClipperLib.JS.AddOuterPolyNodeToExPolygons(n, expolygons);
            }
        }
        expolygons.push(ep);
    };
    ClipperLib.JS.ExPolygonsToPaths = function(expolygons) {
        var a, i, alen, ilen;
        var paths = new ClipperLib.Paths();
        for(a = 0, alen = expolygons.length; a < alen; a++){
            paths.push(expolygons[a].outer);
            for(i = 0, ilen = expolygons[a].holes.length; i < ilen; i++)paths.push(expolygons[a].holes[i]);
        }
        return paths;
    };
    ClipperLib.JS.PolyTreeToExPolygons = function(polytree) {
        var expolygons = new ClipperLib.ExPolygons();
        var node, i, childs, ilen;
        for(i = 0, childs = polytree.Childs(), ilen = childs.length; i < ilen; i++){
            node = childs[i];
            ClipperLib.JS.AddOuterPolyNodeToExPolygons(node, expolygons);
        }
        return expolygons;
    };
})();


var $320e50466335b17c$exports = {};
$320e50466335b17c$exports = JSON.parse("{\"viewBox\":\"0 0 1622.67 1031.47\",\"territories\":{\"sivas\":{\"paths\":[\"m1003.48,308.04c-.99,2.86-4.51,4.07-3.41,7.93,1.1,3.85-2.42,9.91-2.64,12.66-.22,2.75-1.43,6.45.11,9.66,1.54,3.22,4.29,6.41,2.86,7.62-1.43,1.21-3.19,3.75-2.75,6.94s1.76,9.47.33,10.57c-.32.25-.87.73-1.57,1.34-2.43,2.11-6.68,5.7-9.33,5.7-3.41,0-9.8.29-13.54,2.18-3.75,1.9-6.06,4.54-9.03,4.32-2.97-.22-8.81-.66-8.37,2.42.44,3.08.55,10.08-2.04,11.86-2.58,1.79-9.52,8.84-12.6,10.49-.11.06-.21.11-.31.17,0,0-5.3.93-7.42.93s-5.4.61-6.83-.61c-1.43-1.21-6-1.76-8.06-1.45-2.07.3-7.23.31-8.92,3.95-1.69,3.63-2.11,9.66-4.38,10.94-2.27,1.28-4.46,5.45-6.56,3.3-2.11-2.15-3.94-7.35-6.43-7.85-2.49-.49-9.3,1.66-11.32,5.78-2.03,4.13-4.87,10.33-5.91,11.89-1.03,1.57-13.46,11.56-15.19,12.55-1.73,1-5.28,2.65-5.61,4.3-.33,1.65,1.48,10.4.57,11.39-.9.99-2.83,2.26-4.46,1.52-1.62-.75-7.92-3-12.33-3.44-4.4-.44-6.11-.33-6.79-.03-.69.3-5.32,5.17-5.89,5.7-.58.52-3.8.99-4.35,1.04-.55.06-4.16.21-5.6-.16-1.45-.38-2.6,1.73-2.73,3.26-.12,1.53,2.52,6.07,1.03,7.97-1.48,1.89-4.12,4.7-2.14,10.56h0c-2.68.34-7.4.56-9.75,1.1-2.29.54-6.17,1.56-8.19,2.1.18-1.91-2.62-6.73-4.52-10.38-2.15-4.13,2.31-10.9,1.65-13.87-.66-2.97-6.77-10.4-10.57-14.04-3.8-3.63-.16-9.24,3.14-13.61,3.3-4.36,9.91-14.63,8.09-18.33-1.82-3.7-3.74-8.74-2.81-11.54.94-2.81.43-3.83-3.74-3.86-4.17-.03-4.84-5.12-3.52-7.65,1.25-2.39-.21-9.93-.38-10.77,5.78-.01,9.18-6.3,12.05-7.72,3.37-1.68,10.35-5.62,9.69-8.7-.66-3.08.22-3.63-.67-7.49-.88-3.85-2.31-7.59.22-10.02,2.54-2.42-6.49-8.91-8.36-12.55-1.87-3.63-4.3-6.27-7.71-8.25-3.41-1.98-6.27-4.19-11.45-6.72-5.17-2.53-3.74-7.15-3.63-11.04.11-3.89,2.75-6.9,1.1-10.16-1.65-3.25,1.21-4.78-3.85-9.5-.3-.28-.65-.56-1.05-.83,14.57-2.7,8.53-13.5,7.1-17.9-1.43-4.4-4.29-8.15-2.64-13.98.74-2.63.42-5.35-.92-8.11.27-.04.85-.13,1.63-.28.16-.03.34-.06.53-.1.17-.03.35-.07.54-.11.14-.03.28-.06.43-.1.17-.03.35-.08.53-.12.18-.04.36-.08.54-.13.09-.02.18-.05.27-.07.55-.14,1.12-.3,1.69-.48.48-.15.95-.31,1.4-.49.37-.14.73-.29,1.07-.45.17-.08.34-.16.5-.24.16-.08.32-.17.47-.26.15-.08.29-.17.43-.25.01-.01.02-.02.02-.02.14-.09.27-.18.4-.28.13-.09.25-.19.36-.3.09-.07.18-.15.26-.24.03-.03.06-.07.1-.1.07-.07.13-.15.19-.23.02-.03.04-.05.06-.08.07-.1.14-.19.19-.29.01-.01.02-.03.02-.04.01-.02.02-.04.03-.05.05-.1.1-.2.13-.3.02-.04.03-.07.04-.11.02-.04.02-.08.03-.12h0c.03-.09.04-.18.05-.27.02-.08.02-.16.02-.25,0-4.19-4.52-6.83-2.09-9.14,2.42-2.31,6.16-8.37,7.59-11.67,1.43-3.3,4.85-5.17,10.9-2.86,6.06,2.31,9.02,3.49,11.89,3.52,2.87.03,8.16,2.31,8.87,5.95.71,3.63,2.14,5.06,11.17,6.27,9.03,1.21,10.57.66,13.98,1.98,3.41,1.32,7.71,9.14,11.56,9.36,3.85.22,11.45-.44,14.75,1.65,3.31,2.09,8.37-3.3,11.01-7.26,2.64-3.97,5.62-2.1,7.16-.11,1.54,1.98,4.73,8.14,8.58,7.37,3.86-.77,7.82-2.97,9.25-2.2,1.43.77,1.76,7.05,8.7,9.03,6.94,1.98,8.26,4.68,12.11,4.54,3.85-.14,9.91-.25,13.32,2.94,3.41,3.2,4.84,5.2,8.92,5.46,4.07.27,6.89,2.76,8.4,7.95,1.51,5.2,5.47,8.61,7.56,8.28,2.09-.33,4.79-4.51,6.39-4.4,1.59.11,5.94.22,5.56-.77-.39-.99-1.27-4.31.49-4.61,1.76-.29,4.9-.92,5.53-1.87.1.45.16.85.2,1.19.22,2.09,2.86,5.62,3.74,9.58.88,3.96.88,9.36,6.5,13.76,3.43,2.69,6.16,4.85,7.53,6.77.88,1.23,1.22,2.36.83,3.47Z\"],\"label\":[886,350],\"bbox\":[768,219.5,1004,486.5],\"geoNeighbors\":[\"adana\",\"ankara\",\"elazig\",\"erzurum\",\"kastamonu\",\"konya\",\"maras\",\"samsun\",\"trabzon\"],\"poly\":[[[1003.5,308],[1000,313.5],[1000.2,319.2],[997.7,327.5],[996.8,333.3],[996.8,335.8],[997.5,338.3],[1000.8,344.7],[1000.8,345.4],[998.3,348.6],[997.7,350.6],[998.6,361.8],[998,363.4],[996.4,364.8],[991.8,368.4],[989.3,369.9],[987.1,370.5],[980.4,370.8],[976.8,371.5],[973.5,372.6],[966.6,376.6],[959,376.9],[956.8,377.7],[956.3,378.4],[956.1,379.4],[956.3,385.8],[954.9,390.3],[944.4,399.6],[941.2,401.9],[935.8,402.7],[930.1,403],[928.3,402.8],[925.4,401.4],[920.8,400.7],[914.3,401.5],[911.8,402.6],[910,404.7],[906.4,415],[902.2,418.6],[900.6,419.5],[899,419],[894.3,412.2],[892.6,411.1],[890.1,411.2],[886.8,412.3],[883.5,414.2],[881.3,416.9],[876.4,426.8],[874.5,429.7],[863.1,439.2],[855.3,444.4],[854.6,445.6],[854.5,446.6],[855.4,455.1],[855.1,457],[853.2,458.4],[851.9,458.8],[841.9,455.7],[838.3,455.1],[832.3,454.9],[831.6,455.1],[825.7,460.8],[824.8,461.1],[821.3,461.8],[814.7,461.8],[813.9,462.6],[813,464.9],[814.5,471],[814.4,472.1],[811.6,476.7],[811.3,478],[811.3,481.4],[811.9,483.4],[802.1,484.5],[793.9,486.6],[793.6,484.7],[788.9,474.6],[788.9,472.8],[790.8,465.2],[791.1,462.4],[789.7,459.5],[787,455.6],[780.5,448.4],[779.4,446.9],[778.9,445.3],[779.4,441.8],[781.2,438.2],[786.5,430.6],[789.6,425.3],[791.7,420.2],[792,418.1],[791.7,416.4],[789.3,410.3],[788.7,407.3],[789.3,403.1],[789,401.9],[787.6,401.2],[783.8,400.8],[782.7,400.2],[781.4,398.1],[781.1,395.6],[782.1,390.8],[781.3,382.6],[785.2,381.6],[788.4,379.3],[792.2,375.6],[799.7,371],[802.2,368.6],[802.9,367.4],[803,366.2],[802.7,361],[801.2,353.1],[801.3,350.7],[803,347.6],[801.5,344.6],[795.2,337.6],[790.9,331.4],[786.5,327.9],[775,321.1],[772.3,318.9],[771.2,316.1],[771.4,310.1],[773,302.4],[772.9,301.2],[771.2,293.5],[767.6,289.6],[772.2,288.2],[775.1,286.3],[776.6,283.9],[777.2,281.3],[776.3,276],[772.2,265.3],[771.6,261.8],[772.4,253.7],[771.2,249.6],[778.7,247.7],[781.2,246.5],[782.6,245.3],[783.1,244.1],[782.9,242.4],[780.3,236.5],[780.4,235.6],[785.2,229.3],[790,220.9],[792.3,219.5],[795.4,219.2],[799.5,220.2],[806.6,222.8],[813.9,224.1],[816.6,225.3],[819,227.2],[819.8,228.4],[821,232],[822.7,233.7],[828.4,235.5],[843,237.2],[845.4,237.9],[848.1,239.9],[854,245.9],[857,247.3],[868.5,247.8],[873,249.4],[874.4,249.2],[877.5,247.6],[880.3,244.8],[883.7,240.4],[885.7,239.4],[886.7,239.4],[888.5,240.2],[893.3,246.3],[895.7,248.4],[897,248.9],[898.5,248.9],[906.2,246.6],[907.7,246.7],[911,252.2],[914.1,254.8],[920.7,257.3],[926,259.9],[935.3,260.5],[938.9,261.4],[941.8,263.2],[946,267.1],[948.1,268.2],[953.6,269.3],[955.9,270.8],[957.8,273.2],[960.7,280.2],[962.7,282.9],[965.8,284.9],[966.7,284.9],[968.4,284.1],[972.5,280.7],[976.6,280.5],[978.6,280.1],[978.1,277.2],[978.6,275.4],[982.3,274.5],[984.7,273.3],[985.4,276.3],[988.6,284],[990.1,290.8],[991.9,294.4],[993.3,296.1],[999.7,301.5],[1002.6,304.6],[1003.5,306.3],[1003.5,308]]]},\"baghdad\":{\"paths\":[\"m1530.17,947.35s-2.31,7.16-14.75,0c-12.44-7.15-14.53-1.65-17.4-.55-.53.2-1.18.23-1.95.11-3.39-.49-9.22-3.65-18.19-6.16-11.01-3.09-20.04,4.18-21.8,6.38s-7.71,16.96-7.71,16.96l-7.04,14.31s-1.48,2.07-3.05,4.28c-1.62,2.29-3.34,4.74-3.56,5.19-.31.63-5.3,6.92-8.16,10.51-1.16,1.46-1.97,2.48-1.97,2.48l-9.91,2.42-86.97-7.71-136.84-114.88-88.43-51.19-49.79-9.97-12.47-2.5,5.7-3.47-1.88-5.23-1.43-3.99-10.67,2.6-2.95-10.47,5.57-.78-15.64-54.13c.16-.1.31-.19.46-.29.86-.55,1.71-1.1,2.55-1.63,3.59-2.3,7.01-4.49,10.21-6.53.26-.16.5-.32.75-.48,6.44-4.12,11.94-7.63,16.03-10.23.35-.22.69-.44,1.02-.65,1.05-.67,1.99-1.27,2.82-1.79.19-.13.38-.25.57-.36,1.83-1.16,3-1.9,3.38-2.12,4.83-2.86,55.81-33.91,57.46-34.9,1.66-.99,18.2-5.71,18.9-6.08.7-.37,1.49-1.78,1.9-2.77.41-.99,9.86-19.5,10.47-20.38.01-.01.02-.03.03-.06.02-.06.04-.14.05-.24.07-.43.13-1.26.18-2.37.01-.28.02-.58.03-.89.01-.16.01-.33.02-.5,0-.32.02-.67.03-1.02,8.01-3.18,16.33-7.47,25.48-11.82,7.25-3.06,31.03,1.54,35.92,1.02,18.47-8.55,31.73-21.39,50.77-23.75,72.11,19.02,68.41-7.94,108.87-38.81,3-.31,7.92-.16,13.12,6.28,6.49,8.03,12.11,1.87,23.34,3.52,11.22,1.65,5.17,5.95,2.75,7.27-2.42,1.32-7.49,3.19-9.58,8.14-2.09,4.96,4.18,12.55,7.6,22.35,3.41,9.8-8.04,10.35-11.01,9.8-2.98-.55-2.98,8.81-4.85,11.23-1.87,2.42-4.65,4.02-6.05,5.01-1.41.99-4.54,5.37-2.97,7.18,1.56,1.82,3.88,10.24,3.88,11.23s-5.6-.72-6.84-.49c-1.24.22-3.09-2.27-3.84-2.56-.74-.29-1.34,1.17-1.15,3.71.18,2.54.02,2.01-1.96,3.88-1.98,1.87.22,6.28,3.19,8.04,2.97,1.76,1.98,9.47,1.1,12.11-.88,2.64-4.07,6.5-5.39,9.25-1.33,2.75,2.31,3.19,7.15,11.56,4.85,8.36,12.33,11.89,16.08,13.76,3.74,1.87,10.23,15.96,14.03,20.75,3.8,4.79-1.24,8.97-2.01,9.39-.77.41-4.04-.77-4.18.77-.14,1.54,2.64,1.98,3.94,2.42,1.29.44,1.04,2.31.79,3-.24.69-2.47.58-2.58,1.87-.11,1.29,1.87,1.62,2.67,1.9.79.27,5.56.08,9.3.19,3.74.11,8.34,1.93,10.65,4.12,2.31,2.19,8.26,4.7,11.93,8.63,3.68,3.92,14.86,13.99,18.04,16.72,3.18,2.72,6.53,1.77,7.85,1.44,1.32-.33,2.18-1.44,3.96-1.36,1.78.08,4.43,2.49,5.39,3.26.97.77,1.88,2.89,1.52,4.21-.36,1.32-.99,1.4.85,3.08,1.85,1.68,1.96,3.72,2.62,4.46.66.75,2.45,1.43,1.81,2.48-.63,1.04-2.14,1.9-1.26,3.8.88,1.9,5.5,1.95,5.38,2.57-.13.62,3.3,4.62,3.55,6.32.25,1.69,4.75,6.44,6.89,9.7,2.15,3.26.5,5.82.5,5.82l-9.25,17.98-.74,25,17.58.04s-.31,31.91.13,32.04c.44.12,8.79-.09,8.83,3.63.04,3.71,1.41,4.79,2.89,4.37,1.49-.41,3.68.83,4.17,1.9.5,1.08,5.33,3.8,5,5.99-.65,4.28.2,4.55.64,6.32.44,1.76,2.43,6.49,3.86,7.04,1.43.55,4.07,1.32,4.07,1.32Z\"],\"label\":[1275,770],\"bbox\":[1019.5,575,1530.5,1003],\"geoNeighbors\":[\"aleppo\",\"mosul\"],\"poly\":[[[1530.2,947.4],[1528.8,949.2],[1527.5,950],[1525.6,950.5],[1523,950.4],[1519.6,949.4],[1511.2,945.2],[1507.9,944.1],[1505.2,943.7],[1503.1,944],[1498,946.8],[1496.1,946.9],[1477.9,940.8],[1473.9,940],[1470.1,940.1],[1466.6,940.8],[1463.5,942],[1458.7,944.8],[1456.1,947.1],[1455.2,948.5],[1448.4,964.1],[1437.7,985.5],[1438.5,982.4],[1433.7,989.3],[1424.6,1000.9],[1414.7,1003.3],[1327.7,995.6],[1190.9,880.7],[1102.4,829.5],[1040.2,817],[1045.9,813.6],[1042.6,804.3],[1031.9,806.9],[1028.9,796.5],[1034.5,795.7],[1018.9,741.6],[1056.2,717.7],[1114.1,682.6],[1133,676.5],[1134.1,675.3],[1145.4,653.3],[1145.7,648.3],[1171.2,636.5],[1174.6,635.6],[1179.2,635.4],[1207.1,637.5],[1213.8,634.1],[1238.3,620],[1244.5,617.2],[1251,615.1],[1257.9,613.7],[1276.3,617.9],[1291.3,619.8],[1303.4,619.8],[1313.4,617.9],[1319.1,615.8],[1324.2,613],[1329,609.7],[1338.1,601.4],[1353.4,586.2],[1366.8,574.9],[1369.4,574.9],[1372.5,575.5],[1374.3,576.3],[1378,579.1],[1382.3,583.6],[1384.7,584.9],[1387.2,585.4],[1389.8,585.3],[1399.3,584.4],[1403.2,584.7],[1407.9,585.9],[1409.7,587.4],[1409.7,588.5],[1409.1,589.5],[1406,592],[1401.1,594.7],[1398.4,596.9],[1396.4,600.1],[1396,602.1],[1397,606.8],[1404,622.5],[1404.6,625.7],[1404.1,628.2],[1402.8,630],[1400.9,631.3],[1396.5,632.3],[1392,632.5],[1390.6,634.9],[1389.3,640.6],[1388.1,643.5],[1386.6,645.2],[1382.1,648.5],[1379.5,651.8],[1378.7,654.9],[1380.4,658.1],[1381.7,661.6],[1383,666.9],[1382.1,667.2],[1375.2,666.2],[1372.3,663.9],[1371.8,664],[1371.4,664.7],[1371,669.8],[1369.2,671.5],[1368.5,673.3],[1369,675.5],[1370.4,677.8],[1373.3,680.4],[1374,681.8],[1374.4,685.2],[1374.1,688.9],[1373.5,691.6],[1372.5,693.8],[1368.1,700.9],[1368,702.6],[1371.9,707.5],[1377.2,715.3],[1379.3,717.8],[1383.7,721.7],[1392.9,727.4],[1396.4,732.3],[1406.4,748.7],[1406.8,750.4],[1406.6,751.9],[1406.1,753.3],[1404.5,755.3],[1403.4,756.3],[1399.8,756.4],[1399.2,757.1],[1399.6,758.1],[1403.1,759.5],[1403.8,760.1],[1404.1,760.9],[1403.9,762.5],[1401.8,763.6],[1401.3,764.4],[1401.6,765.2],[1404.5,766.4],[1413.3,766.5],[1416.2,766.9],[1421.8,769],[1432.8,776.5],[1453.9,795.9],[1456.3,797.4],[1458.6,797.8],[1461.8,797.4],[1464.6,796.2],[1465.7,796],[1468.7,797.4],[1471.8,800.1],[1472.7,802.4],[1472.3,804.9],[1472.5,805.6],[1474.6,807.9],[1476.1,811],[1478,812.8],[1476.4,816.1],[1476.7,817.3],[1477.9,818.4],[1481.9,819.7],[1484.9,824.6],[1486.5,828],[1492.5,835.9],[1493.5,838.2],[1493.2,841.3],[1483.7,859.7],[1483,884.7],[1500.6,884.7],[1502.7,898.5],[1503.9,911.2],[1503.6,915.6],[1502.9,917.6],[1502.5,917.9],[1501.6,917.8],[1500.7,916.8],[1505.3,917.2],[1508.2,918.3],[1509.2,919.2],[1509.8,922.7],[1510.4,924.1],[1511.4,924.8],[1513.6,924.8],[1514.9,925.2],[1519.4,929.3],[1521.5,931.8],[1521.5,936.8],[1522.8,940.8],[1525,944.9],[1526.1,946],[1530.2,947.4]]]},\"mosul\":{\"paths\":[\"m1366.77,574.91c-40.46,30.87-36.76,57.83-108.87,38.81-19.04,2.36-32.3,15.2-50.77,23.75-4.89.52-28.67-4.08-35.92-1.02-9.15,4.35-17.47,8.64-25.48,11.82.26-8.64.26-25.31.43-26.46.22-1.54,1.93-7.4,2.18-8.31.24-.91.41-7.18,1.07-8.01s5.23-7.18,5.23-8.39-.66-14.87-.94-15.25c-.27-.39-5.5-11.67-5.45-12.5.06-.82,1.49-18.93,1.49-18.93l5.78-10.85s18.91-3.4,20.52-4.18c1.61-.78,13.21-11.85,14.03-13.17.62-.99,12.39-14.63,18.26-21.42,1.9-.77,6.67-1.96,7.57-1.85.94.11,2.76-3.08,3.09-4.18.33-1.11,3.68-1.93,4.68-2.65.99-.71-.83-5.34,1.04-6.33,1.87-.99,7.43.17,9.58,1.32,2.15,1.16,4.57-.27,6.38-1.21,1.82-.93,9.47-.38,12.94,1.52,3.47,1.9,3.14-.99,4.95-.17,1.82.83,3.89,4.13,6.2,4.96,2.31.82,4.87-.58,6.44.49,1.57,1.08,5.14,1.24,7.46.91,2.31-.33,3.63.88,4.68.88s5.2-.22,5.44-2.28c.25-2.07.75-2.89,2.07-3.47s6.36-1.82,8.67-.91c2.31.91,5.65,4.05,6.07,5.57.41,1.53,1.24,3.18-.54,3.97-1.77.78-3.88,3.38-3.01,5.49.86,2.1,2.06,3.88,2.31,5.03.25,1.16,1.65,2.23,2.72,2.03,1.08-.21,3.31-2.11,3.14-3.55-.16-1.45.17-1.37.95-1.45.79-.08,3.63-.2,4.05-.74.41-.54,6.89-6.4,7.47-6.94.58-.53,2.23-1.57,3.38-.58,1.16,1,6.28.38,6.28.38,0,0-.62,1.36-.83,3.46-.2,2.11,2.07,4.34,3.84,5.08,1.78.75,3.55,2.73,2.89,4.01-.66,1.28.42,3.59,1.04,5.86s-1.94,1.44-3.14,5.16c-1.2,3.72,4.54,1.49,5.49,2.93.95,1.45,3.76.04,5.04,3.1,1.28,3.05.2,7.14-1.12,9.25-1.32,2.1-.66,3.75.37,4.41,1.03.66,1.2,2.03,2.31,4.83,1.12,2.81,3.64,1.24,6.65.7,3.02-.53,3.55,3.84,3.63,6.86.09,3.01-.74,3.84.38,4.99,1.11,1.16.86,3.55,1.61,4.92.74,1.36,3.48,3.84,2.27,6.97-1.21,3.14-.28,5.78,2.14,5.56.48-.04,1.11-.15,1.86-.22Z\"],\"label\":[1256,570],\"bbox\":[1145.5,485.5,1366.5,648.5],\"geoNeighbors\":[\"aleppo\",\"baghdad\",\"van\"],\"poly\":[[[1366.8,574.9],[1353.4,586.2],[1338.1,601.4],[1329,609.7],[1324.2,613],[1319.1,615.8],[1313.4,617.9],[1303.4,619.8],[1291.3,619.8],[1276.3,617.9],[1257.9,613.7],[1251,615.1],[1244.5,617.2],[1238.3,620],[1213.8,634.1],[1207.1,637.5],[1184.5,635.6],[1179.2,635.4],[1172.8,636],[1145.7,648.3],[1146.2,621.8],[1148.3,613.5],[1149.2,606],[1153.9,598.8],[1154.6,597.1],[1153.7,581.9],[1148.3,569.4],[1149.7,550.4],[1155.5,539.6],[1156.7,537.7],[1159.4,535.2],[1160.9,534.4],[1164.1,533.7],[1167.3,533.7],[1176,535.4],[1178.8,533.2],[1189.3,523.1],[1208.3,500.8],[1216.7,498.5],[1219.7,494],[1223.7,492.1],[1224,491],[1223.9,487.1],[1224.7,485.8],[1226.7,485.4],[1229.4,485.6],[1235.9,487.5],[1243,485.5],[1250.4,486.3],[1255.6,488.1],[1257.5,487.2],[1258.6,487.3],[1263.1,491.2],[1264.8,492.2],[1269.9,492.3],[1274.6,493.7],[1280.2,493.6],[1283.3,494.5],[1286.4,494.1],[1288,493.4],[1288.5,492.9],[1289.4,489.9],[1290.9,488.7],[1294.8,487.7],[1297.4,487.5],[1299.5,487.8],[1303.3,490.4],[1305.6,493.4],[1306.1,495.7],[1305.9,496.6],[1303.7,498.3],[1302.6,499.6],[1301.9,501.2],[1302,502.9],[1304.7,508.7],[1306.2,509.9],[1307.1,509.9],[1309.1,508.6],[1309.9,507.5],[1310.3,505.1],[1315.2,504.2],[1322.7,497.2],[1324.2,496.4],[1325.1,496.3],[1327.5,497.1],[1332.3,497],[1331.5,500.5],[1331.8,502.1],[1332.7,503.6],[1334,504.8],[1336.6,506.3],[1338.3,508.5],[1338,510.7],[1339.4,516.2],[1336.6,519.4],[1336,521.7],[1337.1,522.8],[1341.1,523.2],[1342.6,524.2],[1345.5,525.1],[1346.1,525.7],[1347.2,529.1],[1347.1,531.6],[1346.5,534],[1344.9,537.4],[1345.2,539.6],[1346.6,540.9],[1348.2,545.1],[1349.3,546.5],[1350.8,546.7],[1355.9,545.8],[1356.7,546.3],[1357.8,547.9],[1358.5,552.7],[1358.4,556.8],[1359.5,558.7],[1360.5,562.6],[1362.4,565.4],[1363,567.4],[1362.3,571.8],[1362.5,573.6],[1363.4,574.8],[1364.9,575.1],[1366.8,574.9]]]},\"aleppo\":{\"paths\":[\"m1208.34,500.8c-5.87,6.79-17.64,20.43-18.26,21.42-.83,1.32-12.42,12.39-14.03,13.17-1.61.78-20.52,4.18-20.52,4.18l-5.78,10.85s-1.43,18.11-1.5,18.93c-.04.83,5.19,12.11,5.46,12.5.28.38.94,14.04.94,15.25s-4.57,7.56-5.23,8.39c-.67.83-.83,7.1-1.07,8.01-.25.91-1.96,6.77-2.18,8.31-.17,1.16-.18,17.82-.43,26.46-.01.35-.02.7-.03,1.02-.01.17-.01.34-.02.5-.01.31-.02.61-.03.89-.05,1.11-.11,1.94-.18,2.37-.02.1-.03.18-.05.24-.01.03-.02.05-.03.06-.61.88-10.06,19.39-10.47,20.38-.41.99-1.2,2.4-1.9,2.77-.7.37-17.24,5.09-18.9,6.08-1.65.99-52.63,32.04-57.46,34.9-.38.22-1.55.96-3.38,2.12-.19.11-.38.23-.57.36-.83.52-1.77,1.12-2.82,1.79-.33.2-.67.42-1.02.65-4.09,2.6-9.59,6.11-16.03,10.23-.25.16-.5.32-.75.47h0c-3.2,2.05-6.62,4.24-10.21,6.54-.84.53-1.69,1.08-2.55,1.63-.15.1-.3.19-.46.29-41.35,26.45-101.87,65.19-102.86,65.37-1.48.28-18.05-3.58-20.2-3.47-2.14.11-4.13-3.35-5.34-4.4-1.21-1.05-6.27-5.23-7.54-5.45-1.26-.22-3.63.28-5.94.44-2.32.17-4.08-8.42-5.29-9.85-1.21-1.43-3.36-2.01-6.33-2.92-2.97-.91-2.81-4.21-2.06-5.2.74-.99,3.96-7.43,4.29-9.25.33-1.82-.91-3.8-1.48-5.86-.58-2.07-.67-5.45,0-6.69.66-1.24-.75-5.86-1.74-8.01-.99-2.15-1.65-3.8-1.32-4.18.33-.39,1.1-2.76,1.76-3.25.66-.5,2.92-2.04,4.3-2.97.81-.55.99-1.14,1.07-1.91.07-.53.09-1.14.25-1.89.38-1.82,2.2-1.49,4.34-1.9,1.12-.21,1.17-1.07.42-2.02-.68-.88-2.05-1.84-3.88-2.44-3.8-1.24.99-7.27,2.89-9.66,1.9-2.39,6.19-3.39,7.97-4.21,1.78-.83,6.75.08,9.61.41,2.87.33,1.22-1.81-2.53-3.58-3.74-1.76.55-4.78,2.09-6,1.55-1.21,2.43-4.45,3.86-3.79,1.43.66,3.85-.99,4.02-2.15.16-1.16,2.64-4.21,4.5-6.19,1.85-1.99.99-.29.7-2.23-.29-1.94-.46-5.2-.83-6.11-.37-.91-.91-1.49-1.5-2.31-.6-.83-.93-1.9-.11-3.39.83-1.49-3.38-3.32-4.15-3.67-.76-.36-1.34-2.65-1.4-3.14-.06-.5-2.99-.15-4.76-.26-1.76-.11.06-2.04,1.71-3,1.65-.97,3.22-3.47,2.01-4.27-1.21-.8-4.51-2.01-6.08-2.15-1.57-.13-4.63.97-5.54,1.16-.89.19-10.81-.02-12.39-.03h-.07c-.24-.11-.93-2.57-1.68-5.85-.01-.02-.01-.03-.01-.04h0c-1.07-4.66-2.25-10.92-2.44-14.42-.33-5.99,2.1-14.78,3.05-16.1.95-1.32-.74-7.06-.7-9.37.04-2.31-2.97-7.02-5.61-8.63-2.65-1.61-3.46-3.77-3.76-4.4-.3-.64-1.32-1.99-.11-2.51,1.21-.52,1.43-2.7,1.24-3.22s-.33-1.65.82-1.95c1.16-.31,2.18-2.56,2.62-3.31.44-.74.01-4.68-.4-5.79-.41-1.11-.25-1.98.87-2.15,1.11-.16,2.8-3.57,2.92-3.93.07-.23.2-.52.34-.81,1.14,0,2.76-.66,2.9-.77s1.46-.78,1.96-.2c.49.58-.69,3.36.19,3.69.88.33,2.31.44,3.27.39.97-.06,2.29.99,2.73,1.76s1.76,1.07,1.87-.39c.11-1.46.55-5.17,1.4-5.56.86-.38,3.61-.85,4.11-1.98.49-1.13,2.03-2.17,3.85-2.06,1.81.11,2.2-5.82,2.08-8.3-.13-2.48.9-5.91,2.72-5.41s2.44-.37,3.39-1.11c.95-.75,2.06-.75,4.29-.25,2.23.49,6.23.49,5.24-2.19-.99-2.68-.57-4-2.02-4.25-1.44-.25-3.47-3.22-3.34-4.96.12-1.73-1.24-11.68.3-15.31,1.54-3.64.56-3.06,1.51-3.84.95-.79-.25-2.77.54-3.55.78-.79,2.35-5.62,5.41-4.05,3.05,1.57,4.66,1.78,6.23,1.82s3.51.37,4.63.86c1.11.5,2.26-.04,2.93,1.33.66,1.36,2.56,1.44,2.06,2.97-.49,1.53-.12,4.13,1.02,4.13s2.32-.87,3.15-1.32c.83-.46,7.75-.72,10.39.38,2.64,1.1,5.39,1.93,7.16,1.6,1.76-.33,2.25-1.21,3.63-2.37,1.38-1.16,4.95-3.63,6.99-4.35,2.04-.71,5.34,0,6.72-.55,1.37-.55,6.88-4.29,9.74-4.57,2.86-.27,4.4-2.14,5.67-3.08,1.26-.94,4.73-2.97,8.09-3.14,3.36-.16,11.73,1.54,15.25,3.47,3.52,1.93,9.41,9.58,11.06,10.02,1.65.44,16.3-.39,20.92,1.04,4.62,1.44,19.05-.22,25.32-2.09,6.28-1.87,5.66-.66,14.41-4.13,8.77-3.46,16.86-5.94,19-8.42,2.15-2.48,4.13-4.46,8.25-5.94,4.14-1.49,12.89-3.64,16.85-5.95,3.97-2.31,14.54-1.48,19.15-.33,4.63,1.16,8.1,1.65,13.06,1.32,4.94-.33,5.94,1.98,11.72-.49,5.78-2.48,6.77-.17,14.2-2.81,7.43-2.64,13.38-6.77,15.36-8.26,1.98-1.48,6.28-1.43,7.93-.49,1.65.93,3.02,3.85,3.02,6.05s1.6,4.63,3.36,3.86c.06-.03.12-.05.19-.08Z\"],\"label\":[1034,660],\"bbox\":[859.5,490.5,1208.5,807.5],\"geoNeighbors\":[\"baghdad\",\"diyarbakir\",\"hatay\",\"maras\",\"mosul\",\"van\"],\"poly\":[[[1208.3,500.8],[1189.3,523.1],[1177.1,534.7],[1174.7,535.8],[1155.5,539.6],[1148,554.3],[1147.1,557.8],[1146.9,563.6],[1148.5,570.1],[1153.7,581.8],[1154.7,597.1],[1153.9,598.8],[1149.2,606],[1148.4,613.5],[1146.2,621.8],[1145.4,653.3],[1134.1,675.3],[1133,676.5],[1114.1,682.6],[1055.5,718.2],[916,806.9],[894.3,803],[890.5,799.1],[883.6,793.9],[881.8,793.6],[877,794],[876.2,793.7],[875.4,792.8],[871.7,784.2],[869.2,782.5],[865.4,781.3],[863.7,780.2],[863,778.7],[862.9,777.2],[866.9,768.9],[867.6,766.8],[867.6,765.4],[866.1,761],[865.7,757.3],[866.3,752.8],[865.9,750.6],[863.2,743.5],[863.1,742.1],[864.8,738.8],[869.9,735],[870.4,732.1],[871,731.1],[874.8,730.2],[875.7,729.4],[875.2,728.1],[873.7,726.8],[870.3,725],[869.9,724],[870.6,721.3],[874.2,716],[876,714.5],[878.2,713.4],[884,711.5],[891.8,712.2],[893.1,712.1],[893,711.2],[891.7,710],[888.2,708],[887.9,706.3],[894.2,699],[896.4,699],[898.7,697.6],[900.9,693.9],[904.9,689.4],[904.4,688.3],[903.6,682.2],[901.5,678.4],[902.1,675.9],[901.8,675.3],[897.8,672.8],[896.9,671.3],[896.4,669.7],[891.7,669.4],[891,669],[891.3,668.2],[894.6,665.5],[895.5,664.2],[895.8,663],[895.4,662.2],[892.5,660.8],[889.3,660],[883.1,661.2],[871.3,661.1],[871.1,660.6],[868.1,647.6],[867.2,640.8],[867.4,636],[868.2,631],[870.5,624],[869.5,615.4],[869.1,613.3],[867.7,610.8],[865.9,608.4],[861.2,604.2],[859.5,600.3],[860.8,599.2],[861.2,598.2],[861.5,595],[863,594.1],[864.7,591.3],[864.9,588.6],[864.2,584.1],[866.1,582.8],[868.5,578.7],[872.8,577.5],[873.3,577.7],[873.2,580.7],[873.5,581.4],[876.8,581.8],[878.4,582.3],[880,584],[881.1,583.9],[881.8,580],[882.8,577.6],[886.2,576.3],[888.3,574.1],[891.4,573.3],[891.9,572.6],[892.5,570.4],[893,563.3],[893.5,561.4],[894.3,560.1],[897.6,559.7],[899,558.7],[900.6,558.1],[905.1,558.7],[907.1,558.6],[908.4,557.8],[908.5,556.3],[907.2,552.4],[905.3,551.4],[903.4,548.5],[902.7,535.4],[903.4,531.8],[904.9,527.9],[905.5,524.4],[907.3,521.5],[908.9,520.2],[909.8,520],[914.5,521.8],[919.6,522.4],[924.1,523.6],[926.7,526.4],[926.6,529.9],[927,531],[927.7,531.4],[931.5,529.9],[935.4,529.7],[940.1,530.1],[945.2,531.8],[948.4,532.1],[950.4,531.2],[955.3,527.4],[959.1,525.4],[965.8,524.8],[973,521],[977.4,519.8],[984.5,515.3],[986.8,514.5],[990.8,514.1],[996.9,515],[1001.1,516.1],[1004.5,517.5],[1007.5,519.8],[1013.7,526],[1015.6,527.5],[1031.5,527.9],[1038.7,529],[1044.9,529],[1059.1,527.2],[1073.4,523.4],[1092.6,515.8],[1094.2,514.9],[1098.6,510.6],[1100.8,509.2],[1103.5,508],[1116.6,503.7],[1122.1,501.3],[1124.4,500.8],[1129.7,500.6],[1135.1,500.9],[1145.9,502.9],[1154.2,503],[1160.7,503.6],[1167.9,501.4],[1173.9,500.9],[1178.5,499.7],[1188.2,495.2],[1193.8,491.5],[1195.7,490.6],[1197.9,490.3],[1201.8,491],[1202.9,492],[1204.6,495.3],[1205.1,498.7],[1205.8,500.1],[1206.9,500.9],[1208.3,500.8]]]},\"western-thrace\":{\"paths\":[\"m382.25,215.55c-1.38,1.49-6.48-2.09-6.55,1.54-.11.82-1.18.44-1.35,1.18.16,1.79-3.19,1.78-3.63,3.06-.25.33-3.22-.09-3.8.16-.58.25.66,1.32-.33,2.15-1.63,2.2.47,5.74-.33,8.01-2.26,3.51,2.08,4.86,1.48,6.52-2.51,1.05,1.18,3.83-.16,4.62-3.62-.24-.5,1.46-6.03,4.96-.82,1.15.15,2.9-2.12,3.6-5.65,2.48-6.36,4.06-7.47,5.7-.1.15-.11.5-.04.98-.37-1.8-1.42-5.82-3.64-7.05-2.88-1.61-7.92-1.15-9.45-1.2-1.53-.04-9.37-.45-12.59-1.4-3.22-.95-10.17-4.07-14.79-5.06-4.63-.99-5.62-1.54-6.22-5.07-.61-3.52-1.27-5.5-3.2-3.03-1.92,2.48-2.8,6.56-5.39,7.77-2.59,1.21-4.79,2.58-6.77,4.18-1.98,1.6-6.55,2.97-9.75,1.27-3.19-1.71-5.39-4.96-6.05-5.89-.66-.94-3.61-.36-5.63.22-2.02.57-6.87,3.68-7.2,5.01-.33,1.32-1.84,5.8-4.28,6.71-2.43.91-5.16,2.6-6.02,3.26-.87.66-3.27,1.03-5.04.13-1.2-.62-3.73-2.08-5.75-3.09,2.96-2.04,6.51-4.65,7.89-6.37,2.54-3.16,3.52-5.72,0-8.94-3.53-3.21-10.91-5.85-12.5-9.59-1.6-3.75-9.97-8.01-8.42-12.49.56-1.64.21-3.86-.46-6.03.16-.09.33-.2.51-.31,1.38-.83,2.53-.23,4.68-.39,2.15-.16,2.86-2.8,4.57-3.3,1.7-.49,1.92-.38,3.03-1.21,1.1-.83,2.75,1.76,4.78,1.32,2.04-.44,3.86-.99,3.86-2.64s1.92-3.85,3.47-3.74c1.54.11,2.8.05,5.28-.94,2.48-.99.99,2.53,3.85,2.26,2.87-.28,4.63-.06,6.28-.99,1.65-.94,2.09-1.77,4.4-1.88,2.31-.11,4.02,2.76,4.3,4.3.27,1.54-.22,4.13,1.37,4.29,1.6.17,2.09,1.65,4.35,1.98,2.26.33,5.92,1.85,8.15,1.64,2.23-.21,3.26-.49,6.02.87,2.77,1.36,3.35,2.23,6.2,1.9,2.85-.33,4.21-1.53,7.39-.13,3.18,1.41,4.41,2.52,6.64,1.86,2.23-.66,5.91-.95,9.05-.12,3.13.82,6.77,1.77,7.96.95,1.2-.83,1.86-.66,4.54-.87,2.69-.21,4.13.45,6.53.33,2.39-.12,9.7-1.32,11.64-2.48,1.94-1.15,3.22-3.13,2.97-5.45-.25-2.31-1.61-2.76-.29-4.58,1.32-1.82.5-7.51-1.32-8.46-1.81-.95-4.42-3.02-3.67-5.78.74-2.77,2.19-2.31,4.04-2.69,1.09-.22,6.22.09,10.25.39,0,.02,0,.04,0,.06,2.43,3.38,3.94,4.54,7.63,4.58.42,1.95,3.45,4.22,5.29,4.83-.2,3,2.55,15.15,1.83,18.58Z\"],\"label\":[298,224],\"bbox\":[227,187.5,383,258.5],\"geoNeighbors\":[\"burgas\",\"edirne\",\"plovdiv\",\"salonica\"],\"poly\":[[[382.3,215.6],[380.7,215.9],[376.6,215.5],[373.9,219.3],[370.7,221.3],[366.9,221.5],[367,223],[366,225.5],[366.4,229.8],[365.6,233.9],[367.8,237.6],[367.7,238.2],[366.8,239.2],[367.9,242.4],[367.6,242.8],[365.9,243],[364.3,245.5],[361.6,247.8],[360.6,250.7],[354,254.5],[352,257.1],[351.9,258],[350.8,254.3],[349.7,252.3],[348.3,251],[345.8,250.1],[343,249.8],[336.7,249.7],[327.6,248.7],[315.3,244.4],[308.6,242.6],[306.8,241.7],[305.8,240.4],[304.1,234.5],[303.3,234.2],[302,235.2],[298.3,241.6],[296.6,243],[288,248.3],[285.5,249],[282.7,249.2],[280.1,248.4],[277.9,246.9],[274.1,242.6],[273.2,242.1],[268.4,242.8],[264.2,245],[261.6,247.2],[259.9,251.3],[258.6,253.2],[250.9,257.8],[248.8,258.4],[245.9,257.9],[240.2,254.8],[244.7,251.5],[248,248.4],[249.6,246.1],[250.3,244],[249.9,241.8],[248,239.5],[237.7,232.5],[236.4,231.2],[234.7,228.5],[228.7,222.3],[227,219.1],[227.4,214.6],[226.7,211.4],[228.2,210.7],[231.9,210.7],[233.2,210.2],[235.3,208.1],[239.5,206.2],[240.4,206.1],[242.8,207.3],[244.2,207.5],[246.9,206.6],[247.8,205.9],[248.4,203.5],[250.4,201.4],[253.8,201],[257.6,200],[258.1,200.1],[259.2,202],[259.8,202.4],[264.3,202.2],[267,201.4],[269.9,199.8],[271.4,199.6],[273,200],[275.2,202.5],[276.2,207.6],[280,209.7],[287.6,211.6],[293.8,211.9],[300,214.6],[307.1,213.8],[314.3,216.4],[320,215.6],[322.4,215.7],[331.5,217.4],[334.5,216.4],[343.9,216.6],[349.9,215.7],[355.5,214.1],[357.8,211.8],[358.4,210.3],[358.5,208.6],[357.6,205.2],[358.8,202.1],[358.7,199.5],[357.5,196.1],[354.1,193.4],[353.2,191.7],[353.2,189.8],[353.9,188.3],[354.8,187.6],[358.7,187],[367.5,187.5],[370.8,191.1],[372.7,191.9],[375.1,192.1],[375.9,193.6],[377.2,195.1],[380.4,197],[382.2,211.6],[382.2,215.6]]]},\"salonica\":{\"paths\":[\"m263.46,298.69c-1.05.77-3.25,0-4.9-1.92-1.65-1.93-4.63-7.49-7.21-8.04-2.59-.55-7.82-2.59-9.42-4.13-1.59-1.54-5.12-.77-7.04-.16-1.93.6-6.28,2.03-4.08,5.78,2.21,3.74,2.48,4.4,5.07,5.11,2.58.72,8.47,4.3,8.86,6.06.39,1.76,1.65,5.5.28,7.1-1.38,1.6-3.25,2.2-5.07.83-1.82-1.38-6.05-6.55-6.99-8.7-.94-2.15-4.46-6.55-5.45-7.21-.99-.66-7.65-2.09-8.97-3.03-1.32-.94-3.36-1.21-4.96-.55-1.59.66-4.07,3.96-2.69,5.78,1.37,1.82,6.33,10.13,9.68,11.34,3.36,1.21,7.44,4.07,8.1,5.06.66.99.05,2.54-1.43,2.1-1.49-.45-9.2-3.64-11.29-3.8-2.09-.17-3.19-1.49-4.13-3.91-.93-2.42-3.69-8.15-3.58-11.45.11-3.3-2.09-3.52-3.74-4.13-1.65-.6-8.17-3.38-11.64-6.6-3.47-3.22-8.34-8.43-8.09-9.67.25-1.23,4.7-2.14,6.27-2.47,1.57-.33-1.32-5.7-2.14-7.1-.83-1.41-3.66-1.41-4.14-.17-.49,1.24-2.55,3.06-4.62,4.05-2.06.99-5.2,3.14-6.44,4.21-1.24,1.07-1.98,4.21-.74,6.85,1.24,2.64-.33,9.17-1.24,11.07-.91,1.9-3.63,9.33-2.56,11.97,1.08,2.64,4.54,7.02,6.52,8.34.35.23.66.56.96.96-1.86.18-3.88.12-6.59.15-6.36.08-7.67-3.6-9.62-5.1-1.95-1.51-4.53-8.01-4.8-9.2-.27-1.18-4.25,1.13-5.88,1.29-1.63.16-1.73-1.67-2.04-2.41-.18-.42-1.05-.98-1.77-1.38.54-.15.91.11,1.33-.41.64-.83,1.6-3.98.84-5.29-.76-1.3-2.89-5.69-3.97-7.59-1.07-1.9-3.63-2.23-5.59-3.31-1.95-1.07-3.57-3.88-4.52-6.15-.95-2.27-1.12-7.22-2.68-8.38-1.57-1.15-2.87-1.33-3.12-2.56-.26-1.23-1.01-2.72-1.83-4.73-.41-1-.64-2.14-.56-3.06.06-.93.42-1.64,1.21-1.75,1.56-.21,3.88-1.67,3.55-2.17-.33-.5-2.31-3.15-2.44-4.54-.04-.36-.21-1.03-.44-1.82.28-.02.5-.07.65-.18.58-.41,1.32-2.72,2.73-4.21,1.4-1.48,3.88-2.97,4.21-4.79.33-1.81,1.32-3.55,4.04-4.62,2.73-1.07,2.81-.99,3.72-1.98.91-.99,1.82-.17,3.14.82,1.32,1,2.06,0,3.38-.82,1.32-.83,5.2-.08,6.94.74,1.73.83,3.05,1.41,4.54,1.32,1.49-.08,3.96.42,7.02-.08,3.05-.5,5.61-1.73,6.44-2.97.82-1.24,3.3,1.4,4.04,1.24.75-.17,1.66-5.95,1.66-8.43s-.66-5.45,3.38-5.11c3.5.29,5.51-.21,6.85-.12.21.01.4.04.58.09,1.32.36,4.43,2.03,6.75,1.92,1.29-.06,3.04-.86,4.61-1.79,1.25-.74,2.39-1.56,3.09-2.17,1.6-1.38,4.57-.99,6.28-.99s2.58-.94,4.68-1.05c2.09-.11,5.28,1.27,7.1,1.44.27.02.51.04.73.04.15,0,.3-.01.43-.02.15-.02.3-.04.43-.06.09-.02.18-.05.26-.07.17-.05.32-.12.48-.19.16-.08.32-.16.49-.26.09-.06.19-.12.3-.18.67,2.17,1.02,4.39.46,6.03-1.55,4.48,6.82,8.74,8.42,12.49,1.59,3.74,8.97,6.38,12.5,9.59,3.52,3.22,2.54,5.78,0,8.94-1.38,1.72-4.93,4.33-7.89,6.37-.97-.49-1.83-.86-2.38-1-1.7-.41-3.55.91-5,1.82-1.44.9-3.01,2.31-3.55,3.5-.54,1.2-1.16,2.07,0,3.22,1.16,1.16,3.01,1.9,3.9,3.33.88,1.44,1.7,3.03,3.24,3.8s3.75.99,3.14,1.65c-.6.67-2.86,1.22-3.3,1.88s-1.16,3.9,1.1,5.72,3.19,3.58,6.38,3.36c3.2-.22,7.82.6,10.08,2.04,2.25,1.43,8.14,8.03,9.47,10.12,1.32,2.1,1.26,3.69.22,4.46Z\"],\"label\":[195,262],\"bbox\":[126,210,264,314],\"geoNeighbors\":[\"kozani\",\"plovdiv\",\"western-thrace\"],\"poly\":[[[263.5,298.7],[262.5,299],[259.9,298],[258.6,296.8],[255.3,292.2],[252.3,289.2],[246.3,287],[240.4,283.8],[236.6,284],[233.1,285.1],[231.3,286.1],[230.2,287.8],[230.3,288.9],[233.2,293.9],[234.3,294.8],[238.3,296.3],[241.1,298],[244.4,300.7],[245.5,305],[245.6,307],[245,308.5],[242.7,310],[241.3,310],[240,309.3],[236.1,305.3],[230.3,296.5],[227.5,293.4],[220.4,291.2],[217.4,289.8],[214.8,289.5],[213.6,289.8],[212.3,290.8],[211.1,292.3],[210.5,294],[210.9,295.6],[217.8,304.9],[219.2,306.2],[223.2,308.1],[227.6,311],[228.7,312],[228.8,313.6],[228.2,314.1],[227.2,314.1],[218.4,310.9],[214.6,310],[213.5,309.2],[211.8,306.4],[208.6,297.8],[207.9,293],[207,291.9],[199.4,288.5],[195.9,286.5],[192.9,284.2],[185.4,276.1],[184.8,274.5],[185,274.1],[191.4,271.7],[190.9,268.9],[188.9,265],[188,264.2],[186.7,263.9],[185.5,264.1],[183,266.9],[173.7,273.1],[172.9,274.2],[172.4,275.9],[172.4,277.9],[173.4,282.5],[173.1,285.7],[172.1,290.1],[169.7,296.7],[168.9,301.8],[170.4,305.2],[172.1,307.6],[176.6,312.3],[170.1,312.4],[166.1,311.9],[163.6,310.5],[159.7,306.5],[157.4,302.6],[155.4,297.8],[149.8,299.4],[148.8,299.2],[147.7,297],[145.9,295.6],[147.3,295.2],[147.8,294.2],[148.4,291.2],[148.1,289.9],[144.1,282.3],[143.1,281.2],[138.6,279],[135.9,276.4],[134,272.9],[132.3,266],[131.4,264.5],[128.6,262.7],[126.4,257.2],[125.8,254.1],[126.2,252.9],[129.5,251.4],[130.6,250.2],[128.5,246.9],[127.7,243.8],[128.4,243.7],[131.1,239.5],[134.7,236],[136.4,232.1],[137.6,231],[141.9,229],[143.8,227.6],[147.1,229.3],[149.6,228.1],[152.9,227.8],[158.9,229.8],[164,230.2],[168.1,230],[170.3,229.5],[173.6,228],[174.9,226.8],[178.6,228.3],[179.7,225],[180.4,216.3],[181.4,215.1],[190.5,214.7],[195.9,216.5],[197.8,216.7],[200,216.1],[202.4,214.9],[206.9,212],[211.8,211.7],[216.5,210.7],[223.6,212.1],[225.1,212.1],[226.7,211.4],[227.4,214.6],[227,219.1],[228.7,222.3],[234.7,228.5],[236.4,231.2],[237.7,232.5],[248.1,239.5],[249.9,241.8],[250.3,244],[249.6,246.1],[248.1,248.4],[244.7,251.5],[240.2,254.8],[237.8,253.8],[236.5,253.8],[232.8,255.6],[230.7,257.3],[229.2,259.1],[228.7,261.5],[233.1,265.7],[234.5,267.8],[236.4,269.5],[239.5,270.7],[239.5,271.1],[236.2,273],[235.9,273.9],[236.1,277.1],[237.3,278.7],[240.2,281.2],[241.7,281.9],[249.1,282.5],[251.7,283.2],[254.8,284.9],[258.9,288.9],[263.2,294.2],[264.2,297],[263.5,298.7]]]},\"kozani\":{\"paths\":[\"m147.27,295.2c-.42.52-.79.26-1.33.41-.31.08-.67.3-1.12.85-1.25,1.54-4.29,4.81-4.67,5.7-.38.89-3.38,3.8-3.8,5.23-.41,1.43-4.56,3.3-4.67,4.46-.11,1.15-.5,1.15.05,2.09.55.94,2.26,4.64.55,4.9-1.71.26-4.58.53-5.62.77-1.04.23-7.75-1.38-10.78-1.87-3.03-.5-6.22-1.16-8.42.55-2.21,1.71-1.99,2.15-5.62.93-3.63-1.21-7.33-1.86-8.64-1.32-1.31.55-4.09-3.72-3.39-5.74.69-2.02-.24-4.72-1.24-5.71-.65-.65-2.07-2.43-2.64-4.29-.3-.98-.36-1.99.06-2.86,1.21-2.53-1.48-6.46-2.73-8.09-1.26-1.64-2.78-5.68-4.18-6.34-.55-.26-2-.62-3.55-.96.32-1.49.71-3.42,1.04-4.54.56-1.87,1.6-3.69,3.53-4.29,1.92-.61,3.74.88,4.79-.44,1.04-1.32,1.92-3.2,3.46-4.35,1.55-1.16,2.87-7.96,1.22-10.18-1.66-2.23-3.64-5.29-2.81-7.85.82-2.56.41-3.71.41-3.71,0,0,1.91.09,4.05.14,2.55.08,5.42.12,5.69-.06.34-.23,2.17-.45,3.92-.68.79-.1,1.57-.2,2.19-.31,1.99-.33,3.97-2.64,7.52-2.81,3.55-.17,6.44,2.81,8.5,1.98,2.07-.82,2.31-1.73,4.79-2.48,1.82-.54,3.11-.42,3.89-.48.23.79.4,1.46.44,1.82.13,1.39,2.11,4.04,2.44,4.54.33.5-1.99,1.96-3.55,2.17-.79.11-1.15.82-1.21,1.75-.08.92.15,2.06.56,3.06.82,2.01,1.57,3.5,1.83,4.73.25,1.23,1.55,1.41,3.12,2.56,1.56,1.16,1.73,6.11,2.68,8.38.95,2.27,2.57,5.08,4.52,6.15,1.96,1.08,4.52,1.41,5.59,3.31,1.08,1.9,3.21,6.29,3.97,7.59.76,1.31-.2,4.46-.84,5.29Z\"],\"label\":[112,282],\"bbox\":[75.5,244,148.5,320],\"geoNeighbors\":[\"salonica\"],\"poly\":[[[147.3,295.2],[145.4,295.9],[144.8,296.5],[140.9,301.1],[135.5,308.5],[132.4,310.9],[131.7,311.9],[131.5,313],[132.9,316.6],[133,318.1],[132.3,318.8],[126,319.6],[111.4,317.2],[109.3,317.4],[105.2,319.9],[103.9,319.8],[96.7,317.9],[92.6,317.9],[92,317.5],[90.8,316],[89.9,314],[90,310.6],[89.3,307.5],[87.2,304.8],[85.9,302.2],[85.7,300.7],[86.2,297.2],[85.5,294.9],[80.1,285.9],[79.1,284.9],[75.5,283.9],[76.6,279.4],[77.8,276.7],[80.1,275.1],[84,275.2],[84.9,274.6],[89.4,268.5],[90.2,265.6],[90.3,262.5],[90.1,261.1],[87.2,256.3],[86.6,254.3],[87.2,248.5],[96.9,248.6],[103,247.6],[108.1,245.3],[110.5,244.8],[113.1,245.2],[117.3,246.8],[119,246.8],[123.8,244.3],[127.7,243.8],[128.5,246.9],[130.6,250.2],[129.5,251.4],[126.2,252.9],[125.8,254.1],[126.4,257.2],[128.6,262.7],[131.4,264.5],[132.3,266],[134,272.9],[135.9,276.4],[138.6,279],[143.1,281.2],[144.1,282.3],[148.1,289.9],[148.2,292.7],[147.3,295.2]]]},\"sofia\":{\"paths\":[\"m307.38,63.62c-1.01,1.3-2.09,3.11-2.15,4.55-.04.68.15,1.28.67,1.7,1.61,1.31.78,8.39-3.14,12.55-3.92,4.16-6.89,6.22-7.58,8.72-.68,2.51-4.17,5.5-4.08,8.96.1,3.45,2.29,6.78,2.84,9.08.41,1.71,2.36,5.51,3.2,8.57-3.85.58-6.99,1.11-8.25,1.21-3.53.28-7.32-.38-10.93-2.8-3.61-2.42-10.21.76-11.31,2.8-1.1,2.04-.7,11.82-4.86,10.9-4.17-.93-6.81-.27-9.67,1.93-2.87,2.21-4.63,7.71-7.49,9.91-2.86,2.2-2.81,14.75-11.97,15.63-9.17.89-20.53,7.01-27.95,7.03-2.78.01-6.3.63-9.93,1.35-4.75.94-9.71,2.05-13.46,2.15-.27-.47-.53-.89-.76-1.22-1.82-2.59-5.89-3.42-9.09-5.23-1.16-.66-2.82-2.4-4.5-4.39-2.94-3.46-5.94-7.69-6.52-8.34-.91-1.03-1.16-2.81-.04-2.89.46-.03.97-.08,1.46-.21.7-.18,1.32-.52,1.64-1.19.53-1.16,1.98-3.23,3.59-3.23s1.77-6.02,1.86-7.43c.08-1.4-3.06-2.93-4.55-4.33-1.48-1.4-.95-4.87-.45-5.66.5-.78.17-4.54,1.53-5.24,1.36-.7,1.07-1.45.53-2.64-.53-1.2-2.83-4.79-2.64-5.26s1.52-1.24,2.64-1.76c1.13-.52,1.3-1.51,2.29-1.6.99-.08,1.43.34,2.15-.38.72-.72,2.75-.23,5.74.1s3.86-3.02,4.25-4.89c.38-1.87,2.25-4.02,4.07-5.45,1.82-1.43,4.84-4.73,6.99-6.83,2.15-2.09.69-5.89-2.7-7.29-3.38-1.4-4.13-5.53-5.45-8.26-1.32-2.72-11.64-7.51-14.28-9.16-2.64-1.65-3.55-9.17-3.72-12.39-.16-3.22-3.55-5.53-5.03-9.41-1.49-3.88.58-8.84.58-10.24s1.07-7.68,3.13-8.17c2.07-.5,3.8-.33,4.38-1.98.58-1.66,2.31-1.33,4.04-2.32,1.74-.99-.41-5.2.67-8.17.53-1.45,1.76-1.98,3.04-2.06.44-.03.89,0,1.32.06.86.12,1.63.37,2.08.6,1.32.66,8.58,5.78,9.82,7.43,1.24,1.65,3.96.16,5.04,1.4,1.07,1.24.25,3.8-2.15,4.54-2.39.74-3.96,4.38-6.69,6.44-2.72,2.07-.41,5.7,2.07,6.94,2.47,1.24,9.66,2.23,11.64,1.98s7.93-3.06,10.57-2.73,8.83.75,11.64,2.73c2.81,1.98,9.08.36,10.73.85,1.66.5,4.68,1.93,10.52,4.19,5.83,2.25,16.9,3.79,20.86,2.47,3.96-1.32,7.21-4.24,9.91-4.24s7.43,4.63,9.36,5.4c1.92.77,5.61-1.43,7.59-2.04,1.98-.6,10.96,1.38,12.86,1.3,1.78-.08,4.64-1.03,7.72,1.71-1.63,2.94-3.43,6.29-3.68,7.12-.46,1.55,1.5,5.2,0,7.13Z\"],\"label\":[235,92],\"bbox\":[159.5,10,310.5,168],\"geoNeighbors\":[\"burgas\",\"plovdiv\",\"varna\"],\"poly\":[[[307.4,63.6],[305.9,65.8],[305.2,68.2],[305.4,69.1],[306.4,70.6],[306.6,73.3],[305.1,78.9],[302.8,82.4],[296.1,89.3],[291.6,97.6],[291.1,100.1],[291.5,102.7],[297.1,117.8],[288.9,119],[286.2,119],[283.5,118.6],[280.7,117.7],[276.5,115.5],[274.8,115.3],[271.4,115.9],[268.4,117.3],[266.7,119],[265.4,125.5],[264.1,128.8],[263.1,129.7],[256.5,129.7],[254.3,130.4],[252.1,131.8],[243.7,143],[239.7,152.6],[238,154.8],[235.7,156.5],[225.5,158.8],[207.7,164.1],[200.1,164.8],[187.7,167.1],[181.3,167.9],[178.8,165],[171.5,161.4],[169.4,159.7],[159.9,147.8],[159.8,146.1],[162.8,145.2],[164.9,142.3],[165.9,141.5],[167.6,140.9],[168.6,138],[168.9,135.5],[169,133.7],[168.5,132.7],[164.4,129.4],[163.6,128],[163.6,124.8],[164.7,119.5],[166.5,117.4],[163.4,110.6],[168.3,107.2],[169.5,107.3],[171.2,106.5],[176.2,107],[178.1,106.6],[179.3,105.3],[181,100.6],[181.9,99.2],[191.5,89.8],[192.5,88],[192.2,85.9],[191,83.9],[186.7,81],[185.3,78.9],[183.4,74.2],[182.5,73.1],[176.7,69.3],[169.1,65.1],[168.2,64.2],[166.3,59.5],[164.7,50.4],[160.3,43.3],[159.8,40.2],[160.1,37.2],[161.7,28.6],[162.7,26.2],[164,24.9],[167.8,23.8],[169.1,22],[172.9,20.1],[172.8,14.8],[173.1,12.4],[174.4,10.9],[176.2,10.3],[179.6,11],[184.5,14.3],[190.5,19.2],[193.4,19.3],[194.4,19.8],[194.9,21],[194.7,22.3],[193.8,23.5],[190.6,25.4],[184.8,31.7],[184.4,32.6],[184.7,34.6],[185.9,36.4],[188.8,38.2],[193.7,39.3],[198.3,39.8],[208.7,37],[212.4,37.3],[218.9,38.5],[224.1,40.6],[232.2,40.6],[245.2,45.6],[256.8,47.6],[261.8,47.6],[263.6,47.2],[271.4,43.5],[273.5,43],[275.9,43.7],[282.9,48.4],[284.6,48.5],[291.5,46.2],[302.3,47.6],[306.7,47.5],[308.8,47.9],[311.1,49.4],[307.4,56.5],[307.9,61.9],[307.4,63.6]]]},\"varna\":{\"paths\":[\"m485.07,61.78c-.44,4.01-4.79,7.7-5.56,8.75-.77,1.04-.94.88-4.68-.88-3.74-1.76-10.68-.33-14.48,0-3.79.33-5.91,11.86-7.48,12.27-1.57.41-1.98,3.06-2.07,4.71-.08,1.65-.08,4.62-1.15,6.27-1.08,1.65-1.08,7.27-.74,9.58.17,1.2.24,5.6.25,9.66-4.8.06-10.75-.37-13.05-2.59-4.1-3.96-11.37-.88-15.33-1.54-3.97-.66-5.35-4.62-11.04-3.96-5.7.66-13.18,0-16.27,1.76-3.08,1.76-7.09,2.73-10.26,1.48-3.17-1.26-10.5-8.23-15.13-7.83-4.63.4-11.26,12.38-18.36,13.99-7.11,1.61-24.28,4.25-31.77,2.93-4.8-.85-13.94.34-20.81,1.37-.84-3.06-2.79-6.86-3.2-8.57-.55-2.3-2.74-5.63-2.84-9.08-.09-3.46,3.4-6.45,4.08-8.96.69-2.5,3.66-4.56,7.58-8.72,3.92-4.16,4.75-11.24,3.14-12.55-.52-.42-.71-1.02-.67-1.7.06-1.44,1.14-3.25,2.15-4.55,1.5-1.93-.46-5.58,0-7.13.25-.83,2.05-4.18,3.68-7.12.21.18.41.38.62.6,3.3,3.47,11.72,1.57,16.1.33,4.37-1.24,13.21-6.94,20.23-14.62,7.01-7.68,20.06-13.21,24.19-12.96s10.24-2.23,13.62-2.39c3.39-.17,7.02-2.48,9-3.06,1.98-.58,8.09-2.23,10.57-1.9,2.48.33,6.77,1.16,8.51,1.41,1.73.24,2.89,1.65,4.12,3.13,1.24,1.49,3.22,3.47,4.13,4.46.91.99,9.58-.16,11.07-.16s1.65-2.4,3.05-1.32c1.41,1.07,1.41,4.37,2.64,5.44,1.24,1.08,4.46.67,6.69-.16,2.23-.83,3.14-2.48,4.05-2.64.91-.17,1.73,1.73,2.06,3.96.33,2.23,1.74,6.03,3.8,8.51,2.06,2.47,12.22,5.69,15.03,6.11,2.81.41,14.6.33,14.6.33,0,0-.04.15-.1.47-.14.64-.41,1.96-.8,4.15-.57,3.3,1.27,8.7.83,12.72Z\"],\"label\":[388,70],\"bbox\":[291,16,485,118],\"geoNeighbors\":[\"burgas\",\"plovdiv\",\"sofia\"],\"poly\":[[[485.1,61.8],[484.1,64.7],[482.4,67.3],[479,71.1],[478.3,71.1],[473.3,69.1],[467.6,68.9],[460.4,69.7],[459,70.3],[457.8,71.6],[453.5,81.3],[451.9,82.6],[451.3,83.8],[450.6,89.8],[449,94.8],[448.7,97.4],[449.2,112.1],[441.7,111.7],[438.4,110.9],[434.4,108.4],[432.5,107.7],[428.4,107.5],[420.8,108],[418.2,107],[413.3,104.3],[411.7,104],[396.5,104.9],[391,107],[388.4,107.7],[385.7,107.8],[383.2,107.3],[381.8,106.6],[372,100.3],[368.1,99.5],[366.3,100.1],[364.3,101.6],[354.9,110.6],[352.4,112.4],[349.7,113.5],[334,116],[325.1,116.7],[313.6,116.1],[308.3,116.4],[297.1,117.8],[291.5,102.7],[291.1,100.1],[291.6,97.6],[296.1,89.3],[302.8,82.4],[305.1,78.9],[306.6,73.3],[306.4,70.6],[305.4,69.1],[305.2,68.2],[305.9,65.8],[307.4,63.6],[307.9,61.9],[307.4,56.5],[311.1,49.4],[313.1,51],[317.1,51.9],[323.9,51.3],[329.6,49.6],[336.9,45.4],[342.5,41],[350.9,32.9],[354.2,30.4],[361.2,26.2],[367.7,23.6],[370.3,22.9],[375.6,22.5],[388.4,19.9],[394.8,17.3],[399.9,16],[405.4,15.4],[415.1,17.2],[422.2,24.4],[422.8,24.6],[433.2,24.2],[435.4,22.6],[436.3,22.9],[438.9,28.3],[440.2,28.9],[441.9,29],[445.6,28.2],[449.7,25.5],[450.3,25.8],[450.9,26.6],[452.2,31.4],[454.1,35.9],[455.5,38],[458.3,39.9],[462.7,41.8],[470.5,44.1],[485.1,44.4],[484.2,49.1],[484.2,51.9],[485,58.6],[485.1,61.8]]]},\"plovdiv\":{\"paths\":[\"m358.49,208.62c.25,2.32-1.03,4.3-2.97,5.45-1.94,1.16-9.25,2.36-11.64,2.48-2.4.12-3.84-.54-6.53-.33-2.68.21-3.34.04-4.54.87-1.19.82-4.83-.13-7.96-.95-3.14-.83-6.82-.54-9.05.12-2.23.66-3.46-.45-6.64-1.86-3.18-1.4-4.54-.2-7.39.13-2.85.33-3.43-.54-6.2-1.9-2.76-1.36-3.79-1.08-6.02-.87-2.23.21-5.89-1.31-8.15-1.64-2.26-.33-2.75-1.81-4.35-1.98-1.59-.16-1.1-2.75-1.37-4.29-.28-1.54-1.99-4.41-4.3-4.3-2.31.11-2.75.94-4.4,1.88-1.65.93-3.41.71-6.28.99-2.86.27-1.37-3.25-3.85-2.26-2.48.99-3.74,1.05-5.28.94-1.55-.11-3.47,2.09-3.47,3.74s-1.82,2.2-3.86,2.64c-2.03.44-3.68-2.15-4.78-1.32-1.11.83-1.33.72-3.03,1.21-1.71.5-2.42,3.14-4.57,3.3-2.15.16-3.3-.44-4.68.39-.18.11-.35.22-.51.31-.11.06-.21.12-.3.18-.17.1-.33.18-.49.26-.16.07-.31.14-.48.19-.08.03-.17.05-.26.07-.13.02-.28.04-.43.06-.13.01-.28.02-.43.02-.22,0-.46-.02-.73-.04-1.82-.17-5.01-1.55-7.1-1.44-2.1.11-2.98,1.05-4.68,1.05s-4.68-.39-6.28.99c-.7.61-1.84,1.43-3.09,2.17-1.57.93-3.32,1.73-4.61,1.79-2.32.11-5.43-1.56-6.75-1.92-.18-.05-.37-.08-.58-.09l-.33-5.47s.44-8.64.36-9.34c-.09-.7-.64-4.64-.21-5.28.43-.64,1.88-2.91,3.45-4.36,1.56-1.44-1.61-4.8-3.05-6.23-1.43-1.43-1.98-4.02-3.52-5.67-1.34-1.44-3.98-7.27-5.84-10.45,3.75-.1,8.71-1.21,13.46-2.15,3.63-.72,7.15-1.34,9.93-1.35,7.42-.02,18.78-6.14,27.95-7.03,9.16-.88,9.11-13.43,11.97-15.63,2.86-2.2,4.62-7.7,7.49-9.91,2.86-2.2,5.5-2.86,9.67-1.93,4.16.92,3.76-8.86,4.86-10.9,1.1-2.04,7.7-5.22,11.31-2.8,3.61,2.42,7.4,3.08,10.93,2.8,1.26-.1,4.4-.63,8.25-1.21.29,1.07.45,2.05.36,2.82-.36,2.97.26,11.45,2.59,13.9,2.34,2.44,5.63,7.15,4.65,10.53-.98,3.39-3.3,5.12.33,10.41,3.63,5.28,6.11,5.45,5.78,11.06-.33,5.62-2.15,7.39-.99,10.79,1.16,3.41,5.45,4.79,8.06,6.71,2.61,1.92,9.11,1.86,9.44,4.98.33,3.12-.02,6.66,3.05,8.36,3.06,1.69,8.18-1.7,11.32.49,3.14,2.2,3.9.77,7.4-.39,2.04-.68,5.38-1.18,8.54-1.03,1.24,1.89,1.64,6.13.53,7.66-1.32,1.82.04,2.27.29,4.58Z\"],\"label\":[270,166],\"bbox\":[181,115,359,217],\"geoNeighbors\":[\"burgas\",\"salonica\",\"sofia\",\"varna\",\"western-thrace\"],\"poly\":[[[358.5,208.6],[358.4,210.3],[356.8,213.1],[354.6,214.5],[349.9,215.7],[343.9,216.6],[334.5,216.4],[331.5,217.4],[322.4,215.7],[320,215.6],[314.3,216.4],[307.1,213.8],[300,214.6],[293.8,211.9],[287.7,211.6],[280,209.7],[276.2,207.6],[275.2,202.5],[273,200],[271.4,199.5],[270,199.8],[265.7,201.9],[260.7,202.4],[259.2,202],[258.1,200.1],[257.6,200],[253.9,201],[250.4,201.4],[248.4,203.5],[247.8,205.9],[246.9,206.6],[244.2,207.5],[242.8,207.3],[240.4,206.1],[239.5,206.2],[235.3,208.1],[233.2,210.2],[231.9,210.7],[228.2,210.7],[224.7,212.1],[216.5,210.7],[211.8,211.7],[206.9,212],[200,216.1],[197.8,216.7],[195.9,216.5],[190.5,214.7],[190,205.5],[190.5,199.9],[190.1,195.6],[190.3,194.6],[194.1,189.6],[194.1,188.8],[193.3,187.1],[190.7,184],[185.9,176.5],[181.3,167.9],[187.7,167.1],[200.1,164.8],[207.7,164.1],[225.5,158.8],[235.7,156.5],[238,154.8],[239.7,152.6],[243.7,143],[252.1,131.8],[254.3,130.4],[256.5,129.7],[263.1,129.7],[264.1,128.8],[264.9,127.4],[266.7,119],[268.4,117.3],[271.4,115.9],[274.8,115.3],[276.5,115.5],[280.7,117.7],[286.2,119],[288.9,119],[297.1,117.8],[297.8,127.7],[298.7,131.7],[299.3,133.3],[303.7,139.4],[304.8,142.3],[304.7,145],[303.2,149.5],[303.3,152],[305.1,155.4],[309.4,160.8],[310.6,163.1],[310.8,166.5],[309.5,174.9],[309.9,177.3],[311.2,179.5],[317.9,184],[326.1,187.1],[327,187.9],[327.9,193.7],[328.7,195.7],[330.4,197.3],[333,197.8],[339.1,197],[340.5,197.2],[343.7,198.8],[345.3,198.9],[350.9,196.9],[357.7,196.4],[358.8,200.3],[358.8,202.5],[357.7,205.2],[358.5,208.6]]]},\"burgas\":{\"paths\":[\"m456.94,171.54c-.9-1.82-3.45.93-7.45-.69-5.32-4.43-2.9,4.98-9.61-.09-18.27,13.72-16.87-16.62-28.51-5.94-13.45-5.2-1.79,4.31-24.33,6.77-7.85-2.16-7.35,4.18-8.2,8.95-2.54,2.44-13.16-.55-11.35,6.96-4.03-.3-9.16-.61-10.25-.39-1.85.38-3.3-.08-4.04,2.69-.75,2.76,1.86,4.83,3.67,5.78.29.15.56.43.79.8-3.16-.15-6.5.35-8.54,1.03-3.5,1.16-4.26,2.59-7.4.39-3.14-2.19-8.26,1.2-11.32-.49-3.07-1.7-2.72-5.24-3.05-8.36s-6.83-3.06-9.44-4.98c-2.61-1.92-6.9-3.3-8.06-6.71-1.16-3.4.66-5.17.99-10.79.33-5.61-2.15-5.78-5.78-11.06-3.63-5.29-1.31-7.02-.33-10.41.98-3.38-2.31-8.09-4.65-10.53-2.33-2.45-2.95-10.93-2.59-13.9.09-.77-.07-1.75-.36-2.82,6.87-1.03,16.01-2.22,20.81-1.37,7.49,1.32,24.66-1.32,31.77-2.93,7.1-1.61,13.73-13.59,18.36-13.99,4.63-.4,11.96,6.57,15.13,7.83,3.17,1.25,7.18.28,10.26-1.48,3.09-1.76,10.57-1.1,16.27-1.76,5.69-.66,7.07,3.3,11.04,3.96,3.96.66,11.23-2.42,15.33,1.54,2.3,2.22,8.25,2.65,13.05,2.59,0,3.73-.04,7.18-.09,7.65-.11.99-6.83-.55-8.15,0-1.32.55-.66,1.21-1.87,2.76-1.21,1.54-4.84,4.29-6.27,5.39-1.43,1.1-5.51,3.52-7.82,6.28-2.31,2.75,2.53,3.85,4.51,3.63,1.99-.22,6.72,1.21,7.6,1.98.88.77,1.1,0,1.54.99.44.99.66,1.87,1.65,3.19.99,1.32,1.98,1.77,2.09,3.86.11,2.09-.55,2.64.56,5.17,1.1,2.53,10.67,11.89,11.66,12.91.77.79,1.9,4.11,2.38,5.59Z\"],\"label\":[377,149],\"bbox\":[297,99,457,199],\"geoNeighbors\":[\"edirne\",\"plovdiv\",\"sofia\",\"varna\",\"western-thrace\"],\"poly\":[[[456.9,171.5],[456,170.9],[450.9,171.3],[447.8,169.8],[446.7,169.7],[444.5,171.8],[443.5,172.3],[442,172],[439.9,170.8],[436.7,172.8],[433.9,174],[431.5,174.4],[429.4,174.1],[425.9,172.1],[420.7,165.6],[418.2,163.2],[416.8,162.6],[415.2,162.6],[413.4,163.3],[411.4,164.8],[407.4,163.5],[405.1,163.3],[403.7,164],[400,167.9],[396.5,169.6],[390.9,171.1],[387,171.6],[384.5,171.2],[382.6,171.4],[381.2,172.2],[380.3,173.5],[378.8,180.5],[377.5,181.2],[369.6,182.6],[368.1,183.6],[367.4,185.1],[367.5,187.5],[358.7,187],[354.8,187.6],[353.9,188.3],[353.2,189.8],[353.2,191.7],[354.1,193.4],[357.7,196.4],[350.9,196.9],[345.3,198.9],[343.7,198.8],[340.5,197.2],[339.1,197],[331.6,197.7],[330.4,197.3],[328.7,195.7],[327.8,193.7],[327,187.9],[326.1,187.1],[317.9,184],[313.3,181.2],[311.2,179.5],[309.9,177.3],[309.5,174.9],[310.8,166.5],[310.6,163.1],[309.4,160.8],[305.1,155.4],[303.3,152],[303.2,149.5],[304.7,145],[304.7,142.3],[303.7,139.4],[299.3,133.3],[298.6,131.7],[297.8,127.7],[297.1,117.8],[308.3,116.4],[313.6,116.1],[325.1,116.7],[334,116],[349.7,113.5],[352.3,112.4],[354.9,110.6],[364.2,101.6],[366.2,100.1],[368.1,99.5],[371.9,100.3],[381.8,106.6],[383.2,107.3],[385.7,107.8],[388.4,107.7],[391,107],[396.5,104.9],[411.7,104],[413.3,104.3],[418.2,107],[420.8,108],[428.4,107.5],[432.5,107.7],[434.4,108.4],[438.4,110.9],[441.7,111.7],[449.2,112.1],[449.1,119.8],[447.9,120.1],[441.6,119.7],[440.2,120.2],[439,122.6],[437.8,123.9],[426.9,132.2],[425,134.2],[424.4,136],[425.6,137.1],[427.6,137.8],[433.7,138.5],[438.3,140.4],[442.1,146.6],[442.4,151.5],[442.9,153],[445,156],[454.6,166],[456.9,171.5]]]},\"gyumri\":{\"paths\":[\"m1333.65,252.56c-2.31,1.44-2.04,4.97-1.51,7.37.13.58.01.97-.31,1.23-.99.84-3.89.38-6.95.22-4.03-.21-7.97-.12-12.04-1.99-4.07-1.87-8.81-.55-11.01,1.43-2.2,1.98-.99,7.16-.11,9.14s-3.63,5.06-6.27,6.5c-2.65,1.43-8.7-1.22-11.78-1.81-3.09-.6-6.06.15-8.04,2.44-.88,1.02-2.77,1.33-4.6,1.36-.03-.3-.24-.52-.78-.96-1.41-1.16-2.77-3.68-.37-5,2.39-1.32,5.36-5.37,6.6-7.27,1.24-1.89,2.23-6.27,1.49-8.5-.74-2.23-2.48-5.78-2.97-7.43-.5-1.65.24-5.7,0-6.11-.25-.41-10.19-5.56-10.68-6.55-.5-.99-1.3-3.66-.91-5.09.12-.44.09-1.15-.04-1.94,5.31-.8,11.63-.13,11.63-.13,11.22-.06,10.1-1.46,12.3-2.56s7.71-1.65,10.68-.99c2.97.66,1.76.33,3.41-1.65,1.65-1.98,4.84-.33,7.16.11,2.31.44,5.06.66,7.15.55,2.09-.11,3.2-1.1,4.85-.55,1.65.55,5.39-2.26,6.96-1.02,1.57,1.24,6.27,2.31,6.25-.82-.01-2,.87-2.43,2.27-2.43.5,3.29,1.68,7.02,2.35,8.68,1.21,2.97-2.09,6.82-3.3,8.3-1.21,1.49,2.97,5.35,3.85,6.47.88,1.12-2.97,7.57-5.28,9Z\"],\"label\":[1301,249],\"bbox\":[1263,220,1339,278],\"geoNeighbors\":[\"kars\",\"trabzon\",\"vanadzor\",\"yerevan\"],\"poly\":[[[1333.7,252.6],[1332.4,254],[1331.8,255.9],[1332.2,260.7],[1330.8,261.6],[1318.9,261],[1315.9,260.5],[1309.7,258.5],[1306.6,258.7],[1303.9,259.5],[1301.8,260.8],[1300.8,262.8],[1300.6,265.4],[1301.8,270.7],[1301.5,271.6],[1299.9,273.4],[1295.5,276.5],[1292.9,276.9],[1283.7,274.7],[1281.4,274.5],[1279.2,274.8],[1277.3,275.7],[1274.8,277.7],[1271,278.5],[1269.3,276.4],[1268.6,275.1],[1268.7,273.7],[1273.6,269.1],[1276.5,265.2],[1278,261.1],[1278.2,258.7],[1278,256.7],[1275,249.3],[1275,243.2],[1264.3,236.6],[1263.3,232.8],[1263.4,229.6],[1267.4,229.2],[1278.7,229.4],[1283.2,228.9],[1289.5,226.2],[1295.4,225.6],[1300.2,226.1],[1301.4,224.3],[1302.9,223.4],[1304.7,223.4],[1312.2,224.9],[1315.7,224.9],[1319.4,224.2],[1322.1,224.3],[1326.8,223.1],[1329.2,224.2],[1332.2,224.5],[1333.6,223.5],[1334.4,220.6],[1336,220.1],[1338.6,229.9],[1337.6,233.5],[1334.9,237.7],[1336.2,240.5],[1338.9,243.6],[1339.1,244.2],[1337.5,247.9],[1335.6,250.7],[1333.7,252.6]]]},\"vanadzor\":{\"paths\":[\"m1393.33,299.79c-.66,4.63-4.74,6.39-9.91,5.73-3.03-.39-4.85.43-5.38,1.51-.44-.04-.79-.07-1.06-.07-2.08-.03-6.4,1.93-9.98,3.12-1.55.51-2.96.88-3.98.88-3.38-.01-5.61-.65-8.62,1.82-1.65,1.35-3.96,2.01-5.73,2.34-.17-2.51-1.3-5.54-2.57-8.8-1.71-4.42-.83-6.91-2.97-10.71-2.15-3.8-2.98-3.63-2.89-7.42.08-3.79-2.18-13.39-4.6-15.37-2.42-1.98-2.86-6.82-2.66-8.93.09-1.04-.51-2.01-1.14-2.73.32-.26.44-.65.31-1.23-.53-2.4-.8-5.93,1.51-7.37,2.31-1.43,6.16-7.88,5.28-9-.88-1.12-5.06-4.98-3.85-6.47,1.21-1.48,4.51-5.33,3.3-8.3-.67-1.66-1.85-5.39-2.35-8.68.79,0,1.74.14,2.79.2.4.02.78-.01,1.16-.07.12-.02.24-.04.36-.07.1-.02.21-.04.31-.07.2-.05.4-.1.6-.16.3-.08.6-.17.9-.26.2-.06.4-.11.6-.15.19-.04.38-.07.57-.1.16-.02.32-.03.48-.04,1.05-.05,2.17.26,3.44,1.41,3.31,2.98,7.21,8.75,6.77,9.8s-2.64.22-4.62,1.43c-1.98,1.21-2.31,2.48-2.31,2.48,5.16.88,23.78,9.8,26.53,11.56,2.75,1.76,1.21,5.06-.33,6.82-1.54,1.77-7.6,4.52-9.8,6.06-2.2,1.54,2.53,5.61,3.3,10.24.78,4.62,5.73,8.14,8.59,9.03,2.86.88,1.87,3.85,3.41,4.29,1.55.44,5.95,2.31,11.67,4.62,5.73,2.31,3.53,8.04,2.87,12.66Z\"],\"label\":[1363,267],\"bbox\":[1331.5,219,1394.5,315],\"geoNeighbors\":[\"gyumri\",\"sevan\",\"yerevan\"],\"poly\":[[[1393.3,299.8],[1392.2,302.7],[1391.3,303.8],[1388.7,305.2],[1379.8,305.7],[1378,307],[1375,307.3],[1364.8,310.7],[1358.6,310.9],[1356.5,311.5],[1351.6,314.3],[1348.7,315.1],[1347.8,311],[1345.2,303.3],[1344.3,298.3],[1340.4,290.4],[1339.9,284.5],[1338.9,279.8],[1336.5,273.9],[1334.2,270.9],[1333.3,268.4],[1332.7,262.4],[1331.8,261.2],[1332.2,260.7],[1331.8,255.9],[1332.4,254],[1335.6,250.7],[1337.5,247.9],[1339.1,244.2],[1338.9,243.6],[1336.2,240.5],[1334.9,237.7],[1337.6,233.5],[1338.6,229.9],[1336,220.1],[1340,220.2],[1343.8,219.4],[1345.4,219.6],[1347.2,220.8],[1352,226.4],[1353.6,229],[1354,230.6],[1353.4,231.1],[1349.4,232],[1348.2,232.9],[1347.1,234.5],[1353,236.4],[1361.3,240],[1371.9,245.1],[1374.5,246.8],[1374.9,247.6],[1375.1,249.5],[1373.3,252.9],[1371.4,254.4],[1363.5,258.9],[1363,259.6],[1363,260.5],[1365.6,265.9],[1367.3,270.9],[1368.1,272.4],[1370.3,275.1],[1372.9,277.1],[1376.3,278.6],[1376.9,279.2],[1378,281.8],[1378.8,282.5],[1390.5,287.1],[1392.3,288.1],[1393.4,289.4],[1394.3,292.6],[1393.3,299.8]]]},\"yerevan\":{\"paths\":[\"m1365.58,364.47c.11,1.07-.66,2.98-1.72,5.03-3.98-3.73-9.2-7.07-10.95-7.39-2.42-.45-1.21-4.66-1.87-6.31-.66-1.65-7.68-7.76-9-10.15-1.32-2.4-4.13-9.09-7.35-12.22-2.52-2.46-8.3-7.97-10.69-10.25.36-.33.58-.53.58-.53,0,0,.65-1.99.04-2.27-.61-.27-5.67-13.49-14.97-14.48-9.31-.99-13.38,2.81-17.45,1.54-4.08-1.26-10.46-3.63-12.11-4.67-1.65-1.05-5.73-1.22-6.06-3.31-.33-2.09,1.87-3.08,2.31-3.08s-1.43-2.37-2.25-3.22c-.83-.85,1.57-2.42.16-3.91-1.4-1.48-4.37-4.13-3.88-7.55.31-2.11.72-2.78.66-3.25,1.83-.03,3.72-.34,4.6-1.36,1.98-2.29,4.95-3.04,8.04-2.44,3.08.59,9.13,3.24,11.78,1.81,2.64-1.44,7.15-4.52,6.27-6.5s-2.09-7.16.11-9.14c2.2-1.98,6.94-3.3,11.01-1.43,4.07,1.87,8.01,1.78,12.04,1.99,3.06.16,5.96.62,6.95-.22.63.72,1.23,1.69,1.14,2.73-.2,2.11.24,6.95,2.66,8.93,2.42,1.98,4.68,11.58,4.6,15.37-.09,3.79.74,3.62,2.89,7.42,2.14,3.8,1.26,6.29,2.97,10.71,1.27,3.26,2.41,6.29,2.57,8.8.04.89-.03,1.71-.26,2.45-.89,2.85-1.7,2.34.5,6.11,2.19,3.77,8.75,10.54,8.58,12.54-.16,2,6.94,9.19,9.08,13.19,2.15,4-1.3,11.92-.98,15.06Z\"],\"label\":[1316,282],\"bbox\":[1270.5,258.5,1367.5,369.5],\"geoNeighbors\":[\"gyumri\",\"igdir\",\"kars\",\"sevan\",\"vanadzor\"],\"poly\":[[[1365.6,364.5],[1365.2,366.6],[1363.9,369.5],[1357.5,364.5],[1352.2,361.8],[1351.3,359.4],[1351,355.8],[1350.5,355],[1342.8,346.7],[1337,336.3],[1334.7,333.4],[1324,323.2],[1324.7,322.3],[1324.6,320.4],[1320.4,313.4],[1315.8,308.5],[1312.9,306.8],[1309.6,305.9],[1306.4,305.7],[1301.1,306.3],[1295.3,307.6],[1292.2,307.4],[1285.2,305],[1274.9,300.7],[1274,299.5],[1274.2,298.1],[1274.9,297.1],[1276.3,296.4],[1276.3,296],[1274.1,293.2],[1274,292.4],[1274.7,290.4],[1274.3,289.3],[1271.6,286.2],[1270.6,284.1],[1270.4,281.7],[1271,278.5],[1274.8,277.7],[1277.3,275.7],[1279.2,274.8],[1281.4,274.5],[1283.7,274.7],[1292.9,276.9],[1295.4,276.5],[1299.9,273.4],[1301.5,271.6],[1301.7,270],[1300.6,265.4],[1301.2,261.7],[1301.8,260.8],[1303.9,259.5],[1306.6,258.7],[1309.7,258.5],[1315.9,260.5],[1318.9,261],[1329.1,261.6],[1331.8,261.2],[1332.7,262.4],[1333.3,268.4],[1334.2,270.9],[1336.5,273.9],[1338.9,279.8],[1339.9,284.5],[1340.3,290.4],[1344.2,298.3],[1345.2,303.3],[1348.4,313.1],[1348.7,315.1],[1348.4,317.6],[1347.5,320.3],[1347.8,321.5],[1349.9,325.2],[1356.5,333.9],[1358.5,338.6],[1365.5,347.8],[1367.1,351.1],[1367.3,353],[1365.6,364.5]]]},\"sevan\":{\"paths\":[\"m1416.78,345.65c.08,1.4,0,3.13,2.39,5.12,2.4,1.98.33,10.48.33,12.55s5.53,8.67,4.38,10.81c-1.11,2.06.44,7.92.57,8.39.01.02.01.03.01.03,0,0,.08.83-1.49,1-1.57.16-6.69-2.23-8.34-1.57-1.65.66-9.52,4.24-9.52,4.24,0,0-.11-1-5.51-2.43-.25-.07-.52-.14-.79-.2-1.2-.3-2.59-.62-4.06-.93-.41-.09-.82-.18-1.25-.27-.23-.05-.46-.1-.69-.15-.46-.1-.93-.2-1.4-.29-.46-.1-.93-.2-1.4-.3-1.43-.3-2.87-.61-4.25-.93-.68-.16-1.34-.31-1.99-.46h0c-1.75-.43-3.34-.87-4.64-1.31-5.18-1.76-8.26,0-11.45-5.06-.9-1.42-2.26-2.93-3.81-4.39,1.06-2.05,1.83-3.96,1.72-5.03-.32-3.14,3.13-11.06.98-15.06-2.14-4-9.24-11.19-9.08-13.19.17-2-6.39-8.77-8.58-12.54-2.2-3.77-1.39-3.26-.5-6.11.23-.74.3-1.56.26-2.45,1.77-.33,4.08-.99,5.73-2.34,3.01-2.47,5.24-1.83,8.62-1.82,1.02,0,2.43-.37,3.98-.88,3.58-1.19,7.9-3.15,9.98-3.12.27,0,.62.03,1.06.07-.37.76-.09,1.65.87,2.34,2.31,1.65,6.49,1.1,6.49,4.07s3.08,6.39,5.17,7.38c2.1.99,8.04,5.29,9.47,7.6,1.43,2.31,6.83,6.08,6.83,6.08,11.75-4.55,19.07,2.64,18,4.05-1.08,1.4-3.47,5.2-5.04,5.78-1.58.57-3.14-.09-3.05,1.32Z\"],\"label\":[1386,347],\"bbox\":[1347.5,307.5,1424.5,386.5],\"geoNeighbors\":[\"vanadzor\",\"yerevan\"],\"poly\":[[[1416.8,345.7],[1417.1,348],[1419.9,351.8],[1420.2,353.3],[1420.2,357],[1419.5,363.3],[1419.7,364.3],[1423.7,371.8],[1424,373.1],[1423.5,376.2],[1424.5,382.5],[1423.9,383.3],[1422.2,383.5],[1416.4,382],[1414.6,382],[1405.1,386.2],[1403.7,385.2],[1399.6,383.8],[1372.7,377.7],[1370.1,376.6],[1363.9,369.5],[1365.5,365.4],[1366.8,357.3],[1367.3,353],[1366.6,349.4],[1358.5,338.6],[1356.5,333.9],[1348.2,322.5],[1347.5,320.3],[1348.4,317.6],[1348.7,315.1],[1351.6,314.3],[1356.5,311.5],[1358.6,310.9],[1364.8,310.7],[1375,307.3],[1378,307],[1378,308.2],[1378.9,309.4],[1384.7,311.8],[1385.2,312.5],[1385.9,315.7],[1387.2,317.9],[1388.9,319.7],[1395.6,324.1],[1398.3,326.4],[1401.7,330.3],[1406.9,334.5],[1411.1,333.3],[1414.8,333],[1418,333.4],[1420.7,334.3],[1424.2,336.7],[1424.9,337.8],[1424.9,338.6],[1422.5,341.7],[1419.8,344.3],[1417,344.9],[1416.8,345.7]]]},\"edirne\":{\"paths\":[\"m498.88,218.31c-1.42,2.81-2.85,5.87-3.16,7.44-.43,2.15-1.49,8.91-3.55,14.51-12.99-1.47-28.72-10.71-36.71-3.64-5.34,5.12-8.66,3.19-11.42,1.87-22.9-6.43-14.24,17.12-30.31,25.05-2.69.92-5.12,1.81-7.34,2.68-5.31-1.69-9.74-1.82-12.96-1.48.06-.32.09-.64.1-.98-7.56-4.73-30.2,9.41-38.33,2.31-.17-.15-.32-.34-.42-.54-1.58-2.96-3.32-8.41-2.82-9.15,1.11-1.64,1.81-3.22,7.47-5.7,2.27-.7,1.29-2.45,2.12-3.6,5.53-3.5,2.41-5.2,6.03-4.96,1.34-.79-2.35-3.57.16-4.62.59-1.66-3.74-3.01-1.48-6.52.8-2.27-1.3-5.81.33-8.01.99-.83-.25-1.9.33-2.15.57-.25,3.55.17,3.8-.16.44-1.28,3.79-1.27,3.63-3.06.16-.74,1.24-.36,1.35-1.18.07-3.63,5.17-.05,6.55-1.54.72-3.43-2.04-15.58-1.83-18.58-1.84-.61-4.88-2.88-5.29-4.83-3.69-.04-5.2-1.2-7.63-4.58-1.88-7.59,8.79-4.57,11.33-7.02.86-4.77.35-11.11,8.21-8.95,22.54-2.46,10.87-11.97,24.33-6.77,11.64-10.68,10.24,19.66,28.51,5.94,6.71,5.07,4.29-4.34,9.61.09,5.7,2.31,8.45-4.26,7.7,6.18-.95.51-4.05-.28-3.14,3.08,5.04,18.48,14.4,25.86,30.67,34.67,2.09,1.13,8.35,2.71,14.16,4.2Z\"],\"label\":[425,212],\"bbox\":[351.5,162,498.5,268],\"geoNeighbors\":[\"burgas\",\"gelibolu\",\"istanbul\",\"western-thrace\"],\"poly\":[[[498.9,218.3],[496.1,224.3],[493.5,235.9],[492.2,240.3],[487.2,239.4],[471.9,235.2],[467.2,234.3],[462.7,234],[458.8,234.7],[457,235.5],[453.5,238.2],[450.2,239.8],[448.8,240],[446.2,239.5],[444,238.5],[440.1,237.6],[436.8,237.4],[434.1,237.7],[431.9,238.6],[428.6,241.5],[426.3,245.6],[422,255.4],[418.7,259.9],[416.5,261.9],[413.7,263.5],[406.4,266.2],[399.1,264.7],[393.4,264.7],[393.5,263.8],[391.9,263.1],[387.9,262.8],[380.2,264.3],[368.9,267.2],[361.1,268.1],[356.9,267.2],[355.2,266.1],[352.6,260.1],[351.9,256.9],[352.8,255.1],[356,252.4],[360.6,250],[361.6,247.1],[364.3,244.8],[365.9,242.3],[367.6,242.1],[367.9,241.7],[366.8,238.6],[367.7,237.5],[367.8,236.9],[365.6,233.2],[366.4,229.1],[366,224.8],[367,222.3],[366.9,220.8],[370.7,220.7],[373.9,218.7],[376.6,214.9],[380.7,215.2],[382.3,214.9],[382.2,211],[380.4,196.3],[377.2,194.4],[375.9,193],[375.1,191.5],[372.7,191.2],[370.8,190.4],[369.2,189],[367.5,186.9],[367.3,184.5],[368.1,182.9],[369.6,182],[377.5,180.6],[378.8,179.9],[380.3,172.8],[381.2,171.5],[382.6,170.7],[384.5,170.5],[387,170.9],[390.9,170.4],[396.5,168.9],[400,167.2],[403.7,163.4],[405.1,162.7],[407.4,162.8],[411.4,164.1],[413.4,162.6],[415.2,161.9],[416.8,161.9],[418.2,162.5],[420.7,165],[425.9,171.4],[429.4,173.4],[431.5,173.7],[433.9,173.3],[436.7,172.2],[439.9,170.1],[442,171.4],[443.5,171.6],[444.5,171.2],[446.7,169],[447.8,169.1],[449.5,170.2],[451.5,170.7],[456.6,170.4],[457.1,171.3],[457.3,173.2],[457.2,176.4],[454.9,176.8],[454,177.6],[454.1,179.4],[456.1,185.9],[458.7,191.4],[461.7,196.2],[465.2,200.4],[469.2,204.1],[473.8,207.6],[484.7,214.1],[490.4,216.1],[498.9,218.3]]]},\"rhodes\":{\"paths\":[\"m403.87,457.41c-2.89-1.73-10.51-2.72-13.87-2.5-2.72.18-6.83,1.38-9.08,3.52-2.26,2.15-1.06,3.91.01,4.08,2.63.41,4.42-.43,5.33-.61,1.84-.36,3.69,1.62,5.31,3.44,1.62,1.82,4.27,1.02,4.76-.28.5-1.29,2.42-2.57,5.42-3,3.61-.52,3.37-3.9,2.12-4.65Z\",\"m363.35,464.59c-.42.58-1.32,2.53-2.94,2.45-1.62-.08-2.42-.52-3.83-.47-1.4.05-4.65.63-5.92,3.55-1.27,2.92-1.05,4.16.99,3.47,2.04-.69,4.18-2.61,6.47-2.72,2.28-.11,6.3-1.27,7.35-3.22,1.05-1.95,2.64-2.34,1.95-4.05-.69-1.71-3.69.46-4.07.99Z\",\"m416.74,513.87c-.83-.08-1.79.54-2.72.87-1.97.7-4.87,1.16-6.32,2.35-1.44,1.2-3.76,3.26-4.62,4.29-.87,1.03-2.52,1.61-3.59,2.06-1.07.45-.91,3.06-.29,4,.62.95,2.15-2.11,3.55-2.85,1.4-.74,5.49.21,6.36-1.28.87-1.49,3.88-3.51,6.61-3.67,2.72-.17,5.2-.95,4.17-2.6-1.03-1.65-2.31-3.1-3.14-3.18Z\",\"m460.51,546.78c-7.88,1.35-21.03,10.88-19.65,19.6,3.04,4.71-1.93,8.77.66,12.83,5.19,5.48,36.03-38.53,18.99-32.42Z\"],\"label\":[416,516],\"bbox\":[350,455,465.5,579.5],\"geoNeighbors\":[\"aydin\"],\"poly\":[[[403.9,457.4],[404.6,458.4],[404.6,459.8],[403.8,461.2],[398.1,463.2],[395.6,465.9],[394.4,466.4],[392.9,466.2],[387.6,462],[380.9,462.5],[380.2,462.1],[379.7,461.2],[379.8,460],[380.9,458.4],[382.9,457],[387.8,455.2],[391.4,454.9],[397.1,455.4],[401,456.3],[403.9,457.4]],[[363.4,464.6],[365.3,463.3],[366.5,463],[367.4,463.6],[367.6,464.7],[364.2,469],[362.3,469.9],[356.4,471.2],[351.7,473.6],[350.5,473.7],[349.9,473.2],[350.7,470.1],[351.9,468.3],[353.6,467.3],[356.6,466.6],[360.4,467],[361.5,466.8],[363.4,464.6]],[[416.8,513.9],[418.2,514.9],[419.9,517],[420.1,518.1],[419.2,518.9],[413.7,520.1],[411.7,521],[407.9,524],[402.8,524.6],[399.8,527.5],[399.2,527.4],[398.7,525.3],[398.9,524.1],[399.5,523.4],[403.1,521.4],[407.7,517.1],[409,516.3],[416.7,513.9]],[[460.5,546.8],[464.1,546.3],[464.8,546.7],[465.5,548],[465.5,550],[464.7,552.7],[461.5,559.2],[454.3,569.7],[449.1,575.6],[444.5,579.1],[442.1,579.6],[441.5,579.2],[440.9,577.7],[440.8,576.2],[441.9,569.8],[441.7,568.1],[440.9,566.4],[440.8,564.7],[441,563.1],[442.2,559.8],[444.4,556.7],[447.2,553.8],[450.5,551.3],[457.3,547.7],[460.5,546.8]]]},\"izmit\":{\"paths\":[\"M539.3,254.2 L538.9,254.2 L538.5,254.1 L538.1,254.1 L537.7,254.1 L537.3,254.1 L536.9,254.1 L536.5,254.1 L536.1,254 L535.7,254 L535.3,254 L534.9,253.9 L534.5,253.9 L534.1,253.9 L533.7,253.9 L533.3,253.8 L532.9,253.8 L532.5,253.7 L532.1,253.7 L531.8,253.7 L531.4,253.6 L531,253.6 L530.6,253.5 L530.2,253.5 L529.8,253.4 L529.4,253.4 L529,253.3 L528.6,253.3 L528.2,253.2 L527.8,253.2 L527.4,253.1 L527,253 L526.6,253 L526.2,252.9 L525.8,252.8 L525.5,252.7 L525.1,252.5 L524.8,252.3 L524.4,252.1 L524.1,251.9 L523.8,251.6 L523.4,251.4 L523.1,251.2 L522.8,250.9 L522.5,250.6 L522.2,250.4 L521.9,250.1 L521.6,249.9 L521.3,249.6 L521,249.3 L520.7,249.1 L520.4,248.8 L520.1,248.5 L519.8,248.3 L519.6,248 L519.3,247.7 L519,247.5 L518.6,247.2 L518.3,247 L518,246.7 L517.7,246.5 L517.4,246.3 L517.3,245.9 L517.5,245.6 L517.6,245.2 L517.7,244.8 L517.9,244.4 L518,244.1 L518.1,243.7 L518.3,243.3 L518.4,242.9 L518.5,242.5 L518.6,242.2 L518.7,241.8 L518.8,241.4 L518.9,241 L519.1,240.6 L519.2,240.2 L519.3,239.9 L519.4,239.5 L519.5,239.1 L519.6,238.7 L519.7,238.3 L519.8,237.9 L519.9,237.6 L520,237.2 L520.1,236.8 L520.3,236.4 L520.4,236 L520.5,235.6 L520.6,235.3 L520.7,234.9 L520.8,234.5 L521,234.1 L521.1,233.8 L521.3,233.4 L521.5,233 L521.7,232.7 L521.9,232.4 L522.1,232 L522.3,231.7 L522.5,231.3 L522.7,231 L522.9,230.6 L523.1,230.3 L523.3,229.9 L523.4,229.6 L523.6,229.2 L523.8,228.9 L524,228.5 L524.2,228.2 L524.4,227.8 L524.5,227.4 L524.7,227.1 L524.9,226.7 L525.1,226.4 L525.2,226 L525.4,225.7 L525.6,225.3 L525.8,224.9 L526,224.6 L526.1,224.2 L526.4,224.1 L526.8,224.2 L527.2,224.3 L527.6,224.4 L528,224.5 L528.4,224.5 L528.8,224.6 L529.2,224.7 L529.6,224.8 L530,224.9 L530.3,224.9 L530.7,225 L531.1,225.1 L531.5,225.2 L531.9,225.3 L532.3,225.3 L532.7,225.4 L533.1,225.5 L533.5,225.6 L533.9,225.7 L534.2,225.7 L534.6,225.8 L535,225.9 L535.4,226 L535.8,226.1 L536.2,226.2 L536.6,226.2 L537,226.3 L537.4,226.4 L537.8,226.5 L538.2,226.6 L538.5,226.6 L538.9,226.7 L539.3,226.8 L539.7,226.9 L540.1,227 L540.5,227 L540.9,227.1 L541.3,227.2 L541.7,227.3 L542.1,227.4 L542.4,227.4 L542.8,227.5 L543.2,227.6 L543.6,227.7 L544,227.7 L544.4,227.8 L544.8,227.9 L545.2,228 L545.6,228.1 L546,228.1 L546.4,228.2 L546.8,228.2 L547.2,228.3 L547.5,228.3 L547.9,228.4 L557.5,228.6 L557.9,228.6 L558.3,228.6 L558.7,228.6 L559.1,228.6 L559.5,228.6 L559.9,228.5 L560.3,228.5 L560.7,228.5 L561.1,228.5 L561.5,228.4 L561.9,228.4 L562.3,228.4 L562.7,228.3 L563.1,228.3 L563.5,228.3 L563.9,228.2 L564.3,228.2 L564.7,228.2 L565.1,228.1 L565.5,228.1 L565.8,228 L566.2,228 L566.6,227.9 L567,227.9 L567.4,227.8 L567.8,227.8 L568.2,227.7 L568.6,227.6 L569,227.6 L569.4,227.5 L569.8,227.4 L570.2,227.4 L570.6,227.3 L571,227.2 L571.4,227.1 L571.7,226.9 L572.1,226.7 L572.4,226.5 L572.7,226.3 L573.1,226.1 L573.4,225.8 L573.7,225.6 L574.1,225.4 L574.4,225.2 L574.8,225.1 L575.2,225 L575.6,225.1 L576,225.2 L576.4,225.3 L576.7,225.4 L577.1,225.6 L577.5,225.7 L577.8,225.9 L578.2,226 L578.6,226.2 L578.9,226.4 L579.3,226.6 L579.6,226.7 L580,226.9 L580.4,227.1 L580.2,227.4 L580,227.8 L579.8,228.1 L579.6,228.5 L579.4,228.8 L579.2,229.2 L579,229.5 L578.8,229.9 L578.7,230.2 L578.5,230.6 L578.3,230.9 L578.1,231.3 L577.9,231.7 L577.8,232 L577.6,232.4 L577.5,232.8 L577.6,233.2 L577.8,233.5 L578.1,233.8 L578.4,234.1 L578.7,234.3 L579,234.5 L579.3,234.8 L579.7,235 L580,235.2 L580.3,235.5 L580.4,235.9 L580.5,236.3 L580.6,236.7 L580.5,237.1 L580.5,237.5 L580.4,237.9 L580.4,238.3 L580.4,238.7 L580.3,239 L580.3,239.4 L580.3,239.8 L580.3,240.2 L580.3,240.6 L580.2,241 L580.2,241.4 L580.2,241.8 L580.2,242.2 L580.1,242.6 L580.1,243 L580.1,243.4 L580,243.8 L580,244.2 L579.9,244.6 L579.9,245 L579.8,245.4 L579.8,245.8 L579.7,246.2 L579.6,246.6 L579.6,247 L579.5,247.4 L579.4,247.8 L579.2,248.1 L578.8,248.3 L578.5,248.4 L578.1,248.3 L577.7,248.2 L577.3,248 L576.9,247.9 L576.6,248.1 L576.5,248.4 L576.4,248.8 L576.3,249.2 L576.2,249.6 L576.1,250 L576,250.4 L576,250.8 L575.9,251.2 L575.8,251.6 L575.8,252 L575.7,252.4 L575.6,252.8 L575.6,253.2 L575.5,253.6 L575.5,253.9 L575.4,254.3 L575.3,254.7 L575.3,255.1 L575.2,255.5 L575.2,255.9 L575.1,256.3 L575,256.7 L575,257.1 L574.9,257.5 L574.9,257.9 L574.8,258.3 L574.8,258.7 L574.7,259.1 L574.6,259.5 L574.6,259.9 L574.5,260.3 L574.4,260.7 L574.3,261 L574.2,261.4 L574.1,261.8 L573.9,262.2 L573.8,262.6 L573.6,262.9 L573.4,263.3 L573.2,263.6 L573,263.9 L572.7,264.2 L572.4,264.5 L572.1,264.8 L571.8,265 L571.5,265.2 L571.1,265.4 L570.8,265.6 L570.4,265.8 L570.1,266 L569.7,266.2 L569.4,266.4 L569,266.6 L568.7,266.8 L568.3,266.9 L568,267.1 L567.6,267.3 L567.2,267.5 L566.9,267.7 L566.5,267.9 L566.2,268.1 L565.9,268.3 L565.5,268.5 L565.2,268.7 L564.9,269 L564.7,269.3 L564.5,269.7 L564.3,270 L564,270.3 L563.7,270.6 L563.4,270.8 L563,271 L562.7,271.2 L562.3,271.4 L562,271.6 L561.6,271.7 L561.3,271.9 L560.9,272.1 L560.5,272.2 L560.1,272.3 L559.8,272.5 L559.4,272.6 L559,272.7 L558.6,272.8 L558.2,272.9 L558,272.6 L557.8,272.2 L557.6,271.9 L557.4,271.6 L557.2,271.2 L556.9,270.9 L556.7,270.6 L556.4,270.3 L556.1,270.1 L555.8,269.8 L555.5,269.5 L555.2,269.3 L554.9,269 L554.5,268.8 L554.2,268.6 L553.9,268.3 L553.5,268.1 L553.2,267.9 L552.8,267.8 L552.5,267.6 L552.1,267.4 L551.8,267.2 L551.4,267.1 L551,267 L550.6,266.8 L550.2,266.7 L549.9,266.6 L549.5,266.6 L549.1,266.6 L548.7,266.6 L548.3,266.7 L547.9,266.9 L547.6,267 L547.2,267.2 L546.8,267.3 L546.4,267.4 L546.1,267.5 L545.7,267.6 L545.3,267.7 L544.9,267.8 L544.5,267.9 L544.1,268 L543.7,268.1 L543.3,268.2 L542.9,268.3 L542.6,268.4 L542.2,268.4 L541.8,268.5 L541.4,268.6 L541,268.7 L540.6,268.7 L540.2,268.8 L539.8,268.9 L539.4,268.9 L539,269 L538.6,269.1 L538.2,269.2 L537.8,269.2 L537.4,269.3 L537.1,269.4 L536.7,269.4 L536.3,269.5 L535.9,269.5 L535.5,269.6 L535.1,269.7 L534.7,269.7 L534.3,269.8 L533.9,269.9 L533.5,269.9 L533.1,270 L532.7,270 L532.3,270.1 L531.9,270.1 L531.5,270.2 L531.1,270.3 L530.7,270.3 L530.3,270.4 L529.9,270.5 L529.6,270.5 L529.2,270.6 L528.8,270.7 L528.4,270.8 L528,270.9 L527.6,271.1 L527.2,271.2 L526.9,271.3 L526.5,271.4 L526.1,271.6 L525.7,271.7 L525.4,271.9 L525,272 L524.6,272.2 L524.3,272.4 L523.9,272.5 L523.6,272.7 L523.2,272.9 L522.8,273.1 L522.5,273.3 L522.2,273.5 L521.8,273.7 L521.5,273.9 L521.1,274.1 L520.8,274.3 L520.5,274.5 L520.1,274.8 L519.8,275 L519.5,275.3 L519.2,275.5 L518.9,275.8 L518.6,276.1 L518.3,276.4 L518.1,276.7 L517.8,277 L517.5,277.3 L517.2,277.5 L516.9,277.7 L516.5,277.9 L516.1,278 L515.8,278.1 L515.4,278.2 L515,278.3 L514.6,278.3 L514.2,278.4 L513.8,278.4 L513.4,278.4 L513.1,278.3 L513.1,277.9 L513,277.5 L512.9,277.2 L512.8,276.8 L512.6,276.4 L512.4,276.1 L512.1,275.8 L511.8,275.5 L511.5,275.3 L511.1,275.1 L510.8,275 L510.4,274.8 L510,274.7 L509.6,274.6 L509.2,274.6 L508.8,274.5 L508.4,274.5 L508,274.6 L507.6,274.6 L507.2,274.6 L506.8,274.7 L506.4,274.8 L506.1,274.9 L505.7,275 L505.3,275.1 L504.9,275.2 L504.5,275.2 L504.1,275.2 L503.7,275.1 L503.3,275 L502.9,274.9 L502.5,274.8 L502.2,274.6 L501.8,274.5 L501.4,274.3 L501.1,274.1 L500.7,273.9 L500.4,273.7 L500.1,273.5 L499.7,273.3 L499.4,273.1 L499.1,272.8 L498.7,272.6 L498.4,272.4 L498.1,272.2 L497.8,271.9 L497.5,271.6 L497.3,271.3 L497.1,270.9 L497.1,270.5 L497.1,270.1 L497.2,269.7 L497.4,269.4 L497.7,269.1 L498,268.9 L498.4,268.7 L498.7,268.5 L499.1,268.5 L499.5,268.4 L499.9,268.2 L500.3,268.1 L500.6,267.9 L501,267.7 L501.3,267.5 L501.7,267.3 L502,267.1 L502.3,266.8 L502.6,266.6 L502.9,266.4 L503.2,266.1 L503.6,265.8 L503.9,265.6 L504.2,265.3 L504.5,265.1 L504.8,264.9 L505.1,264.6 L505.5,264.5 L505.9,264.3 L506.2,264.1 L506.6,264 L507,263.9 L507.4,263.8 L507.8,263.7 L508.2,263.7 L508.6,263.7 L509,263.6 L509.4,263.6 L509.8,263.6 L510.2,263.6 L510.6,263.6 L511,263.6 L511.4,263.6 L511.8,263.6 L512.2,263.6 L512.6,263.6 L513,263.6 L513.4,263.6 L513.8,263.6 L514.2,263.6 L514.6,263.6 L515,263.6 L515.4,263.5 L515.8,263.5 L516.2,263.4 L516.5,263.4 L516.9,263.3 L517.3,263.2 L517.7,263.1 L518.1,263.1 L518.5,263 L518.9,262.9 L519.3,262.8 L519.7,262.7 L520.1,262.6 L520.4,262.4 L520.8,262.3 L521.2,262.2 L521.6,262.1 L521.9,261.9 L522.3,261.8 L522.7,261.6 L523.1,261.5 L523.4,261.3 L523.8,261.2 L524.1,261 L524.5,260.8 L524.9,260.6 L525.2,260.4 L525.5,260.2 L525.9,260.1 L526.3,260 L526.7,259.9 L527.1,259.8 L527.5,259.8 L527.9,259.8 L528.3,259.8 L528.7,259.7 L529.1,259.7 L529.5,259.7 L529.9,259.7 L530.3,259.8 L530.7,259.8 L531.1,259.8 L531.5,259.8 L531.9,259.8 L532.3,259.8 L532.7,259.9 L533.1,259.9 L533.5,259.9 L533.9,259.9 L534.3,260 L534.7,260 L535.1,260 L535.5,260 L535.9,260.1 L536.3,260.1 L536.7,260.1 L537.1,260.1 L537.5,260.1 L537.9,260.1 L538.3,260.1 L538.7,260 L539.1,260 L539.5,260 L539.9,260 L540.3,259.9 L540.7,259.9 L541.1,259.8 L541.5,259.8 L541.9,259.8 L542.3,259.7 L542.6,259.7 L543,259.6 L543.4,259.6 L543.8,259.6 L544.2,259.5 L544.6,259.5 L545,259.4 L545.4,259.4 L545.8,259.3 L546.2,259.3 L546.6,259.2 L547,259.2 L547.4,259.1 L547.8,259.1 L548.2,259 L548.6,259 L549,258.9 L549.4,258.9 L549.8,258.8 L550.2,258.8 L550.6,258.7 L551,258.6 L551.4,258.6 L551.8,258.5 L552.2,258.5 L552.6,258.4 L552.9,258.3 L553.3,258.3 L553.7,258.2 L554.1,258.1 L554.5,258 L554.9,257.9 L555.3,257.7 L555.6,257.6 L556,257.4 L556.3,257.2 L556.6,256.9 L556.9,256.7 L557.2,256.3 L557.3,256 L557.3,255.6 L557,255.2 L556.7,255 L556.4,254.8 L556,254.7 L555.6,254.6 L555.2,254.5 L554.8,254.5 L554.4,254.4 L554,254.3 L553.6,254.3 L553.2,254.3 L552.8,254.2 L552.4,254.2 L552,254.2 L551.6,254.2 L551.2,254.1 L550.8,254.1 L550.4,254.1 L550,254.1 L549.6,254.1 L549.2,254.1 L548.8,254 L548.4,254 Z\"],\"label\":[549,265],\"bbox\":[497,224,581,278.5],\"geoNeighbors\":[\"eskisehir\",\"istanbul\",\"sakarya\"],\"poly\":[[[539.3,254.2],[531.8,253.7],[525.5,252.7],[523.1,251.2],[517.4,246.3],[520.8,234.5],[526.1,224.2],[547.9,228.4],[559.5,228.6],[564.7,228.2],[571.4,227.1],[575.2,225],[580.4,227.1],[577.5,232.8],[578.4,234.1],[580.3,235.5],[580.6,236.7],[579.6,247],[578.8,248.3],[576.6,248.1],[574.6,259.9],[573.8,262.6],[572.1,264.8],[565.2,268.7],[563.7,270.6],[562,271.6],[558.2,272.9],[556.7,270.6],[553.9,268.3],[550.6,266.8],[548.7,266.6],[542.6,268.4],[529.6,270.5],[526.5,271.4],[521.1,274.1],[516.9,277.7],[513.4,278.4],[512.4,276.1],[511.1,275.1],[508.8,274.5],[504.9,275.2],[502.5,274.8],[498.1,272.2],[497.1,270.9],[497.2,269.7],[497.7,269.1],[501.7,267.3],[505.1,264.6],[507.8,263.7],[515,263.6],[518.1,263.1],[521.6,262.1],[527.1,259.8],[538.3,260.1],[552.2,258.5],[555.6,257.6],[557.3,256],[557,255.2],[555.2,254.5],[548.4,254]]]},\"istanbul\":{\"paths\":[\"m510.16,221.73c-1.05-.78-5.97-2.06-11.28-3.42-1.42,2.81-2.85,5.87-3.16,7.44-.43,2.15-1.49,8.91-3.55,14.51,4.05.46,7.84.17,11.04-1.62,3.14-.6,7.61-16.42,6.95-16.91Z\",\"m520.61,223.11l-4.96-.42s-1.24-.7-1.94,1.2c-.7,1.9-5.2,14.28-5.2,14.28,0,0-.62,1.82,1.2,2.94,1.3.8,5.04,3.28,7.52,5.07h.01c2.06-5.4,3.18-11.57,4.3-13.25,1.06-1.6,2.97-5.41,4.64-8.83-2.77-.55-4.85-.93-5.57-.99Z\"],\"label\":[504,220],\"bbox\":[492,218,526,246],\"geoNeighbors\":[\"edirne\",\"izmit\"],\"poly\":[[[510.2,221.7],[509.8,224.5],[508.1,230.1],[505.7,235.8],[504.4,237.8],[500.7,239.7],[498,240.3],[492.2,240.3],[493.5,235.9],[496.1,224.3],[498.9,218.3],[506.1,220.2],[510.2,221.7]],[[520.6,223.1],[526.2,224.1],[521.1,233.8],[517.2,246.2],[509.7,241.1],[508.8,240.2],[508.4,238.5],[514.3,222.9],[514.9,222.6],[520.6,223.1]]]},\"sakarya\":{\"paths\":[\"m651.63,244.57c-1.13,1.43-6.17,2.57-8.86,2.15-2.7-.42-5.12,2.23-5.78,3.39-.66,1.15-.09,5.61-4.3,9.18-4.21,3.57-11.56.39-14.12.48-2.56.08-8.67-1.82-11.64,0-2.97,1.81-1.48,4.62-1.73,6.78-.25,2.17-5.12,2.55-7.68,2.96-2.56.41-5.04,7.51-3.96,9.49,1.07,1.99,1.07,5.87-.42,6.2-.02,0-.03.01-.05.01-1.49.34-4.46,1.28-9.11-1.83-4.71-3.14-9-.41-14.2-.08-5.1.32-9.56-6.25-11.6-10.39,3.09-.72,6.03-2.29,6.35-3.32.55-1.73,6.47-3.38,8.29-5.45,1.81-2.06,2.06-6.69,2.31-8.09s1.07-7.76,1.57-8.09c.49-.33,1.9,1.15,2.56,0,.66-1.16,1.07-7.52,1.07-8.92s.5-2.56,0-3.38c-.5-.83-2.64-1.57-2.81-2.73-.08-.6,1.4-3.31,2.86-5.81.43.21.86.41,1.29.61,2.14.99,6.11.33,12.05,2.97,5.95,2.64,20.31,2.31,28.4.99,3.13-.51,5.37-1.9,6.96-3.53,4.72,2.82,9.71,5.71,10.44,6.06,1.24.61,4.51,1.05,6.63,1.41,2.12.36,7.76-.14,8.31,1.21.55,1.35-1.7,6.3-2.83,7.73Z\"],\"label\":[608,258],\"bbox\":[558,227,654,285],\"geoNeighbors\":[\"eskisehir\",\"izmit\",\"kastamonu\"],\"poly\":[[[651.6,244.6],[650.1,245.6],[647.8,246.3],[640.8,246.9],[639.1,247.8],[637,250.1],[636.2,253.8],[635,256.5],[632.7,259.3],[631,260.3],[629.1,260.9],[625,260.8],[619.7,259.9],[609.6,259],[606.9,259.8],[605.4,261.3],[604.9,267.3],[602.2,268.7],[597.5,269.5],[595.7,270.9],[594.2,273.7],[593.4,276.7],[593.3,278],[594.2,280.8],[594.3,282.7],[594,284.4],[593.1,285.2],[589.7,285.6],[587.2,285],[582.2,282.5],[580.5,282],[577.1,282],[569.8,283.3],[567.9,283.1],[566.1,282.4],[562.8,279.8],[560.1,276.3],[558.2,272.9],[560.4,272.2],[563.8,270.4],[565.8,268.3],[570.8,265.6],[572.8,264.1],[573.9,262.2],[576.5,248.3],[576.7,248],[578.7,248.4],[579.3,248],[579.7,246.3],[580.5,237.1],[580.3,235.7],[578,233.7],[577.5,232.9],[580.4,227.1],[583.6,228.2],[589.6,229.3],[596.3,231.6],[599.5,232.2],[607.1,232.7],[615.1,232.5],[622.1,231.7],[626.2,230.3],[629.1,228.2],[640.8,234.6],[646.2,235.6],[654,236.4],[654.5,236.8],[654.4,238.4],[653.7,240.7],[651.6,244.6]]]},\"balikesir\":{\"paths\":[\"m504.22,341.73c-.33,3.41-2.87,9.72-5.51,12.35-2.64,2.62-7.7,4.6-7.87,7.47-.17,2.86-.21,3.49-.21,3.49,0,0-.02,0-.05-.01-.39-.08-2.97-.56-3.58-.48-.66.08-4.99,3.05-8.3,2.64-3.3-.42-5.03.66-6.03,1.98-.99,1.32-5.36,3.22-7.01,2.64-1.65-.58-2.4-.58-5.54-6.03-3.13-5.45-3.79-6.19-5.86-6.19s-4.04-.58-3.71-4.13c.33-3.55.49-2.97-2.81-3.13-3.3-.17-5.78-1.19-7.76-.75-1.98.44-2.42.06-4.13-1.1-1.71-1.15-4.79-3.97-7.35-2.84-1.42.63-2.18.5-3.05.12-.69-.31-1.44-.77-2.65-1.13-2.72-.83-4.62.05-6.85,1.01-2.23.97-8.26,3.61-9.91,6.09-1.65,2.48-4.21,5.28-6.11,6.27-1.13.59-4.53,2.04-7.52,3.76-.49-.47-.98-.88-1.44-1.2-1.98-1.36-2.68-3.96-4.29-5.78-1.61-1.81,1.28-4.5,3.96-6.35,2.69-1.86,7.23-7.1,9.54-9.91s.99-6.11-.66-5.84c-1.65.28-6.55,1.98-15.03,2.98-8.48.99-16.33,4.41-17.73,4.41s-3.1.62-7.35,1.87c-4.25,1.26-5.53-.9-5.55-1.4-.02-.49,1.35-6.54,2.39-7.47,1.05-.94,1.98-4.57,1.82-6.61-.14-1.73-.25-8.07-.34-10.44,15.85,1.33,22.8-17.4,29.34-23.3,6.82-6.17,21.79-7.05,26.75-9.8,1.75-.97,3.81-2.45,5.1-4.27.43.83,1.05,1.65,1.9,2.4,1.94,1.73,6.57,2.64,11.27,2.89,4.71.25,8.33-.36,12.62-.96,4.3-.61,2.75-3.75-.66-5.45-12.88-5.56-4.29-7.82,1.49-7.87,5.78-.06,9.19,2.53,9.41,4.51.22,1.98-4.02,2.42-4.68,4.29-.66,1.87,2.48,1.32,4.18,1.27.82-.03,6.03-.66,11.82-1.08-1.64,2.03-3.17,4.33-3.01,5.7.33,2.87-.79,7.79-.01,9.89.78,2.11,5.63,7.84,5.96,11.58s2.86,9.58,6.82,11.56c3.97,1.98,11.56,6.72,13.71,7.71,2.15.99,6.22,6.6,9.74,6.82,3.53.22,5.07,4.41,4.74,7.82Z\"],\"label\":[429,322],\"bbox\":[354,272,504,372],\"geoNeighbors\":[\"canakkale\",\"eskisehir\",\"izmir\",\"lesbos\",\"usak\"],\"poly\":[[[504.2,341.7],[502.3,348.2],[500.6,351.5],[498.7,354.1],[493.8,357.7],[491.1,360.5],[490.6,365],[487,364.6],[481.3,367],[474.8,367.5],[471.4,370.2],[467.3,371.8],[465.7,371.8],[463.4,370.6],[456.8,360.6],[455.6,359.8],[452.8,359.4],[451.5,358.9],[450.5,356.7],[450.5,352.6],[441.6,351.5],[437.8,351.6],[432.5,348.2],[430.5,347.4],[426.8,348.1],[420.9,346.3],[419.2,346.5],[416,347.6],[410.8,350.1],[406.8,352.8],[401.5,359],[392.4,363.8],[389.7,361.3],[386.7,356.8],[386.2,355.3],[387.1,353.6],[395.6,345.8],[400.9,339.5],[401.3,336.4],[400.6,335.1],[399.5,334.7],[390.2,336.8],[378.3,338.8],[358,344.3],[355,343.9],[353.9,342.5],[355.4,336.6],[357,333.9],[358,330.2],[357.7,318],[360.6,318],[365.8,316.9],[368.1,315.8],[372.3,312.8],[375.9,309.1],[384.6,297.5],[387.1,294.7],[390,292.6],[393.4,291],[401.1,288.5],[411.5,285.9],[413.8,284.9],[416.5,283.1],[418.9,280.7],[420.8,283.1],[422.7,284.2],[428.6,285.6],[435.4,286],[446.1,284.6],[447.3,283.4],[447.3,282.7],[446.2,281],[438.9,276.7],[437.3,274.6],[437.8,273.5],[439.1,272.7],[441.1,272.1],[445.5,271.7],[449.4,272.1],[452.3,273.2],[454.2,274.6],[454.9,276.2],[454.8,276.8],[451.3,279.3],[450.3,280.5],[450.4,281.5],[451.5,281.8],[454.4,281.7],[466.3,280.7],[463.4,285.2],[463,294.2],[463.2,296.2],[468.2,304.7],[469.9,310.9],[471.3,314.3],[474.6,318.5],[490.6,327.7],[496.8,332.9],[501.8,334.7],[503.3,336.6],[504.1,339.1],[504.2,341.7]]]},\"izmir\":{\"paths\":[\"m430.41,401.55c.34.88.47,1.73.46,2.55-.07,4.11-3.78,7.55-3.95,9.95-.21,2.87-4.28,14.65-4.12,21.75.17,7.1,2.15,12.88-2.8,14.53-1.18.4-2.97.74-5.01,1.02.23-1.24.9-2.66,1.35-3.3.71-1.02.35-3.52-.31-4.18-.66-.66-2.28-1.46-3.52-.99-1.24.46-3.44.24-5.42-1.19-1.98-1.43-6.36-4.92-8.15-4.46-1.79.47-2.97,1.85-3.52,2.04s-1.25-2.06-1.45-3.1c-.21-1.03-.95-3.55-1.7-4.12-.74-.58-1.01-1.68-1.87-3.1-.87-1.43-4.71-.91-6.3-.56-1.59.35-1.82,1.61-1.71,2.69.1,1.07-.23,3.57-1.26,3.59-1.04.02-3.57-1.45-4.73-3.49s-4.07-3.85-6.77-3.91c-2.7-.05-3.11-2.59-4.9-4.87-1.79-2.29.66-3.99,1.57-3.33.91.66,3,1.68,4.24,1.76,1.24.08,3.8-3.4,5.32-5.3,1.53-1.9-.41-2.85-2.1-4.04-1.7-1.2-3.35-3.6-4.67-8.1-1.32-4.5.5-5.45,3.1-5.98,2.6-.54,4.83,1.61,5.12,2.52.29.9,1.61,3.67,2.76,5.07,1.16,1.41,2.3,3.2,2.36,4.3.05,1.1-1.71,1.24-2.09,2.25-.39,1.02,2.2,4.49,2.86,8.54.66,4.04,2.97,2.39,2.97,1.73s.22-5.59.36-6.66c.14-1.07,1.62-1.07,1.7-.25.09.83,2.41,3.7,3.51,3.66,1.09-.05,6.83-2.6,8.15-3.24s4.31-1.02,5.41-.56c1.09.45,2.06,1.44,3.43,2.1,1.36.66,2.62-1.32,2.66-3.09.04-1.78-1.8-2.71-2.66-2.85-.87-.15-2.71-.62-4.3-.5-1.59.13-4.14,1.34-5.3,1.48-1.15.14-1.79-2.06-2.72-4.9-.94-2.83-2.31-4.26-5.12-5.67-2.81-1.4-3.15-4.11-2.82-6.97.33-2.87,5.09-2.19,6.76-1.09,1.66,1.1,2.4-1.2,2.8-1.91.4-.72-.68-3.17-.84-3.46-.17-.29-1.36-1.37,2.77-.93,4.13.44,3.77-7.6,2.97-7.68-.8-.08-6.03.85-8.42,1.43-2.39.58-2.59-2.18-2.59-2.18,0,0-.11-3.96,0-4.89.11-.94.11-.97,1.93-1.38,1.82-.41,2.12-1.84,1.9-3.52-.17-1.29-1.73-3.45-3.34-5,2.99-1.72,6.39-3.17,7.52-3.76,1.9-.99,4.46-3.79,6.11-6.27,1.65-2.48,7.68-5.12,9.91-6.09,2.23-.96,4.13-1.84,6.85-1.01,1.21.36,1.96.82,2.65,1.13,0,0,2.51,5.6,2.72,6.63.21,1.03,1.03,5.66,1.4,7.14.38,1.49,1.86,5.16,2.65,6.19.78,1.04-.1,9.15-1.81,14.42-1.72,5.28-2.03,14.16,0,19.41Z\"],\"label\":[396,396],\"bbox\":[364,346.5,432,451.5],\"geoNeighbors\":[\"aydin\",\"balikesir\",\"usak\"],\"poly\":[[[430.4,401.6],[430.9,404.1],[430.2,407.1],[426.9,414.1],[423.3,429.8],[422.8,435.8],[423.3,445.1],[423.1,446.9],[422.5,448.4],[421.5,449.5],[420,450.3],[415,451.4],[416.7,447.1],[416.7,445.8],[416,443.9],[414.5,443],[413.5,442.7],[411.4,443.1],[408.6,442.5],[402.9,438.8],[399.7,437.2],[398.9,437.2],[395.4,439.3],[395,439],[392.8,432.8],[390.4,428.9],[389.3,428.2],[385.6,428.1],[383.1,428.8],[382.6,429.5],[381.8,434.3],[381.1,434.7],[380.1,434.4],[377.5,432.6],[375.2,429.7],[373.6,428.5],[371.7,427.6],[368,426.8],[366.8,425.7],[364.2,421.6],[364.1,420.8],[364.5,419.6],[365.4,419],[370.5,420.8],[371.7,420.3],[375.9,415.5],[376.4,414.3],[376,413.2],[372.5,410.4],[371.3,408.7],[369.1,403.4],[368.7,400.6],[369.2,398.9],[370.4,397.9],[372.2,397.4],[374,397.4],[376.8,399.1],[378.4,402.3],[381.7,407.3],[382.4,409.3],[382.2,410],[380.3,411.5],[380.3,412],[382.4,417.2],[383.5,421.4],[383.9,422.2],[384.9,422.7],[386.2,421.8],[386.5,415.2],[387.4,414.3],[388,414.5],[389.6,417.1],[391.7,418.6],[399.9,415.3],[402.7,414.6],[405.3,414.8],[408.7,416.9],[409.7,416.9],[410.6,416.2],[411.4,413.8],[411.1,412.6],[409.5,411.2],[404.4,410.4],[399.1,411.9],[398.4,411.6],[395.6,405.1],[394.6,403.6],[389.6,400.1],[388.7,398.4],[388.5,394.4],[389.4,392.8],[391.3,392.3],[393.5,392.6],[396.3,393.5],[397.1,393],[398.1,390.6],[397,387.2],[401.3,386.8],[402.3,386],[403.3,383.3],[403.4,380.6],[402.9,379.3],[393.7,380.8],[392.3,379.9],[391.9,378.5],[391.9,373.7],[392.2,372.8],[394.9,371.8],[395.8,370],[395.4,367.7],[392.4,363.8],[401.5,359],[408,351.9],[413.7,348.7],[419.2,346.5],[422.8,346.6],[425.5,347.8],[428.2,354.4],[430,363],[432.4,368.4],[432.2,373.3],[429.4,386.7],[429,391.9],[429.3,397],[430.4,401.5]]]},\"aydin\":{\"paths\":[\"m545.28,513.64s-5.67,11.83-5.78,14.03c-.11,2.21.28,4.96-1.32,6.66-1.6,1.71-5.4,5.59-5.97,9.39-.58,3.8-4.63,9.16-6.44,10.49-.44.32-1.08,1.03-1.82,1.94-.56-.22-1.17-.49-1.84-.84-3.42-1.76-8.11-8.91-7.78-9.73.33-.83-.58-6.2-.45-7.06.12-.87-1.08-1.65-1.9-1.74-.83-.08-2.52-.37-2.56-1.36-.04-.99,1.32-2.02,2.93-2.52,1.61-.49.16-3.55-.87-3.92-1.03-.37-3.51-1.86-4.91-3.22-1.4-1.36-2.81-1.49-3.22-.66-.41.83-1.65,2.11-2.85,2.52-1.2.41-.87,2.1-.62,2.85.25.74.5,2.39-.33,3.14-.82.74-1.36.33-2.02-2.15-.66-2.48-4.43-3.68-7.13-3.73-2.7-.06-3.47-1.82-3.52-3.96-.06-2.15-1.43-3.42-2.43-4.08-.99-.66-2.8.83-3.79.88-.99.06-.88-3.13-1.76-3.8-.89-.66-2.43-.22-2.92,1.6-.5,1.82-1.54,3.08-2.53,2.97-1-.11-3.14-2.58-4.41-2.91-1.26-.33-1.43,2.42-.49,4.4.93,1.98-.33,2.53-1.77,3.69-1.43,1.15-1.7,2.53-2.69,2.81-.99.27-3.58,4.4-4.35,5.5-.77,1.1-4.02,2.26-5.89,2.2-1.87-.05-.44-4.29-.5-5.5-.05-1.21,1.41-3.75,3.02-4.04,1.61-.28,2.6-1.15,3.88-1.23,1.28-.09.82-1.61,1.32-3.1.49-1.49-.37-2.52-1.16-2.11-.78.42-1.85,2.03-3.26,2.19-1.4.17-3.38.17-4.83.58-1.44.41-4.46.62-6.69.41-2.23-.2-6.02.46-7.3,1.41-1.28.95-1.12,3.05-2.44,3.3s-4.42-.08-5.94.41c-1.53.5-4.05.04-5.74-.66-1.7-.7.12-3.42,1.24-4.21,1.11-.78,3.5-1.03,5.36-.66,1.86.37,2.77-.08,3.26-1.16.5-1.07,3.39-.45,5.12-.33,1.74.13,7.23-2.14,9.21-1.98,1.98.17,7.49.77,8.48,0,.99-.77-.17-4.4-.61-6.27-.44-1.87,1.1-4.13,3.58-3.58,2.48.55,7.6-2,8.99-2.49,1.38-.5,3.94-2.11,3.19-3.2-.74-1.09-5.3.02-6.21.64-.91.62-8.05,1.24-10.24,1.32-2.19.08-8.71.29-12.34,1.57-3.63,1.28-12.98.92-15.54,1.2-2.56.27-2.2-3.5-3-3.94-.8-.44-3.16.55-5.12,2.56-1.95,2.01-2.86,1.65-3.46,1.13-.61-.52-.97-4.71-.97-5.75s.72-1.6,1.82-2.23c1.1-.64,4.79-2.23,7.46-1.41,2.67.83,6.35-1.81,6.35-2.31s.24-2.67,1.74-3.69,1.66-3.45,1.14-3.85-2.49.3-4.06,1.28-2.34-1.73-2.05-2.81c.29-1.07-2.29-1.17-3.45-1.11-1.15.06-2.45-.85-1.17-2.4,1.28-1.54,2.25-3.32.84-4.37-1.4-1.06-3.88,3.42-5.1,4.44-1.21,1.01-4.12.1-5.36-.56-1.24-.66.08-2.15.82-3.14.75-.99-1.79-5.28-1.54-6.08s-1.02-1.71-1.4-2.4c-.39-.68.49-1.84,1.84-2.8,1.35-.97-1.04-2.29-2.75-2.89-1.71-.61-5.27-2.18-6.24-2.3-.97-.13-1.14-1.1-1.05-1.72.08-.61,1.15-.41,1.15-.41,0,0,.52-.02,4.36.08,3.84.11,6.62-3.09,7.31-4.29.68-1.2.06-4.24-.69-5.4-.27-.43-.28-1.1-.13-1.82,2.04-.28,3.83-.62,5.01-1.02,4.95-1.65,2.97-7.43,2.8-14.53-.16-7.1,3.91-18.88,4.12-21.75.17-2.4,3.88-5.84,3.95-9.95.29,0,4.66-.03,5.47,1.65.85,1.73.69,4.87,2.94,5.65,2.25.79,5.04.51,6.31,3.62,1.27,3.11,3.25,3.66,5.89,3.55,2.64-.11,9.14-2.39,11.78.02,2.64,2.4,3.52,3.62,6.06,3.07,2.53-.55,7.59-.3,9.13,1.78,1.55,2.07,3.75,5.59,5.4,8.34,1.65,2.76,4.73,2.62,6.99,3.4,2.26.79,5.23,3.32,6.11,5.52.88,2.2,1.54,6.92.55,8.75-.99,1.82-.14,3.99,1.1,5.89,1.24,1.9,4.41,3.42,3.74,4.85-.66,1.43-3.08,3.02-4.95,4.97-1.87,1.96-6.77,2.73-7.21,4.39-.44,1.65-2.26,5.17-1.38,7.72.88,2.54,2.78,4.69,4.68,6.42,1.9,1.74,4.21,5.12,4.38,7.35.16,2.23,3.8,2.31,5.45,3.55,1.65,1.24,5.47,3.36,6.85,4.46,1.38,1.1,3.19,4.79,3.36,6.88.16,2.09,2.64,5.06,4.68,5.62,2.03.55,5.45-5.67,7.81-6.56.73-.27,1.34-.39,1.86-.37.12,0,.24.01.35.03s.22.04.32.07h.01c.08.02.15.05.23.08.02.01.04.02.07.03.06.03.12.06.17.09.2.11.38.26.52.43.07.07.12.15.17.23.14.2.24.43.32.68.44,1.38,6.02,2,7.67,1.58,1.65-.41,7.58,5.8,7.58,5.8Z\"],\"label\":[474,480],\"bbox\":[403,404,545,556],\"geoNeighbors\":[\"antalya\",\"isparta\",\"izmir\",\"rhodes\",\"usak\"],\"poly\":[[[545.3,513.6],[539.8,526.4],[539,532.9],[533.2,540.9],[531.2,546.8],[529.5,549.9],[527.5,552.5],[523.9,556.2],[520.8,554.4],[516.8,550.1],[514.4,546.2],[513.7,537.9],[512,536.8],[510.4,536.4],[509.4,535.4],[510.3,534],[512.8,532.6],[513,532.1],[512.9,530.9],[511.5,529],[509.2,527.7],[505.5,525],[503.8,524.7],[502.2,526.5],[499.9,528.1],[499.6,528.9],[500.1,532],[500,532.9],[499,533.9],[498.5,533.7],[496.5,529.8],[494.7,528.7],[488.7,527.4],[487.6,526.5],[486,521.2],[484.4,519.7],[483.6,519.5],[480.7,520.6],[480.1,520.1],[478.9,516.8],[478.1,516.5],[476.5,517.3],[475.5,519.6],[474.2,521.2],[473.4,521.3],[469,518.4],[468.3,518.7],[468,519.8],[468.9,524.1],[468.6,525],[463.1,530.1],[459.7,534.8],[458.8,535.6],[455.5,536.9],[453.8,537],[453,536.3],[453.6,530.4],[455.2,528.1],[460.9,525.9],[461.7,522.1],[461,521],[457.1,523.2],[449.3,524.3],[443.7,524.2],[439.7,525],[438.3,525.6],[436.6,528.5],[435.9,528.9],[428.6,529.6],[427.1,529.5],[423.7,528.3],[423.8,526.6],[424.5,525.4],[426.5,524],[427.8,523.7],[432,523.9],[433,523.8],[434.8,522.1],[439.2,522.3],[448.4,520.4],[453,520.7],[456.9,520.4],[457.3,519.3],[457.1,517.6],[456.3,514.1],[456.3,512.7],[457,511.4],[458.2,510.6],[462.1,510.4],[464.8,509.6],[468.8,508],[471.2,506.6],[472,505.7],[472,504.8],[471.6,504.5],[469,504.5],[464.1,505.9],[449.9,507.1],[439.6,509],[427.7,509.5],[426.3,509.1],[424.7,505.6],[423.8,505.5],[421.1,506.9],[417.3,509.7],[416.1,509.3],[415.7,508.3],[415.1,503.5],[415.6,502.3],[417,501.3],[420.1,500.1],[422.3,499.7],[426.5,500],[430.2,498.3],[430.8,497.6],[431.6,494.8],[433.4,492.9],[433.9,490.7],[433.7,490.1],[433,489.9],[428.6,491.5],[427.9,490.7],[427.3,487.9],[423.3,487.3],[422.6,486.8],[422.4,486],[424.4,482.6],[424.4,481.5],[423.8,480.6],[422.6,480.7],[418.7,485.1],[417.5,485.5],[416,485.4],[413.3,484.5],[412.8,483.9],[414.1,481.4],[414.2,480.1],[412.5,474.7],[411.1,472.3],[413.4,469.3],[412.8,468.5],[410.3,467.2],[403.5,464.7],[403,463.2],[403.6,462.8],[408.5,462.9],[411.2,462.4],[413.3,461.2],[415.8,458.6],[416.1,457.4],[415.6,454.3],[414.9,452.4],[415,451.3],[420,450.3],[421.5,449.5],[422.5,448.4],[423.3,445.1],[422.8,435.8],[423.3,429.8],[426.9,414.1],[430.2,407.1],[430.9,404.1],[435.2,404.8],[436.3,405.7],[438,410.4],[439.3,411.4],[442.8,412.3],[444.4,413.3],[446.7,416.9],[448,418],[451.5,418.6],[457.4,417.6],[460.7,417.6],[462.1,417.9],[466.3,421.2],[467.7,421.7],[471.6,421.4],[474.3,421.6],[476.7,422.2],[478.4,423.4],[483.8,431.8],[485.3,433.4],[487.1,434.2],[490.8,435.2],[494.4,437.4],[496.9,440.7],[497.5,442.7],[498,447.6],[497.1,450.9],[497.2,452.4],[498.6,455.3],[502.2,459.1],[502.3,460.2],[497.4,465.2],[490.5,469],[488.6,475.2],[488.8,477.3],[489.6,479.1],[496.3,487.2],[497.4,489.2],[498.1,491.8],[500,493.2],[503.3,494.6],[510.2,499],[512.3,502.1],[514,507.6],[516.6,510.7],[518.2,511.5],[519.9,510.9],[525.1,505.5],[527.9,504.6],[529,504.9],[530.4,506.7],[531.2,507.1],[533.4,507.7],[538.5,508],[542.1,510.6],[545.3,513.6]]]},\"antalya\":{\"paths\":[\"m698.69,550.19c.17,1.48-.52,8.8-2.42,11.2-.81,1.02-.94,3.27-.78,5.74-1.81-.42-3.5-.61-5.08-1.36-1.9-.91-2.56-3.39-5.12-4.38-2.56-.99-4.79-2.81-5.45-4.54-.66-1.74-5.75-9.19-9.55-13.6-3.8-4.4-9.08-7.7-13.76-7.92-4.68-.22-18.39-9.78-20.82-10.77-2.44-.99-8.38-4.58-10.28-4.54-1.9.04-7.52-1.15-11.07-2.06-3.55-.91-6.97-.25-9,.12-2.02.37-5.28.33-7.47-.58-2.19-.9-5.12-.95-6.94-.04-1.81.91-2.38,10.87-2.18,11.92.19,1.05-.5,8.48-1.2,9.01-.7.54-2.68,4.88-3.39,5.54-.7.66.21,3.63.91,5.49.7,1.85.58,2.35-.41,2.64-.99.29-.7,1.36-1.36,2.97-.66,1.61-2.69,2.64-2.81,1.94-.12-.7-1.2-1.9-2.44-1.86-1.23.05-2.8-1.52-6.19-2.1-3.38-.58-4.71.99-5.32,2.48-.62,1.48-1.78.2-3.43.28-1.65.09-2.56,2.11-4.42,2.19-1.86.09-2.97.09-4.13,1.45-1.15,1.36-2.85.95-4.29,1.28-1.45.33-2.93,2.1-3.76,2.19-.82.08-3.55.37-5.12-.5-1.57-.87-3.59-2.56-6.02-2.35-2.44.2-4.34-.29-6.24-1.7-1.53-1.12-2.94-1.26-5.2-2.18.74-.91,1.38-1.62,1.82-1.94,1.81-1.33,5.86-6.69,6.44-10.49.57-3.8,4.37-7.68,5.97-9.39,1.6-1.7,1.21-4.45,1.32-6.66.11-2.2,5.78-14.03,5.78-14.03,0,0,9.28,4.57,15.9,2.69,6.61-1.87,23.02-7.15,26.32-8.75,3.3-1.59,8.09-4.95,15.91-3.36,7.82,1.6,37.46,8.54,46.79,8.21,9.33-.33,9.25-.83,12.96-4.71,3.72-3.88,7.57-5.67,7.57-5.67,1.64,2.2,3.68,4.33,6.22,5.48,4.4,1.98,5.17,7.58,5.95,10.73.77,3.14,5.48,10.71,7.31,14.19,1.82,3.48,6.89,9.87,7.88,11.19.99,1.32,1.05,1.9,1.05,1.9,0,0-.61,3.16-.45,4.65Z\"],\"label\":[614,542],\"bbox\":[524.5,502.5,699.5,567.5],\"geoNeighbors\":[\"adana\",\"aydin\",\"isparta\",\"konya\"],\"poly\":[[[698.7,550.2],[698.3,555.4],[697.5,558.8],[695.8,562.4],[695.5,563.7],[695.5,567.1],[692.9,566.6],[690.4,565.8],[686.9,562.4],[681.9,559.4],[680.6,558.2],[676.2,551.1],[670.3,543.3],[667.2,540.2],[663.7,537.7],[660.1,536],[654.4,534.8],[651.6,533.7],[637.1,525.3],[626.3,520.2],[611.7,517.5],[601.7,518.3],[594.3,516.8],[590.9,517.5],[589.8,519.6],[589.1,523.4],[588.1,536.9],[583.9,544.8],[585.5,551.3],[584.1,552.4],[583.3,555],[581.7,556.9],[580.9,557.2],[579,555.3],[574.1,553.6],[569.7,552.9],[568.2,553.5],[566,556.1],[563.1,555.8],[558.7,558],[555.5,558.6],[553.6,560.1],[550.3,560.7],[546.5,562.9],[544.3,563],[541.4,562.4],[537.1,560.2],[532.1,559.8],[523.9,556.2],[527.5,552.5],[529.5,549.9],[531.2,546.8],[533.2,540.9],[539,532.9],[539.8,526.4],[545.3,513.6],[550.7,515.7],[555.9,516.7],[561.2,516.3],[582.9,509.4],[593.8,504.7],[598.1,503.9],[603.4,504.2],[626.2,509],[640.1,511.5],[650.2,512.4],[655.6,512.1],[658.8,511.4],[660.9,510],[665.9,505.2],[670.7,502.1],[673.5,505.2],[678.4,508.4],[679.6,509.6],[681.3,512.5],[683.4,519.6],[686.2,525.2],[692.1,535.5],[699,545.1],[698.7,550.2]]]},\"samsun\":{\"paths\":[\"m984.68,273.27c-.63.95-3.77,1.58-5.53,1.87-1.76.3-.88,3.62-.49,4.61.38.99-3.97.88-5.56.77-1.6-.11-4.3,4.07-6.39,4.4-2.09.33-6.05-3.08-7.56-8.28-1.51-5.19-4.33-7.68-8.4-7.95-4.08-.26-5.51-2.26-8.92-5.46-3.41-3.19-9.47-3.08-13.32-2.94-3.85.14-5.17-2.56-12.11-4.54-6.94-1.98-7.27-8.26-8.7-9.03s-5.39,1.43-9.25,2.2c-3.85.77-7.04-5.39-8.58-7.37-1.54-1.99-4.52-3.86-7.16.11-2.64,3.96-7.7,9.35-11.01,7.26-3.3-2.09-10.9-1.43-14.75-1.65-3.85-.22-8.15-8.04-11.56-9.36-3.41-1.32-4.95-.77-13.98-1.98-9.03-1.21-10.46-2.64-11.17-6.27-.71-3.64-6-5.92-8.87-5.95-2.87-.03-5.83-1.21-11.89-3.52-6.05-2.31-9.47-.44-10.9,2.86s-5.17,9.36-7.59,11.67c-2.43,2.31,2.09,4.95,2.09,9.14,0,.09,0,.17-.02.25,0,.09-.02.18-.05.26h0c-.01.05-.01.09-.03.13-.01.04-.02.07-.04.11-.03.1-.08.2-.13.3,0,.01-.02.03-.03.05,0,.01-.01.03-.02.04-.05.1-.12.19-.19.29-.02.03-.04.05-.06.08-.06.08-.12.16-.19.23-.04.03-.07.07-.1.1-.08.09-.17.17-.26.24-.11.11-.23.21-.36.3-.13.1-.26.19-.4.28,0,0-.01.01-.02.02-.14.08-.28.17-.43.25-.15.09-.31.18-.47.26s-.33.16-.5.24c-.34.16-.7.31-1.07.45-.45.18-.92.34-1.4.49-.57.18-1.14.34-1.69.48-.09.02-.18.05-.27.07-.18.05-.36.09-.54.13-.18.04-.36.09-.53.12-.15.04-.29.07-.43.1-.19.04-.37.08-.54.11-.19.04-.37.07-.53.1-.78.15-1.36.24-1.63.28h-.01s-.05.01-.07.01c-.06,0-.09,0-.09,0-1.67-3.27-4.74-6.98-9.04-11.9-8.04-9.19-12.33-2.91-30.4-8.9-18.07-5.98-11.43-16.25-11.1-21.2.33-4.96-5.4-6.28-7.71-10.13-2.31-3.85-1.1-5.62-3.19-8.59-1.23-1.75-2.31-6.89-2.99-10.83,4.74-1.41,8.78-2.56,9.81-2.93,2.76-.99,10.24-5.06,13.21-6.83,2.98-1.76,3.86-.44,10.68.11,6.83.55,25.38,1,31.98,1.33,6.61.33,21.91,1.54,24.44,2.47,2.54.94,9.83-.41,13.88-1.32,4.04-.91,7.81-7.43,8.69-8.5.88-1.08,2.98-1.24,3.47,1.26.5,2.51,3.58,2.73,4.6,2.59,1.02-.14.58,1.51-.47,2.06-1.05.55-1.68,4.49-1.43,6.64.25,2.14,3.47,5.61,5.37,8.67,1.89,3.05,10.37,6,13.03,8.09,2.66,2.09,6.04,1.71,10.94,1.65,4.9-.05,12.82-3.85,14.31-4.84,1.49-.99,1.6-.94,6.17,1.76,4.56,2.69,4.34,8.53,3.93,11.92-.41,3.38.66,4.04,3.39,7.76,2.72,3.71,9.96,11.14,13.1,11.75,3.13.6,7.76-3.25,9.91-6.06,2.14-2.8,4.01-2.36,9.3-.71,5.28,1.65,10.57,4.62,11.45,7.32.88,2.7,3.25,4.4,6.27,6,3.03,1.6,12.94,2.81,14.43,4.24,1.48,1.43,5.61,3.47,7.26,3.74,1.65.28,3.19-1.04,4.29-3.3,1.11-2.26,2.26-2.42,4.57-2.31,2.32.11,4.46,2.2,3.8,4.23-.66,2.04,2.15,3.8,4.79,4.52,2.64.71,10.46,1.93,12.44,2.42.08.02.17.04.26.05-.45,2.12-.93,3.85-1.41,4.74-1.99,3.63-2.98,8.81-1.33,15.19,1.39,5.35,2.54,9.15,3,11.47Z\"],\"label\":[846,220],\"bbox\":[707,161.5,985,284.5],\"geoNeighbors\":[\"kastamonu\",\"sivas\",\"trabzon\"],\"poly\":[[[984.7,273.3],[982.3,274.5],[978.6,275.4],[978.1,277.2],[978.6,280.1],[976.6,280.5],[972.5,280.7],[968.4,284.1],[966.7,284.9],[965.8,284.9],[962.7,282.9],[960.7,280.2],[957.8,273.2],[955.9,270.8],[953.6,269.3],[948.1,268.2],[946,267.1],[941.8,263.2],[938.9,261.4],[935.3,260.5],[926,259.9],[920.7,257.3],[914.1,254.8],[911,252.2],[907.7,246.7],[906.2,246.6],[898.5,248.9],[897,248.9],[895.7,248.4],[893.3,246.3],[888.5,240.2],[886.7,239.4],[885.7,239.4],[883.7,240.4],[880.3,244.8],[877.5,247.6],[874.4,249.2],[873,249.4],[868.5,247.8],[857,247.3],[854,245.9],[848.1,239.9],[845.4,237.9],[843,237.2],[828.4,235.5],[824.1,234.4],[821.7,232.9],[821,232],[819.8,228.4],[819,227.2],[816.6,225.3],[813.9,224.1],[806.6,222.8],[799.5,220.2],[795.4,219.2],[792.3,219.5],[790,220.9],[785.2,229.3],[780.4,235.6],[780.3,236.5],[782.9,242.4],[783.1,244.1],[782.5,245.4],[781.2,246.5],[778.7,247.7],[771,249.6],[767.4,244.3],[761.9,237.7],[759.1,235],[756.3,233.3],[753.6,232.5],[742.8,231.5],[734.8,229.8],[728.4,227.7],[725.9,226.4],[722.1,223.7],[720,220.8],[719.1,217.8],[719,214.9],[720.4,207.6],[720.3,205.9],[719.7,204.5],[712.7,197.5],[711.6,195],[710.6,191],[708.6,187],[706.6,178.1],[717.6,174.6],[731.5,167.5],[740.3,168.4],[778.5,170.2],[792.7,171.5],[797.8,172.5],[803,172.3],[810.6,170.9],[812,170.3],[816.1,166.7],[819.2,162.4],[820.1,161.8],[821.1,161.7],[822.1,162.3],[823.5,165.2],[824.8,166],[827.8,166.4],[827.5,167.7],[826.1,169.3],[825.6,171],[825.4,175],[826.1,176.8],[830.8,183.6],[833.2,185.9],[846,192.9],[848.4,193.4],[856.7,193.2],[863.2,191.3],[870,188],[871,188],[872.5,188.7],[876.7,191.4],[877.8,192.8],[879.1,196],[879.4,199.3],[879.1,204.3],[879.7,206],[885.3,213.3],[888.9,217],[894.3,221.2],[895.7,221.7],[898.2,221.4],[901,220],[903.5,217.9],[907.2,214.1],[909,213.6],[911.5,214],[918.8,216.4],[922.2,218.2],[925.8,221.2],[927.2,224.1],[928.6,225.7],[934,228.9],[946.1,232],[950.6,234.8],[954.3,236.2],[955.5,236.2],[956.6,235.6],[959.4,231.6],[960.4,230.9],[963.1,230.6],[964.8,231.1],[966.1,232],[966.9,233.4],[967,236.3],[968.1,237.6],[969.8,238.7],[972.9,239.7],[984.4,241.9],[983.7,244.7],[981.7,249.6],[981,253.2],[980.9,257.2],[981.7,261.8],[984.7,273.3]]]},\"van\":{\"paths\":[\"m1333.73,490.16c-.19.72-1.82,1.82-2.01,2.42-.19.61.62,3.79.62,3.79,0,0-5.12.62-6.28-.38-1.15-.99-2.8.05-3.38.58-.58.54-7.06,6.4-7.47,6.94-.42.54-3.26.66-4.05.74-.78.08-1.11,0-.95,1.45.17,1.44-2.06,3.34-3.14,3.55-1.07.2-2.47-.87-2.72-2.03-.25-1.15-1.45-2.93-2.31-5.03-.87-2.11,1.24-4.71,3.01-5.49,1.78-.79.95-2.44.54-3.97-.42-1.52-3.76-4.66-6.07-5.57-2.31-.91-7.35.33-8.67.91s-1.82,1.4-2.07,3.47c-.24,2.06-4.4,2.28-5.44,2.28s-2.37-1.21-4.68-.88c-2.32.33-5.89.17-7.46-.91-1.57-1.07-4.13.33-6.44-.49-2.31-.83-4.38-4.13-6.2-4.96-1.81-.82-1.48,2.07-4.95.17-3.47-1.9-11.12-2.45-12.94-1.52-1.81.94-4.23,2.37-6.38,1.21-2.15-1.15-7.71-2.31-9.58-1.32s-.05,5.62-1.04,6.33c-1,.72-4.35,1.54-4.68,2.65-.33,1.1-2.15,4.29-3.09,4.18-.93-.11-6,1.16-7.76,1.93-1.76.77-3.36-1.66-3.36-3.86s-1.37-5.12-3.02-6.05c-1.65-.94-5.95-.99-7.93.49-1.98,1.49-7.93,5.62-15.36,8.26-.32.11-.63.22-.93.31-7.86-7.82-7.43-14.76-2.95-18.52,4.87-4.08,3.47-9.29,1.74-16.3-1.74-7.02-8.84-10.24-13.88-13.05-5.03-2.81-8.5-10.57-3.3-13.54,5.2-2.97,9.75-10.57,10.74-14.12.99-3.55-1.82-12.3-2.48-15.28-.4-1.83-1.55-2.57-3.16-2.82,4.23-.52,12.66-1.8,17.47-4.17,6.61-3.24,9.06-13.9,13.43-17.2,4.38-3.3,17.09-1.9,23.7-6.6,6.6-4.71,24.52-9.75,26.17-11.56,1.65-1.82,1.57-6.44-.33-9-1.9-2.56,2.48-8.01,6.03-8.59s8.67,7.35,15.52,7.18c5.07-.12,16.66.51,29.97-.18.14.47.22.9.23,1.26.05,1.98,1.7,4.9,3.35,5.78,1.66.88,2.92,5.5,2.87,6.71-.06,1.21.22,3.86-.22,4.96-.44,1.1-.39,4.34.11,6.27.49,1.93,1.98,3.74,3.41,4.79,1.43,1.05,2.31,2.75,1.1,3.58-1.21.82-.42,3.18-1.14,3.84-.72.67-.35,1.28-.11,2.07.25.78.67,1.67.44,2.91-.23,1.24.41,1.4,1.09,1.53.68.12.87,5.78.68,6.97-.18,1.2-.55,8.94-.27,9.9.27.96,2.26,1.15,3.91,1.24,1.65.08,3.44-.77,5.23.63,1.78,1.4-.94,4.93-2.29,5.5-1.35.58-2.57,4.84-2.41,6.14.17,1.3-1.22,4.05-2.41,5.48-1.18,1.43-5.25,10.99-5.82,12.38-.58,1.38.02,2.17.53,2.66.52.5,6.46.52,6.98.76.52.25,1.16,2.05,1.18,2.48.02.43.35.91,1.03.99.68.08,1.61.7,2.02,1.24.42.54,1.38,1.4,2.15,1.09.77-.3,2.94.31,4.05.72,1.1.41,2.64,3.11,2.69,4.21.06,1.1-1.59,1.93-2.17,2.86-.58.94-.44,1.08.33,1.85.77.77.71.99.6,1.59-.11.61-.35,3.58-.02,4.24.33.66.11,1.21-.2,1.79-.3.58-.85,2.97-.68,3.33.16.36,1.1,1.1,1.23,1.6.14.49.61,1.26,1.27,1.73.66.47.55.83.85,1.43.31.61.44.72,1.05.77.6.06,1.68.28,4.07,2.56,2.4,2.29,3,3.99,2.81,4.71Z\"],\"label\":[1245,429],\"bbox\":[1156.5,348.5,1333.5,509.5],\"geoNeighbors\":[\"aleppo\",\"diyarbakir\",\"erzurum\",\"mosul\"],\"poly\":[[[1333.7,490.2],[1331.7,492.6],[1332.3,496.4],[1327.5,496.5],[1325.1,495.6],[1324.2,495.7],[1322.7,496.6],[1315.2,503.5],[1310.3,504.5],[1309.9,506.8],[1309.1,507.9],[1307.1,509.3],[1306.2,509.2],[1304.7,508.1],[1302,502.2],[1301.9,500.6],[1302.6,498.9],[1303.7,497.6],[1305.9,496],[1306.1,495],[1305.6,492.7],[1304.8,491.3],[1301.4,488.2],[1299.5,487.2],[1297.4,486.8],[1294.8,487.1],[1290.8,488.1],[1289.4,489.2],[1288.5,492.2],[1288,492.8],[1286.4,493.5],[1283.3,493.8],[1280.2,492.9],[1274.6,493],[1269.9,491.6],[1264.8,491.5],[1263.1,490.5],[1258.6,486.6],[1257.5,486.5],[1255.6,487.4],[1250.4,485.6],[1243,484.8],[1235.9,486.9],[1229.4,485],[1225.6,484.8],[1224.7,485.1],[1223.9,486.4],[1224,490.3],[1223.7,491.5],[1219.7,493.3],[1217.7,496.6],[1215.9,498.3],[1206.9,500.2],[1205.8,499.4],[1205.1,498],[1204.5,494.6],[1202.9,491.3],[1201.8,490.3],[1197.9,489.6],[1195.7,490],[1193.8,490.8],[1188.2,494.5],[1183.7,496.9],[1177.5,499.4],[1175,496.5],[1173.1,493.7],[1172,491.1],[1171.4,488.6],[1171.5,486.3],[1172.1,484.2],[1173.1,482.4],[1176.1,479.3],[1177.7,475.7],[1177.9,473.8],[1177.5,469.5],[1175.4,462.1],[1174.1,459.9],[1170.6,456.4],[1160.7,450.2],[1157.8,446.8],[1156.6,442.8],[1156.8,440.9],[1157.6,439.3],[1162.9,435],[1166.1,431.1],[1168.5,427.1],[1169.9,423.8],[1170,420.4],[1167.4,408.6],[1166.3,406.5],[1164.2,405.7],[1172.8,404.3],[1177.6,403.1],[1181.7,401.6],[1184,400],[1186,398],[1193.6,385.9],[1195.1,384.4],[1197.2,383.3],[1213,380.3],[1216.1,379.3],[1225.5,374.2],[1244.5,366.6],[1245.9,364.4],[1246.2,362],[1245.8,359.4],[1244.3,356.1],[1244.3,354.9],[1245.7,352.2],[1248,349.8],[1249.4,349],[1250.7,348.6],[1252.1,348.8],[1261.4,354.7],[1263.8,355.5],[1282.2,355.9],[1296.2,355.6],[1296.8,358.5],[1297.5,360.2],[1300.9,363.9],[1302.5,367.9],[1302.1,377.1],[1302.5,380.6],[1303.9,383.3],[1307.5,387.3],[1307.6,388.2],[1306.5,389.8],[1306.2,392],[1305.5,393.8],[1306.2,396.2],[1306.2,398.5],[1307.6,399.6],[1308,402.4],[1307.7,416.2],[1309.2,417.1],[1315.5,417.4],[1316.9,418.1],[1317.5,419.4],[1316.9,421.1],[1315.8,422.6],[1313.6,424.6],[1312.8,426.4],[1311.5,432.4],[1309.2,436.1],[1306.6,441.4],[1304,447.6],[1303.8,449.2],[1304.5,450.2],[1311.5,451],[1312.9,454.1],[1314.8,454.9],[1316.6,456.5],[1321.9,457.5],[1323.6,459.3],[1324.6,461.7],[1324.4,462.5],[1322.4,464.6],[1322.1,465.5],[1323.4,467.3],[1323.2,471.4],[1323.5,473.2],[1322.4,477.4],[1326.2,482.7],[1329.4,484.1],[1332.4,487.1],[1333.3,488.4],[1333.7,490.2]]]},\"erzurum\":{\"paths\":[\"M1313.3,334.2 L1313.1,334.2 L1312.8,334.3 L1312.3,334.4 L1311.6,334.6 L1310.7,334.7 L1309.7,335 L1308.5,335.2 L1307.1,335.5 L1305.6,335.7 L1304,335.9 L1302.2,336 L1300.3,336 L1298.2,335.9 L1296,335.8 L1293.7,335.6 L1291.3,335.4 L1289.1,335.1 L1287.2,334.9 L1285.6,334.6 L1284.3,334.3 L1283.3,334 L1282.6,333.7 L1282.1,333.5 L1282,333.2 L1281.7,332.8 L1281.3,332.5 L1280.8,332.2 L1280.2,331.8 L1279.4,331.5 L1278.6,331.1 L1277.6,330.7 L1276.6,330.3 L1275.6,329.9 L1274.7,329.4 L1273.9,328.9 L1273.1,328.4 L1272.5,327.9 L1271.9,327.3 L1271.5,326.7 L1271.1,326.1 L1270.7,325.5 L1270.2,324.9 L1269.7,324.4 L1269.2,323.9 L1268.6,323.5 L1267.9,323 L1267.2,322.6 L1266.5,322.3 L1265.7,322 L1264.8,321.8 L1263.8,321.8 L1262.8,321.8 L1261.7,321.9 L1260.5,322.2 L1259.3,322.5 L1258,322.9 L1256.8,323.2 L1255.7,323.4 L1254.8,323.5 L1254,323.5 L1253.3,323.4 L1252.8,323.2 L1252.4,322.9 L1252.1,322.5 L1251.8,322 L1251.5,321.4 L1251.3,320.7 L1251.1,319.9 L1250.9,319 L1250.8,318.1 L1250.6,317 L1250.6,315.9 L1250.5,314.9 L1250.4,314 L1250.3,313.3 L1250.3,312.8 L1250.2,312.3 L1250.2,312 L1250.2,311.9 L1249.3,310.5 L1248.8,310.3 L1248.6,310.3 L1248.2,310.2 L1247.5,310.2 L1246.7,310.1 L1245.6,310 L1244.3,309.9 L1242.8,309.8 L1241.1,309.7 L1239.3,309.6 L1237.5,309.7 L1235.6,309.8 L1233.6,310.1 L1231.6,310.4 L1229.5,310.9 L1227.3,311.4 L1225.1,312.1 L1223,312.6 L1221,313 L1219.1,313.3 L1217.3,313.5 L1215.6,313.6 L1214.1,313.5 L1212.7,313.4 L1211.3,313.1 L1210.1,312.8 L1208.9,312.3 L1207.9,311.7 L1206.9,311.1 L1206,310.3 L1205.1,309.5 L1204.4,308.5 L1203.7,307.5 L1203,306.5 L1202.3,305.5 L1201.5,304.5 L1200.7,303.6 L1199.8,302.8 L1199,301.9 L1198,301.1 L1197.1,300.4 L1196.1,299.7 L1195.2,299 L1194.2,298.5 L1193.3,298 L1192.3,297.5 L1191.4,297.1 L1190.5,296.8 L1189.5,296.6 L1188.7,296.3 L1187.8,295.9 L1187.1,295.5 L1186.4,295 L1185.7,294.5 L1185.1,294 L1184.6,293.3 L1184.1,292.7 L1183.6,292 L1183.3,291.4 L1183.1,290.8 L1182.9,290.2 L1182.9,289.6 L1182.9,289.1 L1183,288.6 L1183.2,288.1 L1183.7,287.4 L1184.5,286.7 L1185.6,285.9 L1187,285 L1188.7,284 L1190.6,282.9 L1192.9,281.7 L1195.5,280.4 L1197.7,279.1 L1199.6,277.9 L1201.2,276.7 L1202.4,275.6 L1203.3,274.5 L1203.8,273.4 L1204,272.4 L1203.8,271.5 L1203.7,270.5 L1203.7,269.7 L1203.7,268.8 L1203.7,268 L1203.8,267.2 L1204,266.4 L1204.2,265.7 L1204.5,265.1 L1204.7,264.5 L1204.9,264 L1205.1,263.5 L1205.2,263.2 L1205.3,263 L1205.4,262.8 L1205.4,262.7 L1208.5,261.5 L1207.1,259.4 L1205.5,256.9 L1201.8,251.7 L1199.7,249.4 L1197.3,247.6 L1194.6,246.5 L1191.6,246.3 L1190.1,246.7 L1188.8,247.4 L1186.4,249.8 L1184.4,253.1 L1182.7,256.8 L1181.3,260.5 L1180.2,263.7 L1179.2,266.1 L1178.7,266.8 L1178.3,267.2 L1177.3,267.3 L1176.1,267.1 L1173.2,266.2 L1170.1,265.3 L1168.5,265.1 L1167.1,265.2 L1163.9,266.3 L1160.3,267.7 L1156.7,268.7 L1155,268.7 L1153.5,268.4 L1152.4,267.4 L1151.8,265.8 L1151.1,261.5 L1150.5,257.2 L1149.9,255.7 L1148.8,254.8 L1147.4,254.5 L1145.6,254.2 L1143.6,254.2 L1141.5,254.4 L1139.2,255 L1136.8,255.9 L1134.3,257.3 L1131.8,259.2 L1129.1,261.3 L1125.8,263.4 L1122,265.4 L1118,267.4 L1109.3,271.2 L1100.6,274.6 L1098.6,275.2 L1096.5,275.5 L1092.6,275.2 L1088.9,274.1 L1085.5,272.6 L1082.6,271 L1080.2,269.8 L1078.5,269.2 L1078,269.4 L1077.6,269.8 L1077.1,271.4 L1076.9,273.8 L1076.5,279.6 L1075.6,285.6 L1074.7,288.1 L1073.4,290 L1072.3,291.9 L1071.9,294.3 L1071.9,297 L1072.1,299.9 L1072.4,305.8 L1072,308.5 L1071,310.8 L1070.1,311.8 L1068.9,312.6 L1065.9,313.7 L1062.1,314.3 L1057.8,314.5 L1053.2,314.2 L1048.8,313.6 L1044.6,312.6 L1041.1,311.5 L1034.9,309.2 L1028.8,307 L1023,305.3 L1017.6,304.3 L1012.4,304 L1007.5,304.1 L1005.6,304.2 L1004,304.4 L1003,304.5 L1002.6,304.6 L1003.5,306.4 L1003.5,308 L1002.4,309.9 L1001,311.6 L1000,313.5 L999.9,314.6 L1000.1,316 L1000.3,317.5 L1000.2,319.2 L999.2,322.7 L998.1,326 L997.7,327.5 L997.4,328.6 L996.8,333.3 L996.8,335.8 L997.5,338.3 L1000.1,342.9 L1000.8,344.7 L1000.8,345.4 L1000.4,345.9 L999.3,347.1 L998.3,348.6 L997.7,350.6 L997.6,352.9 L998.1,355.7 L998.5,358.9 L998.6,361.8 L998.4,362.8 L998,363.4 L997.3,364 L996.4,364.8 L996.5,364.9 L997,365.1 L998.6,366 L1001.1,367 L1004.4,367.7 L1008.4,368.6 L1012.2,370.6 L1015.5,373.1 L1016.7,374.5 L1017.6,375.9 L1018.6,378.4 L1019.1,380.5 L1019.7,381.3 L1020.5,381.9 L1021.8,382.3 L1023.7,382.6 L1028.7,382.9 L1034.2,383.5 L1040.3,384.8 L1043.4,385.9 L1046.5,387.2 L1049.3,388.5 L1051.3,389.4 L1052.8,390 L1053.9,390.2 L1055.5,389.9 L1057.5,388.9 L1060.6,388.1 L1064,388 L1067.3,387.8 L1068.7,387.4 L1070,386.8 L1071.2,385.8 L1072.6,384.4 L1075.4,381 L1076.6,379 L1077.4,376.9 L1077.7,374.8 L1077.5,372.6 L1077.1,370.8 L1077.3,369.7 L1077.8,369.2 L1078.5,369 L1080.7,369.1 L1083,368.8 L1084.5,368.1 L1086.5,367 L1091.4,364.1 L1096.1,361.4 L1097.9,360.4 L1099.1,359.9 L1100.8,360.1 L1101.5,360.6 L1102,361.4 L1102.3,362.4 L1102.2,363.6 L1101.8,365 L1100.9,366.6 L1098.8,369.7 L1097.4,372.2 L1096.9,374.7 L1097,376 L1097.4,377.4 L1098.6,380.2 L1099.7,382.7 L1100.7,384.8 L1101.6,386.3 L1102,387.9 L1101.8,389.9 L1101.2,391.8 L1100.5,392.8 L1099.5,393.1 L1098.3,393.1 L1097.1,393.2 L1096.3,393.6 L1095.7,394.8 L1094.9,396.6 L1094.2,398.5 L1094.1,399.8 L1094.3,400.3 L1094.7,401.2 L1095.9,403.5 L1097.1,406 L1097.7,408 L1097.8,409.3 L1097.9,410.2 L1097.9,410.7 L1097.9,410.9 L1098.2,410.9 L1098.9,411 L1101.3,411 L1104.2,410.3 L1105.5,409.5 L1106.6,408.3 L1108.7,405.5 L1111.2,403.1 L1114.3,401.6 L1116.1,401.2 L1118.1,401.2 L1122.5,401.5 L1127.3,401.4 L1132.2,400.6 L1134.5,399.8 L1136.9,398.7 L1139,397.5 L1140.8,396.5 L1143.7,395.1 L1146,394.5 L1148,394.8 L1148.9,395.3 L1149.6,396.1 L1150.6,398.3 L1151.7,400.9 L1153.5,403.6 L1154.6,404.7 L1155.5,405.4 L1157,406 L1158.6,406 L1160.7,405.7 L1164.2,405.7 L1166,405.5 L1168.1,405.2 L1172.8,404.3 L1177.6,403.1 L1181.7,401.6 L1184,400 L1186,398 L1189.3,393 L1192.1,388 L1193.6,385.9 L1195.1,384.4 L1197.2,383.3 L1199.8,382.6 L1206.2,381.6 L1213,380.3 L1216.1,379.3 L1218.8,377.8 L1221.8,376 L1225.5,374.2 L1233.8,370.9 L1237.8,369.4 L1241.2,368.1 L1243.7,367 L1244.5,366.6 L1245,366.2 L1245.9,364.4 L1246.2,362 L1245.8,359.4 L1244.7,357.2 L1244.3,356.1 L1244.3,354.9 L1244.8,353.5 L1245.7,352.2 L1248,349.8 L1249.4,349 L1250.7,348.6 L1252.1,348.8 L1253.7,349.5 L1257.2,352 L1261.4,354.7 L1263.8,355.5 L1266.2,355.8 L1268.4,355.8 L1271.2,355.8 L1274.4,355.9 L1278.1,355.9 L1282.2,355.9 L1286.6,355.9 L1296.2,355.6 L1295,352.2 L1294.4,350.8 L1294.1,349.8 L1294.2,349 L1294.7,348.2 L1296,347.5 L1297.1,347.4 L1298.4,347.3 L1299.8,347.4 L1300.7,347.4 L1302,347.4 L1303.4,347.1 L1304.3,347.4 L1305.3,348.4 L1306.4,349.4 L1307,349.6 L1307.6,349.4 L1309.3,348 L1310,347.5 L1311.2,347.3 L1312.6,347.2 L1313.8,346.8 L1314.6,346 L1314.9,345 L1314.7,343.2 L1314.5,340.8 L1314.4,338.6 L1314.5,337.8 L1314.7,337.3 Z\"],\"label\":[1161,322],\"bbox\":[996.4,246.3,1314.9,411],\"geoNeighbors\":[\"diyarbakir\",\"elazig\",\"igdir\",\"kars\",\"sivas\",\"trabzon\",\"van\"],\"poly\":[[[1314.7,337.3],[1314.4,338.6],[1314.9,345],[1314.6,346],[1313.8,346.8],[1310,347.5],[1307,349.6],[1304.3,347.4],[1303.4,347.1],[1296,347.5],[1294.7,348.2],[1294.1,349.8],[1296.2,355.6],[1274.4,355.9],[1263.8,355.5],[1261.4,354.7],[1253.7,349.5],[1250.7,348.6],[1249.4,349],[1248,349.8],[1245.7,352.2],[1244.3,354.9],[1244.3,356.1],[1245.8,359.4],[1246.2,362],[1245.9,364.4],[1244.5,366.6],[1225.5,374.2],[1216.1,379.3],[1213,380.3],[1197.2,383.3],[1195.1,384.4],[1193.6,385.9],[1186,398],[1181.7,401.6],[1172.8,404.3],[1164.2,405.7],[1157,406],[1155.5,405.4],[1153.5,403.6],[1151.7,400.9],[1149.6,396.1],[1148,394.8],[1146,394.5],[1143.7,395.1],[1136.9,398.7],[1132.2,400.6],[1127.3,401.4],[1116.1,401.2],[1114.3,401.6],[1111.2,403.1],[1108.7,405.5],[1105.5,409.5],[1104.2,410.3],[1101.3,411],[1097.9,410.9],[1097.7,408],[1097.1,406],[1094.1,399.8],[1094.2,398.5],[1096.3,393.6],[1100.5,392.8],[1101.8,389.9],[1102,387.9],[1101.6,386.3],[1097.4,377.4],[1096.9,374.7],[1097.4,372.2],[1101.8,365],[1102.2,363.6],[1102,361.4],[1100.8,360.1],[1099.1,359.9],[1097.9,360.4],[1083,368.8],[1077.8,369.2],[1077.3,369.7],[1077.1,370.8],[1077.7,374.8],[1076.6,379],[1072.6,384.4],[1070,386.8],[1067.3,387.8],[1060.6,388.1],[1053.9,390.2],[1040.3,384.8],[1034.2,383.5],[1023.7,382.6],[1020.5,381.9],[1019.1,380.5],[1018.6,378.4],[1016.7,374.5],[1015.5,373.1],[1012.2,370.6],[1008.4,368.6],[1001.1,367],[996.4,364.8],[998,363.4],[998.6,361.8],[997.6,352.9],[997.7,350.6],[998.3,348.6],[1000.8,345.4],[1000.1,342.9],[997.5,338.3],[996.8,335.8],[996.8,333.3],[997.4,328.6],[1000.2,319.2],[1000,313.5],[1003.5,308],[1003.5,306.4],[1002.6,304.6],[1012.4,304],[1017.6,304.3],[1023,305.3],[1028.8,307],[1041.1,311.5],[1048.8,313.6],[1057.8,314.5],[1065.9,313.7],[1070.1,311.8],[1071,310.8],[1072,308.5],[1072.4,305.8],[1071.9,294.3],[1072.3,291.9],[1074.7,288.1],[1075.6,285.6],[1076.5,279.6],[1077.1,271.4],[1078,269.4],[1078.5,269.2],[1080.2,269.8],[1088.9,274.1],[1092.6,275.2],[1096.5,275.5],[1098.6,275.2],[1109.3,271.2],[1122,265.4],[1129.1,261.3],[1134.3,257.3],[1136.8,255.9],[1141.5,254.4],[1143.6,254.2],[1148.8,254.8],[1149.9,255.7],[1150.5,257.2],[1151.8,265.8],[1152.4,267.4],[1153.5,268.4],[1156.7,268.7],[1167.1,265.2],[1168.5,265.1],[1176.1,267.1],[1178.3,267.2],[1179.2,266.1],[1184.4,253.1],[1186.4,249.8],[1188.8,247.4],[1191.6,246.3],[1194.6,246.5],[1197.3,247.6],[1199.7,249.4],[1201.8,251.7],[1208.5,261.5],[1205.4,262.7],[1203.8,267.2],[1203.8,273.4],[1202.4,275.6],[1197.7,279.1],[1184.5,286.7],[1183.2,288.1],[1182.9,290.2],[1183.6,292],[1185.7,294.5],[1187.8,295.9],[1191.4,297.1],[1195.2,299],[1199,301.9],[1201.5,304.5],[1205.1,309.5],[1206.9,311.1],[1210.1,312.8],[1215.6,313.6],[1221,313],[1231.6,310.4],[1235.6,309.8],[1239.3,309.6],[1248.8,310.3],[1250.2,311.9],[1250.6,317],[1251.5,321.4],[1252.4,322.9],[1253.3,323.4],[1255.7,323.4],[1261.7,321.9],[1265.7,322],[1269.2,323.9],[1272.5,327.9],[1274.7,329.4],[1280.2,331.8],[1281.7,332.8],[1282.1,333.5],[1287.2,334.9],[1296,335.8],[1302.2,336],[1307.1,335.5],[1313.3,334.2]]]},\"kastamonu\":{\"paths\":[\"m767.61,289.61h-.01c-6.24-4.27-23.21-7.18-27.41-6.56-4.47.66-3.02,3.74-12.27-.66-9.25-4.4-13.87-15.19-23.78-17.84-9.91-2.64-11.45,1.55-15.49,9.47-4.04,7.93-25.96,8.75-28.1,9.75-2.15.99-11.21.77-13.65,1.43-2.45.65-4.26,1.44-7.38,1.21-3.12-.24-4.96-3.3-6.33-2.64-1.38.66-5.67,1.48-8.42-.66-2.76-2.15-8.43-2.59-8.32.38s-3.52,9.25-7.15,10.46c-2.83.94-3.47,3.19-3.61,4.14-1.56-.69-4.08-1.01-6.25-1.85-2.82-1.09-5.82-9.5-6.35-11.03.02,0,.03-.01.05-.01,1.49-.33,1.49-4.21.42-6.2-1.08-1.98,1.4-9.08,3.96-9.49,2.56-.41,7.43-.79,7.68-2.96.25-2.16-1.24-4.97,1.73-6.78,2.97-1.82,9.08.08,11.64,0,2.56-.09,9.91,3.09,14.12-.48,4.21-3.57,3.64-8.03,4.3-9.18.66-1.16,3.08-3.81,5.78-3.39,2.69.42,7.73-.72,8.86-2.15,1.13-1.43,3.38-6.38,2.83-7.73s-6.19-.85-8.31-1.21c-2.12-.36-5.39-.8-6.63-1.41-.73-.35-5.72-3.24-10.44-6.06,2.55-2.59,3.47-5.75,3.78-6.87.49-1.82,4.95-5.62,8.26-5.62s6.93-6.27,7.76-7.76c.82-1.48,8.09-5.78,11.56-6.44,3.46-.66,10.23-5.28,12.38-7.92,2.15-2.65,13.27-6.83,14.92-8.81,1.03-1.24,10.9-4.29,18.81-6.65.68,3.94,1.76,9.08,2.99,10.83,2.09,2.97.88,4.74,3.19,8.59,2.31,3.85,8.04,5.17,7.71,10.13-.33,4.95-6.97,15.22,11.1,21.2,18.07,5.99,22.36-.29,30.4,8.9,4.3,4.92,7.37,8.63,9.04,11.9,0,0,.03,0,.09,0,.02,0,.05-.01.07-.01h.01c1.34,2.76,1.66,5.48.92,8.11-1.65,5.83,1.21,9.58,2.64,13.98,1.43,4.4,7.47,15.2-7.1,17.9Z\"],\"label\":[688,234],\"bbox\":[593,178,777,298],\"geoNeighbors\":[\"ankara\",\"eskisehir\",\"sakarya\",\"samsun\",\"sivas\"],\"poly\":[[[767.6,289.6],[761.3,286.7],[749.1,283.7],[740.2,283.1],[734.7,284.7],[730.9,283.7],[724.6,280.5],[710.7,267.8],[707.6,265.9],[704.1,264.6],[700.8,263.9],[698.1,263.8],[695.9,264.3],[694.2,265.3],[691.4,268.8],[687.7,275.4],[686.4,276.7],[682.9,278.7],[673.9,281.5],[657.9,284.3],[648.1,285],[643.5,286.1],[639.5,286.4],[637.4,285.8],[634.3,283.9],[629.5,284.5],[627.1,284.2],[622.3,281.8],[618.3,281.5],[616.7,282.5],[615.9,286.2],[614.3,289.4],[612,292.2],[607.6,294.9],[606.5,296],[605.7,298.1],[599.4,296.2],[597.3,294.3],[595.4,290.9],[593.1,285.2],[594,284.4],[594.3,282.7],[594.2,280.8],[593.3,278],[593.4,276.7],[594.2,273.7],[595.7,270.9],[596.6,270],[602.2,268.7],[604.9,267.3],[605.4,261.3],[606.9,259.8],[609.6,259],[619.7,259.9],[625,260.8],[629.1,260.9],[631,260.3],[632.7,259.3],[635,256.5],[636.2,253.8],[637,250.1],[639.1,247.8],[640.8,246.9],[647.8,246.3],[650.1,245.6],[651.6,244.6],[653.7,240.7],[654.4,238.4],[654.5,236.8],[654,236.4],[646.2,235.6],[640.8,234.6],[629.1,228.2],[631.8,224.2],[633.2,220.5],[635.9,217.8],[638.5,216.3],[642.4,215.4],[643.6,214.7],[645.9,212.3],[648.9,207.9],[650.5,206.4],[657.3,202.5],[661.9,201],[667.1,198.3],[670.5,195.8],[674,192.5],[685,186.6],[688.5,184.2],[694.6,181.8],[706.5,178.1],[708.6,187],[710.6,191],[711.6,195],[712.7,197.5],[719.7,204.5],[720.3,205.9],[720.4,207.6],[719,214.9],[719.1,217.9],[720,220.8],[722.1,223.7],[725.9,226.4],[728.4,227.7],[734.8,229.8],[742.8,231.5],[753.6,232.5],[756.3,233.3],[759.1,235],[761.9,237.7],[767.4,244.3],[771.1,249.6],[772.4,253.7],[771.6,261.8],[772.2,265.3],[776.3,276],[777.2,281.3],[776.6,283.9],[775.1,286.3],[772.2,288.3],[767.6,289.6]]]},\"adana\":{\"paths\":[\"m824.91,514.9c-.57,2.56-.99,6.11-.33,8.59.25.95-.92,2.51-2.46,4.08-1.12-.61-1.97-1.05-2.33-1.16-1.43-.44-4.51-2.81-6.11-4.02-1.59-1.21-3.79-1.98-6.88-1.93-3.08.06-9.19,3.58-10.35,4.35-1.15.77-13.92,11.34-13.92,11.34,0,0-8.59,8.75-9.8,9.69-1.21.93-.99,3.8-1.05,5.39-.05,1.6-3.68,3.09-4.45,3.86-.78.77-2.48-.83-3.91-1.43-1.43-.61-5.23,2.2-6.11,3.63s-3.64,1.87-5.51,3.63c-1.87,1.76-7.92,2.2-9.52,2.26-1.6.05-4.29-.94-4.84-.33-.56.6-5.07,1.7-6.67,2.09-1.59.39-7.65-.17-8.86.39-1.21.55-1.43,1.76-3.52,1.7-2.09-.05-4.18-.44-6.55.06-2.37.49-7.29,2.89-9.61,3.38-2.31.5-3.3-2.39-5.53-3.05-.38-.11-.75-.21-1.11-.29-.16-2.47-.03-4.72.78-5.74,1.9-2.4,2.59-9.72,2.42-11.2-.16-1.49.45-4.65.45-4.65,0,0,3.7-1.08,5.06-.91,1.36.16,3.3-.04,5.2.29,1.9.33,3.38-1.78,4.91-2.03,1.53-.24,5.66-.37,6.9-.82,1.24-.46,1.44-3.68,1.69-4.4.25-.72,1.49-1.55,2.56-.6s2.85.83,3.1-.78c.24-1.61-4.3-4.05-5.66-4.5-1.36-.46-3.36-2.55-3.59-3.26-.23-.72-1.53-3.59-2.69-5-1.15-1.4-.7-2.68-.28-3.01.41-.33,2.51-.83,3.71-1.24,1.2-.41,3.8-.19,5.56.25s2.75-2.42,4.18-4.09c1.44-1.66,4.74-4.5,8.7-5.82,3.96-1.32,9.36-2.64,12.88-3.08,3.53-.43,6.5-.22,9.07-1.97,2.57-1.75,4.25-1.78,8-2.99,3.74-1.21,8.8-4.51,12.11-5.83,3.3-1.32,12-7.27,13.15-8.51.14-.15.21-.34.23-.59h0c2.02-.55,5.9-1.57,8.19-2.11,2.35-.54,7.07-.76,9.75-1.09,1.98,5.86,6.03,9.24,6.03,11.97s1.65,7.15,5.53,9.77c3.88,2.61,2.06,7.15,1.48,9.71Z\"],\"label\":[764,532],\"bbox\":[696,483.5,826,570.5],\"geoNeighbors\":[\"antalya\",\"konya\",\"maras\",\"sivas\"],\"poly\":[[[824.9,514.9],[824.3,519.2],[824.5,524.3],[822.1,527.6],[818.5,525.8],[813.7,522.4],[810.8,521],[809,520.6],[805.5,520.6],[800.9,522.4],[796.1,525.1],[782.5,536.2],[772.7,545.8],[772.1,546.9],[771.7,551.2],[771.1,552.4],[767.2,555.1],[766.5,555.3],[763.3,553.7],[761.9,553.8],[758.3,556],[756.2,558.2],[750.8,561.5],[746.8,562.7],[742.2,563.2],[738.1,562.7],[730.7,564.9],[722.5,565.2],[719.6,566.9],[711.7,567.1],[702.1,570.5],[700.6,570.3],[698.1,568.2],[695.5,567.1],[695.8,562.4],[697.5,558.8],[698.3,555.4],[699.1,545.5],[702.8,544.7],[710.8,544.8],[714.3,542.9],[721.2,542.1],[722,541.3],[722.9,537.7],[723.9,536.7],[724.6,536.7],[726.4,537.6],[727.3,537.6],[728.1,537.2],[728.6,536.3],[728,535],[726.3,533.6],[721.8,531.2],[719.8,529.3],[716,522.5],[715.9,521.6],[716.3,520.5],[721.2,519.1],[725.6,519.5],[726.8,519.3],[731.2,514],[735.7,510.9],[738.5,509.6],[748.4,507],[758.4,505.6],[762.2,503.5],[771.4,500.3],[783.8,494],[791.6,488.9],[793.7,487.2],[793.9,486.7],[802.1,484.5],[811.9,483.5],[813.6,487.4],[817.2,493.2],[818.2,497.7],[819.2,500.3],[820.9,502.9],[824.6,506.3],[825.4,507.4],[825.8,510.1],[824.9,514.9]]]},\"isparta\":{\"paths\":[\"m670.73,502.05s-3.85,1.79-7.57,5.67c-3.71,3.88-3.63,4.38-12.96,4.71-9.33.33-38.97-6.61-46.79-8.21-7.82-1.59-12.61,1.77-15.91,3.36-3.3,1.6-19.71,6.88-26.32,8.75-6.62,1.88-15.9-2.69-15.9-2.69,0,0-5.93-6.21-7.58-5.8-1.65.42-7.23-.2-7.67-1.58-.08-.25-.18-.48-.32-.68-.05-.08-.1-.16-.17-.23-.14-.17-.32-.32-.52-.43-.05-.03-.11-.06-.17-.09-.03-.01-.05-.02-.07-.03-.08-.03-.15-.06-.23-.08,2.34-1.21,4.12-7.18,5.83-11.5,1.87-4.74,4.18-9.03,3.96-13.37-.22-4.35,1.22-7.55,5.81-12.18,2.34-2.36,4.01-5.02,4.95-7.37,1.6-1.34,4.63-3.58,6.89-3.4,3.22.25,5.98,5.45,8.54,4.91s9.75-9.12,14-8.17c4.25.95,4.46,7.18,9.45,7.8,5,.62,8.55,1.78,10.24,4.42,1.69,2.64,3.54,13.43,10.8,16.18,7,2.65,12.01.07,22.53-2.43,0,.08,0,.16,0,.24.07,1,.34,1.84.97,2.3,2.2,1.6,6.11,2.97,8.97,3.03,2.86.05,9.47,1.59,11.23,2.04,1.76.44,12.99,7.12,14.97,10.26.83,1.32,1.83,2.97,3.03,4.57Z\"],\"label\":[600,487],\"bbox\":[529,453.5,671,516.5],\"geoNeighbors\":[\"antalya\",\"aydin\",\"konya\",\"kutahya\",\"usak\"],\"poly\":[[[670.7,502.1],[665.9,505.2],[660.9,510],[658.8,511.4],[655.6,512.1],[648.2,512.4],[640.1,511.5],[626.2,509],[603.4,504.2],[598.1,503.9],[593.8,504.7],[585.7,508.3],[575.6,511.9],[561.2,516.3],[558.6,516.8],[555.9,516.7],[550.7,515.7],[546.8,514.3],[545.3,513.6],[542.1,510.6],[538.5,508],[533.4,507.7],[531.2,507.1],[528.6,504.7],[530.2,503],[531.7,500.1],[537.1,486.4],[538.1,483.1],[538.5,476.8],[539.4,473.9],[541.3,470.9],[547.2,464],[549.1,460.3],[552.3,458],[554.2,457.2],[556,456.9],[558.3,457.8],[562.6,461.3],[564.5,461.8],[574.9,454.4],[576.8,453.7],[578.5,453.6],[581.1,455.2],[585,460.1],[586.3,461],[594.3,462.9],[596.6,464.1],[598.2,465.9],[602.9,476.4],[604.5,478.7],[606.5,480.7],[609,482],[611.6,482.8],[616.5,483.1],[621.6,482.2],[631.6,479.6],[631.8,481.2],[632.5,482.2],[636.8,484.2],[650.6,486.7],[652.7,487.2],[655.5,488.6],[660.1,491.3],[666.6,496.2],[670.7,502.1]]]},\"usak\":{\"paths\":[\"m549.68,454.94c.54,1.12.32,3.09-.58,5.36-.94,2.35-2.61,5.01-4.95,7.37-4.59,4.63-6.03,7.83-5.81,12.18.22,4.34-2.09,8.63-3.96,13.37-1.71,4.32-3.49,10.29-5.83,11.5h-.01c-.1-.03-.21-.05-.32-.07s-.23-.03-.35-.03c-.52-.02-1.13.1-1.86.37-2.36.89-5.78,7.11-7.81,6.56-2.04-.56-4.52-3.53-4.68-5.62-.17-2.09-1.98-5.78-3.36-6.88-1.38-1.1-5.2-3.22-6.85-4.46-1.65-1.24-5.29-1.32-5.45-3.55-.17-2.23-2.48-5.61-4.38-7.35-1.9-1.73-3.8-3.88-4.68-6.42-.88-2.55.94-6.07,1.38-7.72.44-1.66,5.34-2.43,7.21-4.39,1.87-1.95,4.29-3.54,4.95-4.97.67-1.43-2.5-2.95-3.74-4.85-1.24-1.9-2.09-4.07-1.1-5.89.99-1.83.33-6.55-.55-8.75-.88-2.2-3.85-4.73-6.11-5.52-2.26-.78-5.34-.64-6.99-3.4-1.65-2.75-3.85-6.27-5.4-8.34-1.54-2.08-6.6-2.33-9.13-1.78-2.54.55-3.42-.67-6.06-3.07-2.64-2.41-9.14-.13-11.78-.02-2.64.11-4.62-.44-5.89-3.55-1.27-3.11-4.06-2.83-6.31-3.62-2.25-.78-2.09-3.92-2.94-5.65-.81-1.68-5.18-1.65-5.47-1.65,0-.82-.12-1.67-.46-2.55-2.03-5.25-1.72-14.13,0-19.41,1.71-5.27,2.59-13.38,1.81-14.42-.79-1.03-2.27-4.7-2.65-6.19-.37-1.48-1.19-6.11-1.4-7.14-.21-1.03-2.72-6.63-2.72-6.63.87.38,1.63.51,3.05-.12,2.56-1.13,5.64,1.69,7.35,2.84,1.71,1.16,2.15,1.54,4.13,1.1,1.98-.44,4.46.58,7.76.75,3.3.16,3.14-.42,2.81,3.13-.33,3.55,1.65,4.13,3.71,4.13s2.73.74,5.86,6.19c3.14,5.45,3.89,5.45,5.54,6.03,1.65.58,6.02-1.32,7.01-2.64,1-1.32,2.73-2.4,6.03-1.98,3.31.41,7.64-2.56,8.3-2.64.61-.08,3.19.4,3.58.48.66,1.1,2.14,3.14,4.22,3.77,2.89.86,7.76-.33,10.16,3.63,2.39,3.96,4.05,6.17,3.96,9.71-.08,3.54.33,4.58,1.7,6.31,1.36,1.73,7.72,5.74,14.4,5.08,6.69-.66,9.58-4.63,14.54-7.68,4.95-3.06,12.22-4.54,13.78.49.89,2.85,2.37,5.53,2.58,8.49.17,2.26-.41,4.68-2.58,7.45-4.98,6.38-3.1,8.28-1.56,10.75,1.54,2.46,8.69,8.08,9.35,12.26.66,4.18-6.71,11.67-11.67,15.19-4.95,3.52-.88,12.18.22,14.46Z\"],\"label\":[523,429],\"bbox\":[425,347,561,511],\"geoNeighbors\":[\"aydin\",\"balikesir\",\"eskisehir\",\"isparta\",\"izmir\",\"kutahya\"],\"poly\":[[[549.7,454.9],[549.9,455.9],[549.6,458.7],[547.1,464],[541.3,470.9],[539.4,473.9],[538.5,476.8],[538.1,483.1],[537.1,486.4],[531.7,500.1],[530.2,503],[528.5,504.7],[526,505],[525.1,505.5],[519,511.5],[518.2,511.6],[516.6,510.7],[514,507.6],[513.1,504.1],[511.2,500.3],[510.2,499.1],[503.3,494.6],[498.5,492.4],[496.3,487.2],[490.8,480.8],[488.8,477.3],[488.6,475.2],[489,473.1],[490.5,469],[497.4,465.2],[502.3,460.2],[502.2,459.1],[498.6,455.3],[497.2,452.4],[497.1,450.9],[498,447.6],[497.9,445.2],[496.9,440.7],[495.9,439],[492.6,436.1],[485.3,433.4],[483.8,431.8],[478.4,423.4],[476.7,422.2],[474.3,421.6],[471.6,421.4],[467.7,421.7],[466.3,421.2],[462.1,417.9],[460.7,417.6],[457.4,417.6],[451.5,418.6],[448,418],[446.7,416.9],[444.4,413.3],[442.8,412.3],[439.3,411.4],[438,410.4],[436.3,405.8],[435.2,404.8],[430.9,404.1],[429.3,397],[429,391.9],[429.4,386.7],[432.2,373.3],[432.4,368.4],[430,363],[428.2,354.4],[425.4,347.8],[426.8,348.1],[430.5,347.4],[432.5,348.2],[437.8,351.6],[441.6,351.5],[450.5,352.6],[450.5,356.7],[451.5,358.9],[452.8,359.4],[455.6,359.8],[456.8,360.6],[462.8,369.9],[464.5,371.4],[465.7,371.8],[467.3,371.8],[469.4,371.2],[471.4,370.2],[474.8,367.5],[481.3,367],[487,364.6],[490.6,365],[492.2,367.1],[494.8,368.8],[500.1,369.5],[502.8,370.3],[505,372.4],[507.9,377.4],[508.7,379.7],[509.2,386],[510.6,388.5],[514,391],[520.1,393.3],[525,393.5],[529.4,392.5],[532.9,390.6],[539.6,385.9],[545.7,383.3],[549.6,383.2],[551.2,383.7],[552.5,384.7],[555.6,392.7],[555.9,396.6],[554.7,400.3],[550.8,406.3],[550.1,409.1],[550.7,411.2],[551.8,413],[559.6,422],[561.1,425.3],[561,427],[559,431],[553.5,437.2],[548,442],[547.3,443.9],[547.3,448.2],[549.7,454.9]]]},\"kutahya\":{\"paths\":[\"m638.31,407.56c-.44,2.76-.99,9.15,1.43,12.23,2.42,3.08,4.93,13.7,5.01,15.19.08,1.48-.66,3.19-5.07,5.06-4.4,1.87-3.9,2.75-3.24,5.62.66,2.86,1.87,9.85,1.1,11.94-.77,2.09-2.2,6.5-5.29,9.41-1.59,2.43.28,4.79.28,6.06,0,.87-1.05,4.1-.98,6.54-10.52,2.5-15.53,5.08-22.53,2.43-7.26-2.75-9.11-13.54-10.8-16.18-1.69-2.64-5.24-3.8-10.24-4.42-4.99-.62-5.2-6.85-9.45-7.8-4.25-.95-11.44,7.63-14,8.17s-5.32-4.66-8.54-4.91c-2.26-.18-5.29,2.06-6.89,3.4.9-2.27,1.12-4.24.58-5.36-1.1-2.28-5.17-10.94-.22-14.46,4.96-3.52,12.33-11.01,11.67-15.19-.66-4.18-7.81-9.8-9.35-12.26-1.54-2.47-3.42-4.37,1.56-10.75,2.17-2.77,2.75-5.19,2.58-7.45-.07-1.06-.31-2.08-.63-3.09,4.9-1.41,12.18-3.44,18.01-4.76,9.74-2.21,15.98-10.13,29.93-8.15,13.94,1.98,20.11-1.76,29.57-4.4,6.33-1.77,11.28-2.24,16.17-2.39-.56,1.41-.44,3.06-.18,4.15.5,2.06,1.9,5.36-1.23,9.74-3.14,4.38-3.06,5.7-3.14,8.59-.08,2.89-5.67,10.29-6.11,13.04Z\"],\"label\":[598,430],\"bbox\":[547,372.5,649,483.5],\"geoNeighbors\":[\"eskisehir\",\"isparta\",\"konya\",\"usak\"],\"poly\":[[[638.3,407.6],[638,413.6],[638.4,417],[641.5,423.3],[643.8,430.3],[644.7,435],[644.6,436.1],[643.9,437.4],[642.3,438.7],[637.2,441.3],[636.2,442.5],[636,443.8],[637.5,451.9],[637.7,456.6],[635.8,462],[634.3,464.6],[632.2,467],[631.6,468.8],[632.5,473.1],[631.5,479.6],[621.6,482.2],[616.5,483.1],[611.6,482.8],[609,482],[606.5,480.7],[604.5,478.7],[602.9,476.4],[598.2,465.9],[596.6,464.1],[594.3,462.9],[586.3,461],[585,460.1],[581.1,455.2],[578.5,453.6],[576.8,453.7],[574.9,454.4],[564.5,461.8],[562.6,461.3],[558.3,457.8],[556,456.9],[554.2,457.2],[552.3,458],[549.1,460.3],[549.9,455.9],[547.3,448.2],[547.3,443.9],[548,442],[553.5,437.2],[557.4,433.1],[560.3,428.9],[561,427],[561.1,425.3],[559.6,422],[551.8,413],[550.7,411.2],[550.1,409.1],[550.8,406.3],[554.7,400.3],[555.5,398.4],[555.9,394.8],[555.3,391.7],[576.8,385.9],[586.7,381.3],[594,379],[598.3,378.5],[608.1,379.3],[616.2,379],[619.7,378.4],[637.3,373.3],[649,372],[648.6,374.2],[649.5,380.2],[649.1,382.9],[644.8,390.8],[644.4,394.5],[638.3,407.6]]]},\"eskisehir\":{\"paths\":[\"m665.83,357.91c-1.1,2.42-7.09,3.2-7.18,4.74-.01.18-.12.69-.2,1.04,0,.04-.02.09-.03.13,0,.01-.01.02-.01.03-.59,1.99-2.36,5.1-5.82,5.57-.23.03-.45.07-.66.12-1.61.39-2.51,1.37-2.96,2.5-4.89.15-9.84.62-16.17,2.39-9.46,2.64-15.63,6.38-29.57,4.4-13.95-1.98-20.19,5.94-29.93,8.15-5.83,1.32-13.11,3.35-18.01,4.76-.56-1.81-1.38-3.57-1.95-5.4-1.56-5.03-8.83-3.55-13.78-.49-4.96,3.05-7.85,7.02-14.54,7.68-6.68.66-13.04-3.35-14.4-5.08-1.37-1.73-1.78-2.77-1.7-6.31.09-3.54-1.57-5.75-3.96-9.71-2.4-3.96-7.27-2.77-10.16-3.63-2.08-.63-3.56-2.67-4.22-3.77.03.01.05.01.05.01,0,0,.04-.63.21-3.49.17-2.87,5.23-4.85,7.87-7.47,2.64-2.63,5.18-8.94,5.51-12.35.33-3.41-1.21-7.6-4.74-7.82-3.52-.22-7.59-5.83-9.74-6.82-2.15-.99-9.74-5.73-13.71-7.71-3.96-1.98-6.49-7.82-6.82-11.56-.33-3.74-5.18-9.47-5.96-11.58-.78-2.1.34-7.02.01-9.89-.16-1.37,1.37-3.67,3.01-5.7h.01c6.29-.46,13.25-.67,16.03.42,5.34,2.09,12.22-.83,14.77-.63,2.55.19,3.72,1.59,10.58,3.02,4.63.97,5.69-2.39,5.46-5,1.79-.05,3.92-.41,4.89-1.69,1.81-2.39,7.67-5.78,13.12-6.52,5.45-.74,15.44-2.39,16.93-3.47,1.49-1.07,8.01,1.74,9.99,5.87,1.98,4.12,6.52,10.98,11.73,10.65,5.2-.33,9.49-3.06,14.2.08,4.65,3.11,7.62,2.17,9.11,1.83.53,1.53,3.53,9.94,6.35,11.03,2.17.84,4.69,1.16,6.25,1.85.68.29,1.18.65,1.41,1.14.74,1.65.08,7.85,2.89,7.85s8.01-3.06,9.82-1.74c1.82,1.32,3.12,1.17,4.63-.16,1.5-1.34,7.59,1.07,12.46,1.24,4.88.16,6.47.08,8.56-.25,2.1-.33,5.48,2.41,5.98,6.12.49,3.7,7.34,4.53,6.19,9.15-1.16,4.63-.34,6.11.66,7.8.99,1.7,1.27,3.79,3.69,6.65,2.42,2.87,3.75,10.9,3.03,13.22-.72,2.31,1.92,6.38.82,8.8Z\"],\"label\":[565,330],\"bbox\":[463.5,266.5,666.5,393.5],\"geoNeighbors\":[\"ankara\",\"balikesir\",\"izmit\",\"kastamonu\",\"konya\",\"kutahya\",\"sakarya\",\"usak\"],\"poly\":[[[665.8,357.9],[664.3,359.5],[658.9,362.1],[657.7,365.5],[656.6,367.2],[654.9,368.6],[650.9,369.9],[649,372],[637.3,373.3],[619.7,378.4],[616.2,379],[608.1,379.3],[598.3,378.5],[594,379],[586.7,381.3],[576.8,385.9],[555.3,391.7],[552.5,384.7],[551.2,383.7],[547.7,383.1],[543.6,383.9],[539.6,385.8],[532.9,390.6],[529.4,392.5],[527.4,393.1],[522.5,393.6],[520.1,393.3],[515.8,391.9],[511.4,389.2],[509.8,387.2],[509,384.4],[508.7,379.7],[507.9,377.4],[504,371.2],[502.8,370.3],[500.1,369.5],[494.8,368.8],[492.2,367.1],[490.6,365],[490.8,361.6],[491.8,359.5],[498.7,354.1],[500.6,351.5],[502.3,348.2],[504.2,341.7],[504.1,339.1],[503.3,336.6],[501.8,334.7],[496.8,332.9],[490.6,327.7],[476,319.4],[473.3,317.3],[471.3,314.3],[469.9,310.9],[468.2,304.7],[463.3,296.2],[463,294.2],[463.4,285.2],[466.3,280.7],[475.6,280.3],[479.5,280.5],[486.5,281.8],[497.1,280.4],[507.7,283.5],[510.5,283.5],[512.2,282.3],[513,280.5],[513.1,278.5],[517.1,277.6],[520.1,274.8],[523.2,272.9],[527,271.2],[543.5,268.2],[548.8,266.6],[551.4,267.1],[555.9,269.8],[557.1,271.2],[560,276.1],[562.7,279.6],[566,282.4],[567.9,283.1],[569.8,283.3],[577.1,282],[580.5,282],[582.2,282.5],[587.2,285],[589.7,285.6],[593.1,285.2],[595.4,290.9],[598.4,295.5],[599.4,296.2],[605.7,298.1],[607.1,299.2],[607.8,303.8],[608.5,306.1],[609.1,306.8],[610,307.1],[612.5,306.6],[617.9,305.1],[619,305],[622.2,306.3],[625.2,304.8],[626.3,304.8],[636.9,306.4],[645.5,306.2],[647.2,306.5],[649.1,307.7],[650.6,309.7],[651.9,313.6],[657.2,318.6],[657.7,319.9],[657.1,324.4],[657.6,328],[660.5,333.9],[662.8,337.2],[664.7,342.7],[665.8,357.9]]]},\"trabzon\":{\"paths\":[\"m1263.56,233.68c-14.65,3.88-31.95,8.18-34.06,18.98-2.64,13.55-4.62,13.66-9.46,14.21-4.84.55-8.04-.44-11.57-5.4-3.52-4.95-8.58-16.07-16.84-15.19s-11.12,20.15-13.32,20.92-7.6-2.76-11.23-1.98c-3.63.77-9.91,4.73-13.54,3.19-3.64-1.54-1.21-12.44-4.7-13.57-3.49-1.12-10.5-1.4-16.99,4.32-6.5,5.72-20.15,11.12-31.21,15.43-11.06,4.32-21.58-8.05-23.07-4.79-1.48,3.27,0,16.06-4.12,20.24-4.13,4.19,1.32,15.14-2.48,20.75-3.8,5.62-21.47,3.97-29.87.73-8.4-3.23-16.54-6.34-23.46-7.23-6.92-.89-14.99.28-14.99.28-1.37-1.92-4.1-4.08-7.53-6.77-5.62-4.4-5.62-9.8-6.5-13.76-.88-3.96-3.52-7.49-3.74-9.58-.04-.34-.1-.74-.2-1.19-.46-2.32-1.61-6.12-3-11.47-1.65-6.38-.66-11.56,1.33-15.19.48-.89.96-2.62,1.41-4.74,2.15.42,7.07.11,9.76,1.22,2.81,1.15,6.11,1.4,8.17,1.24,2.07-.17,5.62-2.98,7.1-3.47,1.49-.5,5.21.58,6.36,0,1.16-.58,4.54-3.14,6.69-3.64,2.15-.49,1.57-1.81,3.8-2.06s7.46.11,9.33-1.21c1.87-1.32,2.2-1.76,3.52-1.43,1.32.33,3.63,2.86,6.39,2.2,2.75-.66,5.06-4.4,7.7-3.63,2.65.77,4.63,3.08,7.38,5.61,2.75,2.53,7.93.99,10.02,1.76,2.09.77,4.18,3.09,6.38,2.98,2.21-.11,5.73-.33,9.25,1.54,3.52,1.87,10.24-.99,12.22-3.2,1.98-2.2,6.17-3.85,9.36-3.85s7.93-1.65,10.02-3.08c2.09-1.43,5.5-5.95,8.69-6.39,3.2-.44,9.58-2.75,11.34-4.4,1.77-1.65,11.56-8.15,15.97-10.35,2.65-1.33,5.25-4.47,6.88-6.76.07-.09.13-.17.19-.25.02-.04.05-.08.08-.12.13-.19.25-.36.36-.53.42-.61.73-1.1.92-1.41.04-.06.07-.11.1-.16.02-.03.04-.05.05-.08.03-.03.05-.06.07-.09.31.08,6.75,1.98,8.25,2.46,1.54.5,4.9,1.93,6.93,2.76,2.04.82,3.69-2.42,5.62-3.91,1.92-1.49,2.03-1.6,4.18-.66,2.15.93,2.64.44,6.11.27,3.47-.16,4.4.77,6.66,1.05,2.26.27,3.19.94,6.44,1.82,3.25.88,4.02,1.98,6.22,1.7,2.2-.27,1.32-2.81,2.97-3.58,1.66-.77,1.82-5.72,2.37-6.6.55-.88,5.07-.88,8.09-.33,3.03.55,4.21.88,2.98,3.44-1.24,2.56.24,4.46,2.8,4.54,2.56.08,2.31-1.57,4.38.83,2.06,2.39,3.8,6.11,5.61,7.22,1.82,1.12,1.57,2.06,5.33,3.22,3.76,1.16,1.94,3.55,1.98,4.42.04.87,2.31,4.83,3.3,4.75.99-.09,6.9-.95,8.43-.75,1.52.21,2.62,4.48,2.24,5.91-.2.74-.08,1.81.15,2.81Z\"],\"label\":[1122,253],\"bbox\":[980.5,197,1263.5,315],\"geoNeighbors\":[\"erzurum\",\"gyumri\",\"kars\",\"samsun\",\"sivas\"],\"poly\":[[[1263.6,233.7],[1252.4,236.8],[1241.8,240.6],[1237.3,242.9],[1233.7,245.7],[1231,248.9],[1230.1,250.7],[1227.6,260.5],[1226.6,263],[1225.6,264.6],[1223.2,266.3],[1216.7,267],[1213.8,266.2],[1211.1,264.5],[1209.8,263.1],[1201.8,251.7],[1199.7,249.4],[1197.3,247.6],[1194.6,246.5],[1191.6,246.3],[1188.8,247.4],[1186.4,249.8],[1184.4,253.1],[1179.2,266.1],[1178.3,267.2],[1176.1,267.1],[1168.5,265.1],[1167.1,265.2],[1156.7,268.7],[1153.5,268.4],[1152.4,267.4],[1151.8,265.8],[1150.5,257.2],[1149.9,255.7],[1148.8,254.8],[1147.4,254.5],[1143.6,254.2],[1139.2,255],[1136.8,255.9],[1134.3,257.3],[1129.1,261.3],[1122,265.4],[1109.3,271.2],[1098.6,275.2],[1096.5,275.5],[1092.6,275.2],[1088.9,274.1],[1080.2,269.8],[1078,269.4],[1077.1,271.4],[1075.6,285.6],[1074.7,288.1],[1072.3,291.9],[1071.9,294.3],[1072.4,305.8],[1072,308.5],[1071,310.8],[1068.9,312.6],[1065.9,313.7],[1062.1,314.3],[1053.2,314.2],[1044.6,312.6],[1028.8,307],[1023,305.3],[1017.6,304.3],[1012.4,304],[1002.7,304.6],[999.7,301.5],[993.3,296.1],[991.9,294.4],[990.1,290.8],[988.6,284],[984.9,274.5],[981.7,261.8],[980.9,257.2],[981,253.2],[981.7,249.6],[983.7,244.7],[984.4,241.9],[991.8,242.5],[998.5,244.2],[1002.4,244.3],[1004.1,243.8],[1009.5,240.9],[1015.8,240.9],[1026.3,235.2],[1033.7,234.7],[1038.3,232.4],[1043.6,234.7],[1045.5,234.7],[1051.3,231.2],[1052.3,231],[1055.1,231.9],[1060.6,236.7],[1063.1,237.9],[1070.6,238.5],[1075.4,241.1],[1083.7,241.9],[1087.7,243.5],[1089.4,243.6],[1093,242.9],[1096.2,241.5],[1100.3,238.3],[1102.7,237],[1105.3,236.2],[1110.5,235.6],[1115.9,233.9],[1117.9,232.9],[1124.2,227.4],[1132.8,224.7],[1137,222.7],[1144.9,217.1],[1155.8,210.4],[1157.7,208.7],[1162.5,202.3],[1170.8,204.8],[1178.4,207.7],[1180.6,206.4],[1183.3,203.6],[1185.3,202.4],[1188.9,203.4],[1193.6,203.2],[1197.4,203.6],[1203.1,205],[1211.5,207.8],[1212.9,207.8],[1214.1,207.2],[1215,205.1],[1216.9,203],[1218.3,197.6],[1219.3,197.1],[1221.4,196.9],[1226.4,197.3],[1229.4,198.3],[1229.8,199.2],[1228.9,202.5],[1229.3,203.9],[1230.4,204.9],[1232.1,205.3],[1235.3,205],[1236.5,206.1],[1240.8,212.1],[1242.1,213.3],[1245.3,215.7],[1249.4,217.6],[1249.8,218.9],[1249.4,221],[1249.8,222.1],[1252.3,225.6],[1260.4,224.9],[1261.7,225.2],[1263,227.5],[1263.4,229.4],[1263.6,233.7]]]},\"diyarbakir\":{\"paths\":[\"m1177.54,499.36c-6.6,2.14-7.74.13-13.27,2.5-5.78,2.47-6.77.16-11.72.49-4.96.33-8.43-.16-13.05-1.32-4.62-1.15-15.19-1.98-19.16.33-3.96,2.31-12.71,4.46-16.84,5.95-4.13,1.48-6.11,3.46-8.26,5.94-2.14,2.48-10.23,4.96-18.99,8.42-8.75,3.47-8.14,2.26-14.42,4.13-6.27,1.87-20.7,3.53-25.32,2.09-4.62-1.43-19.27-.6-20.92-1.04-1.65-.44-7.54-8.09-11.06-10.02-3.52-1.93-11.89-3.63-15.25-3.47-3.36.17-6.83,2.2-8.09,3.14-1.09.81-2.38,2.3-4.54,2.88-.67-3.21-1.74-6.1-1.79-7.23-.11-2.2-2.64-6.27-3.74-8.7-1.11-2.42-1.77-5.72-1.22-8.03.55-2.31,1.33-2.2.77-4.85-.55-2.64,1.37-5.63,3.97-8.69,1.72-2.04,3.29-2.83,3.32-3.58,7.78,3.27,18.53-3.61,23.24-3.77,4.7-.17,8.92-6.36,15.36-8.84,6.44-2.47,10.32-13.04,11.39-16.02,1.07-2.97,11.56-12.13,13.29-13.75,1.74-1.62,1.66-4.91-1.32-6.89-2.97-1.98-2.14-6.85-1.15-8.64.99-1.78,8.01-2.01,10.59-1.08,2.58.92,5.84-2.5,10.05-2.42,4.21.09,8.92-1.23,11.39-2.64,2.48-1.4,1.82-5.03,4.38-5.53,2.56-.5,3.96,1.32,5.28,2.23,1.32.91,17.48-.08,17.48-.08,0,0,6.14,1.21,8.71-2.59,2.58-3.8,5.82-7.54,11.44-7.1,5.61.44,12.71.99,18.77-2.48,6.05-3.47,8.42-4.95,11.17-3.91,2.75,1.05,2.37,5.29,5.51,8.81,3.13,3.52,3.8,2.31,7.21,2.09,1.31-.08,2.5-.12,3.5.04,1.61.25,2.76.99,3.16,2.82.66,2.98,3.47,11.73,2.48,15.28-.99,3.55-5.54,11.15-10.74,14.12-5.2,2.97-1.73,10.73,3.3,13.54,5.04,2.81,12.14,6.03,13.88,13.05,1.73,7.01,3.13,12.22-1.74,16.3-4.48,3.76-4.91,10.7,2.95,18.52Z\"],\"label\":[1090,480],\"bbox\":[970,394,1178,528],\"geoNeighbors\":[\"aleppo\",\"elazig\",\"erzurum\",\"maras\",\"van\"],\"poly\":[[[1177.5,499.4],[1173.5,500.3],[1167.7,500.8],[1160.7,502.9],[1154.2,502.3],[1145.9,502.2],[1135.1,500.3],[1129.7,499.9],[1122.1,500.6],[1116.6,503.1],[1100.8,508.5],[1098.6,509.9],[1094.2,514.2],[1092.6,515.1],[1073.4,522.8],[1069.5,524],[1055.9,527.1],[1048.6,528.1],[1041.5,528.4],[1031.5,527.2],[1015.6,526.9],[1013.7,525.4],[1007.5,519.1],[1004.5,516.8],[1001.1,515.5],[992.6,513.6],[989.3,513.4],[986.8,513.8],[982.5,515.6],[978.1,518.8],[976.7,519.4],[974.4,510.2],[971.1,503.5],[969.9,499.4],[969.7,497.3],[970.9,492.1],[970.7,488.5],[971.5,486.4],[974.6,481.9],[978,478.3],[981,479.1],[984.2,479.1],[987.5,478.6],[999.2,474.9],[1002.9,474.2],[1004.7,473.4],[1012.1,468.1],[1018.9,464.4],[1020.9,462.6],[1024.3,457.9],[1028.8,448.3],[1034.3,442.3],[1041.2,435.9],[1042.2,434.4],[1042.4,432.6],[1041.6,430.7],[1039,428.2],[1038.3,427.1],[1037.9,424.6],[1038.1,422.2],[1038.8,420.4],[1039.4,419.8],[1043.5,418.8],[1051.4,419.3],[1056.4,417.4],[1062.6,416.7],[1068.6,415.3],[1070.8,414.3],[1072.2,412.9],[1073.8,409.6],[1075.2,408.7],[1076.9,408.7],[1080.5,411],[1081.6,411.2],[1101.3,411],[1104.2,410.3],[1105.5,409.5],[1108.7,405.5],[1111.2,403.1],[1114.3,401.6],[1116.1,401.2],[1127.3,401.4],[1132.2,400.6],[1134.5,399.8],[1143.7,395.1],[1146,394.5],[1148,394.8],[1148.9,395.3],[1149.6,396.1],[1151.7,400.9],[1153.5,403.6],[1155.5,405.4],[1157,406],[1160.8,405.7],[1165.4,406],[1167,407.4],[1167.4,408.6],[1170,420.4],[1169.9,423.8],[1168.5,427.1],[1166.1,431.1],[1162.9,435],[1157.6,439.3],[1156.8,440.9],[1156.6,442.8],[1157.8,446.8],[1160.7,450.2],[1170.6,456.4],[1174.1,459.9],[1175.4,462.1],[1177.5,469.5],[1177.9,473.8],[1177.7,475.7],[1176.1,479.3],[1173.1,482.4],[1172.1,484.2],[1171.5,486.3],[1171.4,488.6],[1172,491.1],[1173.1,493.7],[1175,496.5],[1177.5,499.4]]]},\"hatay\":{\"paths\":[\"m903.23,557.8c-2.23-.5-3.34-.5-4.29.25-.95.74-1.57,1.61-3.39,1.11s-2.85,2.93-2.72,5.41c.12,2.48-.27,8.41-2.08,8.3-1.82-.11-3.36.93-3.85,2.06-.5,1.13-3.25,1.6-4.11,1.98-.85.39-1.29,4.1-1.4,5.56-.11,1.46-1.43,1.16-1.87.39s-1.76-1.82-2.73-1.76c-.96.05-2.39-.06-3.27-.39-.88-.33.3-3.11-.19-3.69-.5-.58-1.82.09-1.96.2-.14.11-1.76.77-2.9.77.15-.27.28-.72.44-1.3.03-.12.06-.24.09-.35.01-.04.02-.08.03-.13.3-1.15.68-2.68,1.34-4.33,1.11-2.81.12-3.84-.5-5.5-.62-1.65-2.41-4.41-4.33-7-1.93-2.59-2.81-5.28-3.03-6.39-.22-1.1,2.53-2.36,3.03-3.57.49-1.21,2.25-3.25,3.02-4.19.78-.93,3.31-1.76,4.08-2.97.77-1.21,3.71-3.87,8.3-6.3,4.58-2.44,2.64-8.67,2.64-12.02s-3.14-6.81-6.4-9.7c-3.26-2.89-6.23.5-7.23,2.03-.28.43-.67.92-1.15,1.44-.68-1.87-1.19-4.7.7-6.83,3.08-3.46,11.1-9.13,22.64-2.91,9.34,5.03,13.43,7.11,16.31,11.74-1.53.96-2.45,3.44-2.99,3.99-.79.78.41,2.76-.54,3.55-.95.78.03.2-1.51,3.84-1.54,3.63-.18,13.58-.3,15.31-.13,1.74,1.9,4.71,3.34,4.96,1.45.25,1.03,1.57,2.02,4.25.99,2.68-3.01,2.68-5.24,2.19Z\"],\"label\":[884,550],\"bbox\":[863,505,909,583],\"geoNeighbors\":[\"aleppo\",\"maras\"],\"poly\":[[[903.2,557.8],[900.6,557.5],[898.9,558.1],[897.6,559.1],[894.3,559.4],[893.5,560.7],[892.9,562.6],[892.5,569.7],[891.9,572],[891.4,572.6],[888.3,573.4],[886.2,575.7],[882.8,576.9],[881.8,579.3],[881.1,583.3],[880,583.3],[878.4,581.7],[876.8,581.1],[873.5,580.7],[873.2,580.1],[873.3,577],[872.8,576.8],[868.5,578],[870.8,570.1],[870.8,568.7],[869.2,565],[864.3,557.4],[862.5,553],[862.8,552.1],[864.8,550.3],[868.6,545.2],[872.6,542.3],[875.4,539.6],[882.4,534.9],[883.3,533.5],[884,530.3],[883.6,523.9],[883,521.4],[881.6,518.9],[877.2,514.2],[874.8,513.1],[872.7,513.6],[871,514.9],[868.8,517.7],[868.2,514.4],[868.5,512.6],[869.5,510.9],[872.7,508.1],[877.6,505.8],[880.7,505.2],[884.2,505.3],[888,506.2],[892.1,508],[902.7,514],[906,516.6],[908.5,519.7],[907.4,520.7],[905.5,523.7],[904.9,527.2],[904.5,527.7],[903,532.7],[902.7,539.5],[903.4,547.9],[905.3,550.7],[907.2,551.8],[908.6,556.5],[908.4,557.2],[907.1,557.9],[903.2,557.8]]]},\"maras\":{\"paths\":[\"m974.64,481.88c-2.6,3.06-4.52,6.05-3.97,8.69.56,2.65-.22,2.54-.77,4.85-.55,2.31.11,5.61,1.22,8.03,1.1,2.43,3.63,6.5,3.74,8.7.05,1.13,1.12,4.02,1.79,7.23-.35.09-.73.16-1.13.2-2.86.28-8.37,4.02-9.74,4.57-1.38.55-4.68-.16-6.72.55-2.04.72-5.61,3.19-6.99,4.35-1.38,1.16-1.87,2.04-3.63,2.37-1.77.33-4.52-.5-7.16-1.6-2.64-1.1-9.56-.84-10.39-.38-.83.45-1.98,1.32-3.14,1.32s-1.52-2.6-1.03-4.13c.5-1.53-1.4-1.61-2.06-2.97-.66-1.37-1.82-.83-2.93-1.33-1.12-.49-3.06-.82-4.63-.86-1.57-.04-3.18-.25-6.23-1.82-.94-.48-1.74-.36-2.42.06-2.88-4.63-6.97-6.71-16.31-11.74-11.54-6.22-19.56-.55-22.64,2.91-1.89,2.13-1.38,4.96-.7,6.83-1.23,1.33-3.05,2.92-5.12,4.46-2.89,2.15-6.67,1.38-8.38,1.71-1.71.33-1.24,1.76-1.38,2.28-.14.52,1.08,1.46,2.04,2.15.96.68-.25.96-1.87,1.1-1.63.14-.94,1.04-.64,2.5.31,1.46-1.78,3.31-3.05,3.58-1.27.28-3.41-.77-3.85-.94-.44-.16-5.01.33-6.94,1.82-1.93,1.49-5.34-1.26-7.05-2.48-1.28-.91-7.05-4.44-10.44-6.32,1.54-1.57,2.71-3.13,2.46-4.08-.66-2.48-.24-6.03.33-8.59.58-2.56,2.4-7.1-1.48-9.71-3.88-2.62-5.53-7.05-5.53-9.77s-4.05-6.11-6.03-11.97h0c-1.98-5.87.66-8.68,2.14-10.57,1.49-1.9-1.15-6.44-1.03-7.97.13-1.53,1.28-3.64,2.73-3.26,1.44.37,5.05.22,5.6.16.55-.05,3.77-.52,4.35-1.04.57-.53,5.2-5.4,5.89-5.7.68-.3,2.39-.41,6.79.03,4.41.44,10.71,2.69,12.33,3.44,1.63.74,3.56-.53,4.46-1.52.91-.99-.9-9.74-.57-11.39.33-1.65,3.88-3.3,5.61-4.3,1.73-.99,14.16-10.98,15.19-12.55,1.04-1.56,3.88-7.76,5.91-11.89,2.02-4.12,8.83-6.27,11.32-5.78,2.49.5,4.32,5.7,6.43,7.85,2.1,2.15,4.29-2.02,6.56-3.3,2.27-1.28,2.69-7.31,4.38-10.94,1.69-3.64,6.85-3.65,8.92-3.95,2.06-.31,6.63.24,8.06,1.45,1.43,1.22,4.71.61,6.83.61s7.42-.93,7.42-.93c-2.77,1.6-2.77,3.21-2.66,5.55.11,2.43.55,3.64,2.64,3.64s19.6,4.73,22.35,8.58c2.75,3.86,1.65,13.55-1.65,18.5-3.31,4.95-5.18,11.69-7.16,14.37-1.98,2.69-2.97,5.26-5.28,6.9-2.31,1.63-4.08,8.23,1.65,11.1,5.72,2.86,8.04,4.62,11.45,3.74,3.41-.88,11.27,1.21,14.11,2.75.95.52,1.34.89,1.32,1.27-.03.75-1.6,1.54-3.32,3.58Z\"],\"label\":[895,469],\"bbox\":[811.5,401,978.5,537],\"geoNeighbors\":[\"adana\",\"aleppo\",\"diyarbakir\",\"elazig\",\"hatay\",\"sivas\"],\"poly\":[[[974.6,481.9],[971.5,486.4],[970.7,488.5],[970.9,492.1],[969.7,497.3],[969.9,499.4],[971.1,503.5],[974.4,510.2],[976.7,519.4],[973,520.3],[965.8,524.2],[959.1,524.7],[955.3,526.7],[949.6,531.1],[946.9,531.5],[940.1,529.5],[935.4,529],[931.5,529.3],[927.8,530.8],[927,530.3],[926.6,529.3],[926.7,525.7],[924.1,522.9],[919.6,521.7],[914.5,521.1],[909.6,519.3],[908.5,519.7],[906,516.6],[902.7,514],[892.1,508],[888,506.2],[884.2,505.3],[880.7,505.2],[877.6,505.8],[875,506.8],[872.7,508.1],[869.5,510.9],[868.5,512.6],[868.2,514.4],[868.8,517.7],[863.7,522.2],[861.4,523.3],[855.3,523.9],[854.4,524.3],[854,524.9],[854,526.6],[856.3,528.7],[853.3,529.7],[853.3,533],[851.5,535],[849.3,535.5],[845.6,534.6],[841.4,535.4],[838.8,536.7],[837.9,536.8],[836,536.1],[822.1,527.6],[824.5,524.3],[824.3,519.2],[825.8,510.1],[825.4,507.4],[824.6,506.3],[820.9,502.9],[819.2,500.3],[818.2,497.7],[817.7,494.4],[813.6,487.4],[811.9,483.4],[811.2,479.6],[811.6,476.7],[814.4,472.1],[814.5,471],[813,464.9],[813.9,462.6],[814.7,461.8],[821.3,461.8],[824.8,461.1],[825.7,460.8],[831.6,455.1],[832.3,454.9],[838.3,455.1],[845.6,456.7],[850.7,458.5],[851.9,458.8],[853.2,458.4],[855.1,457],[855.4,456.3],[854.5,446.6],[854.6,445.6],[855.3,444.4],[863.1,439.2],[874.5,429.7],[876.4,426.8],[881.3,416.9],[883.5,414.2],[886.8,412.3],[890.1,411.2],[892.6,411.1],[894.3,412.2],[899,419],[900.6,419.5],[902.2,418.6],[906.4,415],[910,404.7],[910.7,403.5],[911.8,402.6],[914.3,401.5],[920.8,400.7],[925.4,401.4],[928.3,402.8],[930.1,403],[935.8,402.7],[941.2,401.9],[939.6,403.1],[938.8,404.4],[938.5,405.8],[938.7,409],[939.1,410.2],[939.9,410.9],[948.4,412.8],[955.8,415.3],[961.9,418.2],[963.5,419.7],[964.4,421.4],[965.1,425.9],[965,428.5],[963.9,433.7],[955.5,451.4],[951,458],[948.6,460.3],[947.9,461.5],[947.2,464.5],[947.4,466.2],[948.1,467.8],[949.3,469.3],[957.7,473.8],[960.1,474.5],[965.8,474.1],[969.8,474.7],[976.6,477],[978,478.3],[974.6,481.9]]]},\"lesbos\":{\"paths\":[\"m376.48,362.94c-.87-1.07-2.07-2.14-2.86-2.77-.87-.7-3.38-1.81-3.34-3.92.07-3.67-2.39-5.74-5.33-6.15-2.93-.41-5.86,1.78-6.15,2.85-.29,1.07-4.38,2.81-9.04,2.72-4.67-.08-7.02,2.31-7.35,3.96s.45,3.88,2.02,5.74c1.57,1.86,8.17,3.39,9.74,3.1s2.44-3.3,4.87-5.53c2.44-2.23,4.05-1.82,5-1.28.95.54,1.4,1.94.21,3.06-1.2,1.11-5.57,3.43-7.18,4.21-1.61.78.74,4.38,2.19,4.58,1.44.21,3.51-.21,6.73,1.69,3.22,1.9,8.88,1.36,9.74,0,.87-1.36-1.61-3.05-1.86-5.08-.25-2.02,1.36-1.86,2.56-.83,1.2,1.03.78,3.22,1.73,4.33.95,1.11,2.64-.45,2.89-1.49.25-1.03-3.72-8.13-4.58-9.21Z\",\"m356.91,409.99c1.21-1.71.61-3.63-1.71-4.73-2.31-1.1-3.19-3.25-4.13-3.25s-2.64,1.71-4.46,1.27c-1.82-.44-5.83.88-4.51,3.52,1.32,2.64,6.77,6.99,6.99,9.36.22,2.37.39,5.34-2.26,6.06-2.64.72-5.17,2.26-2.09,5.23,3.08,2.97,3.8,3.25,6.8,2.64,3.34-.67,4.36-3.1,5.41-5.53,1.05-2.42,1.03-3.34.4-6.47,0,0-1.65-6.39-.44-8.09Z\",\"m320.42,305.34c-1.71.06-3.63,1.21-5.01,2.2-1.38.99-3.47.99-5.67.83-2.2-.17-4.24-1.16-7.43.39-3.19,1.54-1.87,8.37-.94,8.81s1.1-.44,1.82-.39,1.87,2.48,2.64,3.52c.77,1.05,2.86-.22,2.37-1.27s-.06-3.74.5-4.68c.55-.94,3.08-1.1,2.81.77-.28,1.87,1.27,4.29,2.53,5.78,1.27,1.49,2.26-.39,1.98-1.49-.28-1.1.5-4.18.5-5.72s3.14-5.72,3.14-5.72c1.2-1.71,2.48-3.08.77-3.03Z\"],\"label\":[356,360],\"bbox\":[300.5,305.5,381.5,430],\"geoNeighbors\":[\"balikesir\"],\"poly\":[[[376.5,362.9],[380.6,370.4],[381.1,372.1],[380.6,373],[379,374],[378.2,373.6],[376.4,369.3],[374.6,368.6],[374,369],[373.9,370.1],[375.8,374.1],[375.7,375.2],[374.3,376],[371.7,376.4],[368.7,376.2],[363.8,374.2],[359.3,373.5],[358.1,372.8],[357,371.4],[356.5,369.9],[357.1,368.9],[364.3,364.7],[364.9,363],[364,361.7],[362.1,361.3],[360.7,361.7],[359,362.9],[355.3,367.8],[354.2,368.5],[353.4,368.5],[349.3,367.7],[345.2,366],[343.4,363.9],[342.7,362.4],[342.4,359.6],[343,358.3],[344.5,357],[346.7,356],[353.1,355.4],[355.9,354.7],[357.9,353.8],[360.9,351],[362.8,350.2],[365,350.1],[367,350.7],[368.7,352],[369.9,353.8],[370.7,357.7],[376.5,362.9]],[[356.9,410],[356.5,412],[357.8,421.6],[357,424.6],[355.1,428],[353.6,429.3],[351.5,430.1],[348.2,430.1],[344.7,427.5],[343.8,426.4],[343.4,424.7],[343.6,424],[345,422.9],[348.3,421.3],[349,419.8],[349.1,416.2],[348.1,414.1],[342.8,407.9],[341.8,405.9],[342,405.1],[343.2,403.9],[345,403.3],[347.9,403.3],[351.1,402],[356.6,406.2],[357.4,407.4],[357.5,408.7],[356.9,410]],[[320.4,305.3],[321.2,305.6],[321.1,306.2],[318.1,310.7],[316.5,314.1],[316,320.7],[315.6,321.5],[314.9,321.9],[314,321.3],[312.2,318.6],[311.3,314.5],[310.4,314.1],[308.7,314.7],[308.1,317],[308.1,320.2],[307.5,320.9],[306.6,321.1],[305.8,320.7],[303.2,317.2],[301.9,317.7],[301,317.1],[300.3,313.6],[300.7,310.7],[301.3,309.6],[302.3,308.8],[304.5,308],[306.4,307.9],[312.9,308.4],[314.3,308.1],[317.8,306.1],[320.4,305.3]]]},\"konya\":{\"paths\":[\"m793.93,486.64h0c-.02.26-.09.45-.23.6-1.15,1.24-9.85,7.19-13.15,8.51-3.31,1.32-8.37,4.62-12.11,5.83-3.75,1.21-5.43,1.24-8,2.99-2.57,1.75-5.54,1.54-9.07,1.97-3.52.44-8.92,1.76-12.88,3.08-3.96,1.32-7.26,4.16-8.7,5.82-1.43,1.67-2.42,4.53-4.18,4.09s-4.36-.66-5.56-.25c-1.2.41-3.3.91-3.71,1.24-.42.33-.87,1.61.28,3.01,1.16,1.41,2.46,4.28,2.69,5,.23.71,2.23,2.8,3.59,3.26,1.36.45,5.9,2.89,5.66,4.5-.25,1.61-2.03,1.73-3.1.78s-2.31-.12-2.56.6c-.25.72-.45,3.94-1.69,4.4-1.24.45-5.37.58-6.9.82-1.53.25-3.01,2.36-4.91,2.03-1.9-.33-3.84-.13-5.2-.29-1.36-.17-5.06.91-5.06.91,0,0-.06-.58-1.05-1.9-.99-1.32-6.06-7.71-7.88-11.19-1.83-3.48-6.54-11.05-7.31-14.19-.78-3.15-1.55-8.75-5.95-10.73-2.54-1.15-4.58-3.28-6.22-5.48-1.2-1.6-2.2-3.25-3.03-4.57-1.98-3.14-13.21-9.82-14.97-10.26-1.76-.45-8.37-1.99-11.23-2.04-2.86-.06-6.77-1.43-8.97-3.03-.63-.46-.9-1.3-.97-2.3,0-.08,0-.16,0-.24-.07-2.44.98-5.67.98-6.54,0-1.27-1.87-3.63-.28-6.06,3.09-2.91,4.52-7.32,5.29-9.41.77-2.09-.44-9.08-1.1-11.94-.66-2.87-1.16-3.75,3.24-5.62,4.41-1.87,5.15-3.58,5.07-5.06-.08-1.49-2.59-12.11-5.01-15.19-2.42-3.08-1.87-9.47-1.43-12.23.44-2.75,6.03-10.15,6.11-13.04.08-2.89,0-4.21,3.14-8.59,3.13-4.38,1.73-7.68,1.23-9.74-.46-1.96-.49-5.76,3.14-6.65.21-.05.43-.09.66-.12,3.46-.47,5.23-3.58,5.82-5.57,0-.01.01-.02.01-.03.01-.04.03-.09.03-.13.03-.09.05-.17.07-.25,10.75,8.61,13.92,7.35,16.23,6.91,2.31-.44,6.93.11,9.14.99,2.2.88,4.07,3.2,5.94,1.92,1.87-1.28,5.95-3.13,9.31-2.8,3.36.33,4.01-.88,6.1-3.08,2.1-2.2,4.19-3.19,6.6-2.64,2.41.55,5.62,4.29,6.61.66,1-3.63,2.54-6.83,9.25-3.74,6.72,3.08,10.24,11.33,9.03,17.39-1.21,6.06,1.98,15.74,6.39,16.95,4.4,1.22,21.79-4.62,22.01-10.47.22-5.86,6.83-6.48,14.98-3.39.4.15.78.28,1.15.37,0,0,.01.03.01.08.17.84,1.63,8.38.38,10.77-1.32,2.53-.65,7.62,3.52,7.65,4.17.03,4.68,1.05,3.74,3.86-.93,2.8.99,7.84,2.81,11.54,1.82,3.7-4.79,13.97-8.09,18.33-3.3,4.37-6.94,9.98-3.14,13.61,3.8,3.64,9.91,11.07,10.57,14.04.66,2.97-3.8,9.74-1.65,13.87,1.9,3.65,4.7,8.47,4.52,10.38Z\"],\"label\":[713,455],\"bbox\":[632,360.5,794,545.5],\"geoNeighbors\":[\"adana\",\"ankara\",\"antalya\",\"eskisehir\",\"isparta\",\"kutahya\",\"sivas\"],\"poly\":[[[793.9,486.6],[793.7,487.2],[791.6,488.9],[783.8,494],[771.4,500.3],[762.2,503.5],[758.4,505.6],[748.4,507],[738.5,509.6],[735.7,510.9],[731.2,514],[726.8,519.3],[725.6,519.5],[721.2,519.1],[716.3,520.5],[715.9,521.6],[716,522.5],[719.8,529.3],[721.8,531.2],[726.3,533.6],[728,535],[728.6,536.3],[728.1,537.2],[727.3,537.6],[726.4,537.6],[724.6,536.7],[723.9,536.7],[722.9,537.7],[722,541.3],[721.2,542.1],[714.3,542.9],[710.8,544.8],[702.8,544.7],[699.1,545.5],[692.1,535.5],[686.2,525.2],[683.4,519.6],[681.3,512.5],[679.6,509.6],[678.4,508.4],[673.5,505.2],[670.7,502.1],[666.6,496.2],[660.1,491.3],[653.8,487.7],[647.5,486.1],[639.2,484.9],[636.8,484.2],[632.5,482.2],[631.8,481.2],[631.6,479.6],[632.5,473.1],[631.6,468.8],[632.3,467],[634.3,464.6],[635.8,462],[637.8,456.6],[637.5,451.9],[636.1,443.8],[636.2,442.5],[637.2,441.3],[642.4,438.7],[643.9,437.4],[644.6,436.1],[644.8,435],[643.8,430.3],[641.5,423.3],[638.4,417],[638,413.6],[638.3,407.6],[644.4,394.5],[644.9,390.8],[649.2,382.8],[649.5,380.2],[648.6,374.4],[648.8,372.5],[649.9,370.7],[650.7,370],[654.9,368.6],[656.6,367.2],[658.5,363.4],[665.3,368.2],[669.8,370.3],[672.8,370.7],[676.9,370.2],[681.9,370.8],[683.9,371.3],[688.4,373.6],[693.9,371.3],[696.5,370.6],[701.2,370.4],[702.7,369.9],[706.8,366],[710.1,364.6],[711.9,364.7],[715.7,366.6],[717.3,366.9],[718,366.4],[719.4,362.8],[720.9,361],[723.6,360.4],[725.4,360.8],[730.1,363],[732.1,364.8],[735.2,369.2],[736.8,374.2],[736.6,384.1],[737.8,389.3],[740.1,393.7],[741.5,395.2],[744.1,396.1],[748.4,395.7],[752,394.8],[759.2,391.7],[762.2,389.8],[764.3,387.7],[764.9,386.6],[765.5,383.6],[766.4,382.1],[767.8,381.1],[769.7,380.5],[774.4,380.5],[781.3,382.5],[782.2,390.8],[781.1,395.6],[781.4,398.1],[782.7,400.2],[783.8,400.8],[787.7,401.2],[789,401.9],[789.3,403.1],[788.7,407.3],[789.3,410.3],[791.7,416.4],[792,418.1],[791.7,420.2],[789.6,425.3],[786.6,430.6],[781.2,438.2],[779.4,441.8],[778.9,445.3],[779.4,446.9],[780.5,448.4],[787,455.6],[789.7,459.5],[791.1,462.4],[790.8,465.2],[788.9,472.8],[788.9,474.6],[793.6,484.7],[793.9,486.6]]]},\"ankara\":{\"paths\":[\"m793.32,374.87c-2.87,1.42-6.27,7.71-12.05,7.72,0-.05-.01-.08-.01-.08-.37-.09-.75-.22-1.15-.37-8.15-3.09-14.76-2.47-14.98,3.39-.22,5.85-17.61,11.69-22.01,10.47-4.41-1.21-7.6-10.89-6.39-16.95,1.21-6.06-2.31-14.31-9.03-17.39-6.71-3.09-8.25.11-9.25,3.74-.99,3.63-4.2-.11-6.61-.66-2.41-.55-4.5.44-6.6,2.64-2.09,2.2-2.74,3.41-6.1,3.08-3.36-.33-7.44,1.52-9.31,2.8-1.87,1.28-3.74-1.04-5.94-1.92-2.21-.88-6.83-1.43-9.14-.99-2.31.44-5.48,1.7-16.23-6.91-.02.08-.04.16-.07.25.08-.35.19-.86.2-1.04.09-1.54,6.08-2.32,7.18-4.74,1.1-2.42-1.54-6.49-.82-8.8.72-2.32-.61-10.35-3.03-13.22-2.42-2.86-2.7-4.95-3.69-6.65-1-1.69-1.82-3.17-.66-7.8,1.15-4.62-5.7-5.45-6.19-9.15-.5-3.71-3.88-6.45-5.98-6.12-2.09.33-3.68.41-8.56.25-4.87-.17-10.96-2.58-12.46-1.24-1.51,1.33-2.81,1.48-4.63.16-1.81-1.32-7.02,1.74-9.82,1.74s-2.15-6.2-2.89-7.85c-.23-.49-.73-.85-1.41-1.14.14-.95.78-3.2,3.61-4.14,3.63-1.21,7.26-7.49,7.15-10.46s5.56-2.53,8.32-.38c2.75,2.14,7.04,1.32,8.42.66,1.37-.66,3.21,2.4,6.33,2.64,3.12.23,4.93-.56,7.38-1.21,2.44-.66,11.5-.44,13.65-1.43,2.14-1,24.06-1.82,28.1-9.75,4.04-7.92,5.58-12.11,15.49-9.47,9.91,2.65,14.53,13.44,23.78,17.84,9.25,4.4,7.8,1.32,12.27.66,4.2-.62,21.17,2.29,27.41,6.56h.01c.4.27.75.55,1.05.83,5.06,4.72,2.2,6.25,3.85,9.5,1.65,3.26-.99,6.27-1.1,10.16-.11,3.89-1.54,8.51,3.63,11.04,5.18,2.53,8.04,4.74,11.45,6.72,3.41,1.98,5.84,4.62,7.71,8.25,1.87,3.64,10.9,10.13,8.36,12.55-2.53,2.43-1.1,6.17-.22,10.02.89,3.86.01,4.41.67,7.49.66,3.08-6.32,7.02-9.69,8.7Z\"],\"label\":[704,330],\"bbox\":[605.5,264,802.5,396],\"geoNeighbors\":[\"eskisehir\",\"kastamonu\",\"konya\",\"sivas\"],\"poly\":[[[793.3,374.9],[788.4,379.3],[785.2,381.6],[783.3,382.3],[781.3,382.6],[777.1,381.2],[771.8,380.3],[767.8,381.1],[766.4,382.1],[765.5,383.6],[764.9,386.6],[764.3,387.7],[762.2,389.8],[759.2,391.7],[752,394.8],[748.4,395.7],[744.1,396.1],[741.5,395.2],[740.1,393.7],[737.8,389.3],[736.6,384.1],[736.8,374.2],[735.2,369.2],[732.1,364.8],[730.1,363],[725.4,360.8],[723.6,360.4],[720.9,361],[719.4,362.8],[718,366.4],[717.3,366.9],[715.7,366.6],[711.8,364.7],[710.1,364.6],[706.8,366],[702.7,369.9],[701.2,370.4],[696.5,370.6],[693.9,371.3],[688.4,373.6],[683.9,371.3],[681.9,370.8],[676.8,370.2],[671.4,370.6],[667.8,369.5],[662.2,366.2],[658.5,363.4],[658.5,363.7],[658.9,362.1],[664.3,359.5],[665.8,357.9],[664.7,342.7],[662.8,337.2],[660.5,333.9],[657.6,328],[657.1,324.4],[657.7,319.9],[657.2,318.6],[651.9,313.6],[650.6,309.7],[649.1,307.7],[647.2,306.5],[645.5,306.2],[636.9,306.4],[626.3,304.8],[625.2,304.8],[622.2,306.3],[619,305],[617.9,305.1],[610,307.1],[609.1,306.8],[608.5,306.1],[607.1,299.2],[605.7,298.1],[605.9,297.2],[607.6,294.9],[612,292.2],[614.3,289.4],[615.9,286.2],[616.7,282.5],[618.3,281.5],[622.3,281.8],[627.1,284.2],[629.5,284.5],[634.3,283.9],[637.4,285.8],[639.5,286.4],[643.5,286.1],[648.1,285],[657.9,284.3],[673.9,281.5],[682.9,278.7],[686.4,276.7],[688.7,274],[692.7,266.8],[694.2,265.3],[695.9,264.3],[698.1,263.8],[700.8,263.9],[704.1,264.6],[707.6,265.9],[710.7,267.8],[724.6,280.5],[730.9,283.7],[734.7,284.7],[740.2,283.1],[745.4,283.2],[753.1,284.5],[761.3,286.7],[764.8,288.1],[768.7,290.4],[770.2,292.1],[771.7,294.7],[771.9,297.7],[773,302.4],[771.4,310.1],[771.2,316.1],[772.3,318.9],[773.4,320.1],[788.9,329.5],[790.9,331.4],[795.2,337.6],[802.6,346.2],[803,347.6],[801.3,350.7],[801.2,353.1],[802.7,361],[802.9,367.4],[802.2,368.6],[799.7,371],[793.3,374.9]]]},\"elazig\":{\"paths\":[\"m1101.63,386.26c1.04,1.6-.28,5.9-1.16,6.58-.88.69-3.57-.14-4.13.8-.55.93-2.53,5.01-2.25,6.11.27,1.1,3.47,6.16,3.63,8.23.17,2.06.22,2.89.22,2.89,0,0-16.16.99-17.48.08-1.32-.91-2.72-2.73-5.28-2.23-2.56.5-1.9,4.13-4.38,5.53-2.47,1.41-7.18,2.73-11.39,2.64-4.21-.08-7.47,3.34-10.05,2.42-2.58-.93-9.6-.7-10.59,1.08-.99,1.79-1.82,6.66,1.15,8.64,2.98,1.98,3.06,5.27,1.32,6.89-1.73,1.62-12.22,10.78-13.29,13.75-1.07,2.98-4.95,13.55-11.39,16.02-6.44,2.48-10.66,8.67-15.36,8.84-4.71.16-15.46,7.04-23.24,3.77.02-.38-.37-.75-1.32-1.27-2.84-1.54-10.7-3.63-14.11-2.75-3.41.88-5.73-.88-11.45-3.74-5.73-2.87-3.96-9.47-1.65-11.1,2.31-1.64,3.3-4.21,5.28-6.9,1.98-2.68,3.85-9.42,7.16-14.37,3.3-4.95,4.4-14.64,1.65-18.5-2.75-3.85-20.26-8.58-22.35-8.58s-2.53-1.21-2.64-3.64c-.11-2.34-.11-3.95,2.66-5.55.1-.06.2-.11.31-.17,3.08-1.65,10.02-8.7,12.6-10.49,2.59-1.78,2.48-8.78,2.04-11.86-.44-3.08,5.4-2.64,8.37-2.42,2.97.22,5.28-2.42,9.03-4.32,3.74-1.89,10.13-2.18,13.54-2.18,2.65,0,6.9-3.59,9.33-5.7,0,0,3.03,2.4,8.04,2.9,5,.49,11.27,4.56,13.19,8.2,1.92,3.63.04,6.38,6.1,6.71,6.05.33,14.38.58,22.79,4.63,8.41,4.04,7.48,3.41,11.01,1.65,3.52-1.76,9.47.11,12.44-2.09,2.97-2.21,9.03-8.41,7.48-14.17-1.54-5.76,2.57-2.5,5.58-3.75,3.01-1.24,13.91-8.41,16.11-8.9,2.2-.49,4.84,2.14,1.76,6.67-3.07,4.53-5.06,6.83-3.52,10.79s3.19,7.26,4.24,8.86Z\"],\"label\":[1020,405],\"bbox\":[938,360.5,1102,479.5],\"geoNeighbors\":[\"diyarbakir\",\"erzurum\",\"maras\",\"sivas\"],\"poly\":[[[1101.6,386.3],[1102,387.9],[1101.2,391.8],[1100.5,392.8],[1097.1,393.2],[1096.3,393.6],[1094.2,398.5],[1094.1,399.8],[1097.1,406],[1097.7,408],[1097.9,410.9],[1081.6,411.2],[1080.5,411],[1076.9,408.7],[1075.2,408.7],[1073.8,409.6],[1072.2,412.9],[1070.8,414.2],[1068.6,415.3],[1062.6,416.7],[1056.4,417.4],[1051.4,419.3],[1043.5,418.8],[1039.4,419.8],[1038.8,420.4],[1038.1,422.2],[1037.9,424.6],[1038.3,427.1],[1039,428.2],[1041.6,430.7],[1042.4,432.6],[1042.2,434.4],[1041.2,435.9],[1034.3,442.3],[1028.8,448.3],[1024.3,457.9],[1020.9,462.6],[1018.9,464.4],[1012.1,468.1],[1004.7,473.4],[987.5,478.6],[984.2,479.1],[981,479.1],[978,478.3],[977.7,477.7],[975.4,476.4],[969.8,474.7],[965.8,474.1],[960.1,474.5],[957.7,473.8],[951.1,470.5],[949.3,469.3],[948.1,467.8],[947.2,464.5],[947.9,461.5],[948.6,460.3],[951,458],[955.5,451.4],[963.9,433.7],[965,428.5],[964.9,423.5],[963.5,419.7],[961.9,418.2],[959.2,416.7],[948.4,412.8],[939.9,410.9],[939.1,410.2],[938.7,409],[938.5,405.8],[938.8,404.4],[939.6,403.1],[944.4,399.6],[954.9,390.3],[956.3,385.8],[956.1,379.4],[956.3,378.4],[956.8,377.7],[959,376.9],[966.6,376.6],[973.5,372.6],[976.8,371.5],[980.4,370.8],[987.1,370.5],[989.3,369.9],[991.8,368.4],[996.4,364.8],[1001.1,367],[1008.4,368.6],[1012.2,370.6],[1016.7,374.5],[1017.6,375.9],[1019.1,380.5],[1020.5,381.9],[1023.7,382.6],[1034.3,383.5],[1040.3,384.8],[1053.9,390.2],[1060.6,388.1],[1067.3,387.8],[1070,386.8],[1072.6,384.4],[1076.6,379],[1077.7,374.8],[1077.1,370.8],[1077.3,369.7],[1077.8,369.2],[1083,368.8],[1099.1,359.9],[1100.8,360.1],[1101.5,360.6],[1102.3,362.4],[1102.2,363.6],[1101.8,365],[1097.4,372.2],[1096.9,374.7],[1097,376],[1098.6,380.2],[1101.6,386.3]]]},\"gelibolu\":{\"paths\":[\"m345.59,291.39c-1.58.25-3.92,2.23-6.3,1.89-2.02-.29-6.14.39-6.14,3.59,0,2.28,3.95,5.28,9.62,2.97,5.67-2.31,9.7-9.55,2.82-8.45Z\",\"m366.45,300.25c17.31-18.27,18.45-25.51,39.94-34.03-5.31-1.69-9.74-1.82-12.96-1.48-1.54,8.43-20.23,10.88-28.25,18.72-8.41,5.46,2.2,5.29-.49,11.51-4.08,6.07-8.89,13.8,1.76,5.28Z\"],\"label\":[372,281],\"bbox\":[333,264.5,406,303.5],\"geoNeighbors\":[\"canakkale\",\"edirne\"],\"poly\":[[[345.6,291.4],[347.7,291.3],[348.8,291.9],[349.2,293],[348.9,294.3],[346.6,297.4],[342.8,299.8],[340.7,300.5],[337.2,300.5],[334.7,299.4],[333.3,297.7],[333.3,295.8],[333.8,294.9],[335.5,293.8],[337.5,293.3],[341.1,293.2],[345.6,291.4]],[[366.5,300.3],[362,303.4],[360.1,303.9],[360,303.1],[360.6,301.6],[364.7,295],[365.1,292.9],[364.7,291.3],[362,287.9],[362.2,286],[363.8,284.4],[368.6,280.8],[372.8,278.4],[385.9,272.3],[389.5,270.1],[392.1,267.6],[393.4,264.7],[399.1,264.7],[406.4,266.2],[396.2,271],[388.9,275.9],[381,283.7],[366.5,300.3]]]},\"canakkale\":{\"paths\":[\"m418.06,277.6c-.05-1.65-1.53-3.01-3.97-1.2-2.43,1.82-3.38.71-4.58.33-1.2-.37-3.26.38-4.95,3.18-1.7,2.81-4.96,1.49-6.32.29-1.36-1.2-8.19-1.28-9.18-.51-.99.77-23.23,26.64-23.23,26.64,0,0-4.75.38-6.32,1.24-1.56.87-1.94,8.78-1.83,9.61.01.12.03.42.05.84,15.85,1.33,22.8-17.4,29.34-23.3,6.82-6.17,21.79-7.05,26.75-9.8,1.75-.97,3.81-2.45,5.1-4.27-.58-1.05-.84-2.12-.86-3.05Z\"],\"label\":[394,309],\"bbox\":[357.5,275.5,418.5,318.5],\"geoNeighbors\":[\"balikesir\",\"gelibolu\"],\"poly\":[[[418.1,277.6],[418.9,280.7],[416.5,283.1],[413.8,284.9],[411.5,285.9],[401.1,288.5],[393.4,291],[390,292.6],[387.1,294.7],[384.6,297.5],[375.9,309.1],[372.3,312.8],[368.1,315.8],[363.3,317.6],[357.7,318],[358,312.4],[359,308.2],[359.5,307.6],[361.2,307],[365.8,306.3],[389.1,279.7],[390.7,279.3],[396.4,279.5],[401.3,281.6],[403,281.3],[403.9,280.8],[405.9,278.2],[408.5,276.7],[411.3,277.4],[412.5,277.3],[415.7,275.6],[417,275.7],[417.8,276.5],[418.1,277.6]]]},\"kars\":{\"paths\":[\"M1205.9,262.6 L1206.4,262.5 L1206.9,262.4 L1207.4,262.3 L1207.8,262.2 L1208.3,262.2 L1208.8,262.1 L1208.8,261.9 L1209.1,262.3 L1209.3,262.6 L1209.6,262.9 L1209.9,263.3 L1210.2,263.6 L1210.5,263.9 L1210.8,264.2 L1211.1,264.5 L1211.4,264.8 L1211.8,265.1 L1212.1,265.3 L1212.5,265.6 L1212.9,265.8 L1213.3,266 L1213.7,266.2 L1214.1,266.4 L1214.5,266.5 L1214.9,266.6 L1215.3,266.7 L1215.7,266.8 L1216.2,266.9 L1216.6,266.9 L1217,267 L1217.5,267 L1217.9,267 L1218.3,267 L1218.8,267 L1219.2,266.9 L1219.6,266.9 L1220.1,266.9 L1220.5,266.8 L1220.9,266.8 L1221.4,266.7 L1221.8,266.6 L1222.2,266.6 L1222.7,266.5 L1223.1,266.4 L1223.5,266.2 L1223.9,266 L1224.3,265.8 L1224.6,265.6 L1225,265.3 L1225.3,265 L1225.6,264.7 L1225.8,264.3 L1226.1,264 L1226.3,263.6 L1226.5,263.2 L1226.7,262.8 L1226.9,262.4 L1227.1,262 L1227.2,261.6 L1227.4,261.2 L1227.5,260.8 L1227.6,260.4 L1227.8,259.9 L1227.9,259.5 L1228,259.1 L1228.1,258.7 L1228.3,258.3 L1228.4,257.8 L1228.5,257.4 L1228.6,257 L1228.7,256.6 L1228.8,256.1 L1228.9,255.7 L1229,255.3 L1229.1,254.9 L1229.1,254.4 L1229.2,254 L1229.3,253.6 L1229.4,253.1 L1229.5,252.7 L1229.6,252.3 L1229.7,251.9 L1229.8,251.5 L1229.9,251 L1230.1,250.6 L1230.3,250.2 L1230.5,249.8 L1230.7,249.4 L1230.9,249.1 L1231.1,248.7 L1231.3,248.3 L1231.6,248 L1231.9,247.6 L1232.1,247.3 L1232.4,246.9 L1232.7,246.6 L1233,246.3 L1233.3,246 L1233.6,245.7 L1234,245.4 L1234.3,245.1 L1234.6,244.8 L1235,244.6 L1235.3,244.3 L1235.7,244 L1236,243.8 L1236.4,243.6 L1236.7,243.3 L1237.1,243.1 L1237.5,242.8 L1237.9,242.6 L1238.2,242.4 L1238.6,242.2 L1239,242 L1239.4,241.8 L1239.8,241.6 L1240.2,241.4 L1240.6,241.2 L1240.9,241 L1241.3,240.8 L1241.7,240.6 L1242.1,240.4 L1242.5,240.3 L1242.9,240.1 L1243.3,239.9 L1243.7,239.8 L1244.1,239.6 L1244.5,239.4 L1245,239.3 L1245.4,239.1 L1245.8,239 L1246.2,238.8 L1246.6,238.7 L1247,238.5 L1247.4,238.4 L1247.8,238.2 L1248.2,238.1 L1248.7,237.9 L1249.1,237.8 L1249.5,237.7 L1249.9,237.5 L1250.3,237.4 L1250.7,237.3 L1251.1,237.1 L1251.6,237 L1252,236.9 L1252.4,236.8 L1252.8,236.6 L1253.2,236.5 L1253.7,236.4 L1254.1,236.3 L1254.5,236.1 L1254.9,236 L1255.3,235.9 L1255.8,235.8 L1256.2,235.7 L1256.6,235.5 L1263.5,234.3 L1263.5,234.3 L1263.5,234.3 L1263.5,234.3 L1263.5,234.3 L1263.5,234.2 L1263.5,234.1 L1263.5,234.1 L1263.5,234 L1263.5,234 L1263.5,234 L1263.5,233.9 L1263.5,233.9 L1263.5,233.9 L1263.5,233.7 L1263.4,233.7 L1263.5,233.9 L1263.6,234.3 L1263.7,234.7 L1263.8,235.2 L1263.9,235.6 L1264.1,236 L1264.2,236.4 L1264.6,236.9 L1265,237.2 L1265.4,237.5 L1265.7,237.7 L1266.1,238 L1266.5,238.2 L1266.9,238.4 L1267.2,238.6 L1267.6,238.9 L1268,239.1 L1268.4,239.3 L1268.7,239.5 L1269.1,239.8 L1269.5,240 L1269.9,240.2 L1270.3,240.4 L1270.6,240.6 L1271,240.8 L1271.4,241.1 L1271.8,241.3 L1272.2,241.5 L1272.5,241.7 L1272.9,241.9 L1273.3,242.1 L1273.7,242.3 L1274.1,242.6 L1274.4,242.8 L1274.7,243 L1274.9,243.1 L1275,243.5 L1275,243.9 L1275,244.3 L1275,244.8 L1274.9,245.2 L1274.9,245.6 L1274.9,246.1 L1274.9,246.5 L1274.9,247 L1274.8,247.4 L1274.8,247.8 L1274.9,248.3 L1274.9,248.7 L1275,249.1 L1275.1,249.6 L1275.3,250 L1275.4,250.4 L1275.6,250.8 L1275.7,251.2 L1275.9,251.6 L1276.1,252 L1276.2,252.4 L1276.4,252.8 L1276.6,253.2 L1276.7,253.6 L1276.9,254 L1277,254.4 L1277.2,254.8 L1277.4,255.3 L1277.6,255.7 L1277.7,256.1 L1277.9,256.5 L1278,256.8 L1278,257.3 L1278.1,257.7 L1278.1,258.1 L1278.2,258.6 L1278.2,259 L1278.2,259.4 L1278.1,259.9 L1278.1,260.3 L1278,260.7 L1278,261.1 L1277.8,261.6 L1277.7,262 L1277.6,262.4 L1277.5,262.9 L1277.4,263.2 L1277.2,263.7 L1277,264.1 L1276.8,264.5 L1276.6,264.9 L1276.4,265.3 L1276.1,265.7 L1275.9,266 L1275.6,266.4 L1275.4,266.8 L1275.1,267.2 L1274.9,267.5 L1274.6,267.8 L1274.3,268.2 L1274,268.6 L1273.8,268.9 L1273.5,269.2 L1273.2,269.5 L1272.9,269.9 L1272.6,270.2 L1272.3,270.5 L1272,270.8 L1271.6,271.2 L1271.3,271.4 L1270.9,271.7 L1270.6,272 L1270.2,272.2 L1269.9,272.5 L1269.5,272.7 L1269.2,273 L1269,273.2 L1268.8,273.6 L1268.7,273.9 L1268.7,274.3 L1268.7,274.7 L1268.7,275.2 L1268.9,275.6 L1269.1,276 L1269.3,276.5 L1269.6,276.8 L1269.9,277.1 L1270.2,277.5 L1270.6,277.8 L1270.8,278 L1271,278.3 L1271,278.7 L1270.9,279.1 L1270.8,279.6 L1270.7,280 L1270.6,280.4 L1270.5,280.8 L1270.4,281.3 L1270.4,281.7 L1270.4,282.1 L1270.4,282.6 L1270.5,283 L1270.5,283.4 L1270.5,283.8 L1270.7,284.3 L1270.9,284.7 L1271.1,285.1 L1271.3,285.5 L1271.4,285.8 L1271.7,286.3 L1272,286.7 L1272.3,287.1 L1272.5,287.3 L1272.8,287.7 L1273.1,288 L1273.4,288.4 L1273.7,288.7 L1274,289 L1274.3,289.3 L1274.4,289.6 L1274.5,290 L1274.7,290.3 L1274.6,290.8 L1274.5,291.2 L1274.3,291.6 L1274.1,292 L1274,292.4 L1274,292.7 L1274.2,293.3 L1274.5,293.7 L1274.8,294 L1275,294.3 L1275.4,294.7 L1275.6,295 L1275.8,295.3 L1276.1,295.7 L1276.1,295.7 L1276.1,295.7 L1275.7,296.6 L1275.4,296.8 L1275,297.1 L1274.8,297.3 L1274.5,297.6 L1274.3,297.9 L1274.2,298.2 L1274.1,298.6 L1273.8,298.7 L1273.2,298.8 L1272.3,299.1 L1271.1,299.4 L1269.6,299.8 L1267.8,300.3 L1265.7,300.9 L1263.4,301.5 L1261.2,302.2 L1259.2,302.9 L1257.5,303.6 L1255.9,304.4 L1254.6,305.1 L1253.4,305.9 L1252.5,306.7 L1251.8,307.6 L1251.2,308.3 L1250.6,308.9 L1250.2,309.5 L1249.8,309.9 L1249.6,310.2 L1249.4,310.4 L1249.3,310.5 L1248.8,310.3 L1248.6,310.3 L1248.2,310.2 L1247.5,310.2 L1246.7,310.1 L1245.6,310 L1244.3,309.9 L1242.8,309.8 L1241.1,309.7 L1239.3,309.6 L1237.5,309.7 L1235.6,309.8 L1233.6,310.1 L1231.6,310.4 L1229.5,310.9 L1227.3,311.4 L1225.1,312.1 L1223,312.6 L1221,313 L1219.1,313.3 L1217.3,313.5 L1215.6,313.6 L1214.1,313.5 L1212.7,313.4 L1211.3,313.1 L1210.1,312.8 L1208.9,312.3 L1207.9,311.7 L1206.9,311.1 L1206,310.3 L1205.1,309.5 L1204.4,308.5 L1203.7,307.5 L1203,306.5 L1202.3,305.5 L1201.5,304.5 L1200.7,303.6 L1199.8,302.8 L1199,301.9 L1198,301.1 L1197.1,300.4 L1196.1,299.7 L1195.2,299 L1194.2,298.5 L1193.3,298 L1192.3,297.5 L1191.4,297.1 L1190.5,296.8 L1189.5,296.6 L1188.7,296.3 L1187.8,295.9 L1187.1,295.5 L1186.4,295 L1185.7,294.5 L1185.1,294 L1184.6,293.3 L1184.1,292.7 L1183.6,292 L1183.3,291.4 L1183.1,290.8 L1182.9,290.2 L1182.9,289.6 L1182.9,289.1 L1183,288.6 L1183.2,288.1 L1183.7,287.4 L1184.5,286.7 L1185.6,285.9 L1187,285 L1188.7,284 L1190.6,282.9 L1192.9,281.7 L1195.5,280.4 L1197.7,279.1 L1199.6,277.9 L1201.2,276.7 L1202.4,275.6 L1203.3,274.5 L1203.8,273.4 L1204,272.4 L1203.8,271.5 L1203.7,270.5 L1203.7,269.7 L1203.7,268.8 L1203.7,268 L1203.8,267.2 L1204,266.4 L1204.2,265.7 L1204.5,265.1 L1204.7,264.5 L1204.9,264 L1205.1,263.5 L1205.2,263.2 L1205.3,263 L1205.4,262.8 L1205.4,262.7 Z\"],\"label\":[1230,284],\"bbox\":[1182.9,233.7,1278.2,313.6],\"geoNeighbors\":[\"erzurum\",\"gyumri\",\"igdir\",\"trabzon\",\"yerevan\"],\"poly\":[[[1205.9,262.6],[1208.8,261.9],[1212.5,265.6],[1216.2,266.9],[1220.9,266.8],[1224.3,265.8],[1225.6,264.7],[1227.1,262],[1228.3,258.3],[1229.9,251],[1231.3,248.3],[1234.6,244.8],[1238.2,242.4],[1244.5,239.4],[1256.6,235.5],[1263.5,234.3],[1263.5,233.7],[1264.6,236.9],[1274.9,243.1],[1275.1,249.6],[1278,256.8],[1278,261.1],[1276.4,265.3],[1273.8,268.9],[1271.6,271.2],[1269.5,272.7],[1268.7,273.9],[1268.7,275.2],[1269.3,276.5],[1271,278.3],[1270.4,281.3],[1270.5,283.8],[1271.7,286.3],[1274.3,289.3],[1274.7,290.3],[1274,292.7],[1276.1,295.7],[1275.7,296.6],[1274.5,297.6],[1274.1,298.6],[1261.2,302.2],[1255.9,304.4],[1252.5,306.7],[1249.3,310.5],[1239.3,309.6],[1235.6,309.8],[1231.6,310.4],[1221,313],[1215.6,313.6],[1212.7,313.4],[1208.9,312.3],[1205.1,309.5],[1201.5,304.5],[1199,301.9],[1195.2,299],[1191.4,297.1],[1187.8,295.9],[1185.7,294.5],[1183.6,292],[1182.9,290.2],[1183.2,288.1],[1184.5,286.7],[1197.7,279.1],[1202.4,275.6],[1203.8,273.4],[1203.8,267.2],[1205.4,262.7]]]},\"igdir\":{\"paths\":[\"M1274.1,299.1 L1274.1,299.6 L1274.2,300 L1274.6,300.4 L1275.1,300.8 L1275.5,301 L1275.9,301.2 L1276.2,301.4 L1276.7,301.5 L1277.1,301.7 L1277.5,301.8 L1278,301.9 L1278.4,302.1 L1278.7,302.2 L1279.2,302.4 L1279.5,302.5 L1279.9,302.7 L1280.3,302.9 L1280.6,303.1 L1281,303.3 L1281.4,303.5 L1281.9,303.6 L1282.3,303.8 L1282.7,304 L1283.1,304.2 L1283.5,304.3 L1283.9,304.5 L1284.4,304.7 L1284.7,304.8 L1285.2,305 L1285.6,305.2 L1286,305.3 L1286.4,305.4 L1286.8,305.6 L1287.2,305.7 L1287.6,305.8 L1288,306 L1288.5,306.2 L1288.9,306.3 L1289.3,306.4 L1289.7,306.6 L1290.1,306.7 L1290.5,306.9 L1290.9,307 L1291.4,307.2 L1291.8,307.3 L1292.3,307.5 L1292.7,307.5 L1293.1,307.6 L1293.6,307.7 L1294.1,307.7 L1294.6,307.6 L1295,307.6 L1295.5,307.5 L1295.9,307.5 L1296.4,307.3 L1296.8,307.3 L1297.2,307.2 L1297.7,307.1 L1298.1,307 L1298.6,306.9 L1299,306.8 L1299.4,306.7 L1299.9,306.6 L1300.3,306.5 L1300.7,306.4 L1301.1,306.3 L1301.5,306.2 L1301.9,306.2 L1302.3,306.1 L1302.8,306 L1303.2,306 L1303.6,305.9 L1304,305.9 L1304.4,305.8 L1304.8,305.8 L1305.3,305.8 L1305.7,305.8 L1306.1,305.7 L1306.6,305.7 L1307,305.8 L1307.5,305.8 L1307.9,305.8 L1308.3,305.8 L1308.8,305.9 L1309.2,305.9 L1309.6,305.9 L1309.9,306 L1310.3,306.1 L1310.7,306.2 L1311.1,306.3 L1311.6,306.4 L1312,306.5 L1312.4,306.7 L1312.8,306.8 L1313.1,306.9 L1313.4,307.1 L1313.8,307.3 L1314.2,307.5 L1314.6,307.8 L1315,308 L1315.3,308.2 L1315.7,308.5 L1315.9,308.6 L1316.2,308.9 L1316.6,309.2 L1316.9,309.5 L1317.2,309.8 L1317.5,310.1 L1317.9,310.4 L1318.2,310.7 L1318.4,311 L1318.7,311.3 L1319,311.7 L1319.2,312 L1319.6,312.4 L1319.8,312.7 L1320.1,313 L1320.4,313.4 L1320.6,313.7 L1320.8,314.1 L1321.1,314.4 L1321.3,314.8 L1321.5,315.1 L1321.8,315.5 L1322,315.9 L1322.2,316.2 L1322.4,316.6 L1322.7,317 L1322.9,317.4 L1323.1,317.8 L1323.3,318.1 L1323.5,318.5 L1323.7,318.9 L1323.9,319.2 L1324.1,319.6 L1324.4,320 L1324.6,320.4 L1324.8,320.7 L1324.9,321.1 L1324.8,321.5 L1324.8,321.9 L1324.7,322.3 L1324.3,322.9 L1324,323.2 L1324,323.2 L1324,323.2 L1324,323.2 L1324,323.2 L1324,323.2 L1324,323.2 L1324,323.2 L1324,323.2 L1324,323.2 L1324,323.2 L1324,323.2 L1324,323.2 L1324,323.2 L1324,323.2 L1324,323.2 L1324,323.2 L1318.1,327.8 L1317.8,328 L1317.4,328.3 L1317.2,328.7 L1317.2,329.1 L1317.2,329.5 L1317.3,329.9 L1317,330.2 L1316.7,330.5 L1316.3,330.8 L1315.9,331.1 L1315.7,331.5 L1315.6,332 L1315.7,332.5 L1315.8,333 L1315.8,333.5 L1315.9,333.9 L1316,334.4 L1315.9,334.9 L1315.9,335.4 L1315.5,335.1 L1315.1,334.8 L1314.7,334.6 L1314.2,334.5 L1313.7,334.3 L1313.3,334.2 L1313.1,334.2 L1312.8,334.3 L1312.3,334.4 L1311.6,334.6 L1310.7,334.7 L1309.7,335 L1308.5,335.2 L1307.1,335.5 L1305.6,335.7 L1304,335.9 L1302.2,336 L1300.3,336 L1298.2,335.9 L1296,335.8 L1293.7,335.6 L1291.3,335.4 L1289.1,335.1 L1287.2,334.9 L1285.6,334.6 L1284.3,334.3 L1283.3,334 L1282.6,333.7 L1282.1,333.5 L1282,333.2 L1281.7,332.8 L1281.3,332.5 L1280.8,332.2 L1280.2,331.8 L1279.4,331.5 L1278.6,331.1 L1277.6,330.7 L1276.6,330.3 L1275.6,329.9 L1274.7,329.4 L1273.9,328.9 L1273.1,328.4 L1272.5,327.9 L1271.9,327.3 L1271.5,326.7 L1271.1,326.1 L1270.7,325.5 L1270.2,324.9 L1269.7,324.4 L1269.2,323.9 L1268.6,323.5 L1267.9,323 L1267.2,322.6 L1266.5,322.3 L1265.7,322 L1264.8,321.8 L1263.8,321.8 L1262.8,321.8 L1261.7,321.9 L1260.5,322.2 L1259.3,322.5 L1258,322.9 L1256.8,323.2 L1255.7,323.4 L1254.8,323.5 L1254,323.5 L1253.3,323.4 L1252.8,323.2 L1252.4,322.9 L1252.1,322.5 L1251.8,322 L1251.5,321.4 L1251.3,320.7 L1251.1,319.9 L1250.9,319 L1250.8,318.1 L1250.6,317 L1250.6,315.9 L1250.5,314.9 L1250.4,314 L1250.3,313.3 L1250.3,312.8 L1250.2,312.3 L1250.2,312 L1250.2,311.9 L1249.3,310.5 L1249.4,310.4 L1249.6,310.2 L1249.8,309.9 L1250.2,309.5 L1250.6,308.9 L1251.2,308.3 L1251.8,307.6 L1252.5,306.7 L1253.4,305.9 L1254.6,305.1 L1255.9,304.4 L1257.5,303.6 L1259.2,302.9 L1261.2,302.2 L1263.4,301.5 L1265.7,300.9 L1267.8,300.3 L1269.6,299.8 L1271.1,299.4 L1272.3,299.1 L1273.2,298.8 L1273.8,298.7 L1274.1,298.6 Z\"],\"label\":[1303,321],\"bbox\":[1249.3,298.6,1324.9,336],\"geoNeighbors\":[\"erzurum\",\"kars\",\"yerevan\"],\"poly\":[[[1274.1,299.1],[1274.2,300],[1276.2,301.4],[1292.3,307.5],[1295.9,307.5],[1301.5,306.2],[1306.1,305.7],[1309.6,305.9],[1313.1,306.9],[1316.6,309.2],[1320.1,313],[1324.8,320.7],[1324.7,322.3],[1324,323.2],[1317.4,328.3],[1317.3,329.9],[1315.7,331.5],[1315.9,335.4],[1314.7,334.6],[1313.1,334.2],[1307.1,335.5],[1302.2,336],[1291.3,335.4],[1283.3,334],[1282.1,333.5],[1281.7,332.8],[1280.2,331.8],[1275.6,329.9],[1273.1,328.4],[1269.2,323.9],[1265.7,322],[1261.7,321.9],[1254.8,323.5],[1253.3,323.4],[1252.4,322.9],[1251.3,320.7],[1250.2,311.9],[1249.3,310.5],[1252.5,306.7],[1254.6,305.1],[1259.2,302.9],[1274.1,298.6]]]}},\"background\":[\"m1433.07,221.9c-1.54,3.36-4.07,9.31-7.62,10.13-3.55.83-5.21.41-7.85-1.24-2.64-1.65-6.03-4.87-9.82-5.12-3.8-.24-10.16.99-13.46.09-3.3-.91-10.32-2.23-11.89-5.95-1.57-3.71.07-4.04.49-4.79.42-.74-5.01-1.37-7.04-2.31-2.04-.93-5.13-3.74-6.55-4.68-1.43-.93-2.26.28-3.2.77-.93.5-4.07-2.14-5.56-2.47-1.48-.33-5.17,1.98-6.33,2.97-.74.64-6.47,6.21-10.43,10.09-1.3.05-2.51.64-3.82.85-.37.06-.76.09-1.16.07-2.89-.17-5.08-.91-5.06,2.23.02,3.13-4.68,2.06-6.25.82-1.57-1.24-5.31,1.57-6.96,1.02-1.65-.55-2.76.44-4.85.55-2.09.11-4.84-.11-7.15-.55-2.32-.44-5.51-2.09-7.16-.11-1.65,1.98-.44,2.31-3.41,1.65-2.97-.66-8.49-.11-10.68.99-2.2,1.1-1.08,2.5-12.31,2.56,0,0-6.31-.67-11.62.13-.3-1.74-1.15-3.83-2.2-3.97-1.53-.2-7.44.66-8.43.75-1,.08-3.26-3.88-3.3-4.75-.04-.87,1.78-3.26-1.98-4.42-3.76-1.16-3.51-2.1-5.33-3.22-1.81-1.11-3.55-4.83-5.61-7.22-2.07-2.4-1.82-.75-4.38-.83s-4.04-1.98-2.8-4.54c1.23-2.56.05-2.89-2.98-3.44-3.02-.55-7.54-.55-8.09.33-.55.88-.71,5.83-2.37,6.6-1.66.77-.77,3.31-2.97,3.58-2.2.28-2.97-.82-6.22-1.7-3.25-.88-4.18-1.55-6.44-1.82-2.26-.28-3.19-1.21-6.66-1.05-3.47.17-3.96.66-6.12-.27-2.14-.94-2.25-.83-4.17.66-1.93,1.49-3.58,4.73-5.62,3.91-2.03-.83-5.39-2.26-6.93-2.76-1.49-.47-7.85-2.35-8.24-2.46,1.81-2.71,4.51-6.71,5.79-8.56,2.02-2.93,9-10.39,8.34-13.86-.67-3.46-3.03-10.29-2.87-12,.17-1.7-4.07-14.31-5.17-17.83-1.1-3.52-3.19-7.49-4.51-9.14-1.33-1.65-1.21-6.05-1.44-9.69-.22-3.63-2.43-13.98-5.83-16.29-3.41-2.31-10.24-2.42-12.55-3.08-2.31-.66-3.63-5.73-4.51-9.03-.88-3.3-2.87-3.96-5.62-4.51-2.75-.55-8.15-6.17-11.23-6.39-3.08-.22-10.02-.22-11.67-2.2s-3.74-2.64-6.27-3.08c-2.54-.44-3.86.88-4.63,0s-3.08-3.31-3.52-6.28c-.37-2.53-3.69-7.29-9.89-9.33-.04-.01-.07-.02-.11-.03-.47-.16-.95-.29-1.46-.41-.63-.15-1.29-.27-1.97-.36-.02-.09-.03-.2-.04-.33-.09-2.56,3.06-11.72,4.17-12.8,1.15-1.12,7.29-2.14,9-1.73,1.7.41,4.37,2.42,6.91,2.31,2.53-.11,3.63,1.43,5.39,1.76,1.76.33,5.17-1.32,6.61-1.98,1.43-.66,4.95,1.54,6.49,2.75,1.54,1.22,5.07,1.44,6.5,2.21,1.43.77.77,3.41,3.3,3.85,2.53.44,4.73.88,5.94,2.09,1.22,1.21,2.98.22,4.52.33,1.54.11,4.84,1.54,6.04,2.31,1.22.77,3.43,1.54,5.19.55s3.96.44,4.73,2.21c.77,1.76,2.64,3.85,4.74,4.51,2.09.66,2.97,3.19,5.28,3.19s5.06-.55,6.49.11c1.44.66,2.76,1.1,3.86.33,1.1-.77.99-1.76,3.63-.99,2.64.77,6.17,2.31,7.38,1.98,1.2-.33,5.28-.88,7.59-1.21,2.32-.33,6.61-.22,8.36-1.32,1.77-1.1,4.3.22,5.74,1.54,1.43,1.32,6.88,6.77,10.84,4.96,3.96-1.82.99-3.14,7.92-1.65,6.94,1.48,8.92,3.96,10.41,7.76,1.49,3.79,5.45,6.11,9.08,7.76,3.64,1.65,8.59,5.45,11.89,4.95,3.3-.49,7.27,2.31,11.07,4.46,3.79,2.15,7.15,8.64,2.42,12.5-4.74,3.85-5.4,5.5-4.08,7.26,1.33,1.76,4.41,4.41,8.7,4.08,4.3-.33,6.61-4.63,9.91-5.62,3.3-.99,12.33-2.42,14.53-2.09,2.2.33,6.06-2.53,6.82-3.85.78-1.32,5.84-7.38,12.12-7.49,6.27-.11,6.6,5.61,9.47,8.37,2.86,2.75,3.85.11,4.73-2.43.88-2.53,3.52-4.4,5.61-3.74,2.1.66,2.21,3.08,4.52,2.2,2.3-.88,4.07-1.76,7.15,2.43,3.09,4.18,5.4,5.39,6.94,7.48,1.54,2.09,1.98,1.76,6.94,1.43,4.95-.33,7.34.61,12.3,1.76,4.95,1.16,2.72,5.04,2.39,7.44-.33,2.39.75,8.34-2.39,7.92-3.14-.41-5.78,4.46-2.89,6.44,2.89,1.98,5.53,4.79,7.02,5.29,1.48.49,6.69.16,7.59,1.48.91,1.32.42,4.3,1.99,4.54,1.56.25,5.36-.24,6.26.91.92,1.16,1.58,1.32,3.81,1.32s4.21-.66,5.04.66c.82,1.33,1.23,2.56,3.13,2.73,1.9.16,2.65.91,3.47,1.65.83.74,2.3,3.06,2.15,4.05-.04.27-.19.75-.43,1.32-.59,1.46-1.73,3.48-3.04,3.96-1.82.66-8.26,2.64-8.67,5.2-.41,2.56,8.5,16.68,17.42,22.05,3.44,2.07,5.9,3.8,7.53,5.35,2.6,2.46,3.11,4.42,2.16,6.48Z\",\"m1622.17,497.23v465.69c-5.76-7.11-11.55-16.1-12.18-20.3-.91-6.03-2.87-10.26-6.86-9.83-3.98.43-15.35,8.34-17.83,10.16-2.48,1.82-6.61,2.89-7.1-2.31-.5-5.2-3.06-5.37-5.67-5.56-2.61-.19-7.13.69-8.2-.97-1.08-1.65-.66-14.03-2.48-14.61-1.82-.58-5.45-2.23-10.35,1.43-4.9,3.66-1.87,7.49-1.09,11.62.79,4.12-1.07,8.25-2.39,10.36-1.32,2.1-9.89.75-11.19.67-1.29-.08-1.58,1.19-1.9,3.06-.32,1.81-4.81,1.4-5.08,1.37.17-.29.27-.51.3-.61.01-.03.02-.05.02-.05,0,0-2.64-.77-4.07-1.32-1.43-.55-3.42-5.28-3.86-7.04-.44-1.77-1.29-2.04-.64-6.32.33-2.19-4.5-4.91-5-5.99-.49-1.07-2.68-2.31-4.17-1.9-1.48.42-2.85-.66-2.89-4.37-.04-3.72-8.39-3.51-8.83-3.63-.44-.13-.13-32.04-.13-32.04l-17.58-.04.74-25,9.25-17.98s1.65-2.56-.5-5.82c-2.14-3.26-6.64-8.01-6.89-9.7-.25-1.7-3.68-5.7-3.55-6.32.12-.62-4.5-.67-5.38-2.57-.88-1.9.63-2.76,1.26-3.8.64-1.05-1.15-1.73-1.81-2.48-.66-.74-.77-2.78-2.62-4.46-1.84-1.68-1.21-1.76-.85-3.08.36-1.32-.55-3.44-1.52-4.21-.96-.77-3.61-3.18-5.39-3.26-1.78-.08-2.64,1.03-3.96,1.36-1.32.33-4.67,1.28-7.85-1.44-3.18-2.73-14.36-12.8-18.04-16.72-3.67-3.93-9.62-6.44-11.93-8.63-2.31-2.19-6.91-4.01-10.65-4.12-3.74-.11-8.51.08-9.3-.19-.8-.28-2.78-.61-2.67-1.9.11-1.29,2.34-1.18,2.58-1.87.25-.69.5-2.56-.79-3-1.3-.44-4.08-.88-3.94-2.42.14-1.54,3.41-.36,4.18-.77.77-.42,5.81-4.6,2.01-9.39-3.8-4.79-10.29-18.88-14.03-20.75-3.75-1.87-11.23-5.4-16.08-13.76-4.84-8.37-8.48-8.81-7.15-11.56.99-2.06,3.03-4.75,4.36-7.08.44-.77.8-1.51,1.02-2.17.08-.24.17-.53.25-.85.03-.11.05-.22.08-.34.05-.22.1-.47.15-.72.3-1.55.5-3.52.4-5.34-.02-.28-.04-.56-.08-.83-.06-.65-.18-1.27-.36-1.82-.07-.22-.15-.44-.24-.64-.05-.11-.1-.22-.16-.33-.11-.21-.24-.41-.39-.59-.21-.26-.46-.48-.74-.65-2.97-1.76-5.17-6.17-3.19-8.04,1.98-1.87,2.14-1.34,1.96-3.88-.19-2.54.41-4,1.15-3.71.75.29,2.6,2.78,3.84,2.56,1.16-.22,6.17,1.28,6.78.64.03-.04.05-.09.05-.15,0-.59-.81-3.79-1.8-6.68-.1-.31-.21-.61-.32-.9-.1-.3-.21-.58-.32-.86-.11-.28-.22-.54-.33-.79-.38-.89-.76-1.6-1.1-2-1.57-1.81,1.56-6.19,2.97-7.18,1.4-.99,4.18-2.59,6.05-5.01,1.87-2.42,1.87-11.78,4.85-11.23,1.93.36,7.42.25,10.11-2.55.1-.09.19-.19.27-.29.09-.1.17-.21.26-.33.22-.33.42-.68.58-1.07.05-.12.1-.26.14-.4.27-.85.35-1.83.19-2.99-.1-.67-.27-1.39-.55-2.17-.18-.53-.38-1.05-.57-1.57-.4-1.03-.83-2.03-1.26-3.01-.21-.49-.44-.97-.66-1.45-.22-.47-.44-.94-.67-1.4l-.33-.69c-.22-.46-.45-.91-.66-1.35-.77-1.54-1.49-3.01-2.1-4.38-.17-.4-.34-.78-.49-1.16-1.17-2.86-1.7-5.32-.85-7.34,2.09-4.95,7.16-6.82,9.58-8.14,2.42-1.32,8.47-5.62-2.75-7.27-11.23-1.65-16.85,4.51-23.34-3.52-.27-.34-.54-.66-.81-.96-.27-.3-.54-.59-.81-.86-3.95-4-7.64-4.63-10.3-4.54-.15,0-.29.01-.42.02-.27.01-.53.03-.78.06-.75.07-1.38.18-1.86.22-2.42.22-3.35-2.42-2.14-5.56.84-2.16-.21-4.02-1.19-5.4-.22-.31-.43-.6-.62-.86s-.35-.5-.47-.71c-.7-1.28-.53-3.47-1.41-4.69-.06-.08-.12-.16-.19-.23-1.12-1.15-.29-1.98-.38-4.99-.08-3.02-.61-7.39-3.63-6.86-3.01.54-5.53,2.11-6.65-.7-1.11-2.8-1.28-4.17-2.31-4.83-1.03-.66-1.69-2.31-.37-4.41,1.32-2.11,2.4-6.2,1.12-9.25-1.28-3.06-4.09-1.65-5.04-3.1-.95-1.44-6.69.79-5.49-2.93,1.2-3.72,3.76-2.89,3.14-5.16-.62-2.27-1.7-4.58-1.04-5.86s-1.11-3.26-2.89-4.01c-1.77-.74-4.04-2.97-3.84-5.08.21-2.1.83-3.46.83-3.46,0,0-.07-.26-.16-.65-.22-.94-.58-2.63-.46-3.11v-.03c.19-.6,1.82-1.7,2.01-2.42.04-.16.05-.38-.01-.65-.17-.88-.95-2.3-2.8-4.06-2.39-2.28-3.47-2.5-4.07-2.56-.61-.05-.74-.16-1.05-.77-.31-.6-.19-.96-.85-1.43-.66-.47-1.13-1.24-1.27-1.73-.13-.5-1.07-1.24-1.23-1.6-.05-.1-.04-.35,0-.67.11-.86.46-2.24.68-2.66.26-.48.45-.94.32-1.45h0c-.02-.12-.06-.23-.12-.34-.15-.29-.19-1.05-.16-1.85.02-.99.12-2.05.18-2.39.06-.31.1-.52.01-.76-.07-.22-.25-.46-.62-.83-.6-.61-.81-.82-.59-1.35h0c.06-.14.15-.3.27-.5.57-.93,2.23-1.76,2.17-2.86,0-.1-.02-.2-.04-.32-.27-1.23-1.65-3.52-2.65-3.89-1.11-.41-3.28-1.02-4.05-.72-.77.31-1.73-.55-2.15-1.09-.41-.54-1.34-1.16-2.02-1.24-.69-.08-1.01-.56-1.03-.99-.02-.43-.66-2.23-1.18-2.48-.52-.24-6.46-.26-6.98-.76-.41-.4-.89-.99-.74-1.95.03-.22.1-.45.21-.71.57-1.39,4.64-10.95,5.82-12.38,1.19-1.43,2.58-4.18,2.41-5.48-.01-.04-.01-.09-.01-.14.02-.15.03-.3.01-.43.01-.01.01-.02,0-.03.15-1.7,1.22-5.03,2.41-5.54,1.11-.47,3.14-2.93,2.85-4.57-.06-.36-.24-.68-.56-.93-1.79-1.4-3.58-.55-5.23-.63-1.65-.09-3.64-.28-3.92-1.24-.08-.27-.1-1.1-.1-2.17.02-2.67.26-6.87.38-7.73.05-.34.08-1.04.07-1.87-.03-2.09-.26-5.02-.75-5.1-.66-.13-1.29-.28-1.11-1.44,0-.03,0-.06.01-.09.08-.4.09-.77.05-1.11-.07-.7-.31-1.27-.48-1.8-.17-.56-.41-1.04-.26-1.51.05-.18.17-.37.37-.56.72-.66-.07-3.02,1.14-3.84.51-.35.65-.85.53-1.39-.15-.75-.8-1.58-1.63-2.19-1.43-1.05-2.92-2.86-3.41-4.79-.29-1.1-.43-2.64-.4-3.95-.01-.07-.01-.13,0-.2.02-.9.12-1.68.29-2.12.23-.57.26-1.57.24-2.56,0-.85-.04-1.7-.02-2.28-.01-.04,0-.08,0-.12,0-.07,0-.15-.01-.24v-.11c-.15-1.58-1.33-5.55-2.86-6.36-1.65-.88-3.3-3.8-3.35-5.78-.02-.52-.19-1.2-.43-1.92-.67-2.01-1.89-4.4-1.89-5.13,0-.14,0-.3.03-.46.12-.96.78-2.11,4.27-2.02,4.07.11,3.74.17,4.95-.27,1.21-.44,2.53,3.25,4.19,2.37,1.65-.89,1.65-2.15,3.63-2.1,1.98.06,3.69-.75,3.69-2.36,0-.11,0-.24-.02-.39,0,0,.01-.02,0-.04-.08-1.43-.48-4.24-.43-5.92v-.02c.01-.63.1-1.1.28-1.27.74-.7,3.22-4.17,3.18-5.29,0-.1-.02-.22-.05-.34-.17-.89-.82-2.18-.64-3,.05-.24.17-.44.4-.58.89-.53,4.89-4.21,6.39-5.62,2.4,2.28,8.18,7.79,10.7,10.25,3.22,3.13,6.03,9.82,7.35,12.22,1.32,2.39,8.34,8.5,9,10.15.66,1.65-.55,5.86,1.87,6.31.08.01.16.03.25.06.06.02.14.04.21.07.12.04.25.09.4.15.12.05.26.1.39.17,1.8.83,4.65,2.69,7.36,4.9.4.33.8.66,1.19,1s.78.69,1.15,1.04c1.55,1.46,2.91,2.97,3.81,4.39,3.19,5.06,6.27,3.3,11.45,5.06.81.28,1.74.55,2.75.82.6.17,1.23.33,1.89.49.65.16,1.31.31,1.99.46,1.38.32,2.82.63,4.25.93.47.1.94.2,1.4.3.47.09.94.19,1.4.29.23.05.46.1.69.15.43.09.84.18,1.25.27.48.1.95.2,1.41.3.6.14,1.17.27,1.72.4.32.08.63.15.93.23.27.06.54.13.79.2,5.4,1.43,5.51,2.43,5.51,2.43,0,0,7.87-3.58,9.52-4.24,1.65-.66,6.77,1.73,8.34,1.57,1.57-.17,1.49-1,1.49-1,0,0,0-.01-.01-.03l5.43-2.25c1.87-.78,6.71-5.72,8-8.7,1.29-2.97,6.8-4.29,9.61-4.46,2.81-.16,5.12-4.62,8.26-8.25,3.14-3.64,2.81-3.8,7.93-6.61,5.11-2.81,4.62-3.63,7.43-6.6,2.8-2.98,13.13-10.9,16.26-10.9s8.26-4.13,9.84-5.33c1.59-1.2,7.5,1.98,7.5,1.98,0,0,11.7,13.97,13.9,16.78,2.2,2.81-.88,3.41-2.26,3.74-1.37.33-6.93,3.52-7.48,4.13-.55.61-.83,1.65,0,4.68.82,3.03,4.43,5.31,7.57,7.95,3.13,2.65.08,7.68-.99,8.84-1.08,1.15-7.64.82-9.83,2.14-2.18,1.33-4.38,3.72-3.38,6.69.99,2.98,10.23,7.35,10.32,8.92.08,1.57,1.98,3.96,3.55,5.45s2.23.83,3.22.58,3.13-1.65,3.3-.58c.16,1.07,1.49,3.63,2.89,5.37,1.4,1.73,4.38,7.17,6.25,9.47,1.86,2.29,5.67-.47,8.35-2.45,2.48-1.83,5.39-.04,5.88,2.16.04.18.06.36.07.54.08,2.42,1.3,17.06,2.82,28.59,1.51,11.53,7.92,19.15,14.54,25.33,6.62,6.17,17.71,6.36,23.38,7.13,5.67.78,18.69,2.89,22.12,3.66,3.42.76,6.01-1.17,7.36,5.94.67,3.53,3.17,7.37,5.88,10.77Z\",\"m228.44,369.97c.7.54,1.9,1.07,2.85.41.95-.66,1.9-1.78,2.02-2.06s-3.72-1.86-4.29-2.52c-.58-.66-2.81-2.19-2.81-2.19,0,0-1.44-.99-1.9-.87-.45.12.37.83.95,2.06.58,1.24,2.48,4.62,3.18,5.16Z\",\"m237.85,366.17c.83-.25,1.86-.99,2.56-1.9s1.94-3.34,2.35-4.05.78-2.27.29-2.72c-.5-.45-1.46-.58-2.15.5,0,0-1.49,2.23-1.78,3.06s-.83,2.52-1.49,3.26c-.66.74-.62,2.11.21,1.86Z\",\"m270.61,385.24c1.09.8,2.46,1.05,3.34,1.36.89.31,1.07,1.28.74,2-.33.72-.06,2.95,2.48,2.68,2.54-.27,2.97-.47,2.58-1.53s-1.2-3.06-2-3.55c-.8-.5-1.88.02-2.44-2.31-.02-.06-.17-2.08-1.32-3.88-1.16-1.8-3.16-2.21-3.92-2.37-.76-.17-1.22,1.01-.83,3.26.39,2.25.27,3.53,1.36,4.33Z\",\"m285.82,451.38c1.07.29,2.72,5,4.09,6.19,1.36,1.2,3.43,3.92,3.8,4.83.37.91,1.53.95,1.78,0,.25-.95,1.32-2.27.91-3.43-.41-1.16.21-8.85-2.23-9,0,0-3.47,0-4.21-.66-.74-.66-1.36-.95-1.24-2.02.12-1.07-.21-2.15-1.2-2.44-.99-.29-1.57-1.53-2.72-1.24-1.16.29-3.96,1.36-3.06,3.8.91,2.44,3.01,3.67,4.09,3.96Z\",\"m306.42,473.01c2.35,0,3.34-.41,3.43-2.52.08-2.11-1.24-2.6-2.77-2.93-1.53-.33-4.5-1.44-5.53-1.73-.72-.2-2.69-1.13-3.96-.96-.75.1-.99,1.07-.44,1.58,1.9,1.74,7.34,6.57,9.27,6.57Z\",\"m314.39,481.43c.91.58,3.22-.29,4.13-1.24.91-.95,1.32-2.64-.37-3.43-1.69-.78-4.28-1.2-4.33,0,0,0-.33,4.09.58,4.67Z\",\"m292.68,475.65c-1.04.03-1.82,2.34-1.98,4-.06.66-.33,3.48,1.07,4.05.87.35,2.15-.26,2.68-1.16.23-.39.25-.83.29-1.69.06-1.36.1-2.26-.33-3.26-.13-.3-.84-1.97-1.73-1.94Z\",\"m262.46,464.16c-1.58.49-2.22,2.14-2.7,3.36-.85,2.17-1.43,5.79-.22,6.39,1.23.61,3.95-2.11,5.23-4.68.5-1,1.62-3.23.61-4.46-.66-.8-1.99-.89-2.92-.61Z\",\"m267.82,479.3c-1.23-.75-1.84-1.13-2.42-.91-1.06.4-1.46,2.43-.83,3.06.36.36.8.02,1.18.36.58.52-.05,1.69-.14,3.96-.04,1.1-.07,2.02.28,2.15.45.17,1.31-1.2,3.03-3.94,1.03-1.63,1.24-2.11,1.1-2.67-.18-.78-.9-1.21-2.2-2.01Z\",\"m268.03,498.77c.44,1.29,1.97,2.36,3.26,1.86,1.09-.42,1.54-1.77,1.4-2.81-.15-1.13-1.02-2.22-2.19-2.39-.13-.02-.96-.13-1.69.41-.92.68-1.11,1.98-.78,2.93Z\",\"m278.47,506.08c-.28.29-.09.87.08,1.4,1.4,4.25,1.54,4.65,2.11,5.37.68.87,1.22,1.56,1.86,1.49.93-.11,1.61-1.81,1.61-3.18,0-2.66-2.55-4.43-4.09-5-.34-.12-1.22-.45-1.57-.08Z\",\"m306.88,500.22c-1.74.61-2.54,2.18-3.67,4.42-.67,1.31-1,1.98-.87,2.81.26,1.64,2.05,3.07,3.8,3.1,2.34.03,3.72-2.48,4.33-3.59.27-.49,2.33-4.24.58-6.11-1.05-1.11-2.97-1.04-4.17-.62Z\",\"m315.55,503.23c-.23.74.23,1.22,1.24,3.14,1.62,3.08,1.6,4.09,3.1,5.53.63.61,1.07,1.02,1.78,1.16,1.76.33,3.38-1.44,3.88-1.98,1.86-2.02,2.14-4.38,2.56-7.89.43-3.58-.1-4.6-.45-5.12-.13-.19-1.45-2.05-3.14-1.78-.72.12-1.23.58-1.49.87-1.73,2.35-3.49,3.55-4.83,4.21-1.21.6-2.34.89-2.64,1.86Z\",\"m311.01,524.44c-.49,2.24,1.52,4.03,1.76,4.24.74.64,2.59,1.88,3.74,1.16,1.17-.73.96-3.06.28-4.51-.87-1.84-3.07-3.45-4.51-2.81-.94.42-1.2,1.63-1.27,1.93Z\",\"m317.07,551.25c.13.73,2.02,1.36,3.43.78,2.36-.96,2.28-4.84,2.27-5.04-.08-2.44-1.53-5.06-2.72-5-.71.04-1.17,1.01-1.2,1.07-.86,1.87,1.49,3.5.87,5.45-.54,1.7-2.79,1.9-2.64,2.72Z\",\"m338.09,523.72c1.97.68,3.97-.51,5.39-1.38,3.27-1.99,3.04-3.54,6.55-5.78,1.77-1.13,2.94-1.44,2.86-1.98-.1-.74-2.51-1.54-4.35-.77-1.99.83-1.57,2.75-3.85,3.8-1.32.61-2.32.35-3.03,1.32-.58.78-.17,1.28-.66,1.93-1.17,1.52-4.6.22-4.9.99-.17.45.8,1.46,1.98,1.87Z\",\"m372.73,533.12c-.76-.79-2.14-1.46-2.81-.99-.85.6.19,2.49-.74,3.26-.52.43-1.05.02-3.06.08-1.51.05-2.32.07-2.72.62-.59.79-.14,2.44.91,3.22,1.06.79,2.55.57,3.47,0,1.36-.85,1.01-2.2,2.19-2.72,1.41-.62,2.74.94,3.51.33.71-.57.39-2.61-.74-3.8Z\",\"m263.82,531.59c2.03,1.29,4.66,0,6.69-.99,1.58-.77,2.83-1.39,3.06-2.64.24-1.34-.85-2.69-1.94-3.3-1.46-.82-3.54-.68-3.96.17-.45.9,1.16,2.31.66,2.93-.29.36-1.06.19-1.36.12-2.13-.47-2.66-2.52-3.67-2.35-.79.13-1.26,1.52-1.32,2.44-.1,1.46.71,2.91,1.86,3.63Z\",\"m360.77,622.03c-2.42,1.54-3.96,3.41-6.06,1.98-2.09-1.43-4.62.11-6.72,1.43-2.09,1.32-8.15,4.84-10.13,3.52-1.98-1.32-3.74-3.53-2.97-7.33.77-3.79-1.76-6.55-6.83-4.45-5.06,2.09-17.39-1.32-20.37-1.32s-3.96.33-6.39-1.54c-2.42-1.87-11.56-2.97-14.86-2.97s-8.48,2.2-12.77,2.31c-4.29.11-13.21,2.53-14.42.55-1.21-1.98-2.09-3.3-4.95-4.95-2.86-1.65-9.91-4.95-12.77-5.06-2.86-.11-12.88.55-14.53.55s-3.96,1.65-4.62,4.18c-.66,2.53-1.1,9.36.77,10.68,1.87,1.32,3.41,3.3,7.71,3.19,4.29-.11,17.72,2.42,20.92,3.08,3.19.66,11.78.11,13.87.22,2.09.11,5.83,4.29,8.59,4.95,2.75.66,5.17,1.1,8.26,1.65,3.08.55,4.4,4.07,2.75,5.5s-.88,4.07,3.96,4.07,12.11.44,15.3-.66c3.19-1.1,11.89-3.41,19.82-3.08,7.93.33,18.83-1.32,22.24-1.87,3.41-.55,4.79.55,7.29,1.21,2.5.66,9.99.33,10.54-4.84s.92-5.88,0-9.03c0,0-1.21-3.52-3.63-1.98Z\",\"m274.52,442.75c-.74,1.03-1.82,3.05-3.06,2.39-1.23-.66-3.22-3.42-4.45-3.51-1.24-.08-.87,1.45-1.45,1.9-.58.46-3.96-.82-4.17-2.72-.21-1.9-.74-3.51-1.82-3.64-1.07-.12-3.67-1.73-3.67-3.55s.58-3.84-.45-4.83c-1.04-.99-3.06-2.39-3.27-3.55-.2-1.15-3.86-3.85-4.08-5.94-.22-2.09-1.38-3.25-3.42-3.52-2.03-.28-12.33.44-13.76-.23-1.43-.66-5.34-.66-5.01,1.05.33,1.71,1.88,3.08,4.46,3.63,2.59.55,7.43,2.26,8.87,2.65,1.43.38,6.22,3.19,7.21,4.78.99,1.6,2.58,3.58,1.76,4.3-.83.71-2.86,1.26-3.64,2.04-.77.77-.66,3.08-.11,4.29.56,1.21,1.44,5.78,1.05,6.6-.38.83.11,3.8.55,4.63.44.82.33,3.91.77,5.01.44,1.1,1.93,6.44.88,8.14-1.04,1.71-3.25,2.81-5.12.61-1.87-2.2-3.41-5.73-4.68-6.77-1.26-1.05-4.23-1.1-5.06-2.37-.83-1.26-4.02-6-4.57-6.6-.55-.61-3.3-1.9-4.21-2.89-.91-.99.91-3.72-1.98-4.71-2.89-.99-4.38,1.16-5.37,1.73-.99.58-3.96,2.15-6.36,2.23-2.39.09-8.17,1.16-9.16,2.07-.99.91-8.67,2.31-9,3.22-.33.91-.41,4.29,4.87,4.54,5.28.25,4.87,3.96,4.05,4.87-.83.91-1.41.12-.99,2.7.41,2.59.3,5.72.96,6.38.66.66,1.98,1.16,3.3,2.48,1.32,1.32,2.97,2.53,4.74,2.86,1.76.33,2.25-1.65,1.92-2.8-.33-1.16-2.75-2.65-1.48-3.09,1.26-.44,4.23-.66,4.29.22.05.88.44,2.92-.28,3.58-.71.66-.66,2.04.06,2.75.71.72,1.54,1.82,2.59.66,1.04-1.15,2.09-1.76,2.58-1.15.5.6.66,1.98.06,2.42-.61.44.33,2.04.66,2.75.33.72.05,2.59-2.42,2.81-2.48.22-8.87.55-9.75,1.16-.88.6-.88,3.02-1.81,3.3-.94.27-2.87.88-2.98,1.7-.11.83-.44,1.82-.99,1.66-.55-.17-1.15-.55-1.81-1.6-.66-1.05-3.86-2.97-2.64-3.63,1.21-.66,3.08-3.8.93-4.35-2.15-.55-9.74-3.14-11.39-4.3-1.65-1.15-3.31-2.47-5.78-2.72-2.48-.25-2.4,3.3-1.98,5.04.41,1.73,3.38,10.27,4.37,11.57.99,1.31,3.8,5.11,3.88,6.18.08,1.07-.91,4.04.41,4.95,1.33.91,2.32,1.9,2.98,3.47.66,1.57,2.39,7.02,2.56,8.26.16,1.24,1.15,5.03,1.9,6.03.74.99,1.65,2.72,2.06,3.79.41,1.08.63,3.5.08,3.8-.55.3-1.59.19-1.98.55-.38.36-.66,2.15-.63,2.89.03.74.33,5.51,1.59,6.83,1.27,1.32,2.87,2.23,3.06,2.64.19.41,1.02,3.99,1.51,4.29.5.31,2.62,2.1,1.93,2.37-.69.28-4.57.74-5.48-1.29-.91-2.04-2.64-3.75-3.41-3.86-.77-.11-4.9-3.11-5.31-4.18s-4.79-5.12-5.23-7.82c-.44-2.69-.06-5.06-1.93-5.83s-9.69-.11-10.46.52-1.13,2.75-1.57,3.3c-.44.55-.96,1.55-.85,2.32.11.77-.96,3.92-1.54,4.66-.58.74-1.73,1.36-1.73,2.02s-.33,3.8,0,4.75c.33.95,1.52,2.6,1.44,3.35-.08.74,0,2.6-1.98,1.44-1.98-1.15-4.38-2.19-4.67-3.3-.28-1.12,1.33-4.34,1.08-5.7-.25-1.36-2.11-8.59-2.97-9.7-.87-1.12-4.55-8.96-5.7-9.83-1.16-.86-4.63-3.01-4.5-4.25.12-1.24.62-4.17-.46-4.79-1.07-.62-4.87-.04-6.79.73-1.93.77-3.11,2.59-3.47,3.88-.36,1.3-.28,7.54,0,8.89.27,1.35-1.58,5.45-2.29,5.86-.7.42-3.46-3.71-3.84-4.54-.37-.82-5.9.04-5.94-1.15-.04-1.2-1.45-5.7-.79-7.19.67-1.48-1.89-3.96-3.05-6.19-1.16-2.23-5.12-8.83-2.73-10.98,2.4-2.15,7.02-6.85,6.03-9.83-.99-2.97-6.6-13.29-8.25-14.69-1.66-1.41-8.01-6.39-10-7.27-1.98-.88-1.54-4.73-2.86-6.38-1.32-1.66-7.15-4.52-7.92-6.39-.78-1.87.88-4.18,3.74-5.83,2.86-1.66,5.83-6.39,6.93-8.92,1.11-2.53,1.55-6.94,3.42-6.94s6.49,1.43,8.69,1.54c2.21.11,7.55-2.5,7.96-3.71.41-1.21.69-4.38,3.05-5.92,2.37-1.54,6.88-3.36,12.66,2.31,5.78,5.67,9.69,7.43,11.78,7.27,2.1-.17,5.62,2.14,7.82,2.31,2.2.17,5.51,2.04,7.87,2.81,2.37.77,7.05,2.25,8.45,4.07,1.41,1.82,5.37,7.6,8.01,6.77,2.64-.82,7.27-1.82,5.04-3.38-2.23-1.57-2.97-4.3-.09-4.71,2.89-.41,9.83-.08,10.99-1.24,1.15-1.15,3.3-4.87.49-6.03-2.81-1.15-6.19-2.47-8.25-2.97-2.07-.49-11.81-3.22-13.46-4.87-1.65-1.65-2.87-4.82-3.53-6.36-.66-1.54-4.51-1.59-5.23.44-.71,2.04-.66,3.75-1.7,3.69-1.05-.05-1.6-4.24-2.75-5.67-1.16-1.43-2.87-2.42-4.57-2.09-1.71.33-2.54,1.4-2.98,2.9-.44,1.5-1.04,2.22-2.25,2.33-1.21.11-8.26.55-9.58-.5-1.32-1.04-5.45-3.36-7.54-3.19-2.09.17-11.34,1.98-12.61,2.75-1.26.77-10.13,2.09-12.93.66-2.81-1.43-6.22-2.47-7.16-4.46-.94-1.98-2.04-5.01-2.59-5.12-.55-.11-.71,2.92-.55,3.8.17.88,0,3.69-.66,3.97-.66.27-3.58,1.59-3.96,2.42-.39.82-3.96,1.59-4.7.33-.75-1.27-1.25-4.18-.7-6.11.56-1.93-3.02-6.47-4.18-7.87-1.15-1.41-1.48-6.2-2.39-7.19-.91-.99-3.22-.74-3.8-2.06-.58-1.32-1.85-4.57-2.07-6-.22-1.43-2.53-1.32-3.24-.77-.72.55-3.25.88-3.58,2.2-.33,1.32-.22,5.28-1.87,6.61-1.65,1.32-11.23,1.32-6.5-6.5,4.74-7.82,5.51-5.94,8.04-7.05,2.53-1.1,4.02-3.19,5.34-3.52,1.32-.33,6.49-.49,8.03.06,1.55.55,3.91,1.48,5.01.93,1.1-.55,2.32-1.15,2.21-2.91-.11-1.77-1.38-6.72-2.65-7.49-1.26-.77-1.7.22-2.97.88-1.27.66-6.38,2.37-7.71,1.76-1.32-.6-4.23-1.87-5.5-1.43s-1.05,2.59-2.31,2.37c-1.27-.22-4.6-6.8-7.49-10.1-2.89-3.31-6.93-5.12-6.93-7.35s-4.63-1.65-5.62-2.07c-.99-.41-3.41-2.72-4.84-5.8-1.43-3.09-1.54-3.86-.66-5.51.88-1.65-.99-4.29-2.21-5.39-1.21-1.1-2.24-1.75-1.62-3.4.62-1.65-.99-3.51-2.27-3.92-1.28-.42-1.24-1.28-1.24-1.28l.43.02,4.24.18s1.4-1.77,2.39-1.73c.99.04,1.65-1.45,2.02-2.23.38-.79.46-.95.17-3.63-.29-2.69,1.9-2.52,3.05-2.32,1.16.21,4.88-1.03,2.94-3.79-1.94-2.77-3.8-5.99-3.6-7.11.21-1.11-.42-1.84.6-2.17,1.01-.33,2.8-2.06,3.49-3.69.69-1.62,1.74-1.37,3.06-1.4,1.32-.03,2.91-.22,4.21-.3,1.29-.09,3.82-1.52,4.92-1.63,1.1-.11,2.26-3.08,2.18-3.88-.08-.8-.25-2.78.36-3.47.6-.68.38-3.74.6-4.81.22-1.08,2.09-2.78,2.4-3.31.12-.21.3-.99.52-1.98,1.55.34,3,.7,3.55.96,1.4.66,2.92,4.7,4.18,6.34,1.25,1.63,3.94,5.56,2.73,8.09-.42.87-.36,1.88-.06,2.86.57,1.86,1.99,3.64,2.64,4.29,1,.99,1.93,3.69,1.24,5.71-.7,2.02,2.08,6.29,3.39,5.74,1.31-.54,5.01.11,8.64,1.32,3.63,1.22,3.41.78,5.62-.93,2.2-1.71,5.39-1.05,8.42-.55,3.03.49,9.74,2.1,10.78,1.87,1.04-.24,3.91-.51,5.62-.77,1.71-.26,0-3.96-.55-4.9-.55-.94-.16-.94-.05-2.09.11-1.16,4.26-3.03,4.67-4.46.42-1.43,3.42-4.34,3.8-5.23.38-.89,3.42-4.16,4.67-5.7.45-.55.81-.77,1.12-.85.72.4,1.59.96,1.77,1.38.31.74.41,2.57,2.04,2.41,1.63-.16,5.61-2.47,5.88-1.29.27,1.19,2.85,7.69,4.8,9.2,1.95,1.5,3.26,5.18,9.62,5.1,2.71-.03,4.73.03,6.59-.15,1.35,1.85,2.17,5.11,3.67,6.47,1.82,1.65,5.45,4.87,5.78,9.08.33,4.21.82,7.85,3.96,9.99,3.14,2.15,5.37,3.47,6.69,5.12,1.32,1.65,6.39,7.02,7.27,8.84.88,1.81,3.19,4.46,3.85,6,.66,1.54,2.37,5.72.93,6.88-1.43,1.15-4.29,3.47-5.72,3.8s-1.98-.39-.83-1.66c1.16-1.26,2.87-5.45.17-7.98-2.7-2.53-10.62-7.87-12.94-7.32-2.31.55-7.43,7.54-6.19,9.19,1.24,1.66,7.68,11.07,9.25,11.89,1.57.83,2.15,2.71.74,4.54-1.4,1.82-6.03,5.62-10.73,5.62s-10.98-.5-11.4,1.32c-.41,1.82.42,3.06,9.83,5.45,9.41,2.4,12.96,2.48,13.62,3.8.66,1.32,1.16,5.7,3.72,6.11,2.56.41,5.94-.66,7.93,0,1.98.66,2.97,6.27,3.79,7.84.83,1.57,1.82,1.9,3.72,2.07,1.9.16,7.43,1.65,9.16,1.07,1.74-.58,4.05-2.48,1.82-4.29-2.23-1.82-5.37-3.64-6.44-5.29-1.07-1.65-5.45-5.03-6.27-6.19-.83-1.16-4.46-5.2-5.7-5.78-1.24-.58-6.03-2.72-7.43-3.05-1.41-.34-5.54-1.74-3.97-4.22,1.57-2.47,4.96-6.11,8.1-6.77,3.13-.66,6.68-1.57,8.83.66,2.15,2.23,2.31,7.19,4.46,9.33,2.15,2.15,4.79,5.37,7.1,6.36,2.31.99,3.72,1.24,5.12.99,1.4-.24,4.87,4.05,8.01,4.79,3.14.74,7.59,1.41,8.83.83s6.77.41,7.6.91c.82.49-1.24,2.97-.41,4.37.82,1.41,4.95,3.63,4.04,4.79-.91,1.16-2.23,3.88-1.81,5.78.41,1.9,1.12,6.74,1.62,7.79.5,1.05,2.7,3.8,2.64,5.34-.05,1.54-.6,2.59,1.38,3.19,1.98.61,4.22,2.22,5.05,2.09.82-.12,4.83,1.41,5.86,1.12,1.03-.29,3.39.78,3.72,3.09.33,2.32.2,5.5-.54,6.53Z\",\"m799.49,593.19c-2.78,1.62-7.54,3.1-10.82,4.37-.05.02-.1.04-.14.07-2.28,1.43-5.19,4.06-7.97,4.14-3.09-.18-3.91,3.55-6.72,4.4-1.49.44-4.51,3.91-5.89,3.69-5.21,0-11.2,3.04-16.57,4.79-8.13,3.04-27.84,2.81-37-1.28-.56-.25-1.18.22-1.09.83,3.76,26.63-11.12,4.65-21.18,14.58-.08.08-.15.18-.19.29-5.91,15.26-14.12-6.19-12.11,7.04,0,.04.02.08.03.12,11.97,39.82,30.71,13.84,33.68,28.26.07.34.34.6.68.64,1.61.16,3.62.75,3.47-1.15-1.31-11.28,11.52-2.37,29.79-15.1,1.43,0,2.92-3.47,3.14-6.11.22-2.64,4.13-4.9,7.6-2.92,5.07,3.57,7.43-1.74,11.84.06,8.75.41-7.28-11.02-6.17-14.37.22-2.2,1.43-7.6,5.12-8.09,3.69-.5,3.03-.55,3.63-1.6,3.83-6.47,13.84-8.55,18.2-14.49.05-.07.09-.15.11-.23.78-2.47,4.69-2.48,6.13-3.95,1.07-1.18,5.05-2.92,2.42-4.02Z\",\"m193.73,190.21c-1.57,1.45-3.02,3.72-3.45,4.36-.43.64.12,4.58.21,5.28.08.7-.36,9.34-.36,9.34l.33,5.47c-1.34-.09-3.35.41-6.85.12-4.04-.34-3.38,2.64-3.38,5.11s-.91,8.26-1.66,8.43c-.74.16-3.22-2.48-4.04-1.24-.83,1.24-3.39,2.47-6.44,2.97-3.06.5-5.53,0-7.02.08-1.49.09-2.81-.49-4.54-1.32-1.74-.82-5.62-1.57-6.94-.74-1.32.82-2.06,1.82-3.38.82-1.32-.99-2.23-1.81-3.14-.82-.91.99-.99.91-3.72,1.98-2.72,1.07-3.71,2.81-4.04,4.62-.33,1.82-2.81,3.31-4.21,4.79-1.41,1.49-2.15,3.8-2.73,4.21-.15.11-.37.16-.65.18-.78.06-2.07-.06-3.89.48-2.48.75-2.72,1.66-4.79,2.48-2.06.83-4.95-2.15-8.5-1.98-3.55.17-5.53,2.48-7.52,2.81-.62.11-1.4.21-2.19.31-1.75.23-3.58.45-3.92.68-.27.18-3.14.14-5.69.06-2.26-4.12-6.95-3.62-9.45-2.73-2.56.91-3.8-.33-3.82-1.9-.03-1.57-2.89-10.4-4.38-10.46-1.49-.05-2.51-2.67-3.28-3.82-.77-1.16-5.28-8.98-3.02-13.11,2.25-4.12.99-6.66-1.76-9.68-2.76-3.03-1.88-5.73.33-5.89,2.2-.17,2.53-1.74,2.69-3.18.17-1.45-2.27-7.52-1.48-8.67.13-.2.29-.51.45-.9.81-1.88,1.87-5.56,1.94-6.62.06-.85.53-1.34,1.3-1.4.37-.04.81.03,1.3.21,1.49.53,4.09-.69,6.57-2.18,2.47-1.48.55-10.9,2.42-12.55,1.87-1.65,16.13-10.02,18.44-8.75,2.31,1.27,2.64,4.73,4.07,5.78,1.43,1.05,4.02-.55,5.4-4.18,1.37-3.64,6.16-7.44,9.35-6.99,3.2.44,12.22.99,14.92-1.27,2.7-2.26,7.65-4.35,8.48-3.52.82.82,9.03,2.09,10.9,1.59,1.87-.49,6.66-4.24,6.66-4.24l2.62,1.35c-.49.13-1,.18-1.46.21-1.12.08-.87,1.86.04,2.89.58.65,3.58,4.88,6.52,8.34,1.68,1.99,3.34,3.73,4.5,4.39,3.2,1.81,7.27,2.64,9.09,5.23.23.33.49.75.76,1.22,1.86,3.18,4.5,9.01,5.84,10.45,1.54,1.65,2.09,4.24,3.52,5.67,1.44,1.43,4.61,4.79,3.05,6.23Z\",\"m89.57,260.11c1.65,2.22.33,9.02-1.22,10.18-1.54,1.15-2.42,3.03-3.46,4.35-1.05,1.32-2.87-.17-4.79.44-1.93.6-2.97,2.42-3.53,4.29-.33,1.12-.72,3.05-1.04,4.54-.22.99-.4,1.77-.52,1.98-.31.53-2.18,2.23-2.4,3.31-.22,1.07,0,4.13-.6,4.81-.61.69-.44,2.67-.36,3.47.08.8-1.08,3.77-2.18,3.88-1.1.11-3.63,1.54-4.92,1.63-1.3.08-2.89.27-4.21.3-1.32.03-2.37-.22-3.06,1.4-.69,1.63-2.48,3.36-3.49,3.69-1.02.33-.39,1.06-.6,2.17-.2,1.12,1.66,4.34,3.6,7.11,1.94,2.76-1.78,4-2.94,3.79-1.15-.2-3.34-.37-3.05,2.32.29,2.68.21,2.84-.17,3.63-.37.78-1.03,2.27-2.02,2.23-.99-.04-2.39,1.73-2.39,1.73l-4.24-.18c-2.82-2.83-2.6-9.64-2.43-12.42.21-3.39-.47-10.1-8.39-13.96-7.93-3.85-18.5-13.76-23.23-17.06-4.74-3.3-.55-7.49.44-4.96.99,2.54,3.19,4.41,5.39,1.13,2.2-3.27.11-9.49-1.87-11.36-1.98-1.88-6.27-5.51-5.28-8.48.99-2.97,2.97-5.95,3.19-8.04.22-2.09.55-5.17,2.75-7.92,2.2-2.76.66-8.04,0-10.35-.11-.39-.18-.83-.21-1.32-.16-2.4.56-5.68,1.2-7.05.77-1.65.77-7.93-.88-9.69-1.65-1.76-1.32-6.6-.22-8.59,1.1-1.98,2.64-12.22,4.62-17.94,1.99-5.73-3.74-10.02-7.48-11.34-3.74-1.32-3.52-4.4-3.08-7.05.44-2.64,2.31-9.24.77-11.78-1.18-1.95-2.11-4.54-1.87-6.49.07-.59.24-1.11.55-1.55,1.32-1.87,9.19-17.61,11.67-20.03,2.47-2.42,1.98-4.24,4.56-7.49,2.59-3.24,5.62-1.37,5.51.45-.11,1.81-.5,2.31.27,5.72.77,3.41,3.87,2.71,7.09,1.97,3.22-.75,2.31-.54,6.28-3.39.5-.36,1.03-.52,1.57-.49,3.68.12,7.84,8.29,8.62,11.82.91,4.04,2.43,3.41,7.82,5.06.36.11.7.24,1.03.41l.36.18s.06.04.09.05c.14.09.28.17.41.26.12.07.24.16.35.24.17.12.34.26.51.4.16.14.33.28.48.44.14.13.27.26.4.4.11.12.23.25.33.38.11.12.21.24.31.37.6.75,1.14,1.59,1.64,2.49.08.16.17.33.25.49.17.32.33.65.48.99.13.27.25.55.37.83.01.02.02.05.03.07.12.28.23.56.34.85.12.31.24.62.35.93s.22.62.33.93c.12.38.25.76.36,1.14.36,1.16.67,2.29.94,3.35,1.43,5.61,1.76,8.14,1.32,11.33-.2,1.45.21,3.45.72,5.22-.77.06-1.24.55-1.3,1.4-.07,1.06-1.13,4.74-1.94,6.62-.16.39-.32.7-.45.9-.79,1.15,1.65,7.22,1.48,8.67-.16,1.44-.49,3.01-2.69,3.18-2.21.16-3.09,2.86-.33,5.89,2.75,3.02,4.01,5.56,1.76,9.68-2.26,4.13,2.25,11.95,3.02,13.11.77,1.15,1.79,3.77,3.28,3.82.55.02,1.29,1.24,1.99,2.84,1.22,2.74,2.37,6.63,2.39,7.62.02,1.57,1.26,2.81,3.82,1.9,2.5-.89,7.19-1.39,9.45,2.73-2.14-.05-4.05-.14-4.05-.14,0,0,.41,1.15-.41,3.71-.83,2.56,1.15,5.62,2.81,7.85Z\",\"m191.51,89.79c-2.15,2.1-5.17,5.4-6.99,6.83-1.82,1.43-3.69,3.58-4.07,5.45-.39,1.87-1.26,5.22-4.25,4.89s-5.02-.82-5.74-.1c-.72.72-1.16.3-2.15.38-.99.09-1.16,1.08-2.29,1.6-1.12.52-2.45,1.29-2.64,1.76s2.11,4.06,2.64,5.26c.54,1.19.83,1.94-.53,2.64-1.36.7-1.03,4.46-1.53,5.24-.5.79-1.03,4.26.45,5.66,1.49,1.4,4.63,2.93,4.55,4.33-.09,1.41-.25,7.43-1.86,7.43s-3.06,2.07-3.59,3.23c-.32.67-.94,1.01-1.64,1.19l-2.62-1.35s-4.79,3.75-6.66,4.24c-1.87.5-10.08-.77-10.9-1.59-.83-.83-5.78,1.26-8.48,3.52-2.7,2.26-11.72,1.71-14.92,1.27-3.19-.45-7.98,3.35-9.35,6.99-1.38,3.63-3.97,5.23-5.4,4.18-1.43-1.05-1.76-4.51-4.07-5.78-2.31-1.27-16.57,7.1-18.44,8.75-.06.05-.11.11-.16.18-.02.03-.04.06-.06.09-.36.55-.54,1.48-.64,2.61-.01.16-.02.32-.03.49-.1,1.7-.06,3.74-.21,5.48-.01.17-.02.33-.04.48-.04.3-.08.59-.13.87-.04.26-.1.52-.16.75-.01.05-.02.09-.04.13-.06.21-.14.4-.22.57-.03.09-.08.17-.13.24-.15.29-.36.51-.6.66-2.48,1.49-5.08,2.71-6.57,2.18-.49-.18-.93-.25-1.3-.21-.51-1.77-.92-3.77-.72-5.22.44-3.19.11-5.72-1.32-11.33-.27-1.06-.58-2.19-.94-3.35-.11-.38-.24-.76-.36-1.14-.11-.31-.22-.62-.33-.93s-.23-.62-.35-.93c-.11-.29-.22-.57-.34-.85-.01-.02-.02-.05-.03-.07-.12-.28-.24-.56-.37-.83-.15-.34-.31-.67-.48-.99-.08-.17-.17-.33-.25-.49-.5-.9-1.04-1.74-1.64-2.49-.1-.13-.2-.25-.31-.37-.1-.13-.22-.26-.33-.38-.13-.14-.26-.27-.4-.4-.15-.16-.32-.3-.48-.44-.17-.14-.34-.28-.51-.4-.11-.08-.23-.17-.35-.24-.13-.09-.27-.18-.41-.26-.03-.01-.06-.03-.09-.05-.12-.06-.24-.13-.36-.18-.33-.17-.67-.3-1.03-.41-5.39-1.65-6.91-1.02-7.82-5.06-.78-3.53-4.94-11.7-8.62-11.82.99-3.35,2.5-7.24,1.25-8.88-1.76-2.31-3.09-5.39-1.43-6.16,1.65-.77,5.83.88,8.69,1.21,2.87.33,1.88-2.32,2.54-3.97.66-1.65,4.51-1.9,4.51-1.9,0,0-.33-1.89-.83-4.21-.49-2.31-3.3-2.47-5.36-3.79-2.07-1.33-4.96-2.65-6.61-2.81-1.65-.17-2.81-1.57-4.29-3.47-1.49-1.9-1.32-4.71-5.04-5.04-3.71-.33-3.55.09-4.79-1.4-1.24-1.49-4.21-1.82-7.18-2.73-2.97-.9-3.3-3.71-5.7-5.2-2.39-1.48-3.22-3.8-3.71-5.53-.5-1.73-2.84-5.09-7.13-7.62-2.47-1.46-5.2-4.08-6.94-6.55v-6.01c2.81-.75,8.33-.1,12.44-.43,5.51-.44-.99-13.1-5.94-16.74-4.96-3.63-8.37-13.98-2.76-11.23,5.62,2.76,11.12.77,13.66-.88,2.53-1.65-1.66-6.05-4.85-8.36C10.24,17.68.88,1.83.88,1.83h176.15l.46,8.57c-.43-.06-.88-.09-1.32-.06-1.28.08-2.51.61-3.04,2.06-1.08,2.97,1.07,7.18-.67,8.17-1.73.99-3.46.66-4.04,2.32-.58,1.65-2.31,1.48-4.38,1.98-2.06.49-3.13,6.77-3.13,8.17s-2.07,6.36-.58,10.24c1.48,3.88,4.87,6.19,5.03,9.41.17,3.22,1.08,10.74,3.72,12.39,2.64,1.65,12.96,6.44,14.28,9.16,1.32,2.73,2.07,6.86,5.45,8.26,3.39,1.4,4.85,5.2,2.7,7.29Z\",\"m58.46,112s-3.85.25-4.51,1.9c-.66,1.65.33,4.3-2.54,3.97-2.86-.33-7.04-1.98-8.69-1.21-1.66.77-.33,3.85,1.43,6.16,1.25,1.64-.26,5.53-1.25,8.88-.54-.03-1.07.13-1.57.49-3.97,2.85-3.06,2.64-6.28,3.39-3.22.74-6.32,1.44-7.09-1.97-.77-3.41-.38-3.91-.27-5.72.11-1.82-2.92-3.69-5.51-.45-2.58,3.25-2.09,5.07-4.56,7.49-2.48,2.42-10.35,18.16-11.67,20.03-.31.44-.48.96-.55,1.55H.88V63.65c1.74,2.47,4.47,5.09,6.94,6.55,4.29,2.53,6.63,5.89,7.13,7.62.49,1.73,1.32,4.05,3.71,5.53,2.4,1.49,2.73,4.3,5.7,5.2,2.97.91,5.94,1.24,7.18,2.73,1.24,1.49,1.08,1.07,4.79,1.4,3.72.33,3.55,3.14,5.04,5.04,1.48,1.9,2.64,3.3,4.29,3.47,1.65.16,4.54,1.48,6.61,2.81,2.06,1.32,4.87,1.48,5.36,3.79.5,2.32.83,4.21.83,4.21Z\",\"m18.28,28.36c-2.54,1.65-8.04,3.64-13.66.88-5.61-2.75-2.2,7.6,2.76,11.23,4.95,3.64,11.45,16.3,5.94,16.74-4.11.33-9.63-.32-12.44.43V1.83s9.36,15.85,12.55,18.17c3.19,2.31,7.38,6.71,4.85,8.36Z\",\"m488.64,37.36c-.85,1.74-2.2,4.74-3.6,7.55.06-.32.1-.47.1-.47,0,0-11.79.08-14.6-.33-2.81-.42-12.97-3.64-15.03-6.11-2.06-2.48-3.47-6.28-3.8-8.51-.33-2.23-1.15-4.13-2.06-3.96-.91.16-1.82,1.81-4.05,2.64-2.23.83-5.45,1.24-6.69.16-1.23-1.07-1.23-4.37-2.64-5.44-1.4-1.08-1.57,1.32-3.05,1.32s-10.16,1.15-11.07.16c-.91-.99-2.89-2.97-4.13-4.46-1.23-1.48-2.39-2.89-4.12-3.13-1.74-.25-6.03-1.08-8.51-1.41-2.48-.33-8.59,1.32-10.57,1.9-1.98.58-5.61,2.89-9,3.06-3.38.16-9.49,2.64-13.62,2.39s-17.18,5.28-24.19,12.96c-7.02,7.68-15.86,13.38-20.23,14.62-4.38,1.24-12.8,3.14-16.1-.33-.21-.22-.41-.42-.62-.6-3.08-2.74-5.94-1.79-7.72-1.71-1.9.08-10.88-1.9-12.86-1.3-1.98.61-5.67,2.81-7.59,2.04-1.93-.77-6.66-5.4-9.36-5.4s-5.95,2.92-9.91,4.24c-3.96,1.32-15.03-.22-20.86-2.47-5.84-2.26-8.86-3.69-10.52-4.19-1.65-.49-7.92,1.13-10.73-.85-2.81-1.98-9-2.4-11.64-2.73s-8.59,2.48-10.57,2.73-9.17-.74-11.64-1.98c-2.48-1.24-4.79-4.87-2.07-6.94,2.73-2.06,4.3-5.7,6.69-6.44,2.4-.74,3.22-3.3,2.15-4.54-1.08-1.24-3.8.25-5.04-1.4-1.24-1.65-8.5-6.77-9.82-7.43-.45-.23-1.22-.48-2.08-.6l-.46-8.57h312.66s-.19,16.62,0,17.7c.19,1.07.6,14.45-1.05,17.83Z\",\"m1608.44,284.33c-3.14,0-12.05,1.81-15.03-.66-2.47,1.48-.82,4.95-4.46,5.11-3.63.17-16.67,6.94-17.66,9.91-1,2.98-1.82,14.48-1.49,17.78.33,3.31-1.1,11.78-3.3,14.09-2.21,2.32-3.86,9.14-2.98,12.55.88,3.42,5.07,6.94,5.62,7.82.55.88,0,3.14-2.53,2.37-2.54-.77-5.18-.9-5.18.16s-.8,11.62-2.53,12.2c-1.73.57-5.2,2.06-9.25-4.38-4.04-6.44-5.2,15.19-5.53,17.5-.28,1.96,1.13,25.71,1.88,36.49-.49-2.2-3.4-3.99-5.88-2.16-2.68,1.98-6.49,4.74-8.35,2.45-1.87-2.3-4.85-7.74-6.25-9.47-1.4-1.74-2.73-4.3-2.89-5.37-.17-1.07-2.31.33-3.3.58s-1.65.91-3.22-.58-3.47-3.88-3.55-5.45c-.09-1.57-9.33-5.94-10.32-8.92-1-2.97,1.2-5.36,3.38-6.69,2.19-1.32,8.75-.99,9.83-2.14,1.07-1.16,4.12-6.19.99-8.84-3.14-2.64-6.75-4.92-7.57-7.95-.83-3.03-.55-4.07,0-4.68.55-.61,6.11-3.8,7.48-4.13,1.38-.33,4.46-.93,2.26-3.74-2.2-2.81-13.9-16.78-13.9-16.78,0,0-5.91-3.18-7.5-1.98-1.58,1.2-6.71,5.33-9.84,5.33s-13.46,7.92-16.26,10.9c-2.81,2.97-2.32,3.79-7.43,6.6-5.12,2.81-4.79,2.97-7.93,6.61-3.14,3.63-5.45,8.09-8.26,8.25-2.81.17-8.32,1.49-9.61,4.46-1.29,2.98-6.13,7.92-8,8.7l-5.43,2.25c-.13-.47-1.68-6.33-.57-8.39,1.15-2.14-4.38-8.75-4.38-10.81s2.07-10.57-.33-12.55c-2.39-1.99-2.31-3.72-2.39-5.12-.09-1.41,1.47-.75,3.05-1.32,1.57-.58,3.96-4.38,5.04-5.78,1.07-1.41-6.25-8.6-18-4.05,0,0-5.4-3.77-6.83-6.08-1.43-2.31-7.37-6.61-9.47-7.6-2.09-.99-5.17-4.4-5.17-7.38s-4.18-2.42-6.49-4.07c-.96-.69-1.24-1.58-.87-2.34.53-1.08,2.35-1.9,5.38-1.51,5.17.66,9.25-1.1,9.91-5.73.66-4.62,2.86-10.35-2.87-12.66-5.72-2.31-10.12-4.18-11.67-4.62-1.54-.44-.55-3.41-3.41-4.29-2.86-.89-7.81-4.41-8.59-9.03-.77-4.63-5.5-8.7-3.3-10.24,2.2-1.54,8.26-4.29,9.8-6.06,1.54-1.76,3.08-5.06.33-6.82-2.75-1.76-21.37-10.68-26.53-11.56,0,0,.33-1.27,2.31-2.48,1.98-1.21,4.18-.38,4.62-1.43s-3.46-6.82-6.77-9.8c-1.27-1.15-2.39-1.46-3.44-1.41,3.96-3.88,9.69-9.45,10.43-10.09,1.16-.99,4.85-3.3,6.33-2.97,1.49.33,4.63,2.97,5.56,2.47.94-.49,1.77-1.7,3.2-.77,1.42.94,4.51,3.75,6.55,4.68,2.03.94,7.46,1.57,7.04,2.31-.42.75-2.06,1.08-.49,4.79,1.57,3.72,8.59,5.04,11.89,5.95,3.3.9,9.66-.33,13.46-.09,3.79.25,7.18,3.47,9.82,5.12,2.64,1.65,4.3,2.07,7.85,1.24,3.55-.82,6.08-6.77,7.62-10.13.95-2.06.44-4.02-2.16-6.48-1.63-1.55-4.09-3.28-7.53-5.35-8.92-5.37-17.83-19.49-17.42-22.05.41-2.56,6.85-4.54,8.67-5.2,1.31-.48,2.45-2.5,3.04-3.96.74.14,1.24.29,1.41.44,1.32,1.21.33,4.51,3.53,3.63,3.19-.88,6.6-2.38,7.59-2.84s1.43,6.69,4.52,8.79c3.08,2.09,5.83,4.18,7.04,6.05,1.21,1.87.11,6.94,2.09,6.61,1.99-.33,4.52-1.95,6.28.01,1.76,1.97,4.07,18.04,11.23,18.92,7.15.88,9.47,3.42,10.13,4.52s2.75-.99,4.95-1.21c2.2-.23,5.62,3.08,7.05,2.53,1.43-.55,3.74-1.54,5.06-1.43,1.32.11.99-5.4,1.43-6.39s3.31.55,3.53-2.31c.22-2.86,3.08-4.29,3.52-6.28.44-1.98,2.42-3.41,3.41-4.29s12.55-.55,16.4-8.04c3.3-6.4,7.24-14.01,8.32-16.08.17-.35.27-.54.27-.54l2.56,2.62,2.29,2.33s21.85,24.77,24,34.85c2.14,10.07,3.3,19.32,6.44,22.13,3.13,2.8,9.74,9.08,12.05,11.23,2.31,2.14.66,9.08,4.29,11.06,3.64,1.98,18.83,2.31,22.96,3.8,4.13,1.48,11.39,4.29,17.34,12.71,5.94,8.43-5.78,2.65-8.92,2.65Z\",\"m1525.16,181.49c-1.08,2.07-5.02,9.68-8.32,16.08-3.85,7.49-15.41,7.16-16.4,8.04s-2.97,2.31-3.41,4.29c-.44,1.99-3.3,3.42-3.52,6.28-.22,2.86-3.09,1.32-3.53,2.31s-.11,6.5-1.43,6.39c-1.32-.11-3.63.88-5.06,1.43-1.43.55-4.85-2.76-7.05-2.53-2.2.22-4.29,2.31-4.95,1.21s-2.98-3.64-10.13-4.52c-7.16-.88-9.47-16.95-11.23-18.92-1.76-1.96-4.29-.34-6.28-.01-1.98.33-.88-4.74-2.09-6.61-1.21-1.87-3.96-3.96-7.04-6.05-3.09-2.1-3.53-9.25-4.52-8.79s-4.4,1.96-7.59,2.84c-3.2.88-2.21-2.42-3.53-3.63-.17-.15-.67-.3-1.41-.44.24-.57.39-1.05.43-1.32.15-.99-1.32-3.31-2.15-4.05-.82-.74-1.57-1.49-3.47-1.65-1.9-.17-2.31-1.4-3.13-2.73-.83-1.32-2.81-.66-5.04-.66s-2.89-.16-3.81-1.32c-.9-1.15-4.7-.66-6.26-.91-1.57-.24-1.08-3.22-1.99-4.54-.9-1.32-6.11-.99-7.59-1.48-1.49-.5-4.13-3.31-7.02-5.29-2.89-1.98-.25-6.85,2.89-6.44,3.14.42,2.06-5.53,2.39-7.92.33-2.4,2.56-6.28-2.39-7.44-4.96-1.15-7.35-2.09-12.3-1.76-4.96.33-5.4.66-6.94-1.43-1.54-2.09-3.85-3.3-6.94-7.48-3.08-4.19-4.85-3.31-7.15-2.43-2.31.88-2.42-1.54-4.52-2.2-2.09-.66-4.73,1.21-5.61,3.74-.88,2.54-1.87,5.18-4.73,2.43-2.87-2.76-3.2-8.48-9.47-8.37-6.28.11-11.34,6.17-12.12,7.49-.76,1.32-4.62,4.18-6.82,3.85-2.2-.33-11.23,1.1-14.53,2.09-3.3.99-5.61,5.29-9.91,5.62-4.29.33-7.37-2.32-8.7-4.08-1.32-1.76-.66-3.41,4.08-7.26,4.73-3.86,1.37-10.35-2.42-12.5-3.8-2.15-7.77-4.95-11.07-4.46-3.3.5-8.25-3.3-11.89-4.95-3.63-1.65-7.59-3.97-9.08-7.76-1.49-3.8-3.47-6.28-10.41-7.76-6.93-1.49-3.96-.17-7.92,1.65-3.96,1.81-9.41-3.64-10.84-4.96-1.44-1.32-3.97-2.64-5.74-1.54-1.75,1.1-6.04.99-8.36,1.32-2.31.33-6.39.88-7.59,1.21-1.21.33-4.74-1.21-7.38-1.98-2.64-.77-2.53.22-3.63.99-1.1.77-2.42.33-3.86-.33-1.43-.66-4.18-.11-6.49-.11s-3.19-2.53-5.28-3.19c-2.1-.66-3.97-2.75-4.74-4.51-.77-1.77-2.97-3.2-4.73-2.21s-3.97.22-5.19-.55c-1.2-.77-4.5-2.2-6.04-2.31-1.54-.11-3.3.88-4.52-.33-1.21-1.21-3.41-1.65-5.94-2.09-2.53-.44-1.87-3.08-3.3-3.85-1.43-.77-4.96-.99-6.5-2.21-1.54-1.21-5.06-3.41-6.49-2.75-1.44.66-4.85,2.31-6.61,1.98-1.76-.33-2.86-1.87-5.39-1.76-2.54.11-5.21-1.9-6.91-2.31-1.71-.41-7.85.61-9,1.73-1.11,1.08-4.26,10.24-4.17,12.8-10.45-3.99-17.78-13.07-21.05-16.79-3.63-4.12-23.78-25.43-28.07-29.23-4.3-3.79-22.74-22.73-22.74-22.73h440.21s2.97,7.54,4.12,11.34c1.16,3.8,5.45,13.05,6.44,15.03,1,1.98,5.45,19.32,7.44,14.86,1.98-4.46,11.68-6.11,11.68-6.11,0,0-3.76,6.11-5.41,10.4-1.65,4.3-4.29,15.69-5.61,19.43-1.33,3.75,1.32,13.44,1.1,17.18-.22,3.74-1.76,14.97.66,18.93,2.42,3.97,7.26,5.51,9.26,9.69,2,4.19-1.56,9.47,1.31,12.77,2.86,3.31,11.56,15.31,16.07,18.85,4.51,3.55,11.12,20.13,14.09,25.52,2.05,3.73,8.5,8.93,12.28,11.77Z\",\"m1519.11,1030.97h-38.9c-1.5-1.54-3.86-3.98-4.62-4.85-1.16-1.32-1.57-13.04-1.57-13.04,0,0-3.39-5.86-4.96-7.93-1.56-2.06-6.19-1.4-6.19-1.4l-36.31-5.37c2.86-3.59,7.85-9.88,8.16-10.51.22-.45,1.94-2.9,3.56-5.19,1.57-2.21,3.05-4.28,3.05-4.28l7.04-14.31s5.95-14.76,7.71-16.96,10.79-9.47,21.8-6.38c8.97,2.51,14.8,5.67,18.19,6.16,3.17,19.63,6.88,20.24,7.84,22.65.99,2.48.41,2.81-4.46,1.24-4.87-1.57-11.48,5.53-14.28,8.59-2.81,3.05,1.4,4.46,4.21,5.04,2.8.57,8.5-.66,10.81,1.15,2.32,1.82,2.65,9.58,2.65,10.9s1.23,7.6,2.31,9.17c1.07,1.57,4.7,5.12,5.61,6.44s.83,5.61.83,5.61c0,0,3.8,2.89,4.54,5.29.56,1.81,2.21,6.03,2.98,7.98Z\",\"m1501.01,949.21c-1.06.86-1.46,2.3-.96,3.56,1.64,4.16,5.37,13.56,5.76,14.07.5.66,1.73.91,3.55,0,1.82-.91,6.69-5.61,5.12-8.92-1.57-3.3-6.03-9.5-6.03-9.5,0,0-2.54-3.21-7.44.78Z\",\"m1480.21,1030.97h-670.4c-.02-1.43-.04-3.64.03-4.85.11-1.87,2.09-15.74,2.31-20.14.22-4.41,5.61-23.29,5.61-23.29l57.3,10.41,21.97-18.83,14.86-22.62,38.15-7.76,8.91-20.81,16.02-9.25-51.08-60,102.94-30.33,17.17-15.17,1.88,5.23-5.7,3.47,12.47,2.5,49.79,9.97,88.43,51.19,136.84,114.88,86.97,7.71,9.91-2.42s.81-1.02,1.97-2.48l36.31,5.37s4.63-.66,6.19,1.4c1.57,2.07,4.96,7.93,4.96,7.93,0,0,.41,11.72,1.57,13.04.76.87,3.12,3.31,4.62,4.85Z\",\"m903.74,690.54c-1.86,1.98-4.34,5.03-4.5,6.19-.17,1.16-2.59,2.81-4.02,2.15-1.43-.66-2.31,2.58-3.86,3.79-1.54,1.22-5.83,4.24-2.09,6,3.75,1.77,5.4,3.91,2.53,3.58-2.86-.33-7.83-1.24-9.61-.41-1.78.82-6.07,1.82-7.97,4.21-1.9,2.39-6.69,8.42-2.89,9.66,1.83.6,3.2,1.56,3.88,2.44.75.95.7,1.81-.42,2.02-2.14.41-3.96.08-4.34,1.9-.16.75-.18,1.36-.25,1.89-6.51,2.96-13.91,9.66-17.59,10.27-4.46.75-4.88,8.26-6.61,11.4-1.73,3.14-10.07.16-10.98-.74-.91-.91-9.66-.58-9.66-.58.82-.5,1.56-1.21,2.22-2.03h0s.01-.02.01-.02c2.38-2.97,3.76-7.48,4.53-9.68.99-2.8,8.59-20.14,11.23-25.92,2.64-5.78,9-16.19,9.49-18.33.5-2.15,1.16-15.86,2.89-19,1.74-3.13,10.82-9.99,14.37-12.55,1.53-1.1,1.65-3.39,1.29-5.64,1.58.01,11.5.22,12.39.03.91-.19,3.97-1.29,5.54-1.16,1.57.14,4.87,1.35,6.08,2.15,1.21.8-.36,3.3-2.01,4.27-1.65.96-3.47,2.89-1.71,3,1.77.11,4.7-.24,4.76.26.06.49.64,2.78,1.4,3.14.77.35,4.98,2.18,4.15,3.67-.82,1.49-.49,2.56.11,3.39.59.82,1.13,1.4,1.5,2.31.37.91.54,4.17.83,6.11.29,1.94,1.15.24-.7,2.23Z\",\"m1026.83,823.5l-102.94,30.33,51.08,60-16.02,9.25-8.91,20.81-38.15,7.76-14.86,22.62-21.97,18.83-57.3-10.41s1.32-11.28-.55-10.51c-1.52.63-2.97,2.12-3.46,2.66-.06.08-.12.15-.17.2,0,0-12.66-48-13.76-50.42-1.1-2.42-3.75-3.63-3.75-5.62s-.33-4.62-1.54-5.72c-1.21-1.1-1.1-6.83-1.1-6.83,0,0-12.55-34.56-14.53-41.5,20.81-12.44,31.43-53.84,32.17-55.4.75-1.57.99-10.57,1.57-12.55.58-1.99,2.81-10.82,3.72-18.42.91-7.59,3.71-5.12,5.61-5.12s1.79-13.48,1.63-16.13c-.16-2.56,3.74-4.91,3.98-5.05-.66.82-1.4,1.53-2.22,2.03,0,0,8.75-.33,9.66.58.91.9,9.25,3.88,10.98.74,1.73-3.14,2.15-10.65,6.61-11.4,3.68-.61,11.08-7.31,17.59-10.27-.08.77-.26,1.36-1.07,1.91-1.38.93-3.64,2.47-4.3,2.97-.66.49-1.43,2.86-1.76,3.25-.33.38.33,2.03,1.32,4.18.99,2.15,2.4,6.77,1.74,8.01-.67,1.24-.58,4.62,0,6.69.57,2.06,1.81,4.04,1.48,5.86-.33,1.82-3.55,8.26-4.29,9.25-.75.99-.91,4.29,2.06,5.2,2.97.91,5.12,1.49,6.33,2.92,1.21,1.43,2.97,10.02,5.29,9.85,2.31-.16,4.68-.66,5.94-.44,1.27.22,6.33,4.4,7.54,5.45,1.21,1.05,3.2,4.51,5.34,4.4,2.15-.11,18.72,3.75,20.2,3.47.99-.18,61.51-38.92,102.86-65.37l15.64,54.13-5.57.78,2.95,10.47,10.67-2.6,1.43,3.99-17.17,15.17Z\",\"m813.58,975.04c-1.32,1.32-4.9,5.34-9.85,16.24-4.96,10.9-4.63,27.08-4.96,31.29-.23,2.93-2.57,6.5-3.96,8.4h-66.64c-2.03-3.06-2.07-10.43-1.81-13.02.33-3.3-.74-10.98-2.73-14.95-1.98-3.96-15.85-16.92-18.41-20.22-2.56-3.31-6.03-17.34-6.6-22.22-.58-4.87-3.97-13.62-7.85-11.14-3.88,2.47-5.04,8.01-8.09,15.11-3.06,7.1,3.14,11.64,6.61,14.45,3.46,2.8,6.68,12.71,7.43,16.26.74,3.55-1.57,7.02-1.08,13.05.5,6.03,6.2,7.93,9.5,11.97,2.46,3.02,4.19,8.25,4.91,10.71h-411.1c.01-2.38.01-7.63.01-13.62,0-9.59.02-21.06,0-25.64,0-1.08,0-1.77-.01-1.97-.05-1.76-4.26-10.93-5.91-14.23-1.65-3.3,1.57-7.6.99-9.41-.58-1.82-4.21-10.99-4.3-12.22-.08-1.24-.82-8.59-2.89-13.63-2.06-5.03-2.31-7.18-1.89-9.58.41-2.39,5.45-9.41,8.25-12.05,2.81-2.64,3.39-8.09,4.3-10.4.9-2.32,2.06-10.9,1.98-12.89-.08-1.98-6.69-18.08-7.35-20.47-.66-2.4.82-9.25.25-12.47-.58-3.22,3.3-6.19,6.52-8.17,3.22-1.99,5.94-9.09,5.94-9.09.08.22.17.44.26.65h0c5.71,13.6,26.96,4.6,35.41,2.33,8.59-2.32,36,4.29,48.89,7.59,12.88,3.3,48.22,19.49,72.66,22.79,24.44,3.3,42.93,17.84,55.81,18.5,12.88.66,39.86-22.79,55.05-32.04,15.19-9.25,43.59-18.06,53.28-13.65,9.69,4.4,21.36,4.62,27.97,3.52,6.6-1.1,10.78,2.64,12.55,8.71,1.76,6.07,17.61,11.55,23.12,14.63,5.5,3.08,15.85,4.4,20.91,2.64,5.07-1.76,8.37-5.72,9.91-5.72s2.2,5.72,2.2,5.72c0,0,11.45-2.64,23.78-3.3,12.33-.66,32.26-12.55,32.26-12.55,1.98,6.94,14.53,41.5,14.53,41.5,0,0-.11,5.73,1.1,6.83,1.21,1.1,1.54,3.74,1.54,5.72s2.65,3.2,3.75,5.62c1.1,2.42,13.76,50.42,13.76,50.42Z\",\"m305.1,845.78c-.09-.21-.18-.43-.26-.65,0,0-2.72,7.1-5.94,9.09-3.22,1.98-7.1,4.95-6.52,8.17.57,3.22-.91,10.07-.25,12.47.66,2.39,7.27,18.49,7.35,20.47.08,1.99-1.08,10.57-1.98,12.89-.91,2.31-1.49,7.76-4.3,10.4-2.8,2.64-7.84,9.66-8.25,12.05-.42,2.4-.17,4.55,1.89,9.58,2.07,5.04,2.81,12.39,2.89,13.63.09,1.23,3.72,10.4,4.3,12.22.58,1.81-2.64,6.11-.99,9.41,1.65,3.3,5.86,12.47,5.91,14.23.01.2.01.89.01,1.97,0,1.14,0,2.72,0,4.59.01,5.61.01,13.86,0,21.05,0,5.99,0,11.24-.01,13.62H.88v-103.27s23.34-8.37,31.6-18.82c8.25-10.46,17.94-23.34,16.51-30.28-1.43-6.93-9.91-22.24-10.35-28.18-.44-5.95-6.05-37.65,20.81-53.29,26.86-15.63,35.67-19.48,37.32-20.47,1.65-.99,13.54-.33,15.63-.99,2.1-.67,9.91-8.81,13.22-9.69,3.3-.88,12.22,3.19,14.86,2.31,2.64-.88,8.36-2.97,10.46-1.21,2.09,1.76,4.84,2.64,8.03,2.31,3.2-.33,7.05,4.07,10.57,4.73,3.52.66,18.39,9.36,23.34,8.81,4.96-.55,9.36,6.17,8.26,10.57-1.1,4.4-2.97,8.04,4.84,13.65,7.82,5.62,15.42,6.83,18.72,5.95,3.3-.88,17.72,2.31,22.13,5.94,4.4,3.63,11.56,5.18,17.28,5.07,5.73-.11,12.99,1.54,18.17-.44,5.17-1.99,22.73-.55,22.82,22.11Z\"]}");


const $db14449808df859a$var$CLIP_SCALE = 100;
const $db14449808df859a$var$CLOSE_DELTA = 1;
const $db14449808df859a$var$BAND_WIDTH = 6;
const $db14449808df859a$var$SHADE_DEPTH = 20;
const $db14449808df859a$var$orientRing = (ring)=>(0, (/*@__PURE__*/$parcel$interopDefault($6e0489fffd2d2588$exports))).Clipper.Area(ring) < 0 ? ring.slice().reverse() : ring;
const $db14449808df859a$var$blobCache = new Map();
const $db14449808df859a$var$blobData = (slugs)=>{
    const key = slugs.slice().sort().join('|');
    const cached = $db14449808df859a$var$blobCache.get(key);
    if (cached) return cached;
    const paths = slugs.flatMap((slug)=>(0, (/*@__PURE__*/$parcel$interopDefault($320e50466335b17c$exports))).territories[slug].poly.map((ring)=>$db14449808df859a$var$orientRing(ring.map(([x, y])=>({
                    X: Math.round(x * $db14449808df859a$var$CLIP_SCALE),
                    Y: Math.round(y * $db14449808df859a$var$CLIP_SCALE)
                })))));
    const grow = new (0, (/*@__PURE__*/$parcel$interopDefault($6e0489fffd2d2588$exports))).ClipperOffset(2, 0.25 * $db14449808df859a$var$CLIP_SCALE);
    grow.AddPaths(paths, (0, (/*@__PURE__*/$parcel$interopDefault($6e0489fffd2d2588$exports))).JoinType.jtMiter, (0, (/*@__PURE__*/$parcel$interopDefault($6e0489fffd2d2588$exports))).EndType.etClosedPolygon);
    const grown = [];
    grow.Execute(grown, $db14449808df859a$var$CLOSE_DELTA * $db14449808df859a$var$CLIP_SCALE);
    const shrink = new (0, (/*@__PURE__*/$parcel$interopDefault($6e0489fffd2d2588$exports))).ClipperOffset(2, 0.25 * $db14449808df859a$var$CLIP_SCALE);
    shrink.AddPaths(grown, (0, (/*@__PURE__*/$parcel$interopDefault($6e0489fffd2d2588$exports))).JoinType.jtMiter, (0, (/*@__PURE__*/$parcel$interopDefault($6e0489fffd2d2588$exports))).EndType.etClosedPolygon);
    const closed = [];
    shrink.Execute(closed, -$db14449808df859a$var$CLOSE_DELTA * $db14449808df859a$var$CLIP_SCALE);
    const d = closed.map((ring)=>`M${ring.map((point)=>`${point.X / $db14449808df859a$var$CLIP_SCALE},${point.Y / $db14449808df859a$var$CLIP_SCALE}`).join(' L')} Z`).join(' ');
    const data = {
        d: d,
        closed: closed
    };
    $db14449808df859a$var$blobCache.set(key, data);
    return data;
};
const $db14449808df859a$export$aa93071fad79c60d = (slugs)=>$db14449808df859a$var$blobData(slugs).d;
const $db14449808df859a$var$clipPath = (paths)=>paths.map((ring)=>`M${ring.map((point)=>`${point.X / $db14449808df859a$var$CLIP_SCALE},${point.Y / $db14449808df859a$var$CLIP_SCALE}`).join(' L')} Z`).join(' ');
const $db14449808df859a$var$inset = (paths, delta)=>{
    const offset = new (0, (/*@__PURE__*/$parcel$interopDefault($6e0489fffd2d2588$exports))).ClipperOffset(2, 0.25 * $db14449808df859a$var$CLIP_SCALE);
    offset.AddPaths(paths, (0, (/*@__PURE__*/$parcel$interopDefault($6e0489fffd2d2588$exports))).JoinType.jtRound, (0, (/*@__PURE__*/$parcel$interopDefault($6e0489fffd2d2588$exports))).EndType.etClosedPolygon);
    const result = [];
    offset.Execute(result, -delta * $db14449808df859a$var$CLIP_SCALE);
    return result;
};
const $db14449808df859a$var$shadowCache = new Map();
const $db14449808df859a$export$99552ec041cd896c = (slugs)=>{
    const key = slugs.slice().sort().join('|');
    const cached = $db14449808df859a$var$shadowCache.get(key);
    if (cached) return cached;
    let previous = $db14449808df859a$var$inset($db14449808df859a$var$blobData(slugs).closed, $db14449808df859a$var$BAND_WIDTH);
    const rings = [];
    for(let depth = $db14449808df859a$var$BAND_WIDTH; depth < $db14449808df859a$var$SHADE_DEPTH && previous.length; depth += 2){
        const inner = $db14449808df859a$var$inset(previous, 2);
        rings.push(inner.length ? `${$db14449808df859a$var$clipPath(previous)} ${$db14449808df859a$var$clipPath(inner)}` : $db14449808df859a$var$clipPath(previous));
        previous = inner;
    }
    $db14449808df859a$var$shadowCache.set(key, rings);
    return rings;
};
const $db14449808df859a$export$687d60ddc6ec8462 = (territories)=>{
    const components = [];
    const seen = new Set();
    for (const territory of territories){
        if (seen.has(territory.slug)) continue;
        seen.add(territory.slug);
        const slugs = [];
        const stack = [
            territory
        ];
        while(stack.length){
            const current = stack.pop();
            slugs.push(current.slug);
            for (const adjacent of current.adjacent){
                if (seen.has(adjacent.slug) || adjacent.faction !== territory.faction) continue;
                seen.add(adjacent.slug);
                stack.push(adjacent);
            }
        }
        components.push({
            faction: territory.faction.name,
            slugs: slugs
        });
    }
    return components;
};
const $db14449808df859a$export$9172d5f369bced3d = (territories)=>{
    const clusters = [];
    const seen = new Set();
    const bySlug = new Map(territories.map((territory)=>[
            territory.slug,
            territory
        ]));
    for (const territory of territories){
        if (seen.has(territory.slug)) continue;
        seen.add(territory.slug);
        const slugs = [];
        const stack = [
            territory
        ];
        while(stack.length){
            const current = stack.pop();
            slugs.push(current.slug);
            const geometry = (0, (/*@__PURE__*/$parcel$interopDefault($320e50466335b17c$exports))).territories[current.slug];
            for (const slug of geometry.geoNeighbors){
                const adjacent = bySlug.get(slug);
                if (!adjacent || seen.has(slug) || adjacent.faction !== territory.faction) continue;
                seen.add(slug);
                stack.push(adjacent);
            }
        }
        clusters.push({
            faction: territory.faction.name,
            slugs: slugs
        });
    }
    return clusters;
};




var $acw62 = parcelRequire("acw62");
var $f46ed4009cb9c1cd$export$83d89fbfd8236492;
var $f46ed4009cb9c1cd$export$80e7718417253a51;
var $f46ed4009cb9c1cd$export$eb3a06aef9e6ee51;
var $f46ed4009cb9c1cd$export$307591e98609eddd;
var $f46ed4009cb9c1cd$export$b23711c915539651;
var $f46ed4009cb9c1cd$export$7020a3240b287705;
'use strict';
var $f46ed4009cb9c1cd$var$l, $f46ed4009cb9c1cd$var$s;

$f46ed4009cb9c1cd$var$l = (parcelRequire("sBxfj"));

$f46ed4009cb9c1cd$var$s = (parcelRequire("3odmW"));
$f46ed4009cb9c1cd$export$83d89fbfd8236492 = $f46ed4009cb9c1cd$var$l.version;
$f46ed4009cb9c1cd$export$80e7718417253a51 = $f46ed4009cb9c1cd$var$l.renderToString;
$f46ed4009cb9c1cd$export$eb3a06aef9e6ee51 = $f46ed4009cb9c1cd$var$l.renderToStaticMarkup;
$f46ed4009cb9c1cd$export$307591e98609eddd = $f46ed4009cb9c1cd$var$l.renderToNodeStream;
$f46ed4009cb9c1cd$export$b23711c915539651 = $f46ed4009cb9c1cd$var$l.renderToStaticNodeStream;
$f46ed4009cb9c1cd$export$7020a3240b287705 = $f46ed4009cb9c1cd$var$s.renderToReadableStream;



// The map's camera maths, kept free of React and the DOM so it can be tested
// directly. MapView owns the gestures; this owns where they are allowed to land.
const $02812a7dfe853291$export$a0082732d9f8c635 = {
    x: 30,
    y: 0,
    w: 1500,
    h: 820
};
const $02812a7dfe853291$export$1799921084a0d75f = 5;
const $02812a7dfe853291$export$f5db365fc02eb0b2 = 0.16;
const $02812a7dfe853291$export$fab6214a3c2ac72a = 0.62;
const $02812a7dfe853291$export$909d008f94199d9e = 700;
const $02812a7dfe853291$export$4f103843aa83f9bb = (aspect)=>{
    const w = Math.min($02812a7dfe853291$export$a0082732d9f8c635.w, $02812a7dfe853291$export$a0082732d9f8c635.h * aspect);
    return {
        w: w,
        h: w / aspect
    };
};
const $02812a7dfe853291$export$7aa79e2cf2bc45c8 = (z, cx, cy, aspect, padTop = 0, padBottom = 0)=>{
    const base = $02812a7dfe853291$export$4f103843aa83f9bb(aspect);
    const w = base.w / z;
    const h = base.h / z;
    // zoomed out past the map itself (phones, see minZoomFor): there is nothing
    // left to pan on that axis, so the map simply centres in the frame
    const x = w >= $02812a7dfe853291$export$a0082732d9f8c635.w ? $02812a7dfe853291$export$a0082732d9f8c635.x + ($02812a7dfe853291$export$a0082732d9f8c635.w - w) / 2 : Math.min(Math.max(cx - w / 2, $02812a7dfe853291$export$a0082732d9f8c635.x), $02812a7dfe853291$export$a0082732d9f8c635.x + $02812a7dfe853291$export$a0082732d9f8c635.w - w);
    // pads let the frame over-pan vertically so map edges hidden under the HUD
    // chrome (top bars, bottom sheet) can be pulled into the clear
    const yMin = $02812a7dfe853291$export$a0082732d9f8c635.y - padTop;
    const yMax = Math.max(yMin, $02812a7dfe853291$export$a0082732d9f8c635.y + $02812a7dfe853291$export$a0082732d9f8c635.h - h + padBottom);
    const y = h >= $02812a7dfe853291$export$a0082732d9f8c635.h + padTop + padBottom ? $02812a7dfe853291$export$a0082732d9f8c635.y + ($02812a7dfe853291$export$a0082732d9f8c635.h - h) / 2 : Math.min(Math.max(cy - h / 2, yMin), yMax);
    return {
        z: z,
        cx: x + w / 2,
        cy: y + h / 2
    };
};
const $02812a7dfe853291$export$de579cd90dacdc78 = (aspect, viewportW, viewportH, chromePx)=>{
    if (viewportW > $02812a7dfe853291$export$909d008f94199d9e || viewportH <= 0) return 1;
    const clear = Math.max(120, viewportH - chromePx);
    // px per map unit at zoom z is viewportH * z / base.h; the whole map fits
    // when VB.h of them land inside `clear`
    const fit = clear * $02812a7dfe853291$export$4f103843aa83f9bb(aspect).h / ($02812a7dfe853291$export$a0082732d9f8c635.h * viewportH);
    return Math.max($02812a7dfe853291$export$f5db365fc02eb0b2, Math.min(1, fit * $02812a7dfe853291$export$fab6214a3c2ac72a));
};
const $02812a7dfe853291$export$e3327bfc5c155513 = (z)=>(1 + 0.5 * (z - 1) / ($02812a7dfe853291$export$1799921084a0d75f - 1)) / z;
const $02812a7dfe853291$export$1180439ba8385ada = (samples, endT, minSpeed, window = 120)=>{
    const tail = samples[samples.length - 1];
    if (!tail) return null;
    // The finger has to have been MOVING as it left the glass. iOS delivers touch
    // events unevenly — sometimes several in one frame sharing a timestamp,
    // sometimes one lonely event for a whole fast flick — so read the throw two
    // ways and believe the faster: across the tail window, and across the last
    // pair alone. Either one on its own drops flicks that really happened.
    const read = (head)=>{
        if (!head) return null;
        const span = tail.t - head.t;
        if (span <= 0) return null;
        return {
            vx: -(tail.x - head.x) / span,
            vy: -(tail.y - head.y) / span
        };
    };
    if (endT - tail.t > $02812a7dfe853291$export$bf0f2356d4aa8e4a) return null;
    const windowed = read(samples.filter((s)=>tail.t - s.t <= window)[0]);
    const pair = read(samples[samples.length - 2]);
    const best = [
        windowed,
        pair
    ].filter((v)=>!!v).sort((a, b)=>Math.hypot(b.vx, b.vy) - Math.hypot(a.vx, a.vy))[0];
    if (!best) return null;
    // The gap between the last movement and the lift DECAYS the throw rather than
    // cancelling it. A hard cutoff punishes a slow phone for being slow: under
    // load the touchend can arrive hundreds of ms after the last touchmove, and a
    // real flick would be thrown away. Let it fade the way it would have faded
    // had the glide already been running.
    const gap = Math.max(0, Math.min(endT - tail.t, $02812a7dfe853291$export$bf0f2356d4aa8e4a));
    const faded = Math.pow($02812a7dfe853291$export$6280821943b1ea3b, gap / 16);
    const vx = best.vx * faded;
    const vy = best.vy * faded;
    const speed = Math.hypot(vx, vy);
    if (speed < minSpeed) return null;
    if (speed > $02812a7dfe853291$export$cbaa766fff297e4b) return {
        vx: vx / speed * $02812a7dfe853291$export$cbaa766fff297e4b,
        vy: vy / speed * $02812a7dfe853291$export$cbaa766fff297e4b
    };
    return {
        vx: vx,
        vy: vy
    };
};
const $02812a7dfe853291$export$dd2c69eff3f3509e = (v, vx, vy, dt, clamp)=>{
    if (!(dt > 0)) return {
        view: v,
        vx: vx,
        vy: vy
    };
    const k = Math.pow($02812a7dfe853291$export$6280821943b1ea3b, dt / 16);
    const nvx = vx * k;
    const nvy = vy * k;
    const wantX = v.cx + nvx * dt;
    const wantY = v.cy + nvy * dt;
    const view = clamp(wantX, wantY);
    return {
        view: view,
        vx: Math.abs(view.cx - wantX) > $02812a7dfe853291$var$EDGE_EPS ? 0 : nvx,
        vy: Math.abs(view.cy - wantY) > $02812a7dfe853291$var$EDGE_EPS ? 0 : nvy
    };
};
// the clamp round-trips the centre through an edge coordinate, so an untouched
// axis can come back a float whisker off; anything above this was really moved
const $02812a7dfe853291$var$EDGE_EPS = 1e-6;
const $02812a7dfe853291$export$bf0f2356d4aa8e4a = 400;
const $02812a7dfe853291$export$cbaa766fff297e4b = 4;
const $02812a7dfe853291$export$6280821943b1ea3b = 0.94;



parcelRequire("acw62");




var $acw62 = parcelRequire("acw62");
const $3780a3745535c467$export$229206c232c9b1b8 = (params)=>{
    const radians = params.ang * Math.PI / 180;
    const ux = Math.cos(radians);
    const uy = Math.sin(radians);
    const cx = params.x + -uy * 2 * params.bow;
    const cy = params.y + ux * 2 * params.bow;
    const round = (value)=>Math.round(value * 10) / 10;
    const arc = {
        kind: 'arc',
        d: `M ${round(params.x - ux * params.len / 2)},${round(params.y - uy * params.len / 2)} Q ${round(cx)},${round(cy)} ${round(params.x + ux * params.len / 2)},${round(params.y + uy * params.len / 2)}`,
        size: params.size
    };
    if (params.fill !== undefined) arc.fill = params.fill;
    if (params.stroke !== undefined) arc.stroke = params.stroke;
    if (params.strokeW !== undefined) arc.strokeW = params.strokeW;
    return arc;
};


const $7f26ce88f690a70e$var$LABEL_FONT = "700 100px 'Iowan Old Style', 'Palatino Linotype', Palatino, Georgia, serif";
const $7f26ce88f690a70e$var$MAX_SIZE = 32;
const $7f26ce88f690a70e$var$MIN_ARC_SIZE = 8.5;
const $7f26ce88f690a70e$var$FRAME = {
    x1: 30,
    y1: 0,
    x2: 1530,
    y2: 820
};
const $7f26ce88f690a70e$export$f80c391eaed27b3 = {
    centerW: 0.8,
    centerExp: 1,
    rDiv: 1.5,
    flatBias: 1 / 800,
    grainMul: 1,
    grainKnee: 0.25,
    bowComp: 0.6,
    ctrExp: 0,
    thick: 0.52,
    corrKnee: 0.4,
    angDiv: 150,
    comfortW: 0,
    aimK: 1.4
};
function $7f26ce88f690a70e$export$7b85b809d53bc520(ctx, data, name) {
    const [bx1, by1, bx2, by2] = data.bbox;
    const paths = data.paths.map((d)=>new Path2D(d));
    const step = Math.max(2.5, Math.min(bx2 - bx1, by2 - by1) / 44);
    const W = Math.max(2, Math.round((bx2 - bx1) / step));
    const H = Math.max(2, Math.round((by2 - by1) / step));
    const inside = new Uint8Array(W * H);
    let count = 0;
    for(let j = 0; j < H; j++)for(let i = 0; i < W; i++){
        const x = bx1 + (i + 0.5) * step;
        const y = by1 + (j + 0.5) * step;
        if (x < $7f26ce88f690a70e$var$FRAME.x1 || x > $7f26ce88f690a70e$var$FRAME.x2 || y < $7f26ce88f690a70e$var$FRAME.y1 || y > $7f26ce88f690a70e$var$FRAME.y2) continue;
        if (paths.some((p)=>ctx.isPointInPath(p, x, y))) {
            inside[j * W + i] = 1;
            count++;
        }
    }
    if (count < 14) return {
        kind: 'plain',
        size: 8.5
    };
    // clearance to the nearest outside cell (two-pass chamfer transform, grid units)
    const clear = new Float32Array(W * H);
    for(let k = 0; k < W * H; k++)clear[k] = inside[k] ? 1e9 : 0;
    const at = (i, j)=>i < 0 || j < 0 || i >= W || j >= H ? 0 : clear[j * W + i];
    for(let j = 0; j < H; j++)for(let i = 0; i < W; i++){
        const k = j * W + i;
        if (!clear[k]) continue;
        clear[k] = Math.min(clear[k], at(i - 1, j) + 1, at(i, j - 1) + 1, at(i - 1, j - 1) + 1.4, at(i + 1, j - 1) + 1.4);
    }
    for(let j = H - 1; j >= 0; j--)for(let i = W - 1; i >= 0; i--){
        const k = j * W + i;
        if (!clear[k]) continue;
        clear[k] = Math.min(clear[k], at(i + 1, j) + 1, at(i, j + 1) + 1, at(i + 1, j + 1) + 1.4, at(i - 1, j + 1) + 1.4);
    }
    // tracking ramps smoothly with size — a hard jump at one size makes that
    // size disproportionately long and caps labels just under the threshold
    const track = (s)=>Math.min(0.18, 0.08 + Math.max(0, s - 13) * 0.02);
    ctx.font = $7f26ce88f690a70e$var$LABEL_FONT;
    const nameEm = ctx.measureText(name).width / 100;
    const textLen = (s)=>(nameEm + name.length * track(s)) * s;
    const clearAt = ([x, y])=>{
        const i = Math.max(0, Math.min(W - 1, Math.round((x - bx1) / step - 0.5)));
        const j = Math.max(0, Math.min(H - 1, Math.round((y - by1) / step - 0.5)));
        return clear[j * W + i] * step;
    };
    const cellXY = (k)=>[
            bx1 + (k % W + 0.5) * step,
            by1 + ((k / W | 0) + 0.5) * step
        ];
    // centroid of the whole (viewport-clipped) shape — the label should look
    // centered in the region the eye sees, not merely in the band it fits in.
    // Optionally clearance-weighted so thin appendages (a coastal arm, a
    // panhandle) don't drag the perceived center away from the region's body.
    let cxSum = 0;
    let cySum = 0;
    let wSum = 0;
    for(let k = 0; k < W * H; k++)if (inside[k]) {
        const [x, y] = cellXY(k);
        const wt = $7f26ce88f690a70e$export$f80c391eaed27b3.ctrExp ? Math.pow(clear[k], $7f26ce88f690a70e$export$f80c391eaed27b3.ctrExp) : 1;
        cxSum += x * wt;
        cySum += y * wt;
        wSum += wt;
    }
    const sCtr = [
        cxSum / wSum,
        cySum / wSum
    ];
    const insideCells = [];
    for(let k = 0; k < W * H; k++)if (inside[k]) insideCells.push(k);
    // the region's grain — principal axis and elongation of the WHOLE shape.
    // Measuring this on the per-size thick component instead gives garbage for
    // narrow strips: the fittable chunk of a steep sliver reads as round, so
    // the sliver's own axis never becomes the target angle.
    let gxx = 0;
    let gyy = 0;
    let gxy = 0;
    for (const k of insideCells){
        const [x, y] = cellXY(k);
        gxx += (x - sCtr[0]) * (x - sCtr[0]);
        gyy += (y - sCtr[1]) * (y - sCtr[1]);
        gxy += (x - sCtr[0]) * (y - sCtr[1]);
    }
    const gDisc = Math.sqrt(Math.max(0, ((gxx - gyy) / 2) ** 2 + gxy * gxy));
    const gl1 = (gxx + gyy) / 2 + gDisc;
    const gl2 = Math.max(0, (gxx + gyy) / 2 - gDisc);
    let phiShape = Math.atan2(gl1 - gxx, gxy) * 180 / Math.PI;
    if (phiShape > 90) phiShape -= 180;
    if (phiShape < -90) phiShape += 180;
    const elongShape = 1 - Math.sqrt(gl2 / Math.max(1e-6, gl1)) // 0 round … 1 line
    ;
    const smoothed = (P, frac)=>{
        const win = Math.max(1, Math.round(P.length / frac));
        const pass = (Q)=>Q.map((_, idx)=>{
                let sx = 0;
                let sy = 0;
                let c = 0;
                for(let t = -win; t <= win; t++){
                    const q = Q[Math.min(Q.length - 1, Math.max(0, idx + t))];
                    sx += q[0];
                    sy += q[1];
                    c++;
                }
                return [
                    sx / c,
                    sy / c
                ];
            });
        const S = pass(pass(P));
        // the clamped moving average drags both ends inward, silently eating
        // ~1/6 of the usable length — shear the result back onto the original
        // endpoints so a run barely longer than the text still fits it
        const n = P.length - 1;
        if (n < 1) return S;
        const d0 = [
            P[0][0] - S[0][0],
            P[0][1] - S[0][1]
        ];
        const d1 = [
            P[n][0] - S[n][0],
            P[n][1] - S[n][1]
        ];
        return S.map((q, idx)=>{
            const t = idx / n;
            return [
                q[0] + d0[0] * (1 - t) + d1[0] * t,
                q[1] + d0[1] * (1 - t) + d1[1] * t
            ];
        });
    };
    const lengthOf = (P)=>{
        let L = 0;
        for(let i = 1; i < P.length; i++)L += Math.hypot(P[i][0] - P[i - 1][0], P[i][1] - P[i - 1][1]);
        return L;
    };
    // largest connected component of cells thick enough for a given size
    const thickComp = (size)=>{
        const need = 0.55 * size / step;
        const ok = (k)=>inside[k] === 1 && clear[k] >= need;
        const comp = new Int32Array(W * H).fill(-1);
        let bestId = -1;
        let bestSize = 0;
        let bestSeed = -1;
        let id = 0;
        const stack = [];
        for(let k0 = 0; k0 < W * H; k0++){
            if (!ok(k0) || comp[k0] >= 0) continue;
            let sz = 0;
            stack.push(k0);
            comp[k0] = id;
            while(stack.length){
                const k = stack.pop();
                sz++;
                const ci = k % W;
                const cj = k / W | 0;
                for(let dj = -1; dj <= 1; dj++)for(let di = -1; di <= 1; di++){
                    const ni = ci + di;
                    const nj = cj + dj;
                    if (ni < 0 || nj < 0 || ni >= W || nj >= H) continue;
                    const nk = nj * W + ni;
                    if (ok(nk) && comp[nk] < 0) {
                        comp[nk] = id;
                        stack.push(nk);
                    }
                }
            }
            if (sz > bestSize) {
                bestSize = sz;
                bestId = id;
                bestSeed = k0;
            }
            id++;
        }
        if (bestId < 0) return null;
        const cells = [];
        for(let k = 0; k < W * H; k++)if (comp[k] === bestId) cells.push(k);
        return {
            cells: cells,
            comp: comp,
            id: bestId,
            seed: bestSeed
        };
    };
    // straight-ish baseline along a direction: among all "latitudes" (single
    // perpendicular offsets) whose contiguous run of thick cells is long enough
    // for the text, take the one closest to the region's center — never merely
    // the longest run, which drifts to wherever the widest band happens to be.
    // The used window is then centered on the centroid along the line, too.
    // Text sits ON its baseline with glyphs rising ~0.72em above it, and the
    // crown arc lifts the middle of the line further still — so the baseline is
    // aimed below the centroid by half the cap height plus the expected bow.
    // That puts the text's optical middle, not its underside, on the center.
    const baseDrop = (size)=>0.36 * size + $7f26ce88f690a70e$export$f80c391eaed27b3.bowComp * Math.min(0.55 * size, Math.max(2, 0.05 * textLen(size)));
    // ctrA centers the text window along the reading direction (the shape's
    // visual center); ctrP picks the latitude across it (the roomy band's
    // center) — conflating the two drags labels toward the widest lobe
    // Returns EVERY plausible baseline at this direction and size — one per
    // latitude whose contiguous run holds the text, and up to three window
    // placements (left/center/right) when the run has slack. Generating the
    // full candidate set and letting the optical-center score arbitrate is
    // what lets a label sit low in one region and high in another without any
    // per-city rules; picking a single "best latitude" here starved the scorer.
    const sliceSpines = (cells, theta, minLen, size, ctrA)=>{
        const ux = Math.cos(theta);
        const uy = Math.sin(theta);
        const vxx = -uy;
        const vyy = ux;
        const w = step * 1.2;
        // grid extents come from the WHOLE inside mask so the thick corridor and
        // the visual corridor share bins
        let aMin = Infinity;
        let aMax = -Infinity;
        let pMin = Infinity;
        let pMax = -Infinity;
        const projAll = insideCells.map((k)=>{
            const [x, y] = cellXY(k);
            const a = x * ux + y * uy;
            const p = x * vxx + y * vyy;
            aMin = Math.min(aMin, a);
            aMax = Math.max(aMax, a);
            pMin = Math.min(pMin, p);
            pMax = Math.max(pMax, p);
            return [
                a,
                p
            ];
        });
        const na = Math.max(1, Math.ceil((aMax - aMin) / w));
        const np = Math.max(1, Math.ceil((pMax - pMin) / w));
        const occ = new Int32Array(na * np);
        const pSum = new Float64Array(na * np);
        // occupancy of every inside cell — the corridor the EYE sees at each
        // latitude, including parts too thin for text
        const occAll = new Int32Array(na * np);
        for (const [a, p] of projAll){
            const ai = Math.max(0, Math.min(na - 1, Math.floor((a - aMin) / w)));
            const pi = Math.max(0, Math.min(np - 1, Math.floor((p - pMin) / w)));
            occAll[pi * na + ai]++;
        }
        for (const k of cells){
            const [x, y] = cellXY(k);
            const a = x * ux + y * uy;
            const p = x * vxx + y * vyy;
            const ai = Math.max(0, Math.min(na - 1, Math.floor((a - aMin) / w)));
            const pi = Math.max(0, Math.min(np - 1, Math.floor((p - pMin) / w)));
            occ[pi * na + ai]++;
            pSum[pi * na + ai] += p;
        }
        // center of the visual (inside-mask) corridor at row pi that contains
        // along-bin ai — margins are judged against THIS, not the thick run:
        // the thick run ends where text stops fitting, but the eye keeps seeing
        // region well past that (Sivas hugged its east border for this reason)
        const corridorMid = (pi, ai)=>{
            let lo = ai;
            let hi = ai;
            while(lo > 0 && occAll[pi * na + lo - 1])lo--;
            while(hi < na - 1 && occAll[pi * na + hi + 1])hi++;
            return aMin + (lo + hi + 1) * 0.5 * w;
        };
        const cA = ctrA[0] * ux + ctrA[1] * uy;
        const spines = [];
        const build = (pi, bs, bl, start, wantBins)=>{
            // gentle local bow: mean offset within ±1 latitude bin of the chosen one
            const as = [];
            const ps = [];
            for(let ai = start; ai < start + wantBins; ai++){
                let s = 0;
                let c = 0;
                for(let dp = -1; dp <= 1; dp++){
                    const qi = pi + dp;
                    if (qi < 0 || qi >= np) continue;
                    s += pSum[qi * na + ai];
                    c += occ[qi * na + ai];
                }
                as.push(aMin + (ai + 0.5) * w);
                ps.push(c ? s / c : pMin + (pi + 0.5) * w);
            }
            // the bow may bend the middle but must never tilt the chord away from
            // the scanned direction — on short runs the per-bin means otherwise
            // rotate a 60° slice into near-vertical text. Remove the linear drift
            // so both endpoints sit at the same latitude.
            const n = ps.length - 1;
            if (n > 0) {
                const drift = ps[n] - ps[0];
                for(let i = 0; i <= n; i++)ps[i] -= (i / n - 0.5) * drift;
            }
            const P = as.map((a, i)=>[
                    a * ux + ps[i] * vxx,
                    a * uy + ps[i] * vyy
                ]);
            const pts = smoothed(P, 6);
            return {
                pts: pts,
                len: lengthOf(pts)
            };
        };
        for(let pi = 0; pi < np; pi++){
            let runStart = 0;
            let runLen = 0;
            for(let ai = 0; ai <= na; ai++)if (ai < na && occ[pi * na + ai]) {
                if (!runLen) runStart = ai;
                runLen++;
            } else {
                if (runLen && runLen * w >= minLen) {
                    const wantBins = Math.min(runLen, Math.max(3, Math.ceil(minLen * 1.25 / w)));
                    // the window's home is the MIDDLE of its corridor — a label reads
                    // as aligned when the leftover run margins balance, not when it
                    // hugs whichever end is nearer some global centroid (Sivas sat
                    // hard against its eastern border with a plain to the west)
                    const centered = runStart + Math.round((runLen - wantBins) / 2);
                    let atAim = Math.round((cA - aMin) / w - wantBins / 2);
                    atAim = Math.max(runStart, Math.min(runStart + runLen - wantBins, atAim));
                    const visMidA = corridorMid(pi, runStart + (runLen >> 1));
                    const push = (start)=>{
                        const sp = build(pi, runStart, runLen, start, wantBins);
                        sp.alongOff = Math.abs(aMin + (start + wantBins / 2) * w - visMidA);
                        spines.push(sp);
                    };
                    let atVis = Math.round((visMidA - aMin) / w - wantBins / 2);
                    atVis = Math.max(runStart, Math.min(runStart + runLen - wantBins, atVis));
                    const starts = new Set([
                        centered,
                        atAim,
                        atVis
                    ]);
                    // slide the window to the run's ends too when there's real slack
                    if (runLen - wantBins >= 3) {
                        starts.add(runStart);
                        starts.add(runStart + runLen - wantBins);
                    }
                    for (const st of starts)push(st);
                }
                runLen = 0;
            }
        }
        return spines;
    };
    // unrestricted spine: farthest pair in the component via double BFS
    const freeSpine = (tc)=>{
        const bfs = (start)=>{
            const dist = new Int32Array(W * H).fill(-1);
            const par = new Int32Array(W * H).fill(-1);
            const q = [
                start
            ];
            dist[start] = 0;
            let far = start;
            for(let qi = 0; qi < q.length; qi++){
                const k = q[qi];
                if (dist[k] > dist[far]) far = k;
                const ci = k % W;
                const cj = k / W | 0;
                for(let dj = -1; dj <= 1; dj++)for(let di = -1; di <= 1; di++){
                    const ni = ci + di;
                    const nj = cj + dj;
                    if (ni < 0 || nj < 0 || ni >= W || nj >= H) continue;
                    const nk = nj * W + ni;
                    if (tc.comp[nk] === tc.id && dist[nk] < 0) {
                        dist[nk] = dist[k] + 1;
                        par[nk] = k;
                        q.push(nk);
                    }
                }
            }
            return {
                far: far,
                par: par
            };
        };
        const end1 = bfs(tc.seed).far;
        const r = bfs(end1);
        const cells = [];
        for(let k = r.far; k >= 0; k = r.par[k])cells.push(k);
        if (cells.length < 3) return null;
        const pts = smoothed(cells.map(cellXY), 8);
        return {
            pts: pts,
            len: lengthOf(pts)
        };
    };
    // a candidate fits a size when the text's own window (centered on the
    // line) is long enough AND thick enough at every point along it
    const fits = (spine, s)=>{
        const tl = textLen(s);
        if (tl > spine.len * 0.96) return false;
        const lo = (spine.len - tl) / 2;
        const hi = (spine.len + tl) / 2;
        let cum = 0;
        for(let i = 0; i < spine.pts.length; i++){
            if (i > 0) cum += Math.hypot(spine.pts[i][0] - spine.pts[i - 1][0], spine.pts[i][1] - spine.pts[i - 1][1]);
            if (cum < lo || cum > hi) continue;
            if (clearAt(spine.pts[i]) < $7f26ce88f690a70e$export$f80c391eaed27b3.thick * s) return false;
        }
        return true;
    };
    // top-down size ladder, scored: every candidate at every size gets
    //   score = size × angle penalty × centering penalty
    // so a slightly smaller line through the center beats a big one hugging an
    // edge, a flat line beats a tilted one of similar size, and a steeper angle
    // still wins when it genuinely buys legibility (its band fits bigger text)
    // steeper directions are scanned too — a diagonal region (Elazığ, Kütahya)
    // often fits far bigger text along its own axis. Rather than penalizing tilt
    // per se, each size's candidates are judged against the region's own grain:
    // the principal axis of the thick component, blended toward horizontal for
    // round shapes (a blob like Sivas wants flat text; a slanted strip wants
    // text that runs with it).
    const DIRS = [
        0,
        -10,
        10,
        -15,
        15,
        -20,
        20,
        -25,
        25,
        -30,
        30,
        -40,
        40,
        -50,
        50,
        -60,
        60
    ];
    // centering is judged where the eye judges it: the distance between the
    // text's optical middle (baseline mid lifted back up by cap height + bow)
    // and the shape's visual centroid, in BOTH axes, relative to region size —
    // a slightly smaller label that truly sits on the region's center beats a
    // bigger one crammed into an off-center band
    const R = Math.sqrt(count) * step / $7f26ce88f690a70e$export$f80c391eaed27b3.rDiv;
    // centering error of a placement: across the reading direction it is the
    // optical middle's distance from the aim point; along it, the imbalance of
    // the window inside its own corridor. Judging the along-axis against the
    // global centroid instead pins labels to whichever end of their corridor
    // is nearer the centroid, leaving lopsided margins.
    const opticalDist = (spine, s, theta, aim)=>{
        const mid = spine.pts[Math.floor(spine.pts.length / 2)];
        const drop = baseDrop(s);
        const ox = mid[0] + Math.sin(theta) * drop;
        const oy = mid[1] - Math.cos(theta) * drop;
        const cross = Math.abs((ox - aim[0]) * -Math.sin(theta) + (oy - aim[1]) * Math.cos(theta));
        return Math.hypot(cross, spine.alongOff ?? 0);
    };
    const scoreOf = (s, deg, dist, target, roomy = 1)=>s * (1 - Math.abs(deg - target) / $7f26ce88f690a70e$export$f80c391eaed27b3.angDiv) * (1 - Math.abs(deg) * $7f26ce88f690a70e$export$f80c391eaed27b3.flatBias) * (1 - $7f26ce88f690a70e$export$f80c391eaed27b3.centerW * Math.min(1, dist / R) ** $7f26ce88f690a70e$export$f80c391eaed27b3.centerExp) * (1 - $7f26ce88f690a70e$export$f80c391eaed27b3.comfortW * (1 - roomy));
    // how roomy the placement is: 1 when the line's middle has generous
    // clearance, shrinking toward 0 as it sits in a pinched neck of the shape
    const roominess = (spine, s)=>Math.min(1, clearAt(spine.pts[Math.floor(spine.pts.length / 2)]) / (0.8 * s));
    let pick = null;
    let bestSize = 0;
    const upper = Math.min($7f26ce88f690a70e$var$MAX_SIZE, Math.hypot(bx2 - bx1, by2 - by1) / nameEm);
    for(let s = Math.min($7f26ce88f690a70e$var$MAX_SIZE, upper); s >= $7f26ce88f690a70e$var$MIN_ARC_SIZE; s *= 0.93){
        // even a perfectly centered flat line can't beat the current pick once
        // sizes drop below its score — stop scanning
        if (pick && s <= pick.score) break;
        const tc = thickComp(s);
        if (!tc) continue;
        // center on the mass of where the label can actually live at this size:
        // when a region's only roomy part is off to one side (Antalya's west),
        // the label follows the room instead of clinging to the raw centroid
        let tx = 0;
        let ty = 0;
        for (const k of tc.cells){
            const [x, y] = cellXY(k);
            tx += x;
            ty += y;
        }
        const tCtr = [
            tx / tc.cells.length,
            ty / tc.cells.length
        ];
        const grain = Math.max(0, Math.min(1, (elongShape - $7f26ce88f690a70e$export$f80c391eaed27b3.grainKnee) / 0.45)) * $7f26ce88f690a70e$export$f80c391eaed27b3.grainMul;
        let target = Math.max(-65, Math.min(65, phiShape)) * Math.min(1, grain);
        // corridor-ness of the fittable room: a strip whose width is small next
        // to its skeleton length is a corridor, and text in a corridor should
        // run WITH it. Shape-level PCA cannot tell — a bent strip (Kütahya's S,
        // Samsun's coastal arc) averages out to "round" — so this is measured on
        // the thick component's free spine, and corridors take their target
        // angle from the spine's chord instead of the principal axis.
        const fs = freeSpine(tc);
        let corrW = 0;
        let dbgFs = 0;
        let dbgMc = 0;
        if (fs) {
            let maxClear = 0;
            for (const k of tc.cells)if (clear[k] > maxClear) maxClear = clear[k];
            dbgFs = fs.len;
            dbgMc = maxClear * step;
            const corridor = Math.max(0, Math.min(1, 1 - 2 * maxClear * step / Math.max(1e-6, fs.len)));
            corrW = Math.max(0, Math.min(1, (corridor - $7f26ce88f690a70e$export$f80c391eaed27b3.corrKnee) / 0.3));
        }
        if (fs && corrW > 0) {
            let fdx = fs.pts[fs.pts.length - 1][0] - fs.pts[0][0];
            let fdy = fs.pts[fs.pts.length - 1][1] - fs.pts[0][1];
            if (fdx < 0) {
                fdx = -fdx;
                fdy = -fdy;
            }
            const chord = Math.max(-65, Math.min(65, Math.atan2(fdy, Math.max(1e-6, fdx)) * 180 / Math.PI));
            target = target * (1 - corrW) + chord * corrW;
        }
        // when the room that can hold text at this size is only a sliver of the
        // region (Antalya: a fat bulge on a long thin coast), center within the
        // room — the label cannot visually span the whole shape anyway. As the
        // room grows to cover the region, the aim eases back to the shape center.
        const cov = Math.min(1, tc.cells.length / count * $7f26ce88f690a70e$export$f80c391eaed27b3.aimK);
        const aim = [
            tCtr[0] * (1 - cov) + sCtr[0] * cov,
            tCtr[1] * (1 - cov) + sCtr[1] * cov
        ];
        const dbg = typeof localStorage !== 'undefined' && localStorage.getItem('labelDebug') === name ? globalThis.__labelCand ??= [] : null;
        if (dbg) dbg.push({
            s: Math.round(s * 10) / 10,
            cells: tc.cells.length,
            phi: Math.round(phiShape),
            elong: Math.round(elongShape * 100) / 100,
            target: Math.round(target),
            corrW: Math.round(corrW * 100) / 100,
            fsLen: Math.round(dbgFs),
            mc: Math.round(dbgMc),
            sCtr: sCtr.map(Math.round),
            R: Math.round(R)
        });
        for (const deg of DIRS){
            const rad = deg * Math.PI / 180;
            for (const spine of sliceSpines(tc.cells, rad, textLen(s) * 1.04, s, sCtr)){
                const fit = fits(spine, s);
                if (dbg) dbg.push({
                    s: Math.round(s * 10) / 10,
                    deg: deg,
                    fit: fit,
                    len: Math.round(spine.len),
                    mid: spine.pts[Math.floor(spine.pts.length / 2)].map(Math.round)
                });
                if (!fit) continue;
                const score = scoreOf(s, deg, opticalDist(spine, s, rad, aim), target, roominess(spine, s));
                bestSize = Math.max(bestSize, s);
                if (!pick || score > pick.score) pick = {
                    size: s,
                    pts: spine.pts,
                    score: score
                };
            }
        }
        // the unrestricted spine is a last resort for snaking shapes: it must
        // rank below the steepest scanned direction, and a chord steeper than
        // ~50° is rejected outright — names should never read near-vertically
        // (straight steep runs are already covered by the ±60° scan above)
        if (fs && fits(fs, s)) {
            const [fx, fy] = fs.pts[0];
            const [gx, gy] = fs.pts[fs.pts.length - 1];
            if (Math.abs(gy - fy) > Math.abs(gx - fx) * Math.tan(50 * Math.PI / 180)) continue;
            const score = s * 0.5 * (1 - $7f26ce88f690a70e$export$f80c391eaed27b3.centerW * Math.min(1, opticalDist(fs, s, Math.atan2(gy - fy, gx - fx), aim) / R) ** $7f26ce88f690a70e$export$f80c391eaed27b3.centerExp);
            bestSize = Math.max(bestSize, s);
            if (!pick || score > pick.score) pick = {
                size: s,
                pts: fs.pts,
                score: score
            };
        }
    }
    if (!pick || pick.size < $7f26ce88f690a70e$var$MIN_ARC_SIZE) return {
        kind: 'plain',
        size: Math.max(7.5, Math.min(9, bestSize + 2))
    };
    let spine = pick.pts;
    const size = pick.size;
    // orient so the text reads naturally: never advancing leftward (which
    // would set the glyphs near upside-down), top-down only if truly vertical
    const dx = spine[spine.length - 1][0] - spine[0][0];
    const dy = spine[spine.length - 1][1] - spine[0][1];
    if (Math.abs(dx) < 1e-6 ? dy < 0 : dx < 0) spine = [
        ...spine
    ].reverse();
    // quadratic through the spine's endpoints and its arc-length midpoint
    const A = spine[0];
    const B = spine[spine.length - 1];
    let total = 0;
    const cum = [
        0
    ];
    for(let i = 1; i < spine.length; i++){
        total += Math.hypot(spine[i][0] - spine[i - 1][0], spine[i][1] - spine[i - 1][1]);
        cum.push(total);
    }
    let M = spine[Math.floor(spine.length / 2)];
    for(let i = 1; i < spine.length; i++)if (cum[i] >= total / 2) {
        const t = (total / 2 - cum[i - 1]) / Math.max(1e-6, cum[i] - cum[i - 1]);
        M = [
            spine[i - 1][0] + (spine[i][0] - spine[i - 1][0]) * t,
            spine[i - 1][1] + (spine[i][1] - spine[i - 1][1]) * t
        ];
        break;
    }
    // every label gets a gentle arc: cap excessive bow, give dead-straight lines
    // a slight one, and prefer arching OUT (crown, ∩) over sagging in (∪) for
    // horizontal text — unless the crowned midpoint would leave the thick area
    const chordMid = [
        (A[0] + B[0]) / 2,
        (A[1] + B[1]) / 2
    ];
    const chordLen = Math.hypot(B[0] - A[0], B[1] - A[1]);
    const nx = -(B[1] - A[1]) / Math.max(1e-6, chordLen);
    const ny = (B[0] - A[0]) / Math.max(1e-6, chordLen);
    const maxSag = Math.min(size * 0.55, chordLen * 0.12);
    const minSag = Math.min(maxSag, Math.max(2, chordLen * 0.05));
    let sag = (M[0] - chordMid[0]) * nx + (M[1] - chordMid[1]) * ny;
    const mag = Math.max(minSag, Math.min(Math.abs(sag), maxSag));
    const horizontalish = Math.abs(B[0] - A[0]) >= Math.abs(B[1] - A[1]);
    // for a left-to-right chord the normal points down, so negative sag = crown
    const crown = horizontalish ? -1 : Math.sign(sag) || 1;
    const crowned = [
        chordMid[0] + nx * crown * mag,
        chordMid[1] + ny * crown * mag
    ];
    if (Math.sign(sag) === crown || clearAt(crowned) >= 0.55 * size) sag = crown * mag;
    else sag = (Math.sign(sag) || 1) * mag;
    M = [
        chordMid[0] + nx * sag,
        chordMid[1] + ny * sag
    ];
    const CX = 2 * M[0] - (A[0] + B[0]) / 2;
    const CY = 2 * M[1] - (A[1] + B[1]) / 2;
    const fmt = (n)=>Math.round(n * 10) / 10;
    return {
        kind: 'arc',
        d: `M ${fmt(A[0])},${fmt(A[1])} Q ${fmt(CX)},${fmt(CY)} ${fmt(B[0])},${fmt(B[1])}`,
        size: Math.round(size * 10) / 10
    };
}



var $b69769860c20ebee$exports = {};
$b69769860c20ebee$exports = JSON.parse("{\"eskisehir\":{\"x\":584,\"y\":353,\"ang\":-12,\"len\":176.7,\"size\":24.8,\"bow\":-8.8},\"ankara\":{\"x\":721,\"y\":333,\"ang\":-6,\"len\":126,\"size\":23.5,\"bow\":-11.5},\"sivas\":{\"x\":893,\"y\":339,\"ang\":0,\"len\":160.9,\"size\":32,\"bow\":-8},\"erzurum\":{\"x\":1129.4,\"y\":355,\"ang\":0,\"len\":226.9,\"size\":32,\"bow\":-11.4},\"trabzon\":{\"x\":1094,\"y\":268,\"ang\":-22,\"len\":128.7,\"size\":23.5,\"bow\":-6.4},\"samsun\":{\"x\":802,\"y\":222,\"ang\":2,\"len\":151,\"size\":29.2,\"bow\":-11.5},\"kastamonu\":{\"x\":694,\"y\":269.6,\"ang\":-14,\"len\":137.8,\"size\":18.4,\"bow\":-14.9},\"kutahya\":{\"x\":602.3,\"y\":424.4,\"ang\":-37,\"len\":90,\"size\":17.9,\"bow\":-7.2},\"aleppo\":{\"x\":1026.4,\"y\":632.4,\"ang\":-10,\"len\":207.4,\"size\":39.1,\"bow\":-10.4},\"baghdad\":{\"x\":1236.2,\"y\":750.1,\"ang\":0,\"len\":268.5,\"size\":32,\"bow\":-13.5},\"edirne\":{\"x\":423.8,\"y\":233.4,\"ang\":-27,\"len\":111,\"size\":21.9,\"bow\":-5.6},\"sofia\":{\"x\":241,\"y\":123.4,\"ang\":-28,\"len\":119.4,\"size\":27.6,\"bow\":-6},\"varna\":{\"x\":382.8,\"y\":94.4,\"ang\":-7,\"len\":150,\"size\":27.7,\"bow\":-7.5},\"plovdiv\":{\"x\":253.5,\"y\":172.5,\"ang\":-24,\"len\":135,\"size\":22.1,\"bow\":4.7},\"western-thrace\":{\"x\":304.8,\"y\":230.4,\"ang\":-1,\"len\":117.1,\"size\":11.8,\"bow\":2.2},\"izmir\":{\"x\":408.6,\"y\":397.9,\"ang\":86,\"len\":73,\"size\":18.2,\"bow\":-3.5},\"aydin\":{\"x\":454.6,\"y\":475.9,\"ang\":49,\"len\":110.2,\"size\":25.8,\"bow\":-4.3},\"isparta\":{\"x\":594.8,\"y\":503.2,\"ang\":0,\"len\":108,\"size\":19.8,\"bow\":-5.4},\"antalya\":{\"x\":562.6,\"y\":538.3,\"ang\":-38,\"len\":62,\"size\":13.7,\"bow\":-2.9},\"adana\":{\"x\":774.6,\"y\":528.2,\"ang\":-36,\"len\":90,\"size\":23.7,\"bow\":-3.5},\"diyarbakir\":{\"x\":1073.8,\"y\":474.3,\"ang\":-20,\"len\":164.1,\"size\":22.8,\"bow\":8},\"izmit\":{\"x\":549.3,\"y\":244.6,\"ang\":0,\"len\":51,\"size\":14.2,\"bow\":1},\"sakarya\":{\"x\":606.9,\"y\":260.9,\"ang\":-31.9,\"len\":66,\"size\":14.7,\"bow\":-5.8},\"kars\":{\"x\":1235.4,\"y\":292.6,\"ang\":-18,\"len\":66,\"size\":18.9,\"bow\":-3.3},\"igdir\":{\"x\":1286.3,\"y\":323,\"ang\":14.1,\"len\":60,\"size\":16.6,\"bow\":-3},\"elazig\":{\"x\":1022.2,\"y\":436.1,\"ang\":-34,\"len\":116.9,\"size\":24.2,\"bow\":-14.4},\"konya\":{\"x\":713.3,\"y\":442.6,\"ang\":0,\"len\":128.1,\"size\":28.9,\"bow\":-6.4},\"burgas\":{\"x\":374.3,\"y\":160.6,\"ang\":-29,\"len\":117,\"size\":21.8,\"bow\":-12.8},\"maras\":{\"x\":892.8,\"y\":477.6,\"ang\":-34,\"len\":112.1,\"size\":29.1,\"bow\":-10.3},\"salonica\":{\"x\":190.5,\"y\":256.9,\"ang\":-23,\"len\":102,\"size\":16.9,\"bow\":-9.1},\"balikesir\":{\"x\":430.3,\"y\":340.3,\"ang\":19,\"len\":123.1,\"size\":18.6,\"bow\":-11.7},\"istanbul\":{\"x\":522,\"y\":205,\"ang\":12,\"len\":94,\"size\":17.1,\"bow\":3.5},\"usak\":{\"x\":490.2,\"y\":421.1,\"ang\":30,\"len\":100.1,\"size\":29.8,\"bow\":-5},\"lesbos\":{\"x\":356,\"y\":383,\"ang\":10,\"len\":68.3,\"size\":15.7,\"bow\":8},\"rhodes\":{\"x\":396,\"y\":531,\"ang\":61,\"len\":71.3,\"size\":16.5,\"bow\":9},\"hatay\":{\"x\":868.5,\"y\":555,\"ang\":-72,\"len\":64,\"size\":18.3,\"bow\":-9.8},\"yerevan\":{\"x\":1313.6,\"y\":309,\"ang\":31,\"len\":66,\"size\":15.1,\"bow\":-7.5},\"sevan\":{\"x\":1384.7,\"y\":350.5,\"ang\":43,\"len\":86,\"size\":17.8,\"bow\":-2.1},\"vanadzor\":{\"x\":1362.4,\"y\":281.9,\"ang\":52,\"len\":103,\"size\":14.1,\"bow\":-6.5},\"gelibolu\":{\"x\":376.7,\"y\":285.5,\"ang\":-46,\"len\":70,\"size\":10.2,\"bow\":-6.5},\"canakkale\":{\"x\":389.3,\"y\":302.9,\"ang\":-44,\"len\":77.9,\"size\":9,\"bow\":-8.5}}");




const $e83582f0aa0103b8$var$cacheByKey = new Map();
function $e83582f0aa0103b8$export$70601bf16a9b7a55(names, cacheKey = 'default') {
    const hit = $e83582f0aa0103b8$var$cacheByKey.get(cacheKey);
    if (hit) return hit;
    const canvas = document.createElement('canvas');
    canvas.width = canvas.height = 1;
    const ctx = canvas.getContext('2d');
    const layouts = {};
    for (const [slug, data] of Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($320e50466335b17c$exports))).territories)){
        const name = names[slug] ?? slug;
        // hand-pinned placements win outright; the engine covers the rest
        const pin = (0, (/*@__PURE__*/$parcel$interopDefault($b69769860c20ebee$exports)))[slug];
        layouts[slug] = pin ? (0, $3780a3745535c467$export$229206c232c9b1b8)(pin) : ctx ? (0, $7f26ce88f690a70e$export$7b85b809d53bc520)(ctx, data, name) : {
            kind: 'plain',
            size: 9
        };
    }
    $e83582f0aa0103b8$var$cacheByKey.set(cacheKey, layouts);
    return layouts;
}
// dev-only: recompute all layouts under trial PARAMS without reloading, so
// scoring constants can be grid-searched in the browser console
if (typeof window !== 'undefined') window.__labelSweep = (trial, names)=>{
    const saved = {
        ...(0, $7f26ce88f690a70e$export$f80c391eaed27b3)
    };
    Object.assign((0, $7f26ce88f690a70e$export$f80c391eaed27b3), trial);
    const canvas = document.createElement('canvas');
    canvas.width = canvas.height = 1;
    const ctx = canvas.getContext('2d');
    const out = {};
    for (const [slug, data] of Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($320e50466335b17c$exports))).territories)){
        const l = (0, $7f26ce88f690a70e$export$7b85b809d53bc520)(ctx, data, names[slug] ?? slug);
        if (l.kind === 'arc') {
            const m = l.d.match(/M ([\d.-]+),([\d.-]+) Q [\d.-]+,[\d.-]+ ([\d.-]+),([\d.-]+)/);
            const [ax, ay, bx, by] = m.slice(1).map(Number);
            out[slug] = {
                size: l.size,
                ang: Math.round(Math.atan2(by - ay, bx - ax) * 1800 / Math.PI) / 10,
                midX: Math.round((ax + bx) / 2),
                midY: Math.round((ay + by) / 2)
            };
        } else out[slug] = {
            size: l.size,
            plain: true
        };
    }
    Object.assign((0, $7f26ce88f690a70e$export$f80c391eaed27b3), saved);
    return out;
};




const $ac3528b727779928$export$132f4ab9e276e5ff = ()=>typeof location !== 'undefined' && new URLSearchParams(location.search).has('labelEdit');
const $ac3528b727779928$var$round1 = (n)=>Math.round(n * 10) / 10;
const $ac3528b727779928$export$467dcc46fd03fabc = (layout, name, anchor)=>{
    if (layout.kind === 'arc') {
        const m = layout.d.match(/M ([\d.-]+),([\d.-]+) Q ([\d.-]+),([\d.-]+) ([\d.-]+),([\d.-]+)/);
        if (m) {
            const [ax, ay, cx, cy, bx, by] = m.slice(1).map(Number);
            const x = (ax + bx) / 2;
            const y = (ay + by) / 2;
            const len = Math.hypot(bx - ax, by - ay);
            const ang = Math.atan2(by - ay, bx - ax) * 180 / Math.PI;
            // curve midpoint (t = 0.5) projected on the chord normal
            const mx = 0.25 * ax + 0.5 * cx + 0.25 * bx;
            const my = 0.25 * ay + 0.5 * cy + 0.25 * by;
            const nx = -(by - ay) / Math.max(1e-6, len);
            const ny = (bx - ax) / Math.max(1e-6, len);
            const bow = (mx - x) * nx + (my - y) * ny;
            return {
                x: $ac3528b727779928$var$round1(x),
                y: $ac3528b727779928$var$round1(y),
                ang: $ac3528b727779928$var$round1(ang),
                len: $ac3528b727779928$var$round1(len),
                size: layout.size,
                bow: $ac3528b727779928$var$round1(bow)
            };
        }
    }
    return {
        x: anchor[0],
        y: anchor[1] - 15,
        ang: 0,
        len: $ac3528b727779928$var$round1(name.length * 0.85 * layout.size + 20),
        size: layout.size,
        bow: 0
    };
};
const $ac3528b727779928$var$FIELDS = [
    {
        key: 'size',
        label: 'Size',
        min: 5,
        max: 40,
        step: 0.1
    },
    {
        key: 'ang',
        label: 'Angle',
        min: -90,
        max: 90,
        step: 1
    },
    {
        key: 'len',
        label: 'Length',
        min: 20,
        max: 500,
        step: 1
    },
    {
        key: 'bow',
        label: "Bow \u2229\u2212/\u222A+",
        min: -60,
        max: 60,
        step: 0.5
    },
    {
        key: 'x',
        label: 'X',
        min: 30,
        max: 1530,
        step: 1
    },
    {
        key: 'y',
        label: 'Y',
        min: 0,
        max: 820,
        step: 1
    }
];
const $ac3528b727779928$var$S = {
    panel: {
        position: 'fixed',
        top: 12,
        right: 12,
        zIndex: 50,
        width: 272,
        background: 'rgba(28, 21, 12, 0.94)',
        color: '#f0e6cd',
        font: '12px/1.45 system-ui, sans-serif',
        borderRadius: 8,
        padding: '10px 12px',
        boxShadow: '0 4px 18px rgba(0,0,0,0.5)'
    },
    h: {
        margin: '0 0 6px',
        font: '600 13px system-ui',
        display: 'flex',
        justifyContent: 'space-between'
    },
    row: {
        display: 'flex',
        alignItems: 'center',
        gap: 6,
        margin: '3px 0'
    },
    lab: {
        width: 64,
        opacity: 0.85,
        whiteSpace: 'nowrap'
    },
    range: {
        flex: 1,
        minWidth: 0
    },
    num: {
        width: 58,
        background: '#0004',
        color: 'inherit',
        border: '1px solid #f0e6cd44',
        borderRadius: 4,
        padding: '1px 4px'
    },
    btn: {
        background: '#f0e6cd22',
        color: 'inherit',
        border: '1px solid #f0e6cd44',
        borderRadius: 4,
        padding: '2px 8px',
        cursor: 'pointer',
        font: 'inherit'
    },
    ta: {
        width: '100%',
        height: 90,
        marginTop: 6,
        background: '#0004',
        color: '#cdeac0',
        border: '1px solid #f0e6cd33',
        borderRadius: 4,
        font: '10px/1.35 ui-monospace, monospace',
        boxSizing: 'border-box'
    },
    hint: {
        opacity: 0.6,
        margin: '4px 0 0',
        fontSize: 11
    }
};
const $ac3528b727779928$var$DOT_FIELDS = [
    {
        key: 'x',
        label: 'X',
        min: 30,
        max: 1530,
        step: 1
    },
    {
        key: 'y',
        label: 'Y',
        min: 0,
        max: 820,
        step: 1
    }
];
const $ac3528b727779928$export$7e9380a637caa496 = ({ slug: slug, name: name, kind: kind, params: params, dot: dot, computed: computed, overridden: overridden, overrides: overrides, dotOverrides: dotOverrides, decorOverrides: decorOverrides, colorDefaults: colorDefaults, onChange: onChange, onChangeDot: onChangeDot, onReset: onReset, onClearAll: onClearAll, onDeselect: onDeselect })=>{
    const json = JSON.stringify(overrides, null, 1);
    const dotJson = JSON.stringify(dotOverrides, null, 1);
    const decorJson = JSON.stringify(decorOverrides, null, 1);
    const copy = (text)=>()=>{
            navigator.clipboard?.writeText(text).catch(()=>{});
        };
    // the panel itself is draggable by its header, so labels underneath it stay
    // reachable
    const [off, setOff] = (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useState({
        x: 0,
        y: 0
    });
    const dragPanel = (e)=>{
        e.preventDefault();
        const sx = e.clientX - off.x;
        const sy = e.clientY - off.y;
        const move = (ev)=>setOff({
                x: ev.clientX - sx,
                y: ev.clientY - sy
            });
        const up = ()=>{
            window.removeEventListener('pointermove', move);
            window.removeEventListener('pointerup', up);
        };
        window.addEventListener('pointermove', move);
        window.addEventListener('pointerup', up);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        style: {
            ...$ac3528b727779928$var$S.panel,
            transform: `translate(${off.x}px, ${off.y}px)`
        },
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h3", {
                style: {
                    ...$ac3528b727779928$var$S.h,
                    cursor: 'move',
                    userSelect: 'none'
                },
                onPointerDown: dragPanel,
                title: "Drag to move the panel",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: "\u283F Label editor"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        style: {
                            opacity: 0.6
                        },
                        children: [
                            Object.keys(overrides).length,
                            "L \xb7 ",
                            Object.keys(dotOverrides).length,
                            "D \xb7 ",
                            Object.keys(decorOverrides).length,
                            "S"
                        ]
                    })
                ]
            }),
            slug && (kind === 'label' || kind === 'decor') && params && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            ...$ac3528b727779928$var$S.row,
                            justifyContent: 'space-between'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                children: name
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        style: $ac3528b727779928$var$S.btn,
                                        onClick: onReset,
                                        disabled: !overridden,
                                        title: "Drop this label's override",
                                        children: "Reset"
                                    }),
                                    ' ',
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        style: $ac3528b727779928$var$S.btn,
                                        onClick: onDeselect,
                                        children: "\xd7"
                                    })
                                ]
                            })
                        ]
                    }),
                    $ac3528b727779928$var$FIELDS.map((f)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: $ac3528b727779928$var$S.row,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: $ac3528b727779928$var$S.lab,
                                    children: f.label
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    style: $ac3528b727779928$var$S.range,
                                    type: "range",
                                    min: f.min,
                                    max: f.max,
                                    step: f.step,
                                    value: params[f.key],
                                    onChange: (e)=>onChange({
                                            [f.key]: Number(e.target.value)
                                        })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    style: $ac3528b727779928$var$S.num,
                                    type: "number",
                                    step: f.step,
                                    value: params[f.key],
                                    onChange: (e)=>onChange({
                                            [f.key]: Number(e.target.value)
                                        })
                                })
                            ]
                        }, f.key)),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: $ac3528b727779928$var$S.row,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: $ac3528b727779928$var$S.lab,
                                children: "Fill"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "color",
                                value: params.fill ?? colorDefaults.fill,
                                onChange: (e)=>onChange({
                                        fill: e.target.value
                                    })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: $ac3528b727779928$var$S.lab,
                                children: "Outline"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "color",
                                value: params.stroke ?? colorDefaults.stroke,
                                onChange: (e)=>onChange({
                                        stroke: e.target.value
                                    })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: $ac3528b727779928$var$S.row,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                style: $ac3528b727779928$var$S.lab,
                                children: "Outline w"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                style: $ac3528b727779928$var$S.range,
                                type: "range",
                                min: 0,
                                max: 0.5,
                                step: 0.01,
                                value: params.strokeW ?? colorDefaults.strokeW,
                                onChange: (e)=>onChange({
                                        strokeW: Number(e.target.value)
                                    })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                style: $ac3528b727779928$var$S.num,
                                type: "number",
                                min: 0,
                                max: 0.5,
                                step: 0.01,
                                value: params.strokeW ?? colorDefaults.strokeW,
                                onChange: (e)=>onChange({
                                        strokeW: Number(e.target.value)
                                    })
                            })
                        ]
                    }),
                    computed && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                        style: $ac3528b727779928$var$S.hint,
                        children: [
                            "engine: ",
                            computed.size,
                            "px ",
                            computed.ang,
                            "\xb0 len ",
                            computed.len,
                            " bow ",
                            computed.bow,
                            " @ ",
                            computed.x,
                            ",",
                            computed.y
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        style: $ac3528b727779928$var$S.hint,
                        children: "Drag label to move \xb7 arrows nudge (\u21E7 \xd710)"
                    })
                ]
            }),
            slug && kind === 'dot' && dot && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        style: {
                            ...$ac3528b727779928$var$S.row,
                            justifyContent: 'space-between'
                        },
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("strong", {
                                children: [
                                    name,
                                    " \u2014 army dot"
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        style: $ac3528b727779928$var$S.btn,
                                        onClick: onReset,
                                        disabled: !overridden,
                                        title: "Drop this dot's override",
                                        children: "Reset"
                                    }),
                                    ' ',
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                        style: $ac3528b727779928$var$S.btn,
                                        onClick: onDeselect,
                                        children: "\xd7"
                                    })
                                ]
                            })
                        ]
                    }),
                    $ac3528b727779928$var$DOT_FIELDS.map((f)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            style: $ac3528b727779928$var$S.row,
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    style: $ac3528b727779928$var$S.lab,
                                    children: f.label
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    style: $ac3528b727779928$var$S.range,
                                    type: "range",
                                    min: f.min,
                                    max: f.max,
                                    step: f.step,
                                    value: dot[f.key],
                                    onChange: (e)=>onChangeDot({
                                            [f.key]: Number(e.target.value)
                                        })
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                    style: $ac3528b727779928$var$S.num,
                                    type: "number",
                                    step: f.step,
                                    value: dot[f.key],
                                    onChange: (e)=>onChangeDot({
                                            [f.key]: Number(e.target.value)
                                        })
                                })
                            ]
                        }, f.key)),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        style: $ac3528b727779928$var$S.hint,
                        children: "Drag dot to move \xb7 arrows nudge (\u21E7 \xd710)"
                    })
                ]
            }),
            !slug && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                style: $ac3528b727779928$var$S.hint,
                children: "Click a label, army dot, or sea/country name to edit it. Pinch/scroll zooms as usual."
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                style: {
                    ...$ac3528b727779928$var$S.hint,
                    marginTop: 6
                },
                children: "Labels"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                style: $ac3528b727779928$var$S.ta,
                readOnly: true,
                value: json,
                onFocus: (e)=>e.currentTarget.select()
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                style: $ac3528b727779928$var$S.hint,
                children: "Army dots"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                style: {
                    ...$ac3528b727779928$var$S.ta,
                    height: 48
                },
                readOnly: true,
                value: dotJson,
                onFocus: (e)=>e.currentTarget.select()
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                style: $ac3528b727779928$var$S.hint,
                children: "Sea / country names"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textarea", {
                style: {
                    ...$ac3528b727779928$var$S.ta,
                    height: 48
                },
                readOnly: true,
                value: decorJson,
                onFocus: (e)=>e.currentTarget.select()
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                style: {
                    ...$ac3528b727779928$var$S.row,
                    justifyContent: 'space-between',
                    marginTop: 4
                },
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        style: $ac3528b727779928$var$S.btn,
                        onClick: copy(json),
                        children: "Copy labels"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        style: $ac3528b727779928$var$S.btn,
                        onClick: copy(dotJson),
                        children: "Copy dots"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        style: $ac3528b727779928$var$S.btn,
                        onClick: copy(decorJson),
                        children: "Copy decor"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        style: $ac3528b727779928$var$S.btn,
                        onClick: onClearAll,
                        disabled: !Object.keys(overrides).length && !Object.keys(dotOverrides).length && !Object.keys(decorOverrides).length,
                        children: "Clear all"
                    })
                ]
            })
        ]
    });
};


var $86359269279968a4$exports = {};
$86359269279968a4$exports = JSON.parse("{\"serbia\":{\"x\":110.7,\"y\":88.2,\"ang\":-9,\"len\":134,\"size\":17.2,\"bow\":-10.5},\"romania\":{\"x\":285,\"y\":26,\"ang\":0,\"len\":134,\"size\":17.5,\"bow\":3.5},\"black-sea\":{\"x\":792.5,\"y\":108.2,\"ang\":0,\"len\":284,\"size\":30,\"bow\":-19.5},\"aegean-sea\":{\"x\":303.1,\"y\":452.7,\"ang\":-90,\"len\":221,\"size\":23.2,\"bow\":-12},\"mediterranean-sea\":{\"x\":510.7,\"y\":732.5,\"ang\":0,\"len\":464,\"size\":27.9,\"bow\":16.5},\"iran\":{\"x\":1429.4,\"y\":467.7,\"ang\":0,\"len\":127,\"size\":26.6,\"bow\":-5.5},\"crete\":{\"x\":295,\"y\":658.2,\"ang\":0,\"len\":74,\"size\":16.2,\"bow\":7},\"cyprus\":{\"x\":737.2,\"y\":674.1,\"ang\":-19,\"len\":82,\"size\":13,\"bow\":7},\"greece\":{\"x\":116.8,\"y\":413.1,\"ang\":63,\"len\":204,\"size\":22,\"bow\":-14.5},\"macedonia\":{\"x\":129.1,\"y\":203.7,\"ang\":-34,\"len\":123,\"size\":13,\"bow\":10},\"russia\":{\"x\":1291,\"y\":75.1,\"ang\":20,\"len\":238,\"size\":28.2,\"bow\":-9.5},\"georgia\":{\"x\":1260.7,\"y\":178.1,\"ang\":25,\"len\":171,\"size\":18.6,\"bow\":-14},\"azerbaijan\":{\"x\":1446.4,\"y\":287.1,\"ang\":31,\"len\":168,\"size\":16,\"bow\":-18}}");




// Static path collections for the decorative (non-interactive) paint layers.
const $6bcf64dfdf6ad5a9$var$TERRITORY_PATHS = Object.values((0, (/*@__PURE__*/$parcel$interopDefault($320e50466335b17c$exports))).territories).flatMap((t)=>t.paths);
const $6bcf64dfdf6ad5a9$var$LAND_PATHS = [
    ...(0, (/*@__PURE__*/$parcel$interopDefault($320e50466335b17c$exports))).background,
    ...$6bcf64dfdf6ad5a9$var$TERRITORY_PATHS
];
const $6bcf64dfdf6ad5a9$export$4b5e6641e38c53b6 = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("defs", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("filter", {
                id: "flag-tone",
                x: "-5%",
                y: "-5%",
                width: "110%",
                height: "110%",
                colorInterpolationFilters: "sRGB",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feColorMatrix", {
                        type: "saturate",
                        values: "0.72"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feColorMatrix", {
                        type: "matrix",
                        values: "0.91502 0.10766 0.02646 0 0  0.04886 0.95604 0.02352 0 0  0.03808 0.07476 0.87834 0 0  0 0 0 1 0"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("feComponentTransfer", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feFuncR", {
                                type: "linear",
                                slope: "1.04"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feFuncG", {
                                type: "linear",
                                slope: "1.04"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feFuncB", {
                                type: "linear",
                                slope: "1.04"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("filter", {
                id: "coast-glow",
                x: "-15%",
                y: "-15%",
                width: "130%",
                height: "130%",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feGaussianBlur", {
                    in: "SourceGraphic",
                    stdDeviation: "7"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("filter", {
                id: "coast-shade",
                x: "-10%",
                y: "-10%",
                width: "120%",
                height: "120%",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feMorphology", {
                        in: "SourceAlpha",
                        operator: "erode",
                        radius: "9",
                        result: "eroded"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feGaussianBlur", {
                        in: "eroded",
                        stdDeviation: "9",
                        result: "soft"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feComposite", {
                        in: "SourceAlpha",
                        in2: "soft",
                        operator: "out",
                        result: "rim"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feFlood", {
                        floodColor: "#9b8867",
                        floodOpacity: "0.85"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feComposite", {
                        in2: "rim",
                        operator: "in"
                    })
                ]
            }),
            Object.entries((0, $45f8179f43663cce$export$543153e4c8586a40)).map(([name, style])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("filter", {
                    id: `region-shade-${name}`,
                    x: "-20%",
                    y: "-20%",
                    width: "140%",
                    height: "140%",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feMorphology", {
                            in: "SourceAlpha",
                            operator: "erode",
                            radius: "4.5",
                            result: "eroded"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feGaussianBlur", {
                            in: "eroded",
                            stdDeviation: "5",
                            result: "soft"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feComposite", {
                            in: "SourceAlpha",
                            in2: "soft",
                            operator: "out",
                            result: "rim"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feFlood", {
                            floodColor: style.stroke,
                            floodOpacity: "0.5"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feComposite", {
                            in2: "rim",
                            operator: "in"
                        })
                    ]
                }, `rs-${name}`)),
            Object.entries((0, $45f8179f43663cce$export$543153e4c8586a40)).map(([name, style])=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("filter", {
                    id: `faction-shadow-${name}`,
                    x: "-10%",
                    y: "-10%",
                    width: "120%",
                    height: "120%",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feMorphology", {
                            in: "SourceAlpha",
                            operator: "erode",
                            radius: "5",
                            result: "inner"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feMorphology", {
                            in: "inner",
                            operator: "erode",
                            radius: "7",
                            result: "core"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feGaussianBlur", {
                            in: "core",
                            stdDeviation: "3.5",
                            result: "soft"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feComposite", {
                            in: "inner",
                            in2: "soft",
                            operator: "out",
                            result: "band"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feFlood", {
                            floodColor: style.stroke,
                            floodOpacity: "1"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feComposite", {
                            in2: "band",
                            operator: "in"
                        })
                    ]
                }, `fs-${name}`)),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("filter", {
                id: "border-haze",
                x: "-6%",
                y: "-6%",
                width: "112%",
                height: "112%",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feGaussianBlur", {
                    in: "SourceGraphic",
                    stdDeviation: "11"
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("filter", {
                id: "border-bleed",
                x: "-4%",
                y: "-4%",
                width: "108%",
                height: "108%",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feTurbulence", {
                        type: "fractalNoise",
                        baseFrequency: "0.022",
                        numOctaves: "2",
                        seed: "11",
                        result: "noise"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feDisplacementMap", {
                        in: "SourceGraphic",
                        in2: "noise",
                        scale: "5",
                        result: "rough"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feGaussianBlur", {
                        in: "rough",
                        stdDeviation: "1.2"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("filter", {
                id: "paper-grain",
                x: "0%",
                y: "0%",
                width: "100%",
                height: "100%",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feTurbulence", {
                        type: "fractalNoise",
                        baseFrequency: "0.5",
                        numOctaves: "2",
                        seed: "7",
                        stitchTiles: "stitch"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feColorMatrix", {
                        type: "saturate",
                        values: "0"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("feComponentTransfer", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feFuncR", {
                                type: "linear",
                                slope: "1.7",
                                intercept: "-0.35"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feFuncG", {
                                type: "linear",
                                slope: "1.7",
                                intercept: "-0.35"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feFuncB", {
                                type: "linear",
                                slope: "1.7",
                                intercept: "-0.35"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feFuncA", {
                                type: "linear",
                                slope: "0",
                                intercept: "1"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("filter", {
                id: "wash-blotch",
                x: "0%",
                y: "0%",
                width: "100%",
                height: "100%",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feTurbulence", {
                        type: "fractalNoise",
                        baseFrequency: "0.008",
                        numOctaves: "3",
                        seed: "4",
                        stitchTiles: "stitch"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feColorMatrix", {
                        type: "saturate",
                        values: "0"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("feComponentTransfer", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feFuncR", {
                                type: "linear",
                                slope: "2.2",
                                intercept: "-0.6"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feFuncG", {
                                type: "linear",
                                slope: "2.2",
                                intercept: "-0.6"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feFuncB", {
                                type: "linear",
                                slope: "2.2",
                                intercept: "-0.6"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("feFuncA", {
                                type: "linear",
                                slope: "0",
                                intercept: "1"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("radialGradient", {
                id: "vignette-grad",
                cx: "50%",
                cy: "50%",
                r: "70%",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                        offset: "0%",
                        stopColor: "#2a2116",
                        stopOpacity: "0"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                        offset: "58%",
                        stopColor: "#2a2116",
                        stopOpacity: "0"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                        offset: "88%",
                        stopColor: "#2a2116",
                        stopOpacity: "0.2"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                        offset: "100%",
                        stopColor: "#2a2116",
                        stopOpacity: "0.38"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("radialGradient", {
                id: "sea-depth",
                cx: "50%",
                cy: "46%",
                r: "75%",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                        offset: "0%",
                        stopColor: "#f4efdd",
                        stopOpacity: "0.16"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                        offset: "55%",
                        stopColor: "#f4efdd",
                        stopOpacity: "0.05"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("stop", {
                        offset: "100%",
                        stopColor: "#314352",
                        stopOpacity: "0"
                    })
                ]
            })
        ]
    });
// Proper vectorized flag artwork (3:2, drawn in a 36×24 box), shared between
// the map (as symbols stretched over faction blobs) and the HUD (as icons).
// Static decorative layers, built once so re-renders skip them entirely.
const $6bcf64dfdf6ad5a9$var$CoastGlowLayer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
    filter: "url(#coast-glow)",
    opacity: "0.65",
    pointerEvents: "none",
    children: $6bcf64dfdf6ad5a9$var$LAND_PATHS.map((d, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: d,
            fill: "#f0ead8"
        }, i))
});
const $6bcf64dfdf6ad5a9$var$LandmassInkLayer = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
    filter: "url(#coast-glow)",
    opacity: "0.4",
    pointerEvents: "none",
    children: $6bcf64dfdf6ad5a9$var$LAND_PATHS.map((d, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: d,
            fill: "none",
            stroke: "#3b3122",
            strokeWidth: 5,
            strokeLinejoin: "round"
        }, i))
});
const $6bcf64dfdf6ad5a9$export$eabea6b34e7e6079 = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
    children: [
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
            filter: "url(#border-haze)",
            pointerEvents: "none",
            children: $6bcf64dfdf6ad5a9$var$TERRITORY_PATHS.map((d, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: d,
                    fill: "none",
                    stroke: "#4a3a28",
                    strokeWidth: 26,
                    strokeOpacity: 0.1,
                    strokeLinejoin: "round"
                }, `h${i}`))
        }),
        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
            filter: "url(#border-bleed)",
            pointerEvents: "none",
            children: [
                $6bcf64dfdf6ad5a9$var$TERRITORY_PATHS.map((d, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: d,
                        fill: "none",
                        stroke: "#4a3a28",
                        strokeWidth: 5,
                        strokeOpacity: 0.3,
                        strokeLinejoin: "round"
                    }, `w${i}`)),
                $6bcf64dfdf6ad5a9$var$TERRITORY_PATHS.map((d, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: d,
                        fill: "none",
                        stroke: "#33291b",
                        strokeWidth: 1.2,
                        strokeOpacity: 0.5,
                        strokeLinejoin: "round"
                    }, `c${i}`))
            ]
        })
    ]
});
const $6bcf64dfdf6ad5a9$export$40b0a0664260337c = [
    {
        slug: 'black-sea',
        text: 'Black Sea',
        cls: 'sea-label',
        x: 700,
        y: 86,
        size: 30
    },
    {
        slug: 'mediterranean-sea',
        text: 'Mediterranean Sea',
        cls: 'sea-label',
        x: 540,
        y: 742,
        size: 26
    },
    {
        slug: 'aegean-sea',
        text: 'Aegean Sea',
        cls: 'sea-label',
        x: 300,
        y: 550,
        size: 21,
        rotate: -72
    },
    {
        slug: 'russia',
        text: 'Russia',
        cls: 'country-label',
        x: 1290,
        y: 40,
        size: 18
    },
    {
        slug: 'georgia',
        text: 'Georgia',
        cls: 'country-label',
        x: 1245,
        y: 168,
        size: 15
    },
    {
        slug: 'iran',
        text: 'Iran',
        cls: 'country-label',
        x: 1468,
        y: 455,
        size: 18
    },
    {
        slug: 'serbia',
        text: 'Serbia',
        cls: 'country-label',
        x: 105,
        y: 130,
        size: 14
    },
    {
        slug: 'romania',
        text: 'Romania',
        cls: 'country-label',
        x: 285,
        y: 26,
        size: 14
    },
    {
        slug: 'cyprus',
        text: 'Cyprus',
        cls: 'country-label',
        x: 742,
        y: 686,
        size: 13
    },
    {
        slug: 'crete',
        text: 'Crete',
        cls: 'country-label',
        x: 295,
        y: 663,
        size: 14
    },
    {
        slug: 'greece',
        text: 'Greece',
        cls: 'country-label',
        x: 100,
        y: 395,
        size: 16
    },
    {
        slug: 'macedonia',
        text: 'Macedonia',
        cls: 'country-label',
        x: 140,
        y: 195,
        size: 13
    },
    {
        slug: 'azerbaijan',
        text: 'Azerbaijan',
        cls: 'country-label',
        x: 1440,
        y: 260,
        size: 16
    }
];
const $6bcf64dfdf6ad5a9$export$4f51762b8cf3521f = Object.fromEntries($6bcf64dfdf6ad5a9$export$40b0a0664260337c.map((d)=>[
        d.slug,
        d
    ]));
const $6bcf64dfdf6ad5a9$export$8a9cfb1a47760c5e = (def)=>({
        x: def.x,
        y: def.y,
        ang: def.rotate ?? 0,
        len: Math.round(def.text.length * def.size * 1.05),
        size: def.size,
        bow: 0
    });
// Set to true to re-enable the inner shadows along national borders.
const $6bcf64dfdf6ad5a9$var$SHOW_FACTION_BORDER_SHADOWS = false;
// ---- baked static art ----
// WebKit rasterizes SVG filters on the CPU and re-runs the whole chain every
// time the viewBox changes, which made pan/zoom crawl on Safari. The painted
// stack only changes on conquest, so it is rendered ONCE into an offscreen
// bitmap and the live SVG shows a single <image>; the filters never run
// during gestures. Edit mode (?labelEdit) keeps the fully live tree.
// Bitmap px per map unit for the map art, sized to the DEVICE instead of a
// fixed 2.5×: a 1× display cannot show the extra pixels a 2.5× bake pays for
// (quadratically, in filter time, encode time and memory), while phones at
// DPR 3 are capped at 2 to respect iOS canvas-area/memory budgets. Zoom
// beyond the baked resolution upscales, exactly as the old fixed scale did.
const $6bcf64dfdf6ad5a9$var$dpr = typeof window === 'undefined' ? 1 : window.devicePixelRatio || 1;
const $6bcf64dfdf6ad5a9$export$207dd4b0e7e7e3d5 = Math.min(Math.max($6bcf64dfdf6ad5a9$var$dpr, 1.5), 2);
const $6bcf64dfdf6ad5a9$export$74a6dbb120886485 = 1.5 // grain/blotch overlays — noise needs less
;
const $6bcf64dfdf6ad5a9$export$b14bb4b345d340b = `
.bg-land { fill: #e7dcc1; stroke: #bcae8e; stroke-width: 0.7; }
.sea-label { font-family: 'Iowan Old Style', 'Palatino Linotype', Palatino, Georgia, serif; font-style: italic; fill: #4f6b80; letter-spacing: 0.38em; opacity: 0.8; }
.country-label { font-family: 'Iowan Old Style', 'Palatino Linotype', Palatino, Georgia, serif; fill: #8a7a5f; letter-spacing: 0.3em; text-transform: uppercase; opacity: 0.85; }
`;
const $6bcf64dfdf6ad5a9$export$297467e10fb6132c = ({ slug: slug, text: text, layout: layout, at: at, editMode: editMode = false, isEditSel: isEditSel = false })=>layout.kind === 'arc' ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: `lp-${slug}`,
                d: layout.d,
                fill: "none",
                stroke: isEditSel ? '#ff2fd6' : $6bcf64dfdf6ad5a9$var$DEBUG_LABEL_PATHS || editMode ? '#00ff44' : 'none',
                strokeWidth: isEditSel ? 2.5 : $6bcf64dfdf6ad5a9$var$DEBUG_LABEL_PATHS || editMode ? 2 : 0
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                className: "name",
                fontSize: layout.size,
                letterSpacing: `${Math.min(0.18, 0.08 + Math.max(0, layout.size - 13) * 0.02).toFixed(3)}em`,
                style: layout.fill !== undefined || layout.stroke !== undefined || layout.strokeW !== undefined ? {
                    fill: layout.fill,
                    stroke: layout.stroke,
                    strokeWidth: layout.strokeW !== undefined ? `${layout.strokeW}em` : undefined
                } : undefined,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textPath", {
                    href: `#lp-${slug}`,
                    startOffset: "50%",
                    textAnchor: "middle",
                    children: text
                })
            })
        ]
    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
        x: at[0],
        y: at[1] - 15,
        className: "name",
        textAnchor: "middle",
        fontSize: layout.size,
        letterSpacing: "0.05em",
        // plain labels have no guide path to grab, so the text itself
        // must take pointer events while editing
        style: editMode ? {
            fill: isEditSel ? '#ff2fd6' : undefined,
            pointerEvents: 'all'
        } : undefined,
        children: text
    });
const $6bcf64dfdf6ad5a9$export$6b5d8a18060124ed = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
        className: "decor-labels",
        pointerEvents: "none",
        children: $6bcf64dfdf6ad5a9$export$40b0a0664260337c.map((def)=>{
            const p = (0, (/*@__PURE__*/$parcel$interopDefault($86359269279968a4$exports)))[def.slug];
            if (!p) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                x: def.x,
                y: def.y,
                className: def.cls,
                fontSize: def.size,
                textAnchor: "middle",
                transform: def.rotate ? `rotate(${def.rotate} ${def.x} ${def.y})` : undefined,
                children: (0, $6c154842fccf6556$export$367ec920d3208c60)(def.slug, def.text)
            }, def.slug);
            const arc = (0, $3780a3745535c467$export$229206c232c9b1b8)(p);
            const styled = p.fill !== undefined || p.stroke !== undefined || p.strokeW !== undefined;
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        id: `dp-${def.slug}`,
                        d: arc.d,
                        fill: "none"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                        className: def.cls,
                        fontSize: p.size,
                        style: styled ? {
                            fill: p.fill,
                            stroke: p.stroke,
                            strokeWidth: p.strokeW !== undefined ? `${p.strokeW}em` : undefined,
                            paintOrder: 'stroke'
                        } : undefined,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textPath", {
                            href: `#dp-${def.slug}`,
                            startOffset: "50%",
                            textAnchor: "middle",
                            children: (0, $6c154842fccf6556$export$367ec920d3208c60)(def.slug, def.text)
                        })
                    })
                ]
            }, def.slug);
        })
    });
// Debug: paint each label's chosen arc path in bright green.
// (?labelEdit=1 shows the guides regardless.)
const $6bcf64dfdf6ad5a9$var$DEBUG_LABEL_PATHS = false;
const $6bcf64dfdf6ad5a9$export$d2409c893d4bb6b5 = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: 30,
                y: 0,
                width: 1500,
                height: 820,
                fill: "#8fa7b4"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: 30,
                y: 0,
                width: 1500,
                height: 820,
                fill: "url(#sea-depth)",
                pointerEvents: "none"
            }),
            $6bcf64dfdf6ad5a9$var$CoastGlowLayer,
            $6bcf64dfdf6ad5a9$var$LandmassInkLayer,
            (0, (/*@__PURE__*/$parcel$interopDefault($320e50466335b17c$exports))).background.map((d, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: d,
                    className: "bg-land"
                }, `bg-${i}`)),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                filter: "url(#border-haze)",
                pointerEvents: "none",
                children: (0, (/*@__PURE__*/$parcel$interopDefault($320e50466335b17c$exports))).background.map((d, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: d,
                        fill: "none",
                        stroke: "#4a3a28",
                        strokeWidth: 26,
                        strokeOpacity: 0.1,
                        strokeLinejoin: "round"
                    }, `bgs-${i}`))
            })
        ]
    });
const $6bcf64dfdf6ad5a9$export$99022fc3a5833d78 = ({ bySlug: bySlug, flagClusters: flagClusters })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
        className: "flag-layer",
        filter: "url(#flag-tone)",
        pointerEvents: "none",
        children: [
            Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($320e50466335b17c$exports))).territories).map(([slug, data])=>data.paths.map((d, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: d,
                        fill: (0, $45f8179f43663cce$export$543153e4c8586a40)[bySlug[slug].faction.name].fill
                    }, `${slug}-${i}`))),
            flagClusters.map((component, index)=>{
                const box = component.slugs.reduce((acc, slug)=>{
                    const b = (0, (/*@__PURE__*/$parcel$interopDefault($320e50466335b17c$exports))).territories[slug].bbox;
                    return [
                        Math.min(acc[0], b[0]),
                        Math.min(acc[1], b[1]),
                        Math.max(acc[2], b[2]),
                        Math.max(acc[3], b[3])
                    ];
                }, [
                    Infinity,
                    Infinity,
                    -Infinity,
                    -Infinity
                ]);
                const width = box[2] - box[0];
                const height = box[3] - box[1];
                // Cover the blob at the flag's true 3:2 aspect — crop, never squish.
                const scale = Math.max(width / 36, height / 24) * 1.02;
                const flagW = 36 * scale;
                const flagH = 24 * scale;
                const x = (box[0] + box[2]) / 2 - flagW / 2;
                const y = (box[1] + box[3]) / 2 - flagH / 2;
                return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                    clipPath: `url(#flag-clip-${index})`,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                            id: `flag-clip-${index}`,
                            children: component.slugs.flatMap((slug)=>(0, (/*@__PURE__*/$parcel$interopDefault($320e50466335b17c$exports))).territories[slug].paths.map((d, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                        d: d
                                    }, `${slug}-${i}`)))
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("use", {
                            href: `#flag-def-${component.faction}`,
                            x: x,
                            y: y,
                            width: flagW,
                            height: flagH
                        })
                    ]
                }, index);
            })
        ]
    });
const $6bcf64dfdf6ad5a9$export$71c28a968c1dbb1b = ({ bySlug: bySlug, blend: blend })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
        className: "region-shade-layer",
        style: blend ? {
            mixBlendMode: 'multiply'
        } : undefined,
        pointerEvents: "none",
        children: Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($320e50466335b17c$exports))).territories).map(([slug, data])=>data.paths.map((d, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: d,
                    fill: "#000",
                    filter: `url(#region-shade-${bySlug[slug].faction.name})`
                }, `${slug}-${i}`)))
    });
const $6bcf64dfdf6ad5a9$export$3fedf0f742024e85 = ({ flagClusters: flagClusters })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
        className: "faction-line-layer",
        pointerEvents: "none",
        children: flagClusters.map((cluster)=>{
            const d = (0, $db14449808df859a$export$aa93071fad79c60d)(cluster.slugs);
            const key = cluster.slugs.slice().sort().join('-');
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                        id: `blob-clip-${key}`,
                        clipRule: "nonzero",
                        children: cluster.slugs.flatMap((slug)=>(0, (/*@__PURE__*/$parcel$interopDefault($320e50466335b17c$exports))).territories[slug].paths.map((pd, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: pd
                                }, `${slug}-${i}`)))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                        clipPath: `url(#blob-clip-${key})`,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: d,
                            fill: "none",
                            stroke: (0, $45f8179f43663cce$export$543153e4c8586a40)[cluster.faction].border ?? (0, $45f8179f43663cce$export$543153e4c8586a40)[cluster.faction].stroke,
                            strokeWidth: 12,
                            strokeLinejoin: "miter",
                            strokeMiterlimit: 3
                        })
                    })
                ]
            }, key);
        })
    });
const $6bcf64dfdf6ad5a9$export$5a7bd9081842de9e = ({ flagClusters: flagClusters, blend: blend })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
        pointerEvents: "none",
        style: blend ? {
            mixBlendMode: 'multiply'
        } : undefined,
        children: flagClusters.map((cluster)=>{
            const key = cluster.slugs.slice().sort().join('-');
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                        id: `blobsh-clip-${key}`,
                        clipRule: "nonzero",
                        children: cluster.slugs.flatMap((slug)=>(0, (/*@__PURE__*/$parcel$interopDefault($320e50466335b17c$exports))).territories[slug].paths.map((pd, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: pd
                                }, `${slug}-${i}`)))
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                        clipPath: `url(#blobsh-clip-${key})`,
                        fill: (0, $45f8179f43663cce$export$543153e4c8586a40)[cluster.faction].border ?? (0, $45f8179f43663cce$export$543153e4c8586a40)[cluster.faction].stroke,
                        children: (0, $db14449808df859a$export$99552ec041cd896c)(cluster.slugs).map((rd, i, arr)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                d: rd,
                                fillRule: "evenodd",
                                fillOpacity: 0.4 * (1 - (i + 0.5) / arr.length)
                            }, i))
                    })
                ]
            }, key);
        })
    });
const $6bcf64dfdf6ad5a9$export$ea9b85e83fc7941d = ({ blend: blend })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
        filter: "url(#coast-shade)",
        style: blend ? {
            mixBlendMode: 'multiply'
        } : undefined,
        pointerEvents: "none",
        children: $6bcf64dfdf6ad5a9$var$LAND_PATHS.map((d, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: d,
                fill: "#000"
            }, i))
    });
const $6bcf64dfdf6ad5a9$export$3e957bac9b3d392f = ({ bySlug: bySlug, flagClusters: flagClusters, components: components, decor: decor })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6bcf64dfdf6ad5a9$export$d2409c893d4bb6b5, {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6bcf64dfdf6ad5a9$export$99022fc3a5833d78, {
                bySlug: bySlug,
                flagClusters: flagClusters
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6bcf64dfdf6ad5a9$export$71c28a968c1dbb1b, {
                bySlug: bySlug,
                blend: true
            }),
            $6bcf64dfdf6ad5a9$export$eabea6b34e7e6079,
            $6bcf64dfdf6ad5a9$var$SHOW_FACTION_BORDER_SHADOWS && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                className: "faction-shadow-layer",
                pointerEvents: "none",
                children: components.map((component, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
                        filter: `url(#faction-shadow-${component.faction})`,
                        children: component.slugs.flatMap((slug)=>(0, (/*@__PURE__*/$parcel$interopDefault($320e50466335b17c$exports))).territories[slug].paths.map((d, i)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: d,
                                    fill: "#000",
                                    stroke: "#000",
                                    strokeWidth: 3.5,
                                    strokeLinejoin: "round"
                                }, `${slug}-${i}`)))
                    }, index))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6bcf64dfdf6ad5a9$export$3fedf0f742024e85, {
                flagClusters: flagClusters
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6bcf64dfdf6ad5a9$export$5a7bd9081842de9e, {
                flagClusters: flagClusters,
                blend: true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6bcf64dfdf6ad5a9$export$ea9b85e83fc7941d, {
                blend: true
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: 30,
                y: 0,
                width: 1500,
                height: 820,
                fill: "#e6d3aa",
                opacity: 0.2,
                style: {
                    mixBlendMode: 'multiply'
                },
                pointerEvents: "none"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: 30,
                y: 0,
                width: 1500,
                height: 820,
                fill: "#f0e6cd",
                opacity: 0.12,
                pointerEvents: "none"
            }),
            decor && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($6bcf64dfdf6ad5a9$export$6b5d8a18060124ed, {})
        ]
    });



const $debbef03f2544258$export$79f5d796b8ab48ea = Math.round((0, $02812a7dfe853291$export$a0082732d9f8c635).w * (0, $6bcf64dfdf6ad5a9$export$207dd4b0e7e7e3d5));
const $debbef03f2544258$export$46cdbdf92224ca53 = Math.round((0, $02812a7dfe853291$export$a0082732d9f8c635).h * (0, $6bcf64dfdf6ad5a9$export$207dd4b0e7e7e3d5));
// the two-stage first bake: stage one at 1× shows the map as fast as the
// filters allow, stage two re-bakes at full resolution and swaps silently
const $debbef03f2544258$var$QUICK_SCALE = 1;
const $debbef03f2544258$export$43af311bd75a70ae = ({ territories: territories, bySlug: bySlug, flagClusters: flagClusters, ownershipKey: ownershipKey, editMode: editMode, lang: lang, dotFor: dotFor, onReady: onReady })=>{
    const readyReported = (0, $acw62.useRef)(false);
    // ---- offscreen bakes ----
    // Static pieces (the expensive blur/turbulence filters) rasterize ONCE to
    // PNG blobs; every conquest re-rasterizes only the cheap dynamic pieces and
    // assembles the final bitmap on a canvas. The composite is shown on a real
    // <canvas> under the SVG — no PNG round-trip for the displayed map.
    const artCanvasRef = (0, $acw62.useRef)(null);
    const revealCanvasRef = (0, $acw62.useRef)(null);
    const [artDrawn, setArtDrawn] = (0, $acw62.useState)(false);
    const staticPartsRef = (0, $acw62.useRef)(null);
    // the static bucket includes StaticDecor's sea/country labels, which DO
    // depend on language — invalidate and re-bake (once, cheaply) on a switch
    const staticLangRef = (0, $acw62.useRef)(null);
    // conquest reveal: when a re-bake lands, the new bitmap washes over the old
    // one in a soft-edged circle growing from the conquered territory
    const [reveal, setReveal] = (0, $acw62.useState)(null);
    const bakedOwnersRef = (0, $acw62.useRef)(null);
    const wrapSvg = (children, scale)=>(0, $f46ed4009cb9c1cd$export$eb3a06aef9e6ee51)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: `${(0, $02812a7dfe853291$export$a0082732d9f8c635).x} ${(0, $02812a7dfe853291$export$a0082732d9f8c635).y} ${(0, $02812a7dfe853291$export$a0082732d9f8c635).w} ${(0, $02812a7dfe853291$export$a0082732d9f8c635).h}`,
            width: Math.round((0, $02812a7dfe853291$export$a0082732d9f8c635).w * scale),
            height: Math.round((0, $02812a7dfe853291$export$a0082732d9f8c635).h * scale),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("style", {
                    children: (0, $6bcf64dfdf6ad5a9$export$b14bb4b345d340b)
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45f8179f43663cce$export$a2c0099db84fd7d8), {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6bcf64dfdf6ad5a9$export$4b5e6641e38c53b6), {}),
                children
            ]
        }));
    // the noise rect spans the desk area; feTurbulence is deterministic in user
    // space, so cropping the same rect to different viewBoxes yields the same
    // pattern — the map bake and the desk texture stay seamless at the frame
    const noiseSvg = (filter, vb, scale)=>(0, $f46ed4009cb9c1cd$export$eb3a06aef9e6ee51)(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: `${vb.x} ${vb.y} ${vb.w} ${vb.h}`,
            width: Math.round(vb.w * scale),
            height: Math.round(vb.h * scale),
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6bcf64dfdf6ad5a9$export$4b5e6641e38c53b6), {}),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                    x: -400,
                    y: -300,
                    width: 2360,
                    height: 1420,
                    filter: `url(#${filter})`
                })
            ]
        }));
    const loadImage = (url)=>new Promise((resolve, reject)=>{
            const img = new Image();
            img.onload = ()=>resolve(img);
            img.onerror = reject;
            img.src = url;
        });
    const rasterizeSvg = (markup)=>loadImage(URL.createObjectURL(new Blob([
            markup
        ], {
            type: 'image/svg+xml;charset=utf-8'
        })));
    const rasterizeAll = (markups)=>Promise.all(markups.map(rasterizeSvg));
    const revokeAll = (imgs)=>imgs.forEach((i)=>URL.revokeObjectURL(i.src));
    const encodePng = (img)=>{
        const c = document.createElement('canvas');
        c.width = img.naturalWidth;
        c.height = img.naturalHeight;
        c.getContext('2d').drawImage(img, 0, 0);
        return new Promise((res, rej)=>c.toBlob((b)=>{
                // release the backing store immediately — iOS Safari counts spent
                // canvases against a hard total-canvas budget until they are resized
                c.width = 0;
                c.height = 0;
                if (b) res(b);
                else rej(new Error('toBlob failed'));
            }, 'image/png'));
    };
    // one encode in flight at a time: a single scratch buffer instead of six,
    // with a breather between encodes so their main-thread staging (drawImage)
    // never strings into one long post-load jank
    const encodeAllSequentially = async (imgs)=>{
        const blobs = [];
        for (const img of imgs){
            blobs.push(await encodePng(img));
            await new Promise((r)=>setTimeout(r, 100));
        }
        return blobs;
    };
    const staticMarkups = (scale)=>[
            wrapSvg(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6bcf64dfdf6ad5a9$export$d2409c893d4bb6b5), {}), scale),
            wrapSvg((0, $6bcf64dfdf6ad5a9$export$eabea6b34e7e6079), scale),
            wrapSvg(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6bcf64dfdf6ad5a9$export$ea9b85e83fc7941d), {
                blend: false
            }), scale),
            wrapSvg(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6bcf64dfdf6ad5a9$export$6b5d8a18060124ed), {}), scale),
            // grain/blotch crops for the map frame — baked INTO the bitmap so the
            // live tree carries no mix-blend-mode layers (each one forces a
            // full-screen compositor pass and a ~30 MB resident texture)
            noiseSvg('paper-grain', (0, $02812a7dfe853291$export$a0082732d9f8c635), Math.min(scale, (0, $6bcf64dfdf6ad5a9$export$74a6dbb120886485))),
            noiseSvg('wash-blotch', (0, $02812a7dfe853291$export$a0082732d9f8c635), Math.min(scale, (0, $6bcf64dfdf6ad5a9$export$74a6dbb120886485)))
        ];
    const dynamicMarkups = (scale)=>[
            wrapSvg(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6bcf64dfdf6ad5a9$export$99022fc3a5833d78), {
                bySlug: bySlug,
                flagClusters: flagClusters
            }), scale),
            wrapSvg(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6bcf64dfdf6ad5a9$export$71c28a968c1dbb1b), {
                bySlug: bySlug,
                blend: false
            }), scale),
            wrapSvg(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6bcf64dfdf6ad5a9$export$3fedf0f742024e85), {
                flagClusters: flagClusters
            }), scale),
            wrapSvg(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6bcf64dfdf6ad5a9$export$5a7bd9081842de9e), {
                flagClusters: flagClusters,
                blend: false
            }), scale)
        ];
    // assemble the painted stack on an offscreen canvas at display resolution
    const compose = (statics, dynamics)=>{
        const [baseImg, inkImg, coastImg, decorImg, grainImg, blotchImg] = statics;
        const [flagsImg, shadeImg, bandsImg, bandShadowImg] = dynamics;
        const c = document.createElement('canvas');
        c.width = $debbef03f2544258$export$79f5d796b8ab48ea;
        c.height = $debbef03f2544258$export$46cdbdf92224ca53;
        const ctx = c.getContext('2d');
        ctx.drawImage(baseImg, 0, 0, $debbef03f2544258$export$79f5d796b8ab48ea, $debbef03f2544258$export$46cdbdf92224ca53);
        ctx.drawImage(flagsImg, 0, 0, $debbef03f2544258$export$79f5d796b8ab48ea, $debbef03f2544258$export$46cdbdf92224ca53);
        ctx.globalCompositeOperation = 'multiply';
        ctx.drawImage(shadeImg, 0, 0, $debbef03f2544258$export$79f5d796b8ab48ea, $debbef03f2544258$export$46cdbdf92224ca53);
        ctx.globalCompositeOperation = 'source-over';
        ctx.drawImage(inkImg, 0, 0, $debbef03f2544258$export$79f5d796b8ab48ea, $debbef03f2544258$export$46cdbdf92224ca53);
        ctx.drawImage(bandsImg, 0, 0, $debbef03f2544258$export$79f5d796b8ab48ea, $debbef03f2544258$export$46cdbdf92224ca53);
        ctx.globalCompositeOperation = 'multiply';
        ctx.drawImage(bandShadowImg, 0, 0, $debbef03f2544258$export$79f5d796b8ab48ea, $debbef03f2544258$export$46cdbdf92224ca53);
        ctx.drawImage(coastImg, 0, 0, $debbef03f2544258$export$79f5d796b8ab48ea, $debbef03f2544258$export$46cdbdf92224ca53);
        // parchment tint (multiply at 0.2), then the pale veil (normal 0.12)
        ctx.fillStyle = '#e6d3aa';
        ctx.globalAlpha = 0.2;
        ctx.fillRect(0, 0, $debbef03f2544258$export$79f5d796b8ab48ea, $debbef03f2544258$export$46cdbdf92224ca53);
        ctx.globalCompositeOperation = 'source-over';
        ctx.globalAlpha = 0.12;
        ctx.fillStyle = '#f0e6cd';
        ctx.fillRect(0, 0, $debbef03f2544258$export$79f5d796b8ab48ea, $debbef03f2544258$export$46cdbdf92224ca53);
        ctx.globalAlpha = 1;
        ctx.drawImage(decorImg, 0, 0, $debbef03f2544258$export$79f5d796b8ab48ea, $debbef03f2544258$export$46cdbdf92224ca53);
        // paper grain (multiply 0.4) and watercolor blotch (soft-light 0.6),
        // exactly the blend math the old live overlay layers carried
        ctx.globalCompositeOperation = 'multiply';
        ctx.globalAlpha = 0.4;
        ctx.drawImage(grainImg, 0, 0, $debbef03f2544258$export$79f5d796b8ab48ea, $debbef03f2544258$export$46cdbdf92224ca53);
        ctx.globalCompositeOperation = 'soft-light';
        ctx.globalAlpha = 0.6;
        ctx.drawImage(blotchImg, 0, 0, $debbef03f2544258$export$79f5d796b8ab48ea, $debbef03f2544258$export$46cdbdf92224ca53);
        ctx.globalCompositeOperation = 'source-over';
        ctx.globalAlpha = 1;
        return c;
    };
    // draw the finished composite onto the display canvas, freeing the offscreen
    const blit = (offscreen)=>{
        const display = artCanvasRef.current;
        if (display) {
            display.getContext('2d').drawImage(offscreen, 0, 0);
            display.dataset.drawn = '1';
        }
        offscreen.width = 0;
        offscreen.height = 0;
    };
    const currentOwners = ()=>{
        const owners = {};
        for (const t of territories)owners[t.slug] = t.faction.name;
        return owners;
    };
    (0, $acw62.useEffect)(()=>{
        if (editMode) return;
        // base / territory ink / coast shade never change; decor labels do when
        // the language switches — re-bake the static bucket when that happens
        if (staticLangRef.current !== lang) staticPartsRef.current = null;
        staticLangRef.current = lang;
        let cancelled = false;
        if (!staticPartsRef.current) {
            // ---- first bake: two-stage ----
            let resolveBlobs;
            let rejectBlobs;
            staticPartsRef.current = new Promise((res, rej)=>{
                resolveBlobs = res;
                rejectBlobs = rej;
            });
            staticPartsRef.current.catch(()=>{
                staticPartsRef.current = null;
            });
            // stage 2: full-resolution re-bake, silent swap, then cache the static
            // layers as PNG blobs for later conquest re-bakes. Runs to completion
            // even if the effect is cancelled — a conquest may already await it.
            let sharpStarted = false;
            const startSharp = ()=>{
                if (sharpStarted) return;
                sharpStarted = true;
                (async ()=>{
                    try {
                        const statics = await rasterizeAll(staticMarkups((0, $6bcf64dfdf6ad5a9$export$207dd4b0e7e7e3d5)));
                        const dynamics = await rasterizeAll(dynamicMarkups((0, $6bcf64dfdf6ad5a9$export$207dd4b0e7e7e3d5)));
                        if (!cancelled) blit(compose(statics, dynamics));
                        revokeAll(dynamics);
                        const blobs = await encodeAllSequentially(statics);
                        revokeAll(statics);
                        resolveBlobs(blobs);
                    } catch (e) {
                        rejectBlobs(e);
                    }
                })();
            };
            (async ()=>{
                try {
                    const [statics, dynamics] = await Promise.all([
                        rasterizeAll(staticMarkups($debbef03f2544258$var$QUICK_SCALE)),
                        rasterizeAll(dynamicMarkups($debbef03f2544258$var$QUICK_SCALE))
                    ]);
                    if (!cancelled) {
                        blit(compose(statics, dynamics));
                        bakedOwnersRef.current = currentOwners();
                        setArtDrawn(true);
                    }
                    revokeAll([
                        ...statics,
                        ...dynamics
                    ]);
                    // let the quick frame reach the screen before the heavy pass starts
                    window.setTimeout(startSharp, 200);
                } catch (e) {
                    console.error('map bake failed', e);
                    startSharp();
                }
            })();
            return ()=>{
                cancelled = true;
                startSharp();
            };
        }
        (async ()=>{
            try {
                const [statics, dynamics] = await Promise.all([
                    staticPartsRef.current.then((blobs)=>Promise.all(blobs.map((b)=>loadImage(URL.createObjectURL(b))))),
                    rasterizeAll(dynamicMarkups((0, $6bcf64dfdf6ad5a9$export$207dd4b0e7e7e3d5)))
                ]);
                const all = [
                    ...statics,
                    ...dynamics
                ];
                if (cancelled) {
                    revokeAll(all);
                    return;
                }
                const offscreen = compose(statics, dynamics);
                revokeAll(all);
                const previousOwners = bakedOwnersRef.current;
                bakedOwnersRef.current = currentOwners();
                const changed = previousOwners ? territories.find((t)=>previousOwners[t.slug] && previousOwners[t.slug] !== t.faction.name) : undefined;
                const display = artCanvasRef.current;
                const old = display?.dataset.drawn === '1' && changed ? await createImageBitmap(display) : null;
                if (cancelled) {
                    old?.close();
                    offscreen.width = 0;
                    offscreen.height = 0;
                    return;
                }
                blit(offscreen);
                if (old && changed) {
                    const dot = dotFor(changed.slug);
                    // the wash only needs to cover the region that actually changed —
                    // sized to the territory so the edge crosses it slowly enough to see
                    const bb = (0, (/*@__PURE__*/$parcel$interopDefault($320e50466335b17c$exports))).territories[changed.slug].bbox ?? [
                        dot.x - 60,
                        dot.y - 60,
                        dot.x + 60,
                        dot.y + 60
                    ];
                    const radius = Math.hypot(bb[2] - bb[0], bb[3] - bb[1]) / 2 * 1.4 + 30;
                    setReveal((prev)=>{
                        prev?.old.close();
                        return {
                            old: old,
                            origin: [
                                dot.x,
                                dot.y
                            ],
                            radius: radius
                        };
                    });
                }
            } catch (e) {
                // a failed bake keeps the previous bitmap; log for diagnosis
                console.error('map bake failed', e);
            }
        })();
        return ()=>{
            cancelled = true;
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        ownershipKey,
        editMode,
        lang
    ]);
    // drive the conquest reveal on the overlay canvas: the OLD bitmap covers the
    // new one and a soft-edged hole grows from the conquered territory until the
    // fade has cleared the frame. The overlay's backing store only exists while
    // a reveal is running.
    (0, $acw62.useEffect)(()=>{
        if (!reveal) return;
        const overlay = revealCanvasRef.current;
        if (!overlay) {
            reveal.old.close();
            setReveal(null);
            return;
        }
        overlay.width = $debbef03f2544258$export$79f5d796b8ab48ea;
        overlay.height = $debbef03f2544258$export$46cdbdf92224ca53;
        const ctx = overlay.getContext('2d');
        const cx = (reveal.origin[0] - (0, $02812a7dfe853291$export$a0082732d9f8c635).x) * (0, $6bcf64dfdf6ad5a9$export$207dd4b0e7e7e3d5);
        const cy = (reveal.origin[1] - (0, $02812a7dfe853291$export$a0082732d9f8c635).y) * (0, $6bcf64dfdf6ad5a9$export$207dd4b0e7e7e3d5);
        const Rmax = reveal.radius / 0.65 * (0, $6bcf64dfdf6ad5a9$export$207dd4b0e7e7e3d5 // gradient opaque to 65% — overshoot so the fade clears
        );
        const t0 = performance.now();
        const DUR = 900;
        let raf = 0;
        const tick = ()=>{
            const t = Math.min(1, (performance.now() - t0) / DUR);
            const r = Math.max(1, Rmax * (1 - Math.pow(1 - t, 3)));
            ctx.globalCompositeOperation = 'source-over';
            ctx.clearRect(0, 0, $debbef03f2544258$export$79f5d796b8ab48ea, $debbef03f2544258$export$46cdbdf92224ca53);
            ctx.drawImage(reveal.old, 0, 0);
            const grad = ctx.createRadialGradient(cx, cy, 0, cx, cy, r);
            grad.addColorStop(0, 'rgba(0,0,0,1)');
            grad.addColorStop(0.65, 'rgba(0,0,0,1)');
            grad.addColorStop(1, 'rgba(0,0,0,0)');
            ctx.globalCompositeOperation = 'destination-out';
            ctx.fillStyle = grad;
            ctx.fillRect(0, 0, $debbef03f2544258$export$79f5d796b8ab48ea, $debbef03f2544258$export$46cdbdf92224ca53);
            if (t < 1) {
                raf = requestAnimationFrame(tick);
                return;
            }
            overlay.width = 0;
            overlay.height = 0;
            reveal.old.close();
            setReveal(null);
        };
        raf = requestAnimationFrame(tick);
        return ()=>{
            // an interrupted reveal (unmount, edit-mode flip, replacement) must not
            // strand the old bitmap or the overlay's backing store — close() and a
            // re-zero are no-ops when the animation already finished cleanly
            cancelAnimationFrame(raf);
            overlay.width = 0;
            overlay.height = 0;
            reveal.old.close();
        };
    }, [
        reveal
    ]);
    // The dark desk surround keeps its grain/blotch texture as ONE small opaque
    // bitmap (no blend modes: the noise is pre-multiplied over the flat desk
    // color). Low resolution suffices — it is noise on a flat dark surface.
    // (The vignette stays a live gradient rect: gradients are cheap.)
    const [deskUrl, setDeskUrl] = (0, $acw62.useState)(null);
    const deskUrlRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        const DESK_SCALE = 0.5;
        const AREA = {
            x: -400,
            y: -300,
            w: 2360,
            h: 1420
        };
        const W = Math.round(AREA.w * DESK_SCALE);
        const H = Math.round(AREA.h * DESK_SCALE);
        let cancelled = false;
        (async ()=>{
            try {
                const [grain, blotch] = await Promise.all([
                    rasterizeSvg(noiseSvg('paper-grain', AREA, DESK_SCALE)),
                    rasterizeSvg(noiseSvg('wash-blotch', AREA, DESK_SCALE))
                ]);
                const c = document.createElement('canvas');
                c.width = W;
                c.height = H;
                const ctx = c.getContext('2d');
                ctx.fillStyle = '#2e2419';
                ctx.fillRect(0, 0, W, H);
                ctx.globalCompositeOperation = 'multiply';
                ctx.globalAlpha = 0.4;
                ctx.drawImage(grain, 0, 0, W, H);
                ctx.globalCompositeOperation = 'soft-light';
                ctx.globalAlpha = 0.6;
                ctx.drawImage(blotch, 0, 0, W, H);
                URL.revokeObjectURL(grain.src);
                URL.revokeObjectURL(blotch.src);
                c.toBlob((b)=>{
                    c.width = 0;
                    c.height = 0;
                    if (!b || cancelled) return;
                    deskUrlRef.current = URL.createObjectURL(b);
                    setDeskUrl(deskUrlRef.current);
                });
            } catch (e) {
                console.error('desk texture bake failed', e);
            }
        })();
        return ()=>{
            cancelled = true;
            if (deskUrlRef.current) URL.revokeObjectURL(deskUrlRef.current);
        };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Do not uncover the game until the quick composite has been drawn and has
    // survived a browser paint (plus the desk texture, which frames it).
    (0, $acw62.useEffect)(()=>{
        if (readyReported.current) return;
        if (!editMode && (!artDrawn || !deskUrl)) return;
        let cancelled = false;
        let firstFrame = 0;
        let secondFrame = 0;
        const decode = (url)=>new Promise((resolve)=>{
                const image = new Image();
                image.onload = ()=>resolve();
                image.onerror = ()=>resolve();
                image.src = url;
                image.decode?.().then(resolve, ()=>undefined);
            });
        Promise.all(editMode ? [] : [
            decode(deskUrl)
        ]).then(()=>{
            if (cancelled) return;
            firstFrame = requestAnimationFrame(()=>{
                secondFrame = requestAnimationFrame(()=>{
                    if (cancelled || readyReported.current) return;
                    readyReported.current = true;
                    onReady?.();
                });
            });
        });
        return ()=>{
            cancelled = true;
            cancelAnimationFrame(firstFrame);
            cancelAnimationFrame(secondFrame);
        };
    }, [
        artDrawn,
        deskUrl,
        editMode,
        onReady
    ]);
    return {
        deskUrl: deskUrl,
        artCanvasRef: artCanvasRef,
        revealCanvasRef: revealCanvasRef
    };
};



var $acw62 = parcelRequire("acw62");


// screen-pixel height of the HUD chrome hugging the top and bottom edges —
// measured live so desktop cards and the phone bars both work
const $019efc78288eae6e$var$hudChromePx = ()=>{
    let top = 0;
    let bottom = 0;
    const winH = window.innerHeight;
    for (const el of document.querySelectorAll('.hud-brand, .hud-phase, .hud-factions')){
        const r = el.getBoundingClientRect();
        if (r.top < winH * 0.4) top = Math.max(top, r.bottom);
    }
    for (const el of document.querySelectorAll('.hud-log, .hud-actions')){
        const r = el.getBoundingClientRect();
        if (r.bottom > winH * 0.6) bottom = Math.max(bottom, winH - r.top);
    }
    return {
        top: top,
        bottom: bottom
    };
};
// the DOM half of minZoomFor: measure the chrome, then ask the pure helper
const $019efc78288eae6e$var$minZoomOut = (aspect, rect)=>{
    if (typeof window === 'undefined' || !rect || rect.height === 0) return 1;
    const chrome = $019efc78288eae6e$var$hudChromePx();
    return (0, $02812a7dfe853291$export$de579cd90dacdc78)(aspect, window.innerWidth, rect.height, chrome.top + chrome.bottom);
};
const $019efc78288eae6e$export$1317a8937778ff24 = ()=>{
    // trackpad zoom/pan: pinch (ctrl+wheel) zooms toward the cursor, two-finger
    // scroll pans; the view is a zoom level + center, clamped to the base frame
    const svgRef = (0, $acw62.useRef)(null);
    // the baked-art canvases live in a div UNDER the svg; it mirrors the
    // viewBox as a CSS transform so the compositor moves the bitmap for free
    const artStackRef = (0, $acw62.useRef)(null);
    const [view, setView] = (0, $acw62.useState)({
        z: 1,
        cx: (0, $02812a7dfe853291$export$a0082732d9f8c635).x + (0, $02812a7dfe853291$export$a0082732d9f8c635).w / 2,
        cy: (0, $02812a7dfe853291$export$a0082732d9f8c635).y + (0, $02812a7dfe853291$export$a0082732d9f8c635).h / 2
    });
    // viewRef is the live gesture value; state trails it (committed after the
    // gesture settles) so React never re-renders per pointer frame. Synced from
    // state only when state itself changes — a hover re-render mid-gesture must
    // not clobber the ref with a stale committed value.
    const viewRef = (0, $acw62.useRef)(view);
    (0, $acw62.useEffect)(()=>{
        viewRef.current = view;
    }, [
        view
    ]);
    const commitTimer = (0, $acw62.useRef)(undefined);
    // write the viewBox straight to the DOM during gestures; commit to React
    // state (for the dot counter-scaling etc.) once the gesture goes quiet
    // mirror the view onto the art underlay: user point (VB.x, VB.y) is bitmap
    // pixel (0,0); the svg renders with preserveAspectRatio slice, so the scale
    // is the covering one and the crop is centred
    const syncArtStack = (v)=>{
        const el = artStackRef.current;
        const svg = svgRef.current;
        if (!el || !svg) return;
        const rect = svg.getBoundingClientRect();
        if (rect.width === 0 || rect.height === 0) return;
        const base = (0, $02812a7dfe853291$export$4f103843aa83f9bb)(aspectRef.current);
        const w = base.w / v.z;
        const h = base.h / v.z;
        const s = Math.max(rect.width / w, rect.height / h);
        const tx = (rect.width - w * s) / 2 + ((0, $02812a7dfe853291$export$a0082732d9f8c635).x - (v.cx - w / 2)) * s;
        const ty = (rect.height - h * s) / 2 + ((0, $02812a7dfe853291$export$a0082732d9f8c635).y - (v.cy - h / 2)) * s;
        el.style.transform = `translate(${tx}px, ${ty}px) scale(${s / (0, $6bcf64dfdf6ad5a9$export$207dd4b0e7e7e3d5)})`;
    };
    const applyView = (v)=>{
        viewRef.current = v;
        const svg = svgRef.current;
        if (svg) {
            const b = (0, $02812a7dfe853291$export$4f103843aa83f9bb)(aspectRef.current);
            const w = b.w / v.z;
            const h = b.h / v.z;
            svg.setAttribute('viewBox', `${v.cx - w / 2} ${v.cy - h / 2} ${w} ${h}`);
        }
        syncArtStack(v);
        window.clearTimeout(commitTimer.current);
        commitTimer.current = window.setTimeout(()=>setView(viewRef.current), 150);
    };
    // the screen's aspect ratio drives the base viewBox (cover behavior)
    const [aspect, setAspect] = (0, $acw62.useState)(()=>typeof window !== 'undefined' ? window.innerWidth / Math.max(1, window.innerHeight) : 16 / 9);
    const aspectRef = (0, $acw62.useRef)(aspect);
    aspectRef.current = aspect;
    (0, $acw62.useEffect)(()=>{
        const svg = svgRef.current;
        if (!svg) return;
        const measure = ()=>{
            const r = svg.getBoundingClientRect();
            if (r.height > 0) setAspect(r.width / r.height);
        };
        measure();
        // belt and braces: ResizeObserver catches container resizes, the window
        // listeners cover environments where observer delivery is flaky
        const ro = new ResizeObserver(measure);
        ro.observe(svg);
        window.addEventListener('resize', measure);
        window.addEventListener('orientationchange', measure);
        return ()=>{
            ro.disconnect();
            window.removeEventListener('resize', measure);
            window.removeEventListener('orientationchange', measure);
        };
    }, []);
    // Measuring the HUD costs a layout of five elements, and clampChrome runs on
    // every touchmove and every glide frame — on a slow phone that alone is
    // enough to starve the gesture of events. Measure once per gesture instead:
    // the bars do not move while a finger is down.
    const chromeRef = (0, $acw62.useRef)({
        top: 0,
        bottom: 0
    });
    const measureChrome = ()=>{
        chromeRef.current = $019efc78288eae6e$var$hudChromePx();
        return chromeRef.current;
    };
    // clamp with the HUD chrome pads folded in (converted to map units at the
    // target zoom's scale)
    const clampChrome = (z, cx, cy, a)=>{
        const rect = svgRef.current?.getBoundingClientRect();
        if (!rect || rect.height === 0) return (0, $02812a7dfe853291$export$7aa79e2cf2bc45c8)(z, cx, cy, a);
        const scale = rect.height / ((0, $02812a7dfe853291$export$4f103843aa83f9bb)(a).h / z);
        const chrome = chromeRef.current;
        return (0, $02812a7dfe853291$export$7aa79e2cf2bc45c8)(z, cx, cy, a, chrome.top / scale, chrome.bottom / scale);
    };
    // re-clamp on resize so the map keeps covering the new viewport shape
    (0, $acw62.useEffect)(()=>{
        measureChrome();
        setView((v)=>clampChrome(v.z, v.cx, v.cy, aspect));
    }, [
        aspect
    ]);
    (0, $acw62.useEffect)(()=>{
        const svg = svgRef.current;
        if (!svg) return;
        // native listener: React's synthetic wheel handlers are passive, so they
        // cannot preventDefault the page's own pinch/scroll gestures
        const onWheel = (e)=>{
            e.preventDefault();
            stopGlide();
            measureChrome();
            const v = viewRef.current;
            const a = aspectRef.current;
            const rect = svg.getBoundingClientRect();
            const base = (0, $02812a7dfe853291$export$4f103843aa83f9bb)(a);
            const w = base.w / v.z;
            const h = base.h / v.z;
            const scale = Math.min(rect.width / w, rect.height / h);
            const padX = (rect.width - w * scale) / 2;
            const padY = (rect.height - h * scale) / 2;
            if (e.ctrlKey || e.metaKey) {
                const nz = Math.min(Math.max(v.z * Math.exp(-e.deltaY * 0.012), $019efc78288eae6e$var$minZoomOut(a, rect)), (0, $02812a7dfe853291$export$1799921084a0d75f));
                // keep the map point under the cursor fixed while the scale changes
                const mx = v.cx - w / 2 + (e.clientX - rect.left - padX) / scale;
                const my = v.cy - h / 2 + (e.clientY - rect.top - padY) / scale;
                const nx = mx - (mx - (v.cx - w / 2)) * (v.z / nz);
                const ny = my - (my - (v.cy - h / 2)) * (v.z / nz);
                applyView(clampChrome(nz, nx + base.w / nz / 2, ny + base.h / nz / 2, a));
            } else applyView(clampChrome(v.z, v.cx + e.deltaX / scale, v.cy + e.deltaY / scale, a));
        };
        // touch: one finger pans, two fingers pinch-zoom around their midpoint
        const getPts = (e)=>Array.from(e.touches, (t)=>[
                    t.clientX,
                    t.clientY
                ]);
        // screen px per map unit, for turning finger positions into map distances
        const scaleNow = ()=>{
            const v = viewRef.current;
            const base = (0, $02812a7dfe853291$export$4f103843aa83f9bb)(aspectRef.current);
            const rect = svg.getBoundingClientRect();
            return Math.min(rect.width / (base.w / v.z), rect.height / (base.h / v.z));
        };
        let last = [];
        // Momentum. The pan is transform-driven rather than a scroll container, so
        // iOS gives it no inertia of its own — a flick simply stops dead the moment
        // the finger leaves. Velocity is sampled in MAP units per ms, so a flick
        // carries the same distance across the map at any zoom — see flickVelocity
        // for how the throw is read off the samples.
        let samples = [];
        const WINDOW = 120;
        let vx = 0;
        let vy = 0;
        let glide = 0;
        const stopGlide = ()=>{
            if (glide) cancelAnimationFrame(glide);
            glide = 0;
        };
        const FLICK_MIN = 0.012 // map units/ms below which a lift is not a flick
        ;
        const GLIDE_MIN = 0.006 // and below which the glide has arrived
        ;
        const onTouchStart = (e)=>{
            stopGlide();
            measureChrome();
            vx = 0;
            vy = 0;
            last = getPts(e);
            // Seed the buffer with where the finger STARTED. A phone under load may
            // deliver a single touchmove for a whole flick, and one sample has no
            // pair to be read against — the throw then reads as nothing at all.
            samples = last.length === 1 ? [
                {
                    x: last[0][0] / scaleNow(),
                    y: last[0][1] / scaleNow(),
                    t: performance.now()
                }
            ] : [];
        };
        const onTouchMove = (e)=>{
            e.preventDefault();
            const now = getPts(e);
            const v = viewRef.current;
            const a = aspectRef.current;
            const rect = svg.getBoundingClientRect();
            const base = (0, $02812a7dfe853291$export$4f103843aa83f9bb)(a);
            const w = base.w / v.z;
            const h = base.h / v.z;
            const scale = Math.min(rect.width / w, rect.height / h);
            if (now.length === 1 && last.length >= 1) {
                const dx = (now[0][0] - last[0][0]) / scale;
                const dy = (now[0][1] - last[0][1]) / scale;
                // performance.now() rather than the event's own stamp: Safari has
                // shipped touch timestamps on more than one clock, and a flick read
                // against the wrong epoch is either zero or nonsense
                samples.push({
                    x: now[0][0] / scale,
                    y: now[0][1] / scale,
                    t: performance.now()
                });
                while(samples.length > 4 && samples[samples.length - 1].t - samples[0].t > WINDOW)samples.shift();
                applyView(clampChrome(v.z, v.cx - dx, v.cy - dy, a));
            } else if (now.length >= 2 && last.length >= 2) {
                samples = [];
                const dist = (p)=>Math.hypot(p[0][0] - p[1][0], p[0][1] - p[1][1]);
                const mid = (p)=>[
                        (p[0][0] + p[1][0]) / 2,
                        (p[0][1] + p[1][1]) / 2
                    ];
                const nz = Math.min(Math.max(v.z * dist(now) / Math.max(1, dist(last)), $019efc78288eae6e$var$minZoomOut(a, rect)), (0, $02812a7dfe853291$export$1799921084a0d75f));
                const [cxS, cyS] = mid(now);
                const [lxS, lyS] = mid(last);
                // keep the map point under the pinch midpoint fixed, plus midpoint pan
                const mx = v.cx - w / 2 + (cxS - rect.left) / scale;
                const my = v.cy - h / 2 + (cyS - rect.top) / scale;
                const nx = mx - (mx - (v.cx - w / 2)) * (v.z / nz);
                const ny = my - (my - (v.cy - h / 2)) * (v.z / nz);
                applyView(clampChrome(nz, nx + base.w / nz / 2 - (cxS - lxS) / scale, ny + base.h / nz / 2 - (cyS - lyS) / scale, a));
            }
            last = now;
        };
        const onTouchEnd = (e)=>{
            const endT = performance.now();
            last = getPts(e);
            // a lift with fingers still down is a pinch ending, not a flick
            if (last.length > 0) {
                samples = [];
                return;
            }
            const flick = (0, $02812a7dfe853291$export$1180439ba8385ada)(samples, endT, FLICK_MIN);
            samples = [];
            if (!flick) return;
            vx = flick.vx;
            vy = flick.vy;
            let prev = performance.now();
            const step = (t)=>{
                // a frame is only worth integrating if time has actually passed since
                // the lift — see glideStep, and the first frame after a touchend on iOS
                const dt = Math.min(32, t - prev);
                if (dt > 0) prev = t;
                const v = viewRef.current;
                const a = aspectRef.current;
                const s = (0, $02812a7dfe853291$export$dd2c69eff3f3509e)(v, vx, vy, dt, (cx, cy)=>clampChrome(v.z, cx, cy, a));
                vx = s.vx;
                vy = s.vy;
                if (dt > 0) applyView(s.view);
                glide = Math.hypot(vx, vy) > GLIDE_MIN ? requestAnimationFrame(step) : 0;
            };
            glide = requestAnimationFrame(step);
        };
        svg.addEventListener('wheel', onWheel, {
            passive: false
        });
        svg.addEventListener('touchstart', onTouchStart, {
            passive: true
        });
        svg.addEventListener('touchmove', onTouchMove, {
            passive: false
        });
        svg.addEventListener('touchend', onTouchEnd, {
            passive: true
        });
        svg.addEventListener('touchcancel', onTouchEnd, {
            passive: true
        });
        return ()=>{
            stopGlide();
            svg.removeEventListener('wheel', onWheel);
            svg.removeEventListener('touchstart', onTouchStart);
            svg.removeEventListener('touchmove', onTouchMove);
            svg.removeEventListener('touchend', onTouchEnd);
            svg.removeEventListener('touchcancel', onTouchEnd);
        };
    }, []);
    // keep the underlay aligned after renders too (mount, resize, commits)
    (0, $acw62.useEffect)(()=>{
        syncArtStack(viewRef.current);
    });
    const base = (0, $02812a7dfe853291$export$4f103843aa83f9bb)(aspect);
    // render from the live gesture value so an unrelated re-render mid-gesture
    // never writes a stale viewBox over the direct DOM updates
    const viewNow = viewRef.current;
    const vw = base.w / viewNow.z;
    const vh = base.h / viewNow.z;
    const viewBox = `${viewNow.cx - vw / 2} ${viewNow.cy - vh / 2} ${vw} ${vh}`;
    const dotScale = (0, $02812a7dfe853291$export$e3327bfc5c155513)(viewNow.z);
    return {
        svgRef: svgRef,
        artStackRef: artStackRef,
        aspectRef: aspectRef,
        viewRef: viewRef,
        viewBox: viewBox,
        dotScale: dotScale
    };
};



var $acw62 = parcelRequire("acw62");



var $0e208c93274c6c87$exports = {};
$0e208c93274c6c87$exports = JSON.parse("{\"ankara\":{\"x\":762,\"y\":346},\"elazig\":{\"x\":985,\"y\":393},\"erzurum\":{\"x\":1140.8,\"y\":295.4},\"trabzon\":{\"x\":1014.8,\"y\":266.1},\"samsun\":{\"x\":916.3,\"y\":236.3},\"kastamonu\":{\"x\":685,\"y\":217.8},\"mosul\":{\"x\":1254.2,\"y\":518.7},\"baghdad\":{\"x\":1267.1,\"y\":670.2},\"adana\":{\"x\":782.2,\"y\":540.8},\"hatay\":{\"x\":887.2,\"y\":545},\"maras\":{\"x\":906.9,\"y\":477.8},\"isparta\":{\"x\":566.4,\"y\":476.9},\"rhodes\":{\"x\":424.2,\"y\":541.8},\"aydin\":{\"x\":450,\"y\":482.2},\"usak\":{\"x\":520,\"y\":456.6},\"balikesir\":{\"x\":446.7,\"y\":294.3},\"eskisehir\":{\"x\":518.2,\"y\":307.8},\"istanbul\":{\"x\":509.8,\"y\":232.4},\"edirne\":{\"x\":406.5,\"y\":188.7},\"van\":{\"x\":1261.5,\"y\":387},\"western-thrace\":{\"x\":306.1,\"y\":251.3},\"plovdiv\":{\"x\":291.3,\"y\":179.7},\"burgas\":{\"x\":329.3,\"y\":136.2},\"sofia\":{\"x\":216.7,\"y\":67.5},\"varna\":{\"x\":404.9,\"y\":38.9},\"gelibolu\":{\"x\":345.1,\"y\":278.1},\"canakkale\":{\"x\":348.1,\"y\":316},\"lesbos\":{\"x\":370.8,\"y\":359},\"izmir\":{\"x\":387.9,\"y\":415.1},\"kozani\":{\"x\":114.2,\"y\":303.4},\"salonica\":{\"x\":209.9,\"y\":258},\"kars\":{\"x\":1256,\"y\":257},\"gyumri\":{\"x\":1293.6,\"y\":261.6},\"yerevan\":{\"x\":1324.3,\"y\":274.4},\"igdir\":{\"x\":1305.4,\"y\":323.6},\"vanadzor\":{\"x\":1355.7,\"y\":285.4},\"sevan\":{\"x\":1380.4,\"y\":367.7},\"kutahya\":{\"x\":613.2,\"y\":434.2},\"sakarya\":{\"x\":596.7,\"y\":242.5},\"diyarbakir\":{\"x\":1082.2,\"y\":431}}");






const $8830abac408c4fb4$export$ac8df47f87d3436a = ({ territories: territories, lang: lang, bySlug: bySlug, svgRef: svgRef, viewRef: viewRef, aspectRef: aspectRef })=>{
    const layouts = (0, $acw62.useMemo)(()=>(0, $e83582f0aa0103b8$export$70601bf16a9b7a55)(Object.fromEntries(territories.map((territory)=>[
                territory.slug,
                (0, $6c154842fccf6556$export$983732bc59a669db)(territory.slug, territory.name)
            ])), lang), // Territory geometry never changes during a game; only the display
    // language does.
    [
        lang
    ]);
    const editMode = (0, $acw62.useMemo)((0, $ac3528b727779928$export$132f4ab9e276e5ff), []);
    const [overrides, setOverrides] = (0, $acw62.useState)(()=>{
        if (!(0, $ac3528b727779928$export$132f4ab9e276e5ff)()) return {};
        try {
            return JSON.parse(localStorage.getItem('labelOverrides') || '{}');
        } catch  {
            return {};
        }
    });
    const [dotOverrides, setDotOverrides] = (0, $acw62.useState)(()=>{
        if (!(0, $ac3528b727779928$export$132f4ab9e276e5ff)()) return {};
        try {
            return JSON.parse(localStorage.getItem('dotOverrides') || '{}');
        } catch  {
            return {};
        }
    });
    const [decorOverrides, setDecorOverrides] = (0, $acw62.useState)(()=>{
        if (!(0, $ac3528b727779928$export$132f4ab9e276e5ff)()) return {};
        try {
            return JSON.parse(localStorage.getItem('decorOverrides') || '{}');
        } catch  {
            return {};
        }
    });
    const [selected, setSelected] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        if (!editMode) return;
        localStorage.setItem('labelOverrides', JSON.stringify(overrides));
        localStorage.setItem('dotOverrides', JSON.stringify(dotOverrides));
        localStorage.setItem('decorOverrides', JSON.stringify(decorOverrides));
    }, [
        editMode,
        overrides,
        dotOverrides,
        decorOverrides
    ]);
    const paramsFor = (slug)=>overrides[slug] ?? (0, $ac3528b727779928$export$467dcc46fd03fabc)(layouts[slug], bySlug[slug].name, (0, (/*@__PURE__*/$parcel$interopDefault($320e50466335b17c$exports))).territories[slug].label);
    const dotFor = (slug)=>{
        if (editMode && dotOverrides[slug]) return dotOverrides[slug];
        const pin = (0, (/*@__PURE__*/$parcel$interopDefault($0e208c93274c6c87$exports)))[slug];
        if (pin) return pin;
        const [x, y] = (0, (/*@__PURE__*/$parcel$interopDefault($320e50466335b17c$exports))).territories[slug].label;
        return {
            x: x,
            y: y
        };
    };
    const decorFor = (slug)=>(editMode ? decorOverrides[slug] : undefined) ?? (0, (/*@__PURE__*/$parcel$interopDefault($86359269279968a4$exports)))[slug] ?? (0, $6bcf64dfdf6ad5a9$export$8a9cfb1a47760c5e)((0, $6bcf64dfdf6ad5a9$export$4f51762b8cf3521f)[slug]);
    const patchLabel = (slug, patch)=>setOverrides((current)=>({
                ...current,
                [slug]: {
                    ...current[slug] ?? paramsFor(slug),
                    ...patch
                }
            }));
    const patchDot = (slug, patch)=>setDotOverrides((current)=>({
                ...current,
                [slug]: {
                    ...current[slug] ?? dotFor(slug),
                    ...patch
                }
            }));
    const patchDecor = (slug, patch)=>setDecorOverrides((current)=>({
                ...current,
                [slug]: {
                    ...current[slug] ?? decorFor(slug),
                    ...patch
                }
            }));
    const startDrag = (kind, slug, event)=>{
        event.preventDefault();
        event.stopPropagation();
        setSelected({
            kind: kind,
            slug: slug
        });
        const svg = svgRef.current;
        if (!svg) return;
        const start = kind === 'label' ? paramsFor(slug) : kind === 'dot' ? dotFor(slug) : decorFor(slug);
        const patch = kind === 'label' ? patchLabel : kind === 'dot' ? patchDot : patchDecor;
        const startX = event.clientX;
        const startY = event.clientY;
        const rect = svg.getBoundingClientRect();
        const view = viewRef.current;
        const aspect = aspectRef.current;
        if (!view || aspect === null) return;
        const base = (0, $02812a7dfe853291$export$4f103843aa83f9bb)(aspect);
        const scale = Math.min(rect.width / (base.w / view.z), rect.height / (base.h / view.z));
        let moved = false;
        const move = (pointerEvent)=>{
            if (!moved && Math.hypot(pointerEvent.clientX - startX, pointerEvent.clientY - startY) < 3) return;
            moved = true;
            patch(slug, {
                x: Math.round(((pointerEvent.clientX - startX) / scale + start.x) * 10) / 10,
                y: Math.round(((pointerEvent.clientY - startY) / scale + start.y) * 10) / 10
            });
        };
        const stop = ()=>{
            window.removeEventListener('pointermove', move);
            window.removeEventListener('pointerup', stop);
        };
        window.addEventListener('pointermove', move);
        window.addEventListener('pointerup', stop);
    };
    (0, $acw62.useEffect)(()=>{
        if (!editMode) return;
        const onKey = (event)=>{
            if (!selected) return;
            const tag = event.target?.tagName;
            if (tag === 'INPUT' || tag === 'TEXTAREA') return;
            const distance = event.shiftKey ? 10 : 1;
            const params = selected.kind === 'label' ? paramsFor(selected.slug) : selected.kind === 'dot' ? dotFor(selected.slug) : decorFor(selected.slug);
            const patch = event.key === 'ArrowLeft' ? {
                x: params.x - distance
            } : event.key === 'ArrowRight' ? {
                x: params.x + distance
            } : event.key === 'ArrowUp' ? {
                y: params.y - distance
            } : event.key === 'ArrowDown' ? {
                y: params.y + distance
            } : null;
            if (patch) {
                event.preventDefault();
                (selected.kind === 'label' ? patchLabel : selected.kind === 'dot' ? patchDot : patchDecor)(selected.slug, patch);
            }
        };
        window.addEventListener('keydown', onKey);
        return ()=>window.removeEventListener('keydown', onKey);
    });
    const dropSelected = (current)=>{
        if (!selected) return current;
        const { [selected.slug]: _, ...rest } = current;
        return rest;
    };
    const patchSelected = (patch)=>{
        if (!selected) return;
        if (selected.kind === 'decor') patchDecor(selected.slug, patch);
        else patchLabel(selected.slug, patch);
    };
    const patchSelectedDot = (patch)=>{
        if (selected) patchDot(selected.slug, patch);
    };
    const resetSelected = ()=>{
        if (!selected) return;
        if (selected.kind === 'label') setOverrides(dropSelected);
        else if (selected.kind === 'dot') setDotOverrides(dropSelected);
        else setDecorOverrides(dropSelected);
    };
    const clearAll = ()=>{
        setOverrides({});
        setDotOverrides({});
        setDecorOverrides({});
    };
    return {
        layouts: layouts,
        editMode: editMode,
        overrides: overrides,
        dotOverrides: dotOverrides,
        decorOverrides: decorOverrides,
        selected: selected,
        paramsFor: paramsFor,
        dotFor: dotFor,
        decorFor: decorFor,
        startDrag: startDrag,
        patchSelected: patchSelected,
        patchSelectedDot: patchSelectedDot,
        resetSelected: resetSelected,
        clearAll: clearAll,
        deselect: ()=>setSelected(null)
    };
};








const $2d9a0e370f0044b3$export$ddf41bcefa6031fb = (0, $9ff2839edea1890c$export$9b928fc5e710e864).movement.seaLanes;
const $2d9a0e370f0044b3$var$NAVIES = new Set((0, $9ff2839edea1890c$export$9b928fc5e710e864).movement.navies);
const $2d9a0e370f0044b3$var$OCCUPIED_TERRITORIES = new Set((0, $a57adc7b3bbfe58c$export$59d67d3ae020dbb)((0, $9ff2839edea1890c$export$9b928fc5e710e864).movement.occupiedTerritoryGroup));
class $2d9a0e370f0044b3$export$8463c66827c6b0ce {
    game;
    convoys;
    /** Human landings awaiting an assault-or-retreat decision (see landConvoys). */ pendingLandings;
    constructor(game){
        this.game = game;
        this.convoys = [];
        this.pendingLandings = [];
    }
    snapshot() {
        return {
            convoys: this.convoys.map((convoy)=>({
                    ...convoy
                })),
            pendingLandings: this.pendingLandings.map((landing)=>({
                    ...landing
                }))
        };
    }
    restore(snapshot) {
        this.convoys = snapshot.convoys.map((convoy)=>({
                ...convoy
            }));
        this.pendingLandings = (snapshot.pendingLandings ?? []).map((landing)=>({
                ...landing
            }));
    }
    troopsAtSea(faction) {
        let total = 0;
        for (const convoy of this.convoys)if (convoy.faction === faction.name) total += convoy.troops;
        return total;
    }
    movable(from) {
        const spare = from.troops - 1;
        const occupied = from.faction.alliance !== 'turkey' && $2d9a0e370f0044b3$var$OCCUPIED_TERRITORIES.has(from.slug);
        return occupied ? Math.floor(spare * (0, $9ff2839edea1890c$export$9b928fc5e710e864).movement.occupiedMovementFactor) : spare;
    }
    crossesSea(from, to) {
        return $2d9a0e370f0044b3$export$ddf41bcefa6031fb.some((lane)=>lane.ports.includes(from.slug) && lane.ports.includes(to.slug));
    }
    transferCapacity(from, to) {
        const regional = this.game.campaign.transferCapacity(from, to, this.movable(from));
        return this.crossesSea(from, to) ? Math.min(regional, (0, $9ff2839edea1890c$export$9b928fc5e710e864).movement.crossingCapacity) : regional;
    }
    transferDisrupted(from, to) {
        return this.game.campaign.transferCapacity(from, to, this.movable(from)) < this.movable(from);
    }
    fortify(fromSlug, toSlug, count) {
        const game = this.game;
        if (game.turn.phase !== 'fortify' || game.turn.fortifiesUsed >= game.campaign.fortifyLimit) return false;
        const from = game.bySlug[fromSlug];
        const to = game.bySlug[toSlug];
        const faction = game.turn.currentPlayer.faction;
        if (from.faction !== faction || to.faction !== faction || !from.isAdjacentTo(to)) return false;
        const moved = Math.min(count, this.transferCapacity(from, to));
        if (moved <= 0) return false;
        from.troops -= moved;
        to.troops += moved;
        game.turn.useFortify();
        return true;
    }
    seaTargets(fromSlug) {
        const game = this.game;
        const from = game.bySlug[fromSlug];
        if (!from || game.turn.phase !== 'fortify' || game.turn.fortifiesUsed >= game.campaign.fortifyLimit) return [];
        const faction = game.turn.currentPlayer.faction;
        if (from.faction !== faction || !$2d9a0e370f0044b3$var$NAVIES.has(faction.name)) return [];
        return $2d9a0e370f0044b3$export$ddf41bcefa6031fb.flatMap((lane)=>{
            const other = lane.ports[0] === fromSlug ? lane.ports[1] : lane.ports[1] === fromSlug ? lane.ports[0] : null;
            const target = other ? game.bySlug[other] : null;
            return target?.faction === faction && this.transferCapacity(from, target) > 0 ? [
                other
            ] : [];
        });
    }
    shippable(from, to) {
        return this.transferCapacity(from, to);
    }
    embark(fromSlug, toSlug, count) {
        const game = this.game;
        if (!this.seaTargets(fromSlug).includes(toSlug)) return false;
        const from = game.bySlug[fromSlug];
        const to = game.bySlug[toSlug];
        const faction = game.turn.currentPlayer.faction;
        const moved = Math.min(count, this.shippable(from, to));
        if (moved <= 0) return false;
        from.troops -= moved;
        this.convoys.push({
            faction: faction.name,
            from: fromSlug,
            to: toSlug,
            troops: moved,
            arrives: game.turn.round + (0, $9ff2839edea1890c$export$9b928fc5e710e864).movement.crossingRounds
        });
        game.turn.useFortify();
        game.record(faction, 'log.embark', {
            faction: (0, $99b5c8068df0b6a9$export$b827813b2cbfb4b1)(faction.name),
            n: moved,
            from: (0, $99b5c8068df0b6a9$export$1a920137df84177e)(fromSlug, from.name),
            to: (0, $99b5c8068df0b6a9$export$1a920137df84177e)(toSlug, game.bySlug[toSlug].name)
        });
        return true;
    }
    landConvoys() {
        if (!this.convoys.length) return;
        const game = this.game;
        const faction = game.turn.currentPlayer.faction;
        const stillAtSea = [];
        for (const convoy of this.convoys){
            if (convoy.faction !== faction.name || game.turn.round < convoy.arrives) {
                stillAtSea.push(convoy);
                continue;
            }
            const destination = game.bySlug[convoy.to];
            const origin = game.bySlug[convoy.from];
            // The port is still ours: disembark, unopposed.
            if (destination.faction === faction) {
                destination.troops += convoy.troops;
                game.record(faction, convoy.returning ? 'log.convoyReturned' : 'log.convoyLanded', {
                    faction: (0, $99b5c8068df0b6a9$export$b827813b2cbfb4b1)(faction.name),
                    n: convoy.troops,
                    territory: (0, $99b5c8068df0b6a9$export$1a920137df84177e)(destination.slug, destination.name)
                });
                continue;
            }
            // The port was lost while we crossed. Falling back is only possible for an
            // outbound convoy whose home port is still ours; a returning convoy has
            // nowhere left to run and must land where it is.
            const canFallBack = !convoy.returning && origin.faction === faction;
            if (canFallBack) {
                // Never assault an ally: fall back is the only option there.
                if (destination.faction.alliance === faction.alliance) {
                    this.turnBack(faction, destination, origin, convoy.troops);
                    continue;
                }
                // The human weighs the assault; the AI decides on the spot.
                if (faction === game.humanPlayer.faction) {
                    this.pendingLandings.push({
                        faction: faction.name,
                        from: convoy.from,
                        to: convoy.to,
                        troops: convoy.troops
                    });
                    continue;
                }
                if (this.worthStorming(destination, convoy.troops)) game.combat.land(faction, destination, convoy.troops);
                else this.turnBack(faction, destination, origin, convoy.troops);
                continue;
            }
            // No bolt-hole: storm a hostile shore, or reinforce a friendly one — both
            // resolved by combat.land (which lands allied troops unopposed).
            game.combat.land(faction, destination, convoy.troops);
        }
        this.convoys = stillAtSea;
    }
    /** Resolve the oldest pending human landing: true storms the port, false turns back. */ resolveLanding(assault) {
        const landing = this.pendingLandings.shift();
        if (!landing) return;
        const game = this.game;
        const faction = game.factions.find((candidate)=>candidate.name === landing.faction);
        if (faction) {
            const destination = game.bySlug[landing.to];
            const origin = game.bySlug[landing.from];
            // Turn back only if home is still ours; otherwise the troops must fight.
            if (!assault && origin.faction === faction) this.turnBack(faction, destination, origin, landing.troops);
            else game.combat.land(faction, destination, landing.troops);
        }
        // Once the last landing is settled, the turn can finish opening — its draft is
        // now counted from the board the fighting left behind (see TurnController.start).
        if (!this.pendingLandings.length && game.turn.awaitingLanding && game.turn.phase !== 'gameover') game.turn.openTurn();
    }
    /** Send a stranded landing force back home — another full sea crossing. */ turnBack(faction, from, home, troops) {
        this.convoys.push({
            faction: faction.name,
            from: from.slug,
            to: home.slug,
            troops: troops,
            arrives: this.game.turn.round + (0, $9ff2839edea1890c$export$9b928fc5e710e864).movement.crossingRounds,
            returning: true
        });
        this.game.record(faction, 'log.convoyTurnedBack', {
            faction: (0, $99b5c8068df0b6a9$export$b827813b2cbfb4b1)(faction.name),
            n: troops,
            territory: (0, $99b5c8068df0b6a9$export$1a920137df84177e)(home.slug, home.name)
        });
    }
    /** AI heuristic: only storm a hostile port when the landing force outnumbers the garrison. */ worthStorming(destination, troops) {
        return troops > destination.troops;
    }
}




const $2504b5c703291c16$export$cd3654d7d5156824 = ({ convoy: convoy, berth: berth, round: round, dotScale: dotScale, destination: destination })=>{
    const lane = (0, $2d9a0e370f0044b3$export$ddf41bcefa6031fb).find((candidate)=>candidate.ports.includes(convoy.from) && candidate.ports.includes(convoy.to));
    if (!lane) return null;
    const [x, y] = [
        lane.at[0],
        lane.at[1] + berth * 42
    ];
    const style = (0, $45f8179f43663cce$export$543153e4c8586a40)[convoy.faction];
    const away = Math.max(0, convoy.arrives - round);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
        className: "convoy",
        transform: `translate(${x} ${y}) scale(${dotScale}) translate(${-x} ${-y})`,
        pointerEvents: "none",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: (0, $6c154842fccf6556$export$625550452a3fa3ec)(away === 1 ? 'tooltip.convoyLast' : 'tooltip.convoy', {
                    faction: (0, $6c154842fccf6556$export$e75392c849ab10e7)(convoy.faction),
                    troops: convoy.troops,
                    to: (0, $6c154842fccf6556$export$983732bc59a669db)(convoy.to, destination.name),
                    rounds: away
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: x,
                cy: y,
                r: 13,
                fill: "#fffdf5",
                stroke: style.stroke,
                strokeWidth: 2.5
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                x: x,
                y: y + 4,
                className: "troops",
                textAnchor: "middle",
                children: convoy.troops
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                className: "convoy-ship",
                transform: `translate(${x - 21} ${y - 1}) scale(0.6)`,
                d: (0, $45f8179f43663cce$export$9a623eb1424c0726)
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                x: x,
                y: y + 24,
                className: "convoy-eta",
                textAnchor: "middle",
                children: "\u2022".repeat(away)
            })
        ]
    });
};
const $2504b5c703291c16$export$e15d7a9508616972 = ({ convoys: convoys, round: round, dotScale: dotScale, bySlug: bySlug })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: convoys.map((convoy, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($2504b5c703291c16$export$cd3654d7d5156824, {
                convoy: convoy,
                berth: convoys.slice(0, index).filter((candidate)=>candidate.from === convoy.from || candidate.to === convoy.from).length,
                round: round,
                dotScale: dotScale,
                destination: bySlug[convoy.to]
            }, `convoy-${index}`))
    });







const $64e01790b10c58e6$export$9e39d3856f16bfe2 = ({ editMode: editMode, overrides: overrides, selected: selected, paramsFor: paramsFor, onDragStart: onDragStart })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
        className: "decor-labels",
        pointerEvents: editMode ? undefined : 'none',
        children: (0, $6bcf64dfdf6ad5a9$export$40b0a0664260337c).map((def)=>{
            const params = paramsFor(def.slug);
            // An arc is rendered whenever one exists for this label — either a live
            // override or a committed pin.
            const edited = !!(overrides[def.slug] || (0, (/*@__PURE__*/$parcel$interopDefault($86359269279968a4$exports)))[def.slug]);
            const isSelected = editMode && selected?.kind === 'decor' && selected.slug === def.slug;
            const grab = editMode ? {
                cursor: 'grab'
            } : undefined;
            if (!edited) return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                x: def.x,
                y: def.y,
                className: def.cls,
                fontSize: def.size,
                textAnchor: "middle",
                transform: def.rotate ? `rotate(${def.rotate} ${def.x} ${def.y})` : undefined,
                style: isSelected ? {
                    ...grab,
                    fill: '#ff2fd6'
                } : grab,
                onPointerDown: editMode ? (event)=>onDragStart('decor', def.slug, event) : undefined,
                children: (0, $6c154842fccf6556$export$367ec920d3208c60)(def.slug, def.text)
            }, def.slug);
            const arc = (0, $3780a3745535c467$export$229206c232c9b1b8)(params);
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                style: grab,
                onPointerDown: editMode ? (event)=>onDragStart('decor', def.slug, event) : undefined,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        id: `dp-${def.slug}`,
                        d: arc.d,
                        fill: "none",
                        stroke: isSelected ? '#ff2fd6' : editMode ? '#00ff44' : 'none',
                        strokeWidth: isSelected ? 2.5 : editMode ? 2 : 0
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                        className: def.cls,
                        fontSize: params.size,
                        style: params.fill !== undefined || params.stroke !== undefined || params.strokeW !== undefined ? {
                            fill: params.fill,
                            stroke: params.stroke,
                            strokeWidth: params.strokeW !== undefined ? `${params.strokeW}em` : undefined,
                            paintOrder: 'stroke'
                        } : undefined,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("textPath", {
                            href: `#dp-${def.slug}`,
                            startOffset: "50%",
                            textAnchor: "middle",
                            children: (0, $6c154842fccf6556$export$367ec920d3208c60)(def.slug, def.text)
                        })
                    })
                ]
            }, def.slug);
        })
    });






const $300525fe127e51fc$export$5751855f5c7ef897 = ({ bySlug: bySlug, editor: editor })=>{
    if (!editor.editMode) return null;
    const selected = editor.selected;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ac3528b727779928$export$7e9380a637caa496), {
        slug: selected?.slug ?? null,
        name: selected ? selected.kind === 'decor' ? (0, $6bcf64dfdf6ad5a9$export$4f51762b8cf3521f)[selected.slug].text : bySlug[selected.slug].name : null,
        kind: selected?.kind ?? null,
        params: selected?.kind === 'label' ? editor.paramsFor(selected.slug) : selected?.kind === 'decor' ? editor.decorFor(selected.slug) : null,
        dot: selected?.kind === 'dot' ? editor.dotFor(selected.slug) : null,
        computed: selected?.kind === 'label' ? (0, $ac3528b727779928$export$467dcc46fd03fabc)(editor.layouts[selected.slug], bySlug[selected.slug].name, (0, (/*@__PURE__*/$parcel$interopDefault($320e50466335b17c$exports))).territories[selected.slug].label) : null,
        overridden: !!selected && !!(selected.kind === 'label' ? editor.overrides[selected.slug] : selected.kind === 'dot' ? editor.dotOverrides[selected.slug] : editor.decorOverrides[selected.slug]),
        overrides: editor.overrides,
        dotOverrides: editor.dotOverrides,
        decorOverrides: editor.decorOverrides,
        colorDefaults: selected?.kind === 'decor' ? (0, $6bcf64dfdf6ad5a9$export$4f51762b8cf3521f)[selected.slug].cls === 'sea-label' ? {
            fill: '#4f6b80',
            stroke: '#201a12',
            strokeW: 0
        } : {
            fill: '#8a7a5f',
            stroke: '#201a12',
            strokeW: 0
        } : {
            fill: '#fffdf5',
            stroke: '#201a12',
            strokeW: 0.22
        },
        onChange: editor.patchSelected,
        onChangeDot: editor.patchSelectedDot,
        onReset: editor.resetSelected,
        onClearAll: editor.clearAll,
        onDeselect: editor.deselect
    });
};



const $81ae4d1c7e6a848d$export$13e347a0c825e367 = ({ editMode: editMode })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            editMode && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: -400,
                y: -300,
                width: 2360,
                height: 1420,
                filter: "url(#paper-grain)",
                opacity: 0.4,
                style: {
                    mixBlendMode: 'multiply'
                },
                pointerEvents: "none"
            }),
            editMode && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: -400,
                y: -300,
                width: 2360,
                height: 1420,
                filter: "url(#wash-blotch)",
                opacity: 0.6,
                style: {
                    mixBlendMode: 'soft-light'
                },
                pointerEvents: "none"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                x: -400,
                y: -300,
                width: 2360,
                height: 1420,
                fill: "url(#vignette-grad)",
                pointerEvents: "none"
            })
        ]
    });





const $54033658000b64f5$export$36b55809b37e7053 = ({ bySlug: bySlug, selected: selected, targets: targets, activeTarget: activeTarget, fortifyTarget: fortifyTarget, hovered: hovered, onTerritoryClick: onTerritoryClick, onHover: onHover })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("g", {
        className: "territory-layer",
        children: Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($320e50466335b17c$exports))).territories).map(([slug, data])=>{
            const territory = bySlug[slug];
            const isSelected = selected === slug;
            const isTarget = targets.includes(slug);
            const isActiveTarget = activeTarget === slug;
            const isFortifyTarget = fortifyTarget === slug;
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                "data-slug": slug,
                className: `territory${isSelected ? ' selected' : ''}${isTarget ? ' target' : ''}${isActiveTarget ? ' active-target' : ''}${isFortifyTarget ? ' fortify-target' : ''}${hovered === slug ? ' hover' : ''}`,
                onClick: ()=>onTerritoryClick(slug),
                onMouseEnter: ()=>onHover(slug),
                onMouseLeave: ()=>onHover(null),
                children: [
                    data.paths.map((path, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: path,
                            fill: "transparent"
                        }, index)),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("title", {
                        children: (0, $6c154842fccf6556$export$625550452a3fa3ec)('tooltip.territory', {
                            name: (0, $6c154842fccf6556$export$983732bc59a669db)(territory.slug, territory.name),
                            faction: (0, $6c154842fccf6556$export$e75392c849ab10e7)(territory.faction.name),
                            troops: territory.troops
                        })
                    })
                ]
            }, slug);
        })
    });








const $93faf3f38de7a78c$export$67ee96f9bd6505e6 = ({ bySlug: bySlug, layouts: layouts, overrides: overrides, editMode: editMode, selected: selected, dotScale: dotScale, dotFor: dotFor, onTerritoryClick: onTerritoryClick, onHover: onHover, onDragStart: onDragStart })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($320e50466335b17c$exports))).territories).map(([slug, data])=>{
            const territory = bySlug[slug];
            const [x, y] = data.label;
            const style = (0, $45f8179f43663cce$export$543153e4c8586a40)[territory.faction.name];
            const override = editMode ? overrides[slug] : undefined;
            const layout = override ? (0, $3780a3745535c467$export$229206c232c9b1b8)(override) : layouts[slug];
            const isLabelSelected = editMode && selected?.kind === 'label' && selected.slug === slug;
            const dot = dotFor(slug);
            const isDotSelected = editMode && selected?.kind === 'dot' && selected.slug === slug;
            return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                className: "territory-label",
                style: editMode ? {
                    cursor: 'grab'
                } : undefined,
                onClick: editMode ? undefined : ()=>onTerritoryClick(slug),
                onPointerDown: editMode ? (event)=>onDragStart('label', slug, event) : undefined,
                onMouseEnter: ()=>onHover(slug),
                onMouseLeave: ()=>onHover(null),
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6bcf64dfdf6ad5a9$export$297467e10fb6132c), {
                        slug: slug,
                        text: (0, $6c154842fccf6556$export$983732bc59a669db)(territory.slug, territory.name),
                        layout: layout,
                        at: [
                            x,
                            y
                        ],
                        editMode: editMode,
                        isEditSel: isLabelSelected
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                        className: "army-dot",
                        transform: `translate(${dot.x} ${dot.y}) scale(${dotScale}) translate(${-dot.x} ${-dot.y})`,
                        onPointerDown: editMode ? (event)=>onDragStart('dot', slug, event) : undefined,
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("circle", {
                                cx: dot.x,
                                cy: dot.y,
                                r: 11.5,
                                fill: "#fffdf5",
                                stroke: isDotSelected ? '#ff2fd6' : style.stroke,
                                strokeWidth: 2.5
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                                x: dot.x,
                                y: dot.y + 4,
                                className: "troops",
                                textAnchor: "middle",
                                children: territory.troops
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("text", {
                                x: dot.x,
                                y: dot.y + 22,
                                className: "units",
                                textAnchor: "middle",
                                children: (0, $45f8179f43663cce$export$789179201c389be1)(territory.troops)
                            })
                        ]
                    })
                ]
            }, `label-${slug}`);
        })
    });


const $473a150c596d157c$var$MapView = ({ territories: territories, selected: selected, targets: targets, activeTarget: activeTarget, fortifyTarget: fortifyTarget, convoys: convoys, round: round, onTerritoryClick: onTerritoryClick, onReady: onReady })=>{
    // hover tracked in state (not CSS :hover) so the badge/label layer above the
    // hit layer also lights up its territory
    const [hovered, setHovered] = (0, $acw62.useState)(null);
    const { svgRef: svgRef, artStackRef: artStackRef, aspectRef: aspectRef, viewRef: viewRef, viewBox: viewBox, dotScale: dotScale } = (0, $019efc78288eae6e$export$1317a8937778ff24)();
    const bySlug = Object.fromEntries(territories.map((t)=>[
            t.slug,
            t
        ]));
    // re-read every render — App re-renders the whole tree on a language switch
    const lang = (0, $6c154842fccf6556$export$dec8f99c0c14e178)();
    // ownership only changes on conquest — key the cluster computations and the
    // art bake on it instead of recomputing every render
    const ownershipKey = territories.map((t)=>t.faction.name).join('|');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const components = (0, $acw62.useMemo)(()=>(0, $db14449808df859a$export$687d60ddc6ec8462)(territories), [
        ownershipKey
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const flagClusters = (0, $acw62.useMemo)(()=>(0, $db14449808df859a$export$9172d5f369bced3d)(territories), [
        ownershipKey
    ]);
    const editor = (0, $8830abac408c4fb4$export$ac8df47f87d3436a)({
        territories: territories,
        lang: lang,
        bySlug: bySlug,
        svgRef: svgRef,
        viewRef: viewRef,
        aspectRef: aspectRef
    });
    const { layouts: layouts, editMode: editMode, overrides: overrides, decorOverrides: decorOverrides, selected: editSelection, dotFor: dotFor, decorFor: decorFor, startDrag: startDrag } = editor;
    const { deskUrl: deskUrl, artCanvasRef: artCanvasRef, revealCanvasRef: revealCanvasRef } = (0, $debbef03f2544258$export$43af311bd75a70ae)({
        territories: territories,
        bySlug: bySlug,
        flagClusters: flagClusters,
        ownershipKey: ownershipKey,
        editMode: editMode,
        lang: lang,
        dotFor: dotFor,
        onReady: onReady
    });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            !editMode && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "map-underlay",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "map-art-stack",
                    ref: artStackRef,
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("canvas", {
                            ref: artCanvasRef,
                            className: "map-art",
                            width: (0, $debbef03f2544258$export$79f5d796b8ab48ea),
                            height: (0, $debbef03f2544258$export$46cdbdf92224ca53)
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("canvas", {
                            ref: revealCanvasRef,
                            className: "map-reveal",
                            width: 0,
                            height: 0
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                ref: svgRef,
                className: "map",
                viewBox: viewBox,
                preserveAspectRatio: "xMidYMid slice",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45f8179f43663cce$export$a2c0099db84fd7d8), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6bcf64dfdf6ad5a9$export$4b5e6641e38c53b6), {}),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                        id: "map-frame",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                            x: 30,
                            y: 0,
                            width: 1500,
                            height: 820
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("clipPath", {
                        id: "desk-hole",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: "M-400 -300 h2360 v1420 h-2360 Z M30 0 h1500 v820 h-1500 Z",
                            clipRule: "evenodd",
                            fillRule: "evenodd"
                        })
                    }),
                    editMode ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("rect", {
                        x: -4000,
                        y: -4000,
                        width: 9500,
                        height: 9000,
                        fill: "#2e2419"
                    }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M-4000 -4000 h9500 v9000 h-9500 Z M30 0 h1500 v820 h-1500 Z",
                        fillRule: "evenodd",
                        fill: "#2e2419"
                    }),
                    !editMode && deskUrl && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("image", {
                        x: -400,
                        y: -300,
                        width: 2360,
                        height: 1420,
                        href: deskUrl,
                        preserveAspectRatio: "none",
                        clipPath: "url(#desk-hole)",
                        pointerEvents: "none"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("g", {
                        clipPath: "url(#map-frame)",
                        children: [
                            editMode && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6bcf64dfdf6ad5a9$export$3e957bac9b3d392f), {
                                bySlug: bySlug,
                                flagClusters: flagClusters,
                                components: components,
                                decor: false
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $54033658000b64f5$export$36b55809b37e7053), {
                                bySlug: bySlug,
                                selected: selected,
                                targets: targets,
                                activeTarget: activeTarget,
                                fortifyTarget: fortifyTarget,
                                hovered: hovered,
                                onTerritoryClick: onTerritoryClick,
                                onHover: setHovered
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $93faf3f38de7a78c$export$67ee96f9bd6505e6), {
                                bySlug: bySlug,
                                layouts: layouts,
                                overrides: overrides,
                                editMode: editMode,
                                selected: editSelection,
                                dotScale: dotScale,
                                dotFor: dotFor,
                                onTerritoryClick: onTerritoryClick,
                                onHover: setHovered,
                                onDragStart: startDrag
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $2504b5c703291c16$export$e15d7a9508616972), {
                                convoys: convoys,
                                round: round,
                                dotScale: dotScale,
                                bySlug: bySlug
                            }),
                            editMode && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $64e01790b10c58e6$export$9e39d3856f16bfe2), {
                                editMode: editMode,
                                overrides: decorOverrides,
                                selected: editSelection,
                                paramsFor: decorFor,
                                onDragStart: startDrag
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $81ae4d1c7e6a848d$export$13e347a0c825e367), {
                        editMode: editMode
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $300525fe127e51fc$export$5751855f5c7ef897), {
                bySlug: bySlug,
                editor: editor
            })
        ]
    });
};
var $473a150c596d157c$export$2e2bcd8739ae039 = $473a150c596d157c$var$MapView;




var $acw62 = parcelRequire("acw62");

const $abe342800d57128e$export$2143641fa599eb26 = 3;
const $abe342800d57128e$var$factionSnapshot = (game)=>Object.fromEntries(game.factions.map((faction)=>[
            faction.name,
            {
                hand: [
                    ...faction.hand
                ],
                grudges: [
                    ...faction.grudges
                ],
                peaceBroken: faction.peaceBroken
            }
        ]));
const $abe342800d57128e$export$36fdfb121d3b054f = (game)=>({
        v: $abe342800d57128e$export$2143641fa599eb26,
        core: {
            tradeCount: game.tradeCount,
            humanDefeated: game.humanDefeated,
            winner: game.winner?.name ?? null,
            endedRound: game.endedRound,
            log: game.log.map((entry)=>({
                    ...entry
                }))
        },
        turn: game.turn.snapshot(),
        board: game.board.snapshot(),
        factions: $abe342800d57128e$var$factionSnapshot(game),
        campaign: game.campaign.snapshot(),
        movement: game.movement.snapshot(),
        combat: game.combat.snapshot(),
        random: game.random.snapshot?.()
    });
const $abe342800d57128e$var$migrateLegacy = (game, legacy)=>({
        v: $abe342800d57128e$export$2143641fa599eb26,
        core: {
            tradeCount: legacy.tradeCount,
            humanDefeated: legacy.humanDefeated,
            winner: legacy.winner,
            endedRound: legacy.phase === 'gameover' ? legacy.round : 0,
            log: legacy.log
        },
        turn: {
            id: 0,
            round: legacy.round,
            playerIndex: legacy.currentPlayerIndex,
            phase: legacy.phase,
            reinforcements: {
                granted: legacy.reinforcementsLeft,
                remaining: legacy.reinforcementsLeft
            },
            attacks: {
                used: 0,
                advanceDepth: {}
            },
            fortifiesUsed: legacy.fortifiesUsed,
            conqueredTerritory: legacy.conqueredThisTurn,
            liberatedHomeland: legacy.liberatedThisTurn ?? false,
            awaitingLanding: false
        },
        board: {
            territories: Object.fromEntries(game.territories.map((territory)=>{
                const record = legacy.territories[territory.slug];
                if (!record) throw new Error(`save is missing territory ${territory.slug}`);
                const entrench = legacy.entrench?.[territory.slug];
                return [
                    territory.slug,
                    {
                        ...record,
                        quietTurns: entrench?.[0] ?? 0,
                        entrenched: entrench?.[1] ?? 0,
                        heldSince: legacy.heldSince?.[territory.slug] ?? 1,
                        raidedOn: legacy.raidedOn?.[territory.slug] ?? 0
                    }
                ];
            }))
        },
        factions: legacy.factions,
        campaign: {
            variables: legacy.campaignVariables,
            retries: legacy.gateRetries ?? {},
            checkedOn: legacy.gateCheckedOn ?? {},
            announcedEvents: legacy.announcedEvents,
            pendingCards: legacy.pendingCards ?? [],
            pendingDecision: legacy.pendingDecision ?? null
        },
        movement: {
            convoys: legacy.convoys ?? [],
            pendingLandings: []
        },
        combat: {
            active: null,
            pendingAdvance: legacy.pendingAdvance ?? null,
            landedOn: legacy.landedOn ?? []
        }
    });
const $abe342800d57128e$export$806bbea4d4ff90b3 = (game, input)=>{
    if (!input || input.v !== $abe342800d57128e$export$2143641fa599eb26 && input.v !== 2) throw new Error('incompatible save');
    const snapshot = input.v === 2 ? $abe342800d57128e$var$migrateLegacy(game, input) : input;
    game.board.restore(snapshot.board);
    for (const faction of game.factions){
        const record = snapshot.factions[faction.name];
        if (!record) throw new Error(`Save is missing faction ${faction.name}`);
        faction.hand = [
            ...record.hand
        ];
        faction.grudges = new Set(record.grudges);
        faction.peaceBroken = record.peaceBroken;
    }
    game.turn.restore(snapshot.turn);
    game.campaign.restore(snapshot.campaign);
    game.movement.restore(snapshot.movement);
    game.combat.restore(snapshot.combat);
    game.tradeCount = snapshot.core.tradeCount;
    game.humanDefeated = snapshot.core.humanDefeated;
    game.winner = snapshot.core.winner ? game.factions.find((faction)=>faction.name === snapshot.core.winner) ?? null : null;
    game.endedRound = snapshot.core.endedRound;
    game.log = snapshot.core.log.map((entry)=>({
            ...entry
        }));
    if (snapshot.random !== undefined) {
        if (!game.random.restore) throw new Error('Save contains random state but the configured source cannot restore it');
        game.random.restore(snapshot.random);
    }
};


// Named save slots in localStorage. Each slot keeps its own key so one huge
// save can't blow the quota for the whole index, and the index itself stays
// small enough to read on every menu open.
const $944d38e2330df821$var$INDEX_KEY = 'independence.saves';
const $944d38e2330df821$var$SLOT_KEY = (id)=>`independence.save.${id}`;
const $944d38e2330df821$export$3c5e5c7763e0aa37 = 12;
const $944d38e2330df821$var$readIndex = ()=>{
    try {
        const raw = localStorage.getItem($944d38e2330df821$var$INDEX_KEY);
        const list = raw ? JSON.parse(raw) : [];
        return Array.isArray(list) ? list : [];
    } catch  {
        return [];
    }
};
const $944d38e2330df821$var$writeIndex = (list)=>{
    try {
        localStorage.setItem($944d38e2330df821$var$INDEX_KEY, JSON.stringify(list));
    } catch  {
    // quota or private mode — the slot write below will surface the failure
    }
};
const $944d38e2330df821$export$1496ea5d388228d2 = ()=>$944d38e2330df821$var$readIndex().sort((a, b)=>b.savedAt - a.savedAt);
const $944d38e2330df821$export$7cd6ef3e3a9070c2 = (meta, snapshot, id)=>{
    const slot = {
        ...meta,
        id: id ?? `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 7)}`,
        savedAt: Date.now()
    };
    localStorage.setItem($944d38e2330df821$var$SLOT_KEY(slot.id), JSON.stringify(snapshot));
    const list = $944d38e2330df821$var$readIndex().filter((s)=>s.id !== slot.id);
    list.push(slot);
    // trim the oldest beyond the cap so localStorage can't grow without bound
    const sorted = list.sort((a, b)=>b.savedAt - a.savedAt);
    for (const stale of sorted.slice($944d38e2330df821$export$3c5e5c7763e0aa37))localStorage.removeItem($944d38e2330df821$var$SLOT_KEY(stale.id));
    $944d38e2330df821$var$writeIndex(sorted.slice(0, $944d38e2330df821$export$3c5e5c7763e0aa37));
    return slot;
};
const $944d38e2330df821$export$adfe33b5e3538b1f = (id)=>{
    try {
        const raw = localStorage.getItem($944d38e2330df821$var$SLOT_KEY(id));
        if (!raw) return null;
        const snap = JSON.parse(raw);
        return snap && (snap.v === (0, $abe342800d57128e$export$2143641fa599eb26) || snap.v === 2) ? snap : null;
    } catch  {
        return null;
    }
};
const $944d38e2330df821$export$296ee9f0f472be1d = (id)=>{
    localStorage.removeItem($944d38e2330df821$var$SLOT_KEY(id));
    $944d38e2330df821$var$writeIndex($944d38e2330df821$var$readIndex().filter((s)=>s.id !== id));
};




var $acw62 = parcelRequire("acw62");

// HUD-styled replacement for window.prompt / window.confirm: same dark panel,
// gold accents and typography as the rest of the interface, so save naming and
// destructive confirmations don't drop out of the game's visual world.
const $ec81d008cf6d48ec$var$Dialog = ({ request: request, onClose: onClose })=>{
    const [value, setValue] = (0, $acw62.useState)('');
    const inputRef = (0, $acw62.useRef)(null);
    (0, $acw62.useEffect)(()=>{
        if (!request) return;
        setValue(request.defaultValue ?? '');
        // focus + select so typing replaces the suggested name immediately
        const id = window.setTimeout(()=>{
            inputRef.current?.focus();
            inputRef.current?.select();
        }, 20);
        const onKey = (e)=>{
            if (e.key === 'Escape') onClose();
        };
        document.addEventListener('keydown', onKey);
        return ()=>{
            window.clearTimeout(id);
            document.removeEventListener('keydown', onKey);
        };
    }, [
        request,
        onClose
    ]);
    if (!request) return null;
    const submit = (e)=>{
        e?.preventDefault();
        request.onConfirm(value);
        onClose();
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: "dialog-backdrop",
        onPointerDown: (e)=>e.target === e.currentTarget && onClose(),
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
            className: "hud dialog-card",
            onSubmit: submit,
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "dialog-title",
                    children: request.title
                }),
                request.kind === 'prompt' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                    ref: inputRef,
                    className: "dialog-input",
                    value: value,
                    onChange: (e)=>setValue(e.target.value),
                    maxLength: 60
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                    className: "dialog-buttons",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            onClick: onClose,
                            children: (0, $6c154842fccf6556$export$625550452a3fa3ec)('dialog.cancel')
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "submit",
                            className: request.danger ? 'danger' : 'primary',
                            children: request.confirmLabel ?? (0, $6c154842fccf6556$export$625550452a3fa3ec)('dialog.ok')
                        })
                    ]
                })
            ]
        })
    });
};
var $ec81d008cf6d48ec$export$2e2bcd8739ae039 = $ec81d008cf6d48ec$var$Dialog;


// Going fullscreen, and knowing whether it is worth offering.
//
// iOS has no API for hiding Safari's toolbar, and it only auto-hides the bar on
// a page that SCROLLS — this one pans instead, so the bar never leaves. The
// standard Fullscreen API is the way out where it exists: unprefixed on desktop
// and iPadOS since Safari 16.4, webkit-prefixed before that, and on iPhone only
// in recent versions (caniuse still reports iOS as partial). So: never assume,
// always feature-detect, and fall back to the installed home-screen app, which
// has no chrome at all.
const $da9dca253668eb86$var$requestOn = (el)=>el.requestFullscreen?.bind(el) ?? el.webkitRequestFullscreen?.bind(el) ?? el.webkitRequestFullScreen?.bind(el);
const $da9dca253668eb86$var$exitOn = (doc)=>doc.exitFullscreen?.bind(doc) ?? doc.webkitExitFullscreen?.bind(doc) ?? doc.webkitCancelFullScreen?.bind(doc);
const $da9dca253668eb86$export$72fee83dd1572775 = ()=>{
    if (typeof window === 'undefined') return false;
    const iosStandalone = window.navigator.standalone;
    return iosStandalone === true || window.matchMedia?.('(display-mode: standalone), (display-mode: fullscreen)').matches;
};
const $da9dca253668eb86$export$d7e5f5607a21fc72 = ()=>{
    if (typeof document === 'undefined') return false;
    const doc = document;
    return !!(doc.fullscreenElement ?? doc.webkitFullscreenElement);
};
const $da9dca253668eb86$export$e041d5707970e318 = ()=>{
    if (typeof document === 'undefined' || $da9dca253668eb86$export$72fee83dd1572775()) return false;
    const el = document.documentElement;
    const doc = document;
    // Safari advertises the method but refuses it when disabled by policy
    if (doc.fullscreenEnabled === false) return false;
    return !!$da9dca253668eb86$var$requestOn(el);
};
const $da9dca253668eb86$export$1aba1ee5e6dc1474 = async ()=>{
    const doc = document;
    try {
        if ($da9dca253668eb86$export$d7e5f5607a21fc72()) {
            await $da9dca253668eb86$var$exitOn(doc)?.();
            return false;
        }
        await $da9dca253668eb86$var$requestOn(document.documentElement)?.();
        return $da9dca253668eb86$export$d7e5f5607a21fc72();
    } catch  {
        // iPhone Safari has historically rejected this for non-video elements;
        // the home-screen install is the fallback and needs no error of its own
        return $da9dca253668eb86$export$d7e5f5607a21fc72();
    }
};




const $a33ebe2a405df873$var$LANGS = [
    {
        code: 'en',
        flag: "\uD83C\uDDEC\uD83C\uDDE7"
    },
    {
        code: 'tr',
        flag: "\uD83C\uDDF9\uD83C\uDDF7"
    }
];
// Cog button, fixed bottom-right, opening a settings panel: language plus
// named save slots. Self-contained so it survives independently of the HUD
// bars it floats near.
const $a33ebe2a405df873$var$SettingsMenu = ({ onSave: onSave, onLoad: onLoad, defaultSaveName: defaultSaveName })=>{
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [lang, setLangState] = (0, $acw62.useState)((0, $6c154842fccf6556$export$dec8f99c0c14e178)());
    const [saves, setSaves] = (0, $acw62.useState)([]);
    const [error, setError] = (0, $acw62.useState)(null);
    const [dialog, setDialog] = (0, $acw62.useState)(null);
    // the API is only offered where it exists and there is chrome to escape
    const [fsOffered] = (0, $acw62.useState)(()=>(0, $da9dca253668eb86$export$e041d5707970e318)());
    const [fullscreen, setFullscreen] = (0, $acw62.useState)(()=>(0, $da9dca253668eb86$export$d7e5f5607a21fc72)());
    const [music, setMusic] = (0, $acw62.useState)(()=>(0, $a02a16ce6e0bc642$export$2f52891e98fc2f65)());
    const [volume, setVolume] = (0, $acw62.useState)(()=>(0, $a02a16ce6e0bc642$export$6b637599c0fa455f)());
    const [sfx, setSfx] = (0, $acw62.useState)(()=>(0, $ae4c9b4b24a86223$export$b2e9fbdd9ded6db3)());
    const [sfxVol, setSfxVol] = (0, $acw62.useState)(()=>(0, $ae4c9b4b24a86223$export$53d47d6e5fab65a1)());
    (0, $acw62.useEffect)(()=>{
        const sync = ()=>setFullscreen((0, $da9dca253668eb86$export$d7e5f5607a21fc72)());
        document.addEventListener('fullscreenchange', sync);
        document.addEventListener('webkitfullscreenchange', sync);
        return ()=>{
            document.removeEventListener('fullscreenchange', sync);
            document.removeEventListener('webkitfullscreenchange', sync);
        };
    }, []);
    const rootRef = (0, $acw62.useRef)(null);
    const refreshSaves = ()=>setSaves((0, $944d38e2330df821$export$1496ea5d388228d2)());
    (0, $acw62.useEffect)(()=>{
        if (!open) return;
        refreshSaves();
        setError(null);
        const onDocClick = (e)=>{
            const el = e.target;
            if (el.closest && el.closest('.dialog-backdrop')) return;
            if (rootRef.current && !rootRef.current.contains(el)) setOpen(false);
        };
        const onKey = (e)=>{
            if (e.key === 'Escape') setOpen(false);
        };
        document.addEventListener('pointerdown', onDocClick);
        document.addEventListener('keydown', onKey);
        return ()=>{
            document.removeEventListener('pointerdown', onDocClick);
            document.removeEventListener('keydown', onKey);
        };
    }, [
        open
    ]);
    const choose = (code)=>{
        (0, $6c154842fccf6556$export$a3665b844fbc095d)(code);
        setLangState(code);
    };
    const doSave = ()=>setDialog({
            kind: 'prompt',
            title: (0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.saveNamePrompt'),
            defaultValue: defaultSaveName(),
            confirmLabel: (0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.saveCurrent'),
            onConfirm: (raw)=>{
                if (onSave(raw.trim() || defaultSaveName())) {
                    refreshSaves();
                    setError(null);
                } else setError((0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.saveFailed'));
            }
        });
    const doLoad = (id)=>setDialog({
            kind: 'confirm',
            title: (0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.confirmLoad'),
            confirmLabel: (0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.load'),
            onConfirm: ()=>{
                if (onLoad(id)) setOpen(false);
                else setError((0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.loadFailed'));
            }
        });
    const doDelete = (id)=>setDialog({
            kind: 'confirm',
            title: (0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.confirmDelete'),
            confirmLabel: (0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.delete'),
            danger: true,
            onConfirm: ()=>{
                (0, $944d38e2330df821$export$296ee9f0f472be1d)(id);
                refreshSaves();
            }
        });
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "lang-switcher",
        ref: rootRef,
        children: [
            open && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "settings-menu",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "settings-section",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "settings-label",
                                children: (0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.language')
                            }),
                            $a33ebe2a405df873$var$LANGS.map((l)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                    className: `lang-option${lang === l.code ? ' active' : ''}`,
                                    onClick: ()=>choose(l.code),
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            className: "lang-flag",
                                            children: l.flag
                                        }),
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                            children: (0, $6c154842fccf6556$export$625550452a3fa3ec)(`lang.${l.code}`)
                                        })
                                    ]
                                }, l.code))
                        ]
                    }),
                    (fsOffered || !(0, $da9dca253668eb86$export$72fee83dd1572775)()) && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "settings-section",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "settings-label",
                                children: (0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.display')
                            }),
                            fsOffered ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "save-action",
                                onClick: async ()=>setFullscreen(await (0, $da9dca253668eb86$export$1aba1ee5e6dc1474)()),
                                children: fullscreen ? `\u21F2 ${(0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.exitFullscreen')}` : `\u21F1 ${(0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.fullscreen')}`
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "settings-empty",
                                children: (0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.installHint')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "settings-section",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "settings-label",
                                children: (0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.sound')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "save-action",
                                onClick: ()=>{
                                    (0, $a02a16ce6e0bc642$export$6df7d8ca8e8b46f5)(!music);
                                    setMusic(!music);
                                },
                                children: music ? `\u{1F3B5} ${(0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.musicOff')}` : `\u{1F3B5} ${(0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.musicOn')}`
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "volume-row",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "range",
                                        className: "volume-slider",
                                        min: 0,
                                        max: 100,
                                        value: Math.round(volume * 100),
                                        "aria-label": (0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.musicVolume'),
                                        onChange: (e)=>{
                                            const level = Number(e.target.value) / 100;
                                            (0, $a02a16ce6e0bc642$export$ad4230c756f5c4e)(level);
                                            setVolume(level);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "volume-value",
                                        children: (0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.volumeValue', {
                                            volume: Math.round(volume * 100)
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                className: "save-action",
                                onClick: ()=>{
                                    (0, $ae4c9b4b24a86223$export$a5912a2438426e42)(!sfx);
                                    setSfx(!sfx);
                                },
                                children: sfx ? `\u{1F50A} ${(0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.sfxOff')}` : `\u{1F50A} ${(0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.sfxOn')}`
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("label", {
                                className: "volume-row",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                        type: "range",
                                        className: "volume-slider",
                                        min: 0,
                                        max: 100,
                                        value: Math.round(sfxVol * 100),
                                        "aria-label": (0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.sfxVolume'),
                                        onChange: (e)=>{
                                            const level = Number(e.target.value) / 100;
                                            (0, $ae4c9b4b24a86223$export$6d762aca21a0d7bf)(level);
                                            setSfxVol(level);
                                        }
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        className: "volume-value",
                                        children: (0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.volumeValue', {
                                            volume: Math.round(sfxVol * 100)
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "settings-section",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "settings-label",
                                children: (0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.saves')
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                                className: "save-action",
                                onClick: doSave,
                                children: [
                                    "\uD83D\uDCBE ",
                                    (0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.saveCurrent')
                                ]
                            }),
                            error && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "settings-error",
                                children: error
                            }),
                            saves.length === 0 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "settings-empty",
                                children: (0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.noSaves')
                            }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                                className: "save-list",
                                children: saves.map((s)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                        className: "save-row",
                                        children: [
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "save-info",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("strong", {
                                                        children: s.name
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("em", {
                                                        children: (0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.savedRound', {
                                                            round: s.round,
                                                            date: s.date
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                                className: "save-buttons",
                                                children: [
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        onClick: ()=>doLoad(s.id),
                                                        title: (0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.load'),
                                                        children: "\u21BA"
                                                    }),
                                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                                        onClick: ()=>doDelete(s.id),
                                                        title: (0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.delete'),
                                                        children: "\u2715"
                                                    })
                                                ]
                                            })
                                        ]
                                    }, s.id))
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "lang-cog",
                onClick: ()=>setOpen((o)=>!o),
                "aria-label": (0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.title'),
                "aria-expanded": open,
                title: (0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.title'),
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                    viewBox: "0 0 24 24",
                    width: "20",
                    height: "20",
                    fill: "none",
                    children: [
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: "M12 8.5a3.5 3.5 0 1 0 0 7 3.5 3.5 0 0 0 0-7Z",
                            stroke: "currentColor",
                            strokeWidth: "1.6"
                        }),
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: "M12 2.6c.5 0 1 .04 1.47.11l.36 1.83c.7.16 1.36.43 1.96.8l1.6-.98c.75.5 1.42 1.1 1.98 1.8l-.9 1.65c.4.6.7 1.27.88 1.98l1.85.3c.09.47.14.96.14 1.45s-.05.98-.14 1.45l-1.85.3a6.6 6.6 0 0 1-.88 1.98l.9 1.65c-.56.7-1.23 1.3-1.98 1.8l-1.6-.98c-.6.37-1.26.64-1.96.8l-.36 1.83c-.47.07-.97.11-1.47.11s-1-.04-1.47-.11l-.36-1.83a6.6 6.6 0 0 1-1.96-.8l-1.6.98a8.7 8.7 0 0 1-1.98-1.8l.9-1.65a6.6 6.6 0 0 1-.88-1.98l-1.85-.3A8.9 8.9 0 0 1 2.6 12c0-.49.05-.98.14-1.45l1.85-.3c.18-.71.48-1.38.88-1.98l-.9-1.65c.56-.7 1.23-1.3 1.98-1.8l1.6.98c.6-.37 1.26-.64 1.96-.8l.36-1.83A8.9 8.9 0 0 1 12 2.6Z",
                            stroke: "currentColor",
                            strokeWidth: "1.5",
                            strokeLinejoin: "round"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $ec81d008cf6d48ec$export$2e2bcd8739ae039), {
                request: dialog,
                onClose: ()=>setDialog(null)
            })
        ]
    });
};
var $a33ebe2a405df873$export$2e2bcd8739ae039 = $a33ebe2a405df873$var$SettingsMenu;



var $acw62 = parcelRequire("acw62");


const $1cee680eee39b243$export$6a38971a44e57422 = (game)=>{
    if (game.turn.phase !== 'gameover') return null;
    const turkey = game.humanPlayer.faction;
    const date = (0, $6c154842fccf6556$export$950651e963a037d3)(game.dateAt(game.endedRound || game.turn.round));
    if (game.winner && game.totalConquest) return {
        titleKey: 'overlay.total.title',
        bodyKey: 'overlay.total.body',
        vars: {
            date: date
        }
    };
    if (game.winner) {
        const beyond = turkey.territories.filter((territory)=>!(0, $a57adc7b3bbfe58c$export$458d7a1c5c3db6e9).includes(territory.slug));
        if (beyond.length) return {
            titleKey: 'overlay.beyond.title',
            bodyKey: 'overlay.beyond.body',
            vars: {
                date: date,
                named: (0, $6c154842fccf6556$export$b6eb773519eded85)(beyond.map((territory)=>(0, $6c154842fccf6556$export$983732bc59a669db)(territory.slug, territory.name)))
            }
        };
        return {
            titleKey: 'overlay.victory.title',
            bodyKey: 'overlay.victory.body',
            vars: {
                date: date
            }
        };
    }
    if (turkey.eliminated) return {
        titleKey: 'overlay.defeat.title',
        bodyKey: 'overlay.defeat.body',
        vars: {
            date: date
        }
    };
    const held = game.pactProgress;
    const missing = (0, $a57adc7b3bbfe58c$export$458d7a1c5c3db6e9).filter((slug)=>game.bySlug[slug].faction !== turkey);
    const named = missing.slice(0, 3).map((slug)=>(0, $6c154842fccf6556$export$983732bc59a669db)(slug, game.bySlug[slug].name)).join(', ');
    const tier = held >= (0, $a57adc7b3bbfe58c$export$458d7a1c5c3db6e9).length - 3 ? 'near' : held >= (0, $a57adc7b3bbfe58c$export$458d7a1c5c3db6e9).length / 2 ? 'partial' : 'poor';
    return {
        titleKey: `overlay.lausanne.${tier}.title`,
        bodyKey: `overlay.lausanne.${tier}.body`,
        vars: {
            date: date,
            held: held,
            total: (0, $a57adc7b3bbfe58c$export$458d7a1c5c3db6e9).length,
            missing: missing.length,
            named: named
        }
    };
};







var $acw62 = parcelRequire("acw62");
const $efacdc08a7f627ea$var$AI_TURN_DELAY = 600;
const $efacdc08a7f627ea$var$AI_ATTACK_DELAY = 300;
const $efacdc08a7f627ea$export$271d828839566a31 = (game, ai, refresh)=>(0, $acw62.useCallback)(()=>{
        const step = ()=>{
            if (game.turn.phase === 'gameover' || game.turn.currentPlayer.isHuman) {
                refresh();
                return;
            }
            ai.beginTurn();
            const turnId = game.turn.id;
            refresh();
            const attackLoop = ()=>{
                if (!game.turn.isCurrent(turnId)) return;
                if (game.turn.phase === 'gameover') {
                    refresh();
                    return;
                }
                if (ai.attackStep()) {
                    refresh();
                    window.setTimeout(attackLoop, $efacdc08a7f627ea$var$AI_ATTACK_DELAY);
                } else {
                    ai.finishTurn();
                    refresh();
                    window.setTimeout(step, $efacdc08a7f627ea$var$AI_TURN_DELAY);
                }
            };
            window.setTimeout(attackLoop, $efacdc08a7f627ea$var$AI_ATTACK_DELAY);
        };
        window.setTimeout(step, $efacdc08a7f627ea$var$AI_TURN_DELAY);
    }, [
        ai,
        game,
        refresh
    ]);



var $acw62 = parcelRequire("acw62");

const $fb248ef02a22da10$export$853f29f433d233a4 = (game, refresh, runAiTurns)=>{
    const [selected, setSelected] = (0, $acw62.useState)(null);
    const [fortifyTarget, setFortifyTarget] = (0, $acw62.useState)(null);
    const [lastBattle, setLastBattle] = (0, $acw62.useState)(null);
    const clearSelection = ()=>{
        setSelected(null);
        setFortifyTarget(null);
    };
    const resetInteraction = ()=>{
        clearSelection();
        setLastBattle(null);
    };
    // A landing awaiting the player's storm-or-turn-back call blocks the rest of the turn.
    const landingPending = ()=>game.turn.currentPlayer.isHuman && game.movement.pendingLandings.length > 0;
    const endPhase = ()=>{
        if (landingPending()) return;
        const wasFortify = game.turn.phase === 'fortify';
        game.turn.advancePhase();
        (0, $ae4c9b4b24a86223$export$80cb197f7ea4fe13)('uiClick');
        clearSelection();
        if (game.turn.phase !== 'attack') setLastBattle(null);
        refresh();
        if (wasFortify) runAiTurns();
    };
    const finishAttackPhaseIfSpent = ()=>{
        if (!game.turn.finishAttackPhaseIfSpent()) return false;
        clearSelection();
        setLastBattle(null);
        return true;
    };
    const humanFaction = game.humanPlayer.faction;
    const targets = (()=>{
        if (!selected || !game.turn.currentPlayer.isHuman) return [];
        const from = game.bySlug[selected];
        if (game.turn.phase === 'attack') return game.combat.targets(selected);
        if (game.turn.phase === 'fortify' && !fortifyTarget) return [
            ...from.adjacent.filter((territory)=>territory.faction === humanFaction && game.movement.transferCapacity(from, territory) > 0).map((territory)=>territory.slug),
            ...game.movement.seaTargets(selected)
        ];
        return [];
    })();
    const onTerritoryClick = (slug)=>{
        if (!game.turn.currentPlayer.isHuman || game.turn.phase === 'gameover' || landingPending()) return;
        const territory = game.bySlug[slug];
        if (game.turn.phase === 'reinforce') {
            game.turn.placeReinforcements(slug);
            (0, $ae4c9b4b24a86223$export$80cb197f7ea4fe13)('reinforcePlace');
            refresh();
            return;
        }
        if (game.turn.phase === 'attack') {
            if (territory.faction === humanFaction) {
                if (slug !== selected) {
                    game.combat.cancel();
                    setLastBattle(null);
                    if (finishAttackPhaseIfSpent()) {
                        refresh();
                        return;
                    }
                }
                const canAttackFrom = territory.troops > 1;
                setSelected(canAttackFrom ? slug : null);
                if (canAttackFrom) (0, $ae4c9b4b24a86223$export$80cb197f7ea4fe13)('select');
                return;
            }
            if (selected && targets.includes(slug)) {
                const result = game.combat.begin(selected, slug);
                if (result) setLastBattle(result);
                refresh();
            }
            return;
        }
        if (game.turn.phase !== 'fortify') return;
        if (game.turn.fortifiesUsed >= game.campaign.fortifyLimit || territory.faction !== humanFaction) return;
        if (!selected) {
            if (territory.troops > 1) {
                setSelected(slug);
                (0, $ae4c9b4b24a86223$export$80cb197f7ea4fe13)('select');
            }
            return;
        }
        if (slug === selected) {
            clearSelection();
            return;
        }
        if (targets.includes(slug)) setFortifyTarget(slug);
        else if (territory.troops > 1) {
            setSelected(slug);
            (0, $ae4c9b4b24a86223$export$80cb197f7ea4fe13)('select');
        }
    };
    const onAttackPress = ()=>{
        if (!lastBattle) return;
        (0, $ae4c9b4b24a86223$export$80cb197f7ea4fe13)('battleExchange');
        const result = game.combat.step(lastBattle.from.slug, lastBattle.to.slug);
        if (result) setLastBattle(result);
        if (game.bySlug[lastBattle.from.slug].troops < 2) setSelected(null);
        finishAttackPhaseIfSpent();
        refresh();
    };
    const onAttackBlitz = ()=>{
        if (!lastBattle) return;
        (0, $ae4c9b4b24a86223$export$80cb197f7ea4fe13)('battleBlitz');
        const result = game.combat.blitz(lastBattle.from.slug, lastBattle.to.slug);
        if (result) setLastBattle(result);
        if (game.bySlug[lastBattle.from.slug].troops < 2) setSelected(null);
        finishAttackPhaseIfSpent();
        refresh();
    };
    const onPullBack = ()=>{
        game.combat.pullBack();
        (0, $ae4c9b4b24a86223$export$80cb197f7ea4fe13)('pullBack');
        setLastBattle(null);
        finishAttackPhaseIfSpent();
        refresh();
    };
    const onFortifyAmount = (amount)=>{
        if (!selected || !fortifyTarget) return;
        if (game.bySlug[selected].isAdjacentTo(game.bySlug[fortifyTarget])) {
            game.movement.fortify(selected, fortifyTarget, amount);
            (0, $ae4c9b4b24a86223$export$80cb197f7ea4fe13)('fortify');
        } else // embark records log.embark; the observer voices it.
        game.movement.embark(selected, fortifyTarget, amount);
        clearSelection();
        refresh();
    };
    const onAdvance = (amount)=>{
        game.combat.advance(amount);
        (0, $ae4c9b4b24a86223$export$80cb197f7ea4fe13)('uiClick');
        finishAttackPhaseIfSpent();
        refresh();
    };
    const onLandingResolve = (assault)=>{
        game.movement.resolveLanding(assault);
        refresh();
    };
    const onAutoPlace = ()=>{
        if (landingPending()) return;
        game.reinforcements.autoPlace();
        (0, $ae4c9b4b24a86223$export$80cb197f7ea4fe13)('reinforcePlace');
        refresh();
    };
    const onTrade = ()=>{
        game.tradeCards(game.humanPlayer.faction);
        refresh();
    };
    return {
        selected: selected,
        fortifyTarget: fortifyTarget,
        lastBattle: lastBattle,
        targets: targets,
        clearSelection: clearSelection,
        resetInteraction: resetInteraction,
        endPhase: endPhase,
        onTerritoryClick: onTerritoryClick,
        onAttackPress: onAttackPress,
        onAttackBlitz: onAttackBlitz,
        onPullBack: onPullBack,
        onFortifyAmount: onFortifyAmount,
        onAdvance: onAdvance,
        onLandingResolve: onLandingResolve,
        onAutoPlace: onAutoPlace,
        onTrade: onTrade
    };
};



var $acw62 = parcelRequire("acw62");

// Playing a turn with a trained model.
//
// The net scores (position, move) pairs; a turn is then just "enumerate what is
// legal, score it, take the best" — with the option to stop, which is itself a
// scored move, so a faction can decide that attacking again is worth less than
// standing where it is. That is how Italy learns to do nothing.
//
// Every move offered here comes from the engine's own legality checks, so a
// model can never produce an order the rules would refuse.

// What the network actually sees.
//
// One vector per (position, candidate move), scored by that faction's own net —
// an action-value net rather than a policy head, because a single turn offers
// hundreds of from→to pairs and a head with one output per pair would be mostly
// dead weights. Every number is bounded to roughly [0, 1] so no single feature
// can dominate the first layer before any training has happened.
//
// Three parts:
//   the position now  ⊕  the move  ⊕  what the move would CHANGE about it
//
// That last part is one step of lookahead, and it is a difference rather than a
// second copy of the board on purpose. Feeding both the before and after states
// was tried and made the model markedly worse: the two are near-identical
// vectors, so two thirds of the input carried the same information twice and
// the move itself was diluted three to one. The delta is the same lookahead
// with nothing repeated — and it is zero when a move changes nothing, which is
// exactly what "end" means.
//
// The layout is faction-agnostic on purpose: every faction reads the same
// vector, from its own side of the board, and learns its own weights over it.
// Nothing here says "you are Greece" — the behaviour has to come from the
// rewards, not from a label the net can key off.

var $cfae44f0dfdf62c0$exports = {};
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = $cfae44f0dfdf62c0$exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = 'browser';
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ''; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return '/';
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};


// Experiment switch, so the lookahead can be measured rather than assumed.
// AI_LOOKAHEAD=0 drops the delta block entirely.
const $5f08c951ffb351aa$var$LOOKAHEAD = $cfae44f0dfdf62c0$exports.env?.AI_LOOKAHEAD !== '0';
const $5f08c951ffb351aa$export$6db0ca2bfbfc82ec = 17;
const $5f08c951ffb351aa$export$95aef549d2084108 = 20;
const $5f08c951ffb351aa$export$4bad953e4e2a4518 = $5f08c951ffb351aa$export$6db0ca2bfbfc82ec + $5f08c951ffb351aa$export$95aef549d2084108 + ($5f08c951ffb351aa$var$LOOKAHEAD ? $5f08c951ffb351aa$export$6db0ca2bfbfc82ec : 0);
const $5f08c951ffb351aa$var$ASSEMBLY_SEATS = [
    'ankara',
    'sivas'
];
const $5f08c951ffb351aa$var$PACT = new Set((0, $a57adc7b3bbfe58c$export$458d7a1c5c3db6e9));
const $5f08c951ffb351aa$var$clamp01 = (x)=>x < 0 ? 0 : x > 1 ? 1 : x;
const $5f08c951ffb351aa$var$ratio = (a, b)=>b <= 0 ? 0 : $5f08c951ffb351aa$var$clamp01(a / b);
const $5f08c951ffb351aa$export$6a304d15d04ad771 = (attackers, defenders)=>{
    const force = Math.max(0, attackers - 1);
    if (force <= 0) return 0;
    // the defender wins ties, so it is worth about 15% more than its count
    return $5f08c951ffb351aa$var$clamp01(force / (force + defenders * 1.15));
};
/** Expected survivors of an assault that succeeds — what would garrison it. */ const $5f08c951ffb351aa$var$expectedSurvivors = (attackers, defenders)=>Math.max(1, Math.round((attackers - 1) * (1 - defenders / Math.max(1, attackers - 1 + defenders))));
const $5f08c951ffb351aa$var$posture = (faction)=>{
    let borders = 0;
    let ownBorder = 0;
    let enemyBorder = 0;
    let biggest = 0;
    let threatened = 0;
    for (const t of faction.territories){
        if (t.troops > biggest) biggest = t.troops;
        let frontier = false;
        let threat = 0;
        for (const n of t.adjacent)if (n.faction !== faction) {
            frontier = true;
            enemyBorder += n.troops;
            if (n.troops > threat) threat = n.troops;
        }
        if (frontier) {
            borders++;
            ownBorder += t.troops;
            // a province an adjacent enemy could take outright is a province in danger
            if (threat > t.troops) threatened++;
        }
    }
    return {
        borders: borders,
        ownBorder: ownBorder,
        enemyBorder: enemyBorder,
        biggest: biggest,
        threatened: threatened
    };
};
const $5f08c951ffb351aa$export$b26f198a1ca9fc83 = (game, faction, reinforcementFeature)=>{
    const all = game.factions.reduce((n, f)=>n + f.troopTotal, 0);
    let strongest = 0;
    let rivals = 0;
    for (const f of game.factions)if (f !== faction && !f.eliminated) {
        rivals++;
        if (f.troopTotal > strongest) strongest = f.troopTotal;
    }
    const held = faction.territories.filter((t)=>$5f08c951ffb351aa$var$PACT.has(t.slug)).length;
    const p = $5f08c951ffb351aa$var$posture(faction);
    // Men aboard ship are yours and are coming, but they are not on the board
    // this round. Without this the position looks like an army that has simply
    // been destroyed, and nothing would ever choose to embark.
    const atSea = game.movement.troopsAtSea(faction);
    return [
        $5f08c951ffb351aa$var$clamp01(game.turn.round / 27),
        $5f08c951ffb351aa$var$clamp01(faction.territories.length / 45),
        $5f08c951ffb351aa$var$clamp01(faction.troopTotal / 200),
        $5f08c951ffb351aa$var$ratio(faction.troopTotal, all),
        $5f08c951ffb351aa$var$clamp01(atSea / 30),
        $5f08c951ffb351aa$var$clamp01(strongest / 200),
        $5f08c951ffb351aa$var$clamp01(held / (0, $a57adc7b3bbfe58c$export$458d7a1c5c3db6e9).length),
        $5f08c951ffb351aa$var$clamp01(rivals / 6),
        $5f08c951ffb351aa$var$clamp01(p.borders / 20),
        $5f08c951ffb351aa$var$clamp01(p.ownBorder / 150),
        $5f08c951ffb351aa$var$clamp01(p.enemyBorder / 150),
        $5f08c951ffb351aa$var$clamp01(faction.hand.length / 5),
        game.campaign.isPassive(faction) || game.campaign.frozen(faction) ? 1 : 0,
        // how the shared war against Ankara is going — the same number every
        // occupier is partly paid on, so it is worth being able to see
        $5f08c951ffb351aa$var$clamp01(1 - game.pactProgress / (0, $a57adc7b3bbfe58c$export$458d7a1c5c3db6e9).length),
        // provinces one enemy stack could take outright: the shape of the danger,
        // not just its size
        $5f08c951ffb351aa$var$ratio(p.threatened, faction.territories.length),
        // one big stack or many small ones — a different army entirely
        $5f08c951ffb351aa$var$ratio(p.biggest, faction.troopTotal),
        // what next turn's levy will bring, which is what makes a loss affordable
        reinforcementFeature ?? $5f08c951ffb351aa$var$clamp01(game.campaign.reinforcementsFor(faction) / 20)
    ];
};
const $5f08c951ffb351aa$export$8fb6c6605492bc6f = (game, faction, move)=>{
    const { from: from, to: to } = move;
    const target = to ?? from;
    let ownNeighbours = 0;
    let enemyFactions = 0;
    if (target) {
        const seen = new Set();
        for (const n of target.adjacent)if (n.faction === faction) ownNeighbours++;
        else seen.add(n.faction.name);
        enemyFactions = seen.size;
    }
    const defenderLoses = !!(to && to.faction !== faction && to.faction.territories.length === 1);
    const odds = move.kind === 'attack' ? $5f08c951ffb351aa$export$6a304d15d04ad771(from?.troops ?? 0, to?.troops ?? 0) : 0;
    return [
        move.kind === 'reinforce' ? 1 : 0,
        move.kind === 'attack' ? 1 : 0,
        move.kind === 'fortify' ? 1 : 0,
        // a crossing is a transfer that costs two rounds of absence, and the net
        // has to be able to tell it apart from a march
        move.kind === 'sail' ? 1 : 0,
        move.kind === 'end' ? 1 : 0,
        $5f08c951ffb351aa$var$clamp01((from?.troops ?? 0) / 30),
        $5f08c951ffb351aa$var$clamp01((to?.troops ?? 0) / 30),
        odds,
        target && $5f08c951ffb351aa$var$PACT.has(target.slug) ? 1 : 0,
        target && target.faction.alliance === 'turkey' ? 1 : 0,
        target && $5f08c951ffb351aa$var$ASSEMBLY_SEATS.includes(target.slug) ? 1 : 0,
        $5f08c951ffb351aa$var$clamp01(ownNeighbours / 6),
        // how deeply the current holder is dug in — a settled occupier is a
        // different proposition from one that arrived last turn
        target ? $5f08c951ffb351aa$var$clamp01((game.turn.round - target.heldSince) / 8) : 0,
        defenderLoses ? 1 : 0,
        // pressure on the province itself: what sits next to it that is not ours
        target ? $5f08c951ffb351aa$var$clamp01(target.adjacent.filter((n)=>n.faction !== faction).reduce((n, t)=>n + t.troops, 0) / 60) : 0,
        // a province on a seam between several enemies is a different prize from
        // one tucked behind a single front
        $5f08c951ffb351aa$var$clamp01(enemyFactions / 4),
        // what the attack would leave behind if it worked
        move.kind === 'attack' ? $5f08c951ffb351aa$var$clamp01($5f08c951ffb351aa$var$expectedSurvivors(from?.troops ?? 0, to?.troops ?? 0) / 30) : 0,
        move.kind === 'decision' ? 1 : 0,
        move.kind === 'decision' ? $5f08c951ffb351aa$var$ratio(move.choiceIndex ?? 0, Math.max(1, (move.choiceCount ?? 1) - 1)) : 0,
        move.kind === 'decision' ? $5f08c951ffb351aa$var$clamp01((move.choiceCount ?? 0) / 8) : 0
    ];
};
const $5f08c951ffb351aa$export$f63d7b9515436a65 = (game, faction, move, reinforcementFeature)=>{
    const { kind: kind, from: from, to: to } = move;
    const readState = ()=>$5f08c951ffb351aa$export$b26f198a1ca9fc83(game, faction, reinforcementFeature);
    if (kind === 'end' || kind === 'decision' || !from) return readState();
    if (kind === 'reinforce') {
        from.troops++;
        try {
            return readState();
        } finally{
            from.troops--;
        }
    }
    // Sailing empties the province and puts the men nowhere: for two rounds they
    // hold nothing and defend nothing. That absence IS the move's cost, and it is
    // what the net has to weigh against wherever they are going.
    if (kind === 'sail') {
        const moved = to ? game.movement.shippable(from, to) : 0;
        from.troops -= moved;
        try {
            return readState();
        } finally{
            from.troops += moved;
        }
    }
    if (kind === 'fortify' && to) {
        const moved = Math.max(1, Math.floor((from.troops - 1) / 2));
        from.troops -= moved;
        to.troops += moved;
        try {
            return readState();
        } finally{
            from.troops += moved;
            to.troops -= moved;
        }
    }
    if (kind === 'attack' && to) {
        const survivors = $5f08c951ffb351aa$var$expectedSurvivors(from.troops, to.troops);
        const fromTroops = from.troops;
        const owner = to.faction;
        const ownerIndex = owner.territories.indexOf(to);
        const toState = {
            troops: to.troops,
            quietTurns: to.quietTurns,
            entrenched: to.entrenched,
            heldSince: to.heldSince
        };
        game.board.changeControl(to, faction, game.turn.round);
        to.troops = survivors;
        from.troops = fromTroops - survivors;
        try {
            return readState();
        } finally{
            from.troops = fromTroops;
            const factionIndex = faction.territories.indexOf(to);
            if (factionIndex >= 0) faction.territories.splice(factionIndex, 1);
            to.faction = owner;
            owner.territories.splice(ownerIndex, 0, to);
            Object.assign(to, toState);
        }
    }
    return readState();
};
const $5f08c951ffb351aa$export$852441de1447e59e = (before, game, faction, move)=>{
    const out = new Array($5f08c951ffb351aa$export$4bad953e4e2a4518);
    if (!$5f08c951ffb351aa$var$LOOKAHEAD) {
        for(let i = 0; i < $5f08c951ffb351aa$export$6db0ca2bfbfc82ec; i++)out[i] = before[i];
        const m = $5f08c951ffb351aa$export$8fb6c6605492bc6f(game, faction, move);
        for(let i = 0; i < $5f08c951ffb351aa$export$95aef549d2084108; i++)out[$5f08c951ffb351aa$export$6db0ca2bfbfc82ec + i] = m[i];
        return out;
    }
    const after = $5f08c951ffb351aa$export$f63d7b9515436a65(game, faction, move, before[16]);
    for(let i = 0; i < $5f08c951ffb351aa$export$6db0ca2bfbfc82ec; i++)out[i] = before[i];
    const move16 = $5f08c951ffb351aa$export$8fb6c6605492bc6f(game, faction, move);
    for(let i = 0; i < $5f08c951ffb351aa$export$95aef549d2084108; i++)out[$5f08c951ffb351aa$export$6db0ca2bfbfc82ec + i] = move16[i];
    // the change, amplified: a single province moving is a fraction of a percent
    // of a board-wide summary, and unscaled it would sit under the noise floor
    for(let i = 0; i < $5f08c951ffb351aa$export$6db0ca2bfbfc82ec; i++){
        const d = (after[i] - before[i]) * $5f08c951ffb351aa$var$DELTA_GAIN;
        out[$5f08c951ffb351aa$export$6db0ca2bfbfc82ec + $5f08c951ffb351aa$export$95aef549d2084108 + i] = d < -1 ? -1 : d > 1 ? 1 : d;
    }
    return out;
};
/** How much the lookahead delta is scaled up before the net sees it. */ const $5f08c951ffb351aa$var$DELTA_GAIN = 8;
const $5f08c951ffb351aa$export$606190e461fe9031 = (game, faction, move)=>$5f08c951ffb351aa$export$852441de1447e59e($5f08c951ffb351aa$export$b26f198a1ca9fc83(game, faction), game, faction, move);


// A small multilayer perceptron: enough to learn a position evaluation, small
// enough to ship in the bundle and read without a library.
//
// The architecture follows the value-network approach used in the lalecg
// trainer — score a state rather than classify an action, then let the player
// pick the move whose resulting position scores highest. That keeps the output
// a single number no matter how large the action space is, which matters here:
// a single turn has hundreds of from→to pairs, and a policy head over them would
// need one output per pair.
//
// Written out rather than pulled in because inference has to run in the browser
// on a phone, and the whole of it is forty lines.
const $6d94fc140bed5279$var$leaky = (x)=>x > 0 ? x : 0.01 * x;
const $6d94fc140bed5279$var$dLeaky = (x)=>x > 0 ? 1 : 0.01;
// the output is a value estimate, squashed so a runaway reward cannot blow the
// weights up; rewards are scaled into the same range before training
const $6d94fc140bed5279$var$squash = (x)=>Math.tanh(x);
const $6d94fc140bed5279$var$dSquash = (y)=>1 - y * y;
class $6d94fc140bed5279$export$81c37e062c36d637 {
    sizes;
    weights;
    biases;
    constructor(sizes, seed = 1){
        this.sizes = sizes;
        this.weights = [];
        this.biases = [];
        // deterministic init: a training run has to be reproducible from its seed
        let s = seed >>> 0;
        const rand = ()=>{
            s = s * 1664525 + 1013904223 >>> 0;
            return s / 4294967296;
        };
        for(let l = 1; l < sizes.length; l++){
            const fanIn = sizes[l - 1];
            // He initialisation, which is what leaky ReLU wants
            const scale = Math.sqrt(2 / fanIn);
            this.weights.push(Array.from({
                length: sizes[l]
            }, ()=>Array.from({
                    length: fanIn
                }, ()=>(rand() * 2 - 1) * scale)));
            this.biases.push(new Array(sizes[l]).fill(0));
        }
    }
    /** Forward pass, keeping every layer's activations for backprop. */ forward(input) {
        const acts = [
            input
        ];
        const raws = [];
        for(let l = 0; l < this.weights.length; l++){
            const w = this.weights[l];
            const b = this.biases[l];
            const prev = acts[l];
            const raw = new Array(w.length);
            const out = new Array(w.length);
            const last = l === this.weights.length - 1;
            for(let i = 0; i < w.length; i++){
                const row = w[i];
                let sum = b[i];
                for(let j = 0; j < row.length; j++)sum += row[j] * prev[j];
                raw[i] = sum;
                out[i] = last ? $6d94fc140bed5279$var$squash(sum) : $6d94fc140bed5279$var$leaky(sum);
            }
            raws.push(raw);
            acts.push(out);
        }
        return {
            acts: acts,
            raws: raws
        };
    }
    // scratch buffers for run(): scoring is the hot loop of both training and
    // play — thousands of calls a turn — and allocating two arrays per call was
    // costing more than the arithmetic
    scratch = [];
    /** The value this net puts on a position. Allocation-free. */ run(input) {
        if (!this.scratch.length) this.scratch = this.sizes.slice(1).map((n)=>new Array(n).fill(0));
        let prev = input;
        for(let l = 0; l < this.weights.length; l++){
            const w = this.weights[l];
            const b = this.biases[l];
            const out = this.scratch[l];
            const last = l === this.weights.length - 1;
            for(let i = 0; i < w.length; i++){
                const row = w[i];
                let sum = b[i];
                for(let j = 0; j < row.length; j++)sum += row[j] * prev[j];
                out[i] = last ? Math.tanh(sum) : sum > 0 ? sum : 0.01 * sum;
            }
            prev = out;
        }
        return prev[0];
    }
    // scratch for runBatch: one activation buffer per candidate per layer, grown
    // to the widest batch seen and reused. A decision scores tens of candidates,
    // so the allocation would otherwise dwarf the arithmetic here too.
    batchScratch = [];
    /**
   * Score many positions at once. Identical arithmetic to calling run() on each
   * — same result to the last bit — but with the candidate loop INSIDE the
   * weight-row loop, so each weight row is read once and applied across the
   * whole batch while it is hot in cache rather than reloaded per candidate.
   * Measured at ~2x the sequential cost for a typical shortlist, which is most
   * of the forward-pass cost of a turn.
   */ runBatch(inputs) {
        const n = inputs.length;
        if (n === 0) return [];
        if (n === 1) return [
            this.run(inputs[0])
        ];
        if (this.batchScratch.length < n) for(let c = this.batchScratch.length; c < n; c++)this.batchScratch.push(this.sizes.slice(1).map((s)=>new Array(s)));
        let prev = inputs;
        for(let l = 0; l < this.weights.length; l++){
            const w = this.weights[l];
            const b = this.biases[l];
            const last = l === this.weights.length - 1;
            const out = [];
            for(let c = 0; c < n; c++)out.push(this.batchScratch[c][l]);
            for(let i = 0; i < w.length; i++){
                const row = w[i];
                const bi = b[i];
                const width = row.length;
                for(let c = 0; c < n; c++){
                    const p = prev[c];
                    let sum = bi;
                    for(let j = 0; j < width; j++)sum += row[j] * p[j];
                    out[c][i] = last ? Math.tanh(sum) : sum > 0 ? sum : 0.01 * sum;
                }
            }
            prev = out;
        }
        const result = new Array(n);
        for(let c = 0; c < n; c++)result[c] = prev[c][0];
        return result;
    }
    /** One SGD step towards `target`. Returns the squared error before it. */ train(input, target, rate) {
        const { acts: acts, raws: raws } = this.forward(input);
        const L = this.weights.length;
        const out = acts[L][0];
        const error = out - target;
        // output layer: value head, one unit
        let delta = [
            error * $6d94fc140bed5279$var$dSquash(out)
        ];
        for(let l = L - 1; l >= 0; l--){
            const prev = acts[l];
            const w = this.weights[l];
            const b = this.biases[l];
            const next = l > 0 ? new Array(prev.length).fill(0) : [];
            for(let i = 0; i < w.length; i++){
                const d = delta[i];
                if (d === 0) continue;
                const row = w[i];
                for(let j = 0; j < row.length; j++){
                    if (l > 0) next[j] += row[j] * d;
                    row[j] -= rate * d * prev[j];
                }
                b[i] -= rate * d;
            }
            if (l > 0) for(let j = 0; j < next.length; j++)next[j] *= $6d94fc140bed5279$var$dLeaky(raws[l - 1][j]);
            delta = next;
        }
        return error * error;
    }
    toJSON() {
        return {
            sizes: this.sizes,
            weights: this.weights,
            biases: this.biases
        };
    }
    static fromJSON(json) {
        const net = new $6d94fc140bed5279$export$81c37e062c36d637(json.sizes);
        net.weights = json.weights;
        net.biases = json.biases;
        return net;
    }
}
/**
 * Inference only, for the browser: the same forward pass without the training
 * scaffolding, taking the JSON straight as it was saved.
 */ const $6d94fc140bed5279$var$scratchFor = new WeakMap();
const $6d94fc140bed5279$export$fef61f332f2c0afc = (json, input)=>{
    let scratch = $6d94fc140bed5279$var$scratchFor.get(json);
    if (!scratch) {
        scratch = json.sizes.slice(1).map((n)=>new Array(n).fill(0));
        $6d94fc140bed5279$var$scratchFor.set(json, scratch);
    }
    let acts = input;
    for(let l = 0; l < json.weights.length; l++){
        const w = json.weights[l];
        const b = json.biases[l];
        const last = l === json.weights.length - 1;
        const out = scratch[l];
        for(let i = 0; i < w.length; i++){
            const row = w[i];
            let sum = b[i];
            for(let j = 0; j < row.length; j++)sum += row[j] * acts[j];
            out[i] = last ? Math.tanh(sum) : sum > 0 ? sum : 0.01 * sum;
        }
        acts = out;
    }
    return acts[0];
};
// Batched inference for the shipped models, the counterpart of Net.runBatch:
// score a whole shortlist off one pass over the weights. Bit-identical to
// calling evaluate() on each input. The scratch is keyed on the JSON and grown
// to the widest batch, so a turn's scoring allocates nothing after the first.
const $6d94fc140bed5279$var$batchScratchFor = new WeakMap();
const $6d94fc140bed5279$export$c809592f7a0fa121 = (json, inputs)=>{
    const n = inputs.length;
    if (n === 0) return [];
    if (n === 1) return [
        $6d94fc140bed5279$export$fef61f332f2c0afc(json, inputs[0])
    ];
    let scratch = $6d94fc140bed5279$var$batchScratchFor.get(json);
    if (!scratch) {
        scratch = [];
        $6d94fc140bed5279$var$batchScratchFor.set(json, scratch);
    }
    for(let c = scratch.length; c < n; c++)scratch.push(json.sizes.slice(1).map((s)=>new Array(s)));
    let prev = inputs;
    for(let l = 0; l < json.weights.length; l++){
        const w = json.weights[l];
        const b = json.biases[l];
        const last = l === json.weights.length - 1;
        const out = [];
        for(let c = 0; c < n; c++)out.push(scratch[c][l]);
        for(let i = 0; i < w.length; i++){
            const row = w[i];
            const bi = b[i];
            const width = row.length;
            for(let c = 0; c < n; c++){
                const p = prev[c];
                let sum = bi;
                for(let j = 0; j < width; j++)sum += row[j] * p[j];
                out[c][i] = last ? Math.tanh(sum) : sum > 0 ? sum : 0.01 * sum;
            }
        }
        prev = out;
    }
    const result = new Array(n);
    for(let c = 0; c < n; c++)result[c] = prev[c][0];
    return result;
};


const $433e05e19940be62$var$PACT = new Set((0, $a57adc7b3bbfe58c$export$458d7a1c5c3db6e9));
const $433e05e19940be62$var$END = {
    kind: 'end'
};
const $433e05e19940be62$var$EXPLORATION_END_CHANCE = 0.15;
const $433e05e19940be62$export$9e6add1e62cb59e5 = 3;
const $433e05e19940be62$export$51a7da6ba99372f0 = (faction)=>faction.territories.map((from)=>({
            kind: 'reinforce',
            from: from
        }));
const $433e05e19940be62$export$68e79e6a50bf005a = (event)=>{
    const choices = event.choices ?? [];
    return choices.map((choice, choiceIndex)=>({
            kind: 'decision',
            choiceKey: choice.key,
            choiceIndex: choiceIndex,
            choiceCount: choices.length
        }));
};
const $433e05e19940be62$var$attackKey = (from, to)=>`${from.slug}>${to.slug}`;
const $433e05e19940be62$export$1dc043fb2aea8637 = (game, faction, attempted = new Set())=>{
    const moves = [
        $433e05e19940be62$var$END
    ];
    for (const from of faction.territories){
        if (from.troops < 2) continue;
        for (const slug of game.combat.targets(from.slug)){
            const to = game.bySlug[slug];
            if (!attempted.has($433e05e19940be62$var$attackKey(from, to))) moves.push({
                kind: 'attack',
                from: from,
                to: to
            });
        }
    }
    return moves;
};
const $433e05e19940be62$export$98c7cf78c96ae6d4 = (game, faction)=>{
    const moves = [
        $433e05e19940be62$var$END
    ];
    for (const from of faction.territories){
        if (from.troops < 2) continue;
        for (const to of from.adjacent)if (to.faction === faction) moves.push({
            kind: 'fortify',
            from: from,
            to: to
        });
        for (const slug of game.movement.seaTargets(from.slug))moves.push({
            kind: 'sail',
            from: from,
            to: game.bySlug[slug]
        });
    }
    return moves;
};
const $433e05e19940be62$export$dcb93069a440abb3 = (game, faction, moves, model, explore = 0, random = Math.random)=>{
    if (!moves.length) return null;
    if (!model || explore > 0 && random() < explore) {
        const end = moves.find((move)=>move.kind === 'end');
        if (end && random() < $433e05e19940be62$var$EXPLORATION_END_CHANCE) return end;
        const active = end ? moves.filter((move)=>move !== end) : moves;
        return active[Math.floor(random() * active.length)] ?? end ?? null;
    }
    // the position is the same for every candidate — read it once
    const before = (0, $5f08c951ffb351aa$export$b26f198a1ca9fc83)(game, faction);
    let best = moves[0];
    let bestScore = -Infinity;
    for (const move of moves){
        const score = (0, $6d94fc140bed5279$export$fef61f332f2c0afc)(model, (0, $5f08c951ffb351aa$export$852441de1447e59e)(before, game, faction, move));
        if (score > bestScore) {
            bestScore = score;
            best = move;
        }
    }
    return best;
};
/** How much of a garrison this faction is willing to send forward on a fortify. */ const $433e05e19940be62$var$moveAmount = (game, from)=>{
    const spare = from.troops - 1;
    return Math.max(1, Math.floor(spare / 2));
};
const $433e05e19940be62$export$1016d5c8dd15bd0 = (game, model, opts = {})=>{
    const faction = game.turn.currentPlayer.faction;
    const explore = opts.explore ?? 0;
    const random = opts.random ?? Math.random;
    // plan search plays the whole turn as one searched unit
    if (opts.plan && model && explore === 0) {
        $433e05e19940be62$export$d12935a92468a6f6(game, faction, $433e05e19940be62$export$6d5c8b14d4dd4286(model)(game, faction));
        return 0;
    }
    // reinforce in small batches rather than one unit at a time: adding a single
    // unit barely changes the board, and scoring is the expensive part
    let guard = 0;
    while(game.turn.phase === 'reinforce' && game.turn.reinforcementsLeft > 0 && guard++ < 500){
        while(game.findTradeSet(faction.hand))game.tradeCards(faction);
        const move = $433e05e19940be62$export$dcb93069a440abb3(game, faction, $433e05e19940be62$export$51a7da6ba99372f0(faction), model, explore, random);
        if (!move?.from) break;
        for(let i = 0; i < $433e05e19940be62$export$9e6add1e62cb59e5 && game.turn.reinforcementsLeft > 0; i++)game.turn.placeReinforcements(move.from.slug);
    }
    if (game.turn.phase === 'reinforce') game.turn.advancePhase();
    let attacks = 0;
    let attackGuard = 0;
    const attempted = new Set();
    while(game.turn.phase === 'attack' && attackGuard++ < 200){
        const move = model ? $433e05e19940be62$export$dda371c747645c02(game, faction, $433e05e19940be62$export$1dc043fb2aea8637(game, faction, attempted), (set)=>{
            const before = (0, $5f08c951ffb351aa$export$b26f198a1ca9fc83)(game, faction);
            return (0, $6d94fc140bed5279$export$c809592f7a0fa121)(model, set.map((m)=>(0, $5f08c951ffb351aa$export$852441de1447e59e)(before, game, faction, m)));
        }, (move)=>$433e05e19940be62$export$2fa93294faef9bf4(game, faction, move)) : $433e05e19940be62$export$dcb93069a440abb3(game, faction, $433e05e19940be62$export$1dc043fb2aea8637(game, faction, attempted), model, explore, random);
        if (!move || move.kind === 'end' || !move.from || !move.to) break;
        if (!game.combat.begin(move.from.slug, move.to.slug)) break;
        attempted.add($433e05e19940be62$var$attackKey(move.from, move.to));
        attacks++;
        // press the battle while the engine still rates it worth pressing — the
        // decision to START the fight is the model's, the grind is arithmetic
        let rounds = 0;
        while(rounds++ < 60){
            const step = game.combat.step(move.from.slug, move.to.slug);
            if (!step || !step.pending) break;
            if (!game.combat.worthPressing(move.from, move.to)) {
                game.combat.pullBack();
                break;
            }
        }
        if (game.combat.pendingAdvance) game.combat.advance(game.combat.pendingAdvance.max);
        if (game.turn.isGameOver) return attacks;
    }
    if (game.turn.phase === 'attack') game.turn.advancePhase();
    if (game.turn.phase === 'fortify') {
        const move = $433e05e19940be62$export$dcb93069a440abb3(game, faction, $433e05e19940be62$export$98c7cf78c96ae6d4(game, faction), model, explore, random);
        if (move?.from && move.to) {
            if (move.kind === 'fortify') game.movement.fortify(move.from.slug, move.to.slug, $433e05e19940be62$var$moveAmount(game, move.from));
            else if (move.kind === 'sail') game.movement.embark(move.from.slug, move.to.slug, $433e05e19940be62$var$moveAmount(game, move.from));
        }
        if (game.turn.phase === 'fortify') game.turn.advancePhase();
    }
    return attacks;
};
const $433e05e19940be62$export$48aea83313ab2cfc = (models)=>(game, faction, move)=>{
        const model = models[faction.name];
        if (!model) return 0;
        return (0, $6d94fc140bed5279$export$fef61f332f2c0afc)(model, (0, $5f08c951ffb351aa$export$606190e461fe9031)(game, faction, move));
    };
const $433e05e19940be62$export$dda371c747645c02 = (game, faction, moves, // a whole shortlist at once: both plies score a set of candidates off one
// reading of the board, which is exactly what batches on the network side —
// see Net.runBatch. A single-move scorer would defeat that, so the contract
// is the batch.
scoreMany, apply, opts = {})=>{
    if (!moves.length) return null;
    const search = $433e05e19940be62$var$SEARCH[faction.name] ?? $433e05e19940be62$var$SEARCH.default;
    const beam = opts.beam ?? search.beam;
    const cap = opts.followUps ?? search.followUps;
    const discount = opts.discount ?? 0.7;
    const values = scoreMany(moves);
    const scored = moves.map((move, i)=>({
            move: move,
            value: values[i]
        })).sort((a, b)=>b.value - a.value);
    if (scored.length <= 1) return scored[0]?.move ?? null;
    let best = scored[0].move;
    let bestValue = -Infinity;
    for (const { move: move, value: value } of scored.slice(0, beam)){
        let ahead = 0;
        const undo = apply(move);
        if (undo) {
            const followUps = $433e05e19940be62$export$1dc043fb2aea8637(game, faction).slice(0, cap);
            const aheads = scoreMany(followUps);
            for (const v of aheads)if (v > ahead) ahead = v;
            undo();
        }
        const total = value + discount * ahead;
        if (total > bestValue) {
            bestValue = total;
            best = move;
        }
    }
    return best;
};
/**
 * How far ahead each faction plans.
 *
 * Not the same for everyone, and deliberately so. Turkey fights this war with
 * sixteen provinces under one command; the six against it are separate powers
 * with a handful each, and three of them lose the right to attack at all
 * partway through by treaty. Two-ply search rewards whoever has the most moves
 * to plan with, which is Turkey, so an identical search made an already uneven
 * board worse — 85% of wars won and the occupiers holding one per cent of their
 * own aims.
 *
 * The answer is not to make Turkey play worse. It is to let the weaker side
 * think longer, the way a handicap in engine play gives the weaker side more
 * search rather than giving the stronger one less.
 */ const $433e05e19940be62$var$SEARCH = {
    Turkey: {
        beam: 3,
        followUps: 10
    },
    default: {
        beam: 5,
        followUps: 16
    }
};
const $433e05e19940be62$export$e76f0d61ba518608 = (model, game, faction, moves)=>{
    const before = (0, $5f08c951ffb351aa$export$b26f198a1ca9fc83)(game, faction);
    return moves.map((move)=>(0, $6d94fc140bed5279$export$fef61f332f2c0afc)(model, (0, $5f08c951ffb351aa$export$852441de1447e59e)(before, game, faction, move)));
};
const $433e05e19940be62$export$5dfd1a1380d3b4f9 = (models)=>(game, faction, moves)=>{
        const model = models[faction.name];
        if (!model) return moves[0] ?? null;
        const scoreMany = (set)=>{
            const before = (0, $5f08c951ffb351aa$export$b26f198a1ca9fc83)(game, faction);
            return (0, $6d94fc140bed5279$export$c809592f7a0fa121)(model, set.map((move)=>(0, $5f08c951ffb351aa$export$852441de1447e59e)(before, game, faction, move)));
        };
        return $433e05e19940be62$export$dda371c747645c02(game, faction, moves, scoreMany, (move)=>$433e05e19940be62$export$2fa93294faef9bf4(game, faction, move));
    };
const $433e05e19940be62$export$2fa93294faef9bf4 = (game, faction, move)=>{
    if (move.kind !== 'attack' || !move.from || !move.to) return null;
    const { from: from, to: to } = move;
    const survivors = Math.max(1, Math.round((from.troops - 1) * 0.6));
    if (from.troops <= survivors) return null;
    const boardSnapshot = game.board.snapshot();
    const turnSnapshot = game.turn.snapshot();
    if (!game.turn.useAttack(from.slug, to.slug)) return null;
    game.turn.recordConquest(from.slug, to.slug);
    game.board.changeControl(to, faction, game.turn.round);
    to.troops = survivors;
    from.troops -= survivors;
    return ()=>{
        game.board.restore(boardSnapshot);
        game.turn.configure({
            attacks: turnSnapshot.attacks,
            conqueredTerritory: turnSnapshot.conqueredTerritory
        });
    };
};
const $433e05e19940be62$export$6d5c8b14d4dd4286 = (model)=>(game, faction)=>(moves)=>{
            const before = (0, $5f08c951ffb351aa$export$b26f198a1ca9fc83)(game, faction);
            return (0, $6d94fc140bed5279$export$c809592f7a0fa121)(model, moves.map((m)=>(0, $5f08c951ffb351aa$export$852441de1447e59e)(before, game, faction, m)));
        };
const $433e05e19940be62$var$DEFAULT_BUDGET = {
    mass: 4,
    axes: 3,
    rolloutCap: 14
};
/** The net's read of standing pat — V(s), the value of the position itself. */ const $433e05e19940be62$var$positionValue = (score)=>score([
        $433e05e19940be62$var$END
    ])[0];
const $433e05e19940be62$var$borderProvinces = (faction)=>faction.territories.filter((t)=>t.adjacent.some((n)=>n.faction !== faction));
/** The enemy powers this faction actually borders, most-contested first. */ const $433e05e19940be62$var$enemyAxes = (faction, cap)=>{
    const pressure = new Map();
    for (const t of faction.territories)for (const n of t.adjacent)if (n.faction !== faction && !n.faction.eliminated) {
        const seen = pressure.get(n.faction.name);
        if (seen) seen.troops += n.troops;
        else pressure.set(n.faction.name, {
            faction: n.faction,
            troops: n.troops
        });
    }
    return [
        ...pressure.values()
    ].sort((a, b)=>b.troops - a.troops).slice(0, cap).map((p)=>p.faction);
};
const $433e05e19940be62$export$cd26f4129c6052d2 = (game, faction, attempted, score, axis)=>{
    const moves = $433e05e19940be62$export$1dc043fb2aea8637(game, faction, attempted).filter((m)=>m.kind === 'attack' && !!m.from && !!m.to && (0, $5f08c951ffb351aa$export$6a304d15d04ad771)(m.from.troops, m.to.troops) > 0.5);
    if (!moves.length) return null;
    const scores = score(moves);
    const onAxis = axis ? moves.map((_, i)=>i).filter((i)=>moves[i].to.faction === axis) : [];
    const pool = onAxis.length ? onAxis : moves.map((_, i)=>i);
    let best = pool[0];
    for (const i of pool)if (scores[i] > scores[best]) best = i;
    return moves[best];
};
/** Roll the attack phase forward on the LIVE board (caller snapshots/restores). */ const $433e05e19940be62$var$rolloutAttacks = (game, faction, score, axis, cap)=>{
    const attempted = new Set();
    for(let step = 0; step < cap; step++){
        const move = $433e05e19940be62$export$cd26f4129c6052d2(game, faction, attempted, score, axis);
        if (!move) break;
        const { from: from, to: to } = move;
        attempted.add(`${from.slug}>${to.slug}`);
        if (!game.turn.useAttack(from.slug, to.slug)) continue;
        const survivors = Math.max(1, Math.round((from.troops - 1) * 0.6));
        game.turn.recordConquest(from.slug, to.slug);
        game.board.changeControl(to, faction, game.turn.round);
        to.troops = survivors;
        from.troops -= survivors;
    }
};
/** The candidate ways to spend the levy, each a sequence of one-unit drops. */ const $433e05e19940be62$var$allocationPlans = (game, faction, score, levy, mass)=>{
    const pool = $433e05e19940be62$var$borderProvinces(faction);
    const targets = pool.length ? pool : faction.territories;
    if (!targets.length) return [
        []
    ];
    const plans = [];
    const threatOn = (t)=>t.adjacent.reduce((m, n)=>n.faction !== faction ? Math.max(m, n.troops) : m, 0);
    const facesLostPact = (t)=>t.adjacent.some((n)=>n.faction !== faction && $433e05e19940be62$var$PACT.has(n.slug));
    // defensive fill: each unit shores up the border with the largest deficit
    const extra = {};
    const defensive = [];
    for(let i = 0; i < levy; i++){
        const pick = targets.slice().sort((a, b)=>threatOn(b) + 1 - b.troops - (extra[b.slug] ?? 0) - (threatOn(a) + 1 - a.troops - (extra[a.slug] ?? 0)))[0];
        extra[pick.slug] = (extra[pick.slug] ?? 0) + 1;
        defensive.push(pick.slug);
    }
    plans.push(defensive);
    // concentration: all of it on one province, for the few most worth massing on
    const massTargets = targets.slice().sort((a, b)=>Number(facesLostPact(b)) - Number(facesLostPact(a)) || b.troops - a.troops).slice(0, mass);
    for (const p of massTargets)plans.push(Array(levy).fill(p.slug));
    // net-greedy: today's behaviour, so the search can never do worse than it
    const boardSnap = game.board.snapshot();
    const turnSnap = game.turn.snapshot();
    const greedy = [];
    let left = levy;
    let guard = 0;
    while(left > 0 && guard++ < 500){
        const moves = $433e05e19940be62$export$51a7da6ba99372f0(faction);
        if (!moves.length) break;
        const s = score(moves);
        let bi = 0;
        for(let i = 1; i < moves.length; i++)if (s[i] > s[bi]) bi = i;
        const slug = moves[bi].from.slug;
        for(let i = 0; i < $433e05e19940be62$export$9e6add1e62cb59e5 && left > 0; i++, left--){
            greedy.push(slug);
            game.bySlug[slug].troops++;
        }
    }
    while(left-- > 0)greedy.push(targets[0].slug);
    game.board.restore(boardSnap);
    game.turn.restore(turnSnap);
    plans.push(greedy);
    return plans;
};
const $433e05e19940be62$export$8fdc0f381d5482b1 = (game, faction, score, budget = {})=>{
    const { mass: mass, axes: axes, rolloutCap: rolloutCap } = {
        ...$433e05e19940be62$var$DEFAULT_BUDGET,
        ...budget
    };
    const levy = game.turn.reinforcementsLeft;
    const plans = $433e05e19940be62$var$allocationPlans(game, faction, score, Math.max(0, levy), mass);
    const fronts = [
        null,
        ...$433e05e19940be62$var$enemyAxes(faction, axes)
    ];
    const boardSnap = game.board.snapshot();
    const turnSnap = game.turn.snapshot();
    let best = {
        plan: plans[0],
        axis: null
    };
    let bestValue = -Infinity;
    for (const plan of plans)for (const axis of fronts){
        for (const slug of plan)game.bySlug[slug].troops++;
        game.turn.configure({
            phase: 'attack'
        });
        $433e05e19940be62$var$rolloutAttacks(game, faction, score, axis, rolloutCap);
        const value = $433e05e19940be62$var$positionValue(score);
        game.board.restore(boardSnap);
        game.turn.restore(turnSnap);
        if (value > bestValue) {
            bestValue = value;
            best = {
                plan: plan,
                axis: axis
            };
        }
    }
    return best;
};
const $433e05e19940be62$export$d12935a92468a6f6 = (game, faction, score, opts = {})=>{
    const record = opts.record;
    while(game.findTradeSet(faction.hand))game.tradeCards(faction);
    const { plan: plan, axis: axis } = $433e05e19940be62$export$8fdc0f381d5482b1(game, faction, score, opts.budget);
    const recordedReinforce = new Set();
    for (const slug of plan){
        if (game.turn.phase !== 'reinforce' || game.turn.reinforcementsLeft <= 0) break;
        // one training sample per distinct target, not one per unit — a levy of
        // twelve on one province is a single decision, not twelve
        if (record && !recordedReinforce.has(slug)) {
            recordedReinforce.add(slug);
            record({
                kind: 'reinforce',
                from: game.bySlug[slug]
            });
        }
        game.turn.placeReinforcements(slug);
    }
    if (game.turn.phase === 'reinforce') game.turn.advancePhase();
    const attempted = new Set();
    let guard = 0;
    while(game.turn.phase === 'attack' && guard++ < 200){
        const move = $433e05e19940be62$export$cd26f4129c6052d2(game, faction, attempted, score, axis);
        if (!move) break;
        if (record) record(move);
        attempted.add(`${move.from.slug}>${move.to.slug}`);
        if (!game.combat.begin(move.from.slug, move.to.slug)) break;
        let rounds = 0;
        while(rounds++ < 60){
            const step = game.combat.step(move.from.slug, move.to.slug);
            if (!step || !step.pending) break;
            if (!game.combat.worthPressing(move.from, move.to)) {
                game.combat.pullBack();
                break;
            }
        }
        if (game.combat.pendingAdvance) game.combat.advance(game.combat.pendingAdvance.max);
        if (game.turn.isGameOver) return;
    }
    if (game.turn.phase === 'attack') game.turn.advancePhase();
    if (game.turn.phase === 'fortify') {
        const moves = $433e05e19940be62$export$98c7cf78c96ae6d4(game, faction);
        const s = score(moves);
        let bi = 0;
        for(let i = 1; i < moves.length; i++)if (s[i] > s[bi]) bi = i;
        const move = moves[bi];
        if (record) record(move);
        if (move?.from && move.to) {
            if (move.kind === 'fortify') game.movement.fortify(move.from.slug, move.to.slug, $433e05e19940be62$var$moveAmount(game, move.from));
            else if (move.kind === 'sail') game.movement.embark(move.from.slug, move.to.slug, $433e05e19940be62$var$moveAmount(game, move.from));
        }
        if (game.turn.phase === 'fortify') game.turn.advancePhase();
    }
};
const $433e05e19940be62$export$b06101711748c98d = (models)=>(game, faction)=>$433e05e19940be62$export$6d5c8b14d4dd4286(models[faction.name])(game, faction);


const $c0c72f455dbe65e0$var$AGGRESSION = {
    Greece: {
        minEdge: 3
    },
    Armenia: {
        minEdge: 2
    },
    France: {
        minEdge: 3
    },
    Bulgaria: {
        minEdge: 3
    },
    Britain: {
        minEdge: 5
    },
    Italy: {
        minEdge: 6
    },
    Turkey: {
        minEdge: 2
    }
};
const $c0c72f455dbe65e0$var$RETALIATION_MIN_EDGE = 2;
const $c0c72f455dbe65e0$var$SEAT_PRIORITY = 8;
const $c0c72f455dbe65e0$var$REINFORCE_BATCH = 3;
const $c0c72f455dbe65e0$var$ATTACK_SAFETY_GUARD = 200;
class $c0c72f455dbe65e0$export$86ae2bbe2352fd33 {
    game;
    scorer;
    selector;
    planScore;
    planBudget;
    attacking;
    attackSteps;
    attemptedAttacks;
    // set for the current turn when plan search is driving it
    score;
    axis;
    constructor(game, options = {}){
        this.game = game;
        this.attacking = false;
        this.attackSteps = 0;
        this.attemptedAttacks = new Set();
        this.score = null;
        this.axis = null;
        this.scorer = options.scorer ?? null;
        this.selector = options.selector ?? null;
        this.planScore = options.planScore ?? null;
        this.planBudget = options.planBudget ?? {};
    }
    bestMove(faction, moves) {
        if (!moves.length) return null;
        if (this.selector) return this.selector(this.game, faction, moves);
        if (!this.scorer) return null;
        let best = moves[0];
        let bestScore = -Infinity;
        for (const move of moves){
            const score = this.scorer(this.game, faction, move);
            if (score > bestScore) {
                bestScore = score;
                best = move;
            }
        }
        return best;
    }
    beginTurn() {
        const game = this.game;
        if (game.turn.phase === 'gameover' || game.turn.currentPlayer.isHuman) return;
        const faction = game.turn.currentPlayer.faction;
        while(game.findTradeSet(faction.hand))game.tradeCards(faction);
        this.score = null;
        this.axis = null;
        if (this.planScore) {
            // choose the whole turn's plan, then spend the levy on it; the axis it
            // committed to steers attackStep below
            this.score = this.planScore(game, faction);
            const { plan: plan, axis: axis } = (0, $433e05e19940be62$export$8fdc0f381d5482b1)(game, faction, this.score, this.planBudget);
            this.axis = axis;
            for (const slug of plan){
                if (game.turn.phase !== 'reinforce' || game.turn.reinforcementsLeft <= 0) break;
                game.turn.placeReinforcements(slug);
            }
        } else if (this.scorer) {
            let guard = 0;
            while(game.turn.phase === 'reinforce' && game.turn.reinforcementsLeft > 0 && guard++ < 400){
                const move = this.bestMove(faction, faction.territories.map((from)=>({
                        kind: 'reinforce',
                        from: from
                    })));
                if (!move?.from) break;
                for(let i = 0; i < $c0c72f455dbe65e0$var$REINFORCE_BATCH && game.turn.reinforcementsLeft > 0; i++)game.turn.placeReinforcements(move.from.slug);
            }
        }
        game.reinforcements.autoPlace();
        this.attackSteps = 0;
        this.attemptedAttacks.clear();
        this.attacking = !game.campaign.frozen(faction) && (!game.campaign.isPassive(faction) || faction.grudges.size > 0);
    }
    attackOptions(faction) {
        const moves = [
            {
                kind: 'end'
            }
        ];
        for (const from of faction.territories){
            if (from.troops < 2) continue;
            for (const slug of this.game.combat.targets(from.slug))if (!this.attemptedAttacks.has(`${from.slug}>${slug}`)) moves.push({
                kind: 'attack',
                from: from,
                to: this.game.bySlug[slug]
            });
        }
        return moves;
    }
    attackStep() {
        const game = this.game;
        if (game.turn.phase !== 'attack' || game.turn.currentPlayer.isHuman || !this.attacking || this.attackSteps++ >= $c0c72f455dbe65e0$var$ATTACK_SAFETY_GUARD) return false;
        const faction = game.turn.currentPlayer.faction;
        if (this.score) {
            const move = (0, $433e05e19940be62$export$cd26f4129c6052d2)(game, faction, this.attemptedAttacks, this.score, this.axis);
            if (!move) {
                this.attacking = false;
                return false;
            }
            this.attemptedAttacks.add(`${move.from.slug}>${move.to.slug}`);
            if (!game.combat.begin(move.from.slug, move.to.slug)) {
                this.attacking = false;
                return false;
            }
            let step = game.combat.step(move.from.slug, move.to.slug);
            while(step && step.pending){
                if (!game.combat.worthPressing(move.from, move.to)) {
                    game.combat.pullBack();
                    break;
                }
                step = game.combat.step(move.from.slug, move.to.slug);
            }
            if (game.combat.pendingAdvance) game.combat.advance(game.combat.pendingAdvance.max);
            return true;
        }
        if (this.scorer) {
            const move = this.bestMove(faction, this.attackOptions(faction));
            if (!move || move.kind === 'end' || !move.from || !move.to) {
                this.attacking = false;
                return false;
            }
            if (!game.combat.begin(move.from.slug, move.to.slug)) {
                this.attacking = false;
                return false;
            }
            this.attemptedAttacks.add(`${move.from.slug}>${move.to.slug}`);
            let step = game.combat.step(move.from.slug, move.to.slug);
            while(step && step.pending){
                if (!game.combat.worthPressing(move.from, move.to)) {
                    game.combat.pullBack();
                    break;
                }
                step = game.combat.step(move.from.slug, move.to.slug);
            }
            if (game.combat.pendingAdvance) game.combat.advance(game.combat.pendingAdvance.max);
            return true;
        }
        const aggression = $c0c72f455dbe65e0$var$AGGRESSION[faction.name] ?? {
            minEdge: 3
        };
        const options = [];
        faction.territories.forEach((from)=>{
            if (from.troops < 3) return;
            const legalTargets = new Set(game.combat.targets(from.slug));
            from.adjacent.forEach((to)=>{
                if (!legalTargets.has(to.slug)) return;
                if (this.attemptedAttacks.has(`${from.slug}>${to.slug}`)) return;
                const avenging = faction.grudges.has(to.faction.name);
                const minEdge = avenging ? Math.min(aggression.minEdge, $c0c72f455dbe65e0$var$RETALIATION_MIN_EDGE) : aggression.minEdge;
                const seat = to.faction.alliance === 'turkey' && (0, $a57adc7b3bbfe58c$export$afae29cb2a27dbd6).includes(to.slug) ? $c0c72f455dbe65e0$var$SEAT_PRIORITY : 0;
                const edge = from.troops - to.troops;
                if (edge >= minEdge) options.push({
                    from: from,
                    to: to,
                    score: (avenging ? edge + 100 : edge) + seat
                });
            });
        });
        if (!options.length) {
            this.attacking = false;
            return false;
        }
        options.sort((left, right)=>right.score - left.score);
        const { from: from, to: to } = options[0];
        this.attemptedAttacks.add(`${from.slug}>${to.slug}`);
        let step = game.combat.step(from.slug, to.slug);
        while(step && step.pending){
            if (!game.combat.worthPressing(from, to)) {
                game.combat.pullBack();
                break;
            }
            step = game.combat.step(from.slug, to.slug);
        }
        return true;
    }
    finishTurn() {
        const game = this.game;
        if (game.turn.phase === 'gameover' || game.turn.currentPlayer.isHuman) return;
        const faction = game.turn.currentPlayer.faction;
        if (game.turn.phase === 'attack') game.turn.advancePhase();
        if (this.score) {
            const moves = [
                {
                    kind: 'end'
                }
            ];
            for (const from of faction.territories){
                if (from.troops < 2) continue;
                for (const to of from.adjacent)if (to.faction === faction) moves.push({
                    kind: 'fortify',
                    from: from,
                    to: to
                });
                for (const slug of game.movement.seaTargets(from.slug))moves.push({
                    kind: 'sail',
                    from: from,
                    to: game.bySlug[slug]
                });
            }
            const values = this.score(moves);
            let best = 0;
            for(let i = 1; i < moves.length; i++)if (values[i] > values[best]) best = i;
            const move = moves[best];
            if (move?.from && move.to) {
                if (move.kind === 'fortify') game.movement.fortify(move.from.slug, move.to.slug, game.movement.movable(move.from));
                else if (move.kind === 'sail') game.movement.embark(move.from.slug, move.to.slug, game.movement.movable(move.from));
            }
            this.score = null;
            this.axis = null;
            game.turn.finish();
            return;
        }
        if (this.scorer) {
            const moves = [
                {
                    kind: 'end'
                }
            ];
            for (const from of faction.territories){
                if (from.troops < 2) continue;
                for (const to of from.adjacent)if (to.faction === faction) moves.push({
                    kind: 'fortify',
                    from: from,
                    to: to
                });
                for (const slug of game.movement.seaTargets(from.slug))moves.push({
                    kind: 'sail',
                    from: from,
                    to: game.bySlug[slug]
                });
            }
            const move = this.bestMove(faction, moves);
            if (move?.from && move.to) {
                if (move.kind === 'fortify') game.movement.fortify(move.from.slug, move.to.slug, game.movement.movable(move.from));
                else if (move.kind === 'sail') game.movement.embark(move.from.slug, move.to.slug, game.movement.movable(move.from));
            }
            game.turn.finish();
            return;
        }
        if (!this.shipReinforcements(faction)) {
            const interior = faction.territories.filter((territory)=>territory.troops > 1 && territory.adjacent.every((adjacent)=>adjacent.faction === faction)).sort((left, right)=>right.troops - left.troops)[0];
            if (interior) {
                const border = interior.adjacent.filter((territory)=>territory.faction === faction).sort((left, right)=>game.threatOf(right) - game.threatOf(left))[0];
                if (border && game.threatOf(border) > -Infinity) game.movement.fortify(interior.slug, border.slug, game.movement.movable(interior));
            }
        }
        game.turn.finish();
    }
    shipReinforcements(faction) {
        const game = this.game;
        for (const from of faction.territories)for (const slug of game.movement.seaTargets(from.slug)){
            const to = game.bySlug[slug];
            const capacity = game.movement.shippable(from, to);
            if (capacity <= 0) continue;
            if (game.threatOf(to) <= game.threatOf(from) || to.troops >= from.troops) continue;
            if (game.movement.embark(from.slug, slug, capacity)) return true;
        }
        return false;
    }
    playTurn() {
        this.beginTurn();
        while(this.attackStep());
        this.finishTurn();
    }
}
const $c0c72f455dbe65e0$export$ace6fdeb3b4159e3 = (game, options = {})=>new $c0c72f455dbe65e0$export$86ae2bbe2352fd33(game, options).playTurn();


// The trained faction models, bundled with the game.
//
// Produced by `npm run train-ai` from self-play; each faction learns from its
// own reward function, so these seven files are seven different players rather
// than one player copied seven times. Regenerating them replaces the AI's
// behaviour wholesale, which is why they are committed: the game as played
// should always be the game that was trained.
var $3bc696fee26ae82f$exports = {};
$3bc696fee26ae82f$exports = JSON.parse("{\"sizes\":[54,40,24,1],\"weights\":[[[0.019216,0.17781,-0.010446,0.05888,0.13484,-0.083312,-0.057647,0.072043,-0.11649,-0.20408,-0.036836,0.0080924,-0.0095968,0.039552,-0.073283,0.022784,0.13206,0.0046131,0.14145,-0.029072,0.043047,-0.060864,0.023386,0.16904,-0.060115,-0.1944,-0.073279,0.06199,-0.085537,-0.053591,0.17739,-0.15178,0.055593,0.082663,-0.051951,-0.048603,-0.12182,-0.12557,-0.036379,-0.16085,0.088393,0.082242,-0.12704,-0.052885,-0.19235,-0.10104,-0.16175,-0.044319,-0.13055,0.040438,-0.0075347,0.15086,-0.052786,-0.15916],[0.9308,0.07971,0.051406,-0.25605,0.018006,-0.025336,-0.23974,0.076659,-0.037442,0.0078165,-0.074835,-0.012462,0.18529,-0.23189,0.035494,0.17108,-0.30294,0.0037761,-0.022217,0.037445,0.039084,-0.17168,-0.084809,0.0056497,0.074056,0.052772,-0.00054297,-0.024534,-0.074377,-0.062128,0.076722,0.10135,0.065636,-0.0067242,0.1843,-0.14673,0.15396,0.16953,-0.019798,-0.19329,-0.21069,0.012312,-0.02014,0.083419,0.069993,-0.019504,-0.1522,-0.17984,-0.074288,-0.056979,0.034381,0.1763,0.044834,-0.16529],[-0.035744,0.10949,-0.14694,-0.12701,-0.17139,0.067972,-0.12691,-0.15757,-0.11881,0.049634,0.12921,-0.14653,-0.034586,-0.16819,-0.10366,0.014145,-0.023156,-0.058314,0.025615,-0.095116,0.093699,-0.011812,-0.082372,-0.13198,0.054605,0.015254,0.083462,-0.15382,0.07475,0.13948,-0.1475,-0.076659,-0.15527,0.081639,-0.12815,-0.00087041,0.00059903,-0.15233,-0.1575,-0.12169,-0.094506,-0.12512,0.176,0.10158,-0.13105,0.18231,0.17251,-0.019415,-0.12585,0.096497,0.024561,-0.11942,0.055286,-0.16744],[-0.24399,-0.16539,-0.20213,-0.074236,0.083946,0.07981,-0.11629,-0.042755,-0.046196,-0.017435,0.054983,-0.16889,0.12003,-0.015659,0.040851,-0.13449,0.055245,-0.072078,-0.1016,0.12295,0.13279,0.000079385,0.095352,0.029629,0.096559,0.083598,0.13641,0.16393,0.15652,0.11775,-0.15081,-0.067207,0.10928,-0.09438,0.011284,0.12984,-0.02021,0.17214,0.13381,0.10325,0.089378,0.0301,0.027907,0.16452,0.014146,-0.1056,-0.18734,0.092482,0.0074761,0.052847,0.16177,0.11975,-0.0084262,-0.020663],[0.85551,-0.12191,0.12702,0.0044787,0.1237,0.12531,-0.18071,-0.092,-0.0080354,0.084617,-0.046665,0.013416,0.16038,-0.20665,-0.11496,0.078905,-0.20564,0.057565,-0.047408,0.033167,-0.084288,-0.12758,-0.012109,0.12669,-0.041979,-0.083871,-0.18839,-0.05957,0.072408,0.08415,0.11118,0.02582,0.014258,-0.1531,0.020848,-0.18764,-0.12679,-0.04214,0.057891,-0.016421,0.11703,-0.093056,-0.038126,-0.13789,0.028458,0.10305,-0.07198,0.0054939,0.14139,0.035452,-0.026204,-0.10473,-0.093139,0.18812],[-0.78633,-0.11009,-0.050232,-0.049682,0.078831,0.12312,0.25125,0.021878,0.015548,0.17945,0.095598,-0.041678,0.11895,0.16613,-0.13549,0.18314,-0.067156,-0.0050834,0.20983,0.071047,-0.14164,0.10215,-0.076339,0.030787,0.03891,-0.02623,0.1657,0.12513,0.084537,0.064116,-0.14196,-0.062419,0.011923,-0.10754,0.036925,0.30561,0.055353,0.16551,-0.019259,-0.043487,-0.058797,-0.14372,-0.068588,-0.15263,-0.22532,0.076979,-0.15742,0.13003,0.19053,-0.1205,-0.16549,-0.15042,-0.010442,0.17805],[-0.068208,-0.017065,-0.14168,0.1141,0.096433,0.0667,-0.13231,0.12789,-0.14473,0.16744,-0.10374,0.10693,-0.058166,-0.063215,-0.17026,0.18843,0.12319,0.03559,-0.09015,0.072467,0.17723,0.090325,0.10306,-0.047244,-0.14136,-0.22006,-0.032284,0.050861,0.062798,-0.085176,-0.0016965,-0.0054171,0.12188,-0.10886,0.027704,0.14627,0.041073,-0.17718,-0.10262,-0.065396,0.1679,-0.096593,-0.14954,-0.18907,-0.11797,0.18504,-0.17809,0.19206,-0.035612,-0.034692,0.062848,-0.028849,0.073909,0.11186],[-0.11872,0.0022329,0.034865,-0.14776,-0.13392,-0.12795,0.11864,-0.1096,-0.0062602,0.11243,-0.08855,-0.0060557,-0.025024,-0.058682,0.10163,-0.072721,0.031404,-0.00042369,-0.13284,-0.092896,-0.046655,0.038984,-0.0046729,0.17584,-0.036273,0.072637,-0.14944,0.19075,0.041656,-0.045919,0.096043,0.074734,0.088167,0.17164,0.11903,-0.097188,0.037881,0.002532,-0.063112,0.065837,0.039904,0.061993,-0.18273,0.12155,0.14268,0.066854,-0.059539,-0.063506,-0.13289,0.17459,-0.10912,-0.047557,-0.1784,0.1447],[-0.54727,-0.15301,0.20579,-0.012497,-0.082425,-0.091467,0.171,0.014635,0.18164,0.0058621,-0.19263,-0.045116,-0.13673,0.22101,0.081584,0.16821,0.14932,0.051465,0.076851,-0.17159,0.012792,0.085999,-0.097124,0.1446,-0.10832,0.09187,0.022159,-0.0669,0.039918,0.016872,0.11037,-0.0090604,-0.11125,0.097897,-0.025433,0.22037,0.11489,-0.16063,0.0025642,0.18385,0.094294,-0.058242,0.061951,0.010791,0.09433,0.1093,-0.016438,0.11281,-0.066541,0.17578,-0.1454,-0.069062,0.10298,0.17174],[-0.017229,0.14321,-0.021504,0.0882,0.011129,0.0062453,0.012636,0.15641,0.032974,-0.1613,-0.091746,0.0050302,0.034586,-0.072828,-0.16593,0.12863,0.16236,0.061331,0.017835,0.14737,-0.10996,0.053944,-0.086434,0.09846,0.10507,-0.080867,-0.094276,-0.13497,-0.17593,0.12936,0.14421,-0.14289,-0.096062,-0.085359,-0.10635,-0.14074,-0.17151,-0.084991,0.10713,-0.098604,0.065195,-0.03896,-0.068021,0.15811,0.052988,-0.1239,-0.15945,0.13333,-0.095065,-0.062095,0.036628,0.078763,0.0012516,-0.18685],[0.34661,0.055163,0.046741,-0.15091,0.026981,-0.054243,-0.13795,0.016267,-0.082402,-0.29308,0.030804,0.074893,-0.16832,0.30648,-0.17144,0.14134,-0.59218,-0.059356,-0.096873,0.060862,0.027415,-0.019584,-0.065752,0.14033,-0.19564,0.065741,-0.15115,-0.15233,0.055874,0.091253,0.15969,-0.058235,0.17604,0.017364,-0.065446,-0.11087,0.057591,0.15738,-0.16523,0.030269,-0.031393,0.16535,0.0030055,0.13925,0.10458,-0.084167,-0.070118,-0.033609,0.16384,0.14725,0.19427,0.12781,0.10768,0.056949],[-0.059634,-0.03261,-0.056281,-0.11861,-0.112,-0.098989,0.013095,-0.18221,0.013015,-0.14114,0.12616,0.14427,-0.085878,-0.03008,-0.13323,0.031612,-0.13946,-0.17148,-0.052421,-0.12588,0.16035,0.025065,-0.17263,0.15198,0.19144,0.14564,-0.17883,-0.05354,-0.098383,-0.097267,-0.083439,0.17691,-0.061236,0.059016,-0.16851,-0.030285,-0.10743,-0.03551,0.0054346,0.18081,-0.0685,-0.17624,-0.18142,0.0040439,0.064728,-0.01358,-0.18679,0.16621,-0.17206,-0.19059,-0.15436,-0.11074,0.13698,0.18189],[0.081347,-0.13493,-0.11572,0.093029,-0.043218,0.09111,0.054523,-0.026035,-0.1409,-0.04282,-0.15793,0.16447,-0.082386,-0.047196,-0.12518,-0.052018,0.20227,0.20599,0.16111,-0.12345,0.16207,-0.15349,-0.1912,-0.20419,0.0086897,0.083635,-0.1299,-0.079551,0.060726,-0.10859,-0.025566,0.19397,0.15114,-0.048451,0.13079,-0.15793,0.054491,0.13673,-0.11591,-0.10543,0.16623,-0.00051054,0.14428,0.17728,0.0078781,0.10547,0.17095,0.12607,-0.029757,0.0093895,-0.064853,0.10928,0.18079,0.018121],[0.69628,0.21428,0.17605,0.089588,-0.070026,-0.1124,-0.016865,0.080273,-0.17554,-0.1453,0.10648,0.033161,0.024966,-0.37378,0.014192,-0.1565,-0.05585,0.083541,-0.13466,-0.010023,-0.12392,-0.11833,0.0356,0.13261,0.024363,0.063963,-0.2558,-0.055869,0.14323,0.027664,0.0076552,0.062351,0.12409,-0.11115,0.2404,-0.30193,0.14323,-0.087076,0.087897,-0.10458,-0.15243,-0.019447,-0.061255,0.067942,0.20455,0.1678,0.084428,-0.17036,0.025235,-0.18725,-0.098511,0.11008,0.11808,-0.11259],[0.35463,0.17068,-0.034702,0.061646,-0.14774,0.06097,-0.10579,0.079504,-0.02214,0.056497,-0.0016891,0.146,0.12224,-0.085163,0.075316,0.009161,0.25834,-0.15281,0.017882,0.11267,0.088388,-0.10168,-0.079811,-0.18281,-0.1238,-0.046412,0.038589,-0.014989,-0.13668,0.0091707,-0.015759,-0.12653,-0.13754,0.098004,0.1578,-0.024593,0.1794,-0.17905,0.14649,-0.1655,0.029128,-0.15282,0.13156,0.14339,0.062129,-0.014384,-0.12368,-0.048712,-0.17588,-0.079323,0.1798,-0.010487,0.11312,-0.17448],[-0.15184,0.03046,-0.11758,0.023761,0.15185,-0.049847,0.16438,-0.057951,0.041259,-0.15988,0.081009,-0.065903,0.15223,-0.093312,0.021134,0.16527,-0.18083,-0.13914,0.1673,-0.16697,-0.097535,0.14108,0.17357,0.1494,0.02065,-0.0577,0.060334,-0.16253,-0.051654,0.063418,0.031218,0.058312,-0.015483,-0.15759,0.12817,-0.18809,-0.06375,-0.059798,0.037457,0.12564,0.025366,-0.15995,0.010664,-0.074359,-0.069165,-0.048107,0.058209,0.03262,0.057287,0.056657,0.13006,-0.028691,-0.10917,-0.13445],[-0.035222,-0.072477,-0.15531,-0.1764,0.13777,0.12452,0.12376,-0.18938,0.17272,-0.08451,0.056699,-0.11277,0.12971,0.14936,0.20716,-0.09549,-0.045013,0.0051318,0.042415,-0.016532,-0.1105,0.0088651,-0.18198,-0.0011048,0.12905,-0.044953,-0.13076,-0.0016888,0.126,-0.055229,0.07096,0.029147,-0.034208,-0.0086273,0.015301,-0.11177,-0.091801,0.053558,0.0061071,-0.058856,0.012068,-0.13006,0.012318,-0.089957,0.17955,0.089092,-0.019214,-0.10498,-0.017466,-0.13511,-0.14408,-0.1347,0.11415,-0.045621],[-1.5239,0.20785,0.05732,0.20938,-0.13054,0.11295,0.19992,-0.20367,0.16131,0.14907,0.046328,0.15551,-0.18001,0.18946,0.21788,-0.14519,0.65935,0.038598,0.19819,-0.10962,-0.10005,0.10572,-0.09231,-0.10305,0.21528,0.024273,0.36621,-0.075272,0.060271,0.0024709,-0.078373,-0.036139,0.04879,0.069231,-0.078009,0.17919,0.10562,0.03746,-0.018906,-0.009256,0.077705,-0.056733,-0.025584,0.14524,0.046443,-0.11305,0.076326,0.038677,0.005555,0.0098337,-0.13682,0.078431,-0.032505,0.072992],[-0.1188,-0.15351,-0.13309,0.23238,-0.12503,-0.19762,-0.15298,0.070389,0.20645,-0.055718,-0.21217,-0.15487,0.16945,0.16688,0.0079094,0.15522,-0.016922,0.14702,-0.12639,0.15197,0.034512,-0.16642,-0.042346,-0.11743,-0.023616,-0.053942,0.25771,0.15009,-0.078788,-0.039188,0.023691,-0.073926,-0.077296,0.03691,0.1744,0.18691,0.16619,-0.11615,-0.035116,0.14249,-0.11678,0.17781,0.17378,0.17758,-0.095349,0.19053,0.0056768,0.062382,-0.10378,0.14705,0.087272,-0.076531,0.03125,0.18],[-1.2006,0.19261,0.3417,0.30857,0.17395,0.108,0.0027665,-0.20903,0.13755,0.45936,-0.34654,0.19111,-0.11623,0.16782,0.078721,-0.070561,0.56655,0.12805,0.27665,0.11015,0.069247,0.12251,0.13427,-0.092593,0.10771,-0.013158,0.069292,0.0094377,-0.053071,-0.10354,-0.031371,0.05576,-0.046243,-0.09764,-0.085787,0.45397,0.004111,-0.14969,-0.16433,0.050003,0.11903,-0.12103,-0.15242,0.0016543,-0.000056891,-0.062242,0.10209,-0.086608,-0.023773,0.14429,0.18372,0.011942,-0.10843,0.050713],[2.0314,-0.16351,0.20099,0.018339,-0.15456,-0.094486,-0.34392,0.058258,-0.028585,0.016824,0.0761,-0.046723,-0.024516,-0.21344,-0.084036,-0.10757,-0.62663,-0.17748,-0.34063,-0.1218,0.13553,-0.2808,0.089586,-0.018077,-0.096228,-0.061856,-0.33476,-0.02741,0.085969,0.13448,-0.22912,-0.016068,-0.051196,-0.045554,0.15944,-0.51147,-0.12066,0.012781,0.032369,-0.21876,0.07701,-0.079414,0.03135,0.091543,0.020073,-0.11315,0.083483,-0.0034089,-0.093624,-0.11147,0.18699,-0.03397,-0.045999,0.099293],[-0.19195,-0.10641,-0.11544,-0.022874,0.037553,-0.0047454,0.16478,-0.042502,0.12495,-0.18548,0.14569,0.11725,-0.11653,-0.0061382,-0.14882,0.0035097,0.042029,0.1469,-0.17162,0.08809,0.016043,0.20863,0.10902,-0.00576,-0.19677,0.057779,0.042899,-0.12399,-0.14577,-0.011861,0.18184,-0.066156,-0.020432,-0.055988,-0.019259,-0.1067,0.05502,0.072591,0.12371,0.099995,-0.11111,-0.007235,0.079221,-0.058527,0.16712,-0.18773,0.084176,-0.16148,-0.10701,-0.16925,-0.1523,0.099406,-0.14322,-0.18898],[-0.9304,0.068533,0.26743,0.01928,-0.064526,0.11673,0.26106,0.040769,0.16861,0.107,-0.069269,-0.096918,-0.14603,0.10839,0.12744,-0.033515,0.63685,0.20991,0.10056,-0.029648,-0.078688,0.059241,-0.081026,0.13782,0.035886,-0.058665,0.1241,-0.0091765,-0.098829,-0.10784,-0.090394,-0.023162,0.046025,0.12945,-0.12288,0.33533,-0.015758,-0.043993,0.14821,-0.050336,0.18366,0.18193,0.038427,0.16199,-0.23643,-0.083576,0.10401,0.023174,-0.092282,0.15494,0.15386,0.021726,0.062038,0.033028],[0.094928,0.11698,-0.20491,-0.054955,0.11774,0.084506,-0.20515,0.11018,-0.025944,-0.10182,-0.0064186,0.018351,0.027559,0.065851,0.088744,0.084921,-0.073431,0.015755,-0.14697,-0.11772,-0.0504,0.11036,0.065926,-0.084554,0.098377,-0.1081,0.023506,0.052036,-0.1781,0.073043,-0.17818,0.10494,-0.16443,-0.053706,-0.14413,-0.093794,0.06257,0.04408,0.081512,0.012588,0.047309,-0.092394,0.15545,0.17796,0.18071,0.089124,-0.01287,0.035391,-0.11442,0.092343,-0.089284,0.17338,0.0053341,-0.064352],[0.34786,-0.10539,0.12228,-0.19962,0.12648,-0.098607,-0.12951,0.057777,-0.044121,0.18515,-0.10492,0.067528,-0.11624,0.06589,0.006314,-0.054819,-0.1917,-0.088439,-0.059923,0.017265,0.18411,-0.1454,-0.032791,0.16442,0.10014,0.094189,0.017255,0.070832,-0.097532,-0.1197,-0.03211,-0.025933,-0.13312,-0.020651,-0.09675,-0.030102,-0.15765,0.17638,-0.068641,0.050743,-0.17877,-0.10703,0.000025745,0.14514,0.0021518,-0.025849,-0.13673,-0.0087452,0.14393,-0.028776,-0.13609,0.005598,0.10598,0.089697],[-0.28388,-0.079845,-0.24215,0.011417,-0.059717,-0.14392,-0.25874,-0.11553,-0.15886,-0.0030764,0.2557,-0.056599,-0.16027,0.065708,0.031263,0.019668,-0.54406,0.085704,0.10855,0.024737,-0.096958,-0.16937,0.10389,0.15085,-0.078208,0.15599,0.019191,-0.033517,0.05142,0.15718,0.13086,0.017314,0.03271,-0.085285,-0.13483,-0.084267,-0.17439,0.15837,0.090204,0.0699,0.05375,0.056245,0.007547,-0.056633,0.078243,0.07829,-0.072467,0.1299,0.13743,-0.095951,-0.013482,0.032199,-0.11182,-0.13153],[2.298,0.0013604,0.14222,-0.18784,-0.13483,0.15614,-0.30343,-0.15764,0.19637,0.11489,-0.33476,0.058646,-0.085752,-0.71422,0.22603,0.061518,0.42678,-0.20618,-0.42611,-0.28174,0.01333,-0.66695,-0.057354,-0.051966,-0.027222,-0.077523,-0.13896,0.029623,-0.041672,-0.11536,0.099017,-0.0022453,-0.014802,0.12973,0.060502,-0.50048,0.14618,0.13483,0.033817,0.0013363,0.11995,-0.13328,-0.075385,0.030125,0.013284,-0.046956,0.033968,0.078908,0.16014,0.13285,-0.038605,-0.0049445,-0.015615,-0.11323],[0.19441,0.085055,-0.24718,-0.00099905,0.02621,0.13255,0.015497,0.013944,-0.27284,0.047932,0.07183,0.030442,-0.16286,0.02658,-0.25531,0.17637,-0.22719,-0.090518,-0.069486,-0.0012161,0.072664,0.059823,0.14566,0.097029,-0.22161,-0.11766,0.023935,-0.0013046,-0.18201,-0.062276,-0.089131,0.069572,0.12667,0.074219,0.14816,0.021519,0.024256,0.07778,0.094285,0.052377,-0.0587,-0.1794,0.12427,0.15034,-0.017569,0.092444,-0.16878,0.14578,-0.078236,-0.15982,-0.099964,-0.072649,0.07097,0.026053],[-0.24804,-0.11348,0.050157,0.18311,-0.079205,0.26398,-0.029034,-0.20629,0.14667,0.20475,-0.050692,0.11006,0.041667,-0.21951,0.12924,0.026411,0.30765,-0.12313,0.073382,-0.10896,-0.18801,0.058654,0.1146,0.040894,-0.14024,0.14286,0.044025,0.11932,0.035471,-0.1545,-0.13902,0.082005,0.12787,-0.13011,-0.15729,-0.04806,-0.082756,-0.14472,-0.018953,0.13604,0.1913,0.12885,-0.06998,0.099421,0.077263,0.017597,-0.035217,-0.089848,0.11632,0.1809,-0.1195,0.039875,-0.098208,-0.018161],[-0.099878,0.13879,-0.16085,-0.09828,-0.16059,-0.027093,0.16953,-0.08704,-0.14172,-0.0816,-0.14415,-0.1199,0.0034149,0.053819,0.052454,-0.13129,0.019844,0.0087135,-0.12449,0.10465,0.081084,0.021636,-0.13223,0.06327,-0.13687,0.038197,0.14077,0.083828,-0.18703,-0.043044,-0.11153,0.12268,-0.090605,-0.089456,0.05009,0.049515,-0.072177,0.014348,-0.1596,0.14113,-0.16156,-0.17428,-0.084952,0.15868,-0.1252,-0.16759,-0.0099581,0.1523,-0.11423,0.025477,0.029673,0.0059837,0.0074498,-0.026133],[-0.2279,-0.078145,0.1514,-0.081324,0.15627,0.0073548,0.20104,0.068606,0.20396,0.011824,0.097403,-0.076504,0.18666,-0.060807,-0.09471,-0.039582,0.088939,-0.10003,-0.027609,0.082231,0.058667,-0.019261,0.082792,-0.20327,0.18876,-0.0096914,0.11252,0.082288,0.046166,-0.046388,-0.0091194,0.030753,-0.11319,-0.20287,0.15986,0.022273,0.13101,-0.0059681,-0.056419,-0.15689,-0.11765,0.064708,-0.083265,-0.043678,0.013987,-0.11692,-0.097462,0.082095,-0.091045,0.17827,0.092716,0.11236,-0.0596,0.0038956],[0.03071,-0.14576,-0.11871,-0.077178,-0.15179,0.15304,-0.015174,0.15169,-0.15375,-0.15783,-0.066202,0.046454,0.078395,0.0103,-0.045424,0.094163,0.08426,0.086781,0.12489,-0.02904,0.069064,0.054317,-0.16065,-0.061751,0.0049903,0.072967,0.16805,0.17401,0.10223,-0.24013,-0.17798,-0.13687,-0.13232,0.065431,0.043326,0.16076,0.16555,0.11522,0.065217,-0.052894,0.069905,-0.13358,0.09464,-0.19426,0.099922,-0.014133,0.17187,-0.0061171,0.19131,-0.15889,-0.078622,0.13987,0.087093,0.023363],[-0.064613,-0.041814,-0.013268,-0.031852,-0.17745,-0.1348,-0.016436,-0.13455,-0.08279,-0.22149,-0.11694,0.034071,0.18645,0.17161,-0.077893,0.17028,0.17223,-0.022781,0.10421,0.086793,0.1149,-0.094065,0.1333,-0.1013,0.082992,0.11334,0.034414,-0.013848,0.16924,-0.078399,0.0188,0.024509,0.17743,-0.018302,-0.18206,0.012255,0.043483,0.11871,0.13198,-0.025985,0.15358,-0.16261,-0.12756,-0.045266,0.134,-0.087986,-0.032474,-0.11712,0.11225,0.16028,0.0085772,0.0010502,0.028726,0.11831],[0.030025,-0.058572,0.12435,-0.060917,-0.075257,-0.0059133,-0.18176,0.15204,-0.081127,0.041203,-0.1124,-0.15286,-0.14583,0.22833,0.042673,0.0066261,-0.24626,0.05435,0.0068824,0.1449,0.07368,0.24852,-0.059355,-0.045008,-0.030287,-0.04169,-0.16466,-0.027543,-0.18328,-0.040319,0.095195,0.16828,-0.041031,-0.038788,0.13324,-0.082531,-0.1632,0.015365,-0.016945,0.13563,-0.028271,-0.17824,0.0035463,-0.13532,-0.11131,-0.081357,-0.069785,-0.013824,-0.080905,0.0051634,-0.14266,-0.17783,0.15566,-0.15504],[0.16673,-0.040741,0.06446,0.16621,0.1538,-0.068669,-0.13141,-0.16152,-0.1543,0.083174,-0.12171,0.12867,-0.013376,0.069619,0.13415,0.075373,-0.16992,0.015758,-0.13598,0.001451,-0.065244,-0.095378,0.046569,0.13969,-0.17688,0.1735,-0.10444,0.013207,-0.014631,-0.0087111,-0.060597,0.11768,-0.094506,-0.14441,0.18461,0.14448,0.083995,0.0022406,-0.13689,-0.17705,0.031616,0.087542,-0.1706,0.063696,0.1261,0.13677,-0.15204,-0.16754,-0.0059913,-0.14817,0.025642,0.17516,0.10121,-0.14649],[-0.11768,0.032746,-0.050463,0.069571,-0.12628,-0.1474,0.12567,-0.065033,0.11247,-0.14843,-0.15078,0.19052,0.072938,0.086088,-0.12353,-0.16943,-0.0068524,-0.16079,-0.18184,-0.044151,0.020316,-0.1679,-0.18156,-0.14424,0.024783,-0.14578,-0.14475,-0.034443,0.15031,0.030667,-0.016496,-0.10013,-0.15289,0.080321,-0.07514,-0.14038,-0.15895,-0.05328,0.00014872,-0.027238,0.019605,-0.15327,0.081748,-0.11217,0.16259,-0.1908,-0.10745,-0.081134,0.15974,0.045222,-0.15724,0.10589,-0.08552,0.10499],[0.12514,-0.19489,-0.029994,-0.13263,-0.10066,-0.14621,-0.058953,-0.14628,-0.16772,-0.065066,-0.077138,-0.15156,-0.0013759,0.050725,0.090793,-0.086349,-0.14141,-0.12599,-0.051051,0.15404,-0.068543,0.15488,-0.014941,0.10126,-0.15438,0.19925,-0.20895,0.084601,0.16022,0.068242,0.14237,-0.035835,0.16705,-0.043982,-0.010792,0.093639,0.15145,-0.019512,0.15639,-0.050646,0.15859,0.10147,-0.12704,0.11781,-0.15969,0.086467,-0.10466,0.060682,-0.11106,0.1846,0.17509,0.21868,-0.097384,-0.039415],[-0.011539,-0.0071663,-0.15291,-0.05763,-0.10461,0.11502,-0.14334,0.045226,-0.11946,0.070151,0.043511,0.041537,-0.00051043,-0.05693,-0.12818,-0.012071,0.098719,0.063982,-0.12716,-0.14137,0.057829,-0.018512,0.065599,-0.096331,0.035899,-0.056433,-0.034225,-0.096695,-0.14226,-0.040035,0.14058,-0.063773,-0.14922,0.077123,-0.14043,-0.15524,0.15812,-0.11428,0.15216,0.091425,-0.1247,0.075647,0.16833,0.0074499,0.17352,0.039874,-0.13268,0.048821,-0.15969,0.057804,-0.013148,0.053889,-0.091362,0.14421],[-0.020553,-0.013899,-0.15199,0.037087,-0.071712,-0.085528,-0.0045226,0.047699,-0.031818,-0.043288,-0.22073,-0.030317,-0.13904,-0.087616,-0.094725,0.035484,0.11929,0.15046,0.15385,0.065117,0.12572,0.052101,0.019531,-0.104,0.16966,-0.020872,-0.0019058,-0.13796,0.054404,0.10867,-0.034251,-0.029961,-0.14096,-0.022462,-0.026153,0.15748,0.13305,-0.017381,-0.027601,-0.017058,-0.000057581,0.11885,-0.031186,-0.15061,-0.045906,0.081353,0.0036278,-0.045317,-0.08711,0.16126,0.11049,0.027525,0.15943,-0.013189],[0.0091678,-0.42225,-0.30342,-0.37352,0.038501,-0.38981,-0.55239,0.27699,-0.61428,-0.25053,0.56887,-0.079747,0.15407,0.44822,-0.20118,0.26706,-1.3294,-0.17274,-0.079053,-0.01044,-0.092215,0.17844,-0.054381,0.030234,-0.20076,-0.058493,0.052402,-0.075846,-0.15231,0.19258,-0.015137,0.032281,0.03794,0.034684,0.0078944,-0.16617,-0.15281,-0.13965,0.1404,-0.057491,-0.041448,0.16809,0.028489,0.18316,-0.019409,0.12731,0.11738,0.055091,-0.011108,-0.035136,-0.099721,-0.023789,-0.080147,-0.17699]],[[0.16697,0.082537,-0.061322,-0.13613,0.20204,-0.080409,-0.073604,-0.11761,-0.22578,-0.16258,-0.10968,0.043951,0.13241,0.086726,0.20445,-0.19213,0.16499,-0.31873,0.079107,-0.06951,0.40213,-0.23283,-0.052285,-0.17304,0.21405,0.0077566,0.44076,-0.17999,0.20985,0.17702,-0.17332,0.050633,-0.20834,-0.13364,0.11138,0.086219,-0.0021248,0.026311,-0.15896,-0.1932],[-0.11033,0.088743,-0.11846,-0.066151,-0.091212,-0.1078,0.17551,0.022245,0.2179,0.037196,-0.18922,0.12155,-0.11532,0.14259,-0.0011854,0.17648,-0.00020227,-0.1886,0.12077,0.11968,-0.055773,0.20799,-0.11693,0.0869,-0.15183,0.17022,-0.10699,0.078185,0.079501,-0.047416,-0.0042055,-0.14915,0.16347,0.05366,-0.17975,-0.14777,-0.0084674,0.16022,-0.086994,-0.19701],[-0.035717,0.056293,-0.0035092,-0.017377,0.00015556,0.15305,-0.052489,0.080347,-0.10151,-0.069148,0.19153,0.018579,-0.030727,-0.17493,0.13981,-0.1235,0.13902,0.017745,0.12807,-0.077833,0.16524,-0.0028077,-0.11322,-0.034117,-0.076433,-0.15135,0.233,-0.11616,-0.018007,-0.065217,0.020469,0.021611,0.066618,0.12139,0.10661,-0.19748,0.017786,-0.078096,0.0053409,0.10532],[0.11719,-0.042833,-0.16562,-0.09363,-0.11498,0.16872,-0.17395,0.027723,0.12891,-0.080109,-0.060878,-0.063024,0.0084111,0.055852,0.032207,0.15218,0.18462,0.047403,-0.047952,0.21464,-0.051161,0.13973,0.30005,-0.10625,-0.057028,-0.058676,-0.14993,0.19483,0.075996,-0.14026,-0.070747,-0.15972,-0.018694,-0.060882,-0.12695,-0.17981,0.097247,-0.12672,0.12367,-0.25153],[-0.099798,0.21175,0.11708,-0.11341,-0.10507,-0.01643,0.028034,-0.10516,0.068792,0.142,-0.12536,-0.13627,0.15695,-0.034827,-0.10028,0.015737,0.093708,-0.10552,-0.13524,-0.15259,0.032698,-0.20158,-0.17031,0.13087,-0.068067,-0.18984,0.04232,-0.20402,-0.18328,-0.20374,-0.109,-0.087711,0.071472,0.15117,-0.22195,0.18052,-0.018908,-0.18453,0.097732,-0.11258],[-0.099277,-0.084813,0.11715,0.14627,0.077797,0.12021,0.2029,-0.0097288,0.14351,0.10138,-0.030038,-0.20621,0.085462,-0.12178,0.17753,0.010601,-0.013352,-0.069505,0.20026,-0.068292,0.11025,-0.17724,0.062499,-0.22173,0.038443,-0.0061692,-0.12373,0.15295,0.19427,-0.016889,0.020037,-0.12132,-0.083585,-0.17478,0.086442,-0.13754,-0.058642,-0.053149,-0.16287,-0.15426],[-0.091724,0.20499,-0.0061304,0.078137,0.095064,0.13948,-0.056074,0.19531,0.0045784,0.23222,-0.070242,-0.11394,-0.017599,-0.021847,0.040703,0.20177,0.20889,-0.070793,0.055095,0.022811,-0.27486,-0.1079,0.16952,-0.010776,-0.20554,-0.1978,-0.2925,0.10057,-0.082102,-0.12064,0.084466,-0.11839,0.18425,0.027348,0.037496,0.12757,-0.10332,-0.025237,0.028281,-0.24395],[0.0926,0.12055,0.022242,-0.156,0.019919,-0.17435,-0.094108,-0.16738,-0.22842,-0.1157,0.2069,0.083692,0.048963,0.082774,0.15375,-0.20406,0.026911,0.028935,-0.06027,-0.048177,-0.13537,-0.088274,0.076233,-0.067561,0.066096,0.16191,0.14545,0.0092698,-0.20908,0.060809,0.0043497,-0.1625,-0.035898,0.046934,-0.13423,-0.023161,0.12582,0.13759,0.21147,0.11845],[-0.16396,0.15724,-0.15664,0.0065505,-0.22911,0.21444,-0.14961,0.17633,0.075938,-0.10696,-0.056195,0.078548,-0.18824,-0.22725,-0.015461,0.20516,0.21843,0.22195,-0.086316,0.13671,-0.088309,-0.0086115,0.055748,-0.079548,0.022531,0.19553,0.023778,0.068711,0.034355,0.21668,-0.18738,-0.027429,-0.18523,0.029123,0.1502,0.01165,-0.13795,0.10579,0.029582,0.044189],[-0.2031,-0.24938,-0.0072289,-0.046558,0.12685,0.15767,0.046274,-0.037597,-0.0011957,-0.18512,0.10092,0.11997,-0.12603,0.1415,-0.17498,0.13448,0.15572,0.10481,0.094954,0.032821,-0.086736,-0.019843,0.23098,-0.18237,0.12035,-0.1416,-0.068826,-0.18076,0.060011,-0.020212,-0.045173,-0.16348,0.20571,0.16436,-0.1412,-0.041431,-0.15868,-0.13438,0.020771,-0.13532],[0.20603,0.0014931,-0.13184,0.04978,0.23719,-0.094841,0.085611,-0.073257,0.14246,0.2186,-0.095704,-0.081431,-0.079322,-0.028872,-0.1037,-0.19926,0.022293,-0.12336,0.22257,-0.034188,0.21165,-0.10246,0.11959,0.00089418,-0.0013969,0.065077,0.046564,0.10822,-0.13972,-0.11395,-0.21054,-0.005819,0.031403,-0.15489,-0.16299,0.12455,0.027514,-0.19875,0.19004,-0.010456],[0.13626,-0.051161,0.19709,-0.13087,-0.21376,0.17844,0.10135,0.19721,0.11723,0.027167,-0.24316,0.17164,0.15066,-0.37361,-0.039424,-0.20666,0.036747,0.23556,0.1981,0.094507,-0.33564,0.12473,0.23574,0.17208,0.03511,-0.31468,-0.88013,-0.084576,0.01346,-0.19162,0.031881,0.09283,0.10251,-0.11515,0.0093177,0.10301,0.044823,0.031397,0.076128,-0.61145],[-0.020833,-0.20168,0.17981,0.09121,-0.17699,-0.072142,-0.20697,0.18385,0.20381,0.038426,-0.14396,-0.023796,0.13041,0.040032,-0.18007,-0.047651,-0.20043,0.11075,0.1431,-0.16943,-0.012455,-0.21229,0.1763,0.16716,-0.22149,-0.064399,-0.13945,0.18682,0.082709,0.17808,-0.002809,0.13669,-0.037175,-0.20039,0.1615,0.045123,-0.03247,-0.07214,-0.11481,0.17723],[-0.20387,-0.14387,-0.0017921,-0.13242,-0.21728,0.14428,0.10374,-0.066522,-0.021792,0.12727,-0.18741,-0.058693,-0.0037379,-0.17734,0.079954,0.016967,0.12788,0.22114,0.1553,0.27353,-0.32742,0.041774,-0.10795,0.1586,-0.19272,-0.20644,-0.59068,0.13311,0.1328,-0.18024,-0.21865,0.13108,0.23736,-0.065508,0.0072521,0.10776,-0.19757,-0.07918,-0.055547,-0.59321],[-0.11622,0.19064,-0.185,0.14363,0.19288,0.11854,-0.015975,-0.066107,-0.12831,0.074843,-0.19311,-0.083984,0.018528,-0.095978,-0.12885,-0.088173,-0.21609,0.18022,-0.19165,0.02732,-0.19265,-0.12751,-0.0016957,0.18631,0.018405,-0.21932,-0.25437,0.019908,0.1451,0.13782,0.23115,-0.055711,0.11929,-0.022193,-0.17596,0.2204,0.10925,-0.026858,-0.046715,0.1579],[-0.091784,0.058307,0.10194,0.076201,0.038877,0.014029,0.071663,-0.022989,-0.22318,-0.016375,-0.20009,0.13683,-0.17531,-0.1753,0.075089,0.18559,0.086196,-0.082992,0.036767,-0.18854,-0.0091919,-0.037686,0.00056095,-0.044494,0.1065,0.20625,-0.033244,0.14589,0.13682,0.082836,-0.21036,0.19017,0.18603,-0.077391,-0.045942,-0.21113,-0.07582,-0.10294,-0.21687,0.12118],[-0.13113,0.013145,-0.20992,0.18479,-0.23208,0.32198,-0.10775,0.12673,0.14602,0.072853,0.20952,0.10609,-0.18239,-0.009657,-0.17375,0.17874,-0.14869,-0.050751,-0.086838,-0.32069,-0.0093224,0.17505,-0.29677,0.09101,0.067972,0.26959,-0.11437,0.16431,-0.32094,0.18498,-0.25262,-0.10899,0.17306,0.36508,0.01564,-0.0051848,0.22638,-0.13781,-0.1175,0.30652],[-0.10661,0.17863,-0.2062,-0.19202,0.26163,0.15765,0.10449,-0.1097,-0.13524,-0.16545,0.21986,0.046412,-0.13968,-0.14402,-0.077327,-0.10444,0.19489,-0.25846,-0.14883,-0.40103,0.26386,0.05549,-0.197,0.27133,0.22292,0.012285,-0.074959,0.18408,-0.20359,0.030517,-0.003865,-0.0086109,0.13766,0.025949,0.058595,0.20245,-0.033343,0.10895,0.13737,0.42264],[0.13744,0.030449,-0.12728,-0.050069,-0.038341,-0.24502,0.1759,0.1389,0.15987,0.1905,0.076918,0.054548,-0.062168,0.11756,0.13939,0.035863,-0.22022,0.11842,0.21882,-0.15149,0.055851,-0.12617,-0.2006,0.05828,0.10072,0.12714,0.13266,0.20081,0.20976,-0.10354,0.036719,-0.19492,-0.11657,0.027046,0.21446,0.08846,0.1236,-0.047642,0.0363,-0.11561],[0.00023899,0.20306,-0.018959,0.13073,0.014733,-0.15145,0.10755,0.16334,-0.080953,-0.21951,0.063984,0.038887,0.13323,0.25244,0.099689,0.19397,-0.20018,-0.27392,-0.1828,0.08774,0.05361,0.017902,0.14946,0.041596,0.16801,-0.16307,0.14143,-0.032,-0.049978,-0.16062,0.10926,-0.21114,-0.073538,0.13157,-0.11387,-0.10397,-0.0061599,0.035223,0.14878,-0.18308],[-0.044026,-0.09695,-0.14169,0.060675,-0.087786,0.04784,-0.15733,0.0092178,-0.11323,-0.060108,-0.20612,0.042124,-0.20706,0.11597,-0.032853,0.068471,0.11868,0.15076,-0.074359,-0.22877,-0.23299,-0.18916,0.16823,0.10188,0.17972,0.23383,-0.20836,0.060943,0.05817,-0.17002,-0.043893,0.077016,0.1541,0.00083613,0.068802,0.1728,0.2201,-0.22278,0.17272,0.068205],[-0.035962,0.17655,-0.010304,-0.15809,0.12983,0.18024,0.0013392,0.026966,0.051568,-0.22293,0.051527,0.01495,0.10349,-0.044301,-0.070538,0.16145,-0.014819,-0.20462,0.069026,0.0071149,0.25542,0.20186,-0.19398,0.047998,0.099538,0.21084,-0.0239,0.027335,-0.011317,0.0041657,-0.1813,-0.086874,-0.055155,0.14054,0.15176,0.059708,0.040955,-0.076832,0.045531,0.042905],[0.038986,-0.30394,-0.084201,0.063016,-0.20447,0.10147,0.12144,-0.019469,0.11511,0.12856,-0.035235,-0.014972,0.13747,-0.028088,-0.17553,0.1368,-0.19388,0.19035,-0.023237,0.36761,-0.42989,0.042901,0.093004,-0.11969,0.14998,-0.021125,-0.77703,-0.23709,0.034554,0.20059,0.10244,0.11409,-0.089501,0.17909,0.11103,0.0055343,-0.039038,-0.17792,-0.16339,-0.57035],[0.20118,0.14571,0.14722,0.054729,-0.10803,-0.001166,0.11829,-0.17874,0.076848,-0.21179,0.16816,0.10478,-0.062628,-0.2263,-0.013328,-0.127,-0.1273,0.020232,-0.054477,0.13584,-0.14536,0.21234,-0.12955,-0.075762,-0.1347,-0.043206,0.088534,0.19402,0.059061,0.025388,-0.15981,-0.0067182,-0.13773,0.05589,0.01323,-0.13036,-0.11818,-0.16027,-0.13822,-0.19167]],[[-0.62173,0.08799,-0.14767,0.31368,-0.13393,0.067439,0.33299,0.10505,0.05447,0.2521,-0.13667,1.039,-0.15442,0.90342,0.18252,0.24356,-0.64825,-0.6045,-0.21073,-0.25791,-0.22076,-0.31226,0.92536,0.081412]]],\"biases\":[[-0.050231,-0.19761,-0.00013125,-0.021387,-0.23751,0.31176,0.068963,0.0087912,0.18359,0.0024131,0.024325,-0.00091229,0.0016157,-0.25489,-0.11146,0.011117,-0.00085373,0.44948,0.090705,0.28201,-0.58758,0.16742,0.21793,-0.044753,-0.034339,0.067006,-0.8727,0.015148,-0.014571,-0.00023183,0.043197,0.0068404,0.035752,0.074733,0.019127,0.00042829,0.025959,0.0043231,-0.055189,0.1588],[0.058824,0.02697,0.047724,0.13813,-0.0050472,0.0039602,0.13805,-0.032883,0.012765,0.11341,0.026205,0.3993,-0.080945,0.29676,0.035193,-0.052104,0.043487,-0.059682,-0.037681,-0.039579,-0.05763,-0.063245,0.38848,0.028811],[0.68076]]}");


var $8bdb551622310ea8$exports = {};
$8bdb551622310ea8$exports = JSON.parse("{\"sizes\":[54,40,24,1],\"weights\":[[[0.10911,0.059843,-0.098464,-0.034747,-0.12216,-0.10416,0.10503,-0.024959,0.24565,-0.16988,-0.19792,-0.19522,-0.17169,0.15044,-0.061632,-0.016826,-0.02382,0.1272,-0.13019,0.037557,-0.057241,0.11336,-0.28218,-0.15684,0.019828,0.05742,0.06727,0.093184,-0.18055,0.13129,0.16132,0.13084,-0.065243,-0.18368,-0.14597,-0.16858,0.094436,-0.13557,0.083868,0.029283,-0.11857,0.12985,0.067633,0.15032,-0.077697,-0.055483,0.15809,0.23954,-0.10602,0.047938,0.10585,-0.010726,-0.10384,-0.048374],[-0.10246,0.20862,0.19295,0.11328,0.096574,0.097926,-0.17476,-0.32897,0.12537,-0.10513,0.052772,0.14861,-0.09407,-0.09916,-0.056772,0.041316,0.22563,0.17391,-0.085854,0.20094,-0.14782,0.11748,-0.11941,-0.35716,0.15518,0.1809,0.031703,0.063043,0.094026,-0.093497,-0.030203,0.054836,-0.10638,0.065909,-0.12507,-0.18034,0.046442,0.072821,0.063187,0.050885,-0.014992,0.046867,0.041816,0.052981,0.18649,0.057062,0.048845,0.03923,-0.081149,-0.070459,-0.12125,-0.012851,-0.052114,-0.10113],[-0.090545,0.03686,-0.15684,-0.21365,-0.19164,-0.048101,0.1149,-0.0072481,0.038502,-0.11167,-0.19785,-0.20127,-0.0094541,0.21486,-0.31052,0.37214,0.033293,-0.071837,0.038701,-0.097358,0.095261,0.026919,0.0052127,-0.11926,-0.23563,-0.17534,0.14479,0.13898,0.0053343,0.095332,0.075016,0.020581,-0.16957,0.12633,0.0056925,-0.070603,-0.16908,0.042781,0.10736,0.15899,-0.16795,-0.022404,-0.1521,-0.10494,-0.15982,-0.15913,0.037626,0.085017,-0.02445,0.12005,0.057713,0.016111,-0.21638,-0.093207],[-0.28412,0.022175,-0.17969,0.096655,0.014442,0.18086,0.096937,0.092783,-0.0026706,-0.064079,-0.16045,0.049774,-0.12331,-0.39771,0.071711,0.0040897,-0.067421,0.075188,0.022341,0.095054,-0.12968,0.091703,0.068053,0.010793,0.021709,-0.14175,0.081524,-0.13645,0.093183,0.034129,0.020474,-0.0013213,0.010703,0.18268,0.18784,0.16787,-0.11741,-0.16202,-0.17767,-0.12353,0.070191,0.19112,-0.095701,-0.077993,0.17013,-0.17715,0.057241,0.097774,0.18226,-0.19015,0.093925,0.0098045,0.20588,-0.12028],[0.68182,0.10375,0.33939,-0.15036,0.086992,-0.22642,0.28206,-0.16929,0.15245,0.070889,-0.048747,0.021859,0.090492,0.43789,0.051582,-0.32325,-0.31088,-0.056286,-0.057613,-0.036468,0.068179,-0.084393,-0.065616,-0.0042938,-0.037472,-0.020781,0.099775,0.15634,0.047968,0.069284,0.11454,-0.0083147,-0.0029943,-0.011087,-0.03752,-0.016308,0.080676,-0.063407,0.0058783,0.066118,-0.005461,0.0078962,-0.089513,-0.043351,0.15302,-0.17221,0.063309,0.015264,0.17269,-0.15212,-0.12931,0.0051212,-0.011804,-0.085084],[0.043857,0.13706,0.014015,-0.055041,0.12499,0.04277,-0.15589,-0.030744,-0.17846,0.098405,-0.16523,-0.16467,-0.027513,-0.16324,0.0070333,0.005329,0.086275,0.057809,-0.081359,-0.11826,-0.0073832,0.11088,0.077733,-0.078368,-0.13066,-0.18728,-0.086723,-0.041768,0.081789,0.0056249,-0.0027184,0.16418,-0.042716,-0.13006,-0.074599,0.097138,-0.10226,0.036657,0.010655,-0.10303,0.067882,-0.12273,-0.078004,0.11456,-0.15676,0.093341,-0.18578,-0.118,0.1446,0.044348,0.099516,0.12161,-0.11733,-0.15164],[-0.020165,0.067776,0.10524,0.053117,-0.17148,-0.043113,-0.094947,-0.18271,0.11947,-0.12754,-0.17826,0.093494,0.20166,-0.0067749,0.0014737,-0.11518,-0.18621,-0.11996,-0.13028,-0.14022,0.072271,-0.057592,-0.11129,0.078418,0.11189,0.00080808,-0.13237,-0.030045,0.10835,0.16007,-0.17994,-0.12374,0.074845,-0.0088108,0.17815,-0.075905,0.16579,-0.084432,-0.13165,0.15913,0.0048227,0.0039914,0.12576,-0.082499,0.060948,0.071421,-0.092261,-0.067798,-0.15282,-0.013089,-0.044507,-0.042723,-0.012327,-0.17934],[-0.043936,-0.37692,-0.28597,-0.24881,0.039103,-0.16557,-0.256,0.085811,-0.50471,-0.21837,-0.1956,-0.043544,-0.073538,0.22502,-0.25886,0.51251,0.014167,-0.10359,0.065282,-0.0060201,-0.14474,0.11218,-0.015547,0.15312,-0.20125,-0.036156,0.020962,0.035125,-0.021612,0.12337,-0.047858,0.18171,0.058245,0.094135,0.15135,-0.19055,-0.076142,0.022164,-0.16223,-0.1862,-0.045569,-0.15281,0.1225,-0.1787,-0.17756,-0.14531,-0.00176,0.032605,-0.092842,0.16266,-0.0069878,0.013177,0.080421,-0.12478],[0.012835,0.031316,0.13263,-0.18453,0.19587,-0.13265,0.092399,-0.24093,0.1158,-0.11186,0.153,-0.14723,0.0065555,-0.10263,-0.17305,-0.028315,-0.0057618,-0.17742,0.037314,0.071104,0.19204,0.12527,-0.23192,0.27594,-0.22064,0.081113,0.1341,-0.031582,0.025587,-0.046229,0.11175,0.17058,0.059749,-0.019967,-0.133,0.035865,0.0035803,-0.056587,0.19053,0.045138,0.029855,-0.13156,-0.22287,0.066255,-0.054053,0.20356,-0.17943,-0.069464,-0.088076,-0.062209,-0.17128,-0.041062,-0.037823,0.16787],[-0.32742,0.27567,-0.15076,0.10884,0.010448,0.15676,-0.1592,-0.24131,0.36777,-0.023231,-0.18876,0.26582,0.033723,0.30833,-0.10024,0.036472,0.26317,-0.059729,-0.21243,0.031999,-0.054065,-0.067197,0.058911,-0.50419,0.37277,-0.035092,0.045974,-0.14337,0.075159,0.017037,-0.022012,-0.17243,0.13898,0.22333,0.054596,0.13247,0.1773,0.18012,-0.02097,-0.16537,-0.01005,-0.037008,0.23894,-0.23795,0.081215,-0.051807,-0.058696,0.20829,0.14009,0.010352,0.03866,-0.054833,0.020572,0.098583],[-0.21028,-0.057912,-0.020875,-0.092531,0.030427,0.1667,0.048388,-0.09964,0.12437,-0.083103,0.0070863,-0.038445,0.18379,-0.10304,-0.13635,-0.059574,-0.11222,-0.12538,0.036759,0.22944,0.031929,-0.14114,-0.032025,0.11805,0.18996,-0.18558,-0.089793,-0.030112,0.16967,-0.10931,-0.0025857,-0.14868,0.22816,-0.15541,0.045417,-0.039864,0.052349,-0.13153,-0.15266,0.063703,-0.029944,0.032159,-0.066999,0.0069406,0.1361,-0.17454,-0.051014,0.081082,-0.0066307,0.082131,0.1295,-0.05598,-0.010398,-0.0071356],[-0.43743,-0.015264,0.095189,0.31772,-0.056139,-0.035697,0.026971,-0.23233,0.22779,0.15319,0.33954,0.070474,-0.056133,0.26199,-0.054217,0.1798,-0.0096109,0.08873,0.068228,-0.092891,-0.060612,0.017653,0.10982,0.073675,-0.075365,-0.20392,-0.047471,0.071878,-0.23189,0.10592,0.13454,0.047685,0.16217,-0.034313,0.16431,-0.11529,-0.05429,0.065446,0.028985,-0.17884,0.040481,0.027415,-0.18644,0.14189,-0.027619,-0.062713,0.067123,0.058288,-0.14752,-0.12,0.084669,-0.034047,0.053301,-0.0152],[0.30929,0.072818,-0.12669,-0.012311,-0.0064028,-0.0043088,0.068184,-0.22805,0.0029306,-0.10287,0.10193,0.091679,0.1615,0.089436,0.059109,0.27664,-0.16747,0.020981,-0.043859,-0.039249,0.0050848,0.014239,-0.04454,-0.16189,0.13327,0.11154,-0.10004,0.14143,-0.20664,-0.10066,0.16054,0.013582,0.1998,-0.087046,-0.063383,-0.041816,0.0083546,0.10261,0.11793,-0.12843,0.064339,-0.051683,-0.059332,-0.03566,0.13945,0.15859,-0.18715,-0.053001,0.10342,-0.19043,-0.090344,0.084109,0.050749,-0.1587],[-0.10725,0.31222,-0.061922,-0.014745,0.069855,0.30447,-0.012848,-0.40176,0.35085,-0.32601,-0.21851,-0.20702,0.016776,0.19352,-0.0017464,-0.054903,0.13921,0.17898,0.10796,-0.15375,0.14388,0.16335,-0.16142,-0.11202,0.21571,0.022274,0.11504,-0.06088,-0.10885,0.026463,-0.11034,-0.0074193,-0.10171,-0.025261,0.080063,0.060002,0.077894,0.12419,0.16173,-0.045398,0.13358,-0.086957,0.20407,-0.012382,-0.079501,-0.092617,0.039574,-0.091248,-0.11631,0.15549,-0.070584,0.0045085,-0.045829,0.042506],[0.032677,-0.0040651,-0.069794,-0.035416,0.029983,-0.058497,0.089963,-0.23915,-0.0064864,0.037928,-0.15635,0.00099242,0.1183,-0.18653,0.12133,0.086525,-0.1491,-0.016588,0.080101,0.033274,-0.13364,0.089591,-0.0052401,0.12228,0.095834,-0.10622,0.054306,0.10446,-0.17423,0.12682,-0.008967,-0.16344,0.13979,0.11189,-0.051607,-0.14677,0.032992,0.060292,-0.099176,-0.0010464,0.16338,0.029716,-0.17762,-0.11819,-0.11079,-0.12103,0.051494,-0.068425,-0.065386,-0.13366,0.023498,-0.073835,-0.11206,0.067407],[0.0091917,0.19846,0.013385,0.11764,-0.080188,0.12687,0.0021329,0.057241,0.063122,-0.13107,0.18816,-0.12433,0.12704,-0.19802,-0.19681,0.07185,0.11589,0.1355,0.0077438,0.16315,0.10393,-0.042119,-0.029421,0.07139,0.1941,-0.08225,-0.097983,-0.13468,0.0026559,0.11131,-0.026895,-0.1716,-0.19143,-0.04307,-0.013322,0.090947,-0.11366,-0.0063461,0.08786,0.16686,-0.10878,-0.019478,-0.10963,0.19233,0.095281,-0.036195,-0.11112,0.098505,-0.11067,0.10268,0.076363,-0.11328,0.11333,0.13934],[2.0166,-0.34361,0.39245,-0.44407,-0.10733,-0.095376,0.67915,-0.13538,-0.44175,-0.047634,-0.14256,0.016424,0.0086253,-0.027942,0.051453,0.040917,-0.4925,-0.25134,-0.079511,-0.20597,-0.016278,-0.14353,-0.032084,0.083679,-0.26475,0.00053903,0.060827,-0.000079581,-0.0036953,0.082164,0.074618,-0.0055766,0.064006,0.068188,-0.0089887,0.025293,-0.058614,-0.091274,-0.1113,0.17979,-0.25723,0.16751,0.12052,0.025247,0.06575,0.026062,0.014229,0.030211,0.15091,0.046324,0.021425,-0.017845,-0.0072546,-0.033499],[-0.12196,0.020438,0.18044,0.17901,-0.11023,0.045763,0.19574,-0.10251,0.1997,-0.1497,0.2372,0.16219,0.027707,0.38137,-0.032547,-0.15874,0.19273,0.081812,-0.14031,0.074528,0.026688,0.023124,-0.074446,-0.0029295,0.12341,0.013639,0.18402,-0.17262,0.025481,-0.0010035,-0.062954,0.077256,0.032894,-0.020957,-0.15573,-0.037865,-0.067288,-0.057729,-0.033278,0.1425,0.038627,0.16807,0.023139,-0.0165,0.017074,0.14128,0.16996,-0.038808,0.17047,0.15464,-0.14303,-0.016117,-0.041485,-0.17229],[0.025675,-0.10479,0.083524,0.089355,-0.0068931,0.075002,0.061864,-0.11617,0.00053821,-0.18744,0.081739,-0.205,0.19022,0.20229,0.14225,0.012572,0.099935,-0.11475,0.10291,-0.13504,-0.0097817,-0.045214,-0.0734,-0.072769,0.01833,-0.098025,0.068796,0.17817,-0.036123,0.043746,-0.10821,0.1709,0.11471,0.10146,0.13634,-0.026701,-0.025472,0.11425,-0.09943,-0.16728,-0.0071966,-0.0026185,-0.18044,0.07041,-0.15155,-0.17122,-0.10683,-0.060995,0.13498,-0.1075,0.086102,0.094323,0.18004,-0.076015],[-0.20322,-0.15843,-0.10823,0.096195,-0.029066,-0.12712,0.15042,0.018001,0.065995,0.13713,0.070843,-0.13012,-0.097099,-0.02502,-0.080599,-0.19288,0.18181,0.16767,-0.044857,0.15092,-0.060292,-0.16422,0.16343,0.099515,0.082296,0.11004,-0.030887,-0.10734,-0.17763,-0.26875,0.0069999,-0.15302,0.13559,-0.087275,0.02581,0.18556,-0.11638,0.17488,0.089385,0.014642,0.0049809,0.079708,-0.129,0.17215,-0.11928,-0.060977,-0.040735,0.095959,0.16088,-0.18097,-0.0026142,0.011187,-0.038661,0.024097],[0.35377,-0.096007,0.043236,-0.25954,-0.055651,0.079384,-0.11026,-0.23121,-0.099387,0.016352,0.03243,-0.1071,0.17514,-0.10872,0.47609,0.01106,0.091011,-0.11963,-0.17091,-0.10444,-0.15831,-0.0095905,0.08619,0.084069,0.010143,0.018862,-0.043788,0.07623,-0.10938,0.023453,-0.035203,0.021639,0.044532,0.085739,-0.11267,0.15253,-0.16384,-0.090445,-0.0049581,0.042191,-0.073314,0.017141,-0.14333,0.073657,0.023344,0.13433,0.065246,0.029145,-0.16397,0.16557,-0.070285,-0.01298,0.059567,0.0073575],[0.053023,-0.12586,-0.17884,-0.0026177,-0.19118,-0.27453,-0.25889,-0.067366,-0.22112,-0.18896,-0.17237,-0.13083,-0.13856,-0.039763,0.19835,0.25465,-0.02633,0.069153,-0.088647,0.0049721,-0.16522,0.039564,-0.063322,-0.11756,0.034292,0.0019118,-0.096798,-0.13682,-0.031688,-0.087764,-0.018062,-0.052154,0.08381,-0.14703,-0.0076906,0.091189,-0.026604,0.13833,0.087808,-0.07858,-0.13846,0.18641,0.072826,0.026494,0.0017525,0.019852,0.094843,0.12906,0.10961,-0.017912,0.14001,-0.12217,-0.049178,0.094006],[-0.27641,0.032152,0.10354,-0.043176,0.14063,0.013204,0.077211,-0.12319,0.1073,-0.14359,0.20658,0.16701,0.037828,0.2163,-0.038268,0.15631,0.097736,-0.15768,0.0052749,0.070617,-0.14531,-0.014759,0.2432,0.067729,0.1869,-0.0083474,-0.2266,0.12461,0.049105,-0.27859,-0.17746,-0.12052,-0.029645,-0.030938,0.052677,-0.11798,-0.028405,0.13657,-0.13138,-0.0003917,-0.13764,0.061441,0.037305,0.070747,0.097678,-0.12686,0.045481,-0.13088,-0.013345,-0.14643,0.11647,-0.023672,-0.1183,0.071163],[-0.54469,0.096975,-0.21837,0.26077,0.14496,-0.13365,0.076241,-0.17026,0.34934,-0.26571,0.25805,0.10582,0.10324,0.41484,0.028137,0.016729,-0.102,0.10193,-0.0063011,0.084703,0.04964,0.03596,-0.049651,0.064311,0.24259,-0.017533,0.09545,-0.098445,0.083544,-0.041394,-0.16358,0.075887,-0.11578,-0.18394,-0.16213,0.08912,-0.19177,0.058763,-0.068062,-0.067787,-0.052048,0.1169,-0.044829,-0.049428,0.02268,-0.044767,-0.051074,0.010416,-0.10919,0.0048763,0.020729,0.048488,0.045656,-0.11315],[0.029651,-0.0080487,-0.19787,0.18433,0.0097532,-0.13269,-0.020165,0.084682,-0.057163,0.23591,-0.063876,-0.081219,-0.19946,-0.11175,-0.042535,0.040511,0.12,0.24262,-0.040602,-0.027869,0.13659,0.062855,-0.12316,-0.070185,0.057847,0.11427,-0.16497,-0.024436,-0.30567,0.10468,-0.11653,-0.16821,0.016959,-0.053271,0.043461,0.15902,-0.10382,-0.14997,-0.023664,0.038979,0.14462,-0.1813,0.16982,-0.087272,0.025258,-0.009576,-0.025616,-0.18887,0.057265,0.14304,-0.072677,0.06249,0.082852,-0.0023792],[-0.15299,0.18204,0.14398,0.0079849,0.17562,0.057211,0.0432,-0.054893,0.31228,-0.041559,-0.077116,-0.046201,0.040423,0.09237,-0.030517,0.009109,-0.12555,0.088652,-0.038565,0.1705,0.12538,0.037008,-0.014683,0.15502,0.10367,0.029771,-0.11759,-0.020645,-0.14314,0.026985,-0.070937,-0.22577,0.18413,-0.088364,0.15799,0.11621,0.021831,0.10961,-0.10418,-0.056442,0.01803,0.11819,-0.18564,-0.069339,-0.085,-0.15297,0.1204,-0.043281,0.13069,0.11825,0.15374,-0.037198,-0.15055,-0.18936],[-0.18737,0.022749,0.0075752,0.090093,0.054241,-0.12035,0.042742,-0.063391,0.10061,-0.13413,-0.062488,-0.099953,-0.066846,0.09043,0.1151,-0.19137,-0.06839,-0.18163,0.19006,-0.075506,0.12381,0.070749,0.17544,0.081704,-0.11824,-0.19866,-0.0088392,-0.1773,-0.1098,0.064816,-0.11336,-0.13467,0.22862,0.095792,0.12223,0.0040272,0.041161,0.027154,-0.11728,0.13048,0.092731,0.01292,-0.012248,0.051211,0.09192,0.040012,0.028783,-0.10258,-0.04381,-0.074078,0.066864,0.058827,-0.12137,-0.053346],[-0.87518,0.12487,0.030861,0.31666,0.12266,-0.051851,-0.10312,0.12188,0.46116,0.27126,0.21872,-0.060804,0.011423,0.22991,-0.18357,-0.035552,0.31236,0.02421,0.075404,-0.077357,0.24963,0.0014422,-0.0084133,-0.18294,-0.0024917,-0.067932,-0.0082128,0.011848,0.097887,0.0088252,-0.17306,0.12635,0.0059707,0.021395,-0.025926,0.14365,0.059922,0.019087,-0.026565,0.064536,0.12436,-0.06954,0.14338,-0.20524,0.050623,-0.030381,0.01036,0.022296,0.1611,0.089514,0.060406,-0.0075305,0.0035417,-0.16949],[-0.21665,0.31623,0.036733,0.3404,0.072106,-0.039912,-0.02727,0.16726,0.26427,-0.0040449,-0.56069,-0.20173,0.017299,0.25003,0.034494,0.15225,0.17909,0.022325,-0.00070976,0.067888,0.069033,-0.10499,0.074733,-0.039445,-0.040194,0.10424,0.061903,-0.060438,-0.1242,-0.12164,0.1617,-0.20333,0.057274,-0.10693,0.17002,-0.0017464,0.024043,0.11184,0.1613,-0.050184,-0.05394,-0.10972,0.038089,-0.1218,-0.17269,-0.095374,0.12965,-0.019599,0.032646,-0.15638,-0.14052,-0.010637,0.069627,-0.18455],[0.036024,0.12584,-0.025639,-0.021301,-0.14257,-0.027518,-0.033152,0.090111,-0.10788,0.1892,-0.28205,0.15738,-0.13538,-0.016321,0.0056432,-0.0098485,-0.17753,0.14774,-0.047083,-0.02584,-0.074475,-0.012883,-0.086528,-0.31567,0.16636,0.036402,0.11684,0.075796,-0.03199,0.04786,-0.17213,-0.17203,-0.0086415,0.12814,0.0036519,0.037207,0.033702,0.097377,-0.0036737,-0.040665,-0.10735,-0.19068,0.087961,0.013779,0.049538,-0.069705,0.011186,-0.045419,0.10654,-0.144,0.11373,0.0012089,0.086731,-0.088976],[-0.094396,-0.36578,-0.32603,-0.14614,0.003564,0.061352,-0.24204,-0.016191,-0.42044,-0.21638,-0.25028,-0.1547,-0.027524,-0.8245,0.50829,0.3861,-0.24474,-0.15658,0.18527,-0.18646,-0.031771,-0.046508,-0.03034,0.20647,-0.22537,-0.028438,-0.12378,0.060762,-0.047729,0.043788,-0.17282,-0.019423,0.0045577,-0.23948,0.0084587,-0.016767,0.083187,0.16142,0.052373,-0.089745,0.12812,-0.16694,-0.078705,-0.077749,-0.035103,0.035315,0.039802,0.10636,-0.19037,0.019835,-0.10261,0.018556,-0.1173,-0.10181],[0.13056,-0.14673,-0.037112,-0.0064529,-0.081573,-0.13086,-0.17828,0.0097471,0.042485,-0.038695,-0.067366,-0.11689,0.03279,0.13076,-0.014878,0.059257,-0.14895,-0.13642,0.080093,-0.11237,-0.010509,0.12393,-0.059026,-0.03143,-0.1646,0.021402,0.17382,0.10882,0.072976,0.01669,-0.17971,0.021588,-0.14065,-0.16821,0.18417,-0.13408,0.14804,0.14116,0.13014,-0.19173,0.0036419,0.056981,-0.02697,-0.04953,-0.027967,0.16633,0.16974,0.16337,-0.11817,-0.16565,-0.17687,-0.080599,0.081348,-0.10046],[-0.018606,-0.17972,-0.18433,-0.13587,-0.0033573,0.083833,0.0786,-0.15734,-0.041894,-0.082486,0.029769,-0.0048787,0.13003,-0.00024074,-0.005757,-0.12142,0.054706,0.14281,-0.16053,0.08172,0.045205,-0.19191,0.045186,0.15467,-0.0095419,-0.16863,0.01782,-0.10352,-0.17743,0.17639,-0.065954,-0.031995,0.1789,0.02631,-0.017675,0.12896,0.12815,-0.094522,0.08413,0.080136,-0.062112,-0.070534,0.11256,-0.027405,0.046975,0.17444,-0.054816,0.1802,-0.18108,-0.17657,0.17438,0.061878,0.12644,-0.17083],[-0.88423,-0.18041,-0.35787,-0.29382,0.068247,0.45421,-0.49068,0.62519,-0.54281,-0.07325,0.19519,-0.035923,-0.026544,-1.2481,0.076842,0.089957,0.12077,-0.039977,0.064104,-0.018852,0.085132,-0.067781,-0.03338,0.13375,-0.052049,0.017545,-0.080251,0.028698,-0.11127,-0.0033407,-0.0072253,0.015393,-0.081241,0.0065891,-0.039842,-0.086317,0.031836,0.082659,0.018653,-0.061742,-0.14389,0.13882,-0.082283,0.10075,0.052785,-0.019734,0.045192,0.012797,-0.094229,-0.13512,-0.15689,-0.042486,-0.021717,0.023373],[-0.017834,-0.079725,0.0743,0.058762,-0.1777,0.25611,0.15188,0.2877,-0.24257,-0.079857,0.021739,-0.13807,0.10809,-0.40497,-0.31053,-0.28816,-0.12874,-0.088819,-0.067494,-0.092224,0.025051,0.048242,0.12451,-0.032851,-0.14819,-0.064451,0.10524,-0.081872,0.15773,0.012467,-0.059659,-0.052959,0.12652,-0.10429,-0.0041558,0.049857,-0.15323,-0.020766,-0.11254,0.082516,0.08042,0.050413,-0.035991,0.050577,-0.13931,-0.012791,-0.071927,0.031605,-0.15539,0.016284,-0.037474,0.11216,0.020394,-0.083165],[-0.30694,-0.01904,0.084312,0.24046,-0.11591,-0.17628,0.020935,-0.039854,0.22407,-0.24209,0.086749,-0.21364,-0.10747,0.28067,0.038017,0.15649,-0.065082,-0.15791,0.038991,0.12818,-0.074376,0.096541,-0.10956,-0.19168,0.39403,0.16657,-0.051162,-0.018629,0.1063,-0.12197,0.10619,-0.041082,-0.032911,0.19829,0.13729,-0.028986,0.1567,0.18799,0.074431,-0.10289,-0.15199,0.097696,0.026911,0.072004,0.08698,-0.089565,0.076474,0.07713,-0.035815,0.080905,0.021695,0.013473,0.18985,0.19053],[0.074393,-0.13947,-0.19001,-0.11628,-0.14813,-0.040995,0.01048,-0.1265,-0.087936,0.0331,0.09296,-0.07778,0.17857,-0.14641,-0.086717,-0.045711,-0.17734,0.12351,-0.17546,0.089292,0.098421,0.068773,-0.12499,0.015974,-0.18204,0.1066,0.10555,-0.11155,-0.023003,0.030366,0.15802,-0.11362,0.03785,-0.17694,-0.038241,-0.18577,-0.14153,-0.087373,-0.12848,0.061441,-0.12607,0.15216,-0.13908,0.17327,-0.0096075,-0.11676,0.060856,0.12151,0.064211,0.03912,0.09129,-0.18251,0.0024018,-0.16495],[-0.0013809,-0.074611,0.1068,0.13431,-0.13906,-0.10904,-0.039076,0.14327,-0.11075,0.044062,-0.076783,0.080782,-0.10749,0.0099991,-0.2261,0.026476,0.038296,0.084842,-0.11309,0.012469,-0.099891,0.13027,-0.087404,0.013906,-0.16233,-0.014699,-0.078027,0.11863,-0.1118,-0.15981,0.18967,-0.13269,-0.041489,-0.061865,-0.026667,-0.15941,0.16061,-0.13938,-0.044051,-0.045316,0.16667,0.14638,0.086015,0.025029,0.16582,-0.063145,0.052741,0.082206,0.065639,0.16061,-0.049045,0.13436,0.029306,-0.15587],[-0.012445,-0.29886,-0.045724,-0.30334,-0.15267,0.28737,-0.32119,-0.19658,-0.60882,-0.34184,0.14411,0.037806,0.15709,-0.86264,0.15968,0.26488,-0.25819,0.000093821,-0.02543,-0.046152,-0.12219,-0.06798,0.20079,0.21683,-0.022889,-0.14355,0.077086,-0.14533,-0.11697,-0.079756,0.16171,0.20486,-0.15589,-0.18427,-0.17295,0.054969,-0.11017,-0.13041,-0.16347,-0.12354,-0.082516,0.0050144,0.08487,0.12529,-0.014008,-0.040449,-0.072608,-0.017758,0.12587,-0.16464,0.063411,0.049455,0.074968,0.12634],[0.10977,-0.24234,-0.14688,-0.10504,0.0038791,-0.089614,-0.14756,0.037241,-0.17266,-0.20141,-0.20082,0.27512,0.10268,0.050882,0.2068,-0.12092,0.11779,-0.020099,-0.154,0.012178,0.16621,-0.11658,-0.012162,-0.16974,-0.10544,-0.006763,-0.084978,0.073762,-0.14982,-0.030955,-0.040947,-0.058527,-0.12106,0.0022011,0.067322,0.13564,-0.076233,-0.02456,-0.059217,0.0065374,0.11738,0.18818,-0.0029117,-0.060555,-0.17834,0.091385,-0.16584,0.054883,-0.084265,0.058762,-0.14297,-0.060336,0.12573,-0.16804]],[[0.19381,-0.18734,-0.034899,-0.02863,-0.093801,-0.14774,0.082193,0.094411,0.15567,0.086471,-0.16455,-0.032465,0.19272,0.092224,0.062857,-0.018505,-0.19051,-0.084326,0.15795,0.0017833,0.037981,0.10008,0.16181,-0.095618,-0.062497,0.068272,0.21508,0.00072866,-0.22061,0.13221,0.19686,0.044206,0.14852,-0.12019,-0.19462,-0.19058,-0.13748,0.16444,-0.12292,-0.2094],[-0.0057272,-0.054303,0.1566,0.17856,0.058759,-0.16231,0.17983,0.16477,0.17305,-0.083723,-0.20946,0.10252,-0.19673,0.14862,-0.21504,0.082446,-0.20378,-0.1121,-0.18147,0.073882,-0.21048,-0.12273,-0.077725,-0.022416,0.20169,0.035659,0.030457,-0.087825,0.011674,-0.054388,0.15708,0.15265,-0.20544,-0.10718,-0.033994,-0.1134,-0.057946,-0.0029475,-0.045992,-0.076293],[-0.15257,0.17301,-0.16767,-0.059414,0.17574,0.09717,0.063497,-0.1198,0.1659,-0.16751,0.0023542,-0.091219,-0.047141,0.019009,-0.06203,-0.025873,-0.18561,-0.046362,0.047455,0.13746,-0.076537,0.054648,-0.1209,0.035573,0.12974,-0.19773,0.18622,0.2098,-0.054229,0.15118,-0.011424,-0.12407,-0.056999,-0.067816,-0.17371,0.068097,-0.027644,0.034165,-0.067131,0.19771],[-0.17999,-0.075489,0.15816,0.018069,0.1871,-0.13859,0.026224,0.041105,0.17757,0.024789,0.19053,-0.20556,0.071717,0.10006,-0.077746,0.0088213,0.019273,0.17979,-0.22676,-0.04814,0.14679,0.11346,-0.11685,-0.19795,-0.17219,-0.2226,-0.14721,-0.021891,-0.063075,0.20598,-0.18556,0.19153,0.065107,0.095131,-0.055872,0.1754,0.039226,0.1236,-0.048348,0.032718],[-0.11193,-0.086496,0.11402,0.2221,-0.23262,-0.19369,0.1044,0.28789,0.12223,0.023167,-0.15759,-0.025794,0.0022736,0.12373,-0.19157,0.21609,-0.22748,-0.11528,0.02643,0.004411,0.013116,0.091997,-0.021895,-0.24316,-0.18679,-0.024746,-0.16725,0.21492,0.16264,-0.10202,-0.11821,-0.096668,-0.075779,0.19211,-0.19089,-0.26318,0.19082,-0.044193,-0.01587,0.18568],[0.12829,-0.028677,-0.084841,0.22321,-0.076315,0.087163,0.21412,-0.24493,0.17793,0.23423,-0.093961,0.18384,0.0031855,0.31658,-0.089237,-0.19988,-0.40997,-0.25442,0.14353,-0.22244,-0.067895,-0.23507,0.088586,-0.12215,0.21163,0.0071809,0.001154,0.19663,0.29135,0.11274,-0.028459,-0.040732,0.022905,0.031199,-0.16189,0.21179,0.059162,-0.19342,-0.28342,-0.077342],[-0.047583,0.13099,0.26707,-0.22968,0.33775,0.036188,-0.10212,0.37813,0.1332,-0.23412,0.17566,-0.064411,0.15054,-0.21959,0.11685,0.055606,0.56681,-0.13392,0.0033664,0.14575,0.25066,0.25357,-0.059069,-0.26038,-0.001982,-0.19695,-0.22398,-0.31962,0.059795,0.085396,0.22579,-0.14738,0.079368,-0.29464,0.045505,-0.098662,-0.0059929,0.063318,0.31258,0.14701],[-0.020328,0.037148,-0.04452,0.20629,-0.21059,0.10914,0.14883,-0.13512,0.2115,-0.1401,-0.043428,-0.19657,0.034185,0.065792,0.035996,0.031181,-0.22298,-0.071904,-0.11628,0.10244,0.051559,0.098638,-0.085991,-0.01378,-0.065143,0.01645,0.10914,-0.089739,0.072997,0.15282,0.13242,-0.1378,-0.027824,-0.18839,-0.13333,-0.0058265,-0.1771,0.029414,-0.10096,-0.1586],[-0.13892,0.24483,0.082633,-0.034071,-0.2714,0.078248,-0.15933,-0.16001,0.11489,0.13322,-0.22917,0.045126,-0.18152,0.44208,-0.1174,0.13622,-0.045987,0.2247,0.17101,0.12416,-0.24344,-0.14474,0.11739,0.25485,-0.019379,0.096322,0.14511,0.1454,0.026204,0.23318,-0.30116,-0.067679,0.0036212,-0.25171,-0.33071,0.26342,-0.084213,-0.18842,0.0087841,-0.26478],[0.10823,0.27311,-0.19253,0.10943,-0.42587,0.13309,-0.0063518,-0.16556,0.12687,0.17252,0.11667,0.044291,0.032581,0.1802,-0.15386,0.065548,-0.53754,0.12052,-0.049431,-0.18291,0.04276,-0.19672,0.16335,0.0056824,0.18781,-0.041928,0.15085,0.29487,0.26338,-0.086318,-0.040633,-0.086574,-0.050731,-0.18324,-0.052725,0.10951,0.0023534,-0.18745,-0.02623,0.020183],[0.1512,0.094098,0.1415,0.18206,0.021993,0.1666,0.14534,-0.27701,-0.15653,-0.012001,-0.24323,-0.057731,-0.083207,-0.032488,0.13088,-0.087184,-0.22622,-0.1505,-0.013278,-0.018967,-0.15659,-0.1455,0.080175,0.19422,0.26039,0.058736,0.1332,0.30771,0.27588,0.034252,-0.0056676,-0.20765,0.19861,0.049467,0.073893,-0.18859,0.13396,0.019331,-0.24768,0.10333],[0.17704,0.15236,-0.17748,-0.11687,-0.228,-0.13201,0.17196,0.017606,0.1871,0.044144,-0.18247,0.14571,0.012172,0.084359,0.12682,0.12737,-0.48805,-0.15504,-0.1431,-0.03932,0.071044,-0.11314,0.086925,0.29899,0.1323,-0.23279,0.22799,-0.034008,0.24526,0.1489,-0.2855,0.18405,0.028433,-0.16499,-0.23428,0.24657,-0.066121,-0.10885,0.033066,-0.21746],[0.20982,0.21207,0.075482,-0.057054,0.16231,-0.14285,0.028762,-0.19607,0.22737,0.015482,-0.091173,0.1579,-0.10657,-0.066942,0.030579,-0.071872,-0.043158,0.1773,0.14942,-0.062872,-0.045188,-0.013183,0.14914,-0.00087798,0.16558,0.087056,-0.044635,0.060285,0.19441,-0.056372,-0.28044,-0.21597,-0.18529,-0.16164,-0.036152,-0.12834,-0.0053573,-0.02015,-0.13984,-0.049057],[-0.07959,-0.18716,-0.065148,-0.02432,-0.096741,-0.058677,0.11095,-0.11641,0.065554,0.097052,0.072227,-0.10196,0.12008,-0.16688,-0.21523,0.05167,-0.20275,0.11659,-0.17989,0.027303,0.033994,0.051628,-0.14721,0.13472,-0.052602,-0.14544,-0.11632,-0.14984,0.13147,0.098446,0.091664,-0.21848,0.06785,-0.14211,-0.16498,-0.10201,-0.094674,-0.15907,0.045743,0.11708],[0.20224,-0.11043,0.095873,0.23606,0.12585,-0.15832,-0.078559,-0.019352,-0.059713,-0.18787,-0.17233,0.09507,-0.09043,0.072153,0.13095,-0.1787,0.068291,-0.23371,-0.16684,-0.10143,-0.0044563,0.13259,-0.053983,0.080206,0.11765,-0.14311,-0.15442,0.062456,-0.054441,0.10874,0.22228,0.10174,-0.17061,-0.007938,0.16079,-0.13968,-0.12056,0.21384,0.29882,-0.14804],[-0.12766,0.1163,-0.079987,0.052429,-0.2465,-0.19616,0.039806,-0.22046,-0.040957,-0.10387,0.082295,-0.18641,-0.35278,-0.047616,0.016283,0.12289,-0.19105,-0.22888,-0.057923,0.17195,-0.014778,0.098795,-0.015329,-0.034159,0.12668,-0.10334,-0.12285,0.22828,-0.11738,-0.22004,0.13498,-0.15724,0.016874,0.20463,0.17994,0.017691,0.12893,-0.17288,0.046684,0.15253],[-0.016496,0.20145,-0.065999,-0.086979,0.064957,0.069485,0.19094,0.16113,0.0083006,-0.03445,0.086955,0.11631,-0.18924,0.081404,0.14425,-0.10968,0.0073005,0.033367,-0.033652,0.22481,0.030163,-0.033903,0.13996,0.18083,-0.18544,-0.12847,0.16382,0.055349,0.16109,0.026726,-0.096585,-0.010701,-0.041021,0.1077,0.13217,-0.14456,-0.056845,0.11055,0.037915,-0.18135],[0.12527,-0.26687,0.15215,0.25775,-0.26488,0.14606,0.12885,-0.15036,0.042946,-0.22027,-0.17733,-0.15361,0.19841,0.053753,-0.062904,-0.0219,0.14785,-0.032056,0.14868,0.1547,-0.025326,-0.1599,-0.08024,-0.29332,-0.0057787,0.17136,-0.040622,-0.072413,-0.17752,0.057439,0.27426,0.083971,0.12505,0.0083897,0.02502,-0.10771,0.11765,-0.042247,0.29224,0.025393],[-0.27196,0.072105,0.27868,0.031304,-0.15526,0.077634,-0.20331,0.33472,-0.25403,0.13075,0.23677,-0.14144,-0.2549,-0.091072,0.13767,-0.15031,-0.11158,-0.30373,0.05654,0.2739,0.10153,0.21924,-0.17725,0.077185,0.20719,-0.13737,0.018438,-0.018832,0.10054,0.013092,0.14339,0.086537,0.081763,0.27828,-0.095426,-0.22738,0.022789,0.036755,0.28636,0.26197],[0.041503,0.056245,0.058559,0.25051,-0.066266,-0.14136,0.052292,0.15669,0.01154,-0.091577,-0.11838,-0.0035222,0.080178,-0.11002,0.1747,0.031042,0.12327,-0.11461,-0.25477,-0.21077,-0.2105,-0.073083,-0.2531,0.11761,0.025641,-0.088055,0.18773,-0.047691,0.12877,-0.16637,0.22177,0.10037,-0.15845,0.23453,-0.13272,-0.21909,-0.17706,0.036801,0.16561,-0.17124],[-0.096081,-0.0087514,-0.047348,-0.13132,-0.065673,-0.13804,-0.067706,-0.16932,0.05564,0.18875,-0.0923,-0.15317,-0.22452,-0.027221,0.00033517,-0.14961,-0.16263,0.13046,0.094296,0.11335,-0.045681,0.15955,-0.0047519,0.11014,-0.038047,-0.22072,0.078832,-0.18106,0.17385,-0.14158,-0.0014235,-0.155,0.089809,0.13356,0.12293,-0.090867,-0.22055,-0.10837,0.10266,-0.088123],[0.15722,0.040666,-0.052337,-0.096371,-0.48367,-0.20447,-0.06584,-0.14575,0.098134,0.19481,-0.1837,0.27678,0.10731,0.41012,0.13132,0.047958,-0.49985,-0.22275,-0.18025,-0.12941,-0.25717,-0.1186,0.088797,0.34378,0.020106,0.1302,0.19051,0.29682,0.068807,0.25325,-0.11569,0.16579,-0.056451,-0.1911,-0.16143,-0.010518,-0.11811,-0.0326,-0.0040592,0.030851],[-0.021949,0.029912,-0.14311,0.076509,-0.13826,0.14892,-0.014118,-0.1956,0.10094,0.16464,0.073572,0.099282,-0.044545,-0.15009,0.20885,-0.19754,-0.16718,-0.21514,-0.052628,0.10859,-0.18156,-0.055298,0.15983,0.078804,-0.059118,0.14253,0.20103,-0.12092,0.20376,0.21834,-0.031974,0.006715,0.17908,-0.19706,0.069301,-0.080286,0.0034381,0.068997,-0.1357,-0.050389],[0.077375,-0.19155,0.16864,0.073674,-0.07936,-0.20603,-0.10512,0.067285,0.026824,-0.23679,-0.092105,-0.1082,0.23057,0.058716,0.084683,-0.1631,0.14783,0.089421,-0.22988,-0.2048,0.014876,-0.15711,0.13562,-0.079732,0.018149,0.20554,-0.092073,0.0027751,-0.15104,0.011222,-0.003474,0.11525,0.03674,0.14377,-0.081003,-0.13739,0.1572,0.17354,0.16512,-0.017386]],[[-0.00019665,-0.12362,0.11493,-0.044541,-0.36024,0.55946,-0.83623,0.30177,0.59939,0.57393,0.35685,0.58877,0.32839,0.2894,-0.38221,-0.52415,-0.10779,-0.37618,-0.55779,-0.30168,0.11083,0.70806,0.29215,-0.23763]]],\"biases\":[[0.046813,0.057376,-0.062256,0.12358,-0.3914,0.0036681,0.011892,-0.057372,-0.020772,0.15867,0.06751,0.035274,-0.084347,0.049613,-0.035578,0.016019,-1.0472,-0.015273,0.012105,0.0030061,-0.28844,-0.090006,-0.045175,0.051839,0.022391,0.070305,0.048616,0.29735,0.18551,-0.02277,-0.073244,-0.0086948,0.0089227,0.38674,0.023567,-0.023797,0.0069476,-0.054864,-0.13916,-0.0014718],[-0.0043459,-0.028477,0.14291,0.014165,-0.081589,0.20677,0.0031249,0.094103,0.32798,0.18316,0.12717,0.18841,0.21801,0.030714,-0.08837,0.012548,-0.11943,-0.03525,0.13899,-0.096562,-0.050955,0.24083,0.13596,-0.066014],[0.48924]]}");


var $dad9dd4508e0afec$exports = {};
$dad9dd4508e0afec$exports = JSON.parse("{\"sizes\":[54,40,24,1],\"weights\":[[[1.1953,-0.30447,0.15033,0.010646,0.0044094,1.0409,-0.36347,0.0031195,-0.35293,0.27945,0.46827,0.54508,0.065278,-1.392,-0.28674,-0.054286,-0.21334,-0.35836,-0.24261,-0.19708,-0.15064,-0.281,0.039425,0.095545,-0.17876,-0.035553,-0.099197,0.091033,0.14542,-0.020243,0.1655,0.013379,0.02318,0.1891,0.14469,0.095383,-0.074264,-0.14557,0.164,-0.17365,0.033635,0.17745,0.079496,-0.11478,0.016699,-0.045016,0.0074196,0.01706,-0.08149,0.055437,0.15235,-0.046325,0.0056401,0.062413],[0.45141,0.13558,-0.34714,-0.22414,0.16707,0.2235,-0.018403,-0.3694,0.15498,-0.50365,-0.66534,-0.22099,-0.019567,-0.091698,0.03382,0.28625,0.0039971,-0.037172,-0.0072359,0.022527,0.04479,-0.13475,-0.1322,-0.13179,-0.0087556,-0.046502,0.083077,-0.13076,-0.064203,-0.08942,-0.17465,-0.073133,-0.12149,-0.041195,-0.0024949,0.0083975,-0.049303,-0.02389,0.17146,-0.13984,0.12605,0.081422,0.1627,0.073796,-0.04443,-0.11949,0.13673,-0.05911,-0.08801,-0.083938,-0.20126,0.025889,-0.024484,-0.036959],[-1.7044,0.12234,-0.47756,-0.59118,0.18046,0.30158,0.070737,0.31751,-0.15323,-0.92997,-0.22618,-0.25207,0.04692,1.1627,0.23227,-0.53735,0.11005,0.11453,0.17049,0.12058,0.1084,-0.0022982,-0.0011915,-0.099466,0.055762,-0.012571,-0.073154,0.018782,-0.1404,-0.098845,-0.1052,0.099217,-0.028359,-0.064033,0.1397,-0.13855,0.046197,-0.14701,0.0084318,0.05849,0.087242,0.080306,-0.020871,0.047805,-0.17073,-0.0015485,0.030211,-0.070427,0.076952,0.14361,0.065982,0.021568,-0.028277,-0.018974],[0.21485,-0.4757,-0.48372,-0.39911,-0.089626,0.1918,-0.53041,-0.17938,-0.5948,-0.67318,-0.53267,0.71077,-0.098844,-0.50153,0.55358,0.20264,0.079912,-0.13653,-0.051722,-0.088609,-0.043146,-0.18961,-0.066985,0.050261,-0.24706,-0.055973,-0.013966,-0.05514,0.19766,0.056283,0.18354,-0.00050639,0.022353,-0.025777,-0.018117,-0.18178,0.1709,-0.11128,-0.13947,0.038432,0.015029,-0.032765,-0.058358,0.05647,-0.050552,0.099207,-0.12993,0.084199,-0.027865,-0.048241,0.029413,0.0090192,0.038949,0.16501],[0.42799,-0.22602,-0.47953,-0.33957,0.078337,0.88013,-0.66529,-0.64016,-0.75994,-0.17878,0.017081,-0.20288,-0.14558,-0.45875,-0.29426,0.055454,0.098362,0.12751,0.14068,0.15115,-0.05727,0.095874,-0.010737,0.0097823,0.033611,0.028077,0.02038,0.078585,0.16333,-0.0087832,0.071315,-0.053367,-0.10327,-0.14468,-0.07232,0.064062,-0.090857,-0.084674,-0.0090673,0.1236,-0.13155,0.10885,0.027561,-0.021019,-0.060722,-0.082055,-0.12057,0.0047103,-0.18092,0.045215,0.13789,-0.099744,-0.0041055,0.026616],[-0.0080566,0.075184,-0.047786,0.037358,0.17166,-0.15664,0.094855,-0.054798,0.29133,0.014386,-0.12446,0.27687,-0.17577,0.11543,0.15067,-0.097673,-0.064541,-0.16851,-0.074189,0.1402,0.14382,-0.093878,0.044059,0.14816,0.26027,0.035835,0.016277,0.015387,0.28313,-0.75683,0.18282,0.026055,-0.30361,-0.13258,0.16742,0.038115,0.11718,-0.0922,0.025187,-0.1253,-0.17928,-0.10175,-0.015867,0.0031232,-0.13449,0.064139,-0.040718,-0.15997,0.098664,-0.17571,0.0045839,-0.075589,0.0080854,-0.096419],[0.058026,0.19462,-0.55267,-0.052121,-0.054832,0.21399,0.19303,-0.24523,0.37778,-0.24193,-0.055537,-0.014738,-0.094906,0.070965,0.10262,-0.14062,-0.12616,-0.21871,-0.31657,0.2498,-0.035771,-0.056257,0.2582,-1.5883,1.2122,0.27078,0.037826,-0.32461,0.38239,-0.21628,0.041399,-0.21072,-0.73522,0.16264,-0.069188,0.12865,-0.097614,0.0083188,-0.18668,0.000022663,-0.26217,0.10458,0.74481,0.077132,-0.15971,0.13023,0.24278,-0.00051449,0.11487,0.0085145,-0.12765,0.10756,0.028941,-0.085642],[-0.065622,0.0071258,-0.1804,-0.056997,-0.14916,-0.087648,0.055351,-0.025222,0.040903,-0.13081,0.072247,-0.16904,0.16655,0.15799,0.026283,0.020111,0.0097393,0.09145,-0.019776,0.1458,0.098687,-0.085239,-0.026694,-0.054433,-0.033589,-0.0012379,-0.082575,-0.12549,0.12669,-0.14632,0.1824,0.069572,-0.035221,-0.18345,0.16876,0.10789,0.191,0.041795,0.14165,-0.052887,-0.12257,0.017289,0.17633,-0.073881,-0.10215,-0.037686,0.00087324,0.035506,-0.052798,0.15073,0.11221,-0.0093956,0.21713,-0.0093614],[0.26492,0.19927,0.59523,0.66455,0.060773,-1.1912,0.28653,-1.1515,0.44401,1.1289,0.71172,-0.023831,-0.024504,0.73972,-0.13454,1.69,-0.11888,-0.0033175,-0.071402,-0.11186,-0.02008,-0.15117,0.083278,0.11044,-0.029336,0.019512,-0.040553,-0.057193,-0.19638,-0.070689,0.15493,-0.087896,-0.059855,0.11199,0.11343,-0.021972,-0.11546,0.047454,-0.018702,-0.063859,0.02517,0.18003,-0.091367,0.11252,0.14065,0.039066,0.0041719,0.074917,-0.10961,0.084706,-0.14931,-0.018647,0.25872,0.164],[-0.015523,-0.22827,-0.28965,0.17017,-0.10446,-0.23477,-0.19058,0.0081769,0.11448,0.1452,-0.10114,0.098215,-0.036734,-0.08898,0.0049141,0.11739,-0.20161,-0.064365,-0.052986,0.24654,-0.14612,0.010196,0.28669,-0.064359,0.46576,0.24404,-0.13222,-0.11008,0.43218,-1.1512,-0.15928,-0.054821,-0.40708,-0.014111,0.13878,-0.094814,0.12203,0.060322,-0.14822,0.17204,-0.055049,-0.035057,0.31288,-0.10757,0.08049,-0.21544,0.029843,0.1049,-0.009653,0.082799,0.15867,-0.0094596,0.11048,-0.00088854],[-0.83714,0.041874,-0.65648,-0.45156,0.029398,0.038562,-0.0016284,-0.44992,-0.17972,-0.72019,1.0146,0.72648,0.088867,0.87881,0.59881,-0.26664,0.14652,-0.029798,0.086442,-0.077828,0.080193,-0.083653,-0.10142,-0.097453,-0.025353,-0.044587,-0.061129,0.0034515,-0.11092,0.0089215,0.17468,0.11996,-0.15166,0.000037946,0.15951,-0.053916,0.047913,-0.035545,-0.15503,0.070435,-0.055604,-0.10103,-0.031601,-0.15816,-0.17192,0.087154,-0.063588,-0.069532,-0.1771,0.017007,0.050792,-0.034058,-0.023441,-0.07122],[2.0792,-0.18665,0.0046338,-0.28024,-0.052289,-0.45072,-0.55018,-0.49198,-0.82733,0.15529,-0.20463,0.34394,0.20283,1.996,-0.030243,-0.17107,-0.055481,-0.2616,-0.082614,-0.1718,0.026829,-0.14225,0.080148,0.0019105,-0.038319,0.028621,-0.11122,0.09548,0.039925,0.058989,-0.0022828,0.091485,-0.040244,0.056724,0.13061,0.12397,0.0034434,0.1664,0.0042707,-0.15011,0.077714,-0.15383,0.020082,-0.085187,-0.15008,-0.014453,0.016144,-0.0088023,-0.12297,-0.049401,-0.029426,0.021374,-0.017263,0.17261],[0.1498,0.049276,-0.12849,-0.0054411,0.045895,-0.18426,0.025919,0.01715,-0.094137,-0.22107,0.028635,0.015282,-0.13614,0.049951,0.16615,-0.041787,0.012935,-0.16174,-0.16126,0.12259,-0.12563,0.10822,0.053103,-0.19038,-0.046621,-0.1321,-0.050139,0.019475,-0.058579,-0.079592,-0.030487,-0.16368,-0.15023,-0.1299,0.09257,0.091991,-0.046477,0.068487,-0.017566,-0.15241,-0.021497,-0.10286,0.12016,0.12465,-0.12165,-0.16069,-0.12442,-0.16066,-0.14831,-0.0053517,-0.12553,-0.18589,-0.019537,0.049385],[-1.4557,0.48823,0.066345,0.41597,0.18495,0.60371,0.58079,0.59538,0.83069,0.22897,-0.65369,1.0692,0.19466,-1.9095,-0.16539,0.3031,0.074487,0.052374,-0.087372,0.035297,-0.039981,0.036708,-0.041655,-0.053075,0.07835,-0.051522,0.11326,-0.049214,-0.28916,0.022754,0.1536,-0.053039,0.016904,-0.04724,-0.028813,-0.12661,0.025437,-0.049441,-0.15875,-0.0034794,0.026904,-0.15447,-0.18196,-0.085044,0.024325,0.065424,-0.024371,0.03815,0.12705,0.11333,0.0081004,-0.010797,0.00066766,-0.1873],[0.50287,-0.42328,0.15172,-0.068736,-0.18509,-0.043036,-0.74366,-0.66608,-0.44002,0.51962,0.10128,-0.40086,-0.1475,-0.0085237,-0.21054,0.57826,-0.068544,-0.11836,-0.21448,0.010974,0.028434,-0.016617,0.26555,0.16717,-0.066367,-0.19485,0.052117,-0.063398,0.11162,-0.057065,-0.010381,-0.027309,-0.046575,0.045699,0.15319,0.063542,-0.1061,-0.085271,0.045046,0.14722,-0.11124,-0.17265,-0.036326,0.031781,0.1094,0.092733,0.063405,0.105,0.045109,-0.188,-0.095242,-0.012609,0.11965,-0.075609],[0.59562,-0.36924,-0.51265,-0.40422,0.04956,-0.35109,-0.71799,-0.50571,-0.48889,-0.38568,-0.72345,0.14644,0.055849,0.81008,0.053182,-0.052244,-0.03727,0.17587,0.13052,0.21537,-0.10325,0.21152,-0.041565,0.1225,-0.22443,-0.047716,0.067379,-0.082782,0.16201,0.012757,-0.096677,-0.09969,0.11378,0.031963,-0.14306,0.0069247,-0.16064,0.047106,0.12004,-0.17183,0.1227,0.121,-0.014814,0.045024,-0.1135,0.021458,0.1068,0.072994,0.10628,0.14871,0.0037716,-0.0077997,0.0059178,0.028232],[0.12704,-0.14128,0.10092,0.33778,0.16028,0.086256,-0.10652,-0.066951,-0.10436,0.36065,-0.43255,0.025809,-0.10398,-0.25903,-0.16429,0.054337,0.072045,0.43484,-0.12822,-0.095827,-0.033131,-0.15557,-0.046012,-0.22357,0.084765,0.14493,0.14909,0.090701,-0.89998,0.04483,0.11415,-0.18706,-0.070153,-0.076781,0.00037038,-0.015239,-0.017014,0.14879,0.16923,0.052045,0.022402,0.080167,0.20767,-0.014728,-0.08393,-0.072623,-0.078832,-0.090593,-0.065612,-0.15715,0.063225,-0.061029,0.031981,-0.021377],[0.94688,0.22781,-0.1815,-0.12074,-0.097097,-1.6914,0.94401,0.71858,0.67838,-0.25123,-0.11264,1.2221,-0.15071,1.2361,-0.32667,0.2315,0.16347,-0.0092029,-0.16748,-0.047581,0.13227,-0.11299,-0.032709,-0.082364,0.18166,0.0082252,0.1119,-0.10724,-0.20055,-0.037086,0.059162,0.0068858,0.065709,0.0091067,0.053699,0.0032889,0.12027,-0.15292,-0.060728,-0.012817,0.074377,0.0079831,-0.0049375,0.19677,-0.11899,0.017111,0.063933,-0.037912,-0.049512,-0.085446,-0.14326,-0.015987,-0.056274,-0.032673],[-0.11166,0.081294,-0.14675,0.091852,0.11521,-0.31988,0.11821,-0.10376,0.12074,0.072498,-0.19911,0.34471,0.45074,-0.19052,0.35746,-0.15306,-0.052833,0.11505,0.024201,-0.076037,-0.063198,0.1108,-0.142,-0.16295,0.30845,0.078476,0.032956,0.11584,0.019298,0.13519,0.14966,-0.16147,-0.17007,-0.11219,0.093285,-0.14007,0.16651,-0.040254,-0.15007,-0.068394,0.11499,-0.18305,-0.10256,-0.020683,0.17228,-0.045714,0.24296,0.090113,-0.011156,0.022845,0.096792,-0.020919,0.032724,0.052868],[0.33887,-0.026716,-0.086937,0.022684,0.1661,-0.16575,0.19685,-0.072691,0.33188,-0.26851,0.1663,-0.31365,-0.12252,-0.23805,-0.048832,0.26204,-0.075612,0.16824,-0.10289,-0.12559,-0.19175,-0.055893,-0.31914,-0.011312,-0.16904,-0.13965,0.12143,-0.16695,-0.059583,-0.079336,0.12827,0.16028,-0.13702,-0.06703,0.10387,0.18074,0.13964,0.11454,0.0050404,0.032957,-0.046238,-0.10445,0.12364,-0.019616,0.063509,-0.12223,0.15516,0.078447,-0.039377,-0.12132,-0.15487,0.015677,-0.0026187,-0.0025188],[0.18123,-0.15353,-0.024748,-0.024304,0.099674,-0.19581,0.026788,-0.10521,-0.06201,-0.047629,-0.050002,-0.072041,-0.095823,-0.17867,-0.20141,0.029277,0.0096748,-0.19665,-0.11904,-0.16551,-0.057689,0.032576,0.1775,0.032306,-0.11998,-0.05994,-0.013885,-0.12101,0.035166,-0.086948,0.090473,0.18242,-0.17267,0.11661,0.12361,0.086066,-0.17614,0.19123,-0.063234,-0.15452,0.12837,0.1137,-0.14037,-0.013437,0.094854,0.019725,0.17689,0.2555,0.15059,0.057717,0.10073,0.092506,-0.27051,-0.084578],[0.14252,0.29757,0.015102,0.29142,-0.023053,-0.24857,0.41302,0.11055,0.6537,0.059313,-1.1167,-0.2413,-0.048849,0.65201,0.4324,-0.31449,-0.051195,0.050399,-0.10077,0.068484,0.03797,-0.019449,-0.055778,-0.16476,0.1551,0.084667,0.19795,-0.19002,-0.020887,-0.010378,0.18143,-0.26659,0.10358,-0.20313,-0.035553,-0.047025,-0.11809,-0.18082,0.035001,0.15028,-0.1511,-0.0048488,0.1167,0.084822,-0.17811,0.07581,0.052723,-0.084432,-0.058668,0.13343,0.04758,0.031242,-0.16314,-0.0079103],[-0.93336,0.16663,0.43987,-0.010623,-0.056732,-0.016158,0.37517,-0.39533,0.087705,-0.16967,-1.045,0.34818,0.1136,1.6771,0.022611,-0.033577,0.0033357,0.041335,0.15889,0.089578,0.094707,0.088054,0.036568,-0.0039057,-0.085623,0.057059,-0.06891,0.0010722,-0.0099439,0.012816,0.16948,-0.1103,-0.014352,0.081981,-0.14323,-0.011322,-0.037693,-0.067774,0.018159,0.10938,-0.10819,-0.059051,0.036555,0.084523,-0.0022048,-0.037112,-0.0095848,0.0008449,0.065593,-0.062904,-0.17822,0.020246,-0.0056265,0.1093],[0.59622,-0.22325,0.067645,-0.28267,0.096511,0.14968,-0.5906,-0.29661,-0.37381,-0.11321,-1.1683,0.29203,-0.27006,0.025097,-0.2738,-0.023465,-0.074257,-0.066815,-0.048664,-0.092221,-0.031044,0.13138,0.22587,0.13252,-0.24521,-0.13924,-0.028846,0.079919,0.17693,0.27244,-0.15351,-0.12392,-0.084958,0.11473,-0.17762,-0.13328,-0.060582,0.073446,0.13473,-0.11123,-0.20826,-0.058709,0.016516,0.14245,-0.13082,0.13067,0.18305,0.019859,-0.10397,-0.08259,0.17379,-0.0076634,0.073754,-0.16195],[-1.1424,0.14682,0.17203,0.63038,-0.14311,-1.5233,0.32442,0.89145,0.8903,0.99284,-0.37132,0.29532,-0.18102,-1.1794,0.17819,0.49205,0.0068468,0.22212,0.0069249,0.093136,0.083908,0.20777,0.069088,0.080874,0.067408,0.0020416,0.035654,-0.12864,-0.1479,0.012874,0.18697,-0.15505,0.14162,-0.024768,0.13902,-0.14045,-0.061142,-0.091422,0.026325,0.027984,0.11231,0.12933,-0.11855,0.069378,0.045332,0.017922,0.074123,0.12776,-0.029396,-0.070034,0.026941,0.038202,0.048752,-0.094456],[-0.52818,0.21803,0.2474,0.12309,-0.027782,0.9573,0.030855,-0.40839,-0.049258,0.20301,-0.58813,0.12842,-0.15017,0.29647,-0.26578,-0.051009,-0.1474,0.041534,0.062096,0.069734,-0.092601,0.058604,0.063036,0.07522,-0.15219,-0.12362,0.13522,-0.049303,0.043222,0.0092898,0.098225,0.021147,0.028553,-0.034959,0.048568,-0.13858,-0.17118,0.060844,0.06195,-0.17423,-0.10949,0.18014,0.17161,-0.11089,0.1506,0.032966,-0.048674,-0.062477,0.12396,-0.052442,-0.093488,-0.0044997,-0.059031,0.1377],[0.010125,-0.27784,-0.17099,-0.24773,-0.15484,-0.01033,-0.37363,-0.28454,-0.43182,-0.10916,0.25924,-0.65575,0.10264,-0.64023,0.44551,0.41444,-0.13561,-0.1061,0.015269,-0.030153,-0.18833,-0.02149,0.17681,0.068186,-0.010617,-0.11437,-0.088876,0.083246,0.026603,0.032176,-0.0046473,0.12638,-0.22809,0.0010593,-0.001266,0.13978,-0.013939,-0.08052,0.044315,-0.19375,-0.015063,0.15912,0.14467,0.038213,-0.15054,0.15592,-0.018783,-0.012734,0.13714,0.10389,-0.090177,-0.044409,0.058343,0.0065361],[-0.068735,-0.091633,0.02068,-0.030149,0.060235,-0.17317,0.19854,-0.19489,0.15173,0.12049,0.15461,-0.2,0.093202,0.060572,-0.12699,0.0054162,-0.056657,0.07995,0.12115,0.029538,-0.078687,-0.15177,0.0025411,-0.010573,-0.0050451,-0.01737,0.15521,0.14362,0.016038,-0.11221,0.10985,-0.078059,-0.14655,-0.16481,0.15393,0.14386,0.087848,-0.039605,-0.16504,0.0912,-0.13953,0.040321,0.083095,-0.066652,0.13686,-0.13115,-0.01994,-0.19717,0.01554,-0.046056,-0.070767,-0.12518,-0.15706,0.019859],[0.80152,0.74104,1.2933,0.62986,0.083522,-0.39331,1.6589,0.84201,0.96178,1.0346,-0.00059595,-0.69462,0.11327,0.24545,-0.11596,-1.527,-0.17433,-0.10613,-0.022145,-0.17874,-0.14388,-0.17944,-0.049018,0.0706,0.031437,-0.039518,-0.075823,-0.041873,-0.17256,0.09543,0.12197,0.038507,0.077405,-0.14879,0.10791,-0.044919,0.12971,-0.016497,-0.10244,0.16667,0.10856,0.036623,0.039668,0.027763,-0.082192,-0.00853,0.10157,-0.03378,-0.051032,-0.10876,-0.13968,0.009162,-0.10138,0.03396],[-0.070713,-0.05812,-0.21444,-0.17799,-0.12588,0.025487,-0.57093,-0.56819,-0.48914,-0.3105,0.70013,0.35843,-0.072062,0.0065303,0.37546,-0.11292,0.02847,-0.096241,-0.093027,-0.018484,0.15206,-0.095775,-0.17883,-0.037484,-0.10511,0.015881,0.15567,0.075249,-0.2039,-0.011523,0.14982,0.019617,-0.032382,-0.10102,-0.059003,0.0049055,0.13553,0.1804,-0.18615,0.16289,-0.031538,0.17782,0.023378,-0.095222,-0.15827,0.12364,-0.071575,-0.028144,-0.057597,0.07143,-0.15502,-0.021993,0.0017944,-0.15182],[-0.22832,-0.004953,-0.095957,0.2356,-0.13094,-0.44263,-0.065209,0.064898,-0.052358,-0.08119,-0.34043,-0.11024,0.049093,-0.22197,-0.13556,-0.099064,0.046568,-0.039075,0.16701,-0.083738,0.15086,-0.056808,-0.17401,0.1134,-0.081939,0.037676,-0.14312,0.057073,0.24825,-0.30134,0.067079,-0.093274,0.17872,0.073301,-0.12776,0.0012658,0.039157,-0.056094,0.12007,0.0010655,0.045189,-0.013685,-0.21172,-0.04704,-0.10291,-0.16695,-0.23484,-0.44804,0.095197,-0.1386,0.15138,-0.047869,-0.34531,0.17739],[-0.033038,-0.15789,0.044338,0.058704,-0.012396,-0.033135,0.0089159,-0.16361,-0.1768,0.069232,-0.066345,0.078705,-0.066386,-0.1975,-0.058971,0.066973,0.06216,-0.057471,-0.073254,-0.13125,-0.090041,-0.16934,0.22884,0.028134,-0.010734,0.052933,-0.17525,0.1415,0.13166,-0.27776,-0.18111,0.46076,-0.13393,-0.0019095,-0.017731,0.0089286,0.14107,0.16709,0.17576,0.0535,-0.061511,-0.13736,-0.16534,0.067657,-0.15618,-0.069345,0.16975,-0.028937,-0.042746,-0.17241,0.11789,0.049132,0.10024,0.16062],[-0.74418,-0.027679,-0.48488,-0.18858,0.16826,0.055915,0.0092613,0.61401,-0.29412,-0.64516,-1.037,-0.32056,0.10696,0.16798,-0.025317,-0.073623,-0.08694,0.035961,0.024009,0.18124,-0.024393,0.11354,0.0012388,-0.026177,-0.082608,0.10656,0.10425,-0.16993,-0.047658,-0.061566,-0.15016,-0.17626,0.16723,0.067951,0.14761,-0.13753,-0.17185,0.07715,0.047735,0.19284,0.035908,0.021538,0.16359,-0.0050431,-0.040604,-0.04221,-0.048473,0.055925,-0.089512,-0.12851,-0.036048,-0.019586,-0.081567,-0.075068],[0.025593,-0.061968,-0.20021,0.23335,0.17314,-0.22318,0.024617,0.34343,0.067826,0.23991,-0.029556,-0.10641,-0.015634,-0.25667,0.088623,-0.17843,0.15385,0.23189,-0.16652,0.056181,0.054349,-0.27107,0.39697,0.39938,-0.0044417,0.23783,-0.31038,-0.17156,-0.15781,-1.3836,-0.13378,-0.080472,-0.19946,-0.28836,-0.19238,-0.0035945,-0.15289,0.14995,0.0030785,0.10694,0.19296,0.070984,-0.15034,-0.054365,-0.14388,-0.38821,0.012076,-0.20255,-0.10755,0.1095,-0.16419,0.063692,-0.21397,-0.18312],[1.4299,0.63864,0.61098,0.31953,-0.1311,-0.13368,1.3458,0.39343,1.2941,0.63192,-0.0028866,0.73742,-0.37342,-1.1568,0.26207,-0.27463,-0.076879,-0.24408,-0.18154,-0.40528,0.14192,-0.51899,-0.15094,-0.087378,0.20419,-0.0078552,-0.14903,0.031465,-0.15723,-0.1632,-0.068342,0.019566,-0.11321,0.000067332,-0.18633,-0.043891,-0.0038932,-0.043772,-0.12065,-0.049815,0.14093,0.013283,0.09347,-0.015154,-0.010221,0.00096612,-0.055587,0.0058938,0.080113,0.18074,-0.14303,-0.019309,0.0035901,-0.01984],[-0.77092,-0.14619,-0.49951,-0.084047,-0.18993,-0.93666,-0.31624,0.64538,0.23487,-0.23018,0.57305,-0.8469,-0.033568,-1.1364,0.099656,0.65459,0.16237,0.12021,-0.0048927,0.046412,0.15617,0.22269,-0.036874,0.00019253,-0.052837,0.023007,0.13247,-0.10058,-0.061609,0.16415,-0.14283,-0.055491,-0.030121,0.0035915,-0.022841,0.062286,0.090536,0.044365,0.17008,-0.1571,0.090844,-0.036233,-0.10843,-0.055052,-0.0018281,0.17428,-0.072749,-0.0023643,0.15353,0.11659,-0.1255,0.0065406,0.059698,-0.10884],[-0.21253,0.38889,0.38722,0.097874,0.18723,0.036183,0.95651,-0.50154,0.78057,0.43765,-0.32114,-1.0838,0.15541,0.87067,0.57753,0.018452,0.057788,-0.043171,0.0053181,-0.041296,-0.11227,-0.067839,-0.017424,-0.11303,0.089958,0.022607,-0.082166,-0.043073,0.19522,0.0038831,0.16707,-0.005753,-0.13033,-0.067856,-0.065465,-0.080562,-0.049573,-0.15523,-0.042609,0.16997,-0.024702,-0.18204,-0.13823,-0.16799,0.14708,-0.032142,-0.21065,-0.044653,-0.14542,-0.10636,-0.026856,0.030991,-0.021289,0.094424],[0.14211,0.08397,0.30574,0.069119,-0.15093,0.33577,0.34824,0.15605,0.14226,0.24072,-0.32179,-0.67217,-0.099321,0.34407,-0.64698,-0.22766,0.037353,0.077586,-0.033276,0.10491,0.13079,0.10238,0.0013009,-0.035016,0.083423,-0.04983,-0.049451,-0.084346,-0.17701,0.046241,-0.14507,0.066595,0.0040454,0.15058,0.070892,-0.16271,0.15905,-0.16448,0.15633,-0.18545,0.062997,-0.16779,0.056838,0.067768,0.15705,-0.06851,-0.11229,0.060859,-0.093931,-0.12149,-0.063757,-0.017302,-0.085052,-0.071044],[-0.68379,1.163,0.9203,0.67788,-0.16879,0.24088,1.8833,-0.1163,1.7789,0.26797,-0.34225,1.2406,-0.030553,-0.30734,-0.18919,-0.92765,-0.014657,0.10375,-0.15041,0.030149,-0.052776,-0.040289,-0.064103,-0.073735,0.33516,-0.050413,0.1097,0.0057956,-0.13825,-0.033931,-0.011314,-0.031563,0.00066876,-0.020938,0.08048,-0.025136,0.035343,0.14146,0.026783,0.14912,-0.088964,-0.10882,-0.19122,-0.0053787,0.0019652,-0.22184,0.13587,0.065887,-0.046059,-0.10563,0.0038329,-0.024402,-0.012352,-0.11904],[-0.049716,0.038505,-0.0099062,-0.11367,-0.040721,0.20325,-0.23913,-0.17635,-0.40127,-0.2033,-0.075759,-0.38424,0.40007,-0.40464,0.34328,-0.0075314,-0.17472,-0.095085,0.051831,0.14546,-0.035768,0.18941,0.094975,0.15232,-0.071289,-0.15208,0.028855,-0.024067,-0.25871,0.025274,-0.12305,0.092119,-0.060692,-0.17306,0.11884,-0.036775,-0.0016392,0.090528,0.10755,0.053387,-0.18344,-0.17664,0.07308,0.058452,0.10392,0.24401,0.056789,-0.068404,-0.15742,0.15266,0.16916,0.10002,-0.27699,-0.15909]],[[0.29125,0.22786,-0.024195,0.29877,0.4094,-0.18471,-0.082284,-0.15774,0.017171,-0.030236,-0.039755,0.015016,-0.09832,-0.05055,0.19526,0.38081,0.17844,-0.2978,-0.27483,0.0034728,-0.13345,0.12949,-0.025548,0.33992,-0.012023,0.27137,0.43307,0.1965,-0.59744,0.19752,0.1144,0.11196,0.058557,-0.14176,-0.34043,-0.023386,-0.22483,-0.1086,-0.45427,0.044106],[-0.57926,-0.27863,-0.099714,0.011058,-0.35046,-0.23084,-0.049927,-0.15716,0.32335,-0.33349,0.023092,0.10113,0.15503,-0.4339,0.09297,0.21668,-0.047035,0.06848,-0.069811,0.006157,0.13853,-0.040787,0.068591,-0.029568,-0.15434,-0.02592,0.089354,0.17183,-0.15611,-0.0087175,-0.10899,0.088226,-0.13565,-0.017211,-0.5118,-0.3361,-0.13008,-0.27665,-0.65899,-0.038052],[0.28656,-0.33791,0.011974,0.024077,-0.1853,-0.13664,-0.15518,0.076386,-0.26441,-0.18667,-0.027064,-0.059752,-0.078091,0.059822,0.31952,0.088998,-0.15707,-0.15475,-0.042243,-0.17431,0.15115,-0.20112,-0.12423,0.25197,-0.45683,-0.2714,0.20997,-0.017227,-0.23966,-0.048994,-0.10183,0.26542,-0.23771,0.022984,-0.1825,-0.063875,-0.47764,0.05712,-0.38098,-0.061624],[0.010758,-0.18005,-0.11878,0.22368,0.1085,0.011528,-0.28324,0.063805,-0.47791,0.14412,-0.21109,0.11565,0.15579,0.22958,-0.1989,-0.1285,-0.073748,-0.19908,0.00094146,0.22066,-0.15439,0.096027,-0.10981,0.31576,0.17942,0.019987,0.2248,0.18429,-0.50963,0.14218,0.1771,0.105,0.12274,-0.11673,-0.018923,0.23429,-0.13968,-0.14601,-0.32661,0.13002],[-0.07322,0.11935,0.01309,-0.039919,-0.16473,0.036752,0.22939,0.033854,-0.35626,-0.024803,0.32726,0.1573,0.0036977,-0.23493,0.13302,-0.15492,-0.02063,-0.053164,-0.19197,0.12434,0.064903,0.044745,0.24389,-0.14822,-0.090702,-0.0079362,0.09756,0.089843,-0.12854,0.080592,-0.10659,-0.12012,0.24636,-0.16139,-0.23961,-0.14957,-0.043843,0.08356,-0.31078,0.029402],[-0.69588,-0.28543,0.025947,-0.21113,0.12917,-0.0065251,-0.01522,0.069388,0.24353,-0.18407,-0.19136,-0.1483,0.028764,-0.63247,0.25031,0.29175,0.082792,-0.43191,0.056459,0.16886,-0.12643,0.049311,0.048447,-0.054909,-0.095089,-0.020921,0.10208,0.047951,-0.13358,0.094693,-0.21373,0.104,0.025265,-0.19672,-0.54997,0.012954,0.16414,-0.13212,-0.5603,0.031076],[-0.099655,0.10512,-0.14596,0.16328,0.057039,-0.13691,-0.16101,0.042528,0.014288,0.048501,0.086376,-0.019931,0.034755,-0.53538,0.22306,0.092397,0.15083,-0.45679,0.02981,-0.093081,0.044948,-0.088412,0.19436,-0.11715,-0.08571,-0.17044,0.2322,0.21115,-0.33506,0.14128,0.022577,0.18753,-0.12474,-0.098541,0.017022,-0.30596,-0.10368,-0.1213,-0.26839,0.075764],[-0.41266,-0.19796,-0.040234,0.08743,-0.044087,-0.14388,-0.047771,-0.082656,0.11762,-0.18087,0.13919,-0.14058,-0.037661,-0.49858,0.021539,-0.056744,-0.040474,-0.54308,-0.20154,-0.20891,0.21229,-0.30413,0.18841,0.090555,-0.37202,-0.17534,0.13517,-0.083654,-0.43637,0.32958,-0.21233,-0.089944,-0.053178,-0.14255,-0.36026,0.057175,-0.08255,-0.2382,-0.095994,-0.069175],[0.19733,-0.15886,-0.12816,0.12148,-0.21492,-0.054835,-0.21614,-0.20276,0.28002,-0.4095,0.19525,0.29026,-0.21442,-0.1743,-0.011846,0.28694,-0.20665,0.18937,-0.19044,-0.32569,0.14864,-0.030471,0.34756,0.11974,-0.031406,0.16947,0.14289,-0.13635,0.037038,0.128,-0.26526,0.034661,0.13972,-0.20857,-0.22754,-0.65513,0.14804,-0.15582,-0.053105,-0.22593],[-0.37846,-0.14713,0.15526,-0.2111,-0.062822,0.10335,-0.17857,-0.15734,-0.49026,0.12445,0.44899,-0.50463,-0.17822,0.2527,-0.12112,0.018584,-0.13646,-0.16528,-0.18541,-0.11037,0.18454,0.0442,0.016781,-0.1335,0.08348,0.115,-0.24191,0.026113,-0.14984,0.1091,-0.49939,-0.002311,0.16792,0.042671,-0.42352,-0.08485,-0.019837,0.33506,0.16967,0.14543],[-0.011681,-0.03183,0.0011716,-0.13417,-0.012415,-0.092424,-0.017016,0.06381,-0.40091,0.014084,0.099213,-0.33408,-0.066805,0.3206,-0.022553,-0.00066867,-0.12659,-0.40158,-0.24531,0.073696,-0.0078549,-0.29073,-0.13065,-0.22031,-0.27943,-0.085553,-0.15577,-0.12915,-0.12541,0.089935,0.0020839,0.030963,-0.10208,-0.11546,0.015097,0.069514,-0.31792,-0.28818,-0.14702,-0.089099],[-0.065859,0.2407,-0.61038,0.080101,0.24246,0.055967,-0.023936,0.13868,-0.32505,0.20091,0.29009,-0.86791,-0.035573,-0.17853,-0.098824,-0.028994,0.13764,-0.49029,-0.07017,0.1447,-0.044377,-0.17035,-0.40331,-0.097491,-0.044944,0.21246,0.057991,-0.15124,-0.46767,-0.094125,0.026593,-0.10841,-0.31546,0.15614,-0.49403,-0.072454,-0.13481,-0.27942,-0.37342,0.18333],[0.1033,0.030748,0.13534,-0.21321,0.29476,-0.11467,0.066325,0.17502,0.21118,-0.032539,-0.06614,0.36482,0.055449,-0.42576,-0.13877,-0.27963,0.15173,0.22742,-0.060701,0.17416,-0.13396,-0.074882,-0.022247,0.020598,0.44348,-0.33528,-0.0012602,0.22277,-0.17688,-0.0044282,0.21926,-0.16244,0.0052261,-0.016824,-0.33528,0.2245,-0.0028422,0.034283,-0.33132,-0.21546],[-0.043253,0.30292,-0.83151,-0.0086056,0.042073,0.22125,0.31805,-0.075429,-0.16057,0.35531,-0.24901,-0.92535,-0.1512,0.18322,-0.14994,-0.058492,0.31066,-0.29623,0.051541,0.1446,-0.2025,-0.23868,-0.52135,0.01846,0.11103,-0.1843,-0.17959,0.15416,-0.13286,-0.014729,0.20743,-0.07255,-0.55444,0.37983,-0.0064941,0.33194,-0.11932,-0.12254,-0.07384,-0.24136],[-0.15503,-0.14198,0.0049567,0.28932,0.27167,-0.22739,-0.17374,-0.06225,-0.38197,0.061357,-0.25093,-0.24865,-0.18433,-0.3573,0.19029,-0.037816,-0.18538,-0.16203,-0.1578,-0.2979,0.22295,-0.48635,-0.074718,0.36974,-0.41371,-0.21926,0.080607,-0.18179,-0.18699,0.24256,-0.09125,-0.11717,-0.02173,-0.27696,-0.57674,0.23913,-0.3884,-0.094612,-0.36958,-0.09688],[-0.1132,0.16368,0.13599,-0.20192,0.15694,-0.027219,-0.033422,0.11286,-0.11475,-0.26341,-0.25397,-0.10986,0.1636,0.092532,-0.097552,-0.091555,-0.15338,-0.32835,0.071034,-0.030306,0.076407,0.10063,-0.02774,0.06833,0.039814,-0.041443,-0.2163,0.25069,0.019702,0.059675,0.066798,0.015057,-0.24735,-0.1662,-0.20536,0.13437,-0.014088,0.069925,-0.25319,-0.22061],[-0.21584,-0.2141,0.035869,0.13253,-0.21863,-0.10515,-0.050096,0.23699,-0.27337,-0.14661,0.094636,-0.077249,-0.14422,-0.040799,-0.096763,0.24699,0.13005,0.26495,0.076504,0.18384,0.094364,-0.27819,-0.094591,-0.027109,-0.010683,-0.022063,-0.0037562,0.034042,-0.75036,-0.026878,-0.005442,0.14324,0.076815,-0.0082705,-0.4634,0.41006,-0.13399,-0.36359,-0.47504,-0.06853],[-0.088688,-0.2075,0.033946,0.13486,-0.10519,0.1284,-0.17832,0.12433,0.17392,-0.074127,-0.0074224,-0.22769,0.043829,-0.078596,-0.16113,0.085075,0.11459,0.18778,0.15076,0.039646,0.16784,0.081616,-0.1093,-0.19847,-0.14125,0.019711,0.11105,-0.018095,-0.19503,0.16071,-0.21593,0.14756,-0.029619,-0.076795,-0.13772,0.11484,-0.16731,-0.19508,-0.21512,-0.18681],[-0.36907,-0.17002,-0.017607,-0.13256,0.18505,-0.19668,-0.15026,0.17103,-0.32304,0.20063,-0.27281,0.21237,0.23819,-0.6316,0.17344,0.31513,-0.011356,-0.45827,0.092027,-0.058411,-0.19696,-0.021232,-0.041864,0.30975,-0.41408,0.18176,0.13559,0.043852,-0.23881,0.057405,-0.035165,-0.097566,0.096049,-0.19464,-0.38996,-0.04046,-0.26533,0.075604,-0.28767,0.023527],[-0.17192,0.23457,-0.42121,-0.34844,0.14699,0.27204,0.44157,-0.014772,0.23159,0.54761,0.058371,0.089787,0.087181,-0.10917,-0.20326,-0.27734,0.29702,0.34518,0.21098,0.10089,0.040171,0.13384,-0.43105,-0.17247,0.041072,-0.18635,-0.1041,0.11028,-0.079363,-0.1267,0.1712,-0.14601,-0.20985,0.20715,-0.14199,0.095016,0.0086894,0.027637,-0.10727,-0.39929],[-0.27025,0.28659,-0.10348,0.248,-0.16223,0.048358,-0.12211,0.11061,-0.35175,-0.055015,-0.069157,-0.0020638,0.28819,-0.092873,0.013899,0.35162,0.092371,0.087212,-0.27919,0.033534,0.081012,0.03316,-0.23306,0.21999,-0.047979,-0.25408,-0.079347,-0.0082563,-0.64188,-0.038388,0.08019,0.071994,-0.027189,-0.24528,-0.075705,0.21063,-0.50342,-0.090917,-0.36804,0.076176],[-0.60171,0.049676,-0.14824,0.060162,-0.11599,-0.13631,-0.013862,-0.044687,-0.16475,0.17477,0.21907,-0.33661,0.15911,-0.052443,-0.026821,0.0097228,0.014393,0.097309,0.027301,-0.21626,-0.16396,0.12333,0.17746,-0.058364,-0.059284,-0.000751,0.092305,-0.075112,-0.41808,-0.17008,0.083345,0.016319,-0.14169,0.20766,-0.35671,-0.25867,-0.44566,0.025776,-0.22503,-0.087799],[-0.19595,-0.039149,-0.21059,0.12959,-0.14831,-0.26251,-0.18088,0.20544,0.18372,0.13007,0.37271,-0.22317,0.11921,-0.48845,0.1823,0.0057765,-0.11823,-0.30712,0.029822,0.0039967,-0.19115,-0.39133,0.1265,-0.16539,-0.039941,0.15085,0.13893,-0.023443,-0.27123,0.24221,-0.19377,-0.030771,0.0026685,-0.17996,-0.10142,-0.26833,-0.039404,-0.31388,-0.17738,-0.001576],[0.25398,-0.083528,0.049558,0.194,0.20104,-0.037936,0.047321,0.15259,-0.22786,-0.27366,-0.16596,-0.43734,0.090929,-0.27557,0.21351,-0.16053,-0.092166,-0.6153,0.074907,-0.10514,0.077261,-0.35117,-0.035685,0.011644,-0.44259,-0.19378,0.27077,-0.048243,-0.11128,0.13928,-0.01644,0.22508,0.10067,0.13073,0.23937,-0.065649,-0.37409,-0.067701,-0.55763,0.10431]],[[-0.71606,-0.97372,-0.65538,-0.68546,0.70529,-1.044,-0.77549,-0.90005,-0.45262,-0.3549,-0.87449,1.0393,0.60774,0.71363,-0.75207,0.37985,-0.83563,0.2538,-1.0293,0.48228,-0.81777,0.88757,-0.86689,-1.0542]]],\"biases\":[[-0.78335,0.0015614,0.35817,-0.080851,0.10088,-0.075391,-0.1684,0.012421,-0.28515,-0.029911,-0.06145,-0.74817,-0.085089,0.37314,0.0034296,0.21592,0.05464,-0.3967,0.098866,-0.0093057,-0.031518,0.21815,0.15296,0.09256,0.57855,0.15216,-0.21404,-0.026647,-0.64442,-0.096324,0.044955,-0.086898,0.28288,-0.047519,-1.1023,0.2926,-0.23191,0.057688,-0.016571,0.13476],[-0.051363,0.074904,0.58005,0.015001,-0.055696,0.0049571,-0.008261,-0.00869,-0.029368,-0.059237,0.01863,0.36035,-0.29924,0.52214,0.79569,0.14875,0.30478,-0.10806,0.13436,-0.013427,-0.06689,0.24133,0.21639,-0.11967],[0.64726]]}");


var $8ccf5930526c44bf$exports = {};
$8ccf5930526c44bf$exports = JSON.parse("{\"sizes\":[54,40,24,1],\"weights\":[[[-0.72858,0.16772,0.28806,0.33316,0.13092,-0.18471,0.20429,0.076787,-0.0076404,0.23956,0.032029,-0.12426,-0.35768,0.047066,-0.03904,-0.11342,-0.31903,-0.25103,-0.21717,0.049937,0.13753,-0.059161,0.056677,0.11739,-0.14014,0.27989,0.044572,-0.041545,0.020261,0.66614,0.15943,-0.076308,0.11285,0.013379,0.050523,-0.025193,0.14196,-0.15557,-0.11627,0.014381,-0.14832,-0.15984,0.090833,0.072387,0.12134,-0.19539,-0.11008,-0.1447,-0.05696,0.062937,-0.12099,0.020958,0.0069054,0.1732],[-0.046294,-0.20985,0.56031,0.34667,-0.14344,0.26492,-0.447,-0.12242,-0.43635,0.69874,0.31434,-0.39758,-0.3131,0.47068,-1.1487,0.48011,-0.11961,-0.064228,-0.045917,0.023863,-0.14515,0.20189,0.26056,0.12262,-0.35346,0.020068,0.045659,0.0066595,-0.10564,0.023724,0.067122,0.20461,-0.13213,0.0040153,0.1183,-0.18751,-0.1455,-0.1206,-0.12602,0.065109,-0.05637,0.11598,0.060906,0.039241,0.10827,0.33044,0.0051079,0.061289,-0.094871,-0.097418,0.063771,0.046927,-0.073151,0.027209],[1.054,0.41717,0.46626,0.45464,0.16382,-1.7768,0.21013,-0.18918,0.52822,0.61811,-0.75216,0.63534,-0.24601,0.13909,-0.045169,0.4435,1.0262,0.13187,0.069701,0.064121,0.11557,0.084173,0.16809,0.039271,0.22643,-0.0080089,-0.057625,0.023201,-0.019383,-0.0093107,0.11639,-0.063051,0.048553,-0.069469,-0.11129,0.17795,-0.12346,0.048098,-0.13185,-0.046427,0.13033,0.18302,0.031474,-0.10895,0.18634,-0.14283,0.050292,-0.043378,0.17835,0.16717,0.15207,-0.034084,0.059586,0.055259],[0.033194,-0.44843,-0.56488,-0.34394,-0.1758,0.83712,-0.5862,-0.38155,-0.69167,-0.61112,0.34448,-0.71355,0.086808,-1.5159,1.2505,0.25731,-0.18683,-0.21256,0.13405,-0.13261,0.061345,-0.13639,0.007879,0.13553,-0.52825,-0.013206,0.014171,-0.034253,-0.221,-0.042692,-0.033495,0.11871,-0.17927,0.26916,0.15967,-0.14511,0.074012,-0.060544,-0.055056,-0.19617,0.015761,0.12825,0.10711,-0.18175,0.10884,0.15538,0.059765,0.077039,0.14691,0.093665,-0.044116,-0.000047375,0.015393,0.065395],[0.66556,0.64019,0.07062,0.64285,0.056252,-1.7992,0.91547,-0.22075,0.94617,-0.5916,-1.2642,0.55032,0.076642,1.6958,-0.058637,-0.020102,0.67887,0.20566,0.17784,0.18371,0.149,0.1337,-0.10689,-0.13453,0.071908,-0.023111,0.016824,0.03397,0.0054369,-0.067634,0.035241,-0.14495,0.098015,-0.0075205,-0.10601,0.11348,0.12279,-0.10594,-0.052659,0.18199,0.2318,-0.1751,0.13544,0.054575,0.10329,0.10761,0.0023874,-0.016522,-0.14963,-0.14235,0.080414,0.0042115,-0.029197,0.13832],[-0.32157,-0.23783,-0.16016,-0.054884,-0.16674,-0.54096,-0.14516,-0.18271,-0.22441,-0.54663,1.1185,0.24884,-0.23521,0.01256,0.23807,0.37147,0.3552,-0.15753,-0.17634,-0.18851,-0.098187,0.019708,-0.11467,-0.023847,0.1237,0.0087933,-0.024691,-0.0089712,-0.15178,0.059271,-0.029934,0.15339,-0.11503,-0.082242,0.024605,-0.020812,-0.048251,0.16384,0.088707,-0.15162,-0.040973,-0.080757,-0.24361,-0.11854,-0.098828,0.14194,-0.11517,-0.011375,0.052732,-0.010865,-0.096504,-0.028417,0.020392,-0.041201],[-0.21175,-0.52629,-0.78319,-0.54505,0.061996,-0.086602,-0.59242,0.086132,-0.55032,-0.52464,-0.27741,1.1563,-0.634,-1.1664,0.6554,-0.15365,0.043187,-0.015718,-0.045685,0.045272,-0.14227,0.006889,-0.18773,-0.12933,-0.064016,-0.0096001,0.13808,-0.026492,-0.069794,0.035687,-0.12938,-0.061692,0.047236,-0.15198,0.067394,-0.051373,0.023636,0.10107,-0.16042,-0.13218,0.059364,-0.17974,-0.086204,0.15537,0.011746,-0.19878,0.07201,-0.027531,-0.002336,0.030118,0.14336,0.060891,-0.058971,0.0080565],[-0.10015,-0.41262,0.16673,0.0048155,0.035818,0.37043,-0.37915,-0.43868,-0.52517,0.46894,1.0181,-0.70821,-0.40386,0.37853,0.65441,-0.41444,-1.4243,-0.15523,-0.16261,-0.24021,-0.020784,-0.041781,-0.03202,0.12789,-0.12613,-0.077495,0.075979,-0.036728,0.03425,-0.02896,0.026714,0.17155,-0.1439,0.022646,0.19052,0.018192,0.074339,0.061427,0.050347,0.075478,0.14217,0.18739,0.079922,0.0081878,-0.025694,0.15236,0.026717,-0.014261,-0.012754,0.1388,-0.18005,-0.020997,-0.016251,0.10606],[-6.3268,0.27898,1.1844,1.293,-0.060825,-0.71865,0.61147,0.6923,0.55711,0.91462,0.19162,0.10588,-0.97057,-0.65307,-0.14251,-0.25267,-0.35708,0.68535,0.25092,0.56469,0.15566,0.76648,-0.033455,0.20727,0.18975,0.056145,0.22663,-0.037169,-0.031327,0.1141,-0.18362,-0.025655,0.17844,-0.19165,-0.024995,-0.079474,0.15041,0.15149,0.16517,-0.13957,-0.029101,0.10671,-0.065163,0.11702,-0.052717,-0.123,0.047624,0.045372,-0.13115,-0.15328,-0.16409,-0.02114,-0.02081,0.16014],[0.0016219,0.33501,0.39221,0.36776,-0.1621,-0.78797,0.23388,-0.32433,0.43392,0.77026,0.34247,0.4817,-0.59019,1.5003,-0.24509,-0.57199,-2.8254,-0.070951,0.025559,-0.13103,-0.16416,0.18934,-0.098599,0.19537,-0.019066,0.007534,-0.083521,-0.032351,0.048841,0.07826,0.078487,0.036359,0.08941,-0.064844,-0.14762,0.12175,0.070345,-0.059472,0.16349,0.1102,-0.11704,-0.033105,0.045337,-0.051987,0.089626,-0.0058212,0.011501,-0.045009,-0.1594,0.15525,-0.15542,0.015288,-0.05904,-0.10036],[-0.551,-0.51307,-1.3704,-1.0749,0.03069,-0.9984,-0.9732,0.41071,-0.54296,-0.6964,0.21329,-1.396,-0.086644,-0.84942,0.26696,0.40123,0.24812,0.28554,-0.0038181,0.29659,0.10649,0.19799,-0.13405,-0.059439,0.084719,-0.019799,0.20326,-0.055111,-0.078495,-0.10313,-0.017807,0.0090902,0.0046728,-0.18443,-0.11094,-0.068508,0.043566,0.060443,-0.11384,0.10358,-0.10895,0.15067,-0.19006,0.17014,-0.11019,-0.060456,0.049499,0.029225,0.037326,-0.048116,0.073127,0.11192,-0.00054642,-0.1353],[-0.10395,-0.0036141,0.24365,0.018453,-0.022481,0.24158,0.081414,0.21615,-0.16,-0.044913,-0.11822,-0.44734,-0.2063,-0.20862,-0.17284,-0.087711,-0.042492,-0.069842,0.092891,-0.14066,0.15248,0.2083,0.054465,-0.080761,-0.29737,-0.0084465,0.12194,-0.14371,-0.13974,0.14769,-0.1581,-0.21497,0.053931,-0.14404,0.087735,0.0086473,0.058883,-0.11754,0.037573,-0.10761,0.17866,0.049824,-0.057077,0.055973,0.13137,0.17802,-0.12912,-0.00078272,-0.098423,0.021194,-0.18739,0.01428,0.10692,-0.024476],[-0.52356,0.14909,-0.33081,-0.14315,0.09049,-0.7465,0.092195,0.077716,0.49589,-0.44157,-0.95329,2.0784,0.25286,-0.20524,-0.10349,-0.14153,0.40586,0.15486,0.12295,0.28358,0.11545,0.037428,-0.15581,-0.83548,0.75922,-0.12633,0.11145,0.31134,-0.18662,0.23774,0.16,-0.32751,0.15327,-0.44556,-0.13485,-0.16677,-0.10093,0.034367,-0.15009,-0.17073,-0.13033,-0.15403,0.43626,-0.014862,0.0055378,-0.41082,-0.18194,-0.087193,-0.015138,0.17973,-0.074333,-0.032369,-0.027184,-0.12743],[-0.037729,0.33933,-0.62355,-0.35358,-0.072631,-0.44236,0.1795,-0.16414,0.48354,-0.47635,0.68481,-0.51518,0.32416,-0.63008,-0.088375,0.34527,0.49288,0.13204,-0.28424,0.23336,-0.1904,-0.05692,-0.20062,-1.2801,1.3098,0.089764,-0.25546,0.0034629,0.25793,-0.66947,0.017061,0.043165,-0.18262,-0.12067,-0.13303,0.0832,-0.025856,0.16183,-0.16304,0.027356,-0.16297,0.16292,0.91288,-0.18052,0.14372,-0.45656,-0.29483,0.57672,-0.014493,0.071177,0.0923,-0.039637,-0.049517,-0.032205],[-0.18293,-0.19972,-0.10814,-0.19162,-0.011383,0.67608,-0.28237,-0.0563,-0.65045,0.05902,0.29852,0.56235,0.68122,-2.1611,0.0020856,0.51287,-0.10458,-0.13243,-0.12016,-0.10066,0.19084,-0.10326,0.14784,0.090715,-0.34445,-0.013968,0.10734,-0.1242,-0.24674,0.0006737,-0.011933,0.044534,-0.13613,0.0040553,-0.027004,-0.11112,0.13969,0.15407,-0.19491,-0.090803,0.056116,0.0098897,-0.031826,0.13028,-0.055164,0.24439,0.0070246,0.03456,0.1556,0.14257,0.10451,0.016433,-0.029947,0.16627],[-0.87403,-0.059884,-0.023334,-0.095487,0.1919,0.35355,0.17343,0.24657,-0.19685,0.0003357,-0.13005,0.17006,0.17268,0.18646,0.089706,-0.37646,-0.7938,-0.15633,-0.1229,0.063095,0.086345,-0.048272,-0.14595,0.055022,0.012184,0.28452,-0.17051,-0.34487,0.055379,0.5539,-0.15613,0.24748,-0.094068,0.15118,0.10618,-0.087897,0.1758,0.10056,0.15374,-0.14024,-0.017186,-0.12343,0.0057585,-0.098754,0.05229,-0.15738,-0.097627,-0.13436,-0.061675,-0.19017,-0.071234,-0.054014,0.058294,-0.082878],[3.1779,-0.41722,0.2283,-0.41026,-0.021033,1.4512,-0.64502,-0.52501,-0.58979,0.16861,-0.31442,0.16005,0.33221,-0.63894,-0.10905,-0.15652,1.173,-0.47007,-0.28361,-0.40101,-0.18708,-0.48544,0.020027,0.073794,-0.17878,-0.013493,-0.213,0.039616,0.027083,-0.03539,0.14567,0.035624,-0.013688,0.18262,-0.0091567,-0.15686,0.019864,0.0039613,0.04587,-0.11397,-0.14038,-0.0071716,0.082235,-0.063334,0.1593,0.099457,0.0099507,-0.013436,0.10277,0.024283,0.084243,-0.0066297,0.015883,-0.0092548],[-0.10084,-0.46834,-0.64328,-0.56804,-0.081279,0.4692,-0.70632,-0.67769,-0.68776,-0.87493,-0.56805,0.045433,0.2679,-1.1397,0.89519,1.2994,-0.046876,-0.37864,-0.042655,-0.31903,-0.13693,-0.15366,-0.86593,0.090085,-0.77487,0.5622,-0.17886,-0.28173,-0.55598,0.076896,0.16926,-0.12676,-0.083519,0.0054021,-0.1204,0.045429,-0.076721,0.13679,-0.061157,-0.17863,0.02108,-0.15211,-0.072169,-0.017432,0.14186,0.28263,0.11713,0.054019,0.1154,0.059364,-0.17016,0.41748,0.0070255,0.10694],[2.1003,0.32266,1.0658,0.3483,-0.14947,-0.18071,0.52254,-0.79316,0.85316,0.95189,0.019083,0.065063,1.1442,0.090434,-0.34639,-0.64963,1.0368,-0.16765,-0.10293,-0.25548,-0.11204,-0.14137,-0.016826,-0.055993,-0.0055929,-0.0021737,-0.078806,0.0070388,0.12116,0.017578,0.031707,-0.0441,0.095653,0.053347,0.048919,0.1308,-0.026727,0.19015,-0.20932,0.024578,-0.1201,0.021427,0.044709,-0.13859,0.10213,0.043284,0.099773,0.0087488,-0.15729,0.15319,0.082451,-0.071509,0.0063089,0.18175],[-0.050977,-0.0057574,0.13212,0.009052,-0.030231,-0.39911,0.072237,0.080243,-0.10498,-0.12936,0.22283,0.25491,-0.13461,0.061446,-0.2323,-0.096854,-0.21862,-0.2033,0.1078,-0.23392,0.062928,-0.11925,-0.070438,-0.068376,-0.23875,-0.14571,0.17719,0.54212,0.11382,-0.14633,-0.13679,-0.044051,-0.0030556,-0.002417,0.18156,0.17546,0.010667,0.054204,-0.099956,0.051643,-0.081567,0.096282,-0.086076,0.14844,-0.13719,0.082342,-0.067268,-0.11075,0.14527,-0.061679,0.053294,-0.06837,-0.048755,-0.029135],[0.12334,0.8398,1.7074,1.4818,-0.15836,0.39228,1.5343,-0.20391,0.8844,0.18191,-0.5802,-1.6119,0.21262,2.6729,0.28421,-0.34991,-0.85777,-0.24716,-0.21202,-0.2955,0.037858,-0.2257,-0.10743,0.068462,0.038843,0.042436,-0.012069,0.039187,0.095603,0.01126,-0.17284,0.018124,0.00045305,-0.0026697,-0.045277,-0.0025704,0.1914,0.088005,-0.14726,0.018444,-0.000049031,-0.17465,-0.05691,-0.17327,0.17045,0.0010987,-0.029087,0.08209,0.080251,-0.050137,-0.18889,0.0011187,-0.031573,-0.17651],[-0.17436,0.11914,-0.26331,-0.18685,0.13908,-0.012767,-0.071723,-0.002755,-0.0053054,-0.045098,-0.057254,0.18411,-0.064668,-0.0071611,-0.23331,-0.018488,0.33882,-0.045176,-0.17681,0.17324,-0.14342,-0.11165,0.11142,-0.56265,0.090464,0.24923,0.032587,-0.12983,0.38718,-0.97517,-0.0060103,-0.1987,-0.32036,0.083856,-0.067794,-0.19022,0.17424,-0.11508,-0.029171,-0.0089078,-0.19161,0.18879,0.29824,0.12418,0.02896,-0.15746,0.10085,-0.10315,0.15795,-0.10013,-0.058791,-0.013518,-0.11326,-0.10983],[-0.65504,-0.040869,0.005602,0.004472,0.13976,-0.57032,0.13552,-0.049294,-0.096519,-0.17229,-1.2987,-0.27243,0.25909,-0.36756,0.1848,0.83256,0.04922,0.51192,-0.17544,0.48944,-0.011112,-0.37098,0.46651,-0.54704,0.83244,-0.53236,-0.039587,-0.1525,-0.066758,-0.008116,0.16062,-0.89049,-0.055099,0.044958,0.032711,0.10389,-0.050244,0.11279,0.080958,-0.16543,0.050431,-0.17954,0.61291,0.047619,-0.13119,-0.20558,-0.24563,-0.34802,0.14453,0.020625,-0.13976,-0.025553,-0.010999,0.14743],[-1.7937,-0.31788,-0.28408,-0.19647,0.086634,-0.84266,-0.50233,0.31945,-0.70538,-0.10895,0.26405,0.70512,-0.41638,1.2716,0.64988,0.91379,-0.55323,-0.20721,0.0099738,-0.21562,-0.021347,-0.21138,0.011836,0.075292,-0.17441,0.044774,-0.11677,-0.09888,-0.08748,-0.033288,-0.14634,0.15152,-0.089463,0.086554,-0.19066,0.033261,0.071218,0.08813,-0.029426,-0.18428,0.065676,0.15058,-0.051529,-0.17083,0.10349,0.027777,0.07046,0.02882,-0.098746,-0.17006,-0.19373,0.032969,0.049087,0.17416],[-0.051881,0.018477,-0.0048063,0.026924,0.107,0.15021,-0.20122,-0.059868,-0.039854,-0.16414,-0.12245,-0.013928,-0.031331,0.11056,-0.55004,0.169,0.082844,-0.050141,0.0065853,-0.073891,0.033802,0.052848,-0.02281,-0.096961,-0.034775,0.089308,-0.21326,0.022483,0.00072839,-0.20516,0.10163,-0.018424,-0.019968,-0.018357,-0.13605,-0.037825,-0.0149,-0.032873,0.067805,-0.009533,0.002174,0.055059,0.1465,0.17876,0.069358,0.07159,0.10369,-0.16717,-0.11606,0.10179,0.080758,-0.15249,0.14761,-0.18653],[0.023298,0.68217,-0.67726,-0.23147,0.18061,-0.27621,0.73884,-0.46713,0.9244,-0.83622,1.2151,-0.12629,0.63908,-0.39689,-0.15112,-0.59814,1.1847,-0.029822,-0.076063,-0.043354,0.10162,0.2081,-0.13751,-0.090013,0.092537,0.016531,0.14149,-0.022846,0.10012,0.20018,-0.11301,0.12237,-0.0026077,-0.24476,-0.052122,0.026178,0.022882,0.012082,-0.13085,0.10141,-0.12194,-0.14282,-0.081853,-0.073194,-0.0031982,0.1039,0.15557,-0.096771,0.11722,0.16176,0.12256,-0.054731,-0.054971,0.079872],[2.0835,-0.82688,-0.63076,-0.45126,0.02759,-1.906,-0.99295,-0.63473,-0.95769,0.1516,0.37224,-0.014573,-0.13042,1.9632,-0.037659,0.44654,0.16943,-0.13512,0.044355,-0.14288,-0.096743,-0.070445,0.11111,0.04104,-0.08596,-0.000029852,-0.13583,-0.067356,-0.087643,0.0080709,0.10597,0.033704,0.0097299,0.004313,-0.12467,-0.10883,-0.069017,-0.18819,-0.14274,-0.1281,-0.1268,-0.079587,-0.012173,-0.006331,-0.0099942,-0.012009,-0.080643,0.001302,-0.066801,-0.10304,0.084931,-0.020992,0.06966,0.066418],[0.35312,-0.33554,-0.19284,-0.34777,0.077232,0.010349,-0.48713,-0.35174,-0.42447,0.0091497,-0.64408,0.28341,-0.58683,0.38817,0.15828,0.6491,0.2593,-0.19655,-0.12639,0.016159,0.038011,-0.064871,0.30028,0.054226,-0.19753,0.11275,-0.13641,0.15694,-0.19723,-0.26575,0.0069509,-0.11583,0.1561,-0.051436,-0.031477,0.19218,0.12068,-0.098298,0.097663,0.094573,-0.04514,0.15018,-0.1789,-0.00016937,-0.16088,-0.046977,0.1286,0.16008,-0.13002,-0.18163,0.11297,-0.0035125,0.081729,-0.17569],[1.6622,-0.9192,-0.79584,-0.60712,0.16491,-0.42162,-1.139,-0.79497,-0.97789,-0.7952,0.44391,0.46229,0.74556,2.3038,0.16031,0.082045,-0.053245,-0.2406,-0.17057,-0.35936,0.070394,-0.2561,-0.1304,0.10906,-0.23653,-0.022896,0.0053082,-0.083282,-0.15092,-0.080633,0.068647,0.048643,-0.04977,0.26124,0.046847,-0.043239,-0.14925,-0.14484,0.06458,-0.012222,-0.24587,0.18296,0.080544,0.12932,0.021894,0.21953,-0.048943,-0.01913,-0.13471,-0.061144,-0.17151,-0.014769,-0.016339,-0.13243],[-0.79097,0.46382,-0.025627,0.36707,-0.10808,-0.9498,0.41788,-0.15455,0.63625,0.12125,1.0729,-0.098384,-0.1597,0.046794,0.23838,-0.93024,-1.117,0.10128,0.21373,0.051533,-0.0047751,-0.010667,-0.1245,0.06462,-0.045905,0.03848,-0.12701,0.10695,0.0024568,-0.026345,0.087167,-0.18526,0.074382,0.036485,-0.11353,-0.017823,-0.14551,-0.12147,0.010543,-0.016692,0.049643,0.16142,0.11343,0.19537,0.018523,-0.04132,-0.035354,-0.062487,0.16317,-0.098044,-0.02089,0.057697,-0.013092,0.17024],[-0.11033,-0.265,-0.26895,-0.36999,0.11035,-0.12502,-0.29608,0.071214,-0.30043,-0.16408,-0.41204,-0.28975,0.48391,-0.22682,-0.94078,1.0127,-0.086116,0.033094,-0.049878,0.029758,0.0045059,0.23286,-0.0038213,0.15334,-0.0066883,0.084377,0.17899,-0.080545,-0.21646,0.12475,-0.0862,0.032854,0.10146,-0.024713,0.10934,0.0038241,-0.0077691,0.11129,-0.164,0.083944,-0.080869,0.13957,-0.17093,-0.048366,-0.16243,-0.045037,0.020059,-0.033991,-0.0041317,0.087874,-0.012478,0.00077244,0.010374,0.071691],[-0.19046,-0.099859,0.46293,0.40952,0.057324,0.72408,0.20848,0.32771,0.06518,-0.032415,-0.75517,0.55643,-0.49998,0.55574,-0.14286,-0.26203,-0.74277,-0.17963,-0.074479,-0.14804,-0.16932,-0.10055,0.18843,0.025343,-0.22392,-0.017291,-0.064716,-0.041817,0.067014,-0.060585,-0.1823,-0.18789,-0.01173,0.18941,0.16194,0.15103,0.13328,-0.19187,-0.13648,-0.079607,-0.12651,0.053208,-0.019495,-0.21683,0.10029,0.15614,0.086675,0.063584,0.032675,-0.17916,0.00072607,-0.059364,-0.010485,0.036805],[-1.9776,0.46393,0.81915,0.8401,-0.043705,-1.5473,0.69307,-0.077782,0.89489,0.61681,0.21766,0.32659,-0.55808,0.95048,-0.070736,-0.6072,-1.4501,0.24828,0.082063,0.2034,-0.094024,0.23651,-0.066309,0.09379,0.13707,0.025243,0.054434,0.05866,-0.012818,0.040498,0.14594,-0.082015,0.069637,-0.032097,-0.072544,-0.019667,-0.087091,-0.13608,-0.011142,-0.081805,-0.074687,0.11361,0.12667,-0.010869,-0.12359,-0.026272,0.0030565,0.076315,0.0020544,-0.080454,0.10941,-0.0015521,-0.046985,0.020692],[1.0311,0.60615,-0.47008,-0.0076414,-0.087559,0.2407,0.75181,-0.34435,0.92315,-0.51779,-2.1247,-1.4341,-0.26796,0.99526,0.26737,-0.13496,0.83041,0.067582,0.082703,0.16213,0.044854,0.029344,-0.18306,-0.30382,-0.0010426,-0.00098516,0.18217,0.068874,-0.030698,0.069378,0.1397,-0.27626,0.092608,-0.17427,0.020511,0.034933,0.042415,-0.16765,0.072809,-0.10055,0.080699,0.0031483,0.1313,0.23788,0.02922,-0.073262,-0.0046648,-0.066052,-0.12088,-0.030786,-0.10696,0.019253,-0.031434,-0.0047087],[-0.024537,0.30494,0.19506,0.21383,-0.081037,0.045345,0.19003,0.16461,0.52629,0.10541,-1.1235,0.26493,0.090191,-1.3248,-0.048559,-0.024232,-0.059328,0.24522,0.010464,0.25046,-0.13926,0.10061,0.19544,-0.28319,0.1289,-0.035644,0.25654,0.075559,-0.072098,0.0051255,-0.080241,-0.20105,-0.042072,0.02423,0.013856,-0.15016,0.1448,-0.066779,-0.074351,-0.16681,0.16278,-0.023846,0.096896,-0.0029253,0.12208,-0.19281,0.046731,-0.042813,-0.069285,-0.039707,0.23473,-0.0023457,0.069007,0.043486],[-0.024101,0.75035,0.2428,0.30805,0.16296,0.82345,1.0564,0.043708,0.83356,-0.13701,-0.38787,1.5862,-0.48625,-0.177,-0.03768,-0.62213,0.076929,-0.044317,-0.073631,-0.12835,0.031325,-0.086698,-0.17571,0.10649,0.020718,0.022211,-0.013235,0.032508,0.11159,-0.053231,-0.013572,-0.027612,0.0085059,-0.043823,-0.18919,0.16363,0.022815,-0.099263,-0.19202,0.15107,-0.10062,-0.17016,-0.10681,0.06784,-0.084011,-0.084131,0.048717,0.054824,-0.042027,0.15227,-0.0079766,-0.013444,-0.029355,-0.023307],[-0.050408,0.12162,-0.30162,-0.046701,0.13872,0.69337,0.27887,-0.36746,0.34883,-0.31621,-0.0080056,-0.56719,-0.42213,-1.0616,-0.084064,0.20476,0.35881,0.079732,0.0087851,0.1125,0.058171,0.058079,0.012232,-0.34553,0.3541,-0.023471,0.0030527,0.029436,-0.10358,0.021493,0.18006,-0.051936,-0.035242,-0.037007,-0.092754,0.024541,0.042376,0.16181,0.080164,-0.10911,0.059497,-0.13134,-0.056552,-0.048496,-0.085072,-0.081884,0.047584,-0.046934,0.029854,0.13305,-0.058974,-0.027661,0.0094919,-0.031107],[-0.24243,0.0080392,-0.23332,-0.18268,-0.17406,-0.34723,-0.22291,0.23143,-0.1283,0.019366,-0.2087,-0.48834,-0.18031,-0.53921,-0.23457,0.029571,0.11794,0.27716,-0.11401,0.32747,-0.025109,0.13185,-0.21735,-0.058208,-0.18616,-0.12195,0.16674,0.66688,-0.14001,0.1538,-0.09704,-0.44219,0.050358,0.014859,0.17664,-0.16672,0.15953,-0.18959,-0.05673,0.070934,-0.012163,-0.097065,-0.14236,0.052987,0.15041,0.1002,0.076992,-0.18334,0.1314,-0.018685,-0.12847,-0.10605,0.16431,0.013779],[-0.38053,0.8459,0.69098,0.62126,0.16748,-0.28186,1.0407,-0.031743,1.3063,0.50875,1.0661,-0.094941,-0.25428,-0.88043,-0.27033,0.15583,0.99031,0.076903,-0.026303,0.01616,0.050031,-0.046752,0.0056876,-0.14804,0.59579,-0.085704,-0.13018,-0.029425,-0.15988,-0.02163,0.19455,-0.040384,-0.035744,-0.020576,-0.058742,-0.1167,0.17892,0.02843,-0.12358,0.035823,0.2464,0.16225,-0.0064446,-0.13107,0.023952,0.049853,-0.036044,-0.041674,0.16692,-0.046629,-0.039001,-0.056405,0.085699,0.02049],[-0.16986,0.11849,0.12325,0.19065,-0.080159,0.3228,0.072224,0.17243,-0.2835,0.16164,-0.12525,-0.50907,-0.15608,-0.24241,0.24917,-0.17394,-0.10401,-0.17909,0.10618,0.17642,0.18497,-0.0017591,-0.21454,0.1036,-0.00094789,-0.0055774,-0.04129,-0.097097,-0.13939,0.064704,0.18039,-0.18591,-0.16789,0.10654,0.15441,0.14643,0.068966,-0.17928,-0.069079,0.0986,-0.012647,-0.15656,0.023569,-0.14998,0.00063428,0.10094,-0.0014338,-0.16258,0.15432,-0.13834,0.14811,0.13771,0.042705,-0.15013]],[[0.10067,-0.30565,-0.21243,-0.086241,0.26936,0.11972,-0.066961,0.081041,-0.40175,0.22068,0.044164,-0.20793,-0.061209,-0.040268,-0.18974,-0.14495,-0.37074,0.049033,-0.2858,0.21839,0.17358,-0.24385,0.05394,-0.028874,-0.10494,0.038318,0.31866,-0.13257,0.32475,0.071252,0.15753,-0.06996,-0.011903,0.051582,0.018542,-0.31711,-0.0031469,-0.015118,-0.2031,0.10136],[0.12226,-0.4958,-0.012524,-0.047445,-0.56011,0.027154,0.24424,-0.15651,0.41471,0.15937,0.45425,0.049342,0.46657,0.78419,-0.18909,-0.39514,-0.22619,0.11899,0.1398,0.19673,-0.30875,0.068002,0.058056,0.35698,0.043006,-0.11508,-0.29698,0.092894,-0.17335,0.40713,0.16743,-0.27977,0.084904,-0.83568,-0.34864,-0.30142,-0.12837,0.39118,0.39669,0.19917],[0.021466,-0.18144,0.41958,0.0059971,0.1934,-0.10589,-0.056875,-0.36493,-0.28911,-0.35421,-0.085897,0.036821,-0.19397,-0.13071,-0.14254,-0.18007,0.8854,-0.072277,0.2712,0.24316,0.27055,0.029571,-0.0886,0.20251,0.14353,0.22326,0.12115,0.31625,0.29065,0.38503,0.081275,-0.29222,0.35689,0.23977,0.05044,0.22463,-0.089151,-0.1733,0.65777,-0.021309],[-0.11664,-0.39227,-0.16882,-0.54065,0.33625,0.22141,-0.28659,0.1953,-1.0717,-0.38023,0.12094,-0.026529,-0.082971,0.07197,0.097272,0.11729,-0.76859,-0.27385,-0.68567,0.012711,0.1606,0.17796,0.13354,0.63239,-0.059523,0.14793,0.24288,-0.099637,0.1791,0.07045,0.1517,0.055541,-0.59198,-0.051994,-0.24933,-0.12428,-0.23799,0.09019,-0.14715,-0.11926],[-0.16477,0.060799,-0.11797,-0.38931,-0.11196,-0.11495,-0.41952,0.22613,-1.1212,-0.671,-0.25483,-0.18126,0.00026877,-0.10207,-0.092876,-0.17377,-0.47904,-0.10708,-0.4863,-0.21961,0.21965,0.027004,-0.24589,-0.11252,-0.068653,-0.14999,-0.52776,0.038563,-0.3512,-0.44086,-0.27175,0.1375,-0.44519,0.075174,-0.028965,0.10756,0.10714,0.024885,0.087106,-0.049273],[-0.33352,0.026688,0.20959,-0.12424,0.1557,0.14901,0.038848,-0.37477,-2.0094,-0.69033,-0.1301,-0.14852,0.054095,0.34477,-0.22926,-0.17694,-0.44745,-0.75348,-0.20924,0.070247,-0.053768,0.28426,0.44299,-0.14741,-0.26087,0.040649,-0.42637,-0.18583,-0.39388,-0.18007,-0.13821,-0.07139,-0.95471,-0.066293,0.20634,-0.11333,0.29652,0.083605,0.18125,0.028396],[-0.019182,0.13621,0.16084,-0.57665,-0.022059,0.1976,-0.28069,-0.21761,-1.4162,-0.7879,-0.32716,-0.25526,-0.015233,0.13329,-0.41864,-0.079047,-0.0061064,-0.2449,0.13837,-0.12457,0.062204,0.39196,0.0055527,-0.29409,-0.2978,0.25048,-0.20688,0.094528,-0.18883,-0.71211,-0.42474,0.19071,-1.014,-0.092429,-0.039182,0.52824,0.41887,0.078339,0.54339,-0.20054],[0.07871,0.1888,-0.45963,0.043543,-0.50752,0.33548,0.25638,0.0092013,-0.083877,-0.30451,-0.03394,0.17422,-0.21262,0.03858,0.23784,-0.016475,0.20366,-0.13752,-0.68351,-0.061254,-0.7007,0.034463,-0.054891,-0.017924,0.096102,0.12375,0.096324,-0.050877,-0.59402,-0.27075,-0.18784,-0.064859,-0.17231,-0.74929,-0.12306,-0.12724,0.14907,-0.19296,-0.055225,0.15712],[0.052224,-0.34193,-0.080914,0.36856,-0.74167,-0.056632,0.2747,0.073687,-0.2762,-0.15035,0.15283,0.085358,0.064612,0.081098,0.26543,0.072366,-0.066674,0.090078,0.0033139,-0.035464,-0.65299,0.16806,0.097867,0.080593,0.13111,-0.13761,0.25048,-0.16037,-0.18142,-0.0044086,-0.087081,-0.15052,-0.46835,-0.50664,-0.082775,-0.31088,0.16352,0.24619,-0.17934,0.031975],[0.10398,-0.10549,-0.32059,0.002834,-0.48438,0.185,-0.38737,-0.10729,-0.14837,-0.14363,-0.15169,0.10654,-0.39394,-0.13273,0.031913,-0.14249,-0.029935,0.012515,-0.1376,0.16097,-0.42636,-0.045767,-0.43515,0.17473,0.26021,-0.36988,-0.029659,0.16416,0.10492,-0.10048,0.18977,0.0036204,-0.086721,-0.16886,-0.084251,-0.58405,-0.22403,0.067718,-0.42127,-0.22152],[-0.057653,-0.16141,-0.37502,-0.082122,-0.29762,0.11551,-0.43962,0.067226,-0.22725,0.47158,-0.30268,-0.18517,-0.027024,0.17453,-0.14048,0.16374,-0.48799,-0.11522,-0.32897,0.19679,-0.17843,-0.26033,-0.18502,0.34293,-0.19829,0.31464,-0.060334,-0.040026,-0.043416,0.32274,-0.47138,-0.023337,0.20394,-0.6113,-0.1349,0.0089548,-0.13274,-0.086927,0.20597,-0.13381],[0.25176,0.15433,-0.36909,-0.24958,-0.24905,0.017911,-0.23022,0.037768,-0.14894,-0.019782,-0.5895,0.30115,-0.64142,-0.28858,-0.1343,0.008235,-1.1634,-0.34121,-0.96952,-0.17931,0.71677,-0.21502,0.058028,-0.26648,-0.014624,-0.28192,-0.51383,-0.33655,-0.75238,-0.71362,-0.69025,0.10372,-0.11636,0.54758,0.23236,0.0048543,0.080763,-0.31864,-0.024379,0.20259],[0.11383,-0.074296,-0.17767,0.39472,-0.25605,0.24025,-0.088512,-0.020097,-0.055384,0.13248,0.2617,-0.15751,-0.48244,-0.068662,-0.034603,-0.1852,-0.12477,0.051985,-0.068978,-0.1806,-0.20184,0.068236,-0.015241,-0.32609,-0.10878,-0.048137,-0.11907,-0.014474,-0.11646,0.094386,-0.14042,-0.04973,-0.21484,-0.028794,-0.20748,-0.35824,0.20625,0.083835,-0.29797,0.13579],[-0.24068,-0.061474,-0.35664,0.30102,-0.26398,-0.23963,0.41402,-0.21304,-0.20795,-0.0187,-0.17727,-0.16478,0.081854,-0.051121,0.20811,-0.021486,-0.21866,0.0013239,0.016706,-0.10732,-0.25881,0.0026584,-0.38148,-0.19184,0.16686,0.2345,-0.53975,-0.21498,-0.61828,0.091337,0.21942,-0.034701,-0.16496,-0.32334,0.49061,0.011652,0.20578,0.12333,-0.27231,-0.024641],[0.0063929,0.072022,0.40665,-0.45563,0.53369,0.30292,-0.44379,-0.066036,-0.1784,0.16615,-0.34573,0.085177,0.094013,-0.26711,-0.10477,0.09249,-0.63693,-0.032775,-0.60773,0.33022,0.2828,-0.10452,0.11062,0.21835,-0.08433,-0.23139,0.0012962,-0.17272,0.068395,-0.35212,-0.24019,0.086872,0.31754,-0.17863,-0.12336,-0.039898,-0.18679,-0.24538,-0.29283,-0.066798],[0.11298,0.074864,0.18857,0.40187,0.033059,0.31312,-0.085164,-0.16856,-0.41813,0.23575,0.29876,0.10931,-0.30078,-0.078386,-0.34669,-0.12527,-0.14385,-0.13577,-0.38697,-0.29243,-0.2331,-0.20556,0.12225,-0.28375,-0.035327,0.16382,0.11845,-0.18707,0.12382,0.063637,-0.13883,-0.035307,0.17261,0.18844,-0.14251,0.0238,0.16681,0.18146,0.28278,-0.15445],[0.15896,0.025986,-0.44201,-0.48516,-0.28318,0.059739,-0.51957,0.16413,-0.084114,0.22822,-0.68602,0.19443,0.019339,-0.10882,0.01961,0.08095,-1.0893,-0.3089,-1.3485,0.27492,0.37624,-0.038273,-0.16281,-0.079956,0.1413,-0.40982,-0.90309,-0.29923,-0.89566,-0.24905,-0.4989,0.35744,-0.23525,-0.37179,0.073085,0.5784,-0.074408,-0.29311,0.45934,0.1633],[-0.23606,-0.20983,-0.073333,0.011314,-0.1193,0.13672,0.062583,0.073378,-0.081994,-0.099124,-0.10275,0.1265,-0.21024,-0.062931,-0.20269,-0.0076691,0.10203,-0.17953,-0.25286,-0.076199,-0.23695,-0.10278,-0.24913,-0.15108,0.14596,-0.25011,0.18725,0.2598,0.27763,-0.24345,-0.28818,-0.087282,-0.14062,0.05175,-0.37667,-0.4092,-0.080476,0.04027,-0.38542,0.082569],[-0.12834,0.24981,-0.031501,-0.073313,-0.30584,0.18361,-0.15687,0.21107,-0.17058,0.22027,0.16823,0.00029361,-0.23298,-0.33781,-0.066063,-0.19862,-0.11862,-0.17098,-0.26583,-0.026984,-0.19803,0.17154,-0.35718,0.27191,-0.018535,-0.30824,0.23673,0.23185,-0.0802,0.12125,-0.070918,0.045695,-0.10727,0.079599,-0.24612,-0.69321,-0.34657,0.038957,-0.36185,-0.0053305],[-0.33556,-0.13174,-0.0019299,0.10915,-0.54517,0.23767,0.22772,-0.27852,-0.16533,-0.24618,0.29862,-0.0056991,0.14148,0.066502,-0.26347,0.19613,-0.3498,-0.40866,0.1345,-0.054186,-0.57942,0.35015,0.069978,-0.14997,-0.30179,0.17189,-0.97321,-0.090362,-0.48945,0.063095,0.18188,-0.23412,-0.89963,0.091183,0.20981,-0.15572,0.20598,0.18714,-0.51266,-0.26861],[-0.078691,-0.16051,0.36992,-0.41804,0.20979,-0.033871,-0.032321,-0.15772,-0.29691,0.45978,-0.16828,-0.1209,0.066356,0.061076,0.25215,-0.093802,0.22562,-0.00041955,-0.058953,-0.17524,0.14377,0.24142,0.20758,-0.021511,-0.12222,-0.22697,0.56158,0.098403,0.11509,0.006652,0.18606,-0.25284,0.1531,-0.065548,0.3059,-0.29802,-0.31337,0.18075,-0.13982,-0.0076087],[0.034335,-0.31974,0.13432,-0.42586,0.37972,-0.35542,0.14051,-0.14117,-0.1388,0.12957,-0.39493,0.076093,0.11152,0.17305,0.10267,-0.2475,0.68026,-0.035339,0.24222,-0.11634,-0.13268,0.098488,0.087173,-0.10961,0.11599,0.03555,-0.029138,0.15365,0.49166,0.15611,-0.0081623,-0.25204,0.46454,-0.056745,0.33832,0.21707,0.25434,0.41285,0.26226,-0.08899],[-0.086815,-0.018422,-0.13259,0.068735,-0.72962,-0.29142,0.0076211,-0.036522,-0.1542,-0.20342,0.17438,-0.037933,-0.64211,-0.1399,0.0055664,-0.017112,-0.057474,-0.14632,-0.21959,0.022974,-0.56573,0.076493,-0.43838,-0.1932,0.26054,-0.11339,-0.016053,0.13312,-0.74375,-0.068071,-0.11509,-0.21714,-0.46618,-0.060847,0.13474,-0.31549,0.28274,0.096529,-0.24007,0.14037],[0.053773,-0.10991,0.05115,-0.022996,-0.10287,-0.04347,-0.26939,-0.22795,-0.42901,-0.051385,-0.36789,-0.018949,-0.37807,-0.047101,-0.5026,-0.06079,0.41923,0.006534,0.05607,-0.064013,0.52787,-0.019069,-0.08157,-0.41401,-0.12685,0.041873,-0.051807,-0.21867,0.085053,-0.020932,0.050705,-0.19795,-0.11595,0.53013,0.28433,-0.079163,0.040397,0.078735,0.30853,0.14763]],[[-0.91204,0.31715,-0.78538,0.63781,1.1767,0.46865,0.60773,-1.2022,0.78568,-1.0158,-0.5415,-0.40929,-0.83457,-0.99364,-0.5984,0.50482,-0.54271,-0.99994,-1.1385,0.62745,0.50609,0.44728,-1.1151,0.56176]]],\"biases\":[[-0.17305,0.011855,0.21224,-0.55349,0.36163,-0.30357,0.26298,-0.30295,2.0678,-0.31847,0.7736,-0.013629,0.63788,0.2117,-0.3203,-0.27507,-1.4305,-0.94694,-0.63378,-0.12761,-1.0575,0.0046301,0.36472,-0.41409,-0.12085,0.12256,-0.47321,-0.39165,-1.1153,0.094893,0.27428,-0.23791,0.48914,0.48321,0.47754,-0.36376,0.18455,0.41052,-0.25912,-0.082218],[-0.50837,-0.99603,-1.0462,0.055096,0.20023,0.70376,0.36036,-0.12067,0.059345,0.00048548,0.082489,0.46551,-0.22561,-0.33374,-0.24525,0.11124,0.27248,-0.27711,-0.36564,0.68654,-0.01501,-0.43232,0.18245,-0.054452],[-0.51554]]}");


var $afdb9681881917c0$exports = {};
$afdb9681881917c0$exports = JSON.parse("{\"sizes\":[54,40,24,1],\"weights\":[[[0.059865,-0.13617,-0.16038,-0.11643,-0.127,-0.11668,0.071321,-0.15014,0.11799,0.16571,-0.043649,-0.14229,0.15459,-0.029609,0.14269,-0.071218,-0.08535,0.016551,-0.083511,0.094595,0.040705,0.051332,-0.10802,0.13077,-0.038824,-0.13572,-0.16326,0.1423,-0.046765,-0.028851,0.15547,0.078456,-0.11351,-0.18961,-0.04364,-0.14577,-0.026723,-0.16557,0.0075991,-0.17502,0.014033,-0.11224,-0.10463,-0.10236,-0.16102,-0.1091,-0.16188,0.13163,-0.032429,0.070436,0.015124,-0.01776,0.11064,-0.10091],[0.18642,0.086363,0.15568,0.15543,-0.068805,0.30797,-0.1273,-0.039337,0.074857,0.29671,-0.28894,-0.83849,-0.039722,-0.042953,-0.17033,0.51125,-0.05301,0.11747,-0.0098161,0.14087,0.050264,0.069179,0.36576,0.19272,-0.241,-0.22949,0.056081,-0.012439,-0.029046,-0.0948,-0.078352,0.14857,-0.079862,-0.016221,-0.14581,0.0014739,0.14321,0.16759,-0.025297,-0.12318,0.10055,0.15053,-0.31755,0.045477,-0.12161,-0.005928,0.08499,0.11445,-0.10173,-0.1109,-0.022097,-0.025206,0.034613,0.091376],[0.079567,0.31084,0.55897,0.45652,0.14741,-0.31555,0.19676,0.10456,0.27493,0.66339,-0.68683,1.1721,0.11144,0.86118,-0.10855,-0.44286,-0.13928,0.12538,0.043802,0.099912,0.12311,0.058376,0.35114,0.0044987,0.15303,0.046924,-0.11375,-0.0068479,0.14836,-0.12412,-0.057604,-0.32876,0.044764,0.0071832,0.022628,0.10956,0.091791,-0.14169,0.12608,-0.15314,0.030299,-0.099172,0.24371,-0.0081815,0.1692,-0.099853,-0.020971,0.043923,-0.10514,0.19073,0.10475,-0.060844,-0.069234,0.12949],[-0.67499,-0.21018,-0.085718,-0.34434,0.12252,-0.027018,-0.11652,-0.085191,0.026944,-0.13175,-0.25188,0.064496,-0.036063,-0.14431,0.14248,0.15664,0.16588,-0.072027,0.080882,0.050205,0.16582,-0.0001597,-0.38963,-0.19395,-0.054654,0.14969,-0.13643,0.10738,0.038837,-0.49851,0.13377,-0.14432,0.22157,-0.23821,-0.047451,-0.10844,-0.022876,-0.0098066,-0.013123,-0.021516,0.0044564,-0.09563,0.062549,-0.036984,-0.11603,-0.039309,-0.045066,0.09965,-0.063207,-0.14933,-0.10685,0.074149,-0.018849,-0.034219],[0.078538,-0.052153,0.0083331,0.15981,0.033872,-0.29599,0.16373,0.0708,0.27492,0.27681,-0.14012,0.36824,0.14862,-0.035369,0.08463,-0.44473,-0.10766,0.12814,0.075059,-0.19042,-0.029811,-0.12672,0.032776,-0.44794,0.60587,0.14039,-0.24861,0.14879,-0.43908,-0.081082,-0.0051599,0.11679,-0.11189,-0.014883,-0.13971,0.16291,-0.048472,-0.12721,-0.12112,-0.152,0.055463,-0.074149,0.46601,0.059559,-0.11329,0.13054,-0.17495,0.10151,-0.11833,0.054979,-0.056852,0.070591,0.092174,-0.13488],[-0.43558,0.17807,0.013827,0.30006,-0.1203,-0.61033,0.14883,0.10069,0.41776,0.06981,-0.26069,0.50237,-0.084696,-0.030737,0.10114,-0.17559,0.0036904,0.16056,-0.085369,0.076479,0.044598,0.068239,0.2428,-0.19874,-0.063851,0.078974,0.13339,0.11053,-0.19678,-0.56961,0.15408,-0.27795,0.12108,-0.037124,-0.11821,-0.07974,0.17121,0.034986,0.11814,-0.16568,0.1225,-0.059768,0.24025,0.10746,-0.075046,0.018974,0.19254,0.0655,0.0067998,0.15398,0.14699,-0.078411,-0.060191,0.014016],[0.16096,-0.16039,-0.06173,-0.052114,0.17879,0.42319,-0.078575,-0.19217,0.077582,0.14097,-0.50245,-0.20241,0.157,-0.29765,-0.15697,0.68472,0.048608,0.037493,-0.14156,-0.03493,0.13613,0.040422,0.32325,0.082394,0.35323,0.025742,-0.044738,0.024302,-0.0050526,0.36717,0.08828,0.039027,-0.11113,0.057848,-0.18093,0.1535,0.14489,-0.19108,0.18555,0.099048,-0.078941,-0.079156,0.12018,-0.14147,0.17966,0.14218,0.18254,-0.0083233,-0.11954,0.051721,0.014707,-0.088996,0.045292,0.10176],[0.012107,0.043313,0.055717,0.057473,-0.1644,-0.047923,0.044357,0.029719,0.11451,0.065414,-0.26119,0.094106,-0.11533,0.028625,-0.081806,-0.009806,-0.0042452,-0.097505,0.083388,-0.095275,-0.14087,0.15702,0.0034579,0.035665,-0.03681,-0.15145,-0.039891,-0.032452,0.16443,-0.18677,-0.11549,-0.023167,-0.17324,-0.15524,-0.17261,-0.071505,-0.042325,0.081059,-0.040254,-0.16727,0.10179,-0.027415,0.15351,0.11137,0.037276,-0.14834,0.059051,0.098309,0.02729,0.12687,-0.059786,-0.10503,0.15705,-0.16342],[-0.15157,-0.048485,0.27985,-0.04067,-0.18194,0.38765,-0.010576,-0.13774,-0.14453,0.36712,-0.20934,0.61283,0.15059,0.057656,-0.24423,0.52544,0.07432,-0.058863,-0.048549,-0.032609,-0.05336,-0.17871,0.37971,-0.067691,0.093436,0.029428,-0.12993,0.21633,0.0048931,-0.34066,-0.13579,-0.075483,-0.020826,0.29987,-0.16342,-0.13698,0.031379,-0.12937,-0.077974,0.11123,0.18517,0.033397,0.040452,0.10468,0.13735,0.05593,0.10678,-0.02207,-0.15268,-0.0063659,-0.19825,-0.16513,0.093527,0.15627],[-0.035305,0.033394,-0.16348,-0.12185,0.1649,-0.072111,-0.1657,-0.14615,0.098835,-0.13296,-0.26915,-0.14555,-0.071175,0.19594,-0.10565,0.098024,-0.11419,-0.16423,0.15938,-0.10162,-0.18225,-0.17573,0.077846,-0.35925,0.46139,-0.12027,0.11368,-0.1094,0.17901,-0.11366,-0.058581,-0.2999,0.048642,0.19432,-0.049122,-0.04658,0.018654,-0.17927,0.03169,0.060956,-0.14444,-0.031153,0.28455,-0.031166,0.088698,0.13382,-0.062104,-0.1135,0.075759,-0.15721,-0.12642,0.02933,0.16675,0.18507],[-0.39395,0.30559,0.39322,0.59997,0.031923,-1.0943,0.18896,0.0035007,0.43945,0.79396,0.46353,0.36054,-0.096856,1.0091,-0.26335,0.2722,-0.015394,0.068189,-0.050073,-0.059345,0.13283,-0.029388,0.29627,-0.12859,0.06946,0.016145,0.13203,-0.00063524,-0.10232,-0.3523,0.17001,0.090557,-0.014661,-0.065494,0.0035015,-0.083099,0.039218,0.15643,-0.13326,0.1161,-0.061162,0.017482,-0.026333,-0.0091778,-0.043867,-0.01093,-0.060283,-0.058887,-0.13315,-0.11324,-0.023434,0.099102,0.015676,0.18551],[-0.31015,-0.23667,-0.78921,-0.29871,0.0073362,0.034274,-0.39014,-0.020117,-0.31866,-0.71389,-0.17398,-0.40383,-0.080444,-0.88999,0.39679,0.51408,-0.20369,-0.075111,-0.031066,-0.13194,-0.10692,-0.19972,-0.8105,-0.22275,-0.020839,0.23495,0.057578,0.063904,-0.36891,-0.18686,0.073619,0.097704,-0.17437,-0.098498,0.04486,-0.10668,0.11432,-0.016586,0.086066,-0.071705,-0.16913,-0.13142,0.23148,-0.11642,0.025274,0.17467,0.17069,-0.071208,-0.073876,0.091789,0.12552,0.067111,-0.051203,0.16334],[-0.31112,-0.25932,-0.29962,-0.28817,0.13506,-0.36217,-0.17662,-0.19789,-0.28601,-0.23506,-0.15422,0.52389,-0.088766,0.34543,0.13182,0.17504,-0.10561,-0.01507,-0.075944,0.021049,-0.028427,-0.040164,-0.26169,-0.25097,-0.078806,0.1672,0.092206,0.11242,-0.16033,-0.1301,-0.033101,-0.15175,-0.039218,-0.216,0.022621,-0.040625,-0.15538,0.00024718,0.084812,0.19172,0.17509,0.1797,0.10085,0.074506,0.13141,-0.024909,-0.040228,-0.04505,0.11803,-0.020093,0.20367,0.021614,0.065805,0.080648],[-0.2499,0.20729,-0.18932,0.16334,0.054804,-0.075467,0.12147,-0.2165,0.33715,-0.14478,0.26599,0.091686,-0.14639,-0.089912,0.046779,-0.09338,0.16367,-0.12302,0.081319,0.17888,0.044045,0.15211,0.21935,-0.3973,0.28756,0.0011977,-0.12884,-0.15906,0.15337,0.0022804,-0.11887,-0.19885,0.036902,0.038632,0.14766,-0.091892,-0.077148,-0.011806,-0.06734,0.044525,0.14416,0.095411,0.20708,0.12472,-0.12238,0.12634,0.15678,-0.085365,-0.15604,0.029018,-0.21251,-0.019209,-0.068804,0.12289],[-0.56952,-0.12861,-0.3442,-0.18239,0.16236,0.24218,-0.24178,0.11318,-0.25121,-0.38507,-0.045517,-0.070804,-0.099046,-0.62019,0.34272,-0.5044,0.063773,0.048304,0.050422,-0.15878,-0.031758,0.15557,-0.29608,0.015852,-0.36707,0.14789,0.21138,0.0462,0.19942,-0.2374,-0.014071,0.021544,-0.10364,-0.088334,0.1777,0.09912,0.00057411,0.0085046,-0.036429,0.066302,0.15579,0.19243,-0.073774,-0.072237,0.16575,-0.0019987,0.07206,0.0075172,-0.1188,0.088232,0.010665,-0.0055782,-0.03333,0.023259],[0.73507,0.058492,0.29932,0.072807,-0.051387,0.25975,-0.10694,-0.042337,-0.20553,0.29832,0.039043,-0.22521,0.18111,-0.169,-0.28146,-0.048724,0.1182,0.039822,0.020192,0.057403,-0.10897,0.20317,0.15794,0.19929,-0.0093331,0.079611,0.0030776,0.0011901,-0.10688,0.22597,0.16877,-0.090717,0.074899,0.0017441,-0.029473,-0.18272,0.12734,0.15401,0.18952,-0.087103,-0.11902,0.017044,-0.1554,0.15007,-0.16629,-0.017671,0.14421,-0.074816,0.15527,-0.14415,-0.13517,0.00064853,0.039777,0.19091],[-0.25367,-0.25322,-0.19793,-0.048379,0.18265,-0.33264,-0.16664,-0.0674,-0.24044,-0.1906,-0.025618,0.17738,0.04433,-0.25059,0.088446,0.45663,-0.15914,-0.099045,0.19261,-0.12323,0.044276,-0.13049,-0.63512,-0.23807,-0.077527,-0.20608,0.18139,0.03346,0.053797,-0.04834,0.15991,-0.14378,-0.15412,-0.43501,-0.018684,0.086416,0.056742,-0.14087,-0.033621,0.1413,0.011701,-0.09451,-0.027313,0.085169,0.034917,-0.10554,0.17351,-0.10082,-0.11376,-0.17919,-0.076429,-0.029289,-0.47233,0.0028672],[-0.2185,0.059922,-0.21568,-0.070222,-0.064859,-0.16861,-0.043947,0.020182,-0.15316,-0.19557,0.1182,-0.14443,-0.13899,-0.0065285,-0.060815,-0.25578,0.13024,0.1612,0.026518,-0.0023722,-0.020927,0.26894,-0.0064838,-0.14291,-0.074356,-0.0070276,-0.12703,-0.12661,-0.036622,-0.19181,-0.099111,-0.0036876,0.086502,0.16128,0.090403,0.08757,0.11118,0.041605,-0.071481,0.060405,0.054812,0.0727,0.13929,-0.18251,0.011381,-0.12724,0.13706,0.18597,-0.10458,-0.18073,-0.15488,0.039208,-0.23489,-0.13834],[0.045677,0.066654,-0.13709,-0.15637,-0.029422,0.0030302,0.0038803,0.076595,-0.024413,-0.050545,-0.16568,-0.092314,0.14035,0.073872,-0.10238,-0.11813,0.057952,0.049852,-0.081605,0.047393,-0.16091,-0.1693,0.049341,-0.061213,-0.03612,-0.07591,-0.0028654,0.17234,-0.16315,-0.0036031,-0.10574,-0.14215,-0.12428,0.054233,0.0045532,0.016774,0.16493,0.035645,0.14273,0.12281,-0.058578,-0.159,-0.058873,0.18958,0.051479,-0.072812,-0.060953,-0.084315,0.081467,-0.10136,0.13044,0.079018,0.16829,-0.074264],[0.028797,0.051489,-0.11154,-0.092276,0.1583,-0.11945,-0.03698,-0.11203,-0.026338,-0.075356,0.040131,-0.098122,-0.044118,-0.11634,-0.12563,0.017413,0.17346,-0.10547,-0.10105,0.047845,-0.067841,0.015554,-0.11109,0.066737,-0.030156,0.015657,-0.18257,0.040626,0.19044,-0.12358,-0.01463,-0.015047,0.059058,-0.043764,-0.12564,0.17019,-0.1183,-0.0061314,0.17379,0.073547,-0.15798,-0.087881,-0.097432,-0.067157,0.044698,0.099858,-0.18248,-0.12202,-0.05498,-0.0020341,-0.12265,0.1415,-0.14171,-0.05575],[-0.066224,-0.33943,-0.44242,-0.47907,-0.030996,0.18264,-0.45087,0.1424,-0.66948,-0.70129,0.050994,0.43094,-0.19024,-0.44879,-0.14899,0.17769,0.071416,-0.18559,0.040735,-0.24237,0.13399,0.19244,0.24353,0.038952,-0.30458,-0.15364,0.25483,-0.037072,0.042387,0.25947,-0.055908,-0.18168,0.14503,-0.074648,0.17074,-0.091206,0.17404,-0.01522,-0.16982,-0.17692,0.088886,-0.078091,-0.15327,-0.14121,-0.1342,-0.1277,-0.18112,0.10591,0.0099093,-0.15799,0.093218,0.0033267,0.0075961,0.11645],[-0.83752,0.03646,-0.56095,-0.3068,-0.083681,-0.132,-0.19983,-0.010091,-0.016242,-0.78174,0.24601,0.49721,-0.11008,-0.089568,0.32488,-0.16851,0.058977,0.10402,-0.11522,0.14148,0.060025,0.024227,-0.38041,-0.20163,0.23277,0.040599,-0.0015114,0.069175,-0.10236,-0.49625,-0.19187,0.20727,-0.11344,-0.059873,-0.10004,0.051493,0.081661,-0.049341,-0.068873,-0.17369,0.16508,-0.0024626,0.24291,0.19612,-0.15045,0.15205,-0.16488,0.068935,-0.01033,0.051215,-0.13635,0.05074,0.0012826,0.17316],[-0.69001,-0.19403,-0.28829,-0.17881,-0.048745,0.22551,0.036103,0.24751,-0.20816,-0.1785,-0.30344,-0.45203,0.1546,-0.40837,-0.045005,-0.049596,-0.071613,-0.08359,-0.011119,0.10342,-0.11688,0.027057,-0.33573,-0.016225,-0.22316,-0.0041053,0.024581,-0.054651,0.085712,-0.33618,0.14183,0.056102,-0.29525,-0.094384,-0.17625,-0.1658,-0.062795,-0.091554,-0.15249,-0.081027,0.1371,0.084864,0.026127,0.0036851,0.13466,0.049102,-0.059083,0.23968,-0.16143,0.10415,-0.10635,0.19059,-0.10901,0.18557],[0.24415,-0.13741,0.15704,0.18336,0.076255,-0.46002,0.13447,-0.11424,0.091197,0.49319,-0.41853,0.32247,0.1484,0.92886,0.068636,0.44883,0.027606,-0.0246,0.10831,-0.063976,-0.011685,-0.073892,-0.18732,0.14877,-0.094381,-0.26654,-0.11759,-0.036958,0.095486,0.082115,-0.13681,0.18184,0.23526,-0.20784,0.18121,-0.1851,-0.18188,0.10281,-0.18652,0.14037,-0.027412,-0.025025,-0.12318,0.095252,-0.049474,0.12674,-0.045129,-0.0058836,-0.093523,0.12738,0.026762,-0.014727,0.014352,0.12536],[-0.012718,0.11355,0.11534,-0.011838,-0.027801,-0.059309,-0.074726,-0.074093,-0.092736,-0.13917,0.26275,0.25063,0.1168,0.38835,-0.19147,0.66452,-0.11564,-0.094877,-0.003218,-0.04581,-0.016311,-0.23132,0.069957,-0.066953,0.061348,-0.23203,-0.062863,-0.014022,-0.085511,0.20668,0.018082,-0.10969,0.1684,0.019137,-0.026212,0.064795,0.031342,0.025675,0.1076,-0.022755,-0.067343,-0.019211,0.01033,-0.076371,0.091586,0.094733,-0.17596,-0.06796,0.18218,-0.11129,0.15441,-0.083014,0.044394,0.10629],[-0.070459,-0.014819,0.65486,0.26651,0.0040895,-0.55116,0.16217,0.13941,0.17794,0.7836,-0.81019,-1.3655,-0.11041,0.82057,0.0091617,0.20787,0.17257,-0.050327,-0.021563,-0.13142,-0.088724,0.021034,0.54168,0.011553,0.074414,0.10158,-0.077179,-0.11674,0.15413,-0.45444,0.056049,-0.18055,0.24859,0.27563,-0.15281,0.19094,-0.16795,-0.036679,0.027081,-0.020502,0.19732,-0.080872,-0.061811,-0.12773,-0.1524,-0.13426,0.034092,0.13118,0.11049,-0.0089328,-0.13866,-0.091399,0.073767,0.02204],[0.14206,-0.24352,-0.25642,-0.33965,-0.17484,-0.42847,-0.12456,0.046887,-0.24122,-0.3509,0.17449,0.20063,0.11108,0.021709,0.15626,-0.11061,-0.12916,0.012418,-0.10732,0.045194,-0.0050988,0.0024907,-0.35166,0.081826,-0.034759,0.03361,0.15181,0.050621,-0.061102,-0.11558,-0.16817,-0.12617,0.085289,-0.21435,0.13683,0.027469,-0.12409,0.089032,0.022977,-0.053866,0.17655,0.06661,0.15227,0.0018632,0.1304,0.1383,-0.12658,-0.033408,0.11415,0.074933,-0.05805,-0.010988,-0.028906,0.1263],[0.14653,0.06449,-0.17825,-0.13334,0.094266,-0.10944,-0.088754,0.026628,0.055514,0.085627,-0.070336,-0.0061264,-0.024279,-0.11278,-0.074833,-0.09909,-0.11117,-0.17283,0.039476,0.0011514,0.15487,0.026479,-0.093523,0.18561,-0.057771,0.098407,0.021899,-0.12704,-0.19556,-0.047802,-0.095158,0.20232,0.071816,0.082335,0.16801,-0.14441,0.15352,-0.15699,-0.019449,0.12522,0.10887,-0.12486,-0.19258,0.12934,-0.074514,0.20379,0.18624,-0.14152,0.10932,0.067704,-0.021315,-0.092559,0.0084038,0.013665],[-0.18703,0.023498,0.014007,-0.062813,-0.13858,0.076335,-0.10224,-0.18603,-0.079685,-0.13818,0.17357,0.050984,-0.18435,-0.30045,0.17318,0.38231,-0.0088079,-0.14897,0.030629,-0.13169,-0.099792,-0.26844,-0.26792,-0.24518,-0.076048,-0.048036,0.093423,0.12609,-0.19289,-0.26715,0.0072046,-0.083769,-0.1226,0.036694,-0.014221,-0.041559,-0.043324,0.11172,-0.15957,-0.1668,-0.052491,-0.0556,0.048195,-0.041948,0.1341,-0.02027,0.031079,0.069066,0.16651,-0.013526,-0.095389,-0.074412,-0.2235,0.086082],[0.17922,0.11719,-0.16694,0.022383,-0.090649,0.032026,-0.2051,-0.19232,-0.099765,-0.049659,-0.090933,-0.24338,0.086505,-0.2845,0.015679,0.25157,0.076186,0.18637,-0.068071,-0.2451,-0.16187,-0.0042854,-0.09851,-0.25853,-0.0086126,0.12973,-0.20929,0.13903,-0.11758,-0.141,0.031891,0.22569,-0.04296,0.0023177,-0.16805,-0.040551,-0.041655,-0.038439,0.17104,0.18415,0.10747,0.14502,-0.16911,0.035007,0.18794,0.09779,-0.027027,-0.065186,-0.00096286,0.11738,0.045208,0.049826,0.56417,0.1074],[0.063363,0.12487,0.079761,0.13566,-0.03325,-0.41871,0.14401,-0.23017,0.16591,0.24242,-0.40248,-0.30379,-0.19079,0.71788,0.35372,0.1802,0.0042332,0.028005,-0.010119,0.069122,-0.14185,-0.11686,-0.35482,-0.42257,0.08492,-0.091487,0.010696,-0.069188,0.091808,0.32527,0.14971,-0.046025,-0.10992,0.075048,-0.038466,0.0063825,-0.054696,-0.10622,-0.085994,0.16399,-0.1858,-0.092079,0.26641,-0.078349,0.15866,-0.03531,0.014939,0.018353,-0.10346,-0.070556,0.18028,0.16476,-0.0075117,-0.03401],[-0.055408,-0.17562,-0.58653,-0.43294,0.12697,0.15115,-0.32552,0.17625,-0.21956,-0.63368,-0.2928,-0.20792,-0.15561,0.040596,0.18063,-0.07301,0.10981,-0.069399,0.10393,0.24178,0.13572,0.037182,-0.67144,-0.11866,-0.17733,-0.15345,-0.02572,0.065457,0.014365,-0.074589,-0.18433,0.11773,-0.29751,-0.3422,-0.043284,-0.09176,0.12548,-0.16594,-0.1003,0.1672,0.16884,-0.14113,0.095293,-0.056137,-0.027288,-0.13623,0.17254,0.31062,0.10809,-0.18592,-0.048805,-0.064312,-0.13663,-0.087014],[-0.46351,0.09646,-0.35074,-0.27542,0.12907,-0.18937,-0.09759,0.026573,-0.1712,-0.1407,0.33508,-0.35742,-0.096394,-0.37321,0.37951,0.44046,0.065664,0.0011504,-0.19263,-0.016735,-0.16369,-0.16436,-0.10106,0.07514,-0.026682,-0.20077,0.075931,0.05493,-0.19171,-0.25939,0.065483,0.049638,0.085071,0.058303,0.092208,0.098201,-0.0023295,0.035594,-0.060749,0.025397,0.049911,-0.17922,0.099371,0.019114,0.16999,0.17143,-0.091775,0.083147,0.093621,-0.032398,-0.095431,-0.063352,-0.0064754,0.11645],[0.29094,-0.046247,0.47116,0.17084,0.03671,0.081699,0.05332,-0.21778,0.13126,0.64002,0.29373,-0.21187,0.12062,0.010747,0.1379,-0.0091462,0.1535,0.13374,-0.043621,0.040744,0.035222,0.0080956,0.76136,0.19439,0.22125,-0.25786,-0.15883,0.30645,-0.11379,-0.30795,0.025775,0.28638,-0.039061,0.25736,-0.1515,0.073461,-0.14718,-0.10036,0.075776,0.069382,-0.03351,-0.064688,0.016956,0.032383,-0.18006,0.076992,-0.12203,0.062413,-0.1342,-0.17107,-0.1703,-0.14067,0.020311,0.1737],[0.12637,0.29566,0.7678,0.50644,-0.030964,-0.16813,0.52738,0.14361,0.64827,0.76643,-0.09607,-0.97119,-0.18063,0.67344,-0.25883,-0.54794,-0.17809,0.10298,-0.042079,-0.014265,-0.035626,0.15477,0.10464,0.090459,0.17067,0.069316,-0.023412,-0.076786,0.27938,0.37379,-0.085069,-0.13944,-0.0215,0.093397,-0.17086,0.12846,-0.091401,-0.089785,-0.071525,0.089317,-0.15234,-0.060976,-0.020878,-0.092976,-0.13757,-0.1472,-0.17077,0.021362,0.16622,0.12475,0.11241,-0.11823,-0.0091316,0.10681],[-0.097087,-0.036452,0.12789,0.068506,0.13131,-0.059679,0.064137,-0.1924,0.0068739,0.11863,0.074594,0.11775,0.017571,-0.13678,-0.15128,0.050999,-0.11559,0.0069245,0.030191,-0.10313,-0.092861,0.034569,-0.18409,-0.11292,0.18834,-0.088891,-0.12179,0.1548,-0.14062,0.054579,0.11481,-0.089232,-0.090097,-0.12453,0.029371,-0.11993,-0.044906,0.14201,-0.070104,0.081481,0.092349,0.080808,0.1451,-0.079135,-0.16531,0.12142,0.13964,0.08112,0.14732,0.18795,-0.16971,-0.035053,-0.0079331,0.062227],[-0.10962,0.049945,0.10685,-0.039253,0.090294,-0.0037211,-0.13992,-0.13698,0.20108,-0.028339,-0.050309,-0.014794,-0.13535,-0.019449,0.075785,-0.00021238,0.18133,0.029786,-0.07903,0.1045,-0.15597,-0.036123,-0.0936,0.18747,0.10541,-0.22226,0.18457,0.17711,0.07729,0.030233,0.19229,-0.15629,-0.02175,-0.12697,-0.12004,0.12964,0.13432,0.093945,0.18671,0.0044064,0.15705,-0.080645,-0.1933,-0.024805,0.06842,0.12554,-0.17843,-0.14078,-0.17977,-0.012431,0.18628,0.052522,0.069303,-0.15664],[-0.67686,-0.1375,-0.96502,-0.52656,0.1877,0.50586,-0.20442,0.22319,-0.42071,-1.0383,-0.19619,-0.38116,0.13013,-1.1224,0.3922,-0.10307,-0.052124,0.091969,-0.022181,0.1833,-0.18104,0.026055,-0.9832,-0.26934,-0.13369,0.15936,0.18523,-0.0016364,0.10197,-0.17988,-0.048032,-0.011774,-0.16727,-0.31826,-0.10251,-0.17074,0.16001,0.17021,0.14578,-0.075164,-0.14931,-0.026336,-0.10543,0.08806,0.14278,0.030466,-0.17263,0.062879,-0.028169,0.084119,-0.14735,0.037998,-0.036474,0.098601],[0.29207,-0.067868,-0.61531,-0.29111,0.11931,0.89096,-0.49444,-0.0050836,-0.57149,-0.55417,0.33812,0.20281,0.14401,-0.8115,-0.071497,0.23365,0.041629,-0.017244,0.1339,0.029139,0.15372,-0.078772,-0.2133,0.040138,0.11489,-0.10384,-0.11158,-0.020168,-0.11814,-0.041039,0.0096399,0.16628,-0.0025241,-0.14397,0.18694,0.17663,-0.062407,-0.0846,0.11737,-0.070093,0.072043,0.048419,-0.13214,0.13263,0.051818,-0.13344,-0.054186,-0.072178,-0.0050073,0.012376,-0.09461,-0.038226,0.018545,0.16002],[0.34155,0.35638,0.45231,0.60289,-0.11973,0.19227,0.12253,-0.28584,0.59503,0.97654,0.66866,-0.07803,0.076057,0.49522,0.032052,-0.51404,0.15289,-0.026427,-0.16697,-0.14585,0.020681,-0.017832,0.36045,0.094017,0.20544,-0.15081,-0.033076,-0.064665,-0.12953,-0.085366,0.09868,0.35277,-0.047195,0.16166,0.18997,-0.055268,0.13957,-0.064196,0.080965,0.15333,0.13428,-0.13647,0.115,-0.046639,-0.10239,0.0322,0.11481,-0.0028523,0.081164,-0.044445,0.056817,0.020747,-0.017682,-0.14118]],[[0.22023,-0.40035,-0.25304,-0.04748,-0.2285,-0.38907,0.15431,-0.2311,-0.021855,-0.043811,-0.053027,0.35857,0.18528,-0.024256,-0.019585,-0.13436,0.30143,0.1986,-0.072162,0.21651,0.15459,0.37537,0.12529,0.010053,0.14137,-0.31765,0.31871,0.18999,0.17947,0.14706,-0.070279,0.17166,-0.071173,-0.20026,-0.55597,-0.14362,-0.11513,0.25721,0.051568,-0.33973],[-0.11803,-0.035257,0.026225,0.021251,0.10537,0.14758,0.17745,0.058804,0.050609,0.0096902,0.20567,0.015049,-0.013649,0.20828,0.009938,-0.15712,0.10138,0.15776,-0.19955,-0.061775,0.14022,-0.21132,0.081137,0.11724,-0.056223,0.15866,-0.076907,-0.1498,-0.1457,-0.049574,-0.19008,0.14695,0.028697,-0.13741,-0.03441,0.0092483,-0.20837,-0.079118,0.037906,-0.20484],[-0.067518,-0.087533,0.10155,-0.15741,-0.24233,-0.083836,-0.091031,0.14216,0.13019,-0.088247,-0.26817,-0.029103,-0.16906,-0.084534,0.21731,0.18106,0.18223,0.19173,-0.1626,-0.017937,-0.030113,-0.18478,-0.18016,-0.27611,-0.2457,0.080954,0.08517,0.14178,-0.19148,-0.21194,0.093886,-0.1308,0.01999,0.16162,-0.14776,-0.088436,-0.1574,-0.033161,0.19817,0.12401],[-0.15379,0.16726,0.16501,-0.22637,0.071933,-0.05714,0.20899,0.12564,-0.073677,-0.0098883,-0.043169,-0.22721,-0.21094,0.18931,0.014796,-0.037281,-0.029741,-0.11717,0.15543,-0.146,0.032866,-0.011206,-0.24182,0.067102,-0.15837,-0.032165,-0.099842,0.16501,0.0086719,-0.059729,0.12873,-0.084684,-0.12045,0.056514,0.085788,-0.070353,0.21463,-0.14436,-0.16326,-0.0040134],[-0.0068432,0.091135,-0.30528,0.22199,-0.1372,0.089831,-0.052283,0.21175,0.087196,0.23806,-0.042831,-0.081842,-0.16113,0.025814,-0.13737,0.040398,-0.20285,0.13378,-0.085356,-0.077309,-0.0051454,0.064263,0.023791,-0.037288,0.28577,0.029215,0.15957,-0.07019,-0.008507,0.035566,-0.097722,-0.097395,0.0066635,-0.057324,-0.34109,-0.04541,-0.12779,-0.16923,-0.069763,0.02315],[0.1023,-0.32359,0.19747,0.017777,0.1981,-0.021126,-0.39462,0.13986,-0.032664,0.049528,0.10102,0.18772,0.032804,-0.0088662,0.24845,0.092016,-0.014804,0.21015,0.023669,0.029696,0.10023,0.16141,0.0090237,-0.077834,0.090289,-0.16919,-0.084863,-0.070569,0.14813,0.015612,-0.093793,-0.13395,-0.17241,-0.031279,-0.083646,-0.19608,0.043812,-0.13162,0.02834,0.1685],[-0.22365,0.30063,-0.52907,-0.25221,-0.29899,0.018593,0.20356,-0.11633,-0.08811,-0.15673,-0.32223,0.14311,-0.040108,-0.23042,-0.14303,0.031728,0.2466,-0.10249,0.062947,0.14952,-0.027955,-0.0084106,0.22008,-0.34367,0.14188,0.1123,0.15411,-0.17811,-0.182,0.12989,-0.034933,0.017597,0.32998,-0.18011,-0.34531,-0.010024,0.16063,0.060528,-0.10991,-0.28185],[0.081345,0.055073,0.22099,-0.097039,-0.039568,0.02177,-0.034061,0.026378,0.18504,0.2275,0.000023201,-0.12936,-0.24347,-0.05939,0.029282,0.20736,-0.011171,0.030505,0.17695,0.10121,0.018049,0.16981,-0.15255,0.18336,-0.14724,0.055268,-0.094478,-0.14099,-0.081992,-0.03883,-0.086303,-0.070406,-0.028343,-0.082726,-0.036508,0.093485,-0.15381,0.15428,-0.34514,-0.10421],[0.11192,-0.13471,0.029563,-0.0021052,0.098793,0.22768,-0.22743,0.033467,-0.051239,0.22458,0.16671,-0.012392,0.12708,0.2893,-0.06746,-0.14846,0.16177,0.12528,-0.21574,0.045468,-0.2615,0.417,-0.19924,-0.2123,0.06466,-0.13409,-0.27466,0.16408,-0.13016,-0.17489,-0.16488,-0.37954,0.34065,0.035426,-0.078764,-0.15837,0.1407,-0.14505,-0.191,0.18323],[0.015554,-0.081166,-0.044617,0.28033,-0.025114,0.22659,0.37927,-0.1495,0.10362,0.25901,-0.029705,-0.10994,0.11581,-0.14881,0.10915,-0.14064,0.056651,-0.16104,0.031546,0.089634,0.029357,-0.3384,-0.2184,0.0074543,0.21509,-0.18374,-0.13307,-0.16449,-0.10381,-0.015816,0.10951,0.20742,0.02673,-0.38443,-0.41995,0.020857,0.082382,0.16732,-0.13981,-0.3503],[-0.18872,0.094594,0.036165,-0.030179,0.31286,0.032751,-0.24511,0.26871,-0.21398,0.2705,0.048992,-0.15346,-0.12479,0.1085,-0.090399,-0.16229,-0.1367,-0.23634,-0.15028,0.1886,-0.33532,-0.23887,-0.2743,0.081763,-0.068247,0.11998,-0.060122,0.089735,-0.071748,-0.2416,0.26544,-0.0033483,-0.23812,0.099669,0.11739,-0.20186,0.085721,-0.44485,-0.36306,0.069235],[-0.21227,-0.02744,-0.27354,-0.01518,-0.1986,-0.013416,-0.40055,0.16052,-0.51905,0.079764,-0.30703,0.11201,0.23514,-0.056316,0.37302,-0.32537,0.13871,0.11638,-0.20544,-0.12264,0.20217,0.06462,-0.020004,-0.21704,-0.059464,-0.72612,0.067823,0.22405,0.1166,0.024293,-0.024959,0.29179,0.11297,-0.18281,-0.15608,0.12236,-0.19807,0.20957,0.14513,-0.1887],[-0.16202,0.26032,-0.11283,-0.0053499,0.10947,0.23046,-0.19058,0.0987,0.064421,0.090807,0.21845,-0.12668,0.017133,0.12978,-0.21163,0.0077075,0.011399,0.23267,-0.015034,-0.054694,-0.32682,-0.14317,0.016837,-0.14273,-0.29539,0.12558,0.11056,0.16797,-0.22704,-0.14547,0.15439,0.079995,-0.32434,0.077423,0.29848,0.013843,0.14846,0.10843,-0.042546,-0.01499],[-0.071078,-0.096006,-0.37651,-0.081875,0.079782,-0.023286,0.12073,-0.051947,-0.19212,-0.0091221,-0.20283,0.39666,0.19073,-0.005821,0.071183,-0.03293,0.17832,0.094321,-0.060266,-0.18794,-0.2033,-0.127,-0.0029388,0.0041915,-0.28459,0.012315,-0.16461,-0.074625,-0.0017553,0.12816,0.15777,0.2318,0.29236,-0.29011,-0.28211,-0.21174,0.097034,0.19655,-0.023663,-0.37586],[-0.098149,-0.045584,0.033404,-0.38459,0.28866,-0.13216,0.12826,-0.012705,-0.15411,-0.043758,-0.18852,-0.22176,-0.036259,0.15983,-0.196,0.10954,0.13982,0.15784,0.15878,0.12088,-0.074734,-0.013403,0.040898,-0.099215,-0.027694,0.20972,-0.010859,0.1168,0.0048817,0.18137,0.17323,0.077293,-0.29532,0.058869,0.16775,-0.14987,0.071021,-0.17633,-0.016429,0.11457],[0.0001812,-0.043113,-0.18388,-0.018227,0.13881,-0.067061,-0.078745,0.19074,-0.19991,0.0010711,-0.22938,-0.19762,0.066184,-0.015772,0.13613,0.009888,0.017258,0.23054,0.21871,0.12334,0.057121,-0.1226,0.19422,0.22133,-0.015762,0.29123,0.0039551,-0.15292,-0.13264,0.034854,0.050987,-0.13719,-0.050128,-0.13386,0.1529,0.18992,-0.18063,0.053195,-0.26343,-0.066885],[-0.11663,-0.33734,-0.46529,0.10327,-0.13006,-0.45487,-0.16497,0.18635,-0.13649,-0.043112,-0.48791,0.39642,0.35413,-0.30634,0.14364,-0.26733,0.33537,-0.074486,0.0049043,0.21763,0.13158,0.24918,-0.19165,0.053182,-0.036733,-0.68094,0.18407,-0.039179,0.37573,0.33631,0.070491,0.072715,0.11966,-0.37566,-0.27433,-0.10196,0.014742,0.2342,0.15714,-0.43482],[0.054662,-0.23179,-0.11998,-0.033051,0.13417,0.13302,0.00049253,-0.11912,0.056306,0.022178,0.093836,-0.023084,-0.17172,0.1354,0.10792,-0.21329,0.025707,0.0038656,0.042243,-0.17981,0.06184,0.36839,0.1923,-0.22558,-0.0092116,-0.14739,0.047936,-0.11487,0.052722,-0.091996,-0.15872,-0.27351,0.24848,-0.024629,0.077971,0.081185,0.18826,-0.058746,-0.21005,-0.085412],[0.03264,0.26542,-0.15888,-0.17831,-0.025752,-0.10037,0.10899,0.16597,0.0091519,0.11889,0.11564,-0.14544,-0.036414,0.15012,-0.10084,0.065756,0.062866,-0.043156,0.11941,-0.14501,0.098987,-0.018688,-0.084847,-0.17651,0.053746,-0.051213,0.099177,-0.078749,-0.11889,0.025451,-0.18174,-0.086696,0.00077417,-0.0098799,0.061815,0.032418,0.10593,0.14507,0.072573,-0.18569],[-0.11595,-0.078372,-0.023475,-0.36546,-0.084046,-0.0057201,-0.21611,0.26152,-0.13502,0.10817,0.27728,-0.061965,-0.067592,0.024347,-0.21025,-0.10265,-0.045745,-0.12167,0.15635,0.061112,-0.39354,-0.3616,-0.29812,0.27999,0.090213,0.035465,-0.32218,0.16747,0.028707,-0.11051,0.33951,0.097171,-0.1959,-0.21956,0.12485,0.048133,0.22322,-0.31099,-0.33343,-0.098843],[0.17319,0.0012613,-0.045496,-0.11392,-0.30406,-0.20279,0.13795,0.098792,0.19451,-0.10136,0.133,0.29702,0.35189,0.054192,0.074832,0.088305,0.15996,0.15074,0.1759,-0.20655,0.0917,0.13772,-0.12866,0.2702,0.34659,-0.26075,0.03059,-0.1031,0.012043,-0.007192,0.25116,0.033622,0.02734,0.23736,-0.42956,0.065762,-0.20247,-0.10574,0.093867,-0.29277],[0.050426,-0.44377,-0.49587,0.13636,-0.27586,-0.28877,-0.33294,-0.091834,-0.19617,-0.13233,-0.57177,-0.054602,0.22906,0.11195,0.1934,-0.27334,0.14074,0.098647,-0.090239,-0.10989,0.07628,0.20843,0.18986,-0.37483,-0.18904,-0.38457,-0.0085111,0.056004,-0.026248,0.28689,0.0015963,0.27255,-0.14636,-0.33121,-0.19983,0.096487,-0.02809,0.38191,0.18461,-0.20903],[-0.12927,-0.17222,0.28211,0.23389,0.032055,0.0012049,-0.084185,-0.0081625,-0.05916,-0.024697,0.28932,-0.12427,0.24945,-0.02452,0.060908,0.049739,-0.043325,0.18886,0.1686,-0.027203,-0.17295,0.0094959,-0.047857,0.49872,0.079359,0.11378,0.097438,0.16259,0.046085,-0.07982,0.23234,0.23574,-0.27034,0.14818,-0.055337,0.040524,-0.062009,-0.11153,-0.14904,0.036332],[-0.1889,-0.20765,0.11843,-0.053916,0.17517,0.1321,0.026953,0.080065,-0.033381,-0.06195,0.10738,-0.1997,0.064198,0.31446,-0.2279,-0.26076,-0.0076843,0.045799,-0.18029,0.19977,-0.19887,-0.052856,-0.20818,0.062362,0.13075,0.078001,0.1592,0.20902,-0.23173,-0.015766,0.17545,-0.14507,0.068131,0.11647,-0.058039,-0.077254,0.096867,-0.32313,-0.2489,-0.10531]],[[-0.94513,-0.078996,-0.27707,0.11513,0.32649,-0.32193,-0.72493,0.30692,0.3598,0.57741,0.21374,-0.95174,-0.32638,-0.69638,0.20738,-0.24463,-1.2613,0.35291,-0.3757,0.28006,-0.56129,-0.99011,-0.27684,0.18149]]],\"biases\":[[0.0070037,-0.047525,0.097726,0.031127,0.0066174,0.11216,-0.11238,-0.0092586,-0.00068403,-0.0059573,-0.11934,-0.17186,-0.039144,-0.056859,0.025928,0.046794,-0.12468,0.023239,-0.01123,0.0067584,0.0043453,-0.11985,0.080293,-0.18771,-0.15141,0.025259,0.071035,-0.040077,-0.15254,-0.090746,-0.030549,0.11321,-0.093142,-0.065139,0.080148,-0.00047222,-0.044684,0.049116,-0.14569,-0.1834],[0.051036,-0.050931,0.016286,0.036558,0.016646,0.0066548,-0.10844,-0.11263,0.13541,0.035456,0.099669,0.12827,-0.18696,0.017599,0.024415,-0.040937,0.083672,0.040886,-0.15055,0.14269,-0.134,0.2123,-0.19006,0.062638],[0.06621]]}");


var $03dec46743c950ea$exports = {};
$03dec46743c950ea$exports = JSON.parse("{\"sizes\":[54,40,24,1],\"weights\":[[[0.089526,-0.10058,0.066253,0.18264,-0.000012683,0.96184,-0.43629,0.052145,0.053638,0.26496,-0.24198,0.19249,0.047301,-0.56704,0.19755,-0.17582,0.1957,-0.024005,-0.008056,-0.012169,-0.056106,-0.05713,-0.025098,-0.0085451,-0.067399,0.034405,-0.044444,0.064092,-0.071261,0.046352,0.15295,-0.041593,-0.045999,0.037693,-0.1378,0.11855,0.1895,-0.17557,0.12113,0.007345,0.19024,-0.064633,0.080535,0.079775,-0.059924,-0.036365,-0.0073907,0.0054325,-0.0078991,0.077936,0.12326,0.0099051,-0.025808,0.0098744],[-0.2649,0.10175,0.079334,-0.15319,0.0057177,-0.10994,-0.079388,-0.24316,0.10662,-0.14792,0.026149,-0.096272,0.096445,0.0071811,-0.08265,0.16094,0.13883,-0.010072,0.028334,-0.12203,-0.13939,-0.14734,0.084596,-0.26862,0.24677,-0.087511,0.08107,-0.055305,0.16903,0.15184,0.16298,0.082586,-0.19021,0.27217,-0.025025,0.19046,0.047016,0.070874,0.075785,0.07672,-0.13732,0.18509,-0.026846,0.051911,0.031521,-0.061971,-0.16924,0.090268,-0.10859,-0.12438,-0.10711,0.00071226,0.039465,0.15554],[0.1971,-0.25317,-0.23687,0.003062,0.13088,0.082478,-0.89263,-0.32374,-0.88737,-0.11405,-0.20388,0.1794,-0.049054,-0.13714,-0.22129,0.38279,-0.063487,0.17182,0.096174,0.16753,0.13046,0.129,0.13894,0.18509,0.037943,-0.29343,-0.019025,0.037194,-0.049886,-0.0086167,0.15737,0.065577,-0.16546,0.022571,0.15654,0.041168,-0.077862,0.053415,0.013025,0.12772,-0.062227,0.0035384,0.033472,0.1699,0.14799,-0.013946,-0.022525,-0.021397,-0.0037423,-0.17061,0.1379,0.0012746,0.094927,-0.18118],[-0.11225,-0.001,-0.15505,-0.0068268,0.035943,0.03352,-0.18982,-0.068168,-0.20116,0.15698,0.24358,0.17707,0.10929,-0.41844,0.18922,-0.11226,-0.014833,0.0065063,0.13237,-0.07932,-0.1146,0.10283,-0.10731,-0.073109,-0.033735,0.12995,0.18233,0.023225,-0.21965,-0.27685,-0.08372,-0.021988,0.017773,0.13832,0.13033,-0.071777,-0.11976,0.040931,0.047413,0.13523,-0.013451,0.065387,-0.075642,0.10377,0.043832,-0.091429,0.27909,0.074006,0.11157,-0.0074233,-0.17504,0.031036,-0.12499,-0.13383],[-0.23822,0.53929,0.17806,0.29733,0.011414,-0.82769,0.68174,-0.37943,0.72024,0.094548,0.065665,0.23252,0.017637,0.92718,-0.35416,-0.050123,0.25583,0.18749,0.077816,0.062733,0.17626,0.032898,-0.014013,-0.027263,0.21663,-0.0535,0.026278,0.089087,-0.088027,-0.021714,-0.044322,0.03086,-0.0020312,0.041259,-0.1734,-0.17257,0.16517,-0.14848,-0.17084,-0.093429,-0.014136,0.026803,0.13545,0.082551,0.053803,0.017678,0.047059,-0.037112,-0.087039,-0.13259,-0.17344,-0.025577,0.012081,-0.023185],[0.3102,0.0058961,-0.0053686,-0.20536,-0.073858,0.34927,0.18172,-0.29378,-0.0074109,-0.11461,0.1041,-0.1804,0.24851,0.33044,-0.059681,0.0062242,-0.21958,-0.052067,0.01182,-0.031986,0.18738,-0.025987,0.011705,0.065792,0.028808,-0.0053135,-0.078719,-0.091782,-0.016282,0.0058026,-0.051422,0.14047,-0.073811,-0.00010002,0.12388,-0.13867,0.0057769,-0.093871,0.14867,-0.18541,-0.1273,-0.03878,0.093165,-0.034573,-0.046635,-0.017472,0.054597,0.0023328,-0.039132,-0.066078,0.023153,0.015047,-0.038863,0.069233],[1.3974,0.12939,0.21342,-0.34444,-0.089301,-0.31397,0.33876,-0.34848,-0.16742,-0.058526,-0.2417,0.068387,0.018223,0.8455,-0.025604,-0.26712,0.0056785,-0.096721,-0.045764,-0.11077,0.029627,-0.10673,-0.0027579,-0.032169,-0.051226,-0.00033035,-0.044064,0.012587,-0.04601,-0.0095277,-0.08064,-0.035682,0.024526,0.026816,-0.044344,-0.026526,-0.11876,-0.098328,0.18067,-0.047847,0.11933,0.021428,0.052372,-0.01087,-0.035641,0.023764,-0.054928,0.0058341,0.14815,0.073324,-0.071874,-0.0023953,-0.011296,-0.18945],[-0.0095908,-0.11926,-0.12299,0.014937,0.02043,-0.12573,0.22566,-0.1616,-0.22253,-0.12274,-0.14434,0.14064,-0.053983,0.32286,-0.034201,-0.11725,-0.056352,0.069451,-0.038599,0.1281,0.12425,-0.08703,0.070326,-0.032318,-0.0014016,0.037923,0.19266,-0.0065681,-0.055432,0.059189,0.12103,-0.063603,0.18006,-0.13114,-0.15084,-0.1612,-0.15899,0.10069,-0.12784,-0.03657,0.010464,0.14268,0.13286,-0.17441,0.10643,-0.03518,0.024546,0.045755,0.067334,0.11495,0.053115,-0.054281,0.07494,-0.047997],[-0.057303,0.16065,-0.17831,0.045138,0.081855,0.034525,0.16138,-0.17176,0.0036048,-0.44759,0.25484,-0.10533,-0.09799,0.11886,0.08562,0.10927,0.039459,-0.22023,-0.082682,0.11764,0.12255,0.040711,0.045986,-0.84175,0.50287,0.069681,0.1599,-0.21529,0.30349,-0.24894,-0.089294,0.028193,-0.10262,-0.025948,0.083053,0.19042,-0.087651,-0.025326,0.11096,0.0018287,0.075518,-0.039918,0.45843,0.15679,-0.056168,0.11311,0.041324,0.06616,-0.17422,0.14055,-0.16807,0.057433,0.099961,0.1524],[-0.34524,0.05985,0.21426,0.14409,0.10711,-0.15943,0.43593,-0.0048155,0.37824,0.22587,0.40404,0.15269,-0.0732,0.14614,0.16512,-0.22564,-0.18933,-0.072557,-0.0095482,-0.062996,0.18458,-0.12896,-0.017259,0.052714,-0.067221,-0.043782,-0.038805,0.070249,-0.072391,-0.035709,0.18141,-0.097819,0.044284,0.000069632,0.049376,0.16999,-0.033036,0.08584,-0.085502,0.0042544,-0.19149,-0.029202,0.062934,0.024367,0.095604,-0.011095,-0.04933,-0.0065682,-0.073985,-0.084761,-0.064101,0.043242,0.034538,0.085596],[-0.20129,-0.66635,-0.19054,-0.1258,0.033158,0.46608,-1.1129,0.38156,-1.0326,-0.4038,-0.080589,-0.070807,-0.036656,-0.8498,-0.1598,-0.36091,-0.12098,0.053199,0.07727,0.14689,0.15918,0.20902,0.0098788,-0.14557,-0.15735,-0.028508,0.23207,-0.097777,0.14761,-0.052545,-0.026395,0.014266,-0.13433,-0.026365,0.11795,-0.097691,0.03487,-0.13248,-0.12181,0.13643,-0.14174,-0.11571,-0.11934,-0.093438,0.021785,-0.069588,0.069237,-0.055483,0.081283,-0.17836,-0.025194,0.01683,-0.023456,0.12143],[0.02363,-0.10099,-0.22667,0.0066529,0.037169,0.24959,0.14286,-0.24005,0.19095,-0.34391,-0.0033392,0.24923,-0.17636,0.035738,-0.22478,-0.040164,-0.045989,-0.12164,-0.079063,0.032139,0.018707,-0.0075235,0.049678,0.22299,-0.19532,-0.1212,0.063575,0.014128,0.20857,-0.20473,-0.079113,-0.053612,0.0037481,0.014599,0.0019848,0.1629,0.16976,0.08437,0.079634,-0.037559,-0.032282,0.072233,-0.25108,-0.031941,-0.081268,0.034491,0.036109,0.053164,-0.049329,0.16238,-0.07461,0.004607,-0.037071,-0.033752],[-0.77058,0.11885,0.0541,0.031254,0.17963,-0.11088,-0.024091,0.3399,0.36204,0.5684,0.040242,0.0061683,0.016943,-0.72005,0.068875,0.24042,0.050018,0.23257,0.040687,0.072804,-0.17227,0.039748,0.010942,-0.11131,0.12672,0.010817,0.045217,0.01176,-0.065949,-0.0042397,0.1576,-0.0069697,0.0092782,0.051864,0.1801,0.085516,0.17507,-0.033873,-0.077511,0.1711,0.09059,0.12853,-0.12221,-0.17415,-0.12652,0.025377,-0.038046,0.012934,-0.13369,0.16499,0.14465,0.0051597,0.082186,-0.09617],[-0.34367,0.1515,-0.080151,-0.19804,0.18224,-0.6776,0.0032471,0.17581,-0.01314,-0.17405,-0.32277,-0.035556,-0.14864,0.53799,0.17902,-0.31443,0.18045,-0.042348,0.050899,-0.009204,-0.10641,0.011902,-0.075572,0.0035447,-0.079446,0.071753,0.034117,0.0044976,0.06783,-0.098214,0.12896,-0.20638,0.10991,0.012896,0.043441,0.11791,-0.12844,-0.18544,0.026392,0.074728,0.0011495,0.0279,-0.009394,0.10906,-0.0024539,-0.057032,0.092511,0.037975,0.087321,-0.01314,-0.063811,0.020185,-0.060771,-0.10692],[-0.5597,-0.22411,-0.13991,-0.10445,-0.048788,-0.2511,-0.036186,0.28413,-0.10486,-0.059469,-0.74002,-0.21393,-0.10252,0.29484,-0.02993,-0.29112,0.14771,0.1195,0.22876,0.071655,0.13066,0.091087,-0.025172,0.0032999,-0.21856,0.023099,-0.068256,-0.1731,0.12642,-0.018071,-0.015846,-0.085419,-0.1576,0.044732,-0.0025014,-0.075541,-0.13854,-0.13706,0.12344,-0.16637,-0.079741,-0.0099368,-0.027255,0.093308,0.0014053,-0.071921,0.014198,-0.0049281,-0.0083058,0.033896,-0.099993,0.018617,-0.046902,-0.11976],[-0.24185,-0.5931,0.060933,0.013092,0.090254,0.20568,-1.0114,0.62929,-0.84715,0.21799,0.56112,0.44464,0.071703,-1.0268,0.0035738,-0.3536,-0.086466,0.0011601,0.013044,0.11282,0.080626,0.063303,-0.0034972,-0.046077,-0.099607,0.040207,0.017774,-0.0048775,0.016158,0.011723,0.10823,0.031221,-0.10795,0.055492,-0.16513,0.10736,0.078884,-0.17744,-0.18631,-0.044886,0.074068,0.15752,-0.029517,0.033413,0.00059013,-0.012222,0.0031383,-0.010704,-0.012684,-0.098123,0.20477,-0.0088857,-0.044293,0.079804],[0.28496,0.17156,-0.15634,0.033709,0.0014132,-0.6803,0.444,-0.42063,0.87857,0.61555,-0.49345,0.50515,-0.059168,0.82544,0.032775,0.28094,0.1331,0.10805,0.084954,0.0056976,-0.10948,-0.074084,-0.068684,-0.22577,0.045182,-0.075253,-0.068996,-0.000079832,-0.023534,-0.067641,0.1819,-0.050772,0.026814,0.024652,-0.028211,-0.055206,0.09362,0.099197,-0.14849,0.0057426,-0.13457,-0.18185,-0.064347,0.084489,-0.097222,0.063625,-0.013467,-0.024864,0.054619,0.0022425,-0.0047504,-0.016897,0.031276,0.014989],[0.36819,0.29075,-0.36335,0.16633,-0.048439,0.57242,0.4622,-0.52852,0.9283,0.029359,-0.59367,0.046912,-0.072342,-0.079432,-0.11527,0.041392,0.18071,0.048079,0.082527,0.021202,0.095077,-0.11898,-0.024224,-0.25673,0.34386,-0.046948,-0.099914,-0.11204,-0.010696,-0.118,0.017714,-0.43942,0.36112,-0.077503,-0.083695,0.12971,-0.085811,-0.053584,-0.084145,-0.094856,0.055926,-0.087392,0.1716,-0.024732,-0.11939,0.06797,-0.036556,-0.034634,0.060338,-0.035917,-0.20208,-0.037975,-0.032216,0.0012796],[-0.39081,-0.15461,-0.19286,-0.076602,0.090707,-0.081809,-0.6548,0.16686,-0.59858,-0.39326,-0.15564,-0.18213,0.043516,0.26576,0.014875,0.28093,-0.083107,0.031232,-0.17723,0.099039,0.17514,-0.028954,0.10651,-0.037075,-0.11867,-0.13927,-0.057356,-0.01931,0.013021,-0.13878,0.15195,0.12557,0.0081118,0.049488,-0.039813,-0.097254,-0.02831,-0.11886,0.089072,-0.15827,0.050097,0.045472,-0.070087,0.075645,-0.0094011,-0.088115,-0.06035,0.24004,-0.064672,0.02899,0.1199,-0.081662,0.041696,0.054619],[-0.025493,0.11814,0.015161,-0.15827,-0.038061,-0.11659,-0.10361,-0.054876,0.058629,-0.023417,-0.10673,0.066144,-0.026188,-0.16261,-0.1671,-0.059756,-0.087022,-0.043324,0.11413,0.12949,0.18656,-0.18304,-0.088186,-0.056212,0.029994,-0.028311,-0.1206,0.03535,0.041298,-0.17532,0.10647,0.19201,0.17168,-0.033345,-0.047944,0.16491,0.13763,-0.066467,0.069596,0.093989,0.17242,0.11286,0.16247,0.10527,-0.15725,0.01024,0.031205,0.16935,0.12967,0.057611,0.089437,-0.017643,-0.039722,-0.082366],[-0.14247,0.071314,-0.053564,-0.062562,0.096119,-0.18293,0.1579,-0.16571,0.12379,0.164,-0.097804,0.055432,-0.040241,-0.11632,0.026592,0.039012,-0.096626,0.1014,-0.094572,0.01915,-0.15507,-0.13317,0.16344,0.060687,-0.023866,-0.0004783,0.17377,-0.027129,-0.14509,-0.062808,0.063327,-0.12116,0.13288,-0.12443,0.0018562,-0.17984,0.15667,-0.11845,0.12352,0.0078851,-0.091325,0.018465,-0.17498,0.12778,-0.056245,0.11718,-0.1495,0.014887,-0.060432,0.11905,-0.15424,-0.14283,0.13817,0.024516],[0.03212,0.51454,0.21711,0.358,0.078461,-0.30512,0.45038,0.21059,0.21074,-0.23044,0.35622,-0.070188,-0.06655,0.0083276,-0.23336,-0.5807,0.15086,0.12864,-0.029939,-0.010302,-0.12143,-0.088388,-0.076103,-0.19147,0.12792,0.040738,-0.0081674,0.028457,0.019331,-0.077534,0.0085868,-0.027585,-0.05808,-0.00496,-0.13228,-0.091698,-0.010915,0.016402,-0.10436,0.057042,0.19812,0.19118,0.10359,-0.11469,0.053621,-0.092752,0.010367,0.025262,-0.17861,-0.18234,0.17373,-0.028839,-0.083407,0.071241],[-0.53225,-0.13894,-0.11542,0.17044,0.14765,-0.69533,0.20249,0.14406,0.1381,0.39268,0.4213,-0.33346,-0.053182,-0.026661,-0.25866,0.54915,-0.16842,0.10973,0.019908,0.0072543,0.16225,0.10559,0.033924,0.12036,0.027935,-0.010372,-0.01407,-0.073855,-0.013158,0.067666,0.11988,0.046085,-0.013026,-0.0013985,-0.00030139,-0.050585,-0.075346,0.089005,-0.024744,0.020285,-0.11719,-0.035629,0.015116,-0.01492,0.018765,-0.0044685,-0.078808,-0.025228,-0.082496,0.18768,-0.047502,-0.0080426,0.035206,-0.1612],[0.14084,-0.17347,-0.25085,0.1918,0.065884,-0.10091,-0.12841,-0.015354,0.3247,0.1282,-0.49046,-0.014059,-0.04795,-0.093191,-0.19945,0.051487,0.12341,0.13978,-0.12908,-0.10134,-0.0020061,-0.11215,0.0041609,0.18311,-0.081387,0.096817,-0.091803,0.004395,-0.62515,0.12309,-0.12846,0.090439,0.072794,0.11312,0.16817,-0.018558,-0.050082,0.1175,0.05002,0.079723,-0.12836,0.18427,-0.11807,-0.10131,0.18365,-0.037974,-0.17831,-0.035597,-0.0883,0.03991,0.16895,-0.040284,0.025063,0.07656],[-0.42102,0.2579,0.13323,-0.11389,-0.1626,-0.010767,0.083142,0.33336,-0.37858,-0.80201,-0.070045,0.34309,0.037268,-0.10483,-0.050391,-0.75453,0.14438,0.12934,0.056177,0.1749,-0.066416,0.13792,-0.15023,-0.11708,-0.069094,-0.0017337,0.15463,0.0066146,0.033038,-0.022114,-0.065103,0.017347,0.0014856,-0.070345,0.08362,0.16742,0.077584,0.084224,0.1597,-0.04078,-0.13479,-0.09348,0.096026,0.096913,0.11346,0.02404,-0.066977,-0.0065879,0.095519,0.060528,-0.11342,-0.012596,-0.038539,0.014214],[-0.040934,-0.092768,-0.10605,0.025302,-0.17241,-0.033593,-0.22036,-0.062263,0.11118,0.19396,0.051009,-0.049848,0.06932,-0.19814,-0.004671,-0.29741,0.1471,-0.023604,0.18127,0.062617,0.10578,-0.17147,0.031461,0.20624,-0.19131,0.0084196,-0.13853,-0.17302,-0.012838,-0.007428,-0.15888,0.14096,-0.046326,0.037225,0.1314,-0.029204,0.026115,-0.085441,-0.17351,-0.14046,0.091721,-0.018926,-0.17863,-0.12944,0.082381,-0.042206,-0.024541,-0.023104,0.10375,-0.17963,0.03829,0.26588,-0.097533,-0.035792],[-0.094889,0.22353,-0.097537,-0.055718,0.0076105,-0.1146,0.024122,0.04699,-0.17533,0.12552,-0.62316,-0.46596,0.16194,0.22544,-0.27306,-0.01658,-0.19282,-0.0093708,0.026331,0.049411,0.086519,0.12884,-0.032416,0.14934,-0.19332,0.0081515,-0.10512,-0.14243,-0.066846,0.16919,-0.058624,-0.23352,0.22369,0.0054996,0.013423,0.16376,-0.17917,-0.018642,0.17098,0.012945,0.077966,-0.17209,-0.16699,-0.063514,-0.11288,-0.14403,-0.12947,0.073068,-0.089792,-0.132,0.10809,0.010958,-0.063223,0.18618],[-0.394,0.13683,-0.10065,-0.19586,0.11128,-0.009868,-0.089287,0.39534,-0.10659,0.058637,-0.22587,-0.41022,0.12126,-0.23817,-0.3403,0.058132,0.066619,0.060356,0.00087659,-0.072236,-0.11326,0.0075929,-0.02476,0.1877,0.054776,0.10356,-0.041026,-0.12436,0.12938,-0.013851,0.18874,-0.11005,-0.13729,-0.01121,-0.017395,-0.096095,0.18635,0.16922,-0.17292,0.14882,-0.15942,-0.014995,-0.026345,-0.20022,0.010742,-0.061147,-0.087842,0.047889,-0.036246,-0.067866,0.15314,-0.0017268,-0.01564,-0.18188],[-0.083904,-0.03784,-0.1887,0.035295,-0.057196,-0.090197,0.13072,-0.11535,0.024119,-0.12585,-0.039477,0.14338,-0.1443,-0.1841,-0.16736,-0.035635,0.096671,0.047947,0.10678,0.10667,0.11471,0.046702,-0.024974,-0.2051,0.18559,-0.12689,0.036076,-0.091366,0.10255,-0.12053,-0.049963,0.12703,0.026223,0.15831,-0.075289,-0.039879,0.062606,-0.016618,-0.021046,0.052387,0.094446,0.090739,0.017879,0.090175,-0.14285,-0.12777,-0.15184,0.077667,0.082836,0.034093,-0.10158,0.069853,-0.010071,-0.080308],[-0.36892,0.34255,0.0030582,0.25475,-0.073164,-0.10972,0.36881,0.041174,0.33266,-0.042419,-0.17177,-0.142,0.0027155,0.14431,-0.008688,0.11877,-0.068502,-0.025923,-0.012769,0.19228,0.066069,-0.054823,0.1059,0.0077105,-0.01286,-0.14415,0.033219,-0.21424,0.19386,-0.6877,-0.028004,0.040544,0.057559,-0.13669,0.16233,-0.063279,0.062203,0.04459,0.0065535,-0.0097305,0.2033,0.12862,-0.20389,-0.070312,-0.022926,-0.1059,-0.047195,-0.030854,-0.1651,-0.052091,0.1672,0.058642,0.011664,0.044554],[-0.60847,-0.01658,-0.30515,0.19247,-0.17685,0.16467,-0.23086,0.10076,0.29173,0.29413,0.57783,-0.052649,0.0046552,-0.097386,0.16735,-0.16518,-0.18266,-0.030186,-0.081144,-0.011462,0.096693,-0.013874,-0.001153,-0.052825,0.026029,-0.015932,0.10658,0.026037,-0.069359,0.0087546,0.0012052,0.058166,-0.067084,0.077214,-0.18627,0.0089409,-0.10162,0.061166,-0.027673,-0.14293,0.10403,0.061174,0.05372,-0.1324,0.094365,0.094803,-0.048843,-0.053814,0.18211,0.15591,-0.036305,-0.0080614,0.025298,-0.13971],[-0.077848,-0.058156,-0.068956,-0.029388,-0.18824,-0.057175,0.068178,-0.060019,-0.1568,0.057084,-0.13267,0.13465,0.22714,0.18573,-0.048153,-0.13488,-0.078063,-0.10068,-0.054997,0.059962,0.056161,0.026645,-0.077519,-0.059873,-0.18226,0.14711,-0.0029422,-0.059019,-0.098858,0.069915,-0.18587,-0.10495,-0.1377,-0.026514,0.13639,0.050346,0.11768,-0.14001,-0.05567,0.038359,0.11783,0.049435,-0.076951,0.059511,-0.15536,-0.001019,0.1815,-0.065607,0.18352,0.19223,-0.14487,-0.049192,-0.18669,0.17407],[-0.48283,-0.090559,-0.084262,0.0063444,-0.08298,-0.048589,-0.099341,0.083493,-0.2122,-0.36045,0.1453,-0.095106,-0.15624,0.33182,0.67669,-0.48025,-0.123,0.15592,-0.017766,0.11567,0.15157,0.12389,-0.023594,-0.01304,-0.051734,-0.020868,0.15338,-0.0066624,0.033578,0.0043396,-0.019199,0.014104,-0.017083,0.0071417,-0.12794,-0.16883,0.082432,-0.17763,-0.098868,0.13313,-0.18606,-0.087148,-0.088662,0.054076,0.082885,0.057511,0.014996,-0.01561,0.18519,0.015659,0.09068,0.0041548,0.0097808,-0.17269],[0.36325,-0.36641,-0.08191,-0.36336,0.16093,0.18741,-1.0267,-0.12323,-0.76927,-0.2313,-0.0003489,-0.39858,0.10774,-0.23616,-0.017049,-0.11007,-0.16818,-0.083032,0.0013776,-0.013993,0.025608,0.11012,0.10857,0.0064171,-0.14119,-0.089299,0.092098,-0.052118,0.10486,0.054346,-0.085325,0.061174,-0.032209,-0.01439,0.06139,0.11199,0.048126,-0.033064,0.1092,-0.14199,-0.17701,-0.13252,0.015525,-0.061757,-0.0072777,-0.061128,0.032942,-0.0022347,-0.14752,0.073547,-0.11982,-0.0071554,-0.047565,-0.032791],[1.1241,-0.33811,0.073057,-0.57921,0.01907,-0.28895,-0.79617,-0.16501,-1.2462,-0.065768,0.12881,-0.095344,-0.045587,1.1198,-0.16646,-0.11946,-0.162,-0.22246,0.016611,-0.13817,0.068004,-0.017315,0.037012,0.0082398,-0.12999,0.014802,-0.14522,-0.049788,0.12935,0.052465,-0.093419,0.025548,0.028384,0.0015593,0.029332,0.02219,0.057296,-0.11279,-0.048925,-0.047459,-0.22306,-0.098105,0.0042344,-0.080362,-0.0088076,-0.038702,-0.065678,0.035125,0.01682,-0.095698,0.093741,-0.024798,0.022669,0.17014],[0.1371,0.058488,-0.19659,0.15139,0.099486,0.091263,-0.12117,-0.19034,0.067859,0.14466,-0.11528,-0.27333,-0.19323,-0.23892,0.19957,0.13047,0.14399,0.18528,-0.086988,-0.039563,0.16752,-0.050127,-0.15995,0.061115,-0.07693,-0.23501,0.0024742,-0.093865,-0.076219,-0.088238,-0.14105,0.11712,0.15244,-0.094249,-0.13697,-0.018587,-0.11263,-0.0016182,0.012516,0.018283,-0.066683,-0.053121,-0.067687,0.11129,0.13761,-0.10969,-0.057633,-0.00097719,-0.048238,-0.16127,0.009355,-0.018281,-0.15921,0.14776],[-0.1755,0.043201,-0.03008,-0.026231,0.041806,0.25181,-0.13344,-0.18006,-0.1218,0.14375,-0.24536,-0.089095,0.00097501,0.20049,-0.047258,0.052585,0.049021,-0.12097,0.12136,-0.0039581,0.014626,-0.075632,-0.21007,-0.28733,0.37159,0.084727,-0.0058544,-0.017357,0.14084,0.0037578,-0.18072,0.00037229,-0.37369,0.20961,-0.14733,-0.15015,-0.15863,0.026084,-0.10885,0.1145,-0.16446,-0.029948,0.055963,0.024102,-0.16264,-0.026097,0.052891,0.019492,-0.0045023,-0.15791,0.076241,-0.0023201,0.18279,0.10273],[0.047437,0.038722,-0.15147,0.0048193,0.16455,-0.032631,0.21604,-0.097431,-0.0047171,0.11933,-0.16544,0.00097635,0.1636,0.083279,0.0021129,0.18768,-0.11222,-0.1788,-0.16303,-0.059263,0.04792,-0.16604,0.13981,0.086382,-0.32877,0.16099,-0.026161,-0.17688,0.1907,-0.76222,0.0016996,0.097181,-0.070483,0.062498,0.0032464,-0.17476,0.16049,0.14511,-0.07796,0.17613,0.20493,0.044393,0.077405,0.056683,0.13444,-0.17299,0.0090215,-0.011997,-0.18774,0.18692,0.15236,0.0028975,-0.0075598,0.18342],[1.1775,-0.16218,0.60021,-0.16837,0.070842,0.34834,0.10436,-0.22052,-0.35618,0.22192,0.39788,0.12504,0.17077,-0.42105,0.037,0.062578,0.13767,-0.22193,-0.15866,-0.20805,-0.12796,-0.23568,-0.028284,0.032453,-0.069955,0.00078385,-0.044835,0.015238,-0.044437,-0.0082686,-0.17199,0.0074751,0.068272,0.092041,0.047714,0.085058,0.081168,0.18727,-0.038636,-0.19626,-0.0015057,-0.065413,0.044276,0.04117,0.076404,0.063523,-0.052736,-0.0059812,-0.17693,0.071381,-0.11373,-0.017368,0.010663,-0.085358],[-0.12391,0.12068,0.054652,-0.16052,-0.15928,0.08128,-0.13254,0.013007,0.04681,-0.15031,0.25036,-0.003456,0.025981,-0.16953,0.041382,-0.01544,-0.063471,0.031158,-0.13718,-0.19834,-0.14354,-0.1705,0.10486,-0.071352,0.13638,-0.0809,-0.11236,0.17113,-0.17642,0.06563,0.017038,0.029666,-0.13116,-0.12495,-0.15937,0.12794,-0.17472,0.050892,-0.10003,-0.18012,-0.14411,-0.11639,0.0653,0.12615,0.17941,0.062421,-0.1709,-0.040105,0.008007,0.049453,0.034945,-0.016225,0.12083,-0.13223]],[[-0.28107,0.13746,0.0023206,-0.031932,-0.26313,-0.12123,-0.0032794,-0.0066094,0.21164,-0.22899,-0.077317,0.14822,0.28838,0.16087,-0.41091,0.44861,0.31117,-0.21225,-0.068337,-0.16895,-0.19911,-0.017834,0.048448,-0.076682,-0.34285,0.071449,0.013445,-0.082205,0.14972,0.038614,0.070306,-0.0031682,0.20065,-0.055079,0.038054,0.13233,-0.12143,0.0027025,-0.22556,0.14312],[0.096371,-0.23528,0.055296,-0.13499,-0.30654,-0.039933,0.076378,0.13213,-0.24471,-0.082739,0.12889,-0.066394,-0.26895,-0.41279,-0.2396,0.087304,-0.15646,-0.3298,0.016824,-0.10868,0.054134,-0.099786,-0.043773,-0.099423,-0.20642,-0.024108,0.033769,0.036013,-0.19114,-0.18224,0.018827,0.057372,0.19599,0.19974,0.11216,-0.074751,-0.0082524,-0.34831,0.013426,-0.11724],[-0.2177,0.013119,0.10566,-0.19872,-0.066479,-0.17504,-0.017101,-0.067135,-0.047748,-0.22301,0.12496,-0.16034,-0.19675,0.075639,0.0030132,-0.18843,-0.14064,0.082107,0.23109,-0.22037,0.14813,-0.21886,-0.19548,-0.15958,0.011498,0.127,0.088627,0.0085621,0.19944,-0.013954,0.064434,0.17694,-0.085841,0.014956,0.013357,0.14213,-0.20624,0.036993,-0.063715,0.15622],[0.054059,0.061158,0.16683,0.045949,-0.30302,0.08877,-0.34482,0.068055,-0.067249,0.18787,0.20542,0.059126,-0.089496,0.072721,-0.0066073,-0.14314,-0.30751,-0.015057,0.038204,0.11145,-0.20489,0.032632,-0.11447,-0.00092655,0.13331,0.1961,-0.26758,-0.12834,-0.10986,-0.11637,0.15425,-0.15782,0.1314,0.16671,-0.27835,-0.16288,0.03145,-0.19446,0.10742,0.16153],[-0.0059095,0.20787,-0.10598,-0.020913,-0.17652,-0.034659,-0.047424,0.051074,0.028504,0.056383,0.052648,0.0186,-0.19835,-0.20643,-0.15884,-0.089888,-0.066005,0.19218,0.16456,0.047966,0.19499,-0.17758,0.15885,0.20473,0.057309,0.14908,-0.038079,-0.12138,-0.058519,0.15632,-0.070211,-0.11258,0.12562,-0.019867,-0.17894,-0.0031172,0.086296,-0.04282,-0.15585,0.031029],[-0.087325,0.10408,0.0078769,0.06089,0.060955,0.013792,-0.28279,-0.034999,-0.050931,-0.049447,-0.42675,0.20056,-0.094047,-0.054022,-0.32726,-0.030434,-0.14934,0.21985,-0.111,-0.072852,-0.14793,0.050663,0.085521,0.042798,-0.1891,-0.039818,-0.2641,-0.31524,0.11661,0.28095,0.27637,-0.10033,0.034446,0.16946,-0.23655,0.22492,0.13361,0.29075,-0.5575,-0.16004],[-0.11519,-0.27519,-0.016896,0.074767,-0.2927,-0.13593,0.047217,-0.18785,-0.32679,0.13549,0.07849,-0.046548,-0.076553,0.18791,-0.0033883,-0.017686,0.14532,-0.12743,0.089528,0.0029854,0.16314,0.16544,-0.27797,-0.23273,0.059916,0.14887,0.17397,0.065079,0.09085,-0.026827,-0.0011046,-0.09017,0.15002,-0.11397,0.10334,-0.19499,-0.29326,-0.21814,-0.10372,0.10101],[-0.088471,-0.17786,0.1496,-0.13692,-0.064399,-0.34117,0.021821,-0.0004276,0.065284,0.043167,-0.44106,0.11137,0.16964,-0.36326,-0.30879,0.1942,0.35376,0.024939,-0.14029,-0.2191,-0.19454,-0.3718,0.27048,0.23287,-0.70234,0.0023887,-0.0058203,-0.21668,0.20622,0.021144,0.33924,-0.054676,-0.14361,-0.077098,-0.43327,0.33571,0.072607,0.14871,-0.64524,0.020423],[0.0449,-0.22665,-0.012239,-0.022399,-0.062102,0.010714,-0.3694,-0.12152,0.073018,-0.13675,0.087069,-0.20548,0.2678,0.2117,0.14294,-0.084219,-0.16021,0.20984,0.0064827,0.1454,0.076276,-0.11662,0.16484,0.069681,0.012026,-0.18166,-0.15112,0.19558,-0.14174,0.32168,-0.027775,-0.1274,0.077384,-0.22204,-0.17022,-0.0031713,0.18333,0.11375,0.095125,-0.15116],[-0.22702,0.17066,-0.002358,-0.17022,0.29984,-0.34988,0.29772,-0.24043,0.19339,0.12491,0.011833,-0.12579,-0.19067,-0.011988,-0.054987,-0.31887,0.19688,0.055483,-0.12349,-0.0060698,0.05103,0.17265,0.093896,0.1391,0.091328,-0.1004,-0.094774,0.11522,0.16142,0.038955,-0.014541,-0.18926,-0.24957,-0.25138,0.054438,0.16874,-0.092006,0.14825,-0.029025,-0.12495],[0.21448,0.082632,0.1052,-0.12238,-0.20291,-0.13903,-0.099219,0.02735,-0.08564,-0.091581,0.1018,-0.23441,-0.20928,-0.18187,-0.15545,0.025533,0.060891,-0.29663,0.15779,-0.22364,-0.03139,-0.21116,0.0061106,-0.17135,-0.25803,-0.033623,0.11173,0.10883,-0.13492,-0.188,0.073219,-0.079721,0.037725,0.0073757,0.083537,-0.11655,-0.0076682,-0.06013,0.099156,-0.27575],[-0.22352,0.059383,-0.136,0.089966,-0.067228,-0.19409,-0.23057,0.13666,-0.25018,-0.21614,-0.066004,-0.097307,0.047204,0.16914,-0.01902,0.021847,-0.20039,-0.1625,-0.063424,-0.024669,-0.20666,0.018982,-0.26384,-0.099668,-0.028666,0.18001,-0.10475,0.12039,-0.19767,0.21624,-0.24778,-0.068141,0.10629,-0.13983,0.012407,-0.23371,0.044185,-0.17131,-0.046611,-0.096616],[-0.10067,-0.033583,-0.19356,-0.21005,0.20114,0.17795,0.31975,-0.14896,0.16502,-0.21376,-0.35844,0.20874,-0.40843,-0.10179,-0.12616,-0.32434,0.22002,0.36657,-0.075237,0.072771,0.20153,0.051723,-0.15707,0.23542,0.24752,-0.30781,-0.16545,-0.17466,-0.18977,0.19512,-0.19591,0.15235,0.032911,-0.52587,0.05852,0.019507,0.36181,0.11951,0.17821,0.2128],[0.052721,-0.21136,0.68766,0.074669,-0.41452,-0.12929,-0.19107,-0.064107,0.0023389,-0.22849,0.28199,-0.00088083,-0.18432,-0.18908,-0.08782,0.30163,-0.41995,-0.025993,0.24213,0.17307,0.014442,-0.46197,-0.050891,0.15851,-0.025673,-0.064829,-0.44593,-0.15305,-0.0077736,-0.36045,-0.15785,-0.10057,0.056767,0.11504,0.2224,0.076707,0.073376,-0.039311,0.012426,0.11208],[-0.72092,0.091394,-0.15949,-0.09642,0.38173,0.15504,0.029019,0.0388,0.046621,0.18751,-0.23189,0.05002,-0.19459,-0.010361,0.13869,-0.0077954,0.097828,-0.081009,-0.23794,0.061965,-0.1638,-0.013043,0.16201,0.031738,0.18567,-0.12546,0.044637,-0.34727,-0.048764,0.069534,-0.28925,-0.16572,-0.12704,-0.14239,-0.0076967,-0.044437,-0.13901,-0.2231,-0.61407,0.17527],[0.10422,-0.13396,0.056283,-0.22277,-0.020247,0.17156,-0.15252,0.070472,0.030881,-0.14333,0.021748,-0.010783,0.0051571,0.19836,0.027379,-0.13664,-0.11906,0.22572,-0.22875,-0.025254,0.11274,-0.056297,-0.22544,0.26412,-0.082724,0.15819,-0.07429,-0.20103,0.022246,-0.21518,-0.090039,-0.0086886,0.20284,-0.13161,-0.32078,0.16326,0.058742,-0.084837,-0.069803,-0.052634],[0.11284,-0.036374,0.345,0.18208,-0.45372,0.11367,-0.83895,-0.30697,-0.13353,-0.058547,0.15841,-0.2593,-0.0065809,-0.51131,-0.07293,-0.023278,-0.53144,-0.25837,0.16185,0.2052,0.11392,0.026438,-0.52862,-0.17056,-0.053035,0.049093,-0.37699,-0.2354,0.015568,-0.1918,0.32412,0.0033763,-0.11076,0.10888,0.031466,0.1181,-0.33585,-0.21184,-0.33949,0.020605],[-0.20182,-0.22178,0.22785,-0.029231,0.2281,0.10014,0.48243,0.19743,0.00004418,-0.011017,-0.13822,-0.12423,-0.1677,0.29979,0.16718,-0.097942,0.1787,0.23237,-0.048634,0.16978,-0.052378,-0.12321,0.15517,-0.16755,-0.31063,-0.0071448,0.20846,-0.2833,0.011051,-0.11748,-0.15329,0.041517,0.083787,-0.012474,0.089359,-0.20712,-0.23281,-0.3397,-0.068567,0.19725],[0.069318,-0.11127,0.36951,-0.14743,0.1402,0.111,0.62948,0.15153,-0.17502,0.33068,-0.10202,-0.041143,-0.31049,0.16881,-0.09644,-0.23743,0.25257,0.018064,0.14384,0.19305,0.1753,-0.077261,0.021706,-0.2162,0.026534,-0.17127,0.12551,-0.01528,-0.19631,-0.23506,-0.1407,0.28067,0.19937,0.17536,0.10535,-0.21599,-0.21137,-0.082317,0.34301,-0.19993],[-0.078762,-0.058464,0.18219,-0.0065351,0.037298,-0.077632,-0.24146,0.087679,-0.041213,-0.23906,0.03798,0.061478,0.050479,0.16826,0.088225,-0.17116,-0.13627,0.10229,0.17361,0.13429,0.11812,0.046272,-0.17195,-0.12994,-0.036273,-0.03959,0.0014313,0.22741,-0.10692,0.055057,0.095298,-0.0060137,-0.13248,-0.1272,0.034022,-0.032694,-0.022813,-0.024083,-0.10249,-0.14668],[0.26295,0.11801,-0.19392,0.0080923,-0.28248,0.00074706,-0.33569,-0.018889,-0.12029,0.20348,-0.17536,0.011283,0.20289,-0.22737,0.062428,-0.1073,0.11778,0.40168,-0.16125,0.1318,0.001844,-0.42326,0.29161,0.14211,-0.32157,-0.18877,0.31695,0.21586,-0.033786,-0.028807,-0.21469,-0.27005,-0.42312,-0.3129,-0.37263,0.015259,-0.058698,-0.053175,-0.19342,0.070683],[0.148,0.016054,-0.10074,-0.20015,0.21435,-0.0059011,-0.0078903,-0.12132,-0.076438,-0.2037,-0.10965,0.082637,-0.3581,-0.19585,-0.27727,-0.39563,0.037058,0.12439,0.023767,0.12676,-0.049261,-0.062405,-0.22457,0.17167,-0.038092,0.045216,-0.31083,-0.35696,-0.18902,-0.14338,-0.11372,-0.0095834,0.25546,0.023552,-0.44895,0.14119,-0.11967,-0.14076,-0.28421,-0.13195],[-0.15935,-0.1249,0.068633,0.14311,-0.11029,0.13743,-0.17899,-0.097745,-0.13944,0.0047862,-0.030457,-0.020119,-0.16277,0.048231,-0.033694,-0.15436,-0.077675,-0.22058,-0.20895,-0.075106,0.22012,-0.20775,0.10238,-0.047521,0.075257,0.09121,-0.010436,-0.21801,0.15371,-0.026353,0.13311,0.12195,0.087325,-0.19634,-0.20816,-0.060248,-0.078414,0.18861,-0.0517,0.097326],[0.15037,0.0034623,0.019767,0.0416,0.12977,-0.13799,-0.17857,0.22337,0.0020389,-0.18192,-0.008828,0.24611,-0.06026,-0.055424,-0.15077,-0.19046,-0.11758,-0.09681,0.06131,-0.1439,-0.0044582,0.085186,0.10067,0.2439,-0.2189,-0.17695,0.017856,0.057566,0.13291,0.0039802,-0.20259,0.07323,-0.36056,-0.37009,-0.33464,0.034507,-0.061788,0.21385,0.10144,0.032452]],[[0.66616,-0.36578,-0.21301,-0.3362,-0.12622,0.7679,-0.23495,1.0061,-0.4113,0.68225,-0.27487,-0.28053,0.63919,-0.769,-0.87744,0.42763,-0.66117,-0.49043,-0.66758,-0.16177,0.74141,0.85702,-0.27245,0.54588]]],\"biases\":[[-0.16474,-0.1082,0.24245,-0.072076,0.17148,-0.12795,-0.27491,0.046504,-0.078595,-0.15994,0.39164,0.075424,0.10387,0.2862,0.23572,0.038287,-0.014315,-0.0065451,0.17532,-0.0038121,-0.017061,0.056043,0.036818,0.089819,0.23241,0.015245,0.21591,0.1478,-0.026293,0.055672,-0.1665,0.03565,0.062982,0.23461,-0.08973,0.10097,-0.13248,-0.045425,-0.58615,0.056527],[-0.029657,0.19615,0.11452,0.012568,-0.025308,0.11597,0.057191,0.13563,-0.19703,-0.06329,0.098952,0.14751,0.092418,0.058565,0.080605,0.01085,0.25571,0.016436,-0.14219,-0.016133,0.090116,0.087296,-0.058081,0.1328],[1.0331]]}");


var $a042a931c6c31b48$exports = {};
$a042a931c6c31b48$exports = JSON.parse("{\"sizes\":[54,40,24,1],\"weights\":[[[-0.90579,-0.03588,0.5015,0.40681,0.12698,-0.29831,0.097356,0.13294,0.55703,0.51776,0.56692,0.064112,-0.14822,0.0099076,0.60317,-0.38392,0.15925,0.0059966,-0.044471,0.0084061,-0.15292,0.12617,0.18258,-0.17389,0.36986,0.0030102,-0.10525,0.096386,0.29581,-0.02084,0.14839,0.034362,0.033946,0.068098,0.15293,-0.0020217,0.020818,-0.18556,-0.17013,-0.175,0.029401,-0.017028,-0.1048,-0.14695,0.043219,0.012858,0.11466,-0.005079,0.016631,0.085436,-0.166,0.0882,-0.0042314,0.12066],[0.50582,-1.2766,-1.8043,-1.0131,0.08024,-0.416,-0.18795,0.079461,-1.1329,-0.55758,-0.41818,-0.81723,-0.15223,0.58929,0.62976,0.094731,-0.85896,-0.74178,0.34225,0.42318,0.055854,0.096015,-0.34168,0.35178,-0.3346,-0.063775,-0.079693,0.021517,-0.564,-0.081473,0.019201,0.21285,-0.038637,-0.13957,0.095765,-0.0054497,-0.049177,-0.025838,0.22589,-0.13248,-0.011827,-0.16526,0.055974,0.024341,0.18485,-0.10397,-0.14557,-0.024753,-0.11546,-0.13786,0.14172,0.092858,-0.0065586,-0.16519],[-0.028875,0.49942,-0.36502,-0.053852,0.11435,-0.053655,0.022243,-0.068936,-0.0060009,-0.55153,0.13627,0.38737,0.18445,0.029566,0.058815,-0.34285,0.13185,0.28973,-0.21358,-0.19394,0.13781,-0.23235,-0.15424,0.09968,-0.10552,-0.17329,0.088811,0.10203,0.34833,-0.16419,-0.012583,0.069697,-0.5681,0.13283,-0.09444,-0.027226,0.13738,-0.13638,-0.095982,0.026555,-0.1069,0.10625,0.11914,-0.032502,0.12682,0.00083175,0.0037194,0.09186,0.09766,-0.14706,0.17413,0.049139,0.16652,-0.10694],[-0.38434,-0.12369,0.15715,0.39668,-0.050637,0.00070255,-0.11287,-0.011836,0.012579,0.24355,-0.39485,-0.091704,-0.11411,0.064774,-0.19176,-0.47541,-0.17264,0.10419,0.16426,0.012034,-0.010113,-0.12702,-0.019805,-0.47902,0.10425,-0.17661,0.067186,-0.1533,0.49867,0.71518,0.084004,-0.10007,-0.060935,0.069041,-0.076786,-0.035109,0.16825,0.091668,0.10446,-0.076761,-0.0084194,-0.1585,-0.10819,-0.11371,-0.18152,0.13428,0.25505,-0.025258,-0.098548,0.13448,0.14015,-0.026275,0.020106,0.15145],[-0.24598,0.086115,0.069828,-0.01473,-0.011043,-0.43285,0.33166,-0.016661,0.22117,0.42072,0.56064,0.050976,-0.04971,-0.19782,0.45427,0.37491,-0.047626,-0.18701,-0.052927,-0.049279,-0.0025723,-0.047045,-0.061976,-0.16155,0.063323,0.26942,-0.054489,0.09417,-0.093916,-0.021121,-0.082979,-0.0019157,0.14913,-0.003521,0.17781,-0.12315,-0.0060861,-0.16974,0.14061,-0.055255,-0.17315,0.12775,0.097006,0.17154,-0.16451,0.13044,0.18263,-0.14608,-0.055745,0.064742,0.13958,0.066441,0.038358,0.088514],[1.4726,0.73506,0.80613,0.38323,-0.027416,0.9716,0.17538,-0.61775,0.3718,0.43723,0.86956,-1.1617,0.0059287,-0.34913,0.066616,0.19842,-0.048499,0.017231,-0.16178,-0.11113,-0.054735,-0.25486,-0.013431,0.085745,0.3037,0.12314,0.016142,-0.018844,-0.18087,-0.010064,0.13061,0.034545,-0.23404,0.099738,-0.018928,0.18731,-0.15966,0.16217,-0.1854,0.17533,0.011124,-0.017791,-0.030794,-0.15438,-0.02086,-0.021134,0.14121,-0.029558,-0.085065,0.098766,-0.030825,0.010039,0.035838,0.12445],[-0.10983,0.0034177,-0.1751,-0.20339,0.027512,0.10381,0.050882,-0.048868,-0.045285,-0.20658,0.010624,-0.021406,-0.12032,-0.22346,0.037679,-0.063095,-0.14914,0.057471,-0.13226,-0.0037908,-0.076874,-0.16153,-0.13733,-0.0042593,-0.043902,0.089926,0.12304,-0.088673,-0.20669,-0.029066,0.13878,-0.1722,-0.18461,-0.17544,0.092237,0.17835,0.0024864,-0.0055769,0.14339,0.18851,-0.0043489,0.12201,-0.082479,0.073234,0.13052,-0.0893,-0.030855,-0.16278,0.03094,0.094928,0.17847,0.010434,-0.17768,-0.095747],[-0.29653,-0.77216,-0.49362,0.024077,-0.17964,0.079403,-0.0059095,-0.17046,0.35044,0.48495,-0.4816,0.27653,0.031965,-0.062303,0.50735,0.3404,-0.31414,0.050848,0.033966,-0.033622,0.0044739,-0.047103,-0.029459,0.064196,-0.036517,0.10677,-0.094463,0.0094696,-0.11144,0.055688,-0.028033,-0.014371,0.021312,-0.11525,-0.12907,0.134,0.10925,0.12032,0.20404,0.10138,-0.041912,-0.072119,0.10854,-0.077982,0.17626,0.098075,0.073021,-0.053847,0.10738,0.10302,0.12484,0.075764,-0.00040584,0.067425],[0.10799,-0.60533,-0.46671,-0.34167,-0.039249,0.19276,-0.025282,0.014693,-0.5543,-0.32312,0.049479,0.14711,0.1018,0.029498,-0.32656,0.096282,-0.40456,-0.13796,-0.1882,0.31936,-0.086437,0.11888,-0.21202,-0.21677,-0.059202,-0.093397,0.0066615,-0.06749,0.017281,0.062071,-0.044322,-0.016766,-0.092807,0.18195,-0.055373,0.13292,0.17822,0.078714,-0.097711,-0.11337,0.039871,-0.11323,-0.12362,0.17828,0.13674,0.046724,0.15714,0.084195,0.18915,-0.097438,-0.16872,-0.10711,0.42188,0.14854],[-0.05566,0.14228,0.11752,-0.034844,0.049329,0.011483,0.10123,-0.1543,0.054048,0.045937,-0.10241,-0.10456,-0.12405,0.040719,-0.04748,-0.0168,-0.055584,0.103,-0.1399,0.11413,0.16651,-0.073679,-0.10873,0.12028,-0.17165,-0.14225,-0.14957,0.17263,-0.10401,-0.18807,0.042359,-0.13592,-0.16596,-0.085103,0.14787,0.0016535,-0.084726,-0.033954,0.18907,-0.050936,0.15478,-0.02725,-0.10402,0.07123,0.096668,0.059472,-0.024556,0.13774,0.16117,-0.012314,-0.010651,-0.055879,-0.12247,-0.013875],[0.0022291,-0.41647,-0.7879,-0.31831,0.034393,-0.28485,-0.029472,-0.15829,-0.61423,-0.54789,-0.48159,-0.12017,0.13133,0.19432,-0.63498,0.69664,-0.4288,-0.17093,0.12149,0.16269,0.18554,-0.15593,-0.13981,0.20789,-0.2165,-0.13692,0.17339,0.033891,-0.44453,0.13276,0.16102,0.017082,-0.12272,-0.095237,-0.15251,-0.11228,0.030523,-0.036494,-0.12514,0.13356,-0.11659,0.136,0.17639,0.086451,0.08851,-0.14719,-0.050243,-0.049858,-0.089188,0.14141,-0.15241,0.20106,-0.00059672,0.057343],[-0.15366,0.0055328,-0.35906,-0.27538,0.067002,-0.21907,0.15862,-0.27851,-0.18426,-0.16736,1.0356,0.66149,0.11472,0.22921,0.31108,-0.24104,-0.027574,-0.044838,-0.049246,-0.0962,0.14434,-0.091705,-0.24811,-0.072448,-0.061496,0.075948,0.14029,-0.13642,0.18217,-0.0089104,0.15334,0.21677,-0.20801,0.15945,-0.04089,0.047578,-0.1597,0.18533,0.087036,-0.013895,0.0057582,-0.10901,-0.073427,0.16665,-0.18809,0.070336,-0.021274,0.057832,-0.024783,-0.15192,-0.17639,-0.01411,-0.028249,0.15406],[0.5404,-0.85941,-1.0941,-0.85676,-0.1607,0.61165,-0.063907,-0.25306,-0.77928,-0.33449,0.21521,-0.78922,-0.091956,-0.3943,0.17454,0.42309,-0.50714,-0.7464,0.19997,-0.008771,0.068778,0.14911,-0.12752,0.42176,-0.57984,-0.082581,0.037185,-0.16475,-0.16656,0.031325,-0.034509,-0.011374,-0.014606,0.027747,-0.047328,-0.17324,0.12062,-0.067993,0.22108,0.1158,-0.064932,0.077356,0.18868,0.027594,-0.0016331,0.12784,-0.071448,0.053044,-0.00051897,-0.034834,0.1021,-0.0029914,-0.14847,0.11191],[0.018743,-0.07572,-0.17503,0.039641,-0.075232,0.25134,-0.025818,-0.080122,0.016635,-0.046433,-0.019144,-0.16781,-0.039616,0.031113,-0.84974,0.2702,-0.30061,-0.14788,0.10602,-0.18349,0.12803,0.081792,-0.21259,-0.04264,-0.31467,0.073744,-0.19514,0.052161,0.019501,-0.15761,-0.0065907,-0.18844,-0.10972,0.089595,-0.060774,-0.057178,-0.17973,0.025829,0.066902,0.098272,-0.10004,-0.039611,0.17158,-0.012337,0.11597,0.149,-0.0095833,0.12496,-0.054222,-0.055298,-0.035786,-0.054424,-0.16337,0.048179],[-0.42397,2.5087,2.6687,1.6984,0.12496,0.54853,-0.30618,0.37736,1.2544,0.84989,0.066039,-0.1013,-0.017241,-0.30726,-0.76941,-0.7204,0.55156,0.023113,-0.17596,-0.059179,-0.091831,0.12442,0.14037,-0.10239,0.30148,0.01301,-0.00078193,0.019719,0.361,0.069692,-0.016057,0.054674,-0.086491,-0.12225,-0.1827,0.1347,0.10725,0.10228,-0.13681,-0.019914,0.095848,0.1726,0.0053338,-0.1034,-0.16452,0.0042547,0.088899,0.010842,0.10219,-0.02044,0.14575,-0.09116,0.012663,0.12213],[0.3332,-0.61207,-0.44976,-0.081093,-0.153,0.14756,0.15155,-0.93288,-0.28899,-0.15325,0.56552,0.10974,-0.18935,0.62111,0.089213,0.17768,-0.55888,0.052852,0.027207,-0.0094869,-0.11468,0.093251,0.023297,0.27684,-0.069468,0.026334,0.039333,-0.01591,-0.13891,0.058463,0.050067,-0.017256,0.065535,0.17488,0.084115,0.012538,0.030426,-0.12399,-0.10502,0.0036372,-0.0053944,-0.086908,0.10793,-0.12725,0.16509,0.13789,-0.073647,0.036154,-0.18064,-0.052099,0.13974,0.018601,-0.011323,-0.031306],[-0.1465,0.15549,0.12543,0.087835,-0.17982,-0.12443,0.067323,-0.0042418,0.022785,-0.16121,0.095492,-0.093917,-0.19081,-0.10935,-0.040081,-0.15889,0.0095439,0.16448,-0.0088298,-0.11184,0.12166,-0.094778,-0.17332,-0.14195,-0.043103,-0.023039,0.071038,-0.19228,0.0017306,-0.18588,-0.17918,-0.0085493,-0.0063573,0.10554,-0.037738,0.18807,0.1305,-0.045635,0.12402,-0.13832,0.051079,0.11571,-0.10471,0.14851,0.1537,0.14293,0.082654,0.071634,-0.1619,0.18367,0.13173,-0.15089,0.17646,0.027111],[-0.14127,-0.12653,0.25596,0.22155,-0.032019,0.11545,0.1628,-0.1047,0.053659,-0.079276,-0.037694,0.0037386,-0.11848,-0.16907,0.1953,-0.25644,0.1317,-0.093684,0.18743,0.020101,-0.17382,-0.053586,0.13444,-0.25406,0.32941,-0.18886,-0.040572,-0.12426,0.013284,-0.33475,0.13431,-0.013555,0.0078471,0.27021,0.12711,0.17185,0.10209,-0.14877,-0.088118,0.13098,0.074761,0.13742,-0.030915,-0.16118,0.13496,-0.074965,0.0041127,0.074559,-0.15965,0.10889,-0.15526,0.10218,-0.056352,0.1409],[1.8216,-0.9682,-1.3768,-0.80285,-0.17406,-0.087392,0.25994,-0.91089,-0.20063,-0.1401,0.33044,-0.13144,0.12581,0.78381,0.10259,-0.24334,-0.67476,0.010332,0.22433,0.17598,0.12629,0.040719,0.014265,-0.11092,0.018362,0.10082,-0.21495,0.13916,0.15322,-0.039616,0.024735,0.1096,-0.048103,-0.078655,-0.084179,0.17362,0.16335,0.11154,0.055382,-0.069855,0.13617,-0.13496,0.046731,0.022865,-0.070291,-0.16479,0.02702,0.022553,0.17409,0.15934,0.12519,0.003221,0.0042476,0.1835],[-0.25933,0.037231,-0.24094,-0.076228,0.15048,-0.69029,-0.16204,-0.35825,0.015256,-0.19593,0.50104,0.43685,-0.008059,0.16049,0.83859,-0.45147,0.012893,-0.066729,-0.065757,-0.14242,0.056065,-0.17953,-0.33144,0.1893,-0.066858,0.088946,-0.035222,-0.054958,0.0075124,0.005533,-0.15728,-0.022665,-0.14218,-0.04676,0.029752,0.15963,0.0086588,-0.1268,-0.036412,0.11101,0.11202,-0.071307,0.058306,-0.092121,0.02565,0.050744,-0.051295,0.092493,-0.070584,0.11726,-0.075992,0.028035,0.033605,-0.10898],[0.10404,0.64166,0.93615,0.82654,-0.16167,-1.9256,0.23177,-0.34166,0.97462,0.75367,-0.10119,0.69475,0.1118,2.1485,-0.081836,-0.18053,0.33563,-0.025939,-0.21141,-0.058379,-0.059237,-0.047225,0.16739,-0.22538,0.26509,0.058961,-0.15329,0.12475,0.065481,0.0040581,0.18075,-0.034403,0.02431,0.18199,-0.16703,0.11642,0.13931,0.16323,0.03525,0.19156,0.12189,0.11502,-0.27499,-0.036997,0.023518,0.061371,0.11887,-0.037654,-0.13077,0.0112,0.012836,0.014976,-0.013989,-0.067419],[0.075324,-1.0616,0.65622,0.19791,-0.1443,-0.21956,0.38057,0.36033,0.7421,0.89823,-0.095226,0.15044,-0.10685,0.60037,-0.38872,-0.13599,-0.60275,-0.02397,-0.22779,-0.17796,0.082016,-0.11343,-0.044287,-0.0047033,0.5339,-0.049834,0.017847,0.041842,-0.29498,0.13816,-0.1788,-0.11064,0.19686,-0.035898,-0.16452,0.15001,-0.10349,0.082144,-0.19019,-0.10443,0.15383,-0.000076488,0.076332,-0.20884,-0.12426,0.10329,-0.011573,-0.019529,0.038009,-0.031001,0.023323,-0.081921,0.07892,-0.030675],[-2.1261,1.1067,1.235,1.0774,-0.040854,0.13785,0.19335,0.53435,1.0319,0.83328,-0.015486,2.0998,0.11247,-1.1387,-0.13374,0.090913,0.29835,-0.052556,-0.15631,-0.0022557,0.056481,0.072989,0.20581,-0.07395,0.36915,-0.045778,0.13556,0.14188,-0.052281,0.081816,0.10057,-0.094157,0.22028,0.0061923,0.17564,0.064628,-0.087897,-0.11533,0.066165,0.1059,0.0031366,-0.15612,-0.028302,-0.090172,-0.099775,0.0018202,-0.011107,-0.03519,-0.0035584,-0.11369,-0.061537,-0.011294,0.0044717,-0.12306],[0.30616,0.26928,0.63148,0.45463,0.055512,0.67311,-0.15586,-0.32363,0.31633,0.44285,-0.1228,0.27455,0.016372,-0.17692,-0.12731,0.15475,0.21946,0.2065,-0.3562,-0.038884,0.0076728,-0.36669,0.34783,-0.32936,0.48694,-0.23591,-0.1637,-0.058758,0.16654,-0.75779,-0.12003,-0.046619,0.31624,0.10692,0.15513,0.14798,0.081719,0.13218,-0.16495,0.014668,0.10102,0.00866,0.039103,0.050558,0.031797,0.11443,0.13768,0.028089,-0.083077,-0.047556,-0.091502,-0.03889,-0.012625,0.027763],[-0.047821,-1.0312,-1.2823,-0.85354,0.087506,0.34862,0.067538,-0.09725,-0.57495,-0.65823,-0.73704,0.7242,0.040865,-0.37567,-0.093683,-0.01369,-0.60659,-0.13043,0.19943,0.028488,-0.11652,-0.060423,-0.43553,-0.0066431,-0.49083,-0.17005,-0.05831,-0.0040431,-0.27489,-0.024884,-0.14878,0.032817,0.16331,-0.048147,-0.19145,-0.11486,0.12383,0.14277,-0.15819,-0.062436,0.16414,-0.16775,-0.017586,-0.15135,0.13581,-0.036962,-0.088818,0.020162,0.0088576,-0.15255,-0.052569,-0.058272,-0.0024729,-0.077863],[0.20836,-0.074915,0.2306,-0.12529,0.035993,-0.077443,0.14026,0.12145,-0.10079,-0.057405,0.26222,-0.038842,-0.085482,0.033175,-0.23675,-0.095681,0.099727,-0.022378,-0.027008,-0.10609,-0.084607,-0.064295,0.044599,0.17109,0.10326,0.026216,0.09776,-0.10289,-0.1975,0.029425,0.0099284,0.056513,-0.030082,0.087647,0.030709,0.13555,-0.16472,-0.1342,0.0061174,0.12352,0.031764,0.04302,0.090553,-0.18114,-0.066557,0.14312,0.11883,-0.12593,0.097016,0.034576,-0.20069,0.14228,-0.12607,-0.093625],[-0.14166,-0.31619,-0.80593,-0.28558,0.19006,1.0593,0.19931,-0.22859,-0.29794,-0.23451,0.45999,-0.24412,-0.17541,-1.4307,0.38783,-0.27047,-0.36269,-0.035018,0.2528,0.11122,0.17814,0.034502,-0.12876,0.010226,-0.22538,0.25094,0.012583,0.24787,0.073145,0.042922,0.053399,-0.0044651,-0.048992,0.17476,-0.10998,-0.08484,0.15065,-0.12632,0.019027,0.064135,-0.037952,-0.025897,0.1056,-0.0033525,0.026249,-0.066159,0.0027386,0.0051053,0.091163,0.045975,-0.018114,0.044856,-0.0033236,-0.13884],[-0.13936,-0.42138,-0.25866,-0.015075,0.12829,-0.10315,-0.012744,-0.16448,-0.40603,-0.13029,0.09113,0.6795,-0.14744,-0.17257,0.12552,0.51361,-0.24306,-0.093079,-0.13403,-0.051825,0.0035174,-0.19264,-0.29266,-0.047917,-0.15931,-0.16146,0.12688,-0.059572,-0.24141,-0.071015,0.087516,0.18193,-0.30589,-0.093214,0.1821,-0.047782,-0.16572,0.11052,0.10981,0.15703,-0.0082716,0.094866,-0.011433,-0.092721,0.096225,0.0493,-0.02493,-0.061948,-0.18181,0.18146,-0.0068161,0.14512,-0.040702,0.0074707],[-0.54854,-0.3322,-0.33766,-0.13742,0.024186,-0.51857,-0.1604,0.064055,-0.29811,-0.072854,-0.28644,-0.29184,-0.1049,0.081437,0.22153,0.67594,0.24428,-0.033408,-0.058755,-0.0099067,-0.055683,-0.12043,-0.076786,-0.08708,0.09884,0.0097104,0.073102,0.14294,-0.37538,0.076805,-0.10695,0.21843,-0.33396,0.056553,-0.13636,-0.038199,0.16854,-0.14496,0.14293,-0.12449,-0.15106,-0.14782,-0.0097297,-0.14935,-0.03511,0.14268,0.063438,0.088184,-0.00084171,0.081711,-0.091018,0.014879,0.16645,0.1382],[-0.38028,-0.036274,-0.093548,-0.3576,-0.05568,-0.53829,-0.14746,-0.042789,-0.19832,0.01493,-0.019627,-0.12948,-0.0644,0.23062,0.55432,0.31052,0.067217,-0.18329,0.0095923,-0.14008,-0.090894,-0.10073,-0.37601,0.1829,-0.36392,-0.14908,-0.14246,-0.17014,-0.21026,-0.018044,-0.088941,0.17156,0.065019,-0.022546,0.10781,-0.086007,0.16606,0.12762,0.15269,-0.18994,-0.15125,0.11222,-0.035357,0.19516,0.15216,0.095581,-0.053395,-0.047703,0.055671,0.16334,-0.12304,0.10935,-0.13634,-0.018288],[0.61691,0.083415,0.57247,0.13504,0.064442,-0.50104,0.21302,0.32098,0.30647,0.17016,-0.067677,-1.1193,-0.18706,0.5246,-0.21126,0.23178,-0.086681,0.037621,-0.011179,-0.11871,-0.049662,-0.0025903,-0.15616,0.099468,-0.26466,-0.094657,0.040857,0.033734,0.12585,-0.012595,-0.14813,-0.14664,0.23666,0.11208,0.050827,0.011499,-0.14855,-0.15635,0.055712,-0.060272,0.0015505,-0.17047,0.15588,-0.13682,0.030895,-0.097489,0.095117,0.039783,0.082781,-0.0025172,0.19029,-0.031804,-0.020692,0.13949],[-0.084993,-0.10182,-0.12908,0.0039003,-0.11855,-0.0053457,0.01422,-0.24686,0.054658,0.195,0.13596,-0.046713,0.11228,-0.2279,-0.10217,0.58133,0.03913,-0.065784,-0.20814,0.10434,-0.023399,0.0060751,0.097393,-0.024265,0.050976,0.25806,-0.062519,-0.073648,-0.2321,-0.04373,-0.18788,0.13614,-0.10457,0.20891,-0.068836,-0.19245,0.10988,-0.11407,-0.010012,-0.10322,0.041109,-0.1449,-0.066231,0.21494,0.10193,0.24308,0.18769,-0.0065168,-0.12596,0.18547,0.1215,0.09014,-0.059002,0.050248],[-0.17906,-0.20137,0.26452,0.085471,0.089874,-0.067937,0.13069,0.0073967,-0.06005,-0.053291,0.063423,-0.17006,0.14708,-0.10589,-0.051035,-0.066527,-0.18441,-0.058086,0.30248,-0.083978,0.081919,-0.0056087,-0.12776,0.20226,-0.25162,0.68209,0.12179,-0.012393,0.094527,-0.090723,-0.10316,0.17454,0.02744,0.079321,0.036811,-0.050963,0.16719,-0.0059626,-0.11111,-0.14297,0.051274,0.0049233,-0.1771,0.081342,-0.0049436,-0.30387,-0.10146,-0.19607,-0.10815,0.063716,-0.13413,-0.037592,0.01703,-0.07693],[0.5525,-0.10586,-0.24758,-0.012096,-0.099757,-1.1627,0.11238,-0.55322,-0.33491,-0.25506,0.4233,-0.32635,-0.13106,1.1907,-0.1252,0.10883,0.093005,0.048929,-0.042283,0.02979,0.015994,0.03283,0.086926,0.18719,0.058569,0.006527,-0.0053261,0.080341,-0.051707,0.010794,0.1866,0.010629,-0.17632,-0.10142,-0.11062,0.15052,-0.14147,0.03423,0.12686,0.032017,0.12433,0.18454,0.083625,0.12485,0.16738,-0.010725,-0.080591,0.047615,-0.16085,-0.066736,-0.15153,-0.013907,0.031286,0.14562],[2.5518,1.3997,0.21104,-0.051279,0.069103,-0.14212,-0.48988,-0.22999,-0.017052,-0.19126,0.09331,0.23621,0.12065,-0.16514,-0.20026,-0.35254,0.44076,-0.068025,-0.054664,-0.066937,0.17163,0.010461,-0.088455,0.05544,0.030295,0.19339,0.17059,-0.028945,0.18939,0.24391,-0.097295,-0.12653,0.053692,0.15811,-0.15538,-0.084083,-0.17891,-0.1358,-0.04943,-0.16363,-0.18152,-0.13523,-0.019365,-0.098546,0.11548,-0.076033,-0.20145,0.026333,-0.13258,0.068756,-0.021654,-0.031405,0.0040702,-0.15144],[-0.044921,-0.30294,-0.19819,-0.14348,0.067659,-0.0075551,-0.12439,-0.14554,-0.05352,-0.02437,-0.055397,-0.15055,-0.010112,0.26622,-0.31444,0.044328,-0.073226,0.15565,-0.00019875,0.15798,0.043001,-0.026434,-0.0033529,-0.16075,0.015837,0.21287,0.12199,0.041348,-0.0049,0.16695,-0.01197,0.070102,-0.05111,-0.012222,0.081582,0.082756,-0.18035,-0.14525,0.062971,-0.053997,0.13074,-0.18705,0.15795,-0.070914,0.055612,0.015893,0.081636,0.098818,0.14111,-0.12558,-0.1663,0.11381,0.011056,-0.1516],[0.098921,0.1782,0.047032,-0.10024,-0.0066813,-0.3112,-0.077414,-0.092792,-0.084466,0.073601,0.18418,-0.21875,0.18257,0.013021,0.11258,0.044328,-0.069677,0.21415,0.029992,-0.20601,0.18522,-0.11345,0.06249,-0.13759,-0.014547,0.1277,-0.041062,0.19789,0.37008,-0.28936,-0.16929,0.046392,0.12863,0.023039,-0.17462,-0.045053,-0.066678,-0.041776,-0.0029241,-0.1563,-0.061996,0.02075,-0.071889,0.13455,-0.008332,0.17903,0.15433,-0.18868,0.17077,0.081503,-0.014246,0.016033,-0.15712,-0.022799],[-0.063756,-0.057175,-0.14297,-0.31679,0.1414,-0.055904,0.070923,-0.45704,0.4456,0.090799,0.67444,0.012886,0.003004,0.15346,1.198,0.15088,-0.26033,-0.23991,-0.13492,-0.065071,-0.10802,-0.053677,-0.085529,-0.48712,-0.070178,-0.077824,0.06855,0.031131,0.37769,-0.01207,0.050347,-0.019664,-0.01614,0.037085,0.109,-0.17877,0.16097,0.12001,0.11323,0.035433,0.088588,0.11512,0.063128,0.10447,0.12717,0.061744,-0.036417,0.02658,0.037592,-0.095174,0.16892,0.12937,0.058184,-0.11665],[0.34203,-0.22649,0.077187,0.16571,0.022373,-0.053342,0.16698,-0.16519,0.094849,0.090601,-0.075811,0.18503,-0.099362,0.13381,-0.025407,0.057014,-0.24378,0.0598,-0.30561,0.22229,-0.024732,-0.38842,0.080761,-0.55656,0.36786,-0.24518,0.026904,-0.099646,0.33032,-1.5456,0.029608,0.049255,0.0020016,-0.16438,-0.091508,-0.0065104,-0.16016,0.074241,-0.23719,0.086772,-0.034524,-0.17925,0.13527,-0.15185,0.10266,-0.042865,0.058312,-0.099741,0.036044,0.13039,-0.18979,-0.020954,-0.015418,0.054168],[-0.054843,0.18755,-0.0018136,-0.028485,0.18606,-0.028657,0.034301,-0.064403,0.067843,-0.033489,-0.16063,0.058564,0.037048,-0.066507,0.061551,-0.057536,0.10425,-0.041158,0.11286,-0.12852,0.07713,-0.11483,-0.22036,-0.13238,-0.053377,0.32946,0.043085,0.1094,-0.18844,0.0021626,-0.065516,0.29497,0.12424,0.088567,-0.1238,-0.07376,-0.10412,0.16598,0.074598,-0.13495,-0.011507,-0.096308,0.085758,-0.12206,0.077226,0.1543,-0.050041,-0.036268,-0.06515,0.14335,-0.024855,0.16795,0.17691,-0.12328]],[[-0.39478,0.052877,0.18758,-0.10446,0.29128,-0.027081,0.14129,-0.090247,0.13534,0.080477,0.014278,0.022473,0.38479,0.21265,-0.51083,0.031506,-0.13388,-0.068341,0.12724,-0.041063,-0.2909,-0.34757,-0.11419,-0.046923,0.21506,0.030993,0.40893,0.25569,-0.23459,-0.13118,-0.42762,0.23214,-0.083825,0.16412,0.011945,0.1317,0.14484,0.16406,-0.17812,-0.10267],[0.15024,0.1465,0.064935,-0.050593,-0.0057934,-0.052682,0.21716,-0.067149,-0.027926,0.21683,0.15742,-0.035613,-0.17572,-0.18412,-0.18078,0.14292,0.19468,-0.19151,-0.088388,-0.10635,-0.25412,-0.041314,0.41414,-0.21464,-0.10609,-0.11453,0.20694,0.015263,-0.18101,0.0017689,0.043314,-0.084877,-0.14377,0.063866,-0.38765,0.070348,0.095365,-0.057285,0.040636,0.075676],[0.21899,-0.057155,0.043428,0.042955,0.039552,-0.78618,0.19083,0.17023,-0.10284,0.12608,0.1591,0.30896,0.040533,0.249,-0.70037,-0.34115,0.0016507,-0.040541,0.054086,0.31206,-0.60835,-0.1749,-0.74463,-0.3025,0.18091,0.082746,0.010673,0.027459,0.2949,0.31639,-0.37012,0.12581,0.07852,0.045062,0.11961,-0.049334,0.19843,0.33268,-0.21879,-0.24297],[0.15025,0.12098,-0.053612,0.12641,0.042921,-0.078126,0.16907,-0.0052443,0.027754,0.20961,-0.040497,0.053648,-0.010629,0.19066,0.0037409,0.2076,0.07014,-0.047874,-0.26533,-0.072658,-0.13005,-0.12778,-0.18697,-0.011675,0.12293,0.0073738,0.20766,0.10698,-0.22998,0.091979,-0.042539,0.17099,0.20728,-0.14586,-0.22992,0.22406,-0.0248,0.22021,0.011118,-0.16638],[0.22479,-0.0032146,-0.18661,-0.1639,-0.24684,-0.41824,0.069351,-0.035638,0.035353,-0.038712,0.0059961,0.12478,0.087444,0.043246,-0.16883,-0.06049,0.10511,-0.20935,-0.027379,0.24483,-0.74613,0.15926,-0.42225,-0.33306,-0.16559,-0.033482,0.23304,-0.15103,-0.03179,-0.059356,-0.030922,-0.07365,-0.1073,0.14578,-0.40198,0.20866,-0.15598,-0.20946,0.070724,-0.095341],[-0.36484,0.36889,0.092698,-0.065014,0.57877,0.06435,-0.18186,-0.61906,0.0082712,0.22758,0.32447,0.068716,-0.060923,0.0062061,0.35096,0.41668,-0.21242,-0.18778,0.14506,-0.11138,0.44106,-0.3724,0.068218,-0.007076,0.10972,-0.19897,-0.11334,-0.19169,0.12291,0.14396,-0.019215,0.17536,-0.042915,0.32988,0.32515,0.039096,-0.072661,-0.15041,-0.51798,-0.1175],[-0.10829,-0.63499,-0.19833,-0.15142,-0.45346,-0.0058946,0.051481,0.46508,-0.1121,-0.21117,-0.23825,-0.058734,-0.2826,-0.0059416,-0.021104,0.27615,0.19489,-0.079547,0.75434,-0.38215,0.29215,0.20129,0.019584,0.11896,-0.42656,0.20232,-0.25579,-0.18315,-0.049838,-0.21533,0.15936,-0.29143,0.070592,0.070375,0.26552,0.13905,-0.31098,0.062112,0.34815,-0.19926],[-0.54076,0.15894,0.13823,0.023524,-0.32873,-0.65599,-0.047384,-0.25112,0.2996,0.11165,0.55509,0.28115,0.29607,0.52907,-0.68021,0.47541,-0.074499,-0.20333,0.36529,0.036722,-0.38673,0.15412,-0.54736,-0.3571,0.48376,0.1699,-0.11117,0.47106,0.13462,0.13399,-0.19127,0.18374,-0.19174,0.27174,-0.24867,0.17234,0.048053,-0.19117,-0.15175,-0.27418],[-0.096186,0.3476,-0.1475,-0.080354,0.032082,-0.17609,0.21884,0.22478,0.12999,0.089135,-0.049054,0.057395,0.26902,0.16026,-0.38083,-0.24189,-0.19204,0.11849,0.15968,-0.21042,-0.27742,-0.036657,-0.1514,-0.23531,-0.050036,0.15215,-0.10196,0.077884,-0.1414,0.16917,0.017945,-0.1169,0.040514,0.060273,-0.11727,0.24539,-0.17821,-0.13328,0.083736,-0.055297],[-0.30602,0.34913,-0.16415,0.29767,0.28045,-0.45053,-0.0039095,0.1732,-0.16855,0.00052519,-0.061955,0.065254,0.15241,-0.11974,0.29996,-0.49896,-0.24156,0.28265,-0.56612,0.031034,0.036174,-0.051636,-0.091873,0.010908,0.55537,0.048552,0.28131,-0.032265,-0.25095,-0.22674,-0.040005,-0.11145,0.4616,-0.27357,-1.1156,-0.075397,-0.14689,0.59144,0.071206,-0.078456],[0.10676,-0.1701,-0.22304,0.095354,-0.21995,0.02743,-0.016567,0.030147,-0.028415,0.12973,-0.18198,-0.38819,-0.18967,-0.33288,-0.12665,0.29342,0.14512,-0.08952,0.098463,-0.21806,-0.15155,0.37212,-0.19095,0.028762,-0.097606,0.016545,-0.22692,-0.1804,-0.24836,-0.11238,-0.1684,0.0024491,0.26595,-0.45192,-0.36776,0.11588,-0.27681,0.05619,0.63056,-0.12715],[-0.20002,0.241,0.11995,-0.0067169,0.043443,-0.17153,-0.10606,0.39603,-0.02853,-0.17379,0.038075,-0.4012,0.19497,-0.16801,-0.61727,-0.013405,0.045336,-0.069453,-0.047192,0.18139,-0.095359,-0.10395,-0.082079,-0.15242,0.29463,0.029582,0.53346,0.36556,0.16393,0.076246,-0.3077,0.24967,0.00056312,-0.028265,-0.19116,-0.16868,-0.054017,0.43942,-0.17636,-0.31214],[0.11199,-0.61041,-0.16616,0.14547,-0.26949,-0.088279,-0.22581,0.047014,-0.028193,-0.089033,-0.3155,0.039368,-0.26899,-0.091644,-0.27681,0.47334,-0.087599,0.2796,0.11406,-0.40697,-0.047885,0.17416,0.081361,-0.026645,-0.27094,-0.014036,-0.45703,-0.061615,-0.27165,-0.044509,0.077534,-0.29404,0.21049,-0.59769,-0.38159,0.16529,-0.32011,0.076431,0.50489,-0.045914],[-0.23691,0.079535,0.10195,0.058013,-0.15694,-0.11233,0.014669,0.043697,0.069555,-0.021999,-0.062107,0.19869,0.074772,-0.065312,-0.40361,0.077996,-0.01821,0.039047,-0.065881,0.1312,-0.30486,0.12907,0.13435,0.14694,0.10403,-0.04259,-0.14525,-0.10834,0.088828,0.052115,0.14661,0.061821,-0.015151,-0.079832,0.01249,-0.17783,-0.21917,-0.13309,0.029719,0.028217],[-0.24414,-0.12338,0.056702,0.041935,0.15318,-0.097864,-0.014712,-0.084888,0.059899,0.051099,-0.34005,-0.37128,-0.25349,0.15937,-0.1241,0.39412,0.20922,-0.039906,0.20544,-0.1702,0.2091,0.0091683,-0.27539,-0.13302,-0.077903,-0.14119,-0.052771,-0.23484,-0.24859,-0.0055577,0.015274,-0.15995,0.28692,-0.52236,-0.48762,0.22264,-0.11312,0.20724,0.20547,0.091957],[0.15498,-0.067357,-0.059295,0.058567,-0.14749,-0.24792,0.21639,-0.18026,-0.11902,-0.16436,-0.13106,0.06187,0.0036284,-0.060844,-0.029975,-0.28398,0.17228,0.12039,-0.1054,-0.17272,0.23601,-0.041094,-0.011261,-0.25844,-0.11493,-0.13361,-0.20802,-0.10837,0.17786,0.0034292,0.036586,0.10937,0.093489,0.11967,-0.30803,-0.043949,0.20073,-0.11214,-0.13668,-0.05125],[-0.099687,0.043141,-0.07241,-0.15096,0.084304,-0.064451,0.19216,0.1667,0.11599,0.18599,0.15168,-0.1399,0.041876,-0.053709,-0.71226,0.10481,-0.05861,-0.10428,-0.20934,0.35673,0.40418,-0.015335,0.050852,-0.19699,0.0085236,-0.12146,0.16354,0.098485,0.013884,0.36084,-0.16129,0.1844,-0.066236,0.28908,-0.24716,0.034673,0.003262,0.21268,-0.11142,0.070242],[0.056797,-0.11141,0.073727,-0.13795,-0.17157,-0.0076483,-0.12216,0.06512,-0.1667,0.04031,0.011431,0.34638,-0.054424,-0.0029631,-0.12238,0.17562,-0.05059,-0.13623,-0.011049,0.00047763,0.11888,-0.15178,-0.054946,-0.2001,0.083321,0.19482,-0.042708,-0.21568,-0.037157,0.0037409,0.073824,0.037832,-0.02659,0.05215,-0.12974,0.055368,0.047009,0.16544,-0.048922,0.0068973],[0.047617,0.095322,0.23071,-0.25814,-0.26178,-0.92512,0.23188,0.015918,0.35051,0.20674,0.42088,0.14696,0.081525,0.19581,-0.65405,-0.026105,0.18691,-0.012748,0.38022,0.34803,-0.80355,0.2035,-0.80162,-0.41104,0.39943,-0.047187,0.14507,0.01369,0.33648,0.22606,-0.64871,0.21918,-0.34889,0.31918,-0.045569,0.093188,-0.10663,-0.36461,-0.34617,0.096709],[0.24991,-0.015833,0.18509,-0.0814,0.36329,-0.15069,-0.13796,-0.096029,0.14983,-0.043683,-0.08291,0.20011,0.0641,-0.12639,-0.3654,0.22324,-0.16433,-0.18189,-0.034847,0.41303,-0.31432,-0.085424,-0.45357,-0.11498,-0.10053,-0.026067,0.27706,-0.16175,0.20032,0.052431,-0.10473,-0.11199,0.11723,-0.00074768,-0.092917,-0.15547,-0.15404,0.4246,-0.21126,-0.12879],[-0.26698,0.22023,0.032036,-0.12347,-0.1421,0.15202,-0.060638,-0.6004,0.10453,-0.0078943,0.11031,-0.0008385,0.30398,0.16436,-0.47511,0.30954,-0.21037,0.1763,0.25394,0.16623,0.10908,0.1021,-0.52507,-0.14916,0.18678,-0.36218,0.16392,-0.12612,0.045654,0.022759,-0.31468,0.21663,-0.047168,0.33344,-0.24111,0.0087785,-0.17762,0.070917,-0.31376,-0.072671],[-0.031298,0.031474,-0.1129,-0.17678,-0.26736,0.11346,-0.13069,0.047359,-0.1272,-0.20442,-0.045232,0.16849,-0.21595,0.029111,-0.057254,-0.062725,-0.17033,-0.028292,-0.14822,-0.054648,0.052965,0.22204,-0.018065,-0.061447,-0.18177,0.14289,0.19497,-0.0033479,0.20093,-0.079892,-0.0027354,-0.22149,0.21408,-0.021337,0.35832,-0.15027,0.13984,-0.051252,0.096311,0.12639],[-0.43877,0.12562,0.090575,0.09427,0.0091109,-0.34803,0.10536,-0.14912,-0.13778,0.08029,-0.060052,0.051037,0.011215,0.084575,-0.46299,-0.0079209,-0.05606,-0.05232,-0.29777,-0.15487,-0.09649,-0.14472,0.12244,-0.028848,-0.065419,0.063374,-0.0070767,-0.20226,-0.18981,-0.14582,-0.19577,-0.0090258,0.041895,-0.27417,-0.15466,-0.10765,-0.14557,0.07537,0.081128,0.17422],[0.26607,0.0070908,0.023664,0.078026,0.064467,0.011085,0.11012,-0.035541,-0.090067,-0.12185,-0.15726,0.091649,-0.20349,-0.080306,0.054336,-0.15524,0.068517,0.0047113,-0.093258,-0.023773,0.28138,0.11117,0.17723,-0.14483,0.045238,0.14381,-0.13406,-0.059738,-0.037159,-0.025624,-0.20589,0.15962,-0.02963,-0.19845,0.056043,-0.083071,0.11295,0.048681,0.098554,0.097621]],[[-0.75544,-0.59729,-0.81859,0.47331,-0.83242,-0.55264,0.42009,-0.88447,-0.57497,0.82548,0.46262,-0.78098,0.48709,-0.43376,0.52045,0.49468,-1.0021,0.54885,-0.88982,-0.7887,-0.93972,0.24275,0.73248,0.194]]],\"biases\":[[0.041313,0.000921,0.0052688,0.097208,-0.45083,-0.46222,-0.056161,0.010132,-0.074039,-0.044454,-0.18343,-0.044912,-0.27122,-0.017317,-0.18369,0.13357,0.020572,0.02766,0.041598,-0.26154,0.023093,-0.15671,-0.20906,-0.22145,0.051212,-0.10953,-0.098229,-0.23478,-0.10249,-0.15614,-0.15382,-0.13868,0.015729,-0.056131,-0.28446,0.055868,-0.11805,-0.37487,-0.1078,-0.05234],[0.090212,0.0518,-0.033205,-0.10504,0.1157,-0.37388,-0.49108,0.33589,0.27866,0.082523,0.46155,0.02608,0.45271,-0.067789,0.21925,-0.036701,-0.13733,-0.20966,0.26553,-0.011996,0.089344,-0.10917,0.28264,-0.075956],[0.45923]]}");


const $acac2871e0f3fb91$export$fb9ba57710875005 = {
    Turkey: (0, (/*@__PURE__*/$parcel$interopDefault($3bc696fee26ae82f$exports))),
    Greece: (0, (/*@__PURE__*/$parcel$interopDefault($8bdb551622310ea8$exports))),
    Britain: (0, (/*@__PURE__*/$parcel$interopDefault($dad9dd4508e0afec$exports))),
    France: (0, (/*@__PURE__*/$parcel$interopDefault($8ccf5930526c44bf$exports))),
    Italy: (0, (/*@__PURE__*/$parcel$interopDefault($afdb9681881917c0$exports))),
    Armenia: (0, (/*@__PURE__*/$parcel$interopDefault($03dec46743c950ea$exports))),
    Bulgaria: (0, (/*@__PURE__*/$parcel$interopDefault($a042a931c6c31b48$exports)))
};








const $a0b376c94767994c$export$b9d1fef74bbc4c0c = (random, count)=>Array.from({
        length: count
    }, ()=>Math.floor(random.next() * 6) + 1).sort((left, right)=>right - left);
const $a0b376c94767994c$export$89aa21d8d7a6b270 = (attackerDice, defenderDice)=>{
    const losses = {
        attacker: 0,
        defender: 0
    };
    for(let index = 0; index < Math.min(attackerDice.length, defenderDice.length); index++)if (attackerDice[index] > defenderDice[index]) losses.defender++;
    else losses.attacker++;
    return losses;
};
const $a0b376c94767994c$var$rolls = (count)=>count === 0 ? [
        []
    ] : $a0b376c94767994c$var$rolls(count - 1).flatMap((rest)=>[
            1,
            2,
            3,
            4,
            5,
            6
        ].map((value)=>[
                value,
                ...rest
            ]));
const $a0b376c94767994c$var$EXCHANGE_ODDS = (()=>{
    const table = {};
    for(let attacker = 1; attacker <= 3; attacker++)for(let defender = 1; defender <= 3; defender++){
        const losses = {
            attacker: 0,
            defender: 0
        };
        let outcomes = 0;
        for (const attackerRolls of $a0b376c94767994c$var$rolls(attacker))for (const defenderRolls of $a0b376c94767994c$var$rolls(defender)){
            const exchange = $a0b376c94767994c$export$89aa21d8d7a6b270([
                ...attackerRolls
            ].sort((left, right)=>right - left), [
                ...defenderRolls
            ].sort((left, right)=>right - left));
            losses.attacker += exchange.attacker;
            losses.defender += exchange.defender;
            outcomes++;
        }
        table[`${attacker}v${defender}`] = {
            attacker: losses.attacker / outcomes,
            defender: losses.defender / outcomes
        };
    }
    return table;
})();
const $a0b376c94767994c$export$1e4cca5acc0a5d07 = (attackerDice, defenderDice)=>$a0b376c94767994c$var$EXCHANGE_ODDS[`${attackerDice}v${defenderDice}`];


class $730d23a0718a5f71$export$e496168c82ea3403 {
    game;
    active;
    pendingAdvance;
    landedOn;
    constructor(game){
        this.game = game;
        this.active = null;
        this.pendingAdvance = null;
        this.landedOn = [];
    }
    get hasActiveBattle() {
        return this.active !== null;
    }
    snapshot() {
        return {
            active: this.active ? {
                from: this.active.from.slug,
                to: this.active.to.slug,
                attackerLosses: this.active.attackerLosses,
                defenderLosses: this.active.defenderLosses,
                equippedUsed: this.active.equippedUsed
            } : null,
            pendingAdvance: this.pendingAdvance ? {
                ...this.pendingAdvance
            } : null,
            landedOn: [
                ...this.landedOn
            ]
        };
    }
    restore(snapshot) {
        this.active = snapshot.active ? {
            ...snapshot.active,
            from: this.game.bySlug[snapshot.active.from],
            to: this.game.bySlug[snapshot.active.to]
        } : null;
        if (this.active && (!this.active.from || !this.active.to)) throw new Error('Combat snapshot references unknown territory');
        this.pendingAdvance = snapshot.pendingAdvance ? {
            ...snapshot.pendingAdvance
        } : null;
        this.landedOn = [
            ...snapshot.landedOn
        ];
    }
    diceCaps(from, to) {
        const attacker = from.faction;
        const defender = to.faction;
        const sameBattle = this.active?.from === from && this.active?.to === to;
        const spent = sameBattle ? this.active?.equippedUsed ?? 0 : 0;
        return this.game.campaign.combatDice(attacker, defender, to, spent);
    }
    worthPressing(from, to) {
        if (from.troops < 2 || to.troops < 1) return false;
        const caps = this.diceCaps(from, to);
        const odds = (0, $a0b376c94767994c$export$1e4cca5acc0a5d07)(Math.min(caps.attacker, from.troops - 1), Math.min(caps.defender, to.troops));
        if (!odds || odds.defender <= odds.attacker) return false;
        const cost = to.troops * odds.attacker / odds.defender;
        return from.troops - 1 > cost;
    }
    targets(fromSlug) {
        const game = this.game;
        const from = game.bySlug[fromSlug];
        if (!from || game.turn.phase !== 'attack') return [];
        const attacker = from.faction;
        if (attacker !== game.turn.currentPlayer.faction || from.troops < 2 || game.campaign.frozen(attacker) || !from.adjacent.some((to)=>game.turn.canStartAttack(fromSlug, to.slug))) return [];
        return from.adjacent.filter((to)=>to.faction !== attacker && game.turn.canStartAttack(fromSlug, to.slug) && game.campaign.mayAttack(attacker, to.faction) && !game.campaign.frontClosed(attacker, to)).map((to)=>to.slug);
    }
    breakPeace(attacker, defender) {
        const game = this.game;
        if (!game.campaign.atPeace(defender)) return;
        const result = game.campaign.attackStarted(attacker, defender);
        if (result.peaceBroken) game.record(defender, 'log.peaceBroken', {
            attacker: (0, $99b5c8068df0b6a9$export$b827813b2cbfb4b1)(attacker.name),
            defender: (0, $99b5c8068df0b6a9$export$b827813b2cbfb4b1)(defender.name)
        }, true);
        const troops = result.remobilized;
        if (troops > 0) game.record(defender, 'log.armeniaRemobilizes', {
            n: troops
        }, true);
    }
    resolveAttack(fromSlug, toSlug) {
        const game = this.game;
        if (game.turn.phase !== 'attack') return null;
        const from = game.bySlug[fromSlug];
        const to = game.bySlug[toSlug];
        if (!from || !to) return null;
        const attacker = from.faction;
        const defender = to.faction;
        const continuing = this.active?.from === from && this.active?.to === to;
        if (attacker !== game.turn.currentPlayer.faction || defender === attacker) return null;
        if (!from.isAdjacentTo(to) || from.troops < 2) return null;
        if (!game.campaign.mayAttack(attacker, defender) || game.campaign.frontClosed(attacker, to) || game.campaign.frozen(attacker)) return null;
        if (!continuing && !game.turn.canStartAttack(fromSlug, toSlug)) return null;
        return {
            from: from,
            to: to,
            attacker: attacker,
            defender: defender
        };
    }
    ensureActive(context) {
        const { from: from, to: to, attacker: attacker, defender: defender } = context;
        // Retargeting abandons the setup for the previous attack. That's a change of
        // mind, not a repel — reset silently so it neither logs a repel nor triggers
        // the pull-back sound the log observer would otherwise voice.
        if (this.active && (this.active.from !== from || this.active.to !== to)) this.cancel();
        if (this.active) return this.active;
        if (!this.game.turn.useAttack(from.slug, to.slug)) return null;
        this.active = {
            from: from,
            to: to,
            attackerLosses: 0,
            defenderLosses: 0
        };
        if (attacker.alliance !== 'turkey' && defender.alliance === 'turkey') from.raidedOn = this.game.turn.round;
        defender.grudges.add(attacker.name);
        to.quietTurns = 0;
        this.breakPeace(attacker, defender);
        return this.active;
    }
    begin(fromSlug, toSlug) {
        if (this.pendingAdvance) this.advance(0);
        const context = this.resolveAttack(fromSlug, toSlug);
        if (!context) return null;
        const { from: from, to: to, attacker: attacker, defender: defender } = context;
        // Choosing a target only stages the battle for the UI. The operational
        // budget and diplomatic consequences belong to the first dice exchange,
        // when the player actually commits to the attack.
        if (this.active && (this.active.from !== from || this.active.to !== to)) this.cancel();
        const battle = this.active;
        return {
            from: from,
            to: to,
            attacker: attacker,
            defender: defender,
            rounds: [],
            conquered: false,
            attackerLosses: battle?.attackerLosses ?? 0,
            defenderLosses: battle?.defenderLosses ?? 0,
            troopsMoved: 0,
            eliminatedFaction: null,
            pending: true
        };
    }
    step(fromSlug, toSlug) {
        const game = this.game;
        const context = this.resolveAttack(fromSlug, toSlug);
        if (!context) return null;
        const { from: from, to: to, attacker: attacker, defender: defender } = context;
        const battle = this.ensureActive(context);
        if (!battle) return null;
        const caps = this.diceCaps(from, to);
        if (caps.equipped) battle.equippedUsed = (battle.equippedUsed ?? 0) + 1;
        const attackerDice = (0, $a0b376c94767994c$export$b9d1fef74bbc4c0c)(game.random, Math.min(caps.attacker, from.troops - 1));
        const defenderDice = (0, $a0b376c94767994c$export$b9d1fef74bbc4c0c)(game.random, Math.min(caps.defender, to.troops));
        const { attacker: attackerLosses, defender: defenderLosses } = (0, $a0b376c94767994c$export$89aa21d8d7a6b270)(attackerDice, defenderDice);
        from.troops -= attackerLosses;
        to.troops -= defenderLosses;
        battle.attackerLosses += attackerLosses;
        battle.defenderLosses += defenderLosses;
        const round = {
            attackerDice: attackerDice,
            defenderDice: defenderDice,
            attackerLosses: attackerLosses,
            defenderLosses: defenderLosses
        };
        let conquered = false;
        let troopsMoved = 0;
        let eliminatedFaction = null;
        if (to.troops === 0) {
            conquered = true;
            game.turn.recordConquest(from.slug, to.slug);
            const occupiedFor = game.turn.round - to.heldSince;
            game.board.changeControl(to, attacker, game.turn.round);
            const max = from.troops - 1;
            const min = Math.min(attackerDice.length, max);
            troopsMoved = attacker === game.humanPlayer.faction ? min : max;
            from.troops -= troopsMoved;
            to.troops = troopsMoved;
            this.pendingAdvance = attacker === game.humanPlayer.faction && max > min ? {
                from: from.slug,
                to: to.slug,
                min: min,
                max: max
            } : null;
            game.campaign.territoryCaptured(attacker, to, occupiedFor);
            if (defender.eliminated) {
                eliminatedFaction = defender;
                attacker.hand.push(...defender.hand);
                defender.hand = [];
                game.record(defender, 'log.knockedOut', {
                    faction: (0, $99b5c8068df0b6a9$export$b827813b2cbfb4b1)(defender.name)
                });
            }
        }
        const pending = !conquered && from.troops > 1 && to.troops > 0;
        const totalAttackerLosses = battle.attackerLosses;
        const totalDefenderLosses = battle.defenderLosses;
        if (conquered) {
            game.record(attacker, 'log.captured', {
                attacker: (0, $99b5c8068df0b6a9$export$b827813b2cbfb4b1)(attacker.name),
                territory: (0, $99b5c8068df0b6a9$export$1a920137df84177e)(to.slug, to.name),
                territoryAcc: (0, $99b5c8068df0b6a9$export$1a920137df84177e)(to.slug, to.name, 'acc'),
                defender: (0, $99b5c8068df0b6a9$export$b827813b2cbfb4b1)(defender.name),
                atkLoss: totalAttackerLosses,
                defLoss: totalDefenderLosses
            });
            this.active = null;
        } else if (!pending) {
            this.logRepel(attacker, defender, to, totalAttackerLosses, totalDefenderLosses);
            this.active = null;
        }
        game.checkGameEnd();
        return {
            from: from,
            to: to,
            attacker: attacker,
            defender: defender,
            rounds: [
                round
            ],
            conquered: conquered,
            attackerLosses: totalAttackerLosses,
            defenderLosses: totalDefenderLosses,
            troopsMoved: troopsMoved,
            eliminatedFaction: eliminatedFaction,
            pending: pending
        };
    }
    advance(count) {
        const move = this.pendingAdvance;
        if (!move) return 0;
        const from = this.game.bySlug[move.from];
        const to = this.game.bySlug[move.to];
        this.pendingAdvance = null;
        const wanted = Math.min(Math.max(count, move.min), move.max);
        const extra = wanted - move.min;
        if (extra > 0) {
            from.troops -= extra;
            to.troops += extra;
        }
        return to.troops;
    }
    logRepel(attacker, defender, to, attackerLosses, defenderLosses) {
        this.game.record(attacker, 'log.repelled', {
            attacker: (0, $99b5c8068df0b6a9$export$b827813b2cbfb4b1)(attacker.name),
            territory: (0, $99b5c8068df0b6a9$export$1a920137df84177e)(to.slug, to.name),
            territoryDat: (0, $99b5c8068df0b6a9$export$1a920137df84177e)(to.slug, to.name, 'dat'),
            defender: (0, $99b5c8068df0b6a9$export$b827813b2cbfb4b1)(defender.name),
            atkLoss: attackerLosses,
            defLoss: defenderLosses
        });
    }
    cancel() {
        this.active = null;
    }
    pullBack() {
        const battle = this.active;
        if (!battle) return;
        this.active = null;
        this.logRepel(battle.from.faction, battle.to.faction, battle.to, battle.attackerLosses, battle.defenderLosses);
    }
    blitz(fromSlug, toSlug) {
        let last = null;
        let result = this.step(fromSlug, toSlug);
        while(result){
            last = result;
            if (!result.pending) break;
            result = this.step(fromSlug, toSlug);
        }
        return last;
    }
    land(power, site, strength) {
        const game = this.game;
        const defender = site.faction;
        if (defender.alliance === power.alliance) {
            site.troops += strength;
            game.record(power, 'log.landingUnopposed', {
                faction: (0, $99b5c8068df0b6a9$export$b827813b2cbfb4b1)(power.name),
                territory: (0, $99b5c8068df0b6a9$export$1a920137df84177e)(site.slug, site.name),
                n: strength
            }, true);
            return;
        }
        let attackers = strength;
        let defenders = site.troops;
        const caps = game.campaign.combatDice(power, defender, site, Number.MAX_SAFE_INTEGER, 'landing');
        const attackerCap = caps.attacker;
        const defenderCap = caps.defender;
        while(attackers > 0 && defenders > 0){
            const attackDice = (0, $a0b376c94767994c$export$b9d1fef74bbc4c0c)(game.random, Math.min(attackerCap, attackers));
            const defenceDice = (0, $a0b376c94767994c$export$b9d1fef74bbc4c0c)(game.random, Math.min(defenderCap, defenders));
            const losses = (0, $a0b376c94767994c$export$89aa21d8d7a6b270)(attackDice, defenceDice);
            attackers -= losses.attacker;
            defenders -= losses.defender;
        }
        if (defenders > 0) {
            site.troops = defenders;
            game.record(power, 'log.landingRepelled', {
                faction: (0, $99b5c8068df0b6a9$export$b827813b2cbfb4b1)(power.name),
                territory: (0, $99b5c8068df0b6a9$export$1a920137df84177e)(site.slug, site.name),
                n: strength
            }, true);
            return;
        }
        game.board.changeControl(site, power, game.turn.round);
        site.troops = Math.max(1, attackers);
        site.raidedOn = game.turn.round;
        if (!this.landedOn.includes(site.slug)) this.landedOn.push(site.slug);
        defender.grudges.add(power.name);
        power.peaceBroken = true;
        game.record(power, 'log.landing', {
            faction: (0, $99b5c8068df0b6a9$export$b827813b2cbfb4b1)(power.name),
            territory: (0, $99b5c8068df0b6a9$export$1a920137df84177e)(site.slug, site.name),
            n: site.troops
        }, true);
        game.checkGameEnd();
    }
}







class $cad0226104c464a9$export$241853d5920ec2ac {
    game;
    variables;
    retries;
    checkedOn;
    announcedEvents;
    pendingCards;
    pendingDecision;
    constructor(game){
        this.game = game;
        this.variables = (0, $5fc948bed93bbc7c$export$b59a2891c59b34d8).initialVariables();
        this.retries = {};
        this.checkedOn = {};
        this.announcedEvents = new Set();
        this.pendingCards = [];
        this.pendingDecision = null;
    }
    snapshot() {
        return {
            variables: structuredClone(this.variables),
            retries: {
                ...this.retries
            },
            checkedOn: {
                ...this.checkedOn
            },
            announcedEvents: [
                ...this.announcedEvents
            ],
            pendingCards: [
                ...this.pendingCards
            ],
            pendingDecision: this.pendingDecision?.id ?? null
        };
    }
    restore(snapshot) {
        this.variables = structuredClone(snapshot.variables);
        this.retries = {
            ...snapshot.retries
        };
        this.checkedOn = {
            ...snapshot.checkedOn
        };
        this.announcedEvents = new Set(snapshot.announcedEvents);
        this.pendingCards = [
            ...snapshot.pendingCards
        ];
        this.pendingDecision = snapshot.pendingDecision ? (0, $5fc948bed93bbc7c$export$b59a2891c59b34d8).events.find((event)=>event.id === snapshot.pendingDecision) ?? null : null;
    }
    resultNumber(root, path) {
        const value = (0, $4b381e23cd3413de$export$2aa3fd96c49a84a8)(root, path);
        if (typeof value !== 'number' || !Number.isFinite(value)) throw new Error(`Rule result ${path} must be a finite number`);
        return value;
    }
    resultBoolean(root, path) {
        const value = (0, $4b381e23cd3413de$export$2aa3fd96c49a84a8)(root, path);
        if (typeof value !== 'boolean') throw new Error(`Rule result ${path} must be a boolean`);
        return value;
    }
    permissionMatches(permission, attacker, defender) {
        return (!permission.attacker || permission.attacker === attacker.name) && (!permission.attackerAlliance || permission.attackerAlliance === attacker.alliance) && (!permission.defender || permission.defender === defender.name) && (!permission.defenderAlliance || permission.defenderAlliance === defender.alliance);
    }
    fireRules(trigger, extraRoot = {}) {
        return (0, $5fc948bed93bbc7c$export$b59a2891c59b34d8).fireRules(trigger, this.game, extraRoot);
    }
    turnStarted(faction) {
        this.fireRules('turn.started', {
            action: {
                faction: faction.name
            }
        });
    }
    roundUpkeep() {
        this.fireRules('round.upkeep');
    }
    territoryCaptured(attacker, target, occupiedFor) {
        this.fireRules('territory.captured', {
            action: {
                attacker: attacker.name,
                attackerAlliance: attacker.alliance,
                target: {
                    slug: target.slug
                },
                occupiedFor: occupiedFor
            }
        });
    }
    combatDice(attacker, defender, target, exchangesSpent, kind = 'battle') {
        const evaluated = this.fireRules('combatDice.calculate', {
            action: {
                kind: kind,
                attacker: attacker.name,
                attackerAlliance: attacker.alliance,
                defender: defender.name,
                defenderAlliance: defender.alliance,
                target: {
                    slug: target.slug
                },
                exchangesSpent: exchangesSpent
            },
            result: {
                attacker: 3,
                defender: 2,
                equipped: false
            }
        });
        return {
            attacker: this.resultNumber(evaluated.root, 'result.attacker'),
            defender: this.resultNumber(evaluated.root, 'result.defender'),
            equipped: this.resultBoolean(evaluated.root, 'result.equipped')
        };
    }
    attackStarted(attacker, defender) {
        const result = this.fireRules('attack.started', {
            action: {
                attacker: attacker.name,
                defender: defender.name,
                defenderAtPeace: true
            },
            result: {
                peaceBroken: false,
                remobilized: 0
            }
        });
        return {
            peaceBroken: this.resultBoolean(result.root, 'result.peaceBroken'),
            remobilized: this.resultNumber(result.root, 'result.remobilized')
        };
    }
    get attackLimit() {
        const faction = this.game.turn.currentPlayer.faction;
        const evaluated = this.fireRules('attackLimit.calculate', {
            action: {
                faction: faction.name
            },
            result: {
                value: (0, $9ff2839edea1890c$export$9b928fc5e710e864).combat.attacksPerTurn
            }
        });
        return Math.max(0, Math.trunc(this.resultNumber(evaluated.root, 'result.value')));
    }
    maximumAdvanceDepth(targetSlug) {
        const faction = this.game.turn.currentPlayer.faction;
        const target = this.game.bySlug[targetSlug];
        if (!target) return 0;
        const homeland = (0, $a57adc7b3bbfe58c$export$8ca11ae64af8ab3e)[target.slug] === faction.name;
        const evaluated = this.fireRules('maximumAdvanceDepth.calculate', {
            action: {
                faction: faction.name,
                target: {
                    slug: target.slug
                }
            },
            result: {
                value: homeland ? (0, $9ff2839edea1890c$export$9b928fc5e710e864).combat.advanceDepth.homeland : (0, $9ff2839edea1890c$export$9b928fc5e710e864).combat.advanceDepth.foreign
            }
        });
        return Math.max(0, Math.trunc(this.resultNumber(evaluated.root, 'result.value')));
    }
    get fortifyLimit() {
        const faction = this.game.turn.currentPlayer.faction;
        const base = (0, $9ff2839edea1890c$export$9b928fc5e710e864).economy.fortifyLimitByFaction[faction.name] ?? (0, $9ff2839edea1890c$export$9b928fc5e710e864).economy.defaultFortifyLimit;
        const evaluated = this.fireRules('fortifyLimit.calculate', {
            action: {
                faction: faction.name
            },
            result: {
                value: base
            }
        });
        return this.resultNumber(evaluated.root, 'result.value');
    }
    transferCapacity(from, to, base) {
        const evaluated = this.fireRules('transferCapacity.calculate', {
            action: {
                faction: from.faction.name,
                from: {
                    slug: from.slug
                },
                to: {
                    slug: to.slug
                }
            },
            result: {
                value: base
            }
        });
        return Math.max(0, Math.trunc(this.resultNumber(evaluated.root, 'result.value')));
    }
    reinforcementsFor(faction) {
        const occupiedTerritories = (0, $a57adc7b3bbfe58c$export$59d67d3ae020dbb)((0, $9ff2839edea1890c$export$9b928fc5e710e864).movement.occupiedTerritoryGroup);
        const homeTerritoryCount = faction.territories.filter((territory)=>!occupiedTerritories.includes(territory.slug)).length;
        const base = Math.max((0, $9ff2839edea1890c$export$9b928fc5e710e864).economy.minimumReinforcements, Math.floor(faction.territories.length / (0, $9ff2839edea1890c$export$9b928fc5e710e864).economy.territoriesPerReinforcement));
        const evaluated = this.fireRules('reinforcements.calculate', {
            action: {
                faction: faction.name,
                alliance: faction.alliance,
                peaceBroken: faction.peaceBroken,
                homeTerritoryCount: homeTerritoryCount
            },
            result: {
                value: base
            }
        });
        return this.resultNumber(evaluated.root, 'result.value');
    }
    isPassive(faction) {
        const status = this.fireRules('faction.peaceStatus', {
            action: {
                faction: faction.name,
                peaceBroken: faction.peaceBroken
            },
            result: {
                passive: false,
                atPeace: false
            }
        });
        return this.resultBoolean(status.root, 'result.passive');
    }
    atPeace(faction) {
        const status = this.fireRules('faction.peaceStatus', {
            action: {
                faction: faction.name,
                peaceBroken: faction.peaceBroken
            },
            result: {
                passive: false,
                atPeace: false
            }
        });
        return this.resultBoolean(status.root, 'result.atPeace');
    }
    /**
   * Has this faction settled out of the war — signed its treaty or withdrawn —
   * regardless of whether that peace has since been broken? Peace is bilateral:
   * a third party breaking a settled faction's peace (Britain hitting a withdrawn
   * France) must not reopen its war with everyone else. We detect the settlement
   * by asking the peace-status rules as if the peace were intact (peaceBroken
   * forced false), so a broken peace with ONE attacker cannot hide it.
   */ hasSettled(faction) {
        const status = this.fireRules('faction.peaceStatus', {
            action: {
                faction: faction.name,
                peaceBroken: false
            },
            result: {
                passive: false,
                atPeace: false
            }
        });
        return this.resultBoolean(status.root, 'result.atPeace');
    }
    frontClosed(attacker, target) {
        const game = this.game;
        const validation = this.fireRules('attack.target.validate', {
            action: {
                attacker: attacker.name,
                attackerAlliance: attacker.alliance,
                defender: target.faction.name,
                target: {
                    slug: target.slug
                },
                targetLandedOn: game.combat.landedOn.includes(target.slug),
                retaliationActive: target.raidedOn > 0 && game.turn.round - target.raidedOn <= (0, $9ff2839edea1890c$export$9b928fc5e710e864).retaliationWindow
            },
            result: {
                allowed: true
            }
        });
        return !this.resultBoolean(validation.root, 'result.allowed');
    }
    frozen(faction) {
        const evaluated = this.fireRules('faction.turnStatus', {
            action: {
                faction: faction.name
            },
            result: {
                frozen: false
            }
        });
        return this.resultBoolean(evaluated.root, 'result.frozen');
    }
    mayAttack(attacker, defender) {
        const validation = this.fireRules('attack.validate', {
            action: {
                attacker: attacker.name,
                attackerAlliance: attacker.alliance,
                defender: defender.name
            },
            result: {
                allowed: true
            }
        });
        if (!this.resultBoolean(validation.root, 'result.allowed')) return false;
        if ((0, $9ff2839edea1890c$export$9b928fc5e710e864).diplomacy.grudgesOverride && attacker.grudges.has(defender.name)) return true;
        // Peace is reciprocal between two countries, not blanket passivism. A faction
        // that has settled out of the war may only fight factions that actually
        // attacked it (its grudges); it will NOT resume the war against the country it
        // made peace with just because a third party broke its peace elsewhere.
        if (this.hasSettled(attacker)) return attacker.grudges.has(defender.name);
        return (0, $9ff2839edea1890c$export$9b928fc5e710e864).diplomacy.permissions.some((permission)=>this.permissionMatches(permission, attacker, defender));
    }
    dispatch() {
        const game = this.game;
        (0, $5fc948bed93bbc7c$export$b59a2891c59b34d8).dispatch({
            context: game,
            round: game.turn.round,
            isHumanTurn: game.turn.currentPlayer.isHuman,
            hasPendingDecision: ()=>!!this.pendingDecision,
            hasFired: (id)=>this.announcedEvents.has(id),
            markFired: (id)=>this.announcedEvents.add(id),
            gateLastChecked: (id)=>this.checkedOn[id],
            setGateLastChecked: (id, round)=>{
                this.checkedOn[id] = round;
            },
            gateAttempts: (id)=>this.retries[id] ?? 0,
            setGateAttempts: (id, attempts)=>{
                this.retries[id] = attempts;
            },
            actorEliminated: (actor)=>game.factions.find((faction)=>faction.name === actor)?.eliminated ?? false,
            announce: (event, scope)=>{
                const actor = game.factions.find((faction)=>faction.name === event.actor) ?? null;
                game.record(actor, event.id, event.vars?.(game, scope), true);
            },
            queueCard: (id)=>this.pendingCards.push(id),
            setPendingDecision: (event)=>{
                this.pendingDecision = event;
            }
        });
    }
    resolveDecision(choiceKey) {
        const event = this.pendingDecision;
        if (!event || !event.choices?.some((choice)=>choice.key === choiceKey)) return;
        this.pendingDecision = null;
        this.game.record(this.game.turn.currentPlayer.faction, `${event.id}.${choiceKey}.log`, {}, true);
        (0, $5fc948bed93bbc7c$export$b59a2891c59b34d8).resolveChoice(event, choiceKey, this.game, this.game.turn.round);
        this.dispatch();
    }
    clearCards() {
        this.pendingCards.length = 0;
    }
}


class $99c858922c80c557$export$2e2bcd8739ae039 {
    name;
    color;
    territories;
    alliance;
    // factions that attacked us — fair game for retaliation regardless of alliance
    grudges;
    // set when someone attacks this faction after it settled out of the war:
    // the peace is void, it mobilizes and fights on despite the treaty events
    peaceBroken;
    hand;
    constructor(name, color, alliance){
        this.name = name;
        this.color = color;
        this.territories = [];
        this.alliance = alliance;
        this.grudges = new Set();
        this.peaceBroken = false;
        this.hand = [];
    }
    get eliminated() {
        return this.territories.length === 0;
    }
    get troopTotal() {
        return this.territories.reduce((sum, t)=>sum + t.troops, 0);
    }
}


class $aee1ec662dd9e32d$export$2e2bcd8739ae039 {
    name;
    faction;
    isHuman;
    successions;
    constructor(name, faction, isHuman, successions = []){
        this.name = name;
        this.faction = faction;
        this.isHuman = isHuman;
        this.successions = successions;
    }
}


class $d191186039bcf8f8$export$2e2bcd8739ae039 {
    slug;
    name;
    faction;
    troops;
    adjacent;
    // Occupation entrenchment (see Game.entrench): turns this province has gone
    // uncontested, and how many free garrison troops it has already drawn.
    quietTurns;
    entrenched;
    // the round this province last changed hands, so liberation can tell a
    // province snatched back immediately from one the enemy has settled into
    heldSince;
    // the round this province last attacked the homeland from
    raidedOn;
    constructor(slug, name, faction){
        this.slug = slug;
        this.name = name;
        this.faction = faction;
        this.troops = 0;
        this.adjacent = [];
        this.quietTurns = 0;
        this.entrenched = 0;
        this.heldSince = 1;
        this.raidedOn = 0;
    }
    isAdjacentTo(other) {
        return this.adjacent.includes(other);
    }
}



var $b073e0ab7b1a5293$exports = {};
$b073e0ab7b1a5293$exports = JSON.parse('{"territories":[{"name":"Edirne","slug":"edirne","adjacentTerritories":["burgas","western-thrace","istanbul","gelibolu"]},{"name":"Bal\u0131kesir","slug":"balikesir","adjacentTerritories":["lesbos","usak","izmir","canakkale","eskisehir"]},{"name":"U\u015Fak","slug":"usak","adjacentTerritories":["isparta","balikesir","izmir","aydin","eskisehir","kutahya"]},{"name":"Eski\u015Fehir","slug":"eskisehir","adjacentTerritories":["ankara","usak","izmit","sakarya","konya","balikesir","kutahya","kastamonu"]},{"name":"K\xfctahya","slug":"kutahya","adjacentTerritories":["usak","konya","eskisehir","isparta"]},{"name":"Ankara","slug":"ankara","adjacentTerritories":["kastamonu","sivas","konya","eskisehir"]},{"name":"Konya","slug":"konya","adjacentTerritories":["antalya","isparta","sivas","ankara","adana","eskisehir","kutahya"]},{"name":"Sivas","slug":"sivas","adjacentTerritories":["samsun","kastamonu","ankara","adana","maras","erzurum","konya","trabzon","elazig"]},{"name":"Kastamonu","slug":"kastamonu","adjacentTerritories":["samsun","sivas","ankara","sakarya","eskisehir"]},{"name":"Samsun","slug":"samsun","adjacentTerritories":["kastamonu","sivas","trabzon"]},{"name":"Trabzon","slug":"trabzon","adjacentTerritories":["samsun","sivas","erzurum","kars","gyumri"]},{"name":"Erzurum","slug":"erzurum","adjacentTerritories":["sivas","van","igdir","kars","trabzon","elazig","diyarbakir"]},{"name":"Van","slug":"van","adjacentTerritories":["erzurum","mosul","diyarbakir","aleppo"]},{"name":"Elaz\u0131\u011F","slug":"elazig","adjacentTerritories":["sivas","maras","erzurum","diyarbakir"]},{"name":"Diyarbak\u0131r","slug":"diyarbakir","adjacentTerritories":["maras","erzurum","van","elazig","aleppo"]},{"name":"Salonica","slug":"salonica","adjacentTerritories":["western-thrace","plovdiv","kozani"]},{"name":"Kozani","slug":"kozani","adjacentTerritories":["salonica"]},{"name":"Western Thrace","slug":"western-thrace","adjacentTerritories":["burgas","edirne","salonica","plovdiv"]},{"name":"Lesbos","slug":"lesbos","adjacentTerritories":["balikesir","izmir"]},{"name":"Rhodes","slug":"rhodes","adjacentTerritories":["aydin"]},{"name":"\u0130zmir","slug":"izmir","adjacentTerritories":["lesbos","usak","balikesir","aydin"]},{"name":"Ayd\u0131n","slug":"aydin","adjacentTerritories":["antalya","isparta","usak","izmir","rhodes"]},{"name":"Sofia","slug":"sofia","adjacentTerritories":["varna","plovdiv"]},{"name":"Plovdiv","slug":"plovdiv","adjacentTerritories":["burgas","western-thrace","salonica","sofia"]},{"name":"Varna","slug":"varna","adjacentTerritories":["burgas","sofia"]},{"name":"Burgas","slug":"burgas","adjacentTerritories":["varna","western-thrace","edirne","plovdiv"]},{"name":"Gyumri","slug":"gyumri","adjacentTerritories":["vanadzor","kars","yerevan","trabzon"]},{"name":"Yerevan","slug":"yerevan","adjacentTerritories":["vanadzor","sevan","igdir","kars","gyumri"]},{"name":"Vanadzor","slug":"vanadzor","adjacentTerritories":["sevan","gyumri","yerevan"]},{"name":"Sevan","slug":"sevan","adjacentTerritories":["vanadzor","yerevan"]},{"name":"Antalya","slug":"antalya","adjacentTerritories":["isparta","adana","konya","aydin"]},{"name":"Isparta","slug":"isparta","adjacentTerritories":["antalya","usak","konya","aydin","kutahya"]},{"name":"\u0130stanbul","slug":"istanbul","adjacentTerritories":["edirne","izmit","gelibolu","canakkale"]},{"name":"\u0130zmit","slug":"izmit","adjacentTerritories":["istanbul","sakarya","gelibolu","eskisehir"]},{"name":"Gelibolu","slug":"gelibolu","adjacentTerritories":["edirne","izmit","istanbul","canakkale"]},{"name":"\xc7anakkale","slug":"canakkale","adjacentTerritories":["balikesir","gelibolu","istanbul"]},{"name":"Sakarya","slug":"sakarya","adjacentTerritories":["kastamonu","izmit","eskisehir"]},{"name":"Adana","slug":"adana","adjacentTerritories":["antalya","sivas","maras","konya"]},{"name":"Mara\u015F","slug":"maras","adjacentTerritories":["sivas","adana","hatay","elazig","diyarbakir","aleppo"]},{"name":"Hatay","slug":"hatay","adjacentTerritories":["maras","aleppo"]},{"name":"Aleppo","slug":"aleppo","adjacentTerritories":["maras","van","hatay","mosul","baghdad","diyarbakir"]},{"name":"Mosul","slug":"mosul","adjacentTerritories":["van","baghdad","aleppo"]},{"name":"Baghdad","slug":"baghdad","adjacentTerritories":["mosul","aleppo"]},{"name":"Kars","slug":"kars","adjacentTerritories":["erzurum","igdir","trabzon","gyumri","yerevan"]},{"name":"I\u011Fd\u0131r","slug":"igdir","adjacentTerritories":["erzurum","kars","yerevan"]}]}');


var $3282ab88df18ec90$exports = {};
$3282ab88df18ec90$exports = JSON.parse("{\"players\":[{\"name\":\"Mustafa Kemal\",\"type\":\"Human\",\"faction\":\"Turkey\"},{\"name\":\"Eleftherios Venizelos\",\"type\":\"AI\",\"faction\":\"Greece\",\"successions\":[{\"variable\":\"venizelos.fell\",\"name\":\"Dimitrios Rallis\"}]},{\"name\":\"Aleksandar Stamboliyski\",\"type\":\"AI\",\"faction\":\"Bulgaria\"},{\"name\":\"Hovhannes Kajaznuni\",\"type\":\"AI\",\"faction\":\"Armenia\"},{\"name\":\"Vittorio Emanuele Orlando\",\"type\":\"AI\",\"faction\":\"Italy\"},{\"name\":\"David Lloyd George\",\"type\":\"AI\",\"faction\":\"Britain\",\"successions\":[{\"variable\":\"britain.stoodDown\",\"name\":\"Andrew Bonar Law\"}]},{\"name\":\"Georges Clemenceau\",\"type\":\"AI\",\"faction\":\"France\"}]}");



const $3089cb7f00c26c5f$var$validateScenarioReferences = (factions, bySlug)=>{
    const factionNames = new Set(factions.map((faction)=>faction.name));
    const territoryNames = new Set(Object.keys(bySlug));
    for (const name of Object.keys((0, $9ff2839edea1890c$export$9b928fc5e710e864).alliances))if (!factionNames.has(name)) throw new Error(`Scenario assigns an alliance to unknown faction ${name}`);
    for (const name of (0, $9ff2839edea1890c$export$9b928fc5e710e864).movement.navies)if (!factionNames.has(name)) throw new Error(`Scenario assigns a navy to unknown faction ${name}`);
    for (const lane of (0, $9ff2839edea1890c$export$9b928fc5e710e864).movement.seaLanes)for (const slug of lane.ports)if (!territoryNames.has(slug)) throw new Error(`Scenario sea lane references unknown territory ${slug}`);
    for (const slug of (0, $9ff2839edea1890c$export$9b928fc5e710e864).presentation.governmentSeats)if (!territoryNames.has(slug)) throw new Error(`Scenario government seat references unknown territory ${slug}`);
    if (!factionNames.has((0, $9ff2839edea1890c$export$9b928fc5e710e864).presentation.governmentFaction)) throw new Error(`Scenario presentation references unknown faction ${(0, $9ff2839edea1890c$export$9b928fc5e710e864).presentation.governmentFaction}`);
    for (const permission of (0, $9ff2839edea1890c$export$9b928fc5e710e864).diplomacy.permissions){
        if (permission.attacker && !factionNames.has(permission.attacker)) throw new Error(`Scenario diplomacy references unknown attacker ${permission.attacker}`);
        if (permission.defender && !factionNames.has(permission.defender)) throw new Error(`Scenario diplomacy references unknown defender ${permission.defender}`);
    }
};
const $3089cb7f00c26c5f$export$68cc31194f942de7 = ()=>{
    const factions = (0, (/*@__PURE__*/$parcel$interopDefault($1dee7a0df1696628$exports))).factions.map((faction)=>{
        const alliance = (0, $9ff2839edea1890c$export$9b928fc5e710e864).alliances[faction.name];
        if (!alliance) throw new Error(`Scenario does not assign an alliance to ${faction.name}`);
        return new (0, $99c858922c80c557$export$2e2bcd8739ae039)(faction.name, faction.color, alliance);
    });
    const nameBySlug = Object.fromEntries((0, (/*@__PURE__*/$parcel$interopDefault($b073e0ab7b1a5293$exports))).territories.map((territory)=>[
            territory.slug,
            territory.name
        ]));
    const bySlug = {};
    (0, (/*@__PURE__*/$parcel$interopDefault($1dee7a0df1696628$exports))).factions.forEach((faction, index)=>{
        faction.territories.forEach(({ slug: slug, troops: troops })=>{
            if (bySlug[slug]) throw new Error(`Territory ${slug} has more than one setup owner`);
            const territory = new (0, $d191186039bcf8f8$export$2e2bcd8739ae039)(slug, nameBySlug[slug] ?? slug, factions[index]);
            territory.troops = troops;
            factions[index].territories.push(territory);
            bySlug[slug] = territory;
        });
    });
    const territories = Object.values(bySlug);
    (0, (/*@__PURE__*/$parcel$interopDefault($b073e0ab7b1a5293$exports))).territories.forEach((record)=>{
        const territory = bySlug[record.slug];
        if (!territory) throw new Error(`Territory ${record.slug} has no setup owner`);
        record.adjacentTerritories.forEach((slug)=>{
            const adjacent = bySlug[slug];
            if (!adjacent) throw new Error(`Territory ${record.slug} references unknown adjacent territory ${slug}`);
            if (!territory.adjacent.includes(adjacent)) territory.adjacent.push(adjacent);
        });
    });
    $3089cb7f00c26c5f$var$validateScenarioReferences(factions, bySlug);
    const players = (0, (/*@__PURE__*/$parcel$interopDefault($3282ab88df18ec90$exports))).players.map((record)=>{
        const faction = factions.find((candidate)=>candidate.name === record.faction);
        if (!faction) throw new Error(`Player ${record.name} references unknown faction ${record.faction}`);
        const successions = 'successions' in record ? record.successions : [];
        return new (0, $aee1ec662dd9e32d$export$2e2bcd8739ae039)(record.name, faction, record.type === 'Human', successions);
    });
    const humans = players.filter((player)=>player.isHuman);
    if (humans.length !== 1 || humans[0].faction.name !== (0, $9ff2839edea1890c$export$9b928fc5e710e864).humanFaction) throw new Error(`Scenario requires exactly one human player for ${(0, $9ff2839edea1890c$export$9b928fc5e710e864).humanFaction}`);
    return {
        factions: factions,
        players: players,
        territories: territories,
        bySlug: bySlug
    };
};


const $a6c552c289be4d32$var$initialState = ()=>({
        id: 0,
        round: 1,
        playerIndex: 0,
        phase: 'reinforce',
        reinforcements: {
            granted: 0,
            remaining: 0
        },
        attacks: {
            used: 0,
            advanceDepth: {}
        },
        fortifiesUsed: 0,
        conqueredTerritory: false,
        liberatedHomeland: false,
        awaitingLanding: false
    });
class $a6c552c289be4d32$export$b2527ed6b3e49916 {
    game;
    #state = $a6c552c289be4d32$var$initialState();
    constructor(game){
        this.game = game;
    }
    get state() {
        const state = this.#state;
        return {
            ...state,
            reinforcements: {
                ...state.reinforcements
            },
            attacks: {
                used: state.attacks.used,
                advanceDepth: {
                    ...state.attacks.advanceDepth
                }
            }
        };
    }
    get id() {
        return this.#state.id;
    }
    get round() {
        return this.#state.round;
    }
    get playerIndex() {
        return this.#state.playerIndex;
    }
    get phase() {
        return this.#state.phase;
    }
    get isGameOver() {
        return this.#state.phase === 'gameover';
    }
    get reinforcementsGranted() {
        return this.#state.reinforcements.granted;
    }
    get reinforcementsLeft() {
        return this.#state.reinforcements.remaining;
    }
    get attacksUsed() {
        return this.#state.attacks.used;
    }
    get attackLimit() {
        return this.game.campaign.attackLimit;
    }
    get attacksLeft() {
        return Math.max(0, this.attackLimit - this.attacksUsed);
    }
    get fortifiesUsed() {
        return this.#state.fortifiesUsed;
    }
    get conqueredTerritory() {
        return this.#state.conqueredTerritory;
    }
    get liberatedHomeland() {
        return this.#state.liberatedHomeland;
    }
    /** The seat is taken but the turn is paused on a human landing decision. */ get awaitingLanding() {
        return this.#state.awaitingLanding;
    }
    get currentPlayer() {
        return this.game.players[this.#state.playerIndex];
    }
    isCurrent(id) {
        return this.#state.id === id;
    }
    snapshot() {
        return {
            ...this.#state,
            reinforcements: {
                ...this.#state.reinforcements
            },
            attacks: {
                used: this.#state.attacks.used,
                advanceDepth: {
                    ...this.#state.attacks.advanceDepth
                }
            }
        };
    }
    /** Restores one atomic, validated turn state from persistence or scenario tooling. */ restore(state) {
        const playerIndex = Math.trunc(state.playerIndex);
        if (playerIndex < 0 || playerIndex >= this.game.players.length) throw new Error('invalid turn player');
        if (![
            'reinforce',
            'attack',
            'fortify',
            'gameover'
        ].includes(state.phase)) throw new Error('invalid turn phase');
        const round = Math.max(1, Math.trunc(state.round));
        const remaining = Math.max(0, Math.trunc(state.reinforcements.remaining));
        const granted = Math.max(remaining, Math.trunc(state.reinforcements.granted ?? remaining));
        const advanceDepth = {};
        for (const [slug, rawDepth] of Object.entries(state.attacks?.advanceDepth ?? {})){
            if (!this.game.bySlug[slug]) throw new Error(`invalid advance-depth territory ${slug}`);
            if (typeof rawDepth !== 'number' || !Number.isFinite(rawDepth)) throw new Error(`invalid advance depth for ${slug}`);
            const depth = Math.trunc(rawDepth);
            if (depth < 0) throw new Error(`invalid advance depth for ${slug}`);
            if (depth > 0) advanceDepth[slug] = depth;
        }
        const attacksUsed = state.attacks?.used ?? 0;
        if (typeof attacksUsed !== 'number' || !Number.isFinite(attacksUsed) || attacksUsed < 0) throw new Error('invalid attacks used');
        this.#state = {
            id: Math.max(this.#state.id + 1, Math.trunc(state.id ?? 0)),
            round: round,
            playerIndex: playerIndex,
            phase: state.phase,
            reinforcements: {
                granted: granted,
                remaining: remaining
            },
            attacks: {
                used: Math.trunc(attacksUsed),
                advanceDepth: advanceDepth
            },
            fortifiesUsed: Math.max(0, Math.trunc(state.fortifiesUsed)),
            conqueredTerritory: Boolean(state.conqueredTerritory),
            liberatedHomeland: Boolean(state.liberatedHomeland),
            awaitingLanding: Boolean(state.awaitingLanding)
        };
    }
    /** Controlled partial state replacement for simulations and declarative effects. */ configure(patch) {
        const state = this.#state;
        const id = state.id;
        this.restore({
            ...state,
            id: state.id,
            round: patch.round ?? state.round,
            playerIndex: patch.playerIndex ?? state.playerIndex,
            phase: patch.phase ?? state.phase,
            reinforcements: {
                granted: patch.reinforcementsLeft == null ? state.reinforcements.granted : Math.max(state.reinforcements.granted, patch.reinforcementsLeft),
                remaining: patch.reinforcementsLeft ?? state.reinforcements.remaining
            },
            attacks: {
                used: patch.attacks?.used ?? state.attacks.used,
                advanceDepth: patch.attacks?.advanceDepth ?? state.attacks.advanceDepth
            },
            fortifiesUsed: patch.fortifiesUsed ?? state.fortifiesUsed,
            conqueredTerritory: patch.conqueredTerritory ?? state.conqueredTerritory,
            liberatedHomeland: patch.liberatedHomeland ?? state.liberatedHomeland
        });
        this.#state.id = id;
    }
    start() {
        const game = this.game;
        game.movement.landConvoys();
        if (this.phase === 'gameover') return;
        // Seat the new turn, but leave the draft empty for now: a human still owes a
        // storm-or-turn-back call on a landing, and its outcome changes the board the
        // draft is counted from. openTurn finishes the job once that is settled.
        const awaitingLanding = this.currentPlayer.isHuman && game.movement.pendingLandings.length > 0;
        this.#state = {
            id: this.#state.id + 1,
            round: this.round,
            playerIndex: this.playerIndex,
            phase: 'reinforce',
            reinforcements: {
                granted: 0,
                remaining: 0
            },
            attacks: {
                used: 0,
                advanceDepth: {}
            },
            fortifiesUsed: 0,
            conqueredTerritory: false,
            liberatedHomeland: false,
            awaitingLanding: awaitingLanding
        };
        if (awaitingLanding) return;
        this.openTurn();
    }
    /**
   * Finish starting the turn: draw the reinforcement draft from the current board,
   * fire turn-start events, and auto-trade a forced hand. Runs immediately for a
   * normal turn, or once `resolveLanding` clears a human's pending landings.
   */ openTurn() {
        const game = this.game;
        const faction = this.currentPlayer.faction;
        this.#state.awaitingLanding = false;
        const granted = game.campaign.reinforcementsFor(faction);
        this.#state.reinforcements = {
            granted: granted,
            remaining: granted
        };
        game.campaign.turnStarted(faction);
        game.campaign.dispatch();
        while(faction.hand.length >= 5 && game.findTradeSet(faction.hand))game.tradeCards(faction);
    }
    addReinforcements(count) {
        if (this.phase !== 'reinforce' || count <= 0) return;
        this.#state.reinforcements.granted += count;
        this.#state.reinforcements.remaining += count;
    }
    setReinforcements(count) {
        const remaining = Math.max(0, Math.trunc(count));
        this.#state.reinforcements.remaining = remaining;
        this.#state.reinforcements.granted = Math.max(this.#state.reinforcements.granted, remaining);
    }
    setPhase(phase) {
        this.configure({
            phase: phase
        });
    }
    placeReinforcements(slug, count = 1) {
        if (this.phase !== 'reinforce') return;
        const territory = this.game.bySlug[slug];
        if (!territory || territory.faction !== this.currentPlayer.faction) return;
        const placed = Math.min(Math.max(0, Math.trunc(count)), this.reinforcementsLeft);
        territory.troops += placed;
        this.#state.reinforcements.remaining -= placed;
        if (this.reinforcementsLeft === 0) this.#state.phase = 'attack';
    }
    finishReinforcementPhase() {
        if (this.phase !== 'reinforce') return;
        this.#state.reinforcements.remaining = 0;
        this.#state.phase = 'attack';
    }
    advanceDepth(slug) {
        return this.#state.attacks.advanceDepth[slug] ?? 0;
    }
    maximumAdvanceDepth(targetSlug) {
        return this.game.campaign.maximumAdvanceDepth(targetSlug);
    }
    canStartAttack(fromSlug, targetSlug) {
        return this.phase === 'attack' && this.attacksLeft > 0 && this.advanceDepth(fromSlug) < this.maximumAdvanceDepth(targetSlug);
    }
    useAttack(fromSlug, targetSlug) {
        if (!this.canStartAttack(fromSlug, targetSlug)) return false;
        this.#state.attacks.used++;
        return true;
    }
    finishAttackPhaseIfSpent() {
        if (this.phase !== 'attack' || this.attacksLeft > 0 || this.game.combat.hasActiveBattle || this.game.combat.pendingAdvance) return false;
        this.advancePhase();
        return true;
    }
    recordConquest(fromSlug, toSlug) {
        this.#state.conqueredTerritory = true;
        this.#state.attacks.advanceDepth[toSlug] = this.advanceDepth(fromSlug) + 1;
    }
    recordLiberation() {
        this.#state.liberatedHomeland = true;
    }
    useFortify() {
        this.#state.fortifiesUsed++;
    }
    advancePhase() {
        if (this.game.combat.pendingAdvance) this.game.combat.advance(0);
        this.game.combat.pullBack();
        if (this.phase === 'reinforce' && this.reinforcementsLeft === 0) this.#state.phase = 'attack';
        else if (this.phase === 'attack') this.#state.phase = 'fortify';
        else if (this.phase === 'fortify') this.finish();
    }
    finish() {
        if (this.phase === 'gameover') return;
        if (this.conqueredTerritory) this.game.drawCard(this.currentPlayer.faction);
        const total = this.game.players.length;
        for(let step = 1; step <= total; step++){
            const nextIndex = (this.playerIndex + step) % total;
            if (!this.game.players[nextIndex].faction.eliminated) {
                if (nextIndex <= this.playerIndex) {
                    this.#state.round++;
                    this.game.campaign.roundUpkeep();
                }
                this.#state.playerIndex = nextIndex;
                this.start();
                return;
            }
        }
    }
    endGame() {
        this.#state.phase = 'gameover';
    }
}



class $9ce7950a2eca7a6b$export$b5bf5e59250bae99 {
    game;
    constructor(game){
        this.game = game;
    }
    changeControl(territory, newFaction, round = 1) {
        if (territory.faction === newFaction) return;
        const oldFaction = territory.faction;
        const index = oldFaction.territories.indexOf(territory);
        if (index >= 0) oldFaction.territories.splice(index, 1);
        territory.faction = newFaction;
        if (!newFaction.territories.includes(territory)) newFaction.territories.push(territory);
        territory.quietTurns = 0;
        territory.entrenched = 0;
        territory.heldSince = round;
    }
    addTroops(territory, amount) {
        territory.troops = Math.max(0, territory.troops + Math.trunc(amount));
        return territory.troops;
    }
    moveTroops(from, to, amount) {
        const moved = Math.min(Math.max(0, Math.trunc(amount)), from.troops);
        from.troops -= moved;
        to.troops += moved;
        return moved;
    }
    snapshot() {
        return {
            territories: Object.fromEntries(this.game.territories.map((territory)=>[
                    territory.slug,
                    {
                        faction: territory.faction.name,
                        troops: territory.troops,
                        quietTurns: territory.quietTurns,
                        entrenched: territory.entrenched,
                        heldSince: territory.heldSince,
                        raidedOn: territory.raidedOn
                    }
                ]))
        };
    }
    restore(snapshot) {
        const factions = new Map(this.game.factions.map((faction)=>[
                faction.name,
                faction
            ]));
        this.game.factions.forEach((faction)=>faction.territories = []);
        for (const territory of this.game.territories){
            const record = snapshot.territories[territory.slug];
            const faction = record && factions.get(record.faction);
            if (!record || !faction) throw new Error(`Board snapshot is missing territory ${territory.slug}`);
            territory.faction = faction;
            territory.troops = record.troops;
            territory.quietTurns = record.quietTurns;
            territory.entrenched = record.entrenched;
            territory.heldSince = record.heldSince;
            territory.raidedOn = record.raidedOn;
            faction.territories.push(territory);
        }
    }
    simulate(mutate, evaluate) {
        const snapshot = this.snapshot();
        try {
            mutate();
            return evaluate();
        } finally{
            this.restore(snapshot);
        }
    }
}


class $74ce0266e08015f3$export$dc47e572979e64 {
    game;
    constructor(game){
        this.game = game;
    }
    autoPlace() {
        const turn = this.game.turn;
        if (turn.phase !== 'reinforce') return;
        const faction = turn.currentPlayer.faction;
        if (!faction.territories.length || turn.reinforcementsLeft === 0) {
            turn.finishReinforcementPhase();
            return;
        }
        while(turn.reinforcementsLeft > 0){
            const border = faction.territories.filter((territory)=>territory.adjacent.some((adjacent)=>adjacent.faction !== faction)).sort((left, right)=>this.game.threatOf(right) - this.game.threatOf(left))[0];
            turn.placeReinforcements((border ?? faction.territories[0]).slug, 1);
        }
    }
}


class $c70bd4cefccc0496$export$e922cf686e5984e3 {
    next() {
        return Math.random();
    }
}
class $c70bd4cefccc0496$export$ee99f0ca2b3ce17b {
    state;
    constructor(seed){
        this.state = seed >>> 0;
    }
    next() {
        this.state = Math.imul(this.state, 1664525) + 1013904223 >>> 0;
        return this.state / 0x100000000;
    }
    snapshot() {
        return this.state;
    }
    restore(snapshot) {
        if (typeof snapshot !== 'number' || !Number.isInteger(snapshot)) throw new Error('Invalid random source snapshot');
        this.state = snapshot >>> 0;
    }
}



const $7edb9ceba3c976bd$var$MONTHS = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December'
];
const $7edb9ceba3c976bd$var$MONTHS_TR = [
    'Ocak',
    "\u015Eubat",
    'Mart',
    'Nisan',
    "May\u0131s",
    'Haziran',
    'Temmuz',
    "A\u011Fustos",
    "Eyl\xfcl",
    'Ekim',
    "Kas\u0131m",
    "Aral\u0131k"
];
// A specific month rendered in the active language, for events that want to
// quote their real historical date rather than the round they landed on.
const $7edb9ceba3c976bd$var$formatMonth = (month, year, day)=>`${day ? `${day} ` : ''}${((0, $6c154842fccf6556$export$dec8f99c0c14e178)() === 'tr' ? $7edb9ceba3c976bd$var$MONTHS_TR : $7edb9ceba3c976bd$var$MONTHS)[month]} ${year}`;
const $7edb9ceba3c976bd$export$c393b7c99e11d793 = (n)=>n < (0, $9ff2839edea1890c$export$9b928fc5e710e864).economy.tradeBonuses.length ? (0, $9ff2839edea1890c$export$9b928fc5e710e864).economy.tradeBonuses[n] : (0, $9ff2839edea1890c$export$9b928fc5e710e864).economy.tradeBonuses[(0, $9ff2839edea1890c$export$9b928fc5e710e864).economy.tradeBonuses.length - 1] + (0, $9ff2839edea1890c$export$9b928fc5e710e864).economy.tradeIncrement * (n - (0, $9ff2839edea1890c$export$9b928fc5e710e864).economy.tradeBonuses.length + 1);
const $7edb9ceba3c976bd$var$CARD_TYPES = (0, $9ff2839edea1890c$export$9b928fc5e710e864).economy.cardTypes;
class $7edb9ceba3c976bd$export$2e2bcd8739ae039 {
    factions;
    players;
    territories;
    bySlug;
    tradeCount;
    log;
    winner;
    humanDefeated;
    combat;
    movement;
    campaign;
    turn;
    board;
    reinforcements;
    random;
    // the round the war ended on. Stored as a NUMBER, not a formatted date: the
    // ending copy is re-rendered on a language switch, and a baked "Şubat 1922"
    // would survive into the English text.
    endedRound = 0;
    constructor(options = {}){
        const setup = (0, $3089cb7f00c26c5f$export$68cc31194f942de7)();
        this.factions = setup.factions;
        this.players = setup.players;
        this.territories = setup.territories;
        this.bySlug = setup.bySlug;
        this.tradeCount = 0;
        this.log = [];
        this.winner = null;
        this.humanDefeated = false;
        this.random = options.random ?? new (0, $c70bd4cefccc0496$export$e922cf686e5984e3)();
        this.board = new (0, $9ce7950a2eca7a6b$export$b5bf5e59250bae99)(this);
        this.combat = new (0, $730d23a0718a5f71$export$e496168c82ea3403)(this);
        this.movement = new (0, $2d9a0e370f0044b3$export$8463c66827c6b0ce)(this);
        this.campaign = new (0, $cad0226104c464a9$export$241853d5920ec2ac)(this);
        this.turn = new (0, $a6c552c289be4d32$export$b2527ed6b3e49916)(this);
        this.reinforcements = new (0, $74ce0266e08015f3$export$dc47e572979e64)(this);
        this.turn.start();
        this.record(null, 'log.gameStart');
    }
    get humanPlayer() {
        return this.players.find((p)=>p.isHuman);
    }
    /** The leader shown in the HUD follows political successions without making
   * mutable presentation state part of save files. */ leaderName(player) {
        for (const succession of [
            ...player.successions
        ].reverse())if ((0, $5fc948bed93bbc7c$export$b59a2891c59b34d8).variable(this, succession.variable)) return succession.name;
        return player.name;
    }
    // Calendar cadence belongs to the event engine; the game only localizes it.
    dateAt(round) {
        const calendar = (0, $5fc948bed93bbc7c$export$239cb250891f2735).calendar;
        if (!calendar) return `Round ${round}`;
        const at = (0, $6fa8a5163afda41a$export$65079553212d26d6)(calendar, round);
        return $7edb9ceba3c976bd$var$formatMonth(at.month - 1, at.year);
    }
    get date() {
        return this.dateAt(this.turn.round);
    }
    get pactProgress() {
        const turkey = this.humanPlayer.faction;
        return (0, $a57adc7b3bbfe58c$export$458d7a1c5c3db6e9).filter((slug)=>this.bySlug[slug].faction === turkey).length;
    }
    // Won the war and then some: not a single province anywhere on the map is
    // still in foreign hands, well past what Misak-ı Millî ever claimed.
    get totalConquest() {
        const turkey = this.humanPlayer.faction;
        return this.territories.every((t)=>t.faction === turkey);
    }
    record(faction, key, vars = {}, event = false) {
        this.log.push({
            round: this.turn.round,
            faction: faction?.name ?? '',
            color: faction?.name ?? '',
            key: key,
            vars: vars,
            event: event
        });
        if (this.log.length > 200) this.log.splice(0, this.log.length - 200);
    }
    traitSummary(faction) {
        return (0, $6c154842fccf6556$export$625550452a3fa3ec)(`trait.${faction.name}`);
    }
    // ---- cards ----
    drawCard(faction) {
        faction.hand.push($7edb9ceba3c976bd$var$CARD_TYPES[Math.floor(this.random.next() * $7edb9ceba3c976bd$var$CARD_TYPES.length)]);
    }
    // Returns the indexes of a tradable set (3 alike or one of each), preferring the cheapest cards.
    findTradeSet(hand) {
        for (const type of $7edb9ceba3c976bd$var$CARD_TYPES){
            const idx = hand.map((c, i)=>c === type ? i : -1).filter((i)=>i >= 0);
            if (idx.length >= 3) return idx.slice(0, 3);
        }
        const one = [];
        for (const type of $7edb9ceba3c976bd$var$CARD_TYPES){
            const i = hand.findIndex((c, j)=>c === type && !one.includes(j));
            if (i === -1) return null;
            one.push(i);
        }
        return one;
    }
    get pendingTradeBonus() {
        return $7edb9ceba3c976bd$export$c393b7c99e11d793(this.tradeCount);
    }
    tradeCards(faction) {
        const set = this.findTradeSet(faction.hand);
        if (!set) return 0;
        const bonus = $7edb9ceba3c976bd$export$c393b7c99e11d793(this.tradeCount);
        this.tradeCount++;
        faction.hand = faction.hand.filter((_, i)=>!set.includes(i));
        if (faction === this.turn.currentPlayer.faction) this.turn.addReinforcements(bonus);
        this.record(faction, 'log.tradeCards', {
            faction: (0, $99b5c8068df0b6a9$export$b827813b2cbfb4b1)(faction.name),
            bonus: bonus
        });
        return bonus;
    }
    threatOf(territory) {
        // Only borders where war is actually possible count — allies don't threaten each other.
        const enemies = territory.adjacent.filter((a)=>a.faction !== territory.faction && (this.campaign.mayAttack(a.faction, territory.faction) || this.campaign.mayAttack(territory.faction, a.faction)));
        if (enemies.length === 0) return -Infinity;
        return enemies.reduce((sum, e)=>sum + e.troops, 0) - territory.troops;
    }
    checkGameEnd() {
        const turkey = this.humanPlayer.faction;
        if (turkey.eliminated) {
            this.humanDefeated = true;
            this.turn.endGame();
            this.endedRound = this.turn.round;
            this.record(null, 'log.turkeyFallen');
            return;
        }
        // Completing the Pact no longer ends the war by itself — it has to be HELD,
        // and the peace is signed through the conference lifecycle. But a
        // map with no enemy left on it has nothing further to decide.
        if (this.totalConquest) {
            this.winner = turkey;
            this.turn.endGame();
            this.endedRound = this.turn.round;
            this.record(turkey, 'log.victory', {
                date: (0, $99b5c8068df0b6a9$export$9f8baa050125a116)(this.date)
            });
        }
    }
}





// Exposed for headless simulation and console debugging.
if (typeof window !== 'undefined') window.Game = (0, $7edb9ceba3c976bd$export$2e2bcd8739ae039);
const $29e8209087faea70$export$fb301d682b096101 = ()=>{
    const gameRef = (0, $acw62.useRef)();
    if (!gameRef.current) gameRef.current = new (0, $7edb9ceba3c976bd$export$2e2bcd8739ae039)();
    const game = gameRef.current;
    const aiRef = (0, $acw62.useRef)();
    if (!aiRef.current) aiRef.current = new (0, $c0c72f455dbe65e0$export$86ae2bbe2352fd33)(game, {
        scorer: (0, $433e05e19940be62$export$48aea83313ab2cfc)((0, $acac2871e0f3fb91$export$fb9ba57710875005)),
        selector: (0, $433e05e19940be62$export$5dfd1a1380d3b4f9)((0, $acac2871e0f3fb91$export$fb9ba57710875005))
    });
    const [, setVersion] = (0, $acw62.useState)(0);
    const refresh = (0, $acw62.useCallback)(()=>setVersion((version)=>version + 1), []);
    (0, $acw62.useEffect)(()=>(0, $6c154842fccf6556$export$18c6e7c9e91e1c0f)(refresh), [
        refresh
    ]);
    (0, $acw62.useEffect)(()=>{
        (0, $a02a16ce6e0bc642$export$275a724b3b452522)();
        (0, $ae4c9b4b24a86223$export$3d7e390f2650e949)();
    }, []);
    return {
        game: game,
        ai: aiRef.current,
        refresh: refresh
    };
};



var $acw62 = parcelRequire("acw62");

// Which log keys speak, and with what. The log is the game's single event
// stream — every meaningful thing already calls game.record() — so listening
// here catches the player's battles and movements without threading a play()
// call through every engine site. Only the human's own turn is voiced: the AI
// grinding through its conquests and retreats plays out silently. Keys not
// listed are silent by design.
const $4b6a94b85f8d13f8$var$LOG_SOUNDS = {
    'log.captured': 'conquest',
    'log.knockedOut': 'elimination',
    'log.turkeyFallen': 'elimination',
    'log.tradeCards': 'cardTrade',
    'log.embark': 'embark',
    'log.landing': 'landings',
    'log.landingUnopposed': 'landings',
    'log.convoyLanded': 'landings',
    'log.landingRepelled': 'pullBack',
    'log.repelled': 'pullBack',
    'log.convoyTurnedBack': 'pullBack',
    'log.convoyReturned': 'pullBack'
};
const $4b6a94b85f8d13f8$export$5b16a1923de3b1af = (game, hasDecision, historicalCards)=>{
    // Track the last log entry we spoke to by reference: the log is capped and
    // spliced from the front, so a length counter drifts, but the object identity
    // survives — indexOf finds where we left off.
    const lastEntry = (0, $acw62.useRef)(null);
    const primed = (0, $acw62.useRef)(false);
    const wasHumanTurn = (0, $acw62.useRef)(false);
    const hadDecision = (0, $acw62.useRef)(false);
    const historicalSeen = (0, $acw62.useRef)(0);
    // No dependency array: this runs after every commit, matching the version
    // bumps the game loop drives, so each human action and AI step is inspected
    // once, in order.
    (0, $acw62.useEffect)(()=>{
        const log = game.log;
        if (!primed.current) {
            // First pass after mount (or a load): adopt the current state as the
            // baseline so we don't replay a game's worth of history in one burst.
            primed.current = true;
            lastEntry.current = log[log.length - 1] ?? null;
            wasHumanTurn.current = game.turn.currentPlayer.isHuman;
            hadDecision.current = hasDecision;
            historicalSeen.current = historicalCards;
            return;
        }
        const humanTurn = game.turn.currentPlayer.isHuman && game.turn.phase !== 'gameover';
        // Battle and movement effects belong to the player's own turn. During AI
        // turns we still advance the pointer (so these entries never replay later)
        // but stay silent.
        if (humanTurn) {
            const start = lastEntry.current ? log.indexOf(lastEntry.current) + 1 : 0;
            for(let i = start; i < log.length; i++){
                const sound = $4b6a94b85f8d13f8$var$LOG_SOUNDS[log[i].key];
                if (sound) (0, $ae4c9b4b24a86223$export$80cb197f7ea4fe13)(sound);
            }
        }
        lastEntry.current = log[log.length - 1] ?? null;
        // A decision card sliding in, or fresh historical cards being dealt.
        if (hasDecision && !hadDecision.current) (0, $ae4c9b4b24a86223$export$80cb197f7ea4fe13)('decisionCard');
        else if (historicalCards > historicalSeen.current) (0, $ae4c9b4b24a86223$export$80cb197f7ea4fe13)('cardDraw');
        hadDecision.current = hasDecision;
        historicalSeen.current = historicalCards;
        // The moment control returns to the player.
        if (humanTurn && !wasHumanTurn.current) (0, $ae4c9b4b24a86223$export$80cb197f7ea4fe13)('yourTurn');
        wasHumanTurn.current = humanTurn;
    });
};


const $654496e2d17d77b0$var$eventOf = (eventId)=>(0, $5fc948bed93bbc7c$export$bb2f7671035ac146).find((event)=>event.id === eventId);
const $654496e2d17d77b0$export$d7a69369a4611f18 = ()=>{
    const { game: game, ai: ai, refresh: refresh } = (0, $29e8209087faea70$export$fb301d682b096101)();
    const runAiTurns = (0, $efacdc08a7f627ea$export$271d828839566a31)(game, ai, refresh);
    const interaction = (0, $fb248ef02a22da10$export$853f29f433d233a4)(game, refresh, runAiTurns);
    const [started, setStarted] = (0, $acw62.useState)(false);
    const [gameMounted, setGameMounted] = (0, $acw62.useState)(false);
    const [mapReady, setMapReady] = (0, $acw62.useState)(false);
    const decision = game.campaign.pendingDecision;
    (0, $4b6a94b85f8d13f8$export$5b16a1923de3b1af)(game, !!decision, game.campaign.pendingCards.length);
    const entries = decision ? [
        {
            textKey: decision.id,
            faction: decision.actor ?? '',
            vars: (0, $5fc948bed93bbc7c$export$b59a2891c59b34d8).variables(decision, game, game.turn.round, game.campaign.retries[decision.id] ?? 0)
        }
    ] : game.campaign.pendingCards.map((key)=>{
        const event = $654496e2d17d77b0$var$eventOf(key);
        return {
            textKey: key,
            faction: event?.actor ?? '',
            vars: event ? (0, $5fc948bed93bbc7c$export$b59a2891c59b34d8).variables(event, game, game.turn.round, game.campaign.retries[event.id] ?? 0) : undefined
        };
    });
    const save = (name)=>{
        try {
            (0, $944d38e2330df821$export$7cd6ef3e3a9070c2)({
                name: name,
                round: game.turn.round,
                date: game.date,
                pact: game.pactProgress
            }, (0, $abe342800d57128e$export$36fdfb121d3b054f)(game));
            return true;
        } catch  {
            return false;
        }
    };
    const load = (id)=>{
        const snapshot = (0, $944d38e2330df821$export$adfe33b5e3538b1f)(id);
        if (!snapshot) return false;
        try {
            (0, $abe342800d57128e$export$806bbea4d4ff90b3)(game, snapshot);
        } catch  {
            return false;
        }
        interaction.resetInteraction();
        refresh();
        if (!game.turn.currentPlayer.isHuman && game.turn.phase !== 'gameover') runAiTurns();
        return true;
    };
    return {
        game: game,
        started: started,
        gameMounted: gameMounted,
        mapReady: mapReady,
        setStarted: setStarted,
        setGameMounted: setGameMounted,
        setMapReady: setMapReady,
        interaction: interaction,
        decision: decision,
        entries: entries,
        outcome: (0, $1cee680eee39b243$export$6a38971a44e57422)(game),
        save: save,
        load: load,
        defaultSaveName: ()=>(0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.defaultSaveName', {
                date: game.date,
                pact: game.pactProgress
            }),
        dismissCards: ()=>{
            game.campaign.clearCards();
            refresh();
        },
        resolveDecision: (key)=>{
            game.campaign.resolveDecision(key);
            refresh();
        }
    };
};







var $acw62 = parcelRequire("acw62");
const $742a2b2531837bb1$export$6aceaa2aadf4b436 = ({ id: id, kicker: kicker, title: title, copy: copy })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "interlude reveal",
        id: id,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "kicker",
                children: kicker
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                children: title.map((line, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                        children: [
                            index > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            line
                        ]
                    }, line))
            }),
            copy && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "interlude-copy",
                children: copy
            })
        ]
    });







var $acw62 = parcelRequire("acw62");

const $e5df0b2d7740e822$export$b24a004ee43dce44 = ()=>{
    const [lang, setLangState] = (0, $acw62.useState)((0, $6c154842fccf6556$export$dec8f99c0c14e178));
    (0, $acw62.useEffect)(()=>(0, $6c154842fccf6556$export$18c6e7c9e91e1c0f)(()=>setLangState((0, $6c154842fccf6556$export$dec8f99c0c14e178)())), []);
    return lang;
};


const $e3be99bdc8eb8f7b$var$LANGS = [
    'en',
    'tr'
];
const $e3be99bdc8eb8f7b$export$da8a365896b01467 = ()=>{
    const lang = (0, $e5df0b2d7740e822$export$b24a004ee43dce44)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("nav", {
        className: "intro-languages",
        "aria-label": (0, $6c154842fccf6556$export$625550452a3fa3ec)('menu.language'),
        children: $e3be99bdc8eb8f7b$var$LANGS.map((code)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: lang === code ? 'active' : '',
                onClick: ()=>(0, $6c154842fccf6556$export$a3665b844fbc095d)(code),
                "aria-pressed": lang === code,
                children: code.toLocaleUpperCase(code)
            }, code))
    });
};






var $62b15fd72c247d95$exports = {};
$62b15fd72c247d95$exports = import.meta.resolve("fHOQh");


const $169a39ecfc3cbfa7$var$telegraph = new URL($62b15fd72c247d95$exports).href;
var $30788fced5e2a74f$exports = {};
$30788fced5e2a74f$exports = import.meta.resolve("e5xWP");


const $169a39ecfc3cbfa7$var$bosphorus = new URL($30788fced5e2a74f$exports).href;
var $52aa2bf2b33af42c$exports = {};
$52aa2bf2b33af42c$exports = import.meta.resolve("iPUMA");


const $169a39ecfc3cbfa7$var$samsun = new URL($52aa2bf2b33af42c$exports).href;
var $c694a913944128fa$exports = {};
$c694a913944128fa$exports = import.meta.resolve("ddn9o");


const $169a39ecfc3cbfa7$var$warroom = new URL($c694a913944128fa$exports).href;
var $4875af5039a94854$exports = {};
$4875af5039a94854$exports = import.meta.resolve("aIxnn");


const $169a39ecfc3cbfa7$var$soldier = new URL($4875af5039a94854$exports).href;
var $0092885fc576b555$exports = {};
$0092885fc576b555$exports = import.meta.resolve("3p4Gf");


const $169a39ecfc3cbfa7$var$supply = new URL($0092885fc576b555$exports).href;
var $f173748b0ddb8d67$exports = {};
$f173748b0ddb8d67$exports = import.meta.resolve("9e924");


const $169a39ecfc3cbfa7$var$trench = new URL($f173748b0ddb8d67$exports).href;
var $683a32b4e949d692$exports = {};
$683a32b4e949d692$exports = import.meta.resolve("ghFFk");


const $169a39ecfc3cbfa7$var$ridge = new URL($683a32b4e949d692$exports).href;
var $cca33977a38f6dc0$exports = {};
$cca33977a38f6dc0$exports = import.meta.resolve("60Mkq");


const $169a39ecfc3cbfa7$var$deck = new URL($cca33977a38f6dc0$exports).href;
var $8a84947564b8cda0$exports = {};
$8a84947564b8cda0$exports = import.meta.resolve("cb5TQ");


const $169a39ecfc3cbfa7$var$westmap = new URL($8a84947564b8cda0$exports).href;
var $bef29a6c6941b415$exports = {};
$bef29a6c6941b415$exports = import.meta.resolve("fxLTM");


const $169a39ecfc3cbfa7$var$hall = new URL($bef29a6c6941b415$exports).href;
var $bb6c1cae73702b1c$exports = {};
$bb6c1cae73702b1c$exports = import.meta.resolve("BKqkb");


const $169a39ecfc3cbfa7$var$voyage = new URL($bb6c1cae73702b1c$exports).href;
var $f1142f8eed0d386e$exports = {};
$f1142f8eed0d386e$exports = import.meta.resolve("bgVDL");


const $169a39ecfc3cbfa7$var$dawn = new URL($f1142f8eed0d386e$exports).href;













const $169a39ecfc3cbfa7$export$282985d0f9eeff33 = [
    {
        title: 'The First Shot',
        src: new URL($818b933824179c94$exports).href,
        art: $169a39ecfc3cbfa7$var$telegraph,
        pos: '30% 50%'
    },
    {
        title: 'A Nation in Chains',
        src: new URL($666b0f3813cfa78c$exports).href,
        art: $169a39ecfc3cbfa7$var$bosphorus,
        pos: '18% 40%'
    },
    {
        title: 'Rise of the Resistance',
        src: new URL($962f3913a6cc4d4d$exports).href,
        art: $169a39ecfc3cbfa7$var$samsun,
        pos: '50% 60%'
    },
    {
        title: 'Ankara',
        src: new URL($41f8d21a21392820$exports).href,
        art: $169a39ecfc3cbfa7$var$warroom,
        pos: '50% 55%'
    },
    {
        title: 'Mehmets',
        src: new URL($c27beb98e27e163c$exports).href,
        art: $169a39ecfc3cbfa7$var$soldier,
        pos: '42% 22%'
    },
    {
        title: "\u0130n\xf6n\xfc",
        src: new URL($824e0ce03078885f$exports).href,
        art: $169a39ecfc3cbfa7$var$supply,
        pos: '60% 45%'
    },
    {
        title: 'Sakarya',
        src: new URL($e3aa7d7b47c90d21$exports).href,
        art: $169a39ecfc3cbfa7$var$trench,
        pos: '45% 65%'
    },
    {
        title: 'Taarruz',
        src: new URL($5da9cec80afe5fad$exports).href,
        art: $169a39ecfc3cbfa7$var$ridge,
        pos: '50% 40%'
    },
    {
        title: 'For Those Who Never Returned',
        src: new URL($19ae5378b6904214$exports).href,
        art: $169a39ecfc3cbfa7$var$deck,
        pos: '60% 55%'
    },
    {
        title: "The Road to \u0130zmir",
        src: new URL($ffec9804f1b8ebba$exports).href,
        art: $169a39ecfc3cbfa7$var$westmap,
        pos: '38% 45%'
    },
    {
        title: 'Lausanne',
        src: new URL($6df782523b42657e$exports).href,
        art: $169a39ecfc3cbfa7$var$hall,
        pos: '70% 55%'
    },
    {
        title: 'The Dawn of Victory',
        src: new URL($836fb0da37c2236f$exports).href,
        art: $169a39ecfc3cbfa7$var$voyage,
        pos: '80% 20%'
    },
    {
        title: 'A Nation Unchained',
        src: new URL($bfa7d68ec037a10b$exports).href,
        art: $169a39ecfc3cbfa7$var$dawn,
        pos: '50% 40%'
    }
];


// Text glyphs (▶ / Ⅱ) sit off-centre inside their em box and the offset differs
// per font, so the transport draws its own shapes: centred by geometry.

const $1b21806ba5c28826$export$a6630b90defda83f = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 14 14",
        "aria-hidden": "true",
        focusable: "false",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M4 2.5 L12 7 L4 11.5 Z"
        })
    });
const $1b21806ba5c28826$export$9b47433640e5db3a = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 14 14",
        "aria-hidden": "true",
        focusable: "false",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3.5 2.5h2.2v9h-2.2z M8.3 2.5h2.2v9h-2.2z"
        })
    });



var $acw62 = parcelRequire("acw62");


const $3ec2083f5f1294f0$export$84584c2a98eb6753 = {
    brand: [
        'Independence',
        'Original game score'
    ],
    nowPlaying: 'Now playing',
    download: 'Download this track',
    listLabel: 'Original soundtrack tracks',
    playerLabel: 'Soundtrack player',
    seekLabel: 'Track position',
    previous: 'Previous track',
    next: 'Next track',
    coverAlt: (title)=>`Cover for ${title}`,
    downloadTrack: (title)=>`Download ${title}`,
    play: (title)=>`Play ${title}`,
    pause: (title)=>`Pause ${title}`,
    chapters: [
        'The war begins',
        'The occupation',
        'The movement gathers',
        'The new capital',
        'The soldiers of Anatolia',
        'The first victory',
        'The line of defense',
        'The Great Offensive',
        'The fallen',
        'The final pursuit',
        'The peace',
        'A new beginning',
        'Independence won'
    ]
};


const $85c8262c0dd390ad$export$72451b88a72ad9c2 = {
    brand: [
        "Kurtulu\u015F",
        "Oyunun m\xfczi\u011Fi"
    ],
    nowPlaying: "\xc7al\u0131yor",
    download: "Bu par\xe7ay\u0131 indirin",
    listLabel: "Oyunun m\xfczikleri",
    playerLabel: "M\xfczik \xe7alar",
    seekLabel: "Par\xe7a konumu",
    previous: "\xd6nceki par\xe7a",
    next: "Sonraki par\xe7a",
    coverAlt: (title)=>`${title} par\xe7as\u{131}n\u{131}n kapa\u{11F}\u{131}`,
    downloadTrack: (title)=>`${title} par\xe7as\u{131}n\u{131} indirin`,
    play: (title)=>`${title} par\xe7as\u{131}n\u{131} \xe7al\u{131}n`,
    pause: (title)=>`${title} par\xe7as\u{131}n\u{131} duraklat\u{131}n`,
    chapters: [
        "Sava\u015F ba\u015Fl\u0131yor",
        "\u0130\u015Fgal",
        "Hareket toparlan\u0131yor",
        "Yeni ba\u015Fkent",
        "Anadolu\u2019nun askerleri",
        "\u0130lk zafer",
        "Savunma hatt\u0131",
        "B\xfcy\xfck Taarruz",
        "\u015Eehitler",
        'Son takip',
        'Sulh',
        "Yeni bir ba\u015Flang\u0131\xe7",
        "\u0130stiklal kazan\u0131ld\u0131"
    ]
};


const $7249d9acaaacf6dd$export$e98fec024021e5d3 = (lang)=>lang === 'tr' ? (0, $85c8262c0dd390ad$export$72451b88a72ad9c2) : (0, $3ec2083f5f1294f0$export$84584c2a98eb6753);


const $6de2353f57eb5901$var$ARTWORK_SIZE = '512x512';
const $6de2353f57eb5901$var$tryPlay = async (audio)=>{
    if (!audio) return false;
    try {
        await audio.play();
        return true;
    } catch  {
        return false;
    }
};
const $6de2353f57eb5901$var$useTransport = (refs)=>{
    const { audioRef: audioRef, wantsPlayback: wantsPlayback, activeTrack: activeTrack, setActiveTrack: setActiveTrack } = refs;
    const play = ()=>{
        wantsPlayback.current = true;
        $6de2353f57eb5901$var$tryPlay(audioRef.current);
    };
    const pause = ()=>{
        wantsPlayback.current = false;
        audioRef.current?.pause();
    };
    const goToTrack = (index)=>{
        wantsPlayback.current = true;
        setActiveTrack(index);
    };
    const nextTrack = ()=>goToTrack((activeTrack + 1) % (0, $169a39ecfc3cbfa7$export$282985d0f9eeff33).length);
    const previousTrack = ()=>goToTrack((activeTrack - 1 + (0, $169a39ecfc3cbfa7$export$282985d0f9eeff33).length) % (0, $169a39ecfc3cbfa7$export$282985d0f9eeff33).length);
    const toggleTrack = (index)=>{
        if (index !== activeTrack) {
            goToTrack(index);
            return;
        }
        if (audioRef.current?.paused) play();
        else pause();
    };
    return {
        play: play,
        pause: pause,
        toggleTrack: toggleTrack,
        nextTrack: nextTrack,
        previousTrack: previousTrack
    };
};
const $6de2353f57eb5901$var$usePlaybackSync = (refs)=>{
    const { audioRef: audioRef, wantsPlayback: wantsPlayback, activeTrack: activeTrack } = refs;
    (0, $acw62.useEffect)(()=>{
        const audio = audioRef.current;
        if (!audio) return;
        audio.load();
        if (wantsPlayback.current) $6de2353f57eb5901$var$tryPlay(audio);
    }, [
        activeTrack,
        audioRef,
        wantsPlayback
    ]);
    (0, $acw62.useEffect)(()=>{
        const resumeOnGesture = ()=>void $6de2353f57eb5901$var$tryPlay(audioRef.current);
        const openWithTheScore = async ()=>{
            const started = await $6de2353f57eb5901$var$tryPlay(audioRef.current);
            if (!started) document.addEventListener('pointerdown', resumeOnGesture, {
                once: true
            });
        };
        openWithTheScore();
        return ()=>document.removeEventListener('pointerdown', resumeOnGesture);
    }, [
        audioRef
    ]);
};
const $6de2353f57eb5901$var$useMediaSession = (session)=>{
    const { track: track, transport: transport } = session;
    (0, $acw62.useEffect)(()=>{
        if (!('mediaSession' in navigator)) return;
        navigator.mediaSession.metadata = new MediaMetadata({
            title: track.title,
            artist: "Independence \xb7 Original game score",
            album: 'Independence',
            artwork: [
                {
                    src: track.art,
                    sizes: $6de2353f57eb5901$var$ARTWORK_SIZE,
                    type: 'image/jpeg'
                }
            ]
        });
        navigator.mediaSession.setActionHandler('previoustrack', transport.previousTrack);
        navigator.mediaSession.setActionHandler('nexttrack', transport.nextTrack);
        navigator.mediaSession.setActionHandler('play', transport.play);
        navigator.mediaSession.setActionHandler('pause', transport.pause);
    }, [
        track,
        transport
    ]);
};
const $6de2353f57eb5901$export$134d49c87107fbaa = ()=>{
    const audioRef = (0, $acw62.useRef)(null);
    const wantsPlayback = (0, $acw62.useRef)(true);
    const [activeTrack, setActiveTrack] = (0, $acw62.useState)(0);
    const [playing, setPlaying] = (0, $acw62.useState)(false);
    const [currentTime, setCurrentTime] = (0, $acw62.useState)(0);
    const [duration, setDuration] = (0, $acw62.useState)(0);
    const track = (0, $169a39ecfc3cbfa7$export$282985d0f9eeff33).at(activeTrack) ?? (0, $169a39ecfc3cbfa7$export$282985d0f9eeff33)[0];
    const transport = $6de2353f57eb5901$var$useTransport({
        audioRef: audioRef,
        wantsPlayback: wantsPlayback,
        activeTrack: activeTrack,
        setActiveTrack: setActiveTrack
    });
    const seek = (time)=>{
        if (audioRef.current) audioRef.current.currentTime = time;
        setCurrentTime(time);
    };
    $6de2353f57eb5901$var$usePlaybackSync({
        audioRef: audioRef,
        wantsPlayback: wantsPlayback,
        activeTrack: activeTrack
    });
    $6de2353f57eb5901$var$useMediaSession({
        track: track,
        transport: transport
    });
    return {
        ...transport,
        track: track,
        activeTrack: activeTrack,
        playing: playing,
        currentTime: currentTime,
        duration: duration,
        seek: seek,
        audioProps: {
            ref: audioRef,
            src: track.src,
            preload: 'metadata',
            onPlay: ()=>setPlaying(true),
            onPause: ()=>setPlaying(false),
            onTimeUpdate: (event)=>setCurrentTime(event.currentTarget.currentTime),
            onLoadedMetadata: (event)=>setDuration(event.currentTarget.duration),
            onEnded: transport.nextTrack
        }
    };
};
const $6de2353f57eb5901$export$556e193088d484f2 = ()=>(0, $7249d9acaaacf6dd$export$e98fec024021e5d3)((0, $e5df0b2d7740e822$export$b24a004ee43dce44)());



const $c04d38421e1612d3$var$SECONDS_PER_MINUTE = 60;
const $c04d38421e1612d3$var$SECOND_DIGITS = 2;
const $c04d38421e1612d3$var$TRACK_NUMBER_DIGITS = 2;
const $c04d38421e1612d3$export$3203edd9e5edd663 = (seconds)=>{
    if (!Number.isFinite(seconds)) return '0:00';
    const minutes = Math.floor(seconds / $c04d38421e1612d3$var$SECONDS_PER_MINUTE);
    const remainder = Math.floor(seconds % $c04d38421e1612d3$var$SECONDS_PER_MINUTE);
    return `${minutes}:${String(remainder).padStart($c04d38421e1612d3$var$SECOND_DIGITS, '0')}`;
};
const $c04d38421e1612d3$export$19fef0464f69f79d = (index)=>String(index + 1).padStart($c04d38421e1612d3$var$TRACK_NUMBER_DIGITS, '0');
const $c04d38421e1612d3$export$46272c3c6d3a0042 = (currentTime, duration)=>{
    const PERCENT = 100;
    return `${duration ? currentTime / duration * PERCENT : 0}%`;
};


const $865bb822e2882736$export$9c5c5e21ced30d2e = ({ player: player, label: label })=>{
    const { currentTime: currentTime, duration: duration } = player;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
        "aria-label": label,
        type: "range",
        min: "0",
        max: duration || 0,
        value: Math.min(currentTime, duration || 0),
        onChange: (event)=>player.seek(Number(event.target.value)),
        style: {
            '--progress': (0, $c04d38421e1612d3$export$46272c3c6d3a0042)(currentTime, duration)
        }
    });
};





const $0ff860235c049a22$var$TrackList = ({ player: player, copy: copy })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ol", {
        className: "track-list",
        id: "tracks",
        "aria-label": copy.listLabel,
        children: (0, $169a39ecfc3cbfa7$export$282985d0f9eeff33).map((item, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                className: player.activeTrack === index ? 'active' : '',
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("button", {
                        type: "button",
                        className: "track-main",
                        onClick: ()=>player.toggleTrack(index),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                className: "track-art",
                                src: item.art,
                                style: {
                                    objectPosition: item.pos
                                },
                                alt: "",
                                loading: "lazy"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "track-number",
                                children: (0, $c04d38421e1612d3$export$19fef0464f69f79d)(index)
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                                className: "track-name",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                        children: item.title
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                        children: copy.chapters.at(index)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                "aria-hidden": "true",
                                children: player.activeTrack === index && player.playing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b21806ba5c28826$export$9b47433640e5db3a), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b21806ba5c28826$export$a6630b90defda83f), {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        href: item.src,
                        download: true,
                        "aria-label": copy.downloadTrack(item.title),
                        children: "\u2193"
                    })
                ]
            }, item.title))
    });
const $0ff860235c049a22$var$NowPlaying = ({ player: player, copy: copy })=>{
    const { track: track, activeTrack: activeTrack, playing: playing, currentTime: currentTime, duration: duration } = player;
    const chapter = copy.chapters.at(activeTrack);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("aside", {
        className: "score-now",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "score-cover",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        src: track.art,
                        style: {
                            objectPosition: track.pos
                        },
                        alt: copy.coverAlt(track.title)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            copy.brand[0],
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                            copy.brand[1]
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                        children: (0, $c04d38421e1612d3$export$19fef0464f69f79d)(activeTrack)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                children: [
                    copy.nowPlaying,
                    " \xb7 ",
                    (0, $c04d38421e1612d3$export$19fef0464f69f79d)(activeTrack),
                    " / ",
                    (0, $169a39ecfc3cbfa7$export$282985d0f9eeff33).length
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                children: track.title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                className: "score-chapter",
                children: chapter
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "score-controls",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        type: "button",
                        onClick: ()=>player.toggleTrack(activeTrack),
                        "aria-label": playing ? copy.pause(track.title) : copy.play(track.title),
                        children: playing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b21806ba5c28826$export$9b47433640e5db3a), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b21806ba5c28826$export$a6630b90defda83f), {})
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $865bb822e2882736$export$9c5c5e21ced30d2e), {
                                player: player,
                                label: copy.seekLabel
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: (0, $c04d38421e1612d3$export$3203edd9e5edd663)(currentTime)
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: (0, $c04d38421e1612d3$export$3203edd9e5edd663)(duration)
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                href: track.src,
                download: true,
                children: [
                    copy.download,
                    " ",
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        "aria-hidden": "true",
                        children: "\u2193"
                    })
                ]
            })
        ]
    });
};
const $0ff860235c049a22$export$b83262e57e0e96ca = ({ player: player })=>{
    const copy = (0, $6de2353f57eb5901$export$556e193088d484f2)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "score-shell reveal",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0ff860235c049a22$var$NowPlaying, {
                player: player,
                copy: copy
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($0ff860235c049a22$var$TrackList, {
                player: player,
                copy: copy
            })
        ]
    });
};










const $d893ea8e0ffe6258$var$Transport = ({ player: player, copy: copy })=>{
    const { track: track, activeTrack: activeTrack, playing: playing } = player;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "pb-controls",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: player.previousTrack,
                "aria-label": copy.previous,
                children: "\u2039\u2039"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                className: "pb-play",
                onClick: ()=>player.toggleTrack(activeTrack),
                "aria-label": playing ? copy.pause(track.title) : copy.play(track.title),
                children: playing ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b21806ba5c28826$export$9b47433640e5db3a), {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1b21806ba5c28826$export$a6630b90defda83f), {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                onClick: player.nextTrack,
                "aria-label": copy.next,
                children: "\u203A\u203A"
            })
        ]
    });
};
const $d893ea8e0ffe6258$export$9d9d9d1a2206514d = ({ player: player, visible: visible })=>{
    const copy = (0, $6de2353f57eb5901$export$556e193088d484f2)();
    const { track: track, activeTrack: activeTrack, currentTime: currentTime, duration: duration } = player;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `player-bar${visible ? ' on' : ''}`,
        role: "region",
        "aria-label": copy.playerLabel,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d893ea8e0ffe6258$var$Transport, {
                player: player,
                copy: copy
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                className: "pb-info",
                href: "#soundtrack",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                        className: "pb-art",
                        src: track.art,
                        style: {
                            objectPosition: track.pos
                        },
                        alt: ""
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                children: track.title
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("small", {
                                children: [
                                    (0, $c04d38421e1612d3$export$19fef0464f69f79d)(activeTrack),
                                    " / ",
                                    (0, $169a39ecfc3cbfa7$export$282985d0f9eeff33).length,
                                    " \xb7 ",
                                    copy.chapters.at(activeTrack)
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "pb-seek",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: (0, $c04d38421e1612d3$export$3203edd9e5edd663)(currentTime)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $865bb822e2882736$export$9c5c5e21ced30d2e), {
                        player: player,
                        label: copy.seekLabel
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: (0, $c04d38421e1612d3$export$3203edd9e5edd663)(duration)
                    })
                ]
            })
        ]
    });
};








var $acw62 = parcelRequire("acw62");

const $39b86da769d481bf$export$84584c2a98eb6753 = {
    document: {
        title: "Independence \u2014 A strategy game of the Turkish War of Independence",
        description: 'Command the Turkish resistance in a grand strategy campaign where real events, real borders and seven rival factions decide the War of Independence.'
    },
    hero: {
        dateline: "19 May 1919 \xb7 Samsun",
        title: 'Independence',
        tagline: 'A nation under occupation. Independence to be won.',
        cta: 'Go to the game',
        meta: 'A strategy game of the Turkish War of Independence',
        alt: "The SS Band\u0131rma steaming across a dark sea, dawn breaking on the horizon"
    },
    stops: [
        {
            id: 'top',
            label: 'The voyage'
        },
        {
            id: 'story',
            label: 'The situation'
        },
        {
            id: 'moments',
            label: 'The war'
        },
        {
            id: 'board',
            label: 'The board'
        },
        {
            id: 'cards',
            label: 'The cards'
        },
        {
            id: 'factions',
            label: 'The opposition'
        },
        {
            id: 'soundtrack',
            label: 'The score'
        }
    ],
    story: {
        kicker: "Chapter I \xb7 The situation",
        title: [
            'The fleets are in every harbor.',
            'The armies are dissolved.'
        ],
        copy: 'The Great War is over, and every nation at the table is pursuing its own aims. Fleets anchor in the harbors, armies hold the rail lines, and borders are being redrawn in distant capitals. This is the map of May 1919, and it is where the game begins. You take the worst position on the board, Pasha, and everything after that is yours to decide.'
    },
    bosphorus: {
        label: 'The occupied Bosphorus, November 1918',
        alt: "Allied battleships anchored on the Bosphorus before the \u0130stanbul skyline",
        dateline: "November 1918 \xb7 The Bosphorus",
        heading: 'Warships ride at anchor before the capital.',
        copy: 'The fleet that won the world war fills the strait, and every harbor answers to it. On paper, everything is settled.'
    },
    duty: {
        kicker: "Chapter II \xb7 The duty",
        title: [
            'You will not stop',
            'to weigh the odds.'
        ],
        copy: "You are an Ottoman pasha, sent to Samsun with an inspector\u2019s orders: supervise the disarmament, keep the peace. You have other ideas. On 16 May 1919 a small steamship, the SS Band\u0131rma, leaves \u0130stanbul under the eyes of the fleet, and the road inland begins."
    },
    deck: {
        label: "Your view from the deck of the Band\u0131rma",
        alt: 'The rain-slicked deck of an old steamer on a heavy sea at dusk, seen from where you stand',
        dateline: "17 May 1919 \xb7 Aboard the SS Band\u0131rma",
        heading: 'Ahead lies Samsun, and a war nobody has declared yet.',
        copy: "Three days of open water with no escort. At the far end wait resistance forces not yet united, and a people who have not yet been asked what they want. When you step ashore, there will be no army under your command\u2014only a possibility."
    },
    route: {
        label: "The route from \u0130stanbul to the opening of the Assembly",
        stops: [
            {
                date: '16 May 1919',
                place: "\u0130stanbul",
                note: 'Departure'
            },
            {
                date: '19 May 1919',
                place: 'Samsun',
                note: 'Landing'
            },
            {
                date: '22 June 1919',
                place: 'Amasya',
                note: 'The circular'
            },
            {
                date: '23 July 1919',
                place: 'Erzurum',
                note: 'Regional congress'
            },
            {
                date: '4 September 1919',
                place: 'Sivas',
                note: 'National congress'
            },
            {
                date: '23 April 1920',
                place: 'Ankara',
                note: 'The Assembly opens'
            }
        ]
    },
    moments: {
        kicker: "Chapter III \xb7 The war",
        title: [
            'The country is worn and destitute.',
            'It will fight anyway.'
        ],
        copy: 'What it has left, it hands to you. A congress needs its city. An army needs civilian supply. A defensive line needs time, and an offensive needs a force capable of surviving it.'
    },
    hands: {
        label: "Through the commander\u2019s eyes: a hand on the map, hands on the ship\u2019s rail, compass and field glasses",
        alt: "Three views through the commander\u2019s eyes: a gloved hand on a map, hands gripping a ship\u2019s rail over the sea, a compass and field glasses held open"
    },
    board: {
        kicker: "The board \xb7 May 1919",
        title: [
            'You start where the movement started.'
        ],
        copy: "Sixteen provinces, most of them inland. Six other factions on the map, each with its own war aims \u2014 Greece in \u0130zmir, Britain on the Straits, France in Cilicia, Italy in the southwest, Armenia in the east, Bulgaria across the Thracian border. Your aim is not the map: it is the Misak-\u0131 Mill\xee, the thirty provinces the last Ottoman parliament voted for.",
        chip: "\u2691 Actual gameplay",
        caption: "May 1919 \xb7 Round 1 \u2014 the historical starting position",
        alt: 'The Independence campaign board at the historical May 1919 starting position',
        objectiveLabel: "Misak-\u0131 Mill\xee",
        objectiveValue: '16 / 30',
        objectiveBar: '16 of 30 National Pact provinces held',
        objectiveCopy: 'National Pact provinces held at the start. Victory is holding all thirty, and stopping there.'
    },
    cards: {
        kicker: "Actual gameplay \xb7 The event deck",
        title: [
            'Turning points arrive as cards.'
        ],
        copy: 'Twenty-eight dated events run from the congresses of 1919 to the treaties of the mid-twenties. Each arrives on the turn its real date falls in, and each changes something material. A few stop and ask you a question instead.',
        note: "Four of twenty-eight. The rest you will meet in the campaign \u2014 some of them only if your war earns them.",
        exhibits: [
            {
                alt: 'In-game event card: the Erzurum Congress, July 1919',
                dateline: "July 1919 \xb7 The east organizes",
                title: 'The Erzurum Congress',
                copy: 'Raises militia in every eastern province, if Erzurum still stands.'
            },
            {
                alt: 'In-game event card: the Grand National Assembly opens in Ankara',
                dateline: "April 1920 \xb7 A government sits",
                title: 'The Assembly opens',
                copy: 'Everything it does presupposes a seat it still holds.'
            },
            {
                alt: "In-game event card: the Treaty of S\xe8vres, August 1920",
                dateline: "August 1920 \xb7 The dictated peace",
                title: "S\xe8vres",
                copy: 'Guts recruitment for two rounds, then hardens a resistance into a nation in arms.'
            },
            {
                alt: "In-game event card in Turkish: the Battle of \u0130n\xf6n\xfc, January 1921",
                dateline: "January 1921 \xb7 Ve T\xfcrk\xe7e",
                title: "\u0130n\xf6n\xfc holds the line",
                copy: "Every card, log line and map label ships in English and T\xfcrk\xe7e, switchable mid-game."
            }
        ]
    },
    factions: {
        kicker: 'The opposition',
        title: [
            "Each opponent is an AI trained on its nation\u2019s historical behavior."
        ],
        items: [
            {
                key: 'Greece',
                name: 'Greece',
                copy: "Four days before you reach Samsun, its army comes ashore at \u0130zmir."
            },
            {
                key: 'Britain',
                name: 'Britain',
                copy: 'The empire has won the war; now it must police the peace.'
            },
            {
                key: 'France',
                name: 'France',
                copy: 'Victory in Europe has given way to an uneasy occupation.'
            },
            {
                key: 'Italy',
                name: 'Italy',
                copy: 'Rome expected more from the peace than it is prepared to defend.'
            },
            {
                key: 'Armenia',
                name: 'Armenia',
                copy: 'A republic barely a year old, with every border still unsettled.'
            },
            {
                key: 'Bulgaria',
                name: 'Bulgaria',
                copy: 'Defeat has brought a smaller country and an army bound by treaty.'
            }
        ]
    },
    score: {
        kicker: 'Original game score',
        title: [
            'The campaign, in thirteen tracks.'
        ],
        copy: 'Listen to the complete soundtrack in sequence, choose an individual chapter, or download any track directly.'
    },
    charge: {
        label: 'From the Address to Youth',
        lines: [
            'The strength you will need',
            'is in the noble blood within your veins.'
        ],
        sub: "Mustafa Kemal Atat\xfcrk \xb7 Address to Youth, 1927"
    },
    final: {
        label: 'Begin the game',
        alt: 'A map of Anatolia spread across a campaign table'
    },
    footer: {
        team: 'Team',
        imprint: 'Imprint',
        openSource: 'Open source on GitHub',
        brand: 'Independence',
        years: "1919 \xb7 1923",
        tagline: 'A historical strategy game of the Turkish War of Independence.',
        links: [
            {
                href: '#story',
                label: 'Story'
            },
            {
                href: '#board',
                label: 'Board'
            },
            {
                href: '#cards',
                label: 'Cards'
            },
            {
                href: '#factions',
                label: 'Factions'
            },
            {
                href: '#soundtrack',
                label: 'Score'
            }
        ]
    },
    nav: {
        label: 'Page sections'
    }
};


const $09cd832828510154$export$72451b88a72ad9c2 = {
    document: {
        title: "Kurtulu\u015F \xb7 Kurtulu\u015F Sava\u015F\u0131 \xfczerine bir strateji oyunu",
        description: "Ger\xe7ek olaylar, ger\xe7ek s\u0131n\u0131rlar ve kar\u015F\u0131n\u0131zda yedi taraf. 19 May\u0131s 1919\u2019da Samsun\u2019a \xe7\u0131k\u0131yorsunuz; bundan sonras\u0131 size kalm\u0131\u015F."
    },
    hero: {
        dateline: "19 May\u0131s 1919 \xb7 Samsun",
        title: "Kurtulu\u015F",
        tagline: "\u0130\u015Fgal edilen bir vatan. Kazan\u0131lacak bir istiklal.",
        cta: 'Oyuna git',
        meta: "Kurtulu\u015F Sava\u015F\u0131 \xfczerine bir strateji oyunu",
        alt: "\u015Eafak s\xf6kerken karanl\u0131k denizde ilerleyen Band\u0131rma Vapuru"
    },
    stops: [
        {
            id: 'top',
            label: 'Yolculuk'
        },
        {
            id: 'story',
            label: 'Durum'
        },
        {
            id: 'moments',
            label: "Sava\u015F"
        },
        {
            id: 'board',
            label: 'Harita'
        },
        {
            id: 'cards',
            label: 'Kartlar'
        },
        {
            id: 'factions',
            label: "Kar\u015F\u0131 taraf"
        },
        {
            id: 'soundtrack',
            label: "M\xfczik"
        }
    ],
    story: {
        kicker: "Birinci B\xf6l\xfcm \xb7 Durum",
        title: [
            "Yurdun d\xf6rt bir yan\u0131 i\u015Fgal alt\u0131nda.",
            "Ordular terhis edilmi\u015F."
        ],
        copy: "Harp sona erdi, hesapla\u015Fma ba\u015Flad\u0131. \u0130tilaf donanmas\u0131 Bo\u011Faz\u2019da, \u0130ngiliz garnizonu \u0130stanbul\u2019da, Yunan ordusu \u0130zmir\u2019e \xe7\u0131kmak \xfczere. Anadolu\u2019nun haritas\u0131 Paris\u2019te ve Londra\u2019da \xe7iziliyor; masada bu topraklar\u0131n sahibi yok. Oyun tam o haritan\u0131n \xfczerinde, 1919 May\u0131s\u2019\u0131nda ba\u015Fl\u0131yor. Haritadaki en zor mevzi sizin. Bundan sonras\u0131 size kalm\u0131\u015F, Pa\u015Fam."
    },
    bosphorus: {
        label: "\u0130\u015Fgal alt\u0131ndaki Bo\u011Fazi\xe7i, Kas\u0131m 1918",
        alt: "\u0130stanbul sil\xfcetinin \xf6n\xfcnde demirlemi\u015F \u0130tilaf z\u0131rhl\u0131lar\u0131",
        dateline: "Kas\u0131m 1918 \xb7 Bo\u011Fazi\xe7i",
        heading: "D\xfc\u015Fman donanmas\u0131 Dolmabah\xe7e\u2019nin \xf6n\xfcne demirledi.",
        copy: "Cihan Harbi\u2019ni kazanan donanma Bo\u011Faz\u2019a girdi. Mondros M\xfctarekesi imzaland\u0131, ordu terhis edildi, silahlar teslim ediliyor. K\xe2\u011F\u0131t \xfczerinde her \u015Fey sona ermi\u015F durumda."
    },
    duty: {
        kicker: "\u0130kinci B\xf6l\xfcm \xb7 Vazife",
        title: [
            'Durup ihtimalleri',
            "tartmayacaks\u0131n\u0131z."
        ],
        copy: "Bir Osmanl\u0131 pa\u015Fas\u0131s\u0131n\u0131z; m\xfcfetti\u015Flik talimat\u0131yla Samsun\u2019a g\xf6nderildiniz: silahs\u0131zlanmay\u0131 denetleyin, asayi\u015Fi koruyun. Sizin ba\u015Fka fikirleriniz var. 16 May\u0131s 1919\u2019da k\xfc\xe7\xfck SS Band\u0131rma vapuru donanman\u0131n g\xf6zleri \xf6n\xfcnde \u0130stanbul\u2019dan ayr\u0131l\u0131r; i\xe7erilere uzanan yol ba\u015Flar."
    },
    deck: {
        label: "Band\u0131rma\u2019n\u0131n g\xfcvertesinden bak\u0131\u015F\u0131n\u0131z",
        alt: "Bulundu\u011Funuz yerden, alacakaranl\u0131kta kabaran denizde ilerleyen eski bir vapurun ya\u011Fmurdan \u0131slanm\u0131\u015F g\xfcvertesi",
        dateline: "17 May\u0131s 1919 \xb7 SS Band\u0131rma\u2019da",
        heading: "\u0130leride Samsun ve hen\xfcz kimsenin ilan etmedi\u011Fi bir sava\u015F var.",
        copy: "Refakatsiz, a\xe7\u0131k denizde \xfc\xe7 g\xfcn. \xd6te u\xe7ta hen\xfcz bir araya gelmemi\u015F direni\u015F kuvvetleri ve kendisine hen\xfcz ne istedi\u011Fi sorulmam\u0131\u015F bir halk bekliyor. Karaya \xe7\u0131kt\u0131\u011F\u0131n\u0131zda emrinizde bir ordu de\u011Fil, yaln\u0131zca bir ihtimal olacak."
    },
    route: {
        label: "\u0130stanbul\u2019dan Meclis\u2019in a\xe7\u0131l\u0131\u015F\u0131na giden yol",
        stops: [
            {
                date: "16 May\u0131s 1919",
                place: "\u0130stanbul",
                note: "Yola \xe7\u0131k\u0131\u015F"
            },
            {
                date: "19 May\u0131s 1919",
                place: 'Samsun',
                note: "Karaya \xe7\u0131k\u0131\u015F"
            },
            {
                date: '22 Haziran 1919',
                place: 'Amasya',
                note: 'Genelge'
            },
            {
                date: '23 Temmuz 1919',
                place: 'Erzurum',
                note: "Do\u011Fu kongresi"
            },
            {
                date: "4 Eyl\xfcl 1919",
                place: 'Sivas',
                note: "Mill\xee kongre"
            },
            {
                date: '23 Nisan 1920',
                place: 'Ankara',
                note: "Meclis a\xe7\u0131l\u0131yor"
            }
        ]
    },
    moments: {
        kicker: "\xdc\xe7\xfcnc\xfc B\xf6l\xfcm \xb7 Sava\u015F",
        title: [
            'Millet yorgun ve fakir.',
            "Yine de sava\u015Facak."
        ],
        copy: "Elinde kalan ne varsa size veriyor. Kongre, toplanaca\u011F\u0131 bir \u015Fehir ister; ordu, halktan gelecek ikmali. Savunma hatt\u0131 zaman ister, taarruz ise ayakta kalacak bir kuvvet. Hepsinin bedelini ayn\u0131 millet \xf6d\xfcyor."
    },
    hands: {
        label: "Kumandan\u0131n g\xf6z\xfcnden: harita, k\xfcpe\u015Fte, pusula ve d\xfcrb\xfcn",
        alt: "\xdc\xe7 g\xf6r\xfcnt\xfc: harita \xfczerinde eldivenli bir el, denizin \xfcst\xfcnde k\xfcpe\u015Fteyi kavrayan eller, a\xe7\u0131k duran bir pusula ve d\xfcrb\xfcn"
    },
    board: {
        kicker: "Harita \xb7 May\u0131s 1919",
        title: [
            "Mill\xee M\xfccadele\u2019nin ba\u015Flad\u0131\u011F\u0131 yerden ba\u015Fl\u0131yorsunuz."
        ],
        copy: "On alt\u0131 il, \xe7o\u011Fu i\xe7 Anadolu\u2019da. Haritada, her birinin kendi hesab\u0131 olan alt\u0131 taraf daha var: \u0130zmir\u2019de Yunanistan, Bo\u011Fazlar\u2019da \u0130ngiltere, \xc7ukurova\u2019da Fransa, g\xfcneybat\u0131da \u0130talya, do\u011Fuda Ermenistan, Trakya\u2019n\u0131n \xf6te yan\u0131nda Bulgaristan. Hedefiniz haritan\u0131n tamam\u0131 de\u011Fil: son Osmanl\u0131 Meclisi\u2019nin oylad\u0131\u011F\u0131 otuz il, yani Misak-\u0131 Mill\xee.",
        chip: "\u2691 Oyundan g\xf6r\xfcnt\xfc",
        caption: "May\u0131s 1919 \xb7 1. Tur, tarih\xee ba\u015Flang\u0131\xe7 mevzii",
        alt: "Kurtulu\u015F oyununun haritas\u0131, May\u0131s 1919 tarih\xee ba\u015Flang\u0131\xe7 mevziinde",
        objectiveLabel: "Misak-\u0131 Mill\xee",
        objectiveValue: '16 / 30',
        objectiveBar: "Otuz Misak-\u0131 Mill\xee ilinden on alt\u0131s\u0131 elde",
        objectiveCopy: "Ba\u015Flang\u0131\xe7ta elinizde bulunan Misak-\u0131 Mill\xee illeri. Zafer, otuzunu da elde tutmak ve orada durmakt\u0131r."
    },
    cards: {
        kicker: "Oyundan g\xf6r\xfcnt\xfc \xb7 Olay destesi",
        title: [
            "D\xf6n\xfcm noktalar\u0131 masaya kart olarak geliyor."
        ],
        copy: "1919 kongrelerinden yirmili y\u0131llar\u0131n ortas\u0131ndaki antla\u015Fmalara kadar yirmi sekiz tarihli olay. Her biri kendi tarihine denk gelen turda \xe7\u0131k\u0131yor ve her biri elle tutulur bir \u015Fey de\u011Fi\u015Ftiriyor. Birka\xe7\u0131 ise karar\u0131 size b\u0131rak\u0131yor.",
        note: "Yirmi sekizin d\xf6rd\xfc. Kalan\u0131yla sava\u015F s\u0131ras\u0131nda kar\u015F\u0131la\u015Facaks\u0131n\u0131z; baz\u0131lar\u0131 ancak sava\u015F\u0131n\u0131z onlar\u0131 hak ederse gelir.",
        exhibits: [
            {
                alt: "Oyun i\xe7i olay kart\u0131: Erzurum Kongresi, Temmuz 1919",
                dateline: "Temmuz 1919 \xb7 Do\u011Fu \xf6rg\xfctleniyor",
                title: 'Erzurum Kongresi',
                copy: "Erzurum elinizdeyse, do\u011Fudaki her il milis topluyor."
            },
            {
                alt: "Oyun i\xe7i olay kart\u0131: B\xfcy\xfck Millet Meclisi Ankara\u2019da a\xe7\u0131l\u0131yor",
                dateline: "Nisan 1920 \xb7 H\xfck\xfcmet kuruluyor",
                title: "Meclis a\xe7\u0131l\u0131yor",
                copy: "Tek elden komuta, mill\xee yetki. Hepsi elde tutulan bir makama ba\u011Fl\u0131."
            },
            {
                alt: "Oyun i\xe7i olay kart\u0131: Sevr Antla\u015Fmas\u0131, A\u011Fustos 1920",
                dateline: "A\u011Fustos 1920 \xb7 Dayat\u0131lan bar\u0131\u015F",
                title: 'Sevr',
                copy: "\u0130ki tur askere yaz\u0131lmay\u0131 \xe7\xf6kertir, sonra sertle\u015Ftirir: direni\u015F silahl\u0131 bir millete d\xf6n\xfc\u015F\xfcr."
            },
            {
                alt: "Oyun i\xe7i olay kart\u0131 \u0130ngilizce: \u0130n\xf6n\xfc Muharebesi, Ocak 1921",
                dateline: "Ocak 1921 \xb7 And in English",
                title: "\u0130n\xf6n\xfc hatt\u0131 tutuyor",
                copy: "Her kart, her sat\u0131r, her harita etiketi iki dilde. Oyunun ortas\u0131nda de\u011Fi\u015Ftirebilirsiniz."
            }
        ]
    },
    factions: {
        kicker: "Kar\u015F\u0131 taraf",
        title: [
            "Her rakip, \xfclkesinin tarih\xee tutumuyla e\u011Fitilmi\u015F bir yapay zek\xe2."
        ],
        items: [
            {
                key: 'Greece',
                name: 'Yunanistan',
                copy: "Samsun\u2019a varman\u0131zdan d\xf6rt g\xfcn \xf6nce ordusu \u0130zmir\u2019de karaya \xe7\u0131kar."
            },
            {
                key: 'Britain',
                name: "\u0130ngiltere",
                copy: "\u0130mparatorluk sava\u015F\u0131 kazand\u0131; \u015Fimdi bar\u0131\u015F\u0131n bek\xe7ili\u011Fini yapmak zorunda."
            },
            {
                key: 'France',
                name: 'Fransa',
                copy: "Avrupa\u2019daki zaferin ard\u0131ndan bu kez sanc\u0131l\u0131 bir i\u015Fgal ba\u015Flad\u0131."
            },
            {
                key: 'Italy',
                name: "\u0130talya",
                copy: "Roma\u2019n\u0131n bar\u0131\u015Ftan bekledi\u011Fi, u\u011Fruna sava\u015Fmay\u0131 g\xf6ze ald\u0131\u011F\u0131ndan fazlayd\u0131."
            },
            {
                key: 'Armenia',
                name: 'Ermenistan',
                copy: "Daha bir ya\u015F\u0131n\u0131 bile doldurmam\u0131\u015F bir cumhuriyet; s\u0131n\u0131rlar\u0131n\u0131n hi\xe7biri hen\xfcz kesinle\u015Fmi\u015F de\u011Fil."
            },
            {
                key: 'Bulgaria',
                name: 'Bulgaristan',
                copy: "Yenilgi, ard\u0131nda k\xfc\xe7\xfclm\xfc\u015F bir \xfclke ve antla\u015Fmayla k\u0131s\u0131tlanm\u0131\u015F bir ordu b\u0131rakt\u0131."
            }
        ]
    },
    score: {
        kicker: "Oyunun m\xfczi\u011Fi",
        title: [
            "Sava\u015F\u0131n tamam\u0131, on \xfc\xe7 par\xe7ada."
        ],
        copy: "M\xfczi\u011Fin tamam\u0131n\u0131 s\u0131rayla dinleyebilir, tek bir b\xf6l\xfcm se\xe7ebilir veya istedi\u011Finiz par\xe7ay\u0131 indirebilirsiniz."
    },
    charge: {
        label: "Gen\xe7li\u011Fe Hitabe\u2019den",
        lines: [
            "Muhta\xe7 oldu\u011Fun kudret,",
            "damarlar\u0131ndaki asil kanda mevcuttur."
        ],
        sub: "Mustafa Kemal Atat\xfcrk \xb7 Gen\xe7li\u011Fe Hitabe, 1927"
    },
    final: {
        label: "Oyuna ba\u015Fla",
        alt: "Harek\xe2t masas\u0131na serilmi\u015F Anadolu haritas\u0131"
    },
    footer: {
        team: "Tak\u0131m",
        imprint: "K\xfcnye",
        openSource: "GitHub\u2019da a\xe7\u0131k kaynak",
        brand: "Kurtulu\u015F",
        years: "1919 \xb7 1923",
        tagline: "Kurtulu\u015F Sava\u015F\u0131 \xfczerine tarih\xee bir strateji oyunu.",
        links: [
            {
                href: '#story',
                label: "Hik\xe2ye"
            },
            {
                href: '#board',
                label: 'Harita'
            },
            {
                href: '#cards',
                label: 'Kartlar'
            },
            {
                href: '#factions',
                label: 'Taraflar'
            },
            {
                href: '#soundtrack',
                label: "M\xfczik"
            }
        ]
    },
    nav: {
        label: "Sayfa b\xf6l\xfcmleri"
    }
};


const $28c8fda5645424bf$export$4fbff5bc7a251a0f = (lang)=>lang === 'tr' ? (0, $09cd832828510154$export$72451b88a72ad9c2) : (0, $39b86da769d481bf$export$84584c2a98eb6753);


const $bdb6234edc6d6ec1$export$814cfa4ffa8708c = [
    'top',
    'story',
    'moments',
    'board',
    'cards',
    'factions',
    'soundtrack'
];
const $bdb6234edc6d6ec1$export$f472e9f5282be5b9 = '/game';
const $bdb6234edc6d6ec1$export$702dd1129c4aa79 = 'https://github.com/dashersw/independence';
const $bdb6234edc6d6ec1$export$739c2ed980661173 = '/imprint.html';
const $bdb6234edc6d6ec1$export$55963047fee89df2 = '/kunye.html';
const $bdb6234edc6d6ec1$export$bc8b984358922f81 = [
    {
        handle: 'dashersw',
        url: 'https://github.com/dashersw'
    },
    {
        handle: 'baturyilmaz',
        url: 'https://github.com/baturyilmaz'
    }
];


const $7d6f42127d0a7cbe$var$REVEAL_VIEWPORT_FRACTION = 0.92;
const $7d6f42127d0a7cbe$var$HERO_EXIT_FRACTION = 0.3;
const $7d6f42127d0a7cbe$var$SCROLL_THROTTLE_MS = 90;
const $7d6f42127d0a7cbe$var$IDLE_POLL_MS = 800;
const $7d6f42127d0a7cbe$var$VIEWPORT_MIDPOINT_DIVISOR = 2;
const $7d6f42127d0a7cbe$var$isInFrame = (element, topFraction)=>{
    const rect = element.getBoundingClientRect();
    return rect.top < innerHeight * topFraction && rect.bottom > 0;
};
const $7d6f42127d0a7cbe$var$revealEntered = (pending)=>{
    for (const element of pending){
        if (!$7d6f42127d0a7cbe$var$isInFrame(element, $7d6f42127d0a7cbe$var$REVEAL_VIEWPORT_FRACTION)) continue;
        element.classList.add('is-visible');
        pending.delete(element);
    }
};
const $7d6f42127d0a7cbe$var$startEnteredScenes = (scenes)=>{
    for (const scene of scenes){
        if (!$7d6f42127d0a7cbe$var$isInFrame(scene, 1)) continue;
        scene.classList.add('seen');
        scenes.delete(scene);
    }
};
const $7d6f42127d0a7cbe$var$currentStop = (stopElements)=>{
    let current = (0, $bdb6234edc6d6ec1$export$814cfa4ffa8708c)[0];
    for (const element of stopElements){
        const midpoint = innerHeight / $7d6f42127d0a7cbe$var$VIEWPORT_MIDPOINT_DIVISOR;
        if (element.getBoundingClientRect().top <= midpoint) current = element.id;
    }
    return current;
};
const $7d6f42127d0a7cbe$export$7cd2cdd259e4be8a = ()=>{
    const [activeStop, setActiveStop] = (0, $acw62.useState)((0, $bdb6234edc6d6ec1$export$814cfa4ffa8708c)[0]);
    const [pastHero, setPastHero] = (0, $acw62.useState)(false);
    (0, $acw62.useEffect)(()=>{
        const pending = new Set(document.querySelectorAll('.reveal'));
        const seaScenes = new Set(document.querySelectorAll('.scene-sea'));
        const stopElements = (0, $bdb6234edc6d6ec1$export$814cfa4ffa8708c).map((id)=>document.querySelector(`#${id}`)).filter(Boolean);
        const hero = document.querySelector('#top');
        let isThrottled = false;
        const update = ()=>{
            isThrottled = false;
            $7d6f42127d0a7cbe$var$revealEntered(pending);
            $7d6f42127d0a7cbe$var$startEnteredScenes(seaScenes);
            if (hero) setPastHero(hero.getBoundingClientRect().bottom < innerHeight * $7d6f42127d0a7cbe$var$HERO_EXIT_FRACTION);
            setActiveStop($7d6f42127d0a7cbe$var$currentStop(stopElements));
        };
        const onScroll = ()=>{
            if (isThrottled) return;
            isThrottled = true;
            setTimeout(update, $7d6f42127d0a7cbe$var$SCROLL_THROTTLE_MS);
        };
        update();
        addEventListener('scroll', onScroll, {
            passive: true
        });
        addEventListener('resize', onScroll, {
            passive: true
        });
        const idle = setInterval(update, $7d6f42127d0a7cbe$var$IDLE_POLL_MS);
        return ()=>{
            removeEventListener('scroll', onScroll);
            removeEventListener('resize', onScroll);
            clearInterval(idle);
        };
    }, []);
    return {
        activeStop: activeStop,
        pastHero: pastHero
    };
};
const $7d6f42127d0a7cbe$export$d91dad8ffa2a068d = ()=>(0, $28c8fda5645424bf$export$4fbff5bc7a251a0f)((0, $e5df0b2d7740e822$export$b24a004ee43dce44)());
const $7d6f42127d0a7cbe$export$201da98ab7cde95a = (meta)=>{
    (0, $acw62.useEffect)(()=>{
        document.title = meta.title;
        document.querySelector('meta[name="description"]')?.setAttribute('content', meta.description);
    }, [
        meta
    ]);
};
const $7d6f42127d0a7cbe$export$97fb45dd64fb69d0 = ()=>{
    (0, $acw62.useEffect)(()=>{
        document.body.classList.add('landing-page-body');
        return ()=>document.body.classList.remove('landing-page-body');
    }, []);
};





const $c628153d58203372$export$38af1803e3442a7f = ({ id: id, variant: variant, label: label, labelledBy: labelledBy, image: image, alt: alt, eager: eager, children: children })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: variant ? `scene ${variant}` : 'scene',
        id: id,
        "aria-label": label,
        "aria-labelledby": labelledBy,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "scene-art-wrap",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "scene-art",
                    src: image,
                    alt: alt,
                    loading: eager ? 'eager' : 'lazy'
                })
            }),
            children
        ]
    });
const $c628153d58203372$export$b8f1ea023d4fd793 = ({ dateline: dateline, heading: heading, copy: copy })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "scene-label reveal",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: dateline
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h3", {
                children: heading
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                children: copy
            })
        ]
    });





var $3be262511b5c82c5$exports = {};
$3be262511b5c82c5$exports = import.meta.resolve("kjcvJ");


const $38887c556fa1995d$var$handsImage = new URL($3be262511b5c82c5$exports).href;
var $bc9d0ad93b6d31e0$exports = {};
$bc9d0ad93b6d31e0$exports = import.meta.resolve("cEemj");


const $38887c556fa1995d$var$boardShotEn = new URL($bc9d0ad93b6d31e0$exports).href;
var $8d214ac8db5f8488$exports = {};
$8d214ac8db5f8488$exports = import.meta.resolve("9jRyb");


const $38887c556fa1995d$var$boardShotTr = new URL($8d214ac8db5f8488$exports).href;
const $38887c556fa1995d$var$PACT_HELD_WIDTH = '53%';
const $38887c556fa1995d$var$BoardWindow = ({ copy: copy, shot: shot })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "board-window reveal",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "board-window-top",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "hud-chip",
                        children: copy.chip
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                        children: copy.caption
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                src: shot,
                alt: copy.alt,
                loading: "lazy"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "board-objective",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: copy.objectiveLabel
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                        children: copy.objectiveValue
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "pact-bar",
                        role: "img",
                        "aria-label": copy.objectiveBar,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                            style: {
                                width: $38887c556fa1995d$var$PACT_HELD_WIDTH
                            }
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: copy.objectiveCopy
                    })
                ]
            })
        ]
    });
const $38887c556fa1995d$export$dc537a3a3893548e = ({ copy: copy })=>{
    const lang = (0, $e5df0b2d7740e822$export$b24a004ee43dce44)();
    const shot = lang === 'tr' ? $38887c556fa1995d$var$boardShotTr : $38887c556fa1995d$var$boardShotEn;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $742a2b2531837bb1$export$6aceaa2aadf4b436), {
                id: "moments",
                kicker: copy.moments.kicker,
                title: copy.moments.title,
                copy: copy.moments.copy
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c628153d58203372$export$38af1803e3442a7f), {
                variant: "scene-hands",
                label: copy.hands.label,
                image: $38887c556fa1995d$var$handsImage,
                alt: copy.hands.alt
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $742a2b2531837bb1$export$6aceaa2aadf4b436), {
                id: "board",
                kicker: copy.board.kicker,
                title: copy.board.title,
                copy: copy.board.copy
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "case-shell",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($38887c556fa1995d$var$BoardWindow, {
                    copy: copy.board,
                    shot: shot
                })
            })
        ]
    });
};





var $31c485672eb419d8$exports = {};
$31c485672eb419d8$exports = import.meta.resolve("8eBwI");


const $8c15054dc56def52$var$erzurumEn = new URL($31c485672eb419d8$exports).href;
var $a09639f61c4cf879$exports = {};
$a09639f61c4cf879$exports = import.meta.resolve("eoi2a");


const $8c15054dc56def52$var$erzurumTr = new URL($a09639f61c4cf879$exports).href;
var $c2f542b3fdb393b0$exports = {};
$c2f542b3fdb393b0$exports = import.meta.resolve("gI81K");


const $8c15054dc56def52$var$assemblyEn = new URL($c2f542b3fdb393b0$exports).href;
var $e8e9d472ff929b8a$exports = {};
$e8e9d472ff929b8a$exports = import.meta.resolve("0f7vC");


const $8c15054dc56def52$var$assemblyTr = new URL($e8e9d472ff929b8a$exports).href;
var $d9993241abbec0fd$exports = {};
$d9993241abbec0fd$exports = import.meta.resolve("1Hb50");


const $8c15054dc56def52$var$sevresEn = new URL($d9993241abbec0fd$exports).href;
var $411ddc70f805a2b3$exports = {};
$411ddc70f805a2b3$exports = import.meta.resolve("3aDh2");


const $8c15054dc56def52$var$sevresTr = new URL($411ddc70f805a2b3$exports).href;
var $7ebb4ac0de671313$exports = {};
$7ebb4ac0de671313$exports = import.meta.resolve("3vdUe");


const $8c15054dc56def52$var$inonuEn = new URL($7ebb4ac0de671313$exports).href;
var $605d4f380de5d833$exports = {};
$605d4f380de5d833$exports = import.meta.resolve("4dZJa");


const $8c15054dc56def52$var$inonuTr = new URL($605d4f380de5d833$exports).href;
// The fourth card deliberately shows the other language: it is the one that
// exists to demonstrate the game is bilingual.
const $8c15054dc56def52$var$englishShots = [
    $8c15054dc56def52$var$erzurumEn,
    $8c15054dc56def52$var$assemblyEn,
    $8c15054dc56def52$var$sevresEn,
    $8c15054dc56def52$var$inonuTr
];
const $8c15054dc56def52$var$turkishShots = [
    $8c15054dc56def52$var$erzurumTr,
    $8c15054dc56def52$var$assemblyTr,
    $8c15054dc56def52$var$sevresTr,
    $8c15054dc56def52$var$inonuEn
];
const $8c15054dc56def52$export$c8d38e0dcc0f5a1 = ({ copy: copy })=>{
    const lang = (0, $e5df0b2d7740e822$export$b24a004ee43dce44)();
    const shots = lang === 'tr' ? $8c15054dc56def52$var$turkishShots : $8c15054dc56def52$var$englishShots;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $742a2b2531837bb1$export$6aceaa2aadf4b436), {
                id: "cards",
                kicker: copy.kicker,
                title: copy.title,
                copy: copy.copy
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "gallery gallery-2",
                children: copy.exhibits.map((exhibit, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("figure", {
                        className: "exhibit reveal",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                                src: shots.at(index),
                                alt: exhibit.alt,
                                loading: "lazy"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("figcaption", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                        children: exhibit.dateline
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                        children: exhibit.title
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: exhibit.copy
                                    })
                                ]
                            })
                        ]
                    }, exhibit.title))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                className: "gallery-note reveal",
                children: copy.note
            })
        ]
    });
};




var $acw62 = parcelRequire("acw62");



var $706ba031a28d8cb8$exports = {};
$706ba031a28d8cb8$exports = import.meta.resolve("3QVmU");


const $d9946a2b0ca90715$var$finalArtEn = new URL($706ba031a28d8cb8$exports).href;
var $af9b3d2b28f1f264$exports = {};
$af9b3d2b28f1f264$exports = import.meta.resolve("fnBRN");


const $d9946a2b0ca90715$var$finalArtTr = new URL($af9b3d2b28f1f264$exports).href;
const $d9946a2b0ca90715$var$Charge = ({ copy: copy })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
        className: "charge",
        "aria-label": copy.label,
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: "reveal",
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "charge-line",
                    children: copy.lines.map((line, index)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $acw62.Fragment), {
                            children: [
                                index > 0 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("br", {}),
                                line
                            ]
                        }, line))
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                    className: "charge-sub",
                    children: copy.sub
                })
            ]
        })
    });
const $d9946a2b0ca90715$var$GithubMark = ()=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("svg", {
        viewBox: "0 0 24 24",
        "aria-hidden": "true",
        focusable: "false",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 .5C5.37.5 0 5.78 0 12.292c0 5.211 3.438 9.63 8.205 11.188.6.111.82-.254.82-.567 0-.28-.01-1.022-.015-2.005-3.338.711-4.042-1.582-4.042-1.582-.546-1.361-1.335-1.725-1.335-1.725-1.087-.731.084-.716.084-.716 1.205.082 1.838 1.215 1.838 1.215 1.07 1.803 2.809 1.282 3.495.981.108-.763.417-1.282.76-1.577-2.665-.295-5.466-1.309-5.466-5.827 0-1.287.465-2.339 1.235-3.164-.135-.298-.54-1.497.105-3.121 0 0 1.005-.316 3.3 1.209.96-.262 1.98-.392 3-.398 1.02.006 2.04.136 3 .398 2.28-1.525 3.285-1.209 3.285-1.209.645 1.624.24 2.823.12 3.121.765.825 1.23 1.877 1.23 3.164 0 4.53-2.805 5.527-5.475 5.817.42.354.81 1.077.81 2.182 0 1.578-.015 2.846-.015 3.229 0 .309.21.678.825.56C20.565 21.917 24 17.499 24 12.292 24 5.78 18.627.5 12 .5z"
        })
    });
const $d9946a2b0ca90715$var$Footer = ({ copy: copy, imprintUrl: imprintUrl })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("footer", {
        className: "landing-footer",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                className: "landing-brand",
                href: "#top",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: "brand-seal",
                        "aria-hidden": "true",
                        children: "\u2605"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                children: copy.brand
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                                children: copy.years
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "landing-footer-about",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: copy.tagline
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                        className: "landing-source",
                        href: (0, $bdb6234edc6d6ec1$export$702dd1129c4aa79),
                        target: "_blank",
                        rel: "noreferrer",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d9946a2b0ca90715$var$GithubMark, {}),
                            copy.openSource
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                children: copy.links.map((link)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        href: link.href,
                        children: link.label
                    }, link.href))
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "landing-footer-meta",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                        className: "landing-team",
                        children: [
                            copy.team,
                            (0, $bdb6234edc6d6ec1$export$bc8b984358922f81).map((member)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                    href: member.url,
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: [
                                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d9946a2b0ca90715$var$GithubMark, {}),
                                        member.handle
                                    ]
                                }, member.handle))
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                        className: "landing-imprint",
                        href: imprintUrl,
                        children: copy.imprint
                    })
                ]
            })
        ]
    });
const $d9946a2b0ca90715$export$325cdb3936d20a10 = ({ copy: copy })=>{
    const lang = (0, $e5df0b2d7740e822$export$b24a004ee43dce44)();
    const art = lang === 'tr' ? $d9946a2b0ca90715$var$finalArtTr : $d9946a2b0ca90715$var$finalArtEn;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d9946a2b0ca90715$var$Charge, {
                copy: copy.charge
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c628153d58203372$export$38af1803e3442a7f), {
                variant: "scene-final",
                label: copy.final.label,
                image: art,
                alt: copy.final.alt
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($d9946a2b0ca90715$var$Footer, {
                copy: copy.footer,
                imprintUrl: lang === 'tr' ? (0, $bdb6234edc6d6ec1$export$55963047fee89df2) : (0, $bdb6234edc6d6ec1$export$739c2ed980661173)
            })
        ]
    });
};



const $18959d42a0c61d08$export$c476ceeec4b481f5 = ({ stops: stops, label: label, activeStop: activeStop })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("nav", {
        className: "floor-nav",
        "aria-label": label,
        children: stops.map((stop)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                href: `#${stop.id}`,
                "data-label": stop.label,
                "aria-label": stop.label,
                className: activeStop === stop.id ? 'active' : ''
            }, stop.id))
    });





const $9b76ecc1c111010c$var$heroImage = new URL($f1142f8eed0d386e$exports).href;
const $9b76ecc1c111010c$export$887967f05dc521ae = ({ copy: copy })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
        className: "scene scene-hero",
        id: "top",
        "aria-labelledby": "hero-title",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "scene-art-wrap",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("img", {
                    className: "scene-art",
                    src: $9b76ecc1c111010c$var$heroImage,
                    alt: copy.alt
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "hero-content",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "hero-date",
                        children: copy.dateline
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                        id: "hero-title",
                        children: copy.title
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "hero-mark",
                        "aria-hidden": "true",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {}),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {
                                children: "\u2605"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "hero-sub",
                        children: copy.tagline
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: "hero-actions",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                        className: "action-primary",
                        href: (0, $bdb6234edc6d6ec1$export$f472e9f5282be5b9),
                        children: [
                            copy.cta,
                            " ",
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                "aria-hidden": "true",
                                children: "\u2192"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "hero-meta",
                        children: copy.meta
                    })
                ]
            })
        ]
    });





const $1d9f1140cbd41023$export$2b8cf6b49ad4a53a = ({ copy: copy })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $742a2b2531837bb1$export$6aceaa2aadf4b436), {
                id: "factions",
                kicker: copy.kicker,
                title: copy.title
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                className: "faction-wall",
                children: copy.items.map((faction)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                        className: "reveal",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45f8179f43663cce$export$4fd8d63cb0915eb0), {
                                faction: faction.key,
                                className: "faction-flag"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                                        children: faction.name
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: faction.copy
                                    })
                                ]
                            })
                        ]
                    }, faction.key))
            })
        ]
    });






const $351c961b97f88f9c$var$bosphorusImage = new URL($30788fced5e2a74f$exports).href;

const $351c961b97f88f9c$var$deckImage = new URL($cca33977a38f6dc0$exports).href;
const $351c961b97f88f9c$var$Route = ({ copy: copy })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ol", {
        className: "route reveal",
        "aria-label": copy.label,
        children: copy.stops.map((stop)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("li", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: stop.date
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("b", {
                        children: stop.place
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("small", {
                        children: stop.note
                    })
                ]
            }, stop.place))
    });
const $351c961b97f88f9c$export$8f0fc1b507cae465 = ({ copy: copy })=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $742a2b2531837bb1$export$6aceaa2aadf4b436), {
                id: "story",
                kicker: copy.story.kicker,
                title: copy.story.title,
                copy: copy.story.copy
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c628153d58203372$export$38af1803e3442a7f), {
                variant: "scene-sea",
                label: copy.bosphorus.label,
                image: $351c961b97f88f9c$var$bosphorusImage,
                alt: copy.bosphorus.alt,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c628153d58203372$export$b8f1ea023d4fd793), {
                    dateline: copy.bosphorus.dateline,
                    heading: copy.bosphorus.heading,
                    copy: copy.bosphorus.copy
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $742a2b2531837bb1$export$6aceaa2aadf4b436), {
                kicker: copy.duty.kicker,
                title: copy.duty.title,
                copy: copy.duty.copy
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c628153d58203372$export$38af1803e3442a7f), {
                variant: "scene-right scene-sea",
                label: copy.deck.label,
                image: $351c961b97f88f9c$var$deckImage,
                alt: copy.deck.alt,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $c628153d58203372$export$b8f1ea023d4fd793), {
                    dateline: copy.deck.dateline,
                    heading: copy.deck.heading,
                    copy: copy.deck.copy
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($351c961b97f88f9c$var$Route, {
                copy: copy.route
            })
        ]
    });




const $365146b7a8987c60$export$355f3d6a1f8b250c = ()=>{
    const copy = (0, $7d6f42127d0a7cbe$export$d91dad8ffa2a068d)();
    const player = (0, $6de2353f57eb5901$export$134d49c87107fbaa)();
    const { activeStop: activeStop, pastHero: pastHero } = (0, $7d6f42127d0a7cbe$export$7cd2cdd259e4be8a)();
    (0, $7d6f42127d0a7cbe$export$201da98ab7cde95a)(copy.document);
    (0, $7d6f42127d0a7cbe$export$97fb45dd64fb69d0)();
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
        className: "landing-page",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "scroll-pact",
                "aria-hidden": "true",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("i", {})
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e3be99bdc8eb8f7b$export$da8a365896b01467), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $9b76ecc1c111010c$export$887967f05dc521ae), {
                copy: copy.hero
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $351c961b97f88f9c$export$8f0fc1b507cae465), {
                copy: copy
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $38887c556fa1995d$export$dc537a3a3893548e), {
                copy: copy
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $8c15054dc56def52$export$c8d38e0dcc0f5a1), {
                copy: copy.cards
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $1d9f1140cbd41023$export$2b8cf6b49ad4a53a), {
                copy: copy.factions
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $742a2b2531837bb1$export$6aceaa2aadf4b436), {
                id: "soundtrack",
                kicker: copy.score.kicker,
                title: copy.score.title,
                copy: copy.score.copy
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: "case-shell",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0ff860235c049a22$export$b83262e57e0e96ca), {
                    player: player
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d9946a2b0ca90715$export$325cdb3936d20a10), {
                copy: copy
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $18959d42a0c61d08$export$c476ceeec4b481f5), {
                stops: copy.stops,
                label: copy.nav.label,
                activeStop: activeStop
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d893ea8e0ffe6258$export$9d9d9d1a2206514d), {
                player: player,
                visible: player.playing || pastHero
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("audio", {
                ...player.audioProps
            })
        ]
    });
};




const $cd93687958c8007e$var$GameApp = ()=>{
    const session = (0, $654496e2d17d77b0$export$d7a69369a4611f18)();
    const { game: game, interaction: interaction } = session;
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: "app",
        children: [
            session.gameMounted && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $473a150c596d157c$export$2e2bcd8739ae039), {
                        territories: game.territories,
                        selected: interaction.selected,
                        targets: interaction.targets,
                        activeTarget: interaction.lastBattle?.pending ? interaction.lastBattle.to.slug : null,
                        fortifyTarget: interaction.fortifyTarget,
                        convoys: game.movement.convoys,
                        round: game.turn.round,
                        onTerritoryClick: interaction.onTerritoryClick,
                        onReady: ()=>session.setMapReady(true)
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $6e91e55e9b7ea13b$export$2e2bcd8739ae039), {
                        game: game,
                        selected: interaction.selected,
                        fortifyTarget: interaction.fortifyTarget,
                        lastBattle: interaction.lastBattle,
                        onFortifyAmount: interaction.onFortifyAmount,
                        onAdvance: interaction.onAdvance,
                        onLandingResolve: interaction.onLandingResolve,
                        onCancelSelection: interaction.clearSelection,
                        onEndPhase: interaction.endPhase,
                        onAutoPlace: interaction.onAutoPlace,
                        onTrade: interaction.onTrade,
                        onAttackPress: interaction.onAttackPress,
                        onAttackBlitz: interaction.onAttackBlitz,
                        onPullBack: interaction.onPullBack
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a33ebe2a405df873$export$2e2bcd8739ae039), {
                        onSave: session.save,
                        onLoad: session.load,
                        defaultSaveName: session.defaultSaveName
                    }),
                    session.entries.length > 0 && game.turn.phase !== 'gameover' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $36da971f4939abf4$export$2e2bcd8739ae039), {
                        entries: session.entries,
                        choices: session.decision?.choices,
                        onDismiss: session.dismissCards,
                        onChoose: session.resolveDecision
                    }),
                    session.outcome && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: "overlay",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                            className: "overlay-card",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("h2", {
                                    children: [
                                        (0, $6c154842fccf6556$export$625550452a3fa3ec)(session.outcome.titleKey),
                                        game.winner && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $45f8179f43663cce$export$4fd8d63cb0915eb0), {
                                            faction: "Turkey",
                                            className: "victory-flag"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: (0, $6c154842fccf6556$export$625550452a3fa3ec)(session.outcome.bodyKey, session.outcome.vars)
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                                    className: "primary",
                                    onClick: ()=>window.location.reload(),
                                    children: (0, $6c154842fccf6556$export$625550452a3fa3ec)('overlay.playAgain')
                                })
                            ]
                        })
                    })
                ]
            }),
            !session.started && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $0e85057378cd98c0$export$2e2bcd8739ae039), {
                onStart: ()=>session.setGameMounted(true),
                onBegin: ()=>session.setStarted(true),
                mapReady: session.mapReady
            })
        ]
    });
};
const $cd93687958c8007e$var$isGameRoute = ()=>location.pathname === '/game' || location.pathname.startsWith('/game/');
const $cd93687958c8007e$var$App = ()=>$cd93687958c8007e$var$isGameRoute() ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($cd93687958c8007e$var$GameApp, {}) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $365146b7a8987c60$export$355f3d6a1f8b250c), {});
var $cd93687958c8007e$export$2e2bcd8739ae039 = $cd93687958c8007e$var$App;


const $35da740d59af89ba$var$container = document.getElementById('app');
const $35da740d59af89ba$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)($35da740d59af89ba$var$container);
// Keep the loader perceptible on a warm local cache without making genuinely
// slow loads wait any longer. The timestamp is set when the boot markup paints.
const $35da740d59af89ba$var$bootStartedAt = window.__openingBootStartedAt ?? performance.now();
const $35da740d59af89ba$var$isGameRoute = window.location.pathname === '/game' || window.location.pathname.startsWith('/game/');
const $35da740d59af89ba$var$minimumBootMs = $35da740d59af89ba$var$isGameRoute ? 650 : 0;
const $35da740d59af89ba$var$remainingBootMs = Math.max(0, $35da740d59af89ba$var$minimumBootMs - (performance.now() - $35da740d59af89ba$var$bootStartedAt));
window.setTimeout(()=>$35da740d59af89ba$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $cd93687958c8007e$export$2e2bcd8739ae039), {})), $35da740d59af89ba$var$remainingBootMs);


//# sourceMappingURL=independence.faf15692.js.map
